/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const prefix = 'fad';
const fa0 = {
  prefix: 'fad',
  iconName: '0',
  icon: [
    320,
    512,
    [],
    '30',
    [
      'M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 96c-53 0-96 43-96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96z',
      '',
    ],
  ],
};
const fa1 = {
  prefix: 'fad',
  iconName: '1',
  icon: [
    256,
    512,
    [],
    '31',
    [
      'M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8 96 416l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-352z',
      '',
    ],
  ],
};
const fa2 = {
  prefix: 'fad',
  iconName: '2',
  icon: [
    320,
    512,
    [],
    '32',
    [
      'M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416 288 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z',
      '',
    ],
  ],
};
const fa3 = {
  prefix: 'fad',
  iconName: '3',
  icon: [
    320,
    512,
    [],
    '33',
    [
      'M0 64C0 46.3 14.3 32 32 32l240 0c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208l21.7 0c75.1 0 136 60.9 136 136s-60.9 136-136 136l-78.6 0C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5l78.6 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L80 272c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96 32 96C14.3 96 0 81.7 0 64z',
      '',
    ],
  ],
};
const fa4 = {
  prefix: 'fad',
  iconName: '4',
  icon: [
    384,
    512,
    [],
    '34',
    [
      'M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368l224 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-144c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L82.4 304 189 77.6z',
      '',
    ],
  ],
};
const fa5 = {
  prefix: 'fad',
  iconName: '5',
  icon: [
    320,
    512,
    [],
    '35',
    [
      'M32.5 58.3C35.3 43.1 48.5 32 64 32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L90.7 96 70.3 208 184 208c75.1 0 136 60.9 136 136s-60.9 136-136 136l-83.5 0c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1l83.5 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L32 272c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z',
      '',
    ],
  ],
};
const fa6 = {
  prefix: 'fad',
  iconName: '6',
  icon: [
    320,
    512,
    [],
    '36',
    [
      'M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3l0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z',
      '',
    ],
  ],
};
const fa7 = {
  prefix: 'fad',
  iconName: '7',
  icon: [
    320,
    512,
    [],
    '37',
    [
      'M0 64C0 46.3 14.3 32 32 32l256 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96 32 96C14.3 96 0 81.7 0 64z',
      '',
    ],
  ],
};
const fa8 = {
  prefix: 'fad',
  iconName: '8',
  icon: [
    320,
    512,
    [],
    '38',
    [
      'M304 160c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288l15.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l15.9 0c0 0 .1 0 .1 0l32 0c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0l-32 0c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z',
      '',
    ],
  ],
};
const fa9 = {
  prefix: 'fad',
  iconName: '9',
  icon: [
    320,
    512,
    [],
    '39',
    [
      'M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z',
      '',
    ],
  ],
};
const faFillDrip = {
  prefix: 'fad',
  iconName: 'fill-drip',
  icon: [
    576,
    512,
    [],
    'f576',
    [
      'M66.5 296c0 8.2 3.1 16.4 9.4 22.6L193.4 436.1c12.5 12.5 32.8 12.5 45.3 0C288 386.7 337.4 337.4 386.7 288L67.5 288c-.7 2.6-1 5.3-1 8zM448 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-25.2-32.6-79.6-51.2-108.7c-6-9.4-19.5-9.4-25.5 0C480.6 368.4 448 422.8 448 448z',
      'M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L238.6 436.1c-12.5 12.5-32.8 12.5-45.3 0L75.9 318.6c-12.5-12.5-12.5-32.8 0-45.3L168 181.3z',
    ],
  ],
};
const faArrowsToCircle = {
  prefix: 'fad',
  iconName: 'arrows-to-circle',
  icon: [
    640,
    512,
    [],
    'e4bd',
    [
      'M256 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7 160 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l18.7 0L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM114.7 352L96 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0s0 0 0 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160l18.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1s0 0 0 0l0-96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3l0 18.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96s0 0 0 0l0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4l.1 0s0 0 0 0l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-18.7 0z',
    ],
  ],
};
const faCircleChevronRight = {
  prefix: 'fad',
  iconName: 'circle-chevron-right',
  icon: [
    512,
    512,
    ['chevron-circle-right'],
    'f138',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM200 152c0 6.1 2.3 12.3 7 17l87 87-87 87c-4.7 4.7-7 10.8-7 17s2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7L345 273c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17L241 135c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7s-7 10.8-7 17z',
      'M345 239c9.4 9.4 9.4 24.6 0 33.9L241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239z',
    ],
  ],
};
const faChevronCircleRight = faCircleChevronRight;
const faWagonCovered = {
  prefix: 'fad',
  iconName: 'wagon-covered',
  icon: [
    640,
    512,
    [],
    'f8ee',
    [
      'M2.1 43.9c0 4.4 .8 9 2.4 13.5L64 224l160 0 0-178.1c0-16.8-13.1-30.8-29.9-31.9L44.8 4.1C20.9 2.5 2.1 21.7 2.1 43.9zM64 400c0 61.9 50.1 112 112 112c56.4 0 103.1-41.7 110.9-96c.4-2.6 .7-5.3 .8-7.9c.1-1.3 .2-2.7 .2-4c0-1.4 .1-2.7 .1-4.1c0-2 0-2.4 0-2.9c0-.9-.1-1.9-.1-2.9c-.1-1.9-.2-3.8-.4-5.7c-.4-3.8-1-7.5-1.7-11.1c-1.5-7.3-3.7-14.3-6.5-21c-5.7-13.4-13.9-25.5-24-35.6C234.9 300.5 206.9 288 176 288c-30.5 0-58.2 12.2-78.4 32C76.9 340.3 64 368.7 64 400zm50-16c5.8-22.5 23.5-40.2 46-46l0 46-46 0zm0 32l46 0 0 46c-22.5-5.8-40.2-23.5-46-46zm78-78c22.5 5.8 40.2 23.5 46 46l-46 0 0-46zm0 78l46 0c-5.8 22.5-23.5 40.2-46 46l0-46zM256 48l0 176 128 0 0-176c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm96 352a112 112 0 1 0 224 .2A112 112 0 1 0 352 400zm50-16c5.8-22.5 23.5-40.2 46-46l0 46-46 0zm0 32l46 0 0 46c-22.5-5.8-40.2-23.5-46-46zM416 45.9L416 224l160 0L635.5 57.4C644.9 31.2 625.2 4 597.9 4c-.9 0-1.8 0-2.8 .1L445.9 14C429.1 15.1 416 29.1 416 45.9zM480 338c22.5 5.8 40.2 23.5 46 46l-46 0 0-46zm0 78l46 0c-5.8 22.5-23.5 40.2-46 46l0-46z',
      'M96 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l1.6 0c20.2-19.8 47.9-32 78.4-32c61.9 0 112 50.1 112 112c0 5.4-.4 10.8-1.1 16l66.3 0c-.7-5.2-1.1-10.6-1.1-16c0-61.9 50.1-112 112-112c30.5 0 58.2 12.2 78.4 32l1.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 256z',
    ],
  ],
};
const faLineHeight = {
  prefix: 'fad',
  iconName: 'line-height',
  icon: [
    576,
    512,
    [],
    'f871',
    [
      'M256 96c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32z',
      'M73.4 41.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-9.4-9.4 0 229.5 9.4-9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4 0-229.5-9.4 9.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64z',
    ],
  ],
};
const faBagel = {
  prefix: 'fad',
  iconName: 'bagel',
  icon: [
    640,
    512,
    [129391],
    'e3d7',
    [
      'M319.4 91.4c29.8 15.7 56 37.4 76.8 63.6c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64c0 30.6-21.5 56.3-50.3 62.5c1.5 10.9 2.3 22.1 2.3 33.5c0 25.4-3.9 49.9-11.3 72.9c4.7-.7 9.3-2.5 13.3-5.2c7-4.8 13.9-9.6 20.9-14.3c5.1-3.5 11.1-5.4 17.2-5.6c8.4-.2 16.9-.5 25.3-.7c13.2-.4 24.8-8.8 29.3-21.3c2.8-8 5.7-15.9 8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6c6.7-5.2 13.4-10.3 20.1-15.5c10.5-8.1 14.9-21.7 11.2-34.4c-2.4-8.1-4.8-16.2-7.2-24.3c-1.7-5.9-1.7-12.2 0-18.1c2.4-8.1 4.8-16.2 7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4c-6.7-5.2-13.4-10.3-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6c-2.8-8-5.7-15.9-8.5-23.9c-4.4-12.4-16.1-20.9-29.3-21.3c-8.4-.2-16.9-.5-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6c-7-4.8-13.9-9.5-20.9-14.3c-1.4-1-2.8-1.8-4.3-2.5s-2.9-1.3-4.4-1.7c-3.1-.9-6.2-1.4-9.4-1.4c-6.3 0-12.6 1.9-18 5.6c-7 4.8-14 9.6-21 14.4c-5.1 3.5-11.1 5.4-17.2 5.6c-8.4 .2-16.9 .5-25.3 .7c-13.2 .4-24.8 8.8-29.3 21.3c-.6 1.7-1.2 3.4-1.8 5.1z',
      'M432 416c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM144 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faTransporter7 = {
  prefix: 'fad',
  iconName: 'transporter-7',
  icon: [
    512,
    512,
    [],
    'e2a8',
    [
      'M0 304c0 4.1 2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288 6.6 295.3C2.7 296.4 0 299.9 0 304zM416 80c0 4.1 2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faAt = {
  prefix: 'fad',
  iconName: 'at',
  icon: [
    512,
    512,
    [61946],
    '40',
    [
      'M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z',
      '',
    ],
  ],
};
const faRectanglesMixed = {
  prefix: 'fad',
  iconName: 'rectangles-mixed',
  icon: [
    576,
    512,
    [],
    'e323',
    [
      'M64 352l0 80c0 26.5 21.5 48 48 48l176 0c26.5 0 48-21.5 48-48l0-80c0-26.5-21.5-48-48-48l-176 0c-26.5 0-48 21.5-48 48zM384 80l0 256c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-256c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
      'M0 80C0 53.5 21.5 32 48 32H272c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80z',
    ],
  ],
};
const faPhoneArrowUpRight = {
  prefix: 'fad',
  iconName: 'phone-arrow-up-right',
  icon: [
    512,
    512,
    ['phone-arrow-up', 'phone-outgoing'],
    'e224',
    [
      'M0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c1-3.5 1.4-7 1.4-10.5c0-15.8-9.4-30.6-24.6-36.9l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96C158.6 9.4 143.8 0 128 0c-3.5 0-7 .5-10.5 1.4l-88 24C12.1 30.2 0 46 0 64z',
      'M295 217c-9.4-9.4-9.4-24.6 0-33.9l135-135L384 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L488 0c13.3 0 24 10.7 24 24l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1L329 217c-9.4 9.4-24.6 9.4-33.9 0z',
    ],
  ],
};
const faPhoneArrowUp = faPhoneArrowUpRight;
const faPhoneOutgoing = faPhoneArrowUpRight;
const faTrashCan = {
  prefix: 'fad',
  iconName: 'trash-can',
  icon: [
    448,
    512,
    [61460, 'trash-alt'],
    'f2ed',
    [
      'M32 96l0 352c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352L32 96zm80 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm96 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm96 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z',
      'M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0z',
    ],
  ],
};
const faTrashAlt = faTrashCan;
const faCircleL = {
  prefix: 'fad',
  iconName: 'circle-l',
  icon: [
    512,
    512,
    [],
    'e114',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208z',
      'M184 128c13.3 0 24 10.7 24 24l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHeadSideGoggles = {
  prefix: 'fad',
  iconName: 'head-side-goggles',
  icon: [
    512,
    512,
    ['head-vr'],
    'f6ea',
    [
      'M32 192l208 0c14.6 19.4 37.8 32 64 32l112 0 32 0 32 0 2.6 0 19.8 24.8c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-104.2c0-17-7.1-33-17.5-46.4C50.3 293.2 32 246.5 32 201.7c0-3.3 .1-6.5 0-9.7zm13.9-64C75.3 53.1 148.3 0 233.7 0L256 0c56.9 0 108 24.7 143.1 64L304 64c-38.7 0-71 27.5-78.4 64L45.9 128z',
      'M304 64l112 0 0 160-112 0c-26.2 0-49.4-12.6-64-32L32 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l193.6 0C233 91.5 265.3 64 304 64zM480 224l-32 0 0-160 32 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faHeadVr = faHeadSideGoggles;
const faTextHeight = {
  prefix: 'fad',
  iconName: 'text-height',
  icon: [
    576,
    512,
    [],
    'f034',
    [
      'M0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 64 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320 64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L160 32 48 32C21.5 32 0 53.5 0 80z',
      'M457.4 41.4c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 192 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-192-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64z',
    ],
  ],
};
const faUserXmark = {
  prefix: 'fad',
  iconName: 'user-xmark',
  icon: [
    640,
    512,
    ['user-times'],
    'f235',
    [
      'M0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0C79.8 304 0 383.8 0 482.3zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z',
      'M505 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faUserTimes = faUserXmark;
const faFaceHandYawn = {
  prefix: 'fad',
  iconName: 'face-hand-yawn',
  icon: [
    512,
    512,
    [],
    'e379',
    [
      'M0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-32.8 0-53.6c0-28.7 23.3-52 52-52c1.8 0 3.6 .1 5.3 .3C184.8 246.3 217.8 224 256 224c28.7 0 54.5 12.6 72.1 32.6c14.8-2.4 30.4 2 41.8 13.4c12.2 12.2 16.5 29.4 12.8 45c1.1 .9 2.2 1.9 3.2 3c18.1 18.1 18.7 47.1 1.8 65.9c16.9 18.8 16.3 47.8-1.8 65.9l-49 49C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm99.5-70c-5.5-6.9-4.4-17 2.5-22.5c26.7-21.3 53.3-42.7 80-64c6.9-5.5 17-4.4 22.5 2.5s4.4 17-2.5 22.5c-26.7 21.3-53.3 42.7-80 64c-6.9 5.5-17 4.4-22.5-2.5zm208-84c5.5-6.9 15.6-8 22.5-2.5c26.7 21.3 53.3 42.7 80 64c3.9 3.2 6 7.8 6 12.5c0 3.5-1.1 7-3.5 10c-5.5 6.9-15.6 8-22.5 2.5c-26.7-21.3-53.3-42.7-80-64c-6.9-5.5-8-15.6-2.5-22.5z',
      'M204.5 102c-5.5-6.9-15.6-8-22.5-2.5l-80 64c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l80-64c6.9-5.5 8-15.6 2.5-22.5zm94.8 197.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM310 124.5l80 64c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5l-80-64c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5z',
    ],
  ],
};
const faGaugeSimpleMin = {
  prefix: 'fad',
  iconName: 'gauge-simple-min',
  icon: [
    512,
    512,
    ['tachometer-slowest'],
    'f62d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm64-8c0-4.3 1.2-8.7 3.6-12.6c7-11.3 21.8-14.8 33-7.8c39.2 24.3 78.4 48.5 117.6 72.8c10.6-7.8 23.7-12.4 37.8-12.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-3.7 .3-7.3 .9-10.8L75.4 268.4C68 263.9 64 256 64 248z',
      'M100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6z',
    ],
  ],
};
const faTachometerSlowest = faGaugeSimpleMin;
const faStethoscope = {
  prefix: 'fad',
  iconName: 'stethoscope',
  icon: [
    576,
    512,
    [129658],
    'f0f1',
    [
      'M160.5 348.9c5.1 1 10.3 1.8 15.5 2.3c2.6 .3 5.3 .5 7.9 .6c1.3 .1 2.7 .1 4 .1s2.7 0 4 0c11.2 0 22.1-1.2 32.8-2.8C231.3 404.8 278.6 448 336 448c61.9 0 112-50.1 112-112l0-70.7c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3s2.8 .1 4.3 .1c11.4 0 22.2-2.4 32-6.7l0 70.7c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1z',
      'M122.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S118.6-3.9 101.9 1.6L75.8 10.3C49.6 19.1 32 43.5 32 71.1L32 192c0 88.4 71.6 160 160 160s160-71.6 160-160l0-120.9c0-27.5-17.6-52-43.8-60.7L282.1 1.6c-16.8-5.6-34.9 3.5-40.5 20.2s3.5 34.9 20.2 40.5L288 71.1 288 192c0 53-43 96-96 96s-96-43-96-96L96 71.1l26.1-8.7zM512 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z',
    ],
  ],
};
const faCoffin = {
  prefix: 'fad',
  iconName: 'coffin',
  icon: [
    384,
    512,
    [9904],
    'f6c6',
    [
      'M11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6z',
      '',
    ],
  ],
};
const faMessage = {
  prefix: 'fad',
  iconName: 'message',
  icon: [
    512,
    512,
    ['comment-alt'],
    'f27a',
    [
      'M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l96 0 0 80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0z',
      '',
    ],
  ],
};
const faCommentAlt = faMessage;
const faSalad = {
  prefix: 'fad',
  iconName: 'salad',
  icon: [
    512,
    512,
    [129367, 'bowl-salad'],
    'f81e',
    [
      'M0 160c0 53 43 96 96 96l73.4 0L84.7 171.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 249.4 208 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144 52 0c-2.6-10.2-4-21-4-32c0-70.7 57.3-128 128-128c2.6 0 5.2 .1 7.8 .2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4C43 64 0 107 0 160zm320 64c0 11.2 1.9 22 5.5 32l181.1 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96z',
      'M27.4 288C12.3 288 0 300.3 0 315.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28l231.5 0c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 446.1 512 385.9 512 315.4c0-15.1-12.3-27.4-27.4-27.4L27.4 288z',
    ],
  ],
};
const faBowlSalad = faSalad;
const faInfo = {
  prefix: 'fad',
  iconName: 'info',
  icon: [
    192,
    512,
    [],
    'f129',
    [
      'M48 80a48 48 0 1 0 96 0A48 48 0 1 0 48 80z',
      'M32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-224c0-17.7-14.3-32-32-32l-64 0z',
    ],
  ],
};
const faRobotAstromech = {
  prefix: 'fad',
  iconName: 'robot-astromech',
  icon: [
    512,
    512,
    [],
    'e2d2',
    [
      'M2.3 487.8c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1l96 0c8.8 0 16-7.2 16-16l0-112 45.3 45.3c12 12 28.3 18.7 45.3 18.7l75 0c17 0 33.3-6.7 45.3-18.7L384 384l0 112c0 8.8 7.2 16 16 16l96 0c5.8 0 11.1-3.1 13.9-8.1c1.4-2.4 2.1-5.2 2.1-7.9c0-2.9-.8-5.7-2.3-8.2L470.8 423c-4.5-7.5-6.8-16-6.8-24.7L464 240c0-26.5-21.5-48-48-48l-32 0-256 0-32 0c-26.5 0-48 21.5-48 48l0 158.3c0 8.7-2.4 17.2-6.8 24.7L2.3 487.8zM192 272c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
      'M128 128C128 57.3 185.3 0 256 0s128 57.3 128 128l0 64-256 0 0-64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 256l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faRingDiamond = {
  prefix: 'fad',
  iconName: 'ring-diamond',
  icon: [
    384,
    512,
    [],
    'e5ab',
    [
      'M98.5 61.3C95 68.4 95.2 76.7 99 83.7l30.4 54.8c19.6-6.8 40.7-10.4 62.6-10.4c1.4 0 2.7 0 4.1 0s2.7 .1 4.1 .1c2.7 .1 5.4 .3 8.1 .5c5.4 .4 10.7 1.1 15.9 2c10.4 1.8 20.6 4.4 30.4 7.7L285 83.7c3.8-6.9 4-15.3 .5-22.4l-24-48C257.4 5.1 249.1 0 240 0L144 0c-9.1 0-17.4 5.1-21.5 13.3l-24 48z',
      'M192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM384 320A192 192 0 1 1 0 320a192 192 0 1 1 384 0z',
    ],
  ],
};
const faFonduePot = {
  prefix: 'fad',
  iconName: 'fondue-pot',
  icon: [
    512,
    512,
    [129749],
    'e40d',
    [
      'M64 224l0 16 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16s16-7.2 16-16l0-32 0-16-48 0-48 0zm160 0l32.5 0 16.3-65.2c10.6-3 19.4-11.5 22.2-23l24-96c4.3-17.1-6.1-34.5-23.3-38.8S261.2 7.1 257 24.2l-24 96c-2.9 11.5 .9 23.1 8.8 30.8l-17.3 69.1c-.3 1.3-.5 2.6-.5 3.9zm80 0l35.2 0 42.7-64.1c11 .7 22.1-4.3 28.7-14.2l64-96c9.8-14.7 5.8-34.6-8.9-44.4S431.2-.5 421.4 14.2l-64 96c-6.6 9.9-7 22-2.1 31.9l-48.6 72.9c-1.8 2.7-2.7 5.8-2.7 8.9z',
      'M64 224l-32 0c-17.7 0-32 14.3-32 32l0 64c0 52.3 25.1 98.8 64 128l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-3.2c10.3 2.1 21 3.2 32 3.2l128 0c11 0 21.7-1.1 32-3.2l0 3.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c38.9-29.2 64-75.7 64-128l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0-64 0-224 0 0 16 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-16z',
    ],
  ],
};
const faTheta = {
  prefix: 'fad',
  iconName: 'theta',
  icon: [
    384,
    512,
    [],
    'f69e',
    [
      'M96 256c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32z',
      'M104.2 128.4C79.9 160 64 205 64 256s15.9 96 40.2 127.6C128.5 415.1 159.8 432 192 432s63.5-16.9 87.8-48.4C304.1 352 320 307 320 256s-15.9-96-40.2-127.6C255.5 96.9 224.2 80 192 80s-63.5 16.9-87.8 48.4zm-50.7-39C87.1 45.7 135.8 16 192 16s104.9 29.7 138.5 73.4C364.1 133.1 384 192.1 384 256s-19.9 122.9-53.5 166.6C296.9 466.3 248.2 496 192 496s-104.9-29.7-138.5-73.4C19.9 378.9 0 319.9 0 256S19.9 133.1 53.5 89.4z',
    ],
  ],
};
const faFaceHandPeeking = {
  prefix: 'fad',
  iconName: 'face-hand-peeking',
  icon: [
    640,
    512,
    [129763],
    'e481',
    [
      'M80.4 346.4C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2c-5.4 .7-10.8 1.1-16.3 1.1l-64.8 0c-22.1 0-40-17.9-40-40c0-.3 0-.6 0-.9l-8 0c-22.1 0-40-17.9-40-40c0-1.1 0-2.2 .1-3.3c-37-10.4-64.1-44.4-64.1-84.7c0-48.6 39.4-88 88-88c6.6 0 13 .7 19.2 2.1c11.8-4 25.2-2.4 36.1 5.4l37.9 27.1c1.1-9.6 5.3-18.9 12.6-26.2c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0C248.5 0 183.8 29.3 137.3 76.6c7.7 1.8 14.9 5.7 20.9 11.7c17.2 17.2 17.2 45 0 62.2l-1.5 1.5 75.2 0c22.1 0 40 17.9 40 40c0 2.6-.2 5.1-.7 7.5c10.1 7.3 16.7 19.1 16.7 32.5s-6.6 25.3-16.7 32.5c.5 2.4 .7 4.9 .7 7.5c0 22.1-17.9 40-40 40l-8 0c0 .3 0 .6 0 .9c0 22.1-17.9 40-40 40l-64.8 0c-13.3 0-26.4-2.2-38.8-6.5zM256 400c0-26.5 28.7-48 64-48s64 21.5 64 48s-28.7 48-64 48s-64-21.5-64-48zM368.4 224c0 6.1 2.3 11.8 6.1 16l35.8 0c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M232 208c8.8 0 16-7.2 16-16s-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9l64.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-14 0c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0zm182.7-19c-7.2-5.1-8.9-15.1-3.7-22.3s15.1-8.9 22.3-3.7l81.8 58.4c2.3 1.6 5.1 2.3 7.8 2c9.3-1.1 13.2-12.4 6.6-19l-14.8-14.8c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l45.1 45.1 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9H456c-8.8 0-16-7.2-16-16s7.2-16 16-16h19.5c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5L408 328c-8.8 0-16-7.2-16-16s7.2-16 16-16h68c2.2 0 4-1.8 4-4s-1.8-4-4-4H392c-8.8 0-16-7.2-16-16s7.2-16 16-16l74.6 0c7.4 0 13.4-6 13.4-13.4c0-4.3-2.1-8.4-5.6-10.9L414.7 189z',
    ],
  ],
};
const faSquareUser = {
  prefix: 'fad',
  iconName: 'square-user',
  icon: [
    448,
    512,
    [],
    'e283',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM81.1 416l285.7 0c-7.8-54.3-54.4-96-110.9-96l-64 0c-56.4 0-103.1 41.7-110.9 96zM152 200c0 39.8 32.2 72 72 72c19.9 0 37.9-8.1 50.9-21.1c6.5-6.5 11.8-14.3 15.4-22.9c1.8-4.3 3.2-8.8 4.2-13.5c.5-2.3 .8-4.7 1.1-7.1c.1-1.2 .2-2.4 .3-3.6c.1-1.2 .1-2.4 .1-3.7c0-1.4 0-2.6-.1-3.8s-.2-2.4-.3-3.7c-.2-2.4-.6-4.8-1.1-7.2c-1-4.7-2.4-9.2-4.2-13.5c-3.6-8.6-8.9-16.4-15.4-22.9c-13-13-31-21.1-50.9-21.1c-39.8 0-72 32.2-72 72z',
      'M152 200a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM81.1 416c7.8-54.3 54.4-96 110.9-96l64 0c56.4 0 103.1 41.7 110.9 96L81.1 416z',
    ],
  ],
};
const faDownLeftAndUpRightToCenter = {
  prefix: 'fad',
  iconName: 'down-left-and-up-right-to-center',
  icon: [
    512,
    512,
    ['compress-alt'],
    'f422',
    [
      'M0 456c0 6.1 2.3 12.3 7 17l32 32c9.4 9.4 24.6 9.4 33.9 0l87-87 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-144c0-13.3-10.7-24-24-24L72 272c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39L7 439c-4.7 4.7-7 10.8-7 17z',
      'M473 7c-9.4-9.4-24.6-9.4-33.9 0l-87 87L313 55c-6.9-6.9-17.2-8.9-26.2-5.2S272 62.3 272 72l0 144c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-39-39 87-87c9.4-9.4 9.4-24.6 0-33.9L473 7z',
    ],
  ],
};
const faCompressAlt = faDownLeftAndUpRightToCenter;
const faExplosion = {
  prefix: 'fad',
  iconName: 'explosion',
  icon: [
    576,
    512,
    [],
    'e4e9',
    [
      'M34.4 333.5c-5.2 10.7-1.8 23.5 7.9 30.3l87.4 60.5c-1.2 7.7-1.8 15.7-1.8 23.7c21.3 0 42.7 0 64 0c0-53 43-96 96-96s96 43 96 96c21.3 0 42.7 0 64 0c0-9.4-.8-18.7-2.4-27.7L537 329c8.5-8.5 9.4-21.9 2.2-31.5s-20.4-12.3-30.9-6.4l-97.2 54.7c-2-2.4-4.1-4.8-6.3-7.1L541.9 33.9c1.4-3.2 2.1-6.5 2.1-9.8c0-8.6-4.7-16.9-12.7-21.2c-11.2-5.9-25-2.2-31.7 8.5L325.4 291.6 311.9 149.7C310.7 137.4 300.4 128 288 128s-22.7 9.4-23.9 21.7L250.5 292.4c-1.5 .4-3 .7-4.5 1.1L143.6 205.8c-8.9-7.7-22.1-7.7-31.1-.1s-11.2 20.6-5.1 30.7l62.3 103.9c-3.3 3.6-6.4 7.4-9.4 11.3L63.2 321.1c-11.3-3.5-23.5 1.7-28.7 12.4zM264 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M0 480c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faFileLines = {
  prefix: 'fad',
  iconName: 'file-lines',
  icon: [
    384,
    512,
    [128441, 128462, 61686, 'file-alt', 'file-text'],
    'f15c',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 272c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
    ],
  ],
};
const faFileAlt = faFileLines;
const faFileText = faFileLines;
const faWaveSquare = {
  prefix: 'fad',
  iconName: 'wave-square',
  icon: [
    640,
    512,
    [],
    'f83e',
    [
      'M128 64c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 352 96 0 0-160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 160c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-352-96 0 0 160c0 17.7-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-160z',
      '',
    ],
  ],
};
const faRing = {
  prefix: 'fad',
  iconName: 'ring',
  icon: [
    512,
    512,
    [],
    'f70b',
    [
      'M64 206.5c0 .5 0 1 0 1.5c0 .6 0 1.2 0 1.7c.9 11.3 10.6 28 39.3 44.3c40-18.6 93.7-30 152.6-30s112.6 11.4 152.6 30c28.8-16.3 38.4-33 39.3-44.3c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5c-.9-12.3-12.2-31.2-47.9-49.1c-31-15.5-74.3-26.5-123.8-29c-6.7-.3-13.4-.4-20.3-.4s-13.6 .1-20.3 .4c-49.5 2.4-92.8 13.5-123.8 29c-35.6 17.8-47 36.7-47.9 49.1z',
      'M111.9 157.4C147.1 139.8 198 128 256 128s108.9 11.8 144.1 29.4C437.2 176 448 195.7 448 208s-10.8 32-47.9 50.6C364.9 276.2 314 288 256 288s-108.9-11.8-144.1-29.4C74.8 240 64 220.3 64 208s10.8-32 47.9-50.6zM83.3 100.2C39.4 122.2 0 158.4 0 208l0 96c0 49.6 39.4 85.8 83.3 107.8C129.1 434.7 190.3 448 256 448s126.9-13.3 172.7-36.2c43.9-22 83.3-58.2 83.3-107.8l0-96c0-49.6-39.4-85.8-83.3-107.8C382.9 77.3 321.7 64 256 64s-126.9 13.3-172.7 36.2z',
    ],
  ],
};
const faBuildingUn = {
  prefix: 'fad',
  iconName: 'building-un',
  icon: [
    384,
    512,
    [],
    'e4d9',
    [
      'M0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64zm80 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM208 80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4c11.6 17.3 23.1 34.7 34.7 52L272 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3c-1.5 .5-3.1 .7-4.6 .7c-5.2 0-10.3-2.6-13.3-7.1c-11.6-17.3-23.1-34.7-34.7-52l0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm48 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M237.3 71.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-43.2 34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.2-34.7-52zM112 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z',
    ],
  ],
};
const faDiceThree = {
  prefix: 'fad',
  iconName: 'dice-three',
  icon: [
    448,
    512,
    [9858],
    'f527',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm160 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faTirePressureWarning = {
  prefix: 'fad',
  iconName: 'tire-pressure-warning',
  icon: [
    512,
    512,
    [],
    'f633',
    [
      'M2 290.4c0 7.5 .4 15.1 1.3 22.9C8.6 361.9 31.3 412.3 80 462l0 34c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-8 32 0 0 8c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-8 32 0 0 8c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-8 32 0 0 8c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-34c48.7-49.7 71.4-100.1 76.8-148.7c.9-7.8 1.3-15.4 1.3-22.9c0-44.1-13.7-82.8-28.7-113.2c-7.8-15.8-14.5-30-19.3-44.4l-2.5-7.4C451.9 102.5 448 78.5 448 54.5L448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 22.5c0 31 5 61.7 14.8 91.1l2.5 7.4c6.3 19 14.8 36.6 22.6 52.5c14.7 29.7 25.3 64 21.3 100.9c-3.7 34-20.4 74.1-65.7 117.7l-246.8 0c-45.3-43.6-62-83.7-65.7-117.7c-4.1-36.9 6.6-71.1 21.3-100.9c7.8-15.8 16.3-33.5 22.6-52.5l2.5-7.4C123 116.2 128 85.4 128 54.5L128 32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 22.5c0 24.1-3.9 48-11.5 70.8L50 132.7c-4.8 14.4-11.5 28.6-19.3 44.4C15.7 207.6 2 246.3 2 290.4z',
      'M280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faWifiFair = {
  prefix: 'fad',
  iconName: 'wifi-fair',
  icon: [
    640,
    512,
    ['wifi-2'],
    'f6ab',
    [
      'M0 179.8c0 8 3 15.9 8.9 22.2c6.3 6.5 14.7 9.8 23.1 9.8c8 0 15.9-3 22.2-8.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c6.2 6 14.2 8.9 22.2 8.9c8.4 0 16.8-3.3 23.1-9.8c12.2-12.8 11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C3.3 163 0 171.4 0 179.8z',
      'M171.8 312c39.5-34.9 91.3-56 148.2-56s108.7 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faWifi2 = faWifiFair;
const faCalendarDays = {
  prefix: 'fad',
  iconName: 'calendar-days',
  icon: [
    448,
    512,
    ['calendar-alt'],
    'f073',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM192 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM320 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32z',
    ],
  ],
};
const faCalendarAlt = faCalendarDays;
const faMp3Player = {
  prefix: 'fad',
  iconName: 'mp3-player',
  icon: [
    384,
    512,
    [],
    'f8ce',
    [
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 96l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zM96 352a96 96 0 1 0 192 0A96 96 0 1 0 96 352z',
      'M96 64l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM224 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 352a96 96 0 1 1 192 0A96 96 0 1 1 96 352z',
    ],
  ],
};
const faAnchorCircleCheck = {
  prefix: 'fad',
  iconName: 'anchor-circle-check',
  icon: [
    640,
    512,
    [],
    'e4aa',
    [
      'M0 336c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-4.7 4.7-7 10.8-7 17zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faTally4 = {
  prefix: 'fad',
  iconName: 'tally-4',
  icon: [
    640,
    512,
    [],
    'e297',
    [
      'M96 64l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 0l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 0l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M512 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faRectangleHistory = {
  prefix: 'fad',
  iconName: 'rectangle-history',
  icon: [
    512,
    512,
    [],
    'e4a2',
    [
      'M48 104c0 13.3 10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24zM96 24c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24z',
      'M448 160c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0z',
    ],
  ],
};
const faBuildingCircleArrowRight = {
  prefix: 'fad',
  iconName: 'building-circle-arrow-right',
  icon: [
    640,
    512,
    [],
    'e4d1',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 184.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z',
    ],
  ],
};
const faVolleyball = {
  prefix: 'fad',
  iconName: 'volleyball',
  icon: [
    512,
    512,
    [127952, 'volleyball-ball'],
    'f45f',
    [
      'M0 256C0 157.2 56 71.5 138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256zM30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9c9.7 19.3 17.5 39.8 22.9 61.1c2.7 10.7 4.9 21.6 6.5 32.7c.8 5.6 1.4 11.2 1.9 16.8c.2 2.8 .4 5.6 .6 8.5c.2 2.7 .3 5.5 .4 8.1c0 .1 0 .3 0 .4C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2zm87.8 94.6c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71c-50.7 0-98-14.7-137.8-40.2zm43.5-105.5c23.7-36.2 55.4-67.8 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5zm8.2-351.5C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9c0-.1 0-.2 0-.4c-.1-2.6-.2-5.3-.3-8c-.1-2.8-.3-5.6-.6-8.6c-.2-2.7-.5-5.5-.7-8.3c-.3-2.7-.6-5.5-1-8.3c-1.4-11-3.4-21.9-5.8-32.6s-5.4-21.2-8.9-31.5c-1.7-5.1-3.6-10.2-5.6-15.3c-1-2.5-2-4.9-3.1-7.5c-1-2.3-2-4.7-3.2-7.3c-8.8-19.6-19.4-38.2-31.6-55.6c-6.1-8.7-12.6-17.1-19.5-25.2c-3.4-4-6.9-7.9-10.6-11.8c-1.8-1.9-3.6-3.8-5.6-5.8c-1.8-1.8-3.5-3.6-5.3-5.3c-.1-.1-.2-.2-.2-.2zm157.6-4.7C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.3 11.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.6-204.2-103.2-272.4z',
      'M138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9c5.2 21.2 13 41.5 23.1 60.3c6.7-108.7 71.9-209.9 177.1-257.9c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451c8.9 7.5 18.2 14.5 28.1 20.8c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c15.6-14.9 29.3-31.8 40.7-50.2c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.8 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6c2.1-11.3 3.4-22.9 3.9-34.7c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C307.3 4.2 286 .8 263.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.2-2.4-86.4-14.1-126.8-35.9c-2.5-90.9-41.1-172.7-101.9-231.7c-11 3.9-21.7 8.6-32 14z',
    ],
  ],
};
const faVolleyballBall = faVolleyball;
const faSunHaze = {
  prefix: 'fad',
  iconName: 'sun-haze',
  icon: [
    640,
    512,
    [],
    'f765',
    [
      'M64 156.6c0 3.2 1 6.4 2.8 9.1L129.1 256l62.9 0c0-70.7 57.3-128 128-128s128 57.3 128 128l62.9 0 62.3-90.3c1.9-2.7 2.8-5.9 2.8-9.1c0-2.1-.4-4.2-1.2-6.1c-2.1-5-6.6-8.6-11.9-9.6L455 121 435.1 13.1c-1-5.3-4.6-9.8-9.6-11.9c-2-.8-4-1.2-6.1-1.2c-3.2 0-6.4 1-9.1 2.8L320 65.1 229.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L185 121 77.1 140.9c-5.3 1-9.8 4.6-11.9 9.6c-.8 2-1.2 4.1-1.2 6.1zM224 256l192 0c0-53-43-96-96-96s-96 43-96 96z',
      'M640 312c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24zm-208 0c0-13.3-10.7-24-24-24L88 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l320 0c13.3 0 24-10.7 24-24zm144 88c0-13.3-10.7-24-24-24L24 376c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24zM88 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 464zm208 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0z',
    ],
  ],
};
const faTextSize = {
  prefix: 'fad',
  iconName: 'text-size',
  icon: [
    640,
    512,
    [],
    'f894',
    [
      'M0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 96 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320 96 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L192 32 48 32C21.5 32 0 53.5 0 80z',
      'M384 288l0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-64 0 0 128 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-128-64 0z',
    ],
  ],
};
const faUfo = {
  prefix: 'fad',
  iconName: 'ufo',
  icon: [
    640,
    512,
    [128760],
    'e047',
    [
      'M144 237.1s51.8 50.9 176 50.9s176-50.9 176-50.9c0-8.3-.6-16.5-1.7-24.5C482.2 128.6 408.8 64 320 64s-162.2 64.6-174.3 148.6c-1.2 8-1.7 16.2-1.7 24.5z',
      'M320 288c124.2 0 176-50.9 176-50.9c0-8.3-.6-16.5-1.7-24.5C582 235.5 640 275 640 320c0 70.7-143.3 128-320 128S0 390.7 0 320c0-45 58-84.5 145.7-107.4c-1.2 8-1.7 16.2-1.7 24.5c0 0 51.8 50.9 176 50.9zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm408-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faFork = {
  prefix: 'fad',
  iconName: 'fork',
  icon: [
    512,
    512,
    ['utensil-fork'],
    'f2e3',
    [
      'M240 157.1c0 19.3 5.5 37.9 15.7 53.9c3.9 6.1 8.4 11.8 13.6 17c4.9 4.9 9.8 9.8 14.6 14.6c5.2 5.2 10.9 9.8 17 13.6c16 10.2 34.7 15.7 53.9 15.7c33.5 0 64.8-16.8 83.4-44.6l71-106.5c1.8-2.7 2.7-5.8 2.7-8.9c0-4.6-2-9.2-5.9-12.4c-6.4-5.2-15.6-4.8-21.5 1.1L393.4 192c-5.2 5.2-13.6 5.2-18.8 0c-4.9-4.9-5.2-12.8-.6-18.1l86.1-99.4c5.5-6.3 5.2-15.9-.8-21.8s-15.4-6.3-21.8-.8L338.1 138c-5.3 4.6-13.2 4.3-18.1-.6c-5.2-5.2-5.2-13.6 0-18.8l91.3-91.3c5.8-5.8 6.3-15.1 1.1-21.5S398-1.9 391.1 2.7l-106.5 71C256.8 92.3 240 123.6 240 157.1z',
      'M9.4 457.4L255.7 211c3.9 6.1 8.4 11.8 13.6 17L284 242.6c5.2 5.2 10.9 9.8 17 13.6L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3z',
    ],
  ],
};
const faUtensilFork = faFork;
const faArrowsUpToLine = {
  prefix: 'fad',
  iconName: 'arrows-up-to-line',
  icon: [
    576,
    512,
    [],
    'e4c2',
    [
      'M0 64C0 46.3 14.3 32 32 32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64z',
      'M54.6 278.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 237.3 160 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7L54.6 278.6zm320 0c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 237.3 480 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-41.4 41.4z',
    ],
  ],
};
const faMobileSignal = {
  prefix: 'fad',
  iconName: 'mobile-signal',
  icon: [
    512,
    512,
    [],
    'e1ef',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l160 0 0-24c0-13.6 1-27 3-40L64 448 64 64l224 0 0 251.7c18.3-21.2 39.9-39.5 64-54L352 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM128 400c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z',
      'M512 280c0-13.3-10.7-24-24-24c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24zM448 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40-128c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
    ],
  ],
};
const faBarcodeScan = {
  prefix: 'fad',
  iconName: 'barcode-scan',
  icon: [
    640,
    512,
    [],
    'f465',
    [
      'M0 256c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z',
      'M64 56c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 136-64 0L64 56zm0 264l64 0 0 136c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-136zm96 0l32 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144zm64 0l64 0 0 136c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-136zm64-128l-64 0 0-136c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 136zm32 128l64 0 0 136c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-136zm64-128l-64 0 0-136c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 136zm64 128l32 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144zm32-128l-32 0 0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144zm32 128l64 0 0 136c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-136zm64-128l-64 0 0-136c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 136zm-384 0l-32 0 0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144z',
    ],
  ],
};
const faSortDown = {
  prefix: 'fad',
  iconName: 'sort-down',
  icon: [
    320,
    512,
    ['sort-desc'],
    'f0dd',
    [
      'M0 192c0 4.1 .8 8.3 2.4 12.2c5 12 16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128C3.3 175.5 0 183.7 0 192zm109.3-32L160 109.3 210.7 160l-101.5 0z',
      'M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z',
    ],
  ],
};
const faSortDesc = faSortDown;
const faFolderArrowDown = {
  prefix: 'fad',
  iconName: 'folder-arrow-down',
  icon: [
    512,
    512,
    ['folder-download'],
    'e053',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM160 288c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l31 31L232 200c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.1 31-31c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17l-72 72c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7l-72-72c-4.7-4.7-7-10.8-7-17z',
      'M256 176c13.3 0 24 10.7 24 24l0 102.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L232 200c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faFolderDownload = faFolderArrowDown;
const faCircleMinus = {
  prefix: 'fad',
  iconName: 'circle-minus',
  icon: [
    512,
    512,
    ['minus-circle'],
    'f056',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 0c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M160 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faMinusCircle = faCircleMinus;
const faFaceIcicles = {
  prefix: 'fad',
  iconName: 'face-icicles',
  icon: [
    512,
    512,
    [],
    'e37c',
    [
      'M0 256c0 19.7 2.2 38.9 6.5 57.4l18 107.9C27 436.7 40.4 448 56 448c8.3 0 15.9-3.1 21.6-8.4C123.7 484.4 186.6 512 256 512c31.1 0 60.9-5.5 88.5-15.7c5.7 9.6 16.1 15.7 27.5 15.7c13.6 0 25.7-8.6 30.2-21.4l11.5-32.9c5.4-4.2 10.5-8.6 15.6-13.2l2.8 37.9c1.2 16.7 15.2 29.6 31.9 29.6s30.7-12.9 31.9-29.6l14.8-200c0-.5 .1-1.1 .1-1.6c.8-8.1 1.2-16.4 1.2-24.7C512 114.6 397.4 0 256 0S0 114.6 0 256zm35.9 39.7C33.9 283.3 43.4 272 56 272s22.1 11.3 20.1 23.7C69.4 335.7 62.7 375.8 56 415.8l-20-120.1zM112.7 344c3.8-22.7 23.6-40 47.3-40l8 0 0 40-55.3 0zm0 16l55.3 0 0 40-8 0c-23.8 0-43.5-17.3-47.3-40zm95.7-152a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM184 304l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-64 0 0-40zm80-56l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-32 48-32-48 0-40zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM344 304l8 0c23.8 0 43.5 17.3 47.3 40L344 344l0-40zm0 56l56 0 0 40-28 80-28-80 0-40zm98.2-112.1C441 235.1 451.1 224 464 224s23 11.1 21.8 23.9L464 480 442.2 247.9z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faShovel = {
  prefix: 'fad',
  iconName: 'shovel',
  icon: [
    512,
    512,
    [],
    'f713',
    [
      'M201.4 265.4c15.1 15.1 30.2 30.2 45.3 45.3l97-97c13.3 6.6 28.4 10.3 44.3 10.3c26.5 0 51.9-10.5 70.6-29.3l44.1-44.1c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-96-96C400.4 3.1 392.2 0 384 0s-16.4 3.1-22.6 9.4L317.3 53.5C298.5 72.2 288 97.6 288 124.1c0 15.9 3.7 30.9 10.3 44.3l-97 97zM352 124.1c0-9.5 3.8-18.6 10.5-25.4L384 77.3 434.7 128l-21.5 21.5c-6.7 6.7-15.9 10.5-25.4 10.5c-19.8 0-35.9-16.1-35.9-35.9z',
      'M0 386.3V480c0 17.7 14.3 32 32 32h93.7c42.4 0 83.1-16.9 113.1-46.9l58.5-58.5c12.5-12.5 12.5-32.8 0-45.3L150.6 214.6c-12.5-12.5-32.8-12.5-45.3 0L46.9 273.1C16.9 303.1 0 343.8 0 386.3z',
    ],
  ],
};
const faDoorOpen = {
  prefix: 'fad',
  iconName: 'door-open',
  icon: [
    576,
    512,
    [],
    'f52b',
    [
      'M64 92.5L64 448l0 32 0 32 32 0 192 0 32 0 0-32 0-352 0-64 0-32c0-9.9-4.5-19.2-12.3-25.2C302 2.3 295.1 0 288 0c-2.6 0-5.2 .3-7.8 1l-179.9 45C79 51.3 64 70.5 64 92.5zM208 256c0-17.7 10.7-32 24-32s24 14.3 24 32s-10.7 32-24 32s-24-14.3-24-32z',
      'M320 128l128 0 0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320c0-35.3-28.7-64-64-64L320 64l0 64zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0-64-32 0zM232 288c13.3 0 24-14.3 24-32s-10.7-32-24-32s-24 14.3-24 32s10.7 32 24 32z',
    ],
  ],
};
const faFilms = {
  prefix: 'fad',
  iconName: 'films',
  icon: [
    576,
    512,
    [],
    'e17a',
    [
      'M0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24S0 106.7 0 120zm256-8l0 48c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm0 144l0 48c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32z',
      'M96 96c0-35.3 28.7-64 64-64l352 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64L96 96zm56 0l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM488 80c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM152 200l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm336-16c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM152 304l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm336-16c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM256 112l0 48c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm32 112c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-96 0z',
    ],
  ],
};
const faRightFromBracket = {
  prefix: 'fad',
  iconName: 'right-from-bracket',
  icon: [
    512,
    512,
    ['sign-out-alt'],
    'f2f5',
    [
      'M-.3 128l0 256c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-53 0-96 43-96 96z',
      'M500.4 228.7L377.7 105.9c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1-128 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L500.4 283.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z',
    ],
  ],
};
const faSignOutAlt = faRightFromBracket;
const faFaceGlasses = {
  prefix: 'fad',
  iconName: 'face-glasses',
  icon: [
    512,
    512,
    [],
    'e377',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c-2.2 1.2-4.8 1.8-7.5 1.8l-32 0 0 56c0 30.9-25.1 56-56 56l-80 0c-30.9 0-56-25.1-56-56l0-56-32 0 0 56c0 30.9-25.1 56-56 56l-80 0c-30.9 0-56-25.1-56-56l0-56-32 0c-.7 0-1.3 0-2-.1s-1.3-.2-1.9-.4c-1.2-.3-2.4-.8-3.6-1.4C3 211.2 0 233.2 0 256zm18.6-96l34.8 0c9-18.9 28.3-32 50.6-32l80 0c22.3 0 41.6 13.1 50.6 32l42.8 0c9-18.9 28.3-32 50.6-32l80 0c22.3 0 41.6 13.1 50.6 32l34.8 0C455.4 66.2 363.4 0 256 0S56.6 66.2 18.6 160zM139.9 362.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 362.2 212.6 384 256 384s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 388.1 311.1 416 256 416s-93.8-27.9-116.1-53.5z',
      'M16 192l32 0 0 56c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-56 32 0 0 56c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-56 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-37.4 0c-9-18.9-28.3-32-50.6-32l-80 0c-22.3 0-41.6 13.1-50.6 32l-42.8 0c-9-18.9-28.3-32-50.6-32l-80 0c-22.3 0-41.6 13.1-50.6 32L16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16zm64 56l0-56 0-8c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 64c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zm352-56l0 56c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 8zM184.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faNfc = {
  prefix: 'fad',
  iconName: 'nfc',
  icon: [
    448,
    512,
    [],
    'e1f7',
    [
      'M96 144l0 224c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16l0 66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7c0-5.6 1-11 2.7-16L144 128l-32 0c-8.8 0-16 7.2-16 16z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l66.7 0c6.6-18.6 24.4-32 45.3-32l80 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faAtom = {
  prefix: 'fad',
  iconName: 'atom',
  icon: [
    512,
    512,
    [9883],
    'f5d2',
    [
      'M42.4 128C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2c7.1-12.7 10.4-26.4 10.4-40.8c0-27.6-12.3-57.5-34-87.2c21.7-29.8 34-59.7 34-87.2c0-14.3-3.3-28.1-10.4-40.8c-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2zm55.9 31.1c1.6-2.9 8.4-13 40.2-11.7c-2.8 13.1-5 26.9-6.7 41.2c-7.6 6.1-14.8 12.3-21.6 18.6C91.4 177 96 163.3 98.3 159.1zm0 193.8c-2.3-4.2-7-17.9 11.9-48.1c6.8 6.3 14 12.5 21.6 18.6c1.7 14.2 3.9 28 6.7 41.2c-31.8 1.4-38.6-8.7-40.2-11.7zM336 256a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM221.1 99.7C237.9 65.9 252.1 64 256 64s18.1 1.9 34.9 35.7c-11.4 3.9-23.1 8.4-34.9 13.5c-11.8-5.1-23.4-9.7-34.9-13.5zm0 312.6c11.4-3.9 23.1-8.4 34.9-13.5c11.8 5.1 23.4 9.7 34.9 13.5c-16.7 33.8-31 35.7-34.9 35.7s-18.1-1.9-34.9-35.7zM373.5 147.5c31.8-1.4 38.6 8.7 40.2 11.7c2.3 4.2 7 17.9-11.9 48.1c-6.8-6.3-14-12.5-21.6-18.6c-1.7-14.3-3.9-28-6.7-41.2zm0 217.1c2.8-13.1 5-26.9 6.7-41.2c7.6-6.1 14.8-12.3 21.6-18.6c18.9 30.2 14.2 44 11.9 48.1c-1.6 2.9-8.4 13-40.2 11.7z',
      'M224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faSoap = {
  prefix: 'fad',
  iconName: 'soap',
  icon: [
    512,
    512,
    [129532],
    'e06e',
    [
      'M160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm96 144a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM352 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M385.6 262.1C404.3 244.5 416 219.6 416 192c53 0 96 43 96 96l0 128c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 288c0-53 43-96 96-96l128 0c0 24.6 9.2 47 24.4 64L160 256c-53 0-96 43-96 96s43 96 96 96l192 0c53 0 96-43 96-96c0-41.2-25.9-76.3-62.4-89.9zM320 288l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l160 0z',
    ],
  ],
};
const faIcons = {
  prefix: 'fad',
  iconName: 'icons',
  icon: [
    512,
    512,
    ['heart-music-camera-bolt'],
    'f86d',
    [
      'M19.9 119.2l96.9 99.9c6 6.5 16.5 6.5 23 0l96.4-99.9c28-29 26.5-76.9-4.5-103.9C219.2 4.9 204.2 0 189.2 0c-18.8 0-37.6 7.7-51.5 21.8l-9.5 10.5-10-10.5c-25-25.5-66.4-30-93.4-6.5c-31.5 27-33 74.9-5 103.9zM321 389.6c2.3 6.2 8.3 10.4 15 10.4l55.7 0-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7s-8.3-10.4-15-10.4l-55.7 0 38.4-89.7c2.9-6.9 .7-14.9-5.3-19.2s-14.3-4-19.9 .9l-128 112c-5 4.4-6.8 11.4-4.4 17.7z',
      'M500.3 7.3C507.7 13.3 512 22.4 512 32l0 144c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-57L352 90.2 352 208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-96c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2l61.7 0c10.7 0 20.7 5.3 26.6 14.2L213.3 304l42.7 0c17.7 0 32 14.3 32 32l0 144c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32L0 336c0-17.7 14.3-32 32-32l42.7 0zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
    ],
  ],
};
const faHeartMusicCameraBolt = faIcons;
const faMicrophoneLinesSlash = {
  prefix: 'fad',
  iconName: 'microphone-lines-slash',
  icon: [
    640,
    512,
    ['microphone-alt-slash'],
    'f539',
    [
      'M144 216l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6zM224 96l0 54.3c33.5 26.2 66.9 52.5 100.4 78.7c2.9-3.1 7-5 11.6-5l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c0-53-43-96-96-96s-96 43-96 96zM358.9 256c16.4 12.8 32.7 25.6 49.1 38.5c5.2-11.8 8-24.8 8-38.5l-57.1 0zm74.9 58.7c12.8 10 25.5 20 38.3 30c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24 0 16c0 21.2-5.1 41.1-14.2 58.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faMicrophoneAltSlash = faMicrophoneLinesSlash;
const faClosedCaptioningSlash = {
  prefix: 'fad',
  iconName: 'closed-captioning-slash',
  icon: [
    640,
    512,
    [],
    'e135',
    [
      'M32 121.2L32 416c0 35.3 28.7 64 64 64l391.4 0L295 328.4c-16.8 14.7-38.9 23.6-63 23.6c-53 0-96-43-96-96c0-16 3.9-31.1 10.8-44.3L32 121.2zM76.8 34.9L236.6 160.1c26.6 1.2 50.4 13.3 67 31.9c6.1 6.8 7.6 16.2 4.7 24.3c7.5 5.8 14.9 11.7 22.4 17.5c10-42.3 48-73.8 93.4-73.8c28.4 0 54 12.4 71.5 32c8.8 9.9 8 25-1.9 33.9s-25 8-33.9-1.9c-8.8-9.9-21.6-16-35.8-16c-26.5 0-48 21.5-48 48c0 5.4 .9 10.5 2.5 15.4l41.4 32.5c1.3 .1 2.7 .2 4.1 .2c14.2 0 27-6.1 35.8-16c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-7.8 8.7-17.2 16-27.7 21.4L600.8 445.6c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9zM184 256c0 26.5 21.5 48 48 48c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faCalculatorSimple = {
  prefix: 'fad',
  iconName: 'calculator-simple',
  icon: [
    512,
    512,
    ['calculator-alt'],
    'f64c',
    [
      'M0 48L0 176c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48zM0 336L0 464c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L48 288c-26.5 0-48 21.5-48 48zM48 112c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM60.7 348.7c6.2-6.2 16.4-6.2 22.6 0L112 377.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 83.3 451.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 60.7 371.3c-6.2-6.2-6.2-16.4 0-22.6zM288 48l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48zm48 64c0-8.8 7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16z',
      'M416 64l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 96l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM83.3 348.7L112 377.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 83.3 451.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 60.7 371.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 336c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128zm48 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faCalculatorAlt = faCalculatorSimple;
const faBridgeCircleCheck = {
  prefix: 'fad',
  iconName: 'bridge-circle-check',
  icon: [
    640,
    512,
    [],
    'e4c9',
    [
      'M32 64c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-40 0 0 64 72 0 0 72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-53-43-96-96-96l0-128 72 0 0-64L64 96C46.3 96 32 81.7 32 64zM152 96l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faSlidersUp = {
  prefix: 'fad',
  iconName: 'sliders-up',
  icon: [
    512,
    512,
    ['sliders-v'],
    'f3f1',
    [
      'M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 54.7c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3S97.4 80 96 80c-11.4 0-22.2 2.4-32 6.7L64 32zm0 201.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3s2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7L128 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-246.7zM224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 246.7c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7L224 32zm0 393.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3s2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7l0 54.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-54.7zM384 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 86.7c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7L384 32zm0 233.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3s2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7L448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-214.7z',
      'M96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112A80 80 0 1 0 96 80a80 80 0 1 0 0 160zm160 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM384 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faSlidersV = faSlidersUp;
const faLocationMinus = {
  prefix: 'fad',
  iconName: 'location-minus',
  icon: [
    384,
    512,
    ['map-marker-minus'],
    'f609',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm96 0c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M96 192c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faMapMarkerMinus = faLocationMinus;
const faPumpMedical = {
  prefix: 'fad',
  iconName: 'pump-medical',
  icon: [
    448,
    512,
    [],
    'e06a',
    [
      'M35 442.7C31.9 480 61.3 512 98.8 512l186.4 0c35.6 0 64-29 64-63.9c0-1.8-.1-3.6-.2-5.4l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7L256 160l-128 0-10.6 0c-33.3 0-61 25.5-63.8 58.7L35 442.7zM112 336c0-13.3 10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24z',
      'M128 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l60.1 0c21.2 0 41.6 8.4 56.6 23.4l33.9 33.9c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-33.9-33.9c-3-3-7.1-4.7-11.3-4.7L256 96l0 64-128 0 0-128zm64 224c13.3 0 24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faFingerprint = {
  prefix: 'fad',
  iconName: 'fingerprint',
  icon: [
    512,
    512,
    [],
    'f577',
    [
      'M71.6 358.5C71.6 372 82 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256l0 24.9c0 24.2-2.6 48.4-7.8 71.9c-.4 1.9-.6 3.8-.6 5.6zm121.6-234c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9zm.4 346.9c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3z',
      'M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM352 256c0-53-43-96-96-96s-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1l0-24.9z',
    ],
  ],
};
const faSkiBoot = {
  prefix: 'fad',
  iconName: 'ski-boot',
  icon: [
    512,
    512,
    [],
    'e3cc',
    [
      'M0 480c0-2 .2-4 .6-6c1.7-8.7 3.3-17.3 5-26L480 448c17.7 0 32 14.3 32 32c0 17.7-14.3 32-31.9 32L31.9 512c-9.5 0-18.5-4.3-24.6-11.6C2.6 494.6 0 487.4 0 480zM35.4 292.8C50.5 214.5 65.5 136.3 80.6 58C83.5 42.9 96.7 32 112 32l117.4 0C194.3 234.8 81.1 282 35.4 292.8z',
      'M358 .6c17.4 3.3 28.7 20.1 25.4 37.5l-6.2 32L360 160l-72 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l65.8 0-12.3 64L272 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l68 0 122 59.2c11 5.4 18 16.5 18 28.8l0 72L5.6 448 35.4 292.8c45.7-10.8 158.9-58 194-260.8l90 0 1.2-6C323.9 8.6 340.7-2.8 358 .6z',
    ],
  ],
};
const faStandardDefinition = {
  prefix: 'fad',
  iconName: 'standard-definition',
  icon: [
    576,
    512,
    ['rectangle-sd'],
    'e28a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm304 88c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-13.3 0-24-10.7-24-24c0-48 0-96 0-144zm48 24l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z',
      'M328 160c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0zm24 144l0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0zM167.1 208.1c7.4-2.4 19.5-2.9 36.2-.7c5.1 .7 21.1 3.4 25.7 4.4c12.1 2.8 24.1-4.8 26.8-16.9s-4.8-24.1-16.9-26.8c-6.5-1.5-23.9-4.4-29.7-5.1c-18.9-2.5-38.9-3.1-56 2.5c-18.8 6.1-33.9 19.7-38.5 42.3c-.1 .4-.1 .8-.2 1.2c-1.7 11.4-.2 22.4 5 32.3c5.1 9.6 12.9 16.1 20.5 20.7c13.7 8.2 31.5 12.3 45.1 15.5l1.7 .4c16 3.7 27.1 6.5 34.1 10.7c3 1.8 3.8 3 3.9 3.3c0 0 0 0 0 0c.1 .1 .7 1.2 .2 4.7c-.4 2.7-1.2 3.8-1.7 4.3c-.7 .7-2.3 2-5.8 3.1c-7.7 2.4-20.1 2.9-36.9 .6c-7.4-1-20.3-4.8-31.4-8c-2.5-.7-5-1.4-7.2-2.1c-11.9-3.4-24.3 3.5-27.7 15.4s3.5 24.3 15.4 27.7c1.5 .4 3.3 1 5.3 1.6c0 0 0 0 0 0s0 0 0 0c10.8 3.2 28.4 8.3 39.4 9.9c0 0 0 0 0 0l.1 0c18.9 2.5 39.2 3.1 56.4-2.3c8.9-2.8 17.8-7.5 24.9-15.2c7.3-7.8 11.8-17.6 13.4-28.5c1.7-11.4 .2-22.4-5-32.3c-5.1-9.6-12.9-16.1-20.5-20.7c-13.7-8.2-31.5-12.3-45.1-15.5c0 0 0 0 0 0l-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7c-3-1.8-3.8-3-3.9-3.3c0 0 0 0 0 0c-.1-.1-.6-1.1-.3-4.1c.9-4 2.8-6.2 8.3-8z',
    ],
  ],
};
const faRectangleSd = faStandardDefinition;
const faH1 = {
  prefix: 'fad',
  iconName: 'h1',
  icon: [
    576,
    512,
    [],
    'f313',
    [
      'M0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M496.8 68.8C506.3 74.6 512 84.9 512 96l0 288 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-236.2-17.7 8.8c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l64-32c9.9-5 21.7-4.4 31.1 1.4z',
    ],
  ],
};
const faHandPointRight = {
  prefix: 'fad',
  iconName: 'hand-point-right',
  icon: [
    512,
    512,
    [],
    'f0a4',
    [
      'M0 226.3L0 288c0 88.4 71.6 160 160 160l8.6 0c-5.4-9.4-8.6-20.3-8.6-32c0-27.9 17.9-51.7 42.8-60.4C196 345.4 192 333.2 192 320c0-11.7 3.1-22.6 8.6-32l-.6 0c-39.8 0-72-32.2-72-72l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 22.1 17.9 40 40 40s40-17.9 40-40l0-88c0-35.3-28.7-64-64-64l-27 0c-33.9 0-66.5 13.5-90.5 37.5L46.9 113.1C16.9 143.1 0 183.8 0 226.3zM272 96l0 64 208 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L272 96z',
      'M352 192c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0zm-32 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c17.7 0 32 14.3 32 32z',
    ],
  ],
};
const faMagnifyingGlassLocation = {
  prefix: 'fad',
  iconName: 'magnifying-glass-location',
  icon: [
    512,
    512,
    ['search-location'],
    'f689',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm128-32c0-44.2 35.8-80 80-80s80 35.8 80 80c0 48.8-46.5 111.6-68.6 138.6c-6 7.3-16.8 7.3-22.7 0C174.5 287.6 128 224.8 128 176z',
      'M288 176c0 48.8-46.5 111.6-68.6 138.6c-6 7.3-16.8 7.3-22.7 0C174.5 287.6 128 224.8 128 176c0-44.2 35.8-80 80-80s80 35.8 80 80zm-48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm90.7 200C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376z',
    ],
  ],
};
const faSearchLocation = faMagnifyingGlassLocation;
const faMessageBot = {
  prefix: 'fad',
  iconName: 'message-bot',
  icon: [
    640,
    512,
    [],
    'e3b8',
    [
      'M96 64c0-35.3 28.7-64 64-64L480 0c35.3 0 64 28.7 64 64l0 112 0 32 0 144c0 35.3-28.7 64-64 64l-106.7 0L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-64 0c-35.3 0-64-28.7-64-64l0-144 0-32L96 64zm64 64l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L192 96c-17.7 0-32 14.3-32 32z',
      'M59.7 208c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16L96 176l0 32-36.3 0zM192 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 32c0 17.7-14.3 32-32 32c-11.8 0-22.2-6.4-27.7-16L544 208l0-32 36.3 0c5.5-9.6 15.9-16 27.7-16c17.7 0 32 14.3 32 32z',
    ],
  ],
};
const faForwardStep = {
  prefix: 'fad',
  iconName: 'forward-step',
  icon: [
    320,
    512,
    ['step-forward'],
    'f051',
    [
      'M256 96l0 145 0 30 0 145c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4l192-160L256 271l0-30-11.5-9.6-192-160c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96L0 416c0 12.4 7.2 23.7 18.4 29z',
    ],
  ],
};
const faStepForward = faForwardStep;
const faFaceSmileBeam = {
  prefix: 'fad',
  iconName: 'face-smile-beam',
  icon: [
    512,
    512,
    [128522, 'smile-beam'],
    'f5b8',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm120-32c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6zm19.9 122.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5zM280 224c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
    ],
  ],
};
const faSmileBeam = faFaceSmileBeam;
const faLightCeiling = {
  prefix: 'fad',
  iconName: 'light-ceiling',
  icon: [
    512,
    512,
    [],
    'e016',
    [
      'M192 448c0 35.3 28.7 64 64 64s64-28.7 64-64l-128 0zM224 32l0 160 32 0 32 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M256 192C125.4 192 17.7 289.8 2 416.1C-.2 433.6 14.3 448 32 448H480c17.7 0 32.2-14.4 30-31.9C494.3 289.8 386.6 192 256 192z',
    ],
  ],
};
const faMessageExclamation = {
  prefix: 'fad',
  iconName: 'message-exclamation',
  icon: [
    512,
    512,
    ['comment-alt-exclamation'],
    'f4a5',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM224 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm8-200l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M280 104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faCommentAltExclamation = faMessageExclamation;
const faBowlScoop = {
  prefix: 'fad',
  iconName: 'bowl-scoop',
  icon: [
    448,
    512,
    [127847, 'bowl-shaved-ice'],
    'e3de',
    [
      'M32 224c0 10.9 .9 21.6 2.7 32l378.7 0c1.7-10.4 2.7-21.1 2.7-32c0-106-86-192-192-192S32 118 32 224z',
      'M4 261.4c3-3.4 7.4-5.4 12-5.4l416 0c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9C436.9 361.9 375.6 416 303 416l-40.4 0 68.7 68.7c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L185.4 416 145 416C72.4 416 11.1 361.9 2.1 289.9L.1 274c-.6-4.6 .8-9.1 3.9-12.6z',
    ],
  ],
};
const faBowlShavedIce = faBowlScoop;
const faSquareX = {
  prefix: 'fad',
  iconName: 'square-x',
  icon: [
    448,
    512,
    [],
    'e286',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 360c0-5.5 1.9-11 5.7-15.5c25-29.5 49.9-59 74.9-88.5l-74.9-88.5c-8.6-10.2-7.3-25.3 2.8-33.8c4.5-3.8 10-5.7 15.5-5.7c6.8 0 13.6 2.9 18.3 8.5c23.2 27.5 46.5 54.9 69.7 82.3c23.2-27.5 46.5-54.9 69.7-82.3c4.7-5.6 11.5-8.5 18.3-8.5c5.5 0 11 1.9 15.5 5.7c5.6 4.7 8.5 11.5 8.5 18.3c0 5.5-1.9 11-5.7 15.5c-25 29.5-49.9 59-74.9 88.5c25 29.5 49.9 59 74.9 88.5c3.8 4.5 5.7 10 5.7 15.5c0 6.8-2.9 13.6-8.5 18.3c-10.1 8.6-25.3 7.3-33.8-2.8c-23.2-27.5-46.5-54.9-69.7-82.3c-23.2 27.5-46.5 54.9-69.7 82.3c-4.7 5.6-11.5 8.5-18.3 8.5c-5.5 0-11-1.9-15.5-5.7c-5.6-4.7-8.5-11.5-8.5-18.3z',
      'M120.5 133.7c10.1-8.6 25.3-7.3 33.8 2.8L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8z',
    ],
  ],
};
const faBuildingMemo = {
  prefix: 'fad',
  iconName: 'building-memo',
  icon: [
    640,
    512,
    [],
    'e61e',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 16-8 0c-27.5 0-52.1 12.6-68.2 32.4c-1.2-.3-2.5-.4-3.8-.4l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l16 0 0 64-16 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l16 0 0 168c0 21.3 7.5 40.8 20.1 56L240 512l0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M320 160c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-288zm104 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-208c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM464 304c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z',
    ],
  ],
};
const faUtilityPoleDouble = {
  prefix: 'fad',
  iconName: 'utility-pole-double',
  icon: [
    512,
    512,
    [],
    'e2c4',
    [
      'M0 56C0 42.7 10.7 32 24 32s24 10.7 24 24l0 8L0 64l0-8zM0 248c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8L0 256l0-8zM80 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8L80 64l0-8zm0 192c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8zm3.2-120l57.7 0L224 183.4l0 38.5L83.2 128zm0 192l57.7 0L224 375.4l0 38.5L83.2 320zM288 183.4L371.2 128l57.7 0L288 221.9l0-38.5zm0 192L371.2 320l57.7 0L288 413.9l0-38.5zM384 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8zm0 192c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8zM464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8zm0 192c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8z',
      'M256 0c17.7 0 32 14.3 32 32l0 32 224 0 0 32c0 17.7-14.3 32-32 32l-192 0 0 128 224 0 0 32c0 17.7-14.3 32-32 32l-192 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160L32 320c-17.7 0-32-14.3-32-32l0-32 224 0 0-128L32 128C14.3 128 0 113.7 0 96L0 64l224 0 0-32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faFlagCheckered = {
  prefix: 'fad',
  iconName: 'flag-checkered',
  icon: [
    448,
    512,
    [127937],
    'f11e',
    [
      'M64 150.2l69-17.2c19.4-4.9 39.4-6.1 59-3.8l0 96c-19.6-2.3-39.6-1.1-59 3.8L64 246.2l0-96zM192 27c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 102.2c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3L192 27zm0 198.2c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 109.1c-23.9-1.4-47.4-7.5-69.3-18.5c-18.6-9.3-38.5-15.2-58.7-17.5l0-106.7zm128-62.4c25.2 0 50.4-5.8 73.6-17.4c18.1-9.1 36.3-18.1 54.4-27.2l0 96c-18.1 9.1-36.3 18.1-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4l0-96z',
      'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c21-5.2 42.6-6.6 63.7-4.1l0-106.7c-19.6-2.3-39.6-1.1-59 3.8L64 246.2l0-96 69-17.2c19.4-4.9 39.4-6.1 59-3.8l0 96c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 109.1c24.4 1.4 49.1-2.2 72.5-11l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-99.7-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4l0-96c25.2 0 50.4-5.8 73.6-17.4L448 118.2l0-52c0-23-24.2-38-44.8-27.7l-9.6 4.8C370.4 54.8 345.2 60.6 320 60.6l0 102.2c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3L192 27c-19.6-2.3-39.6-1.1-59 3.8L64 48l0-16z',
    ],
  ],
};
const faChevronsUp = {
  prefix: 'fad',
  iconName: 'chevrons-up',
  icon: [
    512,
    512,
    ['chevron-double-up'],
    'f325',
    [
      'M32 448c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0L256 301.3 425.4 470.6c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-192-192c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4l-192 192C35.1 431.6 32 439.8 32 448z',
      'M233.4 41.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 109.3 86.6 278.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z',
    ],
  ],
};
const faChevronDoubleUp = faChevronsUp;
const faFootball = {
  prefix: 'fad',
  iconName: 'football',
  icon: [
    512,
    512,
    [127944, 'football-ball'],
    'f44e',
    [
      'M16.8 306.7c2.1-19.2 5.4-38.6 10.1-57.8L264.5 486.6c-18.3 4.4-37.7 7.6-58.4 9.5L16.8 306.7zM247.5 25.4c18.3-4.4 37.7-7.6 58.4-9.5C369 79.1 432.1 142.2 495.2 205.3c-2.1 19.2-5.4 38.6-10.1 57.8C405.9 183.8 326.7 104.6 247.5 25.4z',
      'M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6C47.8 183.4 35.1 215.9 26.9 249L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z',
    ],
  ],
};
const faFootballBall = faFootball;
const faUserVneck = {
  prefix: 'fad',
  iconName: 'user-vneck',
  icon: [
    448,
    512,
    [],
    'e461',
    [
      'M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M130 308.3c6.1-1.4 12.4 1.4 15.9 6.6L210.7 412c6.3 9.5 20.3 9.5 26.6 0l64.8-97.1c3.5-5.2 9.8-8 15.9-6.6c74.5 17.2 130 84 130 163.7l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-79.7 55.5-146.5 130-163.7z',
    ],
  ],
};
const faSchoolCircleExclamation = {
  prefix: 'fad',
  iconName: 'school-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e56c',
    [
      'M0 144L0 464c0 26.5 21.5 48 48 48l272 0-64 0 0-96c0-35.3 28.7-64 64-64l.7 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4C332.4 1.8 326.2 0 320 0s-12.4 1.8-17.8 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144zm80 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM304 144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faCrop = {
  prefix: 'fad',
  iconName: 'crop',
  icon: [
    512,
    512,
    [],
    'f125',
    [
      'M64 32l0 32 0 64 0 256c0 35.3 28.7 64 64 64l256 0 0-64-210.7 0L384 173.3l0-45.3-45.3 0L128 338.7 128 128l0-64 0-32c0-17.7-14.3-32-32-32S64 14.3 64 32zM400.6 66.2c22 5.9 39.4 23.2 45.3 45.3l56.8-56.8c12.5-12.5 12.5-32.8 0-45.3C496.4 3.1 488.2 0 480 0s-16.4 3.1-22.6 9.4L400.6 66.2zM448 384l0 64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
      'M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0-64L32 64zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-35.3-28.7-64-64-64L128 64l0 64 256 0 0 352z',
    ],
  ],
};
const faAnglesDown = {
  prefix: 'fad',
  iconName: 'angles-down',
  icon: [
    448,
    512,
    ['angle-double-down'],
    'f103',
    [
      'M32 96c0 8.2 3.1 16.4 9.4 22.6l160 160c12.5 12.5 32.8 12.5 45.3 0l160-160c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6S392.2 64 384 64s-16.4 3.1-22.6 9.4L224 210.7 86.6 73.4C80.4 67.1 72.2 64 64 64s-16.4 3.1-22.6 9.4S32 87.8 32 96z',
      'M201.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 86.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z',
    ],
  ],
};
const faAngleDoubleDown = faAnglesDown;
const faUsersRectangle = {
  prefix: 'fad',
  iconName: 'users-rectangle',
  icon: [
    640,
    512,
    [],
    'e594',
    [
      'M96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0C119.9 256 96 279.9 96 309.3zM127.8 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 360c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24zm48-168a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm140 70.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4zM416 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M0 96C0 43 43 0 96 0L544 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 96zM96 64C78.3 64 64 78.3 64 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L96 64z',
    ],
  ],
};
const faPeopleRoof = {
  prefix: 'fad',
  iconName: 'people-roof',
  icon: [
    640,
    512,
    [],
    'e537',
    [
      'M18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5 88 480c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5l0 54.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-54.5 26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5l0 38.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8c8.1-4.3 12.6-12.6 12.6-21.2c0-3.8-.9-7.7-2.9-11.4l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6zM104 296a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176-96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176 96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M304.5 4c9.7-5.4 21.4-5.4 31.1 0l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4z',
    ],
  ],
};
const faSquareArrowRight = {
  prefix: 'fad',
  iconName: 'square-arrow-right',
  icon: [
    448,
    512,
    ['arrow-square-right'],
    'f33b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM80 256c0-13.3 10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7L361 239c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17L249 385c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24z',
      'M361 239c9.4 9.4 9.4 24.6 0 33.9L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239z',
    ],
  ],
};
const faArrowSquareRight = faSquareArrowRight;
const faLocationPlus = {
  prefix: 'fad',
  iconName: 'location-plus',
  icon: [
    384,
    512,
    ['map-marker-plus'],
    'f60a',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm80 0c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M168 216l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faMapMarkerPlus = faLocationPlus;
const faLightbulbExclamationOn = {
  prefix: 'fad',
  iconName: 'lightbulb-exclamation-on',
  icon: [
    640,
    512,
    [],
    'e1ca',
    [
      'M144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176zM352 288a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM296 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48 160 0 0 48z',
    ],
  ],
};
const faPeopleLine = {
  prefix: 'fad',
  iconName: 'people-line',
  icon: [
    640,
    512,
    [],
    'e534',
    [
      'M18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5 88 352c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5l0 54.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-54.5 26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5l0 38.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8c8.1-4.3 12.6-12.6 12.6-21.2c0-3.8-.9-7.7-2.9-11.4l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6zM104 168a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM280 72a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176 96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M0 448c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faBeerMugEmpty = {
  prefix: 'fad',
  iconName: 'beer-mug-empty',
  icon: [
    512,
    512,
    ['beer'],
    'f0fc',
    [
      'M32 64c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32 51.2 0c42.4 0 76.8 34.4 76.8 76.8l0 102.1c0 30.4-17.9 57.9-45.6 70.2L384 381.7l0 34.3c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64L32 64zm96 80l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 0l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 0l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zm128 16l0 151.6 56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7l0-102.1c0-7.1-5.7-12.8-12.8-12.8L384 160z',
      'M144 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faBeer = faBeerMugEmpty;
const faCarpool = {
  prefix: 'fad',
  iconName: 'carpool',
  icon: [
    512,
    512,
    ['car-people'],
    'e69c',
    [
      'M0 416l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32L0 416zM116.8 224l118.4 0c-7.3-14.2-22.1-24-39.2-24l-40 0c-17.1 0-31.9 9.8-39.2 24zM136 144a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm140.8 80l118.4 0c-7.3-14.2-22.1-24-39.2-24l-40 0c-17.1 0-31.9 9.8-39.2 24zM296 144a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM416 416l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0z',
      'M104.6 122.9L80.4 224l351.3 0L407.4 122.9c-6-25.2-28.6-42.9-54.5-42.9L159.1 80c-25.9 0-48.4 17.8-54.5 42.9zM28.4 234.8L57.9 111.7C69.2 65 111 32 159.1 32l193.9 0c48.1 0 89.9 33 101.1 79.7l29.5 123.1c17.1 11.5 28.4 31 28.4 53.2l0 128L0 416 0 288c0-22.2 11.3-41.7 28.4-53.2zM96 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faCarPeople = faCarpool;
const faCrateEmpty = {
  prefix: 'fad',
  iconName: 'crate-empty',
  icon: [
    512,
    512,
    [],
    'e151',
    [
      'M0 272l0 80 512 0 0-80c0-26.5-21.5-48-48-48L48 224c-26.5 0-48 21.5-48 48zM0 384l0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-80L0 384zm80-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM464 288a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M64 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faDiagramPredecessor = {
  prefix: 'fad',
  iconName: 'diagram-predecessor',
  icon: [
    512,
    512,
    [],
    'e477',
    [
      'M0 352l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64z',
      'M224 224c35.3 0 64-28.7 64-64l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0z',
    ],
  ],
};
const faTransporter = {
  prefix: 'fad',
  iconName: 'transporter',
  icon: [
    512,
    512,
    [],
    'e042',
    [
      'M0 112c0 4.1 2.7 7.6 6.6 8.7L32 128l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 128l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 96 56.7 70.6C55.6 66.7 52.1 64 48 64s-7.6 2.7-8.7 6.6L32 96 6.6 103.3C2.7 104.4 0 107.9 0 112zM416 48c0 4.1 2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32 472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 272l0 96-64 0 0-178.7L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36l40.7 0c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7L328 416l-64 0 0-96-16 0zM216 512l-88 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-88 0-80 0z',
    ],
  ],
};
const faCalendarCircleUser = {
  prefix: 'fad',
  iconName: 'calendar-circle-user',
  icon: [
    576,
    512,
    [],
    'e471',
    [
      'M0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112zm0 80L0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7C489.5 468.1 462.2 480 432 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faArrowUpLong = {
  prefix: 'fad',
  iconName: 'arrow-up-long',
  icon: [
    384,
    512,
    ['long-arrow-up'],
    'f176',
    [
      'M160 109.3c10.7-10.7 21.3-21.3 32-32c10.7 10.7 21.3 21.3 32 32L224 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-370.7z',
      'M169.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 77.3 86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z',
    ],
  ],
};
const faLongArrowUp = faArrowUpLong;
const faPersonCarryBox = {
  prefix: 'fad',
  iconName: 'person-carry-box',
  icon: [
    384,
    512,
    ['person-carry'],
    'f4cf',
    [
      'M192 128l0 96 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L224 96c-17.7 0-32 14.3-32 32z',
      'M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7l0 65.1 51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3L98.1 399.4 18.7 320C6.7 308 0 291.7 0 274.7l0-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64 62.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-71.4 0c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64L64 480s0 0 0 0c0 17.7-14.3 32-32 32s-32-14.3-32-32z',
    ],
  ],
};
const faPersonCarry = faPersonCarryBox;
const faFireFlameSimple = {
  prefix: 'fad',
  iconName: 'fire-flame-simple',
  icon: [
    384,
    512,
    ['burn'],
    'f46a',
    [
      'M0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6zm96 13.9c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5z',
      'M279.8 301.6l1.9 4.3c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1z',
    ],
  ],
};
const faBurn = faFireFlameSimple;
const faPerson = {
  prefix: 'fad',
  iconName: 'person',
  icon: [
    320,
    512,
    [129485, 'male'],
    'f183',
    [
      'M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M88 256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1z',
    ],
  ],
};
const faMale = faPerson;
const faLaptop = {
  prefix: 'fad',
  iconName: 'laptop',
  icon: [
    640,
    512,
    [128187],
    'f109',
    [
      'M0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384C8.6 384 0 392.6 0 403.2zM64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96z',
      'M128 96H512V352H128V96z',
    ],
  ],
};
const faFileCsv = {
  prefix: 'fad',
  iconName: 'file-csv',
  icon: [
    512,
    512,
    [],
    'f6dd',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM200 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1-17.9-40-40-40l-16 0zm133.1 0c-24.9 0-45.1 20.2-45.1 45.1c0 17.8 10.5 34 26.8 41.2l37.4 16.6c4.7 2.1 7.8 6.8 7.8 12c0 7.2-5.9 13.1-13.1 13.1L304 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l42.9 0c24.9 0 45.1-20.2 45.1-45.1c0-17.8-10.5-34-26.8-41.2l-37.4-16.6c-4.7-2.1-7.8-6.8-7.8-12c0-7.2 5.9-13.1 13.1-13.1l34.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-34.9 0zm98.9 0c-8.8 0-16 7.2-16 16l0 31.6c0 34.7 10.3 68.7 29.6 97.6l5.1 7.7c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l5.1-7.7c19.3-28.9 29.6-62.9 29.6-97.6l0-31.6c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 31.6c0 23-5.5 45.6-16 66c-10.5-20.3-16-42.9-16-66l0-31.6c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faMenorah = {
  prefix: 'fad',
  iconName: 'menorah',
  icon: [
    640,
    512,
    [],
    'f676',
    [
      'M0 62.8L0 64C0 81.7 14.3 96 32 96s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L43.2 7.4C41.2 2.9 36.9 0 32 0s-9.2 2.9-11.2 7.4L2.7 49.7C.9 53.9 0 58.3 0 62.8zm96 0L96 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L139.2 7.4C137.2 2.9 132.9 0 128 0s-9.2 2.9-11.2 7.4L98.7 49.7C96.9 53.9 96 58.3 96 62.8zm96 0l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L235.2 7.4C233.2 2.9 228.9 0 224 0s-9.2 2.9-11.2 7.4L194.7 49.7c-1.8 4.1-2.7 8.6-2.7 13.1zm96 0l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L331.2 7.4C329.2 2.9 324.9 0 320 0s-9.2 2.9-11.2 7.4L290.7 49.7c-1.8 4.1-2.7 8.6-2.7 13.1zm96 0l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L427.2 7.4C425.2 2.9 420.9 0 416 0s-9.2 2.9-11.2 7.4L386.7 49.7c-1.8 4.1-2.7 8.6-2.7 13.1zm96 0l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L523.2 7.4C521.2 2.9 516.9 0 512 0s-9.2 2.9-11.2 7.4L482.7 49.7c-1.8 4.1-2.7 8.6-2.7 13.1zm96 0l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L619.2 7.4C617.2 2.9 612.9 0 608 0s-9.2 2.9-11.2 7.4L578.7 49.7c-1.8 4.1-2.7 8.6-2.7 13.1z',
      'M64 160c0-17.7-14.3-32-32-32s-32 14.3-32 32L0 288c0 53 43 96 96 96l192 0 0 64-128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-64 192 0c53 0 96-43 96-96l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128c0 17.7-14.3 32-32 32l-192 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160L96 320c-17.7 0-32-14.3-32-32l0-128zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 0 32 64 0 0-32 0-96zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 0 32 64 0 0-32 0-96zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 0 32 64 0 0-32 0-96zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 0 32 64 0 0-32 0-96z',
    ],
  ],
};
const faUnion = {
  prefix: 'fad',
  iconName: 'union',
  icon: [
    384,
    512,
    [8899],
    'f6a2',
    [
      'M32 32c17.7 0 32 14.3 32 32l0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 106-86 192-192 192S0 394 0 288L0 64C0 46.3 14.3 32 32 32z',
      '',
    ],
  ],
};
const faChevronsLeft = {
  prefix: 'fad',
  iconName: 'chevrons-left',
  icon: [
    512,
    512,
    ['chevron-double-left'],
    'f323',
    [
      'M224 256c0 8.2 3.1 16.4 9.4 22.6l192 192c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c12.5-12.5 12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3C464.4 35.1 456.2 32 448 32s-16.4 3.1-22.6 9.4l-192 192c-6.2 6.2-9.4 14.4-9.4 22.6z',
      'M41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l192-192c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 278.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-192-192z',
    ],
  ],
};
const faChevronDoubleLeft = faChevronsLeft;
const faCircleHeart = {
  prefix: 'fad',
  iconName: 'circle-heart',
  icon: [
    512,
    512,
    ['heart-circle'],
    'f4c7',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm109.8-29.1c0-19.5 7.3-39.1 22-54s33.9-22.4 53.2-22.4s38.5 7.5 53.2 22.4c5.9 6 11.8 12 17.7 18c5.9-6 11.8-12 17.7-18c14.7-14.9 33.9-22.4 53.2-22.4s38.5 7.5 53.2 22.4s22 34.5 22 54s-7.3 39.1-22 54L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L131.9 280.9c-14.7-14.9-22-34.5-22-54z',
      'M131.9 172.9c-29.4 29.8-29.4 78.2 0 108L233.5 384.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 280.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0z',
    ],
  ],
};
const faHeartCircle = faCircleHeart;
const faTruckPlane = {
  prefix: 'fad',
  iconName: 'truck-plane',
  icon: [
    640,
    512,
    [],
    'e58f',
    [
      'M0 288l0 64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37 0 81.2-50 40c-3.8 3-6 7.6-6 12.5l0 32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15l0-32.6c-18.2-10.5-30.7-29.7-31.9-51.8c-.1-1.3-.1-2.4-.1-3.6l0-82.5L256 184c0-.4 0-.7 0-1.1c0-32.3 0-64.6 0-96.9C256 54.7 231.5 0 200 0c-30.6 0-56 54.7-56 86.1l0 106.5L7.8 274.3C2.9 277.2 0 282.4 0 288z',
      'M336 128c-26.5 0-48 21.5-48 48l0 224c0 20.9 13.4 38.7 32 45.3l0 42.7c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-40 160 0 0 40c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-42.7c18.6-6.6 32-24.4 32-45.3l0-224c0-26.5-21.5-48-48-48l-256 0zm16 176l15.8-49.3c3.3-8.7 11.2-14.7 20.5-14.7l151.4 0c9.2 0 17.2 6 20.5 14.7L576 304l-224 0zm192 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM360 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faRecordVinyl = {
  prefix: 'fad',
  iconName: 'record-vinyl',
  icon: [
    512,
    512,
    [],
    'f8d9',
    [
      'M128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256z',
    ],
  ],
};
const faBringForward = {
  prefix: 'fad',
  iconName: 'bring-forward',
  icon: [
    512,
    512,
    [],
    'f856',
    [
      'M160 352l0 96c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0 64 96 0 0 224-224 0 0-96-64 0z',
      'M0 288c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288z',
    ],
  ],
};
const faSquareP = {
  prefix: 'fad',
  iconName: 'square-p',
  icon: [
    448,
    512,
    [],
    'e279',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136zm48 24l0 88 68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0z',
      'M128 152c0-13.3 10.7-24 24-24l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136zm48 112l68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88z',
    ],
  ],
};
const faFaceGrinStars = {
  prefix: 'fad',
  iconName: 'face-grin-stars',
  icon: [
    512,
    512,
    [129321, 'grin-stars'],
    'f587',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm91.5-86.2c1-2.9 3.5-5.1 6.6-5.5l38.1-5 16.6-34.7c1.3-2.8 4.1-4.6 7.2-4.6s5.9 1.8 7.2 4.6l16.6 34.7 38.1 5c3.1 .4 5.6 2.5 6.6 5.5s.1 6.2-2.1 8.3l-27.9 26.5 7 37.8c.6 3-.7 6.1-3.2 7.9s-5.8 2-8.5 .6L160 232.5l-33.8 18.3c-2.7 1.5-6 1.3-8.5-.6s-3.7-4.9-3.2-7.9l7-37.8L93.6 178c-2.2-2.1-3.1-5.3-2.1-8.3zm13.6 161.7c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM283.5 169.8c1-2.9 3.5-5.1 6.6-5.5l38.1-5 16.6-34.7c1.3-2.8 4.1-4.6 7.2-4.6s5.9 1.8 7.2 4.6l16.6 34.7 38.1 5c3.1 .4 5.6 2.5 6.6 5.5c.3 .8 .4 1.6 .4 2.5c0 2.2-.9 4.3-2.5 5.8l-27.9 26.5 7 37.8c.6 3-.7 6.1-3.2 7.9s-5.8 2-8.5 .6L352 232.5l-33.8 18.3c-2.7 1.5-6 1.3-8.5-.6s-3.7-4.9-3.2-7.9l7-37.8L285.6 178c-2.2-2.1-3.1-5.3-2.1-8.3z',
      'M167.2 124.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm192 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7z',
    ],
  ],
};
const faGrinStars = faFaceGrinStars;
const faSigma = {
  prefix: 'fad',
  iconName: 'sigma',
  icon: [
    384,
    512,
    [8721],
    'f68b',
    [
      'M2.4 51.8C7.4 39.8 19.1 32 32 32l288 0c35.3 0 64 28.7 64 64l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L109.3 96 246.6 233.4c12.5 12.5 12.5 32.8 0 45.3L109.3 416 320 416l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 35.3-28.7 64-64 64L32 480c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L178.7 256 9.4 86.6C.2 77.5-2.5 63.7 2.4 51.8z',
      '',
    ],
  ],
};
const faCameraMovie = {
  prefix: 'fad',
  iconName: 'camera-movie',
  icon: [
    576,
    512,
    [127909, 127910],
    'f8a9',
    [
      'M0 288c0 17.7 14.3 32 32 32l32 0 0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-16 0-96 0-16c0-35.3-28.7-64-64-64l-32 0-224 0-64 0-32 0c-17.7 0-32 14.3-32 32z',
      'M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM352 256l-224 0C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66C261.8 26.6 303.8 0 352 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM558.3 259.4c10.8 5.4 17.7 16.5 17.7 28.6l0 192c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48L448 448l0-16 0-96 0-16 12.8-9.6 64-48c9.7-7.3 22.7-8.4 33.5-3z',
    ],
  ],
};
const faBong = {
  prefix: 'fad',
  iconName: 'bong',
  icon: [
    448,
    512,
    [],
    'f55c',
    [
      'M0 384c0 39.4 11.9 76.1 32.2 106.5C41.9 504.9 58.8 512 76.1 512l231.9 0c17.3 0 34.2-7.1 43.8-21.5C372.1 460.1 384 423.4 384 384c0-36.1-10-69.9-27.3-98.8L400 241.9l7 7c9.4 9.4 24.6 9.4 33.9 0c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17l-24-24-24-24c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7-39.3 39.3c-9.4-9.3-19.8-17.6-30.9-24.8c-4.8-3.1-7.9-8.3-7.9-14L288 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L272 0 112 0 96 0C78.3 0 64 14.3 64 32s14.3 32 32 32l0 144.5c0 5.7-3.1 10.9-7.9 14C35.1 256.7 0 316.2 0 384zm64 0c0-23.3 6.2-45.2 17.1-64c10.2-17.6 24.5-32.6 41.7-43.7c21.6-13.9 37.2-38.7 37.2-67.8L160 64l64 0 0 144.5c0 29.1 15.6 53.9 37.2 67.8c17.2 11.1 31.5 26.1 41.7 43.7c10.9 18.8 17.1 40.7 17.1 64c0 23.4-6.2 45.2-17.1 64L81.1 448C70.2 429.2 64 407.4 64 384z',
      'M302.9 320L81.1 320C70.2 338.8 64 360.7 64 384c0 23.4 6.2 45.2 17.1 64l221.8 0c10.9-18.8 17.1-40.6 17.1-64c0-23.3-6.2-45.2-17.1-64z',
    ],
  ],
};
const faClarinet = {
  prefix: 'fad',
  iconName: 'clarinet',
  icon: [
    640,
    512,
    [],
    'f8ad',
    [
      'M0 240l0 64c0 6.5 4 12.4 10.1 14.9l68.6 27.4c9.4 3.8 19.5 5.7 29.7 5.7l448.3 0c9.5 0 18.7 2.8 26.6 8.1l31.9 21.3c2.7 1.8 5.8 2.7 8.9 2.7c2.6 0 5.2-.6 7.5-1.9c5.2-2.8 8.5-8.2 8.5-14.1l0-192c0-5.9-3.2-11.3-8.5-14.1c-2.4-1.3-5-1.9-7.5-1.9c-3.1 0-6.2 .9-8.9 2.7l-31.9 21.3c-7.9 5.3-17.1 8.1-26.6 8.1L480 192l-32 0-64 0-32 0-64 0-32 0-147.7 0c-10.2 0-20.3 1.9-29.7 5.7L10.1 225.1C4 227.6 0 233.5 0 240zm296 32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M240 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0-96 0-96 0-32 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faTruckFlatbed = {
  prefix: 'fad',
  iconName: 'truck-flatbed',
  icon: [
    640,
    512,
    [],
    'e2b6',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M640 384c0 17.7-14.3 32-32 32l-33.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-1.1 0-65.1 0c-3.6-24.9-15.3-47.2-32.5-64l97.6 0 0-224c0-17.7 14.3-32 32-32l16 0 16 0 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32zM97.6 352c-17.1 16.8-28.9 39.1-32.5 64L32 416c-17.7 0-32-14.3-32-32s14.3-32 32-32l65.6 0zM544 256l0-18.7L466.7 160 416 160l0 96 128 0z',
    ],
  ],
};
const faSpaghettiMonsterFlying = {
  prefix: 'fad',
  iconName: 'spaghetti-monster-flying',
  icon: [
    640,
    512,
    ['pastafarianism'],
    'f67b',
    [
      'M0 224c0 13.3 10.7 24 24 24c2.5 0 4.3 .6 7.1 3.3c3.7 3.5 7.1 8.8 12.5 17.4l.6 .9c4.6 7.4 11 17.6 19.4 25.7C73.3 304.6 86.5 312 104 312c18.5 0 32.9-8.5 44.3-18.6c3.1 4 6.6 8.3 10.5 12.7c-1.4 4.3-2.8 8.5-4 12.5c-.9 3-1.8 5.8-2.6 8.6c-3 9.8-5.5 18.2-8.6 25.9c-3.9 9.8-7.4 15.4-10.8 18.5c-2.6 2.4-5.9 4.3-12.8 4.3c-8.7 0-16.9-4.2-33.7-13.2c-15-8-35.7-18.8-62.3-18.8c-13.3 0-24 10.7-24 24s10.7 24 24 24c13.4 0 24.7 5.2 39.7 13.2c1 .6 2.1 1.1 3.2 1.7C80.1 414 98.6 424 120 424c18.4 0 33.6-6.1 45.5-17.2c11.1-10.3 17.9-23.7 22.7-36c3.6-9 6.7-19.1 9.5-28.5c16.4 12.3 36.1 23.6 58.9 31.3c-3.6 10.8-8.4 23.5-14.4 36.2c-7.5 15.9-16.2 30.4-25.8 40.5C207 460.5 198.8 464 192 464c-13.3 0-24 10.7-24 24s10.7 24 24 24c25.2 0 45-13.5 59.5-28.8c14.5-15.4 25.7-34.9 34.2-53c8-17 14.1-33.8 18.3-46.9c5.2 .4 10.6 .6 16 .6s10.8-.2 16-.6c4.2 13 10.3 29.9 18.3 46.9c8.5 18.1 19.8 37.6 34.2 53C403 498.5 422.8 512 448 512c13.3 0 24-10.7 24-24s-10.7-24-24-24c-6.8 0-15-3.5-24.5-13.7c-9.5-10.1-18.3-24.6-25.8-40.5c-5.9-12.6-10.7-25.4-14.4-36.2c22.8-7.7 42.5-19 58.9-31.3c2.9 9.4 6 19.5 9.5 28.5c4.8 12.2 11.6 25.6 22.7 36C486.4 417.9 501.6 424 520 424c21.4 0 39.9-10 53.1-17.1c1.1-.6 2.2-1.2 3.2-1.7c15-8 26.3-13.2 39.7-13.2c13.3 0 24-10.7 24-24s-10.7-24-24-24c-26.6 0-47.3 10.8-62.3 18.8c-16.8 9-25 13.2-33.7 13.2c-6.8 0-10.2-1.9-12.8-4.3c-3.4-3.2-7-8.8-10.8-18.5c-3-7.7-5.6-16.1-8.6-25.9c-.8-2.7-1.7-5.6-2.6-8.6c-1.2-4-2.6-8.2-4-12.5c3.9-4.5 7.4-8.8 10.5-12.7C503.1 303.5 517.5 312 536 312c17.5 0 30.7-7.4 40.4-16.7c8.4-8.1 14.8-18.3 19.4-25.7l.6-.9c5.4-8.6 8.8-13.9 12.5-17.4c2.8-2.7 4.6-3.3 7.1-3.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-17.5 0-30.7 7.4-40.4 16.7c-8.4 8.1-14.8 18.3-19.4 25.7l-.6 .9c-5.4 8.6-8.8 13.9-12.5 17.4c-2.8 2.7-4.6 3.3-7.1 3.3c-3.3 0-8.7-1.7-19.4-13.4c-5.1-5.6-10.4-12.3-16.7-20.4l-1.4-1.8c-5.8-7.4-12.2-15.7-19.3-24c-13.8-16.2-30.4-32.8-51.4-46.4l15.1-30.2c-17.1-1.3-32.2-9.4-42.9-21.5l-15.6 31.2c-18.7-6-39.9-9.5-64.4-9.5s-45.8 3.5-64.4 9.5L240 106.3c-10.7 12.1-25.9 20.1-42.9 21.5L212.2 158c-21.1 13.6-37.7 30.2-51.4 46.4c-7.1 8.3-13.5 16.6-19.3 24l-1.4 1.8c-6.3 8.1-11.6 14.8-16.7 20.4C112.7 262.3 107.3 264 104 264c-2.5 0-4.3-.6-7.1-3.3c-3.7-3.5-7.1-8.8-12.5-17.4l-.6-.9c-4.6-7.4-11-17.6-19.4-25.7C54.7 207.4 41.5 200 24 200c-13.3 0-24 10.7-24 24z',
      'M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zm336 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 384 64z',
    ],
  ],
};
const faPastafarianism = faSpaghettiMonsterFlying;
const faArrowDownUpAcrossLine = {
  prefix: 'fad',
  iconName: 'arrow-down-up-across-line',
  icon: [
    576,
    512,
    [],
    'e4af',
    [
      'M0 256c0-17.7 14.3-32 32-32l96 0 64 0 192 0 64 0 96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0-64 0-192 0-64 0-96 0c-17.7 0-32-14.3-32-32z',
      'M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7 192 288l-64 0 0 114.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 224l64 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160zM393.4 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3 384 224l64 0 0-114.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zM448 448l0-160-64 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32z',
    ],
  ],
};
const faArrowsRotateReverse = {
  prefix: 'fad',
  iconName: 'arrows-rotate-reverse',
  icon: [
    512,
    512,
    [],
    'e630',
    [
      'M42.7 320c0 3.5 .6 7.1 1.8 10.6C55.3 361.3 73 390 97.4 414.4C141.1 458.1 198.4 480 255.8 480c57.3 0 114.6-21.9 158.4-65.6l17.6-17.5 0 35.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-111.6 0-.4c0-1.6-.1-3.2-.4-4.8c-.2-1.3-.5-2.6-.8-3.8c-1.4-5.1-4.1-9.9-8.1-14c-3.9-4-8.7-6.7-13.7-8.2c-1.5-.4-3-.8-4.6-1c-1.6-.2-3.2-.3-4.8-.3l-111.6 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l34.4 0L369 369.1c-62.6 62.6-163.9 62.6-226.3 .1c-17.5-17.5-30.1-38-37.8-59.8c-5.9-16.7-24.2-25.4-40.8-19.5c-13.1 4.6-21.4 17-21.4 30.2z',
      'M406.6 202.6c-7.7-21.8-20.2-42.3-37.8-59.8c-62.5-62.5-163.8-62.5-226.3 0L125.5 160l34.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48.3 224c0 0 0 0 0 0l-.4 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 35.2L97.4 97.6c87.5-87.5 229.3-87.5 316.8 0c24.4 24.4 42.1 53.1 52.9 83.7c5.9 16.7-2.9 34.9-19.5 40.8s-34.9-2.9-40.8-19.5z',
    ],
  ],
};
const faLeafHeart = {
  prefix: 'fad',
  iconName: 'leaf-heart',
  icon: [
    512,
    512,
    [],
    'f4cb',
    [
      'M0 440l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-48.6 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96c-34.7 0-69.3 0-104 0c-93.2 0-169.5 72.5-175.6 164.1C38.3 298.8 0 364.9 0 440zM190 237.3c.2-1.8 .5-3.6 .8-5.3c.7-3.5 1.8-6.8 3.1-10c2.7-6.4 6.6-12.2 11.5-17c9.7-9.7 23.1-15.7 37.8-15.7c.5 0 1 0 1.5 0c14.3 0 28.1 5.6 38.4 15.6c1.6 1.6 3.3 3.2 4.9 4.8c1.6-1.6 3.3-3.2 4.9-4.8c10.3-10 24-15.6 38.4-15.6c.5 0 1 0 1.5 0c29.5 0 53.5 23.9 53.5 53.5c0 14.4-5.8 28.3-16.2 38.4c-23.6 23-47.3 46-70.9 69c-3.1 3-7.1 4.5-11.2 4.5s-8-1.5-11.2-4.5c-23.6-23-47.3-46-70.9-69c-5.2-5-9.2-11-12-17.5c-1.4-3.3-2.4-6.7-3.1-10.1c-.4-1.7-.6-3.5-.8-5.3c-.1-.9-.2-1.8-.2-2.7s-.1-1.8-.1-2.7c0-1.9 0-2.3 .1-2.8c0-.9 .1-1.8 .2-2.7z',
      'M243.2 189.3c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0z',
    ],
  ],
};
const faHouseBuilding = {
  prefix: 'fad',
  iconName: 'house-building',
  icon: [
    640,
    512,
    [],
    'e1b1',
    [
      'M320 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-192 0c10-13.4 16-30 16-48l0-112 16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0 0-10.9c0-7.2-1-14.3-2.8-21.1l18.8 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 4.6-64-58.7L320 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M0 464L0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4L384 464c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48zM168 272c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z',
    ],
  ],
};
const faCheeseSwiss = {
  prefix: 'fad',
  iconName: 'cheese-swiss',
  icon: [
    512,
    512,
    [129472],
    'f7f0',
    [
      'M0 256l332.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32L512 256l0-15.8C512 125.2 418.8 32 303.8 32c-10.3 0-20.3 3-28.9 8.7l-47 31.3c-7.8 5.2-9.2 16.1-6.3 25.1c1.5 4.7 2.3 9.7 2.3 14.9c0 26.5-21.5 48-48 48c-12 0-22.9-4.4-31.3-11.6c-7.1-6.1-17.7-9.1-25.5-3.8L28.5 205C11.3 216.5 .8 235.5 0 256zM128 384a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M368 336c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32L512 256l0 160c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 256l332.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48zM224 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
    ],
  ],
};
const faSpoon = {
  prefix: 'fad',
  iconName: 'spoon',
  icon: [
    512,
    512,
    [129348, 61873, 'utensil-spoon'],
    'f2e5',
    [
      'M224 160.2C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8c-2.4-2-4.7-4.1-6.9-6.3l-32-32c-2.2-2.2-4.3-4.6-6.3-6.9c-14.5-17.6-21.8-39.2-21.8-60.8z',
      'M245.8 220.9c2 2.4 4.1 4.7 6.3 6.9l32 32c2.2 2.2 4.6 4.3 6.9 6.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z',
    ],
  ],
};
const faUtensilSpoon = faSpoon;
const faJarWheat = {
  prefix: 'fad',
  iconName: 'jar-wheat',
  icon: [
    320,
    512,
    [],
    'e517',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm64 37.8c0-3.2 2.6-5.8 5.8-5.8l42.2 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l42.2 0c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 224l-32 0-21.8 0C90 224 64 198 64 165.8zm0 96c0-3.2 2.6-5.8 5.8-5.8l42.2 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l42.2 0c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 320l-32 0-21.8 0C90 320 64 294 64 261.8zm0 96c0-3.2 2.6-5.8 5.8-5.8l42.2 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l42.2 0c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 416l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-21.8 0C90 416 64 390 64 357.8z',
      'M64 0L256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 64C46.3 64 32 49.7 32 32S46.3 0 64 0zM256 165.8c0 32.1-26 58.2-58.2 58.2L176 224l-32 0-21.8 0C90 224 64 198 64 165.8c0-3.2 2.6-5.8 5.8-5.8l42.2 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l42.2 0c3.2 0 5.8 2.6 5.8 5.8zM250.2 256c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 320l-32 0-21.8 0C90 320 64 294 64 261.8c0-3.2 2.6-5.8 5.8-5.8l42.2 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l42.2 0zm0 96c3.2 0 5.8 2.6 5.8 5.8c0 32.1-26 58.2-58.2 58.2L176 416l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-21.8 0C90 416 64 390 64 357.8c0-3.2 2.6-5.8 5.8-5.8l42.2 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l42.2 0z',
    ],
  ],
};
const faEnvelopesBulk = {
  prefix: 'fad',
  iconName: 'envelopes-bulk',
  icon: [
    640,
    512,
    ['mail-bulk'],
    'f674',
    [
      'M32 301l0 39.8L168 441.6c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9L352 340.8l0-39.8c-51.7 38.3-103.4 76.6-155.1 114.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6C135.4 377.6 83.7 339.3 32 301zM96 32l0 192 96 0 0-32c0-35.3 28.7-64 64-64l224 0 0-96c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32zM224 192l0 32 96 0c35.3 0 64 28.7 64 64l0 128 192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-320 0c-17.7 0-32 14.3-32 32zm256 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M496 224l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM32 288c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 13L196.9 415.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6L32 301l0-13zM216 441.6L352 340.8 352 480c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-139.2L168 441.6c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9z',
    ],
  ],
};
const faMailBulk = faEnvelopesBulk;
const faFileCircleExclamation = {
  prefix: 'fad',
  iconName: 'file-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e4eb',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faBowArrow = {
  prefix: 'fad',
  iconName: 'bow-arrow',
  icon: [
    512,
    512,
    [127993],
    'f6b9',
    [
      'M0 128c0 8.2 3.1 16.4 9.4 22.6c53 53 106 106 159 159c11.3 11.3 22.6 22.6 33.9 33.9l159 159c12.5 12.5 32.8 12.5 45.3 0c12.2-12.2 12.5-31.8 .9-44.3c59.5-92.6 53.4-215.1-18.3-301.5c-15.2 15.2-30.3 30.3-45.5 45.5c47.3 60.7 53 143.3 17.1 209.3c-37.7-37.7-75.5-75.5-113.2-113.2c-11.3-11.3-22.6-22.6-33.9-33.9c-37.7-37.7-75.5-75.5-113.2-113.2c66-35.8 148.6-30.1 209.3 17.1l45.5-45.5C268.8 51.1 146.3 45 53.7 104.5c-12.6-11.6-32.1-11.3-44.3 .9C3.1 111.6 0 119.8 0 128z',
      'M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L213.7 264.4l33.9 33.9L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zM202.3 343.6l-33.9-33.9-23.8 23.8L93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8 23.8-23.8z',
    ],
  ],
};
const faCartXmark = {
  prefix: 'fad',
  iconName: 'cart-xmark',
  icon: [
    576,
    512,
    [],
    'e0dd',
    [
      'M120.1 32c2 4.2 3.5 8.8 4.4 13.5c15.4 80.8 30.8 161.6 46.2 242.5l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.4-39.9-40-39.9l-411 0zm156.5 68.6c7.8-7.8 20.5-7.8 28.3 0L336 131.7l31.1-31.1c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L364.3 160l31.1 31.1c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L336 188.3c-10.4 10.4-20.7 20.7-31.1 31.1c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L307.7 160c-10.4-10.4-20.7-20.7-31.1-31.1c-7.8-7.8-7.8-20.5 0-28.3z',
      'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM395.4 128.9c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L336 131.7l-31.1-31.1c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L307.7 160l-31.1 31.1c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0L336 188.3l31.1 31.1c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3L364.3 160l31.1-31.1z',
    ],
  ],
};
const faHexagonXmark = {
  prefix: 'fad',
  iconName: 'hexagon-xmark',
  icon: [
    512,
    512,
    ['times-hexagon', 'xmark-hexagon'],
    'f2ee',
    [
      'M7.4 256c0 12.4 3.2 24.9 9.6 36l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c6.4-11.1 9.6-23.6 9.6-36s-3.2-24.9-9.6-36L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220c-6.4 11.1-9.6 23.6-9.6 36zm160.7 61.7c.1-.7 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c15.7-15.7 31.3-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.3-31.3 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.3 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.2-1.1-.4-2.3-.3-2.2c-.1-1.2-.1-1.2-.1-2.4c0-1.5 .1-1.9 .1-2.3z',
      'M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faTimesHexagon = faHexagonXmark;
const faXmarkHexagon = faHexagonXmark;
const faCircleH = {
  prefix: 'fad',
  iconName: 'circle-h',
  icon: [
    512,
    512,
    [9405, 'hospital-symbol'],
    'f47e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z',
      'M344 128c13.3 0 24 10.7 24 24l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHospitalSymbol = faCircleH;
const faMerge = {
  prefix: 'fad',
  iconName: 'merge',
  icon: [
    512,
    512,
    [],
    'e526',
    [
      'M0 416c0 17.7 14.3 32 32 32l97.2 0c29.2 0 56.7-13.3 75-36l99.2-124c5.1 0 10.3 0 15.4 0c-27.4 0-53.5-11.7-71.7-32L154.2 372c-6.1 7.6-15.3 12-25 12L32 384c-17.7 0-32 14.3-32 32zM243.8 252c1.1 1.3 2.2 2.6 3.2 4c-1.1-1.3-2.1-2.7-3.2-4z',
      'M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l97.2 0c9.7 0 18.9 4.4 25 12l89.6 112c18.2 22.8 45.8 36 75 36l65.2 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-65.2 0c-9.7 0-18.9-4.4-25-12L204.2 100c-18.2-22.8-45.8-36-75-36L32 64z',
    ],
  ],
};
const faPager = {
  prefix: 'fad',
  iconName: 'pager',
  icon: [
    512,
    512,
    [128223],
    'f815',
    [
      'M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM56 344c0 13.3 10.7 24 24 24l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-13.3 0-24 10.7-24 24zm8-184l0 64c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zM192 344c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
      'M64 160c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z',
    ],
  ],
};
const faCartMinus = {
  prefix: 'fad',
  iconName: 'cart-minus',
  icon: [
    576,
    512,
    [],
    'e0db',
    [
      'M120.1 32c2 4.2 3.5 8.8 4.4 13.5c15.4 80.8 30.8 161.6 46.2 242.5l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.4-39.9-40-39.9l-411 0zM252 160c0-11 9-20 20-20l128 0c11 0 20 9 20 20s-9 20-20 20l-128 0c-11 0-20-9-20-20z',
      'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 140c-11 0-20 9-20 20s9 20 20 20l128 0c11 0 20-9 20-20s-9-20-20-20l-128 0z',
    ],
  ],
};
const faAddressBook = {
  prefix: 'fad',
  iconName: 'address-book',
  icon: [
    512,
    512,
    [62138, 'contact-book'],
    'f2b9',
    [
      'M32 64C32 28.7 60.7 0 96 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64zm96 304c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80zm48-176a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M496 64c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm16 144l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM128 368c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zM240 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    ],
  ],
};
const faContactBook = faAddressBook;
const faPanFrying = {
  prefix: 'fad',
  iconName: 'pan-frying',
  icon: [
    576,
    512,
    [127859],
    'e42c',
    [
      'M176 224a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M427.6 317.6C440.7 289.1 448 257.4 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448c53.3 0 102.3-18.6 140.8-49.7L472.7 498.5c11 8.8 24.1 13.5 39.3 13.5c35.3 0 64-28.7 64-64c0-20.9-9.3-38.8-24.7-50.5L427.6 317.6zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8zM512 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faGrid = {
  prefix: 'fad',
  iconName: 'grid',
  icon: [
    448,
    512,
    ['grid-3'],
    'e195',
    [
      'M0 232l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM160 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm0 320l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM320 232l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40z',
      'M0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40L0 72zM0 392c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM288 232l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40zM320 72c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM448 392l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40z',
    ],
  ],
};
const faGrid3 = faGrid;
const faFootballHelmet = {
  prefix: 'fad',
  iconName: 'football-helmet',
  icon: [
    512,
    512,
    [],
    'f44f',
    [
      'M272 320l49.7 0-13.2-70.6 31.8-4 14 74.5L464 320c26.5 0 48 21.5 48 48l0 32 0 50.4c0 25.2-20.4 45.6-45.6 45.6l-17 0c-54.9 0-102-39.1-112.1-93l-9.6-51L288 352c-5.3-10.7-10.7-21.3-16-32zm88.3 32l6 32L480 384l0-16c0-8.8-7.2-16-16-16l-103.7 0zm14.4 64c13.1 28.7 42 48 74.7 48l17 0c7.5 0 13.6-6.1 13.6-13.6l0-34.4-105.3 0z',
      'M462.5 230.2c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9l14 0c4.3 0 8.6 .9 12.6 2.6l93.4 40c8.3 3.5 17.2 5.4 26.1 5.4l1.7 0c35.7 0 64.7-29 64.7-64.7c0-10-2.3-20-6.8-28.9L259 294c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l181.4-22.7zM176 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faHandLove = {
  prefix: 'fad',
  iconName: 'hand-love',
  icon: [
    512,
    512,
    [],
    'e1a5',
    [
      'M11 284.4c-15.2 16-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-240c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128 0 64c0 35.3-28.7 64-64 64c-19.1 0-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7c-35.3 0-64-28.7-64-64l0-96 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 304c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4z',
      'M256 160c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faTrees = {
  prefix: 'fad',
  iconName: 'trees',
  icon: [
    640,
    512,
    [],
    'f724',
    [
      'M0 392.5c0 13 10.5 23.5 23.5 23.5L160 416l0-200c0-17.7 14.3-32 32-32s32 14.3 32 32l0 200 136.5 0c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L304 288l24.5 0c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L272 160l25.1 0c12.7 0 22.9-10.3 22.9-22.9c0-5.8-2.2-11.4-6.2-15.7L205.5 5.8C202 2.1 197.1 0 192 0s-10 2.1-13.5 5.8L70.2 121.4c-4 4.3-6.2 9.9-6.2 15.7C64 149.7 74.3 160 86.9 160l25.1 0L37.4 249.5c-3.5 4.2-5.4 9.5-5.4 15c0 13 10.5 23.5 23.5 23.5L80 288 5.4 377.5C1.9 381.7 0 387 0 392.5zm330.7-212L371.1 229c8.3 10 12.9 22.5 12.9 35.5c0 17.8-8.4 33.6-21.4 43.8L403.1 357c8.2 9.8 12.7 22.2 12.9 35c0-58.7 0-117.3 0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 200 136.5 0c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L560 288l24.5 0c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L528 160l25.1 0c12.7 0 22.9-10.3 22.9-22.9c0-5.8-2.2-11.4-6.2-15.7L461.5 5.8C458 2.1 453.1 0 448 0s-10 2.1-13.5 5.8l-92.9 99.1c6.7 9.3 10.4 20.5 10.4 32.1c0 17.7-8.3 33.4-21.3 43.4z',
      'M224 216c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 264c0 17.7 14.3 32 32 32s32-14.3 32-32l0-264zm256 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 264c0 17.7 14.3 32 32 32s32-14.3 32-32l0-264z',
    ],
  ],
};
const faStrikethrough = {
  prefix: 'fad',
  iconName: 'strikethrough',
  icon: [
    512,
    512,
    [],
    'f0cc',
    [
      'M96 416c0 13.4 8.5 25.9 21.9 30.4c3.6 1.2 7.9 2.7 12.7 4.3c24.9 8.5 63.6 21.7 87.6 25.6c15.5 2.4 30.7 3.7 45.5 3.7c28.3 0 55.2-4.6 78.4-14.6c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1l-75.7 0c7 5.6 11.4 11.2 13.9 17.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3c-1.1 3.4-1.6 6.8-1.6 10.1zm2.1-282.1c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9l145.5 0-.4-.1-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.1-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-15.3-2.4-30.5-3.6-45.3-3.6c-28.3 0-55.2 4.6-78.4 14.6c-36.5 15.6-64.4 44.8-71.8 87.3z',
      'M0 256c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faPage = {
  prefix: 'fad',
  iconName: 'page',
  icon: [
    384,
    512,
    [],
    'e428',
    [
      'M64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64z',
      '',
    ],
  ],
};
const faK = {
  prefix: 'fad',
  iconName: 'k',
  icon: [
    320,
    512,
    [107],
    '4b',
    [
      'M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 328 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-107 64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z',
      '',
    ],
  ],
};
const faDiagramPrevious = {
  prefix: 'fad',
  iconName: 'diagram-previous',
  icon: [
    512,
    512,
    [],
    'e478',
    [
      'M0 96l0 64c0 35.3 28.7 64 64 64l49 0c-5.5-18.4-2-39.6 14.1-55.6L216.4 79c21.9-21.9 57.3-21.9 79.2 0L385 168.4c16 16 19.6 37.2 14.1 55.6l49 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M448 288c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l168 0 0-64-46.1 0c-21.4 0-32.1-25.9-17-41L239 113c9.4-9.4 24.6-9.4 33.9 0L343 183c15.1 15.1 4.4 41-17 41L280 224l0 64 168 0z',
    ],
  ],
};
const faGaugeMin = {
  prefix: 'fad',
  iconName: 'gauge-min',
  icon: [
    512,
    512,
    ['tachometer-alt-slowest'],
    'f628',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm64-8c0-4.3 1.2-8.7 3.6-12.6C72.1 228 80 224 88 224c4.3 0 8.7 1.2 12.6 3.6c39.2 24.3 78.4 48.5 117.6 72.8c10.6-7.8 23.7-12.4 37.8-12.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-3.7 .3-7.3 .9-10.8c-39.2-24.3-78.4-48.5-117.5-72.8C68 263.9 64 256 64 248zM176 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm112 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6z',
    ],
  ],
};
const faTachometerAltSlowest = faGaugeMin;
const faFolderGrid = {
  prefix: 'fad',
  iconName: 'folder-grid',
  icon: [
    512,
    512,
    [],
    'e188',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM80 264c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm128 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm128 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48z',
      'M80 264c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm128 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm152-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faEggplant = {
  prefix: 'fad',
  iconName: 'eggplant',
  icon: [
    512,
    512,
    [],
    'e16c',
    [
      'M0 332.7c0 1.1 0 2.2 0 3.3c1.4 95.3 79.8 175.9 176.4 176c145.7 .1 250.1-174.5 291.3-305.6C447.1 201 432 182.3 432 160c0-5.8-4-10.7-9.4-12.6c-13.3-4.8-25.4-13-35.1-22.8s-18-21.9-22.8-35.1c-2-5.4-6.9-9.4-12.6-9.4c-.7 0-1.3 0-1.9 0c-.6 0-1.3-.1-1.9-.1c-1.3-.1-2.5-.2-3.7-.4c-2.4-.4-4.8-1-7.1-1.7c-4.6-1.5-8.9-3.6-12.8-6.4c-7.8-5.5-13.9-13.2-17.3-22.2c-34.6 40.3-86.2 65.3-137.3 90.1C84.2 180.9 0 221.7 0 332.7z',
      'M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-9 9L320 16c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48c5.8 0 10.7 4 12.6 9.4c4.8 13.3 13 25.4 22.8 35.1s21.9 18 35.1 22.8c5.4 2 9.4 6.9 9.4 12.6c0 26.5 21.5 48 48 48c8.8 0 16-7.2 16-16l0-142.1 9-9z',
    ],
  ],
};
const faExcavator = {
  prefix: 'fad',
  iconName: 'excavator',
  icon: [
    640,
    512,
    [],
    'e656',
    [
      'M0 432c0-44.2 35.8-80 80-80l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80zm64 0c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 416c-8.8 0-16 7.2-16 16zM416 160L562.7 13.3c8.5-8.5 20-13.3 32-13.3c25 0 45.3 20.3 45.3 45.3L640 320l0 64 0 48c0 44.2-35.8 80-80 80l-78.1 0c-18.7 0-33.9-15.2-33.9-33.9c0-9 3.6-17.6 9.9-24L576 336l0-208L416 288l0-128z',
      'M238.9 64l64 96L160 160l0-96 78.9 0zM384 208l0-17.5c0-15.8-4.7-31.2-13.4-44.4L292.1 28.5C280.3 10.7 260.3 0 238.9 0L144 0C117.5 0 96 21.5 96 48l0 112-48 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-48 0-16z',
    ],
  ],
};
const faRam = {
  prefix: 'fad',
  iconName: 'ram',
  icon: [
    640,
    512,
    [128015],
    'f70a',
    [
      'M0 256c0 24.5 13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0c2.8-.1 5.6-.3 8.3-.7c6.8 28 32.1 48.7 62.2 48.7c7.5 0 14.7-1.3 21.3-3.6c6.8-2.4 13-5.9 18.5-10.2C219.7 439.6 236.9 448 256 448c19.2 0 36.5-8.5 48.2-21.9C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c2.7 .4 5.5 .7 8.3 .7c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40L464 352c-61.9 0-112-50.1-112-112l0-32.6c-18.7-2.7-35.5-14.8-43.5-33.4c-8.9-20.8-4.3-44 10-59.7C312.3 85.6 286.7 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256z',
      'M400 0c-35.3 0-64 28.7-64 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2 0 72.2c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-72.2 14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21L544 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3l0-1.3c0-35.3-28.7-64-64-64zm64 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM115.1 485.9c2.8 15.1 16.1 26.1 31.5 26.1l29.4 0c17.7 0 32-14.3 32-32l0-53.7-.2-.2C196.9 434.8 183 440 168 440c-30.1 0-55.3-20.8-62.2-48.7c-2.7 .4-5.5 .7-8.3 .7l17.6 93.9zM304 480c0 17.7 14.3 32 32 32l29.4 0c15.4 0 28.6-11 31.4-26.1L414.5 392c-2.8-.1-5.6-.3-8.3-.7c-6.8 28-32.1 48.7-62.2 48.7c-15 0-28.9-5.2-39.8-13.9l-.2 .2 0 53.7z',
    ],
  ],
};
const faLandmarkFlag = {
  prefix: 'fad',
  iconName: 'landmark-flag',
  icon: [
    512,
    512,
    [],
    'e51c',
    [
      'M0 480c0 3.1 .4 6.2 1.4 9.3C5.5 502.8 17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7c.9-3.1 1.4-6.2 1.4-9.3c0-10.5-5.2-20.6-14.2-26.6l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 192l-64 0 0 224-40 0 0-224-64 0 0 224-48 0 0-224-64 0 0 224-40 0 0-224-64 0 0 228.3c-.6 .3-1.2 .7-1.7 1.1l-48 32C5.2 459.4 0 469.5 0 480z',
      'M272 0l80 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-80 0 0 32 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0 0-112c0-8.8 7.2-16 16-16l16 0z',
    ],
  ],
};
const faLips = {
  prefix: 'fad',
  iconName: 'lips',
  icon: [
    576,
    512,
    [128068, 128482],
    'f600',
    [
      'M0 224l64 0c0 7.9 80 96 224 96s224-88.1 224-96l64 0c0 9.2-2.6 19.1-5.3 27.5c-3 9.1-7.4 19.4-12.8 30.3c-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448l-64 0c-84.7 0-148.8-47.1-190.2-95.1C44.9 328.8 29 303.5 18.1 281.8C12.7 271 8.4 260.7 5.3 251.5C2.6 243.1 0 233.2 0 224z',
      'M297.7 94c-3.4 2.5-6.7 4.9-9.7 7.3c-3-2.4-6.2-4.8-9.7-7.3C260.6 81.2 231.5 64 200 64c-20.3 0-42.8 9.3-61.4 19.2c-20 10.6-41.1 24.7-60.2 39.5c-19.1 14.8-37.1 31.2-50.8 46.5c-6.8 7.6-13.1 15.7-17.9 23.7C5.5 200.2 0 211.2 0 224l64 0c0-7.7 46.3-31.1 138.8-32c3.4 0 6.9 .5 10.1 1.5c13.1 4 49.4 14.4 75.1 14.4s62-10.4 75.1-14.4c3.3-1 6.7-1.6 10.1-1.5c92.5 .9 138.8 24.2 138.8 32l64 0c0-12.8-5.5-23.8-9.7-31c-4.8-8.1-11.1-16.1-17.9-23.7c-13.6-15.3-31.7-31.7-50.8-46.5c-19.1-14.9-40.2-29-60.2-39.5C418.8 73.3 396.3 64 376 64c-31.5 0-60.6 17.2-78.3 30z',
    ],
  ],
};
const faPencil = {
  prefix: 'fad',
  iconName: 'pencil',
  icon: [
    512,
    512,
    [9999, 61504, 'pencil-alt'],
    'f303',
    [
      'M144 319.4c0 4.1 1.6 8.2 4.7 11.3s7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7c48-48 96-96 144-144c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-48 48-96 96-144 144c-3.1 3.1-4.7 7.2-4.7 11.3zM302.7 78.7c43.3 43.3 86.6 86.6 129.9 129.9c20-20 40-40 60-60c12.5-12.5 18.7-28.9 18.7-45.3s-6.2-32.8-18.7-45.3L453.3 18.7c-25-25-65.5-25-90.5 0l-60 60z',
      'M432.7 208.7L302.7 78.7 58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L432.7 208.7zM89.3 360.5l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3zm226-196.4c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0z',
    ],
  ],
};
const faPencilAlt = faPencil;
const faBackward = {
  prefix: 'fad',
  iconName: 'backward',
  icon: [
    512,
    512,
    [9194],
    'f04a',
    [
      'M256 241l0 30L459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L256 241z',
      'M203.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160z',
    ],
  ],
};
const faCaretRight = {
  prefix: 'fad',
  iconName: 'caret-right',
  icon: [
    256,
    512,
    [],
    'f0da',
    [
      'M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z',
      '',
    ],
  ],
};
const faComments = {
  prefix: 'fad',
  iconName: 'comments',
  icon: [
    640,
    512,
    [128490, 61670],
    'f086',
    [
      'M231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.3 1c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.3-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129z',
      'M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9c0 0 0 0 0 0s0 0 0 0l.2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176z',
    ],
  ],
};
const faPaste = {
  prefix: 'fad',
  iconName: 'paste',
  icon: [
    512,
    512,
    ['file-clipboard'],
    'f0ea',
    [
      'M224 176c0-26.5 21.5-48 48-48l124.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L512 464c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288z',
      'M160 0c-23.7 0-44.4 12.9-55.4 32L48 32C21.5 32 0 53.5 0 80L0 400c0 26.5 21.5 48 48 48l144 0 0-272c0-44.2 35.8-80 80-80l48 0 0-16c0-26.5-21.5-48-48-48l-56.6 0C204.4 12.9 183.7 0 160 0zm0 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faFileClipboard = faPaste;
const faDesktopArrowDown = {
  prefix: 'fad',
  iconName: 'desktop-arrow-down',
  icon: [
    576,
    512,
    [],
    'e155',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0 96 0 176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L312 0l0 64 200 0 0 224L64 288 64 64l200 0 0-64L64 0C28.7 0 0 28.7 0 64z',
      'M264 64L64 64l0 224 448 0 0-224L312 64l0 110.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 64zm82.7 384L336 416l-96 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0z',
    ],
  ],
};
const faCodePullRequest = {
  prefix: 'fad',
  iconName: 'code-pull-request',
  icon: [
    512,
    512,
    [],
    'e13c',
    [
      'M48 153.3l0 205.3c9.8-4.3 20.6-6.7 32-6.7c1.4 0 2.8 0 4.2 .1s2.8 .2 4.2 .3c2.8 .3 5.5 .7 8.2 1.3c5.4 1.1 10.5 2.8 15.4 4.9l0-205.3c-9.8 4.3-20.6 6.7-32 6.7c-1.4 0-2.8 0-4.2-.1s-2.8-.2-4.2-.3c-2.8-.3-5.5-.7-8.2-1.3c-5.4-1.1-10.5-2.8-15.4-4.9zM192 96c0 6.8 2.9 13.3 7.9 17.8l80 72c7 6.3 17.2 7.9 25.8 4.1s14.2-12.4 14.2-21.9l0-40 16 0c35.3 0 64 28.7 64 64l0 166.7c9.8-4.3 20.6-6.7 32-6.7c1.4 0 2.8 0 4.2 .1s2.8 .2 4.2 .3c2.8 .3 5.5 .7 8.2 1.3c5.4 1.1 10.5 2.8 15.4 4.9L464 192c0-70.7-57.3-128-128-128l-16 0 0-40c0-9.5-5.6-18.1-14.2-21.9C302.6 .7 299.3 0 296 0c-5.8 0-11.6 2.1-16.1 6.2l-80 72c-5.1 4.6-7.9 11-7.9 17.8z',
      'M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zm0 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm328-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faPumpkin = {
  prefix: 'fad',
  iconName: 'pumpkin',
  icon: [
    576,
    512,
    [],
    'f707',
    [
      'M0 320C0 426 68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320z',
      'M234.6 103.9l40.9-93.5c2.8-6.3 9-10.4 15.8-10.4l1.2 0c2.3 0 4.7 .5 6.8 1.4l42.3 18.1c6.4 2.7 10.5 9 10.5 15.9l0 72C332.1 100 310.5 96 288 96c-18.6 0-36.5 2.8-53.5 7.9z',
    ],
  ],
};
const faClipboardList = {
  prefix: 'fad',
  iconName: 'clipboard-list',
  icon: [
    384,
    512,
    [],
    'f46d',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM120 272a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm40-96c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
      'M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faPenField = {
  prefix: 'fad',
  iconName: 'pen-field',
  icon: [
    640,
    512,
    [],
    'e211',
    [
      'M0 208c0-44.2 35.8-80 80-80l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 192c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 208z',
      'M534.1 16L494.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L601.9 16c-18.8-18.8-49.2-18.7-67.9 0zM471.7 78.4L328.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L560.8 167.5 471.7 78.4zM160 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faChartSine = {
  prefix: 'fad',
  iconName: 'chart-sine',
  icon: [
    512,
    512,
    [],
    'e69d',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M159.6 229.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l0 0c1-6.2 2.6-12.2 4.2-18.3c2.9-10.3 7.5-24.3 14.7-38.7C128.9 134.6 157.1 96 208 96c38.2 0 63.6 19.5 80 44.4c14.4 21.9 23 49.6 29.9 72l.7 2.2c7.8 25.3 14 44.4 22.9 57.9c7.3 11.1 14.4 15.6 26.6 15.6c13.1 0 24.9-9.4 35.4-30.3c4.8-9.6 8.1-19.5 10.3-27.3c2.1-7.7 2.8-11.7 2.8-11.7c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8c-1 6.2-2.6 12.3-4.2 18.3c-2.9 10.3-7.5 24.3-14.7 38.7c-13.5 27-41.7 65.7-92.6 65.7c-38.2 0-63.6-19.5-80-44.4c-14.4-21.9-23-49.6-29.9-72l-.7-2.2c-7.8-25.3-14-44.4-22.9-57.9C227.3 164.5 220.1 160 208 160c-13.1 0-24.9 9.4-35.4 30.3c-4.8 9.6-8.1 19.5-10.3 27.3c-1.1 3.9-2 7.8-2.8 11.8l0 0z',
    ],
  ],
};
const faBlueberries = {
  prefix: 'fad',
  iconName: 'blueberries',
  icon: [
    512,
    512,
    [],
    'e2e8',
    [
      'M112 272c0 8.8 7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16zm48.7-111.3c5.1-.4 10.2-.7 15.3-.7c97.2 0 176 78.8 176 176c0 1.3 0 2.6 0 3.9s-.1 2.6-.1 3.8c-.1 2.6-.3 5.1-.5 7.6C441.4 343.6 512 268 512 176C512 78.8 433.2 0 336 0C244 0 168.4 70.6 160.7 160.7zM304 112c0-8.8 7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16z',
      'M384 64l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zM176 208c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faTruckRampBox = {
  prefix: 'fad',
  iconName: 'truck-ramp-box',
  icon: [
    640,
    512,
    ['truck-loading'],
    'f4de',
    [
      'M23.1 207.7L64.5 362.3c4.6 17.1 22.1 27.2 39.2 22.6l154.5-41.4c17.1-4.6 27.2-22.1 22.6-39.2L239.5 149.7c-4.6-17.1-22.1-27.2-39.2-22.6l-46.4 12.4c6.9 25.8 13.8 51.5 20.7 77.3c2.3 8.5-2.8 17.3-11.3 19.6c-10.3 2.8-20.6 5.5-30.9 8.3c-8.5 2.3-17.3-2.8-19.6-11.3L92.1 156.1c-15.5 4.1-30.9 8.3-46.4 12.4c-17.1 4.6-27.2 22.1-22.6 39.2zM448 416a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M544 288c-66.1 0-120.6 50.2-127.3 114.5L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640V331.3c-23.5-26.6-57.8-43.3-96-43.3zM153.9 139.5L92.1 156.1l20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3z',
    ],
  ],
};
const faTruckLoading = faTruckRampBox;
const faNote = {
  prefix: 'fad',
  iconName: 'note',
  icon: [
    448,
    512,
    [],
    'e1ff',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224-128 0c-17.7 0-32 14.3-32 32l0 128L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M288 352V480h5.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V320H320c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faArrowDownToSquare = {
  prefix: 'fad',
  iconName: 'arrow-down-to-square',
  icon: [
    512,
    512,
    [],
    'e096',
    [
      'M0 112C0 67.8 35.8 32 80 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c44.2 0 80 35.8 80 80l0 320c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112z',
      'M233.4 342.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 242.7 288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96z',
    ],
  ],
};
const faUserCheck = {
  prefix: 'fad',
  iconName: 'user-check',
  icon: [
    640,
    512,
    [],
    'f4fc',
    [
      'M0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0C79.8 304 0 383.8 0 482.3zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z',
      'M625 143c9.4 9.4 9.4 24.6 0 33.9L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faCloudXmark = {
  prefix: 'fad',
  iconName: 'cloud-xmark',
  icon: [
    640,
    512,
    [],
    'e35f',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm232 16c0-6.1 2.3-12.3 7-17c15.7-15.7 31.4-31.4 47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l47 47 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-47 47 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7c-15.7-15.7-31.3-31.3-47-47c-15.7 15.7-31.4 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M273 207c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faVialVirus = {
  prefix: 'fad',
  iconName: 'vial-virus',
  icon: [
    512,
    512,
    [],
    'e597',
    [
      'M0 64C0 46.3 14.3 32 32 32l64 0 64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 111.1c-3.1 2.1-6.1 4.4-8.8 7.2c-21.9 21.9-21.9 57.3 0 79.2c.2 .2 .2 .3 .3 .4c0 .1 0 .3-.1 .6s-.2 .4-.4 .5c-.1 0-.2 0-.4 0c-30.9 0-56 25.1-56 56s25.1 56 56 56c.2 0 .4 0 .5 0c.1 .1 .2 .2 .3 .5s.1 .5 .1 .6c0 .1-.1 .2-.3 .3c-11.2 11.2-16.6 25.9-16.4 40.5C181.3 468 156 480 128 480c-53 0-96-43-96-96L32 96C14.3 96 0 81.7 0 64zM96 96l0 96 64 0 0-96L96 96z',
      'M376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.9 43.3-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24c28.8 0 43.3 34.9 22.9 55.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-6 55.2 22.8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.4-20.4-5.9-55.3 22.9-55.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.9 259.3 376 244.8 376 216zM288.8 321.4a31.7 31.7 0 1 1 63.5 0 31.7 31.7 0 1 1 -63.5 0zm95.2 39.6a23.8 23.8 0 1 1 0 47.6 23.8 23.8 0 1 1 0-47.6z',
    ],
  ],
};
const faBookBlank = {
  prefix: 'fad',
  iconName: 'book-blank',
  icon: [
    448,
    512,
    [128213, 128215, 128216, 128217, 'book-alt'],
    'f5d9',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96z',
    ],
  ],
};
const faBookAlt = faBookBlank;
const faGolfFlagHole = {
  prefix: 'fad',
  iconName: 'golf-flag-hole',
  icon: [
    512,
    512,
    [],
    'e3ac',
    [
      'M0 416c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8l0 70.1c11.7-6.6 28.9-10.8 48-10.8c35.3 0 64 14.3 64 32s-28.7 32-64 32c-23.1 0-43.4-6.1-54.6-15.3c-4.4 4.5-10.6 7.3-17.4 7.3c-13.3 0-24-10.7-24-24l0-83.2C51.5 349.4 0 380.5 0 416z',
      'M139.4 3.6c7.1-4.4 15.9-4.8 23.4-1.1l208 104c8.1 4.1 13.3 12.4 13.3 21.5s-5.1 17.4-13.3 21.5L176 246.8 176 416c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-1.4 .1-2.7 .3-4c-.2-1.3-.3-2.6-.3-4l0-208c0-8.3 4.3-16 11.4-20.4z',
    ],
  ],
};
const faMessageArrowDown = {
  prefix: 'fad',
  iconName: 'message-arrow-down',
  icon: [
    512,
    512,
    ['comment-alt-arrow-down'],
    'e1db',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM160 224c0 6.1 2.3 12.3 7 17l72 72c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l72-72c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17c-9.4-9.4-24.6-9.4-33.9 0l-31 31L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1-31-31c-9.4-9.4-24.6-9.4-33.9 0c-4.7 4.7-7 10.8-7 17z',
      'M256 96c13.3 0 24 10.7 24 24l0 118.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L232 120c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faCommentAltArrowDown = faMessageArrowDown;
const faFaceUnamused = {
  prefix: 'fad',
  iconName: 'face-unamused',
  icon: [
    512,
    512,
    [],
    'e39f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-48c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16zm76.1 165.3C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6zM288 208c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z',
      'M96 208c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faSheetPlastic = {
  prefix: 'fad',
  iconName: 'sheet-plastic',
  icon: [
    384,
    512,
    [],
    'e571',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l160 0 0-128c0-17.7 14.3-32 32-32l128 0 0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm52.7 84.7l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm32 96l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z',
      'M224 512L384 352H256c-17.7 0-32 14.3-32 32V512z',
    ],
  ],
};
const faCircle9 = {
  prefix: 'fad',
  iconName: 'circle-9',
  icon: [
    512,
    512,
    [],
    'e0f6',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-32c0-53 43-96 96-96s96 43 96 96c0 32.4-14.2 63.2-38.8 84.3l-81.6 70c-4.5 3.9-10.1 5.8-15.6 5.8c-6.8 0-13.5-2.8-18.2-8.4c-8.6-10.1-7.5-25.2 2.6-33.8L230 316.4c-40.4-11.4-70-48.4-70-92.4zm48 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M304 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-74 92.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C337.8 287.2 352 256.4 352 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z',
    ],
  ],
};
const faBlog = {
  prefix: 'fad',
  iconName: 'blog',
  icon: [
    512,
    512,
    [],
    'f781',
    [
      'M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32z',
      'M48 96c26.5 0 48 21.5 48 48l0 224c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48l-16 0 0-96 16 0c79.5 0 144 64.5 144 144s-64.5 144-144 144S0 447.5 0 368L0 144c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faUserNinja = {
  prefix: 'fad',
  iconName: 'user-ninja',
  icon: [
    448,
    512,
    [129399],
    'f504',
    [
      'M144 112c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
      'M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 96z',
    ],
  ],
};
const faPencilSlash = {
  prefix: 'fad',
  iconName: 'pencil-slash',
  icon: [
    640,
    512,
    [],
    'e215',
    [
      'M64 487.4c0 6.3 2.5 12.4 7 17c6.2 6.2 15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.3-88.3-77.9-61.4-27.6 27.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.9-24.9L195.5 250l-72.9 72.9c-10.4 10.4-18 23.3-22.2 37.4L65 480.7c-.7 2.2-1 4.5-1 6.8zM123.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.1 23zM263.9 181.6c14.1 11 28.1 22.1 42.2 33.1l50.5-50.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-47.8 47.8c26 20.4 52.1 40.8 78.1 61.2l42.1-42.1L474.3 231l11.3-11.3-33.9-33.9-62.1-62.1L355.7 89.8l-11.3 11.3-22.6 22.6-57.8 57.8zM378.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L517.3 18.7C504.8 6.2 488.4 0 472 0s-32.8 6.2-45.3 18.7L412.3 33.2 389.7 55.8 378.3 67.1z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBowlingPins = {
  prefix: 'fad',
  iconName: 'bowling-pins',
  icon: [
    512,
    512,
    [],
    'f437',
    [
      'M32 379.5c0 28.9 6.7 57.5 19.7 83.4l15.7 31.4C72.8 505.2 83.9 512 96 512l64 0c12.1 0 23.2-6.8 28.6-17.7l15.7-31.4C217.3 437 224 408.5 224 379.5c0-22-3.9-43.8-11.5-64.4L173.9 210.4c-2.2-6-3.8-12.1-4.8-18.4l-82.3 0c-1 6.3-2.6 12.4-4.8 18.4L43.5 315.1C35.9 335.7 32 357.5 32 379.5zM64 64l0 1.1c0 7.4 1 14.8 2.9 22l17.7 64.8c.7 2.7 1.3 5.4 1.8 8.1l83.1 0c.5-2.7 1.1-5.4 1.8-8.1l17.7-64.8c2-7.2 2.9-14.6 2.9-22l0-1.1c0-35.3-28.7-64-64-64S64 28.7 64 64zM288 375.1c0 20.5 3.9 40.9 11.5 59.9l22.7 56.9C327.1 504 338.9 512 352 512l64 0c13.1 0 24.9-8 29.7-20.1L468.5 435c7.6-19.1 11.5-39.4 11.5-59.9c0-19-3.4-37.9-10-55.8L429.9 210.4c-2.2-6-3.8-12.1-4.8-18.4l-82.3 0c-1 6.3-2.6 12.4-4.8 18.4L298 319.3c-6.6 17.9-10 36.8-10 55.8zM320 64l0 1.1c0 7.4 1 14.8 2.9 22l17.7 64.8c.7 2.7 1.3 5.4 1.8 8.1l83.1 0c.5-2.7 1.1-5.4 1.8-8.1l17.7-64.8c2-7.2 2.9-14.6 2.9-22l0-1.1c0-35.3-28.7-64-64-64s-64 28.7-64 64z',
      'M86.8 192c.8-4.9 1.2-9.9 1.2-14.8c0-5.8-.5-11.5-1.5-17.2l83.1 0c-1 5.7-1.5 11.4-1.5 17.2c0 5 .4 9.9 1.2 14.8l-82.3 0zm256 0c.8-4.9 1.2-9.9 1.2-14.8c0-5.8-.5-11.5-1.5-17.2l83.1 0c-1 5.7-1.5 11.4-1.5 17.2c0 5 .4 9.9 1.2 14.8l-82.3 0z',
    ],
  ],
};
const faPersonArrowUpFromLine = {
  prefix: 'fad',
  iconName: 'person-arrow-up-from-line',
  icon: [
    640,
    512,
    [],
    'e539',
    [
      'M32 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L120 256.9 120 448l64 0 0-96 16 0 0 96 64 0 0-191.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c10-6 15.5-16.6 15.5-27.5c0-5.6-1.5-11.3-4.6-16.5l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C33.5 276.7 32 282.4 32 288zM144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M598.6 166.6c12.5-12.5 12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-242.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faDownRight = {
  prefix: 'fad',
  iconName: 'down-right',
  icon: [
    384,
    512,
    [],
    'e16b',
    [
      'M0 144c0 10.2 4.1 20.1 11.3 27.3L145.4 305.4l96-96L107.3 75.3C100.1 68.1 90.2 64 80 64s-20.1 4.1-27.3 11.3L11.3 116.7C4.1 123.9 0 133.8 0 144z',
      'M336 432H96c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l240-240c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6V400c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faScrollTorah = {
  prefix: 'fad',
  iconName: 'scroll-torah',
  icon: [
    640,
    512,
    ['torah'],
    'f6a0',
    [
      'M96 32l0 448 448 0 0-448L96 32zM196 198.3c0-10.1 8.2-18.3 18.3-18.3l56.7 0 31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180l56.7 0c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3L369 332l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332l-56.7 0c-10.1 0-18.3-8.2-18.3-18.3c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2zm28.2 5.7l16.4 28.2L257 204l-32.8 0zm0 104l32.8 0-16.4-28.2L224.2 308zm30.3-52l30.3 52 70.4 0 30.3-52-30.3-52-70.4 0-30.3 52zm44.3-76l42.4 0L320 143.6 298.8 180zm0 152L320 368.4 341.2 332l-42.4 0zM383 204l16.4 28.2L415.8 204 383 204zm0 104l32.8 0-16.4-28.2L383 308z',
      'M96 480L96 32C96 14.3 74.5 0 48 0S0 14.3 0 32L0 480c0 17.7 21.5 32 48 32s48-14.3 48-32zm544 0l0-448c0-17.7-21.5-32-48-32s-48 14.3-48 32l0 448c0 17.7 21.5 32 48 32s48-14.3 48-32z',
    ],
  ],
};
const faTorah = faScrollTorah;
const faWebhook = {
  prefix: 'fad',
  iconName: 'webhook',
  icon: [
    576,
    512,
    [],
    'e5d5',
    [
      'M0 383.9c0-51.3 31-98.2 78.8-118c12.2-5.1 26.3 .7 31.4 12.9s-.7 26.3-12.9 31.4c-35.4 14.7-56 53.3-47.1 91.8c9.9 43 52.9 69.9 95.9 60c37-8.5 62.1-41.5 62-77.9c0-6.4 2.5-12.5 7-17s10.6-7 17-7l174.4 0c-2 3.5-3.6 7.3-4.7 11.4c-.5 2-1 4.1-1.2 6.2c-.1 1.1-.2 2.1-.3 3.2s-.1 2.2-.1 3.3c0 8.7 2.3 16.9 6.4 24l-152.7 0c-9.2 48.3-46 89-97 100.7c-9.7 2.2-19.4 3.3-28.9 3.3C69.6 512 16.9 472 3.3 412.8C1 403.1 0 393.4 0 383.9zM129.7 336L201 221.9c-32.5-30.2-48.4-76.4-37.7-122.7C179.2 30.3 247.9-12.6 316.8 3.3c65.9 15.2 108 78.7 97.7 144.4c-2.1 13.1-14.3 22-27.4 20s-22-14.3-20-27.4c6.4-41.1-19.9-80.7-61.1-90.2c-43.1-9.9-86 16.9-95.9 60c-7.9 34.1 7.4 68.2 35.5 85.9c5.4 3.4 9.2 8.8 10.7 15s.3 12.7-3 18.1L170.4 361.5c-7.8-14.7-23.1-24.8-40.7-25.4zM289.7 176c17.7-.6 32.9-10.7 40.7-25.4l71.3 114.1c45.8-17.7 99.8-8.2 136.8 28.9c50 50 50 131 0 181c-43 43-109 49-158.4 18c-11.2-7-14.6-21.8-7.6-33.1s21.8-14.6 33.1-7.6c30.9 19.3 72.1 15.5 99-11.3c31.2-31.2 31.2-81.9 0-113.1c-26.8-26.8-68.1-30.6-99-11.3c-5.4 3.4-11.9 4.5-18.1 3s-11.6-5.3-15-10.7L289.7 176z',
      'M288 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM176 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm320 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
    ],
  ],
};
const faBlindsOpen = {
  prefix: 'fad',
  iconName: 'blinds-open',
  icon: [
    512,
    512,
    [],
    'f8fc',
    [
      'M0 174.2C0 184 8 192 17.8 192L128 192l0-64-80.6 0c-9.7 0-18.9 4.4-25 12L3.9 163.1C1.4 166.3 0 170.2 0 174.2zm0 160C0 344 8 352 17.8 352L144 352c-26.5 0-48-21.5-48-48c0-.7 0-1.4 0-2.1s.1-1.4 .1-2.1c.1-1.4 .3-2.7 .5-4.1c.5-2.7 1.1-5.3 2-7.8l-51.4 0c-9.7 0-18.9 4.4-25 12L3.9 323.1C1.4 326.3 0 330.2 0 334.2zm0 160C0 504 8 512 17.8 512l476.5 0c9.8 0 17.8-8 17.8-17.8c0-4-1.4-7.9-3.9-11.1L489.6 460c-6.1-7.6-15.3-12-25-12L47.4 448c-9.7 0-18.9 4.4-25 12L3.9 483.1C1.4 486.3 0 490.2 0 494.2zM144 352l350.2 0c9.8 0 17.8-8 17.8-17.8c0-4-1.4-7.9-3.9-11.1L489.6 300c-6.1-7.6-15.3-12-25-12l-275.4 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48zm16-224l0 64 334.2 0c9.8 0 17.8-8 17.8-17.8c0-4-1.4-7.9-3.9-11.1L489.6 140c-6.1-7.6-15.3-12-25-12L160 128z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l96 0 0 194.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 64l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0z',
    ],
  ],
};
const faFence = {
  prefix: 'fad',
  iconName: 'fence',
  icon: [
    512,
    512,
    [],
    'e303',
    [
      'M128 160l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zM320 160l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0z',
      'M76.8 38.4C73.8 34.4 69 32 64 32s-9.8 2.4-12.8 6.4L6.4 98.1C2.2 103.7 0 110.4 0 117.3L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-330.7c0-6.9-2.2-13.7-6.4-19.2L76.8 38.4zm192 0c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4L198.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2L192 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-330.7c0-6.9-2.2-13.7-6.4-19.2L268.8 38.4zM448 32c-5 0-9.8 2.4-12.8 6.4L390.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2L384 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-330.7c0-6.9-2.2-13.7-6.4-19.2L460.8 38.4c-3-4-7.8-6.4-12.8-6.4z',
    ],
  ],
};
const faUp = {
  prefix: 'fad',
  iconName: 'up',
  icon: [
    384,
    512,
    ['arrow-alt-up'],
    'f357',
    [
      'M128 256c42.7 0 85.3 0 128 0c0 61.3 0 122.7 0 184c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40c0-61.3 0-122.7 0-184z',
      'M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l96 0s0 0 0 0l128 0s0 0 0 0l96 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-160-160z',
    ],
  ],
};
const faArrowAltUp = faUp;
const faBroomBall = {
  prefix: 'fad',
  iconName: 'broom-ball',
  icon: [
    576,
    512,
    ['quidditch', 'quidditch-broom-ball'],
    'f458',
    [
      'M329.4 201.4l45.3 45.3 192-192c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6S552.2 0 544 0s-16.4 3.1-22.6 9.4l-192 192zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M409.4 281.4L294.6 166.6c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6l0 29.1L364.3 320l29.1 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16zm-68.3 72L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z',
    ],
  ],
};
const faQuidditch = faBroomBall;
const faQuidditchBroomBall = faBroomBall;
const faDrumstick = {
  prefix: 'fad',
  iconName: 'drumstick',
  icon: [
    512,
    512,
    [127831],
    'f6d6',
    [
      'M0 380c0 33.1 26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l36.4-36.4c-39.2-3-70.5-34.3-73.5-73.5l-36.4 36.4c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60z',
      'M160 176v96c0 44.2 35.8 80 80 80h96c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176z',
    ],
  ],
};
const faSquareV = {
  prefix: 'fad',
  iconName: 'square-v',
  icon: [
    448,
    512,
    [],
    'e284',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm98.5 82.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7c27.5 55 55 110.1 82.5 165.1c27.5-55 55-110 82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7c8.4 4.2 13.3 12.7 13.3 21.5c0 3.6-.8 7.3-2.5 10.7c-34.7 69.3-69.3 138.7-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3c-34.7-69.3-69.3-138.7-104-208z',
      'M109.3 146.5c11.9-5.9 26.3-1.1 32.2 10.7L224 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2z',
    ],
  ],
};
const faFaceAwesome = {
  prefix: 'fad',
  iconName: 'face-awesome',
  icon: [
    512,
    512,
    ['gave-dandy'],
    'e409',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm80-72c0-35.3 28.7-64 64-64c3.4 0 6.7 .3 10 .8c22.6 3.5 41.3 18.9 49.5 39.6c2.9 7.3 4.5 15.3 4.5 23.6l0 10.3c0 16.4-13.3 29.7-29.7 29.7l-68.6 0C93.3 224 80 210.7 80 194.3L80 184zm20 120.2c0-8.7 7.1-16.2 16.3-16.2l279.4 0c10.4 0 18.1 9.6 15.9 19.8c-5 22.3-14.6 42.7-27.7 60.2c-29.4 39.3-76.5 64-127.9 64c-74.3 0-139.5-51.6-155.6-124.2c-.3-1.2-.4-2.4-.4-3.6zM272 192c0-39.8 32.2-72 72-72c5.8 0 11.4 .7 16.8 2c22 5.3 40.1 20.6 49.1 40.9c3.9 8.9 6.1 18.8 6.1 29.1l0 7.5c0 13.5-11 24.5-24.5 24.5l-95.1 0C283 224 272 213 272 199.5l0-7.5z',
      'M154 120.8c22.6 3.5 41.3 18.9 49.5 39.6c-5.6 9.4-15.8 15.6-27.5 15.6c-17.7 0-32-14.3-32-32c0-9.1 3.8-17.4 10-23.2zM360.8 122c22 5.3 40.1 20.6 49.1 40.9c-5.8 8-15.2 13.1-25.9 13.1c-17.7 0-32-14.3-32-32c0-8.5 3.3-16.3 8.8-22zM100.4 307.8c-2.3-10.2 5.5-19.8 15.9-19.8l279.4 0c10.4 0 18.1 9.6 15.9 19.8c-5 22.3-14.6 42.7-27.7 60.2c-13.4-10-30-16-47.9-16c-44.2 0-80 35.8-80 80c-74.3 0-139.5-51.6-155.6-124.2z',
    ],
  ],
};
const faGaveDandy = faFaceAwesome;
const faDialOff = {
  prefix: 'fad',
  iconName: 'dial-off',
  icon: [
    576,
    512,
    [],
    'e162',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M312 446.2c77-11.6 136-78 136-158.2c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 80.2 59 146.6 136 158.2L264 288c0-13.3 10.7-24 24-24s24 10.7 24 24l0 158.2z',
    ],
  ],
};
const faToggleOff = {
  prefix: 'fad',
  iconName: 'toggle-off',
  icon: [
    576,
    512,
    [],
    'f204',
    [
      'M0 256C0 362 86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256zm64 0c0-70.7 57.3-128 128-128l192 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-192 0c-70.7 0-128-57.3-128-128z',
      'M96 256a96 96 0 1 0 192 0A96 96 0 1 0 96 256z',
    ],
  ],
};
const faFaceSmileHorns = {
  prefix: 'fad',
  iconName: 'face-smile-horns',
  icon: [
    640,
    512,
    [],
    'e391',
    [
      'M64 256c0-24.6 3.5-48.4 9.9-70.9C89.5 131 122.4 84.3 166.2 51.3C209.1 19.1 262.3 0 320 0s110.9 19.1 153.8 51.3c43.8 33 76.7 79.7 92.3 133.8c6.5 22.5 9.9 46.3 9.9 70.9c0 141.4-114.6 256-256 256S64 397.4 64 256zm112.8-37.1c-2.8 8.4 1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1zm27.1 151.5c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 370.2 363.4 392 320 392s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6zM336.8 261.1c2.8 8.4 11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2z',
      'M566.1 185.1C550.5 131 517.6 84.3 473.8 51.3c17-3.3 39.7-8.6 63-15.5c29.8-8.9 59.1-20.2 78.4-33.1c5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166zM103.3 35.8c23.3 7 46 12.2 63 15.5c-43.8 33-76.7 79.7-92.3 133.8C29.6 125.8 6.5 50.1 .3 19.1C-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1zM240.4 304c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8z',
    ],
  ],
};
const faBoxArchive = {
  prefix: 'fad',
  iconName: 'box-archive',
  icon: [
    512,
    512,
    ['archive'],
    'f187',
    [
      'M32 128l0 288c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-288L32 128zm128 96c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32z',
      'M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64z',
    ],
  ],
};
const faArchive = faBoxArchive;
const faGrapes = {
  prefix: 'fad',
  iconName: 'grapes',
  icon: [
    512,
    512,
    [],
    'e306',
    [
      'M320 72c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 32-8 40-8 40s8-8 40-8c35.7 0 62.6 17.7 74 26.8c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80z',
      'M248 208a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-80-32A56 56 0 1 0 56 176a56 56 0 1 0 112 0zM88 368a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM56 512a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm144-32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM224 344a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z',
    ],
  ],
};
const faPersonDrowning = {
  prefix: 'fad',
  iconName: 'person-drowning',
  icon: [
    576,
    512,
    [],
    'e545',
    [
      'M.8 455.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-5.9-5-13.3-7.6-20.7-7.6c-6.5 0-12.9 2-18.5 5.9C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1C109 386 102.5 384 96 384c-7.4 0-14.8 2.6-20.7 7.6c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4z',
      'M160 32c17.7 0 32 14.3 32 32l0 32.2c0 52.7 34.1 99.3 84.3 115.3c40 12.7 82.7 14.5 123.7 5.2l105-23.9c17.2-3.9 34.4 6.9 38.3 24.1s-6.9 34.4-24.1 38.3l-105 23.9c-10.6 2.4-21.2 4.2-31.9 5.5l-17.7 97.6c-13.6-3.2-27.3-9.4-39.7-18c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-7.3 0-15-1.2-22.8-3.3l21-146.7C151.5 200.1 128 150.2 128 96.2L128 64c0-17.7 14.3-32 32-32zm96 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
    ],
  ],
};
const faDialMax = {
  prefix: 'fad',
  iconName: 'dial-max',
  icon: [
    576,
    512,
    [],
    'e15e',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M417.1 382.8c46.2-62.6 41-151.3-15.7-208c-62.5-62.5-163.8-62.5-226.3 0s-62.5 163.8 0 226.3c56.7 56.7 145.4 62 208 15.7L271.3 304.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L417.1 382.8z',
    ],
  ],
};
const faCircleM = {
  prefix: 'fad',
  iconName: 'circle-m',
  icon: [
    512,
    512,
    [],
    'e115',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 152c0-10.4 6.7-19.6 16.6-22.8c2.4-.8 4.9-1.2 7.4-1.2c7.6 0 14.9 3.6 19.5 9.9c28.2 39 56.4 78 84.5 117.1c28.2-39 56.4-78 84.5-117.1c4.6-6.4 11.9-10 19.5-9.9c2.5 0 4.9 .4 7.4 1.2c9.9 3.2 16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8c-20.2 27.9-40.4 55.9-60.5 83.8c-4.5 6.2-11.7 10-19.5 9.9s-14.9-3.7-19.5-9.9c-20.2-27.9-40.4-55.9-60.5-83.8L176 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z',
      'M144.6 129.2c9.9-3.2 20.7 .3 26.8 8.8L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2 176 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.4 6.7-19.6 16.6-22.8z',
    ],
  ],
};
const faCalendarImage = {
  prefix: 'fad',
  iconName: 'calendar-image',
  icon: [
    448,
    512,
    [],
    'e0d4',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm96 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm3.8 134.2c-8.1 10.5-.6 25.8 12.7 25.8l226.4 0c12.6 0 20.3-13.9 13.5-24.6L268.9 292.3c-6.1-9.7-20.1-9.9-26.7-.5L184 376l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2L99.8 422.2z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM99.8 422.2c-8.1 10.5-.6 25.8 12.7 25.8l226.4 0c12.6 0 20.3-13.9 13.5-24.6L268.9 292.3c-6.1-9.7-20.1-9.9-26.7-.5L184 376l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2L99.8 422.2z',
    ],
  ],
};
const faCircleCaretDown = {
  prefix: 'fad',
  iconName: 'circle-caret-down',
  icon: [
    512,
    512,
    ['caret-circle-down'],
    'f32d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-24c0-3.2 .7-6.5 2-9.6c3.8-8.7 12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4c1.3 3.1 2 6.3 2 9.6c0 5.9-2.2 11.8-6.4 16.3l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-4.2-4.5-6.4-10.4-6.4-16.3z',
      'M273.6 360.3c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112z',
    ],
  ],
};
const faCaretCircleDown = faCircleCaretDown;
const faArrowDown91 = {
  prefix: 'fad',
  iconName: 'arrow-down-9-1',
  icon: [
    576,
    512,
    ['sort-numeric-desc', 'sort-numeric-down-alt'],
    'f886',
    [
      'M344 120c0 39.2 25.6 72.4 61.1 83.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88zm8 328c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32zM464 120a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortNumericDesc = faArrowDown91;
const faSortNumericDownAlt = faArrowDown91;
const faFaceGrinTongueSquint = {
  prefix: 'fad',
  iconName: 'face-grin-tongue-squint',
  icon: [
    512,
    512,
    [128541, 'grin-tongue-squint'],
    'f58a',
    [
      'M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-6.9 5.7-11.9 11.9-11.9c1.9 0 3.8 .4 5.6 1.4c30 16 59.9 32 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8c-30 16-59.9 32-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6c12-14.4 24-28.8 36-43.2c-12-14.4-24-28.8-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm172.6 37.4c30-16 59.9-32 89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6c-12 14.4-24 28.8-36 43.2c12 14.4 24 28.8 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5c-30-16-59.9-32-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8z',
      'M133.5 130.7c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zm245 0l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM320 448l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z',
    ],
  ],
};
const faGrinTongueSquint = faFaceGrinTongueSquint;
const faShishKebab = {
  prefix: 'fad',
  iconName: 'shish-kebab',
  icon: [
    512,
    512,
    [],
    'f821',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l59-59c-15.1-15.1-30.2-30.2-45.3-45.3l-59 59C3.1 463.6 0 471.8 0 480zM166.3 300.4c15.1 15.1 30.2 30.2 45.3 45.3l30.1-30.1c-15.1-15.1-30.2-30.2-45.3-45.3l-30.1 30.1zm128-128c15.1 15.1 30.2 30.2 45.3 45.3l48.1-48.1c16.2-16.2 14.1-39.7 3-53.9c-9.8-12.5-8.8-30.7 2.7-42.2c12.5-12.5 32.8-12.5 45.3 0c10.4 10.4 12.2 26.4 5.1 38.6c-8.8 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c8.6-14.8 12.8-31.4 12.8-48c0-24.6-9.4-49.1-28.1-67.9c-37.5-37.5-98.3-37.5-135.8 0c-29.6 29.6-35.8 73.6-18.8 109.3l-35 35z',
      'M203.7 138.3l-41.4 41.4c-15.6 15.6-15.6 40.9 0 56.6L275.7 349.7c15.6 15.6 40.9 15.6 56.6 0l41.4-41.4c15.6-15.6 15.6-40.9 0-56.6L260.3 138.3c-15.6-15.6-40.9-15.6-56.6 0zm-71.4 128c-15.6-15.6-40.9-15.6-56.6 0L34.3 307.7c-15.6 15.6-15.6 40.9 0 56.6L147.7 477.7c15.6 15.6 40.9 15.6 56.6 0l41.4-41.4c15.6-15.6 15.6-40.9 0-56.6L132.3 266.3z',
    ],
  ],
};
const faSprayCan = {
  prefix: 'fad',
  iconName: 'spray-can',
  icon: [
    512,
    512,
    [],
    'f5bd',
    [
      'M80 336a80 80 0 1 0 160 0A80 80 0 1 0 80 336zM256 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M128 0l64 0c17.7 0 32 14.3 32 32l0 96L96 128l0-96c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 208c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0z',
    ],
  ],
};
const faAlarmSnooze = {
  prefix: 'fad',
  iconName: 'alarm-snooze',
  icon: [
    512,
    512,
    [],
    'f845',
    [
      'M32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4C35.1 463.6 32 471.8 32 480s3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zm144-72c0-13.3 10.7-24 24-24l112 0c9.2 0 17.5 5.2 21.6 13.5s3 18-2.6 25.3L249.1 336l62.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L262.9 240 200 240c-13.3 0-24-10.7-24-24z',
      'M14.9 146.4L160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1zm482.3 0C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l62.9 0L181.1 345.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-62.9 0 81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5l-112 0z',
    ],
  ],
};
const faScarecrow = {
  prefix: 'fad',
  iconName: 'scarecrow',
  icon: [
    448,
    512,
    [],
    'f70d',
    [
      'M128 96c0 11.2 1.9 22 5.5 32c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM192 400.1l0 79.9c0 17.7 14.3 32 32 32s32-14.3 32-32l0-79.9-24.1 13.8c-2.5 1.4-5.2 2.1-7.9 2.1s-5.5-.7-7.9-2.1c-8-4.6-16-9.2-24.1-13.8zM272 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M133.5 128L32 128c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l7.6 11.4L6.4 179.2C2.4 182.2 0 187 0 192s2.4 9.8 6.4 12.8l19.9 14.9-7.6 11.4c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l73 0c10.1 0 17.7 9.2 15.7 19.1L96.3 396.9c-1.2 6.2 1.2 12.5 6.3 16.1s11.8 4 17.3 .9L160.1 391c4.9-2.8 11-2.8 15.9 0l40.1 22.9c4.9 2.8 11 2.8 15.9 0L272.1 391c4.9-2.8 11-2.8 15.9 0l40.1 22.9c5.4 3.1 12.2 2.8 17.3-.9s7.6-10 6.3-16.1L327.3 275.1c-2-9.9 5.6-19.1 15.7-19.1l73 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-7.6-11.4 19.9-14.9c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-19.9-14.9 7.6-11.4c3.3-4.9 3.6-11.2 .8-16.4s-8.2-8.5-14.1-8.5l-101.5 0c-13.2 37.3-48.7 64-90.5 64s-77.4-26.7-90.5-64z',
    ],
  ],
};
const faTruckMonster = {
  prefix: 'fad',
  iconName: 'truck-monster',
  icon: [
    640,
    512,
    [],
    'f63b',
    [
      'M32 384c0 13.4 8.3 24.9 20 29.7c2.5 9.1 6.1 17.7 10.7 25.7C57.7 451 60 465 69.5 474.5s23.5 11.8 35.1 6.9c8 4.6 16.6 8.2 25.7 10.7c4.8 11.7 16.2 20 29.7 20s24.9-8.3 29.7-20c9.1-2.5 17.7-6.1 25.7-10.7c11.6 4.9 25.6 2.6 35.1-6.8s11.8-23.5 6.8-35.1c4.6-8 8.2-16.6 10.7-25.7c11.7-4.8 20-16.2 20-29.7s-8.3-24.9-20-29.7c-2.5-9.1-6.1-17.7-10.7-25.7c4.9-11.6 2.6-25.6-6.8-35.1s-23.5-11.8-35.1-6.8c-8-4.6-16.6-8.2-25.7-10.7c-4.8-11.7-16.2-20-29.7-20s-24.9 8.3-29.7 20c-9.1 2.5-17.7 6.1-25.7 10.7C93 281.7 79 284 69.5 293.5S57.7 317 62.6 328.6c-4.6 8-8.2 16.6-10.7 25.7c-11.7 4.8-20 16.2-20 29.7zm176 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm144 0c0 13.4 8.3 24.9 20 29.7c2.5 9.1 6.1 17.7 10.7 25.7c-4.9 11.6-2.6 25.6 6.8 35.1s23.5 11.8 35.1 6.9c8 4.6 16.6 8.2 25.7 10.7c4.8 11.7 16.2 20 29.7 20s24.9-8.3 29.7-20c9.1-2.5 17.7-6.1 25.7-10.7c11.6 4.9 25.6 2.6 35.1-6.8s11.8-23.5 6.9-35.1c4.6-8 8.2-16.6 10.7-25.7c11.7-4.8 20-16.2 20-29.7s-8.3-24.9-20-29.7c-2.5-9.1-6.1-17.7-10.7-25.7c4.9-11.6 2.6-25.6-6.9-35.1s-23.5-11.8-35.1-6.8c-8-4.6-16.6-8.2-25.7-10.7c-4.8-11.7-16.2-20-29.7-20s-24.9 8.3-29.7 20c-9.1 2.5-17.7 6.1-25.7 10.7c-11.6-4.9-25.6-2.6-35.1 6.8s-11.8 23.5-6.8 35.1c-4.6 8-8.2 16.6-10.7 25.7c-11.7 4.8-20 16.2-20 29.7zm176 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M288 64l0 64 128 0L368 64l-80 0zM419.2 25.6L496 128l80 0c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64l-64 0c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l160 0 0-80c0-26.5 21.5-48 48-48l96 0c20.1 0 39.1 9.5 51.2 25.6z',
    ],
  ],
};
const faGiftCard = {
  prefix: 'fad',
  iconName: 'gift-card',
  icon: [
    576,
    512,
    [],
    'f663',
    [
      'M0 192L0 320l576 0 0-128c0-35.3-28.7-64-64-64l-41.6 0c-14.6 28.5-44.2 48-78.4 48l-59.4 0 53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176 184 176c-1.1 0-2.1 0-3.2-.1s-2.1-.1-3.2-.2c-2.1-.1-4.2-.4-6.2-.7c-4.1-.6-8.1-1.5-12-2.6c-7.8-2.3-15.2-5.6-21.9-9.8c-13.5-8.4-24.6-20.4-31.8-34.7L64 128c-35.3 0-64 28.7-64 64zM0 416l0 32c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-32L0 416z',
      'M186.2 48L184 48c-22.1 0-40 17.9-40 40s17.9 40 40 40l73.3 0L222.5 68.8C214.9 55.9 201.1 48 186.2 48zm57.3 128L184 176c-48.6 0-88-39.4-88-88s39.4-88 88-88l2.2 0c31.9 0 61.5 16.9 77.7 44.4l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0L392 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-59.4 0 53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176zM392 128c22.1 0 40-17.9 40-40s-17.9-40-40-40l-2.2 0c-14.9 0-28.8 7.9-36.3 20.8L318.7 128l1.3 0 72 0zM576 416L0 416l0-96 576 0 0 96z',
    ],
  ],
};
const faW = {
  prefix: 'fad',
  iconName: 'w',
  icon: [
    576,
    512,
    [119],
    '57',
    [
      'M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z',
      '',
    ],
  ],
};
const faCodePullRequestDraft = {
  prefix: 'fad',
  iconName: 'code-pull-request-draft',
  icon: [
    448,
    512,
    [],
    'e3fa',
    [
      'M48 153.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3c1.4 .1 2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7l0 205.3c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7l0-205.3zM416 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0 160a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zm0 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm264-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faSquareB = {
  prefix: 'fad',
  iconName: 'square-b',
  icon: [
    448,
    512,
    [],
    'e264',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76l-108 0c-13.3 0-24-10.7-24-24l0-104 0-104zm48 24l0 56 68 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-68 0zm0 104l0 56 84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0z',
      'M152 128c-13.3 0-24 10.7-24 24l0 104 0 104c0 13.3 10.7 24 24 24l108 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76l-92 0zm92 104l-68 0 0-56 68 0c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-68 48l68 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-84 0 0-56z',
    ],
  ],
};
const faElephant = {
  prefix: 'fad',
  iconName: 'elephant',
  icon: [
    640,
    512,
    [128024],
    'f6da',
    [
      'M0 360c0 7.3 3.3 14.5 9.6 19.2c10.6 8 25.6 5.8 33.6-4.8l12.1-16.2c3.2-4.3 6.1-8.8 8.7-13.5L64 480c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-70c15.3 3.9 31.4 6 48 6s32.7-2.1 48-6l0 70c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-139.3c-5.1-5.8-9.7-12-13.7-18.7c-1.6-2.6-2.3-5.4-2.3-8.2c0-5.4 2.8-10.7 7.7-13.7c7.6-4.6 17.4-2.1 22 5.4C446.5 333.4 477.1 352 512 352c1.4 0 2.8 0 4.2-.1s2.8-.1 4.1-.3c2.7-.2 5.5-.6 8.1-1c5.3-.9 10.5-2.3 15.5-4.1L544 192c0-88.4-71.6-160-160-160l-1.6 0C362.2 12.2 334.5 0 304 0C242.1 0 192 50.1 192 112s50.1 112 112 112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144-64.5-144-144c0-25.3 6.5-49.1 18-69.8c-20.5 7-39.4 17.3-56.1 30.4C67.4 111.9 32 175.8 32 248l0 19c0 12.4-1.2 24.7-3.7 36.9c-1.9 9.3-5.8 18-11.4 25.6L4.8 345.6C1.6 349.9 0 355 0 360zM480 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 172l0 18.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4l0-18.6c-10.2 2.6-21 4-32 4c-1.4 0-2.8 0-4.1-.1s-2.7-.1-4.1-.2c-2.7-.2-5.4-.4-8.1-.8c-5.3-.7-10.6-1.7-15.7-3z',
      'M464 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-34.3 81.5c-4.6-7.6-14.4-10-22-5.4s-10 14.4-5.4 22c22.4 37.1 63.1 62 109.7 62c35.8 0 68.2-14.7 91.4-38.4c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2C563.1 341 538.9 352 512 352c-34.9 0-65.5-18.6-82.3-46.5z',
    ],
  ],
};
const faEarthAfrica = {
  prefix: 'fad',
  iconName: 'earth-africa',
  icon: [
    512,
    512,
    [127757, 'globe-africa'],
    'f57c',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.1-2.8-43.5-8.1-64c-25.5 0-50.9 0-76.4 0c-7.1 0-13.5 4-16.7 10.3c-6.2 12.4-20.7 18.4-33.9 14c-4.2-1.4-8.3-2.8-12.5-4.2c-7.7-2.6-16.1-.6-21.8 5.1c-3.7 3.7-3.7 9.7 0 13.4c11.2 11.2 22.3 22.3 33.5 33.5c.6 .6 1.2 1.3 1.8 2s1.1 1.4 1.6 2.1c1 1.5 1.8 3 2.5 4.6c.7 1.6 1.2 3.3 1.5 5c.2 .9 .3 1.7 .4 2.6c.1 .9 .1 1.7 .1 2.2l0 .4c0 .2 0 .3 0 .4c0 .4 0 1.1-.1 1.8c-.1 .8-.2 1.5-.3 2.2c-.3 1.5-.6 2.9-1.1 4.3c-1 2.8-2.4 5.3-4.2 7.6c-3.6 4.6-8.7 8-14.6 9.5c-1.8 .4-3.5 .9-5.3 1.3c-3.8 .9-6.4 4.3-6.4 8.2c0 4 0 8 0 12.1c0 .1 0 .2 0 .3c0 .7 0 1.4 0 2.2l0 .4c0 .6-.1 1.3-.1 2.1c-.2 1.9-.4 3.6-.6 5.3c-.6 3.4-1.4 6.7-2.5 10c-2.2 6.5-5.4 12.6-9.5 18.2c-8.5 11.4-17.1 22.8-25.6 34.1c-6 8.1-15.5 12.8-25.6 12.8c-17.7 0-32-14.3-32-32c0-16 0-32 0-48c0-.1 0-.3 0-.4c0-.3 0-.7-.1-1.2c-.1-.6-.1-1.1-.2-1.6c-.2-1-.5-2-.9-3c-.8-1.9-2-3.6-3.4-5.1c-2.9-2.9-6.9-4.7-11.3-4.7l-32 0c-26.5 0-48-21.5-48-48c0-9.3 0-18.7 0-28c0-12.6 5.9-24.4 16-32l39.4-29.5c5.6-4.2 12.4-6.5 19.4-6.5c3.5 0 6.9 .6 10.2 1.7l32 10.7c7.2 2.4 15 2.7 22.4 .9c11.8-2.9 23.6-5.9 35.4-8.8c.7-.2 1.3-.4 1.8-.5c.7-.2 1.3-.5 1.8-.7c1.2-.5 2.3-1.1 3.3-1.8c2.1-1.4 4-3.1 5.5-5s2.7-4.2 3.6-6.5c.4-1.2 .7-2.4 .9-3.7c.1-.7 .2-1.3 .2-1.9c0-.6 .1-1.2 .1-1.5l0-.4c0-.1 0-.3 0-.4c0-.2 0-.7-.1-1.2c0-.5-.1-1.1-.2-1.6c-.2-1.1-.4-2.1-.7-3.1c-.6-2-1.4-3.9-2.5-5.7c-2.2-3.5-5.4-6.5-9.2-8.4l-29.2-14.6c-3.7-1.8-8.1-1.1-11 1.8c-1.3 1.3-2.6 2.6-3.9 3.9c-4.6 4.6-10.9 7.2-17.4 7.2c-3.8 0-7.6-.9-11-2.6c-5.1-2.5-10.2-5.1-15.2-7.6c-6.8-3.4-14.9-1.6-19.7 4.3c-4.5 5.7-9.1 11.3-13.6 17c-5.5 6.9-15.8 7.4-22 1.2c-2.8-2.8-4.3-6.5-4.3-10.4c0-13.2 0-26.3 0-39.5c0-.9 0-1.7-.1-2.5c-.1-.8-.2-1.7-.3-2.5c-.3-1.7-.7-3.3-1.2-4.9c-1-3.2-2.6-6.2-4.6-8.9C172.6 61.3 159.3 43 146 24.8C59.7 65.9 0 154 0 256z',
      'M146 24.8l39.9 54.8c4 5.5 6.1 12.1 6.1 18.8l0 39.5c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32l0 28c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16l0 48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4l0-12.1c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l12.5 4.2c13.2 4.4 27.6-1.6 33.9-14c3.2-6.3 9.6-10.3 16.7-10.3l76.4 0C475.5 81.6 375.3 0 256 0c-39.4 0-76.7 8.9-110 24.8z',
    ],
  ],
};
const faGlobeAfrica = faEarthAfrica;
const faRainbow = {
  prefix: 'fad',
  iconName: 'rainbow',
  icon: [
    640,
    512,
    [127752],
    'f75b',
    [
      'M96 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-88.4 71.6-160 160-160s160 71.6 160 160l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-123.7-100.3-224-224-224S96 228.3 96 352z',
      'M64 352C64 210.6 178.6 96 320 96s256 114.6 256 256l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96C640 175.3 496.7 32 320 32S0 175.3 0 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96z',
    ],
  ],
};
const faCircleNotch = {
  prefix: 'fad',
  iconName: 'circle-notch',
  icon: [
    512,
    512,
    [],
    'f1ce',
    [
      'M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z',
      '',
    ],
  ],
};
const faTabletScreenButton = {
  prefix: 'fad',
  iconName: 'tablet-screen-button',
  icon: [
    448,
    512,
    ['tablet-alt'],
    'f3fa',
    [
      'M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 0l0 320 320 0 0-320L64 64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M64 64H384V384H64V64z',
    ],
  ],
};
const faTabletAlt = faTabletScreenButton;
const faPaw = {
  prefix: 'fad',
  iconName: 'paw',
  icon: [
    512,
    512,
    [],
    'f1b0',
    [
      'M0 208.4c0 13.2 3.8 27.6 11.6 41.1c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3C7.5 173.5 0 189.8 0 208.4zm109.5-77.2c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8S174.4 23.8 142.1 34.3s-46.9 53.9-32.6 96.8zm168-38.3c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9zM411.6 198.6c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.8-13.5 11.6-27.8 11.6-41.1c0-18.6-7.5-34.9-21.8-43.1c-24.5-14-59.7 .9-78.5 33.3z',
      'M69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5z',
    ],
  ],
};
const faMessageQuestion = {
  prefix: 'fad',
  iconName: 'message-question',
  icon: [
    512,
    512,
    [],
    'e1e3',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm169.4 54.5c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6c.1-.2 .1-.4 .2-.6c1.4-3.9 4.4-5.9 7.8-5.9l58.3 0c4.2 0 8 1.7 10.7 4.4c1.4 1.4 2.5 3 3.2 4.8c.4 .9 .7 1.9 .9 2.8c.1 .5 .2 1 .2 1.5s.1 1 .1 1.5c0 .5 0 .8 0 1.1s-.1 .7-.1 1c-.1 .7-.2 1.3-.4 2c-.3 1.3-.9 2.5-1.5 3.6c-1.3 2.3-3.2 4.2-5.6 5.5c-14.8 8.5-29.6 17-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8c0 4.5 0 9 0 13.5c0 13.3 10.7 24 24 24c6.6 0 12.5-2.6 16.8-6.9c2.2-2.1 3.9-4.7 5.2-7.5c.6-1.4 1.1-2.9 1.4-4.4c.2-.8 .3-1.6 .4-2.3s.1-1.6 .2-2.3c10.8-6.3 21.5-12.5 32.3-18.6c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3c-.1 .4-.3 .8-.4 1.2zM224 304c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4c2.9-2.9 5.2-6.3 6.9-10.2c.8-1.9 1.4-3.9 1.9-6c.2-1 .4-2.1 .5-3.2c.1-.6 .1-1.1 .1-1.6c0-.5 0-1 0-1.5c0-.8 0-1.3 0-1.8s-.1-1.1-.1-1.6c-.1-1.1-.3-2.1-.5-3.2c-.4-2.1-1.1-4.1-1.9-6c-1.6-3.8-4-7.3-6.9-10.2c-5.8-5.8-13.8-9.4-22.6-9.4c-17.7 0-32 14.3-32 32z',
      'M222.6 80c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faCloud = {
  prefix: 'fad',
  iconName: 'cloud',
  icon: [
    640,
    512,
    [9729],
    'f0c2',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z',
      '',
    ],
  ],
};
const faTrowelBricks = {
  prefix: 'fad',
  iconName: 'trowel-bricks',
  icon: [
    512,
    512,
    [],
    'e58a',
    [
      'M0 416c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-64zm192 0c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-64zm96-160c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64z',
      'M256 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2l0-72 89 0c3.6 13.8 16.1 24 31 24l88 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-88 0c-14.9 0-27.4 10.2-31 24l-89 0 0-72z',
    ],
  ],
};
const faSquare3 = {
  prefix: 'fad',
  iconName: 'square-3',
  icon: [
    448,
    512,
    [],
    'e258',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4c-16.9 15.5-33.8 31-50.8 46.5c21 2.4 39.6 12.5 53 27.4c6.7 7.5 12.1 16.1 15.8 25.6c1.9 4.7 3.3 9.7 4.3 14.8c.5 2.6 .9 5.2 1.1 7.8c.1 1.3 .2 2.6 .3 4c.1 1.4 .1 2.7 .1 4.1c0 1.5 0 2.9-.1 4.4c-.1 1.4-.2 2.8-.3 4.3c-.3 2.8-.7 5.6-1.3 8.3c-1.1 5.5-2.8 10.8-4.9 15.8c-4.3 10.1-10.4 19.1-18 26.7c-15.2 15.2-36.3 24.6-59.5 24.6L208 384c-30.1 0-58.1-15.6-73.9-41.2c-.9-1.4-1.7-2.8-2.6-4.2c-2.4-3.9-3.6-8.3-3.6-12.6c0-8 4-15.9 11.4-20.4c11.3-7 26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c10 0 19-4 25.6-10.6c3.3-3.3 5.9-7.2 7.7-11.5c.9-2.2 1.6-4.4 2.1-6.8c.2-1.2 .4-2.4 .5-3.6c.1-.6 .1-1.2 .1-1.8s0-1.2 0-2c0-.7 0-1.2 0-1.8c0-.6-.1-1.2-.1-1.8c-.1-1.2-.3-2.4-.6-3.6c-.5-2.4-1.2-4.6-2.1-6.8c-1.8-4.3-4.5-8.2-7.8-11.5c-6.6-6.5-15.7-10.6-25.7-10.5l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5c16.8-15.4 33.7-30.9 50.5-46.3L152 176c-13.3 0-24-10.7-24-24z',
      'M128 152c0-13.3 10.7-24 24-24l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.1 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L208 384c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176 152 176c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faFaceFlushed = {
  prefix: 'fad',
  iconName: 'face-flushed',
  icon: [
    512,
    512,
    [128563, 'flushed'],
    'f579',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232-32A72 72 0 1 1 88 224a72 72 0 1 1 144 0zM176 384c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM424 224a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z',
      'M160 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faFlushed = faFaceFlushed;
const faHospitalUser = {
  prefix: 'fad',
  iconName: 'hospital-user',
  icon: [
    576,
    512,
    [],
    'f80d',
    [
      'M0 48C0 21.5 21.5 0 48 0L272 0c26.5 0 48 21.5 48 48l0 223.8 0 95.9c-38.2 21.4-64 62.3-64 109.2c0 12.9 3.6 24.9 9.9 35.1L48 512c-26.5 0-48-21.5-48-48l0-80 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 352l0-64 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 256 0 48zm96 72l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16z',
      'M432 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-50.9 32c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0z',
    ],
  ],
};
const faMicrowave = {
  prefix: 'fad',
  iconName: 'microwave',
  icon: [
    576,
    512,
    [],
    'e01b',
    [
      'M96 152l0 176c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24z',
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l-320 0c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64L0 96zm96 56l0 176c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faChfSign = {
  prefix: 'fad',
  iconName: 'chf-sign',
  icon: [
    640,
    512,
    [],
    'e602',
    [
      'M192 64l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 96 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160-96 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M0 113.4C0 68.5 36.5 32 81.4 32c30.8 0 59 17.4 72.8 45l2.3 4.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L97 105.6c-3-5.9-9-9.6-15.6-9.6C71.8 96 64 103.8 64 113.4l0 285.1c0 9.6 7.8 17.4 17.4 17.4c6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45C36.5 480 0 443.5 0 398.6L0 113.4zM448 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 128 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384z',
    ],
  ],
};
const faTentArrowLeftRight = {
  prefix: 'fad',
  iconName: 'tent-arrow-left-right',
  icon: [
    576,
    512,
    [],
    'e57f',
    [
      'M64.4 475.3c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-5.7-4.4-12.6-6.5-19.4-6.5s-13.7 2.2-19.4 6.5l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160z',
      'M454.2 7.9c8.9-9.9 24-10.7 33.9-1.8l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-9.9 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9L489.5 120 86.5 120l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72C2.9 109.3 0 102.8 0 96s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8s8.1 25-1.8 33.9L86.5 72l402.9 0L455.9 41.8c-9.9-8.9-10.7-24-1.8-33.9z',
    ],
  ],
};
const faCartCircleArrowUp = {
  prefix: 'fad',
  iconName: 'cart-circle-arrow-up',
  icon: [
    640,
    512,
    [],
    'e3f0',
    [
      'M0 24C0 37.3 10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.3-39.9-40-39.9l-411 0C111 12.8 91.6 0 69.5 0L24 0C10.7 0 0 10.7 0 24zM128 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 348.7l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z',
    ],
  ],
};
const faTrashClock = {
  prefix: 'fad',
  iconName: 'trash-clock',
  icon: [
    576,
    512,
    [],
    'e2b0',
    [
      'M32 96L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2l229.5 0C285.6 480.1 256 427.5 256 368c0-89.9 67.4-164 154.4-174.7L416 96 32 96z',
      'M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faReflectBoth = {
  prefix: 'fad',
  iconName: 'reflect-both',
  icon: [
    512,
    512,
    [],
    'e66f',
    [
      'M0 128L0 384c0 12.9 7.8 24.6 19.8 29.6c4 1.6 8.1 2.4 12.2 2.4c8.3 0 16.5-3.3 22.6-9.4l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9S0 115.1 0 128zM329.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c6.1 6.1 14.3 9.4 22.6 9.4c4.1 0 8.3-.8 12.2-2.4c12-5 19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z',
      'M413.6 19.8C408.6 7.8 396.9 0 384 0L128 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9zM384 512c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0z',
    ],
  ],
};
const faGavel = {
  prefix: 'fad',
  iconName: 'gavel',
  icon: [
    512,
    512,
    ['legal'],
    'f0e3',
    [
      'M0 432c0 8.2 3.1 16.4 9.4 22.6l48 48c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4 81.4-81.4c-15.1-15.1-30.2-30.2-45.3-45.3L168 298.7l-1.4-1.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112C3.1 415.6 0 423.8 0 432z',
      'M273.4 9.4c12.5-12.5 32.8-12.5 45.3 0l16 16c12.5 12.5 12.5 32.8 0 45.3l-4 4L437.4 181.4l4-4c12.5-12.5 32.8-12.5 45.3 0l16 16c12.5 12.5 12.5 32.8 0 45.3l-120 120c-12.5 12.5-32.8 12.5-45.3 0l-16-16c-12.5-12.5-12.5-32.8 0-45.3l4-4L218.6 186.6l-4 4c-12.5 12.5-32.8 12.5-45.3 0l-16-16c-12.5-12.5-12.5-32.8 0-45.3l120-120z',
    ],
  ],
};
const faLegal = faGavel;
const faSprinklerCeiling = {
  prefix: 'fad',
  iconName: 'sprinkler-ceiling',
  icon: [
    384,
    512,
    [],
    'e44c',
    [
      'M0 472a24 24 0 1 0 48 0A24 24 0 1 0 0 472zm64-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm56-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm56-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M0 96c0 15.3 10.8 28.4 25.7 31.4L128 147.8l0-65.3L64 69.8 64 0 0 0 0 96zm256 51.8l102.3-20.5c15-3 25.7-16.1 25.7-31.4l0-96L320 0l0 69.8L256 82.6l0 65.3zM224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-128z',
    ],
  ],
};
const faBrowsers = {
  prefix: 'fad',
  iconName: 'browsers',
  icon: [
    576,
    512,
    [],
    'e0cb',
    [
      'M96 192l480 0 0 160c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64l0-160zM224 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M160 0C124.7 0 96 28.7 96 64l0 128 480 0 0-128c0-35.3-28.7-64-64-64L160 0zm32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-256z',
    ],
  ],
};
const faTrillium = {
  prefix: 'fad',
  iconName: 'trillium',
  icon: [
    448,
    512,
    [],
    'e588',
    [
      'M-1.8 135.5c0-10.8 7.9-20.6 19.7-22.1c18.3-2.3 59.8-3.2 112.9 22.2c-.9 4-1.6 8.1-2.1 12.2c-.2 2-.4 4.1-.5 6.1c-.1 1-.1 2-.1 3.1s0 2 0 3.1c0 15.7 3.8 30.4 10.4 43.5c-16.3 0-32.7 4.2-47.8 12.9c-6.3 3.6-12.2 7.9-17.7 12.8C26.4 196.4 7 161 0 144.3c-1.2-2.9-1.8-5.9-1.8-8.9zM169 390.8c3-1.1 6-2.3 9-3.7c1.5-.7 2.9-1.4 4.3-2.1s2.8-1.5 4.2-2.3c16.6-9.6 29.2-23.3 37.4-39.2c8.1 15.8 20.8 29.6 37.4 39.2c5.6 3.2 11.5 5.9 17.7 8.2c-4.9 53.2-25.4 90.3-36 106.3c-9.1 13.7-28.8 13.7-37.9 0c-10.6-16-31.2-53.2-36-106.3zM309.6 203.5c6.6-13.1 10.4-27.8 10.4-43.5c0-8.2-1-16.3-2.8-24.4c53.1-25.4 94.6-24.5 112.9-22.2c11.7 1.5 19.7 11.3 19.7 22.1c0 2.9-.6 5.9-1.8 8.9c-7 16.7-26.4 52-73 84.9c-2.8-2.4-5.6-4.7-8.6-6.9c-1.5-1.1-3-2.1-4.5-3.1c-.8-.5-1.5-1-2.3-1.5s-1.6-.9-2.3-1.4c-15-8.7-31.5-12.8-47.7-12.9z',
      'M214.1 8.9C189.6 31.8 128 95.9 128 160c0 15.7 3.8 30.4 10.4 43.5c-16.3 0-32.7 4.2-47.8 12.9c-55.5 32-80.2 117.5-87.8 150.2c-1.8 7.5 2.5 14.9 9.9 17.1c32.1 9.7 118.4 31.1 173.9-1c16.6-9.6 29.2-23.3 37.4-39.2c8.1 15.8 20.8 29.6 37.4 39.2c55.5 32 141.8 10.7 173.9 1c7.4-2.2 11.6-9.6 9.9-17.1c-7.6-32.7-32.3-118.1-87.8-150.2c-15-8.7-31.5-12.8-47.7-12.9c6.6-13.1 10.4-27.8 10.4-43.5c0-64.1-61.6-128.2-86.1-151.1c-5.6-5.3-14.1-5.3-19.8 0zM224 200a40 40 0 1 1 0 80 40 40 0 1 1 0-80z',
    ],
  ],
};
const faTableCellsUnlock = {
  prefix: 'fad',
  iconName: 'table-cells-unlock',
  icon: [
    640,
    512,
    [],
    'e692',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 88 0 0-64L64 96zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM208 96l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM360 96l0 64 88 0 0-64-88 0z',
      'M528 240c-17.7 0-32 14.3-32 32l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faMusicSlash = {
  prefix: 'fad',
  iconName: 'music-slash',
  icon: [
    640,
    512,
    [],
    'f8d1',
    [
      'M64 432c0 44.2 43 80 96 80s96-35.8 96-80l0-134.3-64-50.4 0 109.3c-10-3-20.8-4.6-32-4.6c-53 0-96 35.8-96 80zM192.1 125.3c36.2 28.4 72.4 56.7 108.6 85.1L512 147l0 145.5c-10-2.9-20.8-4.6-32-4.6c-22.2 0-42.6 6.3-58.8 16.8c46.1 36.1 92.1 72.2 138.2 108.3C569.8 400.2 576 384.7 576 368l0-264 0-72c0-10.1-4.8-19.6-12.9-25.7C557.5 2.2 550.8 0 544 0c-3.1 0-6.2 .4-9.2 1.3l-320 96c-12.7 3.8-21.6 14.9-22.7 27.9z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTruckRamp = {
  prefix: 'fad',
  iconName: 'truck-ramp',
  icon: [
    640,
    512,
    [],
    'f4e0',
    [
      'M448 416a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M416.7 402.5C423.4 338.2 477.9 288 544 288c38.2 0 72.5 16.8 96 43.3L640 0 416 0c-35.3 0-64 28.7-64 64l0 289.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416.7 402.5z',
    ],
  ],
};
const faBinoculars = {
  prefix: 'fad',
  iconName: 'binoculars',
  icon: [
    512,
    512,
    [],
    'f1e5',
    [
      'M96 64l0 32 96 0 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zM224 96l0 160 64 0 0-160-64 0zm96-32l0 32 96 0 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z',
      'M192 448l0-192 32 0 0-160-32 0L93 96c-16.4 0-30.2 12.5-31.8 28.8l-9 89.7c-2.7 27.3-11.5 53.7-25.6 77.3C9.2 320.7 0 353.8 0 387.6L0 448c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32zm128 0c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-60.4c0-33.8-9.2-66.9-26.5-95.8c-14.1-23.6-22.9-49.9-25.6-77.3l-9-89.7C449.2 108.5 435.5 96 419 96l-99 0-32 0 0 160 32 0 0 192z',
    ],
  ],
};
const faMicrophoneSlash = {
  prefix: 'fad',
  iconName: 'microphone-slash',
  icon: [
    640,
    512,
    [],
    'f131',
    [
      'M144 216l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6zM224 96l0 54.3c61.3 48.1 122.7 96.1 184 144.2c5.2-11.8 8-24.8 8-38.5l0-160c0-53-43-96-96-96s-96 43-96 96zM433.8 314.7c12.8 10 25.5 20 38.3 30c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 21.2-5.1 41.1-14.2 58.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBoxTissue = {
  prefix: 'fad',
  iconName: 'box-tissue',
  icon: [
    512,
    512,
    [],
    'e05b',
    [
      'M0 272L0 384l512 0 0-112c0-26.5-21.5-48-48-48l-58.7 0L384 288l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-58.7 0-238.2 0L80 320c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0c-4.7-21.3-9.5-42.7-14.2-64L48 224c-26.5 0-48 21.5-48 48z',
      'M103.9 0L208 0c40 0 52 24 64 48s24 48 64 48l67.6 0c21.8 0 37.3 21.4 30.4 42.1L373.3 320l-238.2 0L72.7 38.9C68.2 19 83.4 0 103.9 0zM512 384l0 80c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-80 512 0z',
    ],
  ],
};
const faCircleC = {
  prefix: 'fad',
  iconName: 'circle-c',
  icon: [
    512,
    512,
    [],
    'e101',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-32.8 12.5-65.5 37.5-90.5s57.8-37.5 90.5-37.5s65.5 12.5 90.5 37.5c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-34 0l-.4-.4c-31.3-30.8-81.6-30.7-112.7 .4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-25 25-57.8 37.5-90.5 37.5s-65.5-12.5-90.5-37.5s-37.5-57.8-37.5-90.5z',
      'M312.6 199.4c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z',
    ],
  ],
};
const faStarChristmas = {
  prefix: 'fad',
  iconName: 'star-christmas',
  icon: [
    512,
    512,
    [],
    'f7d4',
    [
      'M64 88c0 6.1 2.3 12.3 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7s-7 10.8-7 17zm0 336c0 6.1 2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-4.7 4.7-7 10.8-7 17zM359 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17s-10.8-7-17-7s-12.3 2.3-17 7l-48 48zm0 240c-9.4 9.4-9.4 24.6 0 33.9l48 48c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7s7-10.8 7-17s-2.3-12.3-7-17l-48-48c-9.4-9.4-24.6-9.4-33.9 0z',
      'M192 320L15.5 275.9C6.4 273.6 0 265.4 0 256s6.4-17.6 15.5-19.9L192 192 236.1 15.5C238.4 6.4 246.6 0 256 0s17.6 6.4 19.9 15.5L320 192l176.5 44.1c9.1 2.3 15.5 10.5 15.5 19.9s-6.4 17.6-15.5 19.9L320 320 275.9 496.5c-2.3 9.1-10.5 15.5-19.9 15.5s-17.6-6.4-19.9-15.5L192 320z',
    ],
  ],
};
const faChartBullet = {
  prefix: 'fad',
  iconName: 'chart-bullet',
  icon: [
    512,
    512,
    [],
    'e0e1',
    [
      'M160 64l0 64 80 0 0-64-80 0zm0 96l0 64 80 0 0-64-80 0zm96 128l0 64 80 0 0-64-80 0zm0 96l0 64 80 0 0-64-80 0zM288 64l0 64 160 0 0 32-160 0 0 64 176 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L288 64zm96 224l0 64 64 0 0 32-64 0 0 64 80 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-80 0z',
      'M264 32c-13.3 0-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24zM48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l112 0 0-160L48 64zm0 224c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l208 0 0-160L48 288zm336-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176z',
    ],
  ],
};
const faMotorcycle = {
  prefix: 'fad',
  iconName: 'motorcycle',
  icon: [
    640,
    512,
    [127949],
    'f21c',
    [
      'M0 352c0-70.7 57.3-128 128-128c62.5 0 114.5 44.8 125.8 104l-66.4 0c-9.5-23.5-32.5-40-59.3-40c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l66.4 0C242.5 435.2 190.5 480 128 480C57.3 480 0 422.7 0 352zm384 0c0-40 18.4-75.7 47.1-99.2c10.5 19.5 21.1 38.9 31.6 58.4C453.5 322.3 448 336.5 448 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-2.4 0-4.8 .1-7.1 .4c-10.5-19.5-21.1-39-31.6-58.4c12.2-3.9 25.2-6 38.7-6c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128z',
      'M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l57.7 0 16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7L64 128c-17.7 0-32 14.3-32 32l0 32 96 0c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32l70.4 0c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l75.2 139.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5L418.2 128l61.8 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-20.4 0c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21L280 32zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faTreeChristmas = {
  prefix: 'fad',
  iconName: 'tree-christmas',
  icon: [
    448,
    512,
    [127876],
    'f7db',
    [
      'M0 487.1C0 500.9 11.1 512 24.9 512l398.3 0c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352l32.3 0c13.1 0 23.7-10.6 23.7-23.7c0-5.4-1.8-10.6-5.2-14.8L252.7 105.9c-.7 .3-1.4 .5-2.1 .8c-5.9 15.7-11.8 31.4-17.7 47.1c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2c-5.9-15.7-11.8-31.4-17.7-47.1c-.7-.3-1.4-.5-2.1-.8L29.2 313.5c-3.4 4.2-5.2 9.4-5.2 14.8C24 341.4 34.6 352 47.7 352L80 352 3.8 474c-2.5 4-3.8 8.5-3.8 13.2zM184 288a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 128c0-.4 0-.8 0 0z',
      'M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faTireFlat = {
  prefix: 'fad',
  iconName: 'tire-flat',
  icon: [
    512,
    512,
    [],
    'f632',
    [
      'M96 288c0 52.3 25.1 98.8 64 128c26.7 20.1 60 32 96 32c33.1 0 63.9-10.1 89.5-27.3c2.2-1.5 4.4-3.1 6.6-4.7c38.9-29.2 64-75.7 64-128c0-88.4-71.6-160-160-160s-160 71.6-160 160zm32 0c0-36.8 15.5-69.9 40.3-93.3l28.1 38.7 10.1 13.9c-9.1 11-14.5 25.2-14.5 40.6c0 1.4 0 2.7 .1 4l-61.8 20.1c-1.5-7.8-2.3-15.9-2.3-24.2zm12.2 54.6l61.9-20.1c8.6 13.4 22.1 23.4 37.9 27.5l0 65c-44.2-5.5-81.5-33.6-99.8-72.4zm54-166.7C212.5 165.8 233.6 160 256 160s43.5 5.8 61.8 15.9l-38.2 52.6c-7.3-2.9-15.3-4.5-23.6-4.5s-16.3 1.6-23.6 4.5l-10-13.8-28.1-38.8zM288 288a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-16.1 62c15.9-4.1 29.4-14.1 38-27.6l61.9 20.1c-18.3 38.8-55.6 66.9-99.8 72.4l0-65zm33.5-102.6l38.2-52.6C368.5 218.1 384 251.2 384 288c0 8.3-.8 16.3-2.3 24.2L319.9 292c.1-1.3 .1-2.7 .1-4c0-15.4-5.5-29.6-14.5-40.6z',
      'M0 288C0 146.6 114.6 32 256 32s256 114.6 256 256c0 47.3-12.8 91.7-35.2 129.7c20.3 5.6 35.2 24.2 35.2 46.3c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48c0-22.1 14.9-40.7 35.2-46.3C12.8 379.7 0 335.3 0 288zm416 0c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 52.3 25.1 98.8 64 128c26.7 20.1 60 32 96 32c33.1 0 63.9-10.1 89.5-27.3c2.2-1.5 4.4-3.1 6.6-4.7c38.9-29.2 64-75.7 64-128zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faSunglasses = {
  prefix: 'fad',
  iconName: 'sunglasses',
  icon: [
    576,
    512,
    [128374],
    'f892',
    [
      'M48.5 375.8C52.3 407.5 79.3 432 112 432l44.3 0c34 0 62-26.5 63.9-60.4c1.1-19.2 2.1-38.4 3.2-57.5c-9.8-4.2-20.1-7.7-30.5-10.4L48.5 375.8zM356 374c3.1 32.7 30.6 58 63.7 58l44.3 0c35.3 0 64-28.7 64-64l0-53.8c-9.9-4.3-20.3-7.9-31-10.7L356 374z',
      'M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6l0 5.2c0 .5 0 1 0 1.5l0 41.3c0 .2 0 .4 0 .6l0 15.4c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352l0 16c0 35.3 28.7 64 64 64l44.3 0c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2L48 352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5l44.3 0c35.3 0 64-28.7 64-64l0-53.8c-27.2-11.8-58.2-18.2-87.7-18.2z',
    ],
  ],
};
const faBadge = {
  prefix: 'fad',
  iconName: 'badge',
  icon: [
    512,
    512,
    [],
    'f335',
    [
      'M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z',
      '',
    ],
  ],
};
const faMessagePen = {
  prefix: 'fad',
  iconName: 'message-pen',
  icon: [
    512,
    512,
    ['comment-alt-edit', 'message-edit'],
    'f4a4',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM160 287.9c0 4.2 1.6 8.3 4.7 11.3s7.1 4.7 11.3 4.7c1.3 0 2.6-.2 3.9-.5c12.2-3.1 24.4-6.1 36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4c24-24 47.9-48 71.9-71.9L250 160.6c-24 24-47.9 48-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9c-3.1 12.2-6.1 24.4-9.2 36.7c-.3 1.3-.5 2.6-.5 3.9zM272.6 138c17.8 17.8 35.6 35.6 53.3 53.3c5-5 9.9-9.9 14.9-14.9c7.4-7.4 11-17 11-26.7s-3.7-19.3-11-26.7c-14.7-14.7-38.6-14.7-53.3 0c-5 5-9.9 9.9-14.9 14.9z',
      'M287.5 123L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3s-38.6-14.7-53.3 0zM250 160.6l-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6z',
    ],
  ],
};
const faCommentAltEdit = faMessagePen;
const faMessageEdit = faMessagePen;
const faBellConcierge = {
  prefix: 'fad',
  iconName: 'bell-concierge',
  icon: [
    512,
    512,
    [128718, 'concierge-bell'],
    'f562',
    [
      'M0 424c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0L32 400l-8 0c-13.3 0-24 10.7-24 24zM192 88c0 13.3 10.7 24 24 24l16 0 0 33.3c7.9-.8 15.9-1.3 24-1.3c2 0 4 0 6.1 .1s4 .1 6 .2c4 .2 8 .5 11.9 1l0-33.3 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0-40 0c-13.3 0-24 10.7-24 24z',
      'M480 368c0-123.7-100.3-224-224-224S32 244.3 32 368v32H480V368z',
    ],
  ],
};
const faConciergeBell = faBellConcierge;
const faPenRuler = {
  prefix: 'fad',
  iconName: 'pen-ruler',
  icon: [
    512,
    512,
    ['pencil-ruler'],
    'f5ae',
    [
      'M16 94.1c-18.7 18.7-18.7 49.1 0 67.9l87.4 87.4L249.4 103.4 204.2 58.3c-.3 .3-.6 .7-.9 1l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c.3-.3 .7-.6 1-.9L161.9 16C152.6 6.6 140.3 1.9 128 1.9s-24.6 4.7-33.9 14.1L16 94.1zM262.6 408.6L350.1 496c9.4 9.4 21.7 14.1 33.9 14.1s24.6-4.7 33.9-14.1L496 417.9c18.7-18.7 18.7-49.1 0-67.9l-19.8-19.8c-.3 .3-.6 .7-.9 1l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c.3-.3 .7-.6 1-.9l-45.1-45.1L262.6 408.6z',
      'M378.7 19.3L322.3 75.7 436.3 189.7l56.4-56.4c25-25 25-65.5 0-90.5L469.3 19.3c-25-25-65.5-25-90.5 0zm-79 79L44.9 353.2c-6.7 6.7-11.6 15.1-14.2 24.2L.9 481.4C-1.5 489.8 .9 498.8 7 505s15.2 8.5 23.6 6.1l104-29.7c9.2-2.6 17.5-7.5 24.2-14.2L413.7 212.3 299.7 98.3z',
    ],
  ],
};
const faPencilRuler = faPenRuler;
const faFileMp3 = {
  prefix: 'fad',
  iconName: 'file-mp3',
  icon: [
    512,
    512,
    [],
    'e648',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-240 0c-35.3 0-64 28.7-64 64l0 144-16 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM139.7 352.6c-6.9 1.9-11.7 8.2-11.7 15.4l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-70.2 18.3 30.5c2.9 4.8 8.1 7.8 13.7 7.8s10.8-3 13.7-7.8L224 425.8l0 70.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-7.2-4.8-13.5-11.7-15.4s-14.3 1-18 7.2L192 416.9l-34.3-57.1c-3.7-6.2-11.1-9.1-18-7.2zM288 368l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0c-8.8 0-16 7.2-16 16zm32 64l0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0zm144 80c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.3 0-15.1 6.3-15.9 14.4c-.1 .5-.1 1.1-.1 1.6c0 8.8 7.2 16 16 16l24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0z',
    ],
  ],
};
const faArrowProgress = {
  prefix: 'fad',
  iconName: 'arrow-progress',
  icon: [
    512,
    512,
    [],
    'e5df',
    [
      'M0 448c0 35.3 28.7 64 64 64c23.7 0 44.4-12.9 55.4-32l40.6 0 0 14.1c0 9.9 8 17.9 17.9 17.9c4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9l-60.8-47.3c-3.1-2.4-7-3.8-11-3.8c-9.9 0-17.9 8-17.9 17.9l0 14.1-40.6 0c-11.1-19.1-31.7-32-55.4-32c-35.3 0-64 28.7-64 64zM384 64a64 64 0 1 0 128 0A64 64 0 1 0 384 64z',
      'M256 110.1L256 96 128 96c-35.3 0-64 28.7-64 64s28.7 64 64 64l256 0c70.7 0 128 57.3 128 128c0 62.2-44.4 114.1-103.2 125.6C398.1 498 376.7 512 352 512c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.2 0 41.7 11.3 53.2 28.4c24.9-8.7 42.8-32.5 42.8-60.4c0-35.3-28.7-64-64-64l-256 0C57.3 288 0 230.7 0 160S57.3 32 128 32l128 0 0-14.1C256 8 264 0 273.9 0c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9z',
    ],
  ],
};
const faChessRookPiece = {
  prefix: 'fad',
  iconName: 'chess-rook-piece',
  icon: [
    320,
    512,
    ['chess-rook-alt'],
    'f448',
    [
      'M0 488c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L272 416 48 416 4.8 473.6C1.7 477.8 0 482.8 0 488z',
      'M48 416L72 264 47 232.8c-4.5-5.7-7-12.7-7-20L40 112c0-8.8 7.2-16 16-16l24 0c8.8 0 16 7.2 16 16l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-8.8 7.2-16 16-16l24 0c8.8 0 16 7.2 16 16l0 100.8c0 7.3-2.5 14.3-7 20L248 264l24 152L48 416zm88-135.1c0 3.9 3.2 7.1 7.1 7.1l33.8 0c3.9 0 7.1-3.2 7.1-7.1l0-32.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32.9z',
    ],
  ],
};
const faChessRookAlt = faChessRookPiece;
const faSquareRoot = {
  prefix: 'fad',
  iconName: 'square-root',
  icon: [
    576,
    512,
    [8730],
    'f697',
    [
      'M282.6 78.1c8-27.3 33-46.1 61.4-46.1l200 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L344 96 238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l45.6 0c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1z',
      '',
    ],
  ],
};
const faAlbumCollectionCirclePlus = {
  prefix: 'fad',
  iconName: 'album-collection-circle-plus',
  icon: [
    640,
    512,
    [],
    'e48e',
    [
      'M.4 214l32 256c3 24 23.4 42 47.6 42l314.8 0c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2L48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214zM16 104c0 13.3 10.7 24 24 24l432 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 80c-13.3 0-24 10.7-24 24zM32 24c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM224 352c0 13.3 14.3 24 32 24s32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faPeopleArrows = {
  prefix: 'fad',
  iconName: 'people-arrows',
  icon: [
    640,
    512,
    ['people-arrows-left-right'],
    'e068',
    [
      'M21.8 282.7c-.2 1.8-.2 3.6-.2 5.4c0 27.5 17.6 51.3 42.4 60.2L64 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c.6-.2 1.1-.4 1.7-.6c-8.9-8.9-17.8-17.8-26.7-26.7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.1-.8-.3-1.5-.3-2.3c-.1-.8-.1-1.5-.1-2.3c0-.8 0-1.5 .1-2.3s.2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c20.7-20.7 41.3-41.3 62-62c-7.1-37.4-39.8-65.1-78.6-65.1l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM411 225.1l62 62c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-8.9 8.9-17.8 17.8-25.8 27c.3 .1 .6 .2 .9 .3L448 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C610.7 191.9 576 160 534.4 160l-44.8 0c-38.8 0-71.5 27.7-78.6 65.1zM448 64a64 64 0 1 0 128 0A64 64 0 1 0 448 64z',
      'M257.2 217.8c9 3.7 14.8 12.5 14.8 22.2l0 32 96 0 0-32c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-32-96 0 0 32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2z',
    ],
  ],
};
const faPeopleArrowsLeftRight = faPeopleArrows;
const faSignPost = {
  prefix: 'fad',
  iconName: 'sign-post',
  icon: [
    512,
    512,
    [],
    'e624',
    [
      'M224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32-64 0 0-32zm0 224l64 0 0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224z',
      'M441.6 75.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H417c9.5 0 18.5 4.2 24.6 11.5z',
    ],
  ],
};
const faFaceAngryHorns = {
  prefix: 'fad',
  iconName: 'face-angry-horns',
  icon: [
    640,
    512,
    [],
    'e368',
    [
      'M64 256c0-24.6 3.5-48.4 9.9-70.9C89.5 131 122.4 84.3 166.2 51.3C209.1 19.1 262.3 0 320 0s110.9 19.1 153.8 51.3c43.8 33 76.7 79.7 92.3 133.8c6.5 22.5 9.9 46.3 9.9 70.9c0 141.4-114.6 256-256 256S64 397.4 64 256zm112.8-37.1c-2.8 8.4 1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1zm59.3 170.4c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3zM336.8 261.1c2.8 8.4 11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2z',
      'M566.1 185.1C550.5 131 517.6 84.3 473.8 51.3c17-3.3 39.7-8.6 63-15.5c29.8-8.9 59.1-20.2 78.4-33.1c5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166zM103.3 35.8c23.3 7 46 12.2 63 15.5c-43.8 33-76.7 79.7-92.3 133.8C29.6 125.8 6.5 50.1 .3 19.1C-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1zM240.4 304c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8z',
    ],
  ],
};
const faMarsAndVenusBurst = {
  prefix: 'fad',
  iconName: 'mars-and-venus-burst',
  icon: [
    640,
    512,
    [],
    'e523',
    [
      'M4 219.6c0 1.2 .1 2.4 .4 3.6c1.5 6.4 6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-1.9-26.4C247.1 277.9 240 251.8 240 224c0-1.8 0-3.6 .1-5.4s.1-3.6 .3-5.4c.2-3.6 .6-7.1 1.1-10.6c.9-7 2.3-13.8 4.1-20.5c3.6-13.3 8.9-26 15.6-37.7c13.4-23.4 32.6-43.1 55.7-57.2c.9-4.5-.2-9.3-3.2-13c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-4.4 3-6.9 8-6.9 13.2z',
      'M481.8 14.8C485.5 5.8 494.3 0 504 0L616 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C551 163.3 560 192.6 560 224c0 80.2-59 146.6-136 158.2l0 25.8 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-25.8c-77-11.6-136-78-136-158.2c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L526.1 80 487 41c-6.9-6.9-8.9-17.2-5.2-26.2zM592 48s0 0 0 0s0 0 0 0s0 0 0 0zM496 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z',
    ],
  ],
};
const faTombstone = {
  prefix: 'fad',
  iconName: 'tombstone',
  icon: [
    448,
    512,
    [],
    'f720',
    [
      'M32 192l0 256 384 0 0-256C416 86 330 0 224 0S32 86 32 192zm96 24c0-13.3 10.7-24 24-24l48 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-48 0c-13.3 0-24-10.7-24-24z',
      'M248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 120c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-40zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faSquareCaretRight = {
  prefix: 'fad',
  iconName: 'square-caret-right',
  icon: [
    448,
    512,
    ['caret-square-right'],
    'f152',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm160 56c0-9.5 5.7-18.2 14.4-22c3.1-1.3 6.3-2 9.6-2c5.9 0 11.8 2.2 16.3 6.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-4.5 4.2-10.4 6.4-16.3 6.4c-3.2 0-6.5-.7-9.6-2c-8.7-3.8-14.4-12.5-14.4-22l0-208z',
      'M312.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z',
    ],
  ],
};
const faCaretSquareRight = faSquareCaretRight;
const faScissors = {
  prefix: 'fad',
  iconName: 'scissors',
  icon: [
    512,
    512,
    [9984, 9986, 9988, 'cut'],
    'f0c4',
    [
      'M0 112c0 61.9 50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256c21.3-21.3 42.7-42.7 64-64l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112zm160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm96 208L396.8 460.8C410.9 474.9 429.5 482 448 482s37.1-7.1 51.2-21.2c3.5-3.5 5.3-8.2 5.3-12.8s-1.8-9.3-5.3-12.8L320 256l-64 64z',
      'M216.5 359.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L152.5 295.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5zM64 400a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
    ],
  ],
};
const faCut = faScissors;
const faListMusic = {
  prefix: 'fad',
  iconName: 'list-music',
  icon: [
    512,
    512,
    [],
    'f8c9',
    [
      'M0 96C0 78.3 14.3 64 32 64l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 224c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 256c-17.7 0-32-14.3-32-32zM0 352c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32z',
      'M512 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-96 32C360.8 38 352 50.2 352 64l0 64 0 231.7c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-280.9 74.1-24.7C503.2 122 512 109.8 512 96l0-64z',
    ],
  ],
};
const faSunPlantWilt = {
  prefix: 'fad',
  iconName: 'sun-plant-wilt',
  icon: [
    640,
    512,
    [],
    'e57a',
    [
      'M0 160c0 6.3 3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0s-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160zm224 0A64 64 0 1 1 96 160a64 64 0 1 1 128 0zm-96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M536 144c-17.7 0-32 14.3-32 32l0 96 0 8 0 168 104 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l424 0 0-168 0-8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 21.4c14.8 7.7 24 23.1 24 44.6c0 16.6-16 43.9-37.4 67.2c-5.7 6.2-15.5 6.2-21.2 0C336 382 320 354.9 320 338c0-21.5 9.2-37 24-44.6l0-21.4c0-44.2 35.8-80 80-80c11.4 0 22.2 2.4 32 6.7l0-22.7c0-44.2 35.8-80 80-80s80 35.8 80 80l0 53.4c14.8 7.7 24 23.1 24 44.6c0 16.6-16 43.9-37.4 67.2c-5.7 6.2-15.5 6.2-21.2 0C560 318 544 290.9 544 274c0-21.5 9.2-37 24-44.6l0-53.4c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faToiletsPortable = {
  prefix: 'fad',
  iconName: 'toilets-portable',
  icon: [
    576,
    512,
    [],
    'e584',
    [
      'M0 64L0 88 0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 160 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400 0-24-24 0L24 64 0 64zM176 240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64zM320 64l0 24 0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 160 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400 0-24-24 0-8 0L352 64l-8 0-24 0zM496 240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z',
      'M32 0C14.3 0 0 14.3 0 32L0 64l256 0 0-32c0-17.7-14.3-32-32-32L32 0zM352 0c-17.7 0-32 14.3-32 32l0 32 256 0 0-32c0-17.7-14.3-32-32-32L352 0zM192 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z',
    ],
  ],
};
const faHockeyPuck = {
  prefix: 'fad',
  iconName: 'hockey-puck',
  icon: [
    512,
    512,
    [],
    'f453',
    [
      'M0 160c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96S0 107 0 160z',
      'M256 256c141.4 0 256-43 256-96l0 192c0 53-114.6 96-256 96S0 405 0 352L0 160c0 53 114.6 96 256 96z',
    ],
  ],
};
const faMustache = {
  prefix: 'fad',
  iconName: 'mustache',
  icon: [
    640,
    512,
    [],
    'e5bc',
    [
      'M48 223.4c0 .2 0 .4 0 .6c0 .7 0 1.3 .1 2s.2 1.3 .4 2c.1 .4 .2 .8 .3 1.2c9.4 28.2 32.9 54.6 58.8 73.7c25.8 19 57.3 33.1 85 33.1c16.4 0 34.4-4.7 50.1-11.2c15.6-6.5 30.6-15.5 40.6-25.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-6 6-17 13-30.3 18.5c-13.2 5.5-26.9 8.8-37.8 8.8c-18.2 0-43-9.9-66-26.9c-9.5-7-18.1-14.8-25.4-22.9c7 1.2 14.2 1.8 21.4 1.8c27.8 0 54.8-9 77-25.7l13.1-9.8c10.8-8.1 24-12.5 37.6-12.5c19 0 37 8.6 48.9 23.5l8.2 10.2c.4 .6 .9 1.1 1.4 1.6c1.3 1.3 2.8 2.4 4.5 3.1c4.3 2 9.3 2.1 13.7 0c1.6-.8 3.1-1.8 4.5-3.1c.5-.5 1-1 1.4-1.6l8.2-10.2c11.9-14.9 29.9-23.5 48.9-23.5c13.6 0 26.7 4.4 37.6 12.5l13.1 9.8c22.2 16.7 49.3 25.7 77 25.7c7.2 0 14.3-.6 21.4-1.8c-7.3 8.1-16 15.9-25.4 22.9c-23 17-47.9 26.9-66 26.9c-10.9 0-24.6-3.3-37.8-8.8c-13.3-5.5-24.3-12.5-30.3-18.5c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6c10 10 25 19 40.6 25.5C413 331.3 431 336 447.4 336c27.7 0 59.2-14.1 85-33.1c25.9-19.1 49.4-45.6 58.8-73.8c.7-2.3 1-4.6 .7-6.8c-.2-1.5-.5-3-1.1-4.4c-.3-.7-.6-1.3-1-1.9c-.8-1.4-1.9-2.7-3-3.7c-1.6-1.5-3.5-2.6-5.7-3.3c-.3-.1-.5-.2-.8-.2c-1.8-.5-3.6-.7-5.4-.5c-2 .1-4.1 .7-6 1.7l-8.3 4.1c-13.4 6.7-28.1 10.2-43.1 10.2c-20.9 0-41.2-6.8-57.8-19.3l-13.1-9.8c-16.4-12.3-36.3-18.9-56.8-18.9c-26.6 0-51.9 11.2-69.8 30.7c-17.9-19.5-43.2-30.7-69.8-30.7c-20.5 0-40.4 6.6-56.8 18.9l-13.1 9.8c-16.7 12.5-37 19.3-57.8 19.3c-15 0-29.7-3.5-43.1-10.2l-8.2-4.1c-.2-.1-.5-.2-.7-.3c-3.4-1.5-7.3-1.9-11.1-.7c-.3 .1-.7 .2-1 .3c-1.7 .6-3.3 1.6-4.6 2.7c-1.7 1.4-3.1 3.1-4.1 5.2c-1.1 2.1-1.6 4.3-1.7 6.5z',
      'M231 112c-31.6 0-61.7 13.2-83.1 36.4l-2 2.1c-27.6 29.9-74.6 30.9-103.4 2.1L41 151c-2.5-2.5-5.5-4.4-8.6-5.5c-2.6-1-5.4-1.5-8.4-1.5c-3.6 0-7.1 .8-10.2 2.3c-1.7 .8-3.3 1.8-4.8 3c-1.5 1.2-2.9 2.7-4.1 4.2c-.7 1-1.4 2-2 3C1.1 159.9 0 163.8 0 168l0 39.4C0 313.8 86.2 400 192.6 400c46.7 0 91.7-16.9 126.9-47.7l.5-.4 .5 .4c35.1 30.7 80.2 47.7 126.9 47.7C553.8 400 640 313.8 640 207.4l0-39.4c0-4-1-7.8-2.7-11.2c-.2-.5-.5-.9-.8-1.4c-.2-.4-.5-.8-.7-1.1c-.3-.5-.7-1-1.1-1.4c-1.1-1.3-2.3-2.5-3.6-3.6c-4.1-3.3-9.3-5.2-15-5.2c-2.9 0-5.8 .5-8.4 1.5c-3.1 1.2-6.1 3-8.6 5.5l-1.6 1.6c-28.8 28.8-75.8 27.9-103.4-2.1l-2-2.1C470.7 125.2 440.6 112 409 112c-33 0-64.4 14.4-85.9 39.5l-3.1 3.6-3.1-3.6C295.4 126.4 264 112 231 112zm19.2 64c26.6 0 51.9 11.2 69.8 30.7c17.9-19.5 43.2-30.7 69.8-30.7c20.5 0 40.4 6.6 56.8 18.9l13.1 9.8c16.7 12.5 37 19.3 57.8 19.3c15 0 29.7-3.5 43.1-10.2l8.3-4.1c1.9-1 4-1.5 6-1.7c1.8-.1 3.6 0 5.4 .5c.3 .1 .5 .2 .8 .2c2.2 .7 4.1 1.9 5.7 3.3c1.2 1.1 2.2 2.3 3 3.7c.4 .6 .7 1.3 1 1.9c.6 1.5 1 2.9 1.1 4.4c.2 2.2 0 4.5-.7 6.8c-9.4 28.3-32.9 54.7-58.8 73.8c-25.8 19-57.3 33.1-85 33.1c-16.4 0-34.4-4.7-50.1-11.2c-15.6-6.5-30.6-15.5-40.6-25.5c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c6 6 17 13 30.3 18.5c13.2 5.5 26.9 8.8 37.8 8.8c18.2 0 43-9.9 66-26.9c9.5-7 18.1-14.8 25.4-22.9c-7 1.2-14.2 1.8-21.4 1.8c-27.8 0-54.8-9-77-25.7l-13.1-9.8c-10.8-8.1-24-12.5-37.6-12.5c-19 0-37 8.6-48.9 23.5l-8.2 10.2c-.4 .6-.9 1.1-1.4 1.6c-1.3 1.3-2.8 2.4-4.5 3.1c-4.4 2.1-9.4 2-13.7 0c-1.6-.8-3.1-1.8-4.5-3.1c-.5-.5-1-1-1.4-1.6l-8.2-10.2c-11.9-14.9-29.9-23.5-48.9-23.5c-13.6 0-26.7 4.4-37.6 12.5l-13.1 9.8c-22.2 16.7-49.3 25.7-77 25.7c-7.2 0-14.3-.6-21.4-1.8c7.3 8.1 16 15.9 25.4 22.9c23 17 47.9 26.9 66 26.9c10.9 0 24.6-3.3 37.8-8.8c13.3-5.5 24.3-12.5 30.3-18.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-10 10-25 19-40.6 25.5C227 331.3 209 336 192.6 336c-27.7 0-59.2-14.1-85-33.1c-25.9-19.1-49.3-45.5-58.8-73.7c-.1-.4-.2-.8-.3-1.2c-.4-1.5-.6-3.1-.5-4.6c.1-2.2 .6-4.4 1.7-6.5c1-2.1 2.4-3.8 4.1-5.2c1.3-1.1 2.9-2 4.6-2.7c.3-.1 .7-.2 1-.3c3.8-1.1 7.7-.8 11.1 .7c.2 .1 .5 .2 .7 .3l8.2 4.1c13.4 6.7 28.1 10.2 43.1 10.2c20.9 0 41.2-6.8 57.8-19.3l13.1-9.8c16.4-12.3 36.3-18.9 56.8-18.9z',
    ],
  ],
};
const faHyphen = {
  prefix: 'fad',
  iconName: 'hyphen',
  icon: [
    320,
    512,
    [],
    '2d',
    ['M0 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z', ''],
  ],
};
const faTable = {
  prefix: 'fad',
  iconName: 'table',
  icon: [
    512,
    512,
    [],
    'f0ce',
    [
      'M64 256l0 64 160 0 0 96 64 0 0-96 160 0 0-64-160 0 0-96-64 0 0 96L64 256z',
      'M64 160l0 256 384 0 0-256L64 160zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z',
    ],
  ],
};
const faUserChef = {
  prefix: 'fad',
  iconName: 'user-chef',
  icon: [
    448,
    512,
    [],
    'e3d2',
    [
      'M96 160l32 0 16 0 160 0 16 0 32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M384 48c0 20.9-13.4 38.7-32 45.3l0 18.7 0 48-32 0-16 0-160 0-16 0-32 0 0-48 0-18.7C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM178.4 340.6c7.5 1.9 8.2 12.3 1 15.2l-43.2 17.3C111.9 382.8 96 406.3 96 432.5L96 480l0 24 0 8-8 0-24 0-38.4 0C11.5 512 0 500.5 0 486.4c0-58.8 37.7-108.8 90.3-127c3.3-1.2 5.7-4.3 5.7-7.8l0-21.4c0-5.2 4.9-9 9.9-7.8l72.5 18.1zM352 512l-192 0-24 0-8 0 0-8 0-24 0-47.5c0-13.1 8-24.9 20.1-29.7L341 325.6c5.3-2.1 11 1.8 11 7.4l0 18.6c0 3.5 2.3 6.6 5.7 7.8c52.6 18.2 90.3 68.2 90.3 127c0 14.1-11.5 25.6-25.6 25.6L352 512zM224 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faMessageImage = {
  prefix: 'fad',
  iconName: 'message-image',
  icon: [
    512,
    512,
    ['comment-alt-image'],
    'e1e0',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM98.4 306.4c4 8.3 12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 132 304 128 296 128s-15.5 4-20 10.7l-56 84L202.7 201c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4zM112 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M144 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm172-21.3C311.5 132 304 128 296 128s-15.5 4-20 10.7l-56 84L202.7 201c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144z',
    ],
  ],
};
const faCommentAltImage = faMessageImage;
const faUsersMedical = {
  prefix: 'fad',
  iconName: 'users-medical',
  icon: [
    640,
    512,
    [],
    'f830',
    [
      'M0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM64 80a80 80 0 1 0 160 0A80 80 0 1 0 64 80zm64 405.3c0 14.7 11.9 26.7 26.7 26.7l328.1 0c-1.8-5-2.7-10.4-2.7-16l0-16-16 0c-26.5 0-48-21.5-48-48l0-32c0-14.6 6.5-27.7 16.9-36.5C416.3 356.1 398 352 378.7 352l-117.3 0C187.7 352 128 411.7 128 485.3zM224 224a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm180.7 96c.2 0 .4 0 .7 0l77.4 0c6.6-18.6 24.4-32 45.3-32l32 0c20.9 0 38.7 13.4 45.3 32l13.4 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80z',
      'M528 320c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faSensorTriangleExclamation = {
  prefix: 'fad',
  iconName: 'sensor-triangle-exclamation',
  icon: [
    640,
    512,
    ['sensor-alert'],
    'e029',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 32c-26.4 0-50.7 14.2-63.7 37.1L233.9 430c-6.5 11.5-9.9 24.5-9.9 37.7c0 4.2 .3 8.3 1 12.3L64 480c-35.3 0-64-28.7-64-64L0 96zm64 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 0l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M412.2 180.9l-150.4 265c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3l295.4 0c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9zM448 256c8.8 0 16 7.2 16 16l0 88c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-88c0-8.8 7.2-16 16-16zM424 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faSensorAlert = faSensorTriangleExclamation;
const faMagnifyingGlassArrowRight = {
  prefix: 'fad',
  iconName: 'magnifying-glass-arrow-right',
  icon: [
    512,
    512,
    [],
    'e521',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm96 0c0-13.3 10.7-24 24-24l118.1 0-31-31c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l72 72c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31L120 232c-13.3 0-24-10.7-24-24z',
      'M241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L120 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l118.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72zM457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376L457.4 502.6z',
    ],
  ],
};
const faTachographDigital = {
  prefix: 'fad',
  iconName: 'tachograph-digital',
  icon: [
    640,
    512,
    ['digital-tachograph'],
    'f566',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm64 32c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-64zM96 304a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM64 368c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16zm96-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
      'M96 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128zM80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 352zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
    ],
  ],
};
const faDigitalTachograph = faTachographDigital;
const faFaceMask = {
  prefix: 'fad',
  iconName: 'face-mask',
  icon: [
    576,
    512,
    [],
    'e37f',
    [
      'M32 257.5c.3 47.9 13.7 92.7 36.9 131c2.9-2.8 6.8-4.5 11.1-4.5l64 0c0-25.6 0-51.1 0-76.7c-37.3-16.6-74.7-33.2-112-49.8zm2-33.4c1.5 .2 3.1 .6 4.5 1.3c38.1 16.9 76.2 33.9 114.4 50.8c8.7-12.2 23-20.2 39.1-20.2c64 0 128 0 192 0c16.2 0 30.4 8 39.1 20.2c38.1-16.9 76.2-33.9 114.4-50.8c.7-.3 1.5-.6 2.2-.8s1.5-.4 2.3-.5C526.3 97.8 418.6 0 288 0S49.7 97.8 34 224.1zM88.1 416c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96l-58.6 0c-6.6 18.6-24.4 32-45.3 32l-192 0c-20.9 0-38.7-13.4-45.3-32l-58.6 0zm44.5-235.3C146.4 167 184.6 144 240 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-47 0-77.1 19.7-84.7 27.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM320 160c0-8.8 7.2-16 16-16c55.4 0 93.6 23 107.3 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C413.1 195.7 383 176 336 176c-8.8 0-16-7.2-16-16zM432 307.3l0 76.7 64 0c.5 0 1.1 0 1.6 .1s1 .1 1.6 .2c1 .2 2 .5 2.9 .9c1.9 .8 3.6 1.9 5 3.3c23.2-38.2 36.6-83 36.9-131c-37.3 16.6-74.7 33.2-112 49.8z',
      'M38.5 225.4c-8.1-3.6-17.5 0-21.1 8.1s0 17.5 8.1 21.1L144 307.3l0 76.7-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l66.7 0c6.6 18.6 24.4 32 45.3 32l192 0c20.9 0 38.7-13.4 45.3-32l66.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-76.7 118.5-52.7c8.1-3.6 11.7-13 8.1-21.1s-13-11.7-21.1-8.1L423.1 276.2C414.4 264 400.2 256 384 256l-192 0c-16.2 0-30.4 8-39.1 20.2L38.5 225.4zM208 304l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faPickleball = {
  prefix: 'fad',
  iconName: 'pickleball',
  icon: [
    576,
    512,
    [],
    'e435',
    [
      'M304 384a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm64-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M386.3 28c-37.5-37.4-98.4-37.4-136 0L84.9 193c-18.4 18.3-23.8 45.8-13.9 69.7l24.2 57.9c10 23.9 4.5 51.5-13.9 69.8L27.8 443.8c-15.6 15.6-15.7 40.9 0 56.5s41 15.6 56.7 0l53.8-53.6c18.3-18.2 45.7-23.7 69.6-13.9l56.7 23.2c8.7 3.6 17.9 5.1 26.9 4.7C279.1 437.9 272 411.8 272 384c0-3.3 .1-6.5 .3-9.8L133.1 235.5c-6.3-6.2-6.3-16.4 0-22.6s16.4-6.3 22.6 0L279.3 336.1C299.7 271.1 360.3 224 432 224c32.1 0 62 9.4 87 25.7c16.7-35.5 10.3-79.1-19.1-108.4L386.3 28z',
    ],
  ],
};
const faStarSharpHalf = {
  prefix: 'fad',
  iconName: 'star-sharp-half',
  icon: [
    576,
    512,
    [],
    'e28c',
    [
      'M288 0l0 155.9 0 169.4 0 81.1L389.1 485l2.9 2.3 12.3 9.5 13 10.1c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27l-5-15.7-4.7-14.8-1.1-3.5-40.1-126L507.7 240l1.8-1.4 10.5-8.2 14.7-11.5c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2l-18.7 0L488 176l-2.3 0-124.2 0-40-125.6-1-3.2L316 32.9c-1.7-5.4-3.4-10.8-5.2-16.2C307.7 6.8 298.5 0 288 0z',
      'M254.4 50.4L214.5 176 90.3 176 88 176l-13.3 0L56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4 103.7 80.7L132 446.7l-1.1 3.5L126.1 465l-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4l0-81.1 0-169.4L288 0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9s0 0 0 0l-4.6 14.3-1 3.2z',
    ],
  ],
};
const faUsersSlash = {
  prefix: 'fad',
  iconName: 'users-slash',
  icon: [
    640,
    512,
    [],
    'e073',
    [
      'M0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192l-15.2 0C47.8 192 0 239.8 0 298.7zM77.5 35.5c41.9 32.8 83.7 65.6 125.6 98.4c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5zM128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c10.5 0 19.5-6 23.9-14.8L324.9 352l-63.6 0C187.7 352 128 411.7 128 485.3zM243.7 165.7c50.4 39.5 100.7 79 151.1 118.4C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7zM420 303.9c6.9 5.4 13.7 10.7 20.5 16.1l178.1 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faClover = {
  prefix: 'fad',
  iconName: 'clover',
  icon: [
    448,
    512,
    [],
    'e139',
    [
      'M216.6 49.9C205.1 38.5 189.5 32 173.3 32C139.4 32 112 59.4 112 93.3l0 4.9c0 12 3.3 23.7 9.4 34l31.9 53.2-53.2-31.9c-10.3-6.2-22-9.4-34-9.4l-4.9 0C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l7.4 7.4-7.4 7.4C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368l4.9 0c12 0 23.7-3.3 34-9.4l53.2-31.9-31.9 53.2c-6.2 10.3-9.4 22-9.4 34l0 4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l7.4-7.4 7.4 7.4c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3l0-4.9c0-12-3.3-23.7-9.4-34l-31.9-53.2 53.2 31.9c10.3 6.2 22 9.4 34 9.4l4.9 0c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-7.4-7.4 7.4-7.4c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3l-4.9 0c-12 0-23.7 3.3-34 9.4l-53.2 31.9 31.9-53.2c6.2-10.3 9.4-22 9.4-34l0-4.9C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9L224 57.4l-7.4-7.4z',
      '',
    ],
  ],
};
const faMeat = {
  prefix: 'fad',
  iconName: 'meat',
  icon: [
    512,
    512,
    [127830],
    'f814',
    [
      'M0 380c0 33.1 26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l6.3-6.3c-36.7-7.9-65.6-36.8-73.5-73.5l-6.3 6.3c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60zM332.4 124.4c-8.9 8.9-3.8 28.5 11.5 43.8s34.9 20.4 43.8 11.5c3-3 4.4-7.1 4.4-11.9c0-9.6-5.7-21.7-15.9-31.9s-22.3-15.9-31.9-15.9c-4.8 0-8.9 1.4-11.9 4.4z',
      'M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384L224 384c-53 0-96-43-96-96l0-46.7c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2S299.1 33.2 270.2 62.2s-12.2 92.6 37.4 142.2z',
    ],
  ],
};
const faReply = {
  prefix: 'fad',
  iconName: 'reply',
  icon: [
    512,
    512,
    [61714, 'mail-reply'],
    'f3e5',
    [
      'M224 128l112 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-96 0 0-160z',
      'M224 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 190.3 0 198.9 0 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-288z',
    ],
  ],
};
const faMailReply = faReply;
const faStarAndCrescent = {
  prefix: 'fad',
  iconName: 'star-and-crescent',
  icon: [
    512,
    512,
    [9770],
    'f699',
    [
      'M258.1 226.3c0 2.4 .9 4.9 2.9 6.8l50.9 49.6c2.3 2.2 3.3 5.4 2.8 8.5l-12 70.1c-1.1 6.2 3.9 11.2 9.5 11.2c1.5 0 3-.4 4.5-1.1l63-33.1c2.8-1.5 6.1-1.5 8.9 0l63 33.1c1.5 .8 3 1.1 4.5 1.1c5.6 0 10.5-5 9.5-11.2l-12-70.1c-.5-3.1 .5-6.3 2.8-8.5L507 233.1c2-1.9 2.9-4.4 2.9-6.8c0-4.5-3.1-8.8-8.2-9.6l-70.4-10.2c-3.1-.5-5.8-2.4-7.2-5.3l-31.5-63.8c-1.8-3.6-5.2-5.4-8.6-5.4s-6.8 1.8-8.6 5.4l-31.5 63.8c-1.4 2.8-4.1 4.8-7.2 5.3l-70.4 10.2c-5.1 .7-8.2 5.1-8.2 9.6z',
      'M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33 0 64.6-6.3 93.6-17.7c7.4-2.9 11.5-10.7 9.8-18.4s-8.8-13-16.7-12.4c-4.8 .3-9.7 .5-14.6 .5c-114.9 0-208-93.1-208-208s93.1-208 208-208c4.9 0 9.8 .2 14.6 .5c7.9 .5 15-4.7 16.7-12.4s-2.4-15.5-9.8-18.4C320.6 6.3 289 0 256 0z',
    ],
  ],
};
const faEmptySet = {
  prefix: 'fad',
  iconName: 'empty-set',
  icon: [
    512,
    512,
    [8709, 216],
    'f656',
    [
      'M32 256c0 50.3 16.6 96.8 44.6 134.2l45.9-45.9C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5c15.3-15.3 30.6-30.6 45.9-45.9C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256zm89.9 179.4c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1l-45.9 45.9C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5c-15.3 15.3-30.6 30.6-45.9 45.9z',
      'M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-448 448c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l448-448c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faHouseFire = {
  prefix: 'fad',
  iconName: 'house-fire',
  icon: [
    640,
    512,
    [],
    'e50c',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l32 0c0-.6 0-1.3 0-1.9c0-35.2 16.3-73.6 37.2-107.4c21.7-35.2 51.9-71.2 87.3-102.8c9.8-8.8 22.5-12.7 34.8-11.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24z',
      'M640 352c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352zM480 464.2c35.3 0 64-28.7 64-64c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64z',
    ],
  ],
};
const faSquareMinus = {
  prefix: 'fad',
  iconName: 'square-minus',
  icon: [
    448,
    512,
    [61767, 'minus-square'],
    'f146',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM128 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M128 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faMinusSquare = faSquareMinus;
const faHelicopter = {
  prefix: 'fad',
  iconName: 'helicopter',
  icon: [
    640,
    512,
    [128641],
    'f533',
    [
      'M128 32c0-17.7 14.3-32 32-32L544 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L384 64l0 64-64 0 0-64L160 64c-17.7 0-32-14.3-32-32zm96 448c0-17.7 14.3-32 32-32l280.2 0c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0c6.2 6.2 9.4 14.4 9.4 22.6s-3.1 16.4-9.4 22.6l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5L256 512c-17.7 0-32-14.3-32-32z',
      'M384 384l-64 0c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64L48 64c10.1 0 19.6 4.7 25.6 12.8L112 128l272 0 32 0c88.4 0 160 71.6 160 160l0 64c0 17.7-14.3 32-32 32l-160 0zm0-64l128 0 0-32c0-53-43-96-96-96l-32 0 0 128z',
    ],
  ],
};
const faBird = {
  prefix: 'fad',
  iconName: 'bird',
  icon: [
    512,
    512,
    [],
    'e469',
    [
      'M162.1 407.4c18.7 5.4 38.5 8.4 58.9 8.6l32.2 60.8c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-48.6-91.9zm99 5.6c16.4-2.7 32.2-7.3 47.2-13.4l40.9 77.2c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-45.7-86.3zM446.6 79.7l57.6 34.6c4.8 2.9 7.8 8.1 7.8 13.7s-2.9 10.8-7.8 13.7L448 175.5 448 96c0-5.6-.5-11-1.4-16.3z',
      'M0 188.4L0 192C0 315.7 100.3 416 224 416s224-100.3 224-224l0-96c0-53-43-96-96-96s-96 43-96 96l0 32c0 17.7-14.3 32-32 32L28.4 160C12.7 160 0 172.7 0 188.4zM352 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faCompass = {
  prefix: 'fad',
  iconName: 'compass',
  icon: [
    512,
    512,
    [129517],
    'f14e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM129.7 358.3c0-2.8 .5-5.8 1.7-8.7c18.5-48.1 37-96.2 55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4c48.1-18.5 96.2-37 144.3-55.5c19.4-7.5 38.5 11.6 31 31c-18.5 48.1-37 96.2-55.5 144.3c-3.3 8.5-9.9 15.1-18.4 18.4c-48.1 18.5-96.2 37-144.3 55.5c-16.5 6.3-32.7-6.4-32.7-22.3z',
      'M162.4 380.6l144.3-55.5c8.5-3.3 15.1-9.9 18.4-18.4l55.5-144.3c7.5-19.4-11.6-38.5-31-31L205.3 186.9c-8.5 3.3-15.1 9.9-18.4 18.4L131.4 349.6c-7.5 19.4 11.6 38.5 31 31zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faSquareCaretDown = {
  prefix: 'fad',
  iconName: 'square-caret-down',
  icon: [
    448,
    512,
    ['caret-square-down'],
    'f150',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 216c0-3.2 .7-6.5 2-9.6c3.8-8.7 12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4c1.3 3.1 2 6.3 2 9.6c0 5.9-2.2 11.8-6.4 16.3l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112C98.2 227.8 96 221.9 96 216z',
      'M241.6 344.3c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112z',
    ],
  ],
};
const faCaretSquareDown = faSquareCaretDown;
const faHeartHalfStroke = {
  prefix: 'fad',
  iconName: 'heart-half-stroke',
  icon: [
    512,
    512,
    ['heart-half-alt'],
    'e1ac',
    [
      'M256 96l0 67.9 0 22.6 45.3-45.3 12-12c18-18 43.6-26.2 68.8-22c38.1 6.3 66 39.3 66 77.9l0 5.8c0 23.8-9.9 46.5-27.3 62.7L256 407.4l0 21.9 0 50.7c10.3 0 20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96z',
      'M256 96L244 84s0 0 0 0c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9l0-50.7 0-265.4L256 96z',
    ],
  ],
};
const faHeartHalfAlt = faHeartHalfStroke;
const faFileCircleQuestion = {
  prefix: 'fad',
  iconName: 'file-circle-question',
  icon: [
    576,
    512,
    [],
    'e4ef',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-94.4c0-23 18.6-41.6 41.6-41.6l40.5 0c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6L448 378.9l0 5.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-14.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9l-40.5 0c-5.3 0-9.6 4.3-9.6 9.6l0 6.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.4z',
    ],
  ],
};
const faTruckUtensils = {
  prefix: 'fad',
  iconName: 'truck-utensils',
  icon: [
    640,
    512,
    [],
    'e628',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l17.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l66.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l1.1 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM89.5 77.5c.7-5.9 5.6-10.3 11.6-10.3c6.2 0 11.3 4.8 11.6 11l4.4 75.5c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.8c.3-6 5.3-10.6 11.3-10.6s10.9 4.7 11.3 10.6l4.4 75.8c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.5c.4-6.2 5.5-11 11.6-11c5.9 0 10.9 4.4 11.6 10.3l9.5 81.4c0 29.4-20.5 54-48 60.3l0 52.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-52.8c-27.5-6.3-48-30.9-48-60.3l9.5-81.4zM256 154.9c0-63.1 41.3-86 50.3-90.2c1.1-.5 2.3-.8 3.6-.8c5.6 0 10.1 4.5 10.1 10.1l0 53.9 0 96 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c-17.7 0-32-14.3-32-32l0-37z',
    ],
  ],
};
const faLaptopCode = {
  prefix: 'fad',
  iconName: 'laptop-code',
  icon: [
    640,
    512,
    [],
    'f5fc',
    [
      'M0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384C8.6 384 0 392.6 0 403.2zM64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96z',
      'M512 96L128 96l0 256 384 0 0-256zM281 193l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 159l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z',
    ],
  ],
};
const faJoystick = {
  prefix: 'fad',
  iconName: 'joystick',
  icon: [
    448,
    512,
    [128377],
    'f8c5',
    [
      'M64 352c0-17.7 14.3-32 32-32s32 14.3 32 32l-64 0zM192 219.4c5.1 1.5 10.3 2.7 15.6 3.5c2.7 .4 5.4 .7 8.1 .9s5.5 .3 8.3 .3c11.1 0 21.9-1.6 32-4.6L256 352l-64 0 0-132.6z',
      'M336 112a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM176 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64L64 352z',
    ],
  ],
};
const faGrillFire = {
  prefix: 'fad',
  iconName: 'grill-fire',
  icon: [
    576,
    512,
    [],
    'e5a4',
    [
      'M0 72L0 96c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64l75.5 0c-5.5-15.3-9.1-31.4-10.7-48l-73 0 22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4c1.2 0 2.4 0 3.6 0c5.9-26.2 18.6-52.9 33.6-77.3c21.7-35.2 51.9-71.2 87.3-102.8C366.2 124 393.3 124 411 140c9 8.1 17.7 16.4 26.2 25.1c7-21.8 10.9-45 10.9-69.1l0-24c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72zM120 416a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M576 352c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C560.5 268 576 320.2 576 352zM416 464.2c35.3 0 64-28.7 64-64c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C389 327.1 352 363.6 352 400.2c0 35.3 28.7 64 64 64z',
    ],
  ],
};
const faRectangleVerticalHistory = {
  prefix: 'fad',
  iconName: 'rectangle-vertical-history',
  icon: [
    576,
    512,
    [],
    'e237',
    [
      'M0 120L0 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272c0-13.3-10.7-24-24-24S0 106.7 0 120zM96 72l0 368c0 13.3 10.7 24 24 24s24-10.7 24-24l0-368c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M192 64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64z',
    ],
  ],
};
const faSwatchbook = {
  prefix: 'fad',
  iconName: 'swatchbook',
  icon: [
    512,
    512,
    [],
    'f5c3',
    [
      'M64 64l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zM173.1 473.1c.8-1.1 1.7-2.3 2.5-3.5c5.2-7.7 9.3-16.1 12.1-25.1c1.4-4.5 2.5-9.2 3.2-13.9c.4-2.4 .6-4.8 .8-7.2c.1-1.2 .2-2.4 .2-3.7s.1-2.5 .1-3.7l0-230L299.4 78.6c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L189.7 459.9c-5.1 5.1-10.7 9.5-16.5 13.2zm9.7 38.9l192-192L480 320c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-297.2 0z',
      'M32 0C14.3 0 0 14.3 0 32L0 416c0 53 43 96 96 96s96-43 96-96l0-384c0-17.7-14.3-32-32-32L32 0zm96 64l0 64-64 0 0-64 64 0zM64 192l64 0 0 64-64 0 0-64zM96 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faPrescriptionBottle = {
  prefix: 'fad',
  iconName: 'prescription-bottle',
  icon: [
    384,
    512,
    [],
    'f485',
    [
      'M32 96l320 0 0 352c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 384l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 288l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 192l0-96z',
      'M32 0C14.3 0 0 14.3 0 32L0 64C0 81.7 14.3 96 32 96l320 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0zM144 192L32 192l0 32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 96L32 288l0 32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 96L32 384l0 32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16z',
    ],
  ],
};
const faBars = {
  prefix: 'fad',
  iconName: 'bars',
  icon: [
    448,
    512,
    ['navicon'],
    'f0c9',
    [
      'M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z',
      'M448 96c0-17.7-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32L32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z',
    ],
  ],
};
const faNavicon = faBars;
const faKeyboardLeft = {
  prefix: 'fad',
  iconName: 'keyboard-left',
  icon: [
    640,
    512,
    [],
    'e1c3',
    [
      'M160 128l0 256c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L224 64c-35.3 0-64 28.7-64 64zm64 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-192c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-32zm96-192c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M240 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm0 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM224 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM336 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM320 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM432 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM416 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM528 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM512 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM113.2 153.8c9 3.7 14.8 12.5 14.8 22.2l0 160c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L7 273c-9.4-9.4-9.4-24.6 0-33.9l80-80c6.9-6.9 17.2-8.9 26.2-5.2z',
    ],
  ],
};
const faPeopleGroup = {
  prefix: 'fad',
  iconName: 'people-group',
  icon: [
    640,
    512,
    [],
    'e533',
    [
      'M0 304c0 44.7 26.2 83.2 64 101.2L64 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8 0-10.7c-20-24.7-32-56.2-32-90.5c0-37.8 14.6-72.2 38.4-97.9c-16.1-9-34.7-14.1-54.4-14.1l-32 0C50.1 192 0 242.1 0 304zm48 0c0-16.2 6-31.1 16-42.3l0 84.7C54 335 48 320.2 48 304zM64 96a64 64 0 1 0 128 0A64 64 0 1 0 64 96zM441.6 206.1C465.4 231.8 480 266.2 480 304c0 34.3-12 65.8-32 90.5l0 10.7 0 42.8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0c-19.7 0-38.3 5.1-54.4 14.1zM448 96a64 64 0 1 0 128 0A64 64 0 1 0 448 96zM576 261.7c10 11.3 16 26.1 16 42.3s-6 31-16 42.3l0-84.7z',
      'M384 96A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 261.7l0 84.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3zm128 84.7l0-84.7c10 11.3 16 26.1 16 42.3s-6 31-16 42.3zm0 58.9c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2l0 42.8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8z',
    ],
  ],
};
const faHourglassEnd = {
  prefix: 'fad',
  iconName: 'hourglass-end',
  icon: [
    384,
    512,
    [8987, 'hourglass-3'],
    'f253',
    [
      'M32 64l64 0 0 11c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9l0-11 64 0 0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11-32 0-32 0L96 448l-32 0-32 0 0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faHourglass3 = faHourglassEnd;
const faHeartCrack = {
  prefix: 'fad',
  iconName: 'heart-crack',
  icon: [
    512,
    512,
    [128148, 'heart-broken'],
    'f7a9',
    [
      'M0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5l0-5.8c0-69.9-50.5-129.5-119.4-141c-33.4-5.6-67.2 .9-95.7 17.6c7.6 21.2 15.1 42.4 22.7 63.6c1.1 3.2 .2 6.7-2.4 8.8c-30.2 25.2-60.4 50.4-90.7 75.6c20.1 32.7 40.2 65.4 60.4 98.1c2.1 3.4 1.4 7.8-1.7 10.4s-7.6 2.4-10.5-.3c-37.3-34.7-74.7-69.3-112-104c-1.6-1.5-2.5-3.5-2.6-5.7s.8-4.3 2.3-5.8c25.1-25.1 50.3-50.3 75.4-75.4c-16.6-25.8-33.2-51.6-49.8-77.5c-21.8-7.2-45.3-9.2-68.5-5.3C50.5 55.6 0 115.2 0 185.1z',
      'M296.8 61.7C286.4 67.8 276.7 75.3 268 84L256 96 244 84c-16-16-35.2-27.7-56-34.6l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.7z',
    ],
  ],
};
const faHeartBroken = faHeartCrack;
const faFaceBeamHandOverMouth = {
  prefix: 'fad',
  iconName: 'face-beam-hand-over-mouth',
  icon: [
    512,
    512,
    [129325],
    'e47c',
    [
      'M0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-32.8 0-53.6c0-28.7 23.3-52 52-52c17.9 0 33.6 9 43 22.7l47.1-47.1c18.7-18.7 49.1-18.7 67.9 0c1 1 2 2.1 3 3.2c15.7-3.7 32.8 .5 45 12.8s16.5 29.4 12.8 45c1.1 .9 2.2 1.9 3.2 3c18.1 18.1 18.7 47.1 1.8 65.9c16.9 18.8 16.3 47.8-1.8 65.9l-49 49C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm120-48c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6zm160 0c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M217.6 212.8s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm81.7 86.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zm78.3-86.5s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
    ],
  ],
};
const faDropletPercent = {
  prefix: 'fad',
  iconName: 'droplet-percent',
  icon: [
    384,
    512,
    ['humidity'],
    'f750',
    [
      'M0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm160-56a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM112 384c0-4.1 1.6-8.2 4.7-11.3l128-128c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l-128 128c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7s-4.7-7.2-4.7-11.3zm160-8a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M267.3 267.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM160 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faHumidity = faDropletPercent;
const faSquareUpRight = {
  prefix: 'fad',
  iconName: 'square-up-right',
  icon: [
    448,
    512,
    [8599, 'external-link-square-alt'],
    'f360',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 312c0-5.1 2-10 5.7-13.7L184 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6L304 160c8.8 0 16 7.2 16 16l0 137.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L248 296l-66.3 66.3C178 366 173.1 368 168 368s-10-2-13.7-5.7l-36.7-36.7C114 322 112 317.1 112 312z',
      'M320 176l0 137.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L248 296l-66.3 66.3C178 366 173.1 368 168 368s-10-2-13.7-5.7l-36.7-36.7C114 322 112 317.1 112 312s2-10 5.7-13.7L184 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6L304 160c8.8 0 16 7.2 16 16z',
    ],
  ],
};
const faExternalLinkSquareAlt = faSquareUpRight;
const faFaceKissBeam = {
  prefix: 'fad',
  iconName: 'face-kiss-beam',
  icon: [
    512,
    512,
    [128537, 'kiss-beam'],
    'f597',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm120-32c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6zm112.3 70c.9-3.5 4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 4.1-9.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c.1 0 .1-.1 .5-.3l.6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3c-.2-.1-.3-.2-.7-.4c-3.2-1.8-4.7-5.5-3.8-9zM280 224c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
    ],
  ],
};
const faKissBeam = faFaceKissBeam;
const faCorn = {
  prefix: 'fad',
  iconName: 'corn',
  icon: [
    512,
    512,
    [127805],
    'f6c7',
    [
      'M207.1 113.3c29.7 47.7 41.1 103.6 34.2 157.5c53.9-6.9 109.8 4.5 157.5 34.2c10.4-7.2 17.3-19.3 17.3-32.9c0-5.7-1.2-11.2-3.4-16.1c1.1 .1 2.2 .1 3.4 .1c22.1 0 40-17.9 40-40c0-6.4-1.5-12.4-4.2-17.8c16.3-5 28.2-20.2 28.2-38.2c0-6.4-1.5-12.4-4.2-17.8c16.3-5 28.2-20.2 28.2-38.2c0-11.4-4.8-21.8-12.5-29.1C503.7 68.1 512 55 512 40c0-22.1-17.9-40-40-40c-15 0-28.1 8.3-34.9 20.5C429.8 12.8 419.4 8 408 8c-18 0-33.2 11.8-38.2 28.2C364.4 33.5 358.4 32 352 32c-18 0-33.2 11.8-38.2 28.2C308.4 57.5 302.4 56 296 56c-22.1 0-40 17.9-40 40c0 1.1 0 2.3 .1 3.4C251.2 97.2 245.7 96 240 96c-13.6 0-25.7 6.8-32.9 17.3z',
      'M150.9 94.1c-4.3-4.8-12.1-2.4-13.2 3.9l-10.2 54.9c-4.7 25.4-17 48.8-35.3 67.1l-64 64c-36.4 36.4-37.5 94.7-3.2 132.4l77.4-77.4c30.4-30.4 66.9-50.9 105.5-61.6c12.6-69.3-11.5-132.9-56.9-183.4zM47.4 439.2l44.7 44.7c37.5 37.5 98.3 37.5 135.8 0l64-64c18.3-18.3 41.7-30.6 67.1-35.3L414 374.3c6.3-1.2 8.7-8.9 3.9-13.2c-53-47.6-120.7-71.6-192.8-55c-36.7 8.5-71.5 27-100.1 55.6L47.4 439.2z',
    ],
  ],
};
const faRollerCoaster = {
  prefix: 'fad',
  iconName: 'roller-coaster',
  icon: [
    640,
    512,
    [],
    'e324',
    [
      'M104 113.1c13.7-9.7 30.2-15.8 48-16.9L152 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.9zm96-7.2c7 3.5 13.5 7.8 19.5 12.9c3 2.6 5.8 5.3 8.4 8.3c1.3 1.5 2.6 3 3.8 4.5c.6 .8 1.2 1.6 1.8 2.4c.6 .8 1.2 1.6 1.7 2.4L248 154.7 248 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-350.1zm96 117.9c16 23 32 46.1 48 69.1L344 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232.2zm96 128.2c14.2 11.5 30.5 20.2 48 25.6l0 78.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104.1zM488 384l8 0c13.9 0 27.3-2 40-5.6l0 77.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72z',
      'M158.1 96c-52 0-94.1 42.1-94.1 94.1L64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 190.1C0 102.8 70.8 32 158.1 32c51.8 0 100.3 25.4 129.8 67.9l129 185.7c15 21.5 39.5 34.4 65.7 34.4l13.4 0c44.2 0 80-35.8 80-80c0-32.8-19.7-61-48-73.3l0 97.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-103.4c-14.2 1.5-28 5.8-40.7 12.5l-7.3 3.9 0 74.2L357.6 144.2l51.6-27.5C434.7 103.1 463.1 96 492 96l4 0c79.5 0 144 64.5 144 144c0 2.7-.1 5.4-.2 8l.2 0 0 200c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-88.2c-22.9 15.3-50.4 24.2-80 24.2l-13.4 0c-47.2 0-91.4-23.1-118.3-61.9l-129-185.7C217.7 111.1 188.9 96 158.1 96z',
    ],
  ],
};
const faPhotoFilmMusic = {
  prefix: 'fad',
  iconName: 'photo-film-music',
  icon: [
    640,
    512,
    [],
    'e228',
    [
      'M0 160L0 384c0 35.3 28.7 64 64 64l225.9 0c4.4-18.2 15.9-33.1 29.6-43.4c6.8-5.1 14.5-9.4 22.6-12.6L192 392c-17.7 0-32-14.3-32-32l0-264L64 96C28.7 96 0 124.7 0 160zm56 8c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm0 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm0 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM289.6 247c2.7 5.5 8.3 9 14.4 9l64 0 0-7.9c0-24.1 15.4-45.5 38.3-53.1l93.1-31-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9zM320 464c0 26.5 28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64c-9.8 3.3-16.4 12.4-16.4 22.8l0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48z',
      'M192 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9l64 0 0 64-112 0c-35.3 0-64-28.7-64-64l0-192zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faRadar = {
  prefix: 'fad',
  iconName: 'radar',
  icon: [
    512,
    512,
    [],
    'e024',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256l-64 0c0 89.9-61.7 165.3-145.1 186.2C298.2 463.8 279 480 256 480s-42.2-16.2-46.9-37.8c-65.5-16.5-117.7-66.6-137-130.9C49.3 307.6 32 287.8 32 264c0-22.3 15.2-41.1 35.9-46.4C85.7 129.9 163.1 64 256 64c44.4 0 85.2 15 117.7 40.3l45.5-45.5C374.9 22.1 318.1 0 256 0C114.6 0 0 114.6 0 256zm100-35.7c16.5 7.6 28 24.3 28 43.7c0 17.8-9.7 33.4-24.1 41.7c16.5 50.7 57.7 90.3 109.4 104.6c7.9-15.6 24.1-26.2 42.8-26.2s34.8 10.7 42.8 26.2C366.4 391.5 416 329.5 416 256l-64 0c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c17.8 0 34.5 4.8 48.8 13.3c15.4-15.4 30.7-30.7 46.1-46.1C324.3 107.6 291.5 96 256 96c-76.1 0-139.8 53.1-156 124.3z',
      'M497 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-182 182c-7.7-3.3-16.1-5.1-25-5.1c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-8.9-1.8-17.3-5.1-25L497 49z',
    ],
  ],
};
const faSickle = {
  prefix: 'fad',
  iconName: 'sickle',
  icon: [
    512,
    512,
    [],
    'f822',
    [
      'M128 181C128 81 209 0 309 0l11 0c90.1 0 165.8 62.1 186.4 145.8c.2 .9 .3 1.8 .3 2.7c0 6.2-5.2 11.4-11.9 11.4c-3.9 0-7.5-1.9-9.9-4.9C458.9 122.9 419.5 104 377.8 104C301.7 104 240 165.7 240 241.8l0 9.8c0 20.7 5.2 39.7 12.2 58.6c2.2 6 .9 12.8-3.7 17.3L224 352l-23 23-16-16-32-32-16-16 24.8-24.8C139.9 255.8 128 219 128 181z',
      'M129 303c-9.4-9.4-24.6-9.4-33.9 0L79 319c-9.4 9.4-9.4 24.6 0 33.9l7 7L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l79-79 7 7c9.4 9.4 24.6 9.4 33.9 0l16-16c9.4-9.4 9.4-24.6 0-33.9l-24-24-32-32-24-24z',
    ],
  ],
};
const faFilm = {
  prefix: 'fad',
  iconName: 'film',
  icon: [
    512,
    512,
    [127902],
    'f008',
    [
      'M160 128l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L192 96c-17.7 0-32 14.3-32 32zm0 192l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z',
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM48 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM160 128l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L192 96c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0z',
    ],
  ],
};
const faCoconut = {
  prefix: 'fad',
  iconName: 'coconut',
  icon: [
    512,
    512,
    [],
    'e2f6',
    [
      'M97.6 323.9c5.9 5.9 14.5 8.7 24.8 8.7c33.4 0 85.9-29 133.5-76.6c62.5-62.5 92.9-133.4 67.9-158.4s-95.9 5.4-158.4 67.9S72.6 298.9 97.6 323.9z',
      'M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zM395.2 28.8C361.5-4.8 309.6-5.7 260.4 9.5C210 25 155.3 59.1 107.2 107.2S25 209.9 9.5 260.3C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512c143.1 0 259-116 259-259c0-68.7-27.3-134.6-75.9-183.2L395.2 28.8zm24.1 175.8l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 136l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-136 56l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z',
    ],
  ],
};
const faRulerHorizontal = {
  prefix: 'fad',
  iconName: 'ruler-horizontal',
  icon: [
    640,
    512,
    [],
    'f547',
    [
      'M0 176L0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48z',
      'M144 208l0-80-32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16zm96-80l-32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zm96 80l0-80-32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16zm96-80l-32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zm96 0l-32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faShieldCross = {
  prefix: 'fad',
  iconName: 'shield-cross',
  icon: [
    512,
    512,
    [9960],
    'f712',
    [
      'M16 139.7c0-26.1 16.4-47.6 38.3-56.9L224 10.8c0 39.1 0 78.1 0 117.2c0 .1 0 .3 0 .7c0 .1 0 .5 0 .9c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.2-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2s-6.3 5.2-10.2 6.9c-1.9 .8-3.9 1.4-6 1.9c-1 .2-2.1 .4-3.2 .5s-2.2 .2-3.3 .2c-58.5 0-116.9 0-175.4 0c-.4-7-.6-13.7-.6-20.3zM24.7 224c55.7 0 111.5 0 167.3 0c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.4c0 .4 .1 .8 .1 1c0 .1 0 .3 0 .4c0 .5 0 .8 0 .9c0 .2 0 .5 0 .7c0 81.5 0 162.9 0 244.4C97.4 437.2 43.7 319.9 24.7 224zM288 10.8c56.6 24 113.1 48 169.7 72C479.6 92.1 496 113.6 496 140c0 6.4-.2 13-.6 20c-58.5 0-117 0-175.4 0c-17.7 0-32-14.3-32-32c0-39.1 0-78.1 0-117.2zM288 256c0-17.7 14.3-32 32-32c55.8 0 111.5 0 167.3 0c-19 95.9-72.7 213.2-199.3 276.4c0-81.5 0-163 0-244.4z',
      'M288 10.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L224 10.8 224 128c0 17.7-14.3 32-32 32L16.6 160c1.1 19.4 3.6 41.1 8.1 64L192 224c17.7 0 32 14.3 32 32l0 244.4c1.9 .9 3.7 1.8 5.6 2.7c16.7 8 36.1 8 52.8 0c1.9-.9 3.8-1.8 5.6-2.7L288 256c0-17.7 14.3-32 32-32l167.3 0c4.5-22.9 7.1-44.6 8.1-64L320 160c-17.7 0-32-14.3-32-32l0-117.2z',
    ],
  ],
};
const faCassetteTape = {
  prefix: 'fad',
  iconName: 'cassette-tape',
  icon: [
    576,
    512,
    [128429],
    'f8ab',
    [
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-28.9 0-36.3-96.9c-7-18.7-24.9-31.1-44.9-31.1l-227.6 0c-20 0-37.9 12.4-44.9 31.1L92.9 480 64 480c-35.3 0-64-28.7-64-64L0 96zM80 208c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-256 0c-44.2 0-80 35.8-80 80zm47.1 272l32.1-85.6c2.3-6.2 8.3-10.4 15-10.4l227.6 0c6.7 0 12.6 4.1 15 10.4L448.9 480l-321.8 0z',
      'M240 208c0 11.4-2.4 22.2-6.7 32l109.3 0c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32l-109.3 0c4.3 9.8 6.7 20.6 6.7 32zm176 80l-256 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80zM160 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm272-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faSquareTerminal = {
  prefix: 'fad',
  iconName: 'square-terminal',
  icon: [
    448,
    512,
    [],
    'e32a',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64.4 67.7c-.1 .7-.2 1.4-.3 2.2s-.1 1.4-.1 2.1c0 1.7 .2 3.3 .5 4.9s.8 3.2 1.5 4.7c1.3 3 3.2 5.8 5.8 8.2L148.5 256 71.8 326.3c-2.6 2.4-4.5 5.2-5.8 8.2c-.7 1.5-1.1 3.1-1.5 4.7s-.5 3.2-.5 4.8c0 .8 0 1.5 .1 2.2s.2 1.4 .3 2.2c.3 1.4 .7 2.8 1.2 4.2c1 2.8 2.6 5.4 4.7 7.7c9 9.8 24.1 10.4 33.9 1.5c32-29.3 64-58.7 96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7c-32-29.3-64-58.7-96-88c-9.8-9-25-8.3-33.9 1.5c-2.1 2.3-3.7 4.9-4.7 7.7c-.5 1.4-.9 2.8-1.2 4.2zM192 360c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z',
      'M71.8 185.7c-9.8-9-10.4-24.1-1.5-33.9s24.1-10.4 33.9-1.5l96 88c5 4.5 7.8 11 7.8 17.7s-2.8 13.1-7.8 17.7l-96 88c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L148.5 256 71.8 185.7zM216 336l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faPeopleRobbery = {
  prefix: 'fad',
  iconName: 'people-robbery',
  icon: [
    576,
    512,
    [],
    'e536',
    [
      'M241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6L328 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-305.7c38.1-20 67.3-55.6 78.3-99.6L559 39.8c.7-2.6 1-5.2 1-7.8c0-14.3-9.7-27.4-24.2-31C518.6-3.3 501.2 7.1 497 24.2l-8.7 34.9C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8zM352 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM8 192c0-35.3 28.7-64 64-64l32.7 0c27.4 0 52.9 14 67.5 37.1L209.6 224l30.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0c-11 0-21.1-5.6-27-14.9l-13-20.5L152 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L8 288.6l0-.6 0-96z',
    ],
  ],
};
const faLightbulb = {
  prefix: 'fad',
  iconName: 'lightbulb',
  icon: [
    384,
    512,
    [128161],
    'f0eb',
    [
      'M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176zm64 0c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
      'M192 512c44.2 0 80-35.8 80-80V384H112v48c0 44.2 35.8 80 80 80z',
    ],
  ],
};
const faCaretLeft = {
  prefix: 'fad',
  iconName: 'caret-left',
  icon: [
    256,
    512,
    [],
    'f0d9',
    [
      'M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z',
      '',
    ],
  ],
};
const faCommentMiddle = {
  prefix: 'fad',
  iconName: 'comment-middle',
  icon: [
    512,
    512,
    [],
    'e149',
    [
      'M188.3 408.7l44.5 89c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3l44.5-89C432.2 384.5 512 303.8 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 95.8 79.8 176.5 188.3 200.7z',
      '',
    ],
  ],
};
const faTrashCanList = {
  prefix: 'fad',
  iconName: 'trash-can-list',
  icon: [
    640,
    512,
    [],
    'e2ab',
    [
      'M32 96l0 368c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-368L32 96zm96 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm128 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z',
      'M119.2 17.7C124.6 6.8 135.7 0 147.8 0L268.2 0c12.1 0 23.2 6.8 28.6 17.7L304 32l80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l80 0 7.2-14.3zM480 128l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM448 416c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faBlock = {
  prefix: 'fad',
  iconName: 'block',
  icon: [
    448,
    512,
    [],
    'e46a',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm48 8a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM352 104a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M72 128a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm304 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faCircleExclamation = {
  prefix: 'fad',
  iconName: 'circle-exclamation',
  icon: [
    512,
    512,
    ['exclamation-circle'],
    'f06a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faExclamationCircle = faCircleExclamation;
const faSchoolCircleXmark = {
  prefix: 'fad',
  iconName: 'school-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e56d',
    [
      'M0 144L0 464c0 26.5 21.5 48 48 48l272 0-64 0 0-96c0-35.3 28.7-64 64-64l.7 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4C332.4 1.8 326.2 0 320 0s-12.4 1.8-17.8 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144zm80 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM304 144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faArrowRightFromBracket = {
  prefix: 'fad',
  iconName: 'arrow-right-from-bracket',
  icon: [
    512,
    512,
    ['sign-out'],
    'f08b',
    [
      'M0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128z',
      'M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 192 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l210.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z',
    ],
  ],
};
const faSignOut = faArrowRightFromBracket;
const faFaceFrownSlight = {
  prefix: 'fad',
  iconName: 'face-frown-slight',
  icon: [
    512,
    512,
    [],
    'e376',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM139.9 373.5c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faCircleChevronDown = {
  prefix: 'fad',
  iconName: 'circle-chevron-down',
  icon: [
    512,
    512,
    ['chevron-circle-down'],
    'f13a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-32c0-6.1 2.3-12.3 7-17s10.8-7 17-7s12.3 2.3 17 7l87 87 87-87c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17L273 345c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L135 241c-4.7-4.7-7-10.8-7-17z',
      'M239 345c9.4 9.4 24.6 9.4 33.9 0L377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345z',
    ],
  ],
};
const faChevronCircleDown = faCircleChevronDown;
const faSidebarFlip = {
  prefix: 'fad',
  iconName: 'sidebar-flip',
  icon: [
    512,
    512,
    [],
    'e24f',
    [
      'M0 96C0 60.7 28.7 32 64 32l224 0 0 448L64 480c-35.3 0-64-28.7-64-64L0 96z',
      'M448 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-160 0 0-448 160 0zM424 96l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24zm-24 72l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
    ],
  ],
};
const faUnlockKeyhole = {
  prefix: 'fad',
  iconName: 'unlock-keyhole',
  icon: [
    448,
    512,
    ['unlock-alt'],
    'f13e',
    [
      'M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144z',
      'M64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 192zM256 384l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z',
    ],
  ],
};
const faUnlockAlt = faUnlockKeyhole;
const faTemperatureList = {
  prefix: 'fad',
  iconName: 'temperature-list',
  icon: [
    512,
    512,
    [],
    'e299',
    [
      'M0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L256 112C256 50.2 205.9 0 144 0S32 50.2 32 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368zm64 0c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5L96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M320 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L352 96c-17.7 0-32-14.3-32-32zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L128 176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 146.7c18.6 6.6 32 24.4 32 45.3zM352 160l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faCloudShowersHeavy = {
  prefix: 'fad',
  iconName: 'cloud-showers-heavy',
  icon: [
    512,
    512,
    [],
    'f740',
    [
      'M1.9 478.5c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5c-3.1-1.3-6.3-1.9-9.4-1.9c-9.3 0-18.2 5.5-22.1 14.6l-48 112zm120 0c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5c-3.1-1.3-6.3-1.9-9.4-1.9c-9.3 0-18.2 5.5-22.1 14.6l-48 112zm112 0c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5c-3.1-1.3-6.3-1.9-9.4-1.9c-9.3 0-18.2 5.5-22.1 14.6l-48 112zm120 0c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c1.3-3.1 1.9-6.3 1.9-9.4c0-9.3-5.5-18.2-14.6-22.1c-3.1-1.3-6.3-1.9-9.4-1.9c-9.3 0-18.2 5.5-22.1 14.6l-48 112z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faHeadphonesSimple = {
  prefix: 'fad',
  iconName: 'headphones-simple',
  icon: [
    512,
    512,
    ['headphones-alt'],
    'f58f',
    [
      'M0 288L0 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104C48 173.1 141.1 80 256 80s208 93.1 208 208l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104C512 146.6 397.4 32 256 32S0 146.6 0 288z',
      'M144 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l16 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-16 0zm224 0l-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l16 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64z',
    ],
  ],
};
const faHeadphonesAlt = faHeadphonesSimple;
const faSitemap = {
  prefix: 'fad',
  iconName: 'sitemap',
  icon: [
    576,
    512,
    [],
    'f0e8',
    [
      'M56 288l0 32 48 0 0-32c0-4.4 3.6-8 8-8l152 0 0 40 48 0 0-40 152 0c4.4 0 8 3.6 8 8l0 32 48 0 0-32c0-30.9-25.1-56-56-56l-152 0 0-40-48 0 0 40-152 0c-30.9 0-56 25.1-56 56z',
      'M208 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64zM48 320l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm208 0l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm208 0l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faPipeSection = {
  prefix: 'fad',
  iconName: 'pipe-section',
  icon: [
    640,
    512,
    [],
    'e438',
    [
      'M64 128l0 256 512 0 0-256L64 128z',
      'M64 128c0-17.7-14.3-32-32-32S0 110.3 0 128L0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256zm576 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256z',
    ],
  ],
};
const faSpaceStationMoonConstruction = {
  prefix: 'fad',
  iconName: 'space-station-moon-construction',
  icon: [
    512,
    512,
    ['space-station-moon-alt'],
    'e034',
    [
      'M0 256c0 7.8 .3 15.5 1 23.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c.7-7.6 1-15.3 1-23.1c0-10.8-.7-21.5-2-32l-62 0 0-64-80 0 0-64 48 0 0-39.9C372.2 21 316.5 0 256 0C114.6 0 0 114.6 0 256zm6.8 58.8C33.4 427.9 134.9 512 256 512c76.5 0 145.1-33.5 192-86.7l0-41.3-64 0 0-41.2c-40.7 6-83.7 9.2-128 9.2c-91.3 0-176.6-13.6-249.2-37.2zM272 160a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
      'M224 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM6.8 314.8C4.1 303.2 2.1 291.3 1 279.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c-1.1 12.2-3 24.1-5.8 35.8C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2z',
    ],
  ],
};
const faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
const faCircleDollarToSlot = {
  prefix: 'fad',
  iconName: 'circle-dollar-to-slot',
  icon: [
    512,
    512,
    ['donate'],
    'f4b9',
    [
      'M48 208a208 208 0 1 0 416 0A208 208 0 1 0 48 208zm140.2-41.4c.1-1.3 .2-2.5 .4-3.7c.3-2.4 .9-4.8 1.5-7c1.3-4.5 3.2-8.5 5.6-12.2c4.7-7.3 11.2-13 18.2-17.1c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c0 .7 0 1.3 0 1.9s0 1.3-.1 1.9c-.1 1.3-.2 2.5-.3 3.7c-.3 2.4-.7 4.8-1.3 7c-1.2 4.5-3 8.6-5.2 12.4c-4.4 7.5-10.7 13.5-17.9 18c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c0-.7 0-1.3 0-2s.1-1.3 .1-1.9z',
      'M276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9zM64 352l-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0c-19.4 25.9-44 47.7-72.2 64l72.2 0 0 32-192 0L64 448l0-32 72.2 0C108 399.7 83.4 377.9 64 352z',
    ],
  ],
};
const faDonate = faCircleDollarToSlot;
const faMemory = {
  prefix: 'fad',
  iconName: 'memory',
  icon: [
    576,
    512,
    [],
    'f538',
    [
      'M0 128l0 7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6L0 320l576 0 0-71.4c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3l0-7.4c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm128 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm128 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm128 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64z',
      'M192 160l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 416l0-96 576 0 0 96c0 17.7-14.3 32-32 32l-48 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-96 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-96 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-96 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-48 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faFaceSleeping = {
  prefix: 'fad',
  iconName: 'face-sleeping',
  icon: [
    512,
    512,
    [],
    'e38d',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-46.6-12.5-90.3-34.2-128L432 128c-19.4 0-36.9-11.7-44.3-29.6c-7.1-17.1-3.7-36.7 8.6-50.4c-2.9-3.2-5.4-6.9-7.3-10.8C350.2 13.6 304.7 0 256 0C114.6 0 0 114.6 0 256zm99.2 1.6c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0zM296 384a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM256.3 76.8c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7l64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4c-12.2 12.2-24.5 24.5-36.7 36.7l25.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4c12.2-12.2 24.5-24.5 36.7-36.7L272 96c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.8c0-.4 0-1 .1-1.5s.1-1.1 .2-1.6zm34.9 180.8c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0z',
      'M416 16c0 8.8 7.2 16 16 16l25.4 0L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0L432 0c-8.8 0-16 7.2-16 16zM256 80c0 8.8 7.2 16 16 16l25.4 0-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-64 0c-8.8 0-16 7.2-16 16zM387.2 238.4c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm-262.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0z',
    ],
  ],
};
const faRoadSpikes = {
  prefix: 'fad',
  iconName: 'road-spikes',
  icon: [
    640,
    512,
    [],
    'e568',
    [
      'M32 114.8L32 384l128 0 34.5 0 93.5 0 34.5 0 93.5 0 34.5 0L608 384c0-29.8-9.2-58.8-26.2-83.2L445.1 105.6c-9-12.8-29.1-6.5-29.1 9.2l0 132.1L317.1 105.6c-9-12.8-29.1-6.5-29.1 9.2l0 132.1L189.1 105.6c-9-12.8-29.1-6.5-29.1 9.2l0 132.1L61.1 105.6c-9-12.8-29.1-6.5-29.1 9.2z',
      'M0 416c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faFireBurner = {
  prefix: 'fad',
  iconName: 'fire-burner',
  icon: [
    640,
    512,
    [],
    'e4f1',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l576 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-104c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 80L80 384l0-80 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 104c-17.7 0-32 14.3-32 32zm224 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M358 34.5L345.7 48.3l-19-19.9c-2-2.1-4-4.4-6-6.7C311.8 11.4 302.1 .4 288 0c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C176 118.8 160 154.8 160 192.2C160 280.7 230.4 352 320 352c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9zM320 304.2c-35.3 0-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C347 167.1 384 203.6 384 240.2c0 35.3-28.7 64-64 64z',
    ],
  ],
};
const faSquirrel = {
  prefix: 'fad',
  iconName: 'squirrel',
  icon: [
    512,
    512,
    [],
    'f71a',
    [
      'M0 144c0 79.5 64.5 144 144 144c2.3 0 4.6-.1 6.9-.2c4.9-.2 9.1 3.5 9.1 8.4c0 2-.7 3.9-2 5.4c-18.7 22.3-30 51-30 82.3c0 70.7 57.3 128 128 128c16 0 32 0 48 0c-62-.6-112-51-112-113.1l0-3.8c0-27.6 11-54.1 30.5-73.6l7-7c1.5-1.5 3-3 4.5-4.5s2.9-3.1 4.4-4.6c2.9-3.1 5.7-6.3 8.4-9.5c5.5-6.4 10.6-13.1 15.5-19.9c9.8-13.6 18.4-28 25.8-43l0-88.9C288 64.5 223.5 0 144 0S0 64.5 0 144z',
      'M320 75.2C320 69 325 64 331.2 64c15.2 0 28.7 7.6 36.8 19.2C376.1 71.6 389.6 64 404.8 64C411 64 416 69 416 75.2L416 96c53 0 96 43 96 96l-8.2 12.4c-14.8 22.3-39.8 35.6-66.6 35.6L416 240l0 58.8c-14.5-6.9-30.8-10.8-48-10.8c-13.1 0-25.6 2.2-37.3 6.4c-8.3 2.9-12.7 12.1-9.8 20.4s12.1 12.7 20.4 9.8c8.3-2.9 17.3-4.5 26.7-4.5c18 0 34.6 6 48 16c19.4 14.6 32 37.8 32 64c0 18-6 34.6-16 48l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-72 0-24 0-32 0-14.9 0-1.1 0s0 0 0 0c-62-.6-112-51-112-113.1l0-3.8c0-27.6 11-54.1 30.5-73.6l7-7C287.4 256.6 320 178 320 96l0-20.8zM416 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faArrowUpToLine = {
  prefix: 'fad',
  iconName: 'arrow-up-to-line',
  icon: [
    384,
    512,
    ['arrow-to-top'],
    'f341',
    [
      'M0 64C0 46.3 14.3 32 32 32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64z',
      'M169.4 169.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 269.3 224 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-178.7L86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z',
    ],
  ],
};
const faArrowToTop = faArrowUpToLine;
const faFlag = {
  prefix: 'fad',
  iconName: 'flag',
  icon: [
    448,
    512,
    [127988, 61725],
    'f024',
    [
      'M64 48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 247.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-20.1 7.6-41.3 11.3-62.3 11.3c-27.3 0-54.5-6.3-79.4-18.7c-37.9-19-81.3-23.7-122.5-13.4L64 352 64 48z',
      'M32 0C49.7 0 64 14.3 64 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0z',
    ],
  ],
};
const faFaceCowboyHat = {
  prefix: 'fad',
  iconName: 'face-cowboy-hat',
  icon: [
    512,
    512,
    [],
    'e36e',
    [
      'M48 304c0-49.4 17.2-94.7 45.9-130.4c21.3 15.6 46.2 28.2 73.6 36.9c13.7 4.3 28 7.7 42.8 10c7.4 1.1 14.9 2 22.5 2.6c3.8 .3 7.6 .5 11.4 .7s7.7 .2 11.7 .2c62.5 0 119.4-19.1 162.1-50.4c28.7 35.7 45.9 81 45.9 130.4c0 114.9-93.1 208-208 208S48 418.9 48 304zm98 79.5C166.2 424.1 208 452 256.2 452s90-27.9 110.2-68.6c5.7-11.5-6.2-22.2-18.6-18.8c-27.9 7.8-59 12.1-91.6 12.1s-63.7-4.3-91.6-12.1c-12.4-3.5-24.3 7.3-18.6 18.8zM168 296a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm128 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M133.6 109.8C148.6 64.9 179.2 0 216 0c9.1 0 17.9 4 26.1 10.7c7.9 6.5 19.8 6.5 27.7 0C278.1 4 286.9 0 296 0c36.8 0 67.4 64.9 82.4 109.8C412 99.3 442 84.6 466.9 66.8c2.5-1.8 5.4-2.8 8.4-2.8c8.9 0 15.6 8.3 12.9 16.7C461.2 163.2 367.5 224 256 224S50.8 163.2 23.8 80.7C21 72.3 27.7 64 36.7 64c3 0 6 1 8.4 2.8C70 84.6 100 99.3 133.6 109.8zM168 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faHanukiah = {
  prefix: 'fad',
  iconName: 'hanukiah',
  icon: [
    640,
    512,
    [128334],
    'f6e6',
    [
      'M8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3C21.1 60.1 8 84.6 8 104zm80 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C165.1 60.1 152 84.6 152 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zm80-48c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3C309.1 12.1 296 36.6 296 56zm80 48c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C389.1 60.1 376 84.6 376 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C517.1 60.1 504 84.6 504 104zm80 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104z',
      'M352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176L96 320c-17.7 0-32-14.3-32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 53 43 96 96 96l192 0 0 64-128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-64 192 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32l-192 0 0-176zM128 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96z',
    ],
  ],
};
const faChartScatter3d = {
  prefix: 'fad',
  iconName: 'chart-scatter-3d',
  icon: [
    512,
    512,
    [],
    'e0e8',
    [
      'M32 448c0 7.2 2.4 14.5 7.4 20.5c11.3 13.6 31.5 15.4 45.1 4.1L256 329.7 427.5 472.6c13.6 11.3 33.8 9.5 45.1-4.1s9.5-33.8-4.1-45.1L288 273l0-209c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 209L43.5 423.4C35.9 429.7 32 438.8 32 448z',
      'M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faDisplayChartUp = {
  prefix: 'fad',
  iconName: 'display-chart-up',
  icon: [
    576,
    512,
    [],
    'e5e3',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0 96 0 176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 0l448 0 0 288L64 352 64 64z',
      'M64 64l448 0 0 288L64 352 64 64zM346.7 448l69.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416l96 0 10.7 32zM344 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l71-71 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l95-95 0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24l-96 0z',
    ],
  ],
};
const faSquareCode = {
  prefix: 'fad',
  iconName: 'square-code',
  icon: [
    448,
    512,
    [],
    'e267',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 256c0 6.8 2.9 13.3 7.9 17.8c26.7 24 53.3 48 80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9c-20.1-18.1-40.1-36.1-60.2-54.2c20.1-18.1 40.1-36.1 60.2-54.2c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8c-26.7 24-53.3 48-80 72c-5.1 4.6-7.9 11-7.9 17.8zm198.2-88.1c-8.9 9.9-8.1 25 1.8 33.9c20.1 18.1 40.1 36.1 60.2 54.2c-20.1 18.1-40.1 36.1-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8c26.7-24 53.3-48 80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8c-26.7-24-53.3-48-80-72c-9.9-8.9-25-8.1-33.9 1.8z',
      'M184.1 201.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L123.9 256l60.2-54.2zm79.9 0L324.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9z',
    ],
  ],
};
const faFeather = {
  prefix: 'fad',
  iconName: 'feather',
  icon: [
    512,
    512,
    [129718],
    'f52d',
    [
      'M64 330l0 84c82.4-82.4 164.7-164.7 247-247c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17L97.9 448l84 0c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330z',
      'M24 512c-6.2 0-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9L311 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-4.7 4.7-10.8 7-17 7z',
    ],
  ],
};
const faVolumeLow = {
  prefix: 'fad',
  iconName: 'volume-low',
  icon: [
    448,
    512,
    [128264, 'volume-down'],
    'f027',
    [
      'M378.8 185c4.7-5.8 11.7-8.9 18.6-8.9c5.3 0 10.7 1.8 15.1 5.4C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-4.5 3.6-9.8 5.4-15.1 5.4c-7 0-13.9-3-18.6-8.9c-8.4-10.3-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8z',
      'M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160 64 160c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l67.8 0L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448l0-384z',
    ],
  ],
};
const faVolumeDown = faVolumeLow;
const faXmarkToSlot = {
  prefix: 'fad',
  iconName: 'xmark-to-slot',
  icon: [
    576,
    512,
    ['times-to-slot', 'vote-nay'],
    'f771',
    [
      'M96 80l0 208 0 80 0 32 384 0 0-32 0-80 0-208c0-26.5-21.5-48-48-48L144 32c-26.5 0-48 21.5-48 48zm111 55c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l47 47 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
      'M207 135c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9zM48 288l48 0 0 80-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-80 48 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faTimesToSlot = faXmarkToSlot;
const faVoteNay = faXmarkToSlot;
const faBoxTaped = {
  prefix: 'fad',
  iconName: 'box-taped',
  icon: [
    448,
    512,
    ['box-alt'],
    'f49a',
    [
      'M0 160l160 0L192 32 93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160zm160 0l128 0 0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96zM256 32l32 128 160 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L256 32z',
      'M160 160L0 160 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256-160 0 0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96z',
    ],
  ],
};
const faBoxAlt = faBoxTaped;
const faCommentSlash = {
  prefix: 'fad',
  iconName: 'comment-slash',
  icon: [
    640,
    512,
    [],
    'f4b3',
    [
      'M64 240c0-27.8 6.7-54.4 18.9-78.7L424.1 430.1C392.3 441.6 357 448 320 448c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C137.6 471.1 108.7 480 80 480c-6.5 0-12.3-3.9-14.8-9.9c-.8-2-1.2-4.1-1.2-6.1c0-4.2 1.6-8.2 4.7-11.3l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C81.7 326.8 64 285.1 64 240zM144.9 88.3C190.7 53.4 252.3 32 320 32c141.4 0 256 93.1 256 208c0 52.3-23.8 100.2-63.1 136.7c-122.7-96.1-245.3-192.3-368-288.5z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faSwords = {
  prefix: 'fad',
  iconName: 'swords',
  icon: [
    512,
    512,
    [9876],
    'f71d',
    [
      'M.3 19.1L14.4 89.6c1.9 9.3 6.4 17.8 13.1 24.5L329.4 416 416 329.4 114.2 27.5c-6.7-6.7-15.2-11.3-24.5-13.1L19.1 .3C13.9-.7 8.5 .9 4.7 4.7S-.7 13.9 .3 19.1zM96 329.4c28.9 28.9 57.7 57.7 86.6 86.6l50.7-50.7-86.6-86.6L96 329.4zM278.6 146.7l86.6 86.6L484.5 114.2c6.7-6.7 11.3-15.2 13.1-24.5l14.1-70.5c.2-1 .3-2.1 .3-3.1c0-4.2-1.7-8.3-4.7-11.3c-3.8-3.8-9.2-5.4-14.5-4.4L422.4 14.4c-9.3 1.9-17.8 6.4-24.5 13.1L278.6 146.7z',
      'M75.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-4.7 4.7-6 11.8-3.3 17.8l27.5 62L4.7 460.7c-6.2 6.2-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2 62 27.5c6 2.7 13.1 1.4 17.8-3.3l16-16c6.2-6.2 6.2-16.4 0-22.6l-128-128zm361.4 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6l16 16c4.7 4.7 11.8 6 17.8 3.3l62-27.5 56.2 56.2c6.2 6.2 16.4 6.2 22.6 0l24-24c6.2-6.2 6.2-16.4 0-22.6l-56.2-56.2 27.5-62c2.7-6.1 1.4-13.1-3.3-17.8l-16-16c-6.2-6.2-16.4-6.2-22.6 0z',
    ],
  ],
};
const faCloudSunRain = {
  prefix: 'fad',
  iconName: 'cloud-sun-rain',
  icon: [
    640,
    512,
    [127782],
    'f743',
    [
      'M0 128c0 3.2 1 6.4 2.9 9.2L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-19.9-22-32.3-50.9-33.1-82.7c-28.7-16.6-48-47.6-48-83.2c0-53 43-96 96-96c18.4 0 35.6 5.2 50.2 14.1c13.2-21.9 32.7-39.5 56-50.3L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1c-2-.8-4.1-1.2-6.2-1.2c-3.2 0-6.4 1-9.2 2.9L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6c-.8 2-1.2 4.1-1.2 6.2zm144 80c0 18.5 7.8 35.1 20.3 46.8c10.6-39.7 39.9-71.8 77.8-86.4c.8-4.3 1.8-8.4 3-12.6C234.7 148.4 221.8 144 208 144c-35.3 0-64 28.7-64 64zm68.1 266.7c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-32 48zm96 0c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-32 48zm96 0c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-32 48zm96 0c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c2.7-4.1 4-8.7 4-13.3c0-7.8-3.8-15.4-10.7-20c-11-7.4-25.9-4.4-33.3 6.7l-32 48z',
      'M559.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 114.6 402.8 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96l271.9 0z',
    ],
  ],
};
const faAlbum = {
  prefix: 'fad',
  iconName: 'album',
  icon: [
    448,
    512,
    [128189],
    'f89f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM384 256A160 160 0 1 1 64 256a160 160 0 1 1 320 0z',
      'M224 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faCircleN = {
  prefix: 'fad',
  iconName: 'circle-n',
  icon: [
    512,
    512,
    [],
    'e118',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-10.5 6.8-19.8 16.8-22.9s20.9 .6 26.9 9.2c33.4 48.3 66.8 96.6 100.3 144.8L304 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.5-6.8 19.8-16.8 22.9c-2.4 .7-4.8 1.1-7.2 1.1c-7.7 0-15.2-3.7-19.7-10.3c-33.4-48.3-66.8-96.6-100.3-144.8L208 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z',
      'M176.8 129.1c10-3.1 20.9 .6 26.9 9.2L304 283.2 304 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8 208 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.5 6.8-19.8 16.8-22.9z',
    ],
  ],
};
const faCompress = {
  prefix: 'fad',
  iconName: 'compress',
  icon: [
    448,
    512,
    [],
    'f066',
    [
      'M0 352c0 17.7 14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM288 64l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z',
    ],
  ],
};
const faWheatAwn = {
  prefix: 'fad',
  iconName: 'wheat-awn',
  icon: [
    512,
    512,
    ['wheat-alt'],
    'e2cd',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l68.9-68.9c-3.5-3.5-6.9-6.9-10.4-10.4c-4.8-4.8-9.6-9.6-14.4-14.4c-6.8-6.8-13.6-13.6-20.4-20.4L9.4 457.4C3.1 463.6 0 471.8 0 480zM145.7 368.1c1-.3 2-.6 2.9-.8c1-.3 2-.5 3-.7c2-.5 3.9-.9 5.9-1.2c4-.7 7.9-1.3 11.9-1.6c8-.7 16.1-.7 24.1 .1c10.6-10.6 21.3-21.3 31.9-31.9c-3.5-3.5-6.9-6.9-10.4-10.4c-11.6-11.6-23.2-23.2-34.8-34.8l-30.5 30.5c2.1 17 .8 34.4-4 51zM247.5 266.3c2-.6 4-1.1 5.9-1.5s3.9-.9 5.9-1.2c4-.7 8-1.3 12-1.7c8-.7 16.1-.7 24.1 .1c10.6-10.6 21.3-21.3 31.9-31.9l-10.4-10.4L294.2 197l-12.2-12.2-30.5 30.5c2.1 17 .8 34.4-4 51zM329.1 52.9c10.5 14.1 17.7 29.9 21.6 46.3L409 41c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7L329.1 52.9zM383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7L383 95zm28.6 67.4c16.6 3.6 32.7 10.5 47.1 20.8L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4z',
      'M282.8 27.3c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6s0 0 0 0l-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8l11.3-11.3zM203.6 129.1L215 140.5c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0L215 321.5s0 0 0 0l-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8L181 129.1c6.2-6.2 16.4-6.2 22.6 0zM79.2 231c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5L282.8 412c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6s0 0 0 0L67.9 378c-37.5-37.5-37.5-98.3 0-135.8L79.2 231z',
    ],
  ],
};
const faWheatAlt = faWheatAwn;
const faAnkh = {
  prefix: 'fad',
  iconName: 'ankh',
  icon: [
    320,
    512,
    [9765],
    'f644',
    [
      'M128 320l19.4 0 25.1 0 19.4 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160z',
      'M160 64c-35.3 0-64 28.7-64 64c0 41.6 20.7 76.6 46.6 104.1c5.9 6.2 11.8 11.8 17.4 16.7c5.6-4.9 11.5-10.5 17.4-16.7C203.3 204.6 224 169.6 224 128c0-35.3-28.7-64-64-64zM32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 52.4-21.5 95.5-46.8 128l46.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-115.4 0-25.1 0L32 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l46.8 0C53.5 223.5 32 180.4 32 128z',
    ],
  ],
};
const faHandsHoldingChild = {
  prefix: 'fad',
  iconName: 'hands-holding-child',
  icon: [
    640,
    512,
    [],
    'e4fa',
    [
      'M0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c-5.1-5.1-10.2-10.2-15.2-15.2l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40c0-22.1-17.9-40-40-40S0 81.9 0 104zM352 385.1l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c-8.5 8.5-16.9 16.9-25.4 25.4c-21 21-32.8 49.5-32.8 79.2z',
      'M280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM384.5 181l-19.8-16.7L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35-7.6 0-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8L266 109.2c10.1-8.5 22.9-13.2 36.2-13.2l35.6 0c13.2 0 26 4.7 36.2 13.2l41.5 35.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8z',
    ],
  ],
};
const faAsterisk = {
  prefix: 'fad',
  iconName: 'asterisk',
  icon: [
    384,
    512,
    [10033, 61545],
    '2a',
    [
      'M192 32c17.7 0 32 14.3 32 32l0 135.5 111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5 224 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-135.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5 160 64c0-17.7 14.3-32 32-32z',
      '',
    ],
  ],
};
const faKeySkeletonLeftRight = {
  prefix: 'fad',
  iconName: 'key-skeleton-left-right',
  icon: [
    640,
    512,
    [],
    'e3b4',
    [
      'M0 384c0 70.7 57.3 128 128 128c59.6 0 109.8-40.8 124-96l196 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-68 0c-14.2-55.2-64.3-96-124-96C57.3 256 0 313.3 0 384zm192 0A64 64 0 1 1 64 384a64 64 0 1 1 128 0z',
      'M512 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 192c70.7 0 128-57.3 128-128S582.7 0 512 0C452.4 0 402.2 40.8 388 96L192 96c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 68 0c14.2 55.2 64.3 96 124 96z',
    ],
  ],
};
const faCommentLines = {
  prefix: 'fad',
  iconName: 'comment-lines',
  icon: [
    512,
    512,
    [],
    'f4b0',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm128-40c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24z',
      'M128 200c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faLuchadorMask = {
  prefix: 'fad',
  iconName: 'luchador-mask',
  icon: [
    448,
    512,
    ['luchador', 'mask-luchador'],
    'f455',
    [
      'M64 208c0 44.2 35.8 80 80 80l13.3 0c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7l13.3 0c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48l-32 0c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80l-32 0c-26.5 0-48 21.5-48 48zm32 0c0-8.8 7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16l-32 0c-26.5 0-48-21.5-48-48zm32 176c0-17.7 14.3-32 32-32l35.3 0 57.4 0 35.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32zm56-75.3c0-3 1.2-5.9 3.3-8l8-8 4.2-4.2 .4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4 .4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8c0 6.2-5.1 11.3-11.3 11.3l-11.3 0-6 0-.6 0-21.5 0-.6 0-6 0-11.3 0c-6.2 0-11.3-5.1-11.3-11.3zM256 240c0-26.5 21.5-48 48-48l32 0c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16z',
      'M0 224C0 100.3 100.3 0 224 0S448 100.3 448 224l0 96c0 106-86 192-192 192l-64 0C86 512 0 426 0 320l0-96zm153.6 96.3C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7l13.3 0c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48l-32 0c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80l-32 0c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80l13.3 0c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6z',
    ],
  ],
};
const faLuchador = faLuchadorMask;
const faMaskLuchador = faLuchadorMask;
const faSquareCheck = {
  prefix: 'fad',
  iconName: 'square-check',
  icon: [
    448,
    512,
    [9745, 9989, 61510, 'check-square'],
    'f14a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM104 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M337 175c9.4 9.4 9.4 24.6 0 33.9L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faCheckSquare = faSquareCheck;
const faShredder = {
  prefix: 'fad',
  iconName: 'shredder',
  icon: [
    512,
    512,
    [],
    'f68a',
    [
      'M40 384l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104-48 0zM64 64l0 128 384 0 0-101.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64zm72 320l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104-48 0zm96 0l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104-48 0zm96 0l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104-48 0zm96 0l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104-48 0z',
      'M64 192c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64L64 192zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faBookOpenCover = {
  prefix: 'fad',
  iconName: 'book-open-cover',
  icon: [
    640,
    512,
    ['book-open-alt'],
    'e0c0',
    [
      'M64 33.8C64 14.3 81.3-.7 100.6 2.2L304 32l0 416L89.7 405.1c-15-3-25.7-16.1-25.7-31.4L64 33.8zM336 32L539.4 2.2C558.7-.7 576 14.3 576 33.8l0 339.9c0 15.3-10.8 28.4-25.7 31.4L336 448l0-416z',
      'M89.7 405.1L320 451.2l230.3-46.1c15-3 25.7-16.1 25.7-31.4l0-345 25.7-5.1C621.5 19.7 640 34.8 640 55l0 366.7c0 15.3-10.8 28.4-25.7 31.4L320 512 25.7 453.1C10.8 450.2 0 437 0 421.8L0 55C0 34.8 18.5 19.7 38.3 23.7L64 28.8l0 345c0 15.3 10.8 28.4 25.7 31.4z',
    ],
  ],
};
const faBookOpenAlt = faBookOpenCover;
const faSandwich = {
  prefix: 'fad',
  iconName: 'sandwich',
  icon: [
    512,
    512,
    [129386],
    'f81f',
    [
      'M0 272c0 17.7 14.3 32 32 32c22.7 0 44.3-10.3 58.8-17.2c1.3-.6 2.6-1.2 3.8-1.8c17.4-8.2 29.4-13 41.4-13c16.2 0 27.5 5 45.4 13.1c18 8.2 41.4 18.9 74.6 18.9s56.6-10.7 74.5-18.9C348.5 277 359.8 272 376 272c12 0 23.9 4.7 41.4 13c1.2 .6 2.5 1.2 3.8 1.8c14.5 6.9 36.1 17.2 58.8 17.2c17.7 0 32-14.3 32-32s-14.3-32-32-32c-7.2 0-15.8-3.7-35.4-13c-16.6-7.8-40.6-19-68.6-19c-30.6 0-53 10.2-70.1 18l-1.9 .9C286.9 234.7 274.3 240 256 240s-30.9-5.3-48.1-13.1l-1.9-.9c-17-7.8-39.4-18-70.1-18c-28 0-52.1 11.3-68.6 19c-19.6 9.2-28.2 13-35.4 13c-17.7 0-32 14.3-32 32zm212.8 64c7.4 0 14.6 2 20.9 5.7c23.4 13.6 46.8 27.3 70.2 40.9c.6 .4 1.3 .7 1.9 1s1.3 .6 1.9 .9c1.3 .5 2.6 1 4 1.4c2.7 .7 5.5 1.1 8.3 1.1c5.6 0 11.1-1.5 16.1-4.4l70.2-40.9c6.4-3.7 13.6-5.7 20.9-5.7l-214.5 0z',
      'M32 64C14.3 64 0 78.3 0 96l0 48c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32L32 64zM233.7 341.7c-6.4-3.7-13.6-5.7-20.9-5.7l-4.8 0L32 336c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-48 0-4.8 0c-7.4 0-14.6 2-20.9 5.7l-70.2 40.9c-10 5.8-22.3 5.8-32.2 0l-70.2-40.9z',
    ],
  ],
};
const faPesetaSign = {
  prefix: 'fad',
  iconName: 'peseta-sign',
  icon: [
    384,
    512,
    [],
    'e221',
    [
      'M0 192c0 17.7 14.3 32 32 32l0-64c-17.7 0-32 14.3-32 32zm96-32l0 64 186.5 0c3.5-10 5.5-20.8 5.5-32s-1.9-22-5.5-32L96 160zm252.8 0c2.1 10.3 3.2 21 3.2 32c0 1.4 0 2.7-.1 4.1s-.1 2.7-.2 4.1c-.1 2.7-.3 5.4-.6 8.1c-.5 5.3-1.3 10.6-2.4 15.8l3.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-3.2 0z',
      'M32 64c0-17.7 14.3-32 32-32l128 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-96 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128L32 64zM96 288l96 0c53 0 96-43 96-96s-43-96-96-96L96 96l0 192z',
    ],
  ],
};
const faSquareParkingSlash = {
  prefix: 'fad',
  iconName: 'square-parking-slash',
  icon: [
    640,
    512,
    ['parking-slash'],
    'f617',
    [
      'M96 171.6L96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4L288 322.9l0 29.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-15.5L96 171.6zM107.7 59.1c39.8 31.2 79.6 62.4 119.4 93.5c6-14.5 20.3-24.7 37-24.7l72 0c53 0 96 43 96 96c0 26.3-10.6 50.2-27.8 67.5c46.6 36.5 93.2 73 139.8 109.5L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1zM288 192l0 8.4c21.6 16.9 43.2 33.9 64.8 50.8c9.1-5.6 15.2-15.7 15.2-27.2c0-17.7-14.3-32-32-32l-48 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faParkingSlash = faSquareParkingSlash;
const faTrainTunnel = {
  prefix: 'fad',
  iconName: 'train-tunnel',
  icon: [
    512,
    512,
    [],
    'e454',
    [
      'M0 256L0 448c0 35.3 28.7 64 64 64l41.4 0 64.3-64.3C137.3 444.5 112 417.2 112 384l0-192c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 192c0 1 0 2.1-.1 3.1s-.1 2-.2 3.1c-.2 2-.5 4-.9 6c-.8 3.9-1.9 7.7-3.3 11.4c-2.9 7.3-7.1 13.9-12.2 19.6c-10.4 11.4-24.8 19-41 20.6L406.6 512l41.4 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0S0 114.6 0 256zM150.6 512l210.7 0-64-64-82.7 0-64 64zM160 216l0 80c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z',
      'M112 192c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-192zm48 24l0 80c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm96 200a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faHeading = {
  prefix: 'fad',
  iconName: 'heading',
  icon: [
    448,
    512,
    ['header'],
    'f1dc',
    [
      'M0 64C0 46.3 14.3 32 32 32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 112 224 0 0-112-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 144 0 176 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-144-224 0 0 144 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-176L48 96 32 96C14.3 96 0 81.7 0 64z',
      '',
    ],
  ],
};
const faHeader = faHeading;
const faGhost = {
  prefix: 'fad',
  iconName: 'ghost',
  icon: [
    384,
    512,
    [128123],
    'f6e2',
    [
      'M0 192L0 462.2C0 472 8 480 17.8 480c4 0 7.9-1.4 11.1-3.9l11.2-9c13.4-10.7 32.8-9 44.1 3.9L114.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l26.6-30.5c12.7-14.6 35.4-14.6 48.2 0L242.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6L299.8 471c11.3-12.9 30.7-14.6 44.1-3.9l11.2 9c3.2 2.5 7.1 3.9 11.1 3.9c9.8 0 17.8-8 17.8-17.8L384 192C384 86 298 0 192 0S0 86 0 192zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M128 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faFaceAnguished = {
  prefix: 'fad',
  iconName: 'face-anguished',
  icon: [
    512,
    512,
    [],
    'e369',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM100.3 154.9c-6-6.5-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8zM208.4 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM176 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM304 112c0-8.8 7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16zm64.4 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 128.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
    ],
  ],
};
const faHockeySticks = {
  prefix: 'fad',
  iconName: 'hockey-sticks',
  icon: [
    640,
    512,
    [],
    'f454',
    [
      'M0 384l0 96c0 17.7 14.3 32 32 32l32 0 0-160-32 0c-17.7 0-32 14.3-32 32zm96-32l0 128 0 32 32 0 32 0 44.2 0c24.2 0 46.4-13.7 57.2-35.4L476.6 46.3c7.9-15.8 1.5-35-14.3-42.9C457.7 1.1 452.8 0 448 0c-11.7 0-23 6.5-28.6 17.7L252.2 352 96 352zm448 0l0 128c0 10.7 0 21.3 0 32l32 0c0-53.3 0-106.7 0-160l-32 0z',
      'M220.6 17.7l81.5 163-35.8 71.6L163.4 46.3c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3zM337.9 395.3l35.8-71.6L387.8 352 544 352l0 128 0 32-32 0-32 0-44.2 0c-24.2 0-46.4-13.7-57.2-35.4l-40.6-81.3zM608 352c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0 0-160 32 0zM96 352l0 160-32 0 0-160 32 0z',
    ],
  ],
};
const faAbacus = {
  prefix: 'fad',
  iconName: 'abacus',
  icon: [
    576,
    512,
    [129518],
    'f640',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 0l64 0 0 32 32 0 0-32 96 0 0 32 32 0 0-32 128 0 0 32 32 0 0-32 64 0 0 112-64 0 0-32-32 0 0 32-128 0 0-32-32 0 0 32-96 0 0-32-32 0 0 32-64 0L64 96zm0 144l64 0 0 24 32 0 0-24 96 0 0 24 32 0 0-24 128 0 0 96 32 0 0-96 64 0 0 176-64 0 0-32-32 0 0 32-128 0 0-32-32 0 0 32-96 0 0-32-32 0 0 32-64 0 0-176zm64 72l0 24 32 0 0-24-32 0zm128 0l0 24 32 0 0-24-32 0z',
      'M96 152c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm160 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM96 288c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM96 360c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm160 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faFilmSimple = {
  prefix: 'fad',
  iconName: 'film-simple',
  icon: [
    512,
    512,
    ['film-alt'],
    'f3a0',
    [
      'M160 32l192 0 0 448-192 0 0-448z',
      'M160 32l-48 0 0 48c0 8.8-7.2 16-16 16L64 96c-8.8 0-16-7.2-16-16l0-46C20.4 41.1 0 66.2 0 96L0 416c0 29.8 20.4 54.9 48 62l0-46c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0 0-448zM352 480l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 46c27.6-7.1 48-32.2 48-62l0-320c0-29.8-20.4-54.9-48-62l0 46c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0 0 448zM64 160l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm336 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM64 288l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm336 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
    ],
  ],
};
const faFilmAlt = faFilmSimple;
const faList = {
  prefix: 'fad',
  iconName: 'list',
  icon: [
    512,
    512,
    ['list-squares'],
    'f03a',
    [
      'M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32z',
      'M16 72c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm0 160c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zM40 368l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faListSquares = faList;
const faTreePalm = {
  prefix: 'fad',
  iconName: 'tree-palm',
  icon: [
    576,
    512,
    [127796],
    'f82b',
    [
      'M224 480c0 6.7 2.1 13.4 6.2 19c6 8.2 15.6 13 25.8 13l64 0c16.1 0 29.8-12 31.8-28c3-24 4.4-48.4 4.4-73c0-77-13.8-154.7-36.1-219c-16 0-32 0-48 0c-2.5 0-5-.6-7.1-1.7c-5.5 5.5-11 11-16.5 16.5c4 10.8 7.8 26.2 9.7 47.2c4.2 46.5-1.6 116.8-32.7 216.4c-1 3.1-1.5 6.3-1.5 9.5z',
      'M133.2 141.9L102.9 91.4c-3.1-5.2-10.6-5.2-13.7 0L69.5 124.1c-1.4 2.4-4 3.9-6.9 3.9L16 128c-8.8 0-16.1-7.2-14.4-15.9C10.7 64.2 59.6 0 160 0c88 0 136.5 49.4 153.2 93.8C338.4 76.2 372.3 64 416 64c100.4 0 149.3 64.2 158.4 112.1c1.7 8.7-5.6 15.9-14.4 15.9l-46.7 0c-2.8 0-5.4-1.5-6.9-3.9l-19.6-32.7c-3.1-5.2-10.6-5.2-13.7 0l-19.6 32.7c-1.4 2.4-4.1 3.9-6.9 3.9L272 192c-2.5 0-5-.6-7.1-1.7L109.8 345.5c-6.2 6.2-16.5 6.3-21.4-1C61 304.1 50.2 224.1 121.1 153.1c4-4 8-7.7 12-11.2z',
    ],
  ],
};
const faSquarePhoneFlip = {
  prefix: 'fad',
  iconName: 'square-phone-flip',
  icon: [
    448,
    512,
    ['phone-square-alt'],
    'f87b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 320c0-7.9 4.7-15.3 12.3-18.5c16-6.7 32-13.3 48-20c8.2-3.4 17.6-1 23.2 5.8c6.7 8.2 13.4 16.4 20.2 24.7c35.2-16.6 63.7-45.1 80.3-80.3c-8.2-6.7-16.4-13.4-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2c6.7-16 13.3-32 20-48c3.2-7.6 10.6-12.3 18.5-12.3c1.7 0 3.5 .2 5.3 .7c14.7 4 29.3 8 44 12C346 143.1 352 151 352 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-.5-1.8-.7-3.5-.7-5.3z',
      'M269.5 140.3c3.9-9.3 14-14.2 23.7-11.6l44 12C346 143.1 352 151 352 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8L199.7 312c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48z',
    ],
  ],
};
const faPhoneSquareAlt = faSquarePhoneFlip;
const faUserBeardBolt = {
  prefix: 'fad',
  iconName: 'user-beard-bolt',
  icon: [
    576,
    512,
    [],
    'e689',
    [
      'M0 481.3c0 17 13.8 30.7 30.7 30.7l324 0c-4.2-12-3.7-25.5 2.3-37.5L386.3 416 368 416c-20.4 0-38.5-12.9-45.3-32.1c-.7-1.9-1.2-3.8-1.6-5.7c-10.3 3.8-21.5 5.9-33.1 5.9c-2.2 0-4.5-.1-6.7-.2C266.8 398.7 246.5 408 224 408s-42.8-9.3-57.3-24.2c-2.2 .2-4.4 .2-6.7 .2c-33.1 0-62.3-16.8-79.6-42.3C32.3 369.6 0 421.7 0 481.3zM64 210.8c0 24.6 14.6 46 35.7 55.7c-2.4 6.7-3.7 14-3.7 21.5c0 15.2 5.3 29.3 14.2 40.2l.4 .5C122.4 342.9 140.1 352 160 352c7.2 0 14.2-1.2 20.6-3.4c7.7 16.2 24.2 27.4 43.4 27.4s35.7-11.2 43.4-27.4c.8 .3 1.6 .5 2.4 .8c5.8 1.7 11.9 2.6 18.2 2.6c20.1 0 38-9.3 49.8-23.8c8.9-11 14.2-25 14.2-40.2c0-7.5-1.3-14.8-3.7-21.5c21.1-9.7 35.7-31 35.7-55.7c0-7.1-1.2-14.3-3.7-21l-25.2-69.3c-2-5.6-3.1-11.6-3.1-17.6C352 46.1 305.9 0 249.1 0L224 0 198.9 0C142.1 0 96 46.1 96 102.9c0 6-1 12-3.1 17.6L67.7 189.9c-2.4 6.7-3.7 13.8-3.7 21zM144 128c0-11.4 2.4-22.2 6.7-32L168 96c24.1 0 45.1-13.3 56-33c10.9 19.7 31.9 33 56 33l17.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16c0 12.5-2.9 24.4-8 35c-.9-.5-1.8-1.1-2.6-1.8l-.6-.6c-18.2-18.2-43-28.5-68.8-28.5s-50.5 10.2-68.8 28.5l-.6 .6c-.8 .8-1.6 1.4-2.6 1.8c-5.1-10.6-8-22.4-8-35l0-16zm34.2 81.6c1.6-1.3 3.2-2.7 4.7-4.2l.6-.6C194.3 194 208.8 188 224 188s29.7 6 40.5 16.8l.6 .6c1.5 1.5 3.1 2.9 4.7 4.2c-2.6 1.8-5.2 3.4-8 4.9c-11.3 6.1-24.2 9.5-37.9 9.5s-26.6-3.4-37.9-9.5c-2.8-1.5-5.4-3.1-8-4.9z',
      'M542.3 247.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L385.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8z',
    ],
  ],
};
const faCartPlus = {
  prefix: 'fad',
  iconName: 'cart-plus',
  icon: [
    576,
    512,
    [],
    'f217',
    [
      'M120.1 32c2 4.2 3.5 8.8 4.4 13.5c15.4 80.8 30.8 161.7 46.2 242.5l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32l-411 0zM252 160c0-11 9-20 20-20l44 0c0-14.7 0-29.3 0-44c0-11 9-20 20-20s20 9 20 20l0 44 44 0c11 0 20 9 20 20s-9 20-20 20l-44 0 0 44c0 11-9 20-20 20s-20-9-20-20c0-14.7 0-29.3 0-44l-44 0c-11 0-20-9-20-20z',
      'M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l51.6 271c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0-11 9-20 20-20l44 0 0-44c0-11 9-20 20-20s20 9 20 20l0 44 44 0c11 0 20 9 20 20s-9 20-20 20l-44 0 0 44c0 11-9 20-20 20s-20-9-20-20l0-44-44 0c-11 0-20-9-20-20z',
    ],
  ],
};
const faGamepad = {
  prefix: 'fad',
  iconName: 'gamepad',
  icon: [
    640,
    512,
    [],
    'f11b',
    [
      'M0 256C0 362 86 448 192 448l256 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256zm112 0c0-13.3 10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24zm360 48a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm64-96a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z',
      'M192 176c-13.3 0-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faBorderCenterV = {
  prefix: 'fad',
  iconName: 'border-center-v',
  icon: [
    448,
    512,
    [],
    'f89d',
    [
      'M0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 160zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M224 480c-17.7 0-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faCircleDot = {
  prefix: 'fad',
  iconName: 'circle-dot',
  icon: [
    512,
    512,
    [128280, 'dot-circle'],
    'f192',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm352 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
      'M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z',
    ],
  ],
};
const faDotCircle = faCircleDot;
const faClipboardMedical = {
  prefix: 'fad',
  iconName: 'clipboard-medical',
  icon: [
    384,
    512,
    [],
    'e133',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM96 304c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z',
      'M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faFaceDizzy = {
  prefix: 'fad',
  iconName: 'face-dizzy',
  icon: [
    512,
    512,
    ['dizzy'],
    'f567',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM96 144c0-4.1 1.6-8.2 4.7-11.3s7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7L160 169.4l36.7-36.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L160 214.6l-36.7 36.7c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7s-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3L137.4 192l-36.7-36.7c-3.1-3.1-4.7-7.2-4.7-11.3zM320 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM292.7 132.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7L352 169.4l36.7-36.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3L374.6 192l36.7 36.7c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3s-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L352 214.6l-36.7 36.7c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z',
      'M196.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 169.4l36.7-36.7zm96 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z',
    ],
  ],
};
const faDizzy = faFaceDizzy;
const faEgg = {
  prefix: 'fad',
  iconName: 'egg',
  icon: [
    384,
    512,
    [129370],
    'f7fb',
    [
      'M0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zm64 0c0-28.3 5.7-61.9 16.9-93.5c11.2-31.5 28.4-62.4 52.3-84.2c6.5-6 16.7-5.5 22.6 1c2.8 3.1 4.2 6.9 4.2 10.8c0 4.3-1.8 8.7-5.2 11.8c-18.8 17.1-33.6 42.7-43.7 71.2C101 233.6 96 263.5 96 288c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
      'M155.8 111.4c6 6.5 5.5 16.7-1 22.6c-18.8 17.1-33.6 42.7-43.7 71.2C101 233.6 96 263.5 96 288c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-28.3 5.7-61.9 16.9-93.5c11.2-31.5 28.4-62.4 52.3-84.2c6.5-6 16.7-5.5 22.6 1z',
    ],
  ],
};
const faUpToLine = {
  prefix: 'fad',
  iconName: 'up-to-line',
  icon: [
    384,
    512,
    ['arrow-alt-to-top'],
    'f34d',
    [
      'M0 64C0 46.3 14.3 32 32 32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64z',
      'M219.3 139.3L342.1 262.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9L256 320l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128-62.1 0C47.2 320 32 304.8 32 286.1c0-9 3.6-17.6 9.9-24L164.7 139.3c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3z',
    ],
  ],
};
const faArrowAltToTop = faUpToLine;
const faHouseMedicalCircleXmark = {
  prefix: 'fad',
  iconName: 'house-medical-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e513',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l266.7 0C349.5 480.1 320 427.5 320 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 40.2 0c32.3-39.1 81.1-64 135.8-64c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24zM320 352l0 16c0-5.4 .2-10.7 .7-16l-.7 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faWatchFitness = {
  prefix: 'fad',
  iconName: 'watch-fitness',
  icon: [
    384,
    512,
    [],
    'f63e',
    [
      'M0 144c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6l224 0c5.5 0 10.8 .6 16 1.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6C27.5 439 0 406.7 0 368L0 144zm80 77.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9C107.4 160 80 187.4 80 221.3z',
      'M112.3 0L271.7 0C298.4 0 320 21.6 320 48.3l0 17.3c-5.2-1-10.5-1.6-16-1.6L80 64c-5.5 0-10.8 .6-16 1.6l0-17.3C64 21.6 85.6 0 112.3 0zM64 464l0-17.6c5.2 1 10.5 1.6 16 1.6l224 0c5.5 0 10.8-.6 16-1.6l0 17.6c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z',
    ],
  ],
};
const faClockNineThirty = {
  prefix: 'fad',
  iconName: 'clock-nine-thirty',
  icon: [
    512,
    512,
    [],
    'e34d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-13.3 10.7-24 24-24l104 0c13.3 0 24 10.7 24 24l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112-80 0c-13.3 0-24-10.7-24-24z',
      'M256 416c13.3 0 24-10.7 24-24l0-136c0-13.3-10.7-24-24-24l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 112c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faCampground = {
  prefix: 'fad',
  iconName: 'campground',
  icon: [
    576,
    512,
    [9978],
    'f6bb',
    [
      'M0 448l168.5 0L288 448l119.5 0L576 448l0 16c0 26.4-21.3 47.8-47.7 48l-.3 0-240 0L48 512l-.3 0C21.3 511.8 0 490.4 0 464l0-16z',
      'M372 7c13.8 11 16 31.2 5 45l-48 60L563.7 405.4c7.9 9.9 12.3 22.3 12.3 35l0 7.6-168.5 0L288 291.7 168.5 448 0 448l0-7.6c0-12.7 4.3-25.1 12.3-35L247 112 199 52c-11-13.8-8.8-33.9 5-45s33.9-8.8 45 5l39 48.8L327 12c11-13.8 31.2-16 45-5zM47.7 512l480.7 0-.3 0-240 0L48 512l-.3 0z',
    ],
  ],
};
const faFolderPlus = {
  prefix: 'fad',
  iconName: 'folder-plus',
  icon: [
    512,
    512,
    [],
    'f65e',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM144 288c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M232 312l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faJug = {
  prefix: 'fad',
  iconName: 'jug',
  icon: [
    448,
    512,
    [],
    'f8c6',
    [
      'M32 288c128 0 256 0 384 0l0 128L32 416l0-128zM128 32c0-17.7 14.3-32 32-32L288 0c17.7 0 32 14.3 32 32c0 11.8-6.4 22.2-16 27.7c-4.7 2.7-10.2 4.3-16 4.3c-42.7 0-85.3 0-128 0c-5.8 0-11.3-1.6-16-4.3c-9.6-5.5-16-15.9-16-27.7z',
      'M144 59.7L144 85c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6l0 4.1 384 0 0-4.1c0-17.4-3.5-34.5-10.3-50.3C430.6 222.3 448 197.2 448 168c0-39.8-32.2-72-72-72c-21.2 0-40.3 9.2-53.5 23.8l-11.8-15.1C306.4 99 304 92.1 304 85l0-25.3c-4.7 2.7-10.2 4.3-16 4.3L160 64c-5.8 0-11.3-1.6-16-4.3zM32 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-32L32 416l0 32zM378.6 191.9l-25.1-32.2c3.4-9.1 12.2-15.6 22.5-15.6c13.3 0 24 10.7 24 24c0 12.4-9.4 22.6-21.4 23.9z',
    ],
  ],
};
const faFutbol = {
  prefix: 'fad',
  iconName: 'futbol',
  icon: [
    512,
    512,
    [9917, 'futbol-ball', 'soccer-ball'],
    'f1e3',
    [
      'M1 278.9c3.5 39.4 15.9 76.3 35.2 108.5c35.9-2.4 71.8-4.8 107.6-7.2c6.4-.4 12.8 1.4 18.1 5.2s9 9.3 10.5 15.6c8.8 34.9 17.6 69.7 26.5 104.6c18.3 4.2 37.4 6.4 57 6.4s38.7-2.2 57-6.4c8.8-34.9 17.6-69.7 26.5-104.6c1.6-6.3 5.3-11.8 10.5-15.6s11.6-5.6 18.1-5.2l107.6 7.2c19.3-32.2 31.8-69.1 35.2-108.5c-30.4-19.2-60.9-38.3-91.3-57.5c-5.5-3.4-9.6-8.7-11.6-14.8s-1.8-12.8 .6-18.8c13.4-33.4 26.7-66.8 40.1-100.1c-25.1-28.8-56.6-51.9-92.3-67.1c-27.6 23-55.3 46.1-82.9 69.1c-5 4.1-11.2 6.4-17.7 6.4s-12.7-2.3-17.7-6.4c-27.6-23-55.3-46.1-82.9-69.1C119.8 35.8 88.3 58.9 63.1 87.6c13.4 33.4 26.7 66.8 40.1 100.1c2.4 6 2.6 12.6 .6 18.8s-6.1 11.4-11.6 14.8C61.8 240.6 31.4 259.7 1 278.9zm165.3-37.2c-3.2-9.9 .3-20.7 8.7-26.8l66.9-48.6c8.4-6.1 19.8-6.1 28.2 0c22.3 16.2 44.6 32.4 66.9 48.6c8.4 6.1 11.9 16.9 8.7 26.8c-8.5 26.2-17 52.4-25.6 78.6c-3.2 9.9-12.4 16.6-22.8 16.6l-82.7 0c-10.4 0-19.6-6.7-22.8-16.6c-8.5-26.2-17-52.4-25.5-78.6z',
      'M1 278.9c-.7-7.5-1-15.2-1-22.9C0 191.5 23.8 132.6 63.1 87.6l40.1 100.1c2.4 6 2.6 12.6 .6 18.8s-6.1 11.4-11.6 14.8L1 278.9zM199 505.6C130 489.9 71.6 446.4 36.2 387.4l107.6-7.2c6.4-.4 12.8 1.4 18.1 5.2s9 9.3 10.5 15.6L199 505.6zM475.8 387.4C440.4 446.4 382 489.9 313 505.6L339.5 401c1.6-6.3 5.3-11.8 10.5-15.6s11.6-5.6 18.1-5.2l107.6 7.2zM448.9 87.6C488.2 132.6 512 191.5 512 256c0 7.7-.3 15.3-1 22.9l-91.3-57.5c-5.5-3.4-9.6-8.7-11.6-14.8s-1.8-12.8 .6-18.8L448.9 87.6zM356.6 20.5L273.7 89.6c-5 4.1-11.2 6.4-17.7 6.4s-12.7-2.3-17.7-6.4L155.4 20.5C186.3 7.3 220.3 0 256 0s69.7 7.3 100.6 20.5zM241.9 166.3c8.4-6.1 19.8-6.1 28.2 0L337 214.8c8.4 6.1 11.9 16.9 8.7 26.8l-25.5 78.6c-3.2 9.9-12.4 16.6-22.8 16.6l-82.7 0c-10.4 0-19.6-6.7-22.8-16.6l-25.6-78.6c-3.2-9.9 .3-20.7 8.7-26.8l66.9-48.6z',
    ],
  ],
};
const faFutbolBall = faFutbol;
const faSoccerBall = faFutbol;
const faSnowBlowing = {
  prefix: 'fad',
  iconName: 'snow-blowing',
  icon: [
    640,
    512,
    [],
    'f761',
    [
      'M384 208c0 17.7 14.3 32 32 32l128 0c53 0 96-43 96-96s-43-96-96-96l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32l120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l24 0c53 0 96-43 96-96s-43-96-96-96l-120 0c-17.7 0-32 14.3-32 32z',
      'M176 64c13.3 0 24 10.7 24 24l0 25.4 12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6l0 55.8 48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6l0 55.8 35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6l0 25.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.4-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4l0-55.8-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4l0-55.8-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4 152 88c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faPaintbrush = {
  prefix: 'fad',
  iconName: 'paintbrush',
  icon: [
    576,
    512,
    [128396, 'paint-brush'],
    'f1fc',
    [
      'M0 480c0 17.7 14.3 32 32 32l143.9 0c.1-.2 .2-.3 .3-.3c2.6 .2 5.2 .3 7.9 .3c66.3 0 120-53.7 120-120c0-2.8-.1-5.5-.2-8.3l-.6-.6L208 272c-.5 0-1.1 0-1.7 0L184 272c-66.3 0-120 53.7-120 120c0 6.2 .5 12.4 1.4 18.4C68.1 428.2 56.1 448 38 448l-6 0c-17.7 0-32 14.3-32 32z',
      'M411 331.6c-19.9 32.6-55.3 52.4-93.4 52.4c-4.8 0-9.6-.3-14.3-.9L208 272c.2-35.9 17.8-69.4 47.1-90.1L500.2 8.8C518.8-4.3 544.1-2.6 560.7 13s20 40.6 8.2 60.1L411 331.6z',
    ],
  ],
};
const faPaintBrush = faPaintbrush;
const faLock = {
  prefix: 'fad',
  iconName: 'lock',
  icon: [
    448,
    512,
    [128274],
    'f023',
    [
      'M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 64 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144z',
      'M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z',
    ],
  ],
};
const faArrowDownFromLine = {
  prefix: 'fad',
  iconName: 'arrow-down-from-line',
  icon: [
    384,
    512,
    [8615, 'arrow-from-top'],
    'f345',
    [
      'M0 64C0 46.3 14.3 32 32 32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64z',
      'M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.7l0-66.7 0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112 0 66.7L86.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z',
    ],
  ],
};
const faArrowFromTop = faArrowDownFromLine;
const faGasPump = {
  prefix: 'fad',
  iconName: 'gas-pump',
  icon: [
    512,
    512,
    [9981],
    'f52f',
    [
      'M32 64l0 384 288 0 0-144 0-48 0-192c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64zM96 80c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-96z',
      'M384 64l32 32 0 64c0 29.8 20.4 54.9 48 62l0 154c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-8 0 0 48 8 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-152 0-32 0-24 0-13.5c0-17-6.7-33.3-18.7-45.3L416 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32zM0 480c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faSignalBarsSlash = {
  prefix: 'fad',
  iconName: 'signal-bars-slash',
  icon: [
    640,
    512,
    ['signal-alt-slash'],
    'f694',
    [
      'M32 432l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zM192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-141.1-74.7-58.8C200.5 272.7 192 287.4 192 304zM352 176l0 74.6c32 25.1 64 50.2 96 75.2L448 176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 197.3l0 90.7c0 26.5 21.5 48 48 48s48-21.5 48-48l0-15-96-75.6zM512 48l0 328c32 25.1 64 50.2 96 75.2L608 48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm47.7 464l.7 0-.3 0-.3 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faSignalAltSlash = faSignalBarsSlash;
const faMonkey = {
  prefix: 'fad',
  iconName: 'monkey',
  icon: [
    576,
    512,
    [128018],
    'f6fb',
    [
      'M336 112c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M160 416c0-89.7 61.4-165 144.5-186.1C329.1 265 369.9 288 416 288c9.8 0 19.4-1 28.7-3L526.5 363c31.6 30.2 49.5 72 49.5 115.7l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-26.2-10.7-51.3-29.7-69.4L416 346.1 416 448l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-256 0C71.6 512 0 440.4 0 352L0 110.1C0 49.3 49.3 0 110.1 0l10.4 0c57.2 0 102.8 47.8 100.1 104.9c-2.3 48.2-38.6 88-86.4 94.6l-1.9 .3c-17.5 2.4-33.7-9.8-36.1-27.3s9.8-33.7 27.3-36.1l1.9-.3c17.3-2.4 30.4-16.7 31.2-34.2c1-20.6-15.5-37.9-36.2-37.9l-10.4 0C84.7 64 64 84.7 64 110.1L64 352c0 53 43 96 96 96l0-32zM416 256c-29.3 0-55.9-12.2-74.8-31.7c-9-9.3-16.2-20.2-21.3-32.3c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-15.7 37.6-52.8 64-96 64zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48l-64 0z',
    ],
  ],
};
const faRectanglePro = {
  prefix: 'fad',
  iconName: 'rectangle-pro',
  icon: [
    640,
    512,
    ['pro'],
    'e235',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm80 88c0-13.3 10.7-24 24-24l56 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80zm48 24l0 32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm112-24c0-13.3 10.7-24 24-24l56 0c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1c-4 2.5-8.4 3.7-12.7 3.7c-8 0-15.8-4-20.4-11.3l-33-52.7L288 288l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80zm48 24l0 32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm112 40c0-48.6 39.4-88 88-88s88 39.4 88 88l0 16c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-16zm48 0l0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16c0-22.1-17.9-40-40-40s-40 17.9-40 40z',
      'M80 184l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-56 0c-13.3 0-24 10.7-24 24zm48 56l0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0zm112-56l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 18.7 0 33 52.7c7 11.2 21.8 14.7 33.1 7.6s14.7-21.8 7.6-33.1l-24.1-38.5C373 265.2 384 245.9 384 224c0-35.3-28.7-64-64-64l-56 0c-13.3 0-24 10.7-24 24zm48 56l0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0zm200-80c-48.6 0-88 39.4-88 88l0 16c0 48.6 39.4 88 88 88s88-39.4 88-88l0-16c0-48.6-39.4-88-88-88zm-40 88c0-22.1 17.9-40 40-40s40 17.9 40 40l0 16c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-16z',
    ],
  ],
};
const faPro = faRectanglePro;
const faHouseNight = {
  prefix: 'fad',
  iconName: 'house-night',
  icon: [
    640,
    512,
    [],
    'e010',
    [
      'M0 112c0 61.9 50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112zM44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c1.3 3.5 4.4 5.2 7.5 5.2s6.2-1.7 7.5-5.2l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0L76.6 364.6 44.3 376.5zm160-320c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c3.5-1.3 5.2-4.4 5.2-7.5s-1.7-6.2-5.2-7.5L275.4 44.6 263.5 12.3c-2.6-7-12.4-7-15 0L236.6 44.6 204.3 56.5z',
      'M378.3 104.5c12.3-11.3 31.2-11.3 43.4 0l208 192c9.7 8.9 12.9 22.9 8.1 35.2S621.2 352 608 352l-32 0 0 112c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-112-32 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM368 288c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0z',
    ],
  ],
};
const faHotTubPerson = {
  prefix: 'fad',
  iconName: 'hot-tub-person',
  icon: [
    512,
    512,
    ['hot-tub'],
    'f593',
    [
      'M0 64a64 64 0 1 0 128 0A64 64 0 1 0 0 64zM0 256l256 0L153.6 179.2C137 166.7 116.8 160 96 160c-53 0-96 43-96 96zM224 24l0 5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5l0 13.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.2c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2l0-5.2c0-13.3-10.7-24-24-24s-24 10.7-24 24zm112 0l0 5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5l0 13.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.2c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2l0-5.2c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M0 256l448 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256zm112 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm80-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z',
    ],
  ],
};
const faHotTub = faHotTubPerson;
const faGlobePointer = {
  prefix: 'fad',
  iconName: 'globe-pointer',
  icon: [
    512,
    512,
    [],
    'e60e',
    [
      'M0 256c0-22.1 2.8-43.5 8.1-64l123.1 0c-1.9 18.4-2.9 37.4-3.1 57L20.4 280.6c-7.1 2.1-13.1 5.5-18.1 9.9C.8 279.2 0 267.7 0 256zm18.6-96C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160L18.6 160zm141.6 79.5c.4-16.3 1.5-32.2 3.1-47.5l185.3 0c2.2 20.4 3.3 41.8 3.3 64s-1.2 43.6-3.3 64l-66.8 0 12.6-42.8c10.7-36.4-23.1-70.3-59.6-59.6l-74.6 21.9zm7.5-79.5c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7l-176.6 0zm61 338.6c1-2.2 1.9-4.6 2.7-7.1L272.4 352l71.9 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512c-7.2 0-16.3-3.1-27.3-13.4zM321.4 8.4c78.3 20.7 142 77.5 171.9 151.6l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6zm0 495.1c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0c-30 74.1-93.6 130.9-171.9 151.6zM380.8 192l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64z',
      'M243.9 248.3L39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3 .7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9z',
    ],
  ],
};
const faBlanket = {
  prefix: 'fad',
  iconName: 'blanket',
  icon: [
    448,
    512,
    [],
    'f498',
    [
      'M0 128L0 352c0-70.7 57.3-128 128-128l240 0c44.2 0 80 35.8 80 80l0-176c0-53-43-96-96-96L96 32C43 32 0 75 0 128z',
      'M128 288c-35.3 0-64 28.7-64 64s28.7 64 64 64l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0C57.3 480 0 422.7 0 352s57.3-128 128-128l240 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-240 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l240 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-240 0z',
    ],
  ],
};
const faMapLocation = {
  prefix: 'fad',
  iconName: 'map-location',
  icon: [
    576,
    512,
    ['map-marked'],
    'f59f',
    [
      'M0 209.6L0 480.4c0 17 17.1 28.6 32.9 22.3L160 451.8l0-251.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49C6 191 0 199.8 0 209.6zM192 255l0 194.4 192 54.9L384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77zm224-54.6L416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3L576 152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6z',
      'M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120z',
    ],
  ],
};
const faMapMarked = faMapLocation;
const faHouseFloodWater = {
  prefix: 'fad',
  iconName: 'house-flood-water',
  icon: [
    576,
    512,
    [],
    'e50e',
    [
      'M0 368c0 2.4 .3 4.8 .8 7.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2C10 340.3 0 353.4 0 368zM0 480c0 2.4 .3 4.8 .8 7.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2C10 452.3 0 465.4 0 480z',
      'M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192l16 0 0 73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2 16.6 0c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128z',
    ],
  ],
};
const faCommentsQuestionCheck = {
  prefix: 'fad',
  iconName: 'comments-question-check',
  icon: [
    640,
    512,
    [],
    'e14f',
    [
      'M0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8C2.4 326.1 0 331 0 336c0 1.6 .3 3.3 .8 4.9C2.9 347.5 9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zm134.7-59.9c0-2.2 .4-4.5 1.2-6.7l.4-1c6.6-18.6 24.2-31.1 44-31.1l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2c-8.2-2.9-13.3-10.6-13.3-18.8zM234.7 264a26.7 26.7 0 1 1 -53.3 0 26.7 26.7 0 1 1 53.3 0z',
      'M136.2 108.4c6.6-18.6 24.2-31.1 44-31.1l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 264a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0zM432 512c-95.6 0-176.2-54.6-200.5-129C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2s0 0 0 0s0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.3-11.4C505.9 503.3 470.2 512 432 512zM566.1 318.1c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L472 355.7l-25.9-25.9c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l40 40c7.8 7.8 20.5 7.8 28.3 0l80-80z',
    ],
  ],
};
const faTree = {
  prefix: 'fad',
  iconName: 'tree',
  icon: [
    448,
    512,
    [127794],
    'f1bb',
    [
      'M0 424.5c0 13 10.5 23.5 23.5 23.5L192 448l0-224c0-.6 0-1.1 0-1.6s.1-1.1 .1-1.6c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32c0 74.7 0 149.3 0 224l168.5 0c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320l33.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208l24.9 0c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208l24.9 0L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320L80 320 5.4 409.5C1.9 413.7 0 419 0 424.5z',
      'M224 192c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faArrowsCross = {
  prefix: 'fad',
  iconName: 'arrows-cross',
  icon: [
    448,
    512,
    [],
    'e0a2',
    [
      'M0 64c0 8.2 3.1 16.4 9.4 22.6L178.7 256c15.1-15.1 30.2-30.2 45.3-45.3L54.6 41.4C48.4 35.1 40.2 32 32 32s-16.4 3.1-22.6 9.4S0 55.8 0 64zM224 301.3L338.7 416 288 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 50.7L269.3 256 224 301.3z',
      'M256 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7L54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 96 288 96c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faBackpack = {
  prefix: 'fad',
  iconName: 'backpack',
  icon: [
    448,
    512,
    [127890],
    'f5d4',
    [
      'M96 384l0 16 0 112 256 0 0-112 0-16L96 384zM136 56l0 40 48 0 0-40c0-4.4 3.6-8 8-8l64 0c4.4 0 8 3.6 8 8l0 40 48 0 0-40c0-30.9-25.1-56-56-56L192 0c-30.9 0-56 25.1-56 56z',
      'M0 224C0 153.3 57.3 96 128 96l192 0c70.7 0 128 57.3 128 128l0 224c0 35.3-28.7 64-64 64l-32 0 0-112 0-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64 0 112-32 0c-35.3 0-64-28.7-64-64L0 224zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
    ],
  ],
};
const faSquareSmall = {
  prefix: 'fad',
  iconName: 'square-small',
  icon: [
    320,
    512,
    [],
    'e27e',
    ['M0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160z', ''],
  ],
};
const faFolderArrowUp = {
  prefix: 'fad',
  iconName: 'folder-arrow-up',
  icon: [
    512,
    512,
    ['folder-upload'],
    'e054',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM160 272c0-6.1 2.3-12.3 7-17l72-72c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l72 72c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-33.9 0l-31-31L280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0c-4.7-4.7-7-10.8-7-17z',
      'M256 384c13.3 0 24-10.7 24-24l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 360c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faFolderUpload = faFolderArrowUp;
const faBridgeLock = {
  prefix: 'fad',
  iconName: 'bridge-lock',
  icon: [
    640,
    512,
    [],
    'e4cc',
    [
      'M32 64c0 17.7 14.3 32 32 32l40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96c28.8 0 54.6 12.7 72.2 32.7c5.6-10 13.9-18.4 23.8-24.1l0-24.6c0-61.9 50.1-112 112-112l8 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64zM152 96l80 0 0 64-80 0 0-64zm128 0l80 0 0 64-80 0 0-64zm128 0l80 0 0 64-80 0 0-64z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faCrosshairsSimple = {
  prefix: 'fad',
  iconName: 'crosshairs-simple',
  icon: [
    512,
    512,
    [],
    'e59f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm64 0c0-10.9 .9-21.6 2.7-32C80.1 143.6 143.6 80.1 224 66.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7C368.4 80.1 431.9 143.6 445.3 224c1.7 10.4 2.7 21.1 2.7 32s-.9 21.6-2.7 32C431.9 368.4 368.4 431.9 288 445.3c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7C143.6 431.9 80.1 368.4 66.7 288c-1.7-10.4-2.7-21.1-2.7-32z',
      'M288 66.7c-10.4-1.7-21.1-2.7-32-2.7s-21.6 .9-32 2.7l0 61.3c0 17.7 14.3 32 32 32s32-14.3 32-32l0-61.3zM66.7 288l61.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-61.3 0c-1.7 10.4-2.7 21.1-2.7 32s.9 21.6 2.7 32zM224 445.3c10.4 1.7 21.1 2.7 32 2.7s21.6-.9 32-2.7l0-61.3c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 61.3zM445.3 224L384 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l61.3 0c1.7-10.4 2.7-21.1 2.7-32s-.9-21.6-2.7-32z',
    ],
  ],
};
const faSackDollar = {
  prefix: 'fad',
  iconName: 'sack-dollar',
  icon: [
    512,
    512,
    [128176],
    'f81d',
    [
      'M0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4l-128 0c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416zM144.6 24.9L192 96l128 0 47.4-71.1C374.5 14.2 366.9 0 354.1 0L157.9 0c-12.8 0-20.4 14.2-13.3 24.9zm43.6 253.7c.1-1.3 .2-2.5 .4-3.7c.3-2.4 .9-4.8 1.5-7c1.3-4.5 3.2-8.5 5.6-12.2c4.7-7.3 11.2-13 18.2-17.1c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c0 .7 0 1.3 0 1.9s0 1.3-.1 1.9c-.1 1.3-.2 2.5-.3 3.7c-.3 2.4-.7 4.8-1.3 7c-1.2 4.5-3 8.6-5.2 12.4c-4.4 7.5-10.7 13.5-17.9 18c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c0-.7 0-1.3 0-2s.1-1.3 .1-1.9z',
      'M192 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L192 96zm84 120c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z',
    ],
  ],
};
const faPenToSquare = {
  prefix: 'fad',
  iconName: 'pen-to-square',
  icon: [
    512,
    512,
    ['edit'],
    'f044',
    [
      'M0 160c0-53 43-96 96-96l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 160z',
      'M392.4 21.7L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0zM339.7 74.3L172.4 241.7c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3z',
    ],
  ],
};
const faEdit = faPenToSquare;
const faSquareSliders = {
  prefix: 'fad',
  iconName: 'square-sliders',
  icon: [
    448,
    512,
    ['sliders-h-square'],
    'f3f0',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 80c0-17.7 14.3-32 32-32l32 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-32 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l160 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16L96 368c-17.7 0-32-14.3-32-32z',
      'M192 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96zM320 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96z',
    ],
  ],
};
const faSlidersHSquare = faSquareSliders;
const faCarSide = {
  prefix: 'fad',
  iconName: 'car-side',
  icon: [
    640,
    512,
    [128663],
    'f5e4',
    [
      'M64 432a80 80 0 1 0 160 0A80 80 0 1 0 64 432zm47.3-208L224 224c0-32 0-64 0-96l-52.7 0c-13.1 0-24.9 8-29.7 20.1c-10.1 25.3-20.2 50.6-30.4 75.9zM272 128c0 32 0 64 0 96l173.4 0-67.2-84c-6.1-7.6-15.3-12-25-12L272 128zM416 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M171.3 128l52.7 0 0 96-112.7 0 30.4-75.9c4.9-12.1 16.6-20.1 29.7-20.1zM272 224l0-96 81.2 0c9.7 0 18.9 4.4 25 12l67.2 84L272 224zm256.2 1l-100-125c-18.2-22.8-45.8-36-75-36L171.3 64c-39.3 0-74.6 23.9-89.1 60.3L40.6 228.4C16.8 237.8 0 260.9 0 288L0 400c0 17.7 14.3 32 32 32c0-61.9 50.1-112 112-112s112 50.1 112 112l128 0c0-61.9 50.1-112 112-112s112 50.1 112 112c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127z',
    ],
  ],
};
const faMessageMiddleTop = {
  prefix: 'fad',
  iconName: 'message-middle-top',
  icon: [
    512,
    512,
    ['comment-middle-top-alt'],
    'e1e2',
    [
      'M343.5 96L448 96c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l104.5 0L243.7 5.8c3-3.6 7.5-5.8 12.3-5.8s9.3 2.1 12.3 5.8L343.5 96z',
      '',
    ],
  ],
};
const faCommentMiddleTopAlt = faMessageMiddleTop;
const faLightbulbOn = {
  prefix: 'fad',
  iconName: 'lightbulb-on',
  icon: [
    640,
    512,
    [],
    'f672',
    [
      'M144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176zm64 0c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
      'M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48 160 0 0 48z',
    ],
  ],
};
const faKnife = {
  prefix: 'fad',
  iconName: 'knife',
  icon: [
    512,
    512,
    ['utensil-knife'],
    'f2e4',
    [
      'M201.4 265.4l16-16C298.1 168.7 378.7 88 459.5 7.3c4.7-4.7 11-7.3 17.6-7.3c11.2 0 21 7.5 23.5 18.4C505.3 38.6 512 71.5 512 96c0 90.1-56.3 137.9-149.2 229.3c-12.1 11.9-28.4 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7c-4.9-4.9-9.8-9.8-14.6-14.6c-15.1-15.1-30.2-30.2-45.3-45.3z',
      'M217.4 249.4l-16 16 45.3 45.3-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l208-208z',
    ],
  ],
};
const faUtensilKnife = faKnife;
const faShareNodes = {
  prefix: 'fad',
  iconName: 'share-nodes',
  icon: [
    448,
    512,
    ['share-alt'],
    'f1e0',
    [
      'M162.6 186.9c15.4 14.9 25.9 34.9 28.6 57.2l94.1-47c-15.4-14.9-25.9-34.9-28.6-57.2l-94.1 47zm0 138.2l94.1 47c2.8-22.4 13.2-42.4 28.6-57.2l-94.1-47c-2.8 22.4-13.2 42.4-28.6 57.2z',
      'M256 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM0 256a96 96 0 1 1 192 0A96 96 0 1 1 0 256zm352 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
    ],
  ],
};
const faShareAlt = faShareNodes;
const faDisplayChartUpCircleDollar = {
  prefix: 'fad',
  iconName: 'display-chart-up-circle-dollar',
  icon: [
    640,
    512,
    [],
    'e5e6',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l234.8 0C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16L64 352 64 64l448 0 0 128.7c22.9 2.1 44.5 8.5 64 18.5L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2l0-72.7c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z',
    ],
  ],
};
const faWaveSine = {
  prefix: 'fad',
  iconName: 'wave-sine',
  icon: [
    640,
    512,
    [8767],
    'f899',
    [
      'M63.4 230.3l0-.1 .2-1c.2-.9 .5-2.4 1-4.3c1-3.8 2.5-9.4 4.6-16.2C73.6 195 80.3 177 90 159.4C110.2 122.8 137.8 96 176 96c29 0 49.1 14.4 67 44.4c19 31.8 31.9 75.4 46.3 124.5c.2 .8 .5 1.6 .7 2.4c13.5 46.2 28.4 97.5 52 137c25.1 42 63 75.6 122 75.6c73.8 0 118.2-53.2 142-96.6c12.3-22.4 20.6-44.5 25.7-60.8c2.6-8.2 4.5-15.1 5.7-20c.6-2.5 1.1-4.4 1.4-5.9c.2-.7 .3-1.3 .4-1.7l.1-.5 0-.2c0 0 0 0 0-.1c0 0 0 0 0 0L608 288l31.4 6.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1c0 0 0 0 0 0l0 .1-.2 1c-.2 .9-.5 2.4-1 4.3c-1 3.8-2.5 9.4-4.6 16.2c-4.3 13.7-11.1 31.6-20.8 49.2c-20.1 36.6-47.8 63.4-86 63.4c-29 0-49.1-14.4-67-44.4c-19-31.8-31.9-75.4-46.3-124.5c-.2-.8-.5-1.6-.7-2.4c-13.5-46.2-28.4-97.5-52-137C272.9 65.6 235 32 176 32C102.2 32 57.8 85.2 34 128.6C21.7 151 13.4 173 8.2 189.3c-2.6 8.2-4.5 15.1-5.7 20c-.6 2.5-1.1 4.4-1.4 5.9c-.2 .7-.3 1.3-.4 1.7l-.1 .5 0 .2c0 0 0 0 0 .1c0 0 0 0 0 0L32 224 .6 217.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1z',
      '',
    ],
  ],
};
const faHeartCircleMinus = {
  prefix: 'fad',
  iconName: 'heart-circle-minus',
  icon: [
    576,
    512,
    [],
    'e4ff',
    [
      'M0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z',
    ],
  ],
};
const faCircleW = {
  prefix: 'fad',
  iconName: 'circle-w',
  icon: [
    512,
    512,
    [],
    'e12c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm104.3-83.8c.2-1.2 .5-2.5 .9-3.6c.8-2.4 1.9-4.6 3.3-6.6c2.9-4 7.1-7.2 12.2-8.8c12.6-4 26.1 2.9 30.2 15.5c13.7 42.9 27.4 85.7 41.1 128.6c13.7-42.9 27.4-85.7 41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7c13.7 42.9 27.4 85.7 41.1 128.6c13.7-42.9 27.4-85.7 41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2c-21.3 66.7-42.7 133.3-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L256 254.7c-13.7 42.9-27.4 85.7-41.1 128.6c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7c-21.3-66.7-42.7-133.3-64-200c-.4-1.2-.7-2.4-.9-3.7c-.1-.9-.2-1.8-.2-1.8c-.1-.9-.1-.9-.1-1.8c0-.6 0-1.3 .1-1.9s.1-1.2 .2-1.9z',
      'M120.7 153.1c12.6-4 26.1 2.9 30.2 15.5L192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L256 254.7 214.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2z',
    ],
  ],
};
const faCircleCalendar = {
  prefix: 'fad',
  iconName: 'circle-calendar',
  icon: [
    512,
    512,
    ['calendar-circle'],
    'e102',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-96c0-17.7 14.3-32 32-32l32 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 32 0c17.7 0 32 14.3 32 32l0 64 0 128c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-128 0-64z',
      'M192 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 32 0c17.7 0 32 14.3 32 32l0 64-256 0 0-64c0-17.7 14.3-32 32-32l32 0 0-16z',
    ],
  ],
};
const faCalendarCircle = faCircleCalendar;
const faHourglassHalf = {
  prefix: 'fad',
  iconName: 'hourglass-half',
  icon: [
    384,
    512,
    ['hourglass-2'],
    'f252',
    [
      'M32 64l64 0 0 11c0 19 5.6 37.4 16 53L272 128c10.3-15.6 16-34 16-53l0-11 64 0 0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11-48 0-16 0L96 448l-32 0-32 0 0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11zm80 320L272 384c-3.5-5.3-7.6-10.3-12.1-14.9L192 301.3l-67.9 67.9c-4.6 4.6-8.6 9.6-12.1 14.9z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faHourglass2 = faHourglassHalf;
const faMicroscope = {
  prefix: 'fad',
  iconName: 'microscope',
  icon: [
    512,
    512,
    [128300],
    'f610',
    [
      'M96 400c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zM160 32l96 0c0-17.7-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32z',
      'M128 64c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32l0-224zM512 320c0 49.2-18.5 94-48.9 128l16.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l0-64c106 0 192 86 192 192z',
    ],
  ],
};
const faSunset = {
  prefix: 'fad',
  iconName: 'sunset',
  icon: [
    576,
    512,
    [127751],
    'f767',
    [
      'M32 380.6c0 3.2 1 6.4 2.8 9.1L86.1 464l74.9 0c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112l74.9 0 51.3-74.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345 403.1 237.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-2.7-1.9-5.9-2.8-9.1-2.8c-2.1 0-4.2 .4-6.1 1.2c-5 2.1-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6c-.8 2-1.2 4-1.2 6.1zM193.3 464l189.3 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80z',
      'M354.5 104.3L320 135.7 320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 103.7-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464z',
    ],
  ],
};
const faSink = {
  prefix: 'fad',
  iconName: 'sink',
  icon: [
    512,
    512,
    [],
    'e06d',
    [
      'M0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0-48 0-64 0-64 0-64 0-48 0-80 0c-17.7 0-32 14.3-32 32zm32 64l0 32c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-32L32 384z',
      'M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96l0 192 64 0 0-192zM56 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.4 0 8 3.6 8 8l0 24 48 0 0-24c0-30.9-25.1-56-56-56l-48 0zm344 56c0-4.4 3.6-8 8-8l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-30.9 0-56 25.1-56 56l0 24 48 0 0-24z',
    ],
  ],
};
const faCalendarExclamation = {
  prefix: 'fad',
  iconName: 'calendar-exclamation',
  icon: [
    448,
    512,
    [],
    'f334',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM192 432a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm8-176l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 80L0 192l0-80C0 85.5 21.5 64 48 64l48 0 0-32zm96 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-176l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faTruckContainerEmpty = {
  prefix: 'fad',
  iconName: 'truck-container-empty',
  icon: [
    640,
    512,
    [],
    'e2b5',
    [
      'M32 416a64 64 0 1 0 128 0A64 64 0 1 0 32 416zm160 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm288 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M456 144c-13.3 0-24 10.7-24 24l0 88 0 32 0 16L32 304c-17.7 0-32 14.3-32 32l0 16c0 8.8 3.6 16.8 9.4 22.6C24.8 342.3 57.8 320 96 320c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64l85.5 0 21.5 0c13.2-37.3 48.7-64 90.5-64c38.2 0 71.2 22.3 86.6 54.6c5.8-5.8 9.4-13.8 9.4-22.6l0-64 0-16 0-10.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5L456 144zM585 256l-105 0 0-64 48.8 0c2.4 0 4.7 1.1 6.2 2.9L585 256z',
    ],
  ],
};
const faHandHeart = {
  prefix: 'fad',
  iconName: 'hand-heart',
  icon: [
    512,
    512,
    [],
    'f4bc',
    [
      'M11 284.4c-15.2 16-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4zm197 78.2c0-23.5 19.1-42.6 42.6-42.6l1.1 0c14.6 0 28.3 7.3 36.4 19.5c8.1-12.2 21.7-19.5 36.4-19.5l1.1 0c23.5 0 42.6 19.1 42.6 42.6c0 12.1-5.1 23.6-14.1 31.6l-55.2 49.7c-3 2.7-6.9 4.1-10.7 4.1s-7.7-1.4-10.7-4.1l-55.2-49.7c-9-8.1-14.1-19.6-14.1-31.6z',
      'M250.6 320c-23.5 0-42.6 19.1-42.6 42.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6l-1.1 0c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5l-1.1 0z',
    ],
  ],
};
const faBagShopping = {
  prefix: 'fad',
  iconName: 'bag-shopping',
  icon: [
    448,
    512,
    ['shopping-bag'],
    'f290',
    [
      'M0 208L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-208c0-26.5-21.5-48-48-48l-64 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-128 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-64 0c-26.5 0-48 21.5-48 48z',
      'M224 48c-35.3 0-64 28.7-64 64l0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120C112 50.1 162.1 0 224 0s112 50.1 112 112l0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120c0-35.3-28.7-64-64-64z',
    ],
  ],
};
const faShoppingBag = faBagShopping;
const faArrowDownZA = {
  prefix: 'fad',
  iconName: 'arrow-down-z-a',
  icon: [
    576,
    512,
    ['sort-alpha-desc', 'sort-alpha-down-alt'],
    'f881',
    [
      'M304 448c0 11.7 6.5 23 17.7 28.6c15.8 7.9 35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3C521.5 471 528 459.7 528 448c0-4.8-1.1-9.7-3.4-14.3l-16-32-64-128C439.2 262.8 428.1 256 416 256s-23.2 6.8-28.6 17.7l-64 128-16 32c-2.3 4.6-3.4 9.5-3.4 14.3zM320 64c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L352 32c-17.7 0-32 14.3-32 32zm75.8 336L416 359.6 436.2 400l-40.4 0z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortAlphaDesc = faArrowDownZA;
const faSortAlphaDownAlt = faArrowDownZA;
const faMitten = {
  prefix: 'fad',
  iconName: 'mitten',
  icon: [
    448,
    512,
    [],
    'f7b5',
    [
      'M32 416l0 64c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 384c-17.7 0-32 14.3-32 32z',
      'M314.7 234.7L283.2 108.9C267.2 44.9 209.7 0 143.8 0l-3.4 0C62.8 0 0 62.8 0 140.3c0 13 1.8 26 5.4 38.6L64 384l288 0 79.2-85.8c10.8-11.7 16.8-27 16.8-42.9c0-34.9-28.3-63.3-63.3-63.3l-2.8 0c-19 0-37.2 8.2-49.7 22.6l-17.6 20.1z',
    ],
  ],
};
const faReplyClock = {
  prefix: 'fad',
  iconName: 'reply-clock',
  icon: [
    640,
    512,
    ['reply-time'],
    'e239',
    [
      'M0 240c0 9.1 3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-64 96 0c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C430.5 499.9 512 449.3 512 336c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-91.8 0-167.2-70.3-175.3-160L224 160l0-64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240z',
      'M496 288A144 144 0 1 0 496 0a144 144 0 1 0 0 288zM512 80l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faReplyTime = faReplyClock;
const faPersonRays = {
  prefix: 'fad',
  iconName: 'person-rays',
  icon: [
    512,
    512,
    [],
    'e54d',
    [
      'M100.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L184 256.9 184 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c10-6 15.5-16.6 15.5-27.5c0-5.6-1.5-11.3-4.6-16.5l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97zM208 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM471 7L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm464 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80z',
    ],
  ],
};
const faRight = {
  prefix: 'fad',
  iconName: 'right',
  icon: [
    448,
    512,
    [11157, 'arrow-alt-right'],
    'f356',
    [
      'M0 232l0 48c0 22.1 17.9 40 40 40l184 0c0-42.7 0-85.3 0-128c-61.3 0-122.7 0-184 0c-22.1 0-40 17.9-40 40z',
      'M224 320s0 0 0 0l0 96c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 96s0 0 0 0l0 128z',
    ],
  ],
};
const faArrowAltRight = faRight;
const faCircleF = {
  prefix: 'fad',
  iconName: 'circle-f',
  icon: [
    512,
    512,
    [],
    'e10e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z',
      'M160 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z',
    ],
  ],
};
const faUsers = {
  prefix: 'fad',
  iconName: 'users',
  icon: [
    640,
    512,
    [],
    'f0c0',
    [
      'M0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM64 80a80 80 0 1 0 160 0A80 80 0 1 0 64 80zM404.7 320c.2 0 .4 0 .7 0l213.3 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80z',
      'M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0z',
    ],
  ],
};
const faFacePleading = {
  prefix: 'fad',
  iconName: 'face-pleading',
  icon: [
    512,
    512,
    [],
    'e386',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm80.3-83c.2-.9 .4-1.9 .8-2.8c.7-1.8 1.7-3.4 2.9-4.8c2.5-2.8 6-4.8 10-5.3c3.8-.5 7.7-1 11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9c.5-1.7 1-3.4 1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18 6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-.1-.7-.1-1.4-.1-2c0-1 0-1.2 .1-1.5c0-.5 .1-.9 .2-1.4zM208.1 405.3c9.2-10.2 25.2-21.3 47.9-21.3s38.7 11.1 47.9 21.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-4.7-5.3-12.7-10.7-24.1-10.7s-19.4 5.4-24.1 10.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6zM272 240c0-41.4 31.4-75.4 72-79.6c-10-10.8-17.6-24.1-21.9-38.8c-.5-1.7-1-3.4-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9c3.8 .5 7.7 1 11.5 1.4c8.1 1 14 7.9 14 15.9c0 .7 0 1.3-.1 2c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M191.4 116.4c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9s9.1 15 17.9 13.9l11.5-1.4c38.2-4.8 69.8-31.9 80.4-68.9l1.5-5.2zm129.2 0l1.5 5.2c10.6 37 42.2 64.1 80.4 68.9l11.5 1.4c8.8 1.1 16.8-5.1 17.9-13.9s-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8zM128 232c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8c0 17.7-14.3 32-32 32zm224-32c0 17.7-14.3 32-32 32c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8z',
    ],
  ],
};
const faEyeSlash = {
  prefix: 'fad',
  iconName: 'eye-slash',
  icon: [
    640,
    512,
    [],
    'f070',
    [
      'M0 256c0 4.2 .8 8.4 2.5 12.3C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480c56.1 0 104.4-17.8 144.5-43.2l-71.7-56.5C339.4 392.8 314.6 400 288 400c-79.5 0-144-64.5-144-144c0-14.5 2.1-28.5 6.1-41.7L63.5 146c-29.4 34.7-49.9 70.8-61.1 97.6C.8 247.6 0 251.8 0 256zM135.2 80.7L207 136.9c23.1-15.7 51-24.9 81-24.9c79.5 0 144 64.5 144 144c0 17.7-3.2 34.6-9 50.2c28 22 56.1 44 84.1 65.9c32.3-36.6 54.6-75.4 66.4-103.9c1.6-3.9 2.5-8.1 2.5-12.3s-.8-8.4-2.5-12.3c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32c-60 0-111.1 20.3-152.8 48.7zm56.8 179.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9c1.9-.5 3.9-1.1 5.7-1.7l-120-94.6c-3.7 .8-6.7 3.7-6.5 7.7zm92.7-88.4c2.1 6.4 3.3 13.2 3.3 20.3c0 2.7-.2 5.4-.5 8c31.6 24.8 63.2 49.5 94.8 74.3c2.7-13.9 2.4-28.6-1.5-43.2c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faFlaskVial = {
  prefix: 'fad',
  iconName: 'flask-vial',
  icon: [
    640,
    512,
    [],
    'e4f3',
    [
      'M0 32C0 49.7 14.3 64 32 64l0 288c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-18.7 5.2-37.1 15-53.1l49-79.6L224 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 0 96 0 32 0C14.3 0 0 14.3 0 32zM96 64l64 0 0 96-64 0 0-96z',
      'M480 0L352 0 320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 150.9L202.3 406.2c-6.7 10.9-10.3 23.5-10.3 36.4c0 38.3 31.1 69.4 69.4 69.4l309.2 0c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L512 214.9 512 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L480 0zM384 224l0-160 64 0 0 160c0 5.9 1.6 11.7 4.7 16.8L501.5 320l-171 0 48.8-79.2c3.1-5 4.7-10.8 4.7-16.8z',
    ],
  ],
};
const faPoliceBox = {
  prefix: 'fad',
  iconName: 'police-box',
  icon: [
    384,
    512,
    [],
    'e021',
    [
      'M0 488c0 13.3 10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0L32 464l-8 0c-13.3 0-24 10.7-24 24zM96 136l0 24 32 0 0-32-24 0c-4.4 0-8 3.6-8 8zm0 40l0 24c0 4.4 3.6 8 8 8l24 0 0-32-32 0zm48-48l0 32 32 0 0-24c0-4.4-3.6-8-8-8l-24 0zm0 48l0 32 24 0c4.4 0 8-3.6 8-8l0-24-32 0zM176 16l0 16 32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm32 120l0 24 32 0 0-32-24 0c-4.4 0-8 3.6-8 8zm0 40l0 24c0 4.4 3.6 8 8 8l24 0 0-32-32 0zm48-48l0 32 32 0 0-24c0-4.4-3.6-8-8-8l-24 0zm0 48l0 32 24 0c4.4 0 8-3.6 8-8l0-24-32 0z',
      'M96 32C78.3 32 64 46.3 64 64C46.3 64 32 78.3 32 96l0 368 320 0 0-368c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32L96 32zm0 104c0-4.4 3.6-8 8-8l24 0 0 32-32 0 0-24zm0 40l32 0 0 32-24 0c-4.4 0-8-3.6-8-8l0-24zm72-48c4.4 0 8 3.6 8 8l0 24-32 0 0-32 24 0zm-24 48l32 0 0 24c0 4.4-3.6 8-8 8l-24 0 0-32zm72-48l24 0 0 32-32 0 0-24c0-4.4 3.6-8 8-8zm24 48l0 32-24 0c-4.4 0-8-3.6-8-8l0-24 32 0zm16-48l24 0c4.4 0 8 3.6 8 8l0 24-32 0 0-32zm32 48l0 24c0 4.4-3.6 8-8 8l-24 0 0-32 32 0zM96 256c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48z',
    ],
  ],
};
const faCucumber = {
  prefix: 'fad',
  iconName: 'cucumber',
  icon: [
    512,
    512,
    [129362],
    'e401',
    [
      'M120 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm160-32a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96-160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM400 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faHeadSideBrain = {
  prefix: 'fad',
  iconName: 'head-side-brain',
  icon: [
    512,
    512,
    [],
    'f808',
    [
      'M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM64 176c0 20.9 13.4 38.7 32.1 45.3c0 .9-.1 1.8-.1 2.7c0 26.5 21.5 48 48 48c5.6 0 11-1 16-2.7l0 18.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-18.7c5 1.8 10.4 2.7 16 2.7c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16l50.7 0c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7 .1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2c-26.5 0-48 21.5-48 48c-26.5 0-48 21.5-48 48z',
      'M336 208l-50.7 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48c-5.6 0-11-1-16-2.7l0 18.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7c-5 1.8-10.4 2.7-16 2.7c-26.5 0-48-21.5-48-48c0-.9 0-1.8 .1-2.7C77.4 214.7 64 196.9 64 176c0-26.5 21.5-48 48-48c0-26.5 21.5-48 48-48c8.6 0 16.6 2.2 23.5 6.2C192.1 72.8 207 64 224 64s31.9 8.8 40.5 22.2c7-3.9 15-6.2 23.5-6.2c20.9 0 38.7 13.4 45.3 32.1c.9 0 1.8-.1 2.7-.1c26.5 0 48 21.5 48 48s-21.5 48-48 48zM159.9 178.7c0 0 0 0 .1 0l0-2.7c0 .9 0 1.8-.1 2.7z',
    ],
  ],
};
const faHand = {
  prefix: 'fad',
  iconName: 'hand',
  icon: [
    512,
    512,
    [129306, 9995, 'hand-paper'],
    'f256',
    [
      'M11 284.4c-15.2 16-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4zM192 336c0-8.8 7.2-16 16-16l8 0 152 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-77 0c17.9 18.7 29 44.1 29 72l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-39.8-32.2-72-72-72l-8 0c-8.8 0-16-7.2-16-16z',
      'M208 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l8 0c39.8 0 72 32.2 72 72l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-27.9-11-53.3-29-72l77 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-152 0-8 0z',
    ],
  ],
};
const faHandPaper = faHand;
const faPersonBikingMountain = {
  prefix: 'fad',
  iconName: 'person-biking-mountain',
  icon: [
    640,
    512,
    [128693, 'biking-mountain'],
    'f84b',
    [
      'M0 376l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9C97.9 503.1 107.9 512 120 512l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.7-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.8-3.7-14.1-6.8-21.7-9C158.1 264.9 148.1 256 136 256l-16 0c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3L31.8 299.1c-8.6 8.6-9.3 21.9-2.3 31.3c-3.7 6.9-6.8 14.1-9 21.8C8.9 353.9 0 363.9 0 376zm192 8A64 64 0 1 1 64 384a64 64 0 1 1 128 0zm192-8l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.5 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.8-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.9-3.7-14.1-6.8-21.8-9C542.1 264.9 532.1 256 520 256l-16 0c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3c-3.7 6.9-6.8 14.1-9 21.8C392.9 353.9 384 363.9 384 376zm192 8a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM427.2 160l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zm-238.8 6.7L290.8 89.9c7.2-5.4 8.5-15.7 2.9-22.8L278.7 48.4c-21.6-27-60.7-32-88.4-11.2L125.2 86.1c-7.2 5.4-8.5 15.7-2.9 22.8l44 55c5.4 6.7 15.2 8 22.1 2.8z',
    ],
  ],
};
const faBikingMountain = faPersonBikingMountain;
const faUtensilsSlash = {
  prefix: 'fad',
  iconName: 'utensils-slash',
  icon: [
    640,
    512,
    [],
    'e464',
    [
      'M96.1 171.7c1.9 44.2 36.3 80 79.9 83.9L176 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-194.9L96.1 171.7zM116.5 66c14.5 11.4 29 22.7 43.5 34.1L160 16c0-8.2-6.1-15-14.3-15.9s-15.6 4.5-17.4 12.4L116.5 66zm66.2 51.9c41.3 32.3 82.5 64.7 123.8 97c8.6-13.6 13.6-29.7 13.6-47c0-6.4-.7-12.8-2.1-19.1L287.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S256 7.8 256 16l0 134.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L223.9 14.6C223.2 6.3 216.3 0 208 0s-15.2 6.3-15.9 14.6l-9.4 103.3zM384 176l0 99.7c53.3 41.8 106.7 83.6 160 125.4l0-49.1 0-112 0-208c0-17.7-14.3-32-32-32C496 0 384 32 384 176z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faPrintMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'print-magnifying-glass',
  icon: [
    640,
    512,
    ['print-search'],
    'f81a',
    [
      'M64 256l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c24.4 0 45.6-13.7 56.4-33.8l-6.3-6.3c-15.8 5.2-32.6 8-50.2 8c-36 0-69.3-11.9-96-32l-160 0 0-64 0-16 0-16 99.2 0c-2.1-10.3-3.2-21-3.2-32c0-52.3 25.1-98.8 64-128l-224 0c-35.3 0-64 28.7-64 64zM128 64l0 96 64 0 0-96 226.7 0L448 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0L192 0c-35.3 0-64 28.7-64 64z',
      'M528 320.2a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 426c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426z',
    ],
  ],
};
const faPrintSearch = faPrintMagnifyingGlass;
const faTurnRight = {
  prefix: 'fad',
  iconName: 'turn-right',
  icon: [
    512,
    512,
    [],
    'e639',
    [
      'M0 304c0-70.7 57.3-128 128-128l192 0 0 96-192 0c-17.7 0-32 14.3-32 32l0 144c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 304z',
      'M360.5 70.6c-7-6.6-17.2-8.4-26-4.6S320 78.4 320 88l0 272c0 9.6 5.7 18.2 14.5 22s19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136z',
    ],
  ],
};
const faFolderBookmark = {
  prefix: 'fad',
  iconName: 'folder-bookmark',
  icon: [
    512,
    512,
    [],
    'e186',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l0 240c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L368 308l-54.4 40.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-240c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96z',
      'M288 96l0 240c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3l0-240L288 96z',
    ],
  ],
};
const faArrowTurnLeftDown = {
  prefix: 'fad',
  iconName: 'arrow-turn-left-down',
  icon: [
    384,
    512,
    [],
    'e633',
    [
      'M160 96l0 306.7c10.7 10.7 21.3 21.3 32 32c10.7-10.7 21.3-21.3 32-32L224 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L256 0c-53 0-96 43-96 96z',
      'M342.6 329.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 434.7 297.4 329.4c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faOm = {
  prefix: 'fad',
  iconName: 'om',
  icon: [
    512,
    512,
    [128329],
    'f679',
    [
      'M256 79.3c0 .7 0 1.4 0 2.1c.2 2.2 .9 4.3 1.9 6.2l.3 .6c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5c6.1-6 9.7-14.1 9.7-23c0-17.7-14.3-32-32-32c-8.7 0-16.7 3.5-22.4 9.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9c-2.5-1.7-5.2-2.7-8-2.9c-.6 0-1.3-.1-1.9 0c-3.9 .2-7.4 1.7-10.1 4.2c-.9 .8-1.6 1.7-2.3 2.6c-1.7 2.4-2.7 5.3-2.9 8.5zm84.7-58.6c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16C376.2 1.6 372.1 0 368 0s-8.2 1.6-11.3 4.7l-16 16z',
      'M115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48l-34.2 0c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9l8.9 0 16 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5c-.3-.9-.7-1.8-1.1-2.6c-1.2-2.2-2.8-4-4.7-5.4c-1.9-1.4-4.1-2.3-6.5-2.8c-1.4-.3-2.9-.3-4.4-.2c-2.5 .2-4.8 1-6.8 2.3c-1.1 .7-2.2 1.5-3.1 2.5c-2.4 2.5-4.1 5.8-4.5 9.5c-.1 .6-.1 1.1-.1 1.7c0 0 0 0 0 0c0 .8 .1 1.7 .2 2.5l0 .1c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64l22.6 0c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4l5.5 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.2c-.3-1.3-.8-2.6-1.5-3.8c-1.1-2-2.6-3.8-4.4-5.1c-2.7-2-6-3.2-9.6-3.2l-.2 0c-8 .1-14.6 6.1-15.6 13.9c0 0 0 0 0 0l-.1 .5-.1 .6c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96l0-96c0-53-43-96-96-96l-5.5 0c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4l-48.3 0c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4z',
    ],
  ],
};
const faPi = {
  prefix: 'fad',
  iconName: 'pi',
  icon: [
    448,
    512,
    [],
    'f67e',
    [
      'M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l64 0 0 156c0 39.7-9.3 78.9-27 114.5l-1.6 3.2c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l1.6-3.2C148.4 382.7 160 333.7 160 284l0-156 128 0 0 238.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4L352 128l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 64z',
      '',
    ],
  ],
};
const faFlaskRoundPotion = {
  prefix: 'fad',
  iconName: 'flask-round-potion',
  icon: [
    448,
    512,
    ['flask-potion'],
    'f6e1',
    [
      'M16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L304 0 144 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 93.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352zm64 0c0-7.2 .5-14.3 1.5-21.2c6.5-44.1 33-81.7 70.2-103.4c23.4-13.6 40.3-39.3 40.3-69.7L192 64l64 0 0 93.7c0 30.4 16.9 56.1 40.3 69.7c43 25 71.6 71.4 71.7 124.7c0 .8 0 1.7 0 2.9c0 .1 0 .5 0 1c0 .4 0 .9-.1 1.6c-.5 14.1-3.1 27.7-7.4 40.5c-.7 2-1.4 4.1-2.2 6.1c-6.3 16.2-15.5 31-26.9 43.7l-214.7 0C93.8 422.5 80 388.9 80 352z',
      'M368 351.8c-58.6-1.7-85.4-12.6-109.9-22.6c-22-9-42.2-17.2-82.1-17.2c-42.3 0-73.4 9.2-94.5 18.8c-1 6.9-1.5 14-1.5 21.2c0 36.9 13.8 70.5 36.7 96l214.7 0c22.9-25.5 36.7-59.1 36.7-96l0-.2z',
    ],
  ],
};
const faFlaskPotion = faFlaskRoundPotion;
const faFaceShush = {
  prefix: 'fad',
  iconName: 'face-shush',
  icon: [
    512,
    512,
    [],
    'e38c',
    [
      'M0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 82.2-38.8 155.4-99 202.3c7.4-21.4 1.3-46-17.1-61.3c-13.5-11.3-30.8-15.1-46.9-11.9c-5.7-21.2-19.1-39.2-37-50.9l0-58.3c14.8-6.9 26.6-15.9 35.3-24.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-3.7 3.7-8.1 7.4-13.3 10.9c-4-27-27.3-47.6-55.4-47.6s-51.3 20.7-55.4 47.6c-5.2-3.5-9.6-7.3-13.3-10.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6c8.7 8.7 20.5 17.7 35.3 24.6l0 50.1c-32.8 12.8-56 44.7-56 82l0 24 0 24c0 11.8 2.3 23.1 6.5 33.3C61.8 449.1 0 359.8 0 256zM144.4 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm160 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M256 224c13.3 0 24 10.7 24 24l0 72-48 0 0-72c0-13.3 10.7-24 24-24zM232 400c-4.4 0-8 3.6-8 8l0 11.5L287.6 464l10 0c7.1 0 13.9-3.2 18.4-8.6l25.6-30.7c8.5-10.2 23.6-11.6 33.8-3.1s11.6 23.6 3.1 33.8l-25.6 30.7c-13.7 16.4-33.9 25.9-55.3 25.9L280 512l-48 0c-30.9 0-56-25.1-56-56l0-24 0-24c0-30.9 25.1-56 56-56l32 0c30.9 0 56 25.1 56 56l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-4.4-3.6-8-8-8l-32 0z',
    ],
  ],
};
const faWorm = {
  prefix: 'fad',
  iconName: 'worm',
  icon: [
    512,
    512,
    [],
    'e599',
    [
      'M0 312L0 464c0 26.5 21.5 48 48 48s48-21.5 48-48l0-152c0-30.9 25.1-56 56-56s56 25.1 56 56l0 48c0 83.9 68.1 152 152 152s152-68.1 152-152l0-168 0-16 0-86.4C512 40.1 471.9 0 422.4 0L384 0c-53 0-96 43-96 96s43 96 96 96l32 0 0 168c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-48c0-83.9-68.1-152-152-152S0 228.1 0 312zM432 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M384 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faHouseCircleXmark = {
  prefix: 'fad',
  iconName: 'house-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e50b',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faPlug = {
  prefix: 'fad',
  iconName: 'plug',
  icon: [
    384,
    512,
    [128268],
    'f1e6',
    [
      'M64 32l0 128 64 0 0-128c0-17.7-14.3-32-32-32S64 14.3 64 32zm192 0l0 128 64 0 0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 32c0 77.4-55 142-128 156.8l0 67.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.2C87 398 32 333.4 32 256l0-32c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faCalendarCircleExclamation = {
  prefix: 'fad',
  iconName: 'calendar-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e46e',
    [
      'M0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112zm0 80L0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faSquareI = {
  prefix: 'fad',
  iconName: 'square-i',
  icon: [
    448,
    512,
    [],
    'e272',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24z',
      'M128 152c0-13.3 10.7-24 24-24l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faChevronUp = {
  prefix: 'fad',
  iconName: 'chevron-up',
  icon: [
    512,
    512,
    [],
    'f077',
    [
      'M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z',
      '',
    ],
  ],
};
const faFaceSaluting = {
  prefix: 'fad',
  iconName: 'face-saluting',
  icon: [
    640,
    512,
    [129761],
    'e484',
    [
      'M101.7 310C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-18.4 0-36.3 1.9-53.5 5.6c12.6 27.9 3.8 61.6-22.4 79.4l-54.6 37c8.6 4.4 16.3 10.9 22.3 19.2c8.6 11.9 12.6 25.7 12.2 39.3c4.8-2.8 10.4-4.5 16.3-4.5c17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.9 0-25.8-8.9-30.2-21.4c-3.5 4.4-7.7 8.5-12.5 12l-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6zM235 344.6c5.2-7.2 15.2-8.8 22.3-3.6c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3zM464.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M258.1 58.5c14.6-9.9 18.4-29.8 8.5-44.4S236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7s-30.4-17.5-44.7-7.1L128 185.8l0-39.1L258.1 58.5z',
    ],
  ],
};
const faGaugeSimpleLow = {
  prefix: 'fad',
  iconName: 'gauge-simple-low',
  icon: [
    512,
    512,
    ['tachometer-slow'],
    'f62c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 152c0-8.7 4.7-17 12.9-21.3c11.8-6.1 26.3-1.5 32.4 10.2c25.5 49.1 51.1 98.2 76.6 147.4c2-.2 4-.3 6.1-.3c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.9 5.8-30.4 15.3-41.6L130.7 163.1c-1.8-3.5-2.7-7.3-2.7-11.1z',
      'M173.3 140.9c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9z',
    ],
  ],
};
const faTachometerSlow = faGaugeSimpleLow;
const faFacePersevering = {
  prefix: 'fad',
  iconName: 'face-persevering',
  icon: [
    512,
    512,
    [],
    'e385',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-96c0-7.7 5.5-14.5 13.4-15.8l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2c-.1-.9-.2-1.8-.2-2.6zm20 61.2c0-9 9.6-14.7 17.5-10.5c30 16 59.9 32 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8c-30 16-59.9 32-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2c-12-14.4-24-28.8-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm56.1 168.2C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6zM288.6 258.6l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5c-30-16-59.9-32-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8zm12-157.9c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z',
      'M211.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zm89.4 0l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM133.5 210.7c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 221.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6z',
    ],
  ],
};
const faCircleCamera = {
  prefix: 'fad',
  iconName: 'circle-camera',
  icon: [
    512,
    512,
    ['camera-circle'],
    'e103',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-64c0-17.7 14.3-32 32-32l36 0 6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6l62.7 0c10 0 19 6.2 22.5 15.6L316 160l36 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-128z',
      'M202.2 143.6L196 160l-36 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-36 0-6.2-16.4c-3.5-9.4-12.5-15.6-22.5-15.6l-62.7 0c-10 0-19 6.2-22.5 15.6zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faCameraCircle = faCircleCamera;
const faHandSpock = {
  prefix: 'fad',
  iconName: 'hand-spock',
  icon: [
    576,
    512,
    [128406],
    'f259',
    [
      'M32 312c0 10.6 4.2 21.1 12.4 29L156.8 448c43.1 41.1 100.4 64 160 64l10.9 0 8.2 0c.1-.2 .2-.2 .2-.3c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4c-7.4 7.7-11 17.7-11 27.6zm192 24c0-8.8 7.2-16 16-16l8 0 152 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-77 0c17.9 18.7 29 44.1 29 72l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-39.8-32.2-72-72-72l-8 0c-8.8 0-16-7.2-16-16z',
      'M240 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l8 0c39.8 0 72 32.2 72 72l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-27.9-11-53.3-29-72l77 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-152 0-8 0z',
    ],
  ],
};
const faSpiderWeb = {
  prefix: 'fad',
  iconName: 'spider-web',
  icon: [
    576,
    512,
    [128376],
    'f719',
    [
      'M68.4 256l23.3 28 44.6 0c21.9 26.6 38.9 56.9 50.4 89.4l.7 2-22.2 38.9c4.2 11.3 8.5 22.5 12.7 33.8c12.1-2.3 24.3-4.5 36.4-6.8L235.1 405l.8-.2c34.4-6.1 69.7-6.1 104.1 0l.8 .2 20.8 36.4 36.4 6.8 12.7-33.8-22.2-38.9 .7-2c11.5-32.5 28.5-62.8 50.4-89.4l44.6 0c7.8-9.3 15.6-18.7 23.3-28c-7.8-9.3-15.6-18.7-23.3-28l-44.6 0c-21.9-26.6-38.9-56.9-50.4-89.4l-.7-2 22.2-38.9c-4.2-11.3-8.5-22.5-12.7-33.8c-12.1 2.3-24.3 4.5-36.4 6.8L340.9 107l-.8 .1c-34.4 6.1-69.7 6.1-104.1 0l-.8-.1L214.4 70.7c-12.1-2.3-24.3-4.5-36.4-6.8c-4.2 11.3-8.5 22.5-12.7 33.8l22.2 38.9-.7 2c-11.5 32.5-28.5 62.8-50.4 89.4l-44.6 0L68.4 256zm127.4-28c8.1-12.4 15.4-25.3 21.8-38.7L239.8 228l-43.9 0zm0 56l43.9 0-22.1 38.7c-6.4-13.4-13.7-26.3-21.8-38.7zm69-125c15.4 1 30.9 1 46.3 0L288 199.6 264.8 159zm0 194L288 312.4 311.2 353c-15.4-1-30.9-1-46.3 0zm71.4-125l22.1-38.7c6.4 13.4 13.7 26.3 21.8 38.7l-43.9 0zm0 56l43.9 0c-8.1 12.4-15.4 25.3-21.8 38.7L336.2 284z',
      'M133.8 22.2c4.8-12.7 18-20.2 31.4-17.7l69 12.9c35.6 6.7 72.1 6.7 107.6 0l69-12.9c13.4-2.5 26.6 5 31.4 17.7l28.9 77.2c11.5 30.7 28.1 59.2 49.1 84.4l45.3 54.3c8.7 10.4 8.7 25.5 0 35.9l-45.3 54.3c-21 25.2-37.6 53.7-49.1 84.4l-28.9 77.2c-4.8 12.7-18 20.2-31.4 17.7l-69-12.9c-35.6-6.7-72.1-6.7-107.6 0l-69 12.9c-13.4 2.5-26.6-5-31.4-17.7l-28.9-77.2C93.3 382 76.7 353.4 55.7 328.2L10.5 273.9c-8.7-10.4-8.7-25.5 0-35.9l45.3-54.3c21-25.2 37.6-53.7 49.1-84.4l28.9-77.2zM178 63.9L157.3 119c-13.7 36.6-33.5 70.6-58.5 100.6L68.4 256l30.3 36.4c25 30 44.8 64 58.5 100.6L178 448.1l45.9-8.6c42.4-7.9 85.9-7.9 128.3 0l45.9 8.6L418.7 393c13.7-36.6 33.5-70.6 58.5-100.6L507.6 256l-30.3-36.4c-25-30-44.8-64-58.5-100.6L398 63.9l-45.9 8.6c-42.4 7.9-85.9 7.9-128.3 0L178 63.9z',
    ],
  ],
};
const faCircleMicrophone = {
  prefix: 'fad',
  iconName: 'circle-microphone',
  icon: [
    512,
    512,
    ['microphone-circle'],
    'e116',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 65.3-48.9 119.1-112 127l0 17c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17c-63.1-7.9-112-61.7-112-127l0-16zm80-96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112z',
      'M256 96c-26.5 0-48 21.5-48 48l0 112c0 26.5 21.5 48 48 48s48-21.5 48-48l0-112c0-26.5-21.5-48-48-48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 65.3 48.9 119.1 112 127l0 17c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17c63.1-7.9 112-61.7 112-127l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 53-43 96-96 96s-96-43-96-96l0-16z',
    ],
  ],
};
const faMicrophoneCircle = faCircleMicrophone;
const faBookArrowUp = {
  prefix: 'fad',
  iconName: 'book-arrow-up',
  icon: [
    448,
    512,
    [],
    'e0ba',
    [
      'M64 416c0 17.7 14.3 32 32 32l120 0 0-64L96 384c-17.7 0-32 14.3-32 32zm200-32l0 64 88 0 64 0 0-64-64 0-88 0z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l120 0 0-64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l120 0 0-174.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L264 384l88 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zM264 448l0 64 120 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-88 0z',
    ],
  ],
};
const faPopsicle = {
  prefix: 'fad',
  iconName: 'popsicle',
  icon: [
    320,
    512,
    [],
    'e43e',
    [
      'M0 160L0 336c0 26.5 21.5 48 48 48l80 0 0-192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192 80 0c26.5 0 48-21.5 48-48l0-176C320 71.6 248.4 0 160 0S0 71.6 0 160z',
      'M128 192c0-17.7 14.3-32 32-32s32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V192z',
    ],
  ],
};
const faCommand = {
  prefix: 'fad',
  iconName: 'command',
  icon: [
    512,
    512,
    [],
    'e142',
    [
      'M0 416c0 53 43 96 96 96s96-43 96-96l0-32 0-64 0-128-64 0 0 128-32 0c-53 0-96 43-96 96zm64 0c0-17.7 14.3-32 32-32l32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32zM320 96l0 32 0 64 0 128 64 0 0-128 32 0c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96zm64 0c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32l-32 0 0-32z',
      'M0 96C0 43 43 0 96 0s96 43 96 96l0 32 128 0 0 64-128 0-64 0-32 0c0 0 0 0 0 0C43 192 0 149 0 96zM320 320l64 0 32 0c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96l0-32-128 0 0-64 128 0zM128 128l0-32c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32l32 0zM384 384l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-32 0z',
    ],
  ],
};
const faBlinds = {
  prefix: 'fad',
  iconName: 'blinds',
  icon: [
    512,
    512,
    [],
    'f8fb',
    [
      'M0 107.3C0 118.8 9.2 128 20.6 128L128 128l0-64c-32 0-64 0-96 0c-1.6 0-3.1-.1-4.6-.3s-3-.5-4.4-1c-2.9-.8-5.6-2.1-8-3.6L1.1 100.8c-.7 2.1-1.1 4.3-1.1 6.5zm0 128C0 246.8 9.2 256 20.6 256l78.1 0c4.8-13.6 15.6-24.4 29.3-29.3l0-66.7L24 160 1.1 228.8c-.7 2.1-1.1 4.3-1.1 6.5zm0 128C0 374.8 9.2 384 20.6 384l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 288l-298.7 0c-6.6 18.6-24.4 32-45.3 32c-2.6 0-5.2-.2-7.7-.6s-4.9-1-7.3-1.8c-4.7-1.5-9.1-3.8-13-6.6c-7.9-5.7-14-13.7-17.3-23L24 288 1.1 356.8c-.7 2.1-1.1 4.3-1.1 6.5zm0 128C0 502.8 9.2 512 20.6 512l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 416 24 416 1.1 484.8c-.7 2.1-1.1 4.3-1.1 6.5zM160 64l0 64 331.4 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L497 59.1c-4.9 3.1-10.8 4.9-17 4.9c-106.7 0-213.3 0-320 0zm0 96l0 66.7c.9 .3 1.7 .6 2.5 1c.9 .4 1.7 .7 2.5 1.1c1.6 .8 3.2 1.7 4.7 2.6c3 1.9 5.8 4.1 8.3 6.6c5 5 8.9 11.1 11.3 17.9l302.1 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 160l-328 0z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l96 0 0 162.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 64l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0z',
    ],
  ],
};
const faStopwatch = {
  prefix: 'fad',
  iconName: 'stopwatch',
  icon: [
    448,
    512,
    [9201],
    'f2f2',
    [
      'M16 304C16 200 92.3 113.8 192 98.4c10.4-1.6 21.1-2.4 32-2.4s21.6 .8 32 2.4c37.5 5.8 71.7 21.6 99.7 44.6c16.6 13.6 31 29.7 42.8 47.7C419.7 223.3 432 262.2 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304zM200 192l0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M144 32c0-17.7 14.3-32 32-32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 34.4c-10.4-1.6-21.1-2.4-32-2.4s-21.6 .8-32 2.4L192 64l-16 0c-17.7 0-32-14.3-32-32zM355.7 143l21.6-21.6c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-24.1 24.1c-11.7-18-26.2-34.1-42.8-47.7zM248 192l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faSaxophone = {
  prefix: 'fad',
  iconName: 'saxophone',
  icon: [
    640,
    512,
    [127927],
    'f8dc',
    [
      'M0 152c0 13.3 10.7 24 24 24l4.2 0L4.4 277.4C1.5 289.7 0 302.4 0 315.1l0 3.1C0 407.6 72.4 480 161.8 480c49.4 0 96.1-22.6 126.8-61.4L534.4 108.1c6.1-7.7 15.3-12.1 25.1-12.1l64.2 0c9 0 16.3-7.3 16.3-16.3c0-4.9-2.2-9.5-5.9-12.6L609.8 46.8c-11.5-9.6-26-14.8-41-14.8l-30.3 0c-17 0-33.3 6.7-45.3 18.7L449 95 415 129 401 143 367 177 353 191 319 225 206.6 337.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6l0-2.6c0-4.4 1.2-8.8 3.4-12.6L246.7 176l17.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 128c-13.3 0-24 10.7-24 24zM120 320a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32-96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M319 225L353 191l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zm48-48L401 143l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zm48-48L449 95l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8zM152 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-32 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faSquare2 = {
  prefix: 'fad',
  iconName: 'square-2',
  icon: [
    448,
    512,
    [],
    'e257',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128.2 85.3c.1-.9 .3-1.8 .5-2.7c.4-1.8 1-3.5 1.8-5.1c1.6-3.3 4-6.3 7.1-8.6c8.1-6.1 16.1-12.3 24.2-18.4c15.8-12 35.2-18.4 55.1-18.1c1.1 0 2.3 0 3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1c-21.5 20.1-42.9 40.3-64.4 60.4c27.8 0 55.5 0 83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-48 0-96 0-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3c36.2-34 72.5-67.9 108.7-101.9c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3c-8.1 6.1-16.1 12.3-24.2 18.4c-10.5 8-25.6 6-33.6-4.6c-1.7-2.2-2.9-4.5-3.7-7c-.4-1.2-.7-2.5-.9-3.7c-.1-.9-.2-1.9-.2-1.8c-.1-1-.1-1-.1-2c0-.9 0-1.1 0-1.4c0-.4 .1-.9 .1-1.3z',
      'M216 176.3c-9.1-.1-18 2.8-25.3 8.3l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336l83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1z',
    ],
  ],
};
const faFieldHockeyStickBall = {
  prefix: 'fad',
  iconName: 'field-hockey-stick-ball',
  icon: [
    512,
    512,
    [127953, 'field-hockey'],
    'f44c',
    [
      'M352 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm10.2-321.3c26.6 17.8 53.2 35.5 79.9 53.3c20.4-29.6 40.9-59.1 61.3-88.7c15.1-21.8 9.6-51.7-12.2-66.8C482.9 2.8 473.4 0 464 0c-15.2 0-30.2 7.2-39.5 20.7l-62.2 90z',
      'M442.1 164l-79.9-53.3L162 400.3c-6.7 9.7-17.7 15.4-29.4 15.5c-20 .1-36.1-16.2-36-36.1l0-2.2c.1-7.3 2.2-14.4 6.2-20.6l17.3-26.5c14.5-22.2 8.3-51.9-13.9-66.4s-51.9-8.3-66.4 13.9L22.5 304.3C8.4 325.8 .8 350.9 .6 376.7l0 2.2C.1 452.3 59.5 512 132.9 511.8c43.2-.1 83.5-21.4 108.1-56.9L442.1 164z',
    ],
  ],
};
const faFieldHockey = faFieldHockeyStickBall;
const faArrowUpSquareTriangle = {
  prefix: 'fad',
  iconName: 'arrow-up-square-triangle',
  icon: [
    576,
    512,
    ['sort-shapes-up-alt'],
    'f88b',
    [
      'M304 448c0 5.3 1.3 10.7 4 15.5c5.6 10.2 16.4 16.5 28 16.5l160 0c11.6 0 22.3-6.3 28-16.5c2.7-4.8 4-10.2 4-15.5c0-5.9-1.6-11.8-4.9-17l-80-128c-5.8-9.4-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-3.2 5.2-4.9 11.1-4.9 17zM320 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortShapesUpAlt = faArrowUpSquareTriangle;
const faFaceScream = {
  prefix: 'fad',
  iconName: 'face-scream',
  icon: [
    640,
    512,
    [],
    'e38b',
    [
      'M64 256c0 11 .7 21.9 2.1 32.6c20.6-2.5 41.7 3.5 57.8 16.9c57.6 48 87.8 118 98 187C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c10.2-69 40.4-139 98-187c16.1-13.4 37.2-19.5 57.8-17c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256zm110.6-67c17.1-28 44.5-45 68.7-45c7.6 0 14.9 1.7 21.4 5.3c27.3 14.9 31.1 56.9 8.7 93.7s-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7zM272 368c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zm94.6-125c-22.5-36.9-18.6-78.8 8.7-93.7s67.6 2.9 90.1 39.8s18.6 78.8-8.7 93.7s-67.6-2.9-90.1-39.8z',
      'M183.3 282.7c27.3 14.9 67.6-2.9 90.1-39.8s18.6-78.8-8.7-93.7s-67.6 2.9-90.1 39.8s-18.6 78.8 8.7 93.7zm273.4 0c27.3-14.9 31.1-56.9 8.7-93.7s-62.8-54.7-90.1-39.8s-31.1 56.9-8.7 93.7s62.8 54.7 90.1 39.8zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9zM588.5 327c-16.4-10.6-37.6-8.8-51.8 3.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3z',
    ],
  ],
};
const faSquareM = {
  prefix: 'fad',
  iconName: 'square-m',
  icon: [
    448,
    512,
    [],
    'e276',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 56c0-10.4 6.7-19.6 16.6-22.8c2.4-.8 4.9-1.2 7.4-1.2c7.6 0 14.9 3.6 19.5 9.9c28.2 39 56.4 78 84.5 117.1c28.2-39 56.4-78 84.5-117.1c4.6-6.4 11.9-10 19.5-9.9c2.5 0 4.9 .4 7.4 1.2c9.9 3.2 16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8c-20.2 27.9-40.4 55.9-60.5 83.8c-4.5 6.2-11.7 10-19.5 9.9s-14.9-3.7-19.5-9.9c-20.2-27.9-40.4-55.9-60.5-83.8L144 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z',
      'M112.6 129.2c9.9-3.2 20.7 .3 26.8 8.8L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2 144 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.4 6.7-19.6 16.6-22.8z',
    ],
  ],
};
const faCameraWeb = {
  prefix: 'fad',
  iconName: 'camera-web',
  icon: [
    448,
    512,
    ['webcam'],
    'f832',
    [
      'M96 224a128 128 0 1 0 256 0A128 128 0 1 0 96 224zm48 0c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
      'M448 224c0 79.5-41.4 149.3-103.8 189.1l58.2 40.7c11.4 8 16.4 22.5 12.2 35.8S398 512 384 512L64 512c-14 0-26.3-9.1-30.5-22.4s.7-27.8 12.2-35.8l58.2-40.7C41.4 373.3 0 303.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 384a160 160 0 1 0 0-320 160 160 0 1 0 0 320z',
    ],
  ],
};
const faWebcam = faCameraWeb;
const faCommentArrowDown = {
  prefix: 'fad',
  iconName: 'comment-arrow-down',
  icon: [
    512,
    512,
    [],
    'e143',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160 16c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l31 31L232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 118.1 31-31c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17l-72 72c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7l-72-72c-4.7-4.7-7-10.8-7-17z',
      'M256 128c13.3 0 24 10.7 24 24l0 118.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L232 152c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faLightbulbCfl = {
  prefix: 'fad',
  iconName: 'lightbulb-cfl',
  icon: [
    320,
    512,
    [],
    'e5a6',
    [
      'M0 64c0 2.6 .3 5.2 1 7.8C5.2 88.9 22.6 99.3 39.8 95l128-32c17.1-4.3 27.6-21.7 23.3-38.8C187.4 9.7 174.4 0 160 0c-2.6 0-5.2 .3-7.8 1L24.2 33C9.7 36.6 0 49.6 0 64zm0 96c0 2.6 .3 5.2 1 7.8c4.3 17.1 21.7 27.6 38.8 23.3l256-64c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64C9.7 132.6 0 145.6 0 160zm0 96c0 2.6 .3 5.2 1 7.8c4.3 17.1 21.7 27.6 38.8 23.3L96 273l3.9-1 195.8-49c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64C9.7 228.6 0 241.6 0 256zm96 50l0 78 48 0 0-90L96 306zm80.2-2c-.2 1.1-.2 2.2-.2 3.3c0 .5 0 .9 0 1.4l0 75.3 48 0c0-15.7 0-31.3 0-47l7.8-1.9 64-16c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-64 16-16 4c-13.2 3.3-22.4 14.3-24 27z',
      'M96 384c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c0 17.7 14.3 32 32 32s32-14.3 32-32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L96 384z',
    ],
  ],
};
const faWindowFrameOpen = {
  prefix: 'fad',
  iconName: 'window-frame-open',
  icon: [
    512,
    512,
    [],
    'e050',
    [
      'M96 64l0 160 136 0 0-160L96 64zm184 0l0 160 136 0 0-160L280 64z',
      'M480 224l0-160c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 160 0 64 64 0 320 0 64 0 0-64zm-64 0l-136 0 0-160 136 0 0 160zm-184 0L96 224 96 64l136 0 0 160zM96 448l0-128-64 0 0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 384 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128-64 0 0 128L96 448z',
    ],
  ],
};
const faFaceKiss = {
  prefix: 'fad',
  iconName: 'face-kiss',
  icon: [
    512,
    512,
    [128535, 'kiss'],
    'f596',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm87.9 86c.9-3.5 4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 4.1-9.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c.1 0 .1-.1 .5-.3l.6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3c-.2-.1-.3-.2-.7-.4c-3.2-1.8-4.7-5.5-3.8-9zm136.1-86a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faKiss = faFaceKiss;
const faBridgeCircleXmark = {
  prefix: 'fad',
  iconName: 'bridge-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e4cb',
    [
      'M32 64c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-40 0 0 64 72 0 0 72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-53-43-96-96-96l0-128 72 0 0-64L64 96C46.3 96 32 81.7 32 64zM152 96l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faPeriod = {
  prefix: 'fad',
  iconName: 'period',
  icon: [192, 512, [], '2e', ['M32 416a64 64 0 1 1 128 0A64 64 0 1 1 32 416z', '']],
};
const faFaceGrinTongue = {
  prefix: 'fad',
  iconName: 'face-grin-tongue',
  icon: [
    512,
    512,
    [128539, 'grin-tongue'],
    'f589',
    [
      'M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 448l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z',
    ],
  ],
};
const faGrinTongue = faFaceGrinTongue;
const faUpToDottedLine = {
  prefix: 'fad',
  iconName: 'up-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e457',
    [
      'M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm96 0A32 32 0 1 1 96 64a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M196.7 139.3L73.9 262.1c-6.4 6.4-9.9 15-9.9 24C64 304.8 79.2 320 97.9 320l62.1 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L251.3 139.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3z',
    ],
  ],
};
const faThoughtBubble = {
  prefix: 'fad',
  iconName: 'thought-bubble',
  icon: [
    512,
    512,
    [],
    'e32e',
    [
      'M0 480a32 32 0 1 0 64 0A32 32 0 1 0 0 480zm96-48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M374.8 80.3C355.9 33.2 309.8 0 256 0s-99.9 33.2-118.8 80.3c-3-.2-6.1-.3-9.2-.3C57.3 80 0 137.3 0 208s57.3 128 128 128c14.4 0 28.3-2.4 41.3-6.8C184.7 361.6 217.7 384 256 384s71.3-22.4 86.7-54.8c12.9 4.4 26.8 6.8 41.3 6.8c70.7 0 128-57.3 128-128s-57.3-128-128-128c-3.1 0-6.1 .1-9.2 .3z',
    ],
  ],
};
const faSkeletonRibs = {
  prefix: 'fad',
  iconName: 'skeleton-ribs',
  icon: [
    640,
    512,
    [],
    'e5cb',
    [
      'M0 144l0 96L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-240c0-10.1 4.7-19.6 12.8-25.6l25.6-19.2C118.5 183.1 128 164.1 128 144c0-35.3-28.7-64-64-64S0 108.7 0 144zM160.3 372.7L288 337.9l0 42c21.1-4.3 42.9-4.3 64 0l0-40.9 118.8 35.6c3 .9 6.1 1.3 9.1 1.4c-.7-22.1-4.5-45.3-10.1-68.5L352 272.2l0-40.3 102 22.7c-9-26-19.4-50.6-29.3-72.1L352 166.3l0-38.3-64 0 0 38.3-72.7 16.2c-9.9 21.4-20.2 46.1-29.3 72.1l102-22.7 0 39.7L171.2 303.4c-5.9 23.4-9.9 46.9-11 69.3zM288 32l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 414.2l0 33.8c0 17.7 14.3 32 32 32s32-14.3 32-32l0-33.8c-20.7-7.3-43.3-7.3-64 0zM512 144c0 20.1 9.5 39.1 25.6 51.2l25.6 19.2c8.1 6 12.8 15.5 12.8 25.6l0 240c0 17.7 14.3 32 32 32s32-14.3 32-32l0-240 0-96c0-35.3-28.7-64-64-64s-64 28.7-64 64z',
      'M178.2 112.9C194.5 81.6 226.7 64 260.2 64l119.5 0c33.5 0 65.8 17.6 82.1 48.9C489.5 165.8 544 282.2 544 384l0 17c0 43.6-35.4 79-79 79c-15.1 0-30.1-2.7-44.2-8l-67.1-25.2c-21.7-8.2-45.7-8.2-67.4 0L219.2 472c-14.1 5.3-29.1 8-44.2 8c-43.6 0-79-35.4-79-79l0-17c0-101.8 54.5-218.2 82.2-271.1zM260.2 128c-11.4 0-20.8 5.9-25.3 14.5C207.2 195.6 160 299.4 160 384l0 17c0 8.3 6.7 15 15 15c7.4 0 14.8-1.3 21.7-3.9l67.1-25.2c36.2-13.6 76.1-13.6 112.4 0l67.1 25.2c7 2.6 14.3 3.9 21.7 3.9c8.3 0 15-6.7 15-15l0-17c0-84.6-47.2-188.4-74.9-241.5c-4.5-8.6-13.9-14.5-25.3-14.5l-119.5 0z',
    ],
  ],
};
const faRaygun = {
  prefix: 'fad',
  iconName: 'raygun',
  icon: [
    576,
    512,
    [],
    'e025',
    [
      'M64 24.6l0 50.2C78.5 67.9 94.8 64 112 64l80 0L102.2 4.1C98.2 1.4 93.4 0 88.6 0C75 0 64 11 64 24.6zM288 56l0 8 0 231.6 0 .4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 32l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 0-64 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M288 64L112 64C50.1 64 0 114.1 0 176s50.1 112 112 112l8.2 0L51.4 425.7c-7.9 15.8-1.5 35 14.3 42.9l80 40c15.8 7.9 35 1.5 42.9-14.3L288 295.6 288 64zM416 208l60.9 0 77.1 30.9c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2l0-96c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L476.9 144 416 144l0 64zM112 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faFlute = {
  prefix: 'fad',
  iconName: 'flute',
  icon: [
    640,
    512,
    [],
    'f8b9',
    [
      'M0 208l0 96c0 26.5 21.5 48 48 48l48 0 0-192-48 0c-26.5 0-48 21.5-48 48zm128-48l0 192 464 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-464 0zm216 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M128 160l-32 0 0 192 32 0 0-192zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faAcorn = {
  prefix: 'fad',
  iconName: 'acorn',
  icon: [
    448,
    512,
    [],
    'f6ae',
    [
      'M48 192l0 32c0 78.1 30.5 201.9 165.9 252.4c3.2 1.2 6.7 1.8 10.1 1.8s6.9-.6 10.1-1.8C369.5 425.9 400 302.1 400 224l0-32L48 192z',
      'M267.2 38.4c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8L224 16c-10.7 14.3-18 30.7-21.6 48L96 64C43 64 0 107 0 160c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32c0-53-43-96-96-96l-99.9 0c2.4-6.8 5.9-13.3 10.3-19.2l4.8-6.4z',
    ],
  ],
};
const faVideoArrowUpRight = {
  prefix: 'fad',
  iconName: 'video-arrow-up-right',
  icon: [
    576,
    512,
    [],
    'e2c9',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-68.2 0-119.6 0-68.2c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zM96 328c0-6.1 2.3-12.3 7-17l103-103L152 208c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1L137 345c-9.4 9.4-24.6 9.4-33.9 0c-4.7-4.7-7-10.8-7-17z',
      'M559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 315.8l0-119.6 142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM152 160l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103L152 208c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faGrateDroplet = {
  prefix: 'fad',
  iconName: 'grate-droplet',
  icon: [
    576,
    512,
    [],
    'e194',
    [
      'M0 96L0 256 0 416c0 35.3 28.7 64 64 64l64 0 96 0 96 0 24.2 0c-15.3-22.9-24.2-50.4-24.2-80c0-23.6 5.8-46.9 16.9-67.8l75.3-141.2c7.6-14.3 20.6-24.5 35.8-28.8L448 96c0-35.3-28.7-64-64-64l-64 0-96 0-96 0L64 32C28.7 32 0 60.7 0 96zm64 0l32 0 0 128-32 0L64 96zm0 192l32 0 0 128-32 0 0-128zM160 96l32 0 0 128-32 0 0-128zm0 192l32 0 0 128-32 0 0-128zM256 96l32 0 0 128-32 0 0-128zm0 192l32 0 0 128-32 0 0-128zM352 96l32 0 0 128-32 0 0-128z',
      'M365.2 347.3l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z',
    ],
  ],
};
const faSealExclamation = {
  prefix: 'fad',
  iconName: 'seal-exclamation',
  icon: [
    512,
    512,
    [],
    'e242',
    [
      'M4.4 256c0 12.3 4.7 24.6 14.1 33.9L64 335.5 64 400c0 26.5 21.5 48 48 48l64.5 0 45.6 45.6c18.7 18.7 49.1 18.7 67.9 0L335.5 448l64.5 0c26.5 0 48-21.5 48-48l0-64.5 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5l0-64.5c0-26.5-21.5-48-48-48l-64.5 0L289.9 18.4c-18.7-18.7-49.1-18.7-67.9 0L176.5 64 112 64c-26.5 0-48 21.5-48 48l0 64.5L18.4 222.1C9 231.4 4.4 243.7 4.4 256zM288 352a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faChessBishop = {
  prefix: 'fad',
  iconName: 'chess-bishop',
  icon: [
    320,
    512,
    [9821],
    'f43a',
    [
      'M0 489.4C0 501.9 10.1 512 22.6 512l274.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-32-32c-6-6-14.1-9.4-22.6-9.4l-2.7 0L64 432l-2.7 0c-8.5 0-16.6 3.4-22.6 9.4l-32 32c-4.2 4.2-6.6 10-6.6 16z',
      'M96 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32c0 16.1-11.9 29.4-27.4 31.7c22.4 21.4 51 52.8 74.2 90.9L164.7 260.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l99.4-99.4C301.8 215.6 312 250.7 312 288c0 47.4-30.8 72.3-56 84.7l0 59.3L64 432l0-59.3C38.8 360.3 8 335.4 8 288C8 190 78.4 106.8 123.4 63.7C107.9 61.4 96 48.1 96 32z',
    ],
  ],
};
const faMessageSms = {
  prefix: 'fad',
  iconName: 'message-sms',
  icon: [
    512,
    512,
    [],
    'e1e5',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 144 96 160.5 96 180.8zM192 160l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6S192 153.1 192 160zm144 20.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0c-20.3 0-36.8 16.5-36.8 36.8z',
      'M132.8 144l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L112 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 204.7 96 193.2 96 180.8c0-20.3 16.5-36.8 36.8-36.8zM336 180.8c0-20.3 16.5-36.8 36.8-36.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L352 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7zm-133.1-36c6.5-2.2 13.7 .1 17.9 5.6L256 197.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 208l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-6.9 4.4-13 10.9-15.2z',
    ],
  ],
};
const faCoffeeBeans = {
  prefix: 'fad',
  iconName: 'coffee-beans',
  icon: [
    512,
    512,
    [],
    'e13f',
    [
      'M1.8 352c0-77.4 43.6-141.9 101.6-156.8c-6.8 18.2-13.8 40.4-15.4 59.5c-3.6 42.8 11.6 74.9 25 103.2l.4 .9c13.7 28.9 25.3 54.1 22.5 87.8c-1.4 16.7-8.6 38.9-16.1 57.9c-.9 2.3-1.8 4.6-2.7 6.8C52.5 503.9 1.8 435.4 1.8 352zm118.2-94.7c1.4-16.7 8.6-38.9 16.1-57.9c1-2.4 1.9-4.7 2.8-7C204.4 198.9 256 267.9 256 352c0 78.3-44.6 143.4-103.6 157.3c6.9-18.4 13.9-40.8 15.5-59.9c3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8zM240.6 51.2c8.1 17.8 18.9 38.4 31.3 53.1c27.7 32.8 61.2 44.7 90.7 55.3l1 .4c30.1 10.8 56.2 20.3 78 46.2c10.9 12.8 21.4 33.6 29.5 52.3c.9 2 1.7 4 2.5 5.9c-50.8 42.6-136.1 30.7-195.3-29c-54.7-55-69-132.4-37.7-184.2zm23.3-26.8C284 8 309.4 0 336.4 0c41.2 0 86 18.6 121.6 54.4s54 80.9 54 122.4c0 21.7-5.1 42.5-15.5 60.3c-8-17.4-18.5-37.4-30.6-51.6c-27.7-32.8-61.2-44.7-90.7-55.3l-1-.4c-30.1-10.8-56.2-20.3-78-46.2c-10.9-12.8-21.4-33.6-29.5-52.3c-1-2.4-2-4.7-2.9-6.9z',
      'M471 258.5c.9 2 1.7 4 2.5 5.9c2.4-2 4.7-4.1 6.9-6.4c6.3-6.4 11.7-13.4 16.1-21c-8-17.4-18.5-37.4-30.6-51.6c-27.7-32.8-61.2-44.7-90.7-55.3l-1-.4c-30.1-10.8-56.2-20.3-78-46.2c-10.9-12.8-21.4-33.6-29.5-52.3c-1-2.4-2-4.7-2.9-6.9c-2.8 2.3-5.5 4.7-8.1 7.3c-5.9 6-11 12.5-15.2 19.5c8.1 17.8 18.9 38.4 31.3 53.1c27.7 32.8 61.2 44.7 90.7 55.3l1 .4c30.1 10.8 56.2 20.3 78 46.2c10.9 12.8 21.4 33.6 29.5 52.3zM119.9 504.5c-.9 2.3-1.8 4.6-2.7 6.8c3.9 .4 7.8 .7 11.7 .7c8 0 15.9-.9 23.5-2.7c6.9-18.3 13.9-40.7 15.5-59.9c3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8c1.4-16.7 8.6-38.9 16.1-57.9c1-2.4 1.9-4.7 2.8-7c-3.3-.3-6.6-.5-10-.5c-8.7 0-17.2 1.1-25.5 3.2c-6.8 18.2-13.8 40.4-15.4 59.5c-3.6 42.8 11.6 74.9 25 103.2l.4 .9c13.7 28.9 25.3 54.1 22.5 87.8c-1.4 16.7-8.6 38.9-16.1 57.9z',
    ],
  ],
};
const faHatWitch = {
  prefix: 'fad',
  iconName: 'hat-witch',
  icon: [
    576,
    512,
    [],
    'f6e7',
    [
      'M0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512l256 0c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6L480 416l-128 0-32 0-64 0-32 0L96 416l-73.4 0C10.1 416 0 426.1 0 438.6z',
      'M96 416L200.6 180.7c15.3-34.4 40.3-63.5 72-83.7L416.1 5c5.2-3.3 11.1-5 17.3-5l2.2 0c8 0 15.7 3 21.6 8.4l76.4 70.1c6.6 6.1 10.4 14.6 10.4 23.6l0 6.8c0 2.1-.2 4.2-.6 6.3l-12.2 60.8c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1l-6.2-24.6C482.5 138 469.7 128 455 128l-20.4 0c-11.5 0-22.1 6.2-27.8 16.1l-18.6 32.5c-2.8 4.8-4.2 10.3-4.2 15.9l0 .7c0 4.5 .9 8.9 2.8 13L480 416l-128 0 0-48c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 48L96 416zm160 0l0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48-64 0z',
    ],
  ],
};
const faFaceGrinWink = {
  prefix: 'fad',
  iconName: 'face-grin-wink',
  icon: [
    512,
    512,
    ['grin-wink'],
    'f58c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm105.2 75.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm66.8 6.4c30.4-40.5 91.2-40.5 121.6 0c2.2 2.9 3.2 6.2 3.2 9.6c0 4.9-2.2 9.7-6.4 12.8c-7.1 5.3-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm124.4-6.4c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z',
    ],
  ],
};
const faGrinWink = faFaceGrinWink;
const faClockThreeThirty = {
  prefix: 'fad',
  iconName: 'clock-three-thirty',
  icon: [
    512,
    512,
    [],
    'e357',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232 0c0-13.3 10.7-24 24-24l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z',
      'M256 416c-13.3 0-24-10.7-24-24l0-136c0-13.3 10.7-24 24-24l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 112c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faEarDeaf = {
  prefix: 'fad',
  iconName: 'ear-deaf',
  icon: [
    512,
    512,
    ['deaf', 'deafness', 'hard-of-hearing'],
    'f2a4',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128C3.1 463.6 0 471.8 0 480zM417.4 49.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l40-40c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6S488.2 0 480 0s-16.4 3.1-22.6 9.4l-40 40z',
      'M128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78l0 6.1c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112l0-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z',
    ],
  ],
};
const faDeaf = faEarDeaf;
const faDeafness = faEarDeaf;
const faHardOfHearing = faEarDeaf;
const faAlarmClock = {
  prefix: 'fad',
  iconName: 'alarm-clock',
  icon: [
    512,
    512,
    [9200],
    'f34e',
    [
      'M32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4C35.1 463.6 32 471.8 32 480s3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zM232 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 94.1 41 41c9.4 9.4 9.4 24.6 0 33.9c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7l-48-48c-4.5-4.5-7-10.6-7-17l0-104z',
      'M14.9 146.4L160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1zM256 160c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-94.1c0-13.3-10.7-24-24-24zM352 25.4L497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4z',
    ],
  ],
};
const faEclipse = {
  prefix: 'fad',
  iconName: 'eclipse',
  icon: [
    640,
    512,
    [],
    'f749',
    [
      'M0 355.4c0 2.1 .4 4.2 1.2 6.1c2.1 5 6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.6-52.2c-34.2-15-63.7-38.9-85.4-68.8c-12.4 4-25.6 6.2-39.4 6.2c-70.7 0-128-57.3-128-128s57.3-128 128-128c13.7 0 27 2.2 39.4 6.2c21.7-29.9 51.1-53.9 85.4-68.8l-9.6-52.2c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3C1 349 0 352.2 0 355.4zM160 256c0 53 43 96 96 96c7.6 0 15-.9 22.1-2.6C264 321.3 256 289.6 256 256s8-65.3 22.1-93.4c-7.1-1.7-14.5-2.6-22.1-2.6c-53 0-96 43-96 96z',
      'M464 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352z',
    ],
  ],
};
const faFaceRelieved = {
  prefix: 'fad',
  iconName: 'face-relieved',
  icon: [
    512,
    512,
    [],
    'e389',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM96 144c0-3 .9-6.1 2.7-8.9c2.5-3.8 5.1-7.6 7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7c2.1-.7 4.2-1.4 6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2c-2.1 .7-4.2 1.4-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1c-2.5 3.8-5.1 7.6-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4c-4.6-3.1-7.1-8.2-7.1-13.3zm3.2 113.6c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0zm65.5 99.1c6.2-6.2 16.4-6.2 22.6 0c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6zm126.5-99.1c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0zM304.8 74.9C307.1 68.2 313.3 64 320 64c1.7 0 3.4 .3 5.1 .8l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c1.8 2.7 2.7 5.8 2.7 8.9c0 5.2-2.5 10.2-7.1 13.3c-7.4 4.9-17.3 2.9-22.2-4.4L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1c-8.4-2.8-12.9-11.9-10.1-20.2z',
      'M207.2 74.9c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zM124.8 238.4c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm192 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM314.9 95.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z',
    ],
  ],
};
const faRoadCircleCheck = {
  prefix: 'fad',
  iconName: 'road-circle-check',
  icon: [
    640,
    512,
    [],
    'e564',
    [
      'M32 425.4C32 455.5 56.5 480 86.6 480L288 480l0-64c0-17.7 14.3-32 32-32l.7 0c-.5-5.3-.7-10.6-.7-16c0-16.9 2.4-33.3 6.8-48.7c-2.2 .5-4.5 .7-6.8 .7c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 42.8c31.9-45.2 84.5-74.8 144-74.8c11.6 0 22.9 1.1 33.8 3.2L487.1 74.6C478 49.1 453.9 32 426.8 32L352 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faDiceFive = {
  prefix: 'fad',
  iconName: 'dice-five',
  icon: [
    448,
    512,
    [9860],
    'f523',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm160 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faOctagonMinus = {
  prefix: 'fad',
  iconName: 'octagon-minus',
  icon: [
    512,
    512,
    ['minus-octagon'],
    'f308',
    [
      'M.1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5zM160 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M160 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faMinusOctagon = faOctagonMinus;
const faSquareRss = {
  prefix: 'fad',
  iconName: 'square-rss',
  icon: [
    448,
    512,
    ['rss-square'],
    'f143',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 40c0 13.3 10.7 24 24 24c110.5 0 200 89.5 200 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-137-111-248-248-248c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24c57.4 0 104 46.6 104 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-83.9-68.1-152-152-152c-13.3 0-24 10.7-24 24zm0 120a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M120 112c-13.3 0-24 10.7-24 24s10.7 24 24 24c110.5 0 200 89.5 200 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-137-111-248-248-248zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24c57.4 0 104 46.6 104 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-83.9-68.1-152-152-152zm8 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faRssSquare = faSquareRss;
const faFaceZany = {
  prefix: 'fad',
  iconName: 'face-zany',
  icon: [
    512,
    512,
    [],
    'e3a4',
    [
      'M34.4 384c36.2 62.7 94.9 104.3 160.1 120.5c-11.5-15.8-18.4-35.4-18.4-56.5l0-39.8c-10.4-6.2-20.1-13.7-28.9-22.2c-10.2-9.9-6.6-26.3 5.7-33.4L391.2 214.9c12.3-7.1 28.3-2 31.8 11.8c15.2 59.4-5.9 124.1-55 165l0 56.3c0 15.4-3.6 30-10.1 42.9c8.8-3.8 17.5-8.2 26.1-13.2c82.1-47.4 128-133.5 128-221.9c0-43.4-11.1-87.4-34.3-127.8C407.1 5.6 250.5-36.4 128.1 34.3S-36.3 261.6 34.4 384zM192 224A64 64 0 1 1 64 224a64 64 0 1 1 128 0zm192-72a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z',
      'M296 104a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336.1 402.6l0 45.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-45.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6z',
    ],
  ],
};
const faTricycle = {
  prefix: 'fad',
  iconName: 'tricycle',
  icon: [
    512,
    512,
    [],
    'e5c3',
    [
      'M224 368.1A112 112 0 1 1 0 368a112 112 0 1 1 224 .1zM56 368a56 56 0 1 0 112 0A56 56 0 1 0 56 368zm200-16c0-51.5 30.4-95.9 74.2-116.2c4.7 18.7 9.4 37.4 14 56.1c-19.4 12.9-32.2 35-32.2 60c0 39.8 32.2 72 72 72s72-32.2 72-72c0-37.5-28.6-68.2-65.2-71.7c-4.7-18.7-9.4-37.4-14-56.1c2.4-.1 4.8-.2 7.2-.2c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128z',
      'M256 56c0-13.3 10.7-24 24-24l73.6 0C388.1 32 416 59.9 416 94.4c0 18.2-8 35.5-21.8 47.3l-31.3 26.9 44.4 177.6c3.2 12.9-4.6 25.9-17.5 29.1s-25.9-4.6-29.1-17.5L319.3 192l-12.1 0c-57.6 0-110.9 29.5-141.6 77.6c-14.3-7.8-30.5-12.6-47.8-13.5c1.2-2.3 2.5-4.5 3.9-6.7L77.6 176 56 176c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-2.4 0 19.6 32.6c40-40.7 95.3-64.6 154.1-64.6l10.9 0c.7-.8 1.5-1.5 2.3-2.2L363 105.3c3.2-2.7 5-6.7 5-10.9c0-7.9-6.4-14.4-14.4-14.4L280 80c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faLandMineOn = {
  prefix: 'fad',
  iconName: 'land-mine-on',
  icon: [
    640,
    512,
    [],
    'e51b',
    [
      'M83.7 480c0 16.8 13.5 32 32 32l408.4 0c23.8 0 39.3-25 28.6-46.3l-27.6-55.2c-8.1-16.3-24.7-26.5-42.9-26.5l-324.7 0c-18.2 0-34.8 10.3-42.9 26.5L87.2 465.7c-2.3 4.7-3.4 9.6-3.4 14.3zM192 320l0 32 256 0 0-32c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32z',
      'M320 0c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z',
    ],
  ],
};
const faSquareArrowUpLeft = {
  prefix: 'fad',
  iconName: 'square-arrow-up-left',
  icon: [
    448,
    512,
    [],
    'e263',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 72c0-13.3 10.7-24 24-24l152 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L329 327c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-135-135L160 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160z',
      'M136 144l152 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135L160 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faICursor = {
  prefix: 'fad',
  iconName: 'i-cursor',
  icon: [
    256,
    512,
    [],
    'f246',
    [
      'M32 256c0 17.7 14.3 32 32 32l32 0c0-21.3 0-42.7 0-64l-32 0c-17.7 0-32 14.3-32 32zm128-32l0 64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
      'M29.3 63.9C11.7 62.4-1.4 47 .1 29.3S17-1.4 34.7 .1l8 .7C76.8 3.6 106.8 19.7 128 43.7c21.2-24 51.2-40 85.4-42.9l8-.7c17.6-1.5 33.1 11.6 34.5 29.2s-11.6 33.1-29.2 34.5l-8 .7C185.5 67.3 160 95 160 128.3l0 255.3c0 33.3 25.5 61 58.7 63.8l8 .7c17.6 1.5 30.7 16.9 29.2 34.5s-16.9 30.7-34.5 29.2l-8-.7c-34.1-2.8-64.2-18.9-85.4-42.9c-21.2 24-51.2 40-85.4 42.9l-8 .7C17 513.4 1.6 500.3 .1 482.7s11.6-33.1 29.2-34.5l8-.7C70.5 444.7 96 417 96 383.7l0-255.3c0-33.3-25.5-61-58.7-63.8l-8-.7z',
    ],
  ],
};
const faChartMixedUpCircleDollar = {
  prefix: 'fad',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [
    576,
    512,
    [],
    'e5d9',
    [
      'M0 224c0 7 2.3 14.1 7 20c11 13.8 31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105l0 39c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112c0-17.7-14.3-32-32-32L400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.8 0L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-7.9 6.3-12 15.6-12 25zM32 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z',
    ],
  ],
};
const faSaltShaker = {
  prefix: 'fad',
  iconName: 'salt-shaker',
  icon: [
    384,
    512,
    [129474],
    'e446',
    [
      'M0 452.2c0 33 26.8 59.8 59.8 59.8l264.5 0c33 0 59.8-26.8 59.8-59.8c0-2.8-.2-5.7-.6-8.5L347.4 192l-64.6 0c12.2 85.4 24.4 170.7 36.6 256L64.6 448l36.6-256-64.6 0L.6 443.8c-.4 2.8-.6 5.6-.6 8.5z',
      'M101.2 192l181.6 0 64.6 0-9.3-65.3C327.7 54 265.4 0 192 0S56.3 54 45.9 126.7L36.6 192l64.6 0zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faStamp = {
  prefix: 'fad',
  iconName: 'stamp',
  icon: [
    512,
    512,
    [],
    'f5bf',
    [
      'M32 416l8 0 56 0 0 32 320 0 0-32 56 0 8 0 0 48c0 26.5-21.5 48-48 48L80 512c-26.5 0-48-21.5-48-48l0-48z',
      'M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2L112 256C50.1 256 0 306.1 0 368l0 8c0 22.1 17.9 40 40 40l432 0c22.1 0 40-17.9 40-40l0-8c0-61.9-50.1-112-112-112l-33.8 0c-29.9 0-54.2-24.3-54.2-54.2z',
    ],
  ],
};
const faFilePlus = {
  prefix: 'fad',
  iconName: 'file-plus',
  icon: [
    384,
    512,
    [],
    'f319',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 336c0 13.3 10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM192 240c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faDrawSquare = {
  prefix: 'fad',
  iconName: 'draw-square',
  icon: [
    448,
    512,
    [],
    'f5ef',
    [
      'M32 151.4c4.7 2.7 9.8 4.9 15.2 6.3c2.7 .7 5.4 1.3 8.2 1.7c1.4 .2 2.8 .3 4.3 .4c.7 0 1.4 .1 2.2 .1s1.4 0 2.2 0c11.7 0 22.6-3.1 32-8.6l0 209.1c-4.7-2.7-9.8-4.9-15.2-6.3c-2.7-.7-5.4-1.3-8.2-1.7c-1.4-.2-2.8-.3-4.3-.4c-.7 0-1.4-.1-2.2-.1s-1.4 0-2.2 0c-11.7 0-22.6 3.1-32 8.6l0-209.1zM119.4 64l209.1 0c-2.7 4.7-4.9 9.8-6.3 15.2c-.7 2.7-1.3 5.4-1.7 8.2c-.2 1.4-.3 2.8-.4 4.3c0 .7-.1 1.4-.1 2.2s0 1.4 0 2.2c0 11.7 3.1 22.6 8.6 32l-209.1 0c2.7-4.7 4.9-9.8 6.3-15.2c.7-2.7 1.3-5.4 1.7-8.2c.2-1.4 .3-2.8 .4-4.3c0-.7 .1-1.4 .1-2.2s0-1.4 0-2.2c0-11.7-3.1-22.6-8.6-32zm0 320l209.1 0c-2.7 4.7-4.9 9.8-6.3 15.2c-.7 2.7-1.3 5.4-1.7 8.2c-.2 1.4-.3 2.8-.4 4.3c0 .7-.1 1.4-.1 2.2s0 1.4 0 2.2c0 11.7 3.1 22.6 8.6 32l-209.1 0c2.7-4.7 4.9-9.8 6.3-15.2c.7-2.7 1.3-5.4 1.7-8.2c.2-1.4 .3-2.8 .4-4.3c0-.7 .1-1.4 .1-2.2s0-1.4 0-2.2c0-11.7-3.1-22.6-8.6-32zM352 151.4c4.7 2.7 9.8 4.9 15.2 6.3c2.7 .7 5.4 1.3 8.2 1.7c1.4 .2 2.8 .3 4.3 .4c.7 0 1.4 .1 2.2 .1s1.4 0 2.2 0c11.7 0 22.6-3.1 32-8.6l0 209.1c-4.7-2.7-9.8-4.9-15.2-6.3c-2.7-.7-5.4-1.3-8.2-1.7c-1.4-.2-2.8-.3-4.3-.4c-.7 0-1.4-.1-2.2-.1s-1.4 0-2.2 0c-11.7 0-22.6 3.1-32 8.6l0-209.1z',
      'M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM64 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm320 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    ],
  ],
};
const faToiletPaperUnderSlash = {
  prefix: 'fad',
  iconName: 'toilet-paper-under-slash',
  icon: [
    640,
    512,
    ['toilet-paper-reverse-slash'],
    'e2a1',
    [
      'M64 192c0-15 .9-29.6 2.5-43.6L365.5 384 160 384c-53 0-96-86-96-192zM95.6 49.6C112.6 18.8 135.2 0 160 0L412.2 0C400.6 12.2 391 26.9 383.5 41.9C363.5 82 352 135.1 352 192c0 21.5 1.6 42.4 4.7 62.3c-87-68.2-174.1-136.4-261.1-204.7zM224 416l182.2 0c40.6 32 81.2 64 121.8 96l-256 0c-26.5 0-48-21.5-48-48l0-48zM384 192c0-83.6 26.7-154.7 64-181.1C458 3.8 468.8 0 480 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-11.7 40.5-30.6 71.6-53.1 86.4c-38-29.8-76-59.6-114-89.3c-7.7-27.6-12-59.3-12-93.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zm88.1 202.9c16.7-13.6 30-32.4 39.9-51.8l0 83.1c-13.3-10.4-26.6-20.8-39.9-31.2z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faToiletPaperReverseSlash = faToiletPaperUnderSlash;
const faStairs = {
  prefix: 'fad',
  iconName: 'stairs',
  icon: [
    576,
    512,
    [],
    'e289',
    [
      'M128 352l0 64 64 0 0-64-64 0zM256 224l0 64 64 0 0-64-64 0zM384 96l0 64 64 0 0-64-64 0z',
      'M416 32c-17.7 0-32 14.3-32 32l0 32 64 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L416 32zM384 160l-96 0c-17.7 0-32 14.3-32 32l0 32 64 0 96 0c17.7 0 32-14.3 32-32l0-32-64 0zM160 288c-17.7 0-32 14.3-32 32l0 32 64 0 96 0c17.7 0 32-14.3 32-32l0-32-64 0-96 0zm32 128l-64 0-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32z',
    ],
  ],
};
const faDroneFront = {
  prefix: 'fad',
  iconName: 'drone-front',
  icon: [
    640,
    512,
    ['drone-alt'],
    'f860',
    [
      'M0 136c0 13.3 10.7 24 24 24l72 0 64 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-108.3 0-55.4 0L24 112c-13.3 0-24 10.7-24 24zm352 0c0 13.3 10.7 24 24 24l104 0 64 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-76.3 0-55.4 0L376 112c-13.3 0-24 10.7-24 24z',
      'M160 160l-64 0 0 32 0 64c0 12.6 7.4 24.1 19 29.2l56.5 25.1c-17.8 21.5-27.5 48.5-27.5 76.4l0 5.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-5.2c0-16.8 5.9-33.2 16.7-46.1l8.4-10.1L259 349.2c4.1 1.8 8.5 2.8 13 2.8l96 0c4.5 0 8.9-.9 13-2.8l41.9-18.6 8.4 10.1c10.8 12.9 16.7 29.3 16.7 46.1l0 5.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-5.2c0-27.9-9.7-54.9-27.5-76.4L525 285.2c11.6-5.1 19-16.6 19-29.2l0-64 0-32-64 0 0 32 0 43.2-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7L160 235.2l0-43.2 0-32zm324.3-48l55.4 0c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16zM128 96c-11.8 0-22.2 6.4-27.7 16l55.4 0c-5.5-9.6-15.9-16-27.7-16z',
    ],
  ],
};
const faDroneAlt = faDroneFront;
const faGlassEmpty = {
  prefix: 'fad',
  iconName: 'glass-empty',
  icon: [
    384,
    512,
    [],
    'e191',
    [
      'M8.6 10.2C14.6 3.7 23.1 0 32 0L352 0c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3l-166.6 0c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9l166.6 0c8.4 0 15.4-6.5 16-14.9L317.6 64 66.4 64z',
      '',
    ],
  ],
};
const faDialHigh = {
  prefix: 'fad',
  iconName: 'dial-high',
  icon: [
    576,
    512,
    [],
    'e15c',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M446.6 263.6c-11.6-77-78-136-158.2-136c-88.4 0-160 71.6-160 160s71.6 160 160 160c80.2 0 146.6-59 158.2-136l-158.2 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l158.2 0z',
    ],
  ],
};
const faUserHelmetSafety = {
  prefix: 'fad',
  iconName: 'user-helmet-safety',
  icon: [
    448,
    512,
    [128119, 'user-construction', 'user-hard-hat'],
    'f82c',
    [
      'M96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-5.4-.3-10.8-1-16L97 176c-.7 5.2-1 10.6-1 16z',
      'M216 0c-13.3 0-24 10.7-24 24l0 56L163.6 23.1C125.6 43.5 99 82.6 96.2 128l-.2 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l256 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-.2 0C349 82.6 322.4 43.5 284.4 23.1L256 80l0-56c0-13.3-10.7-24-24-24L216 0zM134.4 352C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352l-179.2 0z',
    ],
  ],
};
const faUserConstruction = faUserHelmetSafety;
const faUserHardHat = faUserHelmetSafety;
const faI = {
  prefix: 'fad',
  iconName: 'i',
  icon: [
    320,
    512,
    [105],
    '49',
    [
      'M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l96 0 0 320-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-320 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 32 32 32z',
      '',
    ],
  ],
};
const faHryvniaSign = {
  prefix: 'fad',
  iconName: 'hryvnia-sign',
  icon: [
    384,
    512,
    [8372, 'hryvnia'],
    'f6f2',
    [
      'M0 208c0 17.7 14.3 32 32 32l123.5 0 91.8-52.5c.7-.4 1.3-.8 2-1.2s1.3-.8 1.9-1.3c1.2-.9 2.4-1.8 3.6-2.8c2.3-1.9 4.4-4.1 6.2-6.4L32 176c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32l20.3 0c7.5-26.1 24.2-49 47.5-64L32 272c-17.7 0-32 14.3-32 32zm123.1 32L352 336c17.7 0 32-14.3 32-32s-14.3-32-32-32l-123.5 0-91.8 52.5c-.7 .4-1.3 .8-2 1.2s-1.3 .8-1.9 1.3c-1.2 .9-2.4 1.8-3.6 2.8c-2.3 1.9-4.4 4.1-6.2 6.4zm161.1-96l67.8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-20.3 0c-7.5 26.1-24.2 49-47.5 64z',
      'M179.6 96c-21 0-41.3 7.1-57.7 20.2L116 121c-13.8 11-33.9 8.8-45-5s-8.8-33.9 5-45l5.9-4.7C109.7 44.1 144.1 32 179.6 32L223 32c62.4 0 113 50.6 113 113c0 40.5-21.7 78-56.9 98.1L136.7 324.5c-15.3 8.7-24.7 25-24.7 42.5c0 27.1 21.9 49 49 49l43.4 0c21 0 41.3-7.1 57.7-20.2L268 391c13.8-11 33.9-8.8 45 5s8.8 33.9-5 45l-5.9 4.7c-27.7 22.2-62.2 34.3-97.7 34.3L161 480C98.6 480 48 429.4 48 367c0-40.6 21.7-78 56.9-98.1l142.4-81.4c15.3-8.7 24.7-25 24.7-42.5c0-27.1-21.9-49-49-49l-43.4 0z',
    ],
  ],
};
const faHryvnia = faHryvniaSign;
const faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fad',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [
    512,
    512,
    [],
    'e092',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4L176 381.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L80 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L9.4 457.4C3.1 463.6 0 471.8 0 480z',
      'M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3L381.3 176l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 50.7L457.4 9.4c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faPills = {
  prefix: 'fad',
  iconName: 'pills',
  icon: [
    576,
    512,
    [],
    'f484',
    [
      'M0 144l0 80 0 32 32 0 160 0 32 0 0-32 0-80c0-61.9-50.1-112-112-112S0 82.1 0 144zM256 320c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1c12.3-7.1 13.1-23.7 3.1-33.8L310.9 237.5c-10-10-26.7-9.3-33.8 3.1C263.7 264 256 291.1 256 320zm77.5-105.1L521.1 402.5c10 10 26.7 9.3 33.8-3.1C568.3 376 576 348.9 576 320c0-88.4-71.6-160-160-160c-28.9 0-56 7.7-79.4 21.1c-12.3 7.1-13.1 23.7-3.1 33.8z',
      'M32 256L0 256l0 32 0 80c0 61.9 50.1 112 112 112s112-50.1 112-112l0-80 0-32-32 0L32 256z',
    ],
  ],
};
const faFaceGrinWide = {
  prefix: 'fad',
  iconName: 'face-grin-wide',
  icon: [
    512,
    512,
    [128515, 'grin-alt'],
    'f581',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm105.2 75.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM144 192c0-35.3 14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64s-32-28.7-32-64zm160 0c0-35.3 14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64s-32-28.7-32-64z',
      'M176 256c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zm160 0c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z',
    ],
  ],
};
const faGrinAlt = faFaceGrinWide;
const faTooth = {
  prefix: 'fad',
  iconName: 'tooth',
  icon: [
    448,
    512,
    [129463],
    'f5c9',
    [
      'M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5l0 6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5l0-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z',
      '',
    ],
  ],
};
const faBasketballHoop = {
  prefix: 'fad',
  iconName: 'basketball-hoop',
  icon: [
    640,
    512,
    [],
    'f435',
    [
      'M0 214.9L0 331.2c0 25.3 14.9 48.2 38 58.5l96.4 42.9L113.8 288l-1.8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-16 0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64 0 16 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-1.8 0L505.6 432.6 602 389.7c23.1-10.3 38-33.2 38-58.5l0-116.3c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9zM192 160l0 64 0 16 256 0 0-16 0-64-256 0z',
      'M112 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l34.1 0 7.2 50.3 22.9 160c.9 6.1 5.2 11.2 11.1 13s12.3 .1 16.5-4.4L255.6 451l52.8 56c3 3.2 7.2 5 11.6 5s8.6-1.8 11.6-5l52.8-56 51.9 55.9c4.2 4.5 10.6 6.2 16.5 4.4s10.2-6.9 11.1-13l22.9-160 7.2-50.3 34.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-416 0zm349.6 48l-5.2 36.6-44-36.6 49.2 0zm-99.3 0l.6 .5L320 334.6l-42.8-46.1 .6-.5 84.4 0zm-134.5 0l-44 36.6L178.4 288l49.2 0zm159.8 21l48.7 40.5-51.6 54.7-42.7-46L387.5 309zm49.4 151.6l-30.5-32.9 41.5-44-11 76.8zM320 381.7l42.6 45.9L320 472.7l-42.6-45.2L320 381.7zm-21.8-23.5l-42.7 46-51.6-54.7L252.5 309l45.7 49.2zm-64.6 69.5l-30.5 32.9-11-76.8 41.5 44z',
    ],
  ],
};
const faObjectsAlignBottom = {
  prefix: 'fad',
  iconName: 'objects-align-bottom',
  icon: [
    512,
    512,
    [],
    'e3bb',
    [
      'M64 48l0 288c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48zM288 176l0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z',
      'M0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z',
    ],
  ],
};
const faV = {
  prefix: 'fad',
  iconName: 'v',
  icon: [
    384,
    512,
    [118],
    '56',
    [
      'M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z',
      '',
    ],
  ],
};
const faSparkles = {
  prefix: 'fad',
  iconName: 'sparkles',
  icon: [
    512,
    512,
    [10024],
    'f890',
    [
      'M320 96c0 4.8 3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8zm0 320c0 4.8 3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8z',
      'M205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.4 187.4 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3z',
    ],
  ],
};
const faSquid = {
  prefix: 'fad',
  iconName: 'squid',
  icon: [
    544,
    512,
    [129425],
    'e450',
    [
      'M256.9 16c0-4.1 1.6-8.2 4.6-11.2c3-3.1 7.2-4.8 11.4-4.8c1 0 2.1 .1 3.1 .3L392.7 23.6c-49.9 15.2-90.2 34-122.4 54.7L257.3 19.5c-.3-1.2-.4-2.3-.4-3.5zM434.6 242.5c20.7-32.2 39.4-72.5 54.7-122.4l23.3 116.7c.2 1 .3 2.1 .3 3.1c0 4.3-1.7 8.4-4.8 11.4c-3.9 3.8-9.4 5.4-14.7 4.2l-58.9-13.1z',
      'M512.7 18.6c.8-5.1-.8-10.3-4.5-13.9S499.4-.6 494.3 .2c-238 39.7-322.1 146.4-334.5 226.5l-14-14-2-2-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6l56.4-56.4c18.9-18.9 18.7-49.5-.3-68.2L140.1 4.6c-6.3-6.1-16.3-6.1-22.5 .1l-2.8 2.8c-34 34-33.3 87.7-1.9 121L98.5 142.9c-18.7 18.7-18.7 49.1 0 67.9l22.6 22.6c0 0 0 0 0 0l5.7 5.7c0 0 0 0 0 0c9.3 9.4 9.3 24.5 0 33.9c-9.3 9.3-24.4 9.4-33.8 .2L76.5 256.6c-19.1-19.1-50.2-18.7-68.7 .9L4.4 261c-6.1 6.4-5.8 16.5 .6 22.6s16.5 5.8 22.6-.6l3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l10.6 10.6 .2 .2 22.6 22.6c10.1 10.2 9 26.9-2.4 35.8l-20 15.6c-3.5 2.7-7.7 4.2-12.1 4.2c-10.9 0-19.7-8.8-19.7-19.7l0-12.3c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 12.3C.9 376.8 24.1 400 52.6 400c11.5 0 22.7-3.8 31.8-10.9l28.2-21.9c9.4-7.3 22.8-6.5 31.2 1.9s9.3 21.8 1.9 31.2l-21.9 28.2c-7.1 9.1-10.9 20.3-10.9 31.8c0 28.6 23.2 51.7 51.7 51.7l12.3 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-12.3 0c-10.9 0-19.7-8.8-19.7-19.7c0-4.4 1.5-8.7 4.2-12.1l15.6-20c8.8-11.4 25.6-12.4 35.8-2.3l.1 .1L223 448.3l.1 .1 9.9 9.9c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8l-9.9-9.9-5.7-5.7-.1-.1c-9.2-9.3-9.2-24.4 0-33.8l.1-.1 .1-.1c9.3-9.2 24.4-9.2 33.7 0l28.4 28.4c18.7 18.7 49.1 18.7 67.9 0L384.4 400c33.3 31.4 87 32.1 121-1.9l2.8-2.8c6.2-6.2 6.3-16.3 .1-22.5L472 335.7c-18.7-19-49.3-19.2-68.2-.3l-56.4 56.4c-6.2 6.2-16.4 6.2-22.6 0l-22.5-22.5-.1-.1-16-16C366.3 340.8 473 256.6 512.7 18.6zM168.9 280a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faLeafyGreen = {
  prefix: 'fad',
  iconName: 'leafy-green',
  icon: [
    576,
    512,
    [129388],
    'e41d',
    [
      'M0 170.7c0 12.5 2.8 25.1 8.5 36.6c5.7 11.7 11 24.1 11 37.1l0 35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 14.5 5.7 28.5 15.8 38.8c5-5 10.1-10.1 15.1-15.1c12-12 18.7-28.3 18.7-45.3l0-45.7c0-17 6.7-33.3 18.7-45.3l10.5-10.5c12-12 18.7-28.3 18.7-45.3l0-43c0-17 6.7-33.3 18.7-45.3l29.1-29.1c10.7-10.7 16.4-25 21.3-39.3c.3-.8 .6-1.7 .9-2.5s.6-1.6 1-2.5c.7-1.6 1.4-3.2 2.1-4.8c1.5-3.2 3.1-6.2 5-9.2c-1.3-2-2.6-4.1-3.9-6.2c-4.1-6.9-9.1-13.4-15-19.3C216.3 9.5 191.4 0 166.6 0s-49.7 9.5-68.7 28.4C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C8.1 128.1 0 149.4 0 170.7zm228.7 154c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48L358.6 240l89.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-57.4 0 84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-112 112L304 249.4l0-57.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 89.4-43.3 43.3z',
      'M572.5 140c-7.3 28.4-8.1 60.8-5 89.9c.3 3.3 .5 6.7 .5 10.1c0 42.1-27.1 77.9-64.9 90.8c-14.3 4.9-28.6 10.6-39.3 21.3l-29.1 29.1c-12 12-28.3 18.7-45.3 18.7l-43 0c-17 0-33.3 6.7-45.3 18.7l-10.5 10.5c-12 12-28.3 18.7-45.3 18.7l-45.7 0c-17 0-33.3 6.7-45.3 18.7l-35.9 35.9c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.9-35.9c12-12 18.7-28.3 18.7-45.3l0-45.7c0-17 6.7-33.3 18.7-45.3l10.5-10.5c12-12 18.7-28.3 18.7-45.3l0-43c0-17 6.7-33.3 18.7-45.3l29.1-29.1c10.7-10.7 16.4-25 21.3-39.3C258.1 35.1 293.9 8 336 8c3.4 0 6.8 .2 10.1 .5c29.1 3.1 61.5 2.3 89.9-5C445 1.2 454.3 0 464 0c61.9 0 112 50.1 112 112c0 9.7-1.2 19-3.5 28zm-97.2-16.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-112 112L304 249.4l0-57.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 89.4-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48L358.6 240l89.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-57.4 0 84.7-84.7z',
    ],
  ],
};
const faCircleArrowUpRight = {
  prefix: 'fad',
  iconName: 'circle-arrow-up-right',
  icon: [
    512,
    512,
    [],
    'e0fc',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144 344c0 6.1 2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7l135-135 0 94.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152c0-13.3-10.7-24-24-24l-160 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l102.1 0L151 327c-4.7 4.7-7 10.8-7 17z',
      'M368 168l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l160 0c13.3 0 24 10.7 24 24z',
    ],
  ],
};
const faCalendars = {
  prefix: 'fad',
  iconName: 'calendars',
  icon: [
    512,
    512,
    [],
    'e0d7',
    [
      'M96 192l416 0 0 176c0 26.5-21.5 48-48 48l-320 0c-26.5 0-48-21.5-48-48l0-176z',
      'M224 0c-17.7 0-32 14.3-32 32l0 32-48 0c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-96 0 0-32c0-17.7-14.3-32-32-32zM48 184c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 392c0 66.3 53.7 120 120 120l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-39.8 0-72-32.2-72-72l0-208z',
    ],
  ],
};
const faBangladeshiTakaSign = {
  prefix: 'fad',
  iconName: 'bangladeshi-taka-sign',
  icon: [
    384,
    512,
    [],
    'e2e6',
    [
      'M0 192c0 17.7 14.3 32 32 32l32 0 0-64-32 0c-17.7 0-32 14.3-32 32zm128-32l0 64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
      'M.2 60C2.4 42.5 18.4 30.1 36 32.3l7.9 1c48 6 84.1 46.8 84.1 95.3L128 384c0 17.7 14.3 32 32 32l32 0c70.7 0 128-57.3 128-128l0-32c0-17.7-14.3-32-32-32l-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0c53 0 96 43 96 96l0 32c0 106-86 192-192 192l-32 0c-53 0-96-43-96-96l0-255.5c0-16.1-12-29.8-28-31.8l-7.9-1C10.5 93.6-1.9 77.6 .2 60z',
    ],
  ],
};
const faBicycle = {
  prefix: 'fad',
  iconName: 'bicycle',
  icon: [
    640,
    512,
    [128690],
    'f206',
    [
      'M0 352c0 70.7 57.3 128 128 128c65.3 0 119.1-48.9 127-112l-56.8 0c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l26.2-52.3c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352zm384 0c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6c9.2 17 18.3 33.9 27.5 50.9c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3c-9.2-17-18.3-33.9-27.5-50.9C402.4 276.3 384 312 384 352z',
      'M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l25.7 0 34.6 64-149.4 0-27.4-38C191 99.7 183.7 96 176 96l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l43.7 0 22.1 30.7-77 153.9c-9 18.1 4.1 39.4 24.3 39.4L304 368c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 81.4 150.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5L375.4 48.8C369.8 38.4 359 32 347.2 32L312 32zM166.8 320l50.7-101.3 72.9 101.2-.1 .1-123.5 0zm90.6-128l108.5 0L317 274.8 257.4 192z',
    ],
  ],
};
const faHammerWar = {
  prefix: 'fad',
  iconName: 'hammer-war',
  icon: [
    384,
    512,
    [],
    'f6e4',
    [
      'M160 32l0 18.8c9.1 1.4 18.2 2.7 27.3 4.1c3.1 .5 6.3 .5 9.5 0c9.1-1.4 18.2-2.7 27.3-4.1L224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 237.2L160 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.8c-9.1-1.4-18.2-2.7-27.3-4.1c-3.1-.5-6.3-.5-9.5 0c-9.1 1.4-18.2 2.7-27.3 4.1z',
      'M36.7 32.4c-9.2-1.4-18.6 1.3-25.6 7.4S0 54.7 0 64L0 256c0 9.3 4.1 18.2 11.1 24.2s16.4 8.8 25.6 7.4l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c9.2 1.4 18.6-1.3 25.6-7.4s11.1-14.9 11.1-24.2l0-192c0-9.3-4.1-18.2-11.1-24.2s-16.4-8.8-25.6-7.4L196.7 54.9c-3.1 .5-6.3 .5-9.5 0L36.7 32.4z',
    ],
  ],
};
const faCircleD = {
  prefix: 'fad',
  iconName: 'circle-d',
  icon: [
    512,
    512,
    [],
    'e104',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208zm48 24l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z',
      'M160 152c0-13.3 10.7-24 24-24l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208zm48 24l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z',
    ],
  ],
};
const faSpiderBlackWidow = {
  prefix: 'fad',
  iconName: 'spider-black-widow',
  icon: [
    512,
    512,
    [],
    'f718',
    [
      'M81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4c8.3 2.8 16.6 5.5 24.9 8.3c0-17.1 0-34.2 0-51.3l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100zM216 300c0 2.6 .8 5.1 2.4 7.2c7.2 9.6 14.4 19.2 21.6 28.8l-21.6 28.8c-1.6 2.1-2.4 4.6-2.4 7.2c0 6.6 5.4 12 12 12l56 0c3.3 0 6.3-1.3 8.5-3.5c1.1-1.1 2-2.4 2.6-3.8c.3-.7 .5-1.5 .7-2.2c.1-.4 .1-.8 .2-1.2c0-.3 .1-.7 .1-1.1c0-.6 0-.9 0-1.1c0-.3-.1-.6-.1-1c-.1-.6-.3-1.3-.5-1.9c-.4-1.2-1-2.4-1.8-3.4c-7.2-9.6-14.4-19.2-21.6-28.8c7.2-9.6 14.4-19.2 21.6-28.8c.8-1 1.4-2.2 1.8-3.4c.2-.6 .4-1.2 .5-1.9c.1-.3 .1-.6 .1-1c0-.2 0-.5 0-.8c0-.7 0-1.1-.1-1.4c0-.4-.1-.8-.2-1.2c-.2-.8-.4-1.5-.7-2.2c-.6-1.4-1.5-2.7-2.6-3.8c-2.2-2.2-5.2-3.5-8.5-3.5l-56 0c-6.6 0-12 5.4-12 12zM336 174.1l0 51.3 24.9-8.3 57.4-57.4c10.7-10.7 16.4-25 16.4-39.6c0-6.8-1.2-13.6-3.7-20.1L398.4 15.4C394.7 5.8 385.6 0 376 0c-2.9 0-5.8 .5-8.6 1.6c-12.4 4.8-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1z',
      'M240 101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160l0 65.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1L336 225.4l0-65.4c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8zm-21.6 206c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12l56 0c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12l-56 0c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z',
    ],
  ],
};
const faStaffSnake = {
  prefix: 'fad',
  iconName: 'staff-snake',
  icon: [
    384,
    512,
    ['rod-asclepius', 'rod-snake', 'staff-aesculapius'],
    'e579',
    [
      'M0 104c0 30.9 25.1 56 56 56l16 0c22.3 0 41.6-13.1 50.6-32l41.4 0 56 0 68 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-69 0-2.5 80 71.5 0c53 0 96-43 96-96s-43-96-96-96l-65.5 0-61 0L72 48l-8 0-8 0C25.1 48 0 73.1 0 104zm80-8A16 16 0 1 1 48 96a16 16 0 1 1 32 0zM56 256c0 53 43 96 96 96l19 0 42 0 43 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-44 0-2.1 67.5-.4 12.5 46.5 0c53 0 96-43 96-96s-43-96-96-96l-40.5 0-47 0L152 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l15.5 0L165 160l-13 0c-53 0-96 43-96 96zM96 424c0 22.1 17.9 40 40 40l38.5 0c-.1-4.2-.3-8.3-.4-12.5c-.7-22.5-1.4-45-2.1-67.5l-36 0c-22.1 0-40 17.9-40 40z',
      'M222.6 43.2L223 32c0-.7 0-1.3 0-1.9c-.5-16.6-14.1-30-31-30s-30.5 13.4-31 30c0 .6 0 1.3 0 1.9l.4 11.2 .1 4.8 61 0 .1-4.8zM215.5 272L220 128l-56 0 4.5 144 47 0zM213 352l-42 0 3.1 99.5 1.4 43.5 0 1c.3 8.9 7.6 16 16.5 16s16.2-7.1 16.5-16l0-1 1.4-43.5L213 352z',
    ],
  ],
};
const faRodAsclepius = faStaffSnake;
const faRodSnake = faStaffSnake;
const faStaffAesculapius = faStaffSnake;
const faPear = {
  prefix: 'fad',
  iconName: 'pear',
  icon: [
    512,
    512,
    [],
    'e20c',
    [
      'M0 320c0 49.1 18.7 98.3 56.2 135.8c75 75 196.5 75 271.5 0c25.1-25.1 41.8-55.3 50.1-87.3c11.8-45.7 43.4-90.9 73.3-127.4c18-22.1 28.9-50.3 28.9-81c0-26.7-8.2-51.4-22.1-71.9C446.9 99 435.9 110 425 121c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17s2.3-12.3 7-17c11-11 21.9-21.9 32.9-32.9C403.4 40.2 378.7 32 352 32c-30.7 0-58.9 10.8-81 28.9c-36.5 29.9-81.8 61.4-127.4 73.3c-32 8.3-62.3 25-87.3 50.1C18.7 221.7 0 270.9 0 320zM176 432c0-8.8 7.2-16 16-16c53 0 96-43 96-96c0-8.8 7.2-16 16-16s16 7.2 16 16c0 70.7-57.3 128-128 128c-8.8 0-16-7.2-16-16z',
      'M505 7c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faHeadSideCoughSlash = {
  prefix: 'fad',
  iconName: 'head-side-cough-slash',
  icon: [
    640,
    512,
    [],
    'e062',
    [
      'M0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480l-80 0 0 8c0 13.3-10.7 24-24 24c-13.3 0-26.7 0-40 0L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM89.6 44.9C127 16.7 173.5 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8c-6.7 0-13.4 0-20.2 0l0 5.8C328.5 232.2 209 138.5 89.6 44.9zM576 336a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64-48a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faFileMov = {
  prefix: 'fad',
  iconName: 'file-mov',
  icon: [
    512,
    512,
    [],
    'e647',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-240 0c-35.3 0-64 28.7-64 64l0 144-16 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM157.7 359.8c-3.7-6.2-11.1-9.1-18-7.2s-11.7 8.2-11.7 15.4l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-70.2 18.3 30.5c2.9 4.8 8.1 7.8 13.7 7.8s10.8-3 13.7-7.8L224 425.8l0 70.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-7.2-4.8-13.5-11.7-15.4s-14.3 1-18 7.2L192 416.9l-34.3-57.1zM448 368c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 31.6c0 34.7 10.3 68.7 29.6 97.6l5.1 7.7c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l5.1-7.7c19.3-28.9 29.6-62.9 29.6-97.6l0-31.6c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 31.6c0 23-5.5 45.6-16 66c-10.5-20.3-16-42.9-16-66l0-31.6zM288 392l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8z',
    ],
  ],
};
const faTriangle = {
  prefix: 'fad',
  iconName: 'triangle',
  icon: [
    512,
    512,
    [9650],
    'f2ec',
    [
      'M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480l432 0c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z',
      '',
    ],
  ],
};
const faApartment = {
  prefix: 'fad',
  iconName: 'apartment',
  icon: [
    576,
    512,
    [],
    'e468',
    [
      'M0 144L0 464c0 26.5 21.5 48 48 48l80 0 32 0 96 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 96 0 32 0 80 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-80 0 0-144c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48l0 48L48 96C21.5 96 0 117.5 0 144zm64 32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM192 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM320 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm128 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M384 80c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32zM112 320c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm272-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm128 96l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm-384 0l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm112-80c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm0-256l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM384 208l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 320c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM128 208l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm112 16c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0z',
    ],
  ],
};
const faTruckMedical = {
  prefix: 'fad',
  iconName: 'truck-medical',
  icon: [
    640,
    512,
    [128657, 'ambulance'],
    'f0f9',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm16-288l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L48 416c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM176 80l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faAmbulance = faTruckMedical;
const faPepper = {
  prefix: 'fad',
  iconName: 'pepper',
  icon: [
    512,
    512,
    [129745],
    'e432',
    [
      'M2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c7-1.7 13.6-4.2 19.8-7.3c5.6-2.8 12.3-2.8 17.9 0c3 1.5 6 2.8 9.2 4c10.7 4 22.2 6.2 34 6.2c11.6 0 22.9-2.1 33.5-6.1c3.2-1.2 6.4-2.6 9.4-4.1c5.6-2.8 12.3-2.8 17.9 0c6.2 3.1 12.8 5.6 19.8 7.3c51.4 12.9 103.6-18.4 116.4-69.8l56-224c2-7.8 2.9-15.6 2.9-23.4c0-43-29.1-82.2-72.7-93.1c-23.2-5.8-46.5-2.6-66.3 7.3c-5.6 2.8-12.3 2.8-17.9 0c-6.2-3.1-12.8-5.6-19.8-7.3c-19-4.8-38.1-3.5-55.3 2.6c-4.9 1.8-9.7 3.9-14.3 6.4c-6 3.3-13.4 3.3-19.4 0c-4.6-2.5-9.4-4.7-14.3-6.4c-5-1.8-10.1-3.1-15.3-4c-.3-.1-.6-.1-.9-.2c-8.8-1.5-17.9-1.7-27.1-.6c-4 .5-7.9 1.2-11.9 2.2c-51.4 12.9-74.7 65-61.9 116.4l37.1 148.3c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L83.8 223c-11.8-47 .4-94.4 31.3-125.2c-6.2-1.3-12.6-1.9-19-1.9c-7.7 0-15.5 .9-23.4 2.9C21.3 111.7-10 163.8 2.9 215.3z',
      'M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37l0 10.9c4.9 1.8 9.7 3.9 14.3 6.4c6 3.3 13.4 3.3 19.4 0c4.6-2.5 9.4-4.7 14.3-6.4l0-10.9c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7z',
    ],
  ],
};
const faPiano = {
  prefix: 'fad',
  iconName: 'piano',
  icon: [
    512,
    512,
    [],
    'f8d4',
    [
      'M0 352l0 96c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-96-64 0 0 96L64 448l0-96L0 352z',
      'M0 192L0 352l96 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 96 0 0-24.4c0-24.2-13.7-46.4-35.4-57.2l-58.4-29.2c-21-10.5-34.2-31.9-34.2-55.4C384 83.2 300.8 0 198.3 0L192 0C86 0 0 86 0 192z',
    ],
  ],
};
const faGunSquirt = {
  prefix: 'fad',
  iconName: 'gun-squirt',
  icon: [
    576,
    512,
    [],
    'e19d',
    [
      'M64 160c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32L64 160zM219 376l53 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-41 0-12 48z',
      'M104 32c13.3 0 24 10.7 24 24l0 8 320 0c41.8 0 77.4 26.7 90.5 64l13.5 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-13.5 0c-13.2 37.3-48.7 64-90.5 64l-199 0L199 455.8C195.5 470 182.7 480 168 480L64 480c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L79.4 254.6C34.3 246.7 0 207.3 0 160c0-47.6 34.6-87.1 80-94.7L80 56c0-13.3 10.7-24 24-24zm-8 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 128z',
    ],
  ],
};
const faWheatAwnCircleExclamation = {
  prefix: 'fad',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e598',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L294.2 16 271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L90.5 219.6 67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4C3.1 463.6 0 471.8 0 480zM383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7L383 95z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faSnowman = {
  prefix: 'fad',
  iconName: 'snowman',
  icon: [
    512,
    512,
    [9731, 9924],
    'f7d0',
    [
      'M96 384c0 44.7 18.3 85 47.8 114.1c9.9 9.7 23.7 13.9 37.5 13.9l149.3 0c13.9 0 27.7-4.2 37.5-13.9C397.7 469 416 428.7 416 384c0-45.8-19.3-87.1-50.1-116.3c-2.9-2.8-4-6.9-2.8-10.8c2.7-8.7 4.3-17.9 4.8-27.3c.1-1.9 .1-3.7 .1-5.6c0-15.2-3-29.8-8.6-43c-4.3-10.3-10.1-19.9-17.2-28.4c-2.8-3.4-3.3-8.1-1.2-12C348 127.2 352 112.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 16.1 4 31.2 10.9 44.6c2 3.9 1.6 8.6-1.2 12c-7 8.5-12.9 18.1-17.2 28.4c-5.5 13.2-8.6 27.8-8.6 43c0 1.9 0 3.7 .1 5.6c.5 9.5 2.1 18.6 4.8 27.3c1.2 3.8 .1 8-2.8 10.8C115.3 296.9 96 338.2 96 384zM208 80c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.8c0 .5 0 1-.1 1.5c-.1 .5-.1 1.1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16zm32 40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 3.2c0 3.2-.8 6.3-2.3 9l-9 16.9c-.9 1.7-2.7 2.8-4.7 2.8s-3.8-1.1-4.7-2.8l-9-16.9c-1.5-2.8-2.3-5.9-2.3-9l0-3.2zm0 104c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6c0 .5 .1 .9 .1 1.8c0 .6 0 1.1-.1 1.5c-.1 .5-.1 1.1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.8c0 .5 0 1-.1 1.5c-.1 .5-.1 1.1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.8c0 .5 0 1-.1 1.5c-.1 .5-.1 1.1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16zM272 80c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.8c0 .5 0 1-.1 1.5c-.1 .5-.1 1.1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16z',
      'M224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM304 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 96c-13.3 0-24 10.7-24 24l0 19.6-22.5-9.7c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l56 24 73.6 31.5c-.1-1.9-.1-3.7-.1-5.6c0-15.2 3-29.8 8.6-43L104 160.2l0-40.2c0-13.3-10.7-24-24-24zM368 224c0 1.9 0 3.7-.1 5.6l73.6-31.5 56-24c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L456 139.6l0-19.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40.2L359.4 181c5.5 13.2 8.6 27.8 8.6 43z',
    ],
  ],
};
const faUserAlien = {
  prefix: 'fad',
  iconName: 'user-alien',
  icon: [
    448,
    512,
    [],
    'e04a',
    [
      'M0 486.4C0 415 55.7 356.6 126.1 352.3c23.8 23.2 46.1 40.2 58.5 49.1c12 8.6 25.9 12.4 39.4 12.4s27.4-3.8 39.4-12.4c12.4-8.8 34.7-25.8 58.5-49.1C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4zM64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm48 20.4c0 37.9 30.7 68.6 68.6 68.6l16 0c6.3 0 11.4-5.1 11.4-11.4c0-37.9-30.7-68.6-68.6-68.6l-16 0c-6.3 0-11.4 5.1-11.4 11.4zm128 57.1c0 6.3 5.1 11.4 11.4 11.4l16 0c37.9 0 68.6-30.7 68.6-68.6c0-6.3-5.1-11.4-11.4-11.4l-16 0c-37.9 0-68.6 30.7-68.6 68.6z',
      'M139.4 176c37.9 0 68.6 30.7 68.6 68.6c0 6.3-5.1 11.4-11.4 11.4l-16 0c-37.9 0-68.6-30.7-68.6-68.6c0-6.3 5.1-11.4 11.4-11.4l16 0zm169.1 0l16 0c6.3 0 11.4 5.1 11.4 11.4c0 37.9-30.7 68.6-68.6 68.6l-16 0c-6.3 0-11.4-5.1-11.4-11.4c0-37.9 30.7-68.6 68.6-68.6z',
    ],
  ],
};
const faShieldCheck = {
  prefix: 'fad',
  iconName: 'shield-check',
  icon: [
    512,
    512,
    [],
    'f2f7',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faMortarPestle = {
  prefix: 'fad',
  iconName: 'mortar-pestle',
  icon: [
    512,
    512,
    [],
    'f5a7',
    [
      'M209.3 192c52 0 103.9 0 155.9 0L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5S474.5-3.7 461 6.2L213.7 188.5c-1.5 1.1-3 2.3-4.4 3.5z',
      'M0 224c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32c0 82.5-43.4 147.7-123.9 176.2c11.1 13.9 19.4 30.3 23.9 48.1c4.4 17.1-10.4 31.7-28.1 31.7l-192 0c-17.7 0-32.4-14.6-28.1-31.7c4.5-17.8 12.8-34.1 23.9-48.1C75.4 403.7 32 338.5 32 256c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faRoadBarrier = {
  prefix: 'fad',
  iconName: 'road-barrier',
  icon: [
    640,
    512,
    [],
    'e562',
    [
      'M64 96l85.2 0L64 266.3 64 96zm42.8 192l90.6-181.3L202.8 96l74.3 0L186.5 277.3 181.2 288l-74.3 0zm128 0l90.6-181.3L330.8 96l74.3 0L314.5 277.3 309.2 288l-74.3 0zm128 0l90.6-181.3L458.8 96l74.3 0L442.5 277.3 437.2 288l-74.3 0zm128 0L576 117.7 576 288l-85.2 0z',
      'M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64zm576 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384z',
    ],
  ],
};
const faChartCandlestick = {
  prefix: 'fad',
  iconName: 'chart-candlestick',
  icon: [
    512,
    512,
    [],
    'e0e2',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M304 32c8.8 0 16 7.2 16 16l0 48c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-48c0-8.8 7.2-16 16-16zM416 192l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM128 160c0-17.7 14.3-32 32-32l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c-17.7 0-32-14.3-32-32l0-128z',
    ],
  ],
};
const faBriefcaseBlank = {
  prefix: 'fad',
  iconName: 'briefcase-blank',
  icon: [
    512,
    512,
    [],
    'e0c8',
    [
      'M128 56l0 40 48 0 0-40c0-4.4 3.6-8 8-8l144 0c4.4 0 8 3.6 8 8l0 40 48 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56z',
      'M64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 96z',
    ],
  ],
};
const faSchool = {
  prefix: 'fad',
  iconName: 'school',
  icon: [
    640,
    512,
    [127979],
    'f549',
    [
      'M0 144L0 464c0 26.5 21.5 48 48 48l208 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 208 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4C332.4 1.8 326.2 0 320 0s-12.4 1.8-17.8 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144zm80 64c0-8.8 7.2-16 16-16c10.7 0 21.3 0 32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16c-10.7 0-21.3 0-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM408 176a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zm88 32c0-8.8 7.2-16 16-16c10.7 0 21.3 0 32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16c-10.7 0-21.3 0-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64z',
      'M336 144l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM80 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm416 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM96 320l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64z',
    ],
  ],
};
const faIgloo = {
  prefix: 'fad',
  iconName: 'igloo',
  icon: [
    576,
    512,
    [],
    'f7ae',
    [
      'M0 320l96 0 0-128-66.1 0C10.8 230.6 0 274 0 320zm0 32l0 80c0 26.5 21.5 48 48 48l144 0 0-128L0 352zM48.5 160L320 160l0-126.2c-10.5-1.2-21.2-1.8-32-1.8C188.1 32 100.2 82.8 48.5 160zM128 192l0 128 69.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l69.5 0 0-128-320 0zM352 39.1L352 160l175.5 0C487.2 99.8 424.9 55.7 352 39.1zM384 352l0 128 144 0c26.5 0 48-21.5 48-48l0-80-192 0zm96-160l0 128 96 0c0-46-10.8-89.4-29.9-128L480 192z',
      'M320 33.8c10.9 1.2 21.5 3 32 5.4L352 160l175.5 0c6.8 10.2 13 20.9 18.6 32L480 192l0 128 96 0 0 32-192 0 0 128-32 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128-32 0 0-128L0 352l0-32 96 0 0-128-66.1 0c5.5-11.1 11.7-21.8 18.6-32L320 160l0-126.2zM197.5 320c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l69.5 0 0-128-320 0 0 128 69.5 0z',
    ],
  ],
};
const faBracketRound = {
  prefix: 'fad',
  iconName: 'bracket-round',
  icon: [
    192,
    512,
    ['parenthesis'],
    '28',
    [
      'M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449.1 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z',
      '',
    ],
  ],
};
const faParenthesis = faBracketRound;
const faJoint = {
  prefix: 'fad',
  iconName: 'joint',
  icon: [
    640,
    512,
    [],
    'f595',
    [
      'M384 32l0 11c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9l0 11c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43l0-11c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 0l0 11c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8l0 11c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9l0-11c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M214.7 358c5.2-.8 10.5-.3 15.2 2c10.2 4.9 19.3 12 26.7 20.8L358.9 503.7c2.6 3.2 .5 8.3-3.6 8.3L288 512c-59.2 0-127.7-14.7-180.2-28.8C81.3 476 58.3 468.9 42 463.6c-8.2-2.7-14.7-4.9-19.2-6.5c-2.3-.8-4-1.4-5.2-1.8l-1.3-.5C6.8 451.5 0 442.6 0 432s6.8-19.5 16.3-22.7l1.3-.5c1.2-.4 3-1.1 5.2-1.8c4.5-1.6 11-3.8 19.2-6.5c16.3-5.4 39.2-12.5 65.7-19.6c31.7-8.5 69.2-17.3 106.9-22.8zM464 512l-19 0c-23.7 0-46.3-10.5-61.5-28.8L281.1 360.3c-2.6-3.2-.6-8.2 3.5-8.3c1.1 0 2.3 0 3.4 0l48 0 19 0c23.7 0 46.3 10.5 61.5 28.8L518.9 503.7c2.6 3.2 .5 8.3-3.6 8.3L464 512zM444.7 352L600 352c22.1 0 40 17.9 40 40l0 80c0 21.4-16.8 38.9-37.9 39.9c-22.7-.8-44-11.2-58.6-28.7L441.1 360.3c-2.6-3.2-.5-8.3 3.6-8.3z',
    ],
  ],
};
const faHorseSaddle = {
  prefix: 'fad',
  iconName: 'horse-saddle',
  icon: [
    576,
    512,
    [],
    'f8c3',
    [
      'M0 256c0-44.6 33.2-81.5 76.3-87.2c-3.9 6.4-7 13.4-9.1 20.8c-1.1 3.7-1.9 7.5-2.4 11.4c-.3 1.9-.5 3.9-.6 5.9c-.1 1-.1 2-.2 3s-.1 2-.1 3c0 3.6 .2 7.1 .7 10.7C54.6 230.8 48 242.6 48 256l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56zM160 128l160 0 0 48c0 38.7-27.5 71-64 78.4l0 73.6c0 8.8-7.2 16-16 16c-8.7 0-15.7-6.9-16-15.5c0-1.1 0-1.4 0-1.7l0-6.8 0-65.6c-36.5-7.4-64-39.7-64-78.4l0-48z',
      'M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C377.3 0 320 57.3 320 128l0 48c0 38.7-27.5 71-64 78.4l0 74.7 51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM224 254.4c-36.5-7.4-64-39.7-64-78.4l0-48-11.2 0C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l.3 .1 0-65.6zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faMugMarshmallows = {
  prefix: 'fad',
  iconName: 'mug-marshmallows',
  icon: [
    512,
    512,
    [],
    'f7b7',
    [
      'M32 64c0-17.7 14.3-32 32-32l128 0c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3c0 5.5 .9 10.9 2.6 16L32 128l0-64zm64 96l64 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm96-48c0-5.1 2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128l-144 0-2.3-2.3C194 122 192 117.1 192 112z',
      'M96 160l-64 0c-17.7 0-32 14.3-32 32L0 384c0 53 43 96 96 96l192 0c53 0 96-43 96-96l16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-48 0-192 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM384 320l0-96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0z',
    ],
  ],
};
const faFilters = {
  prefix: 'fad',
  iconName: 'filters',
  icon: [
    640,
    512,
    [],
    'e17e',
    [
      'M0 136c0 9.8 3.6 19.6 10.6 27.1L160 325.5l0 74.5c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6l0-122.5 32-34.8 0-16.7L179 120.7c-6.7-7.3-11.7-15.7-14.9-24.7L40 96c-15.9 0-30.2 9.4-36.6 23.9C1.1 125.1 0 130.6 0 136z',
      'M195.4 55.9C201.7 41.4 216.1 32 232 32l368 0c15.9 0 30.2 9.4 36.6 23.9s3.6 31.5-7.2 43.2L480 261.5 480 416c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-106.5L202.6 99.1c-10.7-11.7-13.6-28.6-7.2-43.2z',
    ],
  ],
};
const faBellOn = {
  prefix: 'fad',
  iconName: 'bell-on',
  icon: [
    640,
    512,
    [128365],
    'f8fa',
    [
      'M96 384c0 4.4 .9 8.9 2.8 13.1C104 408.6 115.4 416 128 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8l0-18.8c0-77.4-55-142-128-156.8L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2C215 66 160 130.6 160 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-5.3 6-8.1 13.6-8.1 21.3z',
      'M586.7 53.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32zM0 200c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm512 0c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zM42.5 21.3c-5.9 11.9-1.1 26.3 10.7 32.2l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3zm322.7 472c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z',
    ],
  ],
};
const faAngleRight = {
  prefix: 'fad',
  iconName: 'angle-right',
  icon: [
    320,
    512,
    [8250],
    'f105',
    [
      'M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z',
      '',
    ],
  ],
};
const faDialMed = {
  prefix: 'fad',
  iconName: 'dial-med',
  icon: [
    576,
    512,
    [],
    'e15f',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M264 129c-77 11.6-136 78-136 158.2c0 88.4 71.6 160 160 160s160-71.6 160-160C448 207 389 140.6 312 129l0 158.2c0 13.3-10.7 24-24 24s-24-10.7-24-24L264 129z',
    ],
  ],
};
const faHorse = {
  prefix: 'fad',
  iconName: 'horse',
  icon: [
    576,
    512,
    [128014],
    'f6f0',
    [
      'M0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256z',
      'M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C377.3 0 320 57.3 320 128l-96 0-20.8 0-54.4 0C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faQ = {
  prefix: 'fad',
  iconName: 'q',
  icon: [
    448,
    512,
    [113],
    '51',
    [
      'M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z',
      '',
    ],
  ],
};
const faMonitorWaveform = {
  prefix: 'fad',
  iconName: 'monitor-waveform',
  icon: [
    576,
    512,
    ['monitor-heart-rate'],
    'f611',
    [
      'M64 96l0 160 128 0c6.1 0 11.6 3.4 14.3 8.8L224 300.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L329.9 256l70.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-6.1 0-11.6-3.4-14.3-8.8L288 243.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L182.1 288 64 288l0 128 448 0 0-320L64 96z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM512 96l0 320L64 416 64 96l448 0z',
    ],
  ],
};
const faMonitorHeartRate = faMonitorWaveform;
const faLinkSimple = {
  prefix: 'fad',
  iconName: 'link-simple',
  icon: [
    576,
    512,
    [],
    'e1cd',
    [
      'M160 256c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32z',
      'M160 96C71.6 96 0 167.6 0 256s71.6 160 160 160l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-53 0-96-43-96-96s43-96 96-96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm256 0l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96 43 96 96s-43 96-96 96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c88.4 0 160-71.6 160-160s-71.6-160-160-160z',
    ],
  ],
};
const faWhistle = {
  prefix: 'fad',
  iconName: 'whistle',
  icon: [
    640,
    512,
    [],
    'f460',
    [
      'M32 256c0-23.6 4.3-46.3 12.1-67.2c6.1-16.3 14.4-31.6 24.4-45.5c3.6-5 7.4-9.7 11.5-14.3c11.4-12.9 24.5-24.3 39-33.8C149.2 75.5 185.2 64 224 64c7.8 0 15.4 .5 22.9 1.4c.5 0 1.1 0 1.7 .1c37.8 4.5 73.8 19.4 103.9 43.2l69.8 55.2c5 4 7.2 10.6 5.5 16.8l-6.5 24c-3.2 11.7 1.1 24.2 10.8 31.5c9.6 7.2 22.7 7.9 33 1.7l19.3-11.6c5.7-3.4 12.9-3 18.2 1.2l127 100.4c6.6 5.2 10.5 13.2 10.5 21.6c0 6.9-2.6 13.5-7.2 18.5l-63.3 69.6c-6.1 6.7-14.7 10.5-23.7 10.5l-2 0c-5.2 0-10.2-1.2-14.8-3.6L380.7 367c-34.8 49-92 81-156.7 81C118 448 32 362 32 256zm128 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M0 128c0 28.4 18.5 52.5 44.1 60.8c6.1-16.3 14.4-31.6 24.4-45.5c-1.4 .4-2.9 .6-4.5 .6c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16c0 .3 0 .7 0 1c11.4-12.9 24.5-24.3 39-33.8C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faG = {
  prefix: 'fad',
  iconName: 'g',
  icon: [
    448,
    512,
    [103],
    '47',
    [
      'M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128L256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l144 0c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z',
      '',
    ],
  ],
};
const faWineGlassCrack = {
  prefix: 'fad',
  iconName: 'wine-glass-crack',
  icon: [
    320,
    512,
    ['fragile'],
    'f4bb',
    [
      'M18.1 197.8c-6 72 42.5 135.2 109.9 150.6l0 99.6-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0L208 0l25.8 51.7c3.5 7.1 1.4 15.7-5.1 20.3l-58.4 40.9c-6 4.2-8.4 12-5.8 18.9l31.1 81c2.1 5.5-1.9 11.4-7.8 11.4c-2.4 0-4.7-1.1-6.3-2.9L92.1 118c-6.4-7.4-4.7-18.7 3.5-24l58.6-37.3c7.6-4.8 9.7-14.9 4.7-22.4L136 0 64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4z',
      'M154.2 56.8L95.7 94c-8.2 5.2-9.9 16.6-3.5 24l89.3 103.1c1.6 1.8 3.9 2.9 6.3 2.9c5.9 0 9.9-5.9 7.8-11.4l-31.1-81c-2.6-6.9-.3-14.6 5.8-18.9l58.4-40.9c6.5-4.5 8.7-13.2 5.1-20.3L208 0H136l22.9 34.4c5 7.5 2.8 17.6-4.7 22.4z',
    ],
  ],
};
const faFragile = faWineGlassCrack;
const faSlotMachine = {
  prefix: 'fad',
  iconName: 'slot-machine',
  icon: [
    640,
    512,
    [],
    'e3ce',
    [
      'M0 160L0 352c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 96C28.7 96 0 124.7 0 160zm56 40c0-13.3 10.7-24 24-24l59.9 0c23 0 38.5 23.5 29.4 44.6L126.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L115.6 224 80 224c-13.3 0-24-10.7-24-24zm144 0c0-13.3 10.7-24 24-24l59.9 0c23 0 38.5 23.5 29.4 44.6L270.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L259.6 224 224 224c-13.3 0-24-10.7-24-24zm144 0c0-13.3 10.7-24 24-24l59.9 0c23 0 38.5 23.5 29.4 44.6L414.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L403.6 224 368 224c-13.3 0-24-10.7-24-24z',
      'M128 0L384 0c35.3 0 64 28.7 64 64L64 64C64 28.7 92.7 0 128 0zM640 176c0 14.2-6.2 27-16 35.8L624 416c0 53-43 96-96 96l-80 0-32 0-288 0c-35.3 0-64-28.7-64-64l0-32 384 0 0 32 80 0c17.7 0 32-14.3 32-32l0-204.2c-9.8-8.8-16-21.6-16-35.8c0-26.5 21.5-48 48-48s48 21.5 48 48z',
    ],
  ],
};
const faNotesMedical = {
  prefix: 'fad',
  iconName: 'notes-medical',
  icon: [
    512,
    512,
    [],
    'f481',
    [
      'M96 96c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 197.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7L160 416c-35.3 0-64-28.7-64-64L96 96zm96 112l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z',
      'M296 464c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0C60.9 512 0 451.1 0 376L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l160 0zM256 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faCarWash = {
  prefix: 'fad',
  iconName: 'car-wash',
  icon: [
    448,
    512,
    [],
    'f5e6',
    [
      'M16 80c0 26.5 21.5 48 48 48s48-16 48-48S64 0 64 0s-48 48-48 80zm160 0c0 26.5 21.5 48 48 48s48-16 48-48s-48-80-48-80s-48 48-48 80zm160 0c0 26.5 21.5 48 48 48s48-16 48-48s-48-80-48-80s-48 48-48 80z',
      'M138.8 234.6L119.7 288l208.6 0-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6l-140.3 0c-6.8 0-12.8 4.3-15.1 10.6zM50.2 292.4l28.3-79.3C89.9 181.3 120 160 153.8 160l140.3 0c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6l0 40 0 64 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32L96 448l0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32 0-64 0-40c0-23.2 14.1-43.1 34.2-51.6zM120 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faEscalator = {
  prefix: 'fad',
  iconName: 'escalator',
  icon: [
    640,
    512,
    [],
    'e171',
    [
      'M32 448c0 35.3 28.7 64 64 64l96 0c15.5 0 30.5-5.6 42.1-15.8L472 288l72 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-96 0c-15.5 0-30.5 5.6-42.1 15.8L168 384l-72 0c-35.3 0-64 28.7-64 64z',
      'M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm64 192l0 16.4-128 112L192 192c0-35.3 28.7-64 64-64s64 28.7 64 64z',
    ],
  ],
};
const faCommentImage = {
  prefix: 'fad',
  iconName: 'comment-image',
  icon: [
    512,
    512,
    [],
    'e148',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm98.3 66.2c-4-8.4-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6L199 257.3l77.8-103.7c4.5-6 11.6-9.6 19.2-9.6s14.7 3.6 19.2 9.6l96 128c3.2 4.2 4.8 9.3 4.8 14.4c0 3.7-.8 7.3-2.5 10.7c-4.1 8.1-12.4 13.3-21.5 13.3l-192 0-80 0c-9.3 0-17.8-5.4-21.7-13.8zM192 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M296 144c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1s-12.4 13.3-21.5 13.3l-192 0-80 0c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6L199 257.3l77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z',
    ],
  ],
};
const faTemperatureHalf = {
  prefix: 'fad',
  iconName: 'temperature-half',
  icon: [
    320,
    512,
    [127777, 'temperature-2', 'thermometer-2', 'thermometer-half'],
    'f2c9',
    [
      'M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L272 112C272 50.2 221.9 0 160 0S48 50.2 48 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L112 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M176 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 114.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L176 208z',
    ],
  ],
};
const faTemperature2 = faTemperatureHalf;
const faThermometer2 = faTemperatureHalf;
const faThermometerHalf = faTemperatureHalf;
const faDongSign = {
  prefix: 'fad',
  iconName: 'dong-sign',
  icon: [
    384,
    512,
    [],
    'e169',
    [
      'M0 480c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM192 96c0-17.7 14.3-32 32-32l32 0 0 64-32 0c-17.7 0-32-14.3-32-32zM320 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l0-64z',
      'M288 32c-17.7 0-32 14.3-32 32l0 113.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32l0-96 0-224c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
    ],
  ],
};
const faDonut = {
  prefix: 'fad',
  iconName: 'donut',
  icon: [
    512,
    512,
    [127849, 'doughnut'],
    'e406',
    [
      'M0 278.8L0 304c0 88.4 114.6 160 256 160s256-71.6 256-160l0-25.1c-7.9 9.2-18.3 16.1-29.9 19.9c-10 3.7-18.6 10.6-24.4 19.6c-11 15.4-25.8 27.6-43 35.5c-17.2 7.9-36.1 11.3-54.9 9.7c-15.6-.2-31.1 2.9-45.5 8.8c-18.4 7.8-38.3 11.7-58.2 11.6c-.7 0-1.1 0-1.5 0c-19.6 0-38.9-3.9-57-11.6c-14.4-6-29.8-9-45.4-8.8c-18.9 1.5-37.8-1.8-55-9.8s-32-20.2-43-35.6c-5.8-8.9-14.4-15.8-24.4-19.6C18.3 294.9 7.9 288 0 278.8zM116.7 132.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6c-3.1-3.1-7.2-4.7-11.3-4.7s-8.2 1.6-11.3 4.7l-32 32zm160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32zm96-160c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-6.2-6.2-16.4-6.2-22.6 0z',
      'M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160l0 70.9c-7.9 9.2-18.3 16.1-29.9 19.9c-10 3.7-18.6 10.6-24.4 19.6c-11 15.4-25.8 27.6-43 35.5s-36.1 11.3-54.9 9.7c-15.6-.2-31 2.9-45.4 8.8C295.9 380.3 276 384.2 256 384c-20 .2-39.9-3.7-58.3-11.6c-14.4-6-29.8-9-45.4-8.8c-18.9 1.5-37.8-1.8-55-9.8s-32-20.2-43-35.6c-5.8-9-14.4-15.8-24.4-19.6C18.3 294.9 7.9 288 0 278.8L0 208zm320-16c0-17.7-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32s64-14.3 64-32zM283.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-112 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224 9.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm331.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-240 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z',
    ],
  ],
};
const faDoughnut = faDonut;
const faCapsules = {
  prefix: 'fad',
  iconName: 'capsules',
  icon: [
    576,
    512,
    [],
    'f46b',
    [
      'M0 144l0 48 0 64c10.7 0 21.3 0 32 0s21.3 0 32 0c32 0 64 0 96 0c10.7 0 21.3 0 32 0s21.3 0 32 0l0-64 0-48c0-61.9-50.1-112-112-112S0 82.1 0 144zM256 98.3l0 163.9 53.1 77.5c17.5-12.2 35-24.5 52.4-36.7c26.6-18.6 53.3-37.3 79.9-55.9l52.4-36.7c-22.2-32.4-44.4-64.7-66.6-97.1C391.8 61.5 321.9 49 271.3 85.2c-5.6 4-10.7 8.4-15.3 13.1z',
      'M372.3 431.7l-63.1-92L361.6 303s0 0 0 0l79.9-55.9s0 0 0 0l52.4-36.7 61.9 90.2c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1zm116.4-22.4c.8-.5 1.6-1 2.4-1.6c.5-.4 1.1-.8 1.6-1.2l-4 2.8zM0 256l32 0 32 0 96 0 32 0 32 0 0 64 0 48c0 61.9-50.1 112-112 112S0 429.9 0 368l0-48 0-64z',
    ],
  ],
};
const faPooStorm = {
  prefix: 'fad',
  iconName: 'poo-storm',
  icon: [
    448,
    512,
    ['poo-bolt'],
    'f75a',
    [
      'M96.9 373.3c2.2 6.4 8.3 10.7 15.1 10.7l70.1 0L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6c2.9 2.4 6.5 3.6 10.1 3.6c3.5 0 7.1-1.2 10-3.5l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8z',
      'M222.4 5.9c3.5-4.3 9-6.5 14.5-5.7C283.9 6.5 320 46.7 320 95.4c0 5.7-.5 11.2-1.4 16.6l1.4 0c35.3 0 64 28.7 64 64c0 12-3.3 23.1-9 32.7c41.2 5.4 73 40.6 73 83.3c0 46.4-37.6 84-84 84l-12.7 0c1.3-7.8 .7-16-2-23.9C342.5 332.9 324.4 320 304 320l-18.3 0 29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L82 330.5C68.9 341 62.4 357.5 64.3 373.7C27.4 364.8 0 331.6 0 292c0-42.7 31.8-77.9 73-83.3c-5.7-9.6-9-20.8-9-32.7c0-35.3 28.7-64 64-64l16.3 0c23.8 0 44-6.3 57.8-17C215.5 84.5 224 69.1 224 47.3c0-9.2-1.5-18-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.3z',
    ],
  ],
};
const faPooBolt = faPooStorm;
const faTally1 = {
  prefix: 'fad',
  iconName: 'tally-1',
  icon: [
    640,
    512,
    [],
    'e294',
    ['', 'M128 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32L96 64c0-17.7 14.3-32 32-32z'],
  ],
};
const faFileVector = {
  prefix: 'fad',
  iconName: 'file-vector',
  icon: [
    384,
    512,
    [],
    'e64c',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 208l0 32c0 8.8 7.2 16 16 16l16 0 0 128-16 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0 0-128 16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 16-128 0 0-16c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm64 48l128 0 0 128-128 0 0-128z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM128 208l0 16 128 0 0-16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-16 0 0 128 16 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16-128 0 0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l16 0 0-128-16 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zm0 176l128 0 0-128-128 0 0 128z',
    ],
  ],
};
const faFaceFrownOpen = {
  prefix: 'fad',
  iconName: 'face-frown-open',
  icon: [
    512,
    512,
    [128550, 'frown-open'],
    'f57a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm14.1 161.1c16.7-38.2 55.8-65.1 101.5-65.1c45.7 0 84.9 26.9 101.5 65.1c5.3 12.2-8.6 21.5-20.8 16.4c-24.4-10.3-51.8-16.1-80.7-16.1c-28.9 0-56.2 5.8-80.6 16.1c-12.3 5.2-26.1-4.2-20.8-16.4zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faFrownOpen = faFaceFrownOpen;
const faSquareDashed = {
  prefix: 'fad',
  iconName: 'square-dashed',
  icon: [
    448,
    512,
    [],
    'e269',
    [
      'M0 128l0 32 64 0 0-32c0-17.7 14.3-32 32-32l32 0 0-64L96 32C43 32 0 75 0 128zM0 352l0 32c0 53 43 96 96 96l32 0 0-64-32 0c-17.7 0-32-14.3-32-32l0-32L0 352zM320 32l0 64 32 0c17.7 0 32 14.3 32 32l0 32 64 0 0-32c0-53-43-96-96-96l-32 0zm0 384l0 64 32 0c53 0 96-43 96-96l0-32-64 0 0 32c0 17.7-14.3 32-32 32l-32 0z',
      'M0 192L0 320l64 0 0-128L0 192zm384 0l0 128 64 0 0-128-64 0zM160 480l128 0 0-64-128 0 0 64zm0-384l128 0 0-64L160 32l0 64z',
    ],
  ],
};
const faBagShoppingPlus = {
  prefix: 'fad',
  iconName: 'bag-shopping-plus',
  icon: [
    448,
    512,
    [],
    'e651',
    [
      'M0 208c0-26.5 21.5-48 48-48l64 0 48 0 128 0 48 0 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208zM120 336c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-56 0c-13.3 0-24 10.7-24 24z',
      'M224 48c-35.3 0-64 28.7-64 64l0 48-48 0 0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48-48 0 0-48c0-35.3-28.7-64-64-64zM120 336c0-13.3 10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faSquareJ = {
  prefix: 'fad',
  iconName: 'square-j',
  icon: [
    448,
    512,
    [],
    'e273',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 53-43 96-96 96s-96-43-96-96l0-8z',
      'M280 128c13.3 0 24 10.7 24 24l0 136c0 53-43 96-96 96s-96-43-96-96l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHandPointUp = {
  prefix: 'fad',
  iconName: 'hand-point-up',
  icon: [
    384,
    512,
    [9757],
    'f0a6',
    [
      'M0 336l0 27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l0-8.6c-9.4 5.4-20.3 8.6-32 8.6c-27.9 0-51.7-17.9-60.4-42.8C281.4 316 269.2 320 256 320c-11.7 0-22.6-3.1-32-8.6l0 .6c0 39.8-32.2 72-72 72l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-88 0c-35.3 0-64 28.7-64 64zM32 32l0 208 64 0L96 32C96 14.3 81.7 0 64 0S32 14.3 32 32z',
      'M128 160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faMoneyBill = {
  prefix: 'fad',
  iconName: 'money-bill',
  icon: [
    576,
    512,
    [],
    'f0d6',
    [
      'M64 192l0 128c35.3 0 64 28.7 64 64l320 0c0-35.3 28.7-64 64-64l0-128c-35.3 0-64-28.7-64-64l-320 0c0 35.3-28.7 64-64 64zm320 64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
      'M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm384 64c0 35.3 28.7 64 64 64l0 128c-35.3 0-64 28.7-64 64l-320 0c0-35.3-28.7-64-64-64l0-128c35.3 0 64-28.7 64-64l320 0z',
    ],
  ],
};
const faArrowUpBigSmall = {
  prefix: 'fad',
  iconName: 'arrow-up-big-small',
  icon: [
    576,
    512,
    ['sort-size-up'],
    'f88e',
    [
      'M320 80l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L368 32c-26.5 0-48 21.5-48 48zm0 288l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortSizeUp = faArrowUpBigSmall;
const faBarcodeRead = {
  prefix: 'fad',
  iconName: 'barcode-read',
  icon: [
    576,
    512,
    [],
    'f464',
    [
      'M0 56l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-4.4 3.6-8 8-8l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C25.1 0 0 25.1 0 56zM0 376l0 80c0 30.9 25.1 56 56 56l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-4.4 0-8-3.6-8-8l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24zM416 24c0 13.3 10.7 24 24 24l80 0c4.4 0 8 3.6 8 8l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-30.9-25.1-56-56-56L440 0c-13.3 0-24 10.7-24 24zm0 464c0 13.3 10.7 24 24 24l80 0c30.9 0 56-25.1 56-56l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 4.4-3.6 8-8 8l-80 0c-13.3 0-24 10.7-24 24z',
      'M152 128c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-208c0-13.3-10.7-24-24-24l-16 0zm160 0c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-208c0-13.3-10.7-24-24-24l-16 0zm72 24l0 208c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-208c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zM240 128c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faBaguette = {
  prefix: 'fad',
  iconName: 'baguette',
  icon: [
    640,
    512,
    [129366],
    'e3d8',
    [
      'M0 384.1c0 24.4 7 49.1 21.5 70.9c24.7 37 65.3 57 106.6 57c24.4 0 49.1-7 70.9-21.5l384-256c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L356.5 77.8c23.6 23.6 47.2 47.2 70.8 70.8c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-6.2 6.2-16.4 6.2-22.6 0c-25.1-25.1-50.2-50.2-75.4-75.4c-29.4 19.6-58.7 39.1-88 58.7c24.7 24.7 49.4 49.4 74 74c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-78.6-78.6c-29.4 19.6-58.7 39.1-88 58.7c25.8 25.8 51.5 51.5 77.2 77.2c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L98.9 249.5c-14 9.3-28 18.6-41.9 28C20 302.2 0 342.8 0 384.1z',
      'M356.5 77.8L329.3 95.9l75.4 75.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L356.5 77.8zM126.1 231.4L98.9 249.5l81.8 81.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-77.2-77.2zm115.2-76.8l-27.2 18.1 78.6 78.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-74-74z',
    ],
  ],
};
const faBowlSoftServe = {
  prefix: 'fad',
  iconName: 'bowl-soft-serve',
  icon: [
    512,
    512,
    [],
    'e46b',
    [
      'M32 240c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80c0-41.7-32-76-72.8-79.7c5.6-9.5 8.8-20.5 8.8-32.3C416 57.3 358.7 0 288 0L256 0l10.8 16.3c3.4 5 5.2 11 5.2 17c0 17-13.7 30.7-30.7 30.7L160 64c-35.3 0-64 28.7-64 64c0 11.8 3.2 22.8 8.8 32.3C64 164 32 198.3 32 240z',
      'M64 320c-8.8 0-16 7.2-16 16l0 8c0 57.4 46.6 104 104 104l30.1 0-20.4 40.8c-1.1 2.3-1.7 4.7-1.7 7.2c0 2.9 .8 5.8 2.4 8.4c2.9 4.7 8.1 7.6 13.6 7.6l160 0c5.5 0 10.7-2.9 13.6-7.6c1.6-2.6 2.4-5.5 2.4-8.4c0-2.4-.6-4.9-1.7-7.2L329.9 448l30.1 0c57.4 0 104-46.6 104-104l0-8c0-8.8-7.2-16-16-16L64 320z',
    ],
  ],
};
const faFaceHoldingBackTears = {
  prefix: 'fad',
  iconName: 'face-holding-back-tears',
  icon: [
    512,
    512,
    [129401],
    'e482',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm80.3-83c.2-.9 .4-1.9 .8-2.8c.7-1.8 1.7-3.4 2.9-4.8c2.5-2.8 6-4.8 10-5.3c3.8-.5 7.7-1 11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9c.5-1.7 1-3.4 1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6l0 32 0 16 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7l0 6.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-.1-.7-.1-1.4-.1-2c0-1 0-1.2 .1-1.5c0-.5 .1-.9 .2-1.4zm85.6 217.4c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C203 384.4 224.9 400 256 400s53-15.6 65.9-30.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C328.9 410.3 298.8 432 256 432s-72.9-21.7-90.1-41.5zM272 240c0-41.4 31.4-75.4 72-79.6c-10-10.8-17.6-24.1-21.9-38.8c-.5-1.7-1-3.4-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8c1.5-.4 2.9-.6 4.4-.6c7 0 13.4 4.6 15.4 11.6l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9c3.8 .5 7.7 1 11.5 1.4c8.1 1 14 7.9 14 15.9c0 .7 0 1.3-.1 2c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48s-6 34.6-16 48l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80z',
      'M191.4 116.4c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9s9.1 15 17.9 13.9l11.5-1.4c38.2-4.8 69.8-31.9 80.4-68.9l1.5-5.2zm129.2 0l1.5 5.2c10.6 37 42.2 64.1 80.4 68.9l11.5 1.4c8.8 1.1 16.8-5.1 17.9-13.9s-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8zM128 232c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8c0 17.7-14.3 32-32 32zm224-32c0 17.7-14.3 32-32 32c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8z',
    ],
  ],
};
const faSquareUp = {
  prefix: 'fad',
  iconName: 'square-up',
  icon: [
    448,
    512,
    [11014, 'arrow-alt-square-up'],
    'f353',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 233.7c0-6.2 2.6-12.1 7.1-16.3l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5c35.7 33.3 71.4 66.6 107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3L272 256l0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-57.7 0C106 256 96 246 96 233.7z',
      'M210.2 117.5L103.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3C96 246 106 256 118.3 256l57.7 0 0 96c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-96 57.7 0c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L237.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5z',
    ],
  ],
};
const faArrowAltSquareUp = faSquareUp;
const faTrainSubwayTunnel = {
  prefix: 'fad',
  iconName: 'train-subway-tunnel',
  icon: [
    512,
    512,
    ['subway-tunnel'],
    'e2a3',
    [
      'M0 256L0 448c0 35.3 28.7 64 64 64l41.4 0 64.3-64.3C137.3 444.5 112 417.2 112 384l0-192c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 192c0 1 0 2.1-.1 3.1s-.1 2-.2 3.1c-.2 2-.5 4-.9 6c-.8 3.9-1.9 7.7-3.3 11.4c-2.9 7.3-7.1 13.9-12.2 19.6c-10.4 11.4-24.8 19-41 20.6L406.6 512l41.4 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0S0 114.6 0 256zM150.6 512l210.7 0-64-64-82.7 0-64 64zM160 216l0 8 0 64 0 8c0 13.3 10.7 24 24 24l8 0 16 0 8 0c13.3 0 24-10.7 24-24l0-8 0-64 0-8c0-13.3-10.7-24-24-24l-8 0-16 0-8 0c-13.3 0-24 10.7-24 24zm112 0l0 8 0 64 0 8c0 13.3 10.7 24 24 24l8 0 16 0 8 0c13.3 0 24-10.7 24-24l0-8 0-64 0-8c0-13.3-10.7-24-24-24l-8 0-16 0-8 0c-13.3 0-24 10.7-24 24z',
      'M112 192c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-192zm48 24l0 8 0 64 0 8c0 13.3 10.7 24 24 24l8 0 16 0 8 0c13.3 0 24-10.7 24-24l0-8 0-64 0-8c0-13.3-10.7-24-24-24l-8 0-16 0-8 0c-13.3 0-24 10.7-24 24zm136-24c-13.3 0-24 10.7-24 24l0 8 0 64 0 8c0 13.3 10.7 24 24 24l8 0 16 0 8 0c13.3 0 24-10.7 24-24l0-8 0-64 0-8c0-13.3-10.7-24-24-24l-8 0-16 0-8 0zM208 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faSubwayTunnel = faTrainSubwayTunnel;
const faSquareExclamation = {
  prefix: 'fad',
  iconName: 'square-exclamation',
  icon: [
    448,
    512,
    ['exclamation-square'],
    'f321',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM256 352a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM200 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faExclamationSquare = faSquareExclamation;
const faSemicolon = {
  prefix: 'fad',
  iconName: 'semicolon',
  icon: [
    192,
    512,
    [],
    '3b',
    [
      'M9.5 472c0 21.5 17.5 40 40.1 40c14 0 26.9-7.3 34.2-19.2L150.8 383c6-9.8 9.2-21.2 9.2-32.7c0-34.2-27.7-62.3-61.9-62.3c-29.2 0-54.4 20.4-60.6 49L10.4 463.6c-.6 2.9-.9 5.7-.9 8.5z',
      'M32 128a64 64 0 1 1 128 0A64 64 0 1 1 32 128z',
    ],
  ],
};
const faBookmark = {
  prefix: 'fad',
  iconName: 'bookmark',
  icon: [
    384,
    512,
    [128278, 61591],
    'f02e',
    [
      'M96 0l0 322.1c0 12.8 14.2 20.4 24.9 13.3L192 288l71.1 47.4c10.6 7.1 24.9-.5 24.9-13.3L288 0 96 0z',
      'M0 487.7L0 48C0 21.5 21.5 0 48 0L96 0l0 322.1c0 12.8 14.2 20.4 24.9 13.3L192 288l71.1 47.4c10.6 7.1 24.9-.5 24.9-13.3L288 0l48 0c26.5 0 48 21.5 48 48l0 439.7c0 13.4-10.9 24.3-24.3 24.3c-5 0-9.9-1.5-14-4.4L192 400 38.3 507.6c-4.1 2.9-9 4.4-14 4.4C10.9 512 0 501.1 0 487.7z',
    ],
  ],
};
const faFanTable = {
  prefix: 'fad',
  iconName: 'fan-table',
  icon: [
    448,
    512,
    [],
    'e004',
    [
      'M16 208c0 104 76.3 190.2 176 205.6l0 34.4 32 0 32 0 0-34.4C355.7 398.2 432 312 432 208C432 93.1 338.9 0 224 0S16 93.1 16 208zm99.4-33.8C97.2 129.1 119 77.9 164.1 59.7c2-.8 4-1.2 6-1.2c6.3 0 12.3 3.8 14.8 10c13.1 32.5 26.3 65 39.4 97.5c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4c-1.2 8.8-9.3 14.8-18.1 13.6c-34.7-4.9-69.4-9.8-104.2-14.6c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2c-7-5.4-8.2-15.5-2.8-22.5c21.6-27.6 43.2-55.3 64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5z',
      'M184.9 68.5L224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4c-1.2 8.8-9.3 14.8-18.1 13.6L260.2 229.2c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2c-7-5.4-8.2-15.5-2.8-22.5l64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7c8.2-3.3 17.5 .6 20.8 8.8zM240 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 448l128 0 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0L96 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faAlignJustify = {
  prefix: 'fad',
  iconName: 'align-justify',
  icon: [
    448,
    512,
    [],
    'f039',
    [
      'M0 64C0 81.7 14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64zM0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32z',
      'M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224z',
    ],
  ],
};
const faBatteryLow = {
  prefix: 'fad',
  iconName: 'battery-low',
  icon: [
    576,
    512,
    ['battery-1'],
    'e0b1',
    [
      'M0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176zm64 0l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160c-8.8 0-16 7.2-16 16z',
      'M96 192h64v128H96V192z',
    ],
  ],
};
const faBattery1 = faBatteryLow;
const faCreditCardFront = {
  prefix: 'fad',
  iconName: 'credit-card-front',
  icon: [
    576,
    512,
    [],
    'f38a',
    [
      'M96 304c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z',
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0zM96 368c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zM408 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0z',
    ],
  ],
};
const faBrainArrowCurvedRight = {
  prefix: 'fad',
  iconName: 'brain-arrow-curved-right',
  icon: [
    640,
    512,
    ['mind-share'],
    'f677',
    [
      'M0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56l0-400c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304zM272 56l0 400c0 30.9 25.1 56 56 56c3.2 0 6.4-.3 9.5-.8C321.3 491 304 459.3 304 416c0-79.5 64.5-144 144-144l32 0 0-16c0-4.9 .8-9.8 2.2-14.3c-4.9-3.9-10.2-7.3-16-10C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56z',
      'M521.9 241.2c6-2.5 12.9-1.1 17.4 3.5l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-48-48 0c-35.3 0-64 28.7-64 64l0 35.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.7-2.2c-10.5-8.2-45-39.5-45-93.8c0-61.9 50.1-112 112-112l64 0 0-48c0-6.5 3.9-12.3 9.9-14.8z',
    ],
  ],
};
const faMindShare = faBrainArrowCurvedRight;
const faUmbrellaBeach = {
  prefix: 'fad',
  iconName: 'umbrella-beach',
  icon: [
    576,
    512,
    [127958],
    'f5ca',
    [
      'M214 448l68.1 0 75.1-206.3c-20-7.3-40.1-14.6-60.1-21.9L214 448z',
      'M434 269.7L223.5 193l3.3-9.1c18.1-49.8 45.6-95.6 80.9-135.1l4-4.5C335 18.3 371.8 8.9 404.8 20.6c.9 .3 1.9 .7 2.8 1.1c31.9 12.6 53.3 43 54.4 77.4l.2 6c1.7 52.9-6.8 105.7-24.9 155.5l-3.3 9.1zM287.8 23.1l-4 4.5c-38 42.5-67.6 91.9-87.1 145.5l-3.3 9.1-71-25.8c-18.1-6.6-26.4-27.7-15.3-43.4C153.7 47.1 228.8 7.3 308.4 4.9C300.9 10 294 16.1 287.8 23.1zM494 98.1c-.3-8.5-1.4-16.8-3.4-24.8c56.9 53 87.3 130 80.8 208.5c-1.6 19.2-21.5 30-39.6 23.4l-67.7-24.6 3.3-9.1c19.5-53.6 28.6-110.4 26.8-167.4l-.2-6zM32 448l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faHelmetUn = {
  prefix: 'fad',
  iconName: 'helmet-un',
  icon: [
    512,
    512,
    [],
    'e503',
    [
      'M215.7 384l2.7 0c3.1-5.3 6.2-10.6 9.3-15.9L242.3 343 320 416.9 320 288l48 0 0 174.5 1.6 1.5 70.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-6.2 0-12.1-2.4-16.5-6.6L215.7 384z',
      'M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240l0 56.3C0 344.8 39.2 384 87.7 384L200 384l18.4 0 9.3-15.9L274.4 288 448 288l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-.5 0zM285.3 103.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faLocationSmile = {
  prefix: 'fad',
  iconName: 'location-smile',
  icon: [
    384,
    512,
    ['map-marker-smile'],
    'f60d',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm92 64c0-6.5 3.1-12.8 8.9-16.7c9.2-6.1 21.6-3.6 27.7 5.5c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c6.1-9.2 18.5-11.7 27.7-5.5c2.9 1.9 5.1 4.5 6.6 7.3c.8 1.4 1.3 3 1.7 4.5c.2 .8 .3 1.6 .4 2.4c.1 .6 .1 1.2 .1 1.1c0 .4 0 .9 0 1.4c0 .9 0 1.2-.1 1.4c0 .4-.1 .9-.2 1.4c-.1 .9-.3 1.9-.6 2.8c-.6 1.9-1.4 3.7-2.5 5.4C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9c-2.3-3.4-3.4-7.3-3.4-11.1zm4-96c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.2l0 .4 0 .4c0 .3 0 .8 0 1.3c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm128 0c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.2l0 .4 0 .4c0 .3 0 .8 0 1.3c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32z',
      'M160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128.6 244.9c-6.1-9.2-18.5-11.7-27.7-5.5s-11.7 18.5-5.5 27.7C106.9 284.4 140.9 316 192 316s85.1-31.6 96.6-48.9c6.1-9.2 3.6-21.6-5.5-27.7s-21.6-3.6-27.7 5.5c-6.2 9.4-29.1 31.1-63.4 31.1s-57.1-21.7-63.4-31.1z',
    ],
  ],
};
const faMapMarkerSmile = faLocationSmile;
const faArrowLeftToLine = {
  prefix: 'fad',
  iconName: 'arrow-left-to-line',
  icon: [
    448,
    512,
    [8676, 'arrow-to-left'],
    'f33e',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z',
    ],
  ],
};
const faArrowToLeft = faArrowLeftToLine;
const faBullseye = {
  prefix: 'fad',
  iconName: 'bullseye',
  icon: [
    512,
    512,
    [],
    'f140',
    [
      'M112 256a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm224 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
      'M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faSushi = {
  prefix: 'fad',
  iconName: 'sushi',
  icon: [
    576,
    512,
    [127843, 'nigiri'],
    'e48a',
    [
      'M32 369l0 15c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c35.3 0 64-28.7 64-64l0-14.3c-8.3 .7-16.9-.3-25.5-3.1L313 298.4c-20-6.7-41.7-6.5-61.7 .4l-193 66.9c-8.9 3.1-17.8 4.1-26.4 3.4z',
      'M405.9 295.5L506.3 125.6c24.8 26.7 42.1 60.7 48.5 98.8l12.5 75.2c4 23.8-18.8 43.2-41.7 35.6L405.9 295.5zm76.2-191.9L374.8 285.2 323.1 268c-14.6-4.9-29.9-7-45.2-6.4L393.5 66.1c32.9 4.8 63.2 18 88.7 37.5zM246.6 64l110.9 0L235.6 270.4 96.1 318.7 246.6 64zm-37.2 0L49.4 334.8C27 341.5 5 322.3 8.9 298.9l12.4-74.4C36.6 132.2 116.1 64.6 209.5 64z',
    ],
  ],
};
const faNigiri = faSushi;
const faMessageCaptions = {
  prefix: 'fad',
  iconName: 'message-captions',
  icon: [
    512,
    512,
    ['comment-alt-captions'],
    'e1de',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM96 216c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm0 80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm128 0c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm96-80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
      'M96 216c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm224 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM96 296c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faCommentAltCaptions = faMessageCaptions;
const faTrashList = {
  prefix: 'fad',
  iconName: 'trash-list',
  icon: [
    640,
    512,
    [],
    'e2b1',
    [
      'M32 96L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2l213.4 0c25.4 0 46.5-19.8 47.9-45.2L384 96 32 96z',
      'M147.8 0c-12.1 0-23.2 6.8-28.6 17.7L112 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0-7.2-14.3C291.4 6.8 280.3 0 268.2 0L147.8 0zM448 160c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm32 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
    ],
  ],
};
const faBacon = {
  prefix: 'fad',
  iconName: 'bacon',
  icon: [
    576,
    512,
    [129363],
    'f7e5',
    [
      'M0 384c0 8.4 3.3 16.6 9.4 22.6l28.5 28.5c11.6-5.8 23.3-11.6 34.9-17.5c122.1-61.1 168.8-129 211.7-191.4c.8-1.1 1.5-2.2 2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9c31.4-27.7 71.6-50.8 129.6-67.4c8.8-2.6 17.6-5.3 26.5-7.9c-15.8-15.8-31.6-31.6-47.3-47.3C462.4 1.2 450.4-2 439.2 1.2C379.1 18.4 336.8 42.5 303.3 72c-32.9 29-55.9 62.1-77.7 93.9l-2.3 3.4C180.9 231 136.1 296.2 17.7 355.4C8.5 360 2.1 368.7 .4 378.9c-.3 1.7-.4 3.4-.4 5.1zm61.8 75l43.6 43.6c6.1 6.1 14.3 9.4 22.6 9.4c4.9 0 9.8-1.1 14.3-3.4C275.5 442 327.8 365.9 372.1 301.4l2.2-3.2c22.2-32.2 41.1-59.1 67.3-82.1c25.6-22.5 59.2-42.4 111.1-57.2c10.9-3.1 19.3-11.8 22.2-22.7s-.3-22.6-8.3-30.7l-23-23C529.2 86.7 515 91 500.6 95.3c-27.2 7.8-49.6 16.9-68.8 27.1c-19.2 10.2-35 21.5-48.8 33.6c-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3c-43.9 63.9-94.3 137.2-223.8 202L61.8 459z',
      'M518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6c0 0 0 0 0 0l.2-.1 43.1-12.9L518 56.7z',
    ],
  ],
};
const faOption = {
  prefix: 'fad',
  iconName: 'option',
  icon: [
    640,
    512,
    [],
    'e318',
    [
      'M416 96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32z',
      'M423 436c6.1 7.6 15.3 12 25 12l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144.6 0L217 76c-6.1-7.6-15.3-12-25-12L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l144.6 0L423 436z',
    ],
  ],
};
const faRaccoon = {
  prefix: 'fad',
  iconName: 'raccoon',
  icon: [
    512,
    512,
    [],
    'e613',
    [
      'M0 128l0 32 128 0 0-32L0 128zm0 96l0 32 112 0c5-6.7 10.4-13.1 16-19.2l0-12.8L0 224zm0 96l0 80c0 61.9 50.1 112 112 112l128 0 80 0 0-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c44.2 0 80 35.8 80 80l0 16 24 0 40 0 64 0 0-16.4c-.2-26.3-21.6-47.6-48-47.6l-16 0c0-24 0-48 0-72l-6.4 4.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l38.1-28.5c12.3-9.2 19.5-23.7 19.5-39.1c0-14.9-6.8-29-18.5-38.3c-6.6 2.2-12.9 5.3-18.7 9.2l-18.8 12.6c-16.6 11-36 16.9-55.9 16.9s-39.4-5.9-55.9-16.9l-18.8-12.6c-6.6-4.4-13.7-7.7-21.3-10l-35.8-10.7c-6.8-2-13.2-4.9-19.1-8.4C131.2 266.9 96 329.4 96 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-28.1 4.8-55 13.7-80L0 320zM192 43.5c0 4.7 .8 9.3 2.2 13.8l13.8 41.5L194 116.2c28.8-10 57.6-20 86.4-30.1c21.7-7.5 44 1.4 55.6 18.6c11.5-17.3 33.9-26.2 55.6-18.6c28.8 10 57.6 20 86.5 30.1L463.9 98.8l13.8-41.5c1.5-4.4 2.2-9.1 2.2-13.8C480 19.5 460.5 0 436.5 0l-1.3 0c-3.3 0-6.5 .4-9.7 1.1l-44.1 9.8C367.5 3.8 352 0 336 0s-31.5 3.8-45.3 10.9L246.6 1.1c-3.2-.7-6.5-1.1-9.7-1.1l-1.3 0C211.5 0 192 19.5 192 43.5zm18.3 268.2c4.5-7.6 14.4-10 22-5.5l80 48c7.6 4.5 10 14.4 5.5 21.9s-14.4 10-22 5.5l-80-48c-7.6-4.5-10-14.4-5.5-22zM224 43.5c0-6.4 5.2-11.5 11.5-11.5l1.3 0c.9 0 1.9 .1 2.8 .3l19.1 4.2-.3 .4L232 69.4l-7.4-22.2c-.4-1.2-.6-2.4-.6-3.6zm16.4 171.7c2.9 .9 5.8 1.7 8.7 2.6c10.6 3.2 20.6 7.9 29.8 14l18.8 12.6c11.1 7.4 24 11.4 37.3 11.6c-12.8-.5-23.1-11-23.1-24c0-13.3 10.7-24 24-24s24 10.7 24 24c0 13-10.3 23.5-23.1 24c13.3-.2 26.2-4.2 37.3-11.6L393 231.9c9.2-6.1 19.2-10.9 29.8-14l8.7-2.6c-26.1-13.9-52.2-27.8-78.2-41.7c-7.1-3.8-13-9.2-17.3-15.7c-4.3 6.5-10.2 11.9-17.3 15.7c-26.1 13.9-52.2 27.8-78.2 41.7zM413.3 36.5l19.1-4.2c.9-.2 1.8-.3 2.8-.3l1.3 0c6.4 0 11.5 5.2 11.5 11.5c0 1.2-.2 2.5-.6 3.6L440 69.4 413.6 37l-.3-.4zm66.3 258.6c0 .4-.1 .9-.1 1.3l.5-.4-.3-.9z',
      'M64 32c35.3 0 64 28.7 64 64l0 32L0 128 0 96C0 60.7 28.7 32 64 32zm64 192L0 224l0-64 128 0 0 64zm-16 32c-14.5 19.3-26.1 40.8-34.3 64L0 320l0-64 112 0zM391.6 86.1L478 116.2l6.3 7.7c7.6 9.3 11.7 21 11.7 33c0 23.1-15.2 43.5-37.3 50.2l-27.1 8.1-78.2-41.7c-7.1-3.8-13-9.2-17.3-15.7c-4.3 6.5-10.2 11.9-17.3 15.7l-78.2 41.7-27.1-8.1c-22.2-6.6-37.3-27-37.3-50.2c0-12 4.1-23.7 11.7-33l6.3-7.7 86.4-30.1c21.7-7.5 44 1.4 55.6 18.6c11.5-17.3 33.9-26.2 55.6-18.6zM312 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8-104a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faHandPointDown = {
  prefix: 'fad',
  iconName: 'hand-point-down',
  icon: [
    384,
    512,
    [],
    'f0a7',
    [
      'M0 149l0 27c0 35.3 28.7 64 64 64l88 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c39.8 0 72 32.2 72 72l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6l0-8.6C384 71.6 312.4 0 224 0L162.3 0C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149zM32 272l0 208c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208-64 0z',
      'M352 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32zm-128 0l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-96 32l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32z',
    ],
  ],
};
const faArrowUpFromBracket = {
  prefix: 'fad',
  iconName: 'arrow-up-from-bracket',
  icon: [
    448,
    512,
    [],
    'e09a',
    [
      'M0 352l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M201.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 109.3 256 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z',
    ],
  ],
};
const faHeadSideGear = {
  prefix: 'fad',
  iconName: 'head-side-gear',
  icon: [
    512,
    512,
    [],
    'e611',
    [
      'M0 224.2c0 49.9 16.6 98.2 46.9 137.3c10.2 13.2 17.1 29 17.1 45.8L64 480c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-32 64 0c35.3 0 64-28.7 64-64l0-64 20.2 0c24.2 0 43.8-19.6 43.8-43.8c0-10-3.4-19.6-9.6-27.4l-42-52.6c-8.3-10.3-12.8-23-15.1-36C429.2 69.3 343.2 0 248 0L224 0C100.2 0 0 100.6 0 224.2zM104.5 178c2.1-5.5 4.6-10.8 7.4-15.9l2.3-3.9c3.1-5.1 6.5-10 10.2-14.6c4.6-5.7 12.7-6.7 19-3l2.9 1.7c9.2 5.3 20.4 4 29.6-1.3s16.1-14.5 16.1-25.1l0-3.4c0-7.3 4.9-13.8 12.1-14.9c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.2 1.1 12.1 7.6 12.1 14.9l0 3.4c0 10.6 6.9 19.8 16.1 25.1s20.4 6.6 29.6 1.3l2.9-1.7c6.3-3.6 14.4-2.6 19 3c3.7 4.6 7.1 9.5 10.2 14.5l2.3 4c2.8 5.1 5.3 10.4 7.4 15.9c2.6 6.8-.5 14.3-6.8 18l-3 1.7c-9.2 5.3-13.7 15.8-13.7 26.4s4.5 21.1 13.7 26.4l3 1.7c4.8 2.8 7.8 7.8 7.8 13c0 1.7-.3 3.3-.9 5c-2.1 5.5-4.6 10.7-7.4 15.8l-2.4 4.2c-3 5.1-6.4 9.9-10.1 14.5c-4.6 5.7-12.7 6.7-19 3l-2.9-1.7c-9.2-5.3-20.4-4-29.6 1.3s-16.1 14.5-16.1 25.1l0 3.4c0 7.3-4.9 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.2-1.1-12.1-7.6-12.1-14.9l0-3.4c0-10.6-6.9-19.8-16.1-25.1s-20.4-6.6-29.6-1.3l-2.9 1.7c-6.3 3.6-14.4 2.6-19-3c-3.7-4.6-7.1-9.4-10.1-14.5l-2.4-4.1c-2.8-5.1-5.3-10.4-7.4-15.8c-2.6-6.8 .5-14.3 6.8-18l3-1.7c9.2-5.3 13.7-15.8 13.7-26.4s-4.5-21.1-13.7-26.4l-2.9-1.7c-6.3-3.6-9.5-11.1-6.8-18z',
      'M343.5 178c2.6 6.8-.5 14.3-6.8 18l-3 1.7c-9.2 5.3-13.7 15.8-13.7 26.4s4.5 21.1 13.7 26.4l3 1.7c6.3 3.6 9.5 11.1 6.8 18c-2.1 5.5-4.6 10.7-7.4 15.8l-2.4 4.2c-3 5.1-6.4 9.9-10.1 14.5c-4.6 5.7-12.7 6.7-19 3l-2.9-1.7c-9.2-5.3-20.4-4-29.6 1.3s-16.1 14.5-16.1 25.1l0 3.4c0 7.3-4.9 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.2-1.1-12.1-7.6-12.1-14.9l0-3.4c0-10.6-6.9-19.8-16.1-25.1s-20.4-6.6-29.6-1.3l-2.9 1.7c-6.3 3.6-14.4 2.6-19-3c-3.7-4.6-7.1-9.4-10.1-14.5l-2.4-4.1c-2.8-5.1-5.3-10.4-7.4-15.8c-2.6-6.8 .5-14.3 6.8-18l3-1.7c9.2-5.3 13.7-15.8 13.7-26.4s-4.5-21.1-13.7-26.4l-2.9-1.7c-6.3-3.6-9.5-11.1-6.8-18c2.1-5.5 4.6-10.8 7.4-15.9l2.3-3.9c3.1-5.1 6.5-10 10.2-14.6c4.6-5.7 12.7-6.7 19-3l2.9 1.7c9.2 5.3 20.4 4 29.6-1.3s16.1-14.5 16.1-25.1l0-3.4c0-7.3 4.9-13.8 12.1-14.9c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.2 1.1 12.1 7.6 12.1 14.9l0 3.4c0 10.6 6.9 19.8 16.1 25.1s20.4 6.6 29.6 1.3l2.9-1.7c6.3-3.6 14.4-2.6 19 3c3.7 4.6 7.1 9.5 10.2 14.5l2.3 4c2.8 5.1 5.3 10.4 7.4 15.9zM224 264a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
    ],
  ],
};
const faTrashPlus = {
  prefix: 'fad',
  iconName: 'trash-plus',
  icon: [
    448,
    512,
    [],
    'e2b2',
    [
      'M32 96L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2l245.4 0c25.4 0 46.5-19.8 47.9-45.2L416 96 32 96zm80 192c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM200 376l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
    ],
  ],
};
const faFileCad = {
  prefix: 'fad',
  iconName: 'file-cad',
  icon: [
    512,
    512,
    [],
    'e672',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM200 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1-17.9-40-40-40l-16 0zm232 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm16 32l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-16 0 0-96zm-160 8l0 56 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 0-56c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm32 40l0-40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 40-32 0z',
    ],
  ],
};
const faObjectsAlignTop = {
  prefix: 'fad',
  iconName: 'objects-align-top',
  icon: [
    512,
    512,
    [],
    'e3c0',
    [
      'M64 176l0 288c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm224 0l0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z',
      'M0 24C0 10.7 10.7 0 24 0H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24z',
    ],
  ],
};
const faFolder = {
  prefix: 'fad',
  iconName: 'folder',
  icon: [
    512,
    512,
    [128193, 128447, 61716, 'folder-blank'],
    'f07b',
    [
      'M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z',
      '',
    ],
  ],
};
const faFolderBlank = faFolder;
const faFaceAnxiousSweat = {
  prefix: 'fad',
  iconName: 'face-anxious-sweat',
  icon: [
    576,
    512,
    [],
    'e36a',
    [
      'M32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256zm80.2-45.4c-1.5-8.7 4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2zM239.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM208 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM399.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM348.7 148.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c7.8 1.3 13.4 8.1 13.4 15.8c0 .9-.1 1.8-.2 2.6c-1.5 8.7-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z',
      'M227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM239.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM348.7 148.7c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM48 416c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369c0 26-21.5 47-48 47z',
    ],
  ],
};
const faCreditCardBlank = {
  prefix: 'fad',
  iconName: 'credit-card-blank',
  icon: [
    576,
    512,
    [],
    'f389',
    [
      'M96 368c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faFileWaveform = {
  prefix: 'fad',
  iconName: 'file-waveform',
  icon: [
    448,
    512,
    ['file-medical-alt'],
    'f478',
    [
      'M64 64C64 28.7 92.7 0 128 0L288 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-128 65.2 0 41.4 82.7c4.2 8.5 13 13.6 22.5 13.2s17.8-6.3 21.3-15.1l44.2-110.4 8.1 16.2c4.1 8.1 12.4 13.3 21.5 13.3l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41.2 0-25.4-50.7c-4.2-8.5-13-13.6-22.5-13.2s-17.8 6.3-21.3 15.1L189.6 333.5l-24.1-48.2c-4.1-8.1-12.4-13.3-21.5-13.3l-80 0L64 64z',
      'M448 160L288 0l0 128c0 17.7 14.3 32 32 32l128 0zM277.5 221.3c-4.2-8.5-13-13.6-22.5-13.2s-17.8 6.3-21.3 15.1L189.6 333.5l-24.1-48.2c-4.1-8.1-12.4-13.3-21.5-13.3L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l105.2 0 41.4 82.7c4.2 8.5 13 13.6 22.5 13.2s17.8-6.3 21.3-15.1l44.2-110.4 8.1 16.2c4.1 8.1 12.4 13.3 21.5 13.3l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41.2 0-25.4-50.7z',
    ],
  ],
};
const faFileMedicalAlt = faFileWaveform;
const faMicrochipAi = {
  prefix: 'fad',
  iconName: 'microchip-ai',
  icon: [
    512,
    512,
    [],
    'e1ec',
    [
      'M0 152c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM0 256c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM0 360c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM128 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM232 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM336 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM448 128l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0zm0 104l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0zm0 104l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0z',
      'M128 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L128 64zm94.7 121.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304l-63.1 0-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9L190.5 272l35.1 0L208 231.9zM352 192l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faMug = {
  prefix: 'fad',
  iconName: 'mug',
  icon: [
    576,
    512,
    [],
    'f874',
    [
      'M384 64c17.7 0 32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0 64 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0z',
      'M32 96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V352c0 53-43 96-96 96H128c-53 0-96-43-96-96V96z',
    ],
  ],
};
const faPlaneUpSlash = {
  prefix: 'fad',
  iconName: 'plane-up-slash',
  icon: [
    640,
    512,
    [],
    'e22e',
    [
      'M64 305.1l0 56.7c0 10.9 10.7 18.6 21.1 15.2L256 320l0 80-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L320 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c7.8 0 14-6.3 14-14l0-42.7c0-2.8-.7-5.6-2.1-8L161.3 223.1 78.2 278.5C69.3 284.4 64 294.4 64 305.1zM245.4 167.1c79 61.9 158 123.8 237 185.8L554.9 377c10.4 3.5 21.1-4.3 21.1-15.2l0-56.7c0-10.7-5.3-20.7-14.2-26.6L384 160l0-66.3C384 59.5 356 0 320 0c-35 0-64 59.5-64 93.7l0 66.3-10.6 7.1z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faRadiation = {
  prefix: 'fad',
  iconName: 'radiation',
  icon: [
    512,
    512,
    [],
    'f7b9',
    [
      'M208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M176 256c0-29.6 16.1-55.5 40-69.3L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l144 0zm40 69.3L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L296 325.3c-11.8 6.8-25.4 10.7-40 10.7s-28.2-3.9-40-10.7zM336 256l144 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L296 186.7c23.9 13.8 40 39.7 40 69.3z',
    ],
  ],
};
const faPenCircle = {
  prefix: 'fad',
  iconName: 'pen-circle',
  icon: [
    512,
    512,
    [],
    'e20e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128.5 364l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2zM279.8 161.1l21.4-21.4c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c7.8 7.8 11.7 18 11.7 28.3s-3.9 20.5-11.7 28.3l-21.4 21.4-71-71z',
      'M301.2 139.7l-21.4 21.4 71 71 21.4-21.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-44 44L151.9 289c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L328.1 254.7l-71-71z',
    ],
  ],
};
const faBagSeedling = {
  prefix: 'fad',
  iconName: 'bag-seedling',
  icon: [
    512,
    512,
    [],
    'e5f2',
    [
      'M32 247.2l0 17.7c0 36.6 4.5 73.1 13.4 108.7L64 448l384 0 18.6-74.5c8.9-35.5 13.4-72 13.4-108.7l0-17.7c0-36.6-4.5-73.1-13.4-108.7L448 64 64 64 45.4 138.5C36.5 174 32 210.5 32 247.2zM128 176c0-8.8 7.2-16 16-16l2 0c47.3 0 88.4 26 110 64.5C277.6 186 318.7 160 366 160l2 0c8.8 0 16 7.2 16 16c0 59.2-45.9 107.6-104 111.7l0 40.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40.3c-58.1-4.1-104-52.6-104-111.7z',
      'M38.6 38.6L64 64l384 0 25.4-25.4c4.2-4.2 6.6-10 6.6-16C480 10.1 469.9 0 457.4 0L54.6 0C42.1 0 32 10.1 32 22.6c0 6 2.4 11.8 6.6 16zm0 434.7c-4.2 4.2-6.6 10-6.6 16C32 501.9 42.1 512 54.6 512l402.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L448 448 64 448 38.6 473.4zM144 160c-8.8 0-16 7.2-16 16c0 59.2 45.9 107.6 104 111.7l0 40.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40.3c58.1-4.1 104-52.6 104-111.7c0-8.8-7.2-16-16-16l-2 0c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160l-2 0z',
    ],
  ],
};
const faChartSimple = {
  prefix: 'fad',
  iconName: 'chart-simple',
  icon: [
    448,
    512,
    [],
    'e473',
    [
      'M160 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-352z',
      'M368 96c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0zM48 224c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0z',
    ],
  ],
};
const faCrutches = {
  prefix: 'fad',
  iconName: 'crutches',
  icon: [
    640,
    512,
    [],
    'f7f8',
    [
      'M0 192c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l1.4-1.4L188.2 345.4c2.7 2.7 5.5 5.1 8.4 7.5l17-17 10.1-45.5L101.3 168 168 101.3l86.3 86.3c5-7.9 10.9-15.3 17.6-22l25.4-25.4L213.3 56l1.4-1.4c12.5-12.5 12.5-32.8 0-45.3C208.4 3.1 200.2 0 192 0s-16.4 3.1-22.6 9.4l-160 160C3.1 175.6 0 183.8 0 192zM367.2 412.4l90.2 90.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64.1-64.1c-8.6 4-17.6 7.1-26.9 9.2l-44.5 9.9zm58.2-403c-12.5 12.5-12.5 32.8 0 45.3c.5 .5 .9 .9 1.4 1.4L472 101.3c22.3 22.3 44.5 44.5 66.7 66.7L584 213.3l1.4 1.4c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-160-160C464.4 3.1 456.2 0 448 0s-16.4 3.1-22.6 9.4z',
      'M329.4 153.4L426.7 56 472 101.3 397.3 176 464 242.7 538.7 168 584 213.3l-97.3 97.3-.1 .1-.1 .1-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8L297.1 395.2c-5.9 1.3-11.4 4.3-15.7 8.6l-98.8 98.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1l34.8-34.8zM352 221.3l-12.2 12.2c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6L418.7 288 352 221.3z',
    ],
  ],
};
const faCircleParking = {
  prefix: 'fad',
  iconName: 'circle-parking',
  icon: [
    512,
    512,
    ['parking-circle'],
    'f615',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm448 0A192 192 0 1 1 64 256a192 192 0 1 1 384 0z',
      'M240 192l0 64 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0zm144 32c0 53-43 96-96 96l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96z',
    ],
  ],
};
const faParkingCircle = faCircleParking;
const faMarsStroke = {
  prefix: 'fad',
  iconName: 'mars-stroke',
  icon: [
    512,
    512,
    [9894],
    'f229',
    [
      'M128 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L376 0zm88 48s0 0 0 0s0 0 0 0s0 0 0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z',
    ],
  ],
};
const faLeafOak = {
  prefix: 'fad',
  iconName: 'leaf-oak',
  icon: [
    512,
    512,
    [],
    'f6f7',
    [
      'M50.9 261.9L66.5 293C75.4 310.7 80 330.3 80 350.2l0 47.8c66.6-66.6 133.3-133.3 199.9-199.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17C247.2 298.7 180.6 365.3 113.9 432l47.8 0c19.9 0 39.5 4.6 57.2 13.5l31.1 15.5c8.3 4.2 17.3 6.2 26.3 6.2c15.2 0 30.3-5.9 41.6-17.2l3.6-3.6c17.7-17.7 20.4-45.4 6.6-66.2c-3.1-4.7 .8-10.9 6.4-10.1l75.1 10.7c14.1 2 28.3-2.7 38.4-12.8c17.7-17.7 17.7-46.3 0-64l-22-22c-4.4-4.4-2.3-11.9 3.7-13.4l40.8-10.2c24.4-6.1 41.4-28 41.4-53.1c0-18.3-9.1-35.4-24.4-45.5l-14.3-9.5c-5.6-3.8-8.3-10.6-6.6-17.2l5-20.1c5.1-20.4-.9-42-15.8-56.9s-36.5-20.9-56.9-15.8l-20.1 5c-6.6 1.6-13.4-1-17.2-6.6l-9.5-14.3C342.1 9.1 325 0 306.7 0c-25.1 0-47 17.1-53.1 41.4L243.4 82.3c-1.5 6-9 8.1-13.4 3.7L208 64c-17.7-17.7-46.3-17.7-64 0c-10.1 10.1-14.8 24.3-12.8 38.4l10.7 75.1c.8 5.6-5.4 9.5-10.1 6.4C111 170 83.3 172.7 65.6 190.4l-3.6 3.6c-17.9 17.9-22.3 45.2-11 67.8z',
      'M7 505c-9.4-9.4-9.4-24.6 0-33.9L279.9 198.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0z',
    ],
  ],
};
const faSquareBolt = {
  prefix: 'fad',
  iconName: 'square-bolt',
  icon: [
    448,
    512,
    [],
    'e265',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112.9 261.3c-2.2-6.4-.2-13.5 5.1-17.8l160-128c2.9-2.3 6.5-3.5 10-3.5c3.6 0 7.1 1.2 10.1 3.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-2.9 2.3-6.5 3.5-10 3.5c-3.6 0-7.1-1.2-10.1-3.6c-5.8-4.7-7.6-12.9-4.3-19.6L198.1 272 128 272c-6.8 0-12.8-4.3-15.1-10.7z',
      'M302.3 135.2c3.4-6.7 1.6-14.9-4.3-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L145.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8z',
    ],
  ],
};
const faVial = {
  prefix: 'fad',
  iconName: 'vial',
  icon: [
    512,
    512,
    [129514],
    'f492',
    [
      'M0 410.5L0 416c0 53 43 96 96 96l5.5 0c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-32-32-96-96-32-32C336.4 3.1 328.2 0 320 0s-16.4 3.1-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5zm64 0c0-8.5 3.4-16.6 9.4-22.6L205.3 256c48.9-48.9 97.8-97.8 146.7-146.7L402.7 160c-32 32-64 64-96 96C245.9 316.9 185 377.7 124.1 438.6c-6 6-14.1 9.4-22.6 9.4L96 448c-17.7 0-32-14.3-32-32l0-5.5z',
      'M306.7 256l-101.5 0L73.4 387.9c-6 6-9.4 14.1-9.4 22.6l0 5.5c0 17.7 14.3 32 32 32l5.5 0c8.5 0 16.6-3.4 22.6-9.4L306.7 256z',
    ],
  ],
};
const faGauge = {
  prefix: 'fad',
  iconName: 'gauge',
  icon: [
    512,
    512,
    ['dashboard', 'gauge-med', 'tachometer-alt-average'],
    'f624',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3L280 88z',
    ],
  ],
};
const faDashboard = faGauge;
const faGaugeMed = faGauge;
const faTachometerAltAverage = faGauge;
const faWandMagicSparkles = {
  prefix: 'fad',
  iconName: 'wand-magic-sparkles',
  icon: [
    576,
    512,
    ['magic-wand-sparkles'],
    'e2ca',
    [
      'M0 128c0 4.8 3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2C3 118.9 0 123.2 0 128zM192 64c0 3.2 2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7 197 56.8c-3 1.1-5 4-5 7.2zm124.7 60.7c13.2 13.2 26.4 26.4 39.6 39.6l105-105 23.3 23.3-105 105c13.2 13.2 26.4 26.4 39.6 39.6c36.9-36.9 73.8-73.8 110.7-110.7c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0C390.5 51 353.6 87.8 316.7 124.7zM352 384c0 4.8 3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8z',
      'M419.2 227.2L316.7 124.7 46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L419.2 227.2z',
    ],
  ],
};
const faMagicWandSparkles = faWandMagicSparkles;
const faLambda = {
  prefix: 'fad',
  iconName: 'lambda',
  icon: [
    448,
    512,
    [],
    'f66e',
    [
      'M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l108.2 0 16.4 32.7L18.8 434.9c-7.3 16.1-.1 35.1 16 42.3s35.1 .1 42.3-16L193.5 202.6l121 242c10.8 21.7 33 35.4 57.2 35.4l44.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-44.2 0L197.5 67.4C186.6 45.7 164.5 32 140.2 32L32 32z',
      '',
    ],
  ],
};
const faE = {
  prefix: 'fad',
  iconName: 'e',
  icon: [
    320,
    512,
    [101],
    '45',
    [
      'M64 32C28.7 32 0 60.7 0 96L0 256 0 416c0 35.3 28.7 64 64 64l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 416l0-128 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 224 64 96l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32z',
      '',
    ],
  ],
};
const faPizza = {
  prefix: 'fad',
  iconName: 'pizza',
  icon: [
    576,
    512,
    [127829],
    'f817',
    [
      'M48.1 251.2c0-1.8 .1-3.6 .2-5.4c.1-1.1 .1-2.2 .2-3.3c0-.8 .1-1.6 .2-2.3c.1-.8 .1-1.6 .2-2.4c1.5-17.6 5.3-34.9 11.3-51.7c.3-.9 .6-1.8 1-2.7c.1-.3 .2-.7 .4-1c.6-1.5 1.1-3 1.8-4.6c1.3-3.1 2.6-6.2 4.1-9.5c.6-1.4 1.3-2.8 2-4.2c.7-1.4 1.4-2.8 2.1-4.1c3.3-6.3 6.9-12.4 10.7-18.3c.2-.2 .3-.5 .5-.7c1.8-2.7 3.7-5.4 5.7-8.1c2-2.7 4-5.4 6.3-8.1c2.2-2.7 4.5-5.4 6.9-8c1.2-1.3 2.4-2.6 3.6-3.9s2.5-2.6 3.8-3.8c2.5-2.5 5.1-5 7.8-7.4s5.3-4.7 8.2-7c2.6-2.1 5.3-4.2 8-6.2c8.5-6.3 17.5-11.8 26.7-16.7c3-1.6 6-3 9-4.5s6.1-2.7 9.4-4.1c1.2-.5 2.4-.9 3.5-1.4c.3-.1 .5-.2 .8-.3c1.4-.5 2.8-1 4.2-1.5c.2-.1 .4-.2 .6-.2c3.1-1.1 6.2-2.1 9.3-3l.6-.2c3-.9 6.1-1.7 9.2-2.5s6.1-1.4 9.2-2c3.6-.7 7.3-1.3 10.9-1.9c3.2-.5 6.4-.8 9.5-1.1l.4 0c3.3-.3 6.7-.5 10-.7c1.6-.1 3.2-.1 4.8-.2s3.2-.1 4.8-.1c3.6 0 7.1 .1 10.6 .3c3.5 .2 6.9 .4 10.3 .8c3.6 .3 7.1 .8 10.6 1.3c3.3 .5 6.6 1.1 9.8 1.7c3.6 .7 7.1 1.5 10.6 2.4c3.2 .8 6.4 1.7 9.6 2.7c1.8 .5 3.5 1.1 5.3 1.7c1.5 .5 2.9 1 4.4 1.5c3.3 1.2 6.5 2.4 9.6 3.8c3.1 1.3 6.2 2.7 9.3 4.2c3 1.4 6 3 8.9 4.6c2.9 1.6 5.7 3.2 8.5 4.9c3.1 1.9 6.1 3.8 9.1 5.9c2.7 1.8 5.3 3.7 7.9 5.6c2.6 2 5.1 4 7.6 6c2.6 2.1 5.1 4.3 7.5 6.5s4.9 4.5 7.2 6.9L278.6 233.4c-12.5 12.5-12.5 32.8 0 45.3L403.1 403.1c-2.4 2.4-4.8 4.6-7.2 6.9s-5 4.4-7.5 6.5c-2.5 2.1-5.1 4.1-7.6 6c-2.6 1.9-5.2 3.8-7.9 5.7c-.3 .2-.6 .4-.8 .6c-2.7 1.8-5.5 3.6-8.3 5.3c-2.8 1.7-5.6 3.3-8.5 4.9c-2.9 1.6-5.9 3.1-9 4.6c-3 1.4-6.1 2.8-9.2 4.2c-3.1 1.3-6.3 2.6-9.4 3.7c-3.1 1.1-6.2 2.2-9.3 3.2c-3.4 1.1-6.7 2-10.2 2.9c-3.2 .8-6.4 1.6-9.6 2.2c-3.6 .8-7.2 1.4-10.8 1.9c-3.4 .5-6.8 .9-10.1 1.3c-.5 .1-1 .1-1.5 .1c-1 .1-1.9 .2-2.9 .3c-.4 0-.8 .1-1.2 .1c-1.7 .1-3.4 .2-5 .3c-3.6 .2-7.2 .3-10.8 .3c-3.3 0-6.6-.1-9.9-.2c-3.3-.2-6.6-.4-9.8-.7c-3.3-.3-6.6-.7-10-1.2c-3.1-.4-6.2-.9-9.2-1.5c-.6-.1-1.1-.2-1.7-.3c-3.1-.6-6.2-1.3-9.2-2s-6.1-1.6-9.2-2.5c-3.3-1-6.6-2-9.9-3.2c-3.1-1.1-6.2-2.3-9.4-3.6c-3.1-1.3-6.2-2.6-9.4-4.1c-1.4-.7-2.8-1.3-4.2-2c-.4-.2-.8-.4-1.2-.6c-.5-.3-1-.5-1.5-.8c-.7-.4-1.5-.8-2.2-1.2c-2.9-1.6-5.8-3.2-8.6-4.8c-3.2-1.9-6.4-3.9-9.5-5.9c-2.8-1.9-5.5-3.8-8.2-5.7c-2.7-2-5.5-4.1-8.1-6.3c-2.7-2.2-5.4-4.5-8-6.9c-1.3-1.2-2.6-2.4-3.9-3.6s-2.6-2.5-3.9-3.8c-2.5-2.5-5-5.1-7.5-7.8c-1.1-1.2-2.2-2.5-3.3-3.7l-.4-.4c-.8-.9-1.5-1.8-2.2-2.7c-.4-.4-.7-.8-1-1.3c-2.1-2.6-4.2-5.3-6.2-8c-2.2-3-4.3-6.1-6.4-9.2c-1.8-2.8-3.6-5.6-5.3-8.5c-1.7-3-3.4-6-5-9c-1.6-3-3-6-4.5-9s-2.7-6.1-4.1-9.4c-.5-1.2-.9-2.3-1.4-3.5c-.1-.3-.2-.6-.3-.9c-.5-1.4-1-2.8-1.5-4.2c-5.9-16.6-9.6-33.8-11.1-51.2c-.1-.8-.1-1.6-.2-2.4c-.1-.7-.1-1.4-.2-2.3c-.1-1.1-.1-2.2-.2-3.3c-.2-3.4-.3-6.9-.3-10.3c0-1.6 0-3.3 .1-4.8zM128 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM366.6 233.4c37.3-37.3 74.6-74.6 112-112C509.4 157.7 528 204.7 528 256s-18.6 98.3-49.4 134.6c-37.3-37.3-74.6-74.6-112-112c-12.5-12.5-12.5-32.8 0-45.3zM416 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M403.1 403.1C365.4 440.7 313.4 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c57.4 0 109.4 23.3 147.1 60.9l11.3-11.3C426.9 85.1 427 64.7 413 53.8C369.7 20.1 315.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c59.2 0 113.7-20.1 157-53.8c13.9-10.9 13.8-31.3 1.3-43.8l-11.3-11.3zm75.5-12.5l9.9 9.9c13.1 13.1 34.7 12.5 44.9-3C560.3 357 576 308.3 576 256s-15.7-101-42.6-141.5c-10.2-15.4-31.8-16-44.9-3l-9.9 9.9C509.4 157.7 528 204.7 528 256s-18.6 98.3-49.4 134.6zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM128 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faBowlChopsticksNoodles = {
  prefix: 'fad',
  iconName: 'bowl-chopsticks-noodles',
  icon: [
    512,
    512,
    [],
    'e2ea',
    [
      'M0 109.3c0 9.8 8.8 17.3 18.5 15.8L64 118c0-11.3 0-22.7 0-34L13.1 93.6C5.5 95 0 101.6 0 109.3zm0 50.5c0 9 7.3 16.2 16.2 16.2L64 176c0-11.3 0-22.7 0-34l-48.3 1.5C7 143.8 0 151 0 159.7zM224 54l0 39L492.3 51.1c11.3-1.8 19.7-11.5 19.7-23C512 15 501.3 4.8 488.8 4.8c-1.4 0-2.9 .1-4.3 .4L224 54zm0 83l0 39 264.4 0c13 0 23.6-10.6 23.6-23.6c0-13.3-11-24-24.4-23.6L224 137z',
      'M192 40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 184-32 0 0-168c0-13.3-10.7-24-24-24S64 42.7 64 56l0 168-30.4 0C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5L192 224l0-184z',
    ],
  ],
};
const faH3 = {
  prefix: 'fad',
  iconName: 'h3',
  icon: [
    640,
    512,
    [],
    'f315',
    [
      'M0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M368 96c0-17.7 14.3-32 32-32l192 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-89.5 89.5C589 210.8 640 263.4 640 328c0 66.3-53.7 120-120 120l-64.6 0c-43 0-79.7-31.1-86.8-73.5l-.2-1.2c-2.9-17.4 8.9-33.9 26.3-36.8s33.9 8.9 36.8 26.3l.2 1.2c1.9 11.6 11.9 20.1 23.7 20.1l64.6 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-72 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L514.7 128 400 128c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faPenClip = {
  prefix: 'fad',
  iconName: 'pen-clip',
  icon: [
    512,
    512,
    ['pen-alt'],
    'f305',
    [
      'M288 94.1c5.7 5.7 11.3 11.3 17 17c32 32 64 64 96 96c5.3 5.3 10.7 10.7 16 16l1 1c24.9-24.9 49.8-49.8 74.7-74.7c12.5-12.5 18.7-28.9 18.7-45.3s-6.2-32.8-18.7-45.3L453.3 19.3C440.8 6.8 424.4 .6 408 .6s-32.8 6.2-45.3 18.7L288 94.1z',
      'M207 114.9c9.4-9.4 24.6-9.4 33.9 0L254.1 128 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L401 241l17-17-1-1-16-16-96-96-17-17L274.9 81c-28.1-28.1-73.7-28.1-101.8 0L71 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L207 114.9z',
    ],
  ],
};
const faPenAlt = faPenClip;
const faBridgeCircleExclamation = {
  prefix: 'fad',
  iconName: 'bridge-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e4ca',
    [
      'M32 64c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-40 0 0 64 72 0 0 72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-53-43-96-96-96l0-128 72 0 0-64L64 96C46.3 96 32 81.7 32 64zM152 96l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faBadgePercent = {
  prefix: 'fad',
  iconName: 'badge-percent',
  icon: [
    512,
    512,
    [],
    'f646',
    [
      'M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm224-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM175 303L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L209 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm177 17a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z',
    ],
  ],
};
const faRotateReverse = {
  prefix: 'fad',
  iconName: 'rotate-reverse',
  icon: [
    512,
    512,
    [],
    'e631',
    [
      'M44.5 330.6C55.3 361.3 73 390 97.4 414.4C141.1 458.1 198.4 480 255.8 480c56.9 0 113.8-21.5 157.4-64.6L454.8 457c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-119.6 0-.4 0-.4 0-7.6c0-13.3-10.7-24-24-24l-7.6 0c-.2 0-.5 0-.7 0l-119.6 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l41.1 41.1c-62.6 61.5-163.1 61.2-225.3-1c-17.5-17.5-30.1-38-37.8-59.8c-4.6-13.1-17-21.4-30.2-21.4c-3.5 0-7.1 .6-10.6 1.8c-16.7 5.9-25.4 24.2-19.5 40.8z',
      'M406.6 202.6c-7.7-21.8-20.2-42.3-37.8-59.8c-62.2-62.2-162.7-62.5-225.3-1L184.7 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8L48.3 224c0 0 0 0 0 0l-8.4 0c-13.3 0-24-10.7-24-24l0-128c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.3 96.6c87.6-86.5 228.7-86.2 315.8 1c24.4 24.4 42.1 53.1 52.9 83.7c5.9 16.7-2.9 34.9-19.5 40.8s-34.9-2.9-40.8-19.5z',
    ],
  ],
};
const faUser = {
  prefix: 'fad',
  iconName: 'user',
  icon: [
    448,
    512,
    [128100, 62144],
    'f007',
    [
      'M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z',
      'M0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z',
    ],
  ],
};
const faSensor = {
  prefix: 'fad',
  iconName: 'sensor',
  icon: [
    448,
    512,
    [],
    'e028',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144zm96 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144z',
      'M88 96c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24zm96 0c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faComma = {
  prefix: 'fad',
  iconName: 'comma',
  icon: [
    192,
    512,
    [],
    '2c',
    [
      'M160 350.4V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.1-60.1 50.1l-22.2 122c-.5 2.6-.7 5.2-.7 7.9v8.2C16 495.9 32.1 512 51.9 512c12.5 0 24.1-6.5 30.6-17.2L150.8 383c6-9.8 9.2-21.1 9.2-32.6z',
      '',
    ],
  ],
};
const faSchoolCircleCheck = {
  prefix: 'fad',
  iconName: 'school-circle-check',
  icon: [
    640,
    512,
    [],
    'e56b',
    [
      'M0 144L0 464c0 26.5 21.5 48 48 48l272 0-64 0 0-96c0-35.3 28.7-64 64-64l.7 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4C332.4 1.8 326.2 0 320 0s-12.4 1.8-17.8 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144zm80 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM304 144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faToiletPaperUnder = {
  prefix: 'fad',
  iconName: 'toilet-paper-under',
  icon: [
    512,
    512,
    ['toilet-paper-reverse'],
    'e2a0',
    [
      'M0 192C0 298 43 384 96 384l32 0 32 0 256 0c-52.4 0-94.9-83.9-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0L96 0C43 0 0 86 0 192zm80 16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M320 195.9c1 104.2 43.6 188.1 96 188.1l-256 0 0 80c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-272C512 86 469 0 416 0s-96 86-96 192c0 1.3 0 2.6 0 3.9zM448 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zM80 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faToiletPaperReverse = faToiletPaperUnder;
const faLightEmergency = {
  prefix: 'fad',
  iconName: 'light-emergency',
  icon: [
    448,
    512,
    [],
    'e41f',
    [
      'M64 192l0 160 320 0 0-160c0-88.4-71.6-160-160-160S64 103.6 64 192zm48 0c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
      'M32 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 352z',
    ],
  ],
};
const faArrowDownToArc = {
  prefix: 'fad',
  iconName: 'arrow-down-to-arc',
  icon: [
    512,
    512,
    [],
    'e4ae',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 106-86 192-192 192S64 362 64 256c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M390.6 185.4c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 242.7 224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 57.4-57.4c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faDumpster = {
  prefix: 'fad',
  iconName: 'dumpster',
  icon: [
    576,
    512,
    [],
    'f793',
    [
      'M0 139.1c0-2.1 .3-4.1 .9-6.1L26.8 48.9C29.9 38.9 39.2 32 49.7 32l90.8 0L114.9 160l-94 0C9.3 160 0 150.7 0 139.1zM147.5 160L173.1 32 272 32l0 128-124.5 0zM304 32l98.9 0 25.6 128L304 160l0-128zm131.5 0l90.8 0c10.5 0 19.8 6.9 22.9 16.9L575.1 133c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9l-94 0L435.5 32z',
      'M64 448L44 288l-12 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l4 0-4-32 512 0-4 32 4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-12 0L512 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l-320 0c0 17.7-14.3 32-32 32s-32-14.3-32-32z',
    ],
  ],
};
const faVanShuttle = {
  prefix: 'fad',
  iconName: 'van-shuttle',
  icon: [
    640,
    512,
    [128656, 'shuttle-van'],
    'f5b6',
    [
      'M80 400a80 80 0 1 0 160 0A80 80 0 1 0 80 400zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M64 104c0-4.4 3.6-8 8-8l88 0 0 96-96 0 0-88zm482 88l-162 0 0-96 81.1 0L546 192zm-226 0l-96 0 0-96 96 0 0 96zM72 32C32.2 32 0 64.2 0 104L0 336c0 26.5 21.5 48 48 48l1.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l98.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l1.1 0c26.5 0 48-21.5 48-48l0-108.3c0-15.1-5.3-29.7-15-41.2L514.1 54.8C501.9 40.3 484 32 465.1 32L352 32 192 32 72 32z',
    ],
  ],
};
const faShuttleVan = faVanShuttle;
const faBuildingUser = {
  prefix: 'fad',
  iconName: 'building-user',
  icon: [
    640,
    512,
    [],
    'e4da',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 223.8 0 95.9c-38.2 21.4-64 62.3-64 109.2c0 12.9 3.6 24.9 9.9 35.1L240 512l0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M496 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-50.9 32c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0z',
    ],
  ],
};
const faLightSwitch = {
  prefix: 'fad',
  iconName: 'light-switch',
  icon: [
    384,
    512,
    [],
    'e017',
    [
      'M96 240l0 32 192 0 0-32L96 240z',
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm96 96l0 192c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zM208 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faSquareCaretLeft = {
  prefix: 'fad',
  iconName: 'square-caret-left',
  icon: [
    448,
    512,
    ['caret-square-left'],
    'f191',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c4.5-4.2 10.4-6.4 16.3-6.4c3.2 0 6.5 .7 9.6 2c8.7 3.8 14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22c-3.1 1.3-6.3 2-9.6 2c-5.9 0-11.8-2.2-16.3-6.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z',
      'M135.7 238.4c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-208c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104z',
    ],
  ],
};
const faCaretSquareLeft = faSquareCaretLeft;
const faHighlighter = {
  prefix: 'fad',
  iconName: 'highlighter',
  icon: [
    576,
    512,
    [],
    'f591',
    [
      'M61.3 400c0 3.5 .6 7 1.7 10.4c1.5 4.5 4.1 8.7 7.6 12.2c16.9 16.9 33.8 33.8 50.7 50.7c3.6 3.6 7.8 6.1 12.2 7.6c3.4 1.2 6.9 1.7 10.4 1.7c8.2 0 16.4-3.1 22.6-9.4L224 416l71.7 0c15.3 0 29.6-7.2 38.6-19.5l26.3-35.8L183.3 183.3l-35.7 26.3c-12.3 9-19.5 23.4-19.5 38.6l0 71.7c-19.1 19.1-38.2 38.3-57.4 57.4c-6.2 6.2-9.4 14.4-9.4 22.6z',
      'M360.7 360.7L183.3 183.3 420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L360.7 360.7zM7 466.3l56-56c1.5 4.5 4.1 8.7 7.6 12.2l50.7 50.7c3.6 3.6 7.8 6.1 12.2 7.6l-24 24c-4.5 4.5-10.6 7-17 7L24 512c-13.3 0-24-10.7-24-24l0-4.7c0-6.4 2.5-12.5 7-17z',
    ],
  ],
};
const faWavePulse = {
  prefix: 'fad',
  iconName: 'wave-pulse',
  icon: [
    640,
    512,
    ['heart-rate'],
    'f5f8',
    [
      'M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4L608 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-108.2 0L444.6 398.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4L323.7 167.3 255.3 486.7c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l103.9 0c28.6 0 53.7 18.9 61.5 46.4L219.6 348 288.7 25.3C291.8 10.9 304.4 .4 319.1 0z',
      '',
    ],
  ],
};
const faHeartRate = faWavePulse;
const faKey = {
  prefix: 'fad',
  iconName: 'key',
  icon: [
    512,
    512,
    [128273],
    'f084',
    [
      'M0 408l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7c11.1-11.1 22.2-22.2 33.3-33.3c-38-38-76-76-113.9-113.9C114.6 283.5 60.8 337.2 7 391c-4.5 4.5-7 10.6-7 17z',
      'M168.3 229.7L282.3 343.7s0 0 0 0c16.9 5.4 35 8.3 53.7 8.3c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7c0 0 0 0 0 0zM336 136a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z',
    ],
  ],
};
const faArrowLeftToBracket = {
  prefix: 'fad',
  iconName: 'arrow-left-to-bracket',
  icon: [
    512,
    512,
    [],
    'e669',
    [
      'M0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128z',
      'M169.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-210.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z',
    ],
  ],
};
const faHatSanta = {
  prefix: 'fad',
  iconName: 'hat-santa',
  icon: [
    640,
    512,
    [],
    'f7a7',
    [
      'M0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L64 352c-35.3 0-64 28.7-64 64zM480 240c0 12.7 9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-7.7-6.7-18.7-7.6-27.3-2.8c-1.9 1.1-3.7 2.4-5.3 4c-8.9 8.9-9.4 23.2-1.2 32.6c-3.9 .3-7.5 1.5-10.7 3.4c-6.9 4.2-11.6 11.8-11.6 20.5z',
      'M64 352l85.7-214.2C175.2 73.9 237.1 32 305.9 32c49.5 0 96.5 21.8 128.5 59.6l74.3 87.8c-1.9 1.1-3.7 2.4-5.3 4c-8.9 8.9-9.4 23.2-1.2 32.6c-3.9 .3-7.5 1.5-10.7 3.4L402 192.6c-1.3-.4-2.7-.6-4-.6l-.8 0c-7.3 0-13.2 5.9-13.2 13.2c0 1.8 .4 3.7 1.1 5.4L448 352 64 352z',
    ],
  ],
};
const faTamale = {
  prefix: 'fad',
  iconName: 'tamale',
  icon: [
    320,
    512,
    [129748],
    'e451',
    [
      'M.4 69.3L28.9 240l57.7 0L72 72.7c-.4-4.4 2.9-8.3 7.3-8.7s8.3 2.9 8.7 7.3L102.6 240l49.4 0 0-176c0-4.4 3.6-8 8-8s8 3.6 8 8l0 176 49.4 0L232 71.3c.4-4.4 4.3-7.7 8.7-7.3s7.7 4.3 7.3 8.7L233.4 240l57.7 0L319.6 69.3c.3-1.8 .4-3.6 .4-5.3c0-13.8-9.5-24.1-20.8-31.6c-6.3-4.2-15.3-9.3-27.4-14.1C247.7 8.6 211.6 0 160 0S72.3 8.6 48.1 18.3c-12.1 4.8-21 9.9-27.4 14.1C8.1 40.8-2.3 52.8 .4 69.3zm0 373.5c-1.7 10.2 1.6 20.6 8.9 27.9c10.6 10.6 25.1 17.6 38.7 23.1C72.3 503.4 108.4 512 160 512s87.7-8.6 111.9-18.3c13.7-5.5 28.1-12.5 38.7-23c7.3-7.3 10.7-17.7 9-27.9L291.1 272l-57.7 0L248 439.3c.4 4.4-2.9 8.3-7.3 8.7s-8.3-2.9-8.7-7.3l-9.8-113.3c-1.1 2.1-2.6 3.9-4.6 5.4c-2.9 2.2-6.3 3.2-9.6 3.2c-4.9 0-9.7-2.2-12.8-6.4L168 293.3 168 448c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-154.7-27.2 36.3c-3.2 4.2-8 6.4-12.8 6.4c-3.3 0-6.7-1-9.6-3.2c-1-.8-1.9-1.6-2.6-2.5s-1.4-1.9-1.9-2.9L88 440.7c-.4 4.4-4.3 7.7-8.7 7.3s-7.7-4.3-7.3-8.7L86.6 272l-57.7 0L.4 442.7zM99.3 310.2c9.6-12.7 19.1-25.5 28.7-38.2l-25.4 0-3.3 38.2zM192 272c9.6 12.7 19.1 25.5 28.8 38.4c-1.2-12.9-2.3-25.6-3.4-38.4L192 272z',
      'M24 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l104 0L99.2 310.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2L160 282.7l35.2 46.9c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4L192 272l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-136 0L24 240z',
    ],
  ],
};
const faBoxCheck = {
  prefix: 'fad',
  iconName: 'box-check',
  icon: [
    448,
    512,
    [],
    'f467',
    [
      'M0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160zM240 32l0 128 208 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32z',
      'M448 160l-208 0 0-128-32 0 0 128L0 160 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256zM337 265L209 393c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 231c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
    ],
  ],
};
const faBullhorn = {
  prefix: 'fad',
  iconName: 'bullhorn',
  icon: [
    512,
    512,
    [128226, 128363],
    'f0a1',
    [
      'M192 128l0 32 0 32 0 96 0 32 0 32 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6 0-120.7L480 32c0-12.9-7.8-24.6-19.8-29.6C456.3 .8 452.1 0 448 0c-8.3 0-16.5 3.3-22.6 9.4L381.7 53c-48 48-113.1 75-181 75c-2.9 0-5.8 0-8.7 0z',
      'M0 192c0-35.3 28.7-64 64-64l128 0 0 192 0 32 0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128c-35.3 0-64-28.7-64-64l0-96zm512 48c0 27.9-13.4 51.6-32 60.4l0-120.7c18.6 8.8 32 32.5 32 60.4z',
    ],
  ],
};
const faSteak = {
  prefix: 'fad',
  iconName: 'steak',
  icon: [
    576,
    512,
    [129385],
    'f824',
    [
      'M0 360c0 84.3 73.4 120.1 110 132.7c43.5 15 93.3 19.3 130 19.3c81.7 0 162.1-30.8 222.6-75.8C520.9 392.8 576 323.9 576 240c0-60.4-23.6-117.6-57.5-160C485.7 39 433 0 368 0c-38.3 0-72.3 12.4-99.2 37.4c-23.5 21.9-36.3 48.9-44.1 66.5c-4.4 10.1-8 18.9-11.2 26.6c-10.4 25.1-16.2 39.1-30 52.9c-23.1 23.1-50.4 36.9-77.7 50.7c-21.8 11-43.6 22.1-63.3 37.8C17.8 291.7 0 321.4 0 360zm64 9.5c0-29.8 19.8-38.3 51.7-51.9c31.1-13.3 73.6-31.5 120.6-79c28.1-28.5 41.9-62.8 54.2-93.4C308.4 100.7 323.1 64 374.2 64C443.1 64 512 151.3 512 238.5C512 343.3 370.9 448 236.3 448C167.4 448 64 430.5 64 369.5z',
      'M236.3 448C167.4 448 64 430.5 64 369.5c0-29.8 19.8-38.3 51.7-51.9c31.1-13.3 73.6-31.5 120.6-79c28.1-28.5 41.9-62.8 54.2-93.4C308.4 100.7 323.1 64 374.2 64C443.1 64 512 151.3 512 238.5C512 343.3 370.9 448 236.3 448zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faLocationCrosshairsSlash = {
  prefix: 'fad',
  iconName: 'location-crosshairs-slash',
  icon: [
    640,
    512,
    ['location-slash'],
    'f603',
    [
      'M64 256c0 17.7 14.3 32 32 32l34.7 0c13.5 80.4 76.9 143.9 157.3 157.3l0 34.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-34.7c22.6-3.8 43.8-11.5 62.9-22.4l-56.8-44.7C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3L96 224c-17.7 0-32 14.3-32 32zM184.9 119.6c17 13.3 34 26.6 51 40C258.3 139.9 287.8 128 320 128c70.7 0 128 57.3 128 128c0 21.2-5.1 41.1-14.2 58.7c17 13.3 34 26.6 51 40c12.1-20.1 20.6-42.6 24.6-66.6l34.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-34.7 0C495.9 143.6 432.4 80.1 352 66.7L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 34.7c-39.9 6.7-75.6 25.7-103.1 52.9zM274.7 190c40 31.4 80.1 62.8 120.2 94.2c3.3-8.8 5.1-18.3 5.1-28.2c0-44.2-35.8-80-80-80c-16.8 0-32.4 5.2-45.3 14z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faLocationSlash = faLocationCrosshairsSlash;
const faPersonDolly = {
  prefix: 'fad',
  iconName: 'person-dolly',
  icon: [
    512,
    512,
    [],
    'f4d0',
    [
      'M200 192c0 1.9 .2 3.9 .7 5.8c2.2 8.7 4.4 17.5 6.5 26.2c5.3 21.3 10.7 42.7 16 64c9 36.1 18 72.2 27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2C244.6 175.3 234.8 168 224 168c-1.9 0-3.9 .2-5.8 .7C207.3 171.4 200 181.2 200 192zM304 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-8.2-186.6L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8z',
      'M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7l0-65.1 16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4l70.7 0-16-64-46.1 0-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6l0 88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0 0 0 0 0 0l0-69.5-64-64z',
    ],
  ],
};
const faGlobe = {
  prefix: 'fad',
  iconName: 'globe',
  icon: [
    512,
    512,
    [127760],
    'f0ac',
    [
      'M0 256c0-22.1 2.8-43.5 8.1-64c41 0 82.1 0 123.1 0c-1 10.3-1.8 20.8-2.4 31.6c-.1 2.6-.2 5.3-.4 8.1c-.1 2.5-.2 5-.2 7.5l0 .6c-.1 2.6-.1 5.1-.1 7.5l0 .4c0 2.6 0 5.2-.1 7.7l0 .4c0 8.2 .2 16.4 .5 24.5c.1 2.6 .2 5.3 .3 7.9c.5 10.7 1.3 21.3 2.4 31.6L8.1 320C2.8 299.5 0 278.1 0 256zm18.6-96C48.5 86.3 111.6 29.6 189.5 8.7c-25 34.6-44.3 88-54.2 151.3c-38.9 0-77.8 0-116.6 0zm0 192l116.6 0c9.9 63.3 29.2 116.7 54.2 151.3C111.6 482.4 48.5 425.7 18.6 352zM160.5 231.4c.1-2.7 .2-5.4 .4-8.1c.6-10.7 1.4-21.1 2.5-31.4c61.8 0 123.6 0 185.3 0c2.2 20.4 3.3 41.9 3.3 64c0 22.1-1.2 43.5-3.3 64c-61.8 0-123.6 0-185.3 0c-1.1-10.2-1.9-20.7-2.5-31.4c-.3-5.4-.5-10.9-.6-16.4c-.1-2.7-.1-5.3-.2-8c0-2.6-.1-5.2-.1-7.8l0-.4c0-.1 0-.3 0-.4c0-2.8 0-5.5 .1-8.2c0-2.5 .1-5.1 .2-7.6l0-.6c.1-2.5 .2-5.1 .3-7.7zm7.2-71.4c6.1-36.7 15.5-69.2 27.1-95.5c10.5-23.8 22.2-41.2 33.6-52.1c6.8-6.5 12.8-10.2 18.1-12.2c3.2-.1 6.3-.2 9.5-.2s6.3 .1 9.5 .2c5.3 1.9 11.4 5.7 18.1 12.2c11.4 10.9 23.1 28.3 33.6 52.1c11.6 26.3 21 58.8 27.1 95.5c-58.9 0-117.8 0-176.7 0zm0 192l176.7 0c-6.1 36.7-15.5 69.2-27.1 95.5c-10.5 23.8-22.2 41.2-33.6 52.1c-6.8 6.5-12.8 10.2-18.1 12.2c-3.2 .1-6.3 .2-9.5 .2s-6.3-.1-9.5-.2c-5.3-1.9-11.4-5.7-18.1-12.2c-11.4-10.9-23.1-28.3-33.6-52.1c-11.6-26.3-21-58.8-27.1-95.5zM322.5 8.7c77.8 20.9 141 77.5 170.9 151.3c-38.9 0-77.8 0-116.6 0C366.9 96.7 347.5 43.3 322.5 8.7zm0 494.6c25-34.6 44.3-88 54.2-151.3l116.6 0c-29.8 73.7-93 130.4-170.9 151.3zM380.8 192c41 0 82.1 0 123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64c0-22-1.1-43.4-3.2-64z',
      'M344.3 352c-6.1 36.7-15.5 69.2-27.1 95.5c-10.5 23.8-22.2 41.2-33.6 52.1c-6.8 6.5-12.8 10.2-18.1 12.2c19.7-.7 38.7-3.6 57-8.6c25-34.6 44.3-88 54.2-151.3l116.6 0c4.2-10.3 7.7-21 10.5-32l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64l123.1 0c-2.8-11-6.4-21.7-10.5-32l-116.6 0C366.9 96.7 347.5 43.3 322.5 8.7c-18.3-4.9-37.4-7.8-57-8.6c5.3 1.9 11.4 5.7 18.1 12.2c11.4 10.9 23.1 28.3 33.6 52.1c11.6 26.3 21 58.8 27.1 95.5l-176.7 0c6.1-36.7 15.5-69.2 27.1-95.5c10.5-23.8 22.2-41.2 33.6-52.1c6.8-6.5 12.8-10.2 18.1-12.2c-19.7 .7-38.7 3.6-57 8.6c-25 34.6-44.4 88-54.2 151.3L18.6 160c-4.2 10.3-7.7 21-10.5 32l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320c2.8 11 6.4 21.7 10.5 32l116.6 0c9.9 63.3 29.2 116.7 54.2 151.3c18.3 4.9 37.4 7.8 57 8.6c-5.3-1.9-11.4-5.7-18.1-12.2c-11.4-10.9-23.1-28.3-33.6-52.1c-11.6-26.3-21-58.8-27.1-95.5l176.7 0zm7.7-96c0 22.1-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.9-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.9 3.3 64z',
    ],
  ],
};
const faSynagogue = {
  prefix: 'fad',
  iconName: 'synagogue',
  icon: [
    640,
    512,
    [128333],
    'f69b',
    [
      'M0 309.3L0 448c0 35.3 28.7 64 64 64l96 0 0-16 0-222.6L99.3 212.7c-3.1-3.1-7.2-4.7-11.3-4.7s-8.2 1.6-11.3 4.7L14.1 275.3c-9 9-14.1 21.2-14.1 33.9zm480-35.9L480 496l0 16 112 0c26.5 0 48-21.5 48-48l0-154.7c0-12.7-5.1-24.9-14.1-33.9l-62.6-62.6c-3.1-3.1-7.2-4.7-11.3-4.7s-8.2 1.6-11.3 4.7L480 273.4z',
      'M330.2 3.7c-5.9-4.9-14.6-4.9-20.5 0l-121 100.8C170.5 119.7 160 142.2 160 166l0 330 0 16 16 0 80 0 0-128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 128 80 0 16 0 0-16 0-330c0-23.7-10.5-46.3-28.8-61.5L330.2 3.7zM313 124.3c3.1-5.4 10.9-5.4 13.9 0l15.9 28.1 32.3-.3c6.2-.1 10.1 6.7 7 12.1L365.7 192l16.4 27.8c3.2 5.4-.7 12.1-7 12.1l-32.3-.3L327 259.7c-3.1 5.4-10.9 5.4-13.9 0l-15.9-28.1-32.3 .3c-6.2 .1-10.1-6.7-7-12.1L274.3 192l-16.4-27.8c-3.2-5.4 .7-12.1 7-12.1l32.3 .3L313 124.3z',
    ],
  ],
};
const faFileChartColumn = {
  prefix: 'fad',
  iconName: 'file-chart-column',
  icon: [
    384,
    512,
    ['file-chart-line'],
    'f659',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 376l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm88-128l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24zm88 64l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM216 248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176zm88 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM128 376c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z',
    ],
  ],
};
const faFileChartLine = faFileChartColumn;
const faPersonHalfDress = {
  prefix: 'fad',
  iconName: 'person-half-dress',
  icon: [
    320,
    512,
    [],
    'e548',
    [
      'M160 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c0-32 0-64 0-96zm0 128l14.9 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c3.1 5.2 4.6 10.8 4.6 16.5c0 10.9-5.5 21.5-15.5 27.5c-15.1 9.1-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-8 0 0-224z',
      'M160 96l0-96s0 0 0 0c-26.5 0-48 21.5-48 48s21.5 48 48 48c0 0 0 0 0 0zm0 32l-5.8 0c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9C51.6 373.3 59.3 384 70.2 384L88 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 8 0 0-256z',
    ],
  ],
};
const faFolderImage = {
  prefix: 'fad',
  iconName: 'folder-image',
  icon: [
    512,
    512,
    [],
    'e18a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM98.4 402.4c-4-8.3-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.5-9 18.7-9s14.2 3.3 18.7 9c5.8 7.2 11.5 14.4 17.3 21.6l56-84C280.5 228 288 224 296 224s15.5 4 20 10.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S400.9 416 392 416l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6zM176 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M296 224c8 0 15.5 4 20 10.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S400.9 416 392 416l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C280.5 228 288 224 296 224z',
    ],
  ],
};
const faCalendarPen = {
  prefix: 'fad',
  iconName: 'calendar-pen',
  icon: [
    448,
    512,
    ['calendar-edit'],
    'f333',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM128.5 428c-1.4 5.5 .2 11.2 4.2 15.2c3 3 7.1 4.7 11.3 4.7c1.3 0 2.6-.2 3.9-.5l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L218 304.6l-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9L128.5 428zM240.6 282l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3c-14.7-14.7-38.6-14.7-53.3 0L240.6 282z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM308.8 267c-14.7-14.7-38.6-14.7-53.3 0L240.6 282l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM146.1 376.5c-4.1 4.1-7 9.2-8.4 14.9L128.5 428c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L218 304.6l-71.9 71.9z',
    ],
  ],
};
const faCalendarEdit = faCalendarPen;
const faRoadBridge = {
  prefix: 'fad',
  iconName: 'road-bridge',
  icon: [
    640,
    512,
    [],
    'e563',
    [
      'M0 128c0 17.7 14.3 32 32 32l40 0 0 64L0 224l0 96c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96l0-96-40 0 0-64 40 0 0-64L32 96C14.3 96 0 110.3 0 128zm120 32l80 0 0 64-80 0 0-64z',
      'M608 0L352 0c-17.7 0-32 14.3-32 32l0 448c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-448c0-17.7-14.3-32-32-32zM504 224l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24zM480 360c13.3 0 24 10.7 24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24zM504 64l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faFaceSmileTear = {
  prefix: 'fad',
  iconName: 'face-smile-tear',
  icon: [
    512,
    512,
    [],
    'e393',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm139.9 90.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 346.2 212.6 368 256 368c8.8 0 16 7.2 16 16s-7.2 16-16 16c-55.1 0-93.8-27.9-116.1-53.5zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM304 369c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C371.4 308.6 400 349 400 369c0 26-21.5 47-48 47s-48-21-48-47zm64.4-161a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM400 369c0 26-21.5 47-48 47s-48-21-48-47c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C371.4 308.6 400 349 400 369zM336.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faMessagePlus = {
  prefix: 'fad',
  iconName: 'message-plus',
  icon: [
    512,
    512,
    ['comment-alt-plus'],
    'f4a8',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM144 208c0 13.3 10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24z',
      'M232 232l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faCommentAltPlus = faMessagePlus;
const faLocationArrow = {
  prefix: 'fad',
  iconName: 'location-arrow',
  icon: [
    448,
    512,
    [],
    'f124',
    [
      'M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l176 0 0 176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z',
      '',
    ],
  ],
};
const faC = {
  prefix: 'fad',
  iconName: 'c',
  icon: [
    384,
    512,
    [99],
    '43',
    [
      'M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z',
      '',
    ],
  ],
};
const faTabletButton = {
  prefix: 'fad',
  iconName: 'tablet-button',
  icon: [
    448,
    512,
    [],
    'f10a',
    [
      'M0 384l448 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64zm192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V384H0V64z',
    ],
  ],
};
const faPersonDressFairy = {
  prefix: 'fad',
  iconName: 'person-dress-fairy',
  icon: [
    640,
    512,
    [],
    'e607',
    [
      'M0 64l0 48c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448c0 17.7 14.3 32 32 32l16 0c55.9 0 106.6-22 144-57.9l0-38.1-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c.3-1.1 .7-2.2 1-3.3s.8-2.1 1.2-3.2c.9-2.1 1.8-4.1 2.9-6.1c2.1-3.9 4.6-7.6 7.4-11c5.7-6.7 12.7-12.2 20.6-16.2C224.8 85.8 134.7 32 32 32C14.3 32 0 46.3 0 64zM364.2 166.7c15.8 7.8 28 22 33.1 39.8l39.1 136.8c.8 3 1.3 5.9 1.3 8.8c0 17.1-13.9 31.9-32 31.9L384 384l0 38.1C421.4 458 472.1 480 528 480l16 0c17.7 0 32-14.3 32-32c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112l0-48c0-17.7-14.3-32-32-32C505.3 32 415.2 85.8 364.2 166.7z',
      'M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zM242.7 206.4c7.8-27.5 33-46.4 61.5-46.4l31.5 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L384 384l0 80c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-80-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z',
    ],
  ],
};
const faRectangleHistoryCircleUser = {
  prefix: 'fad',
  iconName: 'rectangle-history-circle-user',
  icon: [
    640,
    512,
    [],
    'e4a4',
    [
      'M0 224L0 448c0 35.3 28.7 64 64 64l330.8 0C349.5 480.1 320 427.5 320 368c0-97.2 78.8-176 176-176c2.5 0 5 .1 7.5 .2c-11-19.2-31.8-32.2-55.5-32.2L64 160c-35.3 0-64 28.7-64 64zM48 104c0 13.3 10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24zM96 24c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7C553.5 468.1 526.2 480 496 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faBuildingLock = {
  prefix: 'fad',
  iconName: 'building-lock',
  icon: [
    576,
    512,
    [],
    'e4d6',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 145.6c-19.8 20.2-32 47.9-32 78.4l0 24.6c-19.1 11.1-32 31.7-32 55.4l0 128c0 11.7 3.1 22.6 8.6 32L240 512l0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faChartLineUp = {
  prefix: 'fad',
  iconName: 'chart-line-up',
  icon: [
    512,
    512,
    [],
    'e0e5',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M406.6 246.6L439 279c15.1 15.1 41 4.4 41-17L480 152c0-13.3-10.7-24-24-24l-110.1 0c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80z',
    ],
  ],
};
const faMailbox = {
  prefix: 'fad',
  iconName: 'mailbox',
  icon: [
    576,
    512,
    [128234],
    'f813',
    [
      'M144 64c79.5 0 144 64.5 144 144l0 176c0 35.3-28.7 64-64 64l288 0c35.3 0 64-28.7 64-64l0-176c0-79.5-64.5-144-144-144L144 64zM384 208c0-8.8 7.2-16 16-16l64 0 32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16z',
      'M0 208C0 128.5 64.5 64 144 64s144 64.5 144 144l0 176c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 208zm64 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 192c-8.8 0-16 7.2-16 16zm336-16l64 0 32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faSignPosts = {
  prefix: 'fad',
  iconName: 'sign-posts',
  icon: [
    576,
    512,
    [],
    'e625',
    [
      'M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32L64 32zm0 384l64 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM448 32c26.7 0 53.3 0 80 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-16 0 0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 384l64 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64z',
      'M0 80C0 53.5 21.5 32 48 32H528c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80z',
    ],
  ],
};
const faTruckBolt = {
  prefix: 'fad',
  iconName: 'truck-bolt',
  icon: [
    640,
    512,
    [],
    'e3d0',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm16.8-266.9c2.2 6.5 8.3 10.9 15.2 10.9l54.1 0-36.4 72.8c-3.3 6.6-1.6 14.7 4.1 19.4s13.9 5 19.9 .5l128-96c5.5-4.1 7.8-11.3 5.6-17.9S294.9 144 288 144l-54.1 0 36.4-72.8c3.3-6.6 1.6-14.7-4.1-19.4s-13.9-5-19.9-.5l-128 96c-5.5 4.1-7.8 11.3-5.6 17.9zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L48 416c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM266.3 51.7c-5.7-4.8-13.9-5-19.9-.5l-128 96c-5.5 4.1-7.8 11.3-5.6 17.9s8.3 10.9 15.2 10.9l54.1 0-36.4 72.8c-3.3 6.6-1.6 14.7 4.1 19.4s13.9 5 19.9 .5l128-96c5.5-4.1 7.8-11.3 5.6-17.9S294.9 144 288 144l-54.1 0 36.4-72.8c3.3-6.6 1.6-14.7-4.1-19.4z',
    ],
  ],
};
const faPizzaSlice = {
  prefix: 'fad',
  iconName: 'pizza-slice',
  icon: [
    512,
    512,
    [],
    'f818',
    [
      'M.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L432 401.6l0-1.6C432 223.3 288.7 80 112 80l-1.6 0L.5 491.9zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80l1.6 0c176.7 0 320 143.3 320 320l0 1.6 44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM208 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMoneyBillWave = {
  prefix: 'fad',
  iconName: 'money-bill-wave',
  icon: [
    576,
    512,
    [],
    'f53a',
    [
      'M64 208l0 144c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.2c4.7-1.2 9.4-2.3 14.2-3.6c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4l0-144c-33.9 0-61.6-26.3-63.9-59.7c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208zm144 48c0-53 35.8-96 80-96s80 43 80 96s-35.8 96-80 96s-80-43-80-96z',
      'M0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM512 160l0 144c-31.4 0-57.5 22.6-63 52.4c-62.5 .8-121.8 15.7-172.9 28.6c0 0 0 0 0 0c-4.8 1.2-9.5 2.4-14.2 3.6c-50.7 12.6-94.1 22.2-134.2 23.2C125.6 378.3 97.9 352 64 352l0-144c31.4 0 57.5-22.6 63-52.4c62.5-.8 121.8-15.7 172.9-28.6c0 0 0 0 0 0c4.8-1.2 9.5-2.4 14.2-3.6c50.7-12.6 94.1-22.2 134.2-23.2c2.2 33.3 30 59.7 63.9 59.7z',
    ],
  ],
};
const faChartArea = {
  prefix: 'fad',
  iconName: 'chart-area',
  icon: [
    512,
    512,
    ['area-chart'],
    'f1fe',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M448 352H160c-17.7 0-32-14.3-32-32V236c0-7.8 2.8-15.2 7.9-21.1l79.4-90.8c13-14.8 36.1-14.5 48.7 .6l39.2 47c9 10.8 25.4 11.6 35.4 1.6l21-21c13.2-13.2 34.8-12.4 46.9 1.8L472.3 231c5 5.8 7.7 13.2 7.7 20.8V320c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faAreaChart = faChartArea;
const faHouseFlag = {
  prefix: 'fad',
  iconName: 'house-flag',
  icon: [
    640,
    512,
    [],
    'e50d',
    [
      'M2 267.1C6.6 279.7 18.6 288 32 288l32 0 0 192c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-96c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7 14.3 32 32 32l64.7 0-.8 0 0-353L276.8 39.7c-6-5.1-13.4-7.7-20.8-7.7s-14.8 2.6-20.8 7.7l-224 192C1 240.4-2.7 254.5 2 267.1z',
      'M512 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160 0 320 64 0 0-320 112 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L512 32z',
    ],
  ],
};
const faCircleThreeQuartersStroke = {
  prefix: 'fad',
  iconName: 'circle-three-quarters-stroke',
  icon: [
    512,
    512,
    [],
    'e5d4',
    [
      'M256 0C397.4 0 512 114.6 512 256l-64 0c0-106-86-192-192-192l0-64z',
      'M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H288c-17.7 0-32-14.3-32-32V0z',
    ],
  ],
};
const faPersonCircleMinus = {
  prefix: 'fad',
  iconName: 'person-circle-minus',
  icon: [
    576,
    512,
    [],
    'e540',
    [
      'M0 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C1.5 276.7 0 282.4 0 288zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z',
    ],
  ],
};
const faScalpel = {
  prefix: 'fad',
  iconName: 'scalpel',
  icon: [
    512,
    512,
    [],
    'f61d',
    [
      'M1.2 502.1c2.5 6 8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0-4.7 4.7-160 160c-4.6 4.6-5.9 11.5-3.5 17.4z',
      'M441.2 0c-20.6 0-40.2 9-53.7 24.6L155.9 293.6c-4.1 4.7-5 11.4-2.4 17.1s8.3 9.3 14.5 9.3l132.9 0c13.9 0 27.1-6 36.3-16.5L493.8 122.9C505.5 109.4 512 92.1 512 74.2l0-3.4C512 31.7 480.3 0 441.2 0z',
    ],
  ],
};
const faBan = {
  prefix: 'fad',
  iconName: 'ban',
  icon: [
    512,
    512,
    [128683, 'cancel'],
    'f05e',
    [
      'M99.5 144.8c12.5-17.5 27.8-32.8 45.3-45.3L412.5 367.2c-12.5 17.5-27.8 32.8-45.3 45.3L99.5 144.8z',
      'M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
    ],
  ],
};
const faCancel = faBan;
const faBellExclamation = {
  prefix: 'fad',
  iconName: 'bell-exclamation',
  icon: [
    448,
    512,
    [],
    'f848',
    [
      'M2.8 397.1C8 408.6 19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9c1.9-4.2 2.8-8.7 2.8-13.1c0-7.7-2.8-15.3-8.1-21.3l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4zM256 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM200 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96z',
      'M224 112c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24zm32 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm13.3 173.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z',
    ],
  ],
};
const faCircleBookmark = {
  prefix: 'fad',
  iconName: 'circle-bookmark',
  icon: [
    512,
    512,
    ['bookmark-circle'],
    'e100',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 192c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4l0-192z',
      'M208 128c-26.5 0-48 21.5-48 48l0 192c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4l0-192c0-26.5-21.5-48-48-48l-96 0z',
    ],
  ],
};
const faBookmarkCircle = faCircleBookmark;
const faEggFried = {
  prefix: 'fad',
  iconName: 'egg-fried',
  icon: [
    512,
    512,
    [],
    'f7fc',
    [
      'M0 351.8c0 55.3 28.7 109.1 80 138.7c76.5 44.2 174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c33.9-25.1 51.8-63.8 51.8-102.9c0-26.5-8.2-53.2-25.2-76.1c-18.2-24.6-43.5-40.7-71-47.8c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C6.9 297.2 0 324.7 0 351.8zM336 240a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z',
      'M224 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 232c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-39.8 32.2-72 72-72c8.8 0 16 7.2 16 16s-7.2 16-16 16c-22.1 0-40 17.9-40 40z',
    ],
  ],
};
const faFaceWeary = {
  prefix: 'fad',
  iconName: 'face-weary',
  icon: [
    512,
    512,
    [],
    'e3a1',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-32c0-7.7 5.5-14.5 13.4-15.8l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2c-.1-.9-.2-1.8-.2-2.6zm32 176c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3l-3.2 0c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2zM300.7 164.7c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c3.9 .7 7.3 2.7 9.6 5.5c1.2 1.4 2.1 3 2.8 4.8c.3 .9 .6 1.8 .7 2.7c.1 .5 .1 .9 .2 1.4s.1 .9 .1 1.4c0 .4 0 .9-.1 1.3s-.1 .9-.2 1.3c-1.5 8.7-9.7 14.6-18.4 13.2c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z',
      'M211.3 187.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z',
    ],
  ],
};
const faUniformMartialArts = {
  prefix: 'fad',
  iconName: 'uniform-martial-arts',
  icon: [
    640,
    512,
    [],
    'e3d1',
    [
      'M0 224.4L0 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-159.6c0-2.7 .7-5.3 2-7.7l46-83.7L144 288l109 0 54.6-143.3L246.4 18.1C241.1 7 229.9 0 217.6 0L208 0 180 0 164.4 0 160 0c-1 0-2 .1-3 .3c-32.1 2.5-61 20.9-76.7 49.5L13.9 170.5C4.8 187 0 205.6 0 224.4zM144 384l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64-86.3 0 14.2 21.4c14.7 22.1 8.7 51.9-13.3 66.6s-51.9 8.7-66.6-13.3L320 422.5l-24.1 36.1c-14.7 22.1-44.5 28-66.6 13.3s-28-44.5-13.3-66.6L230.3 384 144 384zm143.2-96L496 288l0-154.9 46 83.7c1.3 2.4 2 5 2 7.7L544 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-159.6c0-18.9-4.8-37.4-13.9-54L559.7 49.7C544.1 21.2 515.1 2.8 483 .3c-1-.2-2-.3-3-.3l-4.4 0L460 0 432 0 419 0c-13.3 0-25.2 8.2-29.9 20.6L339.9 149.7 287.2 288z',
      'M496 288l-352 0 0 64 146.1 0-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352 496 352l0-64z',
    ],
  ],
};
const faCameraRotate = {
  prefix: 'fad',
  iconName: 'camera-rotate',
  icon: [
    640,
    512,
    [],
    'e0d8',
    [
      'M64 160l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8L202.7 96 128 96c-35.3 0-64 28.7-64 64zM192 320c0-8.8 7.2-16 16-16l76.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3l0-76.7zm23-105l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3l0 76.7c0 8.8-7.2 16-16 16l-76.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9z',
      'M448 179.3l0 76.7c0 8.8-7.2 16-16 16l-76.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3zM192 396.7l0-76.7c0-8.8 7.2-16 16-16l76.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3z',
    ],
  ],
};
const faSunDust = {
  prefix: 'fad',
  iconName: 'sun-dust',
  icon: [
    512,
    512,
    [],
    'f764',
    [
      'M1.2 150.5c-2.1 5-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l44.5-44.5C142.3 323.3 128 291.3 128 256c0-70.7 57.3-128 128-128c35.3 0 67.3 14.3 90.5 37.5L391 121 371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9c-2-.8-4-1.2-6.1-1.2c-3.2 0-6.4 1-9.1 2.8L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6zM160 256c0 26.5 10.7 50.5 28.1 67.9L323.9 188.1C306.5 170.7 282.5 160 256 160c-53 0-96 43-96 96z',
      'M480 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM272 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faCommentText = {
  prefix: 'fad',
  iconName: 'comment-text',
  icon: [
    512,
    512,
    [],
    'e14d',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160-56c0-13.3 10.7-24 24-24l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-48 0c-13.3 0-24-10.7-24-24z',
      'M160 184c0-13.3 10.7-24 24-24l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-48 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faSprayCanSparkles = {
  prefix: 'fad',
  iconName: 'spray-can-sparkles',
  icon: [
    512,
    512,
    ['air-freshener'],
    'f5d0',
    [
      'M80 336a80 80 0 1 0 160 0A80 80 0 1 0 80 336zM288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48zm64 96c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6zm64-96c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48zm0 192c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6z',
      'M128 0l64 0c17.7 0 32 14.3 32 32l0 96L96 128l0-96c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 208c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0z',
    ],
  ],
};
const faAirFreshener = faSprayCanSparkles;
const faSignalBars = {
  prefix: 'fad',
  iconName: 'signal-bars',
  icon: [
    640,
    512,
    ['signal-alt', 'signal-alt-4', 'signal-bars-strong'],
    'f690',
    [
      '',
      'M560 0c-26.5 0-48 21.5-48 48l0 416c0 26.5 21.5 48 48 48s48-21.5 48-48l0-416c0-26.5-21.5-48-48-48zM352 176l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48s-48 21.5-48 48zM240 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z',
    ],
  ],
};
const faSignalAlt = faSignalBars;
const faSignalAlt4 = faSignalBars;
const faSignalBarsStrong = faSignalBars;
const faDiamondExclamation = {
  prefix: 'fad',
  iconName: 'diamond-exclamation',
  icon: [
    512,
    512,
    [],
    'e405',
    [
      'M0 256c0 10.2 3.9 20.5 11.7 28.3l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216C276.5 3.9 266.2 0 256 0s-20.5 3.9-28.3 11.7l-216 216C3.9 235.5 0 245.8 0 256zm288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faStar = {
  prefix: 'fad',
  iconName: 'star',
  icon: [
    576,
    512,
    [11088, 61446],
    'f005',
    [
      'M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z',
      '',
    ],
  ],
};
const faDialMin = {
  prefix: 'fad',
  iconName: 'dial-min',
  icon: [
    576,
    512,
    [],
    'e161',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M192.8 416.7c62.6 46.2 151.3 41 208-15.7c62.5-62.5 62.5-163.8 0-226.3s-163.8-62.5-226.3 0c-56.7 56.7-62 145.4-15.7 208L270.7 270.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L192.8 416.7z',
    ],
  ],
};
const faRepeat = {
  prefix: 'fad',
  iconName: 'repeat',
  icon: [
    512,
    512,
    [128257],
    'f363',
    [
      'M64 416c0 8.2 3.1 16.4 9.4 22.6l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 160 0c88.4 0 160-71.6 160-160c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64C67.1 399.6 64 407.8 64 416z',
      'M32 256c-17.7 0-32-14.3-32-32C0 135.6 71.6 64 160 64l160 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-160 0c-53 0-96 43-96 96c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faCross = {
  prefix: 'fad',
  iconName: 'cross',
  icon: [
    384,
    512,
    [128327, 10013],
    'f654',
    [
      'M0 176l0 32c0 26.5 21.5 48 48 48l80 0 128 0 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-80c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48l0 80-80 0c-26.5 0-48 21.5-48 48zM128 288l0 176c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-176-128 0z',
      'M128 256H256v32H128V256z',
    ],
  ],
};
const faPageCaretDown = {
  prefix: 'fad',
  iconName: 'page-caret-down',
  icon: [
    384,
    512,
    ['file-caret-down'],
    'e429',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-309.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L64 0C28.7 0 0 28.7 0 64zM98.3 245.8c.1-.8 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.1-2.8 2.8-5.5 4.9-7.7c4.2-4.5 10.2-7.4 17.4-7.4l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2s-8.8-1.9-11.8-5.2c-25.2-27.5-50.5-55.1-75.7-82.6c-2.2-2.4-3.8-5-4.8-7.7c-.5-1.4-.9-2.7-1.2-4.1c-.1-.7-.2-1.4-.3-2.1s-.1-1.4-.1-2.1c0-.8 0-1.5 .1-2.3z',
      'M180.2 346.8c3 3.3 7.3 5.2 11.8 5.2s8.8-1.9 11.8-5.2l75.7-82.6c14.1-15.4 3.2-40.2-17.7-40.2l-139.6 0c-20.9 0-31.8 24.8-17.7 40.2l75.7 82.6z',
    ],
  ],
};
const faFileCaretDown = faPageCaretDown;
const faBox = {
  prefix: 'fad',
  iconName: 'box',
  icon: [
    448,
    512,
    [128230],
    'f466',
    [
      'M0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160zM240 32l0 128 208 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32z',
      'M240 160l208 0 0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160l208 0 0-128 32 0 0 128z',
    ],
  ],
};
const faVenusMars = {
  prefix: 'fad',
  iconName: 'venus-mars',
  icon: [
    640,
    512,
    [9892],
    'f228',
    [
      'M256 176A80 80 0 1 1 96 176a80 80 0 1 1 160 0zm15.9 184.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0L616 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z',
      'M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zm32 0c0-4.8-.2-9.6-.5-14.3c5.3-1.1 10.8-1.7 16.5-1.7c44.2 0 80 35.8 80 80s-35.8 80-80 80c-21.5 0-41-8.5-55.3-22.2C369.4 263.5 384 221.5 384 176z',
    ],
  ],
};
const faClockSevenThirty = {
  prefix: 'fad',
  iconName: 'clock-seven-thirty',
  icon: [
    512,
    512,
    [],
    'e351',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm168 96c0-4.6 1.3-9.2 4-13.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56.7-20 30c-7.4 11-22.3 14-33.3 6.7c-6.9-4.6-10.7-12.2-10.7-20z',
      'M256 416c-13.3 0-24-10.7-24-24l0-56.7-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23l0 136c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faArrowPointer = {
  prefix: 'fad',
  iconName: 'arrow-pointer',
  icon: [
    320,
    512,
    ['mouse-pointer'],
    'f245',
    [
      'M121.2 346c7.6-8.7 15.2-17.3 22.8-26l35.8 0 56.8 113.7c2.3 4.6 3.4 9.5 3.4 14.3c0 11.7-6.5 23-17.7 28.6c-4.6 2.3-9.5 3.4-14.3 3.4c-11.7 0-23-6.5-28.6-17.7L121.2 346z',
      'M0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1H144L38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22z',
    ],
  ],
};
const faMousePointer = faArrowPointer;
const faClockFourThirty = {
  prefix: 'fad',
  iconName: 'clock-four-thirty',
  icon: [
    512,
    512,
    [],
    'e34b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232 0c0-8.9 4.9-17 12.7-21.2s17.3-3.7 24.6 1.2l96 64c6.9 4.6 10.7 12.2 10.7 20c0 4.6-1.3 9.2-4 13.3c-7.4 11-22.3 14-33.3 6.7L280 300.8l0 91.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z',
      'M256 416c13.3 0 24-10.7 24-24l0-91.2L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256l0 136c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faSignalBarsGood = {
  prefix: 'fad',
  iconName: 'signal-bars-good',
  icon: [
    640,
    512,
    ['signal-alt-3'],
    'f693',
    [
      'M512 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 416c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-416z',
      'M400 128c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48zM192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48s-48 21.5-48 48zM32 432l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
    ],
  ],
};
const faSignalAlt3 = faSignalBarsGood;
const faCactus = {
  prefix: 'fad',
  iconName: 'cactus',
  icon: [
    512,
    512,
    [127797],
    'f8a7',
    [
      'M0 144l0 64c0 61.9 50.1 112 112 112l48 0 0-96-48 0c-8.8 0-16-7.2-16-16l0-64c0-26.5-21.5-48-48-48S0 117.5 0 144zM352 352l0 96 48 0c61.9 0 112-50.1 112-112l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64c0 8.8-7.2 16-16 16l-48 0z',
      'M160 96c0-53 43-96 96-96s96 43 96 96l0 368c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-368zm80 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faLightbulbGear = {
  prefix: 'fad',
  iconName: 'lightbulb-gear',
  icon: [
    576,
    512,
    [],
    'e5fd',
    [
      'M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l128.6 0c2.3-13.3 10.5-24.9 21.4-31.8c-16.6-10.6-26.7-31.7-20-53.3c4-12.9 9.4-25.5 16.4-37.6s15.2-23.1 24.4-33c15.7-16.9 39.6-18.5 57.2-8.7l0-.9c0-17.8 10.2-35.6 28-43.3C367.6 78.4 289 0 192 0C94.8 0 16 78.8 16 176zm64 0c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm32 240l0 16c0 44.2 35.8 80 80 80c35.2 0 65.1-22.8 75.8-54.4c-3.3-4.7-6.4-9.5-9.4-14.6c-5.1-8.8-9.3-17.8-12.8-27L112 416z',
      'M383.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8l0 17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7l0-17.7c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM416 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faMaximize = {
  prefix: 'fad',
  iconName: 'maximize',
  icon: [
    512,
    512,
    ['expand-arrows-alt'],
    'f31e',
    [
      'M32 56l0 144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79c21.3-21.3 42.7-42.7 64-64l-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32L56 32C42.7 32 32 42.7 32 56zM256 320l79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79-64 64z',
      'M480 56l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L177 399l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8L56 480c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L335 113 295 73c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8l144 0c13.3 0 24 10.7 24 24z',
    ],
  ],
};
const faExpandArrowsAlt = faMaximize;
const faChargingStation = {
  prefix: 'fad',
  iconName: 'charging-station',
  icon: [
    576,
    512,
    [],
    'f5e7',
    [
      'M32 64C32 28.7 60.7 0 96 0L256 0c35.3 0 64 28.7 64 64l0 192 0 48 0 144L32 448 32 64zM81 197.6c2.3 6.3 8.3 10.4 15 10.4l57.8 0-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4l-57.8 0 25-74.9c2.3-6.8-.3-14.3-6.3-18.3s-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7z',
      'M480 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-16 0c-8.8 0-16 7.2-16 16l0 32c0 35.8 23.5 66.1 56 76.3L472 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-16 0 0 48 16 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-123.7c32.5-10.2 56-40.5 56-76.3l0-32c0-8.8-7.2-16-16-16l-16 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-32 0 0-48zM0 480c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faShapes = {
  prefix: 'fad',
  iconName: 'shapes',
  icon: [
    512,
    512,
    ['triangle-circle-square'],
    'f61f',
    [
      'M0 384a128 128 0 1 0 256 0A128 128 0 1 0 0 384zM164.2 207.8c5.7 10 16.3 16.2 27.8 16.2l192 0c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2z',
      'M328 272c-22.1 0-40 17.9-40 40l0 144c0 22.1 17.9 40 40 40l144 0c22.1 0 40-17.9 40-40l0-144c0-22.1-17.9-40-40-40l-144 0z',
    ],
  ],
};
const faTriangleCircleSquare = faShapes;
const faPlaneTail = {
  prefix: 'fad',
  iconName: 'plane-tail',
  icon: [
    512,
    512,
    [],
    'e22c',
    [
      'M.8 39L61.5 308.8c59.9-16.5 119.8-33.1 179.8-49.6c7.6-2.1 15.5-3.2 23.4-3.2L384 256 154.9 19.5C142.8 7 126.2 0 108.9 0L32 0C11.5 0-3.7 19 .8 39z',
      'M512 464l0-160 0-24 0-24-24 0-223.3 0c-7.9 0-15.8 1.1-23.4 3.2L45.9 313.1C18.8 320.5 0 345.2 0 373.4c0 26 16.1 49.3 40.4 58.5l196.1 74.4c10 3.8 20.5 5.7 31.2 5.7L488 512l24 0 0-24 0-24zM216 352l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faGaugeSimpleMax = {
  prefix: 'fad',
  iconName: 'gauge-simple-max',
  icon: [
    512,
    512,
    ['tachometer-fastest'],
    'f62b',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM192.3 345.4c-.1 1.1-.2 2.2-.2 3.2c-.1 1.1-.1 2.2-.1 3.3s0 2.2 .1 3.3c.1 1.1 .1 2.2 .2 3.2c.2 2.1 .5 4.3 1 6.4c.9 4.2 2.1 8.2 3.7 12c3.2 7.7 7.9 14.6 13.7 20.3C222.3 408.8 238.3 416 256 416c35.3 0 64-28.7 64-64c0-3.7-.3-7.3-.9-10.8c39.2-24.3 78.4-48.5 117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8c-39.2 24.3-78.4 48.5-117.6 72.8C283.2 292.6 270.1 288 256 288c-17.7 0-33.7 7.2-45.3 18.7c-5.8 5.8-10.5 12.7-13.7 20.3c-1.6 3.8-2.9 7.8-3.7 12c-.4 2.1-.8 4.2-1 6.3z',
      'M411.4 227.6c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.6-72.8z',
    ],
  ],
};
const faTachometerFastest = faGaugeSimpleMax;
const faCircleU = {
  prefix: 'fad',
  iconName: 'circle-u',
  icon: [
    512,
    512,
    [],
    'e127',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120z',
      'M168 144c13.3 0 24 10.7 24 24l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faShieldSlash = {
  prefix: 'fad',
  iconName: 'shield-slash',
  icon: [
    640,
    512,
    [],
    'e24b',
    [
      'M80.6 159.5c5.5 102 51.4 266.3 213 343.7c16.7 8 36.1 8 52.8 0c35.8-17.1 65.8-38.5 91.1-62.5L80.6 159.5zM131 77.4C253.3 173.3 375.6 269.1 497.9 365c47.4-78.8 61.8-166.3 62.1-225c.1-26.2-16.3-47.9-38.3-57.2L333.4 2.9C329.2 1 324.7 0 320 0s-9.2 1-13.4 2.9L131 77.4z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faSquarePhoneHangup = {
  prefix: 'fad',
  iconName: 'square-phone-hangup',
  icon: [
    448,
    512,
    ['phone-square-down'],
    'e27a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM66.8 274.8C62 267 63.4 257.3 70.3 251c42.5-39.3 98.1-59 153.7-59s111.3 19.7 153.7 59c4.1 3.8 6.3 8.9 6.3 14c0 3.4-.9 6.7-2.8 9.8L359.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L66.8 274.8z',
      'M332.7 318.5c9.9 3.8 21.4 .2 26.7-8.5l21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8c-84.9-78.6-222.6-78.6-307.5 0c-6.8 6.3-8.2 16.1-3.4 23.8L88.6 310c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3L171.7 254c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6z',
    ],
  ],
};
const faPhoneSquareDown = faSquarePhoneHangup;
const faArrowUpLeft = {
  prefix: 'fad',
  iconName: 'arrow-up-left',
  icon: [
    384,
    512,
    [],
    'e09d',
    [
      'M96 160l45.3 0L342.6 361.4c6.2 6.2 9.4 14.4 9.4 22.6s-3.1 16.4-9.4 22.6s-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4L96 205.3 96 160z',
      'M32 128c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 160l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224z',
    ],
  ],
};
const faTransporter1 = {
  prefix: 'fad',
  iconName: 'transporter-1',
  icon: [
    512,
    512,
    [],
    'e043',
    [
      'M0 368c0 4.1 2.7 7.6 6.6 8.7L32 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 352 6.6 359.3C2.7 360.4 0 363.9 0 368zm160-32c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM416 176c0 4.1 2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM216 512l80 0 88 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l88 0zM359 276c6.3 7.8 15.4 11.9 24.7 12l.3 0s0 0 0 0c7 0 14.1-2.3 20-7c13.8-11.1 16-31.2 5-45l-57.7-72c-18.2-22.7-45.8-36-74.9-36l-40.7 0c-29.1 0-56.7 13.2-74.9 36L103 236c-11.1 13.8-8.8 33.9 5 45c5.9 4.7 13 7 20 7c0 0 0 0 0 0l.3 0c9.3-.1 18.5-4.2 24.7-12l31-38.7 0 50.7 144 0 0-50.7L359 276z',
    ],
  ],
};
const faPeanuts = {
  prefix: 'fad',
  iconName: 'peanuts',
  icon: [
    640,
    512,
    [129372],
    'e431',
    [
      'M128 364l0 68c0 23.4 10 44.4 26 59c14.2 13 33.2 21 54 21l68 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C623.6 225.4 640 188.6 640 148l0-68c0-44.2-35.8-80-80-80L492 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30c-3.7 18.7-9.1 37.5-19.4 53.2c-3.1 4.8-6.7 9.4-10.9 13.5c-17.6 17.6-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364zm147.2 52.1a19.2 19.2 0 1 1 -38.4-.3 19.2 19.2 0 1 1 38.4 .3zm63.6-60.2a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zm0 64a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zM499.2 192a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm64-64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm0 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0z',
      'M161.7 28.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2l22.7 50.9c12.4 27.8 13.5 57.8 5.2 84.8c-3.1 4.8-6.7 9.4-10.9 13.5c-17.6 17.6-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364l0 68c0 23.4 10 44.4 26 59l-34.3 15.3c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3zM524.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM320 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z',
    ],
  ],
};
const faShuffle = {
  prefix: 'fad',
  iconName: 'shuffle',
  icon: [
    512,
    512,
    [128256, 'random'],
    'f074',
    [
      'M0 384c0 17.7 14.3 32 32 32l64 0c30.2 0 58.7-14.2 76.8-38.4L224 309.3c-13.3-17.8-26.7-35.6-40-53.3l-62.4 83.2c-6 8.1-15.5 12.8-25.6 12.8l-64 0c-17.7 0-32 14.3-32 32zM224 202.7c13.3 17.8 26.7 35.6 40 53.3l62.4-83.2c6-8.1 15.5-12.8 25.6-12.8l32 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-32 0c-30.2 0-58.7 14.2-76.8 38.4L224 202.7z',
      'M352 416c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0z',
    ],
  ],
};
const faRandom = faShuffle;
const faPersonRunning = {
  prefix: 'fad',
  iconName: 'person-running',
  icon: [
    448,
    512,
    [127939, 'running'],
    'f70c',
    [
      'M0 384c0 17.7 14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5l24.6-55.4-5.7-3.6c-25.1-15.7-36.1-46.5-26.8-74.5c2.8-8.5 5.7-17 8.5-25.6L91.2 352 32 352c-17.7 0-32 14.3-32 32z',
      'M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7l21.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-21.3 0c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3z',
    ],
  ],
};
const faRunning = faPersonRunning;
const faMobileRetro = {
  prefix: 'fad',
  iconName: 'mobile-retro',
  icon: [
    320,
    512,
    [],
    'e527',
    [
      'M0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM56 328a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm8-248l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zm48-96c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm24 264a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80-80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M64 160c0-17.7 14.3-32 32-32H224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z',
    ],
  ],
};
const faGripLinesVertical = {
  prefix: 'fad',
  iconName: 'grip-lines-vertical',
  icon: [
    192,
    512,
    [],
    'f7a5',
    [
      'M128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384z',
      'M0 64C0 46.3 14.3 32 32 32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z',
    ],
  ],
};
const faBinBottlesRecycle = {
  prefix: 'fad',
  iconName: 'bin-bottles-recycle',
  icon: [
    640,
    512,
    [],
    'e5f6',
    [
      'M32 192l320 0c0-26.5-10.7-50.5-28.1-67.9c-1.1-1.1-2.1-2.1-3.2-3.1c-17.1-15.5-39.7-25-64.6-25L128 96c-53 0-96 43-96 96zM112 48c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-8c0-13.3-10.7-24-24-24L152 0c-13.3 0-24 10.7-24 24l0 8c-8.8 0-16 7.2-16 16zM335.4 91.6C365 115.1 384 151.3 384 192l191.1 0c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-5.3-2.5-10.8-4.4-16.4-5.7l0-42.1c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24l0 42.1c-5.6 1.3-11.1 3.2-16.4 5.7L354.1 78c-7.2 3.4-13.5 8-18.6 13.6z',
      'M0 256c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L583.8 457c-4.5 31.5-31.5 55-63.4 55l-401 0c-31.8 0-58.9-23.4-63.4-55L32 288c-17.7 0-32-14.3-32-32zm319.9 64c4.6 0 9 2.3 11.5 6.2l8.5 12.9c4.8 7.3 14.5 9.4 21.8 4.8c7.6-4.8 9.8-14.9 4.9-22.4l-8.5-12.9c-8.5-12.9-22.8-20.6-38.2-20.6c-15.3 0-29.6 7.7-38.1 20.4l-7.6 11.4c-5 7.5-2.8 17.7 4.8 22.4c7.3 4.6 17 2.5 21.8-4.7l7.6-11.4c2.6-3.8 6.9-6.1 11.5-6.1zm-59.4 48.4c-7.3-4.6-17-2.5-21.8 4.7l-7.9 11.9c-4.4 6.7-6.8 14.5-6.8 22.5c0 22.4 18.2 40.6 40.6 40.6l25.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.2 0c-4.7 0-8.6-3.8-8.6-8.6c0-1.7 .5-3.3 1.4-4.7l7.9-11.9c5-7.5 2.8-17.7-4.8-22.4zM337.7 432c0 8.8 7.2 16 16 16l20.9 0c22.4 0 40.6-18.2 40.6-40.6c0-7.9-2.3-15.7-6.7-22.4l-6.6-10.1c-4.8-7.3-14.5-9.4-21.8-4.8c-7.6 4.8-9.8 14.9-4.9 22.4l6.6 10.1c.9 1.4 1.4 3.1 1.4 4.7c0 4.8-3.9 8.6-8.6 8.6l-20.9 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faArrowUpFromSquare = {
  prefix: 'fad',
  iconName: 'arrow-up-from-square',
  icon: [
    512,
    512,
    [],
    'e09c',
    [
      'M0 112L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-320c0-44.2-35.8-80-80-80l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0C35.8 32 0 67.8 0 112z',
      'M233.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3 288 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z',
    ],
  ],
};
const faFileDashedLine = {
  prefix: 'fad',
  iconName: 'file-dashed-line',
  icon: [
    640,
    512,
    ['page-break'],
    'f877',
    [
      'M128 64l0 192 384 0 0-96-128 0c-17.7 0-32-14.3-32-32L352 0 192 0c-35.3 0-64 28.7-64 64zm0 304l0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-80-384 0zM384 0l0 128 128 0L384 0z',
      'M32 312c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 336c-13.3 0-24-10.7-24-24zm224 0c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zm192 0c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faPageBreak = faFileDashedLine;
const faBracketCurlyRight = {
  prefix: 'fad',
  iconName: 'bracket-curly-right',
  icon: [
    256,
    512,
    [],
    '7d',
    [
      'M192 128c0-53-43-96-96-96L64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 37.5c0 25.5 10.1 49.9 28.1 67.9L178.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9l0 37.5c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c53 0 96-43 96-96l0-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6l0-37.5z',
      '',
    ],
  ],
};
const faSpider = {
  prefix: 'fad',
  iconName: 'spider',
  icon: [
    512,
    512,
    [128375],
    'f717',
    [
      'M81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4c8.3 2.8 16.6 5.5 24.9 8.3c0-17.1 0-34.2 0-51.3l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100zM336 174.1l0 51.3c8.3-2.8 16.6-5.5 24.9-8.3l57.4-57.4c15.7-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1z',
      'M221.5 87.8c9.1-4.4 18.5 3.3 18.5 13.4l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c0-10.1 9.4-17.7 18.5-13.4C317.4 100.7 336 128.2 336 160l0 65.4 105.2-35.1c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-80.4-26.8 57.4 57.4c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-32.3 32.3c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l57.4-57.4L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1L176 225.4l0-65.4c0-31.8 18.6-59.3 45.5-72.2z',
    ],
  ],
};
const faClockThree = {
  prefix: 'fad',
  iconName: 'clock-three',
  icon: [
    512,
    512,
    [],
    'e356',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24l0-136z',
      'M256 96c-13.3 0-24 10.7-24 24l0 136c0 13.3 10.7 24 24 24l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-112c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faHandsBound = {
  prefix: 'fad',
  iconName: 'hands-bound',
  icon: [
    640,
    512,
    [],
    'e4f9',
    [
      'M32 32l0 64 0 59.1 0 .7L32 192l0 21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352 288 352l0-32 0-61.9c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8 96 96l0-64C96 14.3 81.7 0 64 0S32 14.3 32 32zM160 480l0 32 128 0 0-32-128 0zM352 258.1l0 61.9 0 32 156.4 0 85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7l0-21.9 0-36.2 0-.7L608 96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 0 48.8-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1zM352 480l0 32 128 0 0-32-128 0z',
      'M128 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-384 0zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-384 0z',
    ],
  ],
};
const faScalpelLineDashed = {
  prefix: 'fad',
  iconName: 'scalpel-line-dashed',
  icon: [
    576,
    512,
    ['scalpel-path'],
    'f61e',
    [
      'M1.2 502.1c2.5 6 8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0-4.7 4.7-160 160c-4.6 4.6-5.9 11.5-3.5 17.4z',
      'M387.5 24.6C400.9 9 420.5 0 441.2 0C480.3 0 512 31.7 512 70.8l0 3.4c0 17.9-6.5 35.2-18.2 48.7L337.2 303.5C328 314 314.8 320 300.9 320L168 320c-6.3 0-11.9-3.6-14.5-9.3s-1.7-12.4 2.4-17.1L387.5 24.6zM240 480l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faScalpelPath = faScalpelLineDashed;
const faFileInvoiceDollar = {
  prefix: 'fad',
  iconName: 'file-invoice-dollar',
  icon: [
    384,
    512,
    [],
    'f571',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0c0 42.7 0 85.3 0 128c0 .6 0 1.1 0 1.6c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.2 1 .5 2.1 .8 3.1c.2 .5 .3 1 .5 1.5s.4 1 .6 1.5c1.6 3.8 4 7.3 6.9 10.2s6.3 5.2 10.2 6.9c1.9 .8 3.9 1.4 6 1.9c1 .2 2.1 .4 3.2 .5c.5 .1 1.1 .1 1.6 .1s1.1 0 1.6 0l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm64.2 150.9c-.1 1.2-.1 2.3-.1 3.6c0 1.2 .1 2.3 .1 3.4s.2 2.2 .4 3.2c.3 2.1 .8 4.1 1.4 6c1.2 3.8 2.9 7.2 5 10.3c4.2 6.1 9.8 10.9 15.8 14.5c10.5 6.3 23.8 10.4 34.8 13.7c.5 .2 1.1 .3 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1c-.3 .8-.5 1.7-.6 2.5c-.1 .4-.1 .8-.2 1.3c0 .2 0 .4-.1 1.3l.1 1.3c0 0 0 .6 .1 1.2c.1 .8 .3 1.6 .6 2.4c.5 1.6 1.2 3 2.2 4.4c1.9 2.7 4.6 4.8 8 5.9c2 .7 4.1 1.4 6.2 2.1c9.2 3.2 19.7 6.8 30.9 8.9c0 5.9 0 11.9 0 17.8c0 .6 0 1.1 .1 1.6s.1 1.1 .2 1.6c.2 1 .5 2 .9 3c.8 1.9 2 3.6 3.4 5.1c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c6.6-4.1 12.4-9.7 16.5-16.6c2-3.5 3.7-7.3 4.8-11.4c.5-2.1 1-4.2 1.2-6.5c.1-1.1 .2-2.3 .3-3.4c.1-1.1 .1-2.3 .1-3.5c-.2-18.6-10.6-30.7-22.7-38.3c-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-3-1.8-4.8-3.4-5.9-5c-.5-.8-.9-1.6-1.1-2.4c-.1-.4-.2-.8-.2-1.3c0-.4-.1-.8-.1-1.2c0-.8 0-1.4 .1-2.1s.2-1.3 .4-1.8c.3-1.2 .8-2.3 1.5-3.3c1.3-2.1 3.4-3.9 6.2-5.6c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1c0-5.8 0-11.5 0-17.3c0-8.8-7.2-16-16-16c-4.4 0-8.4 1.8-11.3 4.7c-1.4 1.4-2.6 3.2-3.4 5.1c-.4 1-.7 2-.9 3c-.1 .5-.2 1.1-.2 1.6s-.1 1.1-.1 1.5c0 5.9 0 11.7 0 17.5c-8.3 1.5-16.7 4.3-24.1 8.7c-6.5 3.9-12.5 9.1-16.8 15.9c-2.2 3.4-3.9 7.1-5.1 11.2c-.6 2.1-1.1 4.2-1.4 6.4c-.2 1.1-.3 2.3-.4 3.4z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM208 232c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z',
    ],
  ],
};
const faPipeSmoking = {
  prefix: 'fad',
  iconName: 'pipe-smoking',
  icon: [
    640,
    512,
    [],
    'e3c4',
    [
      'M361.5 192c5.6 .3 11.2 2 16.2 5.3l24 16c.7 .5 1.4 1 2.1 1.5s1.3 1.1 1.9 1.7c1.2 1.1 2.4 2.4 3.4 3.7c2 2.6 3.6 5.5 4.8 8.5l81.3-122C513.1 80 543.1 64 575.2 64L608 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L575.2 0C521.7 0 471.7 26.7 442 71.2L361.5 192z',
      'M377.8 197.4c-14.7-9.8-34.6-5.8-44.4 8.9L256 322.3l0-50.3c0-26.5-21.5-48-48-48L48 224c-26.5 0-48 21.5-48 48l0 82.9C0 441.7 70.3 512 157.1 512c52.5 0 101.6-26.2 130.7-69.9L410.6 257.8c9.8-14.7 5.8-34.6-8.9-44.4l-24-16z',
    ],
  ],
};
const faFaceAstonished = {
  prefix: 'fad',
  iconName: 'face-astonished',
  icon: [
    512,
    512,
    [],
    'e36b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM100.3 154.9c-6-6.5-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8zM208.4 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM208 352c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zm96-240c0-8.8 7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16zm64.4 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 128.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
    ],
  ],
};
const faWindow = {
  prefix: 'fad',
  iconName: 'window',
  icon: [
    512,
    512,
    [],
    'f40e',
    [
      'M0 224l512 0 0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 224zm224-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M64 32C28.7 32 0 60.7 0 96L0 224l512 0 0-128c0-35.3-28.7-64-64-64L64 32zM96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faPlaneCircleExclamation = {
  prefix: 'fad',
  iconName: 'plane-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e556',
    [
      'M0 297.3l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faEar = {
  prefix: 'fad',
  iconName: 'ear',
  icon: [
    384,
    512,
    [128066],
    'f5f0',
    [
      'M0 192L0 368c0 36.9 14.1 73.7 42.2 101.8c56.2 56.2 147.4 56.2 203.6 0c20.4-20.4 33.4-45.4 39-71.7c5.1-23.9 16.9-46.7 35.1-62.9C359.2 300 384 248.9 384 192C384 86 298 0 192 0S0 86 0 192zm80.1-5.8c.1-1.9 .2-3.8 .4-5.7c.4-3.8 1-7.5 1.7-11.1c1.5-7.3 3.7-14.3 6.5-21c5.7-13.4 13.9-25.5 24-35.6C133.1 92.5 161.1 80 192 80c61.9 0 112 50.1 112 112c0 2.7 0 5.3 0 8c-.1 13.4-10.8 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.5c0-2.7 0-5.3 0-8c0-35.3-28.7-64-64-64c-17.7 0-33.7 7.2-45.3 18.7c-5.8 5.8-10.5 12.7-13.7 20.3c-1.6 3.8-2.9 7.8-3.7 12c-.4 2.1-.8 4.2-1 6.4c-.1 1.1-.2 2.1-.2 3.2c-.1 1.1-.1 2.2-.1 3.3c0 6.7 0 13.5 0 20.3c0 .3 0 .7 .1 1c.1 .4 .1 .7 .2 1.1c.2 .7 .5 1.4 .9 2c.8 1.2 1.9 2.3 3.2 2.9c4.7 2.3 9.4 4.7 14 7c18.1 9.1 29.5 27.6 29.5 47.8c0 15.9-7 30.9-19.2 41.1c-12.5 10.4-24.9 20.8-37.4 31.2c-10.2 8.5-25.3 7.1-33.8-3.1c-1.9-2.2-3.3-4.7-4.2-7.3c-.5-1.3-.8-2.6-1-4c-.2-1-.3-2-.3-2c-.1-1-.1-1-.1-2.1c0-.9 0-1.1 0-1.3c0-.4 .1-.8 .1-1.3c.1-.8 .2-1.7 .4-2.5c.4-1.7 .9-3.3 1.6-4.9c1.4-3.2 3.6-6.1 6.5-8.4c12.5-10.4 24.9-20.8 37.4-31.2c1.2-1 2-2.6 2-4.2c0-2.1-1.2-4-3-4.9c-4.7-2.3-9.4-4.7-14-7c-9.5-4.7-17.2-12-22.6-20.6c-2.7-4.3-4.8-9.1-6.2-14c-.7-2.5-1.3-5-1.6-7.6c-.2-1.3-.3-2.6-.4-3.9c0-.7-.1-1.3-.1-2s0-1.3 0-2c0-6.7 0-13.5 0-20.3c0-1.9 0-2.4 0-2.9c0-.9 .1-1.9 .1-2.8z',
      'M192 128c-35.3 0-64 28.7-64 64l0 20.2c0 3 1.7 5.8 4.4 7.2l14 7c18.1 9.1 29.5 27.6 29.5 47.8c0 15.9-7 30.9-19.2 41.1l-37.4 31.2c-10.2 8.5-25.3 7.1-33.8-3.1s-7.1-25.3 3.1-33.8L126 278.4c1.2-1 2-2.6 2-4.2c0-2.1-1.2-4-3-4.9l-14-7c-19-9.5-31-28.9-31-50.1L80 192c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-35.3-28.7-64-64-64z',
    ],
  ],
};
const faFileLock = {
  prefix: 'fad',
  iconName: 'file-lock',
  icon: [
    576,
    512,
    [],
    'e3a6',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 33.6c-19.8 20.2-32 47.9-32 78.4l0 24.6c-19.1 11.1-32 31.7-32 55.4l0 128c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm80 80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
    ],
  ],
};
const faDiagramVenn = {
  prefix: 'fad',
  iconName: 'diagram-venn',
  icon: [
    640,
    512,
    [],
    'e15a',
    [
      'M192 256c0 61 24.4 116.4 64 156.8c23.6-4.8 45.4-14.8 64-28.8c-12.1-9.1-22.9-19.9-32-32c-7.4-9.8-13.7-20.6-18.7-32c-6.5-14.9-10.8-31.1-12.5-48c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16c1.7-16.9 6-33.1 12.5-48c5-11.4 11.3-22.2 18.7-32c9.1-12.1 19.9-22.9 32-32c-18.5-14-40.3-24-63.9-28.8C216.4 139.6 192 195 192 256zM320 53.6c12.2 5.8 23.8 12.7 34.6 20.5c.5 .3 1 .7 1.5 1.1c9.9 7.3 19.3 15.4 27.9 24.1c39.6 40.4 64 95.7 64 156.8c0 1.9 0 3.8-.1 5.7s-.1 3.8-.2 5.7c-.2 3.8-.5 7.5-.8 11.2c-.7 7.4-1.9 14.8-3.3 22c-2.9 14.4-7.2 28.3-12.7 41.6c-11.1 26.5-27.1 50.5-46.9 70.7c-9 9.2-18.8 17.6-29.3 25.2c-10.9 7.8-22.4 14.7-34.6 20.5c29.2 13.8 61.7 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6z',
      'M352 352l-64 0c-7.4-9.8-13.7-20.6-18.7-32l101.4 0c6.5-14.9 10.8-31.1 12.5-48l-126.4 0c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16l126.4 0c-1.7-16.9-6-33.1-12.5-48l-101.4 0c5-11.4 11.3-22.2 18.7-32l64 0c-29.2-38.9-75.7-64-128-64C135.6 96 64 167.6 64 256s71.6 160 160 160c52.3 0 98.8-25.1 128-64zM0 256a224 224 0 1 1 448 0A224 224 0 1 1 0 256z',
    ],
  ],
};
const faArrowDownFromBracket = {
  prefix: 'fad',
  iconName: 'arrow-down-from-bracket',
  icon: [
    448,
    512,
    [],
    'e667',
    [
      'M0 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96z',
      'M246.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 402.7 192 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128z',
    ],
  ],
};
const faXRay = {
  prefix: 'fad',
  iconName: 'x-ray',
  icon: [
    512,
    512,
    [],
    'f497',
    [
      'M32 96l0 320 448 0 0-320L32 96zm80 144c0-8.8 7.2-16 16-16l112 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 32 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 48c0 .4 0 .8 0 1.2l50.4-21.6c5.5-2.4 11.4-3.6 17.4-3.6l7.4 0c20.4 0 36.9 16.5 36.9 36.9c0 8.2-2.8 16.3-7.9 22.8l-19.4 24.8C347 376.8 332.1 384 316.4 384l-120.8 0c-15.7 0-30.6-7.2-40.3-19.6l-19.4-24.8c-5.1-6.5-7.9-14.5-7.9-22.8c0-20.4 16.5-36.9 36.9-36.9l7.4 0c6 0 11.9 1.2 17.4 3.6L240 305.2c0-.4 0-.8 0-1.2l0-48-112 0c-8.8 0-16-7.2-16-16zm80 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z',
    ],
  ],
};
const faGoalNet = {
  prefix: 'fad',
  iconName: 'goal-net',
  icon: [
    640,
    512,
    [],
    'e3ab',
    [
      'M96 208c0 8.8 7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16zm96 16l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z',
      'M96 96c-17.7 0-32 14.3-32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 128C0 75 43 32 96 32l448 0c53 0 96 43 96 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7-14.3-32-32-32L96 96z',
    ],
  ],
};
const faCoffinCross = {
  prefix: 'fad',
  iconName: 'coffin-cross',
  icon: [
    384,
    512,
    [],
    'e051',
    [
      'M0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1l127.9 0c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0l-131 0c-9.2 0-18 4-24.1 10.9l-91 104C4.1 123.3 0 134.2 0 145.4zM96 184c0-13.3 10.7-24 24-24l48 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-48 0c-13.3 0-24-10.7-24-24z',
      'M216 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 120c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-40z',
    ],
  ],
};
const faOctopus = {
  prefix: 'fad',
  iconName: 'octopus',
  icon: [
    640,
    512,
    [],
    'e688',
    [
      'M0 344c0 1.7 .2 3.4 .5 5.1l6.8 31.6c12.4 58 63.6 99.4 122.9 99.4l4.1 0c42.4 0 83.8-12.5 119-36l21.4-14.2c13.4-8.9 29.2-13.7 45.3-13.7s31.9 4.8 45.3 13.7L386.7 444c35.2 23.5 76.6 36 119 36l4.1 0c59.3 0 110.5-41.4 123-99.4l6.8-31.6c.4-1.7 .5-3.4 .5-5.1c0-11.1-7.7-21-19-23.4c-13-2.8-25.7 5.5-28.5 18.4l-6.8 31.6c-7.7 35.8-39.4 61.5-76 61.5c-41.1 0-74.8-31.9-77.6-72.4c-.1-1.8-.2-3.6-.2-5.4l0-1.4c0-4.5 .4-9.1 1.2-13.6l9.5-54.6 19.1-109.9c1.5-8.4 2.2-17 2.2-25.6l0-5.2C464 64.5 399.5 0 320 0S176 64.5 176 144c0 1.7 0 3.5 0 5.2c0 8.6 .7 17.1 2.2 25.6c9.5 54.9 19.1 109.7 28.6 164.6c.8 4.5 1.2 9 1.2 13.6l0 1.4c0 1.8-.1 3.6-.2 5.4c-2.8 40.4-36.4 72.4-77.6 72.4c-36.7 0-68.3-25.6-76-61.5L47.5 339c-2.8-13-15.5-21.2-28.5-18.4C7.7 322.9 0 332.9 0 344zm272-72a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M207.8 359.6c.1-1.8 .2-3.6 .2-5.4l0-1.4c0-4.5-.4-9.1-1.2-13.6L178.2 174.8c-1.5-8.4-2.2-17-2.2-25.6l0-5.2C176 64.5 240.5 0 320 0c0 0 0 0 0 0C240.5 0 176 64.5 176 144l0 5.2c0 8.6 .7 17.1 2.2 25.6l19 109.3c3.5 20.3-11.2 39.1-31.7 40.6c-16.3 1.2-31.2-9.2-35.8-24.8L118.8 263c-12.4-42.1-51-71-94.8-71c-13.3 0-24 10.7-24 24s10.7 24 24 24c22.6 0 42.4 14.9 48.8 36.5l10.9 36.9c11 37.3 46.5 62 85.3 59.2c14.4-1 27.7-5.7 38.9-13zm224.4 0c11.3 7.3 24.5 11.9 38.9 12.9c38.8 2.8 74.3-21.9 85.3-59.2l10.9-36.9c6.4-21.6 26.2-36.5 48.8-36.5c13.3 0 24-10.7 24-24s-10.7-24-24-24c-43.8 0-82.5 28.9-94.8 71l-10.9 36.9c-4.6 15.7-19.5 26-35.8 24.8c-20.3-1.5-35-20-31.8-40l-9.5 54.7c-.8 4.5-1.2 9-1.2 13.6l0 1.4c0 1.8 .1 3.6 .2 5.4zM272 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faSpellCheck = {
  prefix: 'fad',
  iconName: 'spell-check',
  icon: [
    576,
    512,
    [],
    'f891',
    [
      'M2.5 211.7c-6.8 16.3 .9 35 17.2 41.8c4 1.7 8.2 2.5 12.3 2.5c12.5 0 24.4-7.4 29.6-19.7L66.7 224l90.7 0 5.1 12.3c5.1 12.3 17 19.7 29.6 19.7c4.1 0 8.3-.8 12.3-2.5c16.3-6.8 24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0S87.4 7.8 82.5 19.7l-66.7 160-13.3 32zM93.3 160L112 115.2 130.7 160l-37.3 0zM256 32l0 96 0 96c0 17.7 14.3 32 32 32l80 0c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80L288 0c-17.7 0-32 14.3-32 32zm64 32l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0-32zm0 96l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0-32z',
      'M566.6 265.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L352 434.7 521.4 265.4c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faLocationXmark = {
  prefix: 'fad',
  iconName: 'location-xmark',
  icon: [
    384,
    512,
    ['map-marker-times', 'map-marker-xmark'],
    'f60e',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm104.1 61.7c.1-.8 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.4 31.4 47 47c15.7-15.7 31.4-31.4 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.3 31.4-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.2-1.1-.4-2.3-.3-2.3c-.1-1.2-.1-1.2-.1-2.3c0-1.5 .1-1.9 .1-2.3z',
      'M145 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faMapMarkerTimes = faLocationXmark;
const faMapMarkerXmark = faLocationXmark;
const faCircleQuarterStroke = {
  prefix: 'fad',
  iconName: 'circle-quarter-stroke',
  icon: [
    512,
    512,
    [],
    'e5d3',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0l0 64c106 0 192 86 192 192s-86 192-192 192S64 362 64 256L0 256z',
      'M256 0C114.6 0 0 114.6 0 256l224 0c17.7 0 32-14.3 32-32L256 0z',
    ],
  ],
};
const faLasso = {
  prefix: 'fad',
  iconName: 'lasso',
  icon: [
    576,
    512,
    [],
    'f8c8',
    [
      'M576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121l-71 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l71 0c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4 .2-.4C44.7 284.1 0 233.2 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 288c123.7 0 224-50.1 224-112s-100.3-112-224-112S64 114.1 64 176s100.3 112 224 112z',
      '',
    ],
  ],
};
const faSlash = {
  prefix: 'fad',
  iconName: 'slash',
  icon: [
    640,
    512,
    [],
    'f715',
    [
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
      '',
    ],
  ],
};
const faPersonToPortal = {
  prefix: 'fad',
  iconName: 'person-to-portal',
  icon: [
    512,
    512,
    ['portal-enter'],
    'e022',
    [
      'M352.7 222.4c3.2 1 6.5 1.6 10 1.6l21.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-21.3 0c-.8 0-1.7 0-2.5 0c-.9 0-1.7-.1-2.5-.1c-1.7-.1-3.4-.2-5-.4C357.4 414 391.1 512 432 512c44.2 0 80-114.6 80-256S476.2 0 432 0c-40.6 0-74.2 96.9-79.3 222.4z',
      'M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352L32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z',
    ],
  ],
};
const faPortalEnter = faPersonToPortal;
const faCalendarStar = {
  prefix: 'fad',
  iconName: 'calendar-star',
  icon: [
    448,
    512,
    [],
    'f736',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM132.6 324.1l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L224 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM233.3 250.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L224 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z',
    ],
  ],
};
const faComputerMouse = {
  prefix: 'fad',
  iconName: 'computer-mouse',
  icon: [
    384,
    512,
    [128433, 'mouse'],
    'f8cc',
    [
      'M0 160C0 71.6 71.6 0 160 0l16 0 0 192L0 192l0-32zm0 64l192 0 192 0 0 128c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 224zM208 0l16 0c88.4 0 160 71.6 160 160l0 32-176 0L208 0z',
      'M176 192L0 192l0 32 192 0 192 0 0-32-176 0L208 0 176 0l0 192z',
    ],
  ],
};
const faMouse = faComputerMouse;
const faArrowRightToBracket = {
  prefix: 'fad',
  iconName: 'arrow-right-to-bracket',
  icon: [
    512,
    512,
    ['sign-in'],
    'f090',
    [
      'M320 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32z',
      'M342.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z',
    ],
  ],
};
const faSignIn = faArrowRightToBracket;
const faPegasus = {
  prefix: 'fad',
  iconName: 'pegasus',
  icon: [
    576,
    512,
    [],
    'f703',
    [
      'M0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256z',
      'M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C378.4 0 321.7 55.6 320 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1c0 48.1 3.8 99.9 26 139.8c9.2 16.6 21.7 31.3 38.2 42.7c-7.2-2.5-14-5.4-20.3-8.8c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43C96 134.3 64 169.8 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faFilesMedical = {
  prefix: 'fad',
  iconName: 'files-medical',
  icon: [
    448,
    512,
    [],
    'f7fd',
    [
      'M96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-256-64 0c-17.7 0-32-14.3-32-32l0-64L160 0C124.7 0 96 28.7 96 64zm80 176c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z',
      'M352 64l0-64 96 96-64 0c-17.7 0-32-14.3-32-32zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24zm216 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faCannon = {
  prefix: 'fad',
  iconName: 'cannon',
  icon: [
    640,
    512,
    [],
    'e642',
    [
      'M0 408c0-17.6 9.7-34.6 26.5-43l22.5-11.3c1 7.9 2.6 15.8 5 23.6c1.2 3.9 2.5 7.8 4.1 11.6c.8 1.9 1.6 3.8 2.4 5.8c.4 .9 .8 1.9 1.3 2.9c.4 .9 .8 1.7 1.3 2.7c7.5 15 17.3 28.2 28.8 39.3L69.5 450.9c-23.7 11.9-52.5 2.2-64.4-21.5C1.6 422.6 0 415.3 0 408zm288-40c0-61.9 50.1-112 112-112c41.3 0 77.4 22.4 96.8 55.6c9.7 16.6 15.2 35.8 15.2 56.4c0 61.9-50.1 112-112 112c-37.4 0-70.5-18.3-90.9-46.5C295.8 415.1 288 392.5 288 368zm80 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M256.4 464.8c-71.1 35.6-157.6 6.7-193.2-64.4s-6.7-157.6 64.4-193.2c49.5-24 287.2-107.9 394.6-145.5c30.3-10.6 63.6 3.1 78 31.8L630.9 155c14.4 28.7 5.3 63.6-21.4 81.5C580.3 256.1 540 283 496.8 311.6C477.4 278.4 441.3 256 400 256c-61.9 0-112 50.1-112 112c0 24.5 7.8 47.1 21.2 65.5c-23.4 14.6-42 25.7-52.7 31.3z',
    ],
  ],
};
const faNfcLock = {
  prefix: 'fad',
  iconName: 'nfc-lock',
  icon: [
    576,
    512,
    [],
    'e1f8',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l256 0 0-64-208 0c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l208 0 0-32c0-23.7 12.9-44.4 32-55.4l0-24.6 0-128c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16l0 66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48l0 49.6c16.8-17.1 39.1-28.9 64-32.5L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faPersonSkiLift = {
  prefix: 'fad',
  iconName: 'person-ski-lift',
  icon: [
    512,
    512,
    ['ski-lift'],
    'f7c8',
    [
      'M2.3 210.4l65 135.8c18.3 38.4 61.5 58.1 102.5 46.9l36.5-9.9c12.8-3.5 20.3-16.7 16.8-29.5s-16.7-20.3-29.5-16.8l-36.5 9.9c-18.7 5.1-38.3-3.9-46.6-21.3l-65-135.8c-5.7-12-20-17-32-11.3s-17 20-11.3 32zm95.1 286C101.1 506 110.2 512 120 512c2.8 0 5.6-.5 8.3-1.5L459.7 388c31.4-11.6 52.3-41.6 52.3-75l0-1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1c0 13.4-8.3 25.4-20.9 30c-41 15.2-82.1 30.3-123.1 45.5c-21.3 7.9-42.7 15.8-64 23.7L111.7 465.5c-12.4 4.6-18.8 18.4-14.2 30.8zM224 16l0 190.8 32-8.5L256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80zm36.4 138c-14.2-30.8 8.3-66 42.2-66c18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6l0 122.1-64 23.7 0-114.5-66.7 17.8c-22.6 6-46.2-5.1-55.9-26.3L100.4 218z',
    ],
  ],
};
const faSkiLift = faPersonSkiLift;
const faSquare6 = {
  prefix: 'fad',
  iconName: 'square-6',
  icon: [
    448,
    512,
    [],
    'e25b',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 288c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4c9.9-8.5 19.7-16.9 29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8c-4.7-5.5-11.5-8.4-18.2-8.4c-5.5 0-11.1 1.9-15.6 5.8c-27.2 23.3-54.4 46.6-81.6 70C142.2 224.8 128 255.6 128 288zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M279.6 170.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4zM272 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
    ],
  ],
};
const faShopSlash = {
  prefix: 'fad',
  iconName: 'shop-slash',
  icon: [
    640,
    512,
    ['store-alt-slash'],
    'e070',
    [
      'M0 155.2c0-7.3 2.2-14.4 6.2-20.4L21 112.5 121.8 192l-85 0C16.5 192 0 175.5 0 155.2zM64 224l64 0 0 160 192 0 0-35.9 64 50.4 0 65.5c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-80 0-160zM74.1 32.8l7.6-11.4C90.7 8 105.6 0 121.7 0L518.3 0c16.1 0 31 8 39.9 21.4l75.6 113.3c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8l-325.9 0C209.5 138.9 141.8 85.9 74.1 32.8zM320 224l64 0 0 51.7-64-50.2 0-1.5zm192 0l64 0 0 202.2c-21.3-16.7-42.7-33.4-64-50.2l0-152z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faStoreAltSlash = faShopSlash;
const faWindTurbine = {
  prefix: 'fad',
  iconName: 'wind-turbine',
  icon: [
    512,
    512,
    [],
    'f89b',
    [
      'M128 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-94.3c-21.3-34.7-42.7-69.3-64-104L224 464l-72 0c-13.3 0-24 10.7-24 24z',
      'M345.2 404.1c2.5 17.2-20.3 25.5-29.5 10.7L214 249.4c-1.8-2.9-4.5-5.2-7.7-6.5L25.7 171.4C9.5 165 13.7 141 31.1 140.6l194.1-5.4c3.5-.1 6.8-1.3 9.5-3.5L387 11c13.6-10.8 32.3 4.8 24 20.1L318.6 202c-1.6 3-2.3 6.5-1.8 9.9l28.4 192.1zM256 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faSlidersSimple = {
  prefix: 'fad',
  iconName: 'sliders-simple',
  icon: [
    512,
    512,
    [],
    'e253',
    [
      'M0 160c0 17.7 14.3 32 32 32l293.5 0c-3.5-10-5.5-20.8-5.5-32c0-1.4 0-2.8 .1-4.2s.1-2.8 .3-4.1c.2-2.7 .6-5.5 1-8.1c.9-5.3 2.3-10.5 4.1-15.5L32 128c-17.7 0-32 14.3-32 32zM186.5 320c3.5 10 5.5 20.8 5.5 32c0 1.4 0 2.8-.1 4.2s-.1 2.8-.3 4.1c-.2 2.7-.6 5.5-1 8.1c-.9 5.3-2.3 10.5-4.1 15.5L480 384c17.7 0 32-14.3 32-32s-14.3-32-32-32l-293.5 0z',
      'M416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-128a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM96 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-128a96 96 0 1 0 0 192 96 96 0 1 0 0-192z',
    ],
  ],
};
const faGridRound = {
  prefix: 'fad',
  iconName: 'grid-round',
  icon: [
    448,
    512,
    [],
    'e5da',
    [
      'M0 256a64 64 0 1 0 128 0A64 64 0 1 0 0 256zM160 96a64 64 0 1 0 128 0A64 64 0 1 0 160 96zm0 320a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM320 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 320A64 64 0 1 1 0 416a64 64 0 1 1 128 0zm96-96a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM448 96A64 64 0 1 1 320 96a64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z',
    ],
  ],
};
const faBadgeSheriff = {
  prefix: 'fad',
  iconName: 'badge-sheriff',
  icon: [
    448,
    512,
    [],
    'f8a2',
    [
      'M160 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M272 48c0 14.8-6.7 28-17.2 36.8l25 42.8c5.7 9.8 16.2 15.8 27.5 15.9l47.6 .2c6.7-18.5 24.4-31.7 45.2-31.7c26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L363 240.1c-5.6 9.8-5.6 21.9 0 31.8l20.1 35.2c5.3-2 10.9-3.1 16.9-3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-47.6 .2c-11.3 0-21.8 6.1-27.5 15.9l-25 42.8c10.5 8.8 17.2 22 17.2 36.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8l-25-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-47.6-.2C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L85 271.9c5.6-9.8 5.6-21.9 0-31.8L64.9 204.9c-5.3 2-10.9 3.1-16.9 3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l47.6-.2c11.3 0 21.8-6.1 27.5-15.9l25-42.8C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faServer = {
  prefix: 'fad',
  iconName: 'server',
  icon: [
    512,
    512,
    [],
    'f233',
    [
      'M0 352l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64zm368 32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm24-256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm56 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm32 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faVirusCovidSlash = {
  prefix: 'fad',
  iconName: 'virus-covid-slash',
  icon: [
    640,
    512,
    [],
    'e4a9',
    [
      'M64 216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 33.6 0c.9-6.3 2-12.4 3.5-18.5L401.3 412.2c-17.6 9.2-36.9 15.4-57.3 18.2l0 33.6 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L189.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-56.6-56.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L156 386.1l23.8-23.8c-17.9-23.5-29.9-51.7-34.1-82.3L112 280l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80zM134.1 79.8l33.1-33.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L189.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1L296 48l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 33.6c30.7 4.2 58.8 16.3 82.3 34.1L450.1 92 438.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L484 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3l33.6 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-33.6 0c-3.2 23.3-10.9 45.2-22.3 64.7C359.4 256.4 246.8 168.1 134.1 79.8z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faIntersection = {
  prefix: 'fad',
  iconName: 'intersection',
  icon: [
    384,
    512,
    [8898],
    'f668',
    [
      'M32 480c17.7 0 32-14.3 32-32l0-224c0-70.7 57.3-128 128-128s128 57.3 128 128l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224c0-106-86-192-192-192S0 118 0 224L0 448c0 17.7 14.3 32 32 32z',
      '',
    ],
  ],
};
const faShopLock = {
  prefix: 'fad',
  iconName: 'shop-lock',
  icon: [
    640,
    512,
    [],
    'e4a5',
    [
      'M0 155.2C0 175.5 16.5 192 36.8 192l412.8 0c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4zM64 224l0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-80 0-32 0-128-64 0 0 160-192 0 0-160-64 0z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faFamily = {
  prefix: 'fad',
  iconName: 'family',
  icon: [
    512,
    512,
    [],
    'e300',
    [
      'M21.8 282.7c-.2 1.8-.2 3.6-.2 5.4c0 27.5 17.6 51.3 42.4 60.2L64 464c0 26.5 21.5 48 48 48l32 0c13.5 0 25.7-5.6 34.4-14.5c-1.6-5.5-2.4-11.4-2.4-17.5l0-56.4c-19.6-17.6-32-43.1-32-71.6l0-16c0-43.1 24.3-80.5 60-99.2c-17.1-14.7-28-36.5-28-60.8c0-3.9 .3-7.8 .8-11.5c-8.3-2.9-17.2-4.5-26.4-4.5l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM308 236.8c35.7 18.7 60 56.1 60 99.2l0 16c0 28.4-12.4 54-32 71.6l0 56.4c0 6.1-.8 11.9-2.4 17.5c8.7 9 20.9 14.5 34.4 14.5l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c18.2 0 32-14.9 32-31.9c0-2.9-.4-5.9-1.3-8.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1c0 24.3-10.9 46.1-28 60.8zM320 64a64 64 0 1 0 128 0A64 64 0 1 0 320 64z',
      'M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 336c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16c0 23.7-12.9 44.4-32 55.4l0 72.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-72.6c-19.1-11.1-32-31.7-32-55.4l0-16z',
    ],
  ],
};
const faHourglassStart = {
  prefix: 'fad',
  iconName: 'hourglass-start',
  icon: [
    384,
    512,
    ['hourglass-1'],
    'f251',
    [
      'M32 64l32 0 32 0 192 0 32 0 32 0 0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11-64 0 0-11c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9l0 11-64 0 0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faHourglass1 = faHourglassStart;
const faUserHairBuns = {
  prefix: 'fad',
  iconName: 'user-hair-buns',
  icon: [
    448,
    512,
    [],
    'e3d3',
    [
      'M128 112l0 64c0 5.5 .5 10.8 1.3 16c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80c.9-5.2 1.3-10.5 1.3-16l0-64-32 0c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32l-32 0z',
      'M109.8 70.1C131 28.5 174.1 0 224 0s93 28.5 114.2 70.1c6.8-3.9 14.7-6.1 23.1-6.1c25.8 0 46.7 20.9 46.7 46.7l0 25.3c0 30.9-25.1 56-56 56l-33.3 0c.9-5.2 1.3-10.5 1.3-16l0-64-32 0c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32l-32 0 0 64c0 5.5 .5 10.8 1.3 16L96 192c-30.9 0-56-25.1-56-56l0-25.3C40 84.9 60.9 64 86.7 64c8.4 0 16.2 2.2 23.1 6.1zM0 481.3C0 392.2 72.2 320 161.3 320l125.4 0C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3z',
    ],
  ],
};
const faBlenderPhone = {
  prefix: 'fad',
  iconName: 'blender-phone',
  icon: [
    576,
    512,
    [],
    'f6b6',
    [
      'M196.2 47.9c0 1.3 .1 2.7 .2 4.1L224 384l256 0 24-96-104 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 16-64-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l136 0 16-64L400 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0 6.1-24.2C571.1 19.6 555.8 0 535 0L244.2 0c-26.7 0-48 21.7-48 47.9z',
      'M147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2zM560 64l-8 32L400 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0zm-24 96l-8 32-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l136 0zm-24 96l-8 32-104 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0zM208 384l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faHourglassClock = {
  prefix: 'fad',
  iconName: 'hourglass-clock',
  icon: [
    576,
    512,
    [],
    'e41b',
    [
      'M0 32C0 49.7 14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 10.8 0c-23.3-16.4-42.5-38.4-55.6-64L96 448l0-11c0-25.5 10.1-49.9 28.1-67.9L192 301.3l64 64c.4-26.2 6.5-51.1 17.2-73.3l-36-36 67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0C14.3 0 0 14.3 0 32zM96 64l192 0 0 11c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75l0-11z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faPersonSeatReclined = {
  prefix: 'fad',
  iconName: 'person-seat-reclined',
  icon: [
    512,
    512,
    [],
    'e21f',
    [
      'M32.5 165.9L65.9 343.6C77.2 404.1 130.1 448 191.7 448l80.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80.3 0c-30.8 0-57.2-21.9-62.9-52.2L95.5 154.1C92.6 138.7 79.1 128 64 128c-2 0-3.9 .2-5.9 .6c-17.4 3.3-28.8 20-25.6 37.3z',
      'M128 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM257 256l8 32 53.8 0c33.3 0 63.2 20.7 74.9 51.9l25.5 68 18.7-6.2c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5l-48 16c-16.3 5.4-34-3-40.1-19.1l-36.3-96.9c-2.3-6.2-8.3-10.4-15-10.4l-78.1 0c-.5 0-.9 0-1.4 0l-6.3 0c-29.4 0-55-20-62.1-48.5L149.8 219c-7.5-30 15.2-59 46.1-59c20.4 0 38.4 13 44.9 32l79.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-63 0z',
    ],
  ],
};
const faPaperPlaneTop = {
  prefix: 'fad',
  iconName: 'paper-plane-top',
  icon: [
    512,
    512,
    ['paper-plane-alt', 'send'],
    'e20a',
    [
      'M1.4 72.3c0 6.1 1.4 12.4 4.7 18.6l70 134.6c63.3 7.9 126.6 15.8 190 23.7c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-190 23.7L6.1 421.1c-14.6 28.1 7.3 58.6 35.2 58.6c5.3 0 10.8-1.1 16.3-3.5L492.9 285.3c11.6-5.1 19.1-16.6 19.1-29.3s-7.5-24.2-19.1-29.3L57.6 35.8C29.5 23.5 1.4 45.6 1.4 72.3z',
      'M76.1 286.5l190-23.7c3.4-.4 6-3.3 6-6.7s-2.6-6.3-6-6.7l-190-23.7 8.2 15.7c4.8 9.3 4.8 20.3 0 29.5l-8.2 15.7z',
    ],
  ],
};
const faPaperPlaneAlt = faPaperPlaneTop;
const faSend = faPaperPlaneTop;
const faMessageArrowUp = {
  prefix: 'fad',
  iconName: 'message-arrow-up',
  icon: [
    512,
    512,
    ['comment-alt-arrow-up'],
    'e1dc',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM160 192c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l31-31L232 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-118.1 31 31c9.4 9.4 24.6 9.4 33.9 0c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17l-72-72c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7l-72 72c-4.7 4.7-7 10.8-7 17z',
      'M256 320c13.3 0 24-10.7 24-24l0-118.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 296c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faCommentAltArrowUp = faMessageArrowUp;
const faLightbulbExclamation = {
  prefix: 'fad',
  iconName: 'lightbulb-exclamation',
  icon: [
    384,
    512,
    [],
    'f671',
    [
      'M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176zM224 288a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM168 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M192 512c44.2 0 80-35.8 80-80V384H112v48c0 44.2 35.8 80 80 80z',
    ],
  ],
};
const faLayerMinus = {
  prefix: 'fad',
  iconName: 'layer-minus',
  icon: [
    576,
    512,
    ['layer-group-minus'],
    'f5fe',
    [
      'M32 256c0 9.4 5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101C304 129.7 296 128 288 128s-16 1.7-23.5 5.2L45.9 234.2C37.4 238.1 32 246.6 32 256zm0 128c0 9.4 5.4 17.9 13.9 21.8l218.6 101C272 510.2 280 512 288 512s16-1.7 23.5-5.2l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384z',
      'M384 80c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faLayerGroupMinus = faLayerMinus;
const faChartPieSimpleCircleCurrency = {
  prefix: 'fad',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [
    640,
    512,
    [],
    'e604',
    [
      'M0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368c0-28.8 6.9-56 19.2-80L224 288l0-221.3c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272zM272 16.6L272 240l103.2 0c31.5-29.8 74-48 120.8-48c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM460.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426c-21.6 13.2-49.1 13.2-70.7 0z',
    ],
  ],
};
const faCircleE = {
  prefix: 'fad',
  iconName: 'circle-e',
  icon: [
    512,
    512,
    [],
    'e109',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104z',
      'M160 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104z',
    ],
  ],
};
const faBuildingWheat = {
  prefix: 'fad',
  iconName: 'building-wheat',
  icon: [
    640,
    512,
    [],
    'e4db',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M640 208l0-16-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80zm0 96l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zm0 112l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zM512 512l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zm0-128c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0 0-16zm0-96l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zM552 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104zm48 16c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24zM480 96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32z',
    ],
  ],
};
const faGaugeMax = {
  prefix: 'fad',
  iconName: 'gauge-max',
  icon: [
    512,
    512,
    ['tachometer-alt-fastest'],
    'f626',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM64 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm48-112a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 208c0 35.3 28.7 64 64 64c17.7 0 33.7-7.2 45.3-18.7c5.8-5.8 10.5-12.7 13.7-20.3c1.6-3.8 2.9-7.8 3.7-12c.4-2.1 .8-4.2 1-6.4c.1-1.1 .2-2.2 .2-3.2c.1-1.1 .1-2.2 .1-3.3c0-.9 0-1.8-.1-2.7s-.1-1.8-.2-2.7c-.2-1.8-.4-3.6-.7-5.4c39.2-24.3 78.4-48.5 117.5-72.8c3.7-2.3 6.5-5.4 8.4-8.9c1-1.8 1.7-3.6 2.2-5.6c.2-1 .4-2 .6-2.9c.1-.5 .1-1 .1-1.5c0-.3 0-.5 0-1.5l-.1-1.7c0 0-.1-.8-.2-1.6c-.1-1.1-.4-2.1-.7-3.2c-.6-2.1-1.5-4.2-2.7-6.2c-7-11.3-21.8-14.8-33-7.8c-39.2 24.3-78.4 48.5-117.5 72.8C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64zM224 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm112 48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M411.4 227.6c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.5-72.8z',
    ],
  ],
};
const faTachometerAltFastest = faGaugeMax;
const faPersonBreastfeeding = {
  prefix: 'fad',
  iconName: 'person-breastfeeding',
  icon: [
    448,
    512,
    [],
    'e53a',
    [
      'M128 320l0 48c0 .8 0 1.6 .1 2.4l101.4 50.7c.6 .3 1.2 .6 1.7 .9s1.1 .6 1.7 1c1.1 .7 2.1 1.4 3.2 2.1c2 1.5 3.9 3.1 5.7 4.8c3.5 3.4 6.4 7.4 8.7 11.6c4.5 8.5 6.4 18.3 5.3 28c8.8 2.4 17.8 4.2 27 5.6l32.8 4.7c3.8 .6 7.6 .4 11.2-.4c.5-.1 .5-.1 .5-.1c-7.5-1.4-14.8-4.6-21.2-9.7c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8l0-36.8c0-17.7-14.3-32-32-32s-32 14.3-32 32zm104 12a44 44 0 1 0 88 0 44 44 0 1 0 -88 0z',
      'M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8l0-36.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1l75.2 0c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z',
    ],
  ],
};
const faApostrophe = {
  prefix: 'fad',
  iconName: 'apostrophe',
  icon: [
    192,
    512,
    [],
    '27',
    [
      'M72 352c66.3 0 120-53.7 120-120l0-72 0-32 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l64 0 0 8c0 30.9-25.1 56-56 56l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0z',
      '',
    ],
  ],
};
const faFilePng = {
  prefix: 'fad',
  iconName: 'file-png',
  icon: [
    512,
    512,
    [],
    'e666',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM318.3 360.8c-3.3-6.6-10.8-10.1-18-8.4s-12.3 8.2-12.3 15.6l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-60.2 33.7 67.4c3.3 6.6 10.8 10.1 18 8.4s12.3-8.2 12.3-15.6l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 60.2-33.7-67.4zM176 352c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm208-40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40z',
    ],
  ],
};
const faFireHydrant = {
  prefix: 'fad',
  iconName: 'fire-hydrant',
  icon: [
    384,
    512,
    [],
    'e17f',
    [
      'M16 304l0 64c0 17.7 14.3 32 32 32l16 0 0-128-16 0c-17.7 0-32 14.3-32 32zM32 152c0 13.3 10.7 24 24 24l8 0 256 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-12 0c-11.6-45-47-80.4-92-92l0-4c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 4c-45 11.6-80.4 47-92 92l-12 0c-13.3 0-24 10.7-24 24zM320 272l0 128 16 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-16 0z',
      'M64 176l256 0 0 288 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0L64 512l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-288zM192 400a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faRightToBracket = {
  prefix: 'fad',
  iconName: 'right-to-bracket',
  icon: [
    512,
    512,
    ['sign-in-alt'],
    'f2f6',
    [
      'M320 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32z',
      'M340.7 228.7L217.9 105.9c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L340.7 283.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z',
    ],
  ],
};
const faSignInAlt = faRightToBracket;
const faVideoPlus = {
  prefix: 'fad',
  iconName: 'video-plus',
  icon: [
    576,
    512,
    [],
    'f4e1',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-68.2 0-119.6 0-68.2c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zM96 256c0-13.3 10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24z',
      'M559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 315.8l0-119.6 142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM216 184l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faSquareRight = {
  prefix: 'fad',
  iconName: 'square-right',
  icon: [
    448,
    512,
    [10145, 'arrow-alt-square-right'],
    'f352',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 240c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L262.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C234 384 224 374 224 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32z',
      'M362.5 242.2L262.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C234 128 224 138 224 150.3l0 57.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8z',
    ],
  ],
};
const faArrowAltSquareRight = faSquareRight;
const faCommentSmile = {
  prefix: 'fad',
  iconName: 'comment-smile',
  icon: [
    512,
    512,
    [],
    'f4b4',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm148.7 64c-8.8-9.9-8-25 1.9-33.9s25-8 33.9 1.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9c5.3 4.7 8 11.3 8 17.9c0 5.7-2 11.4-6.1 16C337 333.4 298.6 352 256 352s-81-18.6-107.3-48zM224 176a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M224 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 272c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z',
    ],
  ],
};
const faVenus = {
  prefix: 'fad',
  iconName: 'venus',
  icon: [
    384,
    512,
    [9792],
    'f221',
    [
      'M112 176a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9z',
    ],
  ],
};
const faPassport = {
  prefix: 'fad',
  iconName: 'passport',
  icon: [
    448,
    512,
    [],
    'f5ab',
    [
      'M96 192a128 128 0 1 0 256 0A128 128 0 1 0 96 192zm33.3-16c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0zm0 32l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zm71.1-32c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.6 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0zm0 32l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.6 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5zM265 105.2c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0c-1.6-30.4-7.7-53.8-14.6-70.8zm0 173.6c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8z',
      'M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0z',
    ],
  ],
};
const faThumbtackSlash = {
  prefix: 'fad',
  iconName: 'thumbtack-slash',
  icon: [
    640,
    512,
    ['thumb-tack-slash'],
    'e68f',
    [
      'M128 320c0 6.6 2.1 13.2 6 18.7c6 8.3 15.7 13.3 26 13.3l164.9 0L177.1 235.6c-20.9 18.9-37.2 43.3-46.5 71.3l-1 3c-1.1 3.3-1.6 6.7-1.6 10.1zM160 32c0 17.7 14.3 32 32 32l29.5 0-6.1 79.5L481.4 352c9.8-.4 18.9-5.3 24.6-13.3c6-8.3 7.7-19.1 4.4-28.8l-1-3c-13.8-41.5-42.8-74.8-79.5-94.7L418.5 64 448 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32zM288 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96-64 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faThumbTackSlash = faThumbtackSlash;
const faInboxIn = {
  prefix: 'fad',
  iconName: 'inbox-in',
  icon: [
    512,
    512,
    [128229, 'inbox-arrow-down'],
    'f310',
    [
      'M0 368l0 96c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-76.2 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L48 320c-26.5 0-48 21.5-48 48z',
      'M256 0c17.7 0 32 14.3 32 32l0 178.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 224 32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faInboxArrowDown = faInboxIn;
const faHeartPulse = {
  prefix: 'fad',
  iconName: 'heart-pulse',
  icon: [
    512,
    512,
    ['heartbeat'],
    'f21e',
    [
      'M0 185.1l0 5.8c0 17.3 3 34.3 8.7 50.2c2.3-.7 4.8-1.1 7.3-1.1l106.7 0c3.2 0 6.1-1.9 7.4-4.9l31.8-76.3c3.7-8.8 12.3-14.6 21.8-14.8s18.3 5.4 22.2 14.1l51.3 113.9 41.4-82.8c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3l23.2 46.3c1.4 2.7 4.1 4.4 7.2 4.4l132 0c5.4-15.6 8.3-32.2 8.3-49.1l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1zM35.7 288c3.7 4.3 7.7 8.5 11.9 12.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c4.2-3.9 8.2-8.1 11.9-12.4l-104.5 0c-21.2 0-40.6-12-50.1-31l-1.7-3.4-42.5 85.1c-4.1 8.3-12.7 13.5-22 13.3s-17.6-5.7-21.4-14.1L184.8 228.4l-10.5 25.2c-8.7 20.9-29.1 34.5-51.7 34.5l-87 0z',
      'M35.7 288l87 0c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31l104.5 0c12.1-14.2 21.4-30.5 27.4-48l-132 0c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9L16 240c-2.6 0-5 .4-7.3 1.1c6.1 17 15.2 32.9 27 46.9z',
    ],
  ],
};
const faHeartbeat = faHeartPulse;
const faCircle8 = {
  prefix: 'fad',
  iconName: 'circle-8',
  icon: [
    512,
    512,
    [],
    'e0f5',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 48c0-25 11.5-47.4 29.5-62C181 230.1 176 215.7 176 200c0-39.8 32.2-72 72-72l16 0c39.8 0 72 32.2 72 72c0 15.7-5 30.1-13.5 42c18 14.7 29.5 37 29.5 62c0 44.2-35.8 80-80 80l-32 0c-44.2 0-80-35.8-80-80zm48 0c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0-16 0-8 0c-17.7 0-32 14.3-32 32zm16-104c0 13.2 10.7 24 24 24l16 0c13.3 0 24-10.8 24-24c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24z',
      'M336 200c0-39.8-32.2-72-72-72l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42zm-72 72l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c0 0 0 0 0 0l16 0c0 0 0 0 0 0zm0-48L248 224c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
    ],
  ],
};
const faCloudsMoon = {
  prefix: 'fad',
  iconName: 'clouds-moon',
  icon: [
    640,
    512,
    [],
    'f745',
    [
      'M352 160C352 71.7 423.4 0 511.5 0c4.6 0 9.1 .2 13.5 .6c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-35.4 20.1-59.3 58.2-59.3 101.9c0 64.6 52.2 116.9 116.5 116.9c6.8 0 13.5-.6 20-1.7c6.9-1.2 13.8 2.2 17 8.5c1.2 2.3 1.8 4.8 1.8 7.3c0 4.2-1.7 8.4-4.8 11.5C594 302.8 554.8 320 511.5 320c-3.8 0-7.5-.1-11.2-.4c-11.3-9.9-24.2-17.8-38.5-23.2c-9.9-53.2-52.6-94.8-106.4-103c-2.3-10.8-3.5-22-3.5-33.4z',
      'M208.1 224c12.9 0 25.3 2.2 36.8 6.2c19.6-19.9 45.8-33.5 75-37.2l0-.9c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c16.1 0 30.9-5.3 42.9-14.1c20.1-30.1 54.3-49.9 93.2-49.9zM64 431.9c0 44.2 35.8 80 80 80l271.9 0c53 0 96-43 96-96c0-47.6-34.6-87-80-94.6l0-1.3c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 431.9z',
    ],
  ],
};
const faClockTenThirty = {
  prefix: 'fad',
  iconName: 'clock-ten-thirty',
  icon: [
    512,
    512,
    [],
    'e355',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm140-77.3c4.6-6.9 12.2-10.7 20-10.7c4.6 0 9.2 1.3 13.3 4c32 21.3 64 42.7 96 64C276 240.5 280 248 280 256c0 45.3 0 90.7 0 136c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.5c0-41 0-82.1 0-123.2c-28.4-19-56.9-37.9-85.3-56.9c-11-7.4-14-22.3-6.7-33.3z',
      'M256 416c13.3 0 24-10.7 24-24l0-136c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8 232 392c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faPeopleCarryBox = {
  prefix: 'fad',
  iconName: 'people-carry-box',
  icon: [
    640,
    512,
    ['people-carry'],
    'f4ce',
    [
      'M224 160l0 76.2 46.3 23.2c15.8 7.9 22.2 27.1 14.3 42.9c-.7 1.4-1.5 2.7-2.3 3.9s-1.8 2.4-2.8 3.5c-2 2.2-4.2 4-6.7 5.5c-4.9 3-10.5 4.7-16.2 4.8l126.7 0c-11.5-.2-22.5-6.7-28-17.7c-7.9-15.8-1.5-35 14.3-42.9c15.4-7.7 30.9-15.4 46.3-23.2l0-76.2c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z',
      'M176 48A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM144 306.7l0-65.1 19 28.5c4.6 7 11 12.6 18.5 16.3l60.2 30.1c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-56.4-28.2L166.5 160c-13.3-20-35.8-32-59.9-32C74.2 128 48 154.2 48 186.6l0 88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM2.3 468.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8l37.6-94L50.1 348.6 2.3 468.1zM464 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm32 258.7l-51 51c-7.1 7.1-11.8 16.2-13.4 26.1l-15.2 90.9c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l14.3-85.9L573.3 320c12-12 18.7-28.3 18.7-45.3l0-88.1c0-32.4-26.2-58.6-58.6-58.6c-24.1 0-46.5 12-59.9 32l-47.4 71.1-56.4 28.2c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l60.2-30.1c7.5-3.7 13.8-9.4 18.5-16.3l19-28.5 0 65.1zM637.7 468.1L589.9 348.6l-49.2 49.2 37.6 94c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6z',
    ],
  ],
};
const faPeopleCarry = faPeopleCarryBox;
const faFolderUser = {
  prefix: 'fad',
  iconName: 'folder-user',
  icon: [
    512,
    512,
    [],
    'e18e',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM144 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7l-202.7 0c-5.9 0-10.7-4.8-10.7-10.7zM320 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-58.7 32c-29.5 0-53.3 23.9-53.3 53.3c0 5.9 4.8 10.7 10.7 10.7l202.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-117.3 0z',
    ],
  ],
};
const faTrashCanXmark = {
  prefix: 'fad',
  iconName: 'trash-can-xmark',
  icon: [
    448,
    512,
    [],
    'e2ae',
    [
      'M32 96l384 0 0 352c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 96zM143 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l47-47 47 47c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
      'M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM143 207c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faTemperatureHigh = {
  prefix: 'fad',
  iconName: 'temperature-high',
  icon: [
    512,
    512,
    [],
    'f769',
    [
      'M0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L256 112C256 50.2 205.9 0 144 0S32 50.2 32 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368zm64 0c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5L96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM144 96c-8.8 0-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 112c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faMicrochip = {
  prefix: 'fad',
  iconName: 'microchip',
  icon: [
    512,
    512,
    [],
    'f2db',
    [
      'M0 152c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM0 256c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM0 360c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM128 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zm32-288l0 192 192 0 0-192-192 0zM232 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM336 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM448 128l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0zm0 104l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0zm0 104l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0z',
      'M128 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L128 64zm32 64l192 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faLeftLongToLine = {
  prefix: 'fad',
  iconName: 'left-long-to-line',
  icon: [
    640,
    512,
    [],
    'e41e',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M305.5 414c-8.8 3.8-19 2-26-4.6l-144-136c-4.8-4.5-7.5-10.8-7.5-17.4s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z',
    ],
  ],
};
const faCrown = {
  prefix: 'fad',
  iconName: 'crown',
  icon: [
    576,
    512,
    [128081],
    'f521',
    [
      'M0 136a40 40 0 1 0 80 0A40 40 0 1 0 0 136zM248 72a40 40 0 1 0 80-.1A40 40 0 1 0 248 72zm248 64a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M504 160l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106c-6.1 3.8-13.3 6-21 6s-14.9-2.2-21-6L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c-7.2 9.5-18.5 15.8-31.3 16L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c-12.8-.2-24.1-6.5-31.3-16z',
    ],
  ],
};
const faWeightHanging = {
  prefix: 'fad',
  iconName: 'weight-hanging',
  icon: [
    512,
    512,
    [],
    'f5cd',
    [
      'M160 96c0 11.2 1.9 22 5.5 32l81 0c-12.7-4.4-22-17-22.4-31c0-.3 0-.7 0-1c0-17.7 14.3-32 32-32s32 14.3 32 32c0 .3 0 .6 0 .8c-.4 14-9.7 26.8-22.4 31.2l81 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96z',
      'M120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-272 0z',
    ],
  ],
};
const faXmarksLines = {
  prefix: 'fad',
  iconName: 'xmarks-lines',
  icon: [
    640,
    512,
    [],
    'e59a',
    [
      'M0 64C0 81.7 14.3 96 32 96l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64zM0 448c0 17.7 14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32z',
      'M177 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47L49 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47L15 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM273 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47zM463 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
    ],
  ],
};
const faFilePrescription = {
  prefix: 'fad',
  iconName: 'file-prescription',
  icon: [
    384,
    512,
    [],
    'f572',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM84 216l0 80 0 64c0 11 9 20 20 20s20-9 20-20l0-44 20 0c.7 .9 1.5 1.8 2.3 2.6l64.8 60.8-32.6 29.9c-8.1 7.5-8.7 20.1-1.2 28.3c3.9 4.3 9.3 6.5 14.7 6.5c4.8 0 9.7-1.7 13.5-5.3l34.9-32 33.9 31.8c8.1 7.6 20.7 7.1 28.3-.9s7.1-20.7-.9-28.3L270 379.7l31.6-28.9c8.1-7.5 8.7-20.1 1.2-28.3s-20.1-8.7-28.3-1.2l-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60l-72 0c-11 0-20 9-20 20zm40 20l52 0c11 0 20 9 20 20s-9 20-20 20l-52 0 0-40z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM104 196c-11 0-20 9-20 20l0 80 0 64c0 11 9 20 20 20s20-9 20-20l0-44 20 0c.7 .9 1.5 1.8 2.3 2.6l64.8 60.8-32.6 29.9c-8.1 7.5-8.7 20.1-1.2 28.3s20.1 8.7 28.3 1.2l34.9-32 33.9 31.8c8.1 7.6 20.7 7.1 28.3-.9s7.1-20.7-.9-28.3L270 379.7l31.6-28.9c8.1-7.5 8.7-20.1 1.2-28.3s-20.1-8.7-28.3-1.2l-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60l-72 0zm72 80l-52 0 0-40 52 0c11 0 20 9 20 20s-9 20-20 20z',
    ],
  ],
};
const faTableCellsLock = {
  prefix: 'fad',
  iconName: 'table-cells-lock',
  icon: [
    640,
    512,
    [],
    'e679',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 88 0 0-64L64 96zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM208 96l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM360 96l0 64 88 0 0-64-88 0z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faCalendarRange = {
  prefix: 'fad',
  iconName: 'calendar-range',
  icon: [
    448,
    512,
    [],
    'e0d6',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 128c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 392c-13.3 0-24 10.7-24 24zM192 288c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zM320 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 80L0 192l0-80C0 85.5 21.5 64 48 64l48 0 0-32zm32 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM352 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM192 288c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm40 104c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 440c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0z',
    ],
  ],
};
const faFlowerDaffodil = {
  prefix: 'fad',
  iconName: 'flower-daffodil',
  icon: [
    512,
    512,
    [9880],
    'f800',
    [
      'M0 349.5C0 439.3 72.7 512 162.5 512l61.5 0 32 0 32 0 61.5 0C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5L432 320c-59.5 0-112.1 29.6-144 74.8l0-113.4c-12.7-5.6-23.8-14.4-32-25.3c-.5 .7-1 1.4-1.6 2s-1.1 1.3-1.6 2c-1.1 1.3-2.3 2.6-3.5 3.8c-2.4 2.5-4.9 4.8-7.6 6.9c-5.4 4.3-11.3 7.9-17.7 10.6l0 113.4C192.1 349.6 139.5 320 80 320l-50.5 0C13.2 320 0 333.2 0 349.5z',
      'M320 288c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c44.2 0 80 35.8 80 80c0 26.2-12.6 49.4-32 64c19.4 14.6 32 37.8 32 64c0 44.2-35.8 80-80 80zm-64-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faHandBackPointUp = {
  prefix: 'fad',
  iconName: 'hand-back-point-up',
  icon: [
    448,
    512,
    [],
    'e1a2',
    [
      'M136 0C113.9 0 96 17.9 96 40l0 200 0 7 0 73c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.7c-2 1.4-3.9 3-5.8 4.5L39 284.8C24.4 297 16 315 16 334L16 372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L288 512c70.7 0 128-57.3 128-128l0-64 0-32c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C334 227.5 313.3 208 288 208c-12.4 0-23.6 4.7-32.1 12.3C254 195.5 233.3 176 208 176c-12.3 0-23.5 4.6-32 12.2L176 40c0-22.1-17.9-40-40-40z',
      '',
    ],
  ],
};
const faWeightScale = {
  prefix: 'fad',
  iconName: 'weight-scale',
  icon: [
    512,
    512,
    ['weight'],
    'f496',
    [
      'M432 176A176 176 0 1 1 80 176a176 176 0 1 1 352 0zM216 224c0 22.1 17.9 40 40 40s40-17.9 40-40c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40z',
      'M256 352c97.2 0 176-78.8 176-176c0-42.5-15.1-81.6-40.2-112L448 64c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l56.2 0C95.1 94.4 80 133.5 80 176c0 97.2 78.8 176 176 176zm40-128c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-22 17.8-39.9 39.7-40l33.6-78.3c3.5-8.1 12.9-11.9 21-8.4s11.9 12.9 8.4 21l-33.6 78.3c6.7 7.2 10.9 16.8 10.9 27.4z',
    ],
  ],
};
const faWeight = faWeightScale;
const faArrowUpToArc = {
  prefix: 'fad',
  iconName: 'arrow-up-to-arc',
  icon: [
    512,
    512,
    [],
    'e617',
    [
      'M0 256c0 17.7 14.3 32 32 32s32-14.3 32-32C64 150 150 64 256 64s192 86 192 192c0 17.7 14.3 32 32 32s32-14.3 32-32C512 114.6 397.4 0 256 0S0 114.6 0 256z',
      'M390.6 326.6c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 269.3 224 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0z',
    ],
  ],
};
const faStarExclamation = {
  prefix: 'fad',
  iconName: 'star-exclamation',
  icon: [
    576,
    512,
    [],
    'f2f3',
    [
      'M25.7 193.1c-3.8 11.5-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c4.7 2.5 9.9 3.8 15.1 3.8c6.6 0 13.1-2 18.7-6c9.9-7.1 14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c6.2-6.1 9.5-14.3 9.5-22.7c0-3.3-.5-6.7-1.6-10c-3.8-11.5-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7zM320 352a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM264 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M312 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM288 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faBooks = {
  prefix: 'fad',
  iconName: 'books',
  icon: [
    512,
    512,
    [128218],
    'f5db',
    [
      'M0 32C0 14.3 14.3 0 32 0L96 0c17.7 0 32 14.3 32 32l0 64L0 96 0 32zm0 96l128 0 0 256L0 384 0 128zM0 416l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM160 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64L160 96l0-64zm0 96l128 0 0 256-128 0 0-256zm0 288l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM289.4 117.8c40.9-11 81.8-21.9 122.8-32.9l8.2 30.9L297.6 148.8l-8.2-30.9zm74.2 278.3c40.9-11 81.8-21.9 122.8-32.9l8.2 30.9L371.8 427c-2.7-10.3-5.5-20.6-8.2-30.9z',
      'M288 112.6l1.4 5.2L412.2 85 395.8 23.7c-4.5-17-22-27.1-38.9-22.6L295.5 17.6c-2.7 .7-5.2 1.8-7.5 3.1L288 96 160 96l0 32 128 0 0-15.4zm132.4 3.2L297.6 148.8l66 247.4 122.8-32.9-66-247.4zM388.2 488.3c4.5 17 22 27.1 38.9 22.6l61.4-16.5c16.9-4.6 27-22.1 22.5-39.1l-16.3-61.1L371.8 427l16.3 61.3zM0 96l0 32 128 0 0-32L0 96zM128 384L0 384l0 32 128 0 0-32zm160 0l-128 0 0 32 128 0 0-32z',
    ],
  ],
};
const faUserGroup = {
  prefix: 'fad',
  iconName: 'user-group',
  icon: [
    640,
    512,
    [128101, 'user-friends'],
    'f500',
    [
      'M352.7 223.1C373 243.4 401 256 432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7C377.4 75.9 384 101.2 384 128c0 35.6-11.6 68.5-31.3 95.1zm57.5 97.1C452.9 356.8 480 411.3 480 472l0 8c0 11.7-3.1 22.6-8.6 32l137.8 0c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320l-61.4 0c-2.4 0-4.8 .1-7.1 .2z',
      'M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z',
    ],
  ],
};
const faUserFriends = faUserGroup;
const faArrowUpAZ = {
  prefix: 'fad',
  iconName: 'arrow-up-a-z',
  icon: [
    576,
    512,
    ['sort-alpha-up'],
    'f15e',
    [
      'M304 224c0 11.7 6.5 23 17.7 28.6c15.8 7.9 35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3C521.5 247 528 235.7 528 224c0-4.8-1.1-9.7-3.4-14.3l-16-32-64-128C439.2 38.8 428.1 32 416 32s-23.2 6.8-28.6 17.7l-64 128-16 32c-2.3 4.6-3.4 9.5-3.4 14.3zm16 96c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-128 0c-17.7 0-32 14.3-32 32zm75.8-144L416 135.6 436.2 176l-40.4 0z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortAlphaUp = faArrowUpAZ;
const faLayerPlus = {
  prefix: 'fad',
  iconName: 'layer-plus',
  icon: [
    576,
    512,
    ['layer-group-plus'],
    'f5ff',
    [
      'M32 256c0 9.4 5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101C304 129.7 296 128 288 128s-16 1.7-23.5 5.2L45.9 234.2C37.4 238.1 32 246.6 32 256zm0 128c0 9.4 5.4 17.9 13.9 21.8l218.6 101C272 510.2 280 512 288 512s16-1.7 23.5-5.2l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384z',
      'M488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32z',
    ],
  ],
};
const faLayerGroupPlus = faLayerPlus;
const faPlayPause = {
  prefix: 'fad',
  iconName: 'play-pause',
  icon: [
    640,
    512,
    [],
    'e22f',
    [
      'M384 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 0l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96l0 320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z',
    ],
  ],
};
const faBlockQuestion = {
  prefix: 'fad',
  iconName: 'block-question',
  icon: [
    448,
    512,
    [],
    'e3dd',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 8a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm41.4-233.5l.4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 272.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6zM256 360a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM400 104a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M48 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm304 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM72 384a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM137.8 173.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 272.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 360a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faSnooze = {
  prefix: 'fad',
  iconName: 'snooze',
  icon: [
    448,
    512,
    [128164, 'zzz'],
    'f880',
    [
      'M160 32c0-17.7 14.3-32 32-32l96 0c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5L256 128l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L224 64l-32 0c-17.7 0-32-14.3-32-32zM288 256c0-17.7 14.3-32 32-32l96 0c12.1 0 23.2 6.8 28.6 17.7c2.3 4.5 3.4 9.4 3.4 14.3c0 6.8-2.2 13.6-6.4 19.2L384 352l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L352 288l-32 0c-17.7 0-32-14.3-32-32z',
      'M0 288c0-17.7 14.3-32 32-32l160 0c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 448l91.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L123.7 320 32 320c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faZzz = faSnooze;
const faScannerImage = {
  prefix: 'fad',
  iconName: 'scanner-image',
  icon: [
    576,
    512,
    [],
    'f8f3',
    [
      'M0 352l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64c-32 0-64 0-96 0L64 288c-35.3 0-64 28.7-64 64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M35.8 48.9c8.3-15.6 27.7-21.5 43.3-13.2L525.2 273.7c20.9 11.2 36.6 29.4 44.7 50.9C559.6 303 537.5 288 512 288l-96 0L48.9 92.2C33.3 83.9 27.4 64.5 35.8 48.9zM96 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faTvRetro = {
  prefix: 'fad',
  iconName: 'tv-retro',
  icon: [
    512,
    512,
    [128250],
    'f401',
    [
      'M0 176L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-256c0-44.2-35.8-80-80-80L321.9 96l55-55c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7l-87 87L169 7c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-9.4 9.4-9.4 24.6 0 33.9l55 55L80 96C35.8 96 0 131.8 0 176zm64 48c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-160zm408 8a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M64 224c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224z',
    ],
  ],
};
const faSquareT = {
  prefix: 'fad',
  iconName: 'square-t',
  icon: [
    448,
    512,
    [],
    'e280',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 72c0-13.3 10.7-24 24-24l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24z',
      'M96 168c0-13.3 10.7-24 24-24l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faFarm = {
  prefix: 'fad',
  iconName: 'farm',
  icon: [
    576,
    512,
    ['barn-silo'],
    'f864',
    [
      'M160 270.3c0-4.2 .8-8.3 2.4-12.2l48.9-118.7c3-7.4 8.7-13.3 15.9-16.7L354.3 62.5c4.3-2.1 9-3.1 13.7-3.1s9.4 1 13.7 3.1l127.1 60.2c7.2 3.4 12.9 9.4 15.9 16.7l48.9 118.7c1.6 3.9 2.4 8 2.4 12.2L576 480c0 17.7-14.3 32-32 32l-112 0 0-64c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 64-112 0c-17.7 0-32-14.3-32-32l0-209.7zM320 248l0 48c0 13.3 10.7 24 24 24c16 0 32 0 48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24c-16 0-32 0-48 0c-13.3 0-24 10.7-24 24z',
      'M0 96l192 0c0-53-43-96-96-96S0 43 0 96zm181.4 32L0 128 0 464c0 26.5 21.5 48 48 48l88.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-209.7c0-8.4 1.6-16.6 4.8-24.4l48.6-118zM344 224c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z',
    ],
  ],
};
const faBarnSilo = faFarm;
const faChessKnight = {
  prefix: 'fad',
  iconName: 'chess-knight',
  icon: [
    448,
    512,
    [9822],
    'f441',
    [
      'M16 489.4C16 501.9 26.1 512 38.6 512l370.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432 64 432 22.6 473.4c-4.2 4.2-6.6 10-6.6 16z',
      'M82.7 61.3L96 48 74.9 37.5C68.2 34.1 64 27.3 64 19.8C64 8.9 72.9 0 83.8 0L224 0C330 0 416 86 416 192l0 17.3c0 9.8-.7 19.5-2.2 29.2L384 432 64 432l0-13.3c0-31.7 15.7-61.4 41.9-79.3l112.6-76.8c10.5-7.2 10.9-22.6 .7-30.3c-6.6-5-15.7-5-22.3 0l-49.4 37c-2.3 1.7-4.8 3.2-7.3 4.5l-3.2 1.6c-15.4 7.7-33.8 6.6-48.1-3l-10.6-7C69.3 259.6 64 249.6 64 238.9l0-132.4c0-17 6.7-33.3 18.7-45.3zM140 136a20 20 0 1 0 0-40 20 20 0 1 0 0 40z',
    ],
  ],
};
const faBarsSort = {
  prefix: 'fad',
  iconName: 'bars-sort',
  icon: [
    448,
    512,
    [],
    'e0ae',
    [
      'M0 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z',
      'M448 96c0-17.7-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM192 416c0-17.7-14.3-32-32-32L32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32z',
    ],
  ],
};
const faPalletBoxes = {
  prefix: 'fad',
  iconName: 'pallet-boxes',
  icon: [
    640,
    512,
    [57863, 'palette-boxes', 'pallet-alt'],
    'f483',
    [
      'M0 352c0 17.7 14.3 32 32 32l32 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 224 0 224 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-224 0L96 320l-64 0c-17.7 0-32 14.3-32 32zm128 32l160 0 0 64-160 0 0-64zm224 0l160 0 0 64-160 0 0-64z',
      'M96 0C78.3 0 64 14.3 64 32l0 192c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L96 0zM416 64c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L416 64z',
    ],
  ],
};
const faPaletteBoxes = faPalletBoxes;
const faPalletAlt = faPalletBoxes;
const faFaceLaughSquint = {
  prefix: 'fad',
  iconName: 'face-laugh-squint',
  icon: [
    512,
    512,
    ['laugh-squint'],
    'f59b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 58.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM116 125.1c0-9 9.6-14.7 17.5-10.5c30 16 59.9 32 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8c-30 16-59.9 32-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6c12-14.4 24-28.8 36-43.2c-12-14.4-24-28.8-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm172.6 37.4c30-16 59.9-32 89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6c-12 14.4-24 28.8-36 43.2c12 14.4 24 28.8 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5c-30-16-59.9-32-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8z',
      'M116 125.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
    ],
  ],
};
const faLaughSquint = faFaceLaughSquint;
const faCodeSimple = {
  prefix: 'fad',
  iconName: 'code-simple',
  icon: [
    576,
    512,
    [],
    'e13d',
    [
      'M352 96c0 8.2 3.1 16.4 9.4 22.6L498.7 256 361.4 393.4c-6.2 6.2-9.4 14.4-9.4 22.6s3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l160-160c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-160-160C400.4 67.1 392.2 64 384 64s-16.4 3.1-22.6 9.4S352 87.8 352 96z',
      'M214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faBoltSlash = {
  prefix: 'fad',
  iconName: 'bolt-slash',
  icon: [
    640,
    512,
    [],
    'e0b8',
    [
      'M128 256c0 3.8 .7 7.6 2 11.2c4.7 12.5 16.6 20.7 30 20.7l83.7 0-88.9-70-15.9 13.9c-7.1 6.2-10.9 15-10.9 24.1zm66.6 211.4c-5.9 13.7-1.5 29.7 10.6 38.5c5.6 4.1 12.2 6.1 18.8 6.1c7.5 0 15.1-2.7 21.1-7.9L374.4 391 264.5 304.4l-69.9 163zm33.8-313.7c73.4 57.5 146.7 115 220.1 172.5l52.7-46.1c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L445.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8L228.4 153.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faPanelFire = {
  prefix: 'fad',
  iconName: 'panel-fire',
  icon: [
    640,
    512,
    [],
    'e42f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l273.6 0c-31-34.7-49.6-80.6-49.6-129.9c0-2 .1-4 .2-6.1c-13.4 0-24.2-10.7-24.2-24s10.7-24 24-24c3.5 0 6.9 .8 9.9 2.1c6.7-19 16.4-37.8 27.2-55.4c3.8-6.2 7.9-12.5 12.3-18.7L96 224c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 39.4c9-9.4 18.5-18.6 28.5-27.5c10-8.9 23-12.8 35.5-11.7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM120 320a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M518 194.3l-12.3 13.8-19-19.9c-2-2.1-4-4.4-6-6.7c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9zM480 464c-35.3 0-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400c0 35.3-28.7 64-64 64z',
    ],
  ],
};
const faBinaryCircleCheck = {
  prefix: 'fad',
  iconName: 'binary-circle-check',
  icon: [
    640,
    512,
    [],
    'e33c',
    [
      'M0 64C0 28.7 28.7 0 64 0l64 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64L0 64zM0 480c0-17.7 14.3-32 32-32l16 0 0-83.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26l0 128 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32zM64 64l0 96 64 0 0-96L64 64zM192 352c0-35.3 28.7-64 64-64l64 0c6.2 0 12.2 .9 17.9 2.5c-11.2 22.9-17.6 48.6-17.9 75.7l0-14.2-64 0 0 96 64 0 19.2 0c7.8 15.3 17.8 29.3 29.5 41.5C357 503.3 339.5 512 320 512l-64 0c-35.3 0-64-28.7-64-64l0-96zm32-160c0-17.7 14.3-32 32-32l16 0 0-83.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C297.2 .5 300.6 0 304 0c6.6 0 13.2 2.1 18.7 6c8.3 6 13.3 15.7 13.3 26l0 128 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32zm96 177.8c0 4.8 .3 9.5 .7 14.2l-.7 0 0-14.2z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faCommentMinus = {
  prefix: 'fad',
  iconName: 'comment-minus',
  icon: [
    512,
    512,
    [],
    'f4b1',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160 0c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M160 240c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faBurrito = {
  prefix: 'fad',
  iconName: 'burrito',
  icon: [
    512,
    512,
    [127791],
    'f7ed',
    [
      'M0 352c0 30.7 12.2 60.2 33.9 81.9l44.1 44.1C99.8 499.8 129.3 512 160 512s60.2-12.2 81.9-33.9L459.4 260.6C429.7 237.6 392.4 224 352 224c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-40.8 0-78.8-11.7-110.9-32C.4 341.3 0 346.6 0 352zm10.5-48.2C39.2 324.1 74.2 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-40.4-13.6-77.7-36.6-107.4L33.9 270.1c-9.9 9.9-17.8 21.3-23.4 33.7z',
      'M320 160c0-53.6-20.3-102.5-53.6-139.4C280.6 7.8 299.4 0 320 0c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 20.6-7.8 39.4-20.6 53.6C454.5 212.3 405.6 192 352 192c-11.9 0-23.6 1-34.9 2.9c1.9-11.4 2.9-23 2.9-34.9z',
    ],
  ],
};
const faViolin = {
  prefix: 'fad',
  iconName: 'violin',
  icon: [
    640,
    512,
    [127931],
    'f8ed',
    [
      'M128 368c0 26.7 7.3 51.7 19.9 73.1c16.8-12.6 33.7-25.3 50.5-37.9c6.4-4.8 15.3-4.1 20.9 1.5c5.3 5.3 10.7 10.7 16 16c5.6 5.6 6.3 14.5 1.5 20.9c-12.6 16.8-25.3 33.7-37.9 50.5C220.3 504.7 245.3 512 272 512c30.8 0 59.3-9.6 82.6-26.1c6.7-4.7 7.6-13.8 4.3-21.3c-4.5-10-7-21-7-32.7c0-44.2 35.8-80 80-80c5.3 0 10.5 .5 15.4 1.5c7.4 1.4 15.4-1 18.8-7.7c8.8-17.4 13.8-37 13.8-57.8c0-23.7-6.5-46-17.7-65c-7.9 7.9-15.8 15.8-23.7 23.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3c7.9-7.9 15.8-15.8 23.7-23.7C398 166.5 375.7 160 352 160c-20.8 0-40.4 5-57.8 13.8c-6.7 3.4-9.1 11.4-7.7 18.8c1 5 1.5 10.2 1.5 15.4c0 44.2-35.8 80-80 80c-11.6 0-22.7-2.5-32.7-7c-7.4-3.3-16.6-2.4-21.3 4.3C137.6 308.7 128 337.2 128 368zM448 72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-48a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48 144a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-48a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M630.6 54.6l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM345 7c9.4 9.4 9.4 24.6 0 33.9L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L311 7c9.4-9.4 24.6-9.4 33.9 0zM219.3 404.7l16 16c5.6 5.6 6.3 14.5 1.5 20.9l-48 64c-2.8 3.7-7 6-11.7 6.4s-9.2-1.4-12.4-4.6l-32-32c-3.3-3.3-5-7.8-4.6-12.4s2.6-8.9 6.4-11.7l64-48c6.4-4.8 15.3-4.1 20.9 1.5z',
    ],
  ],
};
const faObjectsColumn = {
  prefix: 'fad',
  iconName: 'objects-column',
  icon: [
    448,
    512,
    [],
    'e3c1',
    [
      'M256 80l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zm0 192l0 160c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
      'M48 32C21.5 32 0 53.5 0 80L0 240c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 32zm0 320c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0z',
    ],
  ],
};
const faSquareChevronDown = {
  prefix: 'fad',
  iconName: 'square-chevron-down',
  icon: [
    448,
    512,
    ['chevron-square-down'],
    'f329',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 224c0-6.1 2.3-12.3 7-17s10.8-7 17-7s12.3 2.3 17 7l87 87 87-87c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17L241 345c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L103 241c-4.7-4.7-7-10.8-7-17z',
      'M207 345c9.4 9.4 24.6 9.4 33.9 0L345 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 345z',
    ],
  ],
};
const faChevronSquareDown = faSquareChevronDown;
const faCommentPlus = {
  prefix: 'fad',
  iconName: 'comment-plus',
  icon: [
    512,
    512,
    [],
    'f4b2',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm144 0c0-13.3 10.7-24 24-24l64 0 0-64c.1-13.4 10.8-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.5c0 21.3 0 42.7 0 64l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c0 21.3 0 42.7 0 64.2c0 .6 0 1.4-.1 2.2s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-21.3 0-42.7 0-64l-64 0c-13.3 0-24-10.7-24-24z',
      'M232 264l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faTriangleInstrument = {
  prefix: 'fad',
  iconName: 'triangle-instrument',
  icon: [
    576,
    512,
    ['triangle-music'],
    'f8e2',
    [
      'M32 418c0 51.9 42.1 94 94 94L450 512c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L430.7 211.3l-46.4 46.4 91.1 144.2c3 4.8 4.6 10.4 4.6 16c0 16.6-13.5 30-30 30L126 448c-16.6 0-30-13.5-30-30c0-5.7 1.6-11.2 4.6-16L266 140.1c4.8-7.6 13.1-12.1 22-12.1s17.3 4.6 22 12.1l48 75.9c15.5-15.5 30.9-30.9 46.4-46.4L364.1 106C353.6 89.2 338 76.7 320 69.9L320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 37.9c-18 6.8-33.6 19.4-44.1 36.1L46.5 367.7C37 382.8 32 400.2 32 418z',
      'M537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L306.8 267.2c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8L537 105z',
    ],
  ],
};
const faTriangleMusic = faTriangleInstrument;
const faWheelchair = {
  prefix: 'fad',
  iconName: 'wheelchair',
  icon: [
    512,
    512,
    [],
    'f193',
    [
      'M0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l-48 0c0 61.9-50.1 112-112 112S48 413.9 48 352s50.1-112 112-112c5.3 0 10.5 .4 15.6 1.1c-3.3-16.3-6.5-32.6-9.8-49c-1.9-.1-3.8-.1-5.8-.1C71.6 192 0 263.6 0 352z',
      'M240 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm19.8 128l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4l5.1 0c.4 0 .8 0 1.3 0l94.1 0c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9l-68.5 0-9.6-48 63.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-76.2 0z',
    ],
  ],
};
const faUserPilotTie = {
  prefix: 'fad',
  iconName: 'user-pilot-tie',
  icon: [
    448,
    512,
    [],
    'e2c1',
    [
      'M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6l-23.8 20.4c.1 1 .1 2 .1 3.1l0 21.2c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 147.7 80 137.6 80 126.9l0-21.2c0-1 0-2.1 .1-3.1L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM161.7 72.8c-4 7.9-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7c-7.9-4-17.5-.7-21.5 7.2zM208 416l-20.4-40.8c-5.3-10.6 2.4-23.2 14.3-23.2l44.2 0c11.9 0 19.6 12.5 14.3 23.2L240 416l12.2 48.9L315 360.3c3-5 8.6-8.1 14.4-7.4C396.2 360.8 448 417.5 448 486.4c0 14.1-11.5 25.6-25.6 25.6L256 512s0 0 0 0l-64 0s0 0 0 0L25.6 512C11.5 512 0 500.5 0 486.4c0-68.9 51.8-125.6 118.6-133.5c5.8-.7 11.4 2.4 14.4 7.4l62.8 104.6L208 416zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faPianoKeyboard = {
  prefix: 'fad',
  iconName: 'piano-keyboard',
  icon: [
    576,
    512,
    [127929],
    'f8d5',
    [
      'M0 224l64 0 0 160 80 0 0-68.3c2.4 1.4 4.9 2.4 7.6 3.2c1.3 .4 2.7 .6 4.1 .8c.7 .1 1.4 .2 2.1 .2s1.4 .1 2.2 .1c5.8 0 11.3-1.6 16-4.3l0 68.3 96 0 0-68.3c2.4 1.4 4.9 2.4 7.6 3.2c1.3 .4 2.7 .6 4.1 .8c.7 .1 1.4 .2 2.1 .2s1.4 .1 2.2 .1c5.8 0 11.3-1.6 16-4.3l0 68.3 96 0 0-68.3c2.4 1.4 4.9 2.4 7.6 3.2c1.3 .4 2.7 .6 4.1 .8c.7 .1 1.4 .2 2.1 .2s1.4 .1 2.2 .1c5.8 0 11.3-1.6 16-4.3l0 68.3 80 0 0-160 64 0 0 160c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 224z',
      'M64 64C28.7 64 0 92.7 0 128l0 96 128 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 128 0 0-96c0-35.3-28.7-64-64-64L64 64z',
    ],
  ],
};
const faBedEmpty = {
  prefix: 'fad',
  iconName: 'bed-empty',
  icon: [
    640,
    512,
    [128719],
    'f8f9',
    [
      'M64 224l32 0 448 0c24.3 0 46.6 9.1 63.5 24l.5 0 0 .4c19.6 17.6 32 43.1 32 71.6l-32 0L64 320l0-64 0-32z',
      'M32 32c17.7 0 32 14.3 32 32l0 256 544 0 32 0 0 32 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32z',
    ],
  ],
};
const faCircleArrowUp = {
  prefix: 'fad',
  iconName: 'circle-arrow-up',
  icon: [
    512,
    512,
    ['arrow-circle-up'],
    'f0aa',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm120-8c0-6.1 2.3-12.3 7-17L239 119c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7L385 231c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-33.9 0l-71-71L280 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1-71 71c-9.4 9.4-24.6 9.4-33.9 0c-4.7-4.7-7-10.8-7-17z',
      'M239 119c9.4-9.4 24.6-9.4 33.9 0L385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71L280 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119z',
    ],
  ],
};
const faArrowCircleUp = faCircleArrowUp;
const faToggleOn = {
  prefix: 'fad',
  iconName: 'toggle-on',
  icon: [
    576,
    512,
    [],
    'f205',
    [
      'M0 256C0 362 86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256zm480 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
      'M288 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z',
    ],
  ],
};
const faRectangleVertical = {
  prefix: 'fad',
  iconName: 'rectangle-vertical',
  icon: [
    384,
    512,
    ['rectangle-portrait'],
    'f2fb',
    [
      'M320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0z',
      '',
    ],
  ],
};
const faRectanglePortrait = faRectangleVertical;
const faPersonWalking = {
  prefix: 'fad',
  iconName: 'person-walking',
  icon: [
    320,
    512,
    [128694, 'walking'],
    'f554',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l27.7-69.2c-10.1-11-20.2-22.1-30.3-33.1c-.9-1-1.7-1.9-2.5-2.9c-.8-1-1.6-2.1-2.4-3.1c-1.5-2.1-2.9-4.3-4.1-6.5c-2.5-4.5-4.3-9.2-5.7-14.1L68.7 398 9.4 457.4C3.1 463.6 0 471.8 0 480z',
      'M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5z',
    ],
  ],
};
const faWalking = faPersonWalking;
const faL = {
  prefix: 'fad',
  iconName: 'l',
  icon: [
    320,
    512,
    [108],
    '4c',
    [
      'M64 32c17.7 0 32 14.3 32 32l0 352 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32z',
      '',
    ],
  ],
};
const faSignalStream = {
  prefix: 'fad',
  iconName: 'signal-stream',
  icon: [
    576,
    512,
    [],
    'f8dd',
    [
      'M0 256c0 68.1 23.7 130.7 63.2 180c11.1 13.8 31.2 16 45 5s16-31.2 5-45C82.4 357.6 64 309 64 256s18.4-101.6 49.1-140c11.1-13.8 8.8-33.9-5-45s-33.9-8.8-45 5C23.7 125.3 0 187.9 0 256zm112 0c0 45.1 17 86.2 44.8 117.3c11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7s10.8-54.8 28.5-74.7c11.8-13.2 10.7-33.4-2.5-45.2s-33.4-10.7-45.2 2.5C129 169.8 112 210.9 112 256zm259.5-74.7c17.8 19.8 28.5 46 28.5 74.7s-10.8 54.8-28.5 74.7c-11.8 13.2-10.7 33.4 2.5 45.2s33.4 10.7 45.2-2.5C447 342.2 464 301.1 464 256s-17-86.2-44.8-117.3c-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2zM462.9 116c30.7 38.4 49.1 87 49.1 140s-18.4 101.6-49.1 140c-11.1 13.8-8.8 33.9 5 45s33.9 8.8 45-5C552.3 386.7 576 324.1 576 256s-23.7-130.7-63.2-180c-11.1-13.8-31.2-16-45-5s-16 31.2-5 45z',
      'M232 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z',
    ],
  ],
};
const faDownToBracket = {
  prefix: 'fad',
  iconName: 'down-to-bracket',
  icon: [
    448,
    512,
    [],
    'e4e7',
    [
      'M0 352l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M251.3 340.7L374.1 217.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 160l0-128c0-17.7-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 160 64 175.2 64 193.9c0 9 3.6 17.6 9.9 24L196.7 340.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3z',
    ],
  ],
};
const faCircleZ = {
  prefix: 'fad',
  iconName: 'circle-z',
  icon: [
    512,
    512,
    [],
    'e130',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l144 0c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336l98.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-8.9 0-17.1-5-21.3-12.9c-1.8-3.5-2.7-7.3-2.7-11.1c0-4.8 1.4-9.6 4.3-13.7L282.2 176 184 176c-13.3 0-24-10.7-24-24z',
      'M160 152c0-13.3 10.7-24 24-24l144 0c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336l98.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8L282.2 176 184 176c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faStars = {
  prefix: 'fad',
  iconName: 'stars',
  icon: [
    512,
    512,
    [],
    'f762',
    [
      'M256 80c0 4.7 3.1 8.9 7.7 10.2L312 104l13.8 48.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2zM384 224c0 3.8 2.5 7.1 6.2 8.2l38.6 11 11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2z',
      'M213.4 157.4c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z',
    ],
  ],
};
const faFire = {
  prefix: 'fad',
  iconName: 'fire',
  icon: [
    448,
    512,
    [128293],
    'f06d',
    [
      'M0 276.5C0 404.1 98.4 512 224 512c124.2 0 224-107.8 224-235.5c0-29.3-13.5-71.1-33.8-111.9c-20.7-41.4-49.9-85-84.5-118c-7.8-7.5-20.1-7.5-28-.1c-13.5 12.8-26 28.5-37 42.9c-24.2-30.2-50.1-58.1-77.7-84C183.1 1.8 178.1 0 173.1 0c-5 0-9.9 1.8-13.8 5.4c-46.5 43.2-86 92.3-113.9 139.3C17.8 191.2 0 238.1 0 276.5zm112 30.3c0-30.1 16.9-56.9 50.8-99.4c6.3-8 18.4-7.9 24.7 .1c16.8 21.3 46.3 58.8 62.8 79.8c6.2 7.9 18.1 8.1 24.7 .5l25.2-29.3c6.5-7.6 18-6.9 22.5 2c9 16.4 13.4 34.5 13.4 52.2c0 32.1-14.3 63.2-41.5 82.2c-21.1 14-43.5 21-68.8 21C162.6 416 112 375.4 112 306.8z',
      'M294.5 395c-21.1 14-43.5 21-68.8 21C162.6 416 112 375.4 112 306.8c0-30.1 16.9-56.9 50.8-99.4c6.3-8 18.4-7.9 24.7 .1c16.8 21.3 46.3 58.8 62.8 79.8c6.2 7.9 18.1 8.1 24.7 .5l25.2-29.3c6.5-7.6 18-6.9 22.5 2c25.3 46.2 14 105-28.1 134.4z',
    ],
  ],
};
const faBedPulse = {
  prefix: 'fad',
  iconName: 'bed-pulse',
  icon: [
    640,
    512,
    ['procedures'],
    'f487',
    [
      'M96 240a80 80 0 1 0 160 0A80 80 0 1 0 96 240zm192-48l0 128 0 32 32 0 288 0 32 0 0-32 0-64c0-53-43-96-96-96l-82.1 0-11.2 23.8c-8.6 18.3-26.4 30.5-46.5 32s-39.5-8-50.7-24.8L332.7 160 320 160c-17.7 0-32 14.3-32 32z',
      'M483.2 9.6C478.1 2.9 469.9-.7 461.6 .1s-15.7 6-19.3 13.7l-45.9 97.5L372 74.7C367.5 68 360 64 352 64L216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l123.2 0L380 173.3c4.8 7.2 13.1 11.3 21.7 10.6s16.3-5.9 19.9-13.7l47-99.9 24.1 32.1c4.5 6 11.6 9.6 19.2 9.6l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-92 0L483.2 9.6zM64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 512 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 0-32-32 0L64 352 64 96z',
    ],
  ],
};
const faProcedures = faBedPulse;
const faHouseDay = {
  prefix: 'fad',
  iconName: 'house-day',
  icon: [
    640,
    512,
    [],
    'e00e',
    [
      'M-.1 160.2c0 5.9 3.2 11.3 8.4 14.1l51.2 27.6L42.8 257.6c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7L133.1 288l15.7-14.5 41.7-38.5c-9.4 3.9-19.7 6-30.5 6c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 13.1-3.1 25.4-8.7 36.3L296 137.5l-35.3-19 16.7-55.7c1.7-5.6 .1-11.7-4-15.9s-10.3-5.7-15.9-4L201.8 59.5 174.2 8.3C171.4 3.2 166-.1 160.1-.1s-11.3 3.2-14.1 8.4L118.4 59.5 62.8 42.9c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146.1c-5.2 2.8-8.4 8.2-8.4 14.1zM112 160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M378.3 104.5c12.3-11.3 31.2-11.3 43.4 0l208 192c9.7 8.9 12.9 22.9 8.1 35.2S621.2 352 608 352l-32 0 0 112c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-112-32 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM368 288c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0z',
    ],
  ],
};
const faShuttleSpace = {
  prefix: 'fad',
  iconName: 'shuttle-space',
  icon: [
    640,
    512,
    ['space-shuttle'],
    'f197',
    [
      'M32 80l0 48 8 0 56 0 0-96L80 32C53.5 32 32 53.5 32 80zm0 304l0 48c0 26.5 21.5 48 48 48l16 0 0-96-56 0-8 0zM128 32l0 99.7c16.1 5.1 30.1 15.1 40 28.3l237.3 0L245.2 63.9C210.4 43 170.6 32 130 32l-2 0zm0 348.3l0 99.7 2 0c40.6 0 80.4-11 115.2-31.9L405.3 352 168 352c-.6 .8-1.3 1.6-1.9 2.4s-1.3 1.6-2 2.4c-1.4 1.5-2.8 3-4.3 4.5c-3 2.9-6.1 5.5-9.5 7.9c-6.7 4.8-14.3 8.6-22.3 11.1z',
      'M0 168c0-22.1 17.9-40 40-40l64 0c26.2 0 49.4 12.6 64 32l288 0c69.3 0 135 22.7 179.2 81.6c6.4 8.5 6.4 20.3 0 28.8C591 329.3 525.3 352 456 352l-288 0c-14.6 19.4-37.8 32-64 32l-64 0c-22.1 0-40-17.9-40-40l0-16L0 184l0-16zM512 268.4l0-24.9c0-19.6-15.9-35.6-35.6-35.6c-2.5 0-4.4 2-4.4 4.4l0 87.1c0 2.5 2 4.4 4.4 4.4c19.6 0 35.6-15.9 35.6-35.6z',
    ],
  ],
};
const faSpaceShuttle = faShuttleSpace;
const faShirtLongSleeve = {
  prefix: 'fad',
  iconName: 'shirt-long-sleeve',
  icon: [
    640,
    512,
    [],
    'e3c7',
    [
      'M0 224.4L0 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-159.6c0-2.7 .7-5.3 2-7.7l46-83.7L144 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-314.9 46 83.7c1.3 2.4 2 5 2 7.7L544 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-159.6c0-18.9-4.8-37.4-13.9-54L559.7 49.7C544.1 21.2 515.1 2.8 483 .3c-1-.2-2-.3-3-.3l-4.4 0L460 0 432 0c0 61.9-50.1 112-112 112S208 61.9 208 0L180 0 164.4 0 160 0c-1 0-2 .1-3 .3c-32.1 2.5-61 20.9-76.7 49.5L13.9 170.5C4.8 187 0 205.6 0 224.4z',
      'M208 0c0 61.9 50.1 112 112 112s112-50.1 112-112L400 0c0 44.2-35.8 80-80 80s-80-35.8-80-80L208 0z',
    ],
  ],
};
const faChartPieSimple = {
  prefix: 'fad',
  iconName: 'chart-pie-simple',
  icon: [
    512,
    512,
    ['chart-pie-alt'],
    'f64e',
    [
      'M0 272C0 404.6 107.5 512 240 512c121.4 0 221.7-90.1 237.7-207c.1-.7 .1-1.4 .1-2c0-8.3-6.9-15-15.5-15L224 288l0-238.4c0-8.6-6.7-15.5-15-15.5c-.7 0-1.4 0-2 .1C90.1 50.3 0 150.7 0 272z',
      'M272 240H495.4c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6V240z',
    ],
  ],
};
const faChartPieAlt = faChartPieSimple;
const faFaceLaugh = {
  prefix: 'fad',
  iconName: 'face-laugh',
  icon: [
    512,
    512,
    ['laugh'],
    'f599',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 58.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faLaugh = faFaceLaugh;
const faFolderOpen = {
  prefix: 'fad',
  iconName: 'folder-open',
  icon: [
    576,
    512,
    [128194, 128449, 61717],
    'f07c',
    [
      'M0 96L0 448c0-5.6 1.5-11.1 4.4-16.1l112-192C122.1 230 132.6 224 144 224l336 0 0-64c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96zM2.4 460.1c.3 .7 .6 1.3 .9 1.9s.6 1.3 1 1.9c-.7-1.2-1.3-2.5-1.9-3.8zm459 1c7.6-7.6 13.3-17.2 16.2-27.9l-16.2 27.9z',
      'M144 224c-11.4 0-21.9 6-27.6 15.9l-112 192c-5.8 9.9-5.8 22.1-.1 32.1S20.5 480 32 480l400 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0z',
    ],
  ],
};
const faAlbumCollectionCircleUser = {
  prefix: 'fad',
  iconName: 'album-collection-circle-user',
  icon: [
    640,
    512,
    [],
    'e48f',
    [
      'M.4 214l32 256c3 24 23.4 42 47.6 42l314.8 0c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2L48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214zM16 104c0 13.3 10.7 24 24 24l432 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 80c-13.3 0-24 10.7-24 24zM32 24c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM224 352c0 13.3 14.3 24 32 24s32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7C553.5 468.1 526.2 480 496 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faCandy = {
  prefix: 'fad',
  iconName: 'candy',
  icon: [
    640,
    512,
    [127852],
    'e3e7',
    [
      'M0 256c0 10 6.2 19 15.6 22.5l29.1 10.9L15 319c-8.3 8.3-9.4 21.5-2.5 31s19.7 12.7 30.2 7.4L136 310.9c-5.2-17.4-8-35.8-8-54.9c0-1.2 0-2.4 0-3.6s.1-2.4 .1-3.6c.1-2.4 .2-4.7 .4-7.1c.3-4.7 .9-9.3 1.5-13.9c1.3-9.2 3.3-18.1 5.9-26.8L42.7 154.5c-10.5-5.3-23.3-2.1-30.2 7.4s-5.8 22.7 2.5 31l29.6 29.6L15.6 233.5C6.2 237 0 246 0 256zm504-54.9c5.2 17.4 8 35.8 8 54.9c0 1.2 0 2.4 0 3.6s-.1 2.4-.1 3.6c-.1 2.4-.2 4.7-.4 7.1c-.3 4.7-.9 9.3-1.5 13.9c-1.3 9.2-3.3 18.1-5.9 26.8l93.2 46.6c10.5 5.3 23.3 2.1 30.2-7.4s5.8-22.7-2.5-31l-29.6-29.6 29.1-10.9C633.8 275 640 266 640 256s-6.2-19-15.6-22.5l-29.1-10.9L625 193c8.3-8.3 9.4-21.5 2.5-31s-19.7-12.7-30.2-7.4L504 201.1z',
      'M318.1 64c-24.5 .2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.2-28.5 52.6-47.3L318.1 64zM492.3 340.8C504.9 315.2 512 286.4 512 256c0-93.9-67.4-172.1-156.5-188.7L492.3 340.8zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zM284.5 444.7L147.7 171.2C135.1 196.8 128 225.6 128 256c0 93.9 67.4 172.1 156.5 188.7z',
    ],
  ],
};
const faBowlHot = {
  prefix: 'fad',
  iconName: 'bowl-hot',
  icon: [
    512,
    512,
    ['soup'],
    'f823',
    [
      'M128 24l0 8c0 32.7 15.4 63.6 41.6 83.2C183.7 125.8 192 142.4 192 160l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-32.7-15.4-63.6-41.6-83.2C184.3 66.2 176 49.6 176 32l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24zm128 0l0 8c0 32.7 15.4 63.6 41.6 83.2C311.7 125.8 320 142.4 320 160l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-32.7-15.4-63.6-41.6-83.2C312.3 66.2 304 49.6 304 32l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5L33.6 224z',
    ],
  ],
};
const faSoup = faBowlHot;
const faFlatbread = {
  prefix: 'fad',
  iconName: 'flatbread',
  icon: [
    512,
    512,
    [129747],
    'e40b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-16c0-4.1 1.6-8.2 4.7-11.3l128-128c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0c-3.1-3.1-4.7-7.2-4.7-11.3zm52.7 100.7l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm112 48l128-128c6.2-6.2 16.4-6.2 22.6 0c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l-128 128c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6z',
      'M251.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm112 48c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0zm48 134.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faHeartCirclePlus = {
  prefix: 'fad',
  iconName: 'heart-circle-plus',
  icon: [
    576,
    512,
    [],
    'e500',
    [
      'M39.7 270.5L233.5 470.3c12 13 33 13 45.9 0l5.4-5.6C266.6 436.9 256 403.7 256 368c0-97.2 78.8-176 176-176c26.8 0 52.3 6 75 16.7c13.7-51.1-.9-108.7-43.8-146.1c-55.9-47-137.8-38-187.8 13l-19 21-20-21C208.7 47.4 170.8 32 133.3 32c-30 0-59.7 9.8-83.6 30.7c-62.9 53.9-65.9 149.8-10 207.8z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faCodeFork = {
  prefix: 'fad',
  iconName: 'code-fork',
  icon: [
    448,
    512,
    [],
    'e13b',
    [
      'M48 153.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3c1.4 .1 2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7l0 38.7c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-38.7c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3c1.4 .1 2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7l0 38.7c0 53-43 96-96 96l-48 0 0 70.7c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7l0-70.7-48 0c-53 0-96-43-96-96l0-38.7z',
      'M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 368 0a80 80 0 1 0 0 160zM200 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faCity = {
  prefix: 'fad',
  iconName: 'city',
  icon: [
    640,
    512,
    [127961],
    'f64f',
    [
      'M0 144l0 96L0 464c0 26.5 21.5 48 48 48l256 0 32 0 96 0 160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-112 0 0-144c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 48-64 0-48 0-64 0L64 96 48 96C21.5 96 0 117.5 0 144zm64 32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM192 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM352 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm160 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72 48 0 0-72zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72 48 0 0-72zm16 136l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM576 272c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32zM112 416c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm144-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm320-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32zM128 176c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32zM240 320c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM128 304l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faSignalBarsWeak = {
  prefix: 'fad',
  iconName: 'signal-bars-weak',
  icon: [
    640,
    512,
    ['signal-alt-1'],
    'f691',
    [
      'M192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48s-48 21.5-48 48zM352 176l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48s-48 21.5-48 48zM512 48l0 416c0 26.5 21.5 48 48 48s48-21.5 48-48l0-416c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
      'M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z',
    ],
  ],
};
const faSignalAlt1 = faSignalBarsWeak;
const faMicrophoneLines = {
  prefix: 'fad',
  iconName: 'microphone-lines',
  icon: [
    384,
    512,
    [127897, 'microphone-alt'],
    'f3c9',
    [
      'M16 216l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zM192 112c0 8.8 7.2 16 16 16l80 0 0-32-80 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l80 0 0-32-80 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l80 0 0-32-80 0c-8.8 0-16 7.2-16 16z',
      'M192 0C139 0 96 43 96 96l0 160c0 53 43 96 96 96s96-43 96-96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c0-53-43-96-96-96z',
    ],
  ],
};
const faMicrophoneAlt = faMicrophoneLines;
const faClockTwelve = {
  prefix: 'fad',
  iconName: 'clock-twelve',
  icon: [
    512,
    512,
    [],
    'e358',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z',
      'M256 96c13.3 0 24 10.7 24 24l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faPepperHot = {
  prefix: 'fad',
  iconName: 'pepper-hot',
  icon: [
    512,
    512,
    [127798],
    'f816',
    [
      'M0 467.6C0 492.1 19.9 512 44.4 512l58.8 0c155.2 0 294.6-82.3 371.5-210c-3.3-2.1-6.3-5.3-8.3-9.4c-3.9-7.8-7.8-15.6-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3c-24.4 0-48.8 0-73.2 0c-13.3 0-24-10.7-24-24c0-26.7 0-53.3 0-80c0-.1 0-.3 0-.4c0-.5 0-1.3-.1-2c-.1-.8-.2-1.6-.4-2.4c-.3-1.6-.8-3.1-1.4-4.5c-1.2-2.9-3-5.5-5.1-7.6c-4.3-4.3-10.3-7-17-7c-5.7 0-11.4 0-17.1 0c-.7 0-1.3 0-1.9-.1c-.6 0-1.2-.1-1.8-.2c-1.2-.2-2.3-.4-3.4-.7c-2.2-.6-4.2-1.5-5.9-2.7L171.2 345.5C154 380 122.2 404.9 84.5 413.2L34.8 424.3C14.5 428.8 0 446.8 0 467.6z',
      'M461 12.3C454.5 .8 439.9-3.4 428.3 3s-15.8 21-9.3 32.6l4.8 8.7c9.7 17.5 11.5 37.6 6 55.8C406.8 87.3 380.2 80 352 80c-24.3 0-47.3 5.4-67.9 15.1c-19.3 9-10.5 32.9 10.8 32.9l17.1 0c13.3 0 24 10.7 24 24l0 80c0 13.3 10.7 24 24 24l73.2 0c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c8.2 16.4 30.7 17.5 36.7 .1c5.8-16.5 8.9-34.3 8.9-52.8c0-42.1-16.2-80.4-42.8-108.9c16.4-34.3 15.9-75.4-3.4-110L461 12.3z',
    ],
  ],
};
const faCitrusSlice = {
  prefix: 'fad',
  iconName: 'citrus-slice',
  icon: [
    512,
    512,
    [],
    'e2f5',
    [
      'M33.4 371.7c0 6.5 4.1 15.8 7.5 19.3c2.1 2.1 4.2 4.2 6.4 6.1s4.3 3.9 6.5 5.8c4.4 3.8 8.9 7.4 13.4 10.9c9.2 6.9 18.7 13.1 28.5 18.6c19.7 11 40.6 19.1 61.8 24.2c9.7 2.2 18.5-5.3 18.5-15.1l0-177.2c0-6.2-4.3-11.5-10-14c-5.9-2.6-13-2.1-17.6 2.5L35.1 366.3c-1.2 1.2-1.7 3.1-1.7 5.4zM208 262.9l0 185.3c0 8.5 6.6 15.5 15 15.5c.1 0 .3 0 .4 0c50.6-1.4 100.8-18.3 143-50.6c7.3-5.6 7.7-16.3 1.1-22.9L230.9 253.5c-3.7-3.7-9.4-4.4-14.3-2.4s-8.5 6.5-8.5 11.8zM250.5 166c2.5 5.7 7.8 10 14 10l177.2 0c9.9 0 17.4-8.9 15.1-18.5C446.3 114.8 424.4 74.4 391 41c-3.4-3.4-12.8-7.5-19.3-7.5c-2.3 0-4.2 .5-5.4 1.7L253 148.4c-4.6 4.6-5.2 11.7-2.5 17.6zm.6 50.5c-2 4.9-1.4 10.6 2.4 14.3L390.3 367.6c6.5 6.5 17.3 6.2 22.9-1.1c32.3-42.2 49.2-92.5 50.6-143c.2-8.6-6.9-15.5-15.5-15.5L263 208c-5.3 0-9.8 3.7-11.8 8.5z',
      'M7 391c9.4-9.4 24.6-9.4 33.9 0c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faSheep = {
  prefix: 'fad',
  iconName: 'sheep',
  icon: [
    640,
    512,
    [128017],
    'f711',
    [
      'M0 256c0 24.5 13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0c2.8-.1 5.6-.3 8.3-.7c6.8 28 32.1 48.7 62.2 48.7c7.5 0 14.7-1.3 21.3-3.6c6.8-2.4 13-5.9 18.5-10.2C219.7 439.6 236.9 448 256 448c19.2 0 36.5-8.5 48.2-21.9C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c2.7 .4 5.5 .7 8.3 .7c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8L464 320c-61.9 0-112-50.1-112-112l0-32.6c-18.7-2.7-35.5-14.8-43.5-33.4c-6.9-16.1-5.7-33.5 1.8-47.9C299 76 278.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256z',
      'M384 135.8l-14.5 6.2c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l47.8-20.5C415.3 50.2 445.5 32 480 32s64.7 18.2 81.6 45.4l47.8 20.5c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6L576 135.8l0 72.2c0 44.2-35.8 80-80 80l-32 0c-44.2 0-80-35.8-80-80l0-72.2zM464 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM115.1 485.9L97.5 392c2.8-.1 5.6-.3 8.3-.7c6.8 28 32.1 48.7 62.2 48.7c15 0 28.9-5.2 39.8-13.9l.2 .2 0 53.7c0 17.7-14.3 32-32 32l-29.4 0c-15.4 0-28.6-11-31.5-26.1zM304 480l0-53.7 .2-.2C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c2.7 .4 5.5 .7 8.3 .7l-17.6 93.9C394.1 501 380.8 512 365.4 512L336 512c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faUnlock = {
  prefix: 'fad',
  iconName: 'unlock',
  icon: [
    448,
    512,
    [128275],
    'f09c',
    [
      'M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144z',
      'M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z',
    ],
  ],
};
const faColonSign = {
  prefix: 'fad',
  iconName: 'colon-sign',
  icon: [
    384,
    512,
    [],
    'e140',
    [
      'M81 472.2l17.7-70.8c16.8 14.5 36.2 26.2 57.4 34.2l-13 52.1c-3.6 14.5-16.7 24.2-31 24.2c-2.6 0-5.2-.3-7.8-1c-17.1-4.3-27.6-21.7-23.3-38.8zm36.4-145.5l45.9-183.4c9-4.9 18.7-8.7 28.9-11.3c5.1-1.3 10.3-2.3 15.6-3c2.7-.3 5.3-.6 8.1-.8c1.4-.1 2.7-.1 4.1-.2c1.3 0 2.7-.1 4.1-.1c3 0 6 .1 8.9 .3L171.8 372.9c-22.2-9.9-41.1-26-54.4-46.1zM177 472.2l7.1-28.4c6.4 1.4 13 2.4 19.7 3.1c3.3 .3 6.7 .6 10.1 .8c1.7 .1 3.4 .2 5.1 .2s3.4 .1 5.1 .1c8.6 0 17.1-.6 25.4-1.7L239 487.8c-3.6 14.5-16.7 24.2-31 24.2c-2.6 0-5.2-.3-7.8-1c-17.1-4.3-27.6-21.7-23.3-38.8zm4.9-403.6L193 24.2C197.2 7.1 214.6-3.3 231.8 1s27.6 21.7 23.3 38.8l-6.5 25.8c-4-.5-8.1-.9-12.2-1.2c-2-.1-4.1-.2-6.2-.3c-2-.1-4.1-.1-6.2-.1c-14.5 0-28.6 1.6-42.1 4.6zm17.7 313l62-248.1c7.1 2.2 14 5 20.6 8.3c3.3 1.7 6.5 3.5 9.6 5.4c1.6 1 3.1 2 4.6 3s3 2.1 4.4 3.2c6 4.5 13.2 6.6 20.2 6.4L266.8 376.7c-6.7 2.4-13.6 4.2-20.8 5.4c-3.6 .6-7.2 1.1-10.9 1.4c-1.8 .2-3.7 .3-5.5 .4s-3.7 .1-5.6 .1c-8.3 0-16.5-.8-24.4-2.3zM277.2 71.5L289 24.2C293.2 7.1 310.6-3.3 327.8 1C342.3 4.6 352 17.6 352 32c0 2.6-.3 5.2-1 7.8L336 100c-17.6-12.7-37.5-22.4-58.8-28.6z',
      'M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8C307.1 433.7 267.2 448 224 448C118 448 32 362 32 256S118 64 224 64c43.2 0 83.1 14.3 115.2 38.4c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128z',
    ],
  ],
};
const faHeadset = {
  prefix: 'fad',
  iconName: 'headset',
  icon: [
    512,
    512,
    [],
    'f590',
    [
      'M0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40C48 141.1 141.1 48 256 48s208 93.1 208 208l0 144.1c0 22.1-17.9 40-40 40L313.6 440c-8.3-14.4-23.8-24-41.6-24l-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l32 0c17.8 0 33.3-9.7 41.6-24l110.4 .1c48.6 0 88.1-39.4 88.1-88L512 256C512 114.6 397.4 0 256 0S0 114.6 0 256z',
      'M144 208c-35.3 0-64 28.7-64 64l0 48c0 35.3 28.7 64 64 64l16 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32l-16 0zm224 0l-16 0c-17.7 0-32 14.3-32 32l0 112c0 17.7 14.3 32 32 32l16 0c35.3 0 64-28.7 64-64l0-48c0-35.3-28.7-64-64-64z',
    ],
  ],
};
const faBadgerHoney = {
  prefix: 'fad',
  iconName: 'badger-honey',
  icon: [
    640,
    512,
    [129441],
    'f6b4',
    [
      'M88.8 187.5c17 40.2 56.8 68.5 103.2 68.5l53.4 0c17.4 0 34.5-4.7 49.4-13.7l106.8-64.1c19.9-11.9 42.7-18.2 65.9-18.2l5.9 0 45.3 0 51.3 0-68-37.8c-12.1-6.7-25.6-10.2-39.5-10.2c-12.6 0-25.1 2.9-36.3 8.6l-4.7 2.4c-27.7 13.9-58.3 21.1-89.2 21.1L160 144c-31 0-58 17.7-71.2 43.5zm448.3 63.8l16.1 25.8c1.6 2.5 4.2 3.8 6.8 3.8s5.2-1.3 6.8-3.8l22.8-36.5c-1.4 .2-2.8 .4-4.2 .6c-2.2 .2-4.2 .5-6.2 .7c-2.1 .3-4.2 .6-6.2 .9c-4.1 .7-8.2 1.4-12.2 2.3c-8.1 1.7-16 3.8-23.7 6.3z',
      'M180.6 352l-16 37.3c-3 6.9-3.4 14.6-1.2 21.8l8.3 27.7c6.2 20.5-9.2 41.2-30.7 41.2l-29.2 0c-14.1 0-26.6-9.3-30.7-22.8L68 413.5c-2.6-8.8-2.7-18.2-.2-27l16.8-59C69.1 316.2 56.2 301.4 47 284.3c-4.5 2.4-9.6 3.7-15 3.7c-17.7 0-32-14.3-32-32l0-32C0 153.3 57.3 96 128 96l32 0 172.2 0c23.5 0 46.7-5.5 67.8-16l4.7-2.4c17.9-9 37.7-13.6 57.8-13.6c22 0 43.6 5.6 62.8 16.3l81.9 45.5C627.4 137 640 158.4 640 181.6l0 3.8c0 14.5-5.8 28.4-16 38.6s-24.2 15.7-38.6 17.2C500.8 250 427.7 306.1 393 342.1l16.8 100.6C413 462.2 398 480 378.2 480l-31.1 0c-15.6 0-29-11.3-31.6-26.7L298.7 352l-118.1 0zM570 160l-68-37.8c-12.1-6.7-25.6-10.2-39.5-10.2c-12.6 0-25.1 2.9-36.3 8.6l-4.7 2.4c-27.7 13.9-58.3 21.1-89.2 21.1L160 144c-31 0-58 17.7-71.2 43.5c17 40.2 56.8 68.5 103.2 68.5l53.4 0c17.4 0 34.5-4.7 49.4-13.7l106.8-64.1c19.9-11.9 42.7-18.2 65.9-18.2l5.9 0c-.9 2.5-1.4 5.2-1.4 8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.8-.5-5.5-1.4-8l51.3 0z',
    ],
  ],
};
const faH4 = {
  prefix: 'fad',
  iconName: 'h4',
  icon: [
    640,
    512,
    [],
    'f86a',
    [
      'M0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M479 103.8c4.3-17.1-6.1-34.5-23.3-38.8s-34.5 6.1-38.8 23.3l-48 192c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3l176 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160-135 0L479 103.8z',
    ],
  ],
};
const faStoreSlash = {
  prefix: 'fad',
  iconName: 'store-slash',
  icon: [
    640,
    512,
    [],
    'e071',
    [
      'M48 146.5c0-4 .3-8 .9-12l106.4 83.9c-9.6 3.6-20 5.6-31 5.6c-4.1 0-8.2-.3-12.1-.8C72.7 217.9 48 183 48 146.5zM94.9 49.1l22.7-36C122.8 5 131.9 0 141.6 0L498.4 0c9.7 0 18.8 5 23.9 13.1l57.3 90.7c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8c-26.1 0-49.2-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-5.5 6-11.8 11.3-18.8 15.7L94.9 49.1zM96 252.6c3.9 1 7.9 1.7 12.1 2.3c5.3 .7 10.7 1.1 16.3 1.1c12.5 0 24.4-1.9 35.6-5.4L160 384l205.5 0L514.9 501.7c-10 6.5-22 10.3-34.9 10.3l-320 0c-35.3 0-64-28.7-64-64l0-64 0-131.4zm384-2c11.2 3.5 23.1 5.3 35.4 5.3c5.6 0 10.9-.4 16.3-1.1c4.2-.6 8.3-1.3 12.3-2.3L544 384l0 17.1c-21.3-16.7-42.7-33.4-64-50.2l0-100.3z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faRoadCircleXmark = {
  prefix: 'fad',
  iconName: 'road-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e566',
    [
      'M32 425.4C32 455.5 56.5 480 86.6 480L288 480l0-64c0-17.7 14.3-32 32-32l.7 0c-.5-5.3-.7-10.6-.7-16c0-16.9 2.4-33.3 6.8-48.7c-2.2 .5-4.5 .7-6.8 .7c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 42.8c31.9-45.2 84.5-74.8 144-74.8c11.6 0 22.9 1.1 33.8 3.2L487.1 74.6C478 49.1 453.9 32 426.8 32L352 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faSignalSlash = {
  prefix: 'fad',
  iconName: 'signal-slash',
  icon: [
    640,
    512,
    [],
    'f695',
    [
      'M32 416l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 2.9L288 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-106.7-64-50.4zm6.1-117.7c19.3 15.1 38.6 30.3 57.9 45.4l0-26.6c0-17.7-14.3-32-32-32c-10.7 0-20.1 5.2-25.9 13.2zM416 128l0 172.7c21.3 16.7 42.7 33.4 64 50.2L480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 295.8l0 56.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-5.8-64-50.4zM544 32l0 369.1c21.3 16.7 42.7 33.4 64 50.2L608 32c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faUserMinus = {
  prefix: 'fad',
  iconName: 'user-minus',
  icon: [
    640,
    512,
    [],
    'f503',
    [
      'M0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0C79.8 304 0 383.8 0 482.3zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z',
      'M448 224c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faMarsStrokeUp = {
  prefix: 'fad',
  iconName: 'mars-stroke-up',
  icon: [
    320,
    512,
    [9896, 'mars-stroke-v'],
    'f22a',
    [
      'M96 352a64 64 0 1 0 128 0A64 64 0 1 0 96 352z',
      'M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-40 0 0 24 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8l0-24-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-24L96 96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z',
    ],
  ],
};
const faMarsStrokeV = faMarsStrokeUp;
const faChampagneGlasses = {
  prefix: 'fad',
  iconName: 'champagne-glasses',
  icon: [
    640,
    512,
    [129346, 'glass-cheers'],
    'f79f',
    [
      'M0 428.1c0 13.1 8.1 25.4 21.1 30.1l71.1 25.9L163.3 510c3.6 1.3 7.3 1.9 10.9 1.9c13.1 0 25.3-8.1 30.1-21.1c6-16.6-2.5-35-19.1-41l-41-15 31.3-86.2c59.4 5.2 116.2-33.9 130-95.2L320 188.8l14.6 64.7c13.8 61.3 70.6 100.4 130 95.2l31.3 86.2-41 15c-16.6 6.1-25.2 24.4-19.1 41c4.7 13 17 21.1 30 21.1c3.6 0 7.3-.6 10.9-1.9l71.1-25.9L619 458.2c13-4.7 21.1-17 21.1-30.1c0-3.6-.6-7.3-1.9-10.9c-6-16.6-24.4-25.2-41-19.1l-41 15-31.3-86.2c48.8-34.3 67.2-100.8 38.5-156.6L484.4 17.3C478.8 6.4 467.7 0 456 0c-3.6 0-7.3 .6-10.9 1.9L320 47.5 195 1.9C191.4 .6 187.7 0 184 0c-11.7 0-22.8 6.4-28.4 17.3L76.9 170.2C48.1 226 66.5 292.5 115.3 326.8L84 413l-41-15c-16.6-6.1-35 2.5-41 19.1C.6 420.8 0 424.4 0 428.1zM133.7 199.6c12.9-25 25.8-50 38.7-75l27.2-52.8 75.1 27.4c-4.4 19.3-8.7 38.6-13.1 57.9c-6.2 27.5-12.4 54.9-18.6 82.4c-6.2 27.6-30.6 45.7-57.1 45.7c-6.6 0-13.4-1.1-20.1-3.6c-33.2-12.1-48.2-50.6-32.1-82z',
      'M172.4 124.5l-38.7 75c-16.2 31.4-1.1 69.9 32.1 82s69.4-7.7 77.2-42.2L261.6 157l-89.2-32.5zm295.2 0L378.5 157 397 239.4c7.8 34.5 44 54.3 77.2 42.2s48.2-50.6 32.1-82l-38.7-75z',
    ],
  ],
};
const faGlassCheers = faChampagneGlasses;
const faTaco = {
  prefix: 'fad',
  iconName: 'taco',
  icon: [
    512,
    512,
    [127790],
    'f826',
    [
      'M0 448c0-43.2 10.7-84 29.7-119.7C72.6 247.2 157.9 192 256 192s183.4 55.2 226.3 136.3C501.3 364 512 404.8 512 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zm96-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64-64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M237.2 38.4c11-8.6 26.5-8.6 37.5 0l44.1 34.2c5.6 4.4 12.6 6.6 19.7 6.4l55.8-1.7c14-.4 26.5 8.6 30.4 22.1l15.6 53.6c2 6.8 6.3 12.8 12.2 16.8L498.6 201c11.6 7.9 16.3 22.5 11.6 35.7l-27.8 91.6C439.4 247.2 354.1 192 256 192s-183.4 55.2-226.3 136.3L1.8 236.7c-4.7-13.1 0-27.8 11.6-35.7l46.1-31.4c5.9-4 10.2-9.9 12.2-16.8L87.3 99.3c3.9-13.4 16.4-22.5 30.4-22.1L173.4 79c7.1 .2 14.1-2 19.7-6.4l44.1-34.2z',
    ],
  ],
};
const faHexagonPlus = {
  prefix: 'fad',
  iconName: 'hexagon-plus',
  icon: [
    512,
    512,
    ['plus-hexagon'],
    'f300',
    [
      'M7.4 256c0 12.4 3.2 24.9 9.6 36l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c6.4-11.1 9.6-23.6 9.6-36s-3.2-24.9-9.6-36L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220c-6.4 11.1-9.6 23.6-9.6 36zM144 256c0-13.3 10.7-24 24-24c21.3 0 42.7 0 64 0l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64c21.3 0 42.7 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-21.3 0-42.7 0-64 0l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c-21.3 0-42.7 0-64 0c-13.3 0-24-10.7-24-24z',
      'M232 280l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faPlusHexagon = faHexagonPlus;
const faClipboard = {
  prefix: 'fad',
  iconName: 'clipboard',
  icon: [
    384,
    512,
    [128203],
    'f328',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128z',
      'M192 0c-39.5 0-72.4 28.7-78.8 66.3C93.9 72.6 80 90.7 80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24c0-21.3-13.9-39.4-33.2-45.7C264.4 28.7 231.5 0 192 0zm0 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faHouseCircleExclamation = {
  prefix: 'fad',
  iconName: 'house-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e50a',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faFileArrowUp = {
  prefix: 'fad',
  iconName: 'file-arrow-up',
  icon: [
    384,
    512,
    ['file-upload'],
    'f574',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 304c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l31-31L168 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-4.7 4.7-7 10.8-7 17z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM216 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 392z',
    ],
  ],
};
const faFileUpload = faFileArrowUp;
const faWifi = {
  prefix: 'fad',
  iconName: 'wifi',
  icon: [
    640,
    512,
    ['wifi-3', 'wifi-strong'],
    'f1eb',
    [
      '',
      'M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z',
    ],
  ],
};
const faWifi3 = faWifi;
const faWifiStrong = faWifi;
const faMessages = {
  prefix: 'fad',
  iconName: 'messages',
  icon: [
    640,
    512,
    ['comments-alt'],
    'f4b6',
    [
      'M256 352l96 0c53 0 96-43 96-96l0-128 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448c-35.3 0-64-28.7-64-64l0-32z',
      'M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-149.3 0-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-48-32 0c-35.3 0-64-28.7-64-64L0 64z',
    ],
  ],
};
const faCommentsAlt = faMessages;
const faBath = {
  prefix: 'fad',
  iconName: 'bath',
  icon: [
    512,
    512,
    [128705, 'bathtub'],
    'f2cd',
    [
      'M32 77.3L32 256l64 0L96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3z',
      'M32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 256zm448 96L32 352l0 16c0 28.4 12.4 54 32 71.6L64 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 256 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-40.4c19.6-17.6 32-43.1 32-71.6l0-16z',
    ],
  ],
};
const faBathtub = faBath;
const faUmbrellaSimple = {
  prefix: 'fad',
  iconName: 'umbrella-simple',
  icon: [
    512,
    512,
    ['umbrella-alt'],
    'e2bc',
    [
      'M131.4 462.3l2.3 4.7c13.8 27.6 42 45 72.8 45c45 0 81.4-36.5 81.4-81.4L288 288l-64 0 0 142.6c0 9.6-7.8 17.4-17.4 17.4c-6.6 0-12.6-3.7-15.6-9.6l-2.3-4.7c-7.9-15.8-27.1-22.2-42.9-14.3s-22.2 27.1-14.3 42.9z',
      'M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 2C108.2 48.4 16.4 140.2 2 256.1C-.2 273.6 14.3 288 32 288l448 0c17.7 0 32.2-14.4 30-31.9C495.6 140.2 403.8 48.4 288 34l0-2z',
    ],
  ],
};
const faUmbrellaAlt = faUmbrellaSimple;
const faRectangleHistoryCirclePlus = {
  prefix: 'fad',
  iconName: 'rectangle-history-circle-plus',
  icon: [
    640,
    512,
    [],
    'e4a3',
    [
      'M0 224L0 448c0 35.3 28.7 64 64 64l330.8 0C349.5 480.1 320 427.5 320 368c0-97.2 78.8-176 176-176c2.5 0 5 .1 7.5 .2c-11-19.2-31.8-32.2-55.5-32.2L64 160c-35.3 0-64 28.7-64 64zM48 104c0 13.3 10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24zM96 24c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faUnderline = {
  prefix: 'fad',
  iconName: 'underline',
  icon: [
    448,
    512,
    [],
    'f0cd',
    [
      'M16 64c0 17.7 14.3 32 32 32l16 0 0 128c0 88.4 71.6 160 160 160s160-71.6 160-160l0-128 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 128c0 53-43 96-96 96s-96-43-96-96l0-128 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 32C30.3 32 16 46.3 16 64z',
      'M0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faPrescriptionBottlePill = {
  prefix: 'fad',
  iconName: 'prescription-bottle-pill',
  icon: [
    576,
    512,
    [],
    'e5c0',
    [
      'M0 32L0 64C0 81.7 14.3 96 32 96l320 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zm32 96l0 64 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L32 224l0 64 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L32 320l0 64 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L32 416l0 32c0 35.3 28.7 64 64 64l192 0c11.6 0 22.4-3.1 31.8-8.4c-39-32.3-63.8-81-63.8-135.6c0-68.4 39-127.7 96-156.8l0-83.2L32 128z',
      'M338.5 297.1c-10.1-10.1-27-9.2-33.7 3.4C294.1 320.6 288 343.6 288 368c0 79.5 64.5 144 144 144c24.4 0 47.4-6.1 67.5-16.8c12.6-6.7 13.5-23.6 3.4-33.7L338.5 297.1zM525.5 438.9c10.1 10.1 27 9.2 33.7-3.4C569.9 415.4 576 392.4 576 368c0-79.5-64.5-144-144-144c-24.4 0-47.4 6.1-67.5 16.8c-12.6 6.7-13.5 23.6-3.4 33.7L525.5 438.9z',
    ],
  ],
};
const faUserPen = {
  prefix: 'fad',
  iconName: 'user-pen',
  icon: [
    640,
    512,
    ['user-edit'],
    'f4ff',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c48.1 0 91.8 19.1 123.9 50.1l-40.3 40.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M557.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71z',
    ],
  ],
};
const faUserEdit = faUserPen;
const faBinarySlash = {
  prefix: 'fad',
  iconName: 'binary-slash',
  icon: [
    640,
    512,
    [],
    'e33e',
    [
      'M128 64l0 11 64 50.2L192 64l64 0 0 96-19.6 0c20.5 16.1 41.1 32.2 61.6 48.3c13.5-11.7 22-29 22-48.3l0-96c0-35.3-28.7-64-64-64L192 0c-35.3 0-64 28.7-64 64zm0 416c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 83.6-16 0c-17.7 0-32 14.3-32 32zM320.1 348.2c-.1 1.3-.1 2.5-.1 3.8l0 96c0 35.3 28.7 64 64 64l64 0c20.1 0 38.1-9.3 49.8-23.8l-51-40.2L384 448l0-49.5-63.9-50.3zM352 192c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 83.6-16 0c-17.7 0-32 14.3-32 32zm47.7 96c37.4 29.3 74.8 58.7 112.3 88l0-24c0-35.3-28.7-64-64-64l-48.3 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faSquareO = {
  prefix: 'fad',
  iconName: 'square-o',
  icon: [
    448,
    512,
    [],
    'e278',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM352 256A128 128 0 1 1 96 256a128 128 0 1 1 256 0zm-208 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M224 176a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm128 80A128 128 0 1 1 96 256a128 128 0 1 1 256 0z',
    ],
  ],
};
const faCaduceus = {
  prefix: 'fad',
  iconName: 'caduceus',
  icon: [
    512,
    512,
    [],
    'e681',
    [
      'M0 196.1C0 211.5 12.5 224 27.9 224l110.8 0c33.5 0 66.2-10.5 93.3-30l0-82L171.5 71.7c-7.5-5-16.4-7.7-25.4-7.7c-11.6 0-22.9 4.4-31.3 12.4L8.8 175.7C3.2 181 0 188.4 0 196.1zM144 280l0 3.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 24-14.4 24-14.4 0 28.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 3.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4l-24 14.4-24 14.4 0-28.8-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24zM280 112l0 82c27.2 19.5 59.8 30 93.3 30l110.8 0c15.4 0 27.9-12.5 27.9-27.9c0-7.7-3.2-15.1-8.8-20.4l-106-99.3c-8.5-8-19.7-12.4-31.3-12.4c-9 0-17.9 2.7-25.4 7.7L280 112z',
      'M304 48c0 17.8-9.7 33.3-24 41.6l0 240.8-48 28.8 0-269.6c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48zM232 415.2l48-28.8 0 69.6 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32 0-40.8z',
    ],
  ],
};
const faSignature = {
  prefix: 'fad',
  iconName: 'signature',
  icon: [
    640,
    512,
    [],
    'f5b7',
    [
      'M0 392c0-13.3 10.7-24 24-24l40 0 0 39.5c0 2.9 .1 5.7 .3 8.5L24 416c-13.3 0-24-10.7-24-24zm283.5 24c8.2-15.7 15.6-31.7 22.3-48L616 368c13.3 0 24 10.7 24 24s-10.7 24-24 24l-332.5 0z',
      'M224 96c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-53 43-96 96-96s96 43 96 96l0 7.8c0 20.8-1.2 41.6-3.6 62.3l122.4-36.7c11.4-3.4 23.8-.2 32.2 8.4s11.2 21.1 7.4 32.4l-18 53.9 83.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l12.5-37.5-94.4 28.3c-11.9 52.8-31.6 103.5-58.4 150.5l-13.9 24.3c-12.9 22.6-36.9 36.5-62.9 36.5c-40 0-72.5-32.5-72.5-72.5l0-71.9c0-42.4 27.8-79.8 68.4-92l84.4-25.3c4.8-27.2 7.1-54.9 7.1-82.5l0-7.8c0-17.7-14.3-32-32-32zm7.8 194.3l-49 14.7C169.3 309 160 321.5 160 335.6l0 71.9c0 4.7 3.8 8.5 8.5 8.5c3 0 5.9-1.6 7.4-4.3l13.9-24.3c17.6-30.8 31.7-63.4 42.1-97.2z',
    ],
  ],
};
const faStroopwafel = {
  prefix: 'fad',
  iconName: 'stroopwafel',
  icon: [
    512,
    512,
    [],
    'f551',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm59-45.3c0-4.1 1.6-8.2 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0c11.3 11.3 22.6 22.6 33.9 33.9c15.1-15.1 30.2-30.2 45.3-45.3c-18.9-18.9-37.7-37.7-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c18.9 18.9 37.7 37.7 56.6 56.6c15.1-15.1 30.2-30.2 45.3-45.3c-11.3-11.3-22.6-22.6-33.9-33.9c-6.2-6.2-6.2-16.4 0-22.6c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7C233.4 75 244.7 86.3 256 97.6c11.3-11.3 22.6-22.6 33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-11.3 11.3-22.6 22.6-33.9 33.9c15.1 15.1 30.2 30.2 45.3 45.3c18.9-18.9 37.7-37.7 56.6-56.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.6 56.6c15.1 15.1 30.2 30.2 45.3 45.3c11.3-11.3 22.6-22.6 33.9-33.9c6.2-6.2 16.4-6.2 22.6 0c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-11.3 11.3-22.6 22.6-33.9 33.9c11.3 11.3 22.6 22.6 33.9 33.9c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-6.2 6.2-16.4 6.2-22.6 0c-11.3-11.3-22.6-22.6-33.9-33.9l-45.3 45.3c18.9 18.9 37.7 37.7 56.6 56.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-56.6-56.6c-15.1 15.1-30.2 30.2-45.3 45.3c11.3 11.3 22.6 22.6 33.9 33.9c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-11.3-11.3-22.6-22.6-33.9-33.9c-11.3 11.3-22.6 22.6-33.9 33.9c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6c11.3-11.3 22.6-22.6 33.9-33.9c-15.1-15.1-30.2-30.2-45.3-45.3l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c18.9-18.9 37.7-37.7 56.6-56.6c-15.1-15.1-30.2-30.2-45.3-45.3c-11.3 11.3-22.6 22.6-33.9 33.9c-6.2 6.2-16.4 6.2-22.6 0c-3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3C75 278.6 86.3 267.3 97.6 256L63.7 222.1c-3.1-3.1-4.7-7.2-4.7-11.3zM142.9 256a45.3 45.3 0 1 0 90.5 0 45.3 45.3 0 1 0 -90.5 0zm67.9-67.9c15.1 15.1 30.2 30.2 45.3 45.3l45.3-45.3c-15.1-15.1-30.2-30.2-45.3-45.3c-15.1 15.1-30.2 30.2-45.3 45.3zm0 135.8C225.8 339 240.9 354 256 369.1c15.1-15.1 30.2-30.2 45.3-45.3c-15.1-15.1-30.2-30.2-45.3-45.3l-45.3 45.3zM278.6 256l45.3 45.3c15.1-15.1 30.2-30.2 45.3-45.3c-15.1-15.1-30.2-30.2-45.3-45.3c-15.1 15.1-30.2 30.2-45.3 45.3z',
      'M425.7 312.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9zM256 369.1l-45.3-45.3L256 278.6l45.3 45.3L256 369.1zm-67.9-67.9L142.9 256l45.3-45.3L233.4 256l-45.3 45.3zM256 233.4l-45.3-45.3L256 142.9l45.3 45.3L256 233.4zm67.9 67.9L278.6 256l45.3-45.3L369.1 256l-45.3 45.3z',
    ],
  ],
};
const faBold = {
  prefix: 'fad',
  iconName: 'bold',
  icon: [
    384,
    512,
    [],
    'f032',
    [
      'M0 64C0 46.3 14.3 32 32 32l48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-160L48 96 32 96C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z',
      '',
    ],
  ],
};
const faAnchorLock = {
  prefix: 'fad',
  iconName: 'anchor-lock',
  icon: [
    640,
    512,
    [],
    'e4ad',
    [
      'M0 336c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3l0-33.3c-5.2 .9-10.5 1.3-16 1.3l-48 0 0-208 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-4.7 4.7-7 10.8-7 17zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faBuildingNgo = {
  prefix: 'fad',
  iconName: 'building-ngo',
  icon: [
    384,
    512,
    [],
    'e4d7',
    [
      'M0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48zM32 80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4c11.6 17.3 23.1 34.7 34.7 52L96 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4c-11.6-17.3-23.1-34.7-34.7-52L64 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM152 80c0-8.8 7.2-16 16-16c16 0 32 0 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-10.7 0-21.3 0-32 0l0 64c5.3 0 10.7 0 16 0l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 13.3-10.7 24-24 24c-10.7 0-21.3 0-32 0c-13.3 0-24-10.7-24-24l0-88zm8 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-128c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm32-128l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M61.3 71.1c-3.9-5.9-11.2-8.5-17.9-6.4S32 72.9 32 80l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-43.2 34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.2-34.7-52zM152 80l0 88c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0 0-64 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM304 96c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm-48 16l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
    ],
  ],
};
const faTransporter3 = {
  prefix: 'fad',
  iconName: 'transporter-3',
  icon: [
    512,
    512,
    [],
    'e045',
    [
      'M0 144c0 4.1 2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128l-7.3-25.4C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm32-64c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm32-64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 192c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM416 48c0 4.1 2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32 472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm8 464l-88 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-88 0-80 0zM96 256.5l0-1c0 .3 0 .7 0 1z',
    ],
  ],
};
const faEngineWarning = {
  prefix: 'fad',
  iconName: 'engine-warning',
  icon: [
    640,
    512,
    ['engine-exclamation'],
    'f5f2',
    [
      'M0 160L0 352c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0-48-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24zM184 88c0 13.3 10.7 24 24 24l72 0 0 32 48 0 0-32 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L208 64c-13.3 0-24 10.7-24 24zM544 224l0 192c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z',
      'M128 144c-17.7 0-32 14.3-32 32l0 176c0 17.7 14.3 32 32 32l44.8 0 32 40c12.1 15.2 30.5 24 50 24L448 448c35.3 0 64-28.7 64-64l0-145.2c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14L208 144l-48 0-32 0zm196 64l0 88c0 11-9 20-20 20s-20-9-20-20l0-88c0-11 9-20 20-20s20 9 20 20zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faEngineExclamation = faEngineWarning;
const faCircleDownRight = {
  prefix: 'fad',
  iconName: 'circle-down-right',
  icon: [
    512,
    512,
    [],
    'e108',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-56c0-5.1 2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L280 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6L352 336c0 8.8-7.2 16-16 16l-137.4 0c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L216 280l-66.3-66.3C146 210 144 205.1 144 200z',
      'M352 336l0-137.4c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6L280 216l-66.3-66.3C210 146 205.1 144 200 144s-10 2-13.7 5.7l-36.7 36.7C146 190 144 194.9 144 200s2 10 5.7 13.7L216 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6L336 352c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faSquareK = {
  prefix: 'fad',
  iconName: 'square-k',
  icon: [
    448,
    512,
    [],
    'e274',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L278.9 135.2c4.7-4.8 10.9-7.2 17.1-7.2c6.1 0 12.1 2.3 16.8 6.9c9.5 9.3 9.6 24.5 .3 33.9l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5c-4.3 3.1-9.2 4.6-14.2 4.6c-7.4 0-14.7-3.4-19.4-9.8L206 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L128 152z',
      'M312.8 134.9c9.5 9.3 9.6 24.5 .3 33.9l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L128 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3z',
    ],
  ],
};
const faManatSign = {
  prefix: 'fad',
  iconName: 'manat-sign',
  icon: [
    384,
    512,
    [],
    'e1d5',
    [
      'M160 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 34.7c-5.2-.9-10.5-1.5-15.8-2c-2.7-.2-5.4-.4-8-.5c-1.3-.1-2.7-.1-4.1-.1s-2.7 0-4.1 0c-10.9 0-21.6 .9-32 2.7L160 64zm0 100c5.1-1.3 10.3-2.3 15.7-3c2.7-.3 5.4-.6 8.1-.8c1.4-.1 2.7-.2 4.1-.2s2.7-.1 4.1-.1c11 0 21.8 1.4 32 4l0 284c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-284z',
      'M0 288C0 182 86 96 192 96s192 86 192 192l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288z',
    ],
  ],
};
const faMoneyCheckPen = {
  prefix: 'fad',
  iconName: 'money-check-pen',
  icon: [
    640,
    512,
    ['money-check-edit'],
    'f872',
    [
      'M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64.6c-15.2 2-29.8 8.8-41.4 20.5L353.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-6 23.9L64 448c-35.3 0-64-28.7-64-64L0 128zm96 80c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16z',
      'M557.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71z',
    ],
  ],
};
const faMoneyCheckEdit = faMoneyCheckPen;
const faNotEqual = {
  prefix: 'fad',
  iconName: 'not-equal',
  icon: [
    448,
    512,
    [],
    'f53e',
    [
      'M16 176c0-17.7 14.3-32 32-32l212.2 0c-14.2 21.3-28.4 42.7-42.7 64L48 208c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l105.5 0c-14.2 21.3-28.4 42.7-42.7 64L48 368c-17.7 0-32-14.3-32-32zm171.8 32c14.2-21.3 28.4-42.7 42.7-64L400 304c17.7 0 32 14.3 32 32s-14.3 32-32 32l-212.2 0zM294.5 208c14.2-21.3 28.4-42.7 42.7-64l62.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-105.5 0z',
      'M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4l-256 384c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4l256-384c9.8-14.7 29.7-18.7 44.4-8.9z',
    ],
  ],
};
const faBorderTopLeft = {
  prefix: 'fad',
  iconName: 'border-top-left',
  icon: [
    448,
    512,
    ['border-style'],
    'f853',
    [
      'M96 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M32 480c-17.7 0-32-14.3-32-32L0 112C0 67.8 35.8 32 80 32l336 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96c-8.8 0-16 7.2-16 16l0 336c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faBorderStyle = faBorderTopLeft;
const faMapLocationDot = {
  prefix: 'fad',
  iconName: 'map-location-dot',
  icon: [
    576,
    512,
    ['map-marked-alt'],
    'f5a0',
    [
      'M0 209.6L0 480.4c0 17 17.1 28.6 32.9 22.3L160 451.8l0-251.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49C6 191 0 199.8 0 209.6zM192 255l0 194.4 192 54.9L384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77zm224-54.6L416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3L576 152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6z',
      'M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM288 72a40 40 0 1 1 0 80 40 40 0 1 1 0-80z',
    ],
  ],
};
const faMapMarkedAlt = faMapLocationDot;
const faTilde = {
  prefix: 'fad',
  iconName: 'tilde',
  icon: [
    448,
    512,
    [63135],
    '7e',
    [
      'M99.9 192C80.1 192 64 208.1 64 227.9L64 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-92.1C0 172.7 44.7 128 99.9 128c26.5 0 51.9 10.5 70.6 29.3L322.7 309.5c6.7 6.7 15.9 10.5 25.4 10.5c19.8 0 35.9-16.1 35.9-35.9l0-92.1c0-17.7 14.3-32 32-32s32 14.3 32 32l0 92.1c0 55.2-44.7 99.9-99.9 99.9c-26.5 0-51.9-10.5-70.6-29.3L125.3 202.5c-6.7-6.7-15.9-10.5-25.4-10.5z',
      '',
    ],
  ],
};
const faJedi = {
  prefix: 'fad',
  iconName: 'jedi',
  icon: [
    576,
    512,
    [],
    'f669',
    [
      'M200 336c0 3.8 2.7 7.1 6.4 7.8l37.6 7.5c2.2 .4 3.3 3 2 4.9l-21.2 31.9c-2.1 3.2-1.7 7.4 1 10.1s6.9 3.1 10.1 1l26.3-17.6c2.2-1.4 5.1 .2 5 2.8L265.1 446c7.4 1.3 15.1 2 22.9 2c1 0 1.9 0 2.9 0s1.9-.1 2.9-.1c1.9-.1 3.9-.2 5.8-.4c3.8-.3 7.6-.9 11.3-1.5l-2.1-61.5c-.1-2.6 2.8-4.2 5-2.8l26.3 17.6c3.2 2.1 7.4 1.7 10.1-1s3.1-6.9 1-10.1L330 356.3c-1.3-1.9-.2-4.5 2-4.9l37.5-7.5c3.7-.7 6.4-4 6.4-7.8s-2.7-7.1-6.4-7.8L332 320.6c-2.2-.4-3.3-3-2-4.9l21.2-31.9c2.1-3.2 1.7-7.4-1-10.1s-6.9-3.1-10.1-1l-29.5 19.7c-2.1 1.4-4.9 0-5-2.6L296.3 8c-.1-4.5-3.8-8-8.3-8s-8.1 3.5-8.3 8l-9.4 281.9c-.1 2.5-2.9 3.9-5 2.6l-29.5-19.7c-3.2-2.1-7.4-1.7-10.1 1s-3.1 6.9-1 10.1L246 315.7c1.3 1.9 .2 4.5-2 4.9l-37.6 7.5c-3.7 .7-6.4 4-6.4 7.8z',
      'M376.2 201.9c-7.5 5.8-8 17.9-1 24.4C400.3 249.6 416 283 416 320c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-37 15.7-70.4 40.8-93.7c7-6.5 6.5-18.6-1-24.4C165.9 175.5 144 134.3 144 88c0-16.8 2.9-33 8.2-48c4.6-13-10.2-30-21.4-22C77.3 56 38.1 112.8 22.9 178.8c-.5 2.1 .2 4.3 1.7 5.9l28.4 28.4c4 4 1.2 10.9-4.5 10.9l-26 0c-3.4 0-6.2 2.6-6.3 6c-.1 3.3-.2 6.6-.2 10c0 17.5 1.7 34.7 4.8 51.3c.2 1.2 .8 2.4 1.7 3.3l46.5 46.5c4 4 1.2 10.9-4.5 10.9L50 352c-4.6 0-7.7 4.8-5.7 9C88.8 450.5 181.2 512 288 512s199.2-61.5 243.7-151c2.1-4.2-1-9-5.7-9l-14.6 0c-5.7 0-8.6-6.9-4.5-10.9l46.5-46.5c.9-.9 1.5-2 1.7-3.3c3.2-16.6 4.8-33.8 4.8-51.3c0-3.3-.1-6.7-.2-10c-.1-3.4-2.9-6-6.3-6l-26 0c-5.7 0-8.6-6.9-4.5-10.9l28.4-28.4c1.5-1.5 2.2-3.8 1.7-5.9C537.9 112.8 498.7 56 445.2 18c-11.3-8-26 8.9-21.4 22c5.3 15 8.2 31.2 8.2 48c0 46.3-21.9 87.5-55.8 113.9z',
    ],
  ],
};
const faSquarePollVertical = {
  prefix: 'fad',
  iconName: 'square-poll-vertical',
  icon: [
    448,
    512,
    ['poll'],
    'f681',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 256c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zm96-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192zm96 160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32z',
      'M192 160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192zM96 256c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zm224 32c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faPoll = faSquarePollVertical;
const faArrowDownSquareTriangle = {
  prefix: 'fad',
  iconName: 'arrow-down-square-triangle',
  icon: [
    576,
    512,
    ['sort-shapes-down-alt'],
    'f889',
    [
      'M304 448c0 5.3 1.3 10.7 4 15.5c5.6 10.2 16.4 16.5 28 16.5l160 0c11.6 0 22.3-6.3 28-16.5c2.7-4.8 4-10.2 4-15.5c0-5.9-1.6-11.8-4.9-17l-80-128c-5.8-9.4-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-3.2 5.2-4.9 11.1-4.9 17zM320 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortShapesDownAlt = faArrowDownSquareTriangle;
const faMugHot = {
  prefix: 'fad',
  iconName: 'mug-hot',
  icon: [
    512,
    512,
    [9749],
    'f7b6',
    [
      'M64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24S64 10.7 64 24zm112 0c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M32 192c-17.7 0-32 14.3-32 32L0 416c0 53 43 96 96 96l192 0c53 0 96-43 96-96l16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-48 0L32 192zm352 64l16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0-96z',
    ],
  ],
};
const faDogLeashed = {
  prefix: 'fad',
  iconName: 'dog-leashed',
  icon: [
    576,
    512,
    [129454],
    'f6d4',
    [
      'M96 16c0 4 1.5 7.9 4.4 11L256 190.4 256 384c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.2 0-4.4 0-6.6c0-56.4 0-112.8 0-169.3c42.7 18 85.3 35.9 128 53.9c.6 .3 1.2 .5 1.8 .8c8.1 3.4 17.5-.4 21-8.5s-.4-17.5-8.5-21c-3.2-1.4-6.5-2.7-9.7-4.1c-38.2-16.1-76.4-32.2-114.6-48.3l-24.6-10.3L123.6 5c-3.1-3.3-7.4-5-11.6-5c-4 0-7.9 1.5-11 4.4c-3.3 3.1-5 7.4-5 11.6z',
      'M256 192l-112 0-16 0-30 0c-14.7 0-27.5-10-31-24.2L63 152.2c-4.3-17.1-21.7-27.6-38.8-23.3S-3.3 150.6 1 167.8l3.9 15.5c7.8 31.2 30.4 55.6 59.2 66.5L64 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-115.2c24 12.3 51.2 19.2 80 19.2c5.4 0 10.7-.2 16-.7L256 192zm32 185.4c11.2-3.2 21.9-7.4 32-12.6L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-218L288 208.1l0 169.3zM420.5 229.2l6.2-37.2 21.3 0 16 0 32 0c44.2 0 80-35.8 80-80l0-24c0-13.3-10.7-24-24-24l-56 0L478.1 46.1c-9-9-21.2-14.1-33.9-14.1L392 32 375.1 9.5c-4.5-6-11.5-9.5-19-9.5c-11.6 0-21.5 8.4-23.4 19.8l-26.8 161 114.6 48.3zM432 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faCarBattery = {
  prefix: 'fad',
  iconName: 'car-battery',
  icon: [
    512,
    512,
    ['battery-car'],
    'f5df',
    [
      'M0 160c0-35.3 28.7-64 64-64l16 0 128 0 96 0 128 0 16 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 160zm80 80c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm224 0c0 8.8 7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16z',
      'M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32H80zm224 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32H304z',
    ],
  ],
};
const faBatteryCar = faCarBattery;
const faFaceDowncastSweat = {
  prefix: 'fad',
  iconName: 'face-downcast-sweat',
  icon: [
    512,
    512,
    [],
    'e371',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0c-51.4 0-99.3 15.2-139.4 41.2c1.5 3.1 3 6.2 4.3 9.3c3.4 8 7.1 19 7.1 30.5c0 44.3-36.6 79-80 79c-9.6 0-18.8-1.7-27.4-4.8C7.3 186.1 0 220.2 0 256zm96 16c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm76.1 117.3C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6zM288 272c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
      'M48 128C21.5 128 0 107 0 81C0 61 28.6 20.6 41.6 3.3c3.2-4.4 9.6-4.4 12.8 0C67.6 20.6 96 61 96 81c0 26-21.5 47-48 47zM96 272c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faMailboxFlagUp = {
  prefix: 'fad',
  iconName: 'mailbox-flag-up',
  icon: [
    576,
    512,
    [],
    'e5bb',
    [
      'M144 64c79.5 0 144 64.5 144 144l0 176c0 35.3-28.7 64-64 64l288 0c35.3 0 64-28.7 64-64l0-176c0-56.5-32.6-105.5-80-129l0 17c0 8.8-7.2 16-16 16l-64 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112 0-32L144 64z',
      'M400 224c-8.8 0-16-7.2-16-16l0-112 0-48c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-64 0 0 96c0 8.8-7.2 16-16 16zM0 208C0 128.5 64.5 64 144 64s144 64.5 144 144l0 176c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 208zm64 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 192c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faMemoCircleInfo = {
  prefix: 'fad',
  iconName: 'memo-circle-info',
  icon: [
    576,
    512,
    [],
    'e49a',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c3.3 0 6.6-.3 9.7-.7C285.1 479.3 256 427.1 256 368c0-80.6 54.1-148.5 128-169.4L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 80c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-40 56c-8.8 0-16 7.2-16 16s7.2 16 16 16c0 0 0 0 0 0l0 48s0 0 0 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0z',
    ],
  ],
};
const faGift = {
  prefix: 'fad',
  iconName: 'gift',
  icon: [
    512,
    512,
    [127873],
    'f06b',
    [
      'M0 160c0-17.7 14.3-32 32-32l41.6 0c7.3 14.2 18.3 26.2 31.8 34.7c6.8 4.2 14.1 7.5 21.9 9.8c3.9 1.1 7.9 2 12 2.6c2.1 .3 4.1 .5 6.2 .7c1 .1 2.1 .1 3.2 .2s2.1 .1 3.2 .1l64 0 8 0 0 80L32 256c-17.7 0-32-14.3-32-32l0-64zM32 288l192 0 0 224L80 512c-26.5 0-48-21.5-48-48l0-176zM288 176l72 0c34.2 0 63.8-19.5 78.4-48l41.6 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-192 0 0-80zm0 112l192 0 0 176c0 26.5-21.5 48-48 48l-144 0 0-224z',
      'M190.5 68.8L225.3 128l-1.3 0-8 0-64 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88s39.4 88 88 88l64 0 8 0 0 80 64 0 0-80 72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5zm65.5-16.7C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zM288 512l0-224-64 0 0 224 64 0z',
    ],
  ],
};
const faDiceTwo = {
  prefix: 'fad',
  iconName: 'dice-two',
  icon: [
    448,
    512,
    [9857],
    'f528',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faVolume = {
  prefix: 'fad',
  iconName: 'volume',
  icon: [
    576,
    512,
    [128265, 'volume-medium'],
    'f6a8',
    [
      'M405.4 200.1c0-5.3 1.8-10.7 5.4-15.1c8.4-10.3 23.5-11.8 33.8-3.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-5.8-4.7-8.9-11.7-8.9-18.6zm65.9-89.6c8.4-10.3 23.5-11.8 33.8-3.5c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8z',
      'M352 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L163.8 160 96 160c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l67.8 0L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448l0-384z',
    ],
  ],
};
const faVolumeMedium = faVolume;
const faTransporter5 = {
  prefix: 'fad',
  iconName: 'transporter-5',
  icon: [
    512,
    512,
    [],
    'e2a6',
    [
      'M0 176c0 4.1 2.7 7.6 6.6 8.7L32 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 160 6.6 167.3C2.7 168.4 0 171.9 0 176zm96 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm64-128c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 256c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM208 16c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0c-8.8 0-16 7.2-16 16zM416 48c0 4.1 2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32 472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faGaugeCircleBolt = {
  prefix: 'fad',
  iconName: 'gauge-circle-bolt',
  icon: [
    640,
    512,
    [],
    'e496',
    [
      'M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2z',
    ],
  ],
};
const faCoinFront = {
  prefix: 'fad',
  iconName: 'coin-front',
  icon: [
    512,
    512,
    [],
    'e3fc',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm448 0A192 192 0 1 1 64 256a192 192 0 1 1 384 0zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm136-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144z',
      'M256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384z',
    ],
  ],
};
const faFileSlash = {
  prefix: 'fad',
  iconName: 'file-slash',
  icon: [
    640,
    512,
    [],
    'e3a7',
    [
      'M128 64l0 11C256 175.4 384 275.7 512 376l0-216-128 0c-17.7 0-32-14.3-32-32L352 0 192 0c-35.3 0-64 28.7-64 64zm0 132.8L128 448c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8L128 196.8zM384 0l0 128 128 0L384 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faMessageArrowUpRight = {
  prefix: 'fad',
  iconName: 'message-arrow-up-right',
  icon: [
    512,
    512,
    [],
    'e1dd',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM160 280c0 6.1 2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7l87-87 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-87 87c-4.7 4.7-7 10.8-7 17z',
      'M176 152c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87L200 176c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faTreasureChest = {
  prefix: 'fad',
  iconName: 'treasure-chest',
  icon: [
    576,
    512,
    [],
    'f723',
    [
      'M0 160l0 96 96 0L96 36C40.8 50.2 0 100.4 0 160zM0 288L0 432c0 26.5 21.5 48 48 48l48 0 0-192L0 288zM160 32l0 224 64 0 0-32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 32 64 0 0-224L160 32zm0 256l0 192 256 0 0-192-64 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32-64 0zM480 36l0 220 96 0 0-96c0-59.6-40.8-109.8-96-124zm0 252l0 192 48 0c26.5 0 48-21.5 48-48l0-144-96 0z',
      'M160 32l0 224-64 0L96 36c10.2-2.6 21-4 32-4l32 0zM416 256l0-224 32 0c11 0 21.8 1.4 32 4l0 220-64 0zM224 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96zm64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM160 480l-64 0 0-192 64 0 0 192zm256 0l0-192 64 0 0 192-64 0z',
    ],
  ],
};
const faChessQueen = {
  prefix: 'fad',
  iconName: 'chess-queen',
  icon: [
    512,
    512,
    [9819],
    'f445',
    [
      'M64 489.4C64 501.9 74.1 512 86.6 512l338.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L400 432l-.4 0L384 432l-38.4 0-179.2 0L128 432l-15.6 0-.4 0L70.6 473.4c-4.2 4.2-6.6 10-6.6 16z',
      'M312 56A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM164.3 120c-15.3 0-27 10.8-30.2 23.8c-7 27.8-32.2 48.3-62.1 48.3c-10.8 0-20.9-2.7-29.8-7.3c-8.4-4.4-19-4.5-27.7 .9C2.1 193.3-2.4 209.2 4.3 222.2L112.4 432l15.6 0 38.4 0 179.2 0 38.4 0 15.6 0L507.7 222.2c6.7-13 2.2-28.9-10.2-36.5c-8.7-5.4-19.3-5.4-27.7-.9c-8.9 4.7-19 7.3-29.8 7.3c-29.9 0-55.1-20.5-62.1-48.3c-3.3-13-15-23.8-30.2-23.8c-12.3 0-22.6 7.2-27.7 17c-12 23.2-36.2 39-64 39s-52-15.8-64-39c-5.1-9.8-15.4-17-27.7-17zM256 224s0 0 0 0s0 0 0 0s0 0 0 0z',
    ],
  ],
};
const faPaintbrushFine = {
  prefix: 'fad',
  iconName: 'paintbrush-fine',
  icon: [
    576,
    512,
    ['paint-brush-alt', 'paint-brush-fine', 'paintbrush-alt'],
    'f5a9',
    [
      'M0 480c0 17.7 14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-10-1.3-19.7-3.8-29c-26.4-26.5-52.7-52.8-79.2-79.2c-9.3-2.4-19-3.8-29-3.8c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448L32 448c-17.7 0-32 14.3-32 32z',
      'M559.6 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0L205.1 291.7l79.2 79.2L559.6 95.6z',
    ],
  ],
};
const faPaintBrushAlt = faPaintbrushFine;
const faPaintBrushFine = faPaintbrushFine;
const faPaintbrushAlt = faPaintbrushFine;
const faGlasses = {
  prefix: 'fad',
  iconName: 'glasses',
  icon: [
    576,
    512,
    [],
    'f530',
    [
      'M48 314.2c27.2-11.8 58.2-18.2 87.7-18.2c29.4 0 60.4 6.3 87.7 18l-3.2 57.5c-1.9 33.9-29.9 60.5-63.9 60.5L112 432c-35.3 0-64-28.7-64-64l0-16 0-37.8zm304.6-.2c27.3-11.7 58.3-18 87.7-18c29.5 0 60.5 6.4 87.7 18.2l0 53.8c0 35.3-28.7 64-64 64l-44.3 0c-34 0-62-26.5-63.9-60.5L352.6 314z',
      'M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6l0 5.2c0 .5 0 1 0 1.5l0 41.3c0 .2 0 .4 0 .6l0 15.4c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352l0 16c0 35.3 28.7 64 64 64l44.3 0c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2L48 352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5l44.3 0c35.3 0 64-28.7 64-64l0-53.8c-27.2-11.8-58.2-18.2-87.7-18.2z',
    ],
  ],
};
const faHoodCloak = {
  prefix: 'fad',
  iconName: 'hood-cloak',
  icon: [
    576,
    512,
    [],
    'f6ef',
    [
      'M160 320l0 192 256 0 0-192c0-70.7-57.3-128-128-128s-128 57.3-128 128z',
      'M432 0L288 0s0 0 0 0c-9.8 0-66 0-120.2 37.7C111.4 76.9 64 151.8 64 288c0 58.5-14.6 101.6-28.6 129.7c-7 14.1-14 24.5-19 31.1c-2.5 3.3-4.5 5.7-5.7 7.1c-.6 .7-1.1 1.2-1.3 1.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8l128 0 0-192c0-70.7 57.3-128 128-128s128 57.3 128 128l0 192 128 0c12.9 0 24.6-7.8 29.6-19.8c4.9-11.9 2.2-25.6-6.8-34.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-.1-.1c-.2-.2-.7-.7-1.3-1.4c-1.3-1.4-3.2-3.8-5.7-7.1c-5-6.6-11.9-17-19-31.1C526.6 389.6 512 346.5 512 288c0-103.1-46.5-172.8-95.8-217.2l32-29c7.3-6.7 9.8-17.2 6.2-26.4S441.9 0 432 0z',
    ],
  ],
};
const faSquareQuote = {
  prefix: 'fad',
  iconName: 'square-quote',
  icon: [
    448,
    512,
    [],
    'e329',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 96c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48zm144 0c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48z',
      'M96 192c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48zm256 87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3z',
    ],
  ],
};
const faUpLeft = {
  prefix: 'fad',
  iconName: 'up-left',
  icon: [
    384,
    512,
    [],
    'e2bd',
    [
      'M142.6 302.6L276.7 436.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3l41.4-41.4c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L238.6 206.6l-96 96z',
      'M48 80H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-240 240c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V112c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faBringFront = {
  prefix: 'fad',
  iconName: 'bring-front',
  icon: [
    640,
    512,
    [],
    'f857',
    [
      'M0 64L0 192c0 35.3 28.7 64 64 64l96 0 0-64-96 0L64 64l128 0 0 40.6c9.4-5.4 20.3-8.6 32-8.6l32 0 0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM384 416l0 32c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-96 0 0 64 96 0 0 128-128 0 0-40.6c-9.4 5.4-20.3 8.6-32 8.6l-32 0z',
      'M224 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L224 96z',
    ],
  ],
};
const faChessBoard = {
  prefix: 'fad',
  iconName: 'chess-board',
  icon: [
    448,
    512,
    [],
    'f43c',
    [
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM384 96l0 320L64 416 64 96l320 0z',
      'M192 96l-64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0 0-64zm0 128l-64 0 0-64 64 0 0 64zm64 0l0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64 64 0zm0 0l0-64 64 0 0 64-64 0z',
    ],
  ],
};
const faBurgerCheese = {
  prefix: 'fad',
  iconName: 'burger-cheese',
  icon: [
    512,
    512,
    [127828, 'cheeseburger'],
    'f7f1',
    [
      'M32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1L61.1 224C45 224 32 211 32 194.9zM32 400c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16l0 16c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-16zm80-272a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm99.9 128c72 0 144.1 0 216.1 0c-7.9 0-15.6 2.3-22.1 6.7c-22.7 15.2-45.5 30.3-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0c-22.7-15.2-45.5-30.3-68.2-45.5c-6.5-4.4-14.2-6.7-22.1-6.7zM240 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm128 32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M302.2 308.2L234 262.7c-6.5-4.4-14.2-6.7-22.1-6.7l-3.9 0-.1 0L64 256c-26.5 0-48 21.5-48 48s21.5 48 48 48l384 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-15.9 0-.1 0-3.9 0c-7.9 0-15.6 2.3-22.1 6.7l-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0z',
    ],
  ],
};
const faCheeseburger = faBurgerCheese;
const faBuildingCircleCheck = {
  prefix: 'fad',
  iconName: 'building-circle-check',
  icon: [
    640,
    512,
    [],
    'e4d2',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 184.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faRepeat1 = {
  prefix: 'fad',
  iconName: 'repeat-1',
  icon: [
    512,
    512,
    [128258],
    'f365',
    [
      'M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96l160 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32l0 32L160 64C71.6 64 0 135.6 0 224zM73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 160 0c88.4 0 160-71.6 160-160c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z',
      'M278 196.5c6.3 4.5 10 11.8 10 19.5l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3z',
    ],
  ],
};
const faArrowDownToLine = {
  prefix: 'fad',
  iconName: 'arrow-down-to-line',
  icon: [
    384,
    512,
    ['arrow-to-bottom'],
    'f33d',
    [
      'M0 448c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
      'M169.4 342.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 242.7 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 178.7L86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z',
    ],
  ],
};
const faArrowToBottom = faArrowDownToLine;
const faGrid5 = {
  prefix: 'fad',
  iconName: 'grid-5',
  icon: [
    448,
    512,
    [],
    'e199',
    [
      'M0 144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM0 336l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM96 48l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 192l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 192l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-288l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 192l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM288 48l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 192l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 192l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-288l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 192l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M0 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80L0 48zM0 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM16 416l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 176l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 176l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM304 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 32l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 176l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faSwapArrows = {
  prefix: 'fad',
  iconName: 'swap-arrows',
  icon: [
    640,
    512,
    [],
    'e60a',
    [
      'M288 160l0 96 64 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 242.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l96-96c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-12.5-12.5-32.8-12.5-45.3 0L544 402.7 544 160c0-70.7-57.3-128-128-128s-128 57.3-128 128z',
      'M150.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 109.3 96 352c0 70.7 57.3 128 128 128s128-57.3 128-128l0-96-64 0 0 96c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-242.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z',
    ],
  ],
};
const faRightLongToLine = {
  prefix: 'fad',
  iconName: 'right-long-to-line',
  icon: [
    640,
    512,
    [],
    'e444',
    [
      'M576 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z',
    ],
  ],
};
const faPersonChalkboard = {
  prefix: 'fad',
  iconName: 'person-chalkboard',
  icon: [
    640,
    512,
    [],
    'e53d',
    [
      'M32 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L120 256.9 120 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288 56 0 64 0 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0-64 0-76.9 0-65.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C33.5 276.7 32 282.4 32 288zM144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M384 128l0-64 192 0 0 192-192 0 0-64-64 0 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 80 64 0z',
    ],
  ],
};
const faMarsStrokeRight = {
  prefix: 'fad',
  iconName: 'mars-stroke-right',
  icon: [
    640,
    512,
    [9897, 'mars-stroke-h'],
    'f22b',
    [
      'M128 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152l33.6 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 32 0 0-56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-56-32 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-33.6 0z',
    ],
  ],
};
const faMarsStrokeH = faMarsStrokeRight;
const faHandBackFist = {
  prefix: 'fad',
  iconName: 'hand-back-fist',
  icon: [
    448,
    512,
    ['hand-rock'],
    'f255',
    [
      'M144 0C117.5 0 96 21.5 96 48l0 48 0 28.5L96 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-26.7-9 7.5C40.4 169 32 187 32 206L32 244c0 38 16.9 74 46.1 98.3L128 384l0 96c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-105.3c46.9-19 80-65 80-118.7l0-80 0-16 0-16c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z',
      '',
    ],
  ],
};
const faHandRock = faHandBackFist;
const faGridRound5 = {
  prefix: 'fad',
  iconName: 'grid-round-5',
  icon: [
    448,
    512,
    [],
    'e5de',
    [
      'M0 160a32 32 0 1 0 64 0A32 32 0 1 0 0 160zM0 352a32 32 0 1 0 64 0A32 32 0 1 0 0 352zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 192A32 32 0 1 1 0 256a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
    ],
  ],
};
const faTally = {
  prefix: 'fad',
  iconName: 'tally',
  icon: [
    640,
    512,
    ['tally-5'],
    'f69c',
    [
      'M96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 211.6L96 296.9 96 64zm0 300.4c21.3-7.1 42.7-14.2 64-21.3L160 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-83.6zM224 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 168.9-64 21.3L224 64zm0 257.7c21.3-7.1 42.7-14.2 64-21.3L288 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-126.3zM352 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 126.3-64 21.3L352 64zm0 215.1c21.3-7.1 42.7-14.2 64-21.3L416 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-168.9zM480 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 83.6-64 21.3L480 64zm0 172.4c21.3-7.1 42.7-14.2 64-21.3L544 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-211.6z',
      'M638.4 149.9c5.6 16.8-3.5 34.9-20.2 40.5l-576 192c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l576-192c16.8-5.6 34.9 3.5 40.5 20.2z',
    ],
  ],
};
const faTally5 = faTally;
const faSquareCaretUp = {
  prefix: 'fad',
  iconName: 'square-caret-up',
  icon: [
    448,
    512,
    ['caret-square-up'],
    'f151',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 296c0-5.9 2.2-11.8 6.4-16.3l104-112c4.5-4.9 10.9-7.7 17.6-7.7s13 2.8 17.6 7.7l104 112c4.2 4.5 6.4 10.4 6.4 16.3c0 3.2-.7 6.5-2 9.6c-3.8 8.7-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4c-1.3-3.1-2-6.3-2-9.6z',
      'M241.6 167.7c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4l208 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z',
    ],
  ],
};
const faCaretSquareUp = faSquareCaretUp;
const faCloudShowersWater = {
  prefix: 'fad',
  iconName: 'cloud-showers-water',
  icon: [
    576,
    512,
    [],
    'e4e4',
    [
      'M.8 487.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4zM51.4 347.7c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9c-3.9-2.3-8.1-3.4-12.3-3.4c-8.2 0-16.1 4.2-20.6 11.7l-48 80zm112 0c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9c-3.9-2.3-8.1-3.4-12.3-3.4c-8.2 0-16.1 4.2-20.6 11.7l-48 80zm112 0c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9c-3.9-2.3-8.1-3.4-12.3-3.4c-8.2 0-16.1 4.2-20.6 11.7l-48 80zm112 0c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9c-3.9-2.3-8.1-3.4-12.3-3.4c-8.2 0-16.1 4.2-20.6 11.7l-48 80z',
      'M311.2 55.7C295.9 22.8 262.6 0 224 0c-53 0-96 43-96 96c-35.3 0-64 28.7-64 64s28.7 64 64 64l320 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-1.6 0C439 59.5 406.7 32 368 32c-22.2 0-42.3 9.1-56.8 23.7z',
    ],
  ],
};
const faChartBar = {
  prefix: 'fad',
  iconName: 'chart-bar',
  icon: [
    512,
    512,
    ['bar-chart'],
    'f080',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 96zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0z',
    ],
  ],
};
const faBarChart = faChartBar;
const faHandsBubbles = {
  prefix: 'fad',
  iconName: 'hands-bubbles',
  icon: [
    576,
    512,
    ['hands-wash'],
    'e05e',
    [
      'M32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7l0-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8L218.3 141.7c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l51.5-89.1c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5L149.9 116c-18 31.1-35.9 62.2-53.9 93.3L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM64 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.4 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8L307.5 131zm39.8 85l4.7 0 13.3 0c10.6 0 21.2 0 31.8 0l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4zM384 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352l0 8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-92 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-124 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l156 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-156 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0s0 0 0 0s0 0 0 0l-93.2 0L305 219.1c15-9.4 19.5-29.1 10.2-44.1z',
    ],
  ],
};
const faHandsWash = faHandsBubbles;
const faLessThanEqual = {
  prefix: 'fad',
  iconName: 'less-than-equal',
  icon: [
    448,
    512,
    [],
    'f537',
    [
      'M32 192c0 13.1 8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8c1.6-3.9 2.3-7.9 2.3-11.9c0-12.7-7.6-24.7-20.1-29.7L150.2 192 395.9 93.7c12.5-5 20.1-17 20.1-29.7c0-4-.7-8-2.3-11.9c-6.6-16.4-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192z',
      'M0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faTrain = {
  prefix: 'fad',
  iconName: 'train',
  icon: [
    448,
    512,
    [128646],
    'f238',
    [
      'M35.1 492.9C28.1 499.9 33.1 512 43 512l39.7 0c8.5 0 16.6-3.4 22.6-9.4L160 448c-21.3 0-42.7 0-64 0c-2.6 0-5.1-.1-7.5-.3s-4.9-.5-7.3-.9l-46 46zm29-400.2c-.1 .5-.1 1.1-.1 1.6s0 1.1 0 1.6c0 32 0 64 0 96c0 .6 0 1.1 0 1.7s.1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4l256 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 64c-8.8 0-16.8 3.6-22.6 9.4c-2.9 2.9-5.2 6.3-6.9 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2zM288 448l54.6 54.6c6 6 14.1 9.4 22.6 9.4l39.7 0c6.8 0 11.2-5.5 11.2-11.3c0-2.8-1-5.6-3.3-7.8l-46-46c-4.8 .8-9.8 1.1-14.9 1.1c-21.3 0-42.7 0-64 0z',
      'M0 96C0 43 43 0 96 0L352 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 448c-53 0-96-43-96-96L0 96zm64 0l0 96c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faUpFromDottedLine = {
  prefix: 'fad',
  iconName: 'up-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e456',
    [
      'M0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M196.7 43.3L73.9 166.1c-6.4 6.4-9.9 15-9.9 24C64 208.8 79.2 224 97.9 224l62.1 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L251.3 43.3C244.1 36.1 234.2 32 224 32s-20.1 4.1-27.3 11.3z',
    ],
  ],
};
const faEyeLowVision = {
  prefix: 'fad',
  iconName: 'eye-low-vision',
  icon: [
    640,
    512,
    ['low-vision'],
    'f2a8',
    [
      'M150.7 92.8l72.4 56.7C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7c26.4 20.7 52.7 41.3 79.1 62c39.6-40.6 66.4-86.1 79.9-118.4c1.6-3.9 2.5-8.1 2.5-12.3s-.8-8.4-2.5-12.3c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8zm161 67.6c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3c31.5 24.7 63 49.4 94.6 74.1c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4z',
      'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L38.8 5.1zM33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8zM393.6 469.4c18.7-5.5 36.2-13 52.6-21.8L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7z',
    ],
  ],
};
const faLowVision = faEyeLowVision;
const faTrafficLightGo = {
  prefix: 'fad',
  iconName: 'traffic-light-go',
  icon: [
    320,
    512,
    [],
    'f638',
    [
      'M112 368a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z',
    ],
  ],
};
const faFaceExhaling = {
  prefix: 'fad',
  iconName: 'face-exhaling',
  icon: [
    576,
    512,
    [],
    'e480',
    [
      'M0 256C0 397.4 114.6 512 256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7C329.3 410.6 320 398.1 320 384s9.3-26.6 22.8-30.6L385 340.7c5.3-30 31.5-52.7 63-52.7c.7 0 1.4 0 2.1 0c13.2-14.7 32.3-24 53.7-24c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256zm99.2 1.6c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0zM296 384a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-4.8-126.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0z',
      'M543.5 336c0 .8 0 1.7-.1 2.5c19 6.4 32.6 24.4 32.6 45.5s-13.6 39.1-32.6 45.5c.1 .8 .1 1.7 .1 2.5c0 22.1-17.9 40-39.9 40c-14.2 0-26.6-7.4-33.7-18.5c-4.4 1.6-9.1 2.5-14 2.5c-22.1 0-39.9-17.9-39.9-40c0-2.7 .3-5.3 .8-7.8l-56.9-14.2c-4.6-1.1-7.8-5.2-7.8-9.9s3.2-8.8 7.8-9.9L415.9 360c0-22.1 17.9-40 39.9-40c3.6 0 7.2 .5 10.5 1.4c5.8-14.9 20.3-25.4 37.2-25.4c22.1 0 39.9 17.9 39.9 40z',
    ],
  ],
};
const faSensorFire = {
  prefix: 'fad',
  iconName: 'sensor-fire',
  icon: [
    640,
    512,
    [],
    'e02a',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1c0 49.3 18.6 95.2 49.6 129.9L64 480c-35.3 0-64-28.7-64-64L0 96zm64 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 0l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M433.8 163.6c5.6-5 14.2-5 19.8 0c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 56.7 24.2 76.9c0 87.8-71.3 161.9-160 161.9c-89.7 0-160-74.2-160-161.9c0-26.4 12.7-58.6 32.4-90.6c20-32.4 48.1-66.1 81.4-95.8zM481 447.9c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z',
    ],
  ],
};
const faUserUnlock = {
  prefix: 'fad',
  iconName: 'user-unlock',
  icon: [
    640,
    512,
    [],
    'e058',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3l0 128c0 11.7 3.1 22.6 8.6 32L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M528 240c-17.7 0-32 14.3-32 32l0 48 16 0 48 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faHexagonDivide = {
  prefix: 'fad',
  iconName: 'hexagon-divide',
  icon: [
    512,
    512,
    [],
    'e1ad',
    [
      'M7.4 256c0 12.4 3.2 24.9 9.6 36l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c6.4-11.1 9.6-23.6 9.6-36s-3.2-24.9-9.6-36L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220c-6.4 11.1-9.6 23.6-9.6 36zM144 256c0-13.3 10.7-24 24-24c58.7 0 117.3 0 176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-58.7 0-117.3 0-176 0c-13.3-.1-24-10.8-24-24zm144-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const fa00 = {
  prefix: 'fad',
  iconName: '00',
  icon: [
    640,
    512,
    [],
    'e467',
    [
      'M352 176c0-79.5 64.5-144 144-144s144 64.5 144 144l0 160c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-160zm64 0l0 160c0 44.2 35.8 80 80 80s80-35.8 80-80l0-160c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
      'M0 176C0 96.5 64.5 32 144 32s144 64.5 144 144l0 160c0 79.5-64.5 144-144 144S0 415.5 0 336L0 176zM144 96c-44.2 0-80 35.8-80 80l0 160c0 44.2 35.8 80 80 80s80-35.8 80-80l0-160c0-44.2-35.8-80-80-80z',
    ],
  ],
};
const faCrow = {
  prefix: 'fad',
  iconName: 'crow',
  icon: [
    640,
    512,
    [],
    'f520',
    [
      'M259.2 384l51.9 0 39.1 94.9c5 12.3-.8 26.3-13.1 31.3c-3 1.2-6.1 1.8-9.1 1.8c-9.4 0-18.4-5.6-22.2-14.9L259.2 384zm96 0c16.9-.3 33.4-2.8 49-7.1l42 102c5 12.3-.8 26.3-13.1 31.3c-3 1.2-6.1 1.8-9.1 1.8c-9.4 0-18.4-5.6-22.2-14.9L355.2 384zM523.9 32L574 32c29.4 0 55 20 62.1 48.5L640 96l-96 24 0-32c0-21.3-7.5-40.8-20.1-56z',
      'M456 0c-48.6 0-88 39.4-88 88l0 29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384 352 384c106 0 192-86 192-192l0-64 0-40c0-48.6-39.4-88-88-88zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faCassetteBetamax = {
  prefix: 'fad',
  iconName: 'cassette-betamax',
  icon: [
    576,
    512,
    ['betamax'],
    'f8a4',
    [
      'M0 160l576 0 0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160zM64 320a96 96 0 1 0 192 0A96 96 0 1 0 64 320zm256-64l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z',
      'M64 32C28.7 32 0 60.7 0 96l0 64 576 0 0-64c0-35.3-28.7-64-64-64L64 32zM192 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96a96 96 0 1 0 0 192 96 96 0 1 0 0-192z',
    ],
  ],
};
const faBetamax = faCassetteBetamax;
const faSailboat = {
  prefix: 'fad',
  iconName: 'sailboat',
  icon: [
    576,
    512,
    [],
    'e445',
    [
      'M66.1 328.1l128-224c3.6-6.3 11-9.4 18-7.5s11.9 8.2 11.9 15.5l0 224c0 8.8-7.2 16-16 16L80 352c-5.7 0-11-3-13.8-8s-2.9-11-.1-16zM256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c1.9 2.7 2.9 6 2.9 9.2c0 2.5-.6 5.1-1.8 7.4c-2.8 5.3-8.2 8.6-14.2 8.6l-224 0c-8.8 0-16-7.2-16-16l0-320z',
      'M5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z',
    ],
  ],
};
const faWindowRestore = {
  prefix: 'fad',
  iconName: 'window-restore',
  icon: [
    512,
    512,
    [],
    'f2d2',
    [
      'M128 80l0 16 64 0 0-16c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-16 0 0 64 16 0c44.2 0 80-35.8 80-80l0-224c0-44.2-35.8-80-80-80L208 0c-44.2 0-80 35.8-80 80z',
      'M64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128zm32 64l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faNfcMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'nfc-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e1f9',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c8.7 0 17-1.7 24.6-4.9c-35.9-9.1-67-30.3-88.6-59.1l-208 0c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l189.3 0c-8.6-19.6-13.3-41.2-13.3-64c0-52.3 25.1-98.8 64-128l0-48c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16l0 66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48l0 29.3c19.6-8.6 41.2-13.3 64-13.3l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M528 320.1a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 426c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426z',
    ],
  ],
};
const faFileBinary = {
  prefix: 'fad',
  iconName: 'file-binary',
  icon: [
    384,
    512,
    [],
    'e175',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 304l0 64c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48zm32 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm128-32c0 8.8 7.2 16 16 16l16 0 0 96-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-112c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM112 256c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zM96 304c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 96-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-112c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faCircleV = {
  prefix: 'fad',
  iconName: 'circle-v',
  icon: [
    512,
    512,
    [],
    'e12a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm130.5-77.3c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7c27.5 55 55 110 82.5 165.1c27.5-55 55-110 82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7c8.4 4.2 13.3 12.7 13.3 21.5c0 3.6-.8 7.3-2.5 10.7c-34.7 69.3-69.3 138.7-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3c-34.7-69.3-69.3-138.7-104-208z',
      'M141.3 146.5c11.9-5.9 26.3-1.1 32.2 10.7L256 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2z',
    ],
  ],
};
const faSquarePlus = {
  prefix: 'fad',
  iconName: 'square-plus',
  icon: [
    448,
    512,
    [61846, 'plus-square'],
    'f0fe',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 256c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M200 280l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faPlusSquare = faSquarePlus;
const faBowlScoops = {
  prefix: 'fad',
  iconName: 'bowl-scoops',
  icon: [
    448,
    512,
    [127813],
    'e3df',
    [
      'M0 208c0 17.2 3.9 33.5 10.8 48l5.2 0 184.2 0c-5.3-15-8.2-31.2-8.2-48c0-22 4.9-42.8 13.7-61.4c-19.8-30.2-53.8-50.2-92.6-50.6L112 96C50.1 96 0 146.1 0 208zM122.6 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4zM224 208c0 17.2 3.9 33.5 10.8 48L432 256l5.2 0c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208z',
      'M4 261.4c3-3.4 7.4-5.4 12-5.4l416 0c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9C436.9 361.9 375.6 416 303 416l-40.4 0 68.7 68.7c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L185.4 416 145 416C72.4 416 11.1 361.9 2.1 289.9L.1 274c-.6-4.6 .8-9.1 3.9-12.6z',
    ],
  ],
};
const faMistletoe = {
  prefix: 'fad',
  iconName: 'mistletoe',
  icon: [
    576,
    512,
    [],
    'f7b4',
    [
      'M0 341c0 41.4 33.6 75 75 75c50.5 0 94.3-33.5 108.1-81.2c-4.5-6.5-7.1-14.3-7.1-22.8c0-.9 0-1.8 .1-2.6s.1-1.7 .3-2.6c.2-1.7 .6-3.4 1-5c.9-3.3 2.1-6.4 3.7-9.3c3.2-5.8 7.9-10.7 13.4-14.2l5.4-28.2L264 185.9l0 72.4c14.7 13.2 24 32.3 24 53.7c0 39.8-32.2 72-72 72c-7.2 0-14.2-1.1-20.8-3c-2.1 8.4-3.2 17.1-3.2 25.9l0 9.1c0 53 43 96 96 96s96-43 96-96l0-9.1c0-25.1-9-49.4-25.3-68.4L312 284l0-98.1L376.1 250l14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75c0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98L312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 94.1-98 98L91.3 230.4C38.3 240.6 0 287 0 341z',
      'M376 112a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM216 352a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
    ],
  ],
};
const faCustard = {
  prefix: 'fad',
  iconName: 'custard',
  icon: [
    576,
    512,
    [127854],
    'e403',
    [
      'M64.2 350.9L512 352 476.7 193.3C453.9 184.9 424 176 400 176c-22.7 0-39.4 8-56 16s-33.3 16-56 16s-39.4-8-56-16s-33.3-16-56-16c-24 0-53.9 8.9-76.7 17.3c-11.7 52.5-23.3 105-35 157.5z',
      'M396.7 64L179.3 64c-30 0-56 20.8-62.5 50.1L99.3 193.3C122.1 184.9 152 176 176 176c22.7 0 39.4 8 56 16s33.3 16 56 16s39.4-8 56-16s33.3-16 56-16c24 0 53.9 8.9 76.7 17.3l-17.6-79.2C452.6 84.8 426.7 64 396.7 64zM32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 384z',
    ],
  ],
};
const faLacrosseStick = {
  prefix: 'fad',
  iconName: 'lacrosse-stick',
  icon: [
    512,
    512,
    [],
    'e3b5',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l136-136c-18.7-11-34.3-26.6-45.3-45.3l-136 136C3.1 463.6 0 471.8 0 480z',
      'M264.8 117.7l-3.3 11.5c-5.6 19.6-15.1 37.9-27.8 53.9L205.8 218c-8.9 11.1-13.8 25-13.8 39.2c0 34.7 28.1 62.8 62.8 62.8c14.3 0 28.1-4.9 39.2-13.8l34.9-27.9c15.9-12.8 34.3-22.2 53.9-27.8l11.5-3.3c31.8-9.1 53.7-38.1 53.7-71.2c0 0 0 0 0 0c0-.1 0-.2 0-.3c0-19.9-13.6-48.1-38.6-73.1s-53.2-38.6-73.1-38.6l-.3 0s0 0 0 0c-33.1 0-62.1 21.9-71.2 53.7zM512 176s0 0 0 0c0 61.6-40.9 115.8-100.1 132.7L400.3 312c-11.5 3.3-22.2 8.8-31.5 16.2l-34.9 27.9c-22.5 18-50.4 27.8-79.2 27.8c-70 0-126.8-56.8-126.8-126.8c0-28.8 9.8-56.7 27.8-79.2l27.9-34.9c7.4-9.3 13-20 16.2-31.5l3.3-11.5C220.2 40.9 274.4 0 336 0c0 0 0 0 0 0l.3 0c43.8 0 87.4 26.4 118.4 57.3s57.3 74.5 57.3 118.4l0 .3z',
    ],
  ],
};
const faHockeyMask = {
  prefix: 'fad',
  iconName: 'hockey-mask',
  icon: [
    448,
    512,
    [],
    'f6ee',
    [
      'M0 240C0 111 64 0 224 0S448 111 448 240c0 192-48 272-224 272S0 432 0 240zm64-32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM136 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm16 240a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48 192a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm8-240c0 35.3 28.7 64 64 64s64-28.7 64-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm8-128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M136 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM152 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faSunrise = {
  prefix: 'fad',
  iconName: 'sunrise',
  icon: [
    576,
    512,
    [127749],
    'f766',
    [
      'M32 380.6c0 3.2 1 6.4 2.8 9.1L86.1 464l74.9 0c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112l74.9 0 51.3-74.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345 403.1 237.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-2.7-1.9-5.9-2.8-9.1-2.8c-2.1 0-4.2 .4-6.1 1.2c-5 2.1-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6c-.8 2-1.2 4-1.2 6.1zM193.3 464l189.3 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80z',
      'M354.5 135.7L320 104.3 320 208c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-103.7-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zM24 464l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faSubtitles = {
  prefix: 'fad',
  iconName: 'subtitles',
  icon: [
    576,
    512,
    [],
    'e60f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 264c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zm160 0c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm96-96c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24z',
      'M96 264c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm256 0c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zM96 360c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zm160 0c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faPanelEws = {
  prefix: 'fad',
  iconName: 'panel-ews',
  icon: [
    512,
    512,
    [],
    'e42e',
    [
      'M0 64L0 288l16 0c44.2 0 80 35.8 80 80l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-26.5-21.5-48-48-48L0 320 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM96 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM288 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 144c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128z',
      'M128 288c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-26.5-21.5-48-48-48L0 320l0-32 16 0c44.2 0 80 35.8 80 80l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c-17.7 0-32-14.3-32-32l0-32zm192-32l64 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faToriiGate = {
  prefix: 'fad',
  iconName: 'torii-gate',
  icon: [
    512,
    512,
    [9961],
    'f6a1',
    [
      'M64 128l64 0 0 96-64 0 0-96zm0 160l64 0 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192zM224 128l64 0 0 96-64 0 0-96zm160 0l64 0 0 96-64 0 0-96zm0 160l64 0 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192z',
      'M0 13.4L0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-66.6C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32L126.8 32c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z',
    ],
  ],
};
const faCloudExclamation = {
  prefix: 'fad',
  iconName: 'cloud-exclamation',
  icon: [
    640,
    512,
    [],
    'e491',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm352 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM296 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMessageLines = {
  prefix: 'fad',
  iconName: 'message-lines',
  icon: [
    512,
    512,
    ['comment-alt-lines'],
    'f4a6',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM128 168c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z',
      'M128 168c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faCommentAltLines = faMessageLines;
const faFrog = {
  prefix: 'fad',
  iconName: 'frog',
  icon: [
    576,
    512,
    [],
    'f52e',
    [
      'M0 416c0 35.3 28.7 64 64 64l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-90.2 0 37.1-37.1c3.4-3.4 6.4-7.1 9-10.9c18.7-28 15.7-66.2-9-90.9c-24.6-24.6-62.6-27.7-90.5-9.2c-4 2.6-7.8 5.7-11.3 9.2c-.2 .2-.2 .2-.3 .3L123 347.6c-6.4 6.1-16.5 5.8-22.6-.6s-5.8-16.5 .6-22.6l73.6-70.1c40.6-40.5 106.4-40.4 146.9 .1c28.6 28.6 37.1 69.7 25.4 105.7L457.4 470.6c6 6 14.1 9.4 22.6 9.4l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0-92.5-92.5 144.5-82.1c18.9-10.8 30.7-30.9 30.7-52.7c0-26.6-17.3-50.1-42.8-57.9l-85.6-26.3c.2 2.5 .3 5 .3 7.5c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-1.2 0-2.5 .1-3.7s.1-2.5 .3-3.7c.2-2.4 .6-4.8 1-7.2C127 112.9 0 249.6 0 416z',
      'M368 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faBucket = {
  prefix: 'fad',
  iconName: 'bucket',
  icon: [
    448,
    512,
    [],
    'e4cf',
    [
      'M48 152l0 40 48 0 0-40C96 94.6 142.6 48 200 48l48 0c57.4 0 104 46.6 104 104l0 40 48 0 0-40C400 68.1 331.9 0 248 0L200 0C116.1 0 48 68.1 48 152z',
      'M32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l5.1 0L59.5 469c2.6 24.4 23.2 43 47.7 43l233.6 0c24.6 0 45.2-18.5 47.7-43l22.4-213 5.1 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 192z',
    ],
  ],
};
const faFloppyDiskPen = {
  prefix: 'fad',
  iconName: 'floppy-disk-pen',
  icon: [
    576,
    512,
    [],
    'e182',
    [
      'M0 96C0 60.7 28.7 32 64 32l242.7 0c17 0 33.3 6.7 45.3 18.7L429.3 128c12 12 18.7 28.3 18.7 45.3l0 62.4L289.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-14 55.9L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zm96 224a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M493.2 235.8l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L311.9 417.1c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.8l-71-71z',
    ],
  ],
};
const faImage = {
  prefix: 'fad',
  iconName: 'image',
  icon: [
    512,
    512,
    [],
    'f03e',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm2.4 258.4c4 8.3 12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4z',
      'M323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176z',
    ],
  ],
};
const faWindowFrame = {
  prefix: 'fad',
  iconName: 'window-frame',
  icon: [
    512,
    512,
    [129695],
    'e04f',
    [
      'M96 64l0 160 136 0 0-160L96 64zm0 224l0 160 136 0 0-160L96 288zM280 64l0 160 136 0 0-160L280 64zm0 224l0 160 136 0 0-160-136 0z',
      'M32 256L32 64C32 28.7 60.7 0 96 0L416 0c35.3 0 64 28.7 64 64l0 192 0 192c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0L96 512l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-192zm384 32l-136 0 0 160 136 0 0-160zm-184 0L96 288l0 160 136 0 0-160zm48-64l136 0 0-160L280 64l0 160zM232 64L96 64l0 160 136 0 0-160z',
    ],
  ],
};
const faMicrophone = {
  prefix: 'fad',
  iconName: 'microphone',
  icon: [
    384,
    512,
    [],
    'f130',
    [
      'M16 216l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M96 96c0-53 43-96 96-96s96 43 96 96V256c0 53-43 96-96 96s-96-43-96-96V96z',
    ],
  ],
};
const faCow = {
  prefix: 'fad',
  iconName: 'cow',
  icon: [
    640,
    512,
    [128004],
    'f6c8',
    [
      'M0 288c0-20.2 9.4-38.2 24-50c11-8.8 24.9-14 40-14l8 0 0 38.4C72 294.2 46.2 320 14.4 320C6.4 320 0 313.6 0 305.6L0 288zm192.1 37.4c.7-14.3 6.8-27.4 16.3-37l.3-.3c2.5-2.5 5.3-4.7 8.2-6.7s6.1-3.7 9.4-5.1c3.3-1.4 6.8-2.5 10.5-3.2c1.8-.4 3.7-.7 5.5-.8c.9-.1 1.9-.2 2.8-.2s1.9-.1 2.9-.1l48 0c30.8 0 55.9 24.9 56 55.8c-9.9 6.6-20.6 12-32 16.1l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16.9c-5.3 .6-10.6 .9-16 .9s-10.7-.3-16-.9l0 16.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24.2c-11.4-4-22.1-9.4-32-15.8l0-.5c0-.5 0-1.2 .1-2.1z',
      'M72 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160l0 64 0 32 0 160c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-88 0-.2s0 0 0 0c.1-30.8 25.2-55.8 56-55.8l48 0c30.8 0 55.9 24.9 56 55.8c0 0 0 0 0 0l0 .2 0 88c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-160 32 32 0 49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5 0-81.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 14.4-52.9-74.1C496 86.5 452.4 64 405.9 64L272 64l-16 0-64 0-48 0C77.7 64 24 117.7 24 184l0 54c11-8.8 24.9-14 40-14l8 0 0-40zM576 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM190.1 190.1l-23.4-23.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6l178.7 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9z',
    ],
  ],
};
const faFileZip = {
  prefix: 'fad',
  iconName: 'file-zip',
  icon: [
    512,
    512,
    [],
    'e5ee',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-144 0c-35.3 0-64 28.7-64 64l0 144L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM240 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l38.1 0L225.7 488.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-38.1 0 52.4-104.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6l-64 0zm144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm32 0l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 8 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-24 0c-8.8 0-16 7.2-16 16zm32 64l0-48 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0z',
    ],
  ],
};
const faSquareRing = {
  prefix: 'fad',
  iconName: 'square-ring',
  icon: [
    448,
    512,
    [],
    'e44f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM384 256A160 160 0 1 1 64 256a160 160 0 1 1 320 0z',
      'M224 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm160 96A160 160 0 1 1 64 256a160 160 0 1 1 320 0z',
    ],
  ],
};
const faDownFromLine = {
  prefix: 'fad',
  iconName: 'down-from-line',
  icon: [
    384,
    512,
    ['arrow-alt-from-top'],
    'f349',
    [
      'M0 64C0 46.3 14.3 32 32 32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64z',
      'M164.7 468.7L41.9 345.9c-6.4-6.4-9.9-15-9.9-24C32 303.2 47.2 288 65.9 288l62.1 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 62.1 0c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24L219.3 468.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3z',
    ],
  ],
};
const faArrowAltFromTop = faDownFromLine;
const faCaretUp = {
  prefix: 'fad',
  iconName: 'caret-up',
  icon: [
    320,
    512,
    [],
    'f0d8',
    [
      'M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z',
      '',
    ],
  ],
};
const faShieldXmark = {
  prefix: 'fad',
  iconName: 'shield-xmark',
  icon: [
    512,
    512,
    ['shield-times'],
    'e24c',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM168 320c0-6.1 2.3-12.3 7-17c15.7-15.7 31.3-31.4 47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.3-31.3 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.4 31.4-47 47l47 47c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .4 2.3 .3 2.2c.1 1.2 .1 1.2 .1 2.4c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-15.7-15.7-31.4-31.4-47-47c-15.7 15.7-31.4 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faShieldTimes = faShieldXmark;
const faScrewdriver = {
  prefix: 'fad',
  iconName: 'screwdriver',
  icon: [
    512,
    512,
    [129691],
    'f54a',
    [
      'M211 267.1c7.1 3.6 13.7 8.4 19.7 14.3c1.5 1.5 2.9 3 4.2 4.6s2.6 3.2 3.8 4.8c2.4 3.3 4.5 6.7 6.3 10.3l109-109 54.1 0c7.4 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19l0 54.1-109 109z',
      'M230.6 281.4c-30.2-30.2-79.1-30.2-109.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3z',
    ],
  ],
};
const faCircleSortDown = {
  prefix: 'fad',
  iconName: 'circle-sort-down',
  icon: [
    512,
    512,
    ['sort-circle-down'],
    'e031',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm145.2-41.9c-2.5-6-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9zm0 83.8c2.5-6 8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4z',
      'M267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96z',
    ],
  ],
};
const faSortCircleDown = faCircleSortDown;
const faFolderClosed = {
  prefix: 'fad',
  iconName: 'folder-closed',
  icon: [
    512,
    512,
    [],
    'e185',
    [
      'M0 96l0 96 512 0 0-32c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96z',
      'M0 192L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224L0 192z',
    ],
  ],
};
const faHouseTsunami = {
  prefix: 'fad',
  iconName: 'house-tsunami',
  icon: [
    576,
    512,
    [],
    'e515',
    [
      'M0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1c32 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 325.4 219.5 336 192 336c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200zM.8 487.3C4.3 502 17.4 512 32 512c2.4 0 4.8-.3 7.3-.8c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c2.4 .6 4.9 .8 7.3 .8c14.5 0 27.7-10 31.1-24.7c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4z',
      'M332.8 118.4c-8.1 6-12.8 15.5-12.8 25.6l0 121c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72z',
    ],
  ],
};
const faSquareNfi = {
  prefix: 'fad',
  iconName: 'square-nfi',
  icon: [
    448,
    512,
    [],
    'e576',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 80l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.2c22.1 36.8 44.2 73.6 66.3 110.5c2.9 4.9 8.2 7.8 13.7 7.8c1.4 0 2.9-.2 4.3-.6c6.9-1.9 11.7-8.2 11.7-15.4l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 102.2c-22.1-36.8-44.2-73.6-66.3-110.5c-3.7-6.2-11.1-9.1-18-7.2S64 168.8 64 176zm160 0l0 64 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c16 0 32 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16c-16 0-32 0-48 0l0-32c16 0 32 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16c-21.3 0-42.7 0-64 0c-8.8 0-16 7.2-16 16zm128 0l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2S64 168.8 64 176l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.2 66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 102.2L93.7 167.8zM240 160c-8.8 0-16 7.2-16 16l0 64 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z',
    ],
  ],
};
const faForklift = {
  prefix: 'fad',
  iconName: 'forklift',
  icon: [
    640,
    512,
    [],
    'f47a',
    [
      'M0 432a80 80 0 1 0 160 0A80 80 0 1 0 0 432zm256 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM480 32l0 384c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-352c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M160 160l96 96 94 0L281.4 64 160 64l0 96zm-64 0L96 48c0-26.5 21.5-48 48-48L292.7 0c20.3 0 38.4 12.8 45.2 31.9l75.3 210.8c1.8 5.2 2.8 10.6 2.8 16.1l0 94.8c-20.3-20.7-48.7-33.6-80-33.6c-56.4 0-103.1 41.7-110.9 96l-34.3 0c-7.8-54.3-54.4-96-110.9-96c-31.3 0-59.7 12.9-80 33.6L0 208c0-26.5 21.5-48 48-48l48 0z',
    ],
  ],
};
const faArrowUpFromGroundWater = {
  prefix: 'fad',
  iconName: 'arrow-up-from-ground-water',
  icon: [
    576,
    512,
    [],
    'e4b5',
    [
      'M0 240L0 425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3L192 192 48 192c-26.5 0-48 21.5-48 48zm384-48l0 224.5c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9l0-185c0-26.5-21.5-48-48-48l-144 0z',
      'M320 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l80-80c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L320 109.3 320 320zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z',
    ],
  ],
};
const faBracketSquareRight = {
  prefix: 'fad',
  iconName: 'bracket-square-right',
  icon: [
    192,
    512,
    [],
    '5d',
    [
      'M192 96c0-35.3-28.7-64-64-64L64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l64 0 0 320-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c35.3 0 64-28.7 64-64l0-320z',
      '',
    ],
  ],
};
const faMartiniGlass = {
  prefix: 'fad',
  iconName: 'martini-glass',
  icon: [
    512,
    512,
    [127864, 'glass-martini-alt'],
    'f57b',
    [
      'M0 32c0 8.3 3.3 16.5 9.4 22.6L224 269.3 224 448l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-178.7L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0L32 0C19.1 0 7.4 7.8 2.4 19.8C.8 23.7 0 27.9 0 32zM109.3 64l293.5 0c-21.3 21.3-42.7 42.7-64 64L256 210.7c-27.6-27.6-55.2-55.2-82.7-82.7c-21.3-21.3-42.7-42.7-64-64z',
      'M338.7 128L256 210.7 173.3 128l165.5 0z',
    ],
  ],
};
const faGlassMartiniAlt = faMartiniGlass;
const faSquareBinary = {
  prefix: 'fad',
  iconName: 'square-binary',
  icon: [
    512,
    512,
    [],
    'e69b',
    [
      'M32 96l0 320c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L96 32C60.7 32 32 60.7 32 96zm100 48c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm32 152c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zm8-152l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0c-2.2 0-4 1.8-4 4zm88 176c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm32-200c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zm8 200l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0c-2.2 0-4 1.8-4 4z',
      'M132 144c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm44-4c-2.2 0-4 1.8-4 4l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0zm116-20c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zM164 296c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zm96 24c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm44-4c-2.2 0-4 1.8-4 4l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0z',
    ],
  ],
};
const faRotateLeft = {
  prefix: 'fad',
  iconName: 'rotate-left',
  icon: [
    512,
    512,
    ['rotate-back', 'rotate-backward', 'undo-alt'],
    'f2ea',
    [
      'M97.6 369.1c-12.5 12.5-12.5 32.8 0 45.3C141.3 458.1 198.7 480 256 480s114.7-21.9 158.4-65.6S480 313.3 480 256s-21.9-114.7-65.6-158.4c-87.2-87.2-228.3-87.5-315.8-1c15.1 15.1 30.2 30.2 45.3 45.3c62.6-61.5 163.1-61.2 225.3 1c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0c-12.5-12.5-32.8-12.5-45.3 0z',
      'M168 224L40 224c-13.3 0-24-10.7-24-24L16 72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z',
    ],
  ],
};
const faRotateBack = faRotateLeft;
const faRotateBackward = faRotateLeft;
const faUndoAlt = faRotateLeft;
const faTableColumns = {
  prefix: 'fad',
  iconName: 'table-columns',
  icon: [
    512,
    512,
    ['columns'],
    'f0db',
    [
      'M224 160l64 0 0 256-64 0 0-256z',
      'M64 160l0 256 384 0 0-256L64 160zm0 320c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480z',
    ],
  ],
};
const faColumns = faTableColumns;
const faSquareA = {
  prefix: 'fad',
  iconName: 'square-a',
  icon: [
    448,
    512,
    [],
    'e25f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 360c0-3.6 .8-7.3 2.5-10.7c34.7-69.3 69.3-138.7 104-208c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3l104 208c.9 1.7 1.5 3.5 1.9 5.3c.2 .9 .4 1.8 .5 2.7c.1 .7 .1 1.3 .1 1.3l0 1.5c0 1.1 0 1.4-.1 1.6c0 .5-.1 1.1-.2 1.6c-.1 1.1-.4 2.1-.7 3.2c-.6 2.1-1.5 4.1-2.6 6c-2.3 3.7-5.6 6.9-9.8 9c-11.9 5.9-26.3 1.1-32.2-10.7c-5.8-11.6-11.6-23.2-17.4-34.7l-130.3 0c-5.8 11.6-11.6 23.2-17.4 34.7c-4.2 8.4-12.7 13.3-21.5 13.3c-3.6 0-7.3-.8-10.7-2.5C100.9 377.3 96 368.8 96 360zm86.8-72l82.3 0L224 205.7c-13.7 27.5-27.4 54.9-41.2 82.3z',
      'M245.5 141.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L158.8 336l130.3 0 17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208zM265.2 288l-82.3 0L224 205.7 265.2 288z',
    ],
  ],
};
const faTick = {
  prefix: 'fad',
  iconName: 'tick',
  icon: [
    192,
    512,
    [],
    'e32f',
    [
      'M32 98.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L133.5 256.5c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L33 109.6c-.7-3.8-1-7.5-1-11.4z',
      '',
    ],
  ],
};
const faLemon = {
  prefix: 'fad',
  iconName: 'lemon',
  icon: [
    448,
    512,
    [127819],
    'f094',
    [
      'M0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416zM64.2 237.8c.1-.7 .3-1.5 .5-2.3c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4c-3.5-1-6.4-3.1-8.4-5.8c-1-1.4-1.8-2.9-2.3-4.5c-.3-.8-.5-1.6-.6-2.5c-.1-.6-.2-1.3-.2-1.3L64 240c0-.7 0-.9 0-1.1c0-.4 .1-.7 .1-1.1z',
      'M223.4 107.5c2.5 8.5-2.4 17.4-10.9 19.9c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9z',
    ],
  ],
};
const faHeadSideMask = {
  prefix: 'fad',
  iconName: 'head-side-mask',
  icon: [
    576,
    512,
    [],
    'e063',
    [
      'M32 224.2c0-20.2 2.7-39.9 7.7-58.5c77.4 57.5 154.8 115 232.3 172.5c0 57.9 0 115.8 0 173.8c-48 0-96 0-144 0c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zM57.9 119.4C95.5 48.4 170.1 0 256 0l24 0c96.1 0 182.8 70.6 197.7 162.8c1.8 11.4 5.4 22.6 11.9 32.2l44.8 65.7c6.2 7.8 9.6 17.4 9.6 27.4l-259.1 0C209.2 231.8 133.6 175.6 57.9 119.4zM352 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M20.7 121.7c7.9-10.6 22.9-12.9 33.6-5L284.9 288 544 288l0 21.6c0 6.9-1.1 13.7-3.3 20.2L528 368l-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l149.3 0-10.7 32L368 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0-1.4 4.2c-8.7 26.1-33.2 43.8-60.7 43.8L272 512l0-173.8L25.7 155.3c-10.6-7.9-12.9-22.9-5-33.6z',
    ],
  ],
};
const faHandshake = {
  prefix: 'fad',
  iconName: 'handshake',
  icon: [
    640,
    512,
    [],
    'f2b5',
    [
      'M208.3 186.4c-.1 .9-.2 1.9-.2 2.8c-.1 .9-.1 1.9-.1 2.8c0 9.7 2.9 19.4 8.9 27.9c15.4 21.6 45.4 26.6 67 11.2l57.2-40.8c4.4 4 8.8 8 13.1 12L496.4 332.6c5.5 5 9.5 11.1 12.1 17.5c.3 .6 .5 1.2 .7 1.8l2.7 0 0-224-1.5 0-71-47.3C423.2 69.8 404.1 64 384.5 64c-20.7 0-40.9 6.5-57.7 18.5c-3.1 2.2-6.2 4.4-9.3 6.7c-29.8 21.3-59.5 42.5-89.3 63.8c-.8 .6-1.6 1.2-2.4 1.8s-1.5 1.3-2.2 1.9c-1.4 1.3-2.8 2.7-4 4.2c-2.5 2.9-4.6 6.1-6.3 9.5s-3 6.9-3.8 10.5c-.4 1.8-.8 3.7-1 5.5zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-80 0zm64 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M156.2 352L128 352l0-224 72-48c15.6-10.4 34-16 52.8-16c22.7 0 44.7 8.1 61.9 22.9l2.7 2.3-89.3 63.8c-21.6 15.4-26.6 45.4-11.2 67s45.4 26.6 67 11.2l57.2-40.8 13.1 12L496.4 332.6c5.5 5 9.6 11.1 12.1 17.5c6.6 16.6 3.7 36.2-9.2 50.3c-17.9 19.5-48.3 20.9-67.8 2.9l-7.8-7.1c-.9 10.1-5 20.1-12.4 28.2c-17.9 19.5-48.3 20.9-67.8 2.9l-17-15.6c-1.9 7.4-5.6 14.5-11.1 20.6c-17.9 19.6-48.2 21-67.8 3.1L156.2 352zM0 144c0-8.8 7.2-16 16-16l80 0 0 224c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 144zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faGem = {
  prefix: 'fad',
  iconName: 'gem',
  icon: [
    512,
    512,
    [128142],
    'f3a5',
    [
      'M4.7 185.8c-6.8 9.2-6.1 21.9 1.5 30.4l232 256c4.5 5 11 7.9 17.8 7.9s13.2-2.9 17.8-7.9l232-256c4.1-4.6 6.2-10.3 6.2-16.1c0-5-1.5-10-4.7-14.2l-112-152C390.8 27.6 383.6 24 376 24L136 24c-7.6 0-14.8 3.6-19.3 9.8l-112 152zm51.5 12.7c.1-.5 .2-1 .4-1.4c.4-.9 .9-1.7 1.5-2.5c1.3-1.4 3.1-2.4 5.2-2.6c49.1-4.1 98.1-8.2 147.2-12.3L153.1 84.1c-2.1-3.5-1.2-8.1 2.1-10.5s7.9-2 10.7 1c30 32.5 60.1 65.1 90.1 97.6c30-32.5 60.1-65.1 90.1-97.6c2.8-3 7.4-3.4 10.7-1s4.2 7 2.1 10.5c-19.1 31.9-38.3 63.8-57.4 95.6c49.1 4.1 98.1 8.2 147.2 12.3c4.1 .3 7.3 3.8 7.3 8s-3.2 7.6-7.3 8c-64 5.3-128 10.7-192 16c-.2 0-.4 0-.7 0s-.4 0-.7 0c-64-5.3-128-10.7-192-16c-2.1-.2-3.9-1.1-5.2-2.6c-.7-.7-1.2-1.6-1.6-2.5c-.2-.5-.3-.9-.4-1.4c0-.2-.1-.5-.1-.7s0-.5 0-.9c0-.2 0-.4 0-.7s.1-.5 .1-.7z',
      'M165.9 74.6c-2.8-3-7.4-3.4-10.7-1s-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6z',
    ],
  ],
};
const faDolly = {
  prefix: 'fad',
  iconName: 'dolly',
  icon: [
    576,
    512,
    ['dolly-box'],
    'f472',
    [
      'M351.9 416A96 96 0 1 1 160 416a96 96 0 1 1 191.9 0zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3c15.2-4.9 30.4-9.9 45.7-14.8l19.8 60.9c20.3-6.6 40.6-13.2 60.9-19.8c-6.6-20.3-13.2-40.6-19.8-60.9l45.7-14.8c3.3-1.1 6.6-1.6 9.9-1.6c13.5 0 26 8.6 30.4 22.1l49.4 152.2c1.1 3.3 1.6 6.6 1.6 9.9c0 13.5-8.6 26-22.1 30.4L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z',
      'M0 32C0 14.3 14.3 0 32 0l72.9 0c27.5 0 52 17.6 60.7 43.8L257.7 320c-.6 0-1.2 0-1.7 0c-22.2 0-42.7 7.6-59 20.2L104.9 64 32 64C14.3 64 0 49.7 0 32zM352 416c0-22.2-7.6-42.7-20.2-59l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c0-.6 0-1.2 0-1.7zM371.8 59.6l19.8 60.9-60.9 19.8L311 79.4l60.9-19.8z',
    ],
  ],
};
const faDollyBox = faDolly;
const faSmoking = {
  prefix: 'fad',
  iconName: 'smoking',
  icon: [
    640,
    512,
    [128684],
    'f48d',
    [
      'M384 32l0 11c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9l0 11c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43l0-11c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 0l0 11c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8l0 11c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9l0-11c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l352 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L64 352zm160 64l160 0 0 32-160 0 0-32zm320-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96z',
    ],
  ],
};
const faMinimize = {
  prefix: 'fad',
  iconName: 'minimize',
  icon: [
    512,
    512,
    ['compress-arrows-alt'],
    'f78c',
    [
      'M0 456c0 5.1 2 10 5.7 13.7l36.7 36.7C46 510 50.9 512 56 512s10-2 13.7-5.7L143 433l40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-144c0-13.3-10.7-24-24-24L56 288c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40L5.7 442.3C2 446 0 450.9 0 456zM288 56l0 144c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 73.4-73.4C510 66 512 61.1 512 56s-2-10-5.7-13.7L469.7 5.7C466 2 461.1 0 456 0s-10 2-13.7 5.7L369 79 329 39c-6.9-6.9-17.2-8.9-26.2-5.2S288 46.3 288 56z',
      'M56 224l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L143 79 69.7 5.7C66 2 61.1 0 56 0S46 2 42.3 5.7L5.7 42.3C2 46 0 50.9 0 56s2 10 5.7 13.7L79 143 39 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8zm400 64l-144 0c-13.3 0-24 10.7-24 24l0 144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 73.4 73.4c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L433 369l40-40c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8z',
    ],
  ],
};
const faCompressArrowsAlt = faMinimize;
const faRefrigerator = {
  prefix: 'fad',
  iconName: 'refrigerator',
  icon: [
    384,
    512,
    [],
    'e026',
    [
      'M0 160l0 32 288 0 0-32L0 160zm320 0l0 32 64 0 0-32-64 0z',
      'M96 0C43 0 0 43 0 96l0 64 288 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-64c0-53-43-96-96-96L96 0zM384 192l-64 0 0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176L0 192 0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256z',
    ],
  ],
};
const faMonument = {
  prefix: 'fad',
  iconName: 'monument',
  icon: [
    384,
    512,
    [],
    'f5a6',
    [
      'M0 480c0-17.7 14.3-32 32-32l19.9 0 280.2 0 19.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z',
      'M203.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-2.5 2.5-4.1 5.8-4.6 9.3L51.9 448l280.2 0L287.9 94c-.4-3.5-2-6.8-4.6-9.3l-80-80zM128 296c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faOctagonXmark = {
  prefix: 'fad',
  iconName: 'octagon-xmark',
  icon: [
    512,
    512,
    ['times-octagon', 'xmark-octagon'],
    'f2f0',
    [
      'M.1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5zm168 126.2c.1-.7 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c15.7-15.7 31.3-31.3 47-47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.3-31.3 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.3 31.4 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.3 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.2-1.1-.4-2.3-.3-2.2c-.1-1.2-.1-1.2-.1-2.4c0-1.5 .1-1.9 .1-2.3z',
      'M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faTimesOctagon = faOctagonXmark;
const faXmarkOctagon = faOctagonXmark;
const faAlignSlash = {
  prefix: 'fad',
  iconName: 'align-slash',
  icon: [
    640,
    512,
    [],
    'f846',
    [
      'M96 192c0 17.7 14.3 32 32 32l34.5 0-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7zm0 128c0 17.7 14.3 32 32 32l196.9 0-81.2-64L128 288c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32l359.4 0-81.2-64L128 416c-17.7 0-32 14.3-32 32zM98.4 51.8C117.2 66.5 136 81.3 154.8 96L512 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L128 32c-13.4 0-24.8 8.2-29.6 19.8zM236.4 160c27.2 21.3 54.4 42.7 81.7 64L512 224c17.7 0 32-14.3 32-32s-14.3-32-32-32l-275.6 0zM399.7 288c27.2 21.3 54.4 42.7 81.7 64l30.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112.3 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faSnowplow = {
  prefix: 'fad',
  iconName: 'snowplow',
  icon: [
    640,
    512,
    [],
    'f7d2',
    [
      'M0 400c0-44.7 26.2-83.2 64-101.2c14.5-6.9 30.8-10.8 48-10.8l256 0c44.7 0 83.2 26.2 101.2 64c6.9 14.5 10.8 30.8 10.8 48c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400zm64 0c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-256 0c-26.5 0-48 21.5-48 48z',
      'M298.9 64l68.6 160L256 224l-64-64 0-96 106.9 0zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0L176 0c-26.5 0-48 21.5-48 48l0 112-32 0c-17.7 0-32 14.3-32 32l0 106.8c14.5-6.9 30.8-10.8 48-10.8l256 0c44.7 0 83.2 26.2 101.2 64l42.8 0 0 50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7l0-82.7 0-84.8L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40l0 52.8-64 0 0-31.3c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faAnglesRight = {
  prefix: 'fad',
  iconName: 'angles-right',
  icon: [
    512,
    512,
    [187, 'angle-double-right'],
    'f101',
    [
      'M64 96c0 8.2 3.1 16.4 9.4 22.6L210.7 256 73.4 393.4C67.1 399.6 64 407.8 64 416s3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l160-160c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-160-160C112.4 67.1 104.2 64 96 64s-16.4 3.1-22.6 9.4S64 87.8 64 96z',
      'M470.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 256 265.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z',
    ],
  ],
};
const faAngleDoubleRight = faAnglesRight;
const faTruckRampCouch = {
  prefix: 'fad',
  iconName: 'truck-ramp-couch',
  icon: [
    640,
    512,
    ['truck-couch'],
    'f4dd',
    [
      'M8 252.8l1.7 6.4c8.4-6.7 18.2-11.8 29.2-14.7c37.4-10 75.7 8.2 92.3 41.5L227 260.4c-2.3-37.2 21.8-72.1 59.2-82.1c11-2.9 22.1-3.5 32.6-1.9l-1.7-6.4c-7.7-28.6-33.5-47.5-61.8-47.5c-5.5 0-11.1 .7-16.6 2.2L53.3 174.4C19.1 183.5-1.1 218.6 8 252.8zm5.3 81.4l12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l61.8-16.6 154.5-41.4L320 334.8l0-125.5c-8.1-2.3-16.8-2.5-25.5-.2c-25.6 6.9-40.8 33.2-33.9 58.8l4.1 15.5L110.1 324.8 106 309.3c-6.9-25.6-33.2-40.8-58.8-33.9s-40.8 33.2-33.9 58.8zM448 416a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M416.7 402.5C423.4 338.2 477.9 288 544 288c38.2 0 72.5 16.8 96 43.3L640 0 416 0c-35.3 0-64 28.7-64 64l0 289.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416.7 402.5z',
    ],
  ],
};
const faTruckCouch = faTruckRampCouch;
const faCannabis = {
  prefix: 'fad',
  iconName: 'cannabis',
  icon: [
    512,
    512,
    [],
    'f55f',
    [
      'M16.3 152.9c5.6 27.7 19.3 70.9 42.7 111.7c9.1 15.9 19.9 31.7 32.4 46.3c-27.8 6.6-52.4 17.3-67.2 25.5c-5.1 2.8-8.2 8.2-8.2 14s3.2 11.2 8.2 14c15.2 8.4 40.9 19.5 69.8 26.1c20.2 4.6 42.9 7.2 65.2 4.6l-8.3 33.1c-1.5 6.1 .6 12.4 5.5 16.4s11.6 4.6 17.2 1.9L232 417.2l0-41.2c0-13.3 10.7-24 24-24s24 10.7 24 24l0 41.2 58.5 29.1c5.6 2.8 12.3 2.1 17.2-1.9s7-10.3 5.5-16.4L352.8 395c22.2 2.6 45 0 65.2-4.6c28.9-6.6 54.6-17.6 69.8-26.1c5.1-2.8 8.2-8.2 8.2-14s-3.2-11.2-8.2-14c-14.8-8.2-39.4-18.8-67.2-25.5c12.5-14.5 23.3-30.4 32.4-46.3c23.4-40.8 37.1-84 42.7-111.7c1.1-5.2-.6-10.7-4.4-14.5s-9.2-5.4-14.4-4.4c-27.9 5.5-71.2 19.2-112.2 42.5c-12.1 6.9-24.3 14.7-35.8 23.6c1.4-28.7-3.1-57.6-10.4-84C306 70.8 285.1 30.6 269.3 7.1c-3-4.4-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1c-15.8 23.5-36.7 63.7-49.2 109c-7.2 26.4-11.8 55.2-10.4 84c-11.5-8.8-23.7-16.7-35.8-23.6C106.3 153.2 63 139.6 35.1 134c-5.2-1-10.7 .6-14.4 4.4s-5.4 9.2-4.4 14.5z',
      'M280 376c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112z',
    ],
  ],
};
const faCirclePlay = {
  prefix: 'fad',
  iconName: 'circle-play',
  icon: [
    512,
    512,
    [61469, 'play-circle'],
    'f144',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm176-88c0-8.7 4.7-16.7 12.3-20.9c3.7-2 7.7-3.1 11.7-3.1c4.3 0 8.7 1.2 12.5 3.5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176z',
      'M212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z',
    ],
  ],
};
const faPlayCircle = faCirclePlay;
const faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fad',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [
    512,
    512,
    [],
    'e0a0',
    [
      'M0 352L0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0L214.6 342.6c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6s-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4L64 402.7 64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M320 32c0-17.7 14.3-32 32-32L480 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7L342.6 214.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 64 352 64c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faLocationArrowUp = {
  prefix: 'fad',
  iconName: 'location-arrow-up',
  icon: [
    448,
    512,
    [],
    'e63a',
    [
      'M36.6 432L201.7 46.7C205.5 37.8 214.3 32 224 32s18.5 5.8 22.3 14.7L411.4 432c9.7 22.7-6.9 48-31.6 48c-7.7 0-15.1-2.6-21.1-7.2L224 368 89.3 472.8c-6 4.7-13.5 7.2-21.1 7.2c-24.7 0-41.4-25.3-31.6-48z',
      '',
    ],
  ],
};
const faTablets = {
  prefix: 'fad',
  iconName: 'tablets',
  icon: [
    640,
    512,
    [],
    'f490',
    [
      'M320 160c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87zM391.2 48.6L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9z',
      'M316.5 385.5c2-9.3-5.5-17.5-15-17.5L18.5 368c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5zm0-66.9C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5l283.1 0c9.5 0 16.9-8.2 15-17.5z',
    ],
  ],
};
const fa360Degrees = {
  prefix: 'fad',
  iconName: '360-degrees',
  icon: [
    640,
    512,
    [],
    'e2dc',
    [
      'M576 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M0 96C0 78.3 14.3 64 32 64l128 0c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5l-63.7 84.9C163 216.7 192 257 192 304l0 48c0 53-43 96-96 96l-5.5 0c-25.5 0-49.9-10.1-67.9-28.1L9.4 406.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l13.3 13.3c6 6 14.1 9.4 22.6 9.4l5.5 0c17.7 0 32-14.3 32-32l0-48c0-26.5-21.5-48-48-48l-16 0c-12.1 0-23.2-6.8-28.6-17.7s-4.3-23.8 3-33.5L96 128l-64 0C14.3 128 0 113.7 0 96zm496 32c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm0 320c-44.2 0-80-35.8-80-80l0-224c0-44.2 35.8-80 80-80s80 35.8 80 80l0 224c0 44.2-35.8 80-80 80zM320 128c-17.7 0-32 14.3-32 32l0 33.6c5.2-1 10.5-1.6 16-1.6c44.2 0 80 35.8 80 80l0 96c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-79.8 0-.2 0-128c0-53 43-96 96-96c17.7 0 32 14.3 32 32s-14.3 32-32 32zM288 272l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
    ],
  ],
};
const faEthernet = {
  prefix: 'fad',
  iconName: 'ethernet',
  icon: [
    512,
    512,
    [],
    'f796',
    [
      'M0 224c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-64 0 0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-64 0 0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-64 0 0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-64 0 0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-64 0c-17.7 0-32-14.3-32-32L0 224z',
      'M112 320c8.8 0 16 7.2 16 16l0 112-32 0 0-112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16l0 112-32 0 0-112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16l0 112-32 0 0-112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16l0 112-32 0 0-112c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faEuroSign = {
  prefix: 'fad',
  iconName: 'euro-sign',
  icon: [
    320,
    512,
    [8364, 'eur', 'euro'],
    'f153',
    [
      'M0 208c0-17.7 14.3-32 32-32l28.3 0c-7.1 20.1-11.3 41.6-12.1 64L32 240c-17.7 0-32-14.3-32-32zm0 96c0-17.7 14.3-32 32-32l16.1 0c.8 22.4 5 43.9 12.1 64L32 336c-17.7 0-32-14.3-32-32zm112.2-64c1.2-23.1 7.5-44.8 17.9-64L256 176c17.7 0 32 14.3 32 32s-14.3 32-32 32l-143.8 0zm0 32L256 272c17.7 0 32 14.3 32 32s-14.3 32-32 32l-125.9 0c-10.4-19.2-16.7-40.9-17.9-64z',
      'M48 248C48 128.7 144.7 32 264 32l24 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0c-83.9 0-152 68.1-152 152l0 16c0 83.9 68.1 152 152 152l24 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0C144.7 480 48 383.3 48 264l0-16z',
    ],
  ],
};
const faEur = faEuroSign;
const faEuro = faEuroSign;
const faChair = {
  prefix: 'fad',
  iconName: 'chair',
  icon: [
    448,
    512,
    [129681],
    'f6c0',
    [
      'M32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96-64 0zM64 128l0 160 48 0 0-160c0-29.6 16.1-55.5 40-69.3L152 288l48 0 0-240 48 0 0 240 48 0 0-229.3c23.9 13.8 40 39.7 40 69.3l0 160 48 0 0-160C384 57.3 326.7 0 256 0L192 0C121.3 0 64 57.3 64 128zM352 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96-64 0z',
      'M19.4 305.7C24.8 294.8 35.9 288 48 288l352 0c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2L32 384c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32z',
    ],
  ],
};
const faCircleCheck = {
  prefix: 'fad',
  iconName: 'circle-check',
  icon: [
    512,
    512,
    [61533, 'check-circle'],
    'f058',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm136 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faCheckCircle = faCircleCheck;
const faSquareDashedCirclePlus = {
  prefix: 'fad',
  iconName: 'square-dashed-circle-plus',
  icon: [
    576,
    512,
    [],
    'e5c2',
    [
      'M0 128l0 32 64 0 0-32c0-17.7 14.3-32 32-32l32 0 0-64L96 32C43 32 0 75 0 128zm0 64L0 320l64 0 0-128L0 192zM0 352l0 32c0 53 43 96 96 96l32 0 0-64-32 0c-17.7 0-32-14.3-32-32l0-32L0 352zM160 32l0 64 128 0 0-64L160 32zm0 384l0 64 128 0 0-10.8c-11.3-16-19.9-33.9-25.4-53.2L160 416zM320 32l0 64 32 0c17.7 0 32 14.3 32 32l0 70.6c15.3-4.3 31.4-6.6 48-6.6c5.4 0 10.7 .2 16 .7l0-64.7c0-53-43-96-96-96l-32 0z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faHandHoldingCircleDollar = {
  prefix: 'fad',
  iconName: 'hand-holding-circle-dollar',
  icon: [
    576,
    512,
    [],
    'e621',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M272 288A144 144 0 1 0 272 0a144 144 0 1 0 0 288zM248.1 115c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.1-11.6-10.5-20s11.6-13.1 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z',
    ],
  ],
};
const faMoneySimpleFromBracket = {
  prefix: 'fad',
  iconName: 'money-simple-from-bracket',
  icon: [
    640,
    512,
    [],
    'e313',
    [
      'M128 96l0 352c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352L128 96zm96 176c0-44.2 43-80 96-80s96 35.8 96 80s-43 80-96 80s-96-35.8-96-80z',
      'M96 64C78.3 64 64 78.3 64 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 43 43 0 96 0L544 0c53 0 96 43 96 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32L96 64z',
    ],
  ],
};
const faBat = {
  prefix: 'fad',
  iconName: 'bat',
  icon: [
    576,
    512,
    [],
    'f6b5',
    [
      'M195.1 159.2c8.5 4 17 8.1 25.5 12.1c6.4 3.1 13.5 4.7 20.6 4.7l93.5 0c7.1 0 14.2-1.6 20.6-4.7l25.5-12.1-19-101.4c-1.1-5.7-6-9.8-11.8-9.8c-3.8 0-7.4 1.8-9.6 4.8L329.6 67.2C323.6 75.3 314.1 80 304 80l-32 0c-10.1 0-19.6-4.7-25.6-12.8L235.6 52.8c-2.3-3-5.8-4.8-9.6-4.8c-5.8 0-10.8 4.1-11.8 9.8l-19 101.4z',
      'M334.8 176H241.2c-7.1 0-14.2-1.6-20.6-4.7L123.4 125c-16.2-7.7-35.5-3.6-47.1 10C27.1 192.4 0 265.6 0 341.2v37.6c0 9.7 10.2 16 18.9 11.7l63.8-31.9c7.5-3.7 16.6-1.1 20.9 6.1l29.8 49.7c5.4 8.9 17.7 10.4 25 3.1l36.6-36.6c6.8-6.8 18.1-6.1 24 1.6l56.2 73.1c6.4 8.3 19 8.3 25.4 0l56.2-73.1c5.9-7.7 17.2-8.4 24-1.6l36.6 36.6c7.4 7.4 19.7 5.8 25-3.1l29.8-49.7c4.3-7.2 13.4-9.8 20.9-6.1l63.8 31.9c8.7 4.3 18.9-2 18.9-11.7V341.2c0-75.6-27.1-148.8-76.3-206.2c-11.6-13.6-30.9-17.7-47.1-10l-97.2 46.3c-6.4 3.1-13.5 4.7-20.6 4.7z',
    ],
  ],
};
const faCircleStop = {
  prefix: 'fad',
  iconName: 'circle-stop',
  icon: [
    512,
    512,
    [62094, 'stop-circle'],
    'f28d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128z',
      'M192 160h128a32 32 0 0 1 32 32v128a32 32 0 0 1 -32 32H192a32 32 0 0 1 -32-32V192a32 32 0 0 1 32-32z',
    ],
  ],
};
const faStopCircle = faCircleStop;
const faHeadSideHeadphones = {
  prefix: 'fad',
  iconName: 'head-side-headphones',
  icon: [
    512,
    512,
    [],
    'f8c2',
    [
      'M0 224.2c0 49.9 16.6 98.2 46.9 137.3C57.1 374.8 64 390.6 64 407.3L64 480c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-32 64 0c35.3 0 64-28.7 64-64l0-64 20.2 0c24.2 0 43.8-19.6 43.8-43.8c0-10-3.4-19.6-9.6-27.4l-42-52.6c-8.3-10.3-12.8-23-15.1-36C429.6 71.8 348 3.9 256 .2L256 64l0 22.6c0 12.4 7.4 23.3 17.4 30.5C301.6 137.4 320 170.6 320 208c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-37.5 18.4-70.6 46.6-90.9c10-7.2 17.4-18.2 17.4-30.5L160 64l0-54.7C67.4 36.9 0 122.8 0 224.2z',
      'M256 64L256 .2c-2.7-.1-5.3-.2-8-.2L224 0c-22.2 0-43.7 3.2-64 9.3L160 64l0 22.6c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9c-10-7.2-17.4-18.2-17.4-30.5L256 64zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faPhoneRotary = {
  prefix: 'fad',
  iconName: 'phone-rotary',
  icon: [
    512,
    512,
    [9742],
    'f8d3',
    [
      'M0 141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1l0 34.7c0 17.7-14.3 32-32 32l-42.3 0c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16c-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208L32 208c-17.7 0-32-14.3-32-32l0-34.7zM328 312a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z',
      'M32 401l0 31c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-31c0-11.1-2.9-22.1-8.4-31.8l-101.1-177C359 172.3 337.8 160 314.9 160l-117.7 0c-23 0-44.2 12.3-55.6 32.2L40.4 369.2C34.9 378.9 32 389.9 32 401zM256 240a72 72 0 1 1 0 144 72 72 0 1 1 0-144z',
    ],
  ],
};
const faArrowUpToBracket = {
  prefix: 'fad',
  iconName: 'arrow-up-to-bracket',
  icon: [
    448,
    512,
    [],
    'e66a',
    [
      'M0 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96z',
      'M246.6 169.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 269.3 192 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z',
    ],
  ],
};
const faCompassDrafting = {
  prefix: 'fad',
  iconName: 'compass-drafting',
  icon: [
    512,
    512,
    ['drafting-compass'],
    'f568',
    [
      'M31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1c-11 18.9-21.9 37.8-32.9 56.8C53.7 301.6 41.8 289.3 31.2 276zm124.1 89.9l32.7-56.4c21.5 6.8 44.3 10.5 68.1 10.5s46.6-3.7 68.1-10.5c33.7-10.7 63.9-29.2 88.6-53.4c6.5-6.3 12.6-13.1 18.2-20.1c11.1-13.8 31.2-16 45-5c7.9 6.3 12 15.6 12 25c0 7-2.3 14.1-7 20c-10.7 13.3-22.5 25.6-35.3 36.8c-25.9 22.7-55.9 40.8-88.8 53C325.4 377.6 291.4 384 256 384s-69.4-6.4-100.7-18.1z',
      'M343.2 136.2c5.6-12.2 8.8-25.8 8.8-40.2c0-53-43-96-96-96s-96 43-96 96c0 14.3 3.1 27.9 8.8 40.2L6.5 416.5C2.2 423.9 0 432.2 0 440.6L0 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l55.4-27.7c8.4-4.2 15.4-10.8 20.1-18.9L256 192c0 0 0 0 0 0s0 0 0 0l68 117.5c33.7-10.7 63.9-29.2 88.6-53.4L343.2 136.2zM224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM356.7 365.9l56.6 97.8c4.7 8.1 11.7 14.7 20.1 18.9l55.4 27.7c5 2.5 10.9 2.2 15.6-.7s7.6-8.1 7.6-13.6l0-55.4c0-8.4-2.2-16.7-6.5-24.1l-60-103.7c-25.9 22.7-55.9 40.8-88.8 53z',
    ],
  ],
};
const faDraftingCompass = faCompassDrafting;
const faPlateWheat = {
  prefix: 'fad',
  iconName: 'plate-wheat',
  icon: [
    512,
    512,
    [],
    'e55a',
    [
      'M0 160c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 184c-13.3 0-24-10.7-24-24zM32 88c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm0 144c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM160 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16zm0 208c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16zm0 208c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16zM384 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16zm0 208c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16z',
      'M27.8 320C13 320 1.6 332.9 3.5 347.6C9.7 397.8 47.8 437 96 446l0 2c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-2c48.2-9 86.3-48.2 92.6-98.4c1.8-14.7-9.6-27.6-24.4-27.6L27.8 320z',
    ],
  ],
};
const faCalendarCircleMinus = {
  prefix: 'fad',
  iconName: 'calendar-circle-minus',
  icon: [
    576,
    512,
    [],
    'e46f',
    [
      'M0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112zm0 80L0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z',
    ],
  ],
};
const faChopsticks = {
  prefix: 'fad',
  iconName: 'chopsticks',
  icon: [
    640,
    512,
    [],
    'e3f7',
    [
      'M0 496c0 4.7 2.1 9.4 6.1 12.6C9 510.9 12.5 512 16 512c4.7 0 9.4-2.1 12.6-6.1c89.3-101.4 178.5-202.7 267.8-304c-20.2-16.1-40.3-32.3-60.5-48.4C158.4 264.4 80.9 375.2 3.4 486.1C1.1 489 0 492.5 0 496zm131.9 10.4c5.8 6.7 15.9 7.5 22.6 1.7c106-81.3 211.9-162.6 317.9-243.9c-17.8-17.8-35.5-35.5-53.2-53.2L133.6 483.9c-6.7 5.8-7.5 15.8-1.7 22.6z',
      'M296.3 201.9l-60.5-48.4L330.3 18.3C339 7.2 352.7 0 368 0c26.5 0 48 21.5 48 48c0 11.2-3.8 21.5-10.3 29.7L296.3 201.9zm175.9 62.4L419 211 560.8 75.6C569.2 68.4 580.1 64 592 64c26.5 0 48 21.5 48 48c0 14.6-6.5 27.6-16.8 36.4l-151 115.8z',
    ],
  ],
};
const faCarWrench = {
  prefix: 'fad',
  iconName: 'car-wrench',
  icon: [
    512,
    512,
    ['car-mechanic'],
    'f5e3',
    [
      'M10.9 43c0 6.9 6.4 13 14.6 13L56 56c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.5 0c-8.2 0-14.6 6.1-14.6 13c0 2.2 .6 4.5 2.1 6.6C27.2 145.5 51.9 160 80 160c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3l184.4 0c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c28.1 0 52.8-14.5 67.1-36.4c1.4-2.2 2.1-4.4 2.1-6.6c0-6.9-6.4-13-14.6-13L456 104c-13.3 0-24-10.7-24-24s10.7-24 24-24l30.5 0c8.2 0 14.6-6.1 14.6-13c0-2.2-.6-4.5-2.1-6.6C484.8 14.5 460.1 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3L163.8 48c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C51.9 0 27.2 14.5 12.9 36.4c-1.4 2.2-2.1 4.4-2.1 6.6z',
      'M170.8 234.6L151.7 288l208.6 0-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6l-140.3 0c-6.8 0-12.8 4.3-15.1 10.6zM82.2 292.4l28.3-79.3C121.9 181.3 152 160 185.8 160l140.3 0c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6l0 40 0 64 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32 0-64 0-40c0-23.2 14.1-43.1 34.2-51.6zM152 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faCarMechanic = faCarWrench;
const faIcicles = {
  prefix: 'fad',
  iconName: 'icicles',
  icon: [
    512,
    512,
    [],
    'f7ad',
    [
      'M336 160c8.3-41.7 16.7-83.4 25-125.2c.4-1.9 .6-3.8 .6-5.7c0-14.4-10.5-26.4-24.3-28.7c1.6-.3 3.2-.4 4.8-.4L482.4 0C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160z',
      'M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H332.5c16.1 0 29.1 13 29.1 29.1c0 1.9-.2 3.8-.6 5.7L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z',
    ],
  ],
};
const faPersonShelter = {
  prefix: 'fad',
  iconName: 'person-shelter',
  icon: [
    512,
    512,
    [],
    'e54f',
    [
      'M130.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5 200 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 16 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-174.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8c8.1-4.3 12.6-12.6 12.6-21.2c0-3.8-.9-7.7-2.9-11.4l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3zM216 168a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l224 128c10 5.7 16.1 16.3 16.1 27.8l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.4L256 68.9 64 178.6 64 480c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 160c0-11.5 6.2-22.1 16.1-27.8l224-128z',
    ],
  ],
};
const faNeuter = {
  prefix: 'fad',
  iconName: 'neuter',
  icon: [
    384,
    512,
    [9906],
    'f22c',
    [
      'M112 176a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1L160 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-130.9z',
    ],
  ],
};
const faIdBadge = {
  prefix: 'fad',
  iconName: 'id-badge',
  icon: [
    384,
    512,
    [],
    'f2c1',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM80 400c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16zM128 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM256 224a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M192 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z',
    ],
  ],
};
const faKazoo = {
  prefix: 'fad',
  iconName: 'kazoo',
  icon: [
    640,
    512,
    [],
    'f8c7',
    [
      'M0 216l0 80c0 14.2 9.4 26.7 23 30.7l192 56c2.9 .8 5.9 1.3 9 1.3l158 0c-46.3-23.9-78-72.3-78-128c0-1.7 0-3.5 .1-5.2s.2-3.4 .3-5.2c.2-3.4 .6-6.8 1.1-10.2c1-6.7 2.4-13.3 4.2-19.6c3.7-12.7 9.1-24.8 15.9-35.8C339.3 158 358.8 140 382 128l-158 0c-3 0-6 .4-9 1.3l-192 56C9.4 189.3 0 201.8 0 216zm404.7-3.3c-6.2 6.2-6.2 16.4 0 22.6L425.4 256l-20.7 20.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L448 278.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L470.6 256l20.7-20.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L448 233.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zM514 128c46.3 23.9 78 72.3 78 128c0 1.7 0 3.5-.1 5.2s-.2 3.4-.3 5.2c-.2 3.4-.6 6.8-1.1 10.2c-1 6.7-2.4 13.3-4.2 19.6c-3.7 12.7-9.1 24.8-15.9 35.8C556.7 354 537.2 372 514 384l94 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-94 0z',
      'M448 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-240a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
    ],
  ],
};
const faMarker = {
  prefix: 'fad',
  iconName: 'marker',
  icon: [
    512,
    512,
    [],
    'f5a1',
    [
      'M0 488c0 6.3 2.5 12.4 7 17s10.7 7 17 7c1.6 0 3.1-.2 4.7-.5l25-5c66.6-13.3 127.8-46.1 175.8-94.1L305 337C261.7 293.7 218.4 250.4 175 207L99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-.3 1.6-.5 3.1-.5 4.7z',
      'M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 175 207 305 337 481 161c35.9-35.9 35.9-94.1 0-129.9z',
    ],
  ],
};
const faBinBottles = {
  prefix: 'fad',
  iconName: 'bin-bottles',
  icon: [
    640,
    512,
    [],
    'e5f5',
    [
      'M32 192l320 0c0-26.5-10.7-50.5-28.1-67.9c-1.1-1.1-2.1-2.1-3.2-3.1c-17.1-15.5-39.7-25-64.6-25L128 96c-53 0-96 43-96 96zM112 48c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-8c0-13.3-10.7-24-24-24L152 0c-13.3 0-24 10.7-24 24l0 8c-8.8 0-16 7.2-16 16zM335.4 91.6C365 115.1 384 151.3 384 192l191.1 0c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-5.3-2.5-10.8-4.4-16.4-5.7l0-42.1c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24l0 42.1c-5.6 1.3-11.1 3.2-16.4 5.7L354.1 78c-7.2 3.4-13.5 8-18.6 13.6z',
      'M32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32L56.2 457c4.5 31.5 31.5 55 63.4 55l401 0c31.8 0 58.9-23.4 63.4-55L608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z',
    ],
  ],
};
const faFaceLaughBeam = {
  prefix: 'fad',
  iconName: 'face-laugh-beam',
  icon: [
    512,
    512,
    [128513, 'laugh-beam'],
    'f59a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 58.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM120 208c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6zm160 0c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M217.6 212.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
    ],
  ],
};
const faLaughBeam = faFaceLaughBeam;
const faSquareArrowDownLeft = {
  prefix: 'fad',
  iconName: 'square-arrow-down-left',
  icon: [
    448,
    512,
    [],
    'e261',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.1L295 151c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-135 135 94.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-152 0c-13.3 0-24-10.7-24-24l0-160z',
      'M136 368l152 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-94.1 0L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faBatteryBolt = {
  prefix: 'fad',
  iconName: 'battery-bolt',
  icon: [
    576,
    512,
    [],
    'f376',
    [
      'M0 176L0 336c0 44.2 35.8 80 80 80l92.2 0c-12.9-14.5-16.1-35.6-7.2-53.5l5.3-10.5L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l139.2 0 80-64L80 96C35.8 96 0 131.8 0 176zM244.8 416L464 416c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80l-92.2 0c13 14.5 16.1 35.6 7.2 53.5L373.7 160l90.3 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-139.2 0-80 64z',
      'M350.3 135.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8z',
    ],
  ],
};
const faTreeLarge = {
  prefix: 'fad',
  iconName: 'tree-large',
  icon: [
    448,
    512,
    [],
    'f7dd',
    [
      'M0 487.1C0 500.9 11.1 512 24.9 512L192 512l0-288c0-17.7 14.3-32 32-32s32 14.3 32 32l0 288 167.1 0c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352l31.8 0c13.4 0 24.2-10.9 24.2-24.2c0-5-1.6-10-4.5-14.1L344 208l24.9 0c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208l24.9 0L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1C24 341.1 34.8 352 48.2 352L80 352 3.8 474c-2.5 4-3.8 8.5-3.8 13.2z',
      'M224 192c17.7 0 32 14.3 32 32l0 288-64 0 0-288c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faHelicopterSymbol = {
  prefix: 'fad',
  iconName: 'helicopter-symbol',
  icon: [
    512,
    512,
    [],
    'e502',
    [
      'M2 224l64.7 0C80.1 143.6 143.6 80.1 224 66.7L224 2C108.2 16.4 16.4 108.2 2 224zm0 64C16.4 403.8 108.2 495.6 224 510l0-64.7C143.6 431.9 80.1 368.4 66.7 288L2 288zM288 2l0 64.7C368.4 80.1 431.9 143.6 445.3 224l64.7 0C495.6 108.2 403.8 16.4 288 2zm0 443.4l0 64.7c115.8-14.4 207.6-106.2 222-222l-64.7 0C431.9 368.4 368.4 431.9 288 445.3z',
      'M176 128c17.7 0 32 14.3 32 32l0 64 96 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-96 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faAperture = {
  prefix: 'fad',
  iconName: 'aperture',
  icon: [
    512,
    512,
    [],
    'e2df',
    [
      'M0 256c0 17.8 1.8 35.2 5.3 51.9c1.5 7.2 7.9 12.1 15.2 12.1l133.9 0c12.3 0 20-13.3 13.9-24L66.1 119c-5.7-9.8-19.4-10.7-25.6-1.2C14.9 157.7 0 205.1 0 256zM232.3 489c-5.7 9.8 .4 22.2 11.8 22.8c3.9 .2 7.9 .3 11.9 .3c65.4 0 125.1-24.5 170.3-64.9c5.4-4.9 6.5-12.9 2.9-19.2L362.2 312c-6.2-10.7-21.6-10.7-27.7 0L232.3 489zm19-353c-6.2 10.7 1.5 24 13.9 24l204.4 0c11.3 0 19-11.5 13.8-21.6C453 79.5 400.2 34 336.4 12.9c-6.9-2.3-14.4 .8-18 7.1l-67 116z',
      'M256 0c4 0 7.9 .1 11.9 .3c11.3 .5 17.4 12.9 11.8 22.8L177.5 200c-6.2 10.7-21.6 10.7-27.7 0L82.8 84.1c-3.6-6.3-2.6-14.3 2.9-19.2C130.9 24.5 190.6 0 256 0zM193.6 492c-3.6 6.3-11.1 9.4-18 7.1C111.8 478 59 432.5 28.5 373.6C23.3 363.5 31 352 42.3 352l204.4 0c12.3 0 20 13.3 13.9 24l-67 116zm277.9-97.8c-6.1 9.5-19.9 8.6-25.6-1.2L343.8 216c-6.2-10.7 1.5-24 13.9-24l133.9 0c7.3 0 13.7 4.9 15.2 12.1c3.5 16.8 5.3 34.1 5.3 51.9c0 50.9-14.9 98.3-40.5 138.2z',
    ],
  ],
};
const faUniversalAccess = {
  prefix: 'fad',
  iconName: 'universal-access',
  icon: [
    512,
    512,
    [],
    'f29a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-64c0-3.2 .6-6.4 1.9-9.4c5.2-12.2 19.3-17.8 31.5-12.6c4 1.7 7.9 3.4 11.9 5.1c26.1 11.2 54.2 17 82.7 17s56.5-5.8 82.7-17c4-1.7 7.9-3.4 11.9-5.1c12.2-5.2 26.3 .4 31.5 12.6c.7 1.5 1.1 3.1 1.5 4.7c.2 1.2 .4 2.4 .4 2.3c.1 1.2 .1 1.2 .1 2.5c0 1.2 0 1.4-.1 1.7c0 .5-.1 1.1-.2 1.7c-.2 1.1-.4 2.3-.7 3.4c-.7 2.2-1.6 4.3-2.9 6.2c-2.5 3.9-6.1 7.1-10.7 9c-4 1.7-7.9 3.4-11.9 5.1c-17.3 7.4-35.2 12.9-53.6 16.3c0 16.7 0 33.4 0 50.1c0 4.3 .7 8.6 2.1 12.6l28.7 86.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2c-8.1-24.4-16.3-48.8-24.4-73.2c-1.3-3.8-4.8-6.4-8.8-6.4s-7.6 2.6-8.8 6.4c-8.1 24.4-16.3 48.8-24.4 73.2c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4c9.6-28.7 19.1-57.4 28.7-86.2c.7-2 1.2-4.1 1.5-6.3c.2-1.1 .3-2.1 .4-3.2c.1-2.1 .1-2.7 .1-3.2c0-16.7 0-33.4 0-50.1c-18.4-3.5-36.3-8.9-53.6-16.3c-4-1.7-7.9-3.4-11.9-5.1c-9.1-3.9-14.6-12.8-14.6-22.1zm88-72c0-22.1 17.9-40 40-40c11 0 21 4.5 28.3 11.7c3.6 3.6 6.5 7.9 8.6 12.7c1 2.4 1.8 4.9 2.3 7.5c.3 1.3 .5 2.6 .6 4c.1 .7 .1 1.4 .2 2s0 1.3 .1 1.7l0 .4 0 .4c0 .4 0 1-.1 1.7c0 .7-.1 1.3-.2 2c-.1 1.3-.3 2.7-.6 4c-.5 2.6-1.3 5.1-2.3 7.5c-2 4.8-5 9.1-8.6 12.7C277 155.5 267 160 256 160c-22.1 0-40-17.9-40-40z',
      'M256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM129.9 182.5c5.2-12.2 19.3-17.8 31.5-12.6l11.9 5.1c26.1 11.2 54.2 17 82.7 17s56.5-5.8 82.7-17l11.9-5.1c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-11.9 5.1c-17.3 7.4-35.2 12.9-53.6 16.3l0 50.1c0 4.3 .7 8.6 2.1 12.6l28.7 86.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-24.4-73.2c-1.3-3.8-4.8-6.4-8.8-6.4s-7.6 2.6-8.8 6.4l-24.4 73.2c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l28.7-86.1c1.4-4.1 2.1-8.3 2.1-12.6l0-50.1c-18.4-3.5-36.3-8.9-53.6-16.3l-11.9-5.1c-12.2-5.2-17.8-19.3-12.6-31.5z',
    ],
  ],
};
const faGearComplex = {
  prefix: 'fad',
  iconName: 'gear-complex',
  icon: [
    512,
    512,
    [],
    'e5e9',
    [
      'M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2l0-51.9c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
    ],
  ],
};
const faFileMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'file-magnifying-glass',
  icon: [
    384,
    512,
    ['file-search'],
    'f865',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 304c0 53 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L263 425.1c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9c0-53-43-96-96-96s-96 43-96 96zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM272 304c0 17.8-4.9 34.5-13.3 48.9L297 391.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-38.4-38.4C210.4 395.2 193.8 400 176 400c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faFileSearch = faFileMagnifyingGlass;
const faUpRight = {
  prefix: 'fad',
  iconName: 'up-right',
  icon: [
    384,
    512,
    [],
    'e2be',
    [
      'M0 368c0 10.2 4.1 20.1 11.3 27.3l41.4 41.4C59.9 443.9 69.8 448 80 448s20.1-4.1 27.3-11.3L241.4 302.6c-32-32-64-64-96-96L11.3 340.7C4.1 347.9 0 357.8 0 368z',
      'M336 80H96c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l240 240c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V112c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faCircleChevronUp = {
  prefix: 'fad',
  iconName: 'circle-chevron-up',
  icon: [
    512,
    512,
    ['chevron-circle-up'],
    'f139',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 32c0-6.1 2.3-12.3 7-17L239 167c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7L377 271c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-87-87-87 87c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M239 167c9.4-9.4 24.6-9.4 33.9 0L377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167z',
    ],
  ],
};
const faChevronCircleUp = faCircleChevronUp;
const faUserPolice = {
  prefix: 'fad',
  iconName: 'user-police',
  icon: [
    448,
    512,
    [],
    'e333',
    [
      'M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6l23.8 20.4c-.1 1-.1 2-.1 3.1l0 21.2c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-21.2c0-1-.1-2.1-.1-3.1l23.8-20.4c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zm-84.9 306c-2.2-1.7-4.9-2.6-7.7-2.6C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352c-2.8 0-5.5 .9-7.7 2.6l-72.3 54.2c-5.7 4.3-13.5 4.3-19.2 0l-72.3-54.2zm217.5 59l5.4 16.6 17.4 0c3.5 0 6.6 2.2 7.6 5.5s-.1 6.9-2.9 9L373 454.8l5.4 16.6c1.1 3.3-.1 6.9-2.9 9s-6.6 2-9.4 0L352 470.1l-14.1 10.3c-2.8 2-6.6 2.1-9.4 0s-4-5.7-2.9-9l5.4-16.6-14.1-10.2c-2.8-2-4-5.7-2.9-9s4.2-5.5 7.6-5.5l17.4 0 5.4-16.6c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5z',
    ],
  ],
};
const faLariSign = {
  prefix: 'fad',
  iconName: 'lari-sign',
  icon: [
    384,
    512,
    [],
    'e1c8',
    [
      'M112 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32.7c-22.7 1.9-44.2 7.7-64 16.8L112 64zm0 124.1c18-14.4 40-24.1 64-27.1l0 95c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.9zM208 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 49.4c-19.8-9.1-41.3-14.9-64-16.8L208 64zm0 97c24 3 46 12.7 64 27.1l0 67.9c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-95z',
      'M64 288c0-70.7 57.3-128 128-128c61.9 0 113.6 44 125.4 102.4c3.5 17.3 20.4 28.5 37.7 25s28.5-20.4 25-37.7C362.4 162 284.9 96 192 96C86 96 0 182 0 288c0 49.2 18.5 94 48.9 128L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-70.7 0-128-57.3-128-128z',
    ],
  ],
};
const faVolcano = {
  prefix: 'fad',
  iconName: 'volcano',
  icon: [
    512,
    512,
    [127755],
    'f770',
    [
      'M0 459.8C0 488.6 23.4 512 52.2 512l407.7 0c28.8 0 52.2-23.4 52.2-52.2c0-12.8-4.7-25.1-13.2-34.7l-99.6-112L362 369c-6.3 9.4-16.8 15-28 15c-8.9 0-17.5-3.6-23.8-9.9c-11.5-11.5-23-23-34.5-34.5C263.1 327.1 246 320 228.3 320c-13.2 0-26.1 3.9-37.1 11.2l-17.8 11.9c-8.7 5.8-18.9 8.9-29.3 8.9s-20.6-3.1-29.3-8.9c-6-4-12-8-17.9-12l-83.6 94C4.7 434.7 0 447.1 0 459.8z',
      'M160 144c14.7 0 28.3-5 39.1-13.3l32 48C236.7 187 246 192 256 192s19.3-5 24.9-13.3l32-48C323.7 139 337.3 144 352 144c35.3 0 64-28.7 64-64s-28.7-64-64-64c-15.7 0-30 5.6-41.2 15C299.6 12.4 279.3 0 256 0s-43.6 12.4-54.8 31C190 21.6 175.7 16 160 16c-35.3 0-64 28.7-64 64s28.7 64 64 64zm31.1 187.2c11-7.3 23.9-11.2 37.1-11.2c17.8 0 34.8 7.1 47.3 19.6l34.5 34.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l37.2-55.8-50.6-56.9c-18.2-20.5-44.3-32.2-71.8-32.2l-41.8 0c-27.4 0-53.5 11.7-71.8 32.2L96.7 331.2l17.9 12c8.7 5.8 18.9 8.9 29.3 8.9s20.6-3.1 29.3-8.9l17.8-11.9z',
    ],
  ],
};
const faTeddyBear = {
  prefix: 'fad',
  iconName: 'teddy-bear',
  icon: [
    576,
    512,
    [],
    'e3cf',
    [
      'M128 56c0-30.9 25.1-56 56-56c24.2 0 44.7 15.3 52.6 36.7c-41.5 8.5-72.8 29.1-81.9 67C138.7 93.9 128 76.2 128 56zm64 360c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l-192 0zm32-240c0-26.5 28.7-48 64-48s64 21.5 64 48s-28.7 48-64 48s-64-21.5-64-48zm32-8c0 13.3 14.3 24 32 24s32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24zM339.4 36.7C347.3 15.3 367.8 0 392 0c30.9 0 56 25.1 56 56c0 20.2-10.7 37.9-26.7 47.7c-9.1-37.9-40.4-58.5-81.9-67z',
      'M288 256c-75.1 0-136-57.3-136-128s60.9-96 136-96s136 25.3 136 96s-60.9 128-136 128zM240 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM50.3 178.3c20.8-16.4 51-12.8 67.4 8L143.5 219c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7c16.4-20.8 46.6-24.4 67.4-8s24.4 46.6 8 67.4l-25.8 32.7c-17.7 22.4-37.9 41.3-59.9 56.7l0 64.9 16.6 0c3.9-27.1 27.2-48 55.4-48c30.9 0 56 25.1 56 56c0 2.7-.2 5.4-.6 8l-13 53.3c-5.8 23.8-26.3 40.9-50.4 42.6l0 .1-4 0-28 0L96 512l-28 0-4 0 0-.1c-24.1-1.7-44.6-18.8-50.4-42.6L.6 416c-.4-2.6-.6-5.3-.6-8c0-30.9 25.1-56 56-56c28.2 0 51.6 20.9 55.4 48l16.6 0 0-64.9c-22-15.4-42.3-34.3-59.9-56.7L42.3 245.7c-16.4-20.8-12.8-51 8-67.4zM256 352c-35.3 0-64 28.7-64 64l192 0c0-35.3-28.7-64-64-64l-64 0z',
    ],
  ],
};
const faStocking = {
  prefix: 'fad',
  iconName: 'stocking',
  icon: [
    384,
    512,
    [],
    'f7d5',
    [
      'M0 386.9l0 2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6l66-44c-20.4-20.3-33-48.3-33-79.4c0-61.9 50.1-112 112-112c5.4 0 10.8 .4 16 1.1L352 96 96 96l0 142.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9z',
      'M96 0C78.3 0 64 14.3 64 32l0 32c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L96 0zM352 315.5l0-58.4c-5.2-.7-10.6-1.1-16-1.1c-61.9 0-112 50.1-112 112c0 31 12.6 59.1 33 79.4L295 422c35.6-23.7 57-63.7 57-106.5z',
    ],
  ],
};
const faPersonWalkingDashedLineArrowRight = {
  prefix: 'fad',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [
    640,
    512,
    [],
    'e553',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6L68.7 398 9.4 457.4C3.1 463.6 0 471.8 0 480zM17.6 229.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c3.6 14.5 16.7 24.2 31 24.2c2.6 0 5.2-.3 7.8-1c17.1-4.3 27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8zM160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M392 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zM505.4 153.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L530.7 288 384 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3zM416 152l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24zM392 320c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zm24 120l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faImageSlash = {
  prefix: 'fad',
  iconName: 'image-slash',
  icon: [
    640,
    512,
    [],
    'e1b7',
    [
      'M64 146.4L64 416c0 35.3 28.7 64 64 64l359.4 0-81.2-64L320 416l-72 0-96 0c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104c.3-.4 .6-.7 1-1.1L64 146.4zM89.5 44.9c23.1 18.1 46.2 36.2 69.3 54.3c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6c34.8 27.3 69.7 54.6 104.5 81.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1l75.9 59.5c.5-3.1 .7-6.3 .7-9.6l0-320c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faMaskSnorkel = {
  prefix: 'fad',
  iconName: 'mask-snorkel',
  icon: [
    576,
    512,
    [],
    'e3b7',
    [
      'M288 384c0 1.7 .1 3.5 .4 5.3l.3 1.9c11.6 69.7 72 120.8 142.6 120.8C511.3 512 576 447.3 576 367.4L576 192l-64 0 0 175.4c0 44.5-36.1 80.6-80.6 80.6c-39.4 0-73-28.5-79.5-67.4l-.3-1.9c-2.9-17.4-19.4-29.2-36.8-26.3C299.1 355 288 368.6 288 384zM512 64l0 96 64 0 0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M64 64C28.7 64 0 92.7 0 128l0 96c0 35.3 28.7 64 64 64l79.7 0c28.6 0 53.7-18.9 61.5-46.4l3.4-11.7c4.4-15.5 26.3-15.5 30.8 0l3.4 11.7c7.8 27.5 33 46.4 61.5 46.4l79.7 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 64zm512 96l-64 0 0 32 64 0 0-32z',
    ],
  ],
};
const faSmoke = {
  prefix: 'fad',
  iconName: 'smoke',
  icon: [
    640,
    512,
    [],
    'f760',
    [
      'M32 128c0 32 11.7 61.2 31.1 83.6C87.3 199.1 114.8 192 144 192c9.6 0 19.1 .8 28.3 2.3C196.5 136.6 253.5 96 320 96c27.2 0 52.7 6.8 75.1 18.7c9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-22 0-42.6 5.5-60.7 15.3C235.9 18.4 200.1 0 160 0C89.3 0 32 57.3 32 128zm171.7 74.4c10.7 3.9 20.9 8.7 30.5 14.5C259.1 201.1 288.5 192 320 192c52.7 0 99.5 25.5 128.6 64.8c5.1-.5 10.2-.8 15.4-.8c52.9 0 99.1 28.5 124.1 70.9C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128c-46.5 0-87.3 24.8-109.7 62c-22.3-18.7-51-30-82.3-30c-51.6 0-96 30.5-116.3 74.4z',
      'M0 368c0 79.5 64.5 144 144 144l320 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.6 0-62.4 12.2-85.1 32.3C210.1 236.1 178.5 224 144 224C64.5 224 0 288.5 0 368z',
    ],
  ],
};
const faSterlingSign = {
  prefix: 'fad',
  iconName: 'sterling-sign',
  icon: [
    320,
    512,
    [163, 'gbp', 'pound-sign'],
    'f154',
    [
      'M0 256c0 17.7 14.3 32 32 32l16 0 0-64-16 0c-17.7 0-32 14.3-32 32zm112-32l0 64 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0z',
      'M176.4 96c-35.5 0-64.4 28.8-64.4 64.4l0 172.2c0 29-7.9 57.5-22.8 82.3l-.7 1.1L288 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l29.8-49.6c9-14.9 13.7-32 13.7-49.4l0-172.2C48 89.5 105.5 32 176.4 32c13.8 0 27.5 2.2 40.6 6.6l81.2 27.1c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L196.7 99.3c-6.6-2.2-13.4-3.3-20.4-3.3z',
    ],
  ],
};
const faGbp = faSterlingSign;
const faPoundSign = faSterlingSign;
const faBatteryExclamation = {
  prefix: 'fad',
  iconName: 'battery-exclamation',
  icon: [
    576,
    512,
    [],
    'e0b0',
    [
      'M0 176L0 336c0 44.2 35.8 80 80 80l118.7 0c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l128 0 0-64L80 96C35.8 96 0 131.8 0 176zM336 96l0 64 128 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-118.7 0c4.3 9.8 6.7 20.6 6.7 32s-2.4 22.2-6.7 32L464 416c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L336 96z',
      'M296 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176zM272 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faViruses = {
  prefix: 'fad',
  iconName: 'viruses',
  icon: [
    640,
    512,
    [],
    'e076',
    [
      'M0 192c0 13.3 10.7 24 24 24l13.5 0c35.6 0 53.5 43.1 28.3 68.3l-9.5 9.5c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l9.5-9.5c25.2-25.2 68.3-7.4 68.3 28.3l0 13.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.5c0-35.6 43.1-53.5 68.3-28.3l9.5 9.5c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-9.5-9.5C293 259.1 310.9 216 346.5 216l13.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-13.5 0c-35.6 0-53.5-43.1-28.3-68.3l9.5-9.5c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-9.5 9.5C259.1 91 216 73.1 216 37.5L216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 13.5c0 35.6-43.1 53.5-68.3 28.3l-9.5-9.5c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l9.5 9.5C91 124.9 73.1 168 37.5 168L24 168c-13.3 0-24 10.7-24 24zm192-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM448 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352 48c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C417.5 312.1 401 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C440.1 446.5 480 463 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C574.5 423.9 591 384 624 384c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C551.9 289.5 512 273 512 240zM448 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faSquarePersonConfined = {
  prefix: 'fad',
  iconName: 'square-person-confined',
  icon: [
    448,
    512,
    [],
    'e577',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM99.4 369.7l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7l0-58.7c0-30.9 25.1-56 56-56s56 25.1 56 56l0 102.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9zM256 144a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M208 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm88 0c-30.9 0-56 25.1-56 56l0 58.7-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L184.8 342l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L352 248c0-30.9-25.1-56-56-56z',
    ],
  ],
};
const faUserTie = {
  prefix: 'fad',
  iconName: 'user-tie',
  icon: [
    448,
    512,
    [],
    'f508',
    [
      'M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M190.5 328.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c2.1 0 4-.4 5.8-1.1L168 512l112 0-.3-1.1c1.8 .7 3.8 1.1 5.8 1.1l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2z',
    ],
  ],
};
const faUpToBracket = {
  prefix: 'fad',
  iconName: 'up-to-bracket',
  icon: [
    448,
    512,
    [],
    'e66e',
    [
      'M0 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96z',
      'M196.7 171.3L73.9 294.1c-6.4 6.4-9.9 15-9.9 24C64 336.8 79.2 352 97.9 352l62.1 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L251.3 171.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3z',
    ],
  ],
};
const faArrowDownLong = {
  prefix: 'fad',
  iconName: 'arrow-down-long',
  icon: [
    384,
    512,
    ['long-arrow-down'],
    'f175',
    [
      'M160 32l0 370.7c10.7 10.7 21.3 21.3 32 32c10.7-10.7 21.3-21.3 32-32L224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 434.7 86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z',
    ],
  ],
};
const faLongArrowDown = faArrowDownLong;
const faTentArrowDownToLine = {
  prefix: 'fad',
  iconName: 'tent-arrow-down-to-line',
  icon: [
    640,
    512,
    [],
    'e57e',
    [
      'M159.6 448L384 448l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5L464 448l144 0c.1 0 .2 0 .4 0l-.7-4.7-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-5.7-4.4-12.6-6.5-19.4-6.5s-13.7 2.2-19.4 6.5l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160-.7 4.7z',
      'M240.1 145.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-39.9 36L168 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faCertificate = {
  prefix: 'fad',
  iconName: 'certificate',
  icon: [
    512,
    512,
    [],
    'f0a3',
    [
      'M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z',
      '',
    ],
  ],
};
const faCrystalBall = {
  prefix: 'fad',
  iconName: 'crystal-ball',
  icon: [
    448,
    512,
    [],
    'e362',
    [
      'M0 224c0 71.4 33.4 135 85.4 176l277.2 0c52-41 85.4-104.6 85.4-176C448 100.3 347.7 0 224 0S0 100.3 0 224zM116.3 120.5l26.4-9.8 9.8-26.4c2.6-7 12.4-7 15 0l9.8 26.4 26.4 9.8c7 2.6 7 12.4 0 15l-26.4 9.8-9.8 26.4c-2.6 7-12.4 7-15 0l-9.8-26.4-26.4-9.8c-7-2.6-7-12.4 0-15zm112 80l49.8-18.4 18.4-49.8c2.6-7 12.4-7 15 0l18.4 49.8 49.8 18.4c7 2.6 7 12.4 0 15l-49.8 18.4-18.4 49.8c-2.6 7-12.4 7-15 0l-18.4-49.8-49.8-18.4c-7-2.6-7-12.4 0-15z',
      'M362.6 400H85.4L21.7 473.4c-3.7 4.2-5.7 9.7-5.7 15.3C16 501.6 26.4 512 39.3 512H408.7c12.9 0 23.3-10.4 23.3-23.3c0-5.6-2-11-5.7-15.3L362.6 400z',
    ],
  ],
};
const faReplyAll = {
  prefix: 'fad',
  iconName: 'reply-all',
  icon: [
    576,
    512,
    ['mail-reply-all'],
    'f122',
    [
      'M0 208c0 9.1 3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-43.3c-28.5-25.6-56.9-51.2-85.4-76.9c-.5-.4-.8-.8-1.2-1.2c-.4-.4-.8-.8-1.2-1.2c-.8-.8-1.5-1.7-2.1-2.6c-1.3-1.8-2.4-3.8-3.3-5.8c-.5-1-.9-2.1-1.2-3.1s-.6-2.1-.9-3.2c-.2-1.1-.4-2.2-.5-3.4c-.1-.6-.1-1.1-.1-1.7c0-.5 0-1 0-1.3l0-.4c0-.1 0-.3 0-.4c0-.3 0-.8 0-1.3c0-.6 .1-1.1 .1-1.7c.1-1.1 .3-2.2 .5-3.3c.5-2.2 1.2-4.3 2.1-6.3c1.8-4.1 4.5-7.7 7.8-10.8c28.5-25.6 56.9-51.2 85.4-76.9L224 64c0-12.6-7.4-24.1-19-29.2c-4.2-1.9-8.6-2.8-13-2.8c-7.8 0-15.4 2.8-21.4 8.2l-160 144C3.9 190.3 0 198.9 0 208z',
      'M333 34.8c11.5 5.1 19 16.6 19 29.2l0 64 48 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-32 0 0 64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144c-6.7-6.1-10.6-14.7-10.6-23.8s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z',
    ],
  ],
};
const faMailReplyAll = faReplyAll;
const faSuitcase = {
  prefix: 'fad',
  iconName: 'suitcase',
  icon: [
    512,
    512,
    [129523],
    'f0f2',
    [
      'M96 96l32 0 0 32 0 352-32 0L96 96zm288 0l32 0 0 384-32 0 0-352 0-32z',
      'M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 0 32 0 352-256 0 0-352 0-32zM64 96l32 0 0 384-32 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64zM448 480l-32 0 0-384 32 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64z',
    ],
  ],
};
const faPersonSkating = {
  prefix: 'fad',
  iconName: 'person-skating',
  icon: [
    448,
    512,
    ['skating'],
    'f7c5',
    [
      'M0 400c0 4.1 1.6 8.2 4.7 11.3l59.6 59.6c17 17 43.1 21.3 64.6 10.5l6.2-3.1c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-6.2 3.1c-9.2 4.6-20.4 2.8-27.7-4.5L27.3 388.7c-3.1-3.1-7.2-4.7-11.3-4.7s-8.2 1.6-11.3 4.7S0 395.9 0 400zm256 96c0 8.8 7.2 16 16 16l88.8 0c25.7 0 48.1-17.5 54.3-42.4l.4-1.7c.3-1.3 .5-2.6 .5-3.9c0-7.2-4.9-13.7-12.1-15.5c-8.6-2.1-17.3 3.1-19.4 11.6l-.4 1.7c-2.7 10.7-12.3 18.2-23.3 18.2L272 480c-8.8 0-16 7.2-16 16z',
      'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32l159.4 0c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9l0 73.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17L160 160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3z',
    ],
  ],
};
const faSkating = faPersonSkating;
const faStarShooting = {
  prefix: 'fad',
  iconName: 'star-shooting',
  icon: [
    512,
    512,
    [127776],
    'e036',
    [
      'M231 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7L231 55zm96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 41c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7L327 151zm96 96c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48z',
      'M213.4 157.4c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z',
    ],
  ],
};
const faBinaryLock = {
  prefix: 'fad',
  iconName: 'binary-lock',
  icon: [
    640,
    512,
    [],
    'e33d',
    [
      'M0 64l0 96c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM0 480c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16C5.1 311.2-3.9 329.4 1.7 346.1s23.7 25.8 40.5 20.2l5.9-2L48 448l-16 0c-17.7 0-32 14.3-32 32zM64 64l64 0 0 96-64 0 0-96zM192 352l0 96c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zm32-160c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 83.6-16 0c-17.7 0-32 14.3-32 32zm32 160l64 0 0 96-64 0 0-96z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faFilterCircleDollar = {
  prefix: 'fad',
  iconName: 'filter-circle-dollar',
  icon: [
    576,
    512,
    ['funnel-dollar'],
    'f662',
    [
      'M3.9 22.9C-2.8 36.8-.7 53.4 9 65.3L192 288.9l0 79.1c0 10.1 4.7 19.6 12.8 25.6l64 48c1.5 1.1 3 2.1 4.7 2.9C262.3 421.4 256 395.4 256 368c0-85 60.2-155.9 140.4-172.4L503 65.3c9.8-12 11.8-28.5 5.2-42.5S487.5 0 472 0L40 0C24.5 0 10.5 8.9 3.9 22.9z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z',
    ],
  ],
};
const faFunnelDollar = faFilterCircleDollar;
const faCameraRetro = {
  prefix: 'fad',
  iconName: 'camera-retro',
  icon: [
    512,
    512,
    [128247],
    'f083',
    [
      'M0 128C0 92.7 28.7 64 64 64l96 0 32 0 50.5-25.2c8.9-4.4 18.7-6.8 28.6-6.8L448 32c35.3 0 64 28.7 64 64l0 64-256 0L0 160l0-32z',
      'M64 48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16L64 64l0-16zM0 416L0 160l512 0 0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zm256-16a96 96 0 1 0 0-192 96 96 0 1 0 0 192z',
    ],
  ],
};
const faCircleArrowDown = {
  prefix: 'fad',
  iconName: 'circle-arrow-down',
  icon: [
    512,
    512,
    ['arrow-circle-down'],
    'f0ab',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm120 8c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17L273 393c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L127 281c-4.7-4.7-7-10.8-7-17z',
      'M239 393c9.4 9.4 24.6 9.4 33.9 0L385 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71L280 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 182.1-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 393z',
    ],
  ],
};
const faArrowCircleDown = faCircleArrowDown;
const faCommentPen = {
  prefix: 'fad',
  iconName: 'comment-pen',
  icon: [
    512,
    512,
    ['comment-edit'],
    'f4ae',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160 79.9c0-1.3 .2-2.6 .5-3.9l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9c24-24 47.9-48 71.9-71.9l53.3 53.3c-24 24-47.9 48-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4c-12.2 3.1-24.4 6.1-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2c-3-3-4.7-7.1-4.7-11.3zM272.6 170c5-5 9.9-9.9 14.9-14.9c7.4-7.4 17-11.1 26.7-11.1s19.3 3.7 26.7 11.1c14.7 14.7 14.7 38.6 0 53.3c-5 5-9.9 9.9-14.9 14.9c-17.8-17.8-35.6-35.6-53.3-53.3z',
      'M287.5 155L272.6 170l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3s-38.6-14.7-53.3 0zM250 192.6l-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9L160.5 316c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 192.6z',
    ],
  ],
};
const faCommentEdit = faCommentPen;
const faFileImport = {
  prefix: 'fad',
  iconName: 'file-import',
  icon: [
    512,
    512,
    ['arrow-right-to-file'],
    'f56f',
    [
      'M128 64c0-35.3 28.7-64 64-64L352 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-112 174.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L128 288l0-224z',
      'M512 160L352 0l0 128c0 17.7 14.3 32 32 32l128 0zM297 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z',
    ],
  ],
};
const faArrowRightToFile = faFileImport;
const faBanjo = {
  prefix: 'fad',
  iconName: 'banjo',
  icon: [
    512,
    512,
    [129685],
    'f8a3',
    [
      'M24 320c0-8.1 .6-16.2 1.7-24c4.1-28.5 15.3-54.6 31.7-76.6c9.6-12.9 21.1-24.3 33.9-33.9c22-16.5 48.2-27.7 76.6-31.7c7.8-1.1 15.9-1.7 24-1.7s16.2 .6 24 1.7c25.7 3.7 49.5 13.1 70 27c2.2 1.5 4.4 3.1 6.6 4.7c12.9 9.6 24.3 21.1 33.9 33.9c1.6 2.2 3.2 4.4 4.7 6.6c13.9 20.5 23.4 44.3 27 70c1.1 7.8 1.7 15.9 1.7 24s-.6 16.2-1.7 24c-4.1 28.5-15.3 54.6-31.7 76.6c-9.6 12.9-21.1 24.3-33.9 33.9c-22 16.5-48.2 27.7-76.6 31.7c-7.8 1.1-15.9 1.7-24 1.7s-16.2-.6-24-1.7c-28.5-4.1-54.6-15.3-76.6-31.7c-12.9-9.6-24.3-21.1-33.9-33.9C41 398.6 29.8 372.5 25.7 344c-1.1-7.8-1.7-15.9-1.7-24zm56 0a112 112 0 1 0 224 0A112 112 0 1 0 80 320z',
      'M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41L286 180.7c2.2 1.5 4.4 3.1 6.6 4.7c12.9 9.6 24.3 21.1 33.9 33.9c1.6 2.2 3.2 4.4 4.7 6.6l76.1-76.1 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 128c-13.3 0-24 10.7-24 24l0 1.7c7.8-1.1 15.9-1.7 24-1.7s16.2 .6 24 1.7l0-1.7c0-13.3-10.7-24-24-24zM360 320c0 8.1-.6 16.2-1.7 24l1.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.7 0c1.1 7.8 1.7 15.9 1.7 24zM292.6 454.6l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c-9.6 12.9-21.1 24.3-33.9 33.9zM192 488c-8.1 0-16.2-.6-24-1.7l0 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-1.7c-7.8 1.1-15.9 1.7-24 1.7zM57.4 420.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c-12.9-9.6-24.3-21.1-33.9-33.9zM24 320c0-8.1 .6-16.2 1.7-24L24 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l1.7 0c-1.1-7.8-1.7-15.9-1.7-24zM91.4 185.4l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2c9.6-12.9 21.1-24.3 33.9-33.9zm41.3 123.2c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0z',
    ],
  ],
};
const faSquareArrowUpRight = {
  prefix: 'fad',
  iconName: 'square-arrow-up-right',
  icon: [
    448,
    512,
    ['external-link-square'],
    'f14c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 344c0-6.1 2.3-12.3 7-17l135-135L160 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l152 0c13.3 0 24 10.7 24 24l0 160c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1L153 361c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M312 144l-152 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l94.1 0L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135L288 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faExternalLinkSquare = faSquareArrowUpRight;
const faLightEmergencyOn = {
  prefix: 'fad',
  iconName: 'light-emergency-on',
  icon: [
    640,
    512,
    [],
    'e420',
    [
      'M160 192l0 160 320 0 0-160c0-88.4-71.6-160-160-160s-160 71.6-160 160zm48 0c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z',
      'M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM128 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-384 0z',
    ],
  ],
};
const faKerning = {
  prefix: 'fad',
  iconName: 'kerning',
  icon: [
    640,
    512,
    [],
    'f86f',
    [
      'M0 128c0 4.8 1.1 9.7 3.4 14.3l128 256c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l128-256c7.9-15.8 1.5-35-14.3-42.9c-4.6-2.3-9.5-3.4-14.3-3.4c-11.7 0-23 6.5-28.6 17.7L160 312.4 60.6 113.7C52.7 97.9 33.5 91.5 17.7 99.4C6.5 105 0 116.3 0 128zM323.4 369.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L403.8 352l152.4 0 23.2 46.3c7.9 15.8 27.1 22.2 42.9 14.3C633.5 407 640 395.7 640 384c0-4.8-1.1-9.7-3.4-14.3l-128-256C503.2 102.8 492.1 96 480 96s-23.2 6.8-28.6 17.7l-128 256zM435.8 288L480 199.6 524.2 288l-88.4 0z',
      'M447.2 1.7c7.9 4 11.1 13.6 7.2 21.5l-240 480c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l240-480c4-7.9 13.6-11.1 21.5-7.2z',
    ],
  ],
};
const faBoxOpen = {
  prefix: 'fad',
  iconName: 'box-open',
  icon: [
    640,
    512,
    [],
    'f49e',
    [
      'M17.2 125.5L58.9 42.1c3-6.1 9.6-9.6 16.3-8.7C156.8 43.6 238.4 53.8 320 64c-27.8 46.3-55.6 92.6-83.4 139c-7.5 12.4-22.3 18.3-36.2 14.3c-45.5-13-90.9-26-136.4-39c-9-2.6-18-5.1-26.9-7.7c-19.3-5.5-28.8-27.2-19.8-45.1zM320 64L564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1c-9 2.6-18 5.1-26.9 7.7c-45.5 13-90.9 26-136.4 39c-13.9 4-28.8-1.9-36.2-14.3c-27.8-46.3-55.6-92.6-83.4-139z',
      'M320 64L236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L64 178.3l0 200.2c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.6 20.9 2.6 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6l0-200.2-136.4 39c-13.9 4-28.8-1.9-36.2-14.3L320 64z',
    ],
  ],
};
const faSquareF = {
  prefix: 'fad',
  iconName: 'square-f',
  icon: [
    448,
    512,
    [],
    'e270',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z',
      'M128 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z',
    ],
  ],
};
const faScroll = {
  prefix: 'fad',
  iconName: 'scroll',
  icon: [
    576,
    512,
    [128220],
    'f70e',
    [
      'M64 32l352 0c35.3 0 64 28.7 64 64l0 256-160 0c-17.7 0-32 14.3-32 32l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-240 0-64c0-35.3-28.7-64-64-64z',
      'M128 160l-96 0c-17.7 0-32-14.3-32-32L0 96C0 60.7 28.7 32 64 32s64 28.7 64 64l0 64zM288 400l0-16c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-272 0c44.2 0 80-35.8 80-80z',
    ],
  ],
};
const faSpa = {
  prefix: 'fad',
  iconName: 'spa',
  icon: [
    576,
    512,
    [],
    'f5bb',
    [
      'M183.1 235.3c19.6-113 73.8-178.8 91.3-197.7C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6c17.5 18.8 71.8 84.7 91.3 197.7c-22 13.5-42.1 29.9-59.7 48.7c-8.8 9.4-17.1 19.3-24.6 29.8c-3.8 5.2-7.4 10.6-10.8 16.1c-1.7 2.7-3.4 5.5-5 8.3s-3.2 5.6-4.8 8.6c-24.5-46-60.9-84.5-104.9-111.6z',
      'M267.9 480l20.1 0 20.1 0C456.1 480 576 360.1 576 212.1c0-11.1-9-20.1-20.1-20.1l-9.9 0c-110.8 0-208.5 62-258 154.9C238.5 254 140.8 192 30 192l-9.9 0C9 192 0 201 0 212.1C0 360.1 119.9 480 267.9 480z',
    ],
  ],
};
const faArrowLeftFromLine = {
  prefix: 'fad',
  iconName: 'arrow-left-from-line',
  icon: [
    448,
    512,
    [8612, 'arrow-from-right'],
    'f344',
    [
      'M384 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224l66.7 0 112 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-112 0-66.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z',
    ],
  ],
};
const faArrowFromRight = faArrowLeftFromLine;
const faStrawberry = {
  prefix: 'fad',
  iconName: 'strawberry',
  icon: [
    512,
    512,
    [],
    'e32b',
    [
      'M0 336C0 464 48 512 176 512c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64C96.2 64 0 160 0 336zm71.5 28.4c0-7.5 3.9-17.4 11.7-25.2c11.9-11.9 28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7c-2-2-3-5.2-3-9.1zm35-86.9c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7zm32-96c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7zm0 256c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3c-7.8 7.8-17.7 11.7-25.2 11.7c-3.8 0-7.1-1-9.1-3zm32-96c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7zm32-96c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7zm32 160c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7zm32-96c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7zm64 64c-5.9-5.9-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7z',
      'M481.5 1.9c12.2 5.2 17.8 19.3 12.6 31.5c-13.4 31.2-36.9 59-56.3 78.7c32.8 1.8 57.4 18 68.2 26.6c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.5 400 44.3 400 80c0 .7 0 1.4 0 2.1c.7-.7 1.4-1.3 2-2c18.2-18.2 37.7-41.7 47.9-65.5c5.2-12.2 19.3-17.8 31.5-12.6zm-300 136.6c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm104.7-66.3c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm32-96c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-224-96c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-23.3 61.7c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7z',
    ],
  ],
};
const faLocationPinLock = {
  prefix: 'fad',
  iconName: 'location-pin-lock',
  icon: [
    512,
    512,
    [],
    'e51f',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5c11-13.8 25.1-31.7 40.3-52.3l0-94.8c0-23.7 12.9-44.4 32-55.4l0-24.6c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192zm256 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M368 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faPause = {
  prefix: 'fad',
  iconName: 'pause',
  icon: [
    320,
    512,
    [9208],
    'f04c',
    [
      'M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z',
      '',
    ],
  ],
};
const faClockEightThirty = {
  prefix: 'fad',
  iconName: 'clock-eight-thirty',
  icon: [
    512,
    512,
    [],
    'e346',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm140 77.3c-7.4-11-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7z',
      'M256 416c-13.3 0-24-10.7-24-24l0-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256l0 136c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faPlaneEngines = {
  prefix: 'fad',
  iconName: 'plane-engines',
  icon: [
    576,
    512,
    [9992, 'plane-alt'],
    'f3de',
    [
      'M166 20.5L216 192l152 0c-12.7-21.8-25.5-43.7-38.2-65.5c-12.1-20.8-24.3-41.6-36.4-62.5L265.3 15.9C259.5 6 249 0 237.6 0L181.3 0C170.7 0 163 10.2 166 20.5zm0 471c-3 10.2 4.7 20.5 15.4 20.5l56.3 0c11.4 0 21.9-6 27.6-15.9c9.4-16 18.7-32.1 28.1-48.1l36.4-62.5c12.7-21.8 25.5-43.7 38.2-65.5l-152 0L166 491.5z',
      'M576 256c0-35-59.5-64-93.7-64L112 192 68.8 134.4c-3-4-7.8-6.4-12.8-6.4l-42 0c-7.8 0-14 6.3-14 14c0 1.3 .2 2.6 .5 3.9l22.7 79.3C9.8 229 0 241.4 0 256s9.8 27 23.2 30.8L.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14l42 0c5 0 9.8-2.4 12.8-6.4L112 320l370.3 0c34.2 0 93.7-28 93.7-64zM329.8 126.5C342.7 122.3 352 110.3 352 96c0-17.7-14.3-32-32-32l-26.7 0 36.4 62.5zm0 259L293.3 448l26.7 0c17.7 0 32-14.3 32-32c0-14.3-9.3-26.3-22.2-30.5z',
    ],
  ],
};
const faPlaneAlt = faPlaneEngines;
const faHillAvalanche = {
  prefix: 'fad',
  iconName: 'hill-avalanche',
  icon: [
    576,
    512,
    [],
    'e507',
    [
      'M128 80c0 4 .5 7.9 1.4 11.6L439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c17.2-17.2 25.8-39.7 25.8-62.2s-8.6-45-25.8-62.2c-34.4-34.4-90.1-34.4-124.5 0l33.9 33.9c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48zM416 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M54.6 73.4c-9.2-9.2-22.9-11.9-34.9-6.9S0 83.1 0 96L0 480c0 17.7 14.3 32 32 32l384 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-384-384z',
    ],
  ],
};
const faTemperatureEmpty = {
  prefix: 'fad',
  iconName: 'temperature-empty',
  icon: [
    320,
    512,
    ['temperature-0', 'thermometer-0', 'thermometer-empty'],
    'f2cb',
    [
      'M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L272 112C272 50.2 221.9 0 160 0S48 50.2 48 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L112 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M112 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
    ],
  ],
};
const faTemperature0 = faTemperatureEmpty;
const faThermometer0 = faTemperatureEmpty;
const faThermometerEmpty = faTemperatureEmpty;
const faBomb = {
  prefix: 'fad',
  iconName: 'bomb',
  icon: [
    512,
    512,
    [128163],
    'f1e2',
    [
      'M352 79.7c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4 442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4z',
      'M281.4 105.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9zM96 296c0-57.4 46.6-104 104-104l8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0c-75.1 0-136 60.9-136 136l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8z',
    ],
  ],
};
const faGaugeLow = {
  prefix: 'fad',
  iconName: 'gauge-low',
  icon: [
    512,
    512,
    ['tachometer-alt-slow'],
    'f627',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16-104c0-.3 0-.6 0 0zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm112 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3z',
    ],
  ],
};
const faTachometerAltSlow = faGaugeLow;
const faRegistered = {
  prefix: 'fad',
  iconName: 'registered',
  icon: [
    512,
    512,
    [174],
    'f25d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l88 0c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8c-3.2 1.5-6.6 2.2-9.9 2.2c-9.1 0-17.8-5.2-21.9-14.1L268.9 288 208 288l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112zm48 24l0 64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0z',
      'M184 128c-13.3 0-24 10.7-24 24l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 60.9 0 37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80l-88 0zm88 112l-64 0 0-64 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z',
    ],
  ],
};
const faTrashCanPlus = {
  prefix: 'fad',
  iconName: 'trash-can-plus',
  icon: [
    448,
    512,
    [],
    'e2ac',
    [
      'M32 96l0 352c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352L32 96zm80 192c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM200 376l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
    ],
  ],
};
const faAddressCard = {
  prefix: 'fad',
  iconName: 'address-card',
  icon: [
    576,
    512,
    [62140, 'contact-card', 'vcard'],
    'f2bb',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM64 368c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16zM240 192a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm112-16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
      'M176 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z',
    ],
  ],
};
const faContactCard = faAddressCard;
const faVcard = faAddressCard;
const faChartFft = {
  prefix: 'fad',
  iconName: 'chart-fft',
  icon: [
    512,
    512,
    [],
    'e69e',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M254.1 64.1c12.8-.8 24.8 6.2 30.6 17.6L339.8 192l60.2 0c12.1 0 23.2 6.8 28.6 17.7l48 96c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L380.2 256 320 256c-12.1 0-23.2-6.8-28.6-17.7l-30.5-60.9L206.1 330.8C201.6 343.5 189.5 352 176 352l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l25.4 0L225.9 85.2c4.3-12.1 15.4-20.4 28.2-21.2z',
    ],
  ],
};
const faScaleUnbalancedFlip = {
  prefix: 'fad',
  iconName: 'scale-unbalanced-flip',
  icon: [
    640,
    512,
    ['balance-scale-right'],
    'f516',
    [
      'M96 480c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-326.7c5.1-2.2 9.9-5 14.4-8.2l135.5 45.2c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L399.5 88.8c.3-2.9 .5-5.8 .5-8.8c0-44.2-35.8-80-80-80c-29.3 0-55 15.8-68.9 39.3L138.1 1.6c-16.8-5.6-34.9 3.5-40.5 20.2s3.5 34.9 20.2 40.5l125.9 42c7 22 23.3 39.9 44.2 49L288 448l-160 0c-17.7 0-32 14.3-32 32z',
      'M128 163.8L55.6 288l144.9 0L128 163.8zM254 305.1C243.2 350 190.9 384 128 384S12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1zm256.9-13.3L438.4 416l144.9 0L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z',
    ],
  ],
};
const faBalanceScaleRight = faScaleUnbalancedFlip;
const faGlobeSnow = {
  prefix: 'fad',
  iconName: 'globe-snow',
  icon: [
    448,
    512,
    [],
    'f7a3',
    [
      'M0 224c0 71.4 33.4 135 85.4 176L192 400l0-48-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L185.4 256 160 256c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-25.4 0 68.7 68.7c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-64 0 0 48 106.6 0c52-41 85.4-104.6 85.4-176C448 100.3 347.7 0 224 0S0 100.3 0 224zm96-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM256 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm96 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M235.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l25.4 0-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0 0 48L85.4 400 21.7 473.4c-3.7 4.2-5.7 9.7-5.7 15.3C16 501.6 26.4 512 39.3 512l369.4 0c12.9 0 23.3-10.4 23.3-23.3c0-5.6-2-11-5.7-15.3L362.6 400 256 400l0-48 64 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256l25.4 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64z',
    ],
  ],
};
const faSubscript = {
  prefix: 'fad',
  iconName: 'subscript',
  icon: [
    512,
    512,
    [],
    'f12c',
    [
      'M0 96C0 78.3 14.3 64 32 64l32 0c10.4 0 20.2 5.1 26.2 13.6L176 200.2 261.8 77.6c6-8.6 15.8-13.6 26.2-13.6l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-15.3 0L215.1 256l89.6 128 15.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-10.4 0-20.2-5.1-26.2-13.6L176 311.8 90.2 434.4C84.2 442.9 74.4 448 64 448l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l15.3 0 89.6-128L47.3 128 32 128C14.3 128 0 113.7 0 96z',
      'M464.8 292.8c9.4 5.8 15.2 16.1 15.2 27.2l0 128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-80c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l32-16c9.9-5 21.7-4.4 31.1 1.4z',
    ],
  ],
};
const faDiamondTurnRight = {
  prefix: 'fad',
  iconName: 'diamond-turn-right',
  icon: [
    512,
    512,
    ['directions'],
    'f5eb',
    [
      'M0 256c0 10.2 3.9 20.5 11.7 28.3l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216C276.5 3.9 266.2 0 256 0s-20.5 3.9-28.3 11.7l-216 216C3.9 235.5 0 245.8 0 256zm160 24c0-35.3 28.7-64 64-64l64 0 0-56c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-56-64 0c-8.8 0-16 7.2-16 16l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48z',
      'M297.9 145.2c6-2.5 12.9-1.1 17.4 3.5l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-56-64 0c-8.8 0-16 7.2-16 16l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-35.3 28.7-64 64-64l64 0 0-56c0-6.5 3.9-12.3 9.9-14.8z',
    ],
  ],
};
const faDirections = faDiamondTurnRight;
const faIntegral = {
  prefix: 'fad',
  iconName: 'integral',
  icon: [
    320,
    512,
    [],
    'f667',
    [
      'M216 64c-13.3 0-24 10.7-24 24l0 336c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-8c0-17.7 14.3-32 32-32s32 14.3 32 32l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-48.6 39.4-88 88-88s88 39.4 88 88l0 8c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-8c0-13.3-10.7-24-24-24z',
      '',
    ],
  ],
};
const faBurst = {
  prefix: 'fad',
  iconName: 'burst',
  icon: [
    512,
    512,
    [],
    'e4dc',
    [
      'M0 256c0 10.4 6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256zM96 96l130.9 89.8L256 96l29.1 89.8 64.7-23.6-23.6 64.7L416 256l-89.8 29.1 45.6 86.8-86.8-45.6L256 416l-29.1-89.8-86.8 45.6 45.6-86.8L96 256l89.8-29.1L96 96z',
      'M256 96l29.1 89.8 64.7-23.6-23.6 64.7L416 256l-89.8 29.1 45.6 86.8-86.8-45.6L256 416l-29.1-89.8-86.8 45.6 45.6-86.8L96 256l89.8-29.1L96 96l130.9 89.8L256 96z',
    ],
  ],
};
const faHouseLaptop = {
  prefix: 'fad',
  iconName: 'house-laptop',
  icon: [
    640,
    512,
    ['laptop-house'],
    'e066',
    [
      'M2.2 235.7C7 247.9 18.8 256 32 256l32 0 0 112c0 26.5 21.5 48 48 48l160 0 0-128-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 37.7c11.7-13.3 28.9-21.7 48-21.7l144 0c0-8.8-3.6-17.3-10.3-23.5l-208-192C255.6 2.8 247.8 0 240 0s-15.6 2.8-21.7 8.5l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2z',
      'M352 448l192 0 0-144-192 0 0 144zm-48 0l0-160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 160 32 0c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48l-48 0-192 0-48 0c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l32 0z',
    ],
  ],
};
const faLaptopHouse = faHouseLaptop;
const faFaceTired = {
  prefix: 'fad',
  iconName: 'face-tired',
  icon: [
    512,
    512,
    [128555, 'tired'],
    'f5c8',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5c30 16 59.9 32 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8c-30 16-59.9 32-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6c12-14.4 24-28.8 36-43.2l-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zM128 400c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3l-3.2 0c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2zM288.6 194.6c30-16 59.9-32 89.9-47.9c1.8-1 3.7-1.4 5.6-1.4c6.2 0 11.9 5 11.9 11.9c0 2.8-1 5.5-2.8 7.6c-12 14.4-24 28.8-36 43.2c12 14.4 24 28.8 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5c-30-16-59.9-32-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8z',
      'M116 157.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
    ],
  ],
};
const faTired = faFaceTired;
const faMoneyBills = {
  prefix: 'fad',
  iconName: 'money-bills',
  icon: [
    640,
    512,
    [],
    'e1f3',
    [
      'M0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240c0-13.3-10.7-24-24-24S0 106.7 0 120zm160 40l0 96c35.3 0 64 28.7 64 64l288 0c0-35.3 28.7-64 64-64l0-96c-35.3 0-64-28.7-64-64L224 96c0 35.3-28.7 64-64 64zm288 48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
      'M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM512 96c0 35.3 28.7 64 64 64l0 96c-35.3 0-64 28.7-64 64l-288 0c0-35.3-28.7-64-64-64l0-96c35.3 0 64-28.7 64-64l288 0z',
    ],
  ],
};
const faBlindsRaised = {
  prefix: 'fad',
  iconName: 'blinds-raised',
  icon: [
    512,
    512,
    [],
    'f8fd',
    [
      'M0 107.6c0-2.4 .4-4.7 1.2-7L16.1 59.8C20.8 62.5 26.2 64 32 64l96 0 0 64L20.4 128C9.1 128 0 118.9 0 107.6zm0 96.3c0-2.6 .5-5.1 1.4-7.5L16 160l112 0 0 64L20.1 224C9 224 0 215 0 203.9zM160 64l320 0c5.8 0 11.2-1.5 15.9-4.2l14.9 40.9c.8 2.2 1.2 4.6 1.2 7c0 11.3-9.1 20.4-20.4 20.4L160 128l0-64zm0 96l336 0 14.6 36.4c1 2.4 1.4 4.9 1.4 7.5c0 11.1-9 20.1-20.1 20.1L160 224l0-64z',
      'M0 32C0 14.3 14.3 0 32 0L480 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L160 64l0 354.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L128 64 32 64C14.3 64 0 49.7 0 32z',
    ],
  ],
};
const faSmog = {
  prefix: 'fad',
  iconName: 'smog',
  icon: [
    640,
    512,
    [],
    'f75f',
    [
      'M0 488c0 13.3 10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24zm72-96c0 13.3 10.7 24 24 24l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 368c-13.3 0-24 10.7-24 24zm184 0c0 13.3 10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-336 0c-13.3 0-24 10.7-24 24zm160 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z',
      'M176 288C96.5 288 32 223.5 32 144S96.5 0 176 0c34.5 0 66.1 12.1 90.9 32.3C289.6 12.2 319.4 0 352 0c49.1 0 91.8 27.7 113.2 68.3C475 65.5 485.3 64 496 64c61.9 0 112 50.1 112 112s-50.1 112-112 112l-27.3 0c-22.6 19.9-52.2 32-84.7 32s-62.1-12.1-84.7-32L176 288z',
    ],
  ],
};
const faUfoBeam = {
  prefix: 'fad',
  iconName: 'ufo-beam',
  icon: [
    576,
    512,
    [],
    'e048',
    [
      'M2.3 477.7l89-187.9c14.2 5.2 29.9 9.8 46.6 13.8L45.7 498.3C41.6 506.9 33 512 24 512c-3.4 0-6.9-.7-10.3-2.3c-12-5.7-17.1-20-11.4-32zM144 138.7c0-9.3 1-18.8 2.9-28.3C158.5 54.5 204.4 0 288 0s129.5 54.5 141.1 110.3c2 9.5 2.9 19 2.9 28.3c0 0-33.2 53.3-144 53.3s-144-53.3-144-53.3zM438.1 303.6c16.7-4 32.3-8.6 46.6-13.8l89 187.9c1.6 3.3 2.3 6.8 2.3 10.3c0 9-5.1 17.6-13.7 21.7c-3.3 1.6-6.8 2.3-10.3 2.3c-9 0-17.6-5.1-21.7-13.7L438.1 303.6z',
      'M288 192c110.8 0 144-53.3 144-53.3c0-9.3-1-18.8-2.9-28.3C516.8 129.5 576 166.1 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41.9 59.2-78.5 146.9-97.7c-2 9.5-2.9 19-2.9 28.3c0 0 33.2 53.3 144 53.3zM120 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faHydra = {
  prefix: 'fad',
  iconName: 'hydra',
  icon: [
    640,
    512,
    [],
    'e686',
    [
      'M0 320c0 70.7 57.3 128 128 128l32 0 0 32c0 17.7 14.3 32 32 32l36.9 0c15.6 0 29-11.3 31.6-26.7l6.2-37.3 74.7 0 6.2 37.3c2.6 15.4 15.9 26.7 31.6 26.7l36.9 0c17.7 0 32-14.3 32-32l0-37.8c55.6-16.8 96-68.4 96-129.4l0-24.8 0-16c0-8.8 7.2-16 16-16l48 0c13.6 0 25.7-8.6 30.2-21.4s.4-27.1-10.2-35.6l-34-27.2c-7.3-5.8-15.6-10.1-24.6-12.7c-34.2-9.8-68.3 7.5-82.5 37l4.5 45.2c3.3 33.3-8.5 66.3-32.1 89.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c16.9-16.9 25.3-40.4 22.9-64.1l-11.5-115-.1-.8 0-.8c0-5.3 0-10.7 0-16c0-8.8 7.2-16 16-16l48 0c13.6 0 25.7-8.6 30.2-21.4s.4-27.1-10.2-35.6L503.3 16.1C490.3 5.7 474.1 0 457.5 0C416.9 0 384 32.9 384 73.5l0 38.5 0 16 0 34.9c0 6.3-.6 12.5-1.8 18.4C375.4 215 350.5 242.1 318 252c-8.6 2.6-17.7 4-27.1 4l-9.2 0c-46.7 0-90.4 23.4-116.3 62.2l-10.7 16.1c-7.4 11-19.7 17.7-33 17.7c-32.1 0-50.9-36.1-32.5-62.4L121.8 243c1.4-1.8 2.5-3.8 3.4-5.8c2-4.4 2.9-9 2.8-13.6s-1.1-9.2-3.2-13.5c-1.6-3.3-3.8-6.3-6.5-9c-2.7-2.6-5.8-4.7-9.1-6.2c-4.4-2-9-2.9-13.6-2.8s-9.2 1.1-13.5 3.2c-2 1-3.9 2.2-5.7 3.6l-25 18.8C19 241.8 0 279.7 0 320z',
      'M318 252c32.5-9.9 57.4-37 64.2-70.7l-19.9-59.7C350.8 87.2 318.6 64 282.3 64c-19.1 0-37.7 6.5-52.6 18.5L204 103c-10.6 8.5-14.7 22.8-10.2 35.6s16.6 21.4 30.2 21.4l58.5 0c7.3 0 13.7 5 15.5 12.1L318 252z',
    ],
  ],
};
const faCircleCaretUp = {
  prefix: 'fad',
  iconName: 'circle-caret-up',
  icon: [
    512,
    512,
    ['caret-circle-up'],
    'f331',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 24c0-5.9 2.2-11.8 6.4-16.3l104-112c4.5-4.9 10.9-7.7 17.6-7.7s13 2.8 17.6 7.7l104 112c4.2 4.5 6.4 10.4 6.4 16.3c0 3.2-.7 6.5-2 9.6c-3.8 8.7-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4c-1.3-3.1-2-6.3-2-9.6z',
      'M273.6 151.7c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4l208 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z',
    ],
  ],
};
const faCaretCircleUp = faCircleCaretUp;
const faUserVneckHairLong = {
  prefix: 'fad',
  iconName: 'user-vneck-hair-long',
  icon: [
    448,
    512,
    [],
    'e463',
    [
      'M128 112c0 10.7 0 21.3 0 32c0 53 43 96 96 96s96-43 96-96l0-16 0-32c-2.7 0-5.3 0-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112c-16 0-32 0-48 0z',
      'M176 112l-48 0s0 0 0 0l0 32c0 53 43 96 96 96s96-43 96-96l0-16s0 0 0 0l0-32-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112zm48 160L70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11s0 0 0 0C96 57.3 153.3 0 224 0c70.6 0 127.8 57.1 128 127.6l0 .8 0 .2 0 10.3c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272zm-78.1 42.9L210.7 412c6.3 9.5 20.3 9.5 26.6 0l64.8-97.1c3.5-5.2 9.8-8 15.9-6.6c74.5 17.2 130 84 130 163.7l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-79.7 55.5-146.5 130-163.7c6.1-1.4 12.4 1.4 15.9 6.6z',
    ],
  ],
};
const faSquareALock = {
  prefix: 'fad',
  iconName: 'square-a-lock',
  icon: [
    576,
    512,
    [],
    'e44d',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 65.1c-54.3 7.8-96 54.4-96 110.9l0 24.6c-9.9 5.7-18.1 14-23.8 24L245.8 141.9c-3.9-8.5-12.4-13.9-21.8-13.9s-17.9 5.4-21.8 13.9l-96 208c-5.6 12-.3 26.3 11.7 31.8s26.3 .3 31.8-11.7l12-26.1 124.4 0 12 26.1c4 8.8 12.7 13.9 21.8 13.9l0 96L64 480c-35.3 0-64-28.7-64-64L0 96zM184 296l40-86.7L264 296l-80 0z',
      'M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faCrutch = {
  prefix: 'fad',
  iconName: 'crutch',
  icon: [
    512,
    512,
    [],
    'f7f7',
    [
      'M297.4 9.4C303.6 3.1 311.8 0 320 0s16.4 3.1 22.6 9.4l160 160c6.2 6.2 9.4 14.4 9.4 22.6s-3.1 16.4-9.4 22.6s-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4l-1.4-1.4L410.7 168c-22.3-22.2-44.5-44.5-66.7-66.7C328.9 86.2 313.8 71.1 298.7 56l-1.4-1.4c-12.5-12.5-12.5-32.8 0-45.3z',
      'M201.4 153.4L298.7 56 344 101.3 269.3 176 336 242.7 410.7 168 456 213.3l-97.3 97.3c0 0-.1 .1-.1 .1s-.1 .1-.1 .1l-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8L169.1 395.2c-5.9 1.3-11.4 4.3-15.7 8.6L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1l34.8-34.8zM224 221.3l-12.2 12.2c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6L290.7 288 224 221.3z',
    ],
  ],
};
const faGasPumpSlash = {
  prefix: 'fad',
  iconName: 'gas-pump-slash',
  icon: [
    640,
    512,
    [],
    'f5f4',
    [
      'M64 480c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 448c-17.7 0-32 14.3-32 32zM96 171.6L96 416l288 0 0-17.5L96 171.6zM97.3 51L384 275.7 384 64c0-35.3-28.7-64-64-64L160 0c-30.9 0-56.7 21.9-62.7 51zM448 32c-8.8 8.8-8.8 23.2 0 32l32 32 0 64c0 29.8 20.4 54.9 48 62l0 138c0 8.5-2.7 16.4-7.2 22.9c12.6 9.9 25.2 19.8 37.8 29.6C569.5 397.9 576 379.7 576 360l0-136 0-32 0-24 0-13.5c0-17-6.7-33.3-18.7-45.3L480 32c-8.8-8.8-23.2-8.8-32 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faFontAwesome = {
  prefix: 'fad',
  iconName: 'font-awesome',
  icon: [
    512,
    512,
    [62501, 62694, 'font-awesome-flag', 'font-awesome-logo-full'],
    'f2b4',
    [
      'M96 96l0 352 373.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L96 96z',
      'M96 93c12.2-9.5 20-24.3 20-41C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 419 64 0L96 93z',
    ],
  ],
};
const faFontAwesomeFlag = faFontAwesome;
const faFontAwesomeLogoFull = faFontAwesome;
const faCloudArrowUp = {
  prefix: 'fad',
  iconName: 'cloud-arrow-up',
  icon: [
    640,
    512,
    [62338, 'cloud-upload', 'cloud-upload-alt'],
    'f0ee',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm216-56c0-6.1 2.3-12.3 7-17l80-80c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l80 80c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-33.9 0l-39-39L344 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-134.1-39 39c-9.4 9.4-24.6 9.4-33.9 0c-4.7-4.7-7-10.8-7-17z',
      'M223 297c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L344 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-134.1-39 39c-9.4 9.4-24.6 9.4-33.9 0z',
    ],
  ],
};
const faCloudUpload = faCloudArrowUp;
const faCloudUploadAlt = faCloudArrowUp;
const faPalette = {
  prefix: 'fad',
  iconName: 'palette',
  icon: [
    512,
    512,
    [127912],
    'f53f',
    [
      'M0 256C0 397.4 114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-96 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faTransporter4 = {
  prefix: 'fad',
  iconName: 'transporter-4',
  icon: [
    512,
    512,
    [],
    'e2a5',
    [
      'M0 400c0 4.1 2.7 7.6 6.6 8.7L32 416l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 416l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 384l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 384 6.6 391.3C2.7 392.4 0 395.9 0 400zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm32-64c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm32-64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 192c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM208 16c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm208 96c0 4.1 2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M128 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0z',
    ],
  ],
};
const faChartMixedUpCircleCurrency = {
  prefix: 'fad',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [
    576,
    512,
    [],
    'e5d8',
    [
      'M0 224c0 7 2.3 14.1 7 20c11 13.8 31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105l0 39c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112c0-17.7-14.3-32-32-32L400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.8 0L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-7.9 6.3-12 15.6-12 25zM32 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z',
    ],
  ],
};
const faObjectsAlignRight = {
  prefix: 'fad',
  iconName: 'objects-align-right',
  icon: [
    512,
    512,
    [],
    'e3bf',
    [
      'M0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112zM128 336l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48z',
      'M488 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faArrowsTurnRight = {
  prefix: 'fad',
  iconName: 'arrows-turn-right',
  icon: [
    448,
    512,
    [],
    'e4c0',
    [
      'M0 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-17.7 14.3-32 32-32l146.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-96-96c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L242.7 352 96 352c-53 0-96 43-96 96z',
      'M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 128 96C57.3 96 0 153.3 0 224l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-35.3 28.7-64 64-64l210.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96z',
    ],
  ],
};
const faVest = {
  prefix: 'fad',
  iconName: 'vest',
  icon: [
    448,
    512,
    [],
    'e085',
    [
      'M48 416c0 4.1 1.6 8.2 4.7 11.3s7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-48 48c-3.1 3.1-4.7 7.2-4.7 11.3zM117.1 0c6.6 .3 12.4 4.6 14.6 10.9c6.5 19.6 13.1 39.2 19.6 58.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3l19.6-58.7c.1-.4 .3-.8 .4-1.2s.3-.8 .5-1.1c.4-.7 .8-1.4 1.3-2.1c.9-1.3 2.1-2.4 3.3-3.4c2.5-1.9 5.7-3.1 9-3.2c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0zM324.7 356.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7s4.7-7.2 4.7-11.3s-1.6-8.2-4.7-11.3l-48-48c-6.2-6.2-16.4-6.2-22.6 0z',
      'M131.6 10.9C129.5 4.4 123.4 0 116.5 0L112 0C85.5 0 64 21.5 64 48l0 97.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5L0 464c0 26.5 21.5 48 48 48l128 0c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464l0-168.2c0-8.6 1.4-17.1 4.1-25.3l11-33.1L131.6 10.9zM224 295.8L224 464c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-193.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6L384 48c0-26.5-21.5-48-48-48l-4.5 0c-6.9 0-13 4.4-15.2 10.9L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2zm123.3 60.9l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-246.6 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48z',
    ],
  ],
};
const faPig = {
  prefix: 'fad',
  iconName: 'pig',
  icon: [
    640,
    512,
    [128022],
    'f706',
    [
      'M80 240c0-11 1.1-21.7 3.2-32C98 135 162.6 80 240 80l122.4 0c14.5 0 28.8 1.3 42.7 3.9c8.1-19.5 25.4-34.4 47-39.1l58.4-12.5c1-.2 2-.3 3-.3c8 0 14.5 6.5 14.5 14.5L528 78c0 19.7-9 37.8-23.6 49.7c6.4 4.9 12.7 10.1 18.6 15.7c17.6-15.9 28.5-38.6 29-63.3l40 0c8.8 0 16 7.2 16 16l0 16c0 32.8-24.6 59.8-56.3 63.5l6.8 9C570 200 585 212.5 602.2 221.1L608 224l8 0c13.3 0 24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-43.5 0c-22.2 21.2-49.7 36.2-79.8 43.3l-13 45.5C475.8 470.5 463.3 480 449 480l-33 0c-17.7 0-32-14.3-32-32l0-32-64 0-48 0 0 32c0 17.7-14.3 32-32 32l-33 0c-14.3 0-26.8-9.5-30.8-23.2L155 382.4C110.3 358 80 310.5 80 256l0-16zm376-4a20 20 0 1 0 40 0 20 20 0 1 0 -40 0z',
      'M80 240c0-11 1.1-21.7 3.2-32l-35.8 0c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240L80 240zm396 16a20 20 0 1 0 0-40 20 20 0 1 0 0 40z',
    ],
  ],
};
const faInboxFull = {
  prefix: 'fad',
  iconName: 'inbox-full',
  icon: [
    512,
    512,
    [],
    'e1ba',
    [
      'M73 288l51.2 0c12.1 0 23.2 6.8 28.6 17.7c4.8 9.5 9.5 19.1 14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l51.2 0L391 96 121 96c-16 64-32 128-48 192zm55-48c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm32-80c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
      'M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-92.1c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32L121 32zm0 64l270 0 48 192-51.2 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L73 288 121 96z',
    ],
  ],
};
const faCircleEnvelope = {
  prefix: 'fad',
  iconName: 'circle-envelope',
  icon: [
    512,
    512,
    ['envelope-circle'],
    'e10c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 9.3L264.7 255.6c-2.7 1.2-5.7 1.9-8.7 1.9s-5.9-.6-8.7-1.9L128 201.3l0-9.3zm0 44.5l106.1 48.3c6.9 3.1 14.4 4.8 21.9 4.8s15-1.6 21.9-4.8L384 236.5l0 83.5c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-83.5z',
      'M160 160c-17.7 0-32 14.3-32 32l0 9.3 119.3 54.3c2.7 1.2 5.7 1.9 8.7 1.9s5.9-.6 8.7-1.9L384 201.3l0-9.3c0-17.7-14.3-32-32-32l-192 0zm224 76.5L277.9 284.7c-6.9 3.1-14.3 4.8-21.9 4.8s-15-1.6-21.9-4.8L128 236.5l0 83.5c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-83.5z',
    ],
  ],
};
const faEnvelopeCircle = faCircleEnvelope;
const faTrianglePersonDigging = {
  prefix: 'fad',
  iconName: 'triangle-person-digging',
  icon: [
    640,
    512,
    ['construction'],
    'f85d',
    [
      'M69.5 419.8c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480l432 0c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368zm107.9-26.2c10.7-24 21.3-48 32-72c2.5-5.6 5-11.2 7.5-16.8l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-23.1-40.9-25.5-24.5 55.2c-2.7 6-8.5 9.5-14.6 9.5c-2.2 0-4.4-.4-6.5-1.4c-8.1-3.6-11.7-13-8.1-21.1zm47-125.9c-1-4.3-.2-8.8 2.3-12.5c1.4-2.1 2.8-4.2 4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1l-96 0c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2zM336 184a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40.8 74.9l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1l-96 0c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zm-96.3 55.5l64 40c4.7 2.9 7.5 8.1 7.5 13.6l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-23.1-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8 15.6 9.8z',
    ],
  ],
};
const faConstruction = faTrianglePersonDigging;
const faFerry = {
  prefix: 'fad',
  iconName: 'ferry',
  icon: [
    576,
    512,
    [],
    'e4ea',
    [
      'M0 480c0 2.4 .3 4.8 .8 7.3C4.3 502 17.4 512 32 512c2.4 0 4.8-.3 7.3-.8c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c2.4 .6 4.9 .8 7.3 .8c14.5 0 27.7-10 31.1-24.7c4-17.2-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-5.9-5-13.3-7.6-20.7-7.6c-6.5 0-12.9 2-18.5 5.9C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1C109 418 102.5 416 96 416c-7.4 0-14.8 2.6-20.7 7.6c-14.4 11.9-32.5 21-50.6 25.2C10 452.3 0 465.4 0 480z',
      'M192 32l-75.1 0C96.3 32 85.3 56.3 98.8 71.8L120 96l336 0 21.2-24.2C490.8 56.3 479.7 32 459.1 32L384 32c0-17.7-14.3-32-32-32L224 0c-17.7 0-32 14.3-32 32zm288 96L96 128c-17.7 0-32 14.3-32 32l0 123.5c0 13.3 4.2 26.3 11.9 37.2l51.4 71.9c1.9 1.1 3.8 2.2 5.6 3.5c15.5 10.7 34 18 51 19.9l16.6 0c18.2-1.9 35.8-9.7 50.6-19.9c22.1-15.5 51.6-15.5 73.7 0c15.8 10.9 33.7 18.1 50.8 19.9l16.5 0c17-1.8 35.6-9.2 51-19.9c1.8-1.3 3.6-2.4 5.5-3.5l51.4-71.9c7.8-10.9 11.9-23.9 11.9-37.2L512 160c0-17.7-14.3-32-32-32zm-32 64l0 96-320 0 0-96 320 0z',
    ],
  ],
};
const faBullseyeArrow = {
  prefix: 'fad',
  iconName: 'bullseye-arrow',
  icon: [
    512,
    512,
    [127919],
    'f648',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3c1.8 10.4 2.7 21.1 2.7 32.1c0 106-86 192-192 192S64 362 64 256S150 64 256 64c10.9 0 21.6 .9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256zm112 0c0 79.5 64.5 144 144 144s144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2c.5 3.7 .8 7.5 .8 11.3c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c3.8 0 7.6 .3 11.3 .8l31.2-31.2L293.7 117c-12-3.3-24.7-5-37.7-5c-79.5 0-144 64.5-144 144z',
      'M331.2 146.9l-8.4-50.7c-1.7-10.2 1.6-20.6 8.9-27.9l51.2-51.2C391 9 404.7 11.9 409 22.5L432 80l57.5 23c10.7 4.3 13.5 18 5.4 26.2l-51.2 51.2c-7.3 7.3-17.7 10.6-27.9 8.9l-50.7-8.4L273 273c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l92.1-92.1z',
    ],
  ],
};
const faArrowsDownToPeople = {
  prefix: 'fad',
  iconName: 'arrows-down-to-people',
  icon: [
    640,
    512,
    [],
    'e4b9',
    [
      'M18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5 88 480c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5l0 54.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-54.5 26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5l0 38.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8c8.1-4.3 12.6-12.6 12.6-21.2c0-3.8-.9-7.7-2.9-11.4l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6zM104 296a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176-96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176 96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M144 0c-13.3 0-24 10.7-24 24l0 118.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23L168 24c0-13.3-10.7-24-24-24zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23L520 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z',
    ],
  ],
};
const faSeedling = {
  prefix: 'fad',
  iconName: 'seedling',
  icon: [
    512,
    512,
    [127793, 'sprout'],
    'f4d8',
    [
      'M237.7 146.6c25.1 30.7 42.1 68.3 48 109.4l2.3 0c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32L448 0C351.5 0 269.2 61 237.7 146.6z',
      'M32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-32C288 164.3 187.7 64 64 64L32 64z',
    ],
  ],
};
const faSprout = faSeedling;
const faClockSeven = {
  prefix: 'fad',
  iconName: 'clock-seven',
  icon: [
    512,
    512,
    [],
    'e350',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm172 82.7l60-90L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 4.7-1.4 9.4-4 13.3l-64 96c-4.6 6.9-12.2 10.7-20 10.7c-4.6 0-9.2-1.3-13.3-4c-11-7.4-14-22.3-6.7-33.3z',
      'M256 96c-13.3 0-24 10.7-24 24l0 128.7-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3l0-136c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faLeftRight = {
  prefix: 'fad',
  iconName: 'left-right',
  icon: [
    512,
    512,
    [8596, 'arrows-alt-h'],
    'f337',
    [
      'M256 208c0 32 0 64 0 96l96 0 0 56c0 9.5 5.7 18.2 14.4 22c3.1 1.3 6.3 2 9.6 2c5.9 0 11.8-2.2 16.3-6.4l112-104c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-96 0z',
      'M0 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 56 96 0 0 96-96 0 0 56c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104C2.8 269 0 262.7 0 256z',
    ],
  ],
};
const faArrowsAltH = faLeftRight;
const faBoxesPacking = {
  prefix: 'fad',
  iconName: 'boxes-packing',
  icon: [
    640,
    512,
    [],
    'e4c7',
    [
      'M256 48l0 80 112 0c26.5 0 48 21.5 48 48l0 32c0 20.9-13.4 38.7-32 45.3L384 496c0 5.6-1 11-2.7 16L592 512c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L304 0c-26.5 0-48 21.5-48 48zM420.7 324.7l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 310.6 512 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-121.4-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z',
      'M16 160l352 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 224c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm16 96l320 0 0 224c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-224zm96 80c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faCircleArrowLeft = {
  prefix: 'fad',
  iconName: 'circle-arrow-left',
  icon: [
    512,
    512,
    ['arrow-circle-left'],
    'f0a8',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112 0c0-6.1 2.3-12.3 7-17L231 127c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L119 273c-4.7-4.7-7-10.8-7-17z',
      'M119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273z',
    ],
  ],
};
const faArrowCircleLeft = faCircleArrowLeft;
const faFlashlight = {
  prefix: 'fad',
  iconName: 'flashlight',
  icon: [
    640,
    512,
    [128294],
    'f8b8',
    [
      'M0 208l0 96c0 26.5 21.5 48 48 48l336 0s80 64 192 64l0-320c-112 0-192 64-192 64L48 160c-26.5 0-48 21.5-48 48zm224 48c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32z',
      'M608 96l-32 0 0 320 32 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM256 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
    ],
  ],
};
const faFileJpg = {
  prefix: 'fad',
  iconName: 'file-jpg',
  icon: [
    512,
    512,
    [],
    'e646',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM208 512c26.5 0 48-21.5 48-48l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 26.5 21.5 48 48 48zm96-160c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm80-40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40z',
    ],
  ],
};
const faGroupArrowsRotate = {
  prefix: 'fad',
  iconName: 'group-arrows-rotate',
  icon: [
    512,
    512,
    [],
    'e4f6',
    [
      'M9.3 320c0-13.8 9-26.5 22.9-30.7c16.9-5 34.8 4.6 39.8 21.5c4.3 14.6 10.4 28.5 17.9 41.4c2-.2 4.1-.3 6.2-.3c35.3 0 64 28.7 64 64c0 2.1-.1 4.1-.3 6.2c12.9 7.5 26.8 13.6 41.4 17.9c16.9 5 26.6 22.9 21.5 39.8c-4.1 13.9-16.9 22.9-30.7 22.9c-3 0-6.1-.4-9.1-1.3c-21.5-6.4-41.8-15.5-60.6-27c-8 3.6-16.9 5.6-26.3 5.6c-35.3 0-64-28.7-64-64c0-9.4 2-18.3 5.6-26.3c-11.5-18.7-20.6-39-27-60.6c-.9-3-1.3-6.1-1.3-9.1zm1.3-137.1c6.4-21.5 15.5-41.8 27-60.6C34 114.3 32 105.4 32 96c0-35.3 28.7-64 64-64c9.4 0 18.3 2 26.3 5.6c18.7-11.5 39-20.6 60.6-27c3-.9 6.1-1.3 9.1-1.3c13.8 0 26.5 9 30.7 22.9c5 16.9-4.6 34.8-21.5 39.8c-14.6 4.3-28.5 10.4-41.4 17.9c.2 2 .3 4.1 .3 6.1c0 35.3-28.7 64-64 64c-2.1 0-4.1-.1-6.1-.3c-7.5 12.9-13.6 26.8-17.9 41.4c-5 16.9-22.9 26.6-39.8 21.5s-26.6-22.9-21.5-39.8zM289.3 32.2c5-16.9 22.9-26.6 39.8-21.5c21.5 6.4 41.8 15.5 60.6 27c8-3.6 16.9-5.6 26.3-5.6c35.3 0 64 28.7 64 64c0 9.4-2 18.3-5.6 26.3c11.5 18.7 20.6 39 27 60.6c5 16.9-4.6 34.8-21.5 39.8s-34.8-4.6-39.8-21.5c-4.3-14.6-10.4-28.5-17.9-41.4c-2 .2-4.1 .3-6.2 .3c-35.3 0-64-28.7-64-64c0-2.1 .1-4.1 .3-6.1c-12.9-7.5-26.8-13.6-41.4-17.9c-16.9-5-26.6-22.9-21.5-39.8zm0 447.7c-5-16.9 4.6-34.8 21.5-39.8c14.6-4.3 28.5-10.4 41.4-17.9c-.2-2-.3-4.1-.3-6.2c0-35.3 28.7-64 64-64c2.1 0 4.1 .1 6.2 .3c7.5-12.9 13.6-26.8 17.9-41.4c5-16.9 22.9-26.6 39.8-21.5s26.6 22.9 21.5 39.8c-6.4 21.5-15.5 41.8-27 60.6c3.6 8 5.6 16.9 5.6 26.3c0 35.3-28.7 64-64 64c-9.4 0-18.3-2-26.3-5.6c-18.7 11.5-39 20.6-60.6 27c-3 .9-6.1 1.3-9.1 1.3c-13.8 0-26.5-9-30.7-22.9z',
      'M227.7 313.8c11.8 6 16.5 20.5 10.4 32.3s-20.5 16.5-32.3 10.4c-36.2-18.5-61.1-56.2-61.1-99.8c0-28.9 11-55.2 28.9-75.1l-11.2-11.2c-6.6-6.6-1.9-17.8 7.4-17.8l60.5 0c5.7 0 10.4 4.7 10.4 10.4l0 60.5c0 9.3-11.2 13.9-17.8 7.4l-15.3-15.3c-9.3 11.1-14.9 25.4-14.9 41.1c0 24.8 14.1 46.4 34.9 57zm93.1-58.6c0-24.8-14.1-46.4-34.9-57c-11.8-6-16.5-20.5-10.4-32.3s20.5-16.5 32.3-10.4c36.2 18.5 61.1 56.2 61.1 99.8c0 28.9-11 55.2-28.9 75.1L351 341.5c6.6 6.6 1.9 17.8-7.4 17.8l-60.5 0c-5.7 0-10.4-4.7-10.4-10.4l0-60.5c0-9.3 11.2-13.9 17.8-7.4l15.3 15.3c9.3-11.1 14.9-25.4 14.9-41.1z',
    ],
  ],
};
const faBowlFood = {
  prefix: 'fad',
  iconName: 'bowl-food',
  icon: [
    512,
    512,
    [],
    'e4c6',
    [
      'M0 192c0 11.7 3.1 22.6 8.6 32l494.9 0c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64c-.5 0-1.1 0-1.6 0C439 91.5 406.7 64 368 64c-15 0-29 4.1-40.9 11.2C313.8 49.6 286.9 32 256 32s-57.8 17.6-71.1 43.2C173 68.1 159 64 144 64c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64z',
      'M27.4 256C12.3 256 0 268.3 0 283.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28l231.5 0c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 414.1 512 353.9 512 283.4c0-15.1-12.3-27.4-27.4-27.4L27.4 256z',
    ],
  ],
};
const faSquare9 = {
  prefix: 'fad',
  iconName: 'square-9',
  icon: [
    448,
    512,
    [],
    'e25e',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 224c0 44 29.6 81.1 70 92.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8c4.7 5.5 11.5 8.4 18.2 8.4c5.5 0 11.1-1.9 15.6-5.8l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M272 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-74 92.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z',
    ],
  ],
};
const faCandyCane = {
  prefix: 'fad',
  iconName: 'candy-cane',
  icon: [
    512,
    512,
    [],
    'f786',
    [
      'M0 448.1c0 11.6 3.1 23.3 9.7 33.9c18.7 30 58.2 39.1 88.2 20.4c27.3-17 54.5-34.1 81.8-51.1C139.4 426 99.2 400.9 58.9 375.7c-9.6 6-19.2 12-28.8 18C10.7 405.9 0 426.7 0 448.1zm89.1-91.2l111.4 69.6c3.1 2 6.3 3.9 9.4 5.9c24.3-15.2 48.7-30.4 73-45.6c-40.3-25.2-80.5-50.3-120.8-75.5c-24.3 15.2-48.7 30.4-73 45.6zm103.2-64.5c37.4 23.4 74.8 46.7 112.2 70.1c2.9 1.8 5.7 3.6 8.6 5.4c25.7-16 51.3-32.1 77-48.1c-39.5-24.7-79-49.4-118.6-74.1c-.7-.5-1.5-.9-2.2-1.4c-25.7 16-51.3 32.1-77 48.1zm41.4-164.4c18.7 30 58.2 39.1 88.2 20.4c2.6-1.6 5.1-3.2 7.7-4.8l-.8-2.4c-13.3-40-26.7-80-40-120l-.8-2.3c-2.4 1.3-4.8 2.7-7.1 4.2L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2zm65.8 97.4l117 73.1 3.8 2.4c6-3.8 12.1-7.5 18.1-11.3c26.2-16.3 46.4-39.7 59-66.8c-39.5-13.2-79-26.3-118.5-39.5l-7.8-2.6c-.2 .1-.4 .3-.6 .4l-71 44.4zm18.1-219l1.5 4.6 39.1 117.2c.9-.1 1.8-.2 2.7-.2c.3 0 .3 0 .4 0c3.8-3.8 7.5-7.5 11.3-11.3c26.7-26.7 53.3-53.3 80-80c1.1-1.1 2.1-2.1 3.2-3.2C429.9 12.6 396.9 0 361 0c-14.3 0-28.4 2-42 6l-1.3 .4zM384 150.6c0 .1 0 .3 0 .5c1.7 .6 3.4 1.2 5.1 1.7c39.6 13.2 79.2 26.4 118.8 39.6c2.7-11.6 4.1-23.6 4.1-35.8l0-5.6c0-35.9-12.6-69-33.5-94.9l-3.2 3.2-80 80c-3.8 3.8-7.5 7.5-11.3 11.3z',
      'M329.6 143.5l-.8-2.4-40-120-.8-2.3c9.4-5.2 19.3-9.4 29.6-12.4l1.5 4.6 39.1 117.2c-3.4 .4-6.6 1.5-9.5 3.3l-19.1 12zm54.4 7.2c-.2-12.4-10.2-22.4-22.6-22.6c0 0 0 0 0 0l11.3-11.3 80-80 3.2-3.2c8.3 6.7 15.9 14.3 22.6 22.6l-3.2 3.2-80 80L384 150.6s0 0 0 0zm-12.9 29.9c8-5.3 12.9-14.3 12.9-23.9l0-5.5 5.1 1.7 118.8 39.6c-2.5 10.5-6 20.6-10.5 30.2L378.9 183.2l-7.8-2.6zM269.3 244.2l30.2-18.9 117 73.1 3.8 2.4-30.2 18.9L271.5 245.6l-2.2-1.4zm-107.2 67l30.2-18.9 112.2 70.1 8.6 5.4-30.2 18.9L162.1 311.2zM58.9 375.7l30.2-18.9 111.4 69.6 9.4 5.9-30.2 18.9L58.9 375.7z',
    ],
  ],
};
const faArrowDownWideShort = {
  prefix: 'fad',
  iconName: 'arrow-down-wide-short',
  icon: [
    576,
    512,
    ['sort-amount-asc', 'sort-amount-down'],
    'f160',
    [
      'M288 64c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L320 96c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32z',
      'M128 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L160 365.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L63.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C110.5 476.2 119 480 128 480z',
    ],
  ],
};
const faSortAmountAsc = faArrowDownWideShort;
const faSortAmountDown = faArrowDownWideShort;
const faSquareDollar = {
  prefix: 'fad',
  iconName: 'square-dollar',
  icon: [
    448,
    512,
    ['dollar-square', 'usd-square'],
    'f2e9',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM145.1 199.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7l0-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6l0 14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c16.3 11.1 25.3 28.1 25.3 47c0 3.7-.3 7.4-1 11.2c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4z',
      'M223.2 112c11.9 0 21.6 9.7 21.6 21.6v14.2c11.6 1.4 23.2 5 34.5 8.2c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-8.5-2.3-17.1-4.9-25.8-6.6c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c11.9 7.6 26.8 10.7 40.1 14.5c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c13.7 4.5 27.8 9.9 42 12.1c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-12-8.2-27.5-11.5-41.3-15.4c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6z',
    ],
  ],
};
const faDollarSquare = faSquareDollar;
const faUsdSquare = faSquareDollar;
const faPhoneArrowRight = {
  prefix: 'fad',
  iconName: 'phone-arrow-right',
  icon: [
    512,
    512,
    [],
    'e5be',
    [
      'M0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c1-3.5 1.4-7 1.4-10.5c0-15.8-9.4-30.6-24.6-36.9l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96C158.6 9.4 143.8 0 128 0c-3.5 0-7 .5-10.5 1.4l-88 24C12.1 30.2 0 46 0 64z',
      'M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L312 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l118.1 0L391 41c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faHandHoldingSeedling = {
  prefix: 'fad',
  iconName: 'hand-holding-seedling',
  icon: [
    576,
    512,
    [],
    'f4bf',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M96 14.5C96 6.5 102.5 0 110.5 0L160 0c88.4 0 160 71.6 160 160l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-14.5 0C161.1 160 96 94.9 96 14.5zm384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0l49.5 0c8 0 14.5 6.5 14.5 14.5z',
    ],
  ],
};
const faMessageCheck = {
  prefix: 'fad',
  iconName: 'message-check',
  icon: [
    512,
    512,
    ['comment-alt-check'],
    'f4a2',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64z',
      'M369 119c9.4 9.4 9.4 24.6 0 33.9L241 281c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 119c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faCommentAltCheck = faMessageCheck;
const faCloudBolt = {
  prefix: 'fad',
  iconName: 'cloud-bolt',
  icon: [
    512,
    512,
    [127785, 'thunderstorm'],
    'f76c',
    [
      'M144.9 373.3c2.2 6.4 8.3 10.7 15.1 10.7l70.1 0L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6c2.9 2.4 6.5 3.6 10.1 3.6c3.5 0 7.1-1.2 10-3.5l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8z',
      'M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96l-64 0-18.3 0 29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L143.2 320 96 320z',
    ],
  ],
};
const faThunderstorm = faCloudBolt;
const faChartLineUpDown = {
  prefix: 'fad',
  iconName: 'chart-line-up-down',
  icon: [
    512,
    512,
    [],
    'e5d7',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M358.6 102.6l18.7 18.7L288 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l112-112 18.7 18.7c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6l0-73.2 0-.3L480 80c0-8.8-7.2-16-16-16l-89.4 0C362.1 64 352 74.1 352 86.6c0 6 2.4 11.8 6.6 16zm64 178.7l-34.7-34.7-45.3 45.3 34.7 34.7-18.7 18.7c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6l89.4 0c8.8 0 16-7.2 16-16l0-89.4c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6l-18.7 18.7z',
    ],
  ],
};
const faTextSlash = {
  prefix: 'fad',
  iconName: 'text-slash',
  icon: [
    640,
    512,
    ['remove-format'],
    'f87d',
    [
      'M151.6 93.5c18.4 14.4 36.8 28.8 55.1 43.2c.1-.3 .2-.7 .3-1L217 96l116.7 0L301.3 210.8c18.1 14.2 36.3 28.4 54.4 42.7L400.2 96 503 96 497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32L376.1 32 204.5 32c-22 0-41.2 15-46.6 36.4l-6.3 25.2zM160 448c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-42.2 0 17.6-62.1L272.9 311 243.3 416 192 416c-17.7 0-32 14.3-32 32z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faRemoveFormat = faTextSlash;
const faWatch = {
  prefix: 'fad',
  iconName: 'watch',
  icon: [
    384,
    512,
    [8986],
    'f2e1',
    [
      'M384 256A192 192 0 1 1 0 256a192 192 0 1 1 384 0zM168 176l0 80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2l0-67.2c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M64 48C64 21.5 85.5 0 112 0L272 0c26.5 0 48 21.5 48 48l0 64.9C286 82.5 241.2 64 192 64s-94 18.5-128 48.9L64 48zM192 448c49.2 0 94-18.5 128-48.9l0 64.9c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64.9C98 429.5 142.8 448 192 448zm24-272l0 67.2L253.3 268c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32C172 271.5 168 264 168 256l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faCircleDownLeft = {
  prefix: 'fad',
  iconName: 'circle-down-left',
  icon: [
    512,
    512,
    [],
    'e107',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-57.4c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L232 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L296 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L176 352c-8.8 0-16-7.2-16-16l0-137.4z',
      'M160 336l0-137.4c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L232 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L296 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L176 352c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faText = {
  prefix: 'fad',
  iconName: 'text',
  icon: [
    448,
    512,
    [],
    'f893',
    [
      'M64 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 80C0 53.5 21.5 32 48 32l176 0 176 0c26.5 0 48 21.5 48 48l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L256 96l0 320 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 0-320L64 96z',
      '',
    ],
  ],
};
const faProjector = {
  prefix: 'fad',
  iconName: 'projector',
  icon: [
    640,
    512,
    [],
    'f8d6',
    [
      'M0 256L0 384c0 35.3 28.7 64 64 64l9.9 39.8C77.5 502 90.3 512 105 512l14 0c14.7 0 27.5-10 31-24.2L160 448l160 0c-38.9-29.2-64-75.7-64-128c0-1.6 0-3.3 .1-4.9s.1-3.2 .2-4.9c.2-3.2 .5-6.4 .9-9.6c.8-6.3 1.9-12.6 3.4-18.6c3-12.2 7.3-23.8 12.9-34.7c.7-1.4 1.4-2.7 2.1-4.1c.7-1.4 1.5-2.7 2.3-4c1.5-2.6 3.2-5.2 4.8-7.7c3.4-5.1 7-9.9 10.9-14.6c7.8-9.3 16.7-17.7 26.4-25L64 192c-35.3 0-64 28.7-64 64zm128 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM247 39c-9.4 9.4-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L281 39c-9.4-9.4-24.6-9.4-33.9 0zM392 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24zm92.2 440.8l5.7 23c3.6 14.2 16.4 24.2 31 24.2l14 0c14.7 0 27.5-10 31-24.2L576 448c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-64 0c38.9 29.2 64 75.7 64 128c0 2 0 4-.1 6s-.2 4-.3 5.9c-.3 3.9-.7 7.8-1.3 11.7c-1.1 7.7-2.8 15.2-5 22.5c-4.4 14.6-10.8 28.3-18.8 40.8c-16.2 25-39.1 45.2-66.2 58zM495 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L495 95z',
      'M512 320a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-256 0a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faFaceSmileWink = {
  prefix: 'fad',
  iconName: 'face-smile-wink',
  icon: [
    512,
    512,
    [128521, 'smile-wink'],
    'f4da',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm139.9 90.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm130.8 6.4c30.4-40.5 91.2-40.5 121.6 0c2.2 2.9 3.2 6.2 3.2 9.6c0 4.9-2.2 9.7-6.4 12.8c-7.1 5.3-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm124.4-6.4c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z',
    ],
  ],
};
const faSmileWink = faFaceSmileWink;
const faTombstoneBlank = {
  prefix: 'fad',
  iconName: 'tombstone-blank',
  icon: [
    448,
    512,
    [129702, 'tombstone-alt'],
    'f721',
    [
      'M32 192C32 86 118 0 224 0S416 86 416 192l0 256L32 448l0-256z',
      'M0 480c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faTombstoneAlt = faTombstoneBlank;
const faChessKingPiece = {
  prefix: 'fad',
  iconName: 'chess-king-piece',
  icon: [
    256,
    512,
    ['chess-king-alt'],
    'f440',
    [
      'M0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416 4.8 473.6C1.7 477.8 0 482.8 0 488z',
      'M128 0c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 32 51.8 0c11.2 0 20.2 9.1 20.2 20.2c0 2.5-.5 4.9-1.3 7.3L182.2 208l1.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-2.7 0L208 416 48 416 74.7 256 72 256c-13.3 0-24-10.7-24-24s10.7-24 24-24l1.8 0L41.3 123.5c-.9-2.3-1.3-4.8-1.3-7.3C40 105.1 49.1 96 60.2 96L112 96l0-32L96 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faChessKingAlt = faChessKingPiece;
const faCircle6 = {
  prefix: 'fad',
  iconName: 'circle-6',
  icon: [
    512,
    512,
    [],
    'e0f3',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 32c0-32.4 14.2-63.2 38.8-84.3c27.2-23.3 54.4-46.6 81.6-70c4.5-3.9 10.1-5.8 15.6-5.8c6.8 0 13.5 2.8 18.2 8.4c8.6 10.1 7.5 25.2-2.6 33.8c-9.9 8.4-19.7 16.9-29.6 25.4c40.4 11.4 70 48.4 70 92.4c0 53-43 96-96 96s-96-43-96-96zm48 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M311.6 170.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C174.2 224.8 160 255.6 160 288c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4zM304 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
    ],
  ],
};
const faWavesSine = {
  prefix: 'fad',
  iconName: 'waves-sine',
  icon: [
    640,
    512,
    [],
    'e65d',
    [
      'M0 448c0 17.7 14.3 32 32 32c56.7 0 93.7-34.4 118.6-75.4c9.5-15.7 17.9-33.3 25.4-51.7c-11.3-27.6-20.8-57-29.7-84.8l-.7-2.3c-1.1-3.3-2.1-6.6-3.2-9.8c-14.6 45.1-28.3 85.4-46.5 115.4C77 402.4 57.4 416 32 416c-17.7 0-32 14.3-32 32zM176 159.1c11.3 27.6 20.8 57 29.7 84.8l.7 2.3c1.1 3.3 2.1 6.6 3.2 9.8c14.6-45.1 28.3-85.4 46.5-115.4C275 109.6 294.6 96 320 96s45 13.6 63.8 44.6c18.2 30 31.9 70.3 46.5 115.4c1 3.2 2.1 6.5 3.2 9.8l.7 2.3c8.9 27.8 18.4 57.2 29.7 84.8c7.5 18.4 15.9 36 25.4 51.7c24.9 41 61.8 75.4 118.6 75.4c17.7 0 32-14.3 32-32s-14.3-32-32-32c-25.4 0-45-13.6-63.8-44.6c-18.2-30-31.9-70.3-46.5-115.4c-1-3.2-2.1-6.5-3.2-9.8l-.7-2.3c-8.9-27.8-18.4-57.2-29.7-84.8c-7.5-18.4-15.9-36-25.4-51.7C413.7 66.4 376.7 32 320 32s-93.7 34.4-118.6 75.4c-9.5 15.7-17.9 33.3-25.4 51.7z',
      'M320 480c-56.7 0-93.7-34.4-118.6-75.4c-23.8-39.2-40.3-90.2-55.2-136.5c0 0 0 0 0 0l-.7-2.3c-15.8-49.1-30.2-93.1-49.7-125.2C77 109.6 57.4 96 32 96C14.3 96 0 81.7 0 64S14.3 32 32 32c56.7 0 93.7 34.4 118.6 75.4c23.8 39.2 40.3 90.2 55.2 136.5l.7 2.3c15.8 49.1 30.2 93.1 49.7 125.2C275 402.4 294.6 416 320 416s45-13.6 63.8-44.6c18.2-30 31.9-70.3 46.5-115.4c1 3.2 2.1 6.5 3.2 9.8l.7 2.3c8.9 27.8 18.4 57.2 29.7 84.8c-7.5 18.4-15.9 36-25.4 51.7C413.7 445.6 376.7 480 320 480zM497.6 256c-1-3.2-2.1-6.5-3.2-9.8l-.7-2.3c-8.9-27.8-18.4-57.2-29.7-84.8c7.5-18.4 15.9-36 25.4-51.7C514.3 66.4 551.3 32 608 32c17.7 0 32 14.3 32 32s-14.3 32-32 32c-25.4 0-45 13.6-63.8 44.6c-18.2 30-31.9 70.3-46.5 115.4z',
    ],
  ],
};
const faLeft = {
  prefix: 'fad',
  iconName: 'left',
  icon: [
    448,
    512,
    ['arrow-alt-left'],
    'f355',
    [
      'M224 192c61.3 0 122.7 0 184 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-184 0c0-42.7 0-85.3 0-128z',
      'M224 192s0 0 0 0l0-96c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-96s0 0 0 0l0-128z',
    ],
  ],
};
const faArrowAltLeft = faLeft;
const faFileWord = {
  prefix: 'fad',
  iconName: 'file-word',
  icon: [
    384,
    512,
    [],
    'f1c2',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0c0 42.7 0 85.3 0 128c0 1.1 0 1.4 0 1.7c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 264c0-.6 0-.3 0 0z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z',
    ],
  ],
};
const faFilePowerpoint = {
  prefix: 'fad',
  iconName: 'file-powerpoint',
  icon: [
    384,
    512,
    [],
    'f1c4',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM112 264l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0c-13.3 0-24 10.7-24 24zm48 24l44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-44 0 0-56z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM136 240c-13.3 0-24 10.7-24 24l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z',
    ],
  ],
};
const faSquareDown = {
  prefix: 'fad',
  iconName: 'square-down',
  icon: [
    448,
    512,
    [11015, 'arrow-alt-square-down'],
    'f350',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 278.3C96 266 106 256 118.3 256l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3c-35.7 33.3-71.4 66.6-107.1 99.9c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L103.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3z',
      'M210.2 394.5L103.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3C96 266 106 256 118.3 256l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3L237.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5z',
    ],
  ],
};
const faArrowAltSquareDown = faSquareDown;
const faObjectsAlignCenterVertical = {
  prefix: 'fad',
  iconName: 'objects-align-center-vertical',
  icon: [
    512,
    512,
    [],
    'e3bd',
    [
      'M64 80l0 152 0 48 0 152c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-152 0-48 0-152c0-26.5-21.5-48-48-48l-64 0C85.5 32 64 53.5 64 80zm224 64l0 88 0 48 0 88c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-88 0-48 0-88c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z',
      'M24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0 48-40 0zm264 0l-64 0 0-48 64 0 0 48zm160 0l0-48 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0z',
    ],
  ],
};
const faArrowsLeftRight = {
  prefix: 'fad',
  iconName: 'arrows-left-right',
  icon: [
    512,
    512,
    ['arrows-h'],
    'f07e',
    [
      'M256 224l0 64 146.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l96-96c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-96-96c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L402.7 224 256 224z',
      'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 256 288l0-64-146.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96z',
    ],
  ],
};
const faArrowsH = faArrowsLeftRight;
const faHouseLock = {
  prefix: 'fad',
  iconName: 'house-lock',
  icon: [
    640,
    512,
    [],
    'e510',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64 0 24c0 22.1 17.9 40 40 40l.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-23.7 12.9-44.4 32-55.4l0-24.6c0-48.8 31.2-90.3 74.7-105.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faCloudArrowDown = {
  prefix: 'fad',
  iconName: 'cloud-arrow-down',
  icon: [
    640,
    512,
    [62337, 'cloud-download', 'cloud-download-alt'],
    'f0ed',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm216-40c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l39 39L296 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 134.1 39-39c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17l-80 80c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7l-80-80c-4.7-4.7-7-10.8-7-17z',
      'M223 279c-9.4 9.4-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 134.1-39-39c-9.4-9.4-24.6-9.4-33.9 0z',
    ],
  ],
};
const faCloudDownload = faCloudArrowDown;
const faCloudDownloadAlt = faCloudArrowDown;
const faWreath = {
  prefix: 'fad',
  iconName: 'wreath',
  icon: [
    448,
    512,
    [],
    'f7e2',
    [
      'M0 182.6c0 15.8 5.7 30.2 15.2 41.4C5.7 235.2 0 249.6 0 265.4c0 27.9 17.8 51.6 42.6 60.3C40.9 331.5 40 337.7 40 344c0 35.3 28.7 64 64 64c6.3 0 12.5-.9 18.2-2.6c1.5 4.2 3.4 8.3 5.8 12.1c0-4.5 0-9.1 0-13.6c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416c22.7-10.1 45.4-20.2 68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8l0 13.6c2.3-3.8 4.3-7.8 5.8-12.1c5.8 1.7 11.9 2.6 18.2 2.6c35.3 0 64-28.7 64-64c0-6.3-.9-12.5-2.6-18.2c24.8-8.8 42.6-32.5 42.6-60.3c0-15.8-5.7-30.2-15.2-41.4c9.5-11.2 15.2-25.6 15.2-41.4c0-27.9-17.8-51.6-42.6-60.3c1.7-5.8 2.6-11.9 2.6-18.2c0-35.3-28.7-64-64-64c-6.3 0-12.5 .9-18.2 2.6C317 17.8 293.3 0 265.4 0C249.6 0 235.2 5.7 224 15.2C212.8 5.7 198.4 0 182.6 0C154.7 0 131 17.8 122.2 42.6C116.5 40.9 110.3 40 104 40c-35.3 0-64 28.7-64 64c0 6.3 .9 12.5 2.6 18.2C17.8 131 0 154.7 0 182.6zM142.4 203c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1c11.3-12.1 30.6-12.1 41.9 0c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9z',
      'M128 492.2V403.8c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8z',
    ],
  ],
};
const faChildren = {
  prefix: 'fad',
  iconName: 'children',
  icon: [
    640,
    512,
    [],
    'e4e1',
    [
      'M340.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L408 300.5 408 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-179.5L564.9 321c9.4 15 29.2 19.4 44.1 10c9.7-6.1 15-16.5 15-27.1c0-5.8-1.6-11.7-4.9-17l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9l-12.3 0c-33 0-63.7 16.9-81.2 44.9L340.9 287zM416 64a64 64 0 1 0 128 0A64 64 0 1 0 416 64z',
      'M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400l0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 16 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 17.8 0c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400L88 400z',
    ],
  ],
};
const faMeterDroplet = {
  prefix: 'fad',
  iconName: 'meter-droplet',
  icon: [
    640,
    512,
    [],
    'e1ea',
    [
      'M0 256C0 397.4 114.6 512 256 512c53.7 0 103.5-16.5 144.6-44.7C390 447.2 384 424.3 384 400c0-23.6 5.8-46.9 16.9-67.8l75.3-141.2c4.9-9.2 12.1-16.7 20.6-22.1C461.2 70.4 366.8 0 256 0C114.6 0 0 114.6 0 256zm128-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32z',
      'M429.2 347.3l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z',
    ],
  ],
};
const faChalkboard = {
  prefix: 'fad',
  iconName: 'chalkboard',
  icon: [
    576,
    512,
    ['blackboard'],
    'f51b',
    [
      'M0 448c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-320c0-35.3-28.7-64-64-64L96 32C60.7 32 32 60.7 32 96l0 320c-17.7 0-32 14.3-32 32zM96 96l384 0 0 320-64 0-192 0L96 416 96 96z',
      'M480 96L96 96l0 320 128 0 0-32c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 32 64 0 0-320z',
    ],
  ],
};
const faBlackboard = faChalkboard;
const faUserLargeSlash = {
  prefix: 'fad',
  iconName: 'user-large-slash',
  icon: [
    640,
    512,
    ['user-alt-slash'],
    'f4fa',
    [
      'M64 481.3c0 17 13.8 30.7 30.7 30.7l450.8 0L528 512 284.3 320l-59 0C136.2 320 64 392.2 64 481.3zM178.9 114.9C246.6 168 314.3 221 381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faUserAltSlash = faUserLargeSlash;
const faSignalStrong = {
  prefix: 'fad',
  iconName: 'signal-strong',
  icon: [
    640,
    512,
    ['signal-4'],
    'f68f',
    [
      'M544 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352zM352 224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256zM192 288c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64z',
    ],
  ],
};
const faSignal4 = faSignalStrong;
const faLollipop = {
  prefix: 'fad',
  iconName: 'lollipop',
  icon: [
    512,
    512,
    [127853, 'lollypop'],
    'e424',
    [
      'M303.2 348.5c17.5-12.5 32.8-27.8 45.3-45.3L502.6 457.4c6.2 6.2 9.4 14.4 9.4 22.6s-3.1 16.4-9.4 22.6s-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4L303.2 348.5z',
      'M48 192c0 57.4 46.6 104 104 104l8 0c53 0 96-43 96-96l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8c0 61.6-38.7 114.2-93.2 134.8C281.4 325.6 336 265.2 336 192c0-79.5-64.5-144-144-144S48 112.5 48 192zM0 192a192 192 0 1 1 384 0A192 192 0 1 1 0 192z',
    ],
  ],
};
const faLollypop = faLollipop;
const faListTree = {
  prefix: 'fad',
  iconName: 'list-tree',
  icon: [
    512,
    512,
    [],
    'e1d2',
    [
      'M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM288 256c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32z',
      'M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48z',
    ],
  ],
};
const faEnvelopeOpen = {
  prefix: 'fad',
  iconName: 'envelope-open',
  icon: [
    512,
    512,
    [62135],
    'f2b6',
    [
      'M64 208.1l0 47.4L222.5 373c9.7 7.2 21.4 11 33.5 11s23.8-3.9 33.5-11c52.8-39.1 105.7-78.3 158.5-117.4l0-47.4c-64-47.4-128-94.8-192-142.2c-64 47.4-128 94.8-192 142.2z',
      'M64 208.1L256 65.9 448 208.1l0 47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5l0-47.4zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-239.9c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z',
    ],
  ],
};
const faDrawCircle = {
  prefix: 'fad',
  iconName: 'draw-circle',
  icon: [
    512,
    512,
    [],
    'f5ed',
    [
      'M39.9 196.7c7.4-3 15.5-4.7 24.1-4.7c1.9 0 3.8 .1 5.6 .2s3.7 .4 5.5 .7c3.6 .6 7.1 1.6 10.5 2.8c6.7 2.4 12.9 5.9 18.4 10.3C119.8 158 157.7 120 205.7 104.1c.3-.1 .3-.1 .3-.1c-4.4-5.5-7.9-11.7-10.3-18.4c-1.2-3.4-2.1-6.9-2.8-10.5c-.3-1.8-.6-3.6-.7-5.5c-.1-.9-.1-1.9-.2-2.8s-.1-1.9-.1-2.8c0-1.2 0-2.2 .1-3.2c.1-1.1 .1-2.1 .2-3.1c.2-2.1 .5-4.1 .9-6.1c.8-4 2-7.9 3.5-11.6c-76 20.8-135.9 80.7-156.7 156.7zm0 118.6c20.8 76 80.7 135.9 156.7 156.7c-1.5-3.7-2.7-7.6-3.5-11.6c-.4-2-.7-4.1-.9-6.1c-.1-1-.2-2.1-.2-3.1s-.1-2.1-.1-3.2s0-2 .1-2.8c0-.9 .1-1.9 .2-2.8c.2-1.9 .4-3.7 .7-5.5c.6-3.6 1.6-7.1 2.8-10.5c2.4-6.7 5.9-12.9 10.3-18.4C158 392.2 120 354.3 104.1 306.3C93 314.8 79.1 320 64 320c-1.1 0-2.1 0-3.2-.1s-2.1-.1-3.1-.2c-2.1-.2-4.1-.5-6.1-.9c-4-.8-7.9-2-11.6-3.5zM306.3 104.1C354.3 120 392.2 158 408 206c11-8.8 24.8-14 40-14c2.2 0 4.3 .1 6.3 .3s4.1 .5 6.1 .9c4 .8 7.9 2 11.6 3.5c-20.8-76-80.7-135.9-156.7-156.7c3 7.4 4.7 15.5 4.7 24.1c0 .5 0 1 0 1.4l0 1.4c0 .9-.1 1.9-.2 2.8c-.2 1.8-.4 3.7-.7 5.5c-.6 3.6-1.6 7.1-2.8 10.5c-2.4 6.7-5.9 12.9-10 18.5zM306 408c8.7 10.9 14 24.7 14 40c0 .5 0 1.1 0 1.6l-.1 1.6c-.1 1-.1 2.1-.2 3.1c-.2 2.1-.5 4.1-.9 6.1c-.8 4-2 7.9-3.5 11.6c75.5-20.7 135.1-79.9 156.3-155.2l.4-1.5c-7.4 3-15.6 4.7-24.1 4.7c-.9 0-1.9 0-2.8-.1s-1.9-.1-2.8-.2c-1.8-.2-3.7-.4-5.5-.7c-3.6-.6-7.1-1.6-10.5-2.8c-6.7-2.4-12.9-5.9-18.5-10C392 354.3 354 392.2 306 408z',
      'M256 128A64 64 0 1 0 256 0a64 64 0 1 0 0 128zm0 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM128 256A64 64 0 1 0 0 256a64 64 0 1 0 128 0zm320 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faCatSpace = {
  prefix: 'fad',
  iconName: 'cat-space',
  icon: [
    640,
    512,
    [],
    'e001',
    [
      'M167.1 64c0 3.1 1.7 6.2 5.2 7.5l28.8 10.7c2.2 .8 3.9 2.5 4.7 4.7l10.7 28.8c2.6 7 12.4 7 15 0l10.7-28.8c.8-2.2 2.5-3.9 4.7-4.7l28.8-10.7c7-2.6 7-12.4 0-15L246.9 45.8c-2.2-.8-3.9-2.5-4.7-4.7L231.5 12.3c-2.6-7-12.4-7-15 0L205.8 41.1c-.8 2.2-2.5 3.9-4.7 4.7L172.3 56.5c-3.5 1.3-5.2 4.4-5.2 7.5zM288 160c0 11.7 1.3 23.1 3.6 34.1C307.3 266.1 371.3 320 448 320c11 0 21.7-1.1 32-3.2C553 302 608 237.4 608 160C608 71.6 536.4 0 448 0S288 71.6 288 160zM352 42.7c0-5.9 4.8-10.7 10.7-10.7c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7L544 160c0 53-43 96-96 96s-96-43-96-96l0-117.3z',
      'M352 42.7c0-5.9 4.8-10.7 10.7-10.7c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7L544 160c0 53-43 96-96 96s-96-43-96-96l0-117.3zM416 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM160 277.8c29.4-44.3 76.8-75.6 131.6-83.8C307.3 266.1 371.3 320 448 320c11 0 21.7-1.1 32-3.2l0 35.2 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-93.9L300 448l36 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0c-53 0-96-43-96-96l0-223.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3l0 85.3z',
    ],
  ],
};
const faHandshakeSimpleSlash = {
  prefix: 'fad',
  iconName: 'handshake-simple-slash',
  icon: [
    640,
    512,
    ['handshake-alt-slash'],
    'e05f',
    [
      'M0 176L0 304c0 26.5 21.5 48 48 48l108.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6L41.2 128.5C17.9 131.8 0 151.8 0 176zm164.5-72.4c14.4 11.3 28.9 22.6 43.3 34l81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7zm69.2 54.2c21.1 16.5 42.2 33 63.2 49.6l77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352l41.8 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-76 0-4 0-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6zm89.2 69.9c57.6 45.2 115.2 90.3 172.9 135.5c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faHandshakeAltSlash = faHandshakeSimpleSlash;
const faRabbitRunning = {
  prefix: 'fad',
  iconName: 'rabbit-running',
  icon: [
    576,
    512,
    ['rabbit-fast'],
    'f709',
    [
      'M86.6 254.9c4.9 17.2 14.5 33.1 28.4 45.9L257.2 431.2C269 442 284.4 448 300.4 448L416 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16.8 0L320 384l0-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8c-8.5-2.4-13.4-11.3-11-19.8s11.3-13.4 19.8-11l30.8 8.8c55 15.7 92.8 65.9 92.8 123.1l0 15.7 56-32.4 6.4-3.7 101.3 0c33.3 0 60.3-27 60.3-60.3c0-18.1-8.2-35.3-22.2-46.7l-34.6-28.2c-4.6-3.7-9.4-7.1-14.5-10c8.4-49.3-7.8-100-43.9-135.5l-2.2-2.1c-3.5-3.5-8.2-5.3-13-5.3c-1.6 0-3.2 .2-4.8 .6c-6.4 1.7-11.4 6.6-13.1 13l-.8 2.9c-3.3 11.8-5.1 23.7-5.5 35.6c24.3 20.6 42.9 47.8 53.3 78.8c-8.2-1.9-16.5-2.9-25-2.9c-.6 0-1.1 0-1.7 0c-18.4-44-56.5-77.4-103.6-89.3l-3.4-.9c-6.2-1.6-12.9-.6-18.5 2.6c-10.8 6.2-15.6 19.5-11.2 31.1c14.9 39.5 44.3 71.4 81.4 89.7c-3.7 6.6-6.4 14-7.6 21.8L279.7 154.9C248.8 137.3 213.8 128 178.2 128c-32.3 0-62.2 16.8-78.9 44.4l-.3 .4c-.7 1.1-1.4 2.3-2.1 3.4c-14.6 24.3-17.7 52.8-10.3 78.6zm46.8 210.8C139.5 475 149.7 480 160 480c6.1 0 12.3-1.7 17.7-5.4l46-30.7-48.6-44.5-32.9 22c-14.7 9.8-18.7 29.7-8.9 44.4zM512 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M99 172.9l.3-.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1c-7.4-25.8-4.3-54.3 10.3-78.6l2.1-3.4zM496 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faRabbitFast = faRabbitRunning;
const faMemoPad = {
  prefix: 'fad',
  iconName: 'memo-pad',
  icon: [
    448,
    512,
    [],
    'e1da',
    [
      'M0 128l448 0 0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128zm96 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
      'M448 128L0 128 0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 64zM112 208l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faMattressPillow = {
  prefix: 'fad',
  iconName: 'mattress-pillow',
  icon: [
    640,
    512,
    [],
    'e525',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l192 0 0-384L64 64C28.7 64 0 92.7 0 128zm64 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-192z',
      'M256 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H256V64z',
    ],
  ],
};
const faAlarmPlus = {
  prefix: 'fad',
  iconName: 'alarm-plus',
  icon: [
    512,
    512,
    [],
    'f844',
    [
      'M32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4C35.1 463.6 32 471.8 32 480s3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zm112 0c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M14.9 146.4L160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64zM352 25.4L497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4z',
    ],
  ],
};
const faAlicorn = {
  prefix: 'fad',
  iconName: 'alicorn',
  icon: [
    640,
    512,
    [],
    'f6b0',
    [
      'M0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256zM551.4 48c5.4 9.4 8.6 20.3 8.6 32l0 10.7 73.6-24.5c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3l-79.3 0z',
      'M448 238.1l0-78.1 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L560 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 464 0 448 0C378.4 0 321.7 55.6 320 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1c0 48.1 3.8 99.9 26 139.8c9.2 16.6 21.7 31.3 38.2 42.7c-7.2-2.5-14-5.4-20.3-8.8c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43C96 134.3 64 169.8 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faCommentQuestion = {
  prefix: 'fad',
  iconName: 'comment-question',
  icon: [
    512,
    512,
    [],
    'e14b',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm169.4-89.5l.4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8c-10.8 6.2-21.5 12.3-32.3 18.5c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24c0-4.5 0-9 0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-2c0-.3 .1-.7 .1-1s0-.7 0-1.1c0-.5 0-1-.1-1.5s-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3c-.1 .4-.3 .8-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6zM224 336c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .8 .1 1.6 .1 1.6l0 1.7c0 1.1 0 1.4 0 1.7c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32z',
      'M222.6 112c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM256 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faGingerbreadMan = {
  prefix: 'fad',
  iconName: 'gingerbread-man',
  icon: [
    448,
    512,
    [],
    'f79d',
    [
      'M16 240c0 35.3 28.7 64 64 64l20.9 0c19 0 29.4 22.2 17.2 36.7L62.8 407c-22.6 27.2-19 67.5 8.2 90.1s67.5 19 90.1-8.2l45.6-54.8c9-10.7 25.5-10.7 34.4 0L286.8 489c22.6 27.2 63 30.8 90.1 8.2s30.8-63 8.2-90.1l-55.2-66.3c-12.2-14.6-1.8-36.7 17.2-36.7l20.9 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-64.4 0c-7.9 0-11.9-11.5-6.7-17.5C311.3 141.7 320 119.9 320 96c0-53-43-96-96-96s-96 43-96 96c0 23.9 8.7 45.7 23.1 62.5c5.2 6 1.2 17.5-6.7 17.5L80 176c-35.3 0-64 28.7-64 64zM208 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM272 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M208 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faGuaraniSign = {
  prefix: 'fad',
  iconName: 'guarani-sign',
  icon: [
    384,
    512,
    [],
    'e19a',
    [
      'M160 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 34.7c-5.2-.9-10.5-1.5-15.8-2c-2.7-.2-5.4-.4-8.1-.5c-1.3-.1-2.7-.1-4.1-.1s-2.7 0-4.1 0c-10.9 0-21.6 .9-32 2.7L160 32zm0 100c5.1-1.3 10.3-2.3 15.7-3c2.7-.3 5.4-.6 8.1-.8c1.4-.1 2.7-.2 4.1-.2s2.7-.1 4.1-.1c11.1 0 21.8 1.4 32 4l0 92 0 64 0 92c-5.1 1.3-10.4 2.3-15.7 3c-2.7 .3-5.4 .6-8.1 .8c-1.4 .1-2.7 .2-4.1 .2s-2.7 .1-4.1 .1c-11 0-21.8-1.4-32-4L160 132zm0 313.3c5.2 .9 10.5 1.5 15.8 2c2.7 .2 5.4 .4 8.1 .5c1.3 .1 2.7 .1 4.1 .1s2.7 0 4.1 0c10.9 0 21.6-.9 32-2.7l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7z',
      'M192 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c59.6 0 109.8-40.8 124-96l-92 0 0-64 128 0c17.7 0 32 14.3 32 32c0 106-86 192-192 192S0 362 0 256S86 64 192 64c52.3 0 99.8 21 134.4 54.9c12.6 12.4 12.8 32.6 .5 45.3s-32.6 12.8-45.3 .4C258.5 141.9 226.9 128 192 128z',
    ],
  ],
};
const faBurgerFries = {
  prefix: 'fad',
  iconName: 'burger-fries',
  icon: [
    640,
    512,
    [],
    'e0cd',
    [
      'M.2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2L48 192c3.6 0 7 .4 10.2 1L40.3 85.6 19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8zM0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512L272 512c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-11.8-10.4-19.5-25.3-20.2-42.1c-16.6 5.4-37.6 8.8-64.1 8.8c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224l-26.6 0C9.6 224 0 233.6 0 245.4zM64.2 34.6l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6l0-246.3-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9zM160 16l0 190.7c0 21 0 42.1 0 63.1c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2l0-238c-.1-6-3.5-11.4-8.8-14.1l-32-16C180.9 .6 178.4 0 176 0c-2.9 0-5.8 .8-8.4 2.4C162.9 5.3 160 10.5 160 16zm96.2 37.2l-.2 1.4L256 261c4.8-2.1 8.7-4.4 11.8-6.6c.8-.6 1.6-1.1 2.4-1.7c4.1-6.6 9.4-14 16.1-21.6c.1-.3 .2-.6 .3-.9c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2zm71 139.5c2-.3 4-.6 6.1-.7c11-6.5 23.3-12.3 37.1-17.2l13.4-76.1c.2-.9 .2-1.9 .2-2.8c0-4.4-1.8-8.6-5.1-11.7c-4-3.7-9.5-5.1-14.8-3.8L346.2 85l-19 107.8z',
      'M612.5 319.8c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5l296.9 0zM368 255.8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 128c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0c-17.7 0-32 14.3-32 32zm0 80c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faMugTea = {
  prefix: 'fad',
  iconName: 'mug-tea',
  icon: [
    576,
    512,
    [],
    'f875',
    [
      'M96 189.3c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6L144 64l32 0 0 50.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6l0 66.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-66.7z',
      'M144 64l0 50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6L96 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-66.7c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6L176 64l208 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 32c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L32 96c0-17.7 14.3-32 32-32l80 0zM416 256l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128z',
    ],
  ],
};
const faBorderTop = {
  prefix: 'fad',
  iconName: 'border-top',
  icon: [
    448,
    512,
    [],
    'f855',
    [
      'M0 160a32 32 0 1 0 64 0A32 32 0 1 0 0 160zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM96 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64z',
    ],
  ],
};
const faArrowsRotate = {
  prefix: 'fad',
  iconName: 'arrows-rotate',
  icon: [
    512,
    512,
    [128472, 'refresh', 'sync'],
    'f021',
    [
      'M16 320l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-51.1 17.6 17.5c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0L125.6 352l50.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 288c-17.7 0-32 14.3-32 32z',
      'M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l127.5 0c0 0 0 0 0 0l.4 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5z',
    ],
  ],
};
const faRefresh = faArrowsRotate;
const faSync = faArrowsRotate;
const faCircleBookOpen = {
  prefix: 'fad',
  iconName: 'circle-book-open',
  icon: [
    512,
    512,
    ['book-circle'],
    'e0ff',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-70.7c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5l0 160.7c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C225 347.1 207.1 336 184 336s-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9l0-160.7zm144 0c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5l0 160.7c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C369 347.1 351.1 336 328 336s-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9l0-160.7z',
      'M230.3 350.8C225 347.1 207.1 336 184 336s-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9l0-160.7c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5l0 160.7c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2zm144 0C369 347.1 351.1 336 328 336s-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9l0-160.7c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5l0 160.7c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2z',
    ],
  ],
};
const faBookCircle = faCircleBookOpen;
const faArrowsToDottedLine = {
  prefix: 'fad',
  iconName: 'arrows-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e0a6',
    [
      'M64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M224 0c17.7 0 32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-32c0-17.7 14.3-32 32-32zM137.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9z',
    ],
  ],
};
const faFireExtinguisher = {
  prefix: 'fad',
  iconName: 'fire-extinguisher',
  icon: [
    512,
    512,
    [129519],
    'f134',
    [
      'M2.5 159.5c-5.8 11.9-.9 26.3 11.1 32.1s26.3 .9 32.1-11.1C62 146.9 91.8 121.1 128 110l0-49.6C72.7 72.6 26.7 109.8 2.5 159.5zM64 416c0 10.7 0 21.3 0 32c0 35.3 28.7 64 64 64l96 0c35.3 0 64-28.7 64-64c0-10.7 0-21.3 0-32L64 416zM224 56c0 16 0 32 0 48l65 0c-.3-1.3-.6-2.6-.8-3.9c-.1-.7-.1-1.3-.2-2c0-.7-.1-1.4-.1-2.1c0-10.7 0-21.3 0-32c0-.7 0-1.4 .1-2s.1-1.4 .2-2c.2-1.3 .4-2.6 .8-3.9l-65 0z',
      'M500.3 7.3C507.7 13.3 512 22.4 512 32l0 96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32c-15-3-25.7-16.1-25.7-31.4l0-32c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM128 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 106.8c37.8 18 64 56.5 64 101.2l0 176L64 416l0-176c0-44.7 26.2-83.2 64-101.2L128 32zm48 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faMagnifyingGlassArrowsRotate = {
  prefix: 'fad',
  iconName: 'magnifying-glass-arrows-rotate',
  icon: [
    512,
    512,
    [],
    'e65e',
    [
      'M12 144c0 12.8 7.7 24.9 20.4 29.8c3.6 1.4 7.3 2.1 10.9 2.2l1.5 0c12.5-.3 24.2-8 29.1-20.4C94.8 101.9 147 64 208 64c35.2 0 67.4 12.6 92.5 33.6l45.4-45.4C309.1 19.7 260.9 0 208 0C119.8 0 44.4 54.9 14.2 132.4c-1.5 3.8-2.2 7.8-2.2 11.6zM70.2 363.8c36.7 32.5 85 52.2 137.8 52.2c45.9 0 88.3-14.9 122.7-40L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6L376 330.7c10.5-14.4 19.3-30.2 25.8-47.1c6.4-16.5-1.7-35-18.2-41.4c-3.6-1.4-7.3-2.1-10.9-2.2l-1.5 0c-12.5 .3-24.2 8-29.1 20.4C321.2 314.1 269 352 208 352c-35.2 0-67.4-12.6-92.5-33.6L70.2 363.8z',
      'M280 176l112 0c13.3 0 24-10.7 24-24l0-112c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L263 135c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8zm88-48s0 0 0 0l-30.1 0s0 0 0 0l30.1 0zM136 240L24 240c-13.3 0-24 10.7-24 24L0 376c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L153 281c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8z',
    ],
  ],
};
const faGarageOpen = {
  prefix: 'fad',
  iconName: 'garage-open',
  icon: [
    640,
    512,
    [],
    'e00b',
    [
      'M160 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 192 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-21.1-11.7-39.5-28.9-49l-5.2-15L395 320l2.8 8-155.6 0 2.8-8-50.8 0-5.2 15c-17.2 9.5-28.9 27.9-28.9 49zm104 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm160 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M0 488L0 171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4L640 488c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-264c0-17.7-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32l0 264c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM512 224l0 64-384 0 0-64 384 0z',
    ],
  ],
};
const faShelvesEmpty = {
  prefix: 'fad',
  iconName: 'shelves-empty',
  icon: [
    640,
    512,
    [],
    'e246',
    [
      'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 192 0 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l512 0c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-256 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 160 64 32zm0 192l512 0 0 192L64 416l0-192z',
      '',
    ],
  ],
};
const faCruzeiroSign = {
  prefix: 'fad',
  iconName: 'cruzeiro-sign',
  icon: [
    448,
    512,
    [],
    'e152',
    [
      'M192 256l0 55.3 0 8.7 0 82.7c19.6 8.6 41.2 13.3 64 13.3l0-96 0-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32z',
      'M256 96C167.6 96 96 167.6 96 256s71.6 160 160 160c41 0 78.3-15.4 106.7-40.7c13.2-11.8 33.4-10.7 45.2 2.5s10.7 33.4-2.5 45.2c-39.6 35.5-92 57-149.3 57C132.3 480 32 379.7 32 256S132.3 32 256 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C334.3 111.4 297 96 256 96z',
    ],
  ],
};
const faWatchApple = {
  prefix: 'fad',
  iconName: 'watch-apple',
  icon: [
    384,
    512,
    [],
    'e2cb',
    [
      'M0 144c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6l224 0c5.5 0 10.8 .6 16 1.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6C27.5 439 0 406.7 0 368L0 144zM64 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm42.7-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm42.7-96a42.7 42.7 0 1 0 85.3 0 42.7 42.7 0 1 0 -85.3 0zM256 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm21.3-96c0 .6 0 .3 0 0zm0 192c0 .6 0 .3 0 0z',
      'M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3c5.2-1 10.5-1.6 16-1.6l224 0c5.5 0 10.8 .6 16 1.6l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6L64 464zm181.3-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faWatchCalculator = {
  prefix: 'fad',
  iconName: 'watch-calculator',
  icon: [
    384,
    512,
    [],
    'f8f0',
    [
      'M0 144c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6l224 0c5.5 0 10.8 .6 16 1.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6C27.5 439 0 406.7 0 368L0 144zm64 0l0 32c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm0 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3c5.2-1 10.5-1.6 16-1.6l224 0c5.5 0 10.8 .6 16 1.6l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6L64 464zm0-192a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM64 360a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm80 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
    ],
  ],
};
const faListDropdown = {
  prefix: 'fad',
  iconName: 'list-dropdown',
  icon: [
    512,
    512,
    [],
    'e1cf',
    [
      'M104 256c0 13.3 10.7 24 24 24l256 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-256 0c-13.3 0-24 10.7-24 24zm0 88c0 13.3 10.7 24 24 24l256 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-256 0c-13.3 0-24 10.7-24 24z',
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 96l0 224 384 0 0-224L64 192zM363.3 96c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c3.1 3.1 8.2 3.1 11.3 0l36.7-36.7c5-5 1.5-13.7-5.7-13.7l-73.4 0z',
    ],
  ],
};
const faCabinetFiling = {
  prefix: 'fad',
  iconName: 'cabinet-filing',
  icon: [
    448,
    512,
    [128452],
    'f64b',
    [
      'M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 176L0 240 0 64zM0 272l448 0 0 176c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 272zM128 128l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32L160 96c-17.7 0-32 14.3-32 32zm0 256l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z',
      'M160 96c-17.7 0-32 14.3-32 32l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32L160 96zm0 256c-17.7 0-32 14.3-32 32l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32l-128 0zM0 272l448 0 0-32L0 240l0 32z',
    ],
  ],
};
const faBurgerSoda = {
  prefix: 'fad',
  iconName: 'burger-soda',
  icon: [
    640,
    512,
    [],
    'f858',
    [
      'M0 160c0 17.7 14.3 32 32 32l301.4 0c14-8.2 30.1-15.4 48.6-20.9c1.3-3.5 2-7.2 2-11.1c0-17.7-14.3-32-32-32l-127.8 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8L32 128c-17.7 0-32 14.3-32 32zm40 64L60.3 468c2.1 24.9 22.9 44 47.8 44L272 512c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c4.2-9.5 13.8-27.8 32.2-47L40 224z',
      'M612.5 319.8c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5l296.9 0zM368 255.8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 128c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0c-17.7 0-32 14.3-32 32zm0 80c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faSquareArrowUp = {
  prefix: 'fad',
  iconName: 'square-arrow-up',
  icon: [
    448,
    512,
    ['arrow-square-up'],
    'f33c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM88 248c0-6.1 2.3-12.3 7-17L207 119c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7L353 231c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-33.9 0l-71-71L248 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1-71 71c-9.4 9.4-24.6 9.4-33.9 0c-4.7-4.7-7-10.8-7-17z',
      'M207 119c9.4-9.4 24.6-9.4 33.9 0L353 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71L248 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 119z',
    ],
  ],
};
const faArrowSquareUp = faSquareArrowUp;
const faGreaterThanEqual = {
  prefix: 'fad',
  iconName: 'greater-than-equal',
  icon: [
    448,
    512,
    [],
    'f532',
    [
      'M34.3 52.1c6.6-16.4 25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1z',
      'M448 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z',
    ],
  ],
};
const faPalletBox = {
  prefix: 'fad',
  iconName: 'pallet-box',
  icon: [
    640,
    512,
    [],
    'e208',
    [
      'M0 352c0 17.7 14.3 32 32 32l32 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 224 0 224 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-224 0L96 320l-64 0c-17.7 0-32 14.3-32 32zm128 32l160 0 0 64-160 0 0-64zM256 0l0 16 0 96c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-96 0-16L368 0 272 0 256 0zm96 384l160 0 0 64-160 0 0-64z',
      'M256 0L176 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L384 0l0 112c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 99.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1L256 0z',
    ],
  ],
};
const faFaceConfounded = {
  prefix: 'fad',
  iconName: 'face-confounded',
  icon: [
    512,
    512,
    [],
    'e36c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM113.7 376.8c4-7.9 13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5zM116 205.1c0-9 9.6-14.7 17.5-10.5c30 16 59.9 32 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8c-30 16-59.9 32-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6c12-14.4 24-28.8 36-43.2l-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm172.6 37.4l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2c12 14.4 24 28.8 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5c-30-16-59.9-32-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8z',
      'M116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
    ],
  ],
};
const faShieldHalved = {
  prefix: 'fad',
  iconName: 'shield-halved',
  icon: [
    512,
    512,
    ['shield-alt'],
    'f3ed',
    [
      'M256.7 0c4.6 0 9.2 1 13.3 2.9L458.4 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-8.3 4-17.4 6-26.4 6c0-169.7 0-339.4 0-509.1z',
      'M256.7 0c-.2 0-.5 0-.7 0c-4.6 0-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c8.3 4 17.4 6 26.4 6L256 0l.7 0z',
    ],
  ],
};
const faShieldAlt = faShieldHalved;
const faTruckPlow = {
  prefix: 'fad',
  iconName: 'truck-plow',
  icon: [
    640,
    512,
    [],
    'f7de',
    [
      'M48 400a80 80 0 1 0 160 0A80 80 0 1 0 48 400zm224 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M269.9 96l57.6 96L192 192l0-96 77.9 0zm132.2 96L324.8 63.1C313.2 43.8 292.4 32 269.9 32L176 32c-26.5 0-48 21.5-48 48l0 112-96 0c-17.7 0-32 14.3-32 32l0 96c0 16 11.7 29.2 27 31.6C45 314 83.5 288 128 288c44.7 0 83.2 26.2 101.2 64l21.6 0c18-37.8 56.5-64 101.2-64s83.2 26.2 101.2 64l58.8 0 0 16c0 7.3 2.5 14.3 7 20l64 80c11 13.8 31.2 16 45 5s16-31.2 5-45l-57-71.2 0-36.8 0-132.8L633 116c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-64 80c-4.5 5.7-7 12.7-7 20l0 112-32 0 0-64c0-17.7-14.3-32-32-32l-45.9 0z',
    ],
  ],
};
const faBookAtlas = {
  prefix: 'fad',
  iconName: 'book-atlas',
  icon: [
    448,
    512,
    ['atlas'],
    'f558',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zM247.4 283.8c3.8-3.7 8-10 11.8-18.9c6.2-14.5 10.8-34.3 12.2-56.9l-63 0c1.5 22.6 6 42.4 12.2 56.9c3.8 8.9 8 15.2 11.8 18.9c3.7 3.7 6.2 4.2 7.4 4.2s3.7-.5 7.4-4.2zm42.7-9.9c23.2-14.2 39.9-38 44.5-65.9l-31.1 0c-1.4 24.7-6.1 47.5-13.4 65.9zm0-163.8c7.3 18.3 12 41.1 13.4 65.9l31.1 0c-4.7-27.9-21.4-51.7-44.5-65.9zM112 192a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm33.3 16c4.7 27.9 21.4 51.7 44.5 65.9c-7.3-18.3-12-41.1-13.4-65.9l-31.1 0zm31.1-32c1.4-24.7 6.1-47.5 13.4-65.9c-23.2 14.2-39.9 38-44.5 65.9l31.1 0zm56.1-75.8c-3.8 3.7-8 10-11.8 18.9c-6.2 14.5-10.8 34.3-12.2 56.9l63 0c-1.5-22.6-6-42.4-12.2-56.9c-3.8-8.9-8-15.2-11.8-18.9c-3.7-3.7-6.2-4.2-7.4-4.2s-3.7 .5-7.4 4.2z',
    ],
  ],
};
const faAtlas = faBookAtlas;
const faVirus = {
  prefix: 'fad',
  iconName: 'virus',
  icon: [
    512,
    512,
    [],
    'e074',
    [
      'M0 256c0 17.7 14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5L288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224L32 224c-17.7 0-32 14.3-32 32zm272-32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm56 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M224 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96z',
    ],
  ],
};
const faGridRound2 = {
  prefix: 'fad',
  iconName: 'grid-round-2',
  icon: [
    512,
    512,
    [],
    'e5db',
    [
      'M32 384a96 96 0 1 0 192 0A96 96 0 1 0 32 384zM288 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM384 288a96 96 0 1 0 0 192 96 96 0 1 0 0-192z',
    ],
  ],
};
const faCommentMiddleTop = {
  prefix: 'fad',
  iconName: 'comment-middle-top',
  icon: [
    512,
    512,
    [],
    'e14a',
    [
      'M188.3 103.3l44.5-89C237.2 5.5 246.2 0 256 0s18.8 5.5 23.2 14.3l44.5 89C432.2 127.5 512 208.2 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-95.8 79.8-176.5 188.3-200.7z',
      '',
    ],
  ],
};
const faWave = {
  prefix: 'fad',
  iconName: 'wave',
  icon: [
    576,
    512,
    [],
    'e65b',
    [
      'M0 410.6c35 0 66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c21 9.5 52 20.3 87.1 20.3l0 36.6c.1 2.6-.2 5.4-.8 8.1c-4 17.2-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.6-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9c-.6-2.4-.8-4.9-.8-7.3l0-37.4z',
      'M0 336c0-17.7 14.3-32 32-32c35.3 0 64-28.7 64-64C96 125.1 189.1 32 304 32c84.7 0 157.6 50.7 190 123.2c4.7 10.5 1.3 22.8-8.1 29.4s-22.2 5.6-30.4-2.3C441 168.5 421.5 160 400 160c-44.2 0-80 35.8-80 80c0 35.3 28.7 64 64 64c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c15 3.5 25.1 17.1 24.7 31.9v41.9c-28.7 0-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2C55.1 369.7 28.7 378.6 0 378.6V336z',
    ],
  ],
};
const faEnvelopeCircleCheck = {
  prefix: 'fad',
  iconName: 'envelope-circle-check',
  icon: [
    640,
    512,
    [],
    'e4e8',
    [
      'M0 112C0 85.5 21.5 64 48 64l416 0c26.5 0 48 21.5 48 48c0 15.1-7.1 29.3-19.2 38.4l-13.9 10.4c-66.6 6.4-122.4 50-146.3 109.8l-57.4 43c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112zm0 64L217.6 339.2c22.8 17.1 54 17.1 76.8 0l26.4-19.8c-.5 5.5-.8 11-.8 16.6c0 42.5 15.1 81.6 40.2 112L64 448c-35.3 0-64-28.7-64-64L0 176z',
      'M496 480a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faLayerGroup = {
  prefix: 'fad',
  iconName: 'layer-group',
  icon: [
    576,
    512,
    [],
    'f5fd',
    [
      'M32 256c0 9.4 5.4 17.9 13.9 21.8l218.6 101C272 382.2 280 384 288 384s16-1.7 23.5-5.2l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 234.2C37.4 238.1 32 246.6 32 256z',
      'M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 337.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2z',
    ],
  ],
};
const faRestroomSimple = {
  prefix: 'fad',
  iconName: 'restroom-simple',
  icon: [
    640,
    512,
    [],
    'e23a',
    [
      'M21.8 282.7c-.2 1.8-.2 3.6-.2 5.4c0 27.5 17.6 51.3 42.4 60.2L64 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2zM448 64a64 64 0 1 0 128 0A64 64 0 1 0 448 64z',
      'M320 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faArrowsToDot = {
  prefix: 'fad',
  iconName: 'arrows-to-dot',
  icon: [
    512,
    512,
    [],
    'e4be',
    [
      'M224 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 50.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 82.7 288 32zM393.4 342.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 50.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64zM118.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64zm50.7 269.3c12.5 12.5 32.8 12.5 45.3 0l9.4-9.4 0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-50.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3z',
    ],
  ],
};
const faBorderOuter = {
  prefix: 'fad',
  iconName: 'border-outer',
  icon: [
    448,
    512,
    [],
    'f851',
    [
      'M160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M384 96l0 320L64 416 64 96l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
    ],
  ],
};
const faHashtagLock = {
  prefix: 'fad',
  iconName: 'hashtag-lock',
  icon: [
    576,
    512,
    [],
    'e415',
    [
      'M0 352c0 17.7 14.3 32 32 32l58.2 0-9.8 58.7c-2.9 17.4 8.9 33.9 26.3 36.8c1.8 .3 3.6 .4 5.3 .4c15.4 0 28.9-11.1 31.5-26.7L155.1 384l95.1 0-9.8 58.7c-2.9 17.4 8.9 33.9 26.3 36.8c1.8 .3 3.6 .4 5.3 .4c15.4 0 28.9-11.1 31.5-26.7L320 354.7l0-2.6c0-8.1 1.5-15.9 4.3-23.1L347.1 192l38.5 0c16.6-16.3 38.2-27.4 62.4-30.9c0-.4 0-.8 0-1.1c0-17.7-14.3-32-32-32l-58.2 0 9.8-58.7c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L292.9 128l-95.1 0 9.8-58.7c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L132.9 128 64 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l58.2 0L100.9 320 32 320c-17.7 0-32 14.3-32 32zm165.8-32l21.3-128 95.1 0L260.9 320l-95.1 0z',
      'M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faClockTwoThirty = {
  prefix: 'fad',
  iconName: 'clock-two-thirty',
  icon: [
    512,
    512,
    [],
    'e35b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232 0c0-8 4-15.5 10.7-20l96-64c4.1-2.7 8.7-4 13.3-4c7.8 0 15.4 3.8 20 10.7c2.7 4.1 4 8.7 4 13.3c0 7.8-3.8 15.4-10.7 20c-28.4 19-56.9 37.9-85.3 56.9c0 41.1 0 82.1 0 123.3c0 .7 0 1.5-.1 2.3s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-45.3 0-90.7 0-136z',
      'M256 416c-13.3 0-24-10.7-24-24l0-136c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8 280 392c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faArchway = {
  prefix: 'fad',
  iconName: 'archway',
  icon: [
    512,
    512,
    [],
    'f557',
    [
      'M0 448c0 17.7 14.3 32 32 32l96 0 32 0 0-64 0-64c0-53 43-96 96-96s96 43 96 96l0 64 0 64 32 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-224L32 192l0 224c-17.7 0-32 14.3-32 32zM32 96l0 64 448 0 0-64L32 96z',
      'M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM480 160L32 160l0 32 448 0 0-32z',
    ],
  ],
};
const faHeartCircleCheck = {
  prefix: 'fad',
  iconName: 'heart-circle-check',
  icon: [
    576,
    512,
    [],
    'e4fd',
    [
      'M0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faHouseChimneyCrack = {
  prefix: 'fad',
  iconName: 'house-chimney-crack',
  icon: [
    576,
    512,
    ['house-damage'],
    'f6f1',
    [
      'M64 270.5L64.1 448c0 35.3 28.7 64 64 64l102.3 0-31.4-52.3c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64 122.1 0c35.4 0 64-28.7 64-64c-.1-59.2-.3-118.3-.4-177.4L288 74.5 64 270.5z',
      'M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5 512 64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 37.5L309.1 7.9z',
    ],
  ],
};
const faHouseDamage = faHouseChimneyCrack;
const faFileZipper = {
  prefix: 'fad',
  iconName: 'file-zipper',
  icon: [
    384,
    512,
    ['file-archive'],
    'f1c6',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 352.3c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8L66.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4zM96 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM96 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-6.3 71.8L66.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8zM112 336l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faFileArchive = faFileZipper;
const faTicketPerforated = {
  prefix: 'fad',
  iconName: 'ticket-perforated',
  icon: [
    640,
    512,
    [],
    'e63e',
    [
      'M0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 48c0 8.8-7.3 15.8-15.8 18c-27.7 7-48.2 32.1-48.2 62s20.5 55 48.2 62c8.6 2.2 15.8 9.1 15.8 18l0 48c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm416 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M416 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faHeartHalf = {
  prefix: 'fad',
  iconName: 'heart-half',
  icon: [
    512,
    512,
    [],
    'e1ab',
    [
      'M256 96l0 67.9 0 265.4 0 50.7c10.3 0 20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.1 295 57 268 84L256 96z',
      'M256 96L244 84s0 0 0 0c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9l0-50.7 0-265.4L256 96z',
    ],
  ],
};
const faCommentCheck = {
  prefix: 'fad',
  iconName: 'comment-check',
  icon: [
    512,
    512,
    [],
    'f4ac',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm136 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47L335 159c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M369 159c9.4 9.4 9.4 24.6 0 33.9L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faSquare = {
  prefix: 'fad',
  iconName: 'square',
  icon: [
    448,
    512,
    [9632, 9723, 9724, 61590],
    'f0c8',
    ['M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z', ''],
  ],
};
const faMemo = {
  prefix: 'fad',
  iconName: 'memo',
  icon: [
    384,
    512,
    [],
    'e1d8',
    [
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320c-8.8 0-16 7.2-16 16z',
      'M80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320z',
    ],
  ],
};
const faMartiniGlassEmpty = {
  prefix: 'fad',
  iconName: 'martini-glass-empty',
  icon: [
    512,
    512,
    ['glass-martini'],
    'f000',
    [
      'M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3 224 448l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-178.7L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0L32 0zM256 210.7L109.3 64l293.5 0L256 210.7z',
      '',
    ],
  ],
};
const faGlassMartini = faMartiniGlassEmpty;
const faCouch = {
  prefix: 'fad',
  iconName: 'couch',
  icon: [
    640,
    512,
    [],
    'f4b8',
    [
      'M64 160l0 66.7c18.6 6.6 32 24.4 32 45.3l0 80 448 0 0-80c0-.7 0-1.3 0-1.9s.1-1.3 .1-1.9c.1-1.3 .3-2.5 .5-3.8c.4-2.5 1-4.9 1.8-7.3c1.5-4.7 3.8-9.1 6.6-13c5.7-7.9 13.7-14 23-17.3l0-66.7c0-70.7-57.3-128-128-128L192 32C121.3 32 64 89.3 64 160z',
      'M48 224c-26.5 0-48 21.5-48 48L0 448c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l448 0c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-176c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80L96 352l0-80c0-26.5-21.5-48-48-48z',
    ],
  ],
};
const faCediSign = {
  prefix: 'fad',
  iconName: 'cedi-sign',
  icon: [
    384,
    512,
    [],
    'e0df',
    [
      'M192 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 34.7c-5.2-.9-10.5-1.5-15.8-2c-2.7-.2-5.4-.4-8-.5c-1.3-.1-2.7-.1-4.1-.1s-2.7 0-4.1 0c-10.9 0-21.6 .9-32 2.7L192 32zm0 100c5.1-1.3 10.3-2.3 15.7-3c2.7-.3 5.4-.6 8.1-.8c1.4-.1 2.7-.2 4.1-.2s2.7-.1 4.1-.1c11.1 0 21.8 1.4 32 4L256 380c-5.1 1.3-10.3 2.3-15.7 3c-2.7 .3-5.4 .6-8.1 .8c-1.4 .1-2.7 .2-4.1 .2s-2.7 .1-4.1 .1c-11 0-21.8-1.4-32-4L192 132zm0 313.3c5.2 .9 10.5 1.5 15.8 2c2.7 .2 5.4 .4 8.1 .5c1.3 .1 2.7 .1 4.1 .1s2.7 0 4.1 0c10.9 0 21.6-.9 32-2.7l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7z',
      'M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8C307.1 433.7 267.2 448 224 448C118 448 32 362 32 256S118 64 224 64c43.2 0 83.1 14.3 115.2 38.4c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128z',
    ],
  ],
};
const faItalic = {
  prefix: 'fad',
  iconName: 'italic',
  icon: [
    384,
    512,
    [],
    'f033',
    [
      'M128 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-58.7 0L160 416l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l58.7 0L224 96l-64 0c-17.7 0-32-14.3-32-32z',
      '',
    ],
  ],
};
const faGlassCitrus = {
  prefix: 'fad',
  iconName: 'glass-citrus',
  icon: [
    512,
    512,
    [],
    'f869',
    [
      'M.2 163.2L29.3 454.4C32.5 487.1 60.1 512 93 512L259 512c32.9 0 60.4-24.9 63.7-57.6c5.6-56.4 11.3-112.8 16.9-169.2c2.1-21.4 4.3-42.8 6.4-64.3c1.9-19.3 3.9-38.5 5.8-57.8c.9-9-2-18-8.1-24.7S329 128 320 128l-30.4 0-64.7 0L32 128c-9 0-17.7 3.8-23.7 10.5s-9 15.7-8.1 24.7zM67.4 192l217.3 0c-2.1 21.3-4.3 42.7-6.4 64c-6.4 64-12.8 128-19.2 192L93 448c-6.4-64-12.8-128-19.2-192c-2.1-21.3-4.3-42.7-6.4-64z',
      'M448 144c0 44.2-35.8 80-80 80c-7.6 0-15-1.1-21.9-3l-6.4 64.3c9.2 1.8 18.7 2.8 28.4 2.8c79.5 0 144-64.5 144-144S447.5 0 368 0C293.9 0 232.8 56 224.9 128l64.7 0C297 91.5 329.3 64 368 64c44.2 0 80 35.8 80 80zM73.8 256L93 448 259 448l19.2-192L73.8 256z',
    ],
  ],
};
const faCalendarLinesPen = {
  prefix: 'fad',
  iconName: 'calendar-lines-pen',
  icon: [
    576,
    512,
    [],
    'e472',
    [
      'M0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112zm0 80L0 464c0 26.5 21.5 48 48 48l210.8 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L448 235.6l0-43.6L0 192zM96 296c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24z',
      'M493.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L311.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.7l-71-71z',
    ],
  ],
};
const faTableCellsColumnLock = {
  prefix: 'fad',
  iconName: 'table-cells-column-lock',
  icon: [
    640,
    512,
    [],
    'e678',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm208 0l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM360 96l0 64 88 0 0-64-88 0z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faChurch = {
  prefix: 'fad',
  iconName: 'church',
  icon: [
    640,
    512,
    [9962],
    'f51d',
    [
      'M0 372.4c0-17.5 9.5-33.6 24.9-42.1L160 256l0 256L48 512c-26.5 0-48-21.5-48-48l0-91.6zM480 256l135.1 74.3c15.3 8.4 24.9 24.6 24.9 42.1l0 91.6c0 26.5-21.5 48-48 48l-112 0 0-256z',
      'M320 0c13.3 0 24 10.7 24 24l0 24 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 46.4L456.7 210c14.5 8.7 23.3 24.3 23.3 41.2L480 512l-96 0 0-96c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96-96 0 0-260.8c0-16.9 8.8-32.5 23.3-41.2L296 142.4 296 96l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-24c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faPersonSnowmobiling = {
  prefix: 'fad',
  iconName: 'person-snowmobiling',
  icon: [
    640,
    512,
    ['snowmobile'],
    'f7d1',
    [
      'M0 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 416c-26.5 0-48 21.5-48 48zM106.7 220.6c-11.4 21.6-9.4 47.8 5.3 67.4l152 0-72-32 32-48 29.3 29.3c12 12 28.3 18.7 45.3 18.7l13.5 0 48-64-56 0-61.7-55.6c-11.8-10.6-27-16.4-42.8-16.4l-.9 0c-23.7 0-45.5 13.1-56.6 34.1l-35.3 66.6zM192 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM416 488c0 13.3 10.7 24 24 24l136 0c6.4 0 12.5-2.5 17-7l40-40c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17c-9.4-9.4-24.6-9.4-33.9 0l-33 33L546 464l-46-61.3L480 416l-30 0 36 48-46 0c-13.3 0-24 10.7-24 24z',
      'M373.5 85.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l37.4 74.7L288 288 99.8 288c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.5 5-3.6 10.2-3.4 15.2c4-.6 8.1-.9 12.3-.9l224 0c26.2 0 49.4 12.6 64 32l144 0 88.9-59.3c4.5-3 7.1-8 7.1-13.3l0-77.5c0-6.1-3.4-11.6-8.8-14.3L419.8 177.9 373.5 85.3z',
    ],
  ],
};
const faSnowmobile = faPersonSnowmobiling;
const faFaceHushed = {
  prefix: 'fad',
  iconName: 'face-hushed',
  icon: [
    512,
    512,
    [],
    'e37b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm100.3-69.1c-6-6.5-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8zM208.4 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM304 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-240c0-8.8 7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16zm64.4 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 160.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
    ],
  ],
};
const faCommentsDollar = {
  prefix: 'fad',
  iconName: 'comments-dollar',
  icon: [
    640,
    512,
    [],
    'f653',
    [
      'M0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8c-5.8 4.2-8.1 11.5-6 18S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM228 280c0 .3 0 .7 0 0z',
      'M228 72c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7L228 72zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9c0 0 0 0 0 0s0 0 0 0l-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z',
    ],
  ],
};
const faTicketsSimple = {
  prefix: 'fad',
  iconName: 'tickets-simple',
  icon: [
    640,
    512,
    [],
    'e659',
    [
      'M96 96c0-35.3 28.7-64 64-64l416 0c35.3 0 64 28.7 64 64l0 48c0 8.8-7.4 15.7-15.7 18.6C605.5 169.1 592 187 592 208s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6l0 48c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64l0-48c0-8.8 7.4-15.7 15.7-18.6C130.5 246.9 144 229 144 208s-13.5-38.9-32.3-45.4C103.4 159.7 96 152.8 96 144l0-48z',
      'M24 96c13.3 0 24 10.7 24 24l0 240c0 39.8 32.2 72 72 72l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-400 0C53.7 480 0 426.3 0 360L0 120c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faPickaxe = {
  prefix: 'fad',
  iconName: 'pickaxe',
  icon: [
    512,
    512,
    [],
    'e5bf',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4c8 0 16-3 22.2-8.9l306-294.2c-8.6-9.9-17.7-19.8-27.5-29.5c-2.4-2.4-4.8-4.8-7.3-7.2c-2.5-2.4-5-4.7-7.4-7c-4.9-4.6-9.9-9-14.8-13.3L8.9 457.8C3 464 0 472 0 480zM399.5 51.6c23.4 16.9 43.9 37.5 60.9 60.9l9.8-9.4c6.2-6 9.7-14.2 9.8-22.8s-3.3-16.9-9.4-22.9l-16-16c-6.1-6.1-14.3-9.5-22.9-9.4s-16.8 3.6-22.8 9.8l-9.4 9.8z',
      'M462.4 373.5s0 0 0 0s0 0 0 0c2.3 6.2 8.2 10.4 14.8 10.5s12.6-3.9 15.1-10C505 342.5 512 308 512 272C512 121.8 390.2 0 240 0c-36 0-70.5 7-102 19.8c-6.1 2.5-10.1 8.5-10 15.1s4.3 12.5 10.5 14.8c0 0 0 0 0 0s0 0 0 0l.2 .1 .8 .3c.7 .3 1.8 .7 3.3 1.3c2.9 1.2 7.2 3 12.7 5.5c11 5 26.7 12.6 45.3 23.1c37.3 21 86 53.6 132 99.5s78.5 94.7 99.5 132c10.5 18.6 18.1 34.3 23.1 45.3c2.5 5.5 4.3 9.8 5.5 12.7c.6 1.4 1 2.5 1.3 3.3l.3 .8 .1 .2z',
    ],
  ],
};
const faLinkSimpleSlash = {
  prefix: 'fad',
  iconName: 'link-simple-slash',
  icon: [
    640,
    512,
    [],
    'e1ce',
    [
      'M32 256c0 88.4 71.6 160 160 160l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-53 0-96-43-96-96c0-24.9 9.5-47.6 25-64.6L70.7 151.7C46.6 179.7 32 216.1 32 256zM159.1 99.4c25.8 20.2 51.6 40.4 77.3 60.6l19.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-11.3 0-22.3 1.2-32.9 3.4zM318.1 224c27.2 21.3 54.4 42.7 81.7 64l16.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-97.9 0zM352 128c0 17.7 14.3 32 32 32l64 0c53 0 96 43 96 96c0 43.3-28.6 79.8-67.9 91.8c18.8 14.7 37.5 29.4 56.3 44.1c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160l-64 0c-17.7 0-32 14.3-32 32z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faDemocrat = {
  prefix: 'fad',
  iconName: 'democrat',
  icon: [
    640,
    512,
    [],
    'f747',
    [
      'M192 320c117.4 0 234.7 0 352 0l0 32 0 64 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-160 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64 0-64 0-32z',
      'M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8L480 160l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17l0 87.4-352 0-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3l-2 0C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z',
    ],
  ],
};
const faFaceConfused = {
  prefix: 'fad',
  iconName: 'face-confused',
  icon: [
    512,
    512,
    [],
    'e36d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm3.1 186c-5.5-6.9-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304l11 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-11 0c-61.8 0-121.7 21-169.9 59.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faPinball = {
  prefix: 'fad',
  iconName: 'pinball',
  icon: [
    448,
    512,
    [],
    'e229',
    [
      'M256 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M412.1 463.4c-7.2 13.2-23.1 19.9-37.9 15L66.3 379.3c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3c12.6 9.8 15.8 27.1 8.4 40.6zM96 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faZ = {
  prefix: 'fad',
  iconName: 'z',
  icon: [
    384,
    512,
    [122],
    '5a',
    [
      'M0 64C0 46.3 14.3 32 32 32l320 0c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416 352 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96 32 96C14.3 96 0 81.7 0 64z',
      '',
    ],
  ],
};
const faPersonSkiing = {
  prefix: 'fad',
  iconName: 'person-skiing',
  icon: [
    512,
    512,
    [9975, 'skiing'],
    'f7c9',
    [
      'M2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3c19 9.9 38.1 19.8 57.1 29.7c42.9 22.3 85.8 44.5 128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-13.5 6.8-28.2 10.1-42.9 10.1c-15.2 0-30.4-3.6-44.2-10.8L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM97.5 73.2c3.8-8 13.3-11.4 21.3-7.7l18.3 8.6 8.6-17.2c2.8-5.6 8.5-8.8 14.3-8.8c2.4 0 4.8 .5 7.1 1.7c7.9 4 11.1 13.6 7.2 21.5l-8.3 16.5c18.6 8.7 37.1 17.4 55.7 26.1c40.5 19 81 38 121.4 56.9l1 2.9c2.5 7.4 4.9 14.8 7.4 22.2c2.6 7.9 7.2 14.9 13.2 20.3c-1.2-.6-2.4-1.1-3.6-1.7L151.7 116.3l-9.4 18.9c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9.1-18.1-17.5-8.2c-8-3.8-11.4-13.3-7.7-21.3z',
      'M428.7 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-35.6 22.1c-11.6-34.9-50.3-52.9-84.5-39.2l-83.4 33.4c-1.2 .5-2.3 1-3.5 1.5l121.4 56.9 1 2.9 7.4 22.2c2.6 7.9 7.2 14.9 13.2 20.3c0 0 0 0 0 0c3.2 2.9 6.9 5.4 10.8 7.4l58.1 29c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2zM203.7 216.9l75.1 75.1-46.2 69.2L289.8 391l49.5-74.3c12.7-19 10.2-44.4-6-60.6l-39.3-39.3-108.8-52c-2 18.3 3.7 37.5 18.4 52.1z',
    ],
  ],
};
const faSkiing = faPersonSkiing;
const faDeer = {
  prefix: 'fad',
  iconName: 'deer',
  icon: [
    512,
    512,
    [129420],
    'f78e',
    [
      'M224 16l0 24c0 30.9 25.1 56 56 56l8 0 8 0 24 0 32 0c8.8 0 16-7.2 16-16c0-5.6-2.9-10.6-7.3-13.5c-2.5-1.6-5.5-2.5-8.7-2.5l-5.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16zM393.4 65.4c18 3.2 34.9 11.6 48.3 24.4C459.7 80.4 472 61.7 472 40l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-16 0c-2.3 0-4.6 .5-6.6 1.4z',
      'M320 96l32 0c8.8 0 16-7.2 16-16c0-5.6-2.9-10.6-7.3-13.5c5.3-1.7 10.9-2.5 16.6-2.5c24.8 0 48.6 9.9 66.2 27.4l55.3 55.3c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3L416 224l-5.3 0L384 304l0 64 0 112c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-112-36.3 0c-28.8 0-55.3-9.8-76.3-26.4c-2.1 16.9-9.8 32.6-21.9 44.8L142.9 397c-4.6 4.6-6.2 11.5-4 17.7l19.3 54.7c7.3 20.8-8.1 42.6-30.2 42.6l-33.9 0c-13.6 0-25.7-8.6-30.2-21.4l-15.5-44c-11.4-32.4-7.4-67.8 10-96.3C65 339.4 65 324.9 56 315.9c-3-3-5.7-6.1-8.1-9.5c-1.3 12.9-12.7 22.5-25.7 21.5C8.9 326.9-.9 315.4 .1 302.2L2.4 272c4.2-54.2 49.3-96 103.7-96l7.9 0 14.1 0 64 0c.6 0 1.2 0 1.7 0c.8 0 1.7 0 2.5 0l106.1 0 9.6-32-38 0c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96zm96 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faInputPipe = {
  prefix: 'fad',
  iconName: 'input-pipe',
  icon: [
    640,
    512,
    [],
    'e1be',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm64 0l512 0 0 256L64 384l0-256z',
      'M104 184c0-13.3 10.7-24 24-24s24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184z',
    ],
  ],
};
const faRoadLock = {
  prefix: 'fad',
  iconName: 'road-lock',
  icon: [
    640,
    512,
    [],
    'e567',
    [
      'M32 425.4C32 455.5 56.5 480 86.6 480L288 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 32 0 0-128c0-23.7 12.9-44.4 32-55.4l0-24.6c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32L352 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2zM288 224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faA = {
  prefix: 'fad',
  iconName: 'a',
  icon: [
    384,
    512,
    [97],
    '41',
    [
      'M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384l197.3 0 31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320l-144 0 72-172.8L264 320z',
      '',
    ],
  ],
};
const faBookmarkSlash = {
  prefix: 'fad',
  iconName: 'bookmark-slash',
  icon: [
    640,
    512,
    [],
    'e0c2',
    [
      'M128 48l0 27C256 175.4 384 275.7 512 376l0-328c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zm0 148.8l0 290.8c0 13.4 10.9 24.3 24.3 24.3c5 0 9.9-1.5 14-4.4L320 400 473.7 507.6c4.1 2.9 9 4.4 14 4.4c9.9 0 18.4-5.9 22.2-14.3L128 196.8z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTemperatureArrowDown = {
  prefix: 'fad',
  iconName: 'temperature-arrow-down',
  icon: [
    576,
    512,
    ['temperature-down'],
    'e03f',
    [
      'M32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L288 112C288 50.2 237.9 0 176 0S64 50.2 64 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L128 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M480 352l32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-288c0-17.7 14.3-32 32-32s32 14.3 32 32l0 288zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3z',
    ],
  ],
};
const faTemperatureDown = faTemperatureArrowDown;
const faMace = {
  prefix: 'fad',
  iconName: 'mace',
  icon: [
    512,
    512,
    [],
    'f6f8',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4L217.1 340.1c-18.4-11.3-34-26.8-45.3-45.3L9.4 457.4C3.1 463.6 0 471.8 0 480z',
      'M272.8 10.9L244.8 95c-40.4 13.5-72.3 45.4-85.8 85.8l-84.1 28C68.4 211 64 217.1 64 224s4.4 13 10.9 15.2l84.1 28c13.5 40.4 45.4 72.3 85.8 85.8l28 84.1c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l28-84.1c40.4-13.5 72.3-45.4 85.8-85.8l84.1-28c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-84.1-28c-13.5-40.4-45.4-72.3-85.8-85.8l-28-84.1C301 4.4 294.9 0 288 0s-13 4.4-15.2 10.9zM288 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faFeatherPointed = {
  prefix: 'fad',
  iconName: 'feather-pointed',
  icon: [
    512,
    512,
    ['feather-alt'],
    'f56b',
    [
      'M71.3 356.4c3.3 12.2 9.4 23.2 17 33.3L311 167c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17L122.3 423.7c10 7.6 21 13.7 33.3 17C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6c-6.4-6.4-15-10.1-24-10.1c-.9 0-1.8 0-2.6 .1C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4z',
      'M24 512c-6.2 0-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9L311 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-4.7 4.7-10.8 7-17 7z',
    ],
  ],
};
const faFeatherAlt = faFeatherPointed;
const faSausage = {
  prefix: 'fad',
  iconName: 'sausage',
  icon: [
    512,
    512,
    [],
    'f820',
    [
      'M0 388.4l0 55.2C0 454.9 9.1 464 20.4 464c2.4 0 4.7-.4 7-1.2l41.9-15.2C82.3 485.1 118 512 160 512c194.4 0 352-157.6 352-352c0-42-26.9-77.7-64.5-90.7l15.2-41.9c.8-2.2 1.2-4.6 1.2-7C464 9.1 454.9 0 443.6 0L388.4 0C377.1 0 368 9.1 368 20.4c0 2.4 .4 4.7 1.2 7l15.2 41.9C346.9 82.3 320 118 320 160c0 88.4-71.6 160-160 160c-42 0-77.7 26.9-90.7 64.5L27.4 369.2c-2.2-.8-4.6-1.2-7-1.2C9.1 368 0 377.1 0 388.4zM144 384c0-8.8 7.2-16 16-16c114.9 0 208-93.1 208-208c0-8.8 7.2-16 16-16s16 7.2 16 16c0 132.5-107.5 240-240 240c-8.8 0-16-7.2-16-16z',
      'M384 144c8.8 0 16 7.2 16 16c0 132.5-107.5 240-240 240c-8.8 0-16-7.2-16-16s7.2-16 16-16c114.9 0 208-93.1 208-208c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faTrashCanClock = {
  prefix: 'fad',
  iconName: 'trash-can-clock',
  icon: [
    576,
    512,
    [],
    'e2aa',
    [
      'M32 96l384 0 0 96.7c-29.3 2.6-56.6 12.5-80 27.7l0-44.5c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 71.2c-29.8 31.5-48 74-48 120.8c0 59.5 29.6 112.1 74.8 144L96 512c-35.3 0-64-28.7-64-64L32 96zm80 80l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 0l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faP = {
  prefix: 'fad',
  iconName: 'p',
  icon: [
    320,
    512,
    [112],
    '50',
    [
      'M0 96C0 60.7 28.7 32 64 32l96 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-96 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 320 0 96zM64 288l96 0c53 0 96-43 96-96s-43-96-96-96L64 96l0 192z',
      '',
    ],
  ],
};
const faBroomWide = {
  prefix: 'fad',
  iconName: 'broom-wide',
  icon: [
    512,
    512,
    [],
    'e5d1',
    [
      'M329.4 137.4c15.1 15.1 30.2 30.2 45.3 45.3l128-128c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6S488.2 0 480 0s-16.4 3.1-22.6 9.4l-128 128z',
      'M313.6 121.6c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-76.8-76.8zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z',
    ],
  ],
};
const faSnowflake = {
  prefix: 'fad',
  iconName: 'snowflake',
  icon: [
    448,
    512,
    [10052, 10054],
    'f2dc',
    [
      'M1.7 296.6c0-2.1 .3-4.1 .8-6.2c3.4-12.8 16.6-20.4 29.4-17l67.7 18.1L41.2 325.6l-21.7-5.8C8.8 316.9 1.7 307.2 1.7 296.6zm.8-75c-3.4-12.8 4.2-26 17-29.4l21.7-5.8c19.5 11.4 38.9 22.7 58.4 34.1L31.9 238.6c-12.8 3.4-26-4.2-29.4-17zm64-110.9c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1C111 153 91.4 141.6 71.7 130.1l-5.2-19.3zm0 290.4l5.2-19.3c19.6-11.5 39.3-22.9 58.9-34.4l-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4zM143 47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l15 15c0 22.6 0 45.3 0 67.9L143 81c-9.4-9.4-9.4-24.6 0-33.9zm0 384l49-49c0 22.6 0 45.3 0 67.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm113-369l15-15c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9l-49 49 0-67.9zm0 320l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15 0-67.9zm61.4-217.6l17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3c-19.6 11.5-39.3 22.9-58.9 34.4zm0 183l58.9 34.4 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1zm31-127l58.4-34.1 21.7 5.8c10.7 2.9 17.8 12.6 17.8 23.2c0 2.1-.3 4.1-.8 6.2c-3.4 12.8-16.6 20.4-29.4 17l-67.7-18.1zm0 71l67.7-18.1c12.8-3.4 26 4.2 29.4 17c.6 2.1 .8 4.2 .8 6.2c0 10.6-7.1 20.3-17.8 23.2l-21.7 5.8c-19.5-11.3-38.9-22.7-58.4-34.1z',
      'M224 0c17.7 0 32 14.3 32 32l0 168.3 143.9-83.9c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8L287.5 256l144.6 84.4c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5L256 311.7 256 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-168.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8L160.5 256 15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5L192 200.3 192 32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faStomach = {
  prefix: 'fad',
  iconName: 'stomach',
  icon: [
    512,
    512,
    [],
    'f623',
    [
      'M214.8 414l1.7 1.4c11.4 9.5 21.6 17.1 34.4 22.8c12.6 5.5 29.1 9.8 53.1 9.8c69.7 0 127.9-49.5 141.1-115.3c-7.3 1.9-14.6 3.3-21.1 3.3c-16.8 .2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9 .1-17.1 2.1-25.6 4.6c-8.6 53.5-50.4 95.8-103.6 105.4z',
      'M160 0c17.7 0 32 14.3 32 32l0 64c0 35.3 28.7 64 64 64l17.1 0c22.1-38.3 63.5-64 110.9-64c70.7 0 128 57.3 128 128l0 80c0 114.9-93.1 208-208 208c-32 0-57.5-5.8-78.9-15.2c-21.2-9.3-36.9-21.7-49.6-32.2c-1.8-1.5-3.6-3-5.3-4.4c0 0 0 0 0 0C148 441.5 136.6 432 112 432c-26.5 0-48 21.5-48 48c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7 57.3-128 128-128l64 0c35.3 0 64-28.7 64-64l0-64c-70.7 0-128-57.3-128-128l0-64c0-17.7 14.3-32 32-32zm54.8 414c.6 .5 1.1 1 1.7 1.4c11.4 9.5 21.6 17.1 34.4 22.8c12.6 5.5 29.1 9.8 53.1 9.8c79.5 0 144-64.5 144-144l0-80c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64c0 62.9-45.4 115.2-105.2 126z',
    ],
  ],
};
const faNewspaper = {
  prefix: 'fad',
  iconName: 'newspaper',
  icon: [
    512,
    512,
    [128240],
    'f1ea',
    [
      'M48 480c26.5 0 48-21.5 48-48L96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L96 480l-48 0zM160 120l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm0 184c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zM368 112c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z',
      'M0 160L0 432c0 26.5 21.5 48 48 48s48-21.5 48-48L96 96 64 96C28.7 96 0 124.7 0 160zM384 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zM176 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0z',
    ],
  ],
};
const faRectangleAd = {
  prefix: 'fad',
  iconName: 'rectangle-ad',
  icon: [
    576,
    512,
    ['ad'],
    'f641',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112.1 325.3c.1-.9 .3-1.8 .5-2.7c.4-1.8 1.1-3.6 1.9-5.3c24-48 48-96 72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3c24 48 48 96 72 144c5.9 11.9 1.1 26.3-10.7 32.2c-11.9 5.9-26.3 1.1-32.2-10.7L253.2 328l-90.3 0c-1.8 3.6-3.6 7.2-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7c-4.2-2.1-7.5-5.3-9.8-9c-1.1-1.9-2-3.9-2.6-6c-.3-1-.5-2.1-.7-3.2c-.1-.8-.2-1.6-.2-1.6L112 328c0-.9 0-1.1 0-1.4c0-.4 .1-.9 .1-1.3zM186.8 280l42.3 0c-7.1-14.1-14.1-28.2-21.2-42.3c-7.1 14.1-14.1 28.2-21.2 42.3zM320 280c0-39.8 32.2-72 72-72c8.4 0 16.5 1.4 24 4.1l0-28.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96 0 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72zm48 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M208 160c9.1 0 17.4 5.1 21.5 13.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328l-90.3 0-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3zm21.2 120L208 237.7 186.8 280l42.3 0zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9l0-28.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96 0 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z',
    ],
  ],
};
const faAd = faRectangleAd;
const faGuitarElectric = {
  prefix: 'fad',
  iconName: 'guitar-electric',
  icon: [
    512,
    512,
    [127928],
    'f8be',
    [
      'M0 353.5c0 19.9 7.5 39.8 22.5 55l79.9 80.8c30 30.4 78.7 30.4 108.8 0c10.7-10.8 17.9-24.5 22.2-39.2c7.5-25.2 22.5-65.6 47.2-90.6c10-10.1 20-16 28.3-19.3c.4-.2 .8-.3 1.1-.5c11.3-4.6 23-9.4 31.6-18l21.6-21.8c3.3-3.3 4.9-7.6 4.9-11.9s-1.6-8.6-4.9-11.9c-6.5-6.6-17.3-6.6-25.8-3c-11.1 4.7-28 7.3-48.3-4.7c-6.4-3.8-13.2-9-20.2-16.1c-3.9-4-7.9-7.9-11.8-11.9c-5.7-5.8-10-11.6-13.2-17.2c-14.6-26.1-5.5-50.4 3.2-64.7c4.8-7.9 4.8-18.7-1.7-25.3c-3.3-3.3-7.5-4.9-11.8-4.9s-8.5 1.6-11.8 4.9l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5c-1.2 2.6-2.3 5.1-3.5 7.6c-3.5 7.3-8.9 15.7-17.1 24c-24.7 25-64.7 40.2-89.6 47.7c-14.5 4.4-28.1 11.7-38.7 22.4C7.5 313.7 0 333.6 0 353.5zM104 344c0-4.1 1.6-8.2 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0l48 48c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7l-48-48c-3.1-3.1-4.7-7.2-4.7-11.3zm68.7-75.3c6.2-6.2 16.4-6.2 22.6 0l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6z',
      'M352 81.1l0 33.6L243.8 223c3.2 5.7 7.5 11.5 13.2 17.2l11.8 11.9c7 7.1 13.8 12.3 20.2 16.1L461.3 96l2.7 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-1.1 0c-9.7 0-19.2 2.9-27.3 8.3L366.2 54.5C357.3 60.4 352 70.4 352 81.1zM195.3 268.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48zm-64 64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48z',
    ],
  ],
};
const faArrowTurnDownRight = {
  prefix: 'fad',
  iconName: 'arrow-turn-down-right',
  icon: [
    512,
    512,
    [],
    'e3d6',
    [
      'M0 64L0 224c0 53 43 96 96 96l306.7 0 32-32-32-32L96 256c-17.7 0-32-14.3-32-32L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M329.4 137.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288 329.4 182.6c-12.5-12.5-12.5-32.8 0-45.3z',
    ],
  ],
};
const faMoonCloud = {
  prefix: 'fad',
  iconName: 'moon-cloud',
  icon: [
    640,
    512,
    [],
    'f754',
    [
      'M256.5 240.3C264.5 124 361.2 32 479.5 32c6.4 0 12.7 .3 19 .8c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3c0 97.2 78.6 176 175.5 176c10.3 0 20.3-.9 30.1-2.6c6.9-1.2 13.8 2.2 17 8.5c1.2 2.3 1.8 4.8 1.8 7.3c0 4.2-1.7 8.4-4.8 11.5C595 455.8 540 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c17.9-18.7 29-44.1 29-72c0-54.6-42-99.3-95.5-103.7z',
      'M0 352c0 35.3 28.7 64 64 64l184 0c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64z',
    ],
  ],
};
const faBreadSliceButter = {
  prefix: 'fad',
  iconName: 'bread-slice-butter',
  icon: [
    512,
    512,
    [],
    'e3e1',
    [
      'M173.3 288c0 8.2 3.1 16.4 9.4 22.6l50.7 50.7c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c16.9-16.9 33.8-33.8 50.7-50.7c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-16.9-16.9-33.8-33.8-50.7-50.7c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4c-16.9 16.9-33.8 33.8-50.7 50.7c-6.2 6.2-9.4 14.4-9.4 22.6z',
      'M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64l0 176c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-176c-35.3 0-64-28.7-64-64zm182.6 73.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-50.7 50.7z',
    ],
  ],
};
const faCircleArrowRight = {
  prefix: 'fad',
  iconName: 'circle-arrow-right',
  icon: [
    512,
    512,
    ['arrow-circle-right'],
    'f0a9',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zm-400 0c0 13.3 10.7 24 24 24l182.1 0-71 71c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7L393 273c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17L281 127c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-9.4 9.4-9.4 24.6 0 33.9l71 71L136 232c-13.3 0-24 10.7-24 24z',
      'M393 239c9.4 9.4 9.4 24.6 0 33.9L281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239z',
    ],
  ],
};
const faArrowCircleRight = faCircleArrowRight;
const faUserGroupCrown = {
  prefix: 'fad',
  iconName: 'user-group-crown',
  icon: [
    640,
    512,
    ['users-crown'],
    'f6a5',
    [
      'M96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16-32 0-16 0-160 0-16 0-32 0zM359.4 229.3C379 245.9 404.3 256 432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8L384 144c0 5.4-.3 10.7-.8 16c-2.4 24.3-10.3 47.1-22.4 67c-.5 .8-1 1.6-1.4 2.3zm50.8 90.9C452.9 356.8 480 411.3 480 472l0 8c0 11.7-3.1 22.6-8.6 32l137.8 0c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320l-61.4 0c-2.4 0-4.8 .1-7.1 .2z',
      'M352 80l0 48-32 0-16 0-160 0-16 0-32 0 0-48 0-37.7c0 0 0-.1 0-.1L96 39l0-23c0-8.8 7.2-16 16-16l2.4 0c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6l.1 .1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5L336 0c8.8 0 16 7.2 16 16l0 23 0 3.2c0 0 0 .1 0 .1L352 80zM0 472c0-92.8 75.2-168 168-168l112 0c92.8 0 168 75.2 168 168l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8z',
    ],
  ],
};
const faUsersCrown = faUserGroupCrown;
const faCircleI = {
  prefix: 'fad',
  iconName: 'circle-i',
  icon: [
    512,
    512,
    [],
    'e111',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24z',
      'M160 152c0-13.3 10.7-24 24-24l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faToiletPaperCheck = {
  prefix: 'fad',
  iconName: 'toilet-paper-check',
  icon: [
    640,
    512,
    [],
    'e5b2',
    [
      'M20.2 495.8c-5.7-10-5.6-22.3 .4-32.2C63.6 385.7 64 277.3 64 192C64 86 107 0 160 0L512 0c-53 0-96 86-96 192c0 81.9-7.3 145-16.4 192c-8.6 44.1-18.8 74-26.3 91.9c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2zM167 191c-9.4 9.4-9.4 24.6 0 33.9l40 40c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-23-23c-9.4-9.4-24.6-9.4-33.9 0z',
      'M399.6 384L512 384c53 0 96-86 96-192S565 0 512 0s-96 86-96 192c0 81.9-7.3 145-16.4 192zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z',
    ],
  ],
};
const faFilterCircleXmark = {
  prefix: 'fad',
  iconName: 'filter-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e17b',
    [
      'M3.9 22.9C-2.8 36.8-.7 53.4 9 65.3L192 288.9l0 79.1c0 10.1 4.7 19.6 12.8 25.6l64 48c1.5 1.1 3 2.1 4.7 2.9C262.3 421.4 256 395.4 256 368c0-85 60.2-155.9 140.4-172.4L503 65.3c9.8-12 11.8-28.5 5.2-42.5S487.5 0 472 0L40 0C24.5 0 10.5 8.9 3.9 22.9z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faLocust = {
  prefix: 'fad',
  iconName: 'locust',
  icon: [
    576,
    512,
    [],
    'e520',
    [
      'M288 56c0 13.3 10.7 24 24 24l16 0c98.7 0 180.6 71.4 197 165.4c29.8 11.6 51 40.6 51 74.6l0-40C576 143 465 32 328 32l-16 0c-13.3 0-24 10.7-24 24z',
      'M286.1 142.5c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400l74.5 0-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400l80.4 0 38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400l12.4 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-64.2 0-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7zM379.6 240L333 240l29.5-40 17.1 40zm-106.3 0l-48.2 0 32.7-41.5 16.9 39.5-1.4 1.9zm-146.6 0l-37.9 0C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240zM480 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faSort = {
  prefix: 'fad',
  iconName: 'sort',
  icon: [
    320,
    512,
    ['unsorted'],
    'f0dc',
    [
      'M0 320c0 8.3 3.3 16.5 9.4 22.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8C.8 311.7 0 315.9 0 320z',
      'M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z',
    ],
  ],
};
const faUnsorted = faSort;
const faListOl = {
  prefix: 'fad',
  iconName: 'list-ol',
  icon: [
    512,
    512,
    ['list-1-2', 'list-numeric'],
    'f0cb',
    [
      'M192 96c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l264 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-264 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32z',
      'M48 32C34.7 32 24 42.8 24 56s10.7 24 24 24l8 0 0 96-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-120c0-13.3-10.7-24-24-24L48 32zM62.6 342.4c5.7-8.1 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-33.2 0 34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9L12.5 330.1c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z',
    ],
  ],
};
const faList12 = faListOl;
const faListNumeric = faListOl;
const faChartWaterfall = {
  prefix: 'fad',
  iconName: 'chart-waterfall',
  icon: [
    512,
    512,
    [],
    'e0eb',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M352 64c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32zm-64 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zM480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224z',
    ],
  ],
};
const faSparkle = {
  prefix: 'fad',
  iconName: 'sparkle',
  icon: [
    448,
    512,
    [],
    'e5d6',
    [
      'M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9L142.7 174.7 13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L305.3 174.7 245.8 45.9z',
      '',
    ],
  ],
};
const faFaceParty = {
  prefix: 'fad',
  iconName: 'face-party',
  icon: [
    640,
    512,
    [],
    'e383',
    [
      'M64 256c0 141.4 114.6 256 256 256c88 0 165.6-44.4 211.7-112L416 400c-1 0-2 0-3-.1c-1.2 2.3-2.7 4.4-4.3 6.4c-4.3 5.2-10.1 9.7-16.7 13.4C378.7 427.1 361.4 432 344 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c.5-.3 .8-.5 1.2-.7c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5c-2.8-1.6-4.3-4.2-4.3-7.1s1.6-5.6 4.1-7c.5-.3 .8-.5 1.2-.7c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5c-3.4-1.9-5-5.6-4.1-9.2s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c1.6 2 3.1 4.1 4.3 6.4c1-.1 2-.1 3-.1l80 0c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80l3.3 0C529.7 73.8 433.4 0 320 0C178.6 0 64 114.6 64 256zm115.2-41.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4zm160 0c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2zM204.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zm160 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM512 256c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-26.5 0-48-21.5-48-48z',
    ],
  ],
};
const faKidneys = {
  prefix: 'fad',
  iconName: 'kidneys',
  icon: [
    640,
    512,
    [],
    'f5fb',
    [
      'M196.3 233c-1.4-16.8 3.2-33.5 12.8-47.3l64 32c19 9.5 31 28.9 31 50.1L304 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-220.2c0-3-1.7-5.8-4.4-7.2L196.3 233zM336 267.8c0-21.2 12-40.6 31-50.1l64-32c8.5 12.1 13 26.6 13 41.4c0 2-.1 3.9-.2 5.9l-55.3 27.7c-2.7 1.4-4.4 4.1-4.4 7.2L384 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-220.2z',
      'M87.7 23.8C106.5 6.3 130.5 0 152 0l3.2 0c19.9 0 39.4 5.9 55.9 16.9l3.4 2.3C240.4 36.5 256 65.6 256 96.7c0 22.8-8.4 44.8-23.5 61.9l-18.2 20.5c-13.4 15.1-19.9 35.1-17.9 55.1l4.1 41.2c5.8 58.1-39.8 108.5-98.2 108.5c-46.5 0-88.2-32.9-95.3-80.9C3.5 278.7 0 248.9 0 224C0 119.6 56.4 52.8 87.7 23.8zm464.6 0C583.6 52.8 640 119.6 640 224c0 24.9-3.5 54.7-7.1 79.1c-7.1 48-48.8 80.9-95.3 80.9c-58.4 0-104-50.4-98.2-108.5l4.1-41.2c2-20.1-4.5-40.1-17.9-55.1l-18.2-20.5C392.4 141.6 384 119.6 384 96.7c0-31.2 15.6-60.2 41.5-77.5l3.4-2.3C445.5 5.9 464.9 0 484.8 0L488 0c21.5 0 45.5 6.3 64.3 23.8z',
    ],
  ],
};
const faWifiExclamation = {
  prefix: 'fad',
  iconName: 'wifi-exclamation',
  icon: [
    640,
    512,
    [],
    'e2cf',
    [
      'M8.9 202c12.2 12.8 32.5 13.2 45.2 .9c51.3-49.2 116.2-84.3 188.5-99.1l-1.4-19.3c-1.2-17.4 3.3-33.9 11.9-47.6C159.4 51 75.1 94.1 9.8 156.7C-2.9 169-3.3 189.2 8.9 202zM126.7 309.2c11.7 13.3 31.9 14.5 45.2 2.8c23.6-20.8 51.6-36.7 82.4-46.2l-4.7-65.1C204.4 212 163.4 234.1 129.5 264c-13.3 11.7-14.5 31.9-2.8 45.2zm259.1-43.4c30.8 9.4 58.8 25.4 82.4 46.2c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2c-33.9-29.9-74.9-52-120.1-63.3l-4.6 65.1zM386.8 37c8.6 13.7 13.1 30.1 11.9 47.6l-1.4 19.3c72.3 14.8 137.2 49.9 188.5 99.1c12.8 12.2 33 11.8 45.2-.9c6-6.2 8.9-14.2 8.9-22.2c0-8.4-3.3-16.8-9.8-23.1C564.9 94.1 480.6 51 386.8 37z',
      'M320 32c-27.2 0-48.7 23.1-46.8 50.2l14.9 208C289.3 307 303.2 320 320 320s30.7-13 31.9-29.7l14.9-208C368.7 55.1 347.2 32 320 32zm0 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faChartNetwork = {
  prefix: 'fad',
  iconName: 'chart-network',
  icon: [
    640,
    512,
    [],
    'f78a',
    [
      'M119.4 272c5.4 9.4 8.6 20.3 8.6 32c0 .7 0 1.5 0 2.2s-.1 1.4-.1 2.2c-.1 1.4-.2 2.9-.4 4.3c-.4 2.8-.9 5.6-1.7 8.2c-1.5 5.4-3.6 10.5-6.3 15.2l76.1 0c14.6 64.1 71.9 112 140.4 112c40.8 0 77.7-17 103.9-44.3L512 446.9c.4-23.6 13.6-44.1 32.9-54.9l-72-43.2c4.6-14.1 7.1-29.2 7.1-44.8c0-20.3-4.2-39.7-11.8-57.2l82-60.2c-20.5-9-35.3-28.5-37.8-51.6l-82.1 60.2C405 173.3 372.1 160 336 160c-10.4 0-20.6 1.1-30.4 3.2l-29.2-62.5C264.9 117.2 245.7 128 224 128c-.9 0-1.9 0-2.8-.1c-.9 0-1.9-.1-2.8-.2l29.2 62.5C221.8 210.4 203 239 195.6 272l-76.1 0zM384 304a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M224 128A64 64 0 1 0 224 0a64 64 0 1 0 0 128zm352 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm64 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 368a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faPersonDressBurst = {
  prefix: 'fad',
  iconName: 'person-dress-burst',
  icon: [
    640,
    512,
    [],
    'e544',
    [
      'M4 219.6c0 1.2 .1 2.4 .4 3.6c1.5 6.4 6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2c.3-1.2 .4-2.4 .4-3.6c0-5.2-2.5-10.1-6.9-13.2l-65.6-45.1L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-4.4 3-6.9 8-6.9 13.2z',
      'M480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM408 384l-17.8 0c-10.9 0-18.6-10.7-15.2-21.1l38.3-114.8-33.9 56.3c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3l11.6 0c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L585 362.9c3.5 10.4-4.3 21.1-15.2 21.1L552 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z',
    ],
  ],
};
const faDiceD4 = {
  prefix: 'fad',
  iconName: 'dice-d4',
  icon: [
    512,
    512,
    [],
    'f6d0',
    [
      'M2.9 302.8c-4.7 6.7-3.6 15.8 2.5 21.2l208 184c4.7 4.2 11.4 5.2 17.2 2.6s9.4-8.3 9.4-14.6l0-480c0-7-4.5-13.2-11.2-15.3c-1.6-.5-3.2-.7-4.8-.7c-5.1 0-10 2.5-13.1 6.8l-208 296z',
      'M272 16c0-7 4.5-13.2 11.2-15.3s13.9 .3 17.9 6.1l208 296c4.7 6.7 3.6 15.8-2.5 21.2l-208 184c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6l0-480z',
    ],
  ],
};
const faMoneyCheckDollar = {
  prefix: 'fad',
  iconName: 'money-check-dollar',
  icon: [
    576,
    512,
    ['money-check-alt'],
    'f53d',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm76.2 86.6c.1-1.3 .2-2.5 .4-3.7c.3-2.4 .9-4.8 1.5-7c1.3-4.5 3.2-8.5 5.6-12.2c4.7-7.3 11.2-13 18.2-17.1c6.9-4.1 14.5-6.8 22.2-8.5c0-4.7 0-9.4 0-14.2c0-.5 0-1.2 .1-1.9s.2-1.3 .3-2c.3-1.3 .7-2.6 1.2-3.8c1-2.4 2.5-4.5 4.3-6.4c3.6-3.6 8.6-5.9 14.1-5.9c11 0 20 9 20 20c0 4.6 0 9.2 0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-2.4 1.4-3.9 2.8-4.9 4.3c-.5 .8-.8 1.5-1 2.4c-.1 .4-.2 .8-.2 1.3s-.1 .9-.1 1.4c0 .2 0 .4 0 .6c0 .2 0 .5 .1 .7c.1 .5 .3 .9 .6 1.5c.7 1 2 2.3 4.6 3.8c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c0 1.3 0 2.6-.1 3.8c-.1 1.3-.2 2.5-.3 3.7c-.3 2.4-.7 4.8-1.3 7c-1.2 4.5-3 8.6-5.2 12.4c-4.4 7.5-10.7 13.5-17.9 18c-7.2 4.5-15.2 7.3-23.2 9c0 4.6 0 9.2 0 13.8c0 11-9 20-20 20c-5.5 0-10.5-2.2-14.1-5.9c-1.8-1.8-3.3-4-4.3-6.4c-.5-1.2-.9-2.4-1.2-3.7c-.1-.7-.2-1.3-.3-2s-.1-1.3-.1-2c0-4.9 0-9.7 0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c2-1.3 3.5-2.6 4.5-4.3c.5-.8 .8-1.8 1.1-2.8c.1-.5 .2-1.1 .3-1.6c.1-.6 .1-1.1 .1-1.8c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-6.4-3.8-12.5-8.9-17.1-15.6c-2.3-3.3-4.2-7.1-5.5-11.2c-.7-2.1-1.2-4.3-1.5-6.6c-.2-1.2-.3-2.3-.4-3.5c0-.6-.1-1.2-.1-1.8c0-.6 0-1.1 0-1.9c0-.7 0-1.3 0-1.9s.1-1.3 .1-1.9zm180.1-9.8c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.8c0-.5 0-1 .1-1.5s.1-1.1 .2-1.6zM256 304c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16z',
      'M164 152c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9zm108 40c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0z',
    ],
  ],
};
const faMoneyCheckAlt = faMoneyCheckDollar;
const faVectorSquare = {
  prefix: 'fad',
  iconName: 'vector-square',
  icon: [
    448,
    512,
    [],
    'f5cb',
    [
      'M32 160l64 0 0 192-64 0 0-192zm96-96l192 0 0 64-192 0 0-64zm0 320l192 0 0 64-192 0 0-64zM352 160l64 0 0 192-64 0 0-192z',
      'M368 80l32 0 0 32-32 0 0-32zM352 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM48 432l0-32 32 0 0 32-32 0zM0 384l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm368 48l0-32 32 0 0 32-32 0zm-48-48l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM48 112l0-32 32 0 0 32-32 0zM0 64l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64z',
    ],
  ],
};
const faBreadSlice = {
  prefix: 'fad',
  iconName: 'bread-slice',
  icon: [
    512,
    512,
    [],
    'f7ec',
    [
      'M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64l0 176c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-176c-35.3 0-64-28.7-64-64zM128 304a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M144 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm96 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32z',
    ],
  ],
};
const faLanguage = {
  prefix: 'fad',
  iconName: 'language',
  icon: [
    640,
    512,
    [],
    'f1ab',
    [
      'M0 128C0 92.7 28.7 64 64 64l256 0 0 384L64 448c-35.3 0-64-28.7-64-64L0 128zM76 328c0 7.7 4.4 15 11.9 18.3c10.1 4.5 21.9-.1 26.4-10.2c3-6.7 6-13.4 8.9-20.1l73.6 0c3 6.7 6 13.4 8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2c10.1-4.5 14.6-16.2 10.2-26.4c-21.3-48-42.7-96-64-144c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-1.2 2.6-1.7 5.4-1.7 8.1zm65-52l19-42.8L179 276l-38 0z',
      'M640 128c0-35.3-28.7-64-64-64L320 64l0 384 256 0c35.3 0 64-28.7 64-64l0-256zM500 184l0 4 44 0 16 0c11 0 20 9 20 20s-9 20-20 20l-2 0-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45L480 228l-72 0c-11 0-20-9-20-20s9-20 20-20l52 0 0-4c0-11 9-20 20-20s20 9 20 20zM160 164c-7.9 0-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1 73.6 0 8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144c-3.2-7.2-10.4-11.9-18.3-11.9zm0 69.2L179 276l-38 0 19-42.8z',
    ],
  ],
};
const faWheatAwnSlash = {
  prefix: 'fad',
  iconName: 'wheat-awn-slash',
  icon: [
    640,
    512,
    [],
    'e338',
    [
      'M64 480c0-8.2 3.1-16.4 9.4-22.6l68.9-68.9L131.9 378c-37.5-37.5-37.5-98.3 0-135.8L143.2 231c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c21 21 33.2 47.5 36.5 74.8l29.5-29.5 50.6 39.9-36.3 36.3c28.5 2.8 56.2 15.1 78.1 36.9L346.8 412c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-68.9 68.9c-6.2 6.2-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4S64 488.2 64 480zM224.7 150.8c2.7-3.6 5.7-7.1 9-10.4L245 129.1c6.2-6.2 16.4-6.2 22.6 0L279 140.5c21 21 33.2 47.5 36.5 74.8l30.5-30.5-10.4-10.4c-37.5-37.5-37.5-98.3 0-135.8l11.3-11.3c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c4.5 4.5 8.6 9.3 12.4 14.3L439 7c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9L414.7 99.2c5.1 21.5 4.7 44-1.4 65.3c20.3-5.8 41.8-6.5 62.3-2.1L535 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-46.2 46.2c5.7 4.1 11.2 8.7 16.4 13.9l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-28.7 28.7c-45.9-36-91.8-72-137.8-108zM447 95L535 7c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faFaceKissWinkHeart = {
  prefix: 'fad',
  iconName: 'face-kiss-wink-heart',
  icon: [
    512,
    512,
    [128536, 'kiss-wink-heart'],
    'f598',
    [
      'M0 256C0 397.4 114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm71.9 86c.9-3.5 4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 4.1-9.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.6-.3c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.3-7.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7c-3.2-1.8-4.7-5.5-3.8-9zm58.9-79.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm162.8 25.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z',
    ],
  ],
};
const faKissWinkHeart = faFaceKissWinkHeart;
const faDagger = {
  prefix: 'fad',
  iconName: 'dagger',
  icon: [
    384,
    512,
    [],
    'f6cb',
    [
      'M128 192l0 24 0 198.8c0 10.5 2.9 20.8 8.5 29.7l35.1 56.2c4.4 7 12.1 11.3 20.4 11.3s16-4.3 20.4-11.3l35.1-56.2c5.6-8.9 8.5-19.2 8.5-29.7L256 216l0-24-24 0-40 0-40 0-24 0z',
      'M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96L48 128c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32l98.7 0 98.7 0c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48s-21.5-48-48-48l-112 0 0-96z',
    ],
  ],
};
const faPodium = {
  prefix: 'fad',
  iconName: 'podium',
  icon: [
    448,
    512,
    [],
    'f680',
    [
      'M44.4 192l359.1 0L374.3 455.1c-3.6 32.4-31 56.9-63.6 56.9l-173.4 0c-32.6 0-60-24.5-63.6-56.9L44.4 192z',
      'M182.4 72L168 72c-22.1 0-40 17.9-40 40l0 32 296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-32c0-48.6 39.4-88 88-88l14.4 0C190.7 9.7 206.2 0 224 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-17.8 0-33.3-9.7-41.6-24z',
    ],
  ],
};
const faDiamonds4 = {
  prefix: 'fad',
  iconName: 'diamonds-4',
  icon: [
    512,
    512,
    [],
    'e68b',
    [
      'M153.7 85.8c-12.5 12.5-12.5 32.8 0 45.3l79.7 79.7c12.5 12.5 32.8 12.5 45.3 0L358.3 131c12.5-12.5 12.5-32.8 0-45.3L284.3 11.7C276.5 3.9 266.2 0 256 0s-20.5 3.9-28.3 11.7L153.7 85.8zm0 295.2c-12.5 12.5-12.5 32.8 0 45.3l74.1 74.1c7.8 7.8 18 11.7 28.3 11.7s20.5-3.9 28.3-11.7l74.1-74.1c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-79.7-79.7c-12.5-12.5-32.8-12.5-45.3 0L153.7 381z',
      'M131 153.7c-12.5-12.5-32.8-12.5-45.3 0L11.7 227.7c-15.6 15.6-15.6 40.9 0 56.6l74.1 74.1c12.5 12.5 32.8 12.5 45.3 0l79.7-79.7c12.5-12.5 12.5-32.8 0-45.3L131 153.7zM381 358.3c12.5 12.5 32.8 12.5 45.3 0l74.1-74.1c15.6-15.6 15.6-40.9 0-56.6l-74.1-74.1c-12.5-12.5-32.8-12.5-45.3 0l-79.7 79.7c-12.5 12.5-12.5 32.8 0 45.3L381 358.3z',
    ],
  ],
};
const faMemoCircleCheck = {
  prefix: 'fad',
  iconName: 'memo-circle-check',
  icon: [
    576,
    512,
    [],
    'e1d9',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c3.3 0 6.6-.3 9.7-.7C285.1 479.3 256 427.1 256 368c0-80.6 54.1-148.5 128-169.4L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 80c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faRouteHighway = {
  prefix: 'fad',
  iconName: 'route-highway',
  icon: [
    448,
    512,
    [],
    'f61a',
    [
      'M0 323c0 49.5 28 94.8 72.2 116.9l137.4 68.7c4.5 2.3 9.4 3.4 14.3 3.4s9.8-1.1 14.3-3.4l137.4-68.7C420 417.8 448 372.5 448 323c0-16.6-3.2-33.1-9.3-48.5l-14.3-35.7c-5.5-13.9-8.4-28.6-8.4-43.6c0-1.1 0-2.2 0-3.2L32 192c0 1.1 0 2.2 0 3.2c0 14.9-2.8 29.7-8.4 43.6L9.3 274.5C3.2 289.9 0 306.4 0 323z',
      'M240.5 4.6c-10.1-6.1-22.8-6.1-32.9 0l-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7c-15.2-7.6-33.7-2-42.1 12.7l-32 56c-5.3 9.3-5.6 20.6-.8 30.2l16.2 32.5C27.3 158.1 31.5 174.9 32 192L416 192c.5-17.1 4.7-33.9 12.3-49.2l16.2-32.5c4.8-9.6 4.5-20.9-.8-30.2l-32-56c-8.4-14.7-26.9-20.3-42.1-12.7l-1.4 .7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8z',
    ],
  ],
};
const faDownToLine = {
  prefix: 'fad',
  iconName: 'down-to-line',
  icon: [
    384,
    512,
    ['arrow-alt-to-bottom'],
    'f34a',
    [
      'M0 448c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
      'M219.3 372.7L342.1 249.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L256 192l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C47.2 192 32 207.2 32 225.9c0 9 3.6 17.6 9.9 24L164.7 372.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3z',
    ],
  ],
};
const faArrowAltToBottom = faDownToLine;
const faFilter = {
  prefix: 'fad',
  iconName: 'filter',
  icon: [
    512,
    512,
    [],
    'f0b0',
    [
      'M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z',
      '',
    ],
  ],
};
const faSquareG = {
  prefix: 'fad',
  iconName: 'square-g',
  icon: [
    448,
    512,
    [],
    'e271',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 256c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176z',
    ],
  ],
};
const faCirclePhone = {
  prefix: 'fad',
  iconName: 'circle-phone',
  icon: [
    512,
    512,
    ['phone-circle'],
    'e11b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-96c0-9 6-16.9 14.7-19.3c14.7-4 29.3-8 44-12c1.8-.5 3.5-.7 5.3-.7c7.9 0 15.3 4.7 18.5 12.3c6.7 16 13.3 32 20 48c3.4 8.2 1 17.6-5.8 23.2c-8.2 6.7-16.4 13.5-24.7 20.2c16.6 35.2 45.1 63.7 80.3 80.3c6.7-8.2 13.5-16.4 20.2-24.7c5.6-6.8 15-9.2 23.2-5.8c16 6.7 32 13.3 48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C368.9 378 361 384 352 384c-123.7 0-224-100.3-224-224z',
      'M210.5 140.3c-3.9-9.3-14-14.2-23.7-11.6l-44 12C134 143.1 128 151 128 160c0 123.7 100.3 224 224 224c9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L280.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48z',
    ],
  ],
};
const faPhoneCircle = faCirclePhone;
const faClipboardPrescription = {
  prefix: 'fad',
  iconName: 'clipboard-prescription',
  icon: [
    384,
    512,
    [],
    'f5e8',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zm84 88c0-11 9-20 20-20l72 0c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-3.8 3.5-8.7 5.3-13.5 5.3c-5.4 0-10.8-2.2-14.7-6.5c-7.5-8.1-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6l-20 0 0 44c0 11-9 20-20 20s-20-9-20-20l0-64 0-80zm40 20l0 40 52 0c11 0 20-9 20-20s-9-20-20-20l-52 0z',
      'M113.2 66.3C93.9 72.6 80 90.7 80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24c0-21.3-13.9-39.4-33.2-45.7C264.4 28.7 231.5 0 192 0s-72.4 28.7-78.8 66.3zM168 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 196c-11 0-20 9-20 20l0 80 0 64c0 11 9 20 20 20s20-9 20-20l0-44 20 0c.7 .9 1.5 1.8 2.3 2.6l64.8 60.8-32.6 29.9c-8.1 7.5-8.7 20.1-1.2 28.3s20.1 8.7 28.3 1.2l34.9-32 33.9 31.8c8.1 7.6 20.7 7.1 28.3-.9s7.1-20.7-.9-28.3L270 379.7l31.6-28.9c8.1-7.5 8.7-20.1 1.2-28.3s-20.1-8.7-28.3-1.2l-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60l-72 0zm72 80l-52 0 0-40 52 0c11 0 20 9 20 20s-9 20-20 20z',
    ],
  ],
};
const faUserNurseHair = {
  prefix: 'fad',
  iconName: 'user-nurse-hair',
  icon: [
    448,
    512,
    [],
    'e45d',
    [
      'M96.1 170.7c3.7 1.7 7.5 3.1 11.5 4c2 .4 4 .8 6.1 1c1 .1 2 .2 3.2 .3c.9 0 1.9 .1 3.1 .1c24 0 48 0 72 0c34.6 0 65-18.3 81.9-45.8C285.2 148.1 305.2 160 328 160c8 0 15.9 0 24 0c0 1.5 0 2.9 0 4.4C352 232.7 296.7 288 228.4 288l-8.8 0c-66.2 0-120.2-52-123.5-117.3z',
      'M96 96l0 32 0 42.6c7.3 3.5 15.4 5.4 24 5.4l72 0c34.6 0 65-18.3 81.9-45.8C285.2 148.1 305.2 160 328 160l24 0 0-32 0-32 0-25.8c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2L96 96zm45.3 240.2c-7.6-8.1-18.9-11.9-29.4-8.5C47 348.5 0 409.4 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-71.9-47-132.7-111.9-153.6c-10.5-3.4-21.8 .4-29.4 8.5l-71 75.5c-6.3 6.7-17 6.7-23.3 0l-71-75.5zM208 48c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0 0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l16 0 0-16z',
    ],
  ],
};
const faQuestion = {
  prefix: 'fad',
  iconName: 'question',
  icon: [
    320,
    512,
    [10067, 10068, 61736],
    '3f',
    [
      'M120 440a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M144 96c-35.3 0-64 28.7-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2l0 1.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.4c0-29.9 15.2-57.8 40.4-74l42.2-27.1c18.3-11.8 29.4-32.1 29.4-53.8l0-3.6c0-35.3-28.7-64-64-64l-32 0z',
    ],
  ],
};
const faFileSignature = {
  prefix: 'fad',
  iconName: 'file-signature',
  icon: [
    576,
    512,
    [],
    'f573',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-57.2-1.1 1.1c-4.1 4.1-9.2 7-14.9 8.4L310 414.9c-1.8 .7-3.9 1.1-6 1.1c-21.3 .1-42.7 .1-64 .1c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 41.6 0c4-16.1 8-32.1 12-48.2c1.4-5.6 4.3-10.8 8.4-14.9c24-24 48-48.1 72.1-72.1l0-88.9-128 0c-17.7 0-32-14.3-32-32L224 0 64 0C28.7 0 0 28.7 0 64z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zm165.8-20.3l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 321L441.1 191.8l71 71L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z',
    ],
  ],
};
const faToggleLargeOn = {
  prefix: 'fad',
  iconName: 'toggle-large-on',
  icon: [
    576,
    512,
    [],
    'e5b1',
    [
      'M0 256C0 362 86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256zm512 0a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z',
      'M384 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z',
    ],
  ],
};
const faUpDownLeftRight = {
  prefix: 'fad',
  iconName: 'up-down-left-right',
  icon: [
    512,
    512,
    ['arrows-alt'],
    'f0b2',
    [
      'M162.4 108.2c5 12 16.6 19.8 29.6 19.8l32 0 0 96 64 0 0-96 32 0c12.9 0 24.6-7.8 29.6-19.8c1.6-4 2.4-8.1 2.4-12.2c0-8.3-3.3-16.5-9.4-22.6l-64-64C272.4 3.1 264.2 0 256 0s-16.4 3.1-22.6 9.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9zm0 295.5c-5 12-2.2 25.7 6.9 34.9l64 64c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-96c-21.3 0-42.7 0-64 0l0 96-32 0c-12.9 0-24.6 7.8-29.6 19.8z',
      'M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 256 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-256 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64z',
    ],
  ],
};
const faArrowsAlt = faUpDownLeftRight;
const faDryerHeat = {
  prefix: 'fad',
  iconName: 'dryer-heat',
  icon: [
    448,
    512,
    ['dryer-alt'],
    'f862',
    [
      'M152 224c0 4.1 1.6 8.2 4.7 11.3L177.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7c6.2-6.2 6.2-16.4 0-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0c-3.1 3.1-4.7 7.2-4.7 11.3zm8-136a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 248c0 14.5 5.8 28.4 16 38.6l20.7 20.7c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7s4.7-7.2 4.7-11.3s-1.6-8.2-4.7-11.3L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L257.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6z',
      'M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faDryerAlt = faDryerHeat;
const faHouseChimneyUser = {
  prefix: 'fad',
  iconName: 'house-chimney-user',
  icon: [
    576,
    512,
    [],
    'e065',
    [
      'M64 270.5l224-196c74.7 65.4 149.4 130.7 224.1 196.1l.4 177.3c.1 35.4-28.6 64.1-64 64.1l-320.4 0c-35.3 0-64-28.6-64-64L64 270.5zM176.1 433.6c.1 .5 .1 1.1 .2 1.6c.2 1 .5 2 .9 3c.8 1.9 2 3.6 3.4 5.1c2.9 2.9 6.9 4.7 11.3 4.7l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-22.1 0-42.1 9-56.6 23.4c-7.2 7.2-13.1 15.9-17.1 25.4c-2 4.8-3.6 9.8-4.7 15c-.5 2.6-.9 5.3-1.2 7.9c-.1 1.3-.2 2.7-.3 4.1c-.1 1.4-.1 2.7-.1 4.1c0 .6 0 1.1 .1 1.6zm48.2-184.2c-.1 1.1-.2 2.2-.2 3.2c-.1 1.1-.1 2.2-.1 3.3s0 2.2 .1 3.3c.1 1.1 .1 2.2 .2 3.2c.2 2.1 .5 4.3 1 6.4c.9 4.2 2.1 8.2 3.7 12c3.2 7.7 7.9 14.6 13.7 20.3C254.3 312.8 270.3 320 288 320c35.3 0 64-28.7 64-64s-28.7-64-64-64c-17.7 0-33.7 7.2-45.3 18.7c-5.8 5.8-10.5 12.7-13.7 20.3c-1.6 3.8-2.9 7.8-3.7 12c-.4 2.1-.8 4.2-1 6.4z',
      'M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5 512 64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 37.5L309.1 7.9zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z',
    ],
  ],
};
const faHandHoldingHeart = {
  prefix: 'fad',
  iconName: 'hand-holding-heart',
  icon: [
    576,
    512,
    [],
    'f4be',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M163.9 28.9c-29.4 29.8-29.4 78.2 0 108L265.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L412.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L288 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0z',
    ],
  ],
};
const faArrowUpSmallBig = {
  prefix: 'fad',
  iconName: 'arrow-up-small-big',
  icon: [
    576,
    512,
    ['sort-size-up-alt'],
    'f88f',
    [
      'M320 80l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm0 224l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortSizeUpAlt = faArrowUpSmallBig;
const faTrainTrack = {
  prefix: 'fad',
  iconName: 'train-track',
  icon: [
    576,
    512,
    [],
    'e453',
    [
      'M0 384c0-17.7 14.3-32 32-32l30.3 0L40.9 416 32 416c-17.7 0-32-14.3-32-32zM40 256c0-17.7 14.3-32 32-32l32.9 0L83.6 288 72 288c-17.7 0-32-14.3-32-32zM80 128c0-17.7 14.3-32 32-32l35.6 0c-7.1 21.3-14.2 42.7-21.3 64L112 160c-17.7 0-32-14.3-32-32zm28.4 288c7.1-21.3 14.2-42.7 21.3-64l316.5 0c7.1 21.3 14.2 42.7 21.3 64l-359.2 0zm42.7-128c7.1-21.3 14.2-42.7 21.3-64l231.2 0 21.3 64-273.9 0zm42.7-128c7.1-21.3 14.2-42.7 21.3-64l145.9 0c7.1 21.3 14.2 42.7 21.3 64l-188.5 0zM428.4 96L464 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-14.3 0L428.4 96zm42.7 128l32.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-11.6 0c-7.1-21.3-14.2-42.7-21.3-64zm42.7 128l30.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8.9 0c-7.1-21.3-14.2-42.7-21.3-64z',
      'M202.1 33.6c16.8 5.6 25.8 23.7 20.2 40.5l-128 384c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l128-384c5.6-16.8 23.7-25.8 40.5-20.2zm171.8 0c16.8-5.6 34.9 3.5 40.5 20.2l128 384c5.6 16.8-3.5 34.9-20.2 40.5s-34.9-3.5-40.5-20.2l-128-384c-5.6-16.8 3.5-34.9 20.2-40.5z',
    ],
  ],
};
const faPuzzlePiece = {
  prefix: 'fad',
  iconName: 'puzzle-piece',
  icon: [
    512,
    512,
    [129513],
    'f12e',
    [
      'M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2l56.8 0c26.5 0 48 21.5 48 48l0 56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2L384 464c0 26.5-21.5 48-48 48l-56.8 0c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2L48 512c-26.5 0-48-21.5-48-48L0 343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8L0 176c0-26.5 21.5-48 48-48l120.8 0c12.8 0 23.2-10.4 23.2-23.2z',
      '',
    ],
  ],
};
const faMoneyCheck = {
  prefix: 'fad',
  iconName: 'money-check',
  icon: [
    576,
    512,
    [],
    'f53c',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zM96 240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16zM384 184c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48z',
      'M408 160c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zM112 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z',
    ],
  ],
};
const faStarHalfStroke = {
  prefix: 'fad',
  iconName: 'star-half-stroke',
  icon: [
    576,
    512,
    ['star-half-alt'],
    'f5c0',
    [
      'M288.1 0c.5 0 1.1 0 1.6 0c11.6 .6 22.1 7.4 27.2 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7c1.1 3.3 1.6 6.6 1.6 10c0 8.4-3.3 16.6-9.5 22.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3c-5.1 3.7-11.1 5.7-17.1 6l-3.2 0c-4.6-.2-9.2-1.5-13.5-3.7c-42.8-22.8-85.6-45.7-128.5-68.4c0-21.2 0-42.3 .1-63.5c8.9 4.7 17.6 9.3 26.4 14l85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6c-14.2-29.3-28.5-58.6-42.9-87.6c0-29 0-58.1 .1-87.2z',
      'M289.7 0L288 0l0 87.1 0 289.2 0 63.5L159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18c.5 0 1.1 0 1.6 0zM433.2 512c-1.1 .1-2.1 .1-3.2 0l3.2 0z',
    ],
  ],
};
const faStarHalfAlt = faStarHalfStroke;
const faFileExclamation = {
  prefix: 'fad',
  iconName: 'file-exclamation',
  icon: [
    384,
    512,
    [],
    'f31a',
    [
      'M0 64C0 28.7 28.7 0 64 0c53.3 0 106.7 0 160 0c0 42.7 0 85.3 0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 416c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4c2.9-2.9 5.2-6.3 6.9-10.2c.8-1.9 1.4-3.9 1.9-6c.2-1 .4-2.1 .5-3.2c.1-.6 .1-1.1 .1-1.6c0-.5 0-1 0-1.3l0-.4 0-.4c0-.3 0-.7 0-1.2s-.1-1.1-.1-1.6c-.1-1.1-.3-2.1-.5-3.2c-.4-2.1-1.1-4.1-1.9-6c-1.6-3.8-4-7.3-6.9-10.2c-5.8-5.8-13.8-9.4-22.6-9.4c-17.7 0-32 14.3-32 32zm8-200c0 37.3 0 74.7 0 112c0 13.3 10.7 24 24 24c6.6 0 12.6-2.7 17-7c2.2-2.2 3.9-4.8 5.1-7.6c.6-1.4 1.1-2.9 1.4-4.5c.2-.8 .3-1.6 .4-2.4c.1-.8 .1-1.6 .1-2.2c0-37.7 0-75 0-112.3c0-.9 0-1.7-.1-2.5s-.2-1.6-.4-2.4c-.3-1.6-.8-3.1-1.4-4.5c-1.2-2.9-3-5.5-5.1-7.6c-4.3-4.3-10.3-7-17-7c-13.3 0-24 10.7-24 24z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM192 192c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faCode = {
  prefix: 'fad',
  iconName: 'code',
  icon: [
    640,
    512,
    [],
    'f121',
    [
      'M225.2 471.2c-4.9 17 5 34.7 22 39.6c2.9 .8 5.9 1.2 8.8 1.2c13.9 0 26.7-9.2 30.7-23.2l128-448c.8-2.9 1.2-5.9 1.2-8.8c0-13.9-9.2-26.7-23.2-30.8c-17-4.9-34.7 5-39.6 22l-128 448z',
      'M473.4 121.4c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z',
    ],
  ],
};
const faWhiskeyGlass = {
  prefix: 'fad',
  iconName: 'whiskey-glass',
  icon: [
    512,
    512,
    [129347, 'glass-whiskey'],
    'f7a0',
    [
      'M.3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6zM69 96l374 0c-6.2 42.7-12.4 85.3-18.7 128l-26 178.3c-1.1 7.9-7.9 13.7-15.8 13.7l-253 0c-7.9 0-14.7-5.8-15.8-13.7L87.7 224C81.5 181.3 75.2 138.7 69 96z',
      'M424.3 224L87.7 224l26 178.3c1.1 7.9 7.9 13.7 15.8 13.7l253 0c7.9 0 14.7-5.8 15.8-13.7l26-178.3z',
    ],
  ],
};
const faGlassWhiskey = faWhiskeyGlass;
const faMoonStars = {
  prefix: 'fad',
  iconName: 'moon-stars',
  icon: [
    512,
    512,
    [],
    'f755',
    [
      'M240 80c0 3.8 2.5 7.1 6.2 8.2l38.6 11 11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2zm80 144c0 5.7 3.8 10.7 9.2 12.2l58 16.6 16.6 58c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2z',
      'M191.8 128C85.8 128 0 214.1 0 320.2S85.8 512.4 191.8 512.4c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z',
    ],
  ],
};
const faBuildingCircleExclamation = {
  prefix: 'fad',
  iconName: 'building-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e4d3',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 184.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faClothesHanger = {
  prefix: 'fad',
  iconName: 'clothes-hanger',
  icon: [
    640,
    512,
    [],
    'e136',
    [
      'M209.8 84.8C222.3 35 267.1 0 318.5 0L320 0c61.9 0 112 50.1 112 112l0 6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8L608.2 377.2C628.1 391 640 413.7 640 438c0 40.9-33.1 74-74 74L74 512c-40.9 0-74-33.1-74-74c0-24.2 11.9-47 31.8-60.8L301.6 189.8l.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3l0-6.3c0-26.5-21.5-48-48-48l-1.5 0c-22 0-41.2 15-46.6 36.4l-.9 3.4c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l.9-3.4zM320 255L68.3 429.7c-2.7 1.9-4.3 4.9-4.3 8.2c0 5.5 4.5 10 10 10l492 0c5.5 0 10-4.5 10-10c0-3.3-1.6-6.4-4.3-8.2L320 255z',
      '',
    ],
  ],
};
const faMobileNotch = {
  prefix: 'fad',
  iconName: 'mobile-notch',
  icon: [
    384,
    512,
    ['mobile-iphone'],
    'e1ee',
    [
      'M16 80C16 35.8 51.8 0 96 0L288 0c44.2 0 80 35.8 80 80l0 352c0 44.2-35.8 80-80 80L96 512c-44.2 0-80-35.8-80-80L16 80zm64 0l0 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16l-32 0 0 16c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-16L96 64c-8.8 0-16 7.2-16 16z',
      'M128 64H96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H256V80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V64z',
    ],
  ],
};
const faMobileIphone = faMobileNotch;
const faMagnifyingGlassChart = {
  prefix: 'fad',
  iconName: 'magnifying-glass-chart',
  icon: [
    512,
    512,
    [],
    'e522',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm104 8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64zm80-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160zm80 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96z',
      'M104 216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64zm80-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160zm80 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96zM457.4 502.6L330.7 376C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z',
    ],
  ],
};
const faArrowUpRightFromSquare = {
  prefix: 'fad',
  iconName: 'arrow-up-right-from-square',
  icon: [
    512,
    512,
    ['external-link'],
    'f08e',
    [
      'M0 112C0 67.8 35.8 32 80 32l112 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 112c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112z',
      'M288 32c0-17.7 14.3-32 32-32L480 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 64 320 64c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faExternalLink = faArrowUpRightFromSquare;
const faCubesStacked = {
  prefix: 'fad',
  iconName: 'cubes-stacked',
  icon: [
    448,
    512,
    [],
    'e4e6',
    [
      'M0 384c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c5-2.9 10.5-4.3 16-4.3c11.1 0 21.8 5.7 27.7 16l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM320 384c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64z',
      'M224 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zm32 192l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM160 384l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faImagesUser = {
  prefix: 'fad',
  iconName: 'images-user',
  icon: [
    576,
    512,
    [],
    'e1b9',
    [
      'M96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM224 301.7c0-25.2 20.5-45.7 45.7-45.7l132.6 0c25.2 0 45.7 20.5 45.7 45.7c0 10.1-8.2 18.3-18.3 18.3l-187.4 0c-10.1 0-18.3-8.2-18.3-18.3zM400 160a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm352 40a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM224 301.7c0 10.1 8.2 18.3 18.3 18.3l187.4 0c10.1 0 18.3-8.2 18.3-18.3c0-25.2-20.5-45.7-45.7-45.7l-132.6 0c-25.2 0-45.7 20.5-45.7 45.7z',
    ],
  ],
};
const faWonSign = {
  prefix: 'fad',
  iconName: 'won-sign',
  icon: [
    512,
    512,
    [8361, 'krw', 'won'],
    'f159',
    [
      'M0 256c0 17.7 14.3 32 32 32l40.9 0L51.6 224 32 224c-17.7 0-32 14.3-32 32zm119.1-32c7.1 21.3 14.2 42.7 21.3 64l26.6 0 16-64-63.9 0zM233 288l46 0-16-64-14 0c-5.3 21.3-10.7 42.7-16 64zm96-64c5.3 21.3 10.7 42.7 16 64l26.6 0 21.3-64L329 224zm110.1 64l40.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-19.6 0c-7.1 21.3-14.2 42.7-21.3 64z',
      'M21.9 33.6c16.8-5.6 34.9 3.5 40.5 20.2l93.2 279.7L225 56.2C228.5 42 241.3 32 256 32s27.5 10 31 24.2l69.3 277.4L449.6 53.9c5.6-16.8 23.7-25.8 40.5-20.2s25.8 23.7 20.2 40.5l-128 384c-4.5 13.5-17.4 22.4-31.6 21.9s-26.4-10.4-29.8-24.2L256 195.9 191 455.8c-3.5 13.8-15.6 23.7-29.8 24.2s-27.1-8.4-31.6-21.9L1.6 74.1C-3.9 57.4 5.1 39.2 21.9 33.6z',
    ],
  ],
};
const faKrw = faWonSign;
const faWon = faWonSign;
const faImagePolaroidUser = {
  prefix: 'fad',
  iconName: 'image-polaroid-user',
  icon: [
    448,
    512,
    [],
    'e1b6',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 32c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-16 0-224 0-16 0c-17.7 0-32-14.3-32-32l0-192z',
      'M96 96c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l16 0c0-35.3 28.7-64 64-64l96 0c35.3 0 64 28.7 64 64l16 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L96 96zm64 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
    ],
  ],
};
const faVirusCovid = {
  prefix: 'fad',
  iconName: 'virus-covid',
  icon: [
    512,
    512,
    [],
    'e4a8',
    [
      'M0 216l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 25.6 0c4.3 32.9 17.2 63 36.5 88L92 386.1 80.6 374.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L125.9 420 144 402c25 19.2 55.2 32.2 88 36.5l0 25.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-25.6c32.9-4.3 63-17.2 88-36.5L386.1 420l-11.3 11.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L420 386.1 402 368c19.2-25 32.2-55.2 36.5-88l25.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-25.6 0c-4.3-32.9-17.2-63-36.5-88L420 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L408.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L386.1 92 368 110c-25-19.2-55.2-32.2-88-36.5L280 48l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 25.6c-32.9 4.3-63 17.2-88 36.5L125.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L46.7 103.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L92 125.9 110 144c-19.2 25-32.2 55.2-36.5 88L48 232l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24zm240 8a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm88 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M192 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96z',
    ],
  ],
};
const faSquareEllipsis = {
  prefix: 'fad',
  iconName: 'square-ellipsis',
  icon: [
    448,
    512,
    [],
    'e26e',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M128 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faPie = {
  prefix: 'fad',
  iconName: 'pie',
  icon: [
    576,
    512,
    [129383],
    'f705',
    [
      'M49.1 307.2l32.3 97c8.7 26.1 33.2 43.8 60.7 43.8l291.7 0c27.5 0 52-17.6 60.7-43.8l32.3-97c-8.9-4.5-17.9-8.9-26.8-13.4c-14.7-7.4-31.7-8.8-47.4-3.9c-13.9 4.3-27.7 8.5-41.6 12.8c-23.3 7.2-48.3 6.5-71.2-1.8c-10-3.6-20-7.3-30-10.9c-1.8-.6-3.6-1.2-5.4-1.7s-3.6-.9-5.4-1.2c-3.7-.6-7.4-1-11.1-1c-7.4 0-14.8 1.3-21.9 3.9c-10 3.6-20 7.3-30 10.9c-22.9 8.3-47.9 9-71.2 1.8c-13.9-4.3-27.7-8.5-41.6-12.8c-15.7-4.8-32.6-3.4-47.3 3.9c-9.1 4.5-18 9-27 13.5z',
      'M542.1 243.3c-7.5-3.8-13.2-10.4-16.3-18.2C488.1 130.7 395.8 64 288 64S87.9 130.7 50.2 225.1c-3.1 7.8-8.8 14.4-16.3 18.2l-16.2 8.1C1.9 259.3-4.5 278.5 3.4 294.3s27.1 22.2 42.9 14.3l29.6-14.8c14.7-7.4 31.7-8.8 47.4-3.9l41.6 12.8c23.3 7.2 48.3 6.5 71.2-1.8l30-10.9c14.1-5.1 29.6-5.1 43.7 0l30 10.9c22.9 8.3 47.9 9 71.2 1.8l41.6-12.8c15.7-4.8 32.7-3.4 47.4 3.9l29.6 14.8c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-16.2-8.1zM206.3 151.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faChessKnightPiece = {
  prefix: 'fad',
  iconName: 'chess-knight-piece',
  icon: [
    320,
    512,
    ['chess-knight-alt'],
    'f442',
    [
      'M0 488c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L272 416 48 416 4.8 473.6C1.7 477.8 0 482.8 0 488z',
      'M50.7 109.3l6.9-6.9L40.7 94C35.4 91.3 32 85.8 32 79.8C32 71.1 39.1 64 47.8 64l81.5 0C225.8 64 304 142.2 304 238.7c0 11.5-1.1 23-3.4 34.3L272 416 48 416l0-26.3c0-29.8 13.8-57.9 37.5-76.1l71.2-54.7c8.1-6.2 8-18.5-.2-24.7c-5.5-4.1-13.1-4.1-18.6 0L99.1 263.3c-2 1.5-4.2 2.9-6.5 4c-13.7 6.9-30 5.8-42.8-2.7l-3.5-2.4C37.3 256.4 32 246.4 32 235.7l0-81.2c0-17 6.7-33.3 18.7-45.3zm42.1 63.5a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faChessKnightAlt = faChessKnightPiece;
const faAustralSign = {
  prefix: 'fad',
  iconName: 'austral-sign',
  icon: [
    448,
    512,
    [],
    'e0a9',
    [
      'M0 256c0-17.7 14.3-32 32-32l90.7 0L96 288l-64 0c-17.7 0-32-14.3-32-32zm0 96c0-17.7 14.3-32 32-32l50.7 0L56 384l-24 0c-17.7 0-32-14.3-32-32zm125.3 32L152 320l144 0 26.7 64-197.3 0zm40-96L192 224l64 0c8.9 21.3 17.8 42.7 26.7 64l-117.3 0zm160-64l90.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-26.7-64zm40 96l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0-26.7-64z',
      'M224 32c12.9 0 24.6 7.8 29.5 19.7l160 384c6.8 16.3-.9 35-17.2 41.8s-35-.9-41.8-17.2L224 147.2 93.5 460.3c-6.8 16.3-25.5 24-41.8 17.2s-24-25.5-17.2-41.8l160-384C199.4 39.8 211.1 32 224 32z',
    ],
  ],
};
const faCloudPlus = {
  prefix: 'fad',
  iconName: 'cloud-plus',
  icon: [
    640,
    512,
    [],
    'e35e',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm208-48c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M296 312l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faF = {
  prefix: 'fad',
  iconName: 'f',
  icon: [
    320,
    512,
    [102],
    '46',
    [
      'M64 32C28.7 32 0 60.7 0 96L0 256 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 224 64 96l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32z',
      '',
    ],
  ],
};
const faLeaf = {
  prefix: 'fad',
  iconName: 'leaf',
  icon: [
    512,
    512,
    [],
    'f06c',
    [
      'M96.4 260.1C102.5 168.5 178.8 96 272 96l104 0c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2c15-13.9 32.5-25.1 51.8-32.8c9.6-3.9 19.7-6.9 30.2-8.9c5.2-1 10.5-1.8 15.9-2.3c2.7-.3 5.4-.5 8.1-.6c1.3-.1 2.7-.1 4.1-.1c1.3 0 2.6 0 4.1 0c24 0 48 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24c-24 0-48 0-72 0c-44.2 0-85.4 13.3-119.6 36.1z',
      'M216 272c-92.8 0-168 75.2-168 168l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16C0 320.7 96.7 224 216 224l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0z',
    ],
  ],
};
const faBedBunk = {
  prefix: 'fad',
  iconName: 'bed-bunk',
  icon: [
    576,
    512,
    [],
    'f8f8',
    [
      'M96 48a48 48 0 1 0 96 0A48 48 0 1 0 96 48zm0 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 32l0 96 32 0 288 0 32 0C576 57.3 518.7 0 448 0L256 0c-17.7 0-32 14.3-32 32zm0 240l0 112 32 0 256 0 0-96 0-32-272 0c-8.8 0-16 7.2-16 16z',
      'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32l0 96 0 64L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 192 0 256 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-32 0-128 0-96 0-32 0-32-32 0-288 0L64 128l0-96zM512 288l0 96-256 0L64 384l0-192 192 0 256 0 0 96z',
    ],
  ],
};
const faRoad = {
  prefix: 'fad',
  iconName: 'road',
  icon: [
    576,
    512,
    [128739],
    'f018',
    [
      'M256 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64-64 0zm0 192l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 192l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M256 32l-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480L256 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 201.4 0c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32L320 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z',
    ],
  ],
};
const faTaxi = {
  prefix: 'fad',
  iconName: 'taxi',
  icon: [
    512,
    512,
    [128662, 'cab'],
    'f1ba',
    [
      'M0 432l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48L0 432zM109.1 224l293.8 0-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4l-181.2 0c-13.6 0-25.7 8.6-30.2 21.4c-8.7 24.9-17.4 49.7-26.1 74.6zM160 32l0 32 5.4 0 181.2 0c1.8 0 3.6 .1 5.4 0l0-32c0-17.7-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32zM416 432l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48-96 0z',
      'M135.2 149.4L109.1 224l293.8 0-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4l-181.2 0c-13.6 0-25.7 8.6-30.2 21.4zM39.6 228.8L74.8 128.3C88.3 89.8 124.6 64 165.4 64l181.2 0c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2l0 144L0 432 0 288c0-26.7 16.4-49.6 39.6-59.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faCab = faTaxi;
const faPersonCirclePlus = {
  prefix: 'fad',
  iconName: 'person-circle-plus',
  icon: [
    576,
    512,
    [],
    'e541',
    [
      'M0 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C1.5 276.7 0 282.4 0 288zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faChartPie = {
  prefix: 'fad',
  iconName: 'chart-pie',
  icon: [
    576,
    512,
    ['pie-chart'],
    'f200',
    [
      'M32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4L256 288 412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272z',
      'M527.4 240L304 240l0-223.4c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16zm31 48c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288l238.4 0z',
    ],
  ],
};
const faPieChart = faChartPie;
const faBoltLightning = {
  prefix: 'fad',
  iconName: 'bolt-lightning',
  icon: [
    384,
    512,
    [],
    'e0b7',
    [
      'M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z',
      '',
    ],
  ],
};
const faClockEight = {
  prefix: 'fad',
  iconName: 'clock-eight',
  icon: [
    512,
    512,
    [],
    'e345',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm140 77.3c-7.4-11-4.4-25.9 6.7-33.3c28.4-19 56.9-37.9 85.3-56.9c0-41.1 0-82.1 0-123.3c0-.7 0-1.5 .1-2.3s.2-1.6 .4-2.4c.3-1.6 .8-3.1 1.4-4.5c1.2-2.9 3-5.5 5.1-7.6c4.3-4.3 10.3-7 17-7c13.3 0 24 10.7 24 24c0 45.3 0 90.7 0 136c0 8-4 15.5-10.7 20c-32 21.3-64 42.7-96 64c-4.1 2.7-8.7 4-13.3 4c-7.8 0-15.4-3.8-20-10.7z',
      'M256 96c13.3 0 24 10.7 24 24l0 136c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2 232 120c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faSackXmark = {
  prefix: 'fad',
  iconName: 'sack-xmark',
  icon: [
    512,
    512,
    [],
    'e56a',
    [
      'M0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4l-128 0c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416zM144.6 24.9L192 96l128 0 47.4-71.1C374.5 14.2 366.9 0 354.1 0L157.9 0c-12.8 0-20.4 14.2-13.3 24.9zM168 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17l-47 47 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17s2.3-12.3 7-17l47-47-47-47c-4.7-4.7-7-10.8-7-17z',
      'M192 96l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM175 401c-9.4-9.4-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0z',
    ],
  ],
};
const faFileXls = {
  prefix: 'fad',
  iconName: 'file-xls',
  icon: [
    512,
    512,
    [],
    'e64d',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-176 0c-35.3 0-64 28.7-64 64l0 144-80 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM224 368c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 13.6 4 26.9 11.6 38.2L220.8 432l-17.2 25.8C196 469.1 192 482.4 192 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-7.3 2.2-14.4 6.2-20.4l9.8-14.7 9.8 14.7c4 6.1 6.2 13.2 6.2 20.4c0 8.8 7.2 16 16 16s16-7.2 16-16c0-13.6-4-26.9-11.6-38.2L259.2 432l17.2-25.8C284 394.9 288 381.6 288 368c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 7.3-2.2 14.4-6.2 20.4L240 403.2l-9.8-14.7c-4-6.1-6.2-13.2-6.2-20.4zm96 128c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128zm88-98.3c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7L432 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l26.3 0c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7l26.3 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-26.3 0c-25.2 0-45.7 20.4-45.7 45.7z',
    ],
  ],
};
const faFileExcel = {
  prefix: 'fad',
  iconName: 'file-excel',
  icon: [
    384,
    512,
    [],
    'f1c3',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM116.3 277.8L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4c4.2 2.9 9 4.3 13.7 4.3c7.6 0 15-3.6 19.7-10.2L192 385.8l36.3 51.9C233 444.4 240.5 448 248 448c4.8 0 9.6-1.4 13.7-4.3c10.9-7.6 13.5-22.6 5.9-33.4c-15.5-22.1-30.9-44.2-46.4-66.2c15.5-22.1 30.9-44.2 46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1c-12.1-17.3-24.2-34.6-36.3-51.9c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z',
    ],
  ],
};
const faFileContract = {
  prefix: 'fad',
  iconName: 'file-contract',
  icon: [
    384,
    512,
    [],
    'f56c',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm0 256c0 8.8 7.2 16 16 16l8.2 0c21.2 0 39.9-13.9 46-34.2L144 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l8.8-17.7c1.7-3.4 5.1-5.5 8.8-5.5s7.2 2.1 8.8 5.5l8.8 17.7c2.7 5.4 8.3 8.8 14.3 8.8l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-54.1 0-4.4-8.8C238.4 361 223.9 352 208 352c-10 0-19.4 3.5-26.8 9.7l-11.6-38.6C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4L80 384c-8.8 0-16 7.2-16 16z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM134.2 381.8L144 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l8.8-17.7c1.7-3.4 5.1-5.5 8.8-5.5s7.2 2.1 8.8 5.5l8.8 17.7c2.7 5.4 8.3 8.8 14.3 8.8l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-54.1 0-4.4-8.8C238.4 361 223.9 352 208 352c-10 0-19.4 3.5-26.8 9.7l-11.6-38.6C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4L80 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l8.2 0c21.2 0 39.9-13.9 46-34.2z',
    ],
  ],
};
const faFishFins = {
  prefix: 'fad',
  iconName: 'fish-fins',
  icon: [
    576,
    512,
    [],
    'e4f2',
    [
      'M0 352c0 8.3 3.2 16.6 9.5 22.7c10.3 10.2 26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5C264.1 406.9 298.2 416 336 416c5.7 0 11.3-.2 16.8-.6c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c2.9-5 4.3-10.5 4.3-16.1s-1.4-11.1-4.3-16.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8c-5.5-.4-11.1-.6-16.8-.6c-37.8 0-71.9 9.1-101.7 22.9c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1C1.4 341.1 0 346.6 0 352zm448-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M238.9 36.9C227.7 44 222 57.3 224.6 70.3l9.7 48.6C264.1 105.1 298.2 96 336 96c5.7 0 11.3 .2 16.8 .6L275.2 38.4c-10.6-8-25-8.5-36.3-1.5zm-4.6 356.2l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c-5.5 .4-11.1 .6-16.8 .6c-37.8 0-71.9-9.1-101.7-22.9z',
    ],
  ],
};
const faCircleQ = {
  prefix: 'fad',
  iconName: 'circle-q',
  icon: [
    512,
    512,
    [],
    'e11e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-70.7 57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128zm48 0c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
      'M256 176c44.2 0 80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1c-44.2 0-80-35.8-80-80s35.8-80 80-80zM361.9 327.9c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L343 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-15.1-15.1z',
    ],
  ],
};
const faBuildingFlag = {
  prefix: 'fad',
  iconName: 'building-flag',
  icon: [
    640,
    512,
    [],
    'e4d5',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 480 64 0 0-320 144 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L480 32z',
    ],
  ],
};
const faFaceGrinBeam = {
  prefix: 'fad',
  iconName: 'face-grin-beam',
  icon: [
    512,
    512,
    [128516, 'grin-beam'],
    'f582',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm105.2 75.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM120 224c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6zm160 0c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
    ],
  ],
};
const faGrinBeam = faFaceGrinBeam;
const faObjectUngroup = {
  prefix: 'fad',
  iconName: 'object-ungroup',
  icon: [
    640,
    512,
    [],
    'f248',
    [
      'M192 448c0 35.3 28.7 64 64 64c23.7 0 44.4-12.9 55.4-32l209.1 0c11.1 19.1 31.7 32 55.4 32c35.3 0 64-28.7 64-64c0-23.7-12.9-44.4-32-55.4l0-113.1c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64c-23.7 0-44.4 12.9-55.4 32L416 192l0 40.6c.6 .4 1.2 .7 1.8 1.1s1.2 .8 1.8 1.1c1.2 .8 2.3 1.6 3.4 2.4c2.2 1.7 4.3 3.5 6.3 5.5c3.9 3.9 7.4 8.4 10.2 13.3l81.1 0c5.6 9.7 13.7 17.8 23.4 23.4l0 113.1c-9.7 5.6-17.8 13.7-23.4 23.4l-209.1 0c-5.6-9.7-13.7-17.8-23.4-23.4l0-72.6-64 0 0 72.6c-19.1 11.1-32 31.7-32 55.4z',
      'M0 64c0 23.7 12.9 44.4 32 55.4l0 113.1C12.9 243.6 0 264.3 0 288c0 35.3 28.7 64 64 64c23.7 0 44.4-12.9 55.4-32l209.1 0c11.1 19.1 31.7 32 55.4 32c35.3 0 64-28.7 64-64c0-23.7-12.9-44.4-32-55.4l0-113.1c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64c-23.7 0-44.4 12.9-55.4 32L119.4 32C108.4 12.9 87.7 0 64 0C28.7 0 0 28.7 0 64zM328.6 96c5.6 9.7 13.7 17.8 23.4 23.4l0 113.1c-9.7 5.6-17.8 13.7-23.4 23.4l-209.1 0c-5.6-9.7-13.7-17.8-23.4-23.4l0-113.1c9.7-5.6 17.8-13.7 23.4-23.4l209.1 0z',
    ],
  ],
};
const faFaceDisguise = {
  prefix: 'fad',
  iconName: 'face-disguise',
  icon: [
    512,
    512,
    [],
    'e370',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1c-2.8 2.5-6.6 4.1-10.7 4.1l-56 0c0 50.1-38.4 91.2-87.3 95.6c9.6 7.9 15.3 19.7 15.3 32.4c0 15.9-9 30.4-23.1 37.5L364.5 398c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4 .7-4.8 1.3-7.2 1.8l0 25.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.2c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6L172.5 418c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208l-56 0c-.5 0-1 0-1.5-.1s-1-.1-1.5-.2c-1-.2-1.9-.5-2.8-.8c-1.8-.7-3.5-1.7-4.9-3C1.8 220.7 0 238.2 0 256zm12.6-79.6c1.1-.2 2.2-.4 3.4-.4l61.5 0c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9l0-19c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.3c4.4 .4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2L336 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5l61.5 0c.6 0 1.1 0 1.7 .1s1.1 .1 1.7 .3C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4z',
      'M160 80c8.8 0 16 7.2 16 16l0 16.3c4.4 .4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2L336 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5l61.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56 0c0 50.1-38.4 91.2-87.3 95.6c9.6 7.9 15.3 19.7 15.3 32.4c0 15.9-9 30.4-23.1 37.5L364.5 398c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4 .7-4.8 1.3-7.2 1.8l0 25.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.2c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6L172.5 418c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l61.5 0c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9l0-19c0-8.8 7.2-16 16-16zM317.9 266.5c7.9 3.5 16.8 5.5 26.1 5.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3c5.4 3.6 10.1 8.4 13.5 14.1l21.4 35.7c1.1 .6 1.9 1 2.6 1.3zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c9.3 0 18.1-2 26.1-5.5c.6-.3 1.5-.7 2.6-1.3L218 229.5c3.5-5.8 8.1-10.6 13.5-14.1c.3-2.4 .4-4.9 .4-7.3zm24 32c-4.3 0-8.3 2.3-10.5 6l-39.8 66.3-2.4 4-4.2 2.1-17.7 8.8c-3.4 1.7-5.5 5.1-5.5 8.8s2.1 7.2 5.5 8.8l53.1 26.5c13.5 6.8 29.4 6.8 42.9 0l53.1-26.5c3.4-1.7 5.5-5.1 5.5-8.8s-2.1-7.2-5.5-8.8l-17.7-8.8-4.2-2.1-2.4-4L266.5 246c-2.2-3.7-6.2-6-10.5-6zM144 216a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faCircleArrowDownRight = {
  prefix: 'fad',
  iconName: 'circle-arrow-down-right',
  icon: [
    512,
    512,
    [],
    'e0fa',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-88c0-6.1 2.3-12.3 7-17s10.8-7 17-7s12.3 2.3 17 7l135 135L320 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24l-152 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L151 185c-4.7-4.7-7-10.8-7-17z',
      'M344 368l-152 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135L320 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faAlien8bit = {
  prefix: 'fad',
  iconName: 'alien-8bit',
  icon: [
    576,
    512,
    [128126, 'alien-monster'],
    'f8f6',
    [
      'M0 144L0 272c0 8.8 7.2 16 16 16l48 0 0 80c0 8.8 7.2 16 16 16l48 0 0 80c0 8.8 7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-32 192 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16l0-80 48 0c8.8 0 16-7.2 16-16l0-80 48 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 80-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 0-32 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 16-48 0c-8.8 0-16 7.2-16 16l0 48-128 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-16c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 32 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-80c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm160 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm192 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64z',
      'M176 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zm192 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faAlienMonster = faAlien8bit;
const faHandPointRibbon = {
  prefix: 'fad',
  iconName: 'hand-point-ribbon',
  icon: [
    448,
    512,
    [],
    'e1a6',
    [
      'M32 336l0 27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l0-8.6c-9.4 5.4-20.3 8.6-32 8.6c-27.9 0-51.7-17.9-60.4-42.8C313.4 316 301.2 320 288 320c-11.7 0-22.6-3.1-32-8.6l0 .6c0 39.8-32.2 72-72 72l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-88 0c-35.3 0-64 28.7-64 64zM64 32l64 0c0-17.7-14.3-32-32-32S64 14.3 64 32zm0 128l0 80 64 0 0-80-64 0zm96 0l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M176 112V48c0-8.8-7.2-16-16-16H11.8C5.3 32 0 37.3 0 43.8c0 3.9 1.9 7.5 5.1 9.7L43.6 80 5.1 106.5c-3.2 2.2-5.1 5.8-5.1 9.7C0 122.7 5.3 128 11.8 128H160c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faPoop = {
  prefix: 'fad',
  iconName: 'poop',
  icon: [
    512,
    512,
    [],
    'f619',
    [
      'M0 440c0 14.8 4.5 28.6 12.1 40l487.8 0c7.7-11.4 12.1-25.2 12.1-40c0-35.7-25.9-65.3-60-71c.4-.3 .8-.7 1.3-1L58.7 368c.4 .3 .8 .7 1.3 1c-34.1 5.7-60 35.3-60 71zM32 312c0 8.4 1.4 16.5 4.1 24l439.8 0c2.7-7.5 4.1-15.6 4.1-24c0-39.8-32.2-72-72-72c-4.6 0-9.1 0-13.7 0l-276.7 0c-4.6 0-9.1 0-13.7 0c-39.8 0-72 32.2-72 72zM96 192c0 5.5 .7 10.9 2 16l316 0c1.3-5.1 2-10.5 2-16c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1c-.7-.1-1.4-.1-2.1-.1c-4.8 0-9.3 2.1-12.4 5.9c-3.5 4.3-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80L160 128c-35.3 0-64 28.7-64 64z',
      'M117.7 240c-9.4-8.3-16.4-19.4-19.7-32l316 0c-3.2 12.6-10.2 23.7-19.7 32l-276.7 0zM58.7 368c-10.2-8.3-18.2-19.3-22.6-32l439.8 0c-4.5 12.7-12.4 23.7-22.6 32L58.7 368zM71.8 512c-24.9-.1-46.8-12.8-59.7-32l487.8 0c-12.9 19.2-34.8 31.9-59.7 32L71.8 512z',
    ],
  ],
};
const faObjectExclude = {
  prefix: 'fad',
  iconName: 'object-exclude',
  icon: [
    512,
    512,
    [],
    'e49c',
    [
      'M224 160c-35.3 0-64 28.7-64 64l0 128 128 0c35.3 0 64-28.7 64-64l0-128-128 0zm80 48l0 96-96 0 0-96 96 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l96 0 0 96c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0-96c0-35.3-28.7-64-64-64L64 0zM352 160l0 128c0 35.3-28.7 64-64 64l-128 0 0-128c0-35.3 28.7-64 64-64l128 0z',
    ],
  ],
};
const faTelescope = {
  prefix: 'fad',
  iconName: 'telescope',
  icon: [
    576,
    512,
    [128301],
    'e03e',
    [
      'M3.1 376.4L29 421.3c4.4 7.7 12.5 12 20.8 12c4.1 0 8.2-1 12-3.2l44.1-25.5 .8 1.4c8.6 15 27.6 20.4 42.8 12.2l88.4-47.4c1.9-4.7 3.9-9.5 5.8-14.2C231.4 342.5 224 324.1 224 304c0-44.2 35.8-80 80-80c1.3 0 2.5 0 3.8 .1s2.5 .1 3.7 .3c2.5 .2 4.9 .6 7.3 1c4.8 .9 9.4 2.2 13.9 3.9c8.9 3.4 17 8.4 24.1 14.5c14.1 12.3 23.8 29.5 26.5 49l77.5-41.6c-.2-.4-.5-.8-.7-1.2L364 83.7c-.7-1.2-1.3-2.4-1.8-3.6c-.2-.6-.5-1.1-.8-2c-.1-.4-.3-.8-.5-1.5L62.4 268.4c-14.4 9.2-19 28.1-10.4 42.9l4 6.9L11.8 343.6C.4 350.3-3.6 364.9 3.1 376.4z',
      'M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.6-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L375.7 40zM364.3 356.5C376.6 342.5 384 324.1 384 304c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 20.1 7.4 38.5 19.7 52.5L193.8 478.9c-5 12.3 .9 26.3 13.2 31.3s26.3-.9 31.3-13.2l47-115.3c6 1.5 12.3 2.2 18.8 2.2s12.8-.8 18.8-2.2l47 115.3c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3L364.3 356.5zM272 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faLocationPin = {
  prefix: 'fad',
  iconName: 'location-pin',
  icon: [
    384,
    512,
    ['map-marker'],
    'f041',
    [
      'M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z',
      '',
    ],
  ],
};
const faMapMarker = faLocationPin;
const faSquareList = {
  prefix: 'fad',
  iconName: 'square-list',
  icon: [
    448,
    512,
    [],
    'e489',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM168 160c0 13.3 10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0c-13.3 0-24 10.7-24 24z',
      'M168 160c0-13.3 10.7-24 24-24l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24zm24-120l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faKaaba = {
  prefix: 'fad',
  iconName: 'kaaba',
  icon: [
    576,
    512,
    [128331],
    'f66b',
    [
      'M0 229.2c17.6 5.5 35.2 11 52.8 16.5c8.4 2.6 13.1 11.6 10.5 20s-11.6 13.1-20 10.5c-14.4-4.5-28.8-9-43.2-13.5l0-33.5zM60 120c76-23.8 152-47.5 228-71.2C364 72.5 440 96.3 516 120c-76 23.7-152 47.5-228 71.2L60 120zM96.7 276.2c2.6-8.4 11.6-13.1 20-10.5c21.3 6.7 42.7 13.3 64 20c8.4 2.6 13.1 11.6 10.5 20s-11.6 13.1-20 10.5c-21.3-6.7-42.7-13.3-64-20c-8.4-2.6-13.1-11.6-10.5-20zm128 40c2.6-8.4 11.6-13.1 20-10.5c12.8 4 25.6 8 38.5 12c3.1 1 6.4 1 9.5 0c12.8-4 25.6-8 38.5-12c8.4-2.6 17.4 2.1 20 10.5s-2.1 17.4-10.5 20l-38.5 12c-4.7 1.5-9.5 2.2-14.3 2.2s-9.7-.7-14.3-2.2l-38.5-12c-8.4-2.6-13.1-11.6-10.5-20zm160-10.5c-2.6-8.4 2.1-17.4 10.5-20c21.3-6.7 42.7-13.3 64-20c8.4-2.6 17.4 2.1 20 10.5s-2.1 17.4-10.5 20c-21.3 6.7-42.7 13.3-64 20c-8.4 2.6-17.4-2.1-20-10.5zm128-40c-2.6-8.4 2.1-17.4 10.5-20c17.6-5.5 35.2-11 52.8-16.5l0 33.5c-14.4 4.5-28.8 9-43.2 13.5c-8.4 2.6-17.4-2.1-20-10.5z',
      'M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112l0 16s0 0 0 0l0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2 0 128l0-16C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8l0 46.5-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8 576 400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400L0 262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2l0-46.5 273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z',
    ],
  ],
};
const faToiletPaper = {
  prefix: 'fad',
  iconName: 'toilet-paper',
  icon: [
    640,
    512,
    [129531],
    'f71e',
    [
      'M20.2 495.8c-5.7-10-5.6-22.3 .4-32.2C63.6 385.7 64 277.3 64 192C64 86 107 0 160 0L512 0c-53 0-96 86-96 192c0 81.9-7.3 145-16.4 192c-8.6 44.1-18.8 74-26.3 91.9c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2zM128 208a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M512 384l-112.4 0c9.1-47 16.4-110.1 16.4-192C416 86 459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faHelmetSafety = {
  prefix: 'fad',
  iconName: 'helmet-safety',
  icon: [
    576,
    512,
    ['hard-hat', 'hat-hard'],
    'f807',
    [
      'M0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6L544 384 32 384l-15.4 0C7.4 384 0 391.4 0 400.6z',
      'M224 64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 2.3 0 99.6c0 5.6 4.5 10.1 10.1 10.1c3.6 0 7-1.9 8.8-5.1l48-83.9C492.3 123.1 543.1 198.4 544 285.6l0 98.4L32 384l0-96c0-88.2 51-164.5 125.1-201l48 83.9c1.8 3.2 5.2 5.1 8.8 5.1c5.6 0 10.1-4.5 10.1-10.1l0-99.6 0-2.3z',
    ],
  ],
};
const faHardHat = faHelmetSafety;
const faHatHard = faHelmetSafety;
const faCommentCode = {
  prefix: 'fad',
  iconName: 'comment-code',
  icon: [
    512,
    512,
    [],
    'e147',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm112 0c0-6.1 2.3-12.3 7-17l64-64c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7l-64-64c-4.7-4.7-7-10.8-7-17zm183-81c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l64 64c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17l-64 64c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
      'M217 159c9.4 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0zm78.1 0c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faSimCards = {
  prefix: 'fad',
  iconName: 'sim-cards',
  icon: [
    448,
    512,
    [],
    'e251',
    [
      'M96 64c0-35.3 28.7-64 64-64L306.7 0c17 0 33.3 6.7 45.3 18.7L429.3 96c12 12 18.7 28.3 18.7 45.3L448 352c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64L96 64zm64 112l0 16 0 32 0 48 0 32 0 16c0 17.7 14.3 32 32 32l16 0 32 0 64 0 32 0 16 0c17.7 0 32-14.3 32-32l0-16 0-32 0-48 0-32 0-16c0-17.7-14.3-32-32-32l-16 0-32 0-64 0-32 0-16 0c-17.7 0-32 14.3-32 32z',
      'M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0c-48.6 0-88-39.4-88-88l0-256zm144 24c-17.7 0-32 14.3-32 32l0 16 48 0 0-48-16 0zM160 272l64 0 96 0 64 0 0-48-64 0-96 0-64 0 0 48zm224-96c0-17.7-14.3-32-32-32l-16 0 0 48 48 0 0-16zM240 144l0 48 64 0 0-48-64 0zm96 160l0 48 16 0c17.7 0 32-14.3 32-32l0-16-48 0zm-32 0l-64 0 0 48 64 0 0-48zm-96 0l-48 0 0 16c0 17.7 14.3 32 32 32l16 0 0-48z',
    ],
  ],
};
const faStarship = {
  prefix: 'fad',
  iconName: 'starship',
  icon: [
    640,
    512,
    [],
    'e039',
    [
      'M0 128c0-17.7 14.3-32 32-32l176 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-71 0-72.9 0L32 160c-17.7 0-32-14.3-32-32zM0 384c0-17.7 14.3-32 32-32l32.1 0 72.9 0 71 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 416c-17.7 0-32-14.3-32-32zM256 256c0-24.6 4.6-48 13-69.6C296.9 114.8 366.5 64 448 64c106 0 192 86 192 192s-86 192-192 192c-81.5 0-151.1-50.8-179-122.4c-8.4-21.6-13-45.1-13-69.6zm128 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M129.1 216.8L64.1 160l72.9 0 50.4 44.1L269 186.4c-8.4 21.6-13 45.1-13 69.6s4.6 48 13 69.6l-81.6-17.7L137 352l-72.9 0 64.9-56.8-1.8-.4C109 290.8 96 274.7 96 256s13-34.8 31.3-38.8l1.8-.4zM384 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faEject = {
  prefix: 'fad',
  iconName: 'eject',
  icon: [
    448,
    512,
    [9167],
    'f052',
    [
      'M0 432c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48z',
      'M259.4 47.6C250.3 37.6 237.5 32 224 32s-26.3 5.6-35.4 15.6l-176 192c-12.9 14-16.2 34.3-8.6 51.8S29 320 48 320l352 0c19 0 36.3-11.2 43.9-28.7s4.3-37.7-8.6-51.8l-176-192z',
    ],
  ],
};
const faCircleRight = {
  prefix: 'fad',
  iconName: 'circle-right',
  icon: [
    512,
    512,
    [61838, 'arrow-alt-circle-right'],
    'f35a',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM128 240l0 32c0 17.7 14.3 32 32 32l96 0 0 57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8L294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3l0 57.7-96 0c-17.7 0-32 14.3-32 32z',
      'M394.5 242.2L294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3l0 57.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8z',
    ],
  ],
};
const faArrowAltCircleRight = faCircleRight;
const faPlaneCircleCheck = {
  prefix: 'fad',
  iconName: 'plane-circle-check',
  icon: [
    640,
    512,
    [],
    'e555',
    [
      'M0 297.3l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faSeal = {
  prefix: 'fad',
  iconName: 'seal',
  icon: [
    512,
    512,
    [],
    'e241',
    [
      'M289.9 18.4c-18.7-18.7-49.1-18.7-67.9 0L176.5 64 112 64c-26.5 0-48 21.5-48 48l0 64.5L18.4 222.1c-18.7 18.7-18.7 49.1 0 67.9L64 335.5 64 400c0 26.5 21.5 48 48 48l64.5 0 45.6 45.6c18.7 18.7 49.1 18.7 67.9 0L335.5 448l64.5 0c26.5 0 48-21.5 48-48l0-64.5 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5l0-64.5c0-26.5-21.5-48-48-48l-64.5 0L289.9 18.4z',
      '',
    ],
  ],
};
const faUserCowboy = {
  prefix: 'fad',
  iconName: 'user-cowboy',
  icon: [
    448,
    512,
    [],
    'f8ea',
    [
      'M96 221.7c17.4 10.1 36.9 18.7 58.3 24.7c10.7 3 21.9 5.4 33.5 7.1c5.8 .8 11.7 1.4 17.8 1.9c3 .2 6.1 .4 9.1 .5c1.5 .1 3.1 .1 4.6 .1c1.5 0 3 0 4.6 0c50 0 93.2-14.1 128-34.3c0 .8 0 1.5 0 2.3c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-.8 0-1.5 0-2.3z',
      'M208.5 9.9C201.9 5.4 194 0 176 0c-35.2 0-58.3 58.1-72 110.4C131.6 120 171 128 224 128s92.4-8 120-17.6C330.3 58.1 307.2 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1s-10.8-2.8-15.5-6.1zM28.8 102.4c-4.7-6.3-13.3-8.2-20.2-4.6s-10.2 11.8-7.8 19.2c9.3 27.9 35 62.4 72.5 89.9c38 27.7 89.2 49.1 150.6 49.1s112.7-21.4 150.6-49.1c37.6-27.4 63.2-62 72.5-89.9c2.5-7.4-.8-15.6-7.8-19.2s-15.5-1.7-20.2 4.6c-5.6 7.5-22.6 22-55 34.7C332.2 149.6 286.2 160 224 160s-108.2-10.4-140.2-22.9c-32.4-12.7-49.4-27.2-55-34.7zM100.7 384c-48.4 0-89.3 36.1-95.3 84.1l-1 7.9C2.1 495.1 17 512 36.2 512l375.5 0c19.2 0 34.1-16.9 31.8-36l-1-7.9c-6-48-46.8-84.1-95.3-84.1l-246.5 0z',
    ],
  ],
};
const faHexagonVerticalNft = {
  prefix: 'fad',
  iconName: 'hexagon-vertical-nft',
  icon: [
    448,
    512,
    [],
    'e505',
    [
      'M0 168.3L0 344.9c0 25.7 13.7 49.5 36 62.4l152.9 88.3c22.3 12.9 49.7 12.9 72 0l152.9-88.3c22.3-12.9 36-36.6 36-62.4l0-176.6c0-25.7-13.7-49.5-36-62.4L260.9 17.6c-22.3-12.9-49.7-12.9-72 0L36 105.9C13.7 118.8 0 142.6 0 168.3zm65.2 5.5c.2-.9 .4-1.8 .7-2.7c.6-1.7 1.5-3.3 2.7-4.7c2.3-2.8 5.5-4.8 9.3-5.5c7.5-1.5 15 2.6 17.9 9.8c11 27.6 22.1 55.2 33.1 82.9c0-25.6 0-51.3 0-77c0-.5 0-1 .1-1.5s.1-1.1 .2-1.6c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c8.8 0 16 7.2 16 16c0 53.3 0 106.7 0 160c0 7.7-5.4 14.3-13 15.7c-1 .2-2 .3-3 .3c-6.4 0-12.4-3.9-14.8-10.1L96.9 259.7c0 25.6 0 51.3 0 76.9c0 8.8-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-.9-.7-2-.9-3c-.1-.5-.2-1-.2-1.6c-.1-.5-.1-1-.1-1.6c0-53.3 0-106.7 0-160.1c0-.4 0-.8 .1-1.3s.1-.9 .2-1.4zm128.1-.4c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c16 0 32 0 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-10.7 0-21.3 0-32 0c0 16 0 32 0 48c10.7 0 21.3 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-10.7 0-21.3 0-32 0c0 21.3 0 42.7 0 64c0 8.8-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-.9-.7-2-.9-3c-.1-.5-.2-1-.2-1.6c-.1-.5-.1-1-.1-1.6c0-26.7 0-53.3 0-80s0-53.3 0-80.1c0-.5 0-1 .1-1.5s.1-1.1 .2-1.6zm96 0c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c21.3 0 42.7 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-5.3 0-10.7 0-16 0l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144c-5.3 0-10.7 0-16 0c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-.9-.7-2-.9-3c-.1-.5-.2-1-.2-1.6c-.1-.5-.1-1-.1-1.7c0-.5 0-1.1 .1-1.6s.1-1.1 .2-1.6z',
      'M77.9 160.9c7.5-1.5 15 2.6 17.9 9.8l33.1 82.9 0-76.9c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L96.9 259.7l0 76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.7 5.4-14.3 13-15.7zm115 15.7c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80 0-80zm112-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faFaceRollingEyes = {
  prefix: 'fad',
  iconName: 'face-rolling-eyes',
  icon: [
    512,
    512,
    [128580, 'meh-rolling-eyes'],
    'f5a5',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-32c0-32.9 24.8-60 56.8-63.6c2.4-.2 4.8-.4 7.2-.4s4.9 .2 7.2 .4C199.2 164 224 191.1 224 224c0 35.3-28.7 64-64 64s-64-28.7-64-64zm80 160c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM416 224.1A64 64 0 1 1 288 224a64 64 0 1 1 128 .1z',
      'M195.6 180.4c0 19.6-15.9 35.6-35.6 35.6s-35.6-15.9-35.6-35.6c0-3 .4-6 1.1-8.8c9.6-7.3 21.5-11.6 34.5-11.6s24.9 4.3 34.5 11.6c.7 2.8 1.1 5.8 1.1 8.8zM384 184c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-6.9 2.2-13.2 5.8-18.4c8-3.6 16.8-5.6 26.2-5.6s18.2 2 26.2 5.6c3.7 5.2 5.8 11.6 5.8 18.4z',
    ],
  ],
};
const faMehRollingEyes = faFaceRollingEyes;
const faBreadLoaf = {
  prefix: 'fad',
  iconName: 'bread-loaf',
  icon: [
    640,
    512,
    [127838],
    'f7eb',
    [
      'M0 192c0 35.3 28.7 64 64 64l0 176c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-176c35.3 0 64-28.7 64-64C480 64 304 32 240 32S0 64 0 192z',
      'M368 480l160 0c26.5 0 48-21.5 48-48l0-176c35.3 0 64-28.7 64-64C640 64 464 32 400 32L240 32c64 0 240 32 240 160c0 35.3-28.7 64-64 64l0 176c0 26.5-21.5 48-48 48z',
    ],
  ],
};
const faRingsWedding = {
  prefix: 'fad',
  iconName: 'rings-wedding',
  icon: [
    512,
    512,
    [],
    'f81b',
    [
      'M96 48c0-2.5 .6-4.9 1.7-7.2l16-32C116.4 3.4 121.9 0 128 0l96 0c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3l-24.6 49.2c-8.5-2.7-17.2-4.8-26.2-6.2c-4.5-.7-9-1.2-13.6-1.6c-2.3-.2-4.6-.3-6.9-.4c-1.2 0-2.3-.1-3.5-.1s-2.3 0-3.5 0c-18.7 0-36.8 2.9-53.7 8.3L97.7 55.2C96.6 52.9 96 50.5 96 48zm64 288c0-64.4 34.5-120.7 86.1-151.3c16.8 13.5 29.7 31.8 36.5 52.9c-34.9 19-58.6 56-58.6 98.5c0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9c-5-26.2-14.8-50.7-28.6-72.4C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-14.8-18.3-26-39.6-32.5-62.9c-4.2-15.1-6.5-31.1-6.5-47.6z',
      'M176 160c-61.9 0-112 50.1-112 112c0 58.7 45.1 106.8 102.5 111.6c6.5 23.3 17.7 44.6 32.5 62.9c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272S78.8 96 176 96s176 78.8 176 176c0 52.3-22.8 99.2-59 131.5c-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-61.9-50.1-112-112-112z',
    ],
  ],
};
const faObjectGroup = {
  prefix: 'fad',
  iconName: 'object-group',
  icon: [
    576,
    512,
    [],
    'f247',
    [
      'M0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32l337.1 0C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 273.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-337.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-273.1C12.9 108.4 0 87.7 0 64zm96 55.4l0 273.1c9.7 5.6 17.8 13.7 23.4 23.4l337.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-273.1c-9.7-5.6-17.8-13.7-23.4-23.4L119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4z',
      'M160 128c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-128 0zm96 224c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-64 0 0 32c0 35.3-28.7 64-64 64l-32 0 0 32z',
    ],
  ],
};
const faFrenchFries = {
  prefix: 'fad',
  iconName: 'french-fries',
  icon: [
    384,
    512,
    [127839],
    'f803',
    [
      'M.2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2L48 192c3.6 0 7 .4 10.2 1L40.3 85.6 19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8zm64-64.2l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6l0-246.3-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9zM160 16l0 190.7c0 21 0 42.1 0 63.1c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2l0-238c-.1-6-3.5-11.4-8.8-14.1l-32-16C180.9 .6 178.4 0 176 0c-2.9 0-5.8 .8-8.4 2.4C162.9 5.3 160 10.5 160 16zm96.2 37.2l-.2 1.4L256 261c4.8-2.1 8.7-4.4 11.8-6.6c12-8.4 16.7-18 18.7-24.3c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2zm71 139.5c2.8-.5 5.7-.8 8.8-.8l26.6 0c1.6 0 3.2 .1 4.7 .2l16.5-93.4c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8z',
      'M58.1 487.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H48c8.8 0 16.3 7.2 18.9 15.7C74.3 263 100.3 304 192 304s117.7-41 125.1-64.3c2.7-8.4 10.1-15.7 18.9-15.7h26.6c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5z',
    ],
  ],
};
const faChartLine = {
  prefix: 'fad',
  iconName: 'chart-line',
  icon: [
    512,
    512,
    ['line-chart'],
    'f201',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0L240 221.3l-89.4 89.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0L320 210.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faLineChart = faChartLine;
const faCalendarArrowDown = {
  prefix: 'fad',
  iconName: 'calendar-arrow-down',
  icon: [
    448,
    512,
    ['calendar-download'],
    'e0d0',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM127 327c-9.4 9.4-9.4 24.6 0 33.9l80 80c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L248 264c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-39-39c-9.4-9.4-24.6-9.4-33.9 0z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM248 264c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L248 264z',
    ],
  ],
};
const faCalendarDownload = faCalendarArrowDown;
const faSendBack = {
  prefix: 'fad',
  iconName: 'send-back',
  icon: [
    640,
    512,
    [],
    'f87e',
    [
      'M0 64C0 28.7 28.7 0 64 0L192 0c35.3 0 64 28.7 64 64l0 32 0 96c0 35.3-28.7 64-64 64l-32 0-96 0c-35.3 0-64-28.7-64-64L0 64zm64 0l0 128 128 0 0-128L64 64zM384 320c0-35.3 28.7-64 64-64l32 0 96 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-128 0c-35.3 0-64-28.7-64-64l0-32 0-96zm64 0l0 128 128 0 0-128-128 0z',
      'M160 352l0-96 32 0c35.3 0 64-28.7 64-64l0-96 160 0c35.3 0 64 28.7 64 64l0 96-32 0c-35.3 0-64 28.7-64 64l0 96-160 0c-35.3 0-64-28.7-64-64z',
    ],
  ],
};
const faMaskVentilator = {
  prefix: 'fad',
  iconName: 'mask-ventilator',
  icon: [
    640,
    512,
    [],
    'e524',
    [
      'M0 184c0-30.9 25.1-56 56-56l129.1 0c-9.7 15.2-18.5 31.5-26 48L56 176c-4.4 0-8 3.6-8 8l0 85c0 33 22.5 61.8 54.5 69.9l31.8 7.9c5.8 20.5 15.3 39.5 27.9 56.5L90.9 385.5C37.5 372.1 0 324.1 0 269l0-85zM288 320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192-64 0 0-192zM454.5 128L584 128c30.9 0 56 25.1 56 56l0 85c0 55.1-37.5 103.1-90.9 116.4l-71.6 17.9c12.7-16.9 22.3-36 28.2-56.5l31.8-8c32.1-8 54.5-36.8 54.5-69.9l0-85c0-4.4-3.6-8-8-8l-103.3 0c-7.6-16.5-16.3-32.8-26.1-48z',
      'M128 300.8C128 201.9 214 32 320 32c105 0 192 169.9 192 268.8c0 78.6-53.9 144.5-128 169l0-76.6c19.6-16.3 32-40.1 32-66.8c0-49.5-43.5-134.4-96-134.4c-53 0-96 84.9-96 134.4c0 26.6 12.3 50.5 32 66.9l0 76.6c-75-24.5-128-91-128-169.1z',
    ],
  ],
};
const faTickets = {
  prefix: 'fad',
  iconName: 'tickets',
  icon: [
    640,
    512,
    [],
    'e658',
    [
      'M96 96l0 48c0 8.8 7.4 15.7 15.7 18.6C130.5 169.1 144 187 144 208s-13.5 38.9-32.3 45.4C103.4 256.3 96 263.2 96 272l0 48c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-48c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm96 32c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-160zm32 0l0 160 288 0 0-160-288 0z',
      'M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240zm176 8l288 0 0 160-288 0 0-160zm-32 0l0 160c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L224 96c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faSignatureLock = {
  prefix: 'fad',
  iconName: 'signature-lock',
  icon: [
    640,
    512,
    [],
    'e3ca',
    [
      'M0 335.6l0 71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l72.6 0c5.6-9.7 13.7-17.8 23.4-23.4l0-24.6c0-5.4 .4-10.8 1.1-16l-52.7 0 18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L220.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5L68.4 243.7C27.8 255.8 0 293.2 0 335.6zm64 0c0-14.1 9.3-26.6 22.8-30.7l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2L79.9 411.7c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5l0-71.9zM187.5 416L384 416l0-48-174.1 0c-6.7 16.3-14.2 32.3-22.3 48z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faArrowRight = {
  prefix: 'fad',
  iconName: 'arrow-right',
  icon: [
    448,
    512,
    [8594],
    'f061',
    [
      'M0 256c0 17.7 14.3 32 32 32l306.7 0 32-32c-10.7-10.7-21.3-21.3-32-32L32 224c-17.7 0-32 14.3-32 32z',
      'M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 256 233.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z',
    ],
  ],
};
const faSignsPost = {
  prefix: 'fad',
  iconName: 'signs-post',
  icon: [
    512,
    512,
    ['map-signs'],
    'f277',
    [
      'M224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32-64 0 0-32zm0 160l64 0 0 32-64 0 0-32zm0 160l64 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128z',
      'M64 64l377.4 0c4.2 0 8.3 1.7 11.3 4.7l48 48c6.2 6.2 6.2 16.4 0 22.6l-48 48c-3 3-7.1 4.7-11.3 4.7L64 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM448 224c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L70.6 352c-4.2 0-8.3-1.7-11.3-4.7l-48-48c-6.2-6.2-6.2-16.4 0-22.6l48-48c3-3 7.1-4.7 11.3-4.7L448 224z',
    ],
  ],
};
const faMapSigns = faSignsPost;
const faOctagonPlus = {
  prefix: 'fad',
  iconName: 'octagon-plus',
  icon: [
    512,
    512,
    ['plus-octagon'],
    'f301',
    [
      'M.1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5zM144 256c0-13.3 10.7-24 24-24c21.3 0 42.7 0 64 0c0-21.3 0-42.7 0-64c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 1.2 .4 2.4 .4 2.4c.1 1.2 .1 1.2 .1 2.5c0 21.3 0 42.7 0 64l64 0c13.4 .1 24 10.8 24 24c0 13.3-10.7 24-24 24c-21.3 0-42.7 0-64 0c0 21.3 0 42.7 0 64.2c0 .7 0 1.5-.1 2.3s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-21.3 0-42.7 0-64c-21.3 0-42.7 0-64 0c-13.3 0-24-10.7-24-24z',
      'M232 280l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faPlusOctagon = faOctagonPlus;
const faCashRegister = {
  prefix: 'fad',
  iconName: 'cash-register',
  icon: [
    512,
    512,
    [],
    'f788',
    [
      'M32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32 64 0 0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0C46.3 0 32 14.3 32 32zM80 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16zm8 176a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M0 448l0-69.6c0-4.8 .4-9.6 1.1-14.4L23.8 214.4C28.5 183.1 55.4 160 87 160L425 160c31.6 0 58.5 23.1 63.3 54.4l22.7 149.6c.7 4.8 1.1 9.6 1.1 14.4l0 69.6c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64zm64-16c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 416c-8.8 0-16 7.2-16 16zm48-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z',
    ],
  ],
};
const faPersonCircleQuestion = {
  prefix: 'fad',
  iconName: 'person-circle-question',
  icon: [
    576,
    512,
    [],
    'e542',
    [
      'M0 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C1.5 276.7 0 282.4 0 288zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM409.6 280c-23 0-41.6 18.6-41.6 41.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0z',
    ],
  ],
};
const faMelonSlice = {
  prefix: 'fad',
  iconName: 'melon-slice',
  icon: [
    512,
    512,
    [],
    'e311',
    [
      'M16.6 385.2c8.3-2.7 17.8-.8 24.4 5.9c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4c-.8-.9-1.6-1.7-2.3-2.6s-1.3-1.8-1.8-2.8c-1.1-1.9-1.8-4-2.3-6.1c-1-4.3-.8-8.7 .6-12.9c-.7 .5-1.3 1-1.9 1.6L321.6 79.9c-3.9 3.9-5.4 9.4-4.5 14.8c1.9 10.8 2.9 22 2.9 33.3c0 106-86 192-192 192c-11.4 0-22.5-1-33.3-2.9c-5.4-.9-11 .6-14.8 4.5L18.2 383.3c-.6 .6-1.1 1.2-1.6 1.9z',
      'M7 391c9.4-9.4 24.6-9.4 33.9 0c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faSpaceStationMoon = {
  prefix: 'fad',
  iconName: 'space-station-moon',
  icon: [
    512,
    512,
    [],
    'e033',
    [
      'M0 256c0 7.8 .3 15.5 1 23.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c.7-7.6 1-15.3 1-23.1C512 114.6 397.4 0 256 0S0 114.6 0 256zm6.8 58.8C33.4 427.9 134.9 512 256 512s222.6-84.1 249.2-197.2C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2zM272 160a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
      'M224 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM6.8 314.8C4.1 303.2 2.1 291.3 1 279.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c-1.1 12.2-3 24.1-5.8 35.8C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2z',
    ],
  ],
};
const faMessageSmile = {
  prefix: 'fad',
  iconName: 'message-smile',
  icon: [
    512,
    512,
    ['comment-alt-smile'],
    'f4aa',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM148.7 272c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c4.1-4.6 6.1-10.3 6.1-16c0-6.6-2.7-13.2-8-17.9c-9.9-8.8-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9zM160 144a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M224 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 240c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z',
    ],
  ],
};
const faCommentAltSmile = faMessageSmile;
const faCupStraw = {
  prefix: 'fad',
  iconName: 'cup-straw',
  icon: [
    384,
    512,
    [129380],
    'e363',
    [
      'M32 192L59.7 468.8c2.5 24.5 23.1 43.2 47.8 43.2l169.1 0c24.7 0 45.3-18.7 47.8-43.2L352 192 32 192z',
      'M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8L32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-127.8 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0z',
    ],
  ],
};
const faLeftFromLine = {
  prefix: 'fad',
  iconName: 'left-from-line',
  icon: [
    448,
    512,
    ['arrow-alt-from-right'],
    'f348',
    [
      'M384 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M11.3 283.3L134.1 406.1c6.4 6.4 15 9.9 24 9.9c18.7 0 33.9-15.2 33.9-33.9l0-62.1 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-62.1c0-18.7-15.2-33.9-33.9-33.9c-9 0-17.6 3.6-24 9.9L11.3 228.7C4.1 235.9 0 245.8 0 256s4.1 20.1 11.3 27.3z',
    ],
  ],
};
const faArrowAltFromRight = faLeftFromLine;
const faH = {
  prefix: 'fad',
  iconName: 'h',
  icon: [
    384,
    512,
    [104],
    '48',
    [
      'M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z',
      '',
    ],
  ],
};
const faBasketShoppingSimple = {
  prefix: 'fad',
  iconName: 'basket-shopping-simple',
  icon: [
    576,
    512,
    ['shopping-basket-alt'],
    'e0af',
    [
      'M0 224c0 17.7 14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-98.4 0c8.1 18.1 16.2 36.1 24.3 54.2c5.4 12.1 0 26.3-12.1 31.7s-26.3 0-31.7-12.1c-11-24.6-22.1-49.2-33.1-73.8l-210 0c-11 24.6-22.1 49.2-33.1 73.8c-4 8.9-12.7 14.2-21.9 14.2c-3.3 0-6.6-.7-9.8-2.1c-12.1-5.4-17.5-19.6-12.1-31.7c8.1-18.1 16.2-36.1 24.3-54.2L32 192c-17.7 0-32 14.3-32 32z',
      'M253.9 33.8c5.4-12.1 0-26.3-12.1-31.7s-26.3 0-31.7 12.1l-104 232c-5.4 12.1 0 26.3 12.1 31.7s26.3 0 31.7-12.1l104-232zm68.2 0l104 232c5.4 12.1 19.6 17.5 31.7 12.1s17.5-19.6 12.1-31.7l-104-232C360.5 2.1 346.3-3.3 334.2 2.1s-17.5 19.6-12.1 31.7z',
    ],
  ],
};
const faShoppingBasketAlt = faBasketShoppingSimple;
const faHandsHoldingHeart = {
  prefix: 'fad',
  iconName: 'hands-holding-heart',
  icon: [
    640,
    512,
    ['hands-heart'],
    'f4c3',
    [
      'M0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c-5.1-5.1-10.2-10.2-15.2-15.2l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40c0-22.1-17.9-40-40-40S0 81.9 0 104zM352 385.1l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c-8.5 8.5-16.9 16.9-25.4 25.4c-21 21-32.8 49.5-32.8 79.2z',
      'M195.9 28.9c-29.4 29.8-29.4 78.2 0 108L297.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L444.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L320 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0z',
    ],
  ],
};
const faHandsHeart = faHandsHoldingHeart;
const faClockNine = {
  prefix: 'fad',
  iconName: 'clock-nine',
  icon: [
    512,
    512,
    [],
    'e34c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-13.3 10.7-24 24-24l80 0 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 13.3-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24z',
      'M256 96c13.3 0 24 10.7 24 24l0 136c0 13.3-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-112c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHammerBrush = {
  prefix: 'fad',
  iconName: 'hammer-brush',
  icon: [
    640,
    512,
    [],
    'e620',
    [
      'M0 144C0 64.5 64.5 0 144 0l54.1 0c21.9 0 42 12.4 51.8 32L288 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l-38.1 0c-8.3 16.5-23.8 27.9-41.6 31.1c-3.3 .6-6.7 .9-10.2 .9l-66.3 0c-6.9 0-13.6-1-20-2.8c-14.7-4.1-27.7-12.7-37.4-24.6L23.2 158.3c-5 2.5-10.9 2.2-15.6-.7S0 149.5 0 144zM352 320l288 0 0 144c0 26.5-21.5 48-48 48l-105.1 0c-4.1 0-7.8-2.6-9.1-6.6l-20.7-62.1c-2.9-8.8-15.3-8.8-18.2 0l-20.7 62.1c-1.3 3.9-5 6.6-9.1 6.6l-9.1 0c-26.5 0-48-21.5-48-48l0-144z',
      'M352 464l0 .2L352 320l288 0 0-29.7c0-21.4-10.7-41.4-28.5-53.3l-65.1-43.4c-.8-.5-1.6-.9-2.4-1.2L544 48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 144.5c-.9 .3-1.7 .7-2.4 1.2L380.5 237c-17.8 11.9-28.5 31.9-28.5 53.3L352 464zM496 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM131.8 160c-6.9 0-13.6-1-20-2.8L98.8 448.1C97.3 482.9 125.1 512 160 512s62.7-29.1 61.2-63.9l-12.8-289c-3.3 .6-6.7 .9-10.2 .9l-66.3 0z',
    ],
  ],
};
const faTarp = {
  prefix: 'fad',
  iconName: 'tarp',
  icon: [
    576,
    512,
    [],
    'e57b',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32l128 0 0-160c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M576 288L416 448l0-128c0-17.7 14.3-32 32-32l128 0z',
    ],
  ],
};
const faFaceSleepy = {
  prefix: 'fad',
  iconName: 'face-sleepy',
  icon: [
    512,
    512,
    [],
    'e38e',
    [
      'M0 256C0 397.4 114.6 512 256 512c47.1 0 91.2-12.7 129.1-34.9c-.7-4.3-1.1-8.7-1.1-13.1c0-16.3-.2-37.2-6.5-56.6c-5.9-18.2-16.4-33.3-37.4-41.7c-14.2-5.7-22.4-20.7-19.5-35.8s16.1-25.9 31.4-25.9c31.6 0 77.6 14.7 115.4 39.1c7.6 4.9 15.3 10.5 22.7 16.7c14.1-31.7 22-66.9 22-103.9C512 114.6 397.4 0 256 0S0 114.6 0 256zm99.2 9.6c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0zM176 389.5C191.1 364.8 221.3 348 256 348s64.9 16.8 80.1 41.5c6.8 11.1-6 20.7-18.3 16.4c-18.9-6.5-39.8-10.1-61.8-10.1s-42.9 3.6-61.8 10.1c-12.3 4.2-25.1-5.3-18.3-16.4zM291.2 265.6c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0z',
      'M195.2 246.4c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm192 0c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zM512 464c0-80-112-128-160-128c64 25.6 64 96 64 128c0 26.5 21.5 48 48 48s48-21.5 48-48z',
    ],
  ],
};
const faHandHorns = {
  prefix: 'fad',
  iconName: 'hand-horns',
  icon: [
    384,
    512,
    [],
    'e1a9',
    [
      'M0 336l0 27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l0-64 0-96 0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 0 64c0 35.3-28.7 64-64 64c-11.7 0-22.6-3.1-32-8.6l0 .6c0 39.8-32.2 72-72 72l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-88 0c-35.3 0-64 28.7-64 64zM32 32l0 208 64 0L96 32C96 14.3 81.7 0 64 0S32 14.3 32 32z',
      'M160 128c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faScrewdriverWrench = {
  prefix: 'fad',
  iconName: 'screwdriver-wrench',
  icon: [
    512,
    512,
    ['tools'],
    'f7d9',
    [
      'M0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1C7.2 408.8 0 426.1 0 444.1zM104 432a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 144c0 .3 0 .5 0 .8l85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7L352 176c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144z',
      'M47 7c8.5-8.5 22-9.4 31.6-2.1l104 80c5.9 4.5 9.4 11.6 9.4 19l0 54.1 109 109c29-14.7 65.4-10 89.6 14.3l112 112c12.5 12.5 12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-24.2-24.2-29-60.6-14.3-89.6l-109-109L104 192c-7.5 0-14.5-3.5-19-9.4L5 78.6C-2.4 69.1-1.5 55.6 7 47L47 7z',
    ],
  ],
};
const faTools = faScrewdriverWrench;
const faArrowsToEye = {
  prefix: 'fad',
  iconName: 'arrows-to-eye',
  icon: [
    640,
    512,
    [],
    'e4bf',
    [
      'M8 32c0 6.1 2.3 12.3 7 17l63 63L40 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0c13.3 0 24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 38.1L49 15c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7s-7 10.8-7 17zM8 480c0 6.1 2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7l63-63 0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0L15 463c-4.7 4.7-7 10.8-7 17zM480 40l0 96c0 13.3 10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-38.1 0 63-63c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17s-10.8-7-17-7s-12.3 2.3-17 7l-63 63L528 40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 336l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-38.1 63 63c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7s7-10.8 7-17s-2.3-12.3-7-17l-63-63 38.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24z',
      'M133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faCircleThreeQuarters = {
  prefix: 'fad',
  iconName: 'circle-three-quarters',
  icon: [
    512,
    512,
    [],
    'e125',
    [
      'M256 0l0 256 256 0C512 114.6 397.4 0 256 0z',
      'M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H256V0z',
    ],
  ],
};
const faTrophyStar = {
  prefix: 'fad',
  iconName: 'trophy-star',
  icon: [
    576,
    512,
    ['trophy-alt'],
    'f2eb',
    [
      'M0 88C0 74.7 10.7 64 24 64l105.9 0c.3 4.3 .6 8.5 .9 12.7c.3 4.1 .6 8.1 1 12c.7 8 1.5 15.7 2.4 23.3l-85.3 0c7.5 97.9 60.9 150.6 114.6 179.9c11 6 22 11 32.6 15.2c6.5 10.1 13.2 18.9 19.8 26.5c3.3 3.8 6.6 7.4 9.8 10.6c1.6 1.6 3.2 3.2 4.8 4.7s3.2 3 4.7 4.3c6.1 5.4 11.2 11.7 14.9 18.7c-4.7-.8-9.8-1.9-15.3-3.1c-25.5-5.7-59.8-16.1-94.3-35C70.4 295.7 0 222.5 0 88zm208.3 61.6c-4.7-4.6-2.1-12.7 4.4-13.6c14.3-2.1 28.6-4.2 42.9-6.2c2.6-.4 4.9-2 6-4.4l19.2-38.9c2.9-5.9 11.4-5.9 14.3 0c6.4 13 12.8 25.9 19.2 38.9c1.2 2.4 3.4 4 6 4.4c14.3 2.1 28.6 4.2 42.9 6.2c6.6 1 9.2 9 4.4 13.6c-10.3 10.1-20.7 20.2-31 30.2c-1.9 1.8-2.7 4.5-2.3 7.1c2.4 14.3 4.9 28.5 7.3 42.7c1.1 6.5-5.7 11.5-11.6 8.4L291.7 218c-2.4-1.2-5.1-1.2-7.4 0c-12.8 6.7-25.6 13.4-38.4 20.2c-5.9 3.1-12.7-1.9-11.6-8.4c2.4-14.2 4.9-28.5 7.3-42.7c.4-2.6-.4-5.2-2.3-7.1c-10.3-10.1-20.7-20.2-31-30.2zM325.9 372.1c3.7-7 8.8-13.4 14.8-18.7c12.5-11.1 26-26.1 39.4-46.4c10.5-4.2 21.4-9.2 32.3-15.1c53.7-29.4 107.1-82 114.6-179.9l-85.3 0c.9-7.6 1.7-15.3 2.4-23.5c.3-3.9 .7-7.9 1-11.8l0-.5c.3-3.6 .5-7.3 .8-10.8c0-.4 .1-.9 .1-1.3L552 64c13.3 0 24 10.7 24 24c0 134.5-70.4 207.7-140.5 246.1c-34.5 18.9-68.8 29.3-94.3 35c-5.5 1.2-10.6 2.3-15.3 3.1z',
      'M235.2 353.4c12.2 10.8 20.8 25.7 20.8 42l0 4.5c0 26.5-21.5 48-48 48l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c-26.5 0-48-21.5-48-48l0-4.5c0-16.3 8.6-31.2 20.8-42C383.8 315.3 438.7 231 446.9 48c1.2-26.5-20.4-48-47-48L176 0c-26.5 0-48.1 21.6-47 48c8.2 183 63.2 267.2 106.2 305.4zm60-266.9l19.2 38.9c1.2 2.4 3.4 4 6 4.4l42.9 6.2c6.6 1 9.2 9 4.4 13.6l-31 30.2c-1.9 1.8-2.7 4.5-2.3 7.1l7.3 42.7c1.1 6.5-5.7 11.5-11.6 8.4L291.7 218c-2.3-1.2-5.1-1.2-7.4 0l-38.4 20.2c-5.9 3.1-12.7-1.9-11.6-8.4l7.3-42.7c.4-2.6-.4-5.2-2.3-7.1l-31-30.2c-4.7-4.6-2.1-12.7 4.4-13.6l42.9-6.2c2.6-.4 4.9-2 6-4.4l19.2-38.9c2.9-5.9 11.4-5.9 14.3 0z',
    ],
  ],
};
const faTrophyAlt = faTrophyStar;
const faPlugCircleBolt = {
  prefix: 'fad',
  iconName: 'plug-circle-bolt',
  icon: [
    576,
    512,
    [],
    'e55b',
    [
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 67.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.2C87 398 32 333.4 32 256l0-32c-17.7 0-32-14.3-32-32zM64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 96-64 0 0-96zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96-64 0 0-96z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2z',
    ],
  ],
};
const faFaceThermometer = {
  prefix: 'fad',
  iconName: 'face-thermometer',
  icon: [
    576,
    512,
    [],
    'e39a',
    [
      'M32 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-3.2-.1-6.4-.2-9.6c-4.5 4.3-9 8.7-13.5 13l-15.3 14.8c-5.8 5.6-11.5 11.1-17.3 16.7l-15.3 14.8c-5.8 5.6-11.5 11.1-17.3 16.7l-15.3 14.8c-5.8 5.6-11.5 11.1-17.3 16.7L407 378.4c2.3 6.1 .7 13.2-4.5 17.7c-6.7 5.8-16.8 5.1-22.6-1.6C362 373.8 331.4 352 288 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5c18.6 0 35.3 3.2 50.2 8.4L489 182.4c.7-.7 1.4-1.3 2.2-2s1.5-1.2 2.3-1.8c1.5-1.1 3.1-2.1 4.8-3c3.3-1.8 6.7-3.1 10.3-3.9c7.1-1.7 14.5-1.5 21.6 .5C495.2 72 400 0 288 0C146.6 0 32 114.6 32 256zm208.4-48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M548 182.8c-16.2-16.2-42.5-16.5-59-.5l-150.8 146c29.2 10.2 51.2 28.2 65.9 45.2c1.3 1.5 2.2 3.1 2.9 4.8l25.7-24.7-25.1-25.1c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.4 25.4 15.3-14.8-25.7-25.7c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26 26 15.3-14.8-26.3-26.3c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.6 26.6 15.3-14.8-26.9-26.9c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l27.2 27.2c16.7-16.4 16.9-43.3 .3-59.8zM240.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faGridRound4 = {
  prefix: 'fad',
  iconName: 'grid-round-4',
  icon: [
    448,
    512,
    [],
    'e5dd',
    [
      'M0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM119.5 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm0 238.9a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM238.9 196.3a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm0 238.9a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM358.4 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm0 238.9a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z',
      'M44.8 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 238.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm74.7-74.7a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zM238.9 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm74.7-74.7a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6z',
    ],
  ],
};
const faSignPostsWrench = {
  prefix: 'fad',
  iconName: 'sign-posts-wrench',
  icon: [
    640,
    512,
    [],
    'e626',
    [
      'M0 80L0 368c0 26.5 21.5 48 48 48l336 0c-20.1-26.7-32-60-32-96c0-49.9 22.9-94.5 58.6-123.8c14.2-11.7 32.6-12.2 46.7-4.6c13.6 7.3 22.7 21.7 22.7 38.3l0 58.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-58.1c0-16.6 9.1-31 22.7-38.3c2.9-1.6 6.1-2.8 9.3-3.7L576 80c0-26.5-21.5-48-48-48l-16 0c0-17.7-14.3-32-32-32s-32 14.3-32 32L128 32c0-17.7-14.3-32-32-32S64 14.3 64 32L48 32C21.5 32 0 53.5 0 80zM64 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0zM511.7 192l.3 0 .3 0-.7 0z',
      'M592 419.9c29.3-23.5 48-59.5 48-99.9c0-39.9-18.3-75.6-46.9-99c-7.1-5.9-17.1-.3-17.1 9l0 58.1c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-58.1c0-9.2-9.9-14.8-17.1-9c-28.6 23.5-46.9 59.1-46.9 99c0 40.4 18.7 76.5 48 99.9l0 56.1c0 19.9 16.1 36 36 36l88 0c19.9 0 36-16.1 36-36l0-56.1zM512 192l-.3 0 .7 0-.3 0z',
    ],
  ],
};
const faShirtRunning = {
  prefix: 'fad',
  iconName: 'shirt-running',
  icon: [
    384,
    512,
    [],
    'e3c8',
    [
      'M0 282.5L0 393.8 342.5 149.2c-4-23.6-6.5-51.8-6.5-85.2l0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48C112 14.3 97.7 0 80 0S48 14.3 48 32l0 32c0 91-19.2 143.6-33.3 170.1C6.7 249.1 0 265.5 0 282.5zM3.8 469.8C12.7 494.4 36.3 512 64 512l256 0c35.3 0 64-28.7 64-64l0-165.5c0-17-6.7-33.5-14.7-48.4c-2.8-5.3-5.8-11.6-8.9-19C241.6 299.9 122.7 384.8 3.8 469.8z',
      'M342.5 149.2L0 393.8 0 448c0 7.6 1.3 15 3.8 21.8L360.4 215c-6.6-16.2-13.2-37.9-17.9-65.9z',
    ],
  ],
};
const faBookCircleArrowUp = {
  prefix: 'fad',
  iconName: 'book-circle-arrow-up',
  icon: [
    640,
    512,
    [],
    'e0bd',
    [
      'M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 166.6C374.1 219.5 320 287.4 320 368c0 5.4 .2 10.7 .7 16L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l243.2 0c13.1 25.6 32.2 47.6 55.6 64L384 512 96 512c-53 0-96-43-96-96L0 96z',
      'M640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 348.7l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z',
    ],
  ],
};
const faFaceNauseated = {
  prefix: 'fad',
  iconName: 'face-nauseated',
  icon: [
    512,
    512,
    [],
    'e381',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm80-96c0-7.7 5.5-14.5 13.4-15.8l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2c-.1-.9-.2-1.8-.2-2.6zm63.6 48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .8 .1 1.6 .1 1.6l0 1.7c0 1.1 0 1.4 0 1.7c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm2.5 80.6c4.4-7.6 14.2-10.3 21.9-5.8c19.5 11.3 33.8 30.5 38.4 53.3l99.2 0c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3l-99.2 0c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM316.7 100.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c7.8 1.3 13.4 8.1 13.4 15.8c0 .9-.1 1.8-.2 2.6c-1.5 8.7-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z',
      'M195.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM175.6 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-18.9-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z',
    ],
  ],
};
const faHeart = {
  prefix: 'fad',
  iconName: 'heart',
  icon: [
    512,
    512,
    [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578],
    'f004',
    [
      'M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z',
      '',
    ],
  ],
};
const faFileChartPie = {
  prefix: 'fad',
  iconName: 'file-chart-pie',
  icon: [
    384,
    512,
    [],
    'f65a',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 328c0 66.3 53.7 120 120 120c51.2 0 94.9-32.1 112.1-77.2c3.6-9.5-4-18.8-14.1-18.8c-35.3 0-70.7 0-106 0c-8.8 0-16-7.2-16-16l0-106c0-10.1-9.3-17.7-18.8-14.1C96.1 233.1 64 276.8 64 328zM192 216l0 88c0 8.8 7.2 16 16 16l88 0c8.8 0 16.1-7.2 14.9-16c-7.1-53.5-49.5-95.9-103-103c-8.8-1.2-16 6.1-16 14.9z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM141.2 215.9c9.5-3.6 18.8 4 18.8 14.1l0 106c0 8.8 7.2 16 16 16l106 0c10.1 0 17.7 9.3 14.1 18.8C278.9 415.9 235.2 448 184 448c-66.3 0-120-53.7-120-120c0-51.2 32.1-94.9 77.2-112.1z',
    ],
  ],
};
const faMarsAndVenus = {
  prefix: 'fad',
  iconName: 'mars-and-venus',
  icon: [
    512,
    512,
    [9893],
    'f224',
    [
      'M192 224a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M337.8 14.8C341.5 5.8 350.3 0 360 0L472 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2l0 25.8 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-25.8C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48s0 0 0 0s0 0 0 0s0 0 0 0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z',
    ],
  ],
};
const faHouseUser = {
  prefix: 'fad',
  iconName: 'house-user',
  icon: [
    576,
    512,
    ['home-user'],
    'e1b0',
    [
      'M64 270.5l224-196c74.7 65.4 149.4 130.7 224.1 196.1l.4 177.3c.1 35.4-28.6 64.1-64 64.1l-320.4 0c-35.3 0-64-28.6-64-64L64 270.5zM176.4 423.8c-.1 1.3-.2 2.7-.3 4.1c-.1 1.4-.1 2.7-.1 4.1c0 .6 0 1.1 .1 1.6s.1 1.1 .2 1.6c.2 1 .5 2 .9 3c.8 1.9 2 3.6 3.4 5.1c2.9 2.9 6.9 4.7 11.3 4.7l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-22.1 0-42.1 9-56.6 23.4c-7.2 7.2-13.1 15.9-17.1 25.4c-2 4.8-3.6 9.8-4.7 15c-.5 2.6-.9 5.3-1.2 7.9zm47.9-174.4c-.1 1.1-.2 2.2-.2 3.2c-.1 1.1-.1 2.2-.1 3.3s0 2.2 .1 3.3c.1 1.1 .1 2.2 .2 3.2c.2 2.1 .5 4.3 1 6.4c.9 4.2 2.1 8.2 3.7 12c3.2 7.7 7.9 14.6 13.7 20.3C254.3 312.8 270.3 320 288 320c35.3 0 64-28.7 64-64s-28.7-64-64-64c-17.7 0-33.7 7.2-45.3 18.7c-5.8 5.8-10.5 12.7-13.7 20.3c-1.6 3.8-2.9 7.8-3.7 12c-.4 2.1-.8 4.2-1 6.4z',
      'M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224zM224 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 96l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z',
    ],
  ],
};
const faHomeUser = faHouseUser;
const faCircleArrowDownLeft = {
  prefix: 'fad',
  iconName: 'circle-arrow-down-left',
  icon: [
    512,
    512,
    [],
    'e0f9',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.1L327 151c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-135 135 94.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-152 0c-13.3 0-24-10.7-24-24l0-160z',
      'M168 368l152 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-94.1 0L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L192 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faDumpsterFire = {
  prefix: 'fad',
  iconName: 'dumpster-fire',
  icon: [
    640,
    512,
    [],
    'f794',
    [
      'M0 139.1C0 150.7 9.3 160 20.9 160l94 0L140.5 32 49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1zM0 256c0 17.7 14.3 32 32 32l12 0L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32l209.6 0c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4c3.8-6.2 7.9-12.5 12.3-18.7L32 192l4 32-4 0c-17.7 0-32 14.3-32 32zm147.5-96L272 160l0-128-98.9 0L147.5 160zM304 32l0 128 58 0c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32 304 32zm131.5 0l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.7-1.6 3.3-3.2 5-4.8c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32l-90.8 0z',
      'M518 162.5l-12.3 13.8-19-19.9c-2-2.1-4-4.4-6-6.7c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 246.8 320 282.8 320 320.2C320 408.7 390.4 480 480 480c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9zM480 432.2c-35.3 0-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 295.1 544 331.6 544 368.2c0 35.3-28.7 64-64 64z',
    ],
  ],
};
const faHexagonMinus = {
  prefix: 'fad',
  iconName: 'hexagon-minus',
  icon: [
    512,
    512,
    ['minus-hexagon'],
    'f307',
    [
      'M7.4 256c0 12.4 3.2 24.9 9.6 36l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c6.4-11.1 9.6-23.6 9.6-36s-3.2-24.9-9.6-36L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220c-6.4 11.1-9.6 23.6-9.6 36zM160 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M160 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faMinusHexagon = faHexagonMinus;
const faLeftToLine = {
  prefix: 'fad',
  iconName: 'left-to-line',
  icon: [
    448,
    512,
    ['arrow-alt-to-left'],
    'f34b',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M107.3 283.3L230.1 406.1c6.4 6.4 15 9.9 24 9.9c18.7 0 33.9-15.2 33.9-33.9l0-62.1 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-62.1c0-18.7-15.2-33.9-33.9-33.9c-9 0-17.6 3.6-24 9.9L107.3 228.7C100.1 235.9 96 245.8 96 256s4.1 20.1 11.3 27.3z',
    ],
  ],
};
const faArrowAltToLeft = faLeftToLine;
const faHouseCrack = {
  prefix: 'fad',
  iconName: 'house-crack',
  icon: [
    576,
    512,
    [],
    'e3b1',
    [
      'M64 270.5L64.1 448c0 35.3 28.7 64 64 64l102.3 0-31.4-52.3c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64 122.1 0c35.4 0 64-28.7 64-64c-.1-59.2-.3-118.3-.4-177.4L288 74.5 64 270.5z',
      'M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z',
    ],
  ],
};
const faPawSimple = {
  prefix: 'fad',
  iconName: 'paw-simple',
  icon: [
    448,
    512,
    ['paw-alt'],
    'f701',
    [
      'M0 192a48 48 0 1 0 96 0A48 48 0 1 0 0 192zM96 80a48 48 0 1 0 96 0A48 48 0 1 0 96 80zm160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm96 112a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M97.7 286c6.2-2.3 11.8-6.3 15-12.2l40-71.9c14.4-25.9 41.7-42 71.3-42s56.9 16.1 71.3 42l40 71.9c3.2 5.8 8.8 9.9 15 12.2c38.3 14 65.7 50.8 65.7 94c0 55.2-44.8 100-100 100c-21.2 0-40.8-6.6-56.9-17.8c-17.4-12-52.8-12-70.1 0C172.8 473.4 153.2 480 132 480C76.8 480 32 435.2 32 380c0-43.2 27.4-80 65.7-94z',
    ],
  ],
};
const faPawAlt = faPawSimple;
const faArrowLeftLongToLine = {
  prefix: 'fad',
  iconName: 'arrow-left-long-to-line',
  icon: [
    640,
    512,
    [],
    'e3d4',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 608 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-370.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z',
    ],
  ],
};
const faBracketsRound = {
  prefix: 'fad',
  iconName: 'brackets-round',
  icon: [
    512,
    512,
    ['parentheses'],
    'e0c5',
    [
      'M352 64c0 10.3 5 20.5 14.3 26.7C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4C363.5 475 373.7 480 384 480c6.1 0 12.3-1.7 17.7-5.4C440.1 449.1 512 371.8 512 256s-71.9-193.1-110.2-218.6C396.3 33.7 390.1 32 384 32c-10.3 0-20.5 5-26.7 14.3C353.7 51.7 352 57.9 352 64z',
      'M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z',
    ],
  ],
};
const faParentheses = faBracketsRound;
const faMartiniGlassCitrus = {
  prefix: 'fad',
  iconName: 'martini-glass-citrus',
  icon: [
    576,
    512,
    ['cocktail'],
    'f561',
    [
      'M1.8 142.8c-3.7 9-1.7 19.3 5.2 26.2l177 177L184 464l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-118.1c33.1-33.1 66.1-66.1 99.2-99.2c11.3-11.3 22.6-22.6 33.9-33.9c14.6-14.6 29.3-29.3 43.9-43.9c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8l-54.7 0-48.4 0L24 128c-9.7 0-18.5 5.8-22.2 14.8z',
      'M432 240c53 0 96-43 96-96s-43-96-96-96c-47.6 0-87.1 34.6-94.7 80l-48.4 0c8-72 69-128 143.1-128c79.5 0 144 64.5 144 144s-64.5 144-144 144c-39.3 0-74.9-15.7-100.8-41.2l33.9-33.9C382.4 229.7 406 240 432 240z',
    ],
  ],
};
const faCocktail = faMartiniGlassCitrus;
const faUserShakespeare = {
  prefix: 'fad',
  iconName: 'user-shakespeare',
  icon: [
    448,
    512,
    [],
    'e2c2',
    [
      'M96.1 333.7c0 .8-.1 1.5-.1 2.3l0 37.3c0 15.6 16.7 25.4 30.4 17.9c1.6-.9 3.1-1.7 4.7-2.5c1.6-.8 3.2-1.6 4.8-2.4c3.2-1.6 6.5-3 9.8-4.4c6.6-2.7 13.3-5 20.2-7c13.7-3.9 27.8-6.1 42.1-6.7l0-80.2-64 0c-25.8 0-46.8 20.3-47.9 45.7zM128 96l0 64c0 33.4 17 62.8 42.9 80c12.1 8 26 13.4 41.1 15.3l0-31.3c0-6.6 5.4-12 12-12s12 5.4 12 12l0 31.3c15.1-1.9 29-7.2 41.1-15.3C303 222.8 320 193.4 320 160l0-64c0-9.6-1.4-18.9-4-27.7C304.1 28.8 267.4 0 224 0s-80.1 28.8-92 68.3c-2.6 8.8-4 18-4 27.7zm80 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-28 64c0-6.6 5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12zm92-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM240 288l0 80.2c28.6 1.2 56.6 9 81.6 23c13.6 7.6 30.4-2.3 30.4-17.9l0-37.3c0-.7 0-1.5-.1-2.3C350.8 308.3 329.8 288 304 288l-64 0z',
      'M128 96l0 64c0 33.4 17 62.8 42.9 80l-65.8 0C82.4 240 64 221.6 64 198.9c0-9.6 3.4-18.9 9.5-26.3l19.3-23.2c7.2-8.6 11.1-19.5 11.1-30.7l0-6.6c0-19.4 11.5-36.1 28-43.7c-2.6 8.8-4 18-4 27.7zm192 0c0-9.6-1.4-18.9-4-27.7c16.5 7.6 28 24.3 28 43.7l0 6.6c0 11.2 3.9 22.1 11.1 30.7l19.3 23.2c6.2 7.4 9.5 16.7 9.5 26.3c0 22.7-18.4 41.1-41.1 41.1l-65.8 0C303 222.8 320 193.4 320 160l0-64zM192 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-4 96l0 32c0 6.6-5.4 12-12 12s-12-5.4-12-12l0-32c0-6.6 5.4-12 12-12s12 5.4 12 12zm-20.5-56.5c4.7-4.7 12.3-4.7 17 0c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5zM96 336l0 37.3c0 15.6 16.7 25.4 30.4 17.9c27.3-15.2 58-23.1 89.3-23.1l16.7 0c31.2 0 62 8 89.3 23.1c13.6 7.6 30.4-2.3 30.4-17.9l0-37.3c0-.8 0-1.5-.1-2.3c56.6 25 96.1 81.7 96.1 147.5c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-65.9 39.5-122.5 96.1-147.5c0 .8-.1 1.5-.1 2.3zm144 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faArrowRightToArc = {
  prefix: 'fad',
  iconName: 'arrow-right-to-arc',
  icon: [
    512,
    512,
    [],
    'e4b2',
    [
      'M224 32c0 17.7 14.3 32 32 32c106 0 192 86 192 192s-86 192-192 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c141.4 0 256-114.6 256-256S397.4 0 256 0c-17.7 0-32 14.3-32 32z',
      'M185.4 121.4c12.5-12.5 32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l210.7 0-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3z',
    ],
  ],
};
const faFaceSurprise = {
  prefix: 'fad',
  iconName: 'face-surprise',
  icon: [
    512,
    512,
    [128558, 'surprise'],
    'f5c2',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM320 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm48.4-144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faSurprise = faFaceSurprise;
const faBottleWater = {
  prefix: 'fad',
  iconName: 'bottle-water',
  icon: [
    320,
    512,
    [],
    'e4c5',
    [
      'M32 167.5c0 17 7.5 32.3 19.4 42.6C39.4 221.7 32 238 32 256c0 19.1 8.4 36.3 21.7 48C40.4 315.7 32 332.9 32 352s8.4 36.3 21.7 48C40.4 411.7 32 428.9 32 448c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-19.1-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48s-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48c0-18-7.4-34.3-19.4-45.9c11.9-10.4 19.4-25.6 19.4-42.6c0-19.5-10-37.6-26.6-47.9c-12.6-7.9-25.1-15.7-37.6-23.6L96 96c-12.3 7.9-24.9 15.7-37.4 23.6C42 129.9 32 148 32 167.5zM96 240c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 128c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
      'M120 0C106.7 0 96 10.7 96 24l0 72 128 0 0-72c0-13.3-10.7-24-24-24L120 0zM96 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faCirclePause = {
  prefix: 'fad',
  iconName: 'circle-pause',
  icon: [
    512,
    512,
    [62092, 'pause-circle'],
    'f28b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128zm128 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128z',
      'M192 160c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faPauseCircle = faCirclePause;
const faGaugeCirclePlus = {
  prefix: 'fad',
  iconName: 'gauge-circle-plus',
  icon: [
    640,
    512,
    [],
    'e498',
    [
      'M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faFolders = {
  prefix: 'fad',
  iconName: 'folders',
  icon: [
    576,
    512,
    [],
    'f660',
    [
      'M0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24S0 106.7 0 120z',
      'M160 384H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64z',
    ],
  ],
};
const faAngel = {
  prefix: 'fad',
  iconName: 'angel',
  icon: [
    576,
    512,
    [],
    'f779',
    [
      'M0 466.7c0 25 20.3 45.3 45.3 45.3L96 512l99.4-198.8c.8-1.5 1.6-3 2.4-4.5s1.7-2.9 2.6-4.4c1.8-2.9 3.7-5.6 5.8-8.3c4.1-5.3 8.7-10.1 13.6-14.5c9.9-8.7 21.5-15.4 34-19.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3l0 .9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7zM160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6c0-.2 0-.3 0-.3s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6c0 .2 0 .3 0 .3s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64zM322.2 261.8c25 8.8 46.2 26.9 58.4 51.4L480 512l50.7 0c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3l0-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6z',
      'M288 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 512l99.4-198.8C212.9 278.2 248.8 256 288 256s75.1 22.2 92.6 57.2L480 512 96 512z',
    ],
  ],
};
const faValueAbsolute = {
  prefix: 'fad',
  iconName: 'value-absolute',
  icon: [
    512,
    512,
    [],
    'f6a6',
    [
      'M0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64zm448 0l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7l-73.4-73.4z',
    ],
  ],
};
const faRabbit = {
  prefix: 'fad',
  iconName: 'rabbit',
  icon: [
    512,
    512,
    [128007],
    'f708',
    [
      'M96 432c0-12.1 1.1-24 3.3-35.5C114 317.7 176.8 255.9 256 242.7l0-49.2c0-10.9 2.7-21.2 7.4-30.2c-34.3-36.5-50.3-86.8-43.2-136.8l.7-4.9C222.7 9.2 233.2 0 245.7 0c6.6 0 12.9 2.6 17.6 7.3l3.1 3.1c31.8 31.5 47.9 74.8 45.4 118.4c3.1-.5 6.3-.7 9.6-.7c4.8 0 9.6 .3 14.3 .9c1.1-24-2.6-47.9-10.9-70.1c7.6-17.8 18.6-34.2 32.7-48.3l4.6-4.6c3.7-3.7 8.8-5.8 14-5.8c9.2 0 17.2 6.4 19.3 15.4l1 4.4c9.8 42.4 1.8 86.5-21 122.4c5.5 3.1 10.7 6.6 15.6 10.6L425.8 181c14 11.4 22.2 28.6 22.2 46.7c0 33.3-27 60.3-60.3 60.3L352 288l0 25.8 61.7 154.3c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-39.4-98.6L265.6 448l22.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0-48 0c-28.5 0-52.6-18.6-60.9-44.3c-2-6.2-3.1-12.9-3.1-19.7l0-16zM352 208a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M368 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 432l0 16c0 6.9 1.1 13.5 3.1 19.8C88.8 480.1 73.3 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C97.1 408 96 419.9 96 432z',
    ],
  ],
};
const faToiletPaperSlash = {
  prefix: 'fad',
  iconName: 'toilet-paper-slash',
  icon: [
    640,
    512,
    [],
    'e072',
    [
      'M20.2 495.8C25.9 505.8 36.5 512 48 512l237.9 0c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2zM95.6 49.6c95.3 74.7 190.5 149.3 285.8 224c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192L160 0c-24.8 0-47.4 18.8-64.4 49.6zM416 192c0 49.1 9.2 93.9 24.4 127.9c26.9 21.1 53.8 42.2 80.7 63.3C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192zm64 0c0-35.3 14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64s-32-28.7-32-64z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faCircleEuro = {
  prefix: 'fad',
  iconName: 'circle-euro',
  icon: [
    512,
    512,
    [],
    'e5ce',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112-32c0-8.8 7.2-16 16-16l24.7 0c19.2-46.9 65.4-80 119.2-80l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-26.3 0-49.6 12.6-64.4 32l80.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-95.1 0c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2l95.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-81.6 0c14.7 20.3 38.5 33.5 65.5 33.5l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-54.4 0-101-33.8-119.8-81.5L128 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8L128 240c-8.8 0-16-7.2-16-16z',
      'M144.2 240c-.7 5.5-1.1 11.1-1.1 16.8c0 5.2 .3 10.2 .9 15.2l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24.1 0c18.8 47.7 65.4 81.5 119.8 81.5l41.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41.1 0c-27 0-50.8-13.2-65.5-33.5l81.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-95.4 0c-.9-4.9-1.4-10-1.4-15.2c0-5.7 .6-11.4 1.7-16.8l95.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80.5 0c14.7-19.4 38.1-32 64.4-32l41.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41.1 0c-53.9 0-100 33.1-119.2 80L128 208c-8.8 0-16 7.2-16 16s7.2 16 16 16l16.2 0z',
    ],
  ],
};
const faAppleWhole = {
  prefix: 'fad',
  iconName: 'apple-whole',
  icon: [
    448,
    512,
    [127822, 127823, 'apple-alt'],
    'f5d1',
    [
      'M208 80l0 16c0 8.8 7.2 16 16 16l16 0c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16L288 0c-44.2 0-80 35.8-80 80z',
      'M112 128C35.7 128 0 211.7 0 288C0 416 80 512 160 512c16.5 0 38.1-6.6 51.5-11.3c8.1-2.8 16.9-2.8 25 0c13.4 4.7 35 11.3 51.5 11.3c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z',
    ],
  ],
};
const faAppleAlt = faAppleWhole;
const faKitchenSet = {
  prefix: 'fad',
  iconName: 'kitchen-set',
  icon: [
    576,
    512,
    [],
    'e51a',
    [
      'M0 496c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480c-8.8 0-16 7.2-16 16zM64 144a80 80 0 1 0 160 0A80 80 0 1 0 64 144zM256 296c0 13.3 10.7 24 24 24l8 0 224 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-96 0c-13.3 0-24 10.7-24 24z',
      'M224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zm60.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112l71.8 0c8.8-9.8 21.6-16 35.8-16l104 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-104 0c-14.2 0-27-6.2-35.8-16l-71.8 0zM48 320l80 0 16 0 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-80c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zm336-64l0 144c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-144 224 0z',
    ],
  ],
};
const faDiamondHalf = {
  prefix: 'fad',
  iconName: 'diamond-half',
  icon: [
    512,
    512,
    [],
    'e5b7',
    [
      'M256 0c10.2 0 20.5 3.9 28.3 11.7l216 216c7.8 7.8 11.7 18 11.7 28.3s-3.9 20.5-11.7 28.3l-216 216c-7.8 7.8-18 11.7-28.3 11.7L256 0z',
      'M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7L256 0z',
    ],
  ],
};
const faLockKeyhole = {
  prefix: 'fad',
  iconName: 'lock-keyhole',
  icon: [
    448,
    512,
    ['lock-alt'],
    'f30d',
    [
      'M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 64 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144z',
      'M64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 192zM256 320l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z',
    ],
  ],
};
const faLockAlt = faLockKeyhole;
const faR = {
  prefix: 'fad',
  iconName: 'r',
  icon: [
    320,
    512,
    [114],
    '52',
    [
      'M64 32C28.7 32 0 60.7 0 96L0 288 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 95.3 0L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144L64 32zM176 256L64 256 64 96l112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z',
      '',
    ],
  ],
};
const faTemperatureQuarter = {
  prefix: 'fad',
  iconName: 'temperature-quarter',
  icon: [
    320,
    512,
    ['temperature-1', 'thermometer-1', 'thermometer-quarter'],
    'f2ca',
    [
      'M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L272 112C272 50.2 221.9 0 160 0S48 50.2 48 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L112 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M176 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7z',
    ],
  ],
};
const faTemperature1 = faTemperatureQuarter;
const faThermometer1 = faTemperatureQuarter;
const faThermometerQuarter = faTemperatureQuarter;
const faSquareInfo = {
  prefix: 'fad',
  iconName: 'square-info',
  icon: [
    448,
    512,
    [8505, 'info-square'],
    'f30f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM160 248c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64-24 0c-13.3 0-24-10.7-24-24zm96-88a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 248c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64-24 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faInfoSquare = faSquareInfo;
const faWifiSlash = {
  prefix: 'fad',
  iconName: 'wifi-slash',
  icon: [
    640,
    512,
    [],
    'f6ac',
    [
      'M8.9 202c-12.2-12.8-11.8-33 .9-45.2C20 147 30.7 137.7 41.7 128.9l51.9 40.9C79.7 179.9 66.6 191 54.2 202.9c-12.8 12.2-33 11.8-45.2-.9zM126.7 309.2c-11.7-13.3-10.4-33.5 2.8-45.2c13.4-11.9 28-22.5 43.5-31.7L228 275.7c-20.6 9.3-39.5 21.6-56.2 36.3c-13.3 11.7-33.5 10.4-45.2-2.8zm1.4-234.1C186.3 47.5 251.3 32 320 32c120.4 0 229.7 47.5 310.2 124.7c12.8 12.2 13.2 32.5 .9 45.2s-32.5 13.2-45.2 .9C516.8 136.7 423.2 96 320 96c-47.3 0-92.6 8.5-134.4 24.2c-19.2-15-38.3-30.1-57.5-45.1zM256 416c0-35.3 28.7-64 64-64c1.7 0 3.5 .1 5.2 .2L380.8 396c2.1 6.3 3.2 13 3.2 20c0 35.3-28.7 64-64 64s-64-28.7-64-64zm24.7-221.3c12.9-1.8 26-2.7 39.3-2.7c73 0 139.8 27.2 190.5 72c13.2 11.7 14.5 31.9 2.8 45.2s-31.9 14.5-45.2 2.8c-28.9-25.5-64.4-43.7-103.6-51.6c-28-21.9-55.9-43.8-83.9-65.8z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faToiletPaperXmark = {
  prefix: 'fad',
  iconName: 'toilet-paper-xmark',
  icon: [
    512,
    512,
    [],
    'e5b3',
    [
      'M0 192C0 298 43 384 96 384l32 0 32 0 256 0c-52.4 0-94.9-83.9-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0L96 0C43 0 0 86 0 192zm103-65c9.4-9.4 24.6-9.4 33.9 0l31 31 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9z',
      'M416 384c-52.4 0-94.9-83.8-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0s96 86 96 192l0 272c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-80 256 0zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z',
    ],
  ],
};
const faHandsHoldingDollar = {
  prefix: 'fad',
  iconName: 'hands-holding-dollar',
  icon: [
    640,
    512,
    ['hands-usd'],
    'f4c5',
    [
      'M0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c-5.1-5.1-10.2-10.2-15.2-15.2l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40c0-22.1-17.9-40-40-40S0 81.9 0 104zM352 385.1l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c-8.5 8.5-16.9 16.9-25.4 25.4c-21 21-32.8 49.5-32.8 79.2z',
      'M320 0c13.3 0 24 10.7 24 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L296 24c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHandsUsd = faHandsHoldingDollar;
const faCube = {
  prefix: 'fad',
  iconName: 'cube',
  icon: [
    512,
    512,
    [],
    'f1b2',
    [
      'M64 189.4c53.3 19 106.7 38.1 160 57.1l0 188L64 377.4l0-188zm224 57.1l160-57.1 0 188L288 434.6l0-188z',
      'M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6l0 242.9c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4L0 134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zM64 377.4l160 57.1 0-188L64 189.4l0 188zm224 57.1l160-57.1 0-188L288 246.6l0 188z',
    ],
  ],
};
const faArrowDownTriangleSquare = {
  prefix: 'fad',
  iconName: 'arrow-down-triangle-square',
  icon: [
    576,
    512,
    ['sort-shapes-down'],
    'f888',
    [
      'M304 192c0 5.3 1.3 10.7 4 15.5c5.6 10.2 16.4 16.5 28 16.5l160 0c11.6 0 22.3-6.3 28-16.5c2.7-4.8 4-10.2 4-15.5c0-5.9-1.6-11.8-4.9-17l-80-128C437.3 37.7 427 32 416 32s-21.3 5.7-27.1 15l-80 128c-3.2 5.2-4.9 11.1-4.9 17zm16 144l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortShapesDown = faArrowDownTriangleSquare;
const faBitcoinSign = {
  prefix: 'fad',
  iconName: 'bitcoin-sign',
  icon: [
    320,
    512,
    [],
    'e0b4',
    [
      'M48 32l0 32 64 0 0-32C112 14.3 97.7 0 80 0S48 14.3 48 32zm0 416l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0zM144 32l0 32 32 0c1.4 0 2.7 0 4.1 .1s2.7 .1 4.1 .2c2.7 .2 5.4 .5 8 .9c5.3 .8 10.5 1.9 15.5 3.4c.2-1.5 .3-3 .3-4.5l0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 416l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0z',
      'M64 224l112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 128l0 96zM0 265.7L0 224 0 101.6C0 80.8 16.8 64 37.6 64L176 64c61.9 0 112 50.1 112 112c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112L41.7 448C18.7 448 0 429.3 0 406.3L0 288l0-22.3zM176 288L64 288l0 96 144 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z',
    ],
  ],
};
const faShutters = {
  prefix: 'fad',
  iconName: 'shutters',
  icon: [
    512,
    512,
    [],
    'e449',
    [
      'M0 203.4C0 214.8 9.2 224 20.6 224l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 128 24 128 1.1 196.8c-.7 2.1-1.1 4.3-1.1 6.5zm0 128C0 342.8 9.2 352 20.6 352l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 256 24 256 1.1 324.8c-.7 2.1-1.1 4.3-1.1 6.5zm0 128C0 470.8 9.2 480 20.6 480l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 384 24 384 1.1 452.8c-.7 2.1-1.1 4.3-1.1 6.5z',
      'M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64z',
    ],
  ],
};
const faShieldDog = {
  prefix: 'fad',
  iconName: 'shield-dog',
  icon: [
    512,
    512,
    [],
    'e573',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM128 176c0-8.8 7.2-16 16-16l56 0 8 0 24 0 52.2 0c12.1 0 23.2 6.8 28.6 17.7L320 192l64 0c4.4 0 8.4 1.8 11.3 4.7c1.4 1.5 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.3l0 .4c0 10.7 0 21.3 0 32.3c0 1.4 0 2.7-.1 4.1c-.1 1.2-.2 2.5-.3 3.9c-.3 2.7-.7 5.3-1.2 7.9c-1.1 5.2-2.6 10.2-4.7 15c-4 9.6-9.9 18.2-17.1 25.4C362.1 311 342.1 320 320 320l-48 0c0 16.9 0 33.8 0 51c0 .3 0 .7-.1 1.1c0 .4-.1 .9-.2 1.3c-.2 .9-.4 1.7-.8 2.5c-.7 1.6-1.6 3-2.8 4.2c-2.4 2.4-5.7 3.9-9.4 3.9c-1.8 0-3.6-.4-5.2-1.1c-32.9-14.1-65.8-28.2-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8c7.4-14.7 14.7-29.5 22.1-44.2l-8 0c-17.7 0-32-14.3-32-32l0-64z',
      'M168 272l-22.1 44.2c-1.2 2.5-1.9 5.2-1.9 8c0 7.1 4.3 13.6 10.8 16.4l98.7 42.3c1.7 .7 3.4 1.1 5.2 1.1c7.3 0 13.3-5.9 13.3-13.3l0-50.7 48 0c44.2 0 80-35.8 80-80l0-32c0-8.8-7.2-16-16-16l-64 0-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7L232 160l-24 0 0 72c0 22.1-17.9 40-40 40zm88-64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faSolarPanel = {
  prefix: 'fad',
  iconName: 'solar-panel',
  icon: [
    640,
    512,
    [],
    'f5ba',
    [
      'M7 320.1C7 354.6 35 384 71 384l217 0 64 0 217 0c36 0 64-29.4 64-63.9c0-4.2-.4-8.4-1.3-12.7l-51.2-256C574.5 21.5 548.3 0 517.8 0L122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C7.4 311.7 7 316 7 320.1zm64-.1c6.9-34.7 13.9-69.3 20.8-104c3.2-16 6.4-32 9.6-48L122.2 64l90.4 0 48.2 0 118.2 0 48.2 0 90.4 0c6.9 34.7 13.9 69.3 20.8 104c3.2 16 6.4 32 9.6 48c6.9 34.7 13.9 69.3 20.8 104l-116 0-48.2 0-169.4 0-48.2 0L71 320z',
      'M379.1 64L260.9 64 250.5 168l139 0L379.1 64zM212.7 64l-90.4 0L101.4 168l100.8 0L212.7 64zM197.5 216L91.8 216 71 320l116 0 10.4-104zm196.8 0l-148.6 0L235.3 320l169.4 0L394.3 216zm58.6 104l116 0L548.2 216l-105.6 0 10.4 104zM517.8 64l-90.4 0 10.4 104 100.8 0L517.8 64zM416 448l-64 0 0-64-64 0 0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32z',
    ],
  ],
};
const faLockOpen = {
  prefix: 'fad',
  iconName: 'lock-open',
  icon: [
    576,
    512,
    [],
    'f3c1',
    [
      'M288 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48C576 64.5 511.5 0 432 0S288 64.5 288 144z',
      'M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z',
    ],
  ],
};
const faTableTree = {
  prefix: 'fad',
  iconName: 'table-tree',
  icon: [
    512,
    512,
    [],
    'e293',
    [
      'M96 160l0 64 0 96c0 26.5 21.5 48 48 48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-50.7c5 1.8 10.4 2.7 16 2.7l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16l0-64-32 0zm128 80l0 32c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm64 96l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 160l0 256L64 416l0-256 384 0z',
    ],
  ],
};
const faHouseChimneyHeart = {
  prefix: 'fad',
  iconName: 'house-chimney-heart',
  icon: [
    576,
    512,
    [],
    'e1b2',
    [
      'M64 270.5L64.1 448c0 35.3 28.7 64 64 64l320.4 0c35.4 0 64-28.7 64-64c-.1-59.2-.3-118.3-.4-177.4L288 74.5 64 270.5zm112 46.7c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z',
      'M266.9 7.9C279-2.6 297-2.6 309.1 7.9L416 101.5 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121.5 53.1 46.4c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224zM237.3 256c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z',
    ],
  ],
};
const faTally3 = {
  prefix: 'fad',
  iconName: 'tally-3',
  icon: [
    640,
    512,
    [],
    'e296',
    [
      'M96 64l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 0l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M384 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faElevator = {
  prefix: 'fad',
  iconName: 'elevator',
  icon: [
    512,
    512,
    [],
    'e16d',
    [
      'M0 192L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64zM80 400c0-.4 0-.8 0 0zm32-128c0-.4 0-.8 0 0zM272 400c0-.4 0-.8 0 0zm32-128c0-.4 0-.8 0 0z',
      'M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9L80 96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zm224 86.6l-64-64c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9L432 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm192 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
    ],
  ],
};
const faMoneyBillTransfer = {
  prefix: 'fad',
  iconName: 'money-bill-transfer',
  icon: [
    640,
    512,
    [],
    'e528',
    [
      'M32 128l0 214.5 19.2-19.2c20.3-20.3 53.2-20.3 73.5 0C138 336.5 142.6 355 138.6 372L256 372c28.7 0 52 23.3 52 52c0 8.7-2.1 16.8-5.9 24L544 448c35.3 0 64-28.7 64-64l0-214.5-19.2 19.2c-20.3 20.3-53.2 20.3-73.5 0C502 175.5 497.4 157 501.4 140L384 140c-28.7 0-52-23.3-52-52c0-8.7 2.1-16.8 5.9-24L96 64c-35.3 0-64 28.7-64 64zm64 0l64 0c0 35.3-28.7 64-64 64l0-64zM416 256a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zm64 128c0-35.3 28.7-64 64-64l0 64-64 0z',
      'M558.1 64L384 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l174.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17L569 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23zM81.9 400l23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 407c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23L256 448c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 400z',
    ],
  ],
};
const faMoneyBillTrendUp = {
  prefix: 'fad',
  iconName: 'money-bill-trend-up',
  icon: [
    512,
    512,
    [],
    'e529',
    [
      'M0 304L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256c-26.5 0-48 21.5-48 48zm48 0l48 0c0 26.5-21.5 48-48 48l0-48zm0 112c26.5 0 48 21.5 48 48l-48 0 0-48zm272-32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-80l48 0 0 48c-26.5 0-48-21.5-48-48zm0 160c0-26.5 21.5-48 48-48l0 48-48 0z',
      'M477.6 19.8c-1.5-3.7-3.8-7.3-6.9-10.3l-.1-.1C464.8 3.6 456.8 0 448 0c0 0 0 0 0 0L352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l18.7 0-84.4 84.4L196.8 71.7c-12-10.3-29.7-10.3-41.7 0l-112 96c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5L176 138.1l91.2 78.1c12.7 10.9 31.6 10.2 43.5-1.7L416 109.3l0 18.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96s0 0 0 0c0 0 0-.1 0-.1c0-4.3-.9-8.4-2.4-12.2z',
    ],
  ],
};
const faHouseFloodWaterCircleArrowRight = {
  prefix: 'fad',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [
    640,
    512,
    [],
    'e50f',
    [
      'M32.8 375.3c-4-17.2 6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7C168.7 325.2 197.1 336 224 336c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0C361 325.4 388.5 336 416 336c26.9 0 55.4-10.8 77.5-26.1c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C481.5 389.7 449 400 416 400c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9zm0 112c-4-17.2 6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7C168.7 437.2 197.1 448 224 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0C361 437.4 388.5 448 416 448c26.9 0 55.4-10.8 77.5-26.1c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4C603.7 502 590.6 512 576 512c-2.4 0-4.8-.3-7.3-.8c-24.5-5.7-44.9-16.5-58.2-25C481.5 501.7 449 512 416 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-2.4 .6-4.9 .8-7.3 .8c-14.5 0-27.7-10-31.1-24.7zM250.2 284.3c42.4-32.1 69.8-83 69.8-140.3c0-28.6-6.8-55.7-19-79.6L381.2 6.1C386.8 2 393.4 0 400 0s13.2 2 18.8 6.1l176 128c11.2 8.2 15.9 22.6 11.6 35.8S589.9 192 576 192l-16.6 0 .3 84.4c-2.3-1.5-4.4-3.2-6.5-4.9c-22.2-18.7-54.3-20.1-78.1-3.4c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-10 6.9-21.2 12.6-33 16.2z',
      'M144 288A144 144 0 1 0 144 0a144 144 0 1 0 0 288zM163.3 76.7l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160 80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z',
    ],
  ],
};
const faSquarePollHorizontal = {
  prefix: 'fad',
  iconName: 'square-poll-horizontal',
  icon: [
    448,
    512,
    ['poll-h'],
    'f682',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 64c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm0 96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32z',
      'M224 128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0zm96 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z',
    ],
  ],
};
const faPollH = faSquarePollHorizontal;
const faCircle = {
  prefix: 'fad',
  iconName: 'circle',
  icon: [
    512,
    512,
    [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915],
    'f111',
    ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z', ''],
  ],
};
const faLeftToBracket = {
  prefix: 'fad',
  iconName: 'left-to-bracket',
  icon: [
    512,
    512,
    [],
    'e66d',
    [
      'M0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128z',
      'M171.3 283.3L294.1 406.1c6.4 6.4 15 9.9 24 9.9c18.7 0 33.9-15.2 33.9-33.9l0-62.1 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-62.1c0-18.7-15.2-33.9-33.9-33.9c-9 0-17.6 3.6-24 9.9L171.3 228.7c-7.2 7.2-11.3 17.1-11.3 27.3s4.1 20.1 11.3 27.3z',
    ],
  ],
};
const faCartCircleExclamation = {
  prefix: 'fad',
  iconName: 'cart-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e3f2',
    [
      'M0 24C0 37.3 10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.3-39.9-40-39.9l-411 0C111 12.8 91.6 0 69.5 0L24 0C10.7 0 0 10.7 0 24zM128 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faSword = {
  prefix: 'fad',
  iconName: 'sword',
  icon: [
    512,
    512,
    [128481],
    'f71c',
    [
      'M144 265.4L246.6 368 476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.1-.9 .2-1.8 .2-2.6c0-4.2-1.7-8.3-4.7-11.3C503.7 1 498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L144 265.4z',
      'M107.3 228.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176z',
    ],
  ],
};
const faBackwardFast = {
  prefix: 'fad',
  iconName: 'backward-fast',
  icon: [
    512,
    512,
    [9198, 'fast-backward'],
    'f049',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-118.3 0-83.3L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3 288 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L64 214.3l0 83.3L235.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-118.3L459.5 440.6z',
    ],
  ],
};
const faFastBackward = faBackwardFast;
const faRecycle = {
  prefix: 'fad',
  iconName: 'recycle',
  icon: [
    512,
    512,
    [9842, 9850, 9851],
    'f1b8',
    [
      'M0 351.6c0 .2 0 .4 0 .6C0 405.1 42.9 448 95.8 448l32.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32.2 0c-17.6 0-31.9-14.4-31.8-32c0-5.9 1.7-11.7 4.8-16.7l51.5-82.4c-18.5-10.7-37-21.3-55.5-32L14.6 301.4C5.1 316.5 .1 333.9 0 351.6zM157.2 73.1c-9.5 15.2-4.7 35.2 10.7 44.4c15 9 34.4 4.3 43.6-10.5L229 79c5.8-9.3 16-15 27-15s21.2 5.7 27 15l37.4 59.8 55.5-32L337.3 45.1C319.8 17 289.1 0 256 0S192.2 17 174.7 45.1l-17.5 28zM320 384l0 64 96.2 0c53.1 0 96.1-43.2 95.8-96.4c-.1-17.8-5.1-35.1-14.6-50.2l-24.4-39.1c-9.2-14.8-28.6-19.5-43.6-10.5c-15.3 9.2-20.2 29.2-10.7 44.4l24.4 39.1c3.1 5 4.8 10.8 4.8 16.7c.1 17.6-14.2 32-31.8 32L320 384z',
      'M292 155.2c-8.4 4.9-13.1 14.3-11.8 23.9s8.2 17.5 17.6 20l87.4 23.4c12.8 3.4 26-4.2 29.4-17L438 118.2c2.5-9.4-.9-19.3-8.6-25.3s-18.2-6.6-26.6-1.7L292 155.2zM320 352c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-128zM173.5 266.5c7.7-5.9 11.1-15.9 8.6-25.3l-23.4-87.4c-3.4-12.8-16.6-20.4-29.4-17L41.8 160.2c-9.4 2.5-16.3 10.4-17.6 20s3.4 19.1 11.8 23.9l110.9 64c8.4 4.9 18.9 4.2 26.6-1.7z',
    ],
  ],
};
const faUserAstronaut = {
  prefix: 'fad',
  iconName: 'user-astronaut',
  icon: [
    448,
    512,
    [],
    'f4fb',
    [
      'M112 144c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 16c0 53-43 96-96 96l-32 0c-53 0-96-43-96-96l0-16zm16 304c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64-128 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-32 0 0-64zm8-272c0 3.4 2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3zM256 464a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M224 0c65.7 0 122.1 39.5 146.7 96.1C387.1 97.5 400 111.2 400 128l0 64c0 16.8-12.9 30.5-29.3 31.9C346.1 280.5 289.7 320 224 320s-122.1-39.5-146.7-96.1C60.9 222.5 48 208.8 48 192l0-64c0-16.8 12.9-30.5 29.3-31.9C101.9 39.5 158.3 0 224 0zM336 160l0-16c0-26.5-21.5-48-48-48L160 96c-26.5 0-48 21.5-48 48l0 16c0 53 43 96 96 96l32 0c53 0 96-43 96-96zM112.7 316.5C144.1 338.8 182.5 352 224 352s79.9-13.2 111.3-35.5C401.3 342.6 448 407 448 482.3c0 16.4-13.3 29.7-29.7 29.7L320 512l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 64-98.3 0C13.3 512 0 498.7 0 482.3C0 407 46.7 342.6 112.7 316.5z',
    ],
  ],
};
const faInterrobang = {
  prefix: 'fad',
  iconName: 'interrobang',
  icon: [
    320,
    512,
    [8253],
    'e5ba',
    [
      'M16 160c0 17.7 14.3 32 32 32s32-14.3 32-32c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-18.6 12 0 89.2c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160z',
      'M192 176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144zM160 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
    ],
  ],
};
const faPlaneSlash = {
  prefix: 'fad',
  iconName: 'plane-slash',
  icon: [
    640,
    512,
    [],
    'e069',
    [
      'M32 142c0 1.3 .2 2.6 .5 3.9L64 256 32.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14l42 0c5 0 9.8-2.4 12.8-6.4L144 320l102.9 0-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1l65.3-114.3L41.5 128.7C36 130.6 32 135.9 32 142zM197.8 20.4l40.3 140.9L440.6 320l73.8 0c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64l-116.6 0L297.2 16.1C291.5 6.2 280.9 0 269.4 0L213.2 0c-10.6 0-18.3 10.2-15.4 20.4z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faCircleDashed = {
  prefix: 'fad',
  iconName: 'circle-dashed',
  icon: [
    512,
    512,
    [],
    'e105',
    [
      'M1.1 280C6 332.7 26.9 380.7 58.8 419.3l45.5-45.5C83.7 347.2 69.9 315.1 65.5 280L1.1 280zM92.7 58.8l45.5 45.5c26.6-20.6 58.7-34.5 93.7-38.8l0-64.4C179.3 6 131.3 26.9 92.7 58.8zM280 446.5l0 64.4c52.7-4.9 100.7-25.8 139.3-57.7l-45.5-45.5c-26.6 20.6-58.7 34.5-93.7 38.8zM407.7 138.3c20.6 26.6 34.5 58.7 38.8 93.7l64.4 0c-4.9-52.7-25.8-100.7-57.7-139.3l-45.5 45.5z',
      'M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5C83.7 164.8 69.9 196.9 65.5 232L1.1 232zM407.7 373.7c20.6-26.6 34.5-58.7 38.8-93.7l64.4 0c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zM92.7 453.2l45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8l0 64.4c-52.7-4.9-100.7-25.8-139.3-57.7zM419.3 58.8l-45.5 45.5C347.2 83.7 315.1 69.9 280 65.5l0-64.4C332.7 6 380.7 26.9 419.3 58.8z',
    ],
  ],
};
const faTrademark = {
  prefix: 'fad',
  iconName: 'trademark',
  icon: [
    640,
    512,
    [8482],
    'f25c',
    [
      'M288 128l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-13.8-8.8-26-21.9-30.4c-3.3-1.1-6.7-1.6-10.1-1.6c-9.9 0-19.4 4.6-25.6 12.8L464 266.7 345.6 108.8C339.4 100.6 329.9 96 320 96c-3.4 0-6.8 .5-10.1 1.6C296.8 102 288 114.2 288 128z',
      'M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l64 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 96z',
    ],
  ],
};
const faBasketball = {
  prefix: 'fad',
  iconName: 'basketball',
  icon: [
    512,
    512,
    [127936, 'basketball-ball'],
    'f434',
    [
      'M0 256c0 64.9 24.2 124.2 64 169.4C120.5 368.9 176.9 312.4 233.4 256c-20.5-20.5-40.9-40.9-61.4-61.4C138.5 222.9 95.3 240 48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256zm5.6-53.7C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1C120.8 143.5 92.4 115.1 64 86.6C35.5 119 15 158.6 5.6 202.3zM86.6 64c28.4 28.4 56.8 56.8 85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zm0 384c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9c-.5-1.9-.9-3.8-1.3-5.7s-.8-3.8-1.2-5.7c-.7-3.9-1.3-7.8-1.8-11.7c-.3-2-.5-4-.6-6c-.2-2-.3-3.9-.5-5.9c-.1-2.1-.2-4.1-.3-6.1c-.1-2-.1-3.9-.1-6c0-1.7 0-3 0-4.4c0-1.6 .1-2.9 .1-4.3c.1-3.1 .3-6 .6-8.9c.5-5.8 1.3-11.5 2.3-17.1c2-11.2 5.1-22.1 9-32.6c7.8-20.9 19.2-40.1 33.3-56.8c-20.5-20.5-40.9-40.9-61.4-61.4C199.5 335.1 143.1 391.5 86.6 448zm108-276c20.5 20.5 40.9 40.9 61.4 61.4C312.5 176.9 368.9 120.5 425.4 64C380.2 24.2 320.9 0 256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124zm84 84c20.5 20.5 40.9 40.9 61.4 61.4c33.5-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4C391.5 143.1 335.1 199.6 278.6 256zm25.5 200.7c-.1 2.4-.2 4.8-.2 7.3c0 1.9 0 3.7 .1 5.5c.1 1.8 .2 3.6 .3 5.4c.2 3.6 .6 7.2 1.1 10.7c1 7.1 2.4 14 4.2 20.7C353.4 497 393 476.5 425.4 448l-85.2-85.2c-11.3 13.8-20.3 29.5-26.5 46.6c-3.1 8.5-5.5 17.4-7.1 26.5c-.8 4.6-1.4 9.2-1.8 13.9c-.2 2.3-.4 4.7-.5 7zm58.6-116.6L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1z',
      'M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4c10.4-2.2 21-3.8 31.9-4.7C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64c8 7.1 15.6 14.6 22.6 22.6L278.6 256 340 317.4c33.5-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8c-.9 10.8-2.5 21.5-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c-7.1 8-14.6 15.6-22.6 22.6l-85.2-85.2C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4c-10.4 2.2-21 3.8-31.9 4.7C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124L256 278.6 86.6 448c-8-7.1-15.6-14.6-22.6-22.6L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240c-16.2 0-32-2-47.1-5.8c.9-10.8 2.5-21.5 4.7-31.9C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6c7.1-8 14.6-15.6 22.6-22.6z',
    ],
  ],
};
const faBasketballBall = faBasketball;
const faForkKnife = {
  prefix: 'fad',
  iconName: 'fork-knife',
  icon: [
    576,
    512,
    ['utensils-alt'],
    'f2e6',
    [
      'M0 96c0 83.3 48.2 130.5 128.9 209.4c6.5 6.4 13.3 13 20.3 19.9c1.9 1.8 3.8 3.5 5.9 5.1L265.4 220.1 52.5 7.3C47.9 2.6 41.5 0 34.9 0c-11.2 0-21 7.5-23.5 18.4C6.7 38.6 0 71.5 0 96zM310.6 355.9L457.4 502.6c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4s9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6L355.9 310.6l-45.3 45.3z',
      'M476.4 5.9c5.2 6.4 4.8 15.6-1.1 21.5L384 118.6c-5.2 5.2-5.2 13.6 0 18.8c4.9 4.9 12.8 5.2 18.1 .6l99.4-86.1c6.3-5.5 15.9-5.2 21.8 .8s6.3 15.4 .8 21.8L438 173.9c-4.6 5.3-4.3 13.2 .6 18.1c5.2 5.2 13.6 5.2 18.8 0l91.3-91.3c5.8-5.8 15.1-6.3 21.5-1.1s7.7 14.4 3.2 21.2l-71 106.5c-18.6 27.9-49.9 44.6-83.4 44.6c-19.3 0-37.9-5.5-53.9-15.7L118.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L319.7 211c-10.2-16-15.7-34.7-15.7-53.9c0-33.5 16.8-64.8 44.6-83.4l106.5-71c6.8-4.6 16-3.2 21.2 3.2z',
    ],
  ],
};
const faUtensilsAlt = faForkKnife;
const faSatelliteDish = {
  prefix: 'fad',
  iconName: 'satellite-dish',
  icon: [
    512,
    512,
    [128225],
    'f7c0',
    [
      'M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32z',
      'M60.6 220.6c-14.5-14.5-38.8-11.8-46.3 7.3C5.1 251.5 0 277.1 0 304C0 418.9 93.1 512 208 512c26.9 0 52.5-5.1 76.1-14.4c19-7.5 21.8-31.8 7.3-46.3L187.3 347.3l28.4-28.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3l-28.4 28.4L60.6 220.6z',
    ],
  ],
};
const faBadgeCheck = {
  prefix: 'fad',
  iconName: 'badge-check',
  icon: [
    512,
    512,
    [],
    'f336',
    [
      'M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm136 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faCircleUp = {
  prefix: 'fad',
  iconName: 'circle-up',
  icon: [
    512,
    512,
    [61467, 'arrow-alt-circle-up'],
    'f35b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-22.3c0-6.2 2.6-12.1 7.1-16.3l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5c35.7 33.3 71.4 66.6 107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3L304 256l0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-57.7 0C138 256 128 246 128 233.7z',
      'M242.2 117.5L135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3l57.7 0 0 96c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-96 57.7 0c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5z',
    ],
  ],
};
const faArrowAltCircleUp = faCircleUp;
const faSlider = {
  prefix: 'fad',
  iconName: 'slider',
  icon: [
    512,
    512,
    [],
    'e252',
    [
      'M0 256c0 17.7 14.3 32 32 32l192 0 0-64L32 224c-17.7 0-32 14.3-32 32zm416-32l0 64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0z',
      'M352 160l0 192-32 0 0-192 32 0zM320 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l32 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0z',
    ],
  ],
};
const faMobileScreenButton = {
  prefix: 'fad',
  iconName: 'mobile-screen-button',
  icon: [
    384,
    512,
    ['mobile-alt'],
    'f3cd',
    [
      'M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zm64 0l0 320 224 0 0-320L80 64zm80 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M80 64H304V384H80V64z',
    ],
  ],
};
const faMobileAlt = faMobileScreenButton;
const faClockOneThirty = {
  prefix: 'fad',
  iconName: 'clock-one-thirty',
  icon: [
    512,
    512,
    [],
    'e34f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232 0c0-4.7 1.4-9.4 4-13.3l64-96c7.4-11 22.3-14 33.3-6.7c6.9 4.6 10.7 12.2 10.7 20c0 4.6-1.3 9.2-4 13.3l-60 90L280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z',
      'M256 416c13.3 0 24-10.7 24-24l0-128.7 60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3l0 136c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faInboxOut = {
  prefix: 'fad',
  iconName: 'inbox-out',
  icon: [
    512,
    512,
    [128228, 'inbox-arrow-up'],
    'f311',
    [
      'M0 368l0 96c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-76.2 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L48 320c-26.5 0-48 21.5-48 48z',
      'M256 320c17.7 0 32-14.3 32-32l0-178.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 224 288c0 17.7 14.3 32 32 32z',
    ],
  ],
};
const faInboxArrowUp = faInboxOut;
const faCloudSlash = {
  prefix: 'fad',
  iconName: 'cloud-slash',
  icon: [
    640,
    512,
    [],
    'e137',
    [
      'M0 336c0 79.5 64.5 144 144 144l343.4 0L97.2 172.6c-.8 6.4-1.2 12.9-1.2 19.4c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zM138.6 83.3L600 445c24.6-23.3 40-56.3 40-93c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.4 0-88.2 19.8-117.4 51.3z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faVolumeHigh = {
  prefix: 'fad',
  iconName: 'volume-high',
  icon: [
    640,
    512,
    [128266, 'volume-up'],
    'f028',
    [
      'M378.8 185c8.4-10.3 23.5-11.8 33.8-3.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.5 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8zm60.5-74.5c8.4-10.3 23.5-11.8 33.8-3.5c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8zM499.9 36c8.4-10.3 23.5-11.8 33.8-3.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-4.5 3.6-9.8 5.4-15.1 5.4c-7 0-13.9-3-18.6-8.9c-8.4-10.3-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8z',
      'M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160 64 160c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l67.8 0L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448l0-384z',
    ],
  ],
};
const faVolumeUp = faVolumeHigh;
const faUsersRays = {
  prefix: 'fad',
  iconName: 'users-rays',
  icon: [
    640,
    512,
    [],
    'e593',
    [
      'M96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0C119.9 256 96 279.9 96 309.3zM127.8 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 360c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24zm48-168a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm140 70.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4zM416 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72z',
    ],
  ],
};
const faWallet = {
  prefix: 'fad',
  iconName: 'wallet',
  icon: [
    512,
    512,
    [],
    'f555',
    [
      'M0 80C0 53.5 21.5 32 48 32l384 0c26.5 0 48 21.5 48 48l0 16 0 32 0 8.6c-6.8-3.9-14.4-6.6-22.4-7.9c-2.7-.4-5.5-.6-8.2-.7c-.4 0-.9 0-1.3 0c-21.3 0-42.7 0-64 0c-96 0-192 0-288 0c-16 0-32 0-48 0C21.5 128 0 106.5 0 80z',
      'M48 128l48 0s0 0 0 0l352 0c.4 0 .9 0 1.3 0c11.2 .2 21.6 3.6 30.7 8.9l0-.3c19.1 11.1 32 31.7 32 55.4l0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 240l0-48L0 80c0 26.5 21.5 48 48 48zM416 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faOctagonCheck = {
  prefix: 'fad',
  iconName: 'octagon-check',
  icon: [
    512,
    512,
    [],
    'e426',
    [
      'M.1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47L335 175c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5.1 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .4 2.3 .3 2.3c.1 1.2 .1 1.2 .1 2.3c0 1.5-.1 1.9-.1 2.3c-.1 .8-.2 1.5-.3 2.3c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faFlatbreadStuffed = {
  prefix: 'fad',
  iconName: 'flatbread-stuffed',
  icon: [
    576,
    512,
    [129369],
    'e40c',
    [
      'M16 272.1c0 6.7 2.1 13.5 6.4 19.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120c27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4c-4.8-2.7-10.1-4-15.4-4c-8.6 0-17.1 3.5-23.3 10.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-4.7 5.8-7.1 12.9-7.1 20zM144 264c0 18.4 5.6 35.4 15.3 49.5L281.5 191.3C267.4 181.6 250.4 176 232 176c-48.6 0-88 39.4-88 88z',
      'M465.4 64c6.8 .4 13.2 3.7 17.4 9C519.1 118.8 544 175.3 544 240c0 150.2-121.8 272-272 272c-64.7 0-121.2-24.9-166.9-61.2c-5.4-4.3-8.6-10.6-9-17.4s2.2-13.5 7-18.3l86-86 86-86 86-86 43-43 43-43c4.8-4.8 11.5-7.4 18.3-7zM272 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faClipboardCheck = {
  prefix: 'fad',
  iconName: 'clipboard-check',
  icon: [
    384,
    512,
    [],
    'f46c',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM72 320c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17L177 401c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L79 337c-4.7-4.7-7-10.8-7-17z',
      'M113.2 66.3C93.9 72.6 80 90.7 80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24c0-21.3-13.9-39.4-33.2-45.7C264.4 28.7 231.5 0 192 0s-72.4 28.7-78.8 66.3zM168 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM305 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L305 273z',
    ],
  ],
};
const faCartCirclePlus = {
  prefix: 'fad',
  iconName: 'cart-circle-plus',
  icon: [
    640,
    512,
    [],
    'e3f3',
    [
      'M0 24C0 37.3 10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.3-39.9-40-39.9l-411 0C111 12.8 91.6 0 69.5 0L24 0C10.7 0 0 10.7 0 24zM128 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faTruckClock = {
  prefix: 'fad',
  iconName: 'truck-clock',
  icon: [
    640,
    512,
    ['shipping-timed'],
    'f48c',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm96-320l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L48 416c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM208 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224z',
    ],
  ],
};
const faShippingTimed = faTruckClock;
const faPool8Ball = {
  prefix: 'fad',
  iconName: 'pool-8-ball',
  icon: [
    512,
    512,
    [],
    'e3c5',
    [
      'M200 216c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2C207.2 184.5 200 199.4 200 216zm80 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-8-72a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-448a128 128 0 1 1 0 256 128 128 0 1 1 0-256z',
    ],
  ],
};
const faFileAudio = {
  prefix: 'fad',
  iconName: 'file-audio',
  icon: [
    384,
    512,
    [],
    'f1c7',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 312l0 48c0 8.8 7.2 16 16 16l33.4 0 35.3 35.3c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-128c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5L113.4 296 80 296c-8.8 0-16 7.2-16 16zm151.9 2.7c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C249.8 367.4 256 352.4 256 336s-6.2-31.4-16.3-42.7c-5.9-6.6-16-7.1-22.6-1.3s-7.1 16-1.3 22.6zM236 231.7c-4.6 7.6-2.1 17.4 5.4 22C269.4 270.5 288 301.1 288 336s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22c3 5 8.3 7.7 13.7 7.7c2.8 0 5.7-.7 8.2-2.3c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7c-7.6-4.6-17.4-2.1-22 5.4z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM258 226.3c-7.6-4.6-17.4-2.1-22 5.4s-2.1 17.4 5.4 22C269.4 270.5 288 301.1 288 336s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22s14.4 10 22 5.4c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7zm-91.9 30.9c-6-2.5-12.9-1.1-17.4 3.5L113.4 296 80 296c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l33.4 0 35.3 35.3c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-128c0-6.5-3.9-12.3-9.9-14.8zm51 34.9c-6.6 5.9-7.1 16-1.3 22.6c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C249.8 367.4 256 352.4 256 336s-6.2-31.4-16.3-42.7c-5.9-6.6-16-7.1-22.6-1.3z',
    ],
  ],
};
const faTurnDownLeft = {
  prefix: 'fad',
  iconName: 'turn-down-left',
  icon: [
    512,
    512,
    [],
    'e331',
    [
      'M192 240l208 0c8.8 0 16-7.2 16-16l0-160c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 160c0 61.9-50.1 112-112 112l-208 0 0-96z',
      'M151.5 441.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-272c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136C2.7 275.1 0 281.4 0 288s2.7 12.9 7.5 17.4l144 136z',
    ],
  ],
};
const faLockHashtag = {
  prefix: 'fad',
  iconName: 'lock-hashtag',
  icon: [
    448,
    512,
    [],
    'e423',
    [
      'M0 256L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-16 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144l0 48-16 0c-35.3 0-64 28.7-64 64zm112 48c0-8.8 7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16zm32-160c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48-160 0 0-48zm48 176l0 64 64 0 0-64-64 0z',
      'M192 256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 64-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 64 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-64 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-64 0 0-32zm64 128l-64 0 0-64 64 0 0 64z',
    ],
  ],
};
const faChartRadar = {
  prefix: 'fad',
  iconName: 'chart-radar',
  icon: [
    512,
    512,
    [],
    'e0e7',
    [
      'M13.8 223.8c-11.6 19.9-11.6 44.6 0 64.5l93.3 160c11.5 19.7 32.5 31.8 55.3 31.8l187.2 0c22.8 0 43.8-12.1 55.3-31.8l93.3-160c5.8-10 8.7-21.1 8.7-32.2s-2.9-22.3-8.7-32.2l-93.3-160C393.4 44.1 372.4 32 349.6 32L162.4 32c-22.8 0-43.8 12.1-55.3 31.8l-93.3 160zM69 256L162.4 96l187.2 0L443 256 349.6 416l-187.2 0L69 256z',
      'M290.2 180.8c3.7-6.1 5.8-13.2 5.8-20.8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9 .6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7c22.1 0 40-17.9 40-40c0-18.5-12.6-34.1-29.6-38.6L290.2 180.8zm-8.9 107L202 271.9l47.5-63.4 31.7 79.2z',
    ],
  ],
};
const faStaff = {
  prefix: 'fad',
  iconName: 'staff',
  icon: [
    512,
    512,
    [],
    'f71b',
    [
      'M96 304c0-8.8 7.2-16 16-16l44.1 0c-20 20-40.1 40.1-60.1 60.1L96 304zm265.1-16.7c27.5-7.9 55.1-15.7 82.6-23.6l-22.2 39.4c-4.3 7.7-14.1 10.4-21.8 6.1l-38.6-21.8z',
      'M284.2 44.2C297.8 17.1 325.5 0 355.8 0L432 0c44.2 0 80 35.8 80 80l0 103.9c0 35.7-23.7 67.1-58 76.9L269.1 313.6c-2.6 .7-5 2.1-6.9 4.1L81.9 497.9c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9L200.2 243.9c9.6-9.6 21.5-16.6 34.6-20.4l169.6-48.5c6.9-2 11.6-8.2 11.6-15.4l0-47.7c0-8.8-7.2-16-16-16l-28.2 0c-3.7 0-7.2 2.1-8.8 5.5c-11.9 23.7-40.7 33.3-64.4 21.5s-33.3-40.7-21.5-64.4l7.2-14.3z',
    ],
  ],
};
const faBurger = {
  prefix: 'fad',
  iconName: 'burger',
  icon: [
    512,
    512,
    ['hamburger'],
    'f805',
    [
      'M32 194.9C32 211 45 224 61.1 224l389.8 0c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM32 400l0 16c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-16c0-8.8-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16zM144 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM272 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48z',
    ],
  ],
};
const faHamburger = faBurger;
const faUtilityPole = {
  prefix: 'fad',
  iconName: 'utility-pole',
  icon: [
    512,
    512,
    [],
    'e2c3',
    [
      'M0 56C0 42.7 10.7 32 24 32s24 10.7 24 24l0 8L0 64l0-8zm80 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8L80 64l0-8zm3.2 72l57.7 0L224 183.4l0 38.5L83.2 128zM288 183.4L371.2 128l57.7 0L288 221.9l0-38.5zM384 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8zm80 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8z',
      'M256 0c17.7 0 32 14.3 32 32l0 32 224 0 0 32c0 17.7-14.3 32-32 32l-192 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352L32 128C14.3 128 0 113.7 0 96L0 64l224 0 0-32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faTransporter6 = {
  prefix: 'fad',
  iconName: 'transporter-6',
  icon: [
    512,
    512,
    [],
    'e2a7',
    [
      'M0 48c0 4.1 2.7 7.6 6.6 8.7L32 64l7.3 25.4C40.4 93.3 43.9 96 48 96s7.6-2.7 8.7-6.6L64 64l25.4-7.3C93.3 55.6 96 52.1 96 48s-2.7-7.6-6.6-8.7L64 32 56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM208 16c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0c-8.8 0-16 7.2-16 16zM416 400c0 4.1 2.7 7.6 6.6 8.7L448 416l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 416l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 384l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 384l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faArrowTurnLeft = {
  prefix: 'fad',
  iconName: 'arrow-turn-left',
  icon: [
    512,
    512,
    [],
    'e632',
    [
      'M77.3 224l32-32L416 192c53 0 96 43 96 96l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7-14.3-32-32-32l-306.7 0-32-32z',
      'M182.6 374.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 224 182.6 329.4c12.5 12.5 12.5 32.8 0 45.3z',
    ],
  ],
};
const faWrench = {
  prefix: 'fad',
  iconName: 'wrench',
  icon: [
    512,
    512,
    [128295],
    'f0ad',
    [
      'M0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c-44.5-16.1-79.9-51.5-96-96L19.9 396.1C7.2 408.8 0 426.1 0 444.1zM104 432a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160s71.6 160 160 160z',
    ],
  ],
};
const faBugs = {
  prefix: 'fad',
  iconName: 'bugs',
  icon: [
    576,
    512,
    [],
    'e4d0',
    [
      'M256 379.5c0 7.1 3.2 14.2 9.2 18.9c10.4 8.2 25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.8-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.2-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-3.4 4.4-5.1 9.6-5.1 14.8z',
      'M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6l-17 0-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184l32 0 0 23.3-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.8 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3l0-23.3 32 0c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136l-17 0c-4.7-11.6-12.7-21.5-22.9-28.6z',
    ],
  ],
};
const faVectorPolygon = {
  prefix: 'fad',
  iconName: 'vector-polygon',
  icon: [
    448,
    512,
    [],
    'e2c7',
    [
      'M32 160l0 192 64 0 0-192-64 0zm96-96l0 64 192 0 0-64L128 64zm0 320l0 64 192 0 0-64-192 0zM292.3 192l27.7 0c.5 0 1 0 1.4 0s1 .1 1.4 .1c.9 .1 1.9 .2 2.8 .4c1.8 .3 3.6 .8 5.3 1.4c3.4 1.3 6.6 3.1 9.4 5.4c5.5 4.6 9.5 11 11 18.3l28.4-49.7 4.5-7.9L352 160c-.8 0-1.7 0-2.5-.1s-1.7-.2-2.5-.3c-1.6-.3-3.2-.6-4.7-1.1c-3.1-1-5.9-2.4-8.5-4.2c-5.2-3.6-9.2-8.7-11.6-14.6L292.3 192zm0 128l29.9 52.3c4.7-11.9 16.3-20.3 29.8-20.3l32.3 0-4.5-7.9-28.4-49.7C348.4 309 335.5 320 320 320l-27.7 0z',
      'M32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 32zM80 80l0 32-32 0 0-32 32 0zM352 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zm48 48l0 32-32 0 0-32 32 0zM0 384l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm48 16l32 0 0 32-32 0 0-32zm304-48c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zm48 48l0 32-32 0 0-32 32 0zM224 224l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm48 16l32 0 0 32-32 0 0-32z',
    ],
  ],
};
const faDiagramNested = {
  prefix: 'fad',
  iconName: 'diagram-nested',
  icon: [
    448,
    512,
    [],
    'e157',
    [
      'M64 224l0 96c0 53 43 96 96 96l96 0 0-64-96 0c-17.7 0-32-14.3-32-32l0-96-64 0z',
      'M48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L48 32zM304 288c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0z',
    ],
  ],
};
const faRupeeSign = {
  prefix: 'fad',
  iconName: 'rupee-sign',
  icon: [
    448,
    512,
    [8360, 'rupee'],
    'f156',
    [
      'M257.2 263.1c-2.2 15.2-1.1 29.8 4.4 43.2c5.4 13.4 14.2 23.5 23.7 31c16.3 12.9 37.8 20.5 53.3 25.9c1 .4 2.1 .7 3 1.1c18.7 6.6 30.1 11.2 36.9 17c2.7 2.3 3.9 4.2 4.5 5.9c.7 1.7 1.5 5.4 .5 12.3c-1 7-4.1 10.6-9.1 13c-6.2 3.1-17.2 5.1-32.9 2.3c-3.4-.7-9.9-2.7-18.7-6c-5.5-2.1-10.6-4.1-15.4-6c-2.7-1.1-5.4-2.1-7.9-3.1c-16.5-6.4-35 1.8-41.4 18.2s1.8 35 18.2 41.4c1.7 .6 3.8 1.5 6.3 2.5c5.2 2.1 11.7 4.7 17.7 6.9c8.7 3.3 19.9 7.2 29.3 9c8.8 1.6 17.5 2.5 26.2 2.5c16.5 0 32.7-3.1 47.2-10.4c23.3-11.6 39.6-32.8 43.8-60.9c.8-5.2 1.2-10.3 1.2-15.3c0-10-1.6-19.6-5-28.7c-5.1-13.7-13.6-24.3-23.1-32.3c-17.1-14.5-39.7-22.5-55.7-28.1c-.4-.2-.9-.3-1.3-.5c-19.2-6.8-30.7-11.1-37.9-16.8c-2.8-2.2-3.7-3.8-4.2-4.9c-.4-1-1.3-3.8-.4-9.8c.7-4.5 3.2-8.7 9.5-12c6.8-3.6 18-5.9 32.6-3.2c5.6 1 23.3 5.1 27.9 6.5c16.9 5.2 34.8-4.2 40.1-21.1s-4.2-34.8-21.1-40.1c-8.1-2.5-28.5-7.1-35.4-8.4c-7.5-1.4-15.1-2.1-22.8-2.1c-43.5 0-87 22.4-94.1 70.9z',
      'M32 32C14.3 32 0 46.3 0 64L0 288 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 42.3 0 56 139.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L170.3 307.7C220.8 285.3 256 234.8 256 176c0-79.5-64.5-144-144-144L32 32zm80 224l-48 0L64 96l48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z',
    ],
  ],
};
const faRupee = faRupeeSign;
const faFileImage = {
  prefix: 'fad',
  iconName: 'file-image',
  icon: [
    384,
    512,
    [128443],
    'f1c5',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 176c0 2.7 .7 5.4 2.1 7.9c2.8 5 8.2 8.1 13.9 8.1l48 0 48 0 40 0 88 0c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-48.3 70.2-12.8-21.4c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8c-16 26.7-32 53.3-48 80c-1.5 2.5-2.3 5.4-2.3 8.2z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM229.2 294.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-48.3 70.2-12.8-21.4c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-48 80c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1l48 0 48 0 40 0 88 0c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128z',
    ],
  ],
};
const faCircleQuestion = {
  prefix: 'fad',
  iconName: 'circle-question',
  icon: [
    512,
    512,
    [62108, 'question-circle'],
    'f059',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm169.4-89.5c.1-.4 .3-.8 .4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8c-10.8 6.2-21.5 12.4-32.3 18.5c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24c0-4.5 0-9 0-13.5c0-8.7 4.6-16.6 12.1-20.8c14.8-8.5 29.6-17 44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-2c0-.3 .1-.7 .1-1s0-.7 0-1.1c0-.5 0-1-.1-1.5s-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3c-.1 .4-.3 .8-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6zM288 352c0 .3 0 .6 0 0z',
      'M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faQuestionCircle = faCircleQuestion;
const faTicketsPerforated = {
  prefix: 'fad',
  iconName: 'tickets-perforated',
  icon: [
    640,
    512,
    [],
    'e63f',
    [
      'M96 96c0-35.3 28.7-64 64-64l416 0c35.3 0 64 28.7 64 64l0 48c0 8.8-7.4 15.7-15.7 18.6C605.5 169.1 592 187 592 208s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6l0 48c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64L96 96zm416 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240zm496-8a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faImageUser = {
  prefix: 'fad',
  iconName: 'image-user',
  icon: [
    512,
    512,
    [],
    'e1b8',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM144 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0c-15.1 0-27.4-12.3-27.4-27.4zM320 192a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M256 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-43.4 32c-37.9 0-68.6 30.7-68.6 68.6c0 15.1 12.3 27.4 27.4 27.4l169.1 0c15.1 0 27.4-12.3 27.4-27.4c0-37.9-30.7-68.6-68.6-68.6l-86.9 0z',
    ],
  ],
};
const faBuoy = {
  prefix: 'fad',
  iconName: 'buoy',
  icon: [
    576,
    512,
    [],
    'e5b5',
    [
      'M0 480c0 2.4 .3 4.8 .8 7.3C4.3 502 17.4 512 32 512c2.4 0 4.8-.3 7.3-.8c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2C10 452.3 0 465.4 0 480zM160 32c0 17.7 14.3 32 32 32l58.2 0 75.5 0L384 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32z',
      'M391 64l-65.3 0 9.8 49L288 168.5 240.4 113l9.8-49L185 64 133.8 320 96 320c-17.7 0-32 14.3-32 32l0 16c0 8.2 .7 16.1 2 23.9c21-11.1 46.9-9.9 66.9 4.2c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20-14.1 45.9-15.3 66.9-4.2c1.3-7.8 2-15.8 2-23.9l0-16c0-17.7-14.3-32-32-32l-37.8 0L391 64zM347.5 172.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM221.3 320L288 242.2 354.7 320l-133.4 0z',
    ],
  ],
};
const faPlaneDeparture = {
  prefix: 'fad',
  iconName: 'plane-departure',
  icon: [
    640,
    512,
    [128747],
    'f5b0',
    [
      'M0 480c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z',
      'M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2l137.7 0c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48l-57.4 0c-20.2 0-40.2 4.8-58.2 14L381 114.9z',
    ],
  ],
};
const faHandshakeSlash = {
  prefix: 'fad',
  iconName: 'handshake-slash',
  icon: [
    640,
    512,
    [],
    'e060',
    [
      'M0 144L0 352c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-180.4L40.6 128 16 128c-8.8 0-16 7.2-16 16zM64 336a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-139.2L128 352l28.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6L128 196.8zm36.5-93.2c14.4 11.3 28.9 22.6 43.3 34l81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7zm69.2 54.2c21.1 16.5 42.2 33 63.2 49.6l77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6zm89.2 69.9c57.6 45.2 115.2 90.3 172.9 135.5c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-80 0zm64 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBookBookmark = {
  prefix: 'fad',
  iconName: 'book-bookmark',
  icon: [
    448,
    512,
    [],
    'e0bb',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 352 0l0 190.7c0 13.4-15.5 20.9-26 12.5L272 160l-54 43.2c-10.5 8.4-26 .9-26-12.5L192 0 96 0z',
    ],
  ],
};
const faBorderCenterH = {
  prefix: 'fad',
  iconName: 'border-center-h',
  icon: [
    448,
    512,
    [],
    'f89c',
    [
      'M0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 160zM0 352a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faCanFood = {
  prefix: 'fad',
  iconName: 'can-food',
  icon: [
    384,
    512,
    [129387],
    'e3e6',
    [
      'M16 64c0 1.3 .1 2.5 .3 3.8C21.7 101.4 98.3 128 192 128s170.3-26.6 175.7-60.2c.2-1.2 .3-2.5 .3-3.8c0-35.3-78.8-64-176-64S16 28.7 16 64zm96 240a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M320 434.3l0-158.9c-14.1 6.1-30.7 11.2-49.2 15C264.4 252.7 231.5 224 192 224s-72.4 28.7-78.8 66.4c-18.5-3.8-35.1-8.9-49.2-15l0 158.9c3.4 3 10.2 7.5 21.7 12.2C110.5 456.6 148.1 464 192 464s81.5-7.4 106.3-17.5c11.5-4.7 18.3-9.2 21.7-12.2zm48 5.7c0 39.8-78.8 72-176 72s-176-32.2-176-72L16 72c0-1.4 .1-2.8 .3-4.2C21.7 101.4 98.3 128 192 128s170.3-26.6 175.7-60.2c.2 1.4 .3 2.8 .3 4.2l0 368z',
    ],
  ],
};
const faTypewriter = {
  prefix: 'fad',
  iconName: 'typewriter',
  icon: [
    512,
    512,
    [],
    'f8e7',
    [
      'M64 64C64 28.7 92.7 0 128 0L352 0l0 64c0 17.7 14.3 32 32 32l64 0 0 96-82.7 0c-8.5 0-16.6 3.4-22.6 9.4l-13.3 13.3c-6 6-14.1 9.4-22.6 9.4l-101.5 0c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4L64 192 64 64z',
      'M448 93.3l0 2.7-64 0c-17.7 0-32-14.3-32-32l0-64 2.7 0c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3zM0 256l0-32c0-17.7 14.3-32 32-32l114.7 0c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4l101.5 0c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4L480 192c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l0 160c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-160c-17.7 0-32-14.3-32-32zm176 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 304a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 128c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zm0-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faArrowRightFromArc = {
  prefix: 'fad',
  iconName: 'arrow-right-from-arc',
  icon: [
    512,
    512,
    [],
    'e4b1',
    [
      'M0 256C0 397.4 114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256S150 64 256 64c17.7 0 32-14.3 32-32s-14.3-32-32-32C114.6 0 0 114.6 0 256z',
      'M345.4 121.4c12.5-12.5 32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 192 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l210.7 0-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3z',
    ],
  ],
};
const faCircleK = {
  prefix: 'fad',
  iconName: 'circle-k',
  icon: [
    512,
    512,
    [],
    'e113',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L310.9 135.2c4.7-4.8 10.9-7.2 17.1-7.2c6.1 0 12.1 2.3 16.8 6.9c9.5 9.3 9.6 24.5 .3 33.9l-73.1 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5c-4.3 3.1-9.2 4.6-14.2 4.6c-7.4 0-14.7-3.4-19.4-9.8L238 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L160 152z',
      'M344.8 134.9c9.5 9.3 9.6 24.5 .3 33.9l-73.1 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L160 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L310.9 135.2c9.3-9.5 24.5-9.6 33.9-.3z',
    ],
  ],
};
const faFaceHandOverMouth = {
  prefix: 'fad',
  iconName: 'face-hand-over-mouth',
  icon: [
    512,
    512,
    [129762],
    'e378',
    [
      'M0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-32.8 0-53.6c0-28.7 23.3-52 52-52c17.9 0 33.6 9 43 22.7l47.1-47.1c18.7-18.7 49.1-18.7 67.9 0c1 1 2 2.1 3 3.2c15.7-3.7 32.8 .5 45 12.8s16.5 29.4 12.8 45c1.1 .9 2.2 1.9 3.2 3c18.1 18.1 18.7 47.1 1.8 65.9c16.9 18.8 16.3 47.8-1.8 65.9l-49 49C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm208.4-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm90.9 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM336.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faPopcorn = {
  prefix: 'fad',
  iconName: 'popcorn',
  icon: [
    448,
    512,
    [127871],
    'f819',
    [
      'M32 156c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.8-.1 3.5-.3 5.2c-1.6-.4-3.3-.7-5-.9c-.9-.1-1.7-.2-2.6-.2s-1.7-.1-2.6-.1l-77.3 0-208.4 0-77.3 0c-3.5 0-6.9 .4-10.2 1.2c-.2-1.7-.3-3.5-.3-5.2z',
      'M1.4 213.3L70.6 476.2C76.1 497.3 95.2 512 117 512l214 0c21.8 0 40.9-14.7 46.4-35.8l69.2-262.9c.9-3.5 1.4-7.2 1.4-10.8c0-23.5-19-42.5-42.5-42.5l-363 0C19 160 0 179 0 202.5c0 3.7 .5 7.3 1.4 10.8zm126.4 8.4l32 224c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6l-32-224c-1.2-8.7 4.8-16.9 13.6-18.1s16.9 4.8 18.1 13.6zm224 4.5l-32 224c-1.2 8.7-9.4 14.8-18.1 13.6s-14.8-9.4-13.6-18.1l32-224c1.3-8.7 9.4-14.8 18.1-13.6s14.8 9.4 13.6 18.1zM240 224l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faHouseWater = {
  prefix: 'fad',
  iconName: 'house-water',
  icon: [
    576,
    512,
    ['house-flood'],
    'f74f',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 105.4c21.3-12.2 48.1-11.4 68.8 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20.7-14.6 47.7-15.4 69.1-3l-.5-105.6 32 0c17 0 32-14 32-32.1c.1-.9 .2-1.8 .2-2.7c0-7.9-4-15-11.2-21.3L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24zM224 216c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80z',
      'M306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z',
    ],
  ],
};
const faHouseFlood = faHouseWater;
const faObjectSubtract = {
  prefix: 'fad',
  iconName: 'object-subtract',
  icon: [
    512,
    512,
    [],
    'e49e',
    [
      'M0 64L0 288c0 35.3 28.7 64 64 64l96 0 128 0c35.3 0 64-28.7 64-64l0-128 0-96c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 0l224 0 0 224L64 288 64 64z',
      'M448 512c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0 128c0 35.3-28.7 64-64 64l-128 0 0 96c0 35.3 28.7 64 64 64l224 0z',
    ],
  ],
};
const faCodeBranch = {
  prefix: 'fad',
  iconName: 'code-branch',
  icon: [
    448,
    512,
    [],
    'f126',
    [
      'M48 153.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3c1.4 .1 2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7l0 87.8c18.8-10.9 40.7-17.1 64-17.1l96 0c35.3 0 64-28.7 64-64l0-6.7c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3c1.4 .1 2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7l0 6.7c0 70.7-57.3 128-128 128l-96 0c-35.3 0-64 28.7-64 64l0 6.7c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7l0-6.7 0-198.7z',
      'M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 368 0a80 80 0 1 0 0 160zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0A80 80 0 1 0 0 432a80 80 0 1 0 160 0z',
    ],
  ],
};
const faWarehouseFull = {
  prefix: 'fad',
  iconName: 'warehouse-full',
  icon: [
    640,
    512,
    ['warehouse-alt'],
    'f495',
    [
      'M128 248c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-80zm0 160c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-80zm224 0c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-80z',
      'M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z',
    ],
  ],
};
const faWarehouseAlt = faWarehouseFull;
const faHatCowboy = {
  prefix: 'fad',
  iconName: 'hat-cowboy',
  icon: [
    640,
    512,
    [],
    'f8c0',
    [
      'M144.3 286.1c1.1-6.9 5.4-32.2 12.4-64.4C195.8 239.6 250.5 256 320 256s124.2-16.4 163.3-34.2c7 32.2 11.3 57.6 12.4 64.4c-11.2 4.6-23.3 9-36.2 13.1c-6.5 2-13.2 3.9-20 5.7c-3.4 .9-6.9 1.8-10.5 2.6c-3.6 .8-7.2 1.6-10.9 2.4c-14.7 3.1-30.2 5.6-46.5 7.3c-8.2 .9-16.5 1.5-25.1 2c-4.3 .2-8.6 .4-13 .5c-2.2 .1-4.4 .1-6.6 .1s-4.5 0-6.7 0c-72.1 0-131-15.3-175.8-33.8z',
      'M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c42.7 0 74.7 113.9 91.3 189.8C444.2 239.6 389.5 256 320 256s-124.2-16.4-163.3-34.2C173.3 145.9 205.3 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z',
    ],
  ],
};
const faBridge = {
  prefix: 'fad',
  iconName: 'bridge',
  icon: [
    576,
    512,
    [],
    'e4c8',
    [
      'M0 64C0 46.3 14.3 32 32 32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-40 0 0 64-48 0 0-64-80 0 0 64-48 0 0-64-80 0 0 64-48 0 0-64-80 0 0 64-48 0 0-64L32 96C14.3 96 0 81.7 0 64z',
      'M0 160H576V288c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96s-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160z',
    ],
  ],
};
const faPhoneFlip = {
  prefix: 'fad',
  iconName: 'phone-flip',
  icon: [
    512,
    512,
    [128381, 'phone-alt'],
    'f879',
    [
      'M6.3 412.3l8.5 31.2c2.2-.3 4.5-.6 6.7-.9c2.2-.3 4.5-.6 6.7-1c4.5-.7 8.9-1.4 13.3-2.2c8.8-1.6 17.6-3.4 26.2-5.4c17.3-4.1 34.3-9 50.8-14.9c33.1-11.7 64.6-26.8 94-44.9l-20.5-25C136.7 382.8 73.7 404.8 6.3 412.3zM349.4 192.1c8.3 6.8 16.7 13.6 25 20.5c36.2-58.9 60.4-125.9 69.2-197.8c-10.4-2.8-20.8-5.7-31.2-8.5c-7.5 67.4-29.5 130.4-62.9 185.8z',
      'M443.6 14.8l39 10.6C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-10.6-39c224-27.2 401.6-204.8 428.8-428.8zM6.3 412.3L1.4 394.5c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6l25.1 30.7C136.7 382.8 73.7 404.8 6.3 412.3zM349.4 192.1L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96c7.7-18.6 28-28.5 47.4-23.2l17.8 4.9c-7.5 67.4-29.5 130.4-62.9 185.8z',
    ],
  ],
};
const faPhoneAlt = faPhoneFlip;
const faArrowDownFromDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-down-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e090',
    [
      'M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm96 0A32 32 0 1 1 96 64a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M201.4 470.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 370.7l0-66.7 0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112 0 66.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z',
    ],
  ],
};
const faFileDoc = {
  prefix: 'fad',
  iconName: 'file-doc',
  icon: [
    512,
    512,
    [],
    'e5ed',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM176 352c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm16 128l0-96 16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-16 0zM456 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1-17.9-40-40-40l-16 0zM288 392l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8z',
    ],
  ],
};
const faSquareQuarters = {
  prefix: 'fad',
  iconName: 'square-quarters',
  icon: [
    448,
    512,
    [],
    'e44e',
    [
      'M64 96l0 320L224 256 64 96zM224 256L384 416l0-320L224 256z',
      'M384 96l0 320L64 416 64 96l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
    ],
  ],
};
const faTruckFront = {
  prefix: 'fad',
  iconName: 'truck-front',
  icon: [
    512,
    512,
    [],
    'e2b7',
    [
      'M32 432c6.7 5 14.2 9 22.3 11.8c4 1.4 8.2 2.4 12.5 3.1c2.1 .4 4.3 .6 6.5 .8c1.1 .1 2.2 .2 3.3 .2s2.2 .1 3.4 .1l48 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48zm80-208l17.9-71.8c3.6-14.2 16.4-24.2 31-24.2l190 0c14.7 0 27.5 10 31 24.2L400 224l-288 0zM384 448l48 0c18 0 34.6-6 48-16l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32z',
      'M80 0C35.8 0 0 35.8 0 80L0 368c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-288c0-44.2-35.8-80-80-80L80 0zm32 224l17.9-71.8c3.6-14.2 16.4-24.2 31-24.2l190 0c14.7 0 27.5 10 31 24.2L400 224l-288 0zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faCat = {
  prefix: 'fad',
  iconName: 'cat',
  icon: [
    576,
    512,
    [128008],
    'f6be',
    [
      'M171.8 261.9c13.5 6.8 27.1 13.5 40.6 20.3c.3 .1 .6 .3 .9 .4s.6 .2 .9 .3c.6 .1 1.2 .2 1.8 .2c4.2 0 8-3.3 8-8c0-19.1 0-38.2 0-57.4c-19.9 11.5-37.6 26.6-52.2 44.2zM241 209c12.2 12.2 24.3 24.3 36.5 36.5c4.5 4.5 12.2 2.2 13.5-4.1c3.2-16.1 6.5-32.3 9.7-48.4c-21.1 2.1-41.1 7.6-59.6 16z',
      'M320 192l17.1 0c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4l0 4 0 32 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-140.8L280 448l56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0c-53 0-96-43-96-96l0-223.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3l0 63.5 0 21.8c3.7-5.5 7.6-10.8 11.8-15.9l40.6 20.3c5.3 2.7 11.6-1.2 11.6-7.2l0-57.4c5.5-3.2 11.2-6.1 17-8.7l36.5 36.5c4.5 4.5 12.2 2.2 13.5-4.1l9.7-48.4c6.4-.6 12.8-1 19.4-1zm160 26.5s0 0 0 0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32c0 0 0 0 0 0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128c0 0 0 0 0 0l0-96 0-20 0-1.3C352 4.8 356.7 .1 362.6 0l.2 0c3.3 0 6.4 1.6 8.4 4.2c0 0 0 0 0 .1L384 21.3l27.2 36.3L416 64l64 0 4.8-6.4L512 21.3 524.8 4.3c0 0 0 0 0-.1c2-2.6 5.1-4.2 8.4-4.2l.2 0C539.3 .1 544 4.8 544 10.7l0 1.3 0 20 0 96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faTrashXmark = {
  prefix: 'fad',
  iconName: 'trash-xmark',
  icon: [
    448,
    512,
    [],
    'e2b4',
    [
      'M32 96l384 0L394.6 466.8c-1.5 25.4-22.5 45.2-47.9 45.2l-245.4 0c-25.4 0-46.5-19.8-47.9-45.2L32 96zM143 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l47-47 47 47c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
      'M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM143 207c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faCircleCaretLeft = {
  prefix: 'fad',
  iconName: 'circle-caret-left',
  icon: [
    512,
    512,
    ['caret-circle-left'],
    'f32e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 0c0-6.7 2.8-13 7.7-17.6l112-104c4.5-4.2 10.4-6.4 16.3-6.4c3.2 0 6.5 .7 9.6 2c8.7 3.8 14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22c-3.1 1.3-6.3 2-9.6 2c-5.9 0-11.8-2.2-16.3-6.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z',
      'M151.7 238.4c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-208c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104z',
    ],
  ],
};
const faCaretCircleLeft = faCircleCaretLeft;
const faFiles = {
  prefix: 'fad',
  iconName: 'files',
  icon: [
    448,
    512,
    [],
    'e178',
    [
      'M96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-256-64 0c-17.7 0-32-14.3-32-32l0-64L160 0C124.7 0 96 28.7 96 64z',
      'M352 0l0 64c0 17.7 14.3 32 32 32l64 0L352 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0c-48.6 0-88-39.4-88-88l0-256z',
    ],
  ],
};
const faAnchorCircleExclamation = {
  prefix: 'fad',
  iconName: 'anchor-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e4ab',
    [
      'M0 336c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-4.7 4.7-7 10.8-7 17zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faFaceClouds = {
  prefix: 'fad',
  iconName: 'face-clouds',
  icon: [
    640,
    512,
    [],
    'e47d',
    [
      'M64 256c0 114.6 75.4 211.7 179.3 244.3c-12.1-17-19.3-37.8-19.3-60.3c0-50.6 36.2-92.8 84.1-102.1C321.2 290.7 364.6 256 416 256c29.1 0 55.6 11.1 75.5 29.2c8.9-3.4 18.5-5.2 28.5-5.2c20 0 38.3 7.3 52.3 19.5c2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96c0 39.6-24 73.6-58.2 88.3c6.5 5.9 10.5 14.3 10.5 23.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L72.1 192c-5.3 20.5-8.1 41.9-8.1 64zm368.4-48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M128 0C104.3 0 83.6 12.9 72.6 32L64 32C28.7 32 0 60.7 0 96s28.7 64 64 64l160 0c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C179.7 17.9 155.9 0 128 0zM416 288c-44.2 0-80 35.8-80 80l-8 0c-39.8 0-72 32.2-72 72s32.2 72 72 72l240 0c39.8 0 72-32.2 72-72s-32.2-72-72-72l-.7 0c.4-2.6 .7-5.3 .7-8c0-26.5-21.5-48-48-48c-13.9 0-26.4 5.9-35.1 15.3C470.9 303.8 445.3 288 416 288z',
    ],
  ],
};
const faUserCrown = {
  prefix: 'fad',
  iconName: 'user-crown',
  icon: [
    448,
    512,
    [],
    'f6a4',
    [
      'M96 128l32 0 16 0 160 0 16 0 32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M352 80l0 48-32 0-16 0-160 0-16 0-32 0 0-48 0-37.7c0 0 0-.1 0-.1L96 39l0-23c0-8.8 7.2-16 16-16l2.4 0c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6l.1 .1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5L336 0c8.8 0 16 7.2 16 16l0 23 0 3.2c0 0 0 .1 0 .1L352 80zM0 472c0-92.8 75.2-168 168-168l112 0c92.8 0 168 75.2 168 168l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8z',
    ],
  ],
};
const faBasketShoppingPlus = {
  prefix: 'fad',
  iconName: 'basket-shopping-plus',
  icon: [
    576,
    512,
    [],
    'e653',
    [
      'M0 224c0 17.7 14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-98.4 0L393 192l-210 0-52.6 0L32 192c-17.7 0-32 14.3-32 32zM184 352c0-13.3 10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24z',
      'M253.9 33.8L183 192l-52.6 0L210.1 14.2c5.4-12.1 19.6-17.5 31.7-12.1s17.5 19.6 12.1 31.7zm112-19.6L445.6 192 393 192 322.1 33.8c-5.4-12.1 0-26.3 12.1-31.7s26.3 0 31.7 12.1zM264 432l0-56-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
    ],
  ],
};
const faTruckField = {
  prefix: 'fad',
  iconName: 'truck-field',
  icon: [
    640,
    512,
    [],
    'e58d',
    [
      'M96 400a80 80 0 1 0 160 0A80 80 0 1 0 96 400zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M32 96c0-35.3 28.7-64 64-64l224 0c23.7 0 44.4 12.9 55.4 32l51.8 0c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2l4.2 0c35.3 0 64 28.7 64 64l0 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-33.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-32c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-32zM384 224l85.9 0-42.7-96L384 128l0 96z',
    ],
  ],
};
const faRoute = {
  prefix: 'fad',
  iconName: 'route',
  icon: [
    512,
    512,
    [],
    'f4d7',
    [
      'M96 512l320 0c53 0 96-43 96-96s-43-96-96-96l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c-5.1 0-9.9-2.1-13.3-6c-1.1-1.3-2.3-2.7-3.7-4.3s-2.9-3.4-4.5-5.3c-3.2-3.9-6.8-8.4-10.7-13.4c-7.8-10-16.6-22-25.2-35c-12.9 0-25.7 0-38.6 0c-53 0-96 43-96 96s43 96 96 96l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-262.6 0c-17.1 26-35.4 48-44.1 58c-3.3 3.9-8.2 6-13.3 6z',
      'M320 96c0 54.5 63.8 132.1 82.7 154c3.3 3.9 8.2 6 13.3 6s9.9-2.1 13.3-6c19-21.9 82.7-99.6 82.7-154c0-53-43-96-96-96s-96 43-96 96zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 352c0 54.5 63.8 132.1 82.7 154c3.3 3.9 8.2 6 13.3 6s9.9-2.1 13.3-6c19-21.9 82.7-99.6 82.7-154c0-53-43-96-96-96s-96 43-96 96zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faCartCircleCheck = {
  prefix: 'fad',
  iconName: 'cart-circle-check',
  icon: [
    640,
    512,
    [],
    'e3f1',
    [
      'M0 24C0 37.3 10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.3-39.9-40-39.9l-411 0C111 12.8 91.6 0 69.5 0L24 0C10.7 0 0 10.7 0 24zM128 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm224-96a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm76.7-11.3c6.2-6.2 16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faClipboardQuestion = {
  prefix: 'fad',
  iconName: 'clipboard-question',
  icon: [
    384,
    512,
    [],
    'e4e3',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM105.4 246.5l.4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 344.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6zM224 432a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M270.8 66.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM105.8 245.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 344.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faPanorama = {
  prefix: 'fad',
  iconName: 'panorama',
  icon: [
    640,
    512,
    [],
    'e209',
    [
      'M0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32C20.4 32 0 52.4 0 77.6zM160 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM126 378.9c-5.1-8.6-4.3-19.4 1.9-27.2c23.1-28.9 46.3-57.8 69.4-86.7c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9c8.8 11 17.6 22 26.4 33.1l87-127.6c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-1.4 .2-2.7 .3-4.1 .3c-8.4 0-16.3-4.4-20.7-11.8z',
      'M387.8 170.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L234.7 265c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-69.4 86.7c-6.2 7.8-7 18.6-1.9 27.2s14.9 13.1 24.7 11.5C196.6 382.5 254.4 376 320 376c65.2 0 122.7 6.4 168.4 14.2c9.5 1.6 19-2.6 24.2-10.7s5.1-18.5-.4-26.5L387.8 170.5z',
    ],
  ],
};
const faCommentMedical = {
  prefix: 'fad',
  iconName: 'comment-medical',
  icon: [
    512,
    512,
    [],
    'f7f5',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160-16c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z',
      'M240 144c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faTeethOpen = {
  prefix: 'fad',
  iconName: 'teeth-open',
  icon: [
    576,
    512,
    [],
    'f62f',
    [
      'M48 176l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 168l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM176 144l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 200l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM304 144l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 200l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM432 176l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 168l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
      'M96 32C43 32 0 75 0 128l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-53-43-96-96-96L96 32zM224 96c26.5 0 48 21.5 48 48l0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56zM96 128c26.5 0 48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24zM96 480l384 0c53 0 96-43 96-96l0-32c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48zm80-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48zm80-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48s-48-21.5-48-48z',
    ],
  ],
};
const faUserTieHairLong = {
  prefix: 'fad',
  iconName: 'user-tie-hair-long',
  icon: [
    448,
    512,
    [],
    'e460',
    [
      'M48 249.4C48 261.9 58.1 272 70.6 272L224 272l153.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5l0-10.3 0-1C351.8 57.1 294.6 0 224 0C153.3 0 96 57.3 96 128c0 3.7 0 7.3 0 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16zM128 112c16 0 32 0 48 0c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96c2.7 0 5.3 0 8 0l0 32 0 32c0 53-43 96-96 96s-96-43-96-96l0-48z',
      'M257.9 66.2C269.2 84.1 289.2 96 312 96l8 0 0 32s0 0 0 0l0 32c0 53-43 96-96 96s-96-43-96-96l0-48s0 0 0 0l48 0c34.6 0 65-18.3 81.9-45.8zM70.6 272L224 272l153.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5l0-10.3 0-.2 0-.8C351.8 57.1 294.6 0 224 0C153.3 0 96 57.3 96 128c0 0 0 0 0 0l0 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 261.9 58.1 272 70.6 272zM279.7 510.9c1.8 .7 3.8 1.1 5.8 1.1l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c2.1 0 4-.4 5.8-1.1L168 512l112 0-.3-1.1z',
    ],
  ],
};
const faFileCircleMinus = {
  prefix: 'fad',
  iconName: 'file-circle-minus',
  icon: [
    576,
    512,
    [],
    'e4ed',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faHeadSideMedical = {
  prefix: 'fad',
  iconName: 'head-side-medical',
  icon: [
    512,
    512,
    [],
    'f809',
    [
      'M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM128 176l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z',
      'M208 96c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faArrowTurnRight = {
  prefix: 'fad',
  iconName: 'arrow-turn-right',
  icon: [
    512,
    512,
    [],
    'e635',
    [
      'M0 288L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7 14.3-32 32-32l306.7 0 32-32-32-32L96 192c-53 0-96 43-96 96z',
      'M329.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L434.7 224 329.4 329.4c-12.5 12.5-12.5 32.8 0 45.3z',
    ],
  ],
};
const faTags = {
  prefix: 'fad',
  iconName: 'tags',
  icon: [
    512,
    512,
    [],
    'f02c',
    [
      'M303.9 56c0 6.1 2.3 12.2 6.9 16.9L438.6 202.1c33.9 34.3 33.9 89.4 0 123.7L326.7 439.1c-9.3 9.4-9.2 24.6 .2 33.9c4.7 4.6 10.8 6.9 16.9 6.9c6.2 0 12.4-2.4 17.1-7.1L472.8 359.6c26.2-26.5 39.3-61 39.3-95.6s-13.1-69.1-39.3-95.6L345 39.1c-4.7-4.8-10.9-7.1-17.1-7.1c-6.1 0-12.2 2.3-16.9 6.9c-4.8 4.7-7.1 10.9-7.1 17.1z',
      'M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faWineGlass = {
  prefix: 'fad',
  iconName: 'wine-glass',
  icon: [
    320,
    512,
    [127863],
    'f4e3',
    [
      'M18.1 197.8c-6 72 42.5 135.2 109.9 150.6l0 99.6-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0L64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4zm63.8 5.3L88.1 128c1.8-21.3 3.6-42.7 5.3-64l133.1 0c1.8 21.3 3.6 42.7 5.3 64c2.1 25 4.2 50 6.3 75.1c.2 2.2 .3 4.4 .3 6.6c0 42.8-34.8 78.3-78.4 78.3s-78.4-35.5-78.4-78.3c0-2.2 .1-4.4 .3-6.6z',
      'M88.1 128l-6.3 75.1C78 248.8 114.1 288 160 288s82-39.2 78.1-84.9L231.9 128 88.1 128z',
    ],
  ],
};
const faForwardFast = {
  prefix: 'fad',
  iconName: 'forward-fast',
  icon: [
    512,
    512,
    [9197, 'fast-forward'],
    'f050',
    [
      'M448 96l0 118.3 0 83.3L448 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3 224 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4L448 214.3l0 83.3L276.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-118.3L52.5 440.6z',
    ],
  ],
};
const faFastForward = faForwardFast;
const faFaceMehBlank = {
  prefix: 'fad',
  iconName: 'face-meh-blank',
  icon: [
    512,
    512,
    [128566, 'meh-blank'],
    'f5a4',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMehBlank = faFaceMehBlank;
const faUserRobot = {
  prefix: 'fad',
  iconName: 'user-robot',
  icon: [
    448,
    512,
    [],
    'e04b',
    [
      'M32 160l0 64c0 17.7 14.3 32 32 32l16 0 0-128-16 0c-17.7 0-32 14.3-32 32zM144 464l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm0 448l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 0l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96-336l0 128 16 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-16 0z',
      'M80 128c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-128zm112 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 256a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM0 448c0-53 43-96 96-96l256 0c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32l-64 0 0-64c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32l0 64-64 0c-17.7 0-32-14.3-32-32l0-32z',
    ],
  ],
};
const faSquareParking = {
  prefix: 'fad',
  iconName: 'square-parking',
  icon: [
    448,
    512,
    [127359, 'parking'],
    'f540',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 72c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96s-43 96-96 96l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120zm64 24l0 64 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0z',
      'M192 192l0 64 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0zm144 32c0 53-43 96-96 96l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96z',
    ],
  ],
};
const faParking = faSquareParking;
const faCardDiamond = {
  prefix: 'fad',
  iconName: 'card-diamond',
  icon: [
    384,
    512,
    [],
    'e3ea',
    [
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 256c0 4.1 1.6 8.2 4.7 11.3l96 96c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l96-96c3.1-3.1 4.7-7.2 4.7-11.3s-1.6-8.2-4.7-11.3l-96-96c-3.1-3.1-7.2-4.7-11.3-4.7s-8.2 1.6-11.3 4.7l-96 96c-3.1 3.1-4.7 7.2-4.7 11.3z',
      'M203.3 148.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z',
    ],
  ],
};
const faFaceZipper = {
  prefix: 'fad',
  iconName: 'face-zipper',
  icon: [
    512,
    512,
    [],
    'e3a5',
    [
      'M0 256C0 397.4 114.6 512 256 512c50.3 0 97.2-14.5 136.7-39.5c-1.1-1.8-2.2-3.7-3.1-5.7l-29.1-58.1c-9.2-18.5-5.6-40.8 9-55.4l15.7-15.7c14.6-14.6 36.9-18.2 55.4-9l51.8 25.9C505 324.1 512 290.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm112 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32zm32.4-128c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM176 336c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32zm64 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32zm64 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32zm64.4-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM389.2 394.3l29.1 58.1c14.6 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5zm91.3 38.2l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17zM336.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faFaceRaisedEyebrow = {
  prefix: 'fad',
  iconName: 'face-raised-eyebrow',
  icon: [
    512,
    512,
    [],
    'e388',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112-96c0-8.8 7.2-16 16-16c21.3 0 42.7 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-21.3 0-42.7 0-64 0c-8.8 0-16-7.2-16-16zm32 192c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm64.4-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm68.3-91.3c9.8-9.8 19.7-19.7 29.5-29.5c11-11 25.3-16.4 39.5-16.4c17.9 0 35.7 8.5 46.6 24.9c1.6 2.5 3.3 4.9 4.9 7.4c1.8 2.7 2.7 5.8 2.7 8.9c0 5.2-2.5 10.2-7.1 13.3c-7.4 4.9-17.3 2.9-22.2-4.4c-1.6-2.5-3.3-4.9-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7c-9.8 9.8-19.7 19.7-29.5 29.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM368.4 240a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm80.4 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faHouseSignal = {
  prefix: 'fad',
  iconName: 'house-signal',
  icon: [
    576,
    512,
    [],
    'e012',
    [
      'M96 224c0 3.5 .6 7 1.8 10.4c18.3 5.3 35.9 12.6 52.3 21.6l9.9 0 0 5.7c56.8 34.2 99.6 89.1 118.1 154.3L464 416c26.5 0 48-21.5 48-48l0-112 32 0c13.2 0 25-8.1 29.8-20.3c1.5-3.8 2.2-7.7 2.2-11.6c0-8.8-3.6-17.3-10.3-23.5l-208-192C351.6 2.8 343.8 0 336 0s-15.6 2.8-21.7 8.5l-208 192C99.6 206.7 96 215.2 96 224zm192-16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z',
      'M0 280c0-13.3 10.7-24 24-24c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480zM24 352c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faSquareChevronUp = {
  prefix: 'fad',
  iconName: 'square-chevron-up',
  icon: [
    448,
    512,
    ['chevron-square-up'],
    'f32c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 288c0-6.1 2.3-12.3 7-17L207 167c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7L345 271c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-87-87-87 87c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M207 167c9.4-9.4 24.6-9.4 33.9 0L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167z',
    ],
  ],
};
const faChevronSquareUp = faSquareChevronUp;
const faNfcSymbol = {
  prefix: 'fad',
  iconName: 'nfc-symbol',
  icon: [
    512,
    512,
    [],
    'e531',
    [
      'M160 288c0 8.8 3.6 17.5 10.6 23.8l178.3 160c6 5.4 13.7 8.2 21.4 8.2c5.5 0 11-1.4 16-4.3C461.6 432.1 512 348.8 512 256s-50.3-176.1-125.7-219.7c-5-2.9-10.6-4.3-16-4.3c-11.1 0-21.8 5.7-27.7 16c-8.8 15.3-3.6 34.9 11.7 43.7C410.1 124 448 186.4 448 256c0 61.4-29.5 117.2-74.8 151.7L213.4 264.2c-13.2-11.8-33.4-10.7-45.2 2.4c-5.5 6.1-8.2 13.8-8.2 21.4z',
      'M125.7 36.3c12-6.9 27.1-5.4 37.4 3.9l178.3 160c13.2 11.8 14.2 32 2.4 45.2s-32 14.2-45.2 2.4L138.8 104.4C93.5 138.8 64 194.6 64 256c0 69.6 37.9 132 93.7 164.3c15.3 8.8 20.5 28.4 11.7 43.7s-28.4 20.5-43.7 11.7C50.3 432.1 0 348.8 0 256S50.3 79.9 125.7 36.3z',
    ],
  ],
};
const faBarsProgress = {
  prefix: 'fad',
  iconName: 'bars-progress',
  icon: [
    512,
    512,
    ['tasks-alt'],
    'f828',
    [
      'M192 288l0 64 256 0 0 32-256 0 0 64 272 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-272 0zM320 64l0 64 128 0 0 32-128 0 0 64 144 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L320 64z',
      'M0 112C0 85.5 21.5 64 48 64H320V224H48c-26.5 0-48-21.5-48-48V112zM0 336c0-26.5 21.5-48 48-48H192V448H48c-26.5 0-48-21.5-48-48V336z',
    ],
  ],
};
const faTasksAlt = faBarsProgress;
const faFaucetDrip = {
  prefix: 'fad',
  iconName: 'faucet-drip',
  icon: [
    512,
    512,
    [128688],
    'e006',
    [
      'M0 224l0 64c0 17.7 14.3 32 32 32l100.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160l-32 0-22.6-22.6c-6-6-14.1-9.4-22.6-9.4L256 160l0-76-32-4-32 4 0 76-18.7 0c-8.5 0-16.6 3.4-22.6 9.4L128 192l-96 0c-17.7 0-32 14.3-32 32zM192 32l0 12 32 4 32-4 0-12c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M224 80L96 96C78.3 96 64 81.7 64 64s14.3-32 32-32L224 48 352 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L224 80zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z',
    ],
  ],
};
const faArrowsToLine = {
  prefix: 'fad',
  iconName: 'arrows-to-line',
  icon: [
    448,
    512,
    [],
    'e0a7',
    [
      'M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z',
      'M224 0c17.7 0 32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-32c0-17.7 14.3-32 32-32zM137.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9z',
    ],
  ],
};
const faDolphin = {
  prefix: 'fad',
  iconName: 'dolphin',
  icon: [
    512,
    512,
    [],
    'e168',
    [
      'M0 245.8C0 269.1 18.9 288 42.2 288L176 288l16 0 11.2 0 92 61.3c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-48 6.6 0c31.7 0 57.4 25.7 57.4 57.4c0 30.6-24 55.8-54.5 57.3l-53.4 2.7c-20.2-33-56.3-53.4-95.4-53.4l-4.7 0c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l4.7 0c35.9 0 69.2-17.2 90.1-45.4l68 3.8c94.1 5.2 173.3-70 173.3-164.3c0-80.8-31.4-154.5-82.7-209.3l48-72c3.5-5.3 3.6-12.2 .1-17.6S467.7-.8 461.4 .2c-16.7 2.8-43.1 8.6-68.8 17C378 22 362.5 28 349 35.3C306.5 12.8 258 0 206.5 0L176 0C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7L20.5 209.6C7.8 217.2 0 231 0 245.8zM200 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M152 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faArrowUpRight = {
  prefix: 'fad',
  iconName: 'arrow-up-right',
  icon: [
    384,
    512,
    [],
    'e09f',
    [
      'M32 384c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0L288 205.3l0-45.3-45.3 0L41.4 361.4C35.1 367.6 32 375.8 32 384z',
      'M352 128c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224z',
    ],
  ],
};
const faCircleR = {
  prefix: 'fad',
  iconName: 'circle-r',
  icon: [
    512,
    512,
    [],
    'e120',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6c-4.3 3.2-9.4 4.8-14.4 4.8c-7.3 0-14.5-3.3-19.2-9.6L252 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112zm48 24l0 64 56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0z',
      'M160 152c0-13.3 10.7-24 24-24l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112zm48 88l56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64z',
    ],
  ],
};
const faCartFlatbed = {
  prefix: 'fad',
  iconName: 'cart-flatbed',
  icon: [
    640,
    512,
    ['dolly-flatbed'],
    'f474',
    [
      'M160 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48zM192 80c0-26.5 21.5-48 48-48l96 0 0 144c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8c13-8.7 26.1-17.4 39.1-26.1l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-144 96 0c26.5 0 48 21.5 48 48l0 192c0 26.5-21.5 48-48 48l-320 0c-26.5 0-48-21.5-48-48l0-192zM448 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l16 0c8.8 0 16 7.2 16 16l0 288c0 44.2 35.8 80 80 80l464 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-464 0c-8.8 0-16-7.2-16-16l0-288C128 35.8 92.2 0 48 0L32 0zM336 176c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L400 163.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-144-16 0-16 0-64 0-16 0-16 0 0 144z',
    ],
  ],
};
const faDollyFlatbed = faCartFlatbed;
const faBanSmoking = {
  prefix: 'fad',
  iconName: 'ban-smoking',
  icon: [
    512,
    512,
    [128685, 'smoking-ban'],
    'f54d',
    [
      'M96 240l0 64c0 8.8 7.2 16 16 16l162.7 0c-32-32-64-64-96-96L112 224c-8.8 0-16 7.2-16 16zM256 112c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16zm13.3 112l32 32 82.7 0 0 32-50.7 0 32 32 34.7 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-130.7 0z',
      'M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
    ],
  ],
};
const faSmokingBan = faBanSmoking;
const faCircleSortUp = {
  prefix: 'fad',
  iconName: 'circle-sort-up',
  icon: [
    512,
    512,
    ['sort-circle-up'],
    'e032',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm145.2-41.9c-2.5-6-1.1-12.9 3.5-17.4l96-96c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9zm0 83.8c2.5-6 8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4z',
      'M267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l192 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96z',
    ],
  ],
};
const faSortCircleUp = faCircleSortUp;
const faTerminal = {
  prefix: 'fad',
  iconName: 'terminal',
  icon: [
    576,
    512,
    [],
    'f120',
    [
      'M224 448c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32z',
      'M9.4 41.4C-3.1 53.9-3.1 74.1 9.4 86.6L178.7 256 9.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0z',
    ],
  ],
};
const faMobileButton = {
  prefix: 'fad',
  iconName: 'mobile-button',
  icon: [
    384,
    512,
    [],
    'f10b',
    [
      'M16 384l352 0 0 64c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64l0-64zm144 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V384H16V64z',
    ],
  ],
};
const faHouseMedicalFlag = {
  prefix: 'fad',
  iconName: 'house-medical-flag',
  icon: [
    640,
    512,
    [],
    'e514',
    [
      'M0 256c0 3.7 .6 7.5 2 11.1C6.6 279.7 18.6 288 32 288l32 0 0 192c0 17.7 14.3 32 32 32l320.8 0-.8 0 0-353L276.8 39.7c-6-5.1-13.4-7.7-20.8-7.7s-14.8 2.6-20.8 7.7l-224 192C3.9 237.9 0 246.8 0 256zm160 16c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z',
      'M512 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160 0 320 64 0 0-320 112 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L512 32z',
    ],
  ],
};
const faBasketShopping = {
  prefix: 'fad',
  iconName: 'basket-shopping',
  icon: [
    576,
    512,
    ['shopping-basket'],
    'f291',
    [
      'M0 224c0 17.7 14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-98.4 0c8.1 18.1 16.2 36.1 24.3 54.2c5.4 12.1 0 26.3-12.1 31.7s-26.3 0-31.7-12.1c-11-24.6-22.1-49.2-33.1-73.8l-210 0c-11 24.6-22.1 49.2-33.1 73.8c-4 8.9-12.7 14.2-21.9 14.2c-3.3 0-6.6-.7-9.8-2.1c-12.1-5.4-17.5-19.6-12.1-31.7c8.1-18.1 16.2-36.1 24.3-54.2L32 192c-17.7 0-32 14.3-32 32zm160 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm112 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm112 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96z',
      'M253.9 33.8c5.4-12.1 0-26.3-12.1-31.7s-26.3 0-31.7 12.1l-104 232c-5.4 12.1 0 26.3 12.1 31.7s26.3 0 31.7-12.1l104-232zm68.2 0l104 232c5.4 12.1 19.6 17.5 31.7 12.1s17.5-19.6 12.1-31.7l-104-232C360.5 2.1 346.3-3.3 334.2 2.1s-17.5 19.6-12.1 31.7z',
    ],
  ],
};
const faShoppingBasket = faBasketShopping;
const faTape = {
  prefix: 'fad',
  iconName: 'tape',
  icon: [
    576,
    512,
    [],
    'f4db',
    [
      'M64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm224 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M64 256a160 160 0 1 1 320 0A160 160 0 1 1 64 256zM380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-163.2 0z',
    ],
  ],
};
const faChestnut = {
  prefix: 'fad',
  iconName: 'chestnut',
  icon: [
    448,
    512,
    [127792],
    'e3f6',
    [
      'M4 384L444 384c-14.2 55.2-64.3 96-124 96l-192 0C68.4 480 18.2 439.2 4 384z',
      'M224 32c5.3 0 10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c7.5 6.8 16.7 14.3 27.2 22.8l3.1 2.5s0 0 0 0c20.3 16.4 44.7 36.1 68.2 59.6C400.8 190.2 448 258 448 352c0 11-1.4 21.8-4 32L4 384c-2.6-10.2-4-21-4-32c0-94 47.2-161.8 96.7-211.3c23.5-23.5 47.9-43.2 68.2-59.6l3.1-2.5c10.6-8.5 19.7-16 27.2-22.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1z',
    ],
  ],
};
const faBusSimple = {
  prefix: 'fad',
  iconName: 'bus-simple',
  icon: [
    448,
    512,
    ['bus-alt'],
    'f55e',
    [
      'M32 448l96 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32zM64 128c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32l0-128zM320 448l96 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32z',
      'M224 0C348.8 0 448 35.2 448 80l0 16 0 320c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32L0 96 0 80C0 35.2 99.2 0 224 0zM64 128l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faBusAlt = faBusSimple;
const faEye = {
  prefix: 'fad',
  iconName: 'eye',
  icon: [
    576,
    512,
    [128065],
    'f06e',
    [
      'M0 256c0 4.2 .8 8.4 2.5 12.3C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c1.6-3.9 2.5-8.1 2.5-12.3s-.8-8.4-2.5-12.3c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32s-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7C.8 247.6 0 251.8 0 256zm432 0a144 144 0 1 1 -288 0 144 144 0 1 1 288 0z',
      'M224 256c35.3 0 64-28.7 64-64c0-7.1-1.2-13.9-3.3-20.3c-1.8-5.5 1.6-11.9 7.4-11.7c40.8 1.7 77.5 29.6 88.6 71.1c13.7 51.2-16.7 103.9-67.9 117.6s-103.9-16.7-117.6-67.9c-1.9-6.9-2.9-13.9-3.2-20.7c-.3-5.8 6.1-9.2 11.7-7.4c6.4 2.1 13.2 3.3 20.3 3.3z',
    ],
  ],
};
const faFaceSadCry = {
  prefix: 'fad',
  iconName: 'face-sad-cry',
  icon: [
    512,
    512,
    [128557, 'sad-cry'],
    'f5b3',
    [
      'M0 256c0 94.8 51.5 177.5 128 221.8c0-63.2 0-126.5 0-189.8c0-.6 0-1.1 .1-1.6c.1-.5 .1-1.1 .2-1.6c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c8.8 0 16 7.2 16 16c0 68.5 0 136.9 0 205.4c29.6 12 62.1 18.6 96 18.6s66.4-6.6 96-18.6L352 288c0-8.8 7.2-16 16-16s16 7.2 16 16l0 189.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256zm99.2-41.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4zM208 336c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zm83.2-121.6c30.4-40.5 91.2-40.5 121.6 0c2.2 2.9 3.2 6.2 3.2 9.6c0 4.9-2.2 9.7-6.4 12.8c-7.1 5.3-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M195.2 233.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM128 477.8L128 288c0-8.8 7.2-16 16-16s16 7.2 16 16l0 205.4c-11.1-4.5-21.8-9.7-32-15.6zm224 15.6L352 288c0-8.8 7.2-16 16-16s16 7.2 16 16l0 189.8c-10.2 5.9-20.9 11.2-32 15.6zM316.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z',
    ],
  ],
};
const faSadCry = faFaceSadCry;
const faHeat = {
  prefix: 'fad',
  iconName: 'heat',
  icon: [
    448,
    512,
    [],
    'e00c',
    [
      'M144 64l0 80c0 48.5 15.7 95.6 44.8 134.4L208 304c20.8 27.7 32 61.4 32 96l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-48.5-15.7-95.6-44.8-134.4L240 240c-20.8-27.7-32-61.4-32-96l0-80c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M64 128c0-17.7-14.3-32-32-32S0 110.3 0 128l0 32c0 48.5 15.7 95.6 44.8 134.4L64 320c20.8 27.7 32 61.4 32 96l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-48.5-15.7-95.6-44.8-134.4L96 256c-20.8-27.7-32-61.4-32-96l0-32zm288 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32c0 48.5 15.7 95.6 44.8 134.4L352 320c20.8 27.7 32 61.4 32 96l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-48.5-15.7-95.6-44.8-134.4L384 256c-20.8-27.7-32-61.4-32-96l0-32z',
    ],
  ],
};
const faTicketAirline = {
  prefix: 'fad',
  iconName: 'ticket-airline',
  icon: [
    640,
    512,
    ['ticket-perforated-plane', 'ticket-plane'],
    'e29a',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.3-15.8-15.8-18c-27.7-7-48.2-32.1-48.2-62s20.5-55 48.2-62c8.6-2.2 15.8-9.1 15.8-18l0-48c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm448 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M147.5 138.5L176 224l-56 0-19.2-25.6c-3-4-7.8-6.4-12.8-6.4l-13.8 0c-5.2 0-9 4.9-7.8 9.9L79 252.1c.6 2.5 .6 5.2 0 7.8L66.5 310.1c-1.3 5 2.6 9.9 7.8 9.9L88 320c5 0 9.8-2.4 12.8-6.4L120 288l56 0-28.5 85.5c-1.7 5.2 2.1 10.5 7.6 10.5l31.1 0c8.5 0 16.4-4.5 20.7-11.9L256 288l46.9 0c16.1 0 31.5-6.4 42.8-17.7c7.9-7.9 7.9-20.7 0-28.5C334.4 230.4 319 224 302.9 224L256 224l-49.1-84.1c-4.3-7.4-12.2-11.9-20.7-11.9l-31.1 0c-5.5 0-9.3 5.3-7.6 10.5z',
    ],
  ],
};
const faTicketPerforatedPlane = faTicketAirline;
const faTicketPlane = faTicketAirline;
const faBootHeeled = {
  prefix: 'fad',
  iconName: 'boot-heeled',
  icon: [
    512,
    512,
    [],
    'e33f',
    [
      'M32 416l0 72c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-15.1 125 34.7c10.5 2.9 21.3 4.4 32.1 4.4L456 512l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-160 0L160 416 32 416z',
      'M63.3 0L128 0l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16L160 0 264 0c13.3 0 24 10.7 24 24l0 220.7c0 27.3 15.4 52.2 39.8 64.4l112.4 56.2c24.4 12.2 39.8 37.1 39.8 64.4l0 34.3-160 0L160 416 32 416l0-24.2c0-12.5 1.6-24.8 4.3-36.6C43.2 325.5 56 265.2 56 232C56 154.3 34.6 47.1 32.6 37.4c-.5-2.3-.6-4.3-.6-6.2C32 14 46 0 63.3 0z',
    ],
  ],
};
const faArrowsMinimize = {
  prefix: 'fad',
  iconName: 'arrows-minimize',
  icon: [
    512,
    512,
    ['compress-arrows'],
    'e0a5',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4L160 397.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L64 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L9.4 457.4C3.1 463.6 0 471.8 0 480zM288 64l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0L502.6 54.6c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6S488.2 0 480 0s-16.4 3.1-22.6 9.4L352 114.7 352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7 160 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L64 224c-17.7 0-32-14.3-32-32s14.3-32 32-32l50.7 0L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM288 320c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-50.7 0L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 397.3l0 50.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128z',
    ],
  ],
};
const faCompressArrows = faArrowsMinimize;
const faAudioDescription = {
  prefix: 'fad',
  iconName: 'audio-description',
  icon: [
    576,
    512,
    [],
    'f29e',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM98.5 317.3c24-48 48-96 72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3c24 48 48 96 72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0c-3.1 6.3-6.3 12.6-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2zm72.4-37.4l42.2 0c-7-14.1-14.1-28.1-21.1-42.2c-7 14.1-14.1 28.1-21.1 42.2zm133.2-98.3c.1-.8 .2-1.6 .4-2.4c.3-1.6 .8-3.1 1.4-4.5c1.2-2.9 3-5.5 5.1-7.6c4.3-4.3 10.3-7 17-7l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.5c0-48 0-96 0-144.3c0-.6 0-1.4 .1-2.2zM352 208l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z',
      'M192 160c9.1 0 17.4 5.1 21.5 13.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3zM170.9 279.8l42.2 0L192 237.7l-21.1 42.2zM304 184c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-13.3 0-24-10.7-24-24l0-144zm48 24l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z',
    ],
  ],
};
const faPersonMilitaryToPerson = {
  prefix: 'fad',
  iconName: 'person-military-to-person',
  icon: [
    512,
    512,
    [],
    'e54c',
    [
      'M288 256c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32zm0 176c0-6.9 3-13.5 8.2-18.1l64-56c10-8.7 25.1-7.7 33.9 2.3s7.7 25.1-2.3 33.9L375.9 408 488 408c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112.1 0 15.9 13.9c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-64-56c-5.2-4.6-8.2-11.1-8.2-18.1zM448 96A64 64 0 1 1 320 96a64 64 0 1 1 128 0z',
      'M71 12.5L182.2 .1C191.7-1 200 6.5 200 16l0 14.1c0 8.8-7.1 15.9-15.9 16l-111.4 0C63.5 46 56 38.5 56 29.2c0-8.6 6.5-15.8 15-16.8zM189.5 78.1c1.6 5.7 2.5 11.7 2.5 17.9c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-6.2 .9-12.2 2.5-17.9l122.9 0zM32 256c0-18.8 8.1-35.7 21-47.4l144.2 111c-1.7 .3-3.4 .4-5.2 .4L64 320c-17.7 0-32-14.3-32-32l0-32zm190.2 42.5L85.1 192.9c3.6-.6 7.2-.9 10.9-.9l64 0c35.3 0 64 28.7 64 64l0 32c0 3.7-.6 7.2-1.8 10.5zM224 432c0 6.9-3 13.5-8.2 18.1l-64 56c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9L136.1 456 24 456c-13.3 0-24-10.7-24-24s10.7-24 24-24l112.1 0-15.9-13.9c-10-8.7-11-23.9-2.3-33.9s23.9-11 33.9-2.3l64 56c5.2 4.6 8.2 11.1 8.2 18.1z',
    ],
  ],
};
const faFileShield = {
  prefix: 'fad',
  iconName: 'file-shield',
  icon: [
    576,
    512,
    [],
    'e4f0',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 47-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zm39.1 65.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z',
    ],
  ],
};
const faHexagon = {
  prefix: 'fad',
  iconName: 'hexagon',
  icon: [
    512,
    512,
    [11043],
    'f312',
    [
      'M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220z',
      '',
    ],
  ],
};
const faManhole = {
  prefix: 'fad',
  iconName: 'manhole',
  icon: [
    512,
    512,
    [],
    'e1d6',
    [
      'M96 256c0 71.3 46.6 131.7 111 152.4c9 2.9 17.8-4.3 23.6-11.8c5.8-7.6 15.1-12.6 25.4-12.6s19.6 4.9 25.4 12.6c5.8 7.5 14.5 14.7 23.6 11.8c64.4-20.7 111-81.1 111-152.4s-46.6-131.7-111-152.4c-9-2.9-17.8 4.3-23.6 11.8c-5.8 7.6-15.1 12.6-25.4 12.6s-19.6-4.9-25.4-12.6c-5.8-7.5-14.5-14.7-23.6-11.8C142.6 124.3 96 184.7 96 256zm112-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-448a192 192 0 1 1 0 384 192 192 0 1 1 0-384z',
    ],
  ],
};
const faUserSlash = {
  prefix: 'fad',
  iconName: 'user-slash',
  icon: [
    640,
    512,
    [],
    'f506',
    [
      'M96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c3.9 0 7.6-.7 11-2.1l-261-205.6C170.5 309.4 96 387.2 96 482.3zm96-357.1c53.8 42.1 107.5 84.3 161.3 126.4C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faPen = {
  prefix: 'fad',
  iconName: 'pen',
  icon: [
    512,
    512,
    [128394],
    'f304',
    [
      'M303 79C346.3 122.3 389.7 165.6 433 209c19.9-19.9 39.8-39.8 59.7-59.7c12.5-12.5 18.7-28.9 18.7-45.3s-6.2-32.8-18.7-45.3L453.3 19.3C440.8 6.8 424.4 .6 408 .6s-32.8 6.2-45.3 18.7L303 79z',
      'M433 209L303 79 52.8 329.3c-6.6 6.6-11.5 14.8-14.1 23.8L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1L433 209z',
    ],
  ],
};
const faTowerObservation = {
  prefix: 'fad',
  iconName: 'tower-observation',
  icon: [
    512,
    512,
    [],
    'e586',
    [
      'M100.9 448l32-192 64.9 0c-1.6 9.4-3.1 18.9-4.7 28.3L256 336.8l62.9-52.5L314.2 256l64.9 0 32 192-96.6 0L256 399.2 197.5 448l-96.6 0zm71.9-41.9L218.5 368l-34.6-28.8-11.2 67zM293.5 368l45.8 38.1-11.2-67L293.5 368z',
      'M270.3 3.4c-9-4.5-19.6-4.5-28.6 0l-160 80c-15.8 7.9-22.2 27.1-14.3 42.9C73 137.5 84.3 144 96 144l0 80c0 17.7 14.3 32 32 32l4.9 0 64.9 0 116.5 0 64.9 0 4.9 0c17.7 0 32-14.3 32-32l0-80c11.7 0 23-6.5 28.6-17.7c7.9-15.8 1.5-35-14.3-42.9l-160-80zM480 448l-68.9 0-96.6 0-117 0-96.6 0L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l95.5 0c.4 0 .8 0 1.1 0l254.8 0c.4 0 .8 0 1.1 0l95.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zM160 144c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faFloppyDisks = {
  prefix: 'fad',
  iconName: 'floppy-disks',
  icon: [
    512,
    512,
    [],
    'e183',
    [
      'M0 120L0 376c0 75.1 60.9 136 136 136l256 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-256 0c-48.6 0-88-39.4-88-88l0-256c0-13.3-10.7-24-24-24S0 106.7 0 120zM240 288a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M152 0C121.1 0 96 25.1 96 56l0 304c0 30.9 25.1 56 56 56l304 0c30.9 0 56-25.1 56-56l0-218.7c0-14.9-5.9-29.1-16.4-39.6L410.3 16.4C399.8 5.9 385.6 0 370.7 0L152 0zm8 96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-32zM304 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    ],
  ],
};
const faToiletPaperBlankUnder = {
  prefix: 'fad',
  iconName: 'toilet-paper-blank-under',
  icon: [
    512,
    512,
    ['toilet-paper-reverse-alt'],
    'e29f',
    [
      'M0 192C0 86 43 0 96 0L416 0c-53 0-96 86-96 192c0 1.3 0 2.6 0 3.9c1 104.2 43.6 188.1 96 188.1l-256 0-32 0-32 0C43 384 0 298 0 192z',
      'M416 384c-52.4 0-94.9-83.8-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0s96 86 96 192l0 272c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-80 256 0zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z',
    ],
  ],
};
const faToiletPaperReverseAlt = faToiletPaperBlankUnder;
const faFileCode = {
  prefix: 'fad',
  iconName: 'file-code',
  icon: [
    384,
    512,
    [],
    'f1c9',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 320c0 6.1 2.3 12.3 7 17l48 48c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-31-31 31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 303c-4.7 4.7-7 10.8-7 17zm167-65c-9.4 9.4-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48c-9.4-9.4-24.6-9.4-33.9 0z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM153 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM265 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z',
    ],
  ],
};
const faSignal = {
  prefix: 'fad',
  iconName: 'signal',
  icon: [
    640,
    512,
    [128246, 'signal-5', 'signal-perfect'],
    'f012',
    [
      '',
      'M576 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352c0-17.7 14.3-32 32-32zM352 224l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z',
    ],
  ],
};
const faSignal5 = faSignal;
const faSignalPerfect = faSignal;
const faPump = {
  prefix: 'fad',
  iconName: 'pump',
  icon: [
    640,
    512,
    [],
    'e442',
    [
      'M64 224l96 0 0-160 160 0 0 160 32 0 0 160L64 384l0-160z',
      'M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 0zM64 208c0-17.7-14.3-32-32-32s-32 14.3-32 32L0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-176zM431.9 106.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3l0 219.5c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7L576 512c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L467.4 96c-12.6 0-25 3.7-35.5 10.7zM448 208c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faBus = {
  prefix: 'fad',
  iconName: 'bus',
  icon: [
    576,
    512,
    [128653],
    'f207',
    [
      'M96 448l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0zm32.2-291.3c-.1 .5-.1 1.1-.1 1.6s0 1.1 0 1.6c0 32 0 64 0 96c0 .6 0 1.1 0 1.7s.1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4l112 0 0-160-112 0c-8.8 0-16.8 3.6-22.6 9.4c-2.9 2.9-5.2 6.3-6.9 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2zM304 128l0 160 112 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-112 0zm80 320l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0z',
      'M288 0C422.4 0 512 35.2 512 80l0 16 0 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32c0 0 0 0 0 0l0-32s0 0 0 0l0-16C64 35.2 153.6 0 288 0zM128 160l0 96c0 17.7 14.3 32 32 32l112 0 0-160-112 0c-17.7 0-32 14.3-32 32zM304 288l112 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-112 0 0 160zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16L208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faHeartCircleXmark = {
  prefix: 'fad',
  iconName: 'heart-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e501',
    [
      'M39.7 270.5L233.5 470.3c12 13 33 13 45.9 0l5.4-5.6C266.6 436.9 256 403.7 256 368c0-97.2 78.8-176 176-176c26.8 0 52.3 6 75 16.7c13.7-51.1-.9-108.7-43.8-146.1c-55.9-47-137.8-38-187.8 13l-19 21-20-21C208.7 47.4 170.8 32 133.3 32c-30 0-59.7 9.8-83.6 30.7c-62.9 53.9-65.9 149.8-10 207.8z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faArrowUpLeftFromCircle = {
  prefix: 'fad',
  iconName: 'arrow-up-left-from-circle',
  icon: [
    512,
    512,
    [],
    'e09e',
    [
      'M66.6 320c0 1.8 .1 3.5 .4 5.3C84.9 431.3 177 512 288 512c123.7 0 224-100.3 224-224c0-111-80.7-203.1-186.7-220.9c-1.8-.3-3.6-.4-5.3-.4c-15.3 0-28.9 11.1-31.5 26.7c-2.9 17.4 8.8 33.9 26.3 36.9C390.4 142.9 448 208.8 448 288c0 88.4-71.6 160-160 160c-79.2 0-145.1-57.6-157.8-133.3c-2.9-17.4-19.4-29.2-36.9-26.3c-15.6 2.6-26.7 16.2-26.7 31.5z',
      'M32 0L192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-82.7 0L342.6 297.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L64 109.3 64 192c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0z',
    ],
  ],
};
const faHouseChimney = {
  prefix: 'fad',
  iconName: 'house-chimney',
  icon: [
    576,
    512,
    [63499, 'home-lg'],
    'e3af',
    [
      'M64 270.5c74.7-65.3 149.3-130.7 224-196L512.1 270.6l.4 201.3c0 22.1-17.9 40.1-40 40.1L392 512c-22.1 0-40-17.9-40-40l0-88.3c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 88.3c0 22.1-17.9 40-40 40l-79.9 0c-22.1 0-40-17.9-40-40L64 270.5z',
      'M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5 512 64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 37.5L309.1 7.9z',
    ],
  ],
};
const faHomeLg = faHouseChimney;
const faWindowMaximize = {
  prefix: 'fad',
  iconName: 'window-maximize',
  icon: [
    512,
    512,
    [128470],
    'f2d0',
    [
      'M64 128c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32z',
      'M448 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0zM96 96l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faDryer = {
  prefix: 'fad',
  iconName: 'dryer',
  icon: [
    448,
    512,
    [],
    'f861',
    [
      'M80.9 288l95.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-95.1 0c8 72 69 128 143.1 128c79.5 0 144-64.5 144-144s-64.5-144-144-144c-74.1 0-135.2 56-143.1 128zM160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faFaceFrown = {
  prefix: 'fad',
  iconName: 'face-frown',
  icon: [
    512,
    512,
    [9785, 'frown'],
    'f119',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128.7 379.3C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faFrown = faFaceFrown;
const faChessBishopPiece = {
  prefix: 'fad',
  iconName: 'chess-bishop-piece',
  icon: [
    256,
    512,
    ['chess-bishop-alt'],
    'f43b',
    [
      'M0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416 4.8 473.6C1.7 477.8 0 482.8 0 488z',
      'M104 32C90.7 32 80 42.7 80 56c0 12.2 9.1 22.3 20.9 23.8C79.6 100.1 48 139 48 192c0 26.3 13.6 40.5 26.3 48L72 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l4.4 0L48 416l160 0L179.6 288l4.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-2.3 0c12.7-7.5 26.3-21.7 26.3-48c0-25.9-7.5-48.4-17.7-67l-48.6 48.6c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L181.7 111c-8.8-12.9-18.5-23.4-26.6-31.2C166.9 78.3 176 68.2 176 56c0-13.3-10.7-24-24-24l-48 0z',
    ],
  ],
};
const faChessBishopAlt = faChessBishopPiece;
const faShirtTankTop = {
  prefix: 'fad',
  iconName: 'shirt-tank-top',
  icon: [
    384,
    512,
    [],
    'e3c9',
    [
      'M112 32C112 14.3 97.7 0 80 0S48 14.3 48 32l0 32c0 91-19.2 143.6-33.3 170.1C6.7 249.1 0 265.5 0 282.5L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-165.5c0-17-6.7-33.5-14.7-48.4C355.2 207.6 336 155 336 64l0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48z',
      '',
    ],
  ],
};
const faDiploma = {
  prefix: 'fad',
  iconName: 'diploma',
  icon: [
    640,
    512,
    ['scroll-ribbon'],
    'f5ea',
    [
      'M0 272c0 56.9 24.1 119.2 81 140.7c10.5 4 22.5 4.2 33.4 1.8L256 383l0-223 0-16-16 0-73.3 0L96 144c-65.1 .3-96 71.5-96 128zM384 144l0 16 0 223 141.6 31.5c4.6 1 9.4 1.6 14.1 1.6c6.6 0 13.2-1 19.3-3.3c56.9-21.5 81-83.8 81-140.7c0-56.5-30.9-127.7-96-128l-70.7 0L400 144l-16 0z',
      'M302 59.7l18 20.6 18-20.6C353.4 42.1 375.6 32 399 32l1 0c44.2 0 80 35.8 80 80c0 11.4-2.4 22.2-6.7 32L400 144c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1 0c-1.2 0-2.3 .1-3.5 .2c-8.2 .9-15.8 4.8-21.3 11.1l-34.5 39.5c-4.5 5.2-.9 13.3 6 13.3l22.4 0 16 0 0 16 0 304c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2L320 444.8l-37.8 31.5c-4.8 4-11.4 4.8-17 2.2s-9.2-8.3-9.2-14.5l0-304 0-16 16 0 22.4 0c6.9 0 10.5-8.1 6-13.3L265.9 91.3C259.6 84.1 250.5 80 241 80l-1 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l-73.3 0c-4.3-9.8-6.7-20.6-6.7-32c0-44.2 35.8-80 80-80l1 0c23.4 0 45.6 10.1 61 27.7z',
    ],
  ],
};
const faScrollRibbon = faDiploma;
const faScreencast = {
  prefix: 'fad',
  iconName: 'screencast',
  icon: [
    576,
    512,
    [],
    'e23e',
    [
      'M0 96l0 96 24 0c13.6 0 27 1 40 3l0-99 448 0 0 320-227 0c2 13 3 26.4 3 40l0 24 224 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M0 248c0-13.3 10.7-24 24-24c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zM24 320c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faWalker = {
  prefix: 'fad',
  iconName: 'walker',
  icon: [
    448,
    512,
    [],
    'f831',
    [
      'M448 448.1A64 64 0 1 1 320 448a64 64 0 1 1 128 .1z',
      'M194 64l126 0c17.7 0 32 14.3 32 32l0 64-207 0 17.9-71.8C166.5 74 179.3 64 194 64zM63 487.8L129 224l223 0 0 168.6c9.4-5.4 20.3-8.6 32-8.6s22.6 3.1 32 8.6L416 96c0-53-43-96-96-96L194 0c-44.1 0-82.4 30-93.1 72.7L1 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3z',
    ],
  ],
};
const faPrescription = {
  prefix: 'fad',
  iconName: 'prescription',
  icon: [
    448,
    512,
    [],
    'f5b1',
    [
      'M128 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c35.1-35.1 70.2-70.2 105.4-105.4c15.1-15.1 30.2-30.2 45.3-45.3c35.1-35.1 70.2-70.2 105.4-105.4c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6s-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4c-35.1 35.1-70.2 70.2-105.4 105.4c-15.1 15.1-30.2 30.2-45.3 45.3L137.4 457.4c-6.2 6.2-9.4 14.4-9.4 22.6z',
      'M0 32C0 14.3 14.3 0 32 0L176 0c61.9 0 112 50.1 112 112c0 52.8-36.6 97.1-85.8 108.9L288 306.7 242.7 352l-128-128L64 224l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96L0 32zM288 397.3L333.3 352 438.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 397.3zM64 160l112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 64l0 96z',
    ],
  ],
};
const faShop = {
  prefix: 'fad',
  iconName: 'shop',
  icon: [
    640,
    512,
    ['store-alt'],
    'f54f',
    [
      'M64 192l32 0 32 0 192 0 64 0 128 0 32 0 32 0 0 288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256-128 0 0 160 0 80c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-80 0-192zm64 32l0 160 192 0 0-160-192 0z',
      'M603.2 192H36.8C16.5 192 0 175.5 0 155.2c0-7.3 2.2-14.4 6.2-20.4L81.8 21.4C90.7 8 105.6 0 121.7 0H518.3c16.1 0 31 8 39.9 21.4l75.6 113.3c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8z',
    ],
  ],
};
const faStoreAlt = faShop;
const faFloppyDisk = {
  prefix: 'fad',
  iconName: 'floppy-disk',
  icon: [
    448,
    512,
    [128190, 128426, 'save'],
    'f0c7',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32C28.7 32 0 60.7 0 96zm64 32c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM288 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M224 288a64 64 0 1 0 0 128 64 64 0 1 0 0-128z',
    ],
  ],
};
const faSave = faFloppyDisk;
const faVihara = {
  prefix: 'fad',
  iconName: 'vihara',
  icon: [
    640,
    512,
    [],
    'f6a7',
    [
      'M64 448l64 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zM96 288l64 0 0 64-56 0-8 0 0-64zm64-160l64 0 0 64-56 0-7.3 0-.7 0 0-64zM288 448l8 0 24 0 24 0 8 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zM416 128l64 0 0 64-.7 0-7.3 0-56 0 0-64zm64 160l64 0 0 64-8 0-56 0 0-64zm32 160l64 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32z',
      'M305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9L320 128l-167.5 0c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22L305.8 4.7zM472 192l7.3 0 6 4 11.1 7.4c22.1 14.8 46.6 25.6 72.4 32l21 5.2c11.8 2.9 19.5 14.2 18 26.2S596.1 288 584 288l-208 0-24 0-64 0-24 0L56 288c-12.1 0-22.3-9-23.8-21.1s6.2-23.3 18-26.2l21-5.2c25.8-6.4 50.3-17.3 72.4-32l11.1-7.4 6-4 7.3 0 96 0 24 0 64 0 24 0 96 0zM95.6 352l8.4 0 192 0 24 0 24 0 192 0 8.4 0 6.6 5.3 10.4 8.3c17.8 14.2 37.6 25.8 58.8 34.2l4.8 1.9c10.7 4.3 16.8 15.5 14.7 26.8S627.5 448 616 448l-272 0-24 0-24 0L24 448c-11.5 0-21.4-8.2-23.6-19.5s4-22.5 14.7-26.8l4.8-1.9c21.2-8.5 41-20 58.8-34.2L89 357.3l6.6-5.3z',
    ],
  ],
};
const faFaceKissClosedEyes = {
  prefix: 'fad',
  iconName: 'face-kiss-closed-eyes',
  icon: [
    512,
    512,
    [],
    'e37d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm115.2-41.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4zM232.3 294c.9-3.5 4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 4.1-9.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c.1 0 .1-.1 .5-.3l.6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3c-.2-.1-.3-.2-.7-.4c-3.2-1.8-4.7-5.5-3.8-9zm42.9-79.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M140.8 233.6c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm160 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z',
    ],
  ],
};
const faScaleUnbalanced = {
  prefix: 'fad',
  iconName: 'scale-unbalanced',
  icon: [
    640,
    512,
    ['balance-scale-left'],
    'f515',
    [
      'M96.5 170.1c5.6 16.8 23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2l0 326.7c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-294.7c21-9.2 37.2-27 44.2-49L521 62.4c16.8-5.6 25.8-23.7 20.2-40.5C536.7 8.5 524.2 0 510.9 0c-3.4 0-6.8 .5-10.1 1.7l-113 37.7C373.8 15.8 348.2 0 318.8 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L116.7 129.6c-16.8 5.6-25.8 23.7-20.2 40.5z',
      'M510.8 163.8L583.3 288l-144.9 0 72.4-124.2zm-126 141.3C395.7 350 448 384 510.8 384s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L534.9 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L391.6 273.1c-5.7 9.8-9.3 21.1-6.7 32.1zM128 291.8L200.4 416 55.6 416 128 291.8zM2 433.1C12.8 478 65.1 512 128 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L152.1 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 401.1C3 410.8-.6 422.1 2 433.1z',
    ],
  ],
};
const faBalanceScaleLeft = faScaleUnbalanced;
const faFileUser = {
  prefix: 'fad',
  iconName: 'file-user',
  icon: [
    384,
    512,
    [],
    'f65c',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 432c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80zm48-176a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 432c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80z',
    ],
  ],
};
const faUserPoliceTie = {
  prefix: 'fad',
  iconName: 'user-police-tie',
  icon: [
    448,
    512,
    [],
    'e334',
    [
      'M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6l-23.8 20.4c.1 1 .1 2 .1 3.1l0 21.2c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 147.7 80 137.6 80 126.9l0-21.2c0-1 0-2.1 .1-3.1L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4c0 17.2 7 46.1 36.9 58.6c2 .8 4.2 .8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4L227 48.6zM208 416l-20.4-40.8c-5.3-10.6 2.4-23.2 14.3-23.2l44.2 0c11.9 0 19.6 12.5 14.3 23.2L240 416l12.2 48.9L315 360.3c3-5 8.6-8.1 14.4-7.4C396.2 360.8 448 417.5 448 486.4c0 14.1-11.5 25.6-25.6 25.6L256 512s0 0 0 0l-64 0s0 0 0 0L25.6 512C11.5 512 0 500.5 0 486.4c0-68.9 51.8-125.6 118.6-133.5c5.8-.7 11.4 2.4 14.4 7.4l62.8 104.6L208 416zm144-8c-3.5 0-6.5 2.2-7.6 5.5L339 430.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9L331 454.8l-5.4 16.6c-1.1 3.3 .1 6.9 2.9 9s6.6 2 9.4 0L352 470.1l14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9L373 454.8l14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5z',
    ],
  ],
};
const faFaceTongueMoney = {
  prefix: 'fad',
  iconName: 'face-tongue-money',
  icon: [
    512,
    512,
    [],
    'e39d',
    [
      'M0 256C0 364.6 67.7 457.5 163.1 494.6C151.1 476.8 144 455.2 144 432l0-10.5c-22.4-20.1-39-46.1-47.2-75.4c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1c-8.2 29.4-24.9 55.4-47.2 75.4l0 10.5c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM128.6 144.1c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1l0-9.3c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2l0 8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2zm160 0c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1l0-9.3c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c2 4.4 2.9 9.1 2.9 13.9c0 2.4-.2 4.8-.6 7.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2l0 8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2z',
      'M176 88c8.8 0 16 7.2 16 16l0 9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2l0 8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1l0-9.3c0-8.8 7.2-16 16-16zm160 0c8.8 0 16 7.2 16 16l0 9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2l0 8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1l0-9.3c0-8.8 7.2-16 16-16zm0 264l0 80c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-80 160 0zm-80 16c-5.9 0-10.7 4.9-10.7 10.9l0 6.4c-3.8 .8-7.8 2.2-11.3 4.9c-5 3.7-8.4 9.2-9.6 16.1c-.8 5-.5 9.9 1.5 14.4c1.9 4.5 5.1 7.7 8.3 9.9c5.6 4 12.9 6.1 18.1 7.6l.8 .2c6.4 1.9 10.2 3.1 12.6 4.8c1.7 1.2 1.4 4.4-.4 5.5c-.8 .5-2.5 1.1-5.9 1c-6.8-.1-15-2.7-21.3-4.8c-5.6-1.9-11.6 1.2-13.5 6.9s1.2 11.9 6.8 13.8c3.4 1.1 8.4 2.8 14 4.1l0 7.3c0 6 4.8 10.9 10.7 10.9s10.7-4.9 10.7-10.9l0-6.1c3.2-.6 6.5-1.7 9.6-3.6c6.1-3.7 10-9.8 11.3-17.7c.8-5 .5-9.9-1.5-14.4c-1.9-4.5-5.1-7.7-8.3-9.9c-4.8-3.4-10.4-4.9-15.9-6.4c-5.5-1.5-10.9-3-15.5-6.2c-1.6-1.1-1.6-3.6 .2-4.9c.7-.5 2.1-1.1 4.7-1.4c5.4-.6 12.5 .6 18 2.2c5.7 1.5 11.5-1.9 13-7.7s-1.9-11.8-7.6-13.3c-2.3-.6-5-1.3-8.1-1.8l0-6.7c0-6-4.8-10.9-10.7-10.9z',
    ],
  ],
};
const faTennisBall = {
  prefix: 'fad',
  iconName: 'tennis-ball',
  icon: [
    512,
    512,
    [127934],
    'f45e',
    [
      'M.2 245.1c24.8 8.7 51.3 12.3 77.9 10.4c42.9-3.2 83.5-20.6 115.2-49.6s52.9-67.7 60-110.1c5.4-32.2 2.5-65.1-8.2-95.6c3.6-.2 7.2-.2 10.9-.2C397.4 0 512 114.6 512 256c0 3.7-.1 7.3-.2 10.9c-21.5-7.6-44.1-11.3-67-10.9c-27.5 .5-54.6 6.8-79.5 18.7s-46.9 28.9-64.5 50.1s-30.6 45.8-37.9 72.4s-8.8 54.4-4.4 81.6c1.8 11.3 4.7 22.4 8.4 33.1c-3.6 .2-7.2 .2-10.9 .2C114.6 512 0 397.4 0 256c0-3.6 .1-7.3 .2-10.9zm4.5-38.3C24.6 104.9 104.9 24.6 206.8 4.7c11.1 26.7 14.5 56.1 9.7 84.9c-5.7 34.1-22.8 65.4-48.4 88.7s-58.3 37.4-92.8 39.9C51.1 220 26.9 216 4.7 206.8zM295.4 472.7c-3.5-21.9-2.3-44.3 3.5-65.7s16.3-41.3 30.5-58.3s32-30.8 52-40.3s41.8-14.7 64-15.1c21.2-.4 42.3 3.7 61.9 11.8C487.4 407.1 407.1 487.4 305.2 507.3c-4.6-11.1-7.9-22.7-9.8-34.6z',
      'M305.2 507.3c-12.5 2.4-25.3 3.9-38.3 4.5c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c-.5 13-2.1 25.8-4.5 38.3c-19.6-8.1-40.6-12.1-61.9-11.8c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6zM245.1 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4c.5-13 2.1-25.8 4.5-38.3C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9c12.5-2.4 25.3-3.9 38.3-4.5z',
    ],
  ],
};
const faSquareL = {
  prefix: 'fad',
  iconName: 'square-l',
  icon: [
    448,
    512,
    [],
    'e275',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208z',
      'M152 128c13.3 0 24 10.7 24 24l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faSortUp = {
  prefix: 'fad',
  iconName: 'sort-up',
  icon: [
    320,
    512,
    ['sort-asc'],
    'f0de',
    [
      'M0 320c0 8.3 3.3 16.5 9.4 22.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8C.8 311.7 0 315.9 0 320zm109.3 32l101.5 0L160 402.7 109.3 352z',
      'M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z',
    ],
  ],
};
const faSortAsc = faSortUp;
const faCalendarArrowUp = {
  prefix: 'fad',
  iconName: 'calendar-arrow-up',
  icon: [
    448,
    512,
    ['calendar-upload'],
    'e0d1',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM127 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM248 424l0-102.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 424c0 13.3 10.7 24 24 24s24-10.7 24-24z',
    ],
  ],
};
const faCalendarUpload = faCalendarArrowUp;
const faCommentDots = {
  prefix: 'fad',
  iconName: 'comment-dots',
  icon: [
    512,
    512,
    [128172, 62075, 'commenting'],
    'f4ad',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M96 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faCommenting = faCommentDots;
const faPlantWilt = {
  prefix: 'fad',
  iconName: 'plant-wilt',
  icon: [
    512,
    512,
    [],
    'e5aa',
    [
      'M48 248l0 13c9.6-3.3 20.4-5 32-5c1.5 0 2.9 0 4.3 .1s2.8 .1 4.2 .2c2.8 .2 5.5 .5 8.2 .9c5.3 .8 10.4 2.1 15.2 3.7l0-13c0-30.9 25.1-56 56-56s56 25.1 56 56l0 32 0 200c0 17.7 14.3 32 32 32s32-14.3 32-32l0-200 0-32 0-128c0-30.9 25.1-56 56-56s56 25.1 56 56l0 13c9.6-3.3 20.4-5 32-5c1.5 0 2.9 0 4.3 .1s2.8 .1 4.2 .2c2.8 .2 5.5 .5 8.2 .9c5.3 .8 10.4 2.1 15.2 3.7l0-13C464 53.7 410.3 0 344 0S224 53.7 224 120l0 21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120z',
      'M432 128c-47.1 0-80 27.8-80 75.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-47.3-32.9-75.1-80-75.1zM80 256c-47.1 0-80 27.8-80 75.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-47.3-32.9-75.1-80-75.1z',
    ],
  ],
};
const faScarf = {
  prefix: 'fad',
  iconName: 'scarf',
  icon: [
    512,
    512,
    [129507],
    'f7c1',
    [
      'M0 400c0-4.1 1.6-8.2 4.7-11.3l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0C1.6 408.2 0 404.1 0 400zm52.7 36.7l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6zM288 406.6l11.3-11.3c3.8-3.8 7.5-7.5 11.3-11.3L411.3 484.7c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L288 406.6zm48-48l11.3-11.3L358.6 336 459.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 358.6zm48-48c3.8-3.8 7.5-7.5 11.3-11.3s7.5-7.5 11.3-11.3c33.6 33.6 67.1 67.1 100.7 100.7c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-6.2 6.2-16.4 6.2-22.6 0L384 310.6z',
      'M374.6 256L256 137.4 218.2 99.6C228.9 97.5 241.7 96 256 96s27.1 1.5 37.8 3.6l-15.1 15.1L396.1 232.2C409 213.7 416 191.6 416 168.8c0-19-4.9-37.7-14.2-54.2L360.3 40.8C346.1 15.6 319.5 0 290.6 0L221.4 0c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8C100.9 131.1 96 149.8 96 168.8c0 29.3 11.7 57.5 32.4 78.2L276.7 395.3 288 406.6l11.3-11.3 48-48 48-48L406.6 288l-11.3-11.3L384 265.4l-9.4-9.4z',
    ],
  ],
};
const faAlbumCirclePlus = {
  prefix: 'fad',
  iconName: 'album-circle-plus',
  icon: [
    576,
    512,
    [],
    'e48c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-16.2-19.7-28.3-42.9-34.8-68.4c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160c69.3 0 128.3 44 150.5 105.6c18-6.2 37.4-9.6 57.5-9.6c5.4 0 10.7 .2 16 .7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM192 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faUserNurseHairLong = {
  prefix: 'fad',
  iconName: 'user-nurse-hair-long',
  icon: [
    448,
    512,
    [],
    'e45e',
    [
      'M128 160c0 53 43 96 96 96s96-43 96-96l0-16-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 141.7 210.6 160 176 160l-48 0z',
      'M96 152.8L96 68c0-13.3 8.3-25.3 20.8-30l96-36C220-.7 228-.7 235.2 2l96 36C343.7 42.7 352 54.7 352 68l0 84.8c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6l-306.7 0c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5zM212.3 409.4c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 346.4 448 407.3 448 479.1c0 17-13.8 30.7-30.7 30.7l-386.6 0c-17 0-30.7-13.8-30.7-30.7c0-71.9 47-132.7 111.9-153.6c10.5-3.4 21.8 .4 29.4 8.5l71 75.5zM216 40c-4.4 0-8 3.6-8 8l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0zM176 160l-48 0c0 53 43 96 96 96s96-43 96-96l0-16-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 141.7 210.6 160 176 160z',
    ],
  ],
};
const faDiamond = {
  prefix: 'fad',
  iconName: 'diamond',
  icon: [
    512,
    512,
    [9830],
    'f219',
    [
      'M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z',
      '',
    ],
  ],
};
const faSquareLeft = {
  prefix: 'fad',
  iconName: 'square-left',
  icon: [
    448,
    512,
    [11013, 'arrow-alt-square-left'],
    'f351',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM80 256c0-5.1 2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32c-32 0-64 0-96 0l0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1c-33.3-35.7-66.6-71.4-99.9-107.1C82 266.1 80 261.1 80 256z',
      'M85.5 269.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L85.5 242.2C82 245.9 80 250.9 80 256s2 10.1 5.5 13.8z',
    ],
  ],
};
const faArrowAltSquareLeft = faSquareLeft;
const faFaceGrinSquint = {
  prefix: 'fad',
  iconName: 'face-grin-squint',
  icon: [
    512,
    512,
    [128518, 'grin-squint'],
    'f585',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm105.2 75.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM116 157.1c0-9 9.6-14.7 17.5-10.5c30 16 59.9 32 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8c-30 16-59.9 32-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6c12-14.4 24-28.8 36-43.2c-12-14.4-24-28.8-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm172.6 37.4c30-16 59.9-32 89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6c-12 14.4-24 28.8-36 43.2c12 14.4 24 28.8 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5c-30-16-59.9-32-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8z',
      'M116 157.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm280 0c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z',
    ],
  ],
};
const faGrinSquint = faFaceGrinSquint;
const faCircleEllipsisVertical = {
  prefix: 'fad',
  iconName: 'circle-ellipsis-vertical',
  icon: [
    512,
    512,
    [],
    'e10b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm288-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M256 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faHandHoldingDollar = {
  prefix: 'fad',
  iconName: 'hand-holding-dollar',
  icon: [
    576,
    512,
    ['hand-holding-usd'],
    'f4c0',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M288 0c13.3 0 24 10.7 24 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHandHoldingUsd = faHandHoldingDollar;
const faGridDividers = {
  prefix: 'fad',
  iconName: 'grid-dividers',
  icon: [
    512,
    512,
    [],
    'e3ad',
    [
      'M32 128l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 96c-17.7 0-32 14.3-32 32zm0 288l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM192 128l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm0 288l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM352 128l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm0 288l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
      'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zm0 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 288z',
    ],
  ],
};
const faChartDiagram = {
  prefix: 'fad',
  iconName: 'chart-diagram',
  icon: [
    512,
    512,
    [],
    'e695',
    [
      'M40 304l0 48 48 0 0-48c0-22.1 17.9-40 40-40l56 0 48 48 0 40 48 0 0-40 48-48 56 0c22.1 0 40 17.9 40 40l0 48 48 0 0-48c0-48.6-39.4-88-88-88l-56 0-48-48 0-40-48 0 0 40-48 48-56 0c-48.6 0-88 39.4-88 88z',
      'M32 80c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L80 128c-26.5 0-48-21.5-48-48zm0 272l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm192 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm192 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faBacterium = {
  prefix: 'fad',
  iconName: 'bacterium',
  icon: [
    512,
    512,
    [],
    'e05a',
    [
      'M.9 406.6c3.6 12.7 16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7c2.2 .6 4.4 .9 6.6 .9c10.4 0 20.1-6.9 23.1-17.4l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8c3.6-12.7-3.7-26-16.5-29.7c-2.2-.6-4.4-.9-6.6-.9c-10.4 0-20.1 6.9-23.1 17.4l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .5c-.5 5.1-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6zm111.3-91.5c.2-1.6 .4-3.2 .7-4.7c.6-3.1 1.6-6.1 2.8-9c2.4-5.7 5.9-10.9 10.3-15.3c8.7-8.7 20.7-14.1 33.9-14.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-13.3 0-25.3-5.4-33.9-14.1c-4.3-4.3-7.9-9.5-10.3-15.3c-1.2-2.9-2.2-5.9-2.8-9c-.3-1.6-.6-3.2-.7-4.8c-.1-.8-.1-1.6-.2-2.4s-.1-1.5-.1-2l0-.5 0-.5c0-.5 0-1.2 .1-2c0-.8 .1-1.6 .2-2.4zM264 208a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
    ],
  ],
};
const faHandPointer = {
  prefix: 'fad',
  iconName: 'hand-pointer',
  icon: [
    448,
    512,
    [],
    'f25a',
    [
      'M0 312c0 8.4 2.6 16.8 8 24l72 96c33.7 45 84.6 73.4 140 79c4.8 .7 9.7 1 14.7 1l5.2 0 64.1 0 16 0c70.7 0 128-57.3 128-128l0-48 0-16 0-48c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C366 211.5 345.3 192 320 192c-13.8 0-26.3 5.8-35 15.2C278.2 189 260.6 176 240 176c-12.3 0-23.5 4.6-32 12.2L208 40c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 322.7L72 288c-13.3-17.7-38.3-21.3-56-8C5.5 287.9 0 299.9 0 312zm208-8c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1.1 .1 1.6c0 32 0 64 0 96.1c0 .4 0 1-.1 1.5s-.1 1.1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16c0-32 0-64 0-96zm64 0c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1.1 .1 1.6c0 32 0 64 0 96.1c0 .4 0 1-.1 1.5s-.1 1.1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16c0-32 0-64 0-96zm64 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96z',
      'M224 288c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm80 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faDrumSteelpan = {
  prefix: 'fad',
  iconName: 'drum-steelpan',
  icon: [
    576,
    512,
    [],
    'f56a',
    [
      'M48 160c0 9.9 8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160zM224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8C224.5 87 224 91.5 224 96zm2.8 141.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3zM368 172.8c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8s-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4z',
      'M288 32c159.1 0 288 48 288 128l0 192c0 80-128.9 128-288 128S0 432 0 352L0 160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z',
    ],
  ],
};
const faHandScissors = {
  prefix: 'fad',
  iconName: 'hand-scissors',
  icon: [
    512,
    512,
    [],
    'f257',
    [
      'M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9c0 0 0 .1 0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z',
      '',
    ],
  ],
};
const faHandsPraying = {
  prefix: 'fad',
  iconName: 'hands-praying',
  icon: [
    640,
    512,
    ['praying-hands'],
    'f684',
    [
      'M336 224l0 118.2c0 58 39 108.7 95 123.7l168.7 45c2.7 .7 5.5 1.1 8.2 1.1c7 0 13.8-2.3 19.5-6.6c7.9-6.1 12.5-15.4 12.5-25.4l0-96c0-13.8-8.8-26-21.9-30.4l-79.2-26.4c-6.5-2.2-10.9-8.3-10.9-15.2l0-73.5c0-15.8-4.7-31.2-13.4-44.4L394.8 14.5C390.1 7.4 383.1 2.7 375.4 .9c-2.4-.6-4.9-.9-7.4-.9c-2.3 0-4.5 .2-6.8 .7c-3.5 .8-6.9 2.1-10 4.1c-7.5 4.6-12.4 11.9-14.3 19.9c-1.1 4.6-1.2 9.4-.1 14.1c.7 3.2 1.9 6.3 3.6 9.3l86.4 151.2c3.5 6 5.3 12.9 5.3 19.8l0 84.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M278.8 .7c3.5 .8 6.9 2.1 10 4.1c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8l0 84.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 118.2c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 489.9 0 480l0-96c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2l0-73.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1z',
    ],
  ],
};
const faPrayingHands = faHandsPraying;
const faFacePensive = {
  prefix: 'fad',
  iconName: 'face-pensive',
  icon: [
    512,
    512,
    [],
    'e384',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm65.7-40.8c-4-7.9-.7-17.5 7.2-21.5c7.6-3.8 15.2-7.6 22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2c4.8-6 9.6-12 14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-4.8 6-9.6 12-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3c-7.9 4-17.5 .7-21.5-7.2zm33.5 74.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-15.2 20.3-38 30.4-60.8 30.4s-45.6-10.1-60.8-30.4zM192 400c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm99.2-110.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-15.2 20.3-38 30.4-60.8 30.4s-45.6-10.1-60.8-30.4zM339.5 154c-5.5-6.9-4.4-17 2.5-22.5c2.9-2.4 6.5-3.5 10-3.5c4.7 0 9.3 2.1 12.5 6l14.4 18c10.1 12.7 22.9 23 37.4 30.2c7.6 3.8 15.2 7.6 22.9 11.4c5.6 2.8 8.8 8.5 8.8 14.3c0 2.4-.5 4.8-1.7 7.1c-4 7.9-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8c-4.8-6-9.6-12-14.4-18z',
      'M439.2 193.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4zM65.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3c-7.9 4-17.5 .7-21.5-7.2zm59.1 55.2c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm192 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2z',
    ],
  ],
};
const faUserMusic = {
  prefix: 'fad',
  iconName: 'user-music',
  icon: [
    640,
    512,
    [],
    'f8eb',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c36.3 0 70.1 10.9 98.3 29.5l0 51.6c-18 2.5-34.8 9.1-48.5 19.4c-17.6 13.2-31.5 34-31.5 59.5c0 19.1 7.7 35.4 18.9 48L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M640 184c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64c-9.8 3.3-16.4 12.4-16.4 22.8l0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48z',
    ],
  ],
};
const faArrowRotateRight = {
  prefix: 'fad',
  iconName: 'arrow-rotate-right',
  icon: [
    512,
    512,
    [8635, 'arrow-right-rotate', 'arrow-rotate-forward', 'redo'],
    'f01e',
    [
      'M32 256c0 57.3 21.9 114.7 65.6 158.4S198.7 480 256 480s114.7-21.9 158.4-65.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160l45.7 0 0-44.8L414.4 97.6C370.6 53.9 313.3 32 256 32S141.3 53.9 97.6 97.6S32 198.7 32 256z',
      'M496 192c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128z',
    ],
  ],
};
const faArrowRightRotate = faArrowRotateRight;
const faArrowRotateForward = faArrowRotateRight;
const faRedo = faArrowRotateRight;
const faMessagesDollar = {
  prefix: 'fad',
  iconName: 'messages-dollar',
  icon: [
    640,
    512,
    ['comments-alt-dollar'],
    'f652',
    [
      'M0 64L0 256c0 35.3 28.7 64 64 64l32 0 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320 352 320c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm140.2 54.6c.1-1.3 .2-2.5 .4-3.7c.3-2.4 .9-4.8 1.5-7c1.3-4.5 3.2-8.5 5.6-12.2c4.7-7.3 11.2-13 18.2-17.1c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c0 .7 0 1.3 0 1.9s0 1.3-.1 1.9c-.1 1.3-.2 2.5-.3 3.7c-.3 2.4-.7 4.8-1.3 7c-1.2 4.5-3 8.6-5.2 12.4c-4.4 7.5-10.7 13.5-17.9 18c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c0-.7 0-1.3 0-2s.1-1.3 .1-1.9z',
      'M228 56l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20zm28 328l0-32 96 0c53 0 96-43 96-96l0-128 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448c-35.3 0-64-28.7-64-64z',
    ],
  ],
};
const faCommentsAltDollar = faMessagesDollar;
const faSensorOn = {
  prefix: 'fad',
  iconName: 'sensor-on',
  icon: [
    640,
    512,
    [],
    'e02b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144zm96 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144z',
      'M604 74.7c7.4 11 4.4 25.9-6.7 33.3l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7zM512 256c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zm4 122.7c7.4-11 22.3-14 33.3-6.7l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3z',
    ],
  ],
};
const faBalloon = {
  prefix: 'fad',
  iconName: 'balloon',
  icon: [
    384,
    512,
    [],
    'e2e3',
    [
      'M64 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.1 64 64 114.1 64 176z',
      'M0 192C0 86 86 0 192 0S384 86 384 192c0 102.6-102.8 194.9-143.6 227.5c-9.3 7.4-12.5 20.4-7.1 31l21.4 42.7c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-102.1 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l21.4-42.7c5.3-10.6 2.1-23.6-7.1-31C102.8 386.9 0 294.6 0 192zm96-16c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.1 64 64 114.1 64 176c0 8.8 7.2 16 16 16s16-7.2 16-16z',
    ],
  ],
};
const faWebAwesome = {
  prefix: 'fad',
  iconName: 'web-awesome',
  icon: [
    640,
    512,
    [],
    'e682',
    [
      'M46.4 192L159 442.3c10.3 23 33.2 37.7 58.4 37.7l205.2 0c25.2 0 48-14.8 58.4-37.7L593.6 192c-.5 0-1.1 0-1.6 0c-1 0-2.1 0-3.1-.1s-2-.2-3-.3c-2-.3-3.9-.6-5.8-1.1c-3.8-1-7.4-2.4-10.8-4.2c-6.8-3.6-12.6-8.9-16.9-15.2L448 192 342 99.2c-6.6 3.1-14 4.8-21.8 4.8c-1 0-2 0-2.9-.1s-1.9-.1-2.9-.2c-1.9-.2-3.8-.5-5.6-.9c-3.7-.8-7.2-2-10.6-3.6L192 192 87.6 171.1C79 183.7 64.4 192 48 192c-.5 0-1.1 0-1.6 0z',
      'M268.2 52a52 52 0 1 1 104 0 52 52 0 1 1 -104 0zM0 144a48 48 0 1 1 96 0A48 48 0 1 1 0 144zM592 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faBiohazard = {
  prefix: 'fad',
  iconName: 'biohazard',
  icon: [
    576,
    512,
    [9763],
    'f780',
    [
      'M80 267.9c21.3-4.2 43.4-3.3 64 4.1c0 55.4 31.3 103.5 77.2 127.6c-3.5 21.6-13.9 41.2-28.5 57.3C125.7 422.3 80 352.5 80 272c0-1.4 0-2.7 0-4.1zm11.2-63.5c7.2-21 17.7-40.5 30.9-57.9c1.3 8.2 3.2 16.2 5.6 23.9c1.2 3.9 2.6 7.7 4.1 11.4c.7 1.9 1.5 3.7 2.3 5.6s1.6 3.7 2.5 5.5c-15.4 1.7-30.6 5.4-45.4 11.4zM177.7 95.6C209.7 75.6 247.5 64 288 64s78.3 11.6 110.3 31.6c-6.3 20.8-17.7 39.7-34.3 54c-22-13.7-48.1-21.6-75.9-21.6s-53.9 7.9-75.9 21.6c-16.6-14.3-28-33.3-34.3-54zm79.4 382.1c6-4.5 11.5-9.4 16.7-14.6c2.6-2.6 5.1-5.3 7.4-8c1.2-1.4 2.3-2.7 3.5-4.1s2.2-2.8 3.3-4.2c8.7 11.5 19 21.9 30.9 31c-10.1 1.5-20.4 2.3-30.9 2.3s-20.8-.8-30.9-2.3zm97.7-78.1C400.7 375.5 432 327.4 432 272c20.6-7.3 42.7-8.3 64-4.1c0 1.3 0 2.7 0 4.1c0 80.5-45.7 150.3-112.7 184.9c-14.7-16.2-25.1-35.7-28.5-57.3zM439.4 193c7-14.4 11.9-30 14.6-46.4c13.1 17.4 23.6 36.8 30.8 57.9c-7.4-3-14.9-5.5-22.5-7.4c-3.8-1-7.6-1.8-11.4-2.4c-1.9-.3-3.8-.6-5.7-.9s-3.8-.5-5.8-.7z',
      'M168.4 2c1.3-1.3 3-2 4.8-2c5 0 8.4 5.2 6.7 9.9C154.3 80.5 190.4 176 288 176s133.7-95.5 108.1-166.1c-1.7-4.7 1.6-9.9 6.7-9.9c1.8 0 3.5 .7 4.8 2c30 30.3 48.4 72 48.4 118c0 26.2-6 50.9-16.6 73c22 2.4 43.8 9.1 64.2 20.5c34.5 19.3 59.1 48.9 72.1 82.5c.7 1.7 .5 3.7-.5 5.2c-2.2 3.7-7.4 4.3-10.6 1.3C511.8 254.3 418 245.1 371 324s8.1 153.1 77.6 173.2c4.2 1.2 6.3 5.9 4.1 9.6c-1 1.6-2.6 2.7-4.5 3c-36.5 5.9-75.2 .1-109.7-19.2c-20.4-11.4-37.4-26.5-50.5-43.8c-13.1 17.3-30.1 32.4-50.5 43.8c-34.5 19.3-73.3 25.2-109.7 19.2c-1.9-.3-3.5-1.4-4.5-3c-2.2-3.7-.1-8.4 4.1-9.6C196.9 477.1 252 403 205 324s-140.7-69.8-193.5-21.4c-3.2 2.9-8.4 2.3-10.6-1.3c-1-1.6-1.1-3.5-.5-5.2c12.9-33.6 37.5-63.2 72.1-82.5c20.4-11.4 42.2-18.1 64.2-20.5C126 170.9 120 146.2 120 120c0-46 18.5-87.7 48.4-118zM288 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faChessQueenPiece = {
  prefix: 'fad',
  iconName: 'chess-queen-piece',
  icon: [
    256,
    512,
    ['chess-queen-alt'],
    'f446',
    [
      'M0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416 4.8 473.6C1.7 477.8 0 482.8 0 488z',
      'M152 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM67.6 192.4C56.5 194.5 48 204.2 48 216c0 12.9 10.2 23.4 23 24L48 416l160 0L185 240c12.8-.5 23-11.1 23-24c0-11.8-8.5-21.5-19.6-23.6l41.5-67.5c3.7-6 3-13.6-1.6-18.9s-12.1-6.9-18.6-4.1c-3 1.3-6.3 2.1-9.8 2.1c-11.8 0-21.6-8.5-23.6-19.7c-1.1-6.3-6-11.4-12.3-12.8s-12.8 1.1-16.5 6.4C143.2 84 136.1 88 128 88s-15.2-4-19.6-10.1c-3.7-5.3-10.2-7.8-16.5-6.4S80.8 78 79.6 84.3C77.6 95.5 67.8 104 56 104c-3.5 0-6.8-.7-9.8-2.1c-6.4-2.9-13.9-1.2-18.6 4.1s-5.3 13-1.6 18.9l41.5 67.5z',
    ],
  ],
};
const faChessQueenAlt = faChessQueenPiece;
const faLocationCrosshairs = {
  prefix: 'fad',
  iconName: 'location-crosshairs',
  icon: [
    512,
    512,
    ['location'],
    'f601',
    [
      'M176 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M256 0c17.7 0 32 14.3 32 32l0 34.7C368.4 80.1 431.9 143.6 445.3 224l34.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-34.7 0C431.9 368.4 368.4 431.9 288 445.3l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7C143.6 431.9 80.1 368.4 66.7 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l34.7 0C80.1 143.6 143.6 80.1 224 66.7L224 32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0z',
    ],
  ],
};
const faLocation = faLocationCrosshairs;
const faMarsDouble = {
  prefix: 'fad',
  iconName: 'mars-double',
  icon: [
    640,
    512,
    [9891],
    'f227',
    [
      'M96 304a80 80 0 1 0 160 0A80 80 0 1 0 96 304zM304 468c19.8 7.8 41.4 12 64 12c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L504 32c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .3c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7l0 21.3c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1z',
      'M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L312 32zm88 48s0 0 0 0s0 0 0 0s0 0 0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zm320 0c0 28.3-5.7 55.4-15.9 80c44.2 0 79.9-35.8 79.9-80s-35.8-80-79.9-80c10.3 24.6 15.9 51.7 15.9 80z',
    ],
  ],
};
const faLeftFromBracket = {
  prefix: 'fad',
  iconName: 'left-from-bracket',
  icon: [
    512,
    512,
    [],
    'e66c',
    [
      'M320 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32z',
      'M11.3 283.3L134.1 406.1c6.4 6.4 15 9.9 24 9.9c18.7 0 33.9-15.2 33.9-33.9l0-62.1 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-62.1c0-18.7-15.2-33.9-33.9-33.9c-9 0-17.6 3.6-24 9.9L11.3 228.7C4.1 235.9 0 245.8 0 256s4.1 20.1 11.3 27.3z',
    ],
  ],
};
const faHousePersonLeave = {
  prefix: 'fad',
  iconName: 'house-person-leave',
  icon: [
    640,
    512,
    ['house-leave', 'house-person-depart'],
    'e00f',
    [
      'M0 232c0 3.9 .7 7.9 2.2 11.6C7 255.9 18.8 264 32 264l32 0 0 112c0 26.5 21.5 48 48 48l205.5 0 44-44 32.6-81.6c-14.1 6.3-30.5 7.5-46.3 2.3c-33.5-11.2-51.7-47.4-40.5-81l2.6-7.8c12.2-36.5 37-67.2 69.6-86.7L261.7 16.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192C3.6 214.7 0 223.2 0 232zm144-24c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z',
      'M480 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM446.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L601 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM388.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L388.7 398z',
    ],
  ],
};
const faHouseLeave = faHousePersonLeave;
const faHousePersonDepart = faHousePersonLeave;
const faRulerTriangle = {
  prefix: 'fad',
  iconName: 'ruler-triangle',
  icon: [
    512,
    512,
    [128208],
    'f61c',
    [
      'M0 32L0 448c0 35.3 28.7 64 64 64l416 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9c-17.6-17.6-35.1-35.1-52.7-52.7c-7.5 7.5-15.1 15.1-22.6 22.6c-3.1 3.1-7.2 4.7-11.3 4.7c-4.1 0-8.2-1.6-11.3-4.7c-6.2-6.4-6.2-16.4 0-22.6c7.5-7.5 15.1-15.1 22.6-22.6c-19.1-19.1-38.3-38.2-57.4-57.4c-7.5 7.5-15.1 15.1-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0c-6.2-6.4-6.2-16.4 0-22.6c7.5-7.5 15.1-15.1 22.6-22.6c-19.1-19.1-38.2-38.2-57.4-57.4c-7.5 7.5-15.1 15.1-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c7.5-7.5 15.1-15.1 22.6-22.6l-57.4-57.4c-7.5 7.5-15.1 15.1-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c7.5-7.5 15.1-15.1 22.6-22.6L129.9 84.7c-7.5 7.5-15.1 15.1-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0C81.6 104.2 80 100.1 80 96s1.6-8.2 4.7-11.3c7.5-7.5 15.1-15.1 22.6-22.6L54.6 9.4C45.5 .2 31.7-2.5 19.8 2.4S0 19.1 0 32zM128 256L256 384l-128 0 0-128z',
      'M107.3 62.1L84.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6L107.3 62.1zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6zm80 80l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6-22.6-22.6z',
    ],
  ],
};
const faCardClub = {
  prefix: 'fad',
  iconName: 'card-club',
  icon: [
    384,
    512,
    [],
    'e3e9',
    [
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8l0 32.8-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3C101.9 211.3 80 235.1 80 264z',
      'M253.9 208.3c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8l0 32.8-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7z',
    ],
  ],
};
const faChildDress = {
  prefix: 'fad',
  iconName: 'child-dress',
  icon: [
    320,
    512,
    [],
    'e59c',
    [
      'M96 64a64 64 0 1 0 128 0A64 64 0 1 0 96 64z',
      'M86.2 285.5L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.7-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1L232 400l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80-16 0 0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80-17.8 0c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4z',
    ],
  ],
};
const faUsersBetweenLines = {
  prefix: 'fad',
  iconName: 'users-between-lines',
  icon: [
    640,
    512,
    [],
    'e591',
    [
      'M32 320c0 17.7 14.3 32 32 32l85.6 0c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4l-96 0c-35.3 0-64 28.7-64 64zM83.2 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm94.4 224c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6c-6.9-1.6-14.2-2.4-21.6-2.4l-96 0c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32zm64-208a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm174.3 88.6c38.1 14.8 67.4 47.3 77.7 87.4l82.4 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-11.7 0-22.7 3.1-32.1 8.6zM435.2 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zm0 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464z',
    ],
  ],
};
const faLungsVirus = {
  prefix: 'fad',
  iconName: 'lungs-virus',
  icon: [
    640,
    512,
    [],
    'e067',
    [
      'M.2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2c20.9-5.2 38.7-17.1 51.5-32.9c-14 1.5-28.5-3-39.2-13.8c-18.7-18.7-18.7-49.1 0-67.9c1.5-1.5 1.9-3.4 1.1-5.5s-2.5-3.1-4.6-3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c2.2 0 3.8-1.1 4.6-3.1s.5-3.9-1.1-5.5c-18.7-18.7-18.7-49.1 0-67.9c16.4-16.4 41.8-18.5 60.5-6.1l0-24.1C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412zM288 32l0 124.2c8.5-7.6 19.7-12.2 32-12.2s23.5 4.6 32 12.2L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 133.3l0 24.1c18.6-12.4 44-10.3 60.5 6.1c18.7 18.7 18.7 49.1 0 67.9c-1.5 1.5-1.9 3.4-1.1 5.5s2.5 3.1 4.6 3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.2 0-3.8 1.1-4.6 3.1s-.5 3.9 1.1 5.5c18.7 18.7 18.7 49.1 0 67.9c-10.7 10.7-25.3 15.3-39.2 13.8c12.8 15.9 30.6 27.7 51.5 32.9l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3z',
      'M336 192c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C241.5 264.1 225 304 192 304c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C264.1 398.5 304 415 304 448c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C398.5 375.9 415 336 448 336c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C375.9 241.5 336 225 336 192zM272 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faSpinnerThird = {
  prefix: 'fad',
  iconName: 'spinner-third',
  icon: [
    512,
    512,
    [],
    'f3f4',
    [
      'M0 256C0 114.9 114.1 .5 255.1 0C237.9 .5 224 14.6 224 32c0 17.7 14.3 32 32 32C150 64 64 150 64 256s86 192 192 192c69.7 0 130.7-37.1 164.5-92.6c-3 6.6-3.3 14.8-1 22.2c1.2 3.7 3 7.2 5.4 10.3c1.2 1.5 2.6 3 4.1 4.3c.8 .7 1.6 1.3 2.4 1.9c.4 .3 .8 .6 1.3 .9s.9 .6 1.3 .8c5 2.9 10.6 4.3 16 4.3c11 0 21.8-5.7 27.7-16c-44.3 76.5-127 128-221.7 128C114.6 512 0 397.4 0 256z',
      'M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faFaceGrinTears = {
  prefix: 'fad',
  iconName: 'face-grin-tears',
  icon: [
    640,
    512,
    [128514, 'grin-tears'],
    'f588',
    [
      'M66.8 217.7c10.3-2 19.8-3.5 26.6-4.4c26.5-3.9 49.2 18.8 45.2 45.4c-1.6 11.3-4.6 30-9.3 48.2c-2.3 9.1-5.2 18.8-8.8 27.5c-3.3 8.1-8.4 18.5-16.5 26.6c-3.9 3.9-8.2 7.4-12.7 10.3C133.6 454.8 220.1 512 320 512s186.4-57.2 228.6-140.6c-4.5-2.9-8.7-6.3-12.7-10.3c-8.1-8.1-13.2-18.6-16.5-26.6c-3.6-8.8-6.5-18.4-8.8-27.5c-4.6-18.2-7.7-37-9.3-48.2c-3.9-26.5 18.8-49.2 45.2-45.4c6.8 .9 16.2 2.4 26.6 4.4C554.7 94.5 448.4 0 320 0S85.3 94.5 66.8 217.7zM169.2 331.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C446.4 390.6 388.2 432 320.3 432s-126.2-41.4-151.1-100.5zm15.1-114.2c.2-2.2 .5-4.4 .9-6.6c.8-4.4 1.9-8.7 3.4-12.8c2.9-8.3 7.1-16 12-22.7c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8c-1.6-.5-3-1.6-4-2.9c-.5-.7-.9-1.4-1.1-2.2c-.1-.4-.2-.8-.3-1.2s-.1-.8-.1-1.4c0-1 0-2.1 .1-3.2s.1-2.2 .2-3.3zM344 224c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.1-.1-.2-.3-.4-.5l-.4-.5c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M281.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm184.8 41.8c-14.1-14.1-62.8-22.6-84.4-25.5c-5.4-.8-9.9 3.7-9 9c3.1 21.5 11.4 70.2 25.5 84.4c18.4 18.4 48.5 18 67.2-.7s19.1-48.8 .7-67.2zM97.9 245c-21.6 3-70.2 11.4-84.4 25.5c-18.4 18.4-18 48.5 .7 67.2s48.8 19.1 67.2 .7c14.1-14.1 22.5-62.9 25.5-84.4c.8-5.4-3.7-9.9-9-9z',
    ],
  ],
};
const faGrinTears = faFaceGrinTears;
const faPhone = {
  prefix: 'fad',
  iconName: 'phone',
  icon: [
    512,
    512,
    [128222, 128379],
    'f095',
    [
      'M68.4 14.8c.3 2.3 .6 4.5 .9 6.7c.3 2.2 .6 4.5 1 6.7c.7 4.5 1.4 8.9 2.2 13.3c1.6 8.8 3.4 17.6 5.4 26.2c4.1 17.3 9 34.3 14.9 50.8c11.7 33.1 26.8 64.6 44.9 94c8.3-6.8 16.7-13.6 25-20.5C129.2 136.7 107.2 73.7 99.7 6.3L68.4 14.8zm231 359.6c58.9 36.2 125.9 60.4 197.8 69.1l8.5-31.2c-67.4-7.5-130.4-29.5-185.8-62.9l-20.5 25z',
      'M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z',
    ],
  ],
};
const faComputerMouseScrollwheel = {
  prefix: 'fad',
  iconName: 'computer-mouse-scrollwheel',
  icon: [
    384,
    512,
    ['mouse-alt'],
    'f8cd',
    [
      'M0 160L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-192C384 71.6 312.4 0 224 0L160 0C71.6 0 0 71.6 0 160zm160-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32z',
      'M192 96c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faMouseAlt = faComputerMouseScrollwheel;
const faCalendarXmark = {
  prefix: 'fad',
  iconName: 'calendar-xmark',
  icon: [
    448,
    512,
    ['calendar-times'],
    'f273',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm143 79c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l47-47 47 47c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z',
    ],
  ],
};
const faCalendarTimes = faCalendarXmark;
const faChildReaching = {
  prefix: 'fad',
  iconName: 'child-reaching',
  icon: [
    384,
    512,
    [],
    'e59d',
    [
      'M128 64a64 64 0 1 0 128 0A64 64 0 1 0 128 64z',
      'M155.7 170.2c11.7 3.8 24 5.8 36.6 5.8c39.9 0 77.1-20.2 98.8-53.6l18.1-27.9c9.6-14.8 29.5-19 44.3-9.4s19 29.5 9.4 44.3l-18.2 27.9c-18.2 28-43.5 50-72.7 64.2L272 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-258.6C83.6 207.4 58.9 186.1 40.9 159L21.4 129.8c-9.8-14.7-5.8-34.6 8.9-44.4s34.6-5.8 44.4 8.9l19.5 29.2c14.3 21.5 35.1 37.4 58.8 45.8c.9 .3 1.8 .6 2.7 .9z',
    ],
  ],
};
const faTableLayout = {
  prefix: 'fad',
  iconName: 'table-layout',
  icon: [
    512,
    512,
    [],
    'e290',
    [
      'M64 160l384 0 0 64-256 0 0 192-64 0 0-192-64 0 0-64z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 96l0 320L64 416 64 96l384 0z',
    ],
  ],
};
const faNarwhal = {
  prefix: 'fad',
  iconName: 'narwhal',
  icon: [
    640,
    512,
    [],
    'f6fe',
    [
      'M0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L64 253.1 64 352c0 88.4 71.6 160 160 160l240 0c97.2 0 176-78.8 176-176c0-51.4-22.3-97.7-57.8-129.9c-18.7-17-41-30-65.6-37.8c-16.9-5.4-34.9-8.3-53.6-8.3c-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4l0-81.3 29.9-20.9c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112zM520 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M639.3 20.7c2.4-7.8-1.4-16.1-8.9-19.4s-16.2-.4-20.2 6.6L516.7 168.3c24.6 7.8 46.9 20.9 65.6 37.8l57-185.4zM496 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faRampLoading = {
  prefix: 'fad',
  iconName: 'ramp-loading',
  icon: [
    448,
    512,
    [],
    'f4d4',
    [
      'M32 48C32 21.5 53.5 0 80 0L368 0c26.5 0 48 21.5 48 48l0 392.4-64-128L352 64 96 64l0 248.4-64 128L32 48z',
      'M128 320H320l84.4 168.8c5.3 10.6-2.4 23.2-14.3 23.2H57.9c-11.9 0-19.6-12.5-14.3-23.2L128 320z',
    ],
  ],
};
const faCalendarCirclePlus = {
  prefix: 'fad',
  iconName: 'calendar-circle-plus',
  icon: [
    576,
    512,
    [],
    'e470',
    [
      'M0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112zm0 80L0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faToothbrush = {
  prefix: 'fad',
  iconName: 'toothbrush',
  icon: [
    576,
    512,
    [129701],
    'f635',
    [
      'M32 280l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M64 224c-35.3 0-64-28.7-64-64s28.7-64 64-64l224 0c31.2 0 38.2-22.7 39.6-48c.5-8.8 7.6-16.1 16.4-15.2c52.4 5.3 104 36.7 104 95.2c0 53-43 96-96 96L64 224zM32 416l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faBorderInner = {
  prefix: 'fad',
  iconName: 'border-inner',
  icon: [
    448,
    512,
    [],
    'f84e',
    [
      'M0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 160zM0 352a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M192 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 0 160z',
    ],
  ],
};
const faPawClaws = {
  prefix: 'fad',
  iconName: 'paw-claws',
  icon: [
    512,
    512,
    [],
    'f702',
    [
      'M0 236.8L0 240c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1C91.1 214.7 77.9 203 64 196.8l0-44.2c0-7.7-9.9-11-14.5-4.7L12.2 199.2C4.3 210.1 0 223.3 0 236.8zM112 128c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8C226.3 100.2 210.3 81 192 71.2l0-50.5c0-7.3-9-10.8-13.9-5.4L138.9 58.4C121.6 77.4 112 102.3 112 128zm165.5-3.1c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1c0-25.7-9.6-50.6-26.9-69.6L333.9 15.3C329 9.9 320 13.4 320 20.7l0 50.5c-18.3 9.8-34.3 28.9-42.5 53.6zM411.6 230.6c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.8-13.5 11.6-27.8 11.6-41.1l0-.4 0-3.2c0-13.5-4.3-26.7-12.2-37.6l-37.3-51.3c-4.6-6.3-14.5-3-14.5 4.7l0 44.2c-13.9 6.1-27.1 17.8-36.4 33.7z',
      'M69.2 433.2C121.6 291.9 214.7 256 256 256s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 512 64 491.1 64 465.3v-1.6c0-10.4 1.6-20.8 5.2-30.5z',
    ],
  ],
};
const faKiwiFruit = {
  prefix: 'fad',
  iconName: 'kiwi-fruit',
  icon: [
    448,
    512,
    [],
    'e30c',
    [
      'M0 176C0 96.5 100.3 32 224 32s224 64.5 224 144s-100.3 144-224 144S0 255.5 0 176zm64 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm52.7-83.3c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16c-6.2-6.2-16.4-6.2-22.6 0zm0 144c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16zM168 176c0 13.3 25.1 24 56 24s56-10.7 56-24s-25.1-24-56-24s-56 10.7-56 24zm40-96l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16zm0 168l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16zm84.7-139.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16zm0 112c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16c-6.2-6.2-16.4-6.2-22.6 0zM320 176c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M224 64c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM116.7 92.7c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16c-6.2-6.2-16.4-6.2-22.6 0zm192 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-153.4 128c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm137.4 0c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16c-6.2-6.2-16.4-6.2-22.6 0zM224 480c123.7 0 224-100.3 224-224l0-80c0 79.5-100.3 144-224 144S0 255.5 0 176l0 80C0 379.7 100.3 480 224 480z',
    ],
  ],
};
const faTrafficLightSlow = {
  prefix: 'fad',
  iconName: 'traffic-light-slow',
  icon: [
    320,
    512,
    [],
    'f639',
    [
      'M112 240a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z',
    ],
  ],
};
const faRectangleCode = {
  prefix: 'fad',
  iconName: 'rectangle-code',
  icon: [
    512,
    512,
    [],
    'e322',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 256c0 6.8 2.9 13.3 7.9 17.8c26.7 24 53.3 48 80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9c-20.1-18.1-40.1-36.1-60.2-54.2c20.1-18.1 40.1-36.1 60.2-54.2c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8c-26.7 24-53.3 48-80 72c-5.1 4.6-7.9 11-7.9 17.8zm198.2-88.1c-8.9 9.9-8.1 25 1.8 33.9c20.1 18.1 40.1 36.1 60.2 54.2c-20.1 18.1-40.1 36.1-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8c26.7-24 53.3-48 80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8c-26.7-24-53.3-48-80-72c-9.9-8.9-25-8.1-33.9 1.8z',
      'M216.1 201.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L155.9 256l60.2-54.2zm79.9 0L356.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9z',
    ],
  ],
};
const faHeadSideVirus = {
  prefix: 'fad',
  iconName: 'head-side-virus',
  icon: [
    512,
    512,
    [],
    'e064',
    [
      'M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM80 208c0 8.8 7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16z',
      'M240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80zM176 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faKeyboardBrightness = {
  prefix: 'fad',
  iconName: 'keyboard-brightness',
  icon: [
    640,
    512,
    [],
    'e1c0',
    [
      'M0 384c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM89.4 153.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM288 96l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM441.4 217.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64zM512 384c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
      'M192 384c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faBooksMedical = {
  prefix: 'fad',
  iconName: 'books-medical',
  icon: [
    576,
    512,
    [],
    'f7e8',
    [
      'M64 32C64 14.3 78.3 0 96 0l64 0c17.7 0 32 14.3 32 32l0 64c-42.7 0-85.3 0-128 0l0-64zm0 384l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM224 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c-42.7 0-85.3 0-128 0l0-64zm0 96c42.7 0 85.3 0 128 0l0 256-128 0 0-256zm0 288l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM353.4 117.9c40.9-11 81.8-21.9 122.8-32.9c2.7 10.3 5.5 20.6 8.2 30.9c-40.9 11-81.8 21.9-122.8 32.9c-2.7-10.3-5.5-20.6-8.2-30.9zm74.2 278.3c40.9-11 81.8-21.9 122.8-32.9l8.2 30.9L435.8 427c-2.7-10.3-5.5-20.6-8.2-30.9z',
      'M353.4 117.9l-1.4-5.2 0 15.4-128 0 0-32 128 0 0-75.3c2.3-1.3 4.8-2.4 7.5-3.1L420.9 1.1c16.9-4.6 34.4 5.5 38.9 22.6L476.2 85 353.4 117.9zm8.2 30.9l122.8-32.9 66 247.4L427.6 396.1l-66-247.4zM435.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L435.8 427zM192 96l0 32L64 128l0-32 128 0zM64 416l0-32 128 0 0 32L64 416zm160-32l128 0 0 32-128 0 0-32zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faLightbulbSlash = {
  prefix: 'fad',
  iconName: 'lightbulb-slash',
  icon: [
    640,
    512,
    [],
    'f673',
    [
      'M152.4 229.8c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l108.1 0L152.4 229.8zm8.5-129c17.5 13.7 35 27.4 52.4 41.1C227.7 96.7 270 64 320 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-40 0-73.1 29.3-79 67.6c65 50.9 129.9 101.8 194.9 152.8c4.4-6.2 8.9-12.4 13.4-18.6c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8zM240 416l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-7.1L388.7 416 240 416z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faHouseBlank = {
  prefix: 'fad',
  iconName: 'house-blank',
  icon: [
    576,
    512,
    ['home-blank'],
    'e487',
    [
      'M64 270.5c74.7-65.3 149.3-130.6 224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1l-320.4 0c-35.3 0-64-28.6-64-64L64 270.5z',
      'M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z',
    ],
  ],
};
const faHomeBlank = faHouseBlank;
const faSquare5 = {
  prefix: 'fad',
  iconName: 'square-5',
  icon: [
    448,
    512,
    [],
    'e25a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM132.1 341.4c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c8.6 0 16.5-3.5 22.1-9.2c2.8-2.8 5.1-6.2 6.7-9.9c.8-1.9 1.4-3.8 1.8-5.9c.2-1 .4-2.1 .5-3.1c.1-.5 .1-1.1 .1-1.6s0-1 0-1.8c0-.6 0-1 0-1.4c0-.5-.1-1-.1-1.5c-.1-1-.2-1.9-.4-2.9c-.4-1.9-.9-3.7-1.6-5.5c-1.4-3.5-3.4-6.7-5.8-9.5c-5-5.6-11.9-9.3-19.8-10.2c-29-3.3-57.9-6.5-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6c5.3-29.3 10.7-58.7 16-88c2.1-11.4 12-19.7 23.6-19.7l104 0c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.6c0 .7 0 1.5-.1 2.3s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7l-84 0c-2.6 14.3-5.2 28.7-7.8 43c20.5 2.3 40.9 4.6 61.4 6.9c20 2.3 37.6 11.9 50.2 26c6.3 7 11.3 15.2 14.8 24.1c1.7 4.5 3.1 9.1 4 13.9c.5 2.4 .8 4.8 1 7.3c.1 1.2 .2 2.5 .3 3.7c.1 1.2 .1 2.4 .1 3.8c0 1.4 0 2.8-.1 4.1c-.1 1.3-.2 2.7-.3 4c-.3 2.7-.7 5.3-1.2 7.9c-1.1 5.2-2.6 10.1-4.6 14.9c-4 9.5-9.8 18-17 25.2c-14.3 14.3-34.2 23.2-56.1 23.2l-36 0c-27.5 0-53.3-13.7-68.6-36.6c-1.4-2-2.7-4-4.1-6.1z',
      'M152.4 147.7c2.1-11.4 12-19.7 23.6-19.7l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88z',
    ],
  ],
};
const faSquareHeart = {
  prefix: 'fad',
  iconName: 'square-heart',
  icon: [
    448,
    512,
    [128159, 'heart-square'],
    'f4c8',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM77.8 226.9c0-19.5 7.3-39.1 22-54s33.9-22.4 53.2-22.4s38.5 7.5 53.2 22.4c5.9 6 11.8 12 17.7 18c5.9-6 11.8-12 17.7-18c14.7-14.9 33.9-22.4 53.2-22.4s38.5 7.5 53.2 22.4s22 34.5 22 54s-7.3 39.1-22 54L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 280.9c-14.7-14.9-22-34.5-22-54z',
      'M99.9 172.9c-29.4 29.8-29.4 78.2 0 108L201.5 384.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L348.1 280.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0z',
    ],
  ],
};
const faHeartSquare = faSquareHeart;
const faPuzzle = {
  prefix: 'fad',
  iconName: 'puzzle',
  icon: [
    512,
    512,
    [],
    'e443',
    [
      'M0 288L0 448c0 35.3 28.7 64 64 64l160 0 0-64c0-8.8-7.2-16-16-16l-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0c8.8 0 16-7.2 16-16l0-64-64 0c-8.8 0-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16c0 8.8-7.2 16-16 16L0 288zM304 16l0 48c0 8.8 7.2 16 16 16l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l36 0c6.6 0 12 5.4 12 12l0 4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-4c0-6.6 5.4-12 12-12l52 0c8.8 0 16-7.2 16-16l0-128c0-35.3-28.7-64-64-64L320 0c-8.8 0-16 7.2-16 16z',
      'M0 288l64 0c8.8 0 16-7.2 16-16l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16c0 8.8 7.2 16 16 16l64 0 0-68c0-6.6 5.4-12 12-12l4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-4 0c-6.6 0-12-5.4-12-12l0-52c0-8.8-7.2-16-16-16L64 64C28.7 64 0 92.7 0 128L0 288zm224 0l0 64c0 8.8-7.2 16-16 16l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0c8.8 0 16 7.2 16 16l0 64 160 0c35.3 0 64-28.7 64-64l0-144c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16c0-8.8-7.2-16-16-16l-64 0z',
    ],
  ],
};
const faUserGear = {
  prefix: 'fad',
  iconName: 'user-gear',
  icon: [
    640,
    512,
    ['user-cog'],
    'f4fe',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M447.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8l0 17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7l0-17.7c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faUserCog = faUserGear;
const faPipeCircleCheck = {
  prefix: 'fad',
  iconName: 'pipe-circle-check',
  icon: [
    640,
    512,
    [],
    'e436',
    [
      'M0 128L0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32S0 110.3 0 128zm96 0l0 256 224.7 0c-.5-5.3-.7-10.6-.7-16c0-68.4 39-127.7 96-156.8l0-83.2L96 128zm352 0l0 70.6c15.3-4.3 31.4-6.6 48-6.6c5.4 0 10.7 .2 16 .7l0-64.7c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faArrowUp19 = {
  prefix: 'fad',
  iconName: 'arrow-up-1-9',
  icon: [
    576,
    512,
    ['sort-numeric-up'],
    'f163',
    [
      'M344 336c0 39.2 25.6 72.4 61.1 83.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88zm8-144c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32zM464 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortNumericUp = faArrowUp19;
const faOctagonExclamation = {
  prefix: 'fad',
  iconName: 'octagon-exclamation',
  icon: [
    512,
    512,
    [],
    'e204',
    [
      'M.1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5zM224 352c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1.1 0 1.8c0 .5 0 1 0 1.6s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm8-200c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 1.2 .4 2.4 .4 2.4c.1 1.2 .1 1.2 .1 2.5c0 37.3 0 74.7 0 112.2c0 .7 0 1.5-.1 2.3s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-37.3 0-74.7 0-112z',
      'M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faDialLow = {
  prefix: 'fad',
  iconName: 'dial-low',
  icon: [
    576,
    512,
    [],
    'e15d',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M129.4 311.6c11.6 77 78 136 158.2 136c88.4 0 160-71.6 160-160s-71.6-160-160-160c-80.2 0-146.6 59-158.2 136l158.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-158.2 0z',
    ],
  ],
};
const faDoorClosed = {
  prefix: 'fad',
  iconName: 'door-closed',
  icon: [
    576,
    512,
    [128682],
    'f52a',
    [
      'M96 64l0 384 0 64 384 0 0-64 0-384c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64zM416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M384 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 480c0-17.7 14.3-32 32-32l64 0 0 64-64 0c-17.7 0-32-14.3-32-32zm576 0c0 17.7-14.3 32-32 32l-64 0 0-64 64 0c17.7 0 32 14.3 32 32z',
    ],
  ],
};
const faLaptopMobile = {
  prefix: 'fad',
  iconName: 'laptop-mobile',
  icon: [
    640,
    512,
    ['phone-laptop'],
    'f87a',
    [
      'M0 307.2C0 349.6 34.4 384 76.8 384L352 384l0-96-224 0 0-224 320 0 0 32 64 0 0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 224-44.8 0C8.6 288 0 296.6 0 307.2zM448 192l0 256 128 0 0-256-128 0z',
      'M448 192l128 0 0 256-128 0 0-256zm-16-64c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-160 0z',
    ],
  ],
};
const faPhoneLaptop = faLaptopMobile;
const faConveyorBeltBoxes = {
  prefix: 'fad',
  iconName: 'conveyor-belt-boxes',
  icon: [
    640,
    512,
    ['conveyor-belt-alt'],
    'f46f',
    [
      'M0 416c0 53 43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320c-53 0-96 43-96 96zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M96 0C78.3 0 64 14.3 64 32l0 192c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L96 0zM416 64c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L416 64z',
    ],
  ],
};
const faConveyorBeltAlt = faConveyorBeltBoxes;
const faShieldVirus = {
  prefix: 'fad',
  iconName: 'shield-virus',
  icon: [
    512,
    512,
    [],
    'e06c',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM112 256c0-8.8 7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c11.7 11.7 27.5 13.4 40.3 8c6.4-2.7 12.2-7.1 16.3-12.9c2-2.9 3.7-6.2 4.8-9.7c.6-1.8 1-3.6 1.3-5.6c.1-1 .3-1.9 .3-2.9c.1-.9 .1-1.7 .1-2.6l0-.4c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.6c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c4.4 0 8.4 1.8 11.3 4.7c1.4 1.5 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.3l0 .4 0 .4c0 .3 0 .8-.1 1.3c-.1 .5-.1 1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384.3c0 .3 0 .9-.1 1.4c-.1 .5-.1 1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16l0-.4c0-.9 0-1.8-.1-2.7c-.1-1-.2-2-.3-2.9c-.3-1.9-.7-3.8-1.3-5.6c-1.1-3.6-2.8-6.8-4.8-9.7c-4.1-5.8-9.8-10.2-16.3-12.9c-12.9-5.3-28.7-3.6-40.3 8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16z',
      'M272 128c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 200.1 161 240 128 240c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 334.5 240 351 240 384c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C334.5 311.9 351 272 384 272c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 177.5 272 161 272 128zM208 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fad',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [
    640,
    512,
    ['starfighter-alt-advanced'],
    'e28e',
    [
      'M64 217.6l0 76.8 107.6 21.5C164.1 297.4 160 277.2 160 256c0-1.3 0-2.6 0-4s.1-2.6 .1-3.9c.1-2.6 .3-5.2 .6-7.8c.5-5.2 1.3-10.3 2.2-15.3c2-10 4.9-19.7 8.6-29L64 217.6zm404.4-21.5c7.5 18.5 11.6 38.7 11.6 59.9c0 1.3 0 2.6 0 4s-.1 2.6-.1 3.9c-.1 2.6-.3 5.2-.6 7.8c-.5 5.2-1.3 10.3-2.2 15.3c-2 10-4.9 19.7-8.6 29L576 294.4l0-76.8L468.4 196.1z',
      'M148.8 7.7c-13.4-11.5-33.6-9.9-45.1 3.5l-88.3 103C5.5 125.8 0 140.6 0 155.8L0 356.2c0 15.3 5.5 30.1 15.4 41.7l88.3 103c11.5 13.4 31.7 15 45.1 3.5s15-31.7 3.5-45.1L64 356.2l0-200.3 88.3-103c11.5-13.4 9.9-33.6-3.5-45.1zM414.7 272c-2.4 14.6-8.2 28.1-16.4 39.6l-23.1-23.1c3-5.1 5.3-10.6 6.8-16.5l32.7 0zm-39 62.3c-11.6 8.2-25 14-39.6 16.4l0-32.7c5.9-1.5 11.4-3.8 16.5-6.8l23.1 23.1zM304 350.7c-14.6-2.4-28.1-8.2-39.6-16.4l23.1-23.1c5.1 3 10.6 5.3 16.5 6.8l0 32.7zm-62.3-39c-8.2-11.6-14-25-16.4-39.6l32.7 0c1.5 5.9 3.8 11.4 6.8 16.5l-23.1 23.1zM414.7 240L382 240c-1.5-5.9-3.8-11.4-6.8-16.5l23.1-23.1c8.2 11.6 14 25 16.4 39.6zm-39-62.3l-23.1 23.1c-5.1-3-10.6-5.3-16.5-6.8l0-32.7c14.6 2.4 28.1 8.2 39.6 16.4zM304 194c-5.9 1.5-11.4 3.8-16.5 6.8l-23.1-23.1c11.6-8.2 25-14 39.6-16.4l0 32.7zm-39.1 29.5c-3 5.1-5.3 10.6-6.8 16.5l-32.7 0c2.4-14.6 8.2-28.1 16.4-39.6l23.1 23.1zM320 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm22.8-137.5l-.3 .3c-5.8 5.7-13.7 9.2-22.5 9.2c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32c0 8.8-3.5 16.7-9.2 22.5zM488.5 53.7L576 148.5l0 200.3L487 460c-11 13.8-8.8 33.9 5 45s33.9 8.8 45-5l89-111.2c9.1-11.3 14-25.4 14-40l0-200.3c0-16.1-6.1-31.6-17-43.4L535.5 10.3c-12-13-32.2-13.8-45.2-1.8s-13.8 32.2-1.8 45.2z',
    ],
  ],
};
const faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
const faDiceSix = {
  prefix: 'fad',
  iconName: 'dice-six',
  icon: [
    448,
    512,
    [9861],
    'f526',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faStarfighterTwinIonEngine = {
  prefix: 'fad',
  iconName: 'starfighter-twin-ion-engine',
  icon: [
    576,
    512,
    ['starfighter-alt'],
    'e038',
    [
      'M64 211.2l0 89.6 75.6 15.1C132.1 297.4 128 277.2 128 256c0-1.3 0-2.6 0-4s.1-2.6 .1-3.9c.1-2.6 .3-5.2 .6-7.8c.5-5.2 1.3-10.3 2.2-15.3c2-10 4.9-19.7 8.6-29L64 211.2zm372.4-15.1c7.5 18.5 11.6 38.7 11.6 59.9c0 1.3 0 2.6 0 4s-.1 2.6-.1 3.9c-.1 2.6-.3 5.2-.6 7.8c-.5 5.2-1.3 10.3-2.2 15.3c-2 10-4.9 19.7-8.6 29L512 300.8l0-89.6-75.6-15.1z',
      'M32 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zm512 0c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM272 350.7l0-32.7c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5l-32.7 0c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240l32.7 0c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8l0-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zM343.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8l0 32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6L350 272c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240l32.7 0c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4l0 32.7c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM128 256a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zm182.8 22.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z',
    ],
  ],
};
const faStarfighterAlt = faStarfighterTwinIonEngine;
const faRocketLaunch = {
  prefix: 'fad',
  iconName: 'rocket-launch',
  icon: [
    512,
    512,
    [128640],
    'e027',
    [
      'M.1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7zm3-207.9C7.3 283.3 15.3 288 24 288l94.5 0c19.5-43.5 51.6-112.1 80.1-158l-80.8 0c-25.2 0-48.5 13.1-61.5 34.6L3.5 251.5c-4.5 7.4-4.7 16.7-.4 24.2zM64.6 433.5c.7-12.8 3.7-31.2 13.7-41.3c11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4c-10.1 10.1-28.5 13-41.3 13.7c-8 .5-14.3-5.9-13.9-13.9zm159.1-41.6c.2 32 .2 64 .2 96.1c0 8.7 4.7 16.7 12.2 20.9c3.7 2.1 7.7 3.1 11.8 3.1c4.3 0 8.6-1.2 12.5-3.5l86.9-52.8c21.5-13.1 34.6-36.4 34.6-61.5l0-80.8c-45.6 28.2-114 59.4-158.2 78.5z',
      'M223.7 391.9c-4-56-49.1-100.6-105.3-103.8c21.4-47.9 58.4-126.6 88.8-171.5C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-44.7 30.3-123.1 66.2-171.6 87.2zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z',
    ],
  ],
};
const faMosquitoNet = {
  prefix: 'fad',
  iconName: 'mosquito-net',
  icon: [
    640,
    512,
    [],
    'e52c',
    [
      'M0 286.3c0 72.6 87.8 109 139.2 57.6L256 242.2l0 23.1-59.3 59.3c-3 3-4.7 7.1-4.7 11.3l0 44.2-30.3 60.6c-4 7.9-.7 17.5 7.2 21.5c2.3 1.1 4.7 1.7 7.1 1.7c5.9 0 11.5-3.2 14.3-8.8l32-64c1.1-2.2 1.7-4.7 1.7-7.2l0-41.4 32-32 0 50c0 17.7 14.3 32 32 32s32-14.3 32-32l0-50 42.9 42.9c3-3.7 6.6-6.9 10.6-9.5c-12.9-8.6-21.5-23.3-21.5-40c0-2.1 .1-4.2 .4-6.2L320 265.4l0-23.1 40.2 35c6.1-9.1 15.2-15.9 25.9-19.2c6-19.7 24.3-34.1 45.9-34.1c16.7 0 31.4 8.5 40 21.5c8.6-12.9 23.3-21.5 40-21.5s31.4 8.5 40 21.5c2.1-3.1 4.5-6 7.3-8.6c-12.9-16.9-32.2-28.6-54.7-31.4L344.7 181.6l49.6-41.3c5.1-4.2 7-11.1 4.9-17.4L385.3 81.2l29-58.1c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-32 64c-1.9 3.8-2.2 8.2-.9 12.2l12.5 37.6L320 160.5l0-22.6c0-14.9-10.1-27.3-23.8-31l0-43.3c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2l0 43.3c-13.7 3.6-23.8 16.1-23.8 31l0 22.6-45.4-37.8 12.5-37.6c1.3-4 1-8.4-.9-12.2l-32-64c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l29 58.1-13.9 41.7c-2.1 6.2-.1 13.1 4.9 17.4l49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3z',
      'M528 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-48 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 48-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 48-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-48 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-48 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-48 0 0-16zm48 48l0 48-48 0 0-48 48 0zm0 80l0 48-48 0 0-48 48 0zM448 368l0-48 48 0 0 48-48 0zm0 80l0-48 48 0 0 48-48 0z',
    ],
  ],
};
const faFileFragment = {
  prefix: 'fad',
  iconName: 'file-fragment',
  icon: [
    384,
    512,
    [],
    'e697',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-128 0 0-128c0-35.3-28.7-64-64-64L0 320 0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM32 352c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0z',
    ],
  ],
};
const faVentDamper = {
  prefix: 'fad',
  iconName: 'vent-damper',
  icon: [
    640,
    512,
    [],
    'e465',
    [
      'M0 192L0 320c0 17.7 14.3 32 32 32l32 0 0-192-32 0c-17.7 0-32 14.3-32 32zm576-32l0 192 32 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-32 0z',
      'M128 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L128 64zm56 80l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 88l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 88l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faBridgeWater = {
  prefix: 'fad',
  iconName: 'bridge-water',
  icon: [
    576,
    512,
    [],
    'e4ce',
    [
      'M.8 455.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-5.9-5-13.3-7.6-20.7-7.6c-6.5 0-12.9 2-18.5 5.9C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1C109 386 102.5 384 96 384c-7.4 0-14.8 2.6-20.7 7.6c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4z',
      'M32 64C14.3 64 0 78.3 0 96l0 35.6C0 147.3 12.7 160 28.4 160C65.8 160 96 190.2 96 227.6l0 124.9c12.9 0 25.8 3.9 36.9 11.7c18 12.4 40.1 20.3 59.1 20.3c0-.2 0-.3 0-.5l0-128c0-53 43-96 96-96s96 43 96 96l0 128c0 .2 0 .3 0 .5c0 0 0 0 0 0c19 0 41.2-7.9 59.2-20.3c11.1-7.8 24-11.7 36.8-11.7l0-124.9c0-37.3 30.2-67.6 67.6-67.6c15.7 0 28.4-12.7 28.4-28.4L576 96c0-17.7-14.3-32-32-32L32 64z',
    ],
  ],
};
const faBanBug = {
  prefix: 'fad',
  iconName: 'ban-bug',
  icon: [
    512,
    512,
    ['debug'],
    'f7f9',
    [
      'M128.3 291.1c1.7 8.7 10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c18.7 0 35.9-6.4 49.6-17.2c-43.2-43.2-86.3-86.3-129.5-129.5c0 .9 0 1.8 0 2.7l0 41.3-35.1 7c-8.7 1.7-14.3 10.2-12.6 18.8zm78.1-129.9L345 299.7l19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7 0-18.6 35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22c-3-5-8.3-7.8-13.7-7.8c-2.8 0-5.6 .7-8.2 2.3L307.8 163c-14-11.9-32.1-19-51.8-19c-18.7 0-35.9 6.4-49.6 17.2z',
      'M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
    ],
  ],
};
const faDebug = faBanBug;
const faPersonBooth = {
  prefix: 'fad',
  iconName: 'person-booth',
  icon: [
    576,
    512,
    [],
    'f756',
    [
      'M192 32l0 160 64 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 288l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160-64 0zM288.3 36.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5zM512 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M64 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm48 237.3l0 72.1 38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8l0 58.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-53.3L64 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 278.3l0-.9 0-55.7c0-34 27.6-61.6 61.6-61.6c20.3 0 39.7 8.1 54 22.4L157.3 224l66.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-73.4 0c-12.7 0-24.9-5.1-33.9-14.1l-4.7-4.7z',
    ],
  ],
};
const faTextWidth = {
  prefix: 'fad',
  iconName: 'text-width',
  icon: [
    448,
    512,
    [],
    'f035',
    [
      'M0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 128 0 0 128-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128 128 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L224 32 48 32C21.5 32 0 53.5 0 80z',
      'M9.4 406.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 192 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-192 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64z',
    ],
  ],
};
const faGarageCar = {
  prefix: 'fad',
  iconName: 'garage-car',
  icon: [
    640,
    512,
    [],
    'e00a',
    [
      'M160 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 192 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-21.1-11.7-39.5-28.9-49L431 277.5C423.2 255.1 402 240 378.2 240l-116.3 0c-23.8 0-45 15.1-52.9 37.5L188.9 335c-17.2 9.5-28.9 27.9-28.9 49zm104 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-21.8-72l12.1-34.6c1.1-3.2 4.2-5.4 7.6-5.4l116.3 0c3.4 0 6.4 2.2 7.6 5.4L397.8 328l-155.6 0zM424 400a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z',
    ],
  ],
};
const faSquareKanban = {
  prefix: 'fad',
  iconName: 'square-kanban',
  icon: [
    448,
    512,
    [],
    'e488',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192z',
      'M288 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192zM96 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128zm128-32c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32z',
    ],
  ],
};
const faHatWizard = {
  prefix: 'fad',
  iconName: 'hat-wizard',
  icon: [
    512,
    512,
    [],
    'f6e8',
    [
      'M0 480c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0L48 448l-16 0c-17.7 0-32 14.3-32 32zM232 176c0 3.4 2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6z',
      'M168.5 180.1L48 448l416 0L355.5 207.7c-2.3-5.1-3.5-10.6-3.5-16.1c0-5 1-9.9 2.8-14.6L414.6 27.6c1-2.4 1.4-4.9 1.4-7.5l0-1.6C416 8.3 407.7 0 397.4 0c-3.5 0-7 1-10 2.9L240.1 97.2c-31.4 20.1-56.3 48.9-71.6 82.9zm70.6 86.8l13.5 40.4 40.4 13.5c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-40.4 13.5-13.5 40.4C237 411.6 230.9 416 224 416s-13-4.4-15.2-10.9l-13.5-40.4-40.4-13.5C148.4 349 144 342.9 144 336s4.4-13 10.9-15.2l40.4-13.5 13.5-40.4c2.2-6.5 8.3-10.9 15.2-10.9s13 4.4 15.2 10.9zM272 136c3.4 0 6.5 2.2 7.6 5.5l6.7 20.2 20.2 6.7c3.3 1.1 5.5 4.1 5.5 7.6s-2.2 6.5-5.5 7.6l-20.2 6.7-6.7 20.2c-1.1 3.3-4.1 5.5-7.6 5.5s-6.5-2.2-7.6-5.5l-6.7-20.2-20.2-6.7c-3.3-1.1-5.5-4.1-5.5-7.6s2.2-6.5 5.5-7.6l20.2-6.7 6.7-20.2c1.1-3.3 4.1-5.5 7.6-5.5z',
    ],
  ],
};
const faChartKanban = {
  prefix: 'fad',
  iconName: 'chart-kanban',
  icon: [
    448,
    512,
    [],
    'e64f',
    [
      'M160 80l0 160c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48z',
      'M368 480c-26.5 0-48-21.5-48-48l0-352c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0zM48 416c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l32 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-32 0z',
    ],
  ],
};
const faPenFancy = {
  prefix: 'fad',
  iconName: 'pen-fancy',
  icon: [
    512,
    512,
    [128395, 10002],
    'f5ac',
    [
      'M1.7 487.7l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1L24.3 510.3 211.2 458c11.3-3.2 19.9-12.2 22.6-23.6l21.9-94.7c.1-.6 .3-1.1 .4-1.7c-27.3-27.3-54.6-54.6-81.9-81.9c-.6 .1-1.1 .3-1.7 .4L77.7 278.3c-11.4 2.6-20.5 11.3-23.6 22.6L1.7 487.7z',
      'M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L256 337.9s0 0 0 0s0 0 0 0L174.1 256 373.5 27.1z',
    ],
  ],
};
const faCoffeePot = {
  prefix: 'fad',
  iconName: 'coffee-pot',
  icon: [
    512,
    512,
    [],
    'e002',
    [
      'M64 328l0 16c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8L418 480c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344l0-16c0-67.2-39.4-125.1-96.4-152l-255.3 0C103.4 202.9 64 260.8 64 328zm64.3-8c4.1-53.7 49-96 103.7-96l112 0c54.7 0 99.6 42.3 103.7 96c.2 2.6 .3 5.3 .3 8l0 16c0 27.4-16.8 53.7-33.5 72l-253.1 0c-16.7-18.3-33.5-44.6-33.5-72l0-16c0-2.7 .1-5.4 .3-8z',
      'M96 96c-17.7 0-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64C0 75 43 32 96 32l25.3 0L192 32l262.7 0c14 0 25.3 11.3 25.3 25.3c0 4.4-1.1 8.7-3.3 12.5L416 176l-256 0L114.3 96 96 96zM448 344c0 27.4-16.8 53.7-33.5 72l-253.1 0c-16.7-18.3-33.5-44.6-33.5-72l0-16c0-2.7 .1-5.4 .3-8l319.4 0c.2 2.6 .3 5.3 .3 8l0 16z',
    ],
  ],
};
const faMouseField = {
  prefix: 'fad',
  iconName: 'mouse-field',
  icon: [
    512,
    512,
    [],
    'e5a8',
    [
      'M272 88c0-22.1 17.9-40 40-40s40 17.9 40 40l0 24c0 8.8-7.2 16-16 16l-24 0c-22.1 0-40-17.9-40-40z',
      'M396.4 112.9C398.8 105 400 96.6 400 88c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.9 14.9 56.3 37.6 72.2C169.5 164.3 96 240.4 96 333.6c0 12.3 2.7 24 7.5 34.4L72 368c-39.8 0-72 32.2-72 72s32.2 72 72 72l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 464c-13.3 0-24-10.7-24-24s10.7-24 24-24l106.4 0 53.6 0 8 0 19 0 123.6 0c18.5 0 33.4-15 33.4-33.4c0-14.1-8.8-26.6-22-31.4l-43.7-15.9 23.8-63.5c2 .1 4 .2 6 .2l102.8 0c16.1 0 29.1-13 29.1-29.1c0-41.5-19.3-78.4-49.4-102.4C473.5 125.8 480 107.7 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 13.9-2.5 27.2-7.2 39.5c-9.1-3.2-18.6-5.5-28.4-6.6zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40l0 24c0 8.8-7.2 16-16 16l-24 0c-22.1 0-40-17.9-40-40s17.9-40 40-40z',
    ],
  ],
};
const faPersonDigging = {
  prefix: 'fad',
  iconName: 'person-digging',
  icon: [
    576,
    512,
    ['digging'],
    'f85e',
    [
      'M9.8 214.8C13.7 205.5 22.6 200 32 200c3.1 0 6.2 .6 9.2 1.9L60.7 210c82.7 34.5 165.4 68.9 248.1 103.4c26.4 11 52.9 22 79.3 33.1l34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c3 5.1 4.6 10.8 4.6 16.5c0 5.4-1.4 10.9-4.2 15.8c-5.7 10-16.3 16.2-27.8 16.2l-256 0c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7l32 0 22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4z',
      'M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM60.6 292.9l32 13.7 112 48c11.8 5 19.4 16.6 19.4 29.4l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-74.9-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33zm.1-82.9l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7L60.7 210z',
    ],
  ],
};
const faDigging = faPersonDigging;
const faShowerDown = {
  prefix: 'fad',
  iconName: 'shower-down',
  icon: [
    384,
    512,
    ['shower-alt'],
    'e24d',
    [
      'M32 350.8l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1L75.2 295.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4L34.7 337.7c-1.8 4.1-2.7 8.6-2.7 13.1zm64 128l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4L98.7 465.7c-1.8 4.1-2.7 8.6-2.7 13.1zm64-128l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1zm64 128l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1zm64-128l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1z',
      'M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 3.2C87 50 32 114.6 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-77.4-55-142-128-156.8l0-3.2z',
    ],
  ],
};
const faShowerAlt = faShowerDown;
const faBoxCircleCheck = {
  prefix: 'fad',
  iconName: 'box-circle-check',
  icon: [
    576,
    512,
    [],
    'e0c4',
    [
      'M0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160zm0 32L0 416c0 35.3 28.7 64 64 64l232.2 0C271.1 449.6 256 410.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192zM240 32l0 128 176 0 32 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faBrightness = {
  prefix: 'fad',
  iconName: 'brightness',
  icon: [
    512,
    512,
    [],
    'e0c9',
    [
      'M0 256c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zM73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32c-12.5-12.5-32.8-12.5-45.3 0zm0 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32zM224 32l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 400l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zM361.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32zm0 256c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32c-12.5-12.5-32.8-12.5-45.3 0zM400 256c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32z',
      'M160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z',
    ],
  ],
};
const faCarSideBolt = {
  prefix: 'fad',
  iconName: 'car-side-bolt',
  icon: [
    640,
    512,
    [],
    'e344',
    [
      'M64 432a80 80 0 1 0 160 0A80 80 0 1 0 64 432zM192.6 212.4c2 6.9 8.2 11.6 15.4 11.6l51.7 0-33.5 55.8c-3.8 6.3-2.8 14.5 2.5 19.6s13.4 6.1 19.7 2.2l128-80c6.1-3.8 8.9-11.1 6.9-18s-8.2-11.6-15.4-11.6l-51.7 0 33.5-55.8c3.8-6.3 2.8-14.5-2.5-19.6s-13.4-6.1-19.7-2.2l-128 80c-6.1 3.8-8.9 11.1-6.9 18zM416 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M528.2 225l-100-125c-18.2-22.8-45.8-36-75-36L171.3 64c-39.3 0-74.6 23.9-89.1 60.3L40.6 228.4C16.8 237.8 0 260.9 0 288L0 400c0 17.7 14.3 32 32 32c0-61.9 50.1-112 112-112s112 50.1 112 112l128 0c0-61.9 50.1-112 112-112s112 50.1 112 112c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127zm-181-108.4c5.3 5.2 6.3 13.3 2.5 19.6L316.3 192l51.7 0c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L259.7 224 208 224c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z',
    ],
  ],
};
const faFileXml = {
  prefix: 'fad',
  iconName: 'file-xml',
  icon: [
    512,
    512,
    [],
    'e654',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM192 368c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 13.6 4 26.9 11.6 38.2L188.8 432l-17.2 25.8C164 469.1 160 482.4 160 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-7.3 2.2-14.4 6.2-20.4l9.8-14.7 9.8 14.7c4 6.1 6.2 13.2 6.2 20.4c0 8.8 7.2 16 16 16s16-7.2 16-16c0-13.6-4-26.9-11.6-38.2L227.2 432l17.2-25.8C252 394.9 256 381.6 256 368c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 7.3-2.2 14.4-6.2 20.4L208 403.2l-9.8-14.7c-4-6.1-6.2-13.2-6.2-20.4zM448 496c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128zM299.7 352.6c-6.9 1.9-11.7 8.2-11.7 15.4l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-70.2 18.3 30.5c2.9 4.8 8.1 7.8 13.7 7.8s10.8-2.9 13.7-7.8L384 425.8l0 70.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-7.2-4.8-13.5-11.7-15.4s-14.3 1-18 7.2L352 416.9l-34.3-57.1c-3.7-6.2-11.1-9.1-18-7.2z',
    ],
  ],
};
const faOrnament = {
  prefix: 'fad',
  iconName: 'ornament',
  icon: [
    384,
    512,
    [],
    'f7b8',
    [
      'M0 320c0 22.4 3.8 44 10.9 64l362.2 0c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64L10.9 256C3.8 276 0 297.6 0 320zM128 64c0 11.7 3.1 22.6 8.6 32l45.9 0c-12.7-4.4-22-17-22.4-31c0-.3 0-.7 0-1c0-17.7 14.3-32 32-32s32 14.3 32 32c0 .3 0 .6 0 .8c-.4 14-9.7 26.8-22.4 31.2l45.9 0c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64s-64 28.7-64 64z',
      'M96 128c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 25.7c39.3 22.7 69.7 58.9 85.1 102.3L10.9 256C26.3 212.6 56.7 176.4 96 153.7L96 128zM10.9 384l362.1 0C346.7 458.6 275.6 512 192 512s-154.7-53.4-181.1-128z',
    ],
  ],
};
const faPhoneArrowDownLeft = {
  prefix: 'fad',
  iconName: 'phone-arrow-down-left',
  icon: [
    512,
    512,
    ['phone-arrow-down', 'phone-incoming'],
    'e223',
    [
      'M0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c1-3.5 1.4-7 1.4-10.5c0-15.8-9.4-30.6-24.6-36.9l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96C158.6 9.4 143.8 0 128 0c-3.5 0-7 .5-10.5 1.4l-88 24C12.1 30.2 0 46 0 64z',
      'M505 7c9.4 9.4 9.4 24.6 0 33.9l-135 135 46.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 46.1L471 7c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faPhoneArrowDown = faPhoneArrowDownLeft;
const faPhoneIncoming = faPhoneArrowDownLeft;
const faCloudWord = {
  prefix: 'fad',
  iconName: 'cloud-word',
  icon: [
    640,
    512,
    [],
    'e138',
    [
      'M0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336zm128-32c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zm96-64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
      'M128 304c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm112 48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0zm256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0zm-96-64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faHandFingersCrossed = {
  prefix: 'fad',
  iconName: 'hand-fingers-crossed',
  icon: [
    384,
    512,
    [],
    'e1a3',
    [
      'M0 336l0 27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l0-8.6c-9.4 5.4-20.3 8.6-32 8.6c-27.9 0-51.7-17.9-60.4-42.8C281.4 316 269.2 320 256 320c-11.7 0-22.6-3.1-32-8.6c0 .2 0 .4 0 .6c0 39.8-32.2 72-72 72l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-1.4 0c-11.8 0-23.5 0-35.3 0s-23.5 0-35.3 0c-5.3 0-10.7 0-16 0c-35.3 0-64 28.7-64 64zM35 45.5l40 85.8 35.3-75.7L93 18.5C87.6 6.8 76 0 64 0c-4.5 0-9.1 1-13.5 3C34.5 10.5 27.5 29.5 35 45.5zM59.6 240l70.6 0L221 45.5c7.5-16 .5-35.1-15.5-42.5s-35.1-.5-42.5 15.5L59.6 240zM165 241.2c9.8 1.8 19 5.6 27 11l0-21.5L181 207l-16 34.2z',
      'M256 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faTrash = {
  prefix: 'fad',
  iconName: 'trash',
  icon: [
    448,
    512,
    [],
    'f1f8',
    [
      'M32 96L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2l245.4 0c25.4 0 46.5-19.8 47.9-45.2L416 96 32 96z',
      'M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0z',
    ],
  ],
};
const faGaugeSimple = {
  prefix: 'fad',
  iconName: 'gauge-simple',
  icon: [
    512,
    512,
    ['gauge-simple-med', 'tachometer-average'],
    'f629',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192 96c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64z',
      'M280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3L280 88z',
    ],
  ],
};
const faGaugeSimpleMed = faGaugeSimple;
const faTachometerAverage = faGaugeSimple;
const faArrowDownSmallBig = {
  prefix: 'fad',
  iconName: 'arrow-down-small-big',
  icon: [
    576,
    512,
    ['sort-size-down-alt'],
    'f88d',
    [
      'M320 80l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm0 224l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortSizeDownAlt = faArrowDownSmallBig;
const faBookMedical = {
  prefix: 'fad',
  iconName: 'book-medical',
  icon: [
    448,
    512,
    [],
    'f7e6',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zM208 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faFaceMelting = {
  prefix: 'fad',
  iconName: 'face-melting',
  icon: [
    640,
    512,
    [129760],
    'e483',
    [
      'M0 480c0 17.7 14.3 32 32 32l288 0 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1.3 0c-23.6 0-39.8-24.1-35.4-47.2c3-15.8 4.6-32.1 4.6-48.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 38.5 8.5 75.1 23.8 107.9c15.5 33.4-6 84.1-42.9 84.1L32 448c-17.7 0-32 14.3-32 32zM184.4 313.3c-3.9-7.9-.5-17.5 7.4-21.4s17.5-.5 21.4 7.4c12 24.7 35.9 53.6 77.8 64.8s77.1-1.9 99.8-17.2c7.3-5 17.3-3 22.2 4.3s3 17.3-4.3 22.2c-28.1 19-72.8 35.9-126 21.7s-83.4-51.2-98.3-81.7zM287.5 189a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM441 238.7a32 32 0 1 1 -61.8-16.6A32 32 0 1 1 441 238.7z',
      'M247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zm154.6 41.4a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8z',
    ],
  ],
};
const faPoo = {
  prefix: 'fad',
  iconName: 'poo',
  icon: [
    512,
    512,
    [128169],
    'f2fe',
    [
      'M160 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80L160 128c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48L104 240c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72l-13.7 0c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3l167.4 0c6.8 0 12.3 5.5 12.3 12.3z',
    ],
  ],
};
const faPenClipSlash = {
  prefix: 'fad',
  iconName: 'pen-clip-slash',
  icon: [
    640,
    512,
    ['pen-alt-slash'],
    'e20f',
    [
      'M64.5 483.3c-1.6 7.9 .9 16 6.6 21.7c4.5 4.5 10.7 7 17 7c1.6 0 3.1-.2 4.7-.5l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7L195.8 250.3l-32.3 32.3c-48 48-80.8 109.2-94.1 175.8l-5 25zm128-357.7c12.7 9.9 25.4 19.9 38.1 29.8L271 114.9c9.4-9.4 24.6-9.4 33.9 0L318.1 128l-53.8 53.8c48.6 38.1 97.1 76.1 145.7 114.2l55-55 17-17-1-1-16-16-96-96-17-17L338.9 81c-28.1-28.1-73.7-28.1-101.8 0l-44.6 44.6zM374.6 71.4l17 17 96 96 16 16 1 1c17.4-17.4 34.7-34.7 52.1-52.1c12.5-12.5 18.7-28.9 18.7-45.3s-6.2-32.8-18.7-45.3L517.3 19.3C504.8 6.8 488.4 .6 472 .6s-32.8 6.2-45.3 18.7L374.6 71.4z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faPenAltSlash = faPenClipSlash;
const faQuoteRight = {
  prefix: 'fad',
  iconName: 'quote-right',
  icon: [
    448,
    512,
    [8221, 'quote-right-alt'],
    'f10e',
    [
      'M0 160l0 64c0 35.3 28.7 64 64 64l64 0 0 8c0 30.9-25.1 56-56 56l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0c66.3 0 120-53.7 120-120l0-72 0-32 0-32c0-35.3-28.7-64-64-64L64 96C28.7 96 0 124.7 0 160z',
      'M328 416c66.3 0 120-53.7 120-120l0-72 0-32 0-32c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l64 0 0 8c0 30.9-25.1 56-56 56l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0z',
    ],
  ],
};
const faQuoteRightAlt = faQuoteRight;
const faScrollOld = {
  prefix: 'fad',
  iconName: 'scroll-old',
  icon: [
    576,
    512,
    [],
    'f70f',
    [
      'M64 32l352 0c35.3 0 64 28.7 64 64l0 24 0 1.4c0 4.2-1.7 8.3-4.7 11.3l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3l0 1.4 0 16 0 1.4c0 4.2-1.7 8.3-4.7 11.3l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3l0 1.4 0 56-56 0-1.4 0c-4.2 0-8.3 1.7-11.3 4.7l-21.7 21.7c-3.1 3.1-8.2 3.1-11.3 0l-21.7-21.7c-3-3-7.1-4.7-11.3-4.7l-1.4 0-24 0c-17.7 0-32 14.3-32 32l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-136 0-1.4c0-4.2 1.7-8.3 4.7-11.3l21.7-21.7c3.1-3.1 3.1-8.2 0-11.3l-21.7-21.7c-3-3-4.7-7.1-4.7-11.3l0-1.4 0-24 0-64c0-35.3-28.7-64-64-64z',
      'M32 160l96 0 0-64c0-35.3-28.7-64-64-64S0 60.7 0 96l0 32c0 17.7 14.3 32 32 32zM288 384l0 16c0 44.2-35.8 80-80 80l272 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32l-120 0-1.4 0c-4.2 0-8.3 1.7-11.3 4.7l-21.7 21.7c-3.1 3.1-8.2 3.1-11.3 0l-21.7-21.7c-3-3-7.1-4.7-11.3-4.7l-1.4 0-24 0c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faGuitars = {
  prefix: 'fad',
  iconName: 'guitars',
  icon: [
    512,
    512,
    [],
    'f8bf',
    [
      'M0 408c0 57.4 57.3 104 128 104c41.3 0 77.9-15.9 101.4-40.5c-3.5-10.5-5.4-21.7-5.4-33.3c0-20.9 6.2-40.2 15-56.5c2.3-4.3 4.7-9 7-13.9c-3.9-7.6-8.9-14.7-14.8-21.3c-10.3-11.4-11.1-30.4-2.9-43.4C235.8 291.3 240 278 240 264c0-42.1-37.7-77.3-88-86l0 94c9.7 7.3 16 18.9 16 32c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1 6.3-24.7 16-32l0-94c-50.3 8.6-88 43.8-88 86c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408zm256 30.2c0 40.8 33 73.8 73.8 73.8l108.4 0c40.8 0 73.8-33 73.8-73.8c0-14.5-4.3-28.6-11.2-41.3C489 374.9 472 337.5 472 304c0-13.6 2.9-24.3 6.2-32.1l.5-1.1c4.6-10.7 9.3-21.9 9.3-33.5l0-29.3c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5c-4.9 12-16.6 27.1-44.5 31.3c-4.8 .7-10.1 1.1-16 1.1l-16 0c-5.9 0-11.2-.5-16-1.5c-30.9-6.2-41.9-30.3-45.8-46.7c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16l0 40.6c0 12.4 4.4 24.4 8.8 36.2c.9 2.5 1.8 5 2.7 7.5c2.6 7.3 4.5 16.5 4.5 27.8c0 33.5-17 70.9-28.8 92.9c-6.9 12.7-11.2 26.9-11.2 41.3zM336 320c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z',
      'M80 24C80 10.7 90.7 0 104 0l48 0c13.3 0 24 10.7 24 24l0 52.2c0 6.2-1.4 12.3-4.2 17.9L152 133.7 152 272c-6.7-5-15-8-24-8s-17.3 3-24 8l0-138.3L84.2 94.1C81.4 88.6 80 82.4 80 76.2L80 24zM338.6 124.1c-6.7-7.6-9.3-17.9-7.2-27.8l13.9-64.8C349.2 13.1 365.4 0 384.2 0c22 0 39.8 17.8 39.8 39.8l0 4.6c0 12.4-6.4 23.3-16 29.7l0 164.7c-4.8 .7-10.1 1.1-16 1.1l-16 0c-5.9 0-11.2-.5-16-1.5l0-89.9-21.4-24.5zM352 304l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faPhoneXmark = {
  prefix: 'fad',
  iconName: 'phone-xmark',
  icon: [
    576,
    512,
    [],
    'e227',
    [
      'M32 64c0 247.4 200.6 448 448 448c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L336.7 368C266.3 334.7 209.3 277.7 176 207.3L225.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C44.1 30.2 32 46 32 64z',
      'M401 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47L401 15z',
    ],
  ],
};
const faHose = {
  prefix: 'fad',
  iconName: 'hose',
  icon: [
    448,
    512,
    [],
    'e419',
    [
      'M0 176c0 79.5 64.5 144 144 144l272 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-272 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l144 0 0-64L144 32C64.5 32 0 96.5 0 176zM0 384c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 352c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z',
      'M312 128c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 2.3 80.2 11.5C417.3 30 423.9 24 432 24c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16c-8.1 0-14.7-6-15.8-13.7L336 101.7l0 2.3c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faClockSix = {
  prefix: 'fad',
  iconName: 'clock-six',
  icon: [
    512,
    512,
    [],
    'e352',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240z',
      'M256 96c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faShirt = {
  prefix: 'fad',
  iconName: 'shirt',
  icon: [
    640,
    512,
    [128085, 't-shirt', 'tshirt'],
    'f553',
    [
      'M.1 149.5c-.7 8.6 2.1 17.1 7.8 23.6l56 64c11.4 13.1 31.2 14.6 44.6 3.5L160 197.7 160 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-250.3 51.5 42.9c13.3 11.1 33.1 9.6 44.6-3.5l56-64c5.7-6.5 8.5-15 7.8-23.6s-4.8-16.6-11.4-22.1L502.3 22.3C485 7.9 463.3 0 440.8 0L432 0c0 61.9-50.1 112-112 112S208 61.9 208 0l-8.8 0C176.7 0 155 7.9 137.7 22.3L11.5 127.4C4.9 132.9 .8 140.9 .1 149.5z',
      'M208 0c0 61.9 50.1 112 112 112s112-50.1 112-112L400 0c0 44.2-35.8 80-80 80s-80-35.8-80-80L208 0z',
    ],
  ],
};
const faTShirt = faShirt;
const faTshirt = faShirt;
const faBillboard = {
  prefix: 'fad',
  iconName: 'billboard',
  icon: [
    640,
    512,
    [],
    'e5cd',
    [
      'M160 160c0 17.7 14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 0 32c-17.7 0-32 14.3-32 32zM288 416l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64-64 0zm64-256c0 17.7 14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 0 32c-17.7 0-32 14.3-32 32z',
      'M192 32L80 32C53.5 32 32 53.5 32 80l0 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 480 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-272c0-26.5-21.5-48-48-48L448 32l0 64 96 0 0 256L96 352 96 96l96 0 0-64zm64 64l128 0 0-64L256 32l0 64z',
    ],
  ],
};
const faSquareR = {
  prefix: 'fad',
  iconName: 'square-r',
  icon: [
    448,
    512,
    [],
    'e27c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6c-4.3 3.2-9.4 4.8-14.4 4.8c-7.3 0-14.5-3.3-19.2-9.6L220 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112zm48 24l0 64 56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0z',
      'M128 152c0-13.3 10.7-24 24-24l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112zm48 88l56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64z',
    ],
  ],
};
const faCubes = {
  prefix: 'fad',
  iconName: 'cubes',
  icon: [
    576,
    512,
    [],
    'f1b3',
    [
      'M48 323.2l80 30.6 0 100.4L52.8 421.2c-2.9-1.3-4.8-4.2-4.8-7.3l0-90.7zm128 30.6l80-30.6 0 95.9-80 35.2 0-100.4zM184 121c26.7 10.2 53.3 20.4 80 30.7l0 89.2c-26.7-10.1-53.3-20.2-80-30.3l0-89.6zm128 30.7c26.7-10.2 53.3-20.4 80-30.7l0 89.6c-26.7 10.1-53.3 20.2-80 30.3l0-89.2zm8 171.6l80 30.6 0 100.4-80-35.2 0-95.9zm128 30.6l80-30.6 0 90.7c0 3.2-1.9 6-4.8 7.3L448 454.3l0-100.4z',
      'M290.8 48.6c-1.8-.7-3.8-.7-5.7 0L206.8 78.3 288 109.5l81.2-31.1L290.8 48.6zM184 210.6l80 30.3 0-89.2L184 121l0 89.6zm128 30.3l80-30.3 0-89.6-80 30.7 0 89.2zM288 457.5L174.5 507.3c-14.4 6.3-30.7 6.3-45.1 0l-96-42.2C13.1 456.2 0 436.1 0 413.9L0 294.7c0-23.3 14.4-44.1 36.1-52.4l96-36.4c1.3-.5 2.6-.9 3.9-1.3l0-112.2c0-23.3 14.4-44.1 36.1-52.4l96-36.4c12.8-4.8 26.9-4.8 39.7 0l96 36.4C425.6 48.4 440 69.3 440 92.5l0 112.2c1.3 .4 2.6 .8 3.9 1.3l96 36.4c21.8 8.2 36.1 29.1 36.1 52.4l0 119.1c0 22.2-13.1 42.3-33.5 51.3l-96 42.2c-14.4 6.3-30.7 6.3-45.1 0L288 457.5zM149.2 250.9L70.8 280.6 152 311.7l81.2-31.1-78.4-29.7c-1.8-.7-3.8-.7-5.7 0zm26.8 103l0 100.4 80-35.2 0-95.9-80 30.6zm-48 0L48 323.2l0 90.7c0 3.2 1.9 6 4.8 7.3L128 454.3l0-100.4zm293.2-103l-78.4 29.7L424 311.7l81.2-31.1-78.4-29.7c-1.8-.7-3.8-.7-5.7 0zM448 454.3l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3l0-90.7-80 30.6 0 100.4zM400 353.9l-80-30.6 0 95.9 80 35.2 0-100.4z',
    ],
  ],
};
const faEnvelopeOpenDollar = {
  prefix: 'fad',
  iconName: 'envelope-open-dollar',
  icon: [
    512,
    512,
    [],
    'f657',
    [
      'M64 64l0 64.5 0 79.6 0 41.6c57.6 42.6 115.1 85.3 172.7 127.9c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4C332.9 335 390.5 292.3 448 249.7l0-41.6 0-79.6L448 64c0-17.7-14.3-32-32-32l-98.2 0L194.2 32 96 32C78.3 32 64 46.3 64 64zM188.2 166.6c.1-1.3 .2-2.5 .4-3.7c.3-2.4 .9-4.8 1.5-7c1.3-4.5 3.2-8.5 5.6-12.2c4.7-7.3 11.2-13 18.2-17.1c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c0 .7 0 1.3 0 1.9s0 1.3-.1 1.9c-.1 1.3-.2 2.5-.3 3.7c-.3 2.4-.7 4.8-1.3 7c-1.2 4.5-3 8.6-5.2 12.4c-4.4 7.5-10.7 13.5-17.9 18c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c0-.7 0-1.3 0-2s.1-1.3 .1-1.9z',
      'M511.8 202.5c-1.6-18.1-10.9-34.9-25.7-45.8L448 128.5l0 79.6 0 41.6 63.8-47.2zM512 448l0-205.9L294.4 403.3C283.3 411.6 269.8 416 256 416s-27.3-4.4-38.4-12.7L0 242.1 0 448s0 0 0 0c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64c0 0 0 0 0 0zM64 249.7l0-41.6 0-79.6L25.9 156.7C11.1 167.6 1.8 184.4 .2 202.5L64 249.7zM289.5 11.1C279.8 3.9 268.1 0 256 0s-23.8 3.9-33.5 11L194.2 32l123.5 0L289.5 11.1zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z',
    ],
  ],
};
const faDivide = {
  prefix: 'fad',
  iconName: 'divide',
  icon: [
    448,
    512,
    [10135, 247],
    'f529',
    [
      'M16 256c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 224c-17.7 0-32 14.3-32 32z',
      'M224 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faSunCloud = {
  prefix: 'fad',
  iconName: 'sun-cloud',
  icon: [
    640,
    512,
    [127780],
    'f763',
    [
      'M0 355.4c0 2.1 .4 4.2 1.2 6.1c2.1 5 6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.4-51c-42.1-1.5-77.4-30.2-88.7-69c-11.4 3.3-23.4 5.1-35.8 5.1c-70.7 0-128-57.3-128-128s57.3-128 128-128c61.3 0 112.6 43.1 125.1 100.7c20.5-22.5 50-36.7 82.9-36.7c8.6 0 17 1 25.1 2.8l20.1-29.1c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3C1 349 0 352.2 0 355.4zM160 256c0 53 43 96 96 96c11.3 0 22.1-1.9 32.2-5.5c2.2-39.3 28.1-72.3 63.7-85c.1-1.8 .2-3.7 .2-5.5c0-53-43-96-96-96s-96 43-96 96z',
      'M320 352c0 35.3 28.7 64 64 64l184 0c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64z',
    ],
  ],
};
const faLampFloor = {
  prefix: 'fad',
  iconName: 'lamp-floor',
  icon: [
    384,
    512,
    [],
    'e015',
    [
      'M160 224l0 224 32 0 32 0 0-224-64 0z',
      'M66.3 20.1C71.1 8 82.9 0 96 0L288 0c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1L32 224c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM96 448l96 0 96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faSquare7 = {
  prefix: 'fad',
  iconName: 'square-7',
  icon: [
    448,
    512,
    [],
    'e25c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7c-37.3 69.3-74.7 138.7-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L152 176c-13.3 0-24-10.7-24-24z',
      'M128 152c0-13.3 10.7-24 24-24l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L152 176c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faTengeSign = {
  prefix: 'fad',
  iconName: 'tenge-sign',
  icon: [
    384,
    512,
    [8376, 'tenge'],
    'f7d7',
    [
      'M0 192c0 17.7 14.3 32 32 32l128 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0L32 160c-17.7 0-32 14.3-32 32z',
      'M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64z',
    ],
  ],
};
const faTenge = faTengeSign;
const faHeadphones = {
  prefix: 'fad',
  iconName: 'headphones',
  icon: [
    512,
    512,
    [127911],
    'f025',
    [
      'M0 288l0 48c0-1 0-2.1 .1-3.1s.1-2.1 .2-3.1c.2-2 .4-4.1 .7-6.1c.6-4 1.5-7.9 2.7-11.7c2.4-7.6 5.8-14.7 10.2-21.1c8.8-12.8 21.2-23 35.7-29C62.4 159.4 149.9 80 256 80s193.6 79.4 206.4 182c29.1 12 49.6 40.6 49.6 74l0-48C512 146.6 397.4 32 256 32S0 146.6 0 288z',
      'M80 256c-44.2 0-80 35.8-80 80l0 64c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48zm352 0c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80z',
    ],
  ],
};
const faHandsHolding = {
  prefix: 'fad',
  iconName: 'hands-holding',
  icon: [
    640,
    512,
    [],
    'f4c2',
    [
      'M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c0 0 0 0 0 0l-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40zm480 0l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c0 0 0 0 0 0l-25.3 25.3c-21 21-32.8 49.5-32.8 79.2l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40z',
      '',
    ],
  ],
};
const faCampfire = {
  prefix: 'fad',
  iconName: 'campfire',
  icon: [
    512,
    512,
    [],
    'f6ba',
    [
      'M112 174.7C112 255.2 175.4 320 256 320c79.8 0 144-64.7 144-145.3c0-27.3-9.9-55.4-23.6-80.1C362.7 69.7 344.7 47 326.9 30.4c-5-4.7-11.5-7.1-17.9-7.1c-6.8 0-14 2.5-18.8 8.1l-11 12.5L262.1 25.8c-1.8-1.9-3.6-4-5.4-6.1C248.6 10.4 239.9 .3 227.2 0c-6.5-.2-13.1 2.1-18.3 6.8c-21.1 19.2-45 44.4-63.8 72.9c-18.7 28.3-33.1 61-33.1 95zm87.3 43.6c0-33.2 33.7-66.4 49.8-80.4c4.9-4.2 11.9-4.2 16.8 0c16.1 14 49.8 47.2 49.8 80.4c0 32.1-26 58.2-58.2 58.2s-58.2-26-58.2-58.2z',
      'M1.9 309.2c5.9-16.6 24.3-25.3 40.9-19.4L256 366l213.2-76.2c16.6-5.9 35 2.7 40.9 19.4s-2.7 35-19.4 40.9L351.1 400l139.6 49.9c16.6 5.9 25.3 24.3 19.4 40.9s-24.3 25.3-40.9 19.4L256 434 42.8 510.1c-16.6 5.9-35-2.7-40.9-19.4s2.7-35 19.4-40.9L160.9 400 21.2 350.1C4.6 344.2-4.1 325.9 1.9 309.2z',
    ],
  ],
};
const faCircleAmpersand = {
  prefix: 'fad',
  iconName: 'circle-ampersand',
  icon: [
    512,
    512,
    [],
    'e0f8',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 61.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6l19.2 0c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L361 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4l-32.2 0c-36.7 0-66.5-29.8-66.5-66.5zm48 0c0 10.2 8.3 18.5 18.5 18.5l32.2 0c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5c-4.7 3.5-7.5 9-7.5 14.9zm24-125.9c0 4.1 1.6 8.1 4.6 11L235 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2l-19.2 0c-8.6 0-15.6 7-15.6 15.6z',
      'M231.6 176l19.2 0c7.3 0 13.2 5.9 13.2 13.2c0 4.2-2 8.1-5.4 10.6L235 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11c0-8.6 7-15.6 15.6-15.6zm37.8 75.4L287 238.5c15.7-11.5 25-29.8 25-49.3c0-33.8-27.4-61.2-61.2-61.2l-19.2 0c-35.1 0-63.6 28.5-63.6 63.6c0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1c-17.1 12.5-27.2 32.4-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5l32.2 0c24.1 0 46.9-10.9 62-29.4L327 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7zm-39.2 28.7l40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8l-32.2 0c-10.2 0-18.5-8.3-18.5-18.5c0-5.9 2.8-11.4 7.5-14.9l30.7-22.5z',
    ],
  ],
};
const faSnowflakes = {
  prefix: 'fad',
  iconName: 'snowflakes',
  icon: [
    640,
    512,
    [],
    'f7cf',
    [
      'M487 7c-9.4 9.4-9.4 24.6 0 33.9l23 23L487 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 23-23c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7l-23 23L521 7c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7zm32 192c-9.4 9.4-9.4 24.6 0 33.9l23 23-23 23c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l23-23 23 23c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-23-23 23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23-23-23c-9.4-9.4-24.6-9.4-33.9 0z',
      'M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faHandsClapping = {
  prefix: 'fad',
  iconName: 'hands-clapping',
  icon: [
    512,
    512,
    [],
    'e1a8',
    [
      'M208 32c0-5.2 2.5-10.2 7.1-13.3c7.4-4.9 17.3-2.9 22.2 4.4l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-1.8-2.7-2.7-5.8-2.7-8.9zm96-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64zm51.4 492c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4c-24.2 14.5-50.9 22.1-77.7 23.1zM370.7 71.1l32-48c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2z',
      'M135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faRepublican = {
  prefix: 'fad',
  iconName: 'republican',
  icon: [
    640,
    512,
    [],
    'f75e',
    [
      'M0 288l0 96 0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64 192 0 0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64 0-32 32 0 0 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80 0-32-32 0-64 0-32 0-96 0-192 0L0 288z',
      'M160 32C71.6 32 0 103.6 0 192l0 96 544 0 0-96c0-88.4-71.6-160-160-160L160 32zm261.7 99.4l12.6 24.6 28.2 4c2.4 .3 4.4 2 5.2 4.2s.1 4.7-1.6 6.3l-20.4 19.2 4.8 27.1c.4 2.3-.6 4.7-2.5 6s-4.6 1.6-6.7 .5l-25.2-12.8-25.2 12.8c-2.2 1.1-4.8 .9-6.7-.5s-3-3.7-2.5-6l4.8-27.1-20.4-19.2c-1.7-1.6-2.4-4.1-1.6-6.3s2.8-3.9 5.2-4.2l28.2-4 12.6-24.6c1.1-2.1 3.3-3.4 5.7-3.4s4.7 1.3 5.7 3.4zM271.9 128c2.4 0 4.7 1.3 5.7 3.4l12.6 24.6 28.2 4c2.4 .3 4.4 2 5.2 4.2s.1 4.7-1.6 6.3l-20.4 19.2 4.8 27.1c.4 2.3-.6 4.7-2.5 6s-4.6 1.6-6.7 .5l-25.2-12.8-25.2 12.8c-2.2 1.1-4.8 .9-6.7-.5s-3-3.7-2.5-6l4.8-27.1-20.4-19.2c-1.7-1.6-2.4-4.1-1.6-6.3s2.8-3.9 5.2-4.2l28.2-4 12.6-24.6c1.1-2.1 3.3-3.4 5.7-3.4zm-138.3 3.4l12.6 24.6 28.2 4c2.4 .3 4.4 2 5.2 4.2s.1 4.7-1.6 6.3l-20.4 19.2 4.8 27.1c.4 2.3-.6 4.7-2.5 6s-4.6 1.6-6.7 .5l-25.2-12.8-25.2 12.8c-2.2 1.1-4.8 .9-6.7-.5s-3-3.7-2.5-6l4.8-27.1L77.9 170.5c-1.7-1.6-2.4-4.1-1.6-6.3s2.8-3.9 5.2-4.2l28.2-4 12.6-24.6c1.1-2.1 3.3-3.4 5.7-3.4s4.7 1.3 5.7 3.4z',
    ],
  ],
};
const faLeafMaple = {
  prefix: 'fad',
  iconName: 'leaf-maple',
  icon: [
    512,
    512,
    [127809],
    'f6f6',
    [
      'M16 264.8c0 4.4 2.4 8.5 6.3 10.7l115.9 64.4c47.3-47.3 94.5-94.5 141.8-141.8c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17c-47.3 47.3-94.5 94.5-141.8 141.8l64.4 115.9c2.2 3.9 6.2 6.3 10.7 6.3c5.3 0 9.9-3.4 11.6-8.4l8.5-25.4c2.7-8 11.1-12.6 19.2-10.4l155 40.4c7.4 1.9 14.6-3.6 14.6-11.2c0-.6-.1-1.3-.2-1.9L451.7 454c-2.2-13.2 4.1-26.4 15.7-33l28.9-16.5c4.8-2.7 7.8-7.8 7.8-13.4c0-4.5-2-8.8-5.4-11.7L464.3 350c-9.9-8.5-13.6-22.1-9.5-34.4l8.5-25.5c.5-1.4 .7-2.9 .7-4.4c0-7.6-6.2-13.8-13.8-13.8l-38.3 0c-8 0-11.1-10.5-4.2-14.8L505.6 196c4-2.5 6.4-6.9 6.4-11.6c0-5.2-2.9-9.9-7.5-12.2l-31.6-15.8c-14.2-7.1-21.1-23.6-16-38.7l22.5-67.6c.5-1.4 .7-2.9 .7-4.4c0-7.6-6.2-13.8-13.8-13.8c-1.5 0-3 .2-4.4 .7L394.3 55.2c-15.1 5-31.6-1.8-38.7-16L339.8 7.5c-2.3-4.6-7-7.5-12.2-7.5c-4.7 0-9.1 2.4-11.6 6.4l-61.2 97.9c-4.3 6.8-14.8 3.8-14.8-4.2l0-38.3c0-7.6-6.2-13.8-13.8-13.8c-1.5 0-2.9 .2-4.4 .7l-25.5 8.5c-12.3 4.1-25.9 .3-34.4-9.5L132.6 13.4C129.7 10 125.4 8 120.9 8c-5.5 0-10.6 3-13.4 7.7L91.1 44.6C84.4 56.3 71.2 62.5 58 60.3L32.9 56.2c-.6-.1-1.3-.2-1.9-.2c-7.6 0-13.2 7.2-11.2 14.6l40.4 155c2.1 8.2-2.4 16.6-10.4 19.2l-25.4 8.5c-5 1.7-8.4 6.3-8.4 11.6z',
      'M7 505c-9.4-9.4-9.4-24.6 0-33.9L279.9 198.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0z',
    ],
  ],
};
const faArrowLeft = {
  prefix: 'fad',
  iconName: 'arrow-left',
  icon: [
    448,
    512,
    [8592],
    'f060',
    [
      'M77.3 256l32-32L416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-306.7 0c-10.7-10.7-21.3-21.3-32-32z',
      'M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z',
    ],
  ],
};
const faPersonCircleXmark = {
  prefix: 'fad',
  iconName: 'person-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e543',
    [
      'M0 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C1.5 276.7 0 282.4 0 288zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faRuler = {
  prefix: 'fad',
  iconName: 'ruler',
  icon: [
    512,
    512,
    [128207],
    'f545',
    [
      'M17.9 334.1c-18.7 18.7-18.7 49.1 0 67.9l92.1 92.1c18.7 18.7 49.1 18.7 67.9 0L494.1 177.9c9.4-9.4 14.1-21.7 14.1-33.9s-4.7-24.6-14.1-33.9L401.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L283.3 68.7c16 16 32 32 48 48c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-6.2 6.2-16.4 6.2-22.6 0c-16-16-32-32-48-48c-13.8 13.8-27.6 27.6-41.4 41.4c16 16 32 32 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-13.8 13.8-27.6 27.6-41.4 41.4c16 16 32 32 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-13.8 13.8-27.6 27.6-41.4 41.4c16 16 32 32 48 48c6.2 6.2 6.2 16.2 .2 22.5c-3.3 3.3-7.4 4.9-11.5 4.9s-8.2-1.6-11.3-4.7l-48-48c-16.9 16.9-33.8 33.8-50.7 50.7z',
      'M260.7 91.3l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48zm-64 64l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48zm-64 64l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48zm-64 64l22.6-22.6 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48z',
    ],
  ],
};
const faArrowLeftFromBracket = {
  prefix: 'fad',
  iconName: 'arrow-left-from-bracket',
  icon: [
    512,
    512,
    [],
    'e668',
    [
      'M320 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32z',
      'M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224 320 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-210.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z',
    ],
  ],
};
const faCupStrawSwoosh = {
  prefix: 'fad',
  iconName: 'cup-straw-swoosh',
  icon: [
    384,
    512,
    [],
    'e364',
    [
      'M32 192l320 0-6.4 64c-50.7 .6-85.3 8.9-111.2 22.8c-25.7 13.9-40.8 32.5-53.1 47.7l-1.9 2.3c-12.7 15.6-23.5 28.1-42.8 37.6C119.3 375 93.5 382 51.2 383.6L32 192zM55.9 431.5c45.2-2 77.3-9.8 101.9-22c29.2-14.4 45.4-34 58.7-50.4l.7-.8c13-16 22.7-28 39.9-37.2c16.1-8.7 40.9-15.9 83.6-17L324.3 468.8c-2.5 24.5-23.1 43.2-47.8 43.2l-169.1 0c-24.7 0-45.3-18.7-47.8-43.2l-3.7-37.3z',
      'M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8L32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-127.8 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0z',
    ],
  ],
};
const faTemperatureSun = {
  prefix: 'fad',
  iconName: 'temperature-sun',
  icon: [
    640,
    512,
    ['temperature-hot'],
    'f76a',
    [
      'M320 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L576 112C576 50.2 525.9 0 464 0S352 50.2 352 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L416 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C537.8 332.6 544 349.5 544 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M320.6 98.5c-.4 4.4-.6 8.9-.6 13.5l0 146.8c-20.2 28.6-32 63.5-32 101.2c0 18.7 2.9 36.7 8.3 53.7c-.7 .4-1.4 .8-2.1 1.1c-5.1 2.1-10.9 1.5-15.4-1.6L208 363.5l-70.8 49.6c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6s8.7 6.7 9.6 12.1l14.1 84.7 2.7 .5zM208 144a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM464 96c8.8 0 16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L448 112c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faTemperatureHot = faTemperatureSun;
const faAlignLeft = {
  prefix: 'fad',
  iconName: 'align-left',
  icon: [
    448,
    512,
    [],
    'f036',
    [
      'M0 64C0 81.7 14.3 96 32 96l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64zM0 320c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32z',
      'M416 480c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0zm0-256c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0z',
    ],
  ],
};
const faDiceD6 = {
  prefix: 'fad',
  iconName: 'dice-d6',
  icon: [
    448,
    512,
    [],
    'f6d1',
    [
      'M17.3 120c0 5.9 3.2 11.2 8.3 14L216.3 238c2.4 1.3 5 2 7.7 2s5.3-.7 7.7-2L422.3 134c5.1-2.8 8.3-8.2 8.3-14s-3.2-11.2-8.3-14L247 10.3c-7.2-3.9-15.1-5.9-23-5.9s-15.8 2-23 5.9L25.7 106c-5.1 2.8-8.3 8.2-8.3 14z',
      'M7.8 170.2c4.9-2.9 10.9-3 15.8-.3l176 96c5.1 2.8 8.3 8.2 8.3 14l0 216c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381L0 184c0-5.6 3-10.9 7.8-13.8zm432.3 0c4.9 2.9 7.8 8.1 7.8 13.8l0 197c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8l0-216c0-5.9 3.2-11.2 8.3-14l176-96c5-2.7 11-2.6 15.8 .3z',
    ],
  ],
};
const faRestroom = {
  prefix: 'fad',
  iconName: 'restroom',
  icon: [
    640,
    512,
    [],
    'f7bd',
    [
      'M0 304c0 13.6 8.8 26.3 22.5 30.5c12.4 3.9 25.4-.2 33.5-9.4L56 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-154.8c8.1 9.2 21.1 13.2 33.5 9.4c16.9-5.3 26.3-23.2 21-40.1l-30.9-99.1C211.1 155.3 174 128 132 128l-8 0c-42 0-79.1 27.3-91.6 67.4L1.5 294.5C.5 297.6 0 300.9 0 304zM80 48a48 48 0 1 0 96 0A48 48 0 1 0 80 48zM385.5 294.5c-5.3 16.9 4.1 34.8 21 40.1c3.2 1 6.4 1.5 9.5 1.5l-9 26.9c-3.5 10.4 4.3 21.1 15.2 21.1l17.8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L608 336c3.2 0 6.4-.5 9.5-1.5c16.9-5.3 26.3-23.2 21-40.1l-29.7-95.2C595.6 156.9 556.4 128 512 128s-83.6 28.9-96.8 71.2l-29.7 95.2zM464 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M320 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHighDefinition = {
  prefix: 'fad',
  iconName: 'high-definition',
  icon: [
    576,
    512,
    ['rectangle-hd'],
    'e1ae',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48 64 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-64 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-72zm192 0c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-13.3 0-24-10.7-24-24l0-144zm48 24l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z',
      'M160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 64 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-64 0 0-48zm168-24c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0zm56 144l-32 0 0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z',
    ],
  ],
};
const faRectangleHd = faHighDefinition;
const faJ = {
  prefix: 'fad',
  iconName: 'j',
  icon: [
    320,
    512,
    [106],
    '4a',
    [
      'M288 32c17.7 0 32 14.3 32 32l0 256c0 88.4-71.6 160-160 160S0 408.4 0 320l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 53 43 96 96 96s96-43 96-96l0-256c0-17.7 14.3-32 32-32z',
      '',
    ],
  ],
};
const faGalaxy = {
  prefix: 'fad',
  iconName: 'galaxy',
  icon: [
    512,
    512,
    [],
    'e008',
    [
      'M0 180.5L0 192c0 70.3 37.8 131.8 94.2 165.2c28.7 17 62.1 26.8 97.8 26.8c22.3 0 43.7-3.8 63.5-10.8c-8.4 25.9-23 49.5-42.4 68.8c-9.2 9.1-19.6 17.3-30.9 24.3L169.8 474c-6.1 3.7-9.8 10.4-9.8 17.5c0 11.3 9.2 20.5 20.5 20.5l11.5 0c70.3 0 131.8-37.8 165.2-94.2c17-28.7 26.8-62.1 26.8-97.8c0-22.3-3.8-43.7-10.8-63.5c25.9 8.4 49.5 23 68.8 42.4c9.1 9.2 17.3 19.6 24.3 30.9l7.7 12.5c3.7 6.1 10.4 9.8 17.5 9.8c11.3 0 20.5-9.2 20.5-20.5l0-11.5c0-70.3-37.8-131.8-94.2-165.2c-28.7-17-62.1-26.8-97.8-26.8c-22.3 0-43.7 3.8-63.5 10.8c8.4-25.9 23-49.5 42.4-68.8c9.2-9.1 19.6-17.3 30.9-24.3L342.2 38c6.1-3.7 9.8-10.4 9.8-17.5C352 9.2 342.8 0 331.5 0L320 0C249.7 0 188.2 37.8 154.8 94.2c-8.5 14.3-15.2 29.9-19.8 46.3c-2.3 8.2-4 16.6-5.2 25.2c-.6 4.3-1 8.7-1.3 13c-.1 2.2-.3 4.4-.3 6.6c-.1 2.2-.1 4.5-.1 6.7c0 1.4 0 2.8 0 4.2c0 1.4 .1 2.7 .1 4.1c.1 2.7 .3 5.5 .5 8.2c.5 5.4 1.2 10.8 2.1 16.1c1.8 10.6 4.5 20.9 8 30.9c-25.9-8.4-49.5-23-68.8-42.4c-9.1-9.2-17.3-19.6-24.3-30.9L38 169.8c-3.7-6.1-10.4-9.8-17.5-9.8C9.2 160 0 169.2 0 180.5zM288 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M154.8 94.2c.1-13 1.6-26.1 4.7-39l3.4-14.2c1.7-6.9-.4-14.2-5.5-19.3c-8-8-21-8-29 0l-8.1 8.1C70.5 79.4 53.8 149.6 70 213.1c19.3 19.4 42.9 34 68.8 42.4c-7-19.9-10.8-41.3-10.8-63.5c0-35.7 9.8-69.2 26.8-97.8zM94.2 357.2c-13-.1-26.1-1.6-39-4.7l-14.2-3.4c-6.9-1.7-14.2 .4-19.3 5.5c-8 8-8 21 0 29l8.1 8.1c49.7 49.7 119.9 66.5 183.4 50.3c19.4-19.3 34-42.9 42.4-68.8c-19.9 7-41.3 10.8-63.5 10.8c-35.7 0-69.2-9.8-97.8-26.8zm263.1 60.6c-.1 13-1.6 26.1-4.7 39l-3.4 14.2c-1.7 6.9 .4 14.2 5.5 19.3c8 8 21 8 29 0l8.1-8.1c49.7-49.7 66.5-119.9 50.3-183.4c-19.3-19.4-42.9-34-68.8-42.4c7 19.9 10.8 41.3 10.8 63.5c0 35.7-9.8 69.2-26.8 97.8zm60.6-263.1c13 .1 26.1 1.6 39 4.7l14.2 3.4c6.9 1.7 14.2-.4 19.3-5.5c8-8 8-21 0-29l-8.1-8.1C432.6 70.5 362.4 53.8 298.9 70c-19.4 19.3-34 42.9-42.4 68.8c19.9-7 41.3-10.8 63.5-10.8c35.7 0 69.2 9.8 97.8 26.8z',
    ],
  ],
};
const faUsersViewfinder = {
  prefix: 'fad',
  iconName: 'users-viewfinder',
  icon: [
    640,
    512,
    [],
    'e595',
    [
      'M96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0C119.9 256 96 279.9 96 309.3zM127.8 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 360c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24zm48-168a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm140 70.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4zM416 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M136 48L48 48l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 32C0 14.3 14.3 0 32 0L136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm368 0c-13.3 0-24-10.7-24-24s10.7-24 24-24L608 0c17.7 0 32 14.3 32 32l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-88 0zM48 464l88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L32 512c-17.7 0-32-14.3-32-32L0 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88zm456 0l88 0 0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104c0 17.7-14.3 32-32 32l-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faFileVideo = {
  prefix: 'fad',
  iconName: 'file-video',
  icon: [
    384,
    512,
    [],
    'f1c8',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 288l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm192 16l0 64 44.9 29.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3l0-103.4c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM64 288l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM300.9 397.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3l0-103.4c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304l0 64 44.9 29.9z',
    ],
  ],
};
const faCherries = {
  prefix: 'fad',
  iconName: 'cherries',
  icon: [
    640,
    512,
    [],
    'e0ec',
    [
      'M0 336C0 224 96 224 96 224c30.5 0 56.3 9.5 73.4 18.2C183.7 249.4 192 256 192 256s1-.8 2.9-2.2s4.7-3.2 8.4-5.4c7.3-4.4 17.8-9.9 30.8-14.7c15-5.4 33.4-9.7 54-9.7c0 0 96 0 96 112c0 160-144 176-192 176S0 480 0 336zM353.9 488.9c36-32 62.1-80.9 62.1-152.9c0-53.1-18.7-88.3-43.2-110.5c17.1 2.4 32.2 7.4 44.2 12.7c19.4 8.6 31 17.8 31 17.8s7.2-5.7 19.7-12.4c17.1-9 44-19.6 76.3-19.6c0 0 96 0 96 112c0 160-144 176-192 176c-20.3 0-57.6-5.7-94.1-23.1z',
      'M302.4 4.8l.3 .2c.3 .2 .8 .6 1.4 1c1.2 .9 2.9 2.2 5 3.9c4.3 3.3 10.3 8.2 17.5 14.5c14.4 12.6 33.7 30.9 53.6 53.9c35.1 40.6 73.3 97.7 87.6 165.3C455.2 250.3 448 256 448 256s-11.6-9.3-31-17.8c-14-50.1-43.6-94.2-73.1-128.5c-14.3-16.6-28.3-30.5-40.1-41.2c-3.1 12.9-7.3 28.2-13 45.1c-11.7 35-29.6 77.5-56.7 120.2c-26 9.4-42 22.3-42 22.3s-8.3-6.6-22.6-13.8c38.4-49.1 61.8-101.8 75.8-143.7c7.7-23 12.4-42.5 15.3-56.3c1.4-6.9 2.4-12.2 2.9-15.8c.3-1.8 .5-3.1 .6-4l.1-.9c.6-5.3 2.9-10.1 6.3-13.8C274.9 2.9 281.1 0 288 0c5.4 0 10.4 1.8 14.4 4.8z',
    ],
  ],
};
const faUpRightFromSquare = {
  prefix: 'fad',
  iconName: 'up-right-from-square',
  icon: [
    512,
    512,
    ['external-link-alt'],
    'f35d',
    [
      'M0 112C0 67.8 35.8 32 80 32l112 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 112c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112z',
      'M322.4 19.8C327.4 7.8 339.1 0 352 0L480 0c17.7 0 32 14.3 32 32l0 128c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L416 141.3 246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 96 329.4 54.6c-9.2-9.2-11.9-22.9-6.9-34.9z',
    ],
  ],
};
const faExternalLinkAlt = faUpRightFromSquare;
const faCircleSort = {
  prefix: 'fad',
  iconName: 'circle-sort',
  icon: [
    512,
    512,
    ['sort-circle'],
    'e030',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm145.2-41.9c-2.5-6-1.1-12.9 3.5-17.4l96-96c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9zm0 83.8c2.5-6 8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4z',
      'M244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zm0 310.6l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0z',
    ],
  ],
};
const faSortCircle = faCircleSort;
const faTableCells = {
  prefix: 'fad',
  iconName: 'table-cells',
  icon: [
    512,
    512,
    ['th'],
    'f00a',
    [
      'M64 160l0 64 80 0 0 64-80 0 0 64 80 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 80 0 0-64-80 0 0-64 80 0 0-64-80 0 0-64-64 0 0 64-96 0 0-64-64 0 0 64-80 0zm144 64l96 0 0 64-96 0 0-64z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 96l0 320L64 416 64 96l384 0z',
    ],
  ],
};
const faTh = faTableCells;
const faBagShoppingMinus = {
  prefix: 'fad',
  iconName: 'bag-shopping-minus',
  icon: [
    448,
    512,
    [],
    'e650',
    [
      'M0 208L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-208c0-26.5-21.5-48-48-48l-64 0-48 0-128 0-48 0-64 0c-26.5 0-48 21.5-48 48zM120 336c0-13.3 10.7-24 24-24l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24z',
      'M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48 48 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112l0 48 48 0 0-48zM144 312c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0z',
    ],
  ],
};
const faFilePdf = {
  prefix: 'fad',
  iconName: 'file-pdf',
  icon: [
    512,
    512,
    [],
    'f1c1',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM176 352c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm32 128l-16 0 0-96 16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16zm80-112l0 64 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faSiren = {
  prefix: 'fad',
  iconName: 'siren',
  icon: [
    448,
    512,
    [],
    'e02d',
    [
      'M48 352L73 152.1C77 120 104.2 96 136.5 96l175 0c32.3 0 59.5 24 63.5 56.1L400 352l-261.9 0 21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L105.9 352 48 352z',
      'M32 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 352z',
    ],
  ],
};
const faArrowUpToDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-up-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e0a1',
    [
      'M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm96 0A32 32 0 1 1 96 64a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M201.4 169.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 269.3l0 66.7 0 112c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-112 0-66.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z',
    ],
  ],
};
const faImageLandscape = {
  prefix: 'fad',
  iconName: 'image-landscape',
  icon: [
    576,
    512,
    ['landscape'],
    'e1b5',
    [
      'M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm128 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm2.4 178.4c4 8.3 12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C343.5 196 336 192 328 192s-15.5 4-20 10.7l-56 84L234.7 265c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4z',
      'M328 192c8 0 15.5 4 20 10.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S432.9 384 424 384l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C312.5 196 320 192 328 192z',
    ],
  ],
};
const faLandscape = faImageLandscape;
const faTankWater = {
  prefix: 'fad',
  iconName: 'tank-water',
  icon: [
    448,
    512,
    [],
    'e452',
    [
      'M64 297.9L64 348l0 68 320 0 0-68 0-50.1c-8.3-3-16.2-6.8-23.4-10.8c-6.9-3.9-13.1-8.2-19-12.8c-12.9-10-30.6-10-43.4 0c-5.9 4.6-12 8.8-18.9 12.7c-15.8 9-35.5 16.8-55.2 16.9l-.4 0c-19.6 0-39.3-7.9-55.2-16.9c-6.9-3.9-13.1-8.2-18.9-12.7c-12.9-10-30.6-10-43.4 0c-5.9 4.6-12 8.8-18.9 12.7c-7.1 4-15 7.8-23.3 10.8zM168 166.6l0 1.4c0 30.9 25.1 56 56 56s56-25.1 56-56l0-1.4c0-9.6-2.4-19-7-27.5L235.8 71c-2.4-4.3-6.9-7-11.8-7s-9.5 2.7-11.8 7L175 139.2c-4.6 8.4-7 17.9-7 27.5z',
      'M285.9 96l-22-40.3L251 32l133 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l133 0L184.1 55.7 162.1 96 64 96l0 320 320 0 0-320-98.1 0z',
    ],
  ],
};
const faCurlingStone = {
  prefix: 'fad',
  iconName: 'curling-stone',
  icon: [
    576,
    512,
    [129356, 'curling'],
    'f44a',
    [
      'M0 320l0 16 576 0 0-16c0-53-43-96-96-96L96 224c-53 0-96 43-96 96zm0 48l0 16c0 53 43 96 96 96l384 0c53 0 96-43 96-96l0-16L0 368z',
      'M224 128c0-17.7 14.3-32 32-32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L256 32c-53 0-96 43-96 96l0 32c-35.3 0-64 28.7-64 64l384 0c0-35.3-28.7-64-64-64l-192 0 0-32z',
    ],
  ],
};
const faCurling = faCurlingStone;
const faGamepadModern = {
  prefix: 'fad',
  iconName: 'gamepad-modern',
  icon: [
    640,
    512,
    [127918, 63676, 'gamepad-alt'],
    'e5a2',
    [
      'M0 369.4c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7l0 2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7L424 384l-208 0-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2l0-2.8zM112 224c0 13.3 10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24zm280 48a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm64-96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M192 144c13.3 0 24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faGamepadAlt = faGamepadModern;
const faMessagesQuestion = {
  prefix: 'fad',
  iconName: 'messages-question',
  icon: [
    640,
    512,
    [],
    'e1e7',
    [
      'M0 64L0 256c0 35.3 28.7 64 64 64l32 0 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320 352 320c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM134.9 96.8c.2-1.1 .5-2.2 .9-3.3c.1-.3 .2-.7 .4-1c6.6-18.6 24.2-31.1 44-31.1c16.2 0 32.4 0 48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6c-9 5.1-17.9 10.3-26.9 15.4c-.2 10.9-9.1 19.6-20 19.6c-5.5 0-10.5-2.2-14.1-5.9c-1.8-1.8-3.3-4-4.3-6.4c-.5-1.2-.9-2.4-1.2-3.7c-.1-.7-.2-1.3-.3-2s-.1-1.3-.1-2c0-3.7 0-7.5 0-11.5c0-.3 0-.7 0-1.1s.1-.9 .1-1.3c.1-.9 .3-1.7 .5-2.6c.5-1.7 1.1-3.3 2-4.8c1.7-3 4.2-5.5 7.4-7.3c12.3-7.1 24.6-14.1 36.9-21.2c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4c-.1 .3-.2 .7-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2c-4.1-1.5-7.4-4.1-9.7-7.4c-1.2-1.7-2-3.5-2.7-5.4c-.3-1-.5-2-.7-3c-.1-.7-.2-1.5-.2-1.5l-.1-1.6c0-1.1 0-1.4 .1-1.7c0-.5 .1-1.1 .2-1.7zm46.5 148.5c.1-.9 .2-1.8 .4-2.6c.4-1.7 .9-3.4 1.6-5c1.3-3.2 3.3-6.1 5.7-8.5c4.8-4.8 11.5-7.8 18.9-7.8c14.7 0 26.7 11.9 26.7 26.7s-11.9 26.7-26.7 26.7c-7.4 0-14-3-18.9-7.8c-2.4-2.4-4.4-5.3-5.7-8.5c-.7-1.6-1.2-3.3-1.6-5c-.2-.9-.3-1.8-.4-2.7c0-.5-.1-.9-.1-1.4s0-.9 0-1.6c0-.3 0-.8 0-1.2s.1-.9 .1-1.3z',
      'M136.2 92.4c6.6-18.6 24.2-31.1 44-31.1l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 175c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 124.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 248a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0zM256 384l0-32 96 0c53 0 96-43 96-96l0-128 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448c-35.3 0-64-28.7-64-64z',
    ],
  ],
};
const faBookBible = {
  prefix: 'fad',
  iconName: 'book-bible',
  icon: [
    448,
    512,
    ['bible'],
    'f647',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM208 80l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-112 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faBible = faBookBible;
const faO = {
  prefix: 'fad',
  iconName: 'o',
  icon: [
    448,
    512,
    [111],
    '4f',
    ['M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z', ''],
  ],
};
const faSuitcaseMedical = {
  prefix: 'fad',
  iconName: 'suitcase-medical',
  icon: [
    512,
    512,
    ['medkit'],
    'f0fa',
    [
      'M96 96l0 384 32 0 0-352 0-32L96 96zm288 0l0 32 0 352 32 0 0-384-32 0z',
      'M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40 0 32 0 352 256 0 0-352 0-32 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM96 96L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l32 0L96 96zM416 480l32 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-32 0 0 384zM224 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faMedkit = faSuitcaseMedical;
const faBriefcaseArrowRight = {
  prefix: 'fad',
  iconName: 'briefcase-arrow-right',
  icon: [
    512,
    512,
    [],
    'e2f2',
    [
      'M0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56l0 40L64 96C28.7 96 0 124.7 0 160zM128 288c0-13.3 10.7-24 24-24l150.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l80 80c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17l-80 80c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l39-39L152 312c-13.3 0-24-10.7-24-24zM176 56c0-4.4 3.6-8 8-8l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40z',
      'M263 191c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L152 312c-13.3 0-24-10.7-24-24s10.7-24 24-24l150.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faExpandWide = {
  prefix: 'fad',
  iconName: 'expand-wide',
  icon: [
    512,
    512,
    [],
    'f320',
    [
      'M0 320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96zM352 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-64 0c-17.7 0-32-14.3-32-32z',
      'M0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96l0 96zM512 320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z',
    ],
  ],
};
const faClockElevenThirty = {
  prefix: 'fad',
  iconName: 'clock-eleven-thirty',
  icon: [
    512,
    512,
    [],
    'e348',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm168-96c0-7.8 3.8-15.4 10.7-20c11-7.4 25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128.7-60-90c-2.7-4.1-4-8.7-4-13.3z',
      'M256 416c-13.3 0-24-10.7-24-24l0-128.7-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3l0 136c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faRv = {
  prefix: 'fad',
  iconName: 'rv',
  icon: [
    640,
    512,
    [],
    'f7be',
    [
      'M112 448a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm320 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M224 16c0-8.8 7.2-16 16-16L368 0c8.8 0 16 7.2 16 16l0 16 128 0c53 0 96 43 96 96c0 17.7-14.3 32-32 32l-192 0 0 256-117.5 0c-13.2-37.3-48.7-64-90.5-64c-38.9 0-72.5 23.2-87.5 56.5L18.7 338.7C6.7 326.7 0 310.5 0 293.5L0 96C0 60.7 28.7 32 64 32l160 0 0-16zM96 144l0 64c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zM416 320l0-32 0-72 0-24 24 0 76.6 0c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3l0 16.8 0 64c0 17.7-14.3 32-32 32l-21.5 0c-13.2-37.3-48.7-64-90.5-64c-33.4 0-62.8 17-80 42.9l0-74.9zm162.1-32l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8L464 240l0 48 114.1 0z',
    ],
  ],
};
const faUserSecret = {
  prefix: 'fad',
  iconName: 'user-secret',
  icon: [
    448,
    512,
    [128373],
    'f21b',
    [
      'M112 167c2.6 .5 5.2 .9 7.9 1.3c2.6 .4 5.3 .8 8.1 1.2l0 14.4c0 22.1 17.9 40 40 40c4.1 0 8.3 0 12.4 0c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2c4.1 0 8.3 0 12.4 0c22.1 0 40-17.9 40-40l0-14.4c5.5-.8 10.9-1.7 16-2.6l0 17c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-17z',
      'M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 17.8 38.6 33.3 96 41.6l0 14.4c0 22.1 17.9 40 40 40l12.4 0c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2l12.4 0c22.1 0 40-17.9 40-40l0-14.4c57.4-8.3 96-23.8 96-41.6c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm44.1 496l149.2 0c17 0 30.7-13.8 30.7-30.7c0-57-29.6-107.1-74.2-135.8L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4l-59 0L273.7 490.5l-34-116.6 17.8-29.6c6.4-10.7-1.3-24.2-13.7-24.2L224 320l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2l17.8 29.6-34 116.6L104.4 224l-59 0C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5L74.2 345.5C29.6 374.2 0 424.3 0 481.3c0 17 13.8 30.7 30.7 30.7l149.2 0 88.1 0z',
    ],
  ],
};
const faOtter = {
  prefix: 'fad',
  iconName: 'otter',
  icon: [
    640,
    512,
    [129446],
    'f700',
    [
      'M64 144c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 21.4c0 23.5-19.1 42.6-42.6 42.6c-6.6 0-13.1-1.5-19.1-4.5l-12.9-6.4c-2.8-1.4-5.6-2.8-8.4-4.2l11.8-7.9c4.5-3 7.1-8 7.1-13.3l0-3.7c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24l0 3.7c0 5.3 2.7 10.3 7.1 13.3l11.8 7.9-8.4 4.2-12.9 6.4c-5.9 3-12.4 4.5-19.1 4.5C83.1 208 64 188.9 64 165.4L64 144zm16 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM96 255.4c3.5 .4 7 .6 10.6 .6c14.1 0 27.9-3.3 40.5-9.6L160 240l12.9 6.4c12.6 6.3 26.5 9.6 40.5 9.6c5.3 0 10.5-.5 15.6-1.3c12.8 38 48.7 65.3 91 65.3l32 0 32 0 0 16 0 48-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-35.3 0-64-28.7-64-64l0-.6zM208 144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6l0-21.4c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3l0-3.7c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6l0 .6c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l160 0 0-48 0-16c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6l0-16c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16l0 32 0 16 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-99.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1s0 0 0 0c0 123.7-100.3 224-224 224l-1.1 0L256 480l-.6 0C132 480 32 380 32 256.6l0-.6 0-39.2c-10.1-14.6-16-32.3-16-51.4L16 144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24l2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4 0 21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-13.3 0-24 10.7-24 24l0 8 56.4 0c-15.2 17-24.4 39.4-24.4 64l-32 0c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6z',
    ],
  ],
};
const faDreidel = {
  prefix: 'fad',
  iconName: 'dreidel',
  icon: [
    448,
    512,
    [],
    'f792',
    [
      'M89.4 153.4c79.1 79.1 158.2 158.2 237.3 237.3c22.9-22.9 45.8-45.8 68.7-68.7c18.7-18.7 18.7-49.1 0-67.9L333.3 192 438.6 86.6c12.5-12.5 12.5-32.8 0-45.3C432.4 35.1 424.2 32 416 32s-16.4 3.1-22.6 9.4L288 146.7 225.9 84.7c-18.7-18.7-49.1-18.7-67.9 0c-22.9 22.9-45.8 45.8-68.7 68.7z',
      'M326.6 390.6L89.4 153.4 18.7 224C6.7 236 0 252.3 0 269.3L0 416c0 35.3 28.7 64 64 64l146.7 0c17 0 33.3-6.7 45.3-18.7l70.6-70.6z',
    ],
  ],
};
const faPersonDress = {
  prefix: 'fad',
  iconName: 'person-dress',
  icon: [
    320,
    512,
    ['female'],
    'f182',
    [
      'M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M88 384l-17.8 0c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3l11.6 0c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1L232 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z',
    ],
  ],
};
const faFemale = faPersonDress;
const faCommentDollar = {
  prefix: 'fad',
  iconName: 'comment-dollar',
  icon: [
    512,
    512,
    [],
    'f651',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm188.1-37.5c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20c5.5 0 10.5 2.2 14.1 5.9c1.8 1.8 3.3 4 4.3 6.4c.5 1.2 .9 2.4 1.2 3.7c.1 .7 .2 1.3 .3 2s.1 1.3 .1 2.1c0 4.6 0 9.2 0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c0 .3 0 .5 0 .8c0 1.3 0 2.5-.1 3.8c-.1 1.2-.2 2.4-.4 3.6c-.3 2.4-.8 4.7-1.4 6.9c-1.2 4.4-3 8.5-5.2 12.2c-4.4 7.4-10.6 13.3-17.7 17.7c-7.2 4.5-15.2 7.3-23.2 9c0 4.6 0 9.2 0 14c0 .5 0 1.2-.1 1.8s-.2 1.3-.3 2c-.3 1.3-.7 2.5-1.2 3.7c-1 2.4-2.5 4.5-4.3 6.4c-3.6 3.6-8.6 5.9-14.1 5.9c-11 0-20-9-20-20c0-4.9 0-9.7 0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c2-1.3 3.5-2.6 4.5-4.3c.5-.8 .8-1.8 1.1-2.8c.1-.5 .2-1.1 .3-1.6c.1-.6 .1-1.1 .1-1.8c0-.3 0-.7-.1-1s-.1-.7-.2-1c-.2-.6-.4-1.3-.8-1.9c-.8-1.3-2.3-2.6-4.8-4.2c-6.3-4-15.4-6.9-28-10.7c-.6-.2-1.2-.4-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7zm98.4-9.4l.4 .1-.4-.1z',
      'M256 116c11 0 20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20z',
    ],
  ],
};
const faBusinessTime = {
  prefix: 'fad',
  iconName: 'business-time',
  icon: [
    640,
    512,
    ['briefcase-clock'],
    'f64a',
    [
      'M0 160l0 96 192 0 160 0 8.2 0c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7l0-32.7c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56l0 40L64 96C28.7 96 0 124.7 0 160zM0 288L0 416c0 35.3 28.7 64 64 64l296.2 0C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16c-.2 0-.5 0-.7 0l-96 0c-17.7 0-32-14.3-32-32l0-32L0 288zM176 56c0-4.4 3.6-8 8-8l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faBriefcaseClock = faBusinessTime;
const faFlowerTulip = {
  prefix: 'fad',
  iconName: 'flower-tulip',
  icon: [
    512,
    512,
    [127799],
    'f801',
    [
      'M0 349.5C0 439.3 72.7 512 162.5 512l61.5 0 32 0 32 0 61.5 0C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5L432 320c-59.5 0-112.1 29.5-144 74.8L288 256l-64 0 0 138.8C192.1 349.5 139.5 320 80 320l-50.5 0C13.2 320 0 333.2 0 349.5z',
      'M96 128V44c0-6.6 5.4-12 12-12c2.6 0 5.1 .8 7.2 2.4L176 80 243.2 5.3c3-3.4 7.4-5.3 11.9-5.3h1.7c4.5 0 8.9 1.9 11.9 5.3L336 80l60.8-45.6c2.1-1.6 4.6-2.4 7.2-2.4c6.6 0 12 5.4 12 12v84c0 70.7-57.3 128-128 128H224c-70.7 0-128-57.3-128-128z',
    ],
  ],
};
const faPeoplePantsSimple = {
  prefix: 'fad',
  iconName: 'people-pants-simple',
  icon: [
    512,
    512,
    [],
    'e21a',
    [
      'M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64z',
      'M25.9 233.4C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L192 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zm256 0c3.5-41.5 38.1-73.4 79.7-73.4l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L448 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z',
    ],
  ],
};
const faCloudDrizzle = {
  prefix: 'fad',
  iconName: 'cloud-drizzle',
  icon: [
    512,
    512,
    [],
    'f738',
    [
      'M40 376l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96-64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96-64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faTableCellsLarge = {
  prefix: 'fad',
  iconName: 'table-cells-large',
  icon: [
    512,
    512,
    ['th-large'],
    'f009',
    [
      'M64 224l0 64 160 0 0 128 64 0 0-128 160 0 0-64-160 0 0-128-64 0 0 128L64 224z',
      'M448 96l0 320L64 416 64 96l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
    ],
  ],
};
const faThLarge = faTableCellsLarge;
const faBookTanakh = {
  prefix: 'fad',
  iconName: 'book-tanakh',
  icon: [
    448,
    512,
    ['tanakh'],
    'f827',
    [
      'M32 384l64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0 0-64z',
      'M448 96c0-53-43-96-96-96L64 0 32 0C14.3 0 0 14.3 0 32L0 352c0 17.7 14.3 32 32 32l64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 288 0c53 0 96-43 96-96l0-320zM138.7 208l-13.9 24 27.7 0-13.9-24zm13.9-24l27.7 48 55.4 0 27.7-48-27.7-48-55.4 0-27.7 48zm-27.7 0L97.1 136c-6.2-10.7 1.5-24 13.9-24l55.4 0 27.7-48c6.2-10.7 21.6-10.7 27.7 0l27.7 48 55.4 0c12.3 0 20 13.3 13.9 24l-27.7 48 27.7 48c6.2 10.7-1.5 24-13.9 24l-55.4 0-27.7 48c-6.2 10.7-21.6 10.7-27.7 0l-27.7-48L111 256c-12.3 0-20-13.3-13.9-24l27.7-48zm27.7-48l-27.7 0 13.9 24 13.9-24zm41.6-24l27.7 0L208 88l-13.9 24zm69.3 24l13.9 24 13.9-24-27.7 0zm13.9 72l-13.9 24 27.7 0-13.9-24zm-55.4 48l-27.7 0L208 280l13.9-24z',
    ],
  ],
};
const faTanakh = faBookTanakh;
const faSolarSystem = {
  prefix: 'fad',
  iconName: 'solar-system',
  icon: [
    512,
    512,
    [],
    'e02f',
    [
      'M0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448C150 448 64 362 64 256c0-41.9 13.4-80.6 36.2-112.2c-1.4 .1-2.8 .2-4.2 .2c-.7 0-1.5 0-2.2 0s-1.4-.1-2.1-.1c-1.4-.1-2.8-.3-4.2-.6c-2.8-.5-5.5-1.2-8-2.2c-5.2-1.9-9.9-4.7-14.1-8.1c-8.3-6.9-14.3-16.5-16.5-27.5C18.2 147.7 0 199.7 0 256zm104 0c0 83.9 68.1 152 152 152s152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3C383.3 197.5 368.9 208 352 208c-.6 0-1.3 0-1.9 0s-1.3-.1-1.9-.1c7.5 14.4 11.8 30.8 11.8 48.2c0 57.4-46.6 104-104 104s-104-46.6-104-104s46.6-104 104-104c20.6 0 39.8 6 56 16.4l0-.4c0-.6 0-1.1 0-1.7s.1-1.1 .1-1.7c.1-1.1 .2-2.2 .4-3.3c.4-2.2 .9-4.3 1.6-6.3c1.4-4.1 3.4-7.8 5.9-11.2c5.1-6.7 12.2-11.8 20.5-14.2C316.4 113.5 287.3 104 256 104c-83.9 0-152 68.1-152 152zM138.8 28.4c18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192c0 41.9-13.4 80.6-36.2 112.2c1.4-.1 2.8-.2 4.2-.2c.7 0 1.5 0 2.2 0s1.4 .1 2.1 .1c1.4 .1 2.8 .3 4.2 .6c2.8 .5 5.5 1.2 8 2.2c5.2 1.9 9.9 4.7 14.1 8.1c8.3 6.9 14.3 16.5 16.5 27.5C493.9 364.2 512 312.2 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4z',
      'M96 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM392 168a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faSealQuestion = {
  prefix: 'fad',
  iconName: 'seal-question',
  icon: [
    512,
    512,
    [],
    'e243',
    [
      'M4.4 256c0 12.3 4.7 24.6 14.1 33.9L64 335.5 64 400c0 26.5 21.5 48 48 48l64.5 0 45.6 45.6c18.7 18.7 49.1 18.7 67.9 0L335.5 448l64.5 0c26.5 0 48-21.5 48-48l0-64.5 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5l0-64.5c0-26.5-21.5-48-48-48l-64.5 0L289.9 18.4c-18.7-18.7-49.1-18.7-67.9 0L176.5 64 112 64c-26.5 0-48 21.5-48 48l0 64.5L18.4 222.1C9 231.4 4.4 243.7 4.4 256zm165-89.5l.4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8c-10.8 6.2-21.5 12.3-32.3 18.5c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8c14.8-8.5 29.6-17 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6zM288 352a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faPhoneVolume = {
  prefix: 'fad',
  iconName: 'phone-volume',
  icon: [
    512,
    512,
    ['volume-control-phone'],
    'f2a0',
    [
      'M0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c1-3.5 1.4-7 1.4-10.5c0-15.8-9.4-30.6-24.6-36.9l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96C158.6 9.4 143.8 0 128 0c-3.5 0-7 .5-10.5 1.4l-88 24C12.1 30.2 0 46 0 64z',
      'M256 24c0-13.3 10.7-24 24-24C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zm0 200a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 96c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faVolumeControlPhone = faPhoneVolume;
const faDiscDrive = {
  prefix: 'fad',
  iconName: 'disc-drive',
  icon: [
    512,
    512,
    [],
    'f8b5',
    [
      'M96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 320c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0L96 480l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 96zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z',
    ],
  ],
};
const faHatCowboySide = {
  prefix: 'fad',
  iconName: 'hat-cowboy-side',
  icon: [
    640,
    512,
    [],
    'f8c1',
    [
      'M0 363.2c0 33.4 14 63.5 36.5 84.8l80.3 0C70 448 32 410 32 363.2c0-15.4 3.6-30.6 10.5-44.4l9.2-18.4C75.1 253.6 123 224 175.4 224c28.4 0 56.1 8.7 79.3 25L522.4 436.4C533.2 444 546 448 559.1 448l.9 0c2.5 0 5-.1 7.5-.3c40.7-3.8 72.5-38 72.5-79.7l0-8.1c0-12.7-2.7-25.2-7.8-36.8c-18.1-40.8-54-71-97.4-81.8l-32.1-8c1 5.1 1.9 10.1 2.9 15.2l3.7 19.5 17.7 4.4c33.8 8.4 61.7 32 75.9 63.8c3.3 7.5 5.1 15.6 5.1 23.8l0 8.1c0 26.5-21.5 48-48 48l-.9 0c-6.6 0-13-2-18.3-5.8L273 222.8c-28.6-20-62.7-30.8-97.7-30.8c-11.4 0-22.5 1.1-33.4 3.3C91 205.5 46.8 238.6 23 286.1l-9.2 18.4C4.7 322.7 0 342.8 0 363.2z',
      'M141.9 195.3l10.8-59.4c4.4-24.4 22.5-44 46.5-50.4L391.9 34.2c5.4-1.4 10.9-2.2 16.5-2.2l2.7 0c30.7 0 57.1 21.8 62.8 51.9l28.7 149.3 2.9 15.2 3.7 19.5 17.7 4.4c33.8 8.4 61.7 32 75.9 63.8c3.3 7.5 5.1 15.6 5.1 23.8l0 8.1c0 26.5-21.5 48-48 48l-.9 0c-6.6 0-13-2-18.3-5.8L273 222.8c-28.6-20-62.7-30.8-97.7-30.8c-11.4 0-22.5 1.1-33.4 3.3zM116.8 448C70 448 32 410 32 363.2c0-15.4 3.6-30.6 10.5-44.4l9.2-18.4C75.1 253.6 123 224 175.4 224c28.4 0 56.1 8.7 79.3 25L522.4 436.4C533.2 444 546 448 559.1 448L544 448l-427.2 0zM560 448c2.5 0 5-.1 7.5-.3l.5 .3-8 0z',
    ],
  ],
};
const faTableRows = {
  prefix: 'fad',
  iconName: 'table-rows',
  icon: [
    512,
    512,
    ['rows'],
    'e292',
    [
      'M128 224l0 64 320 0 0-64-320 0z',
      'M128 416l320 0 0-320L128 96l0 320zM64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480z',
    ],
  ],
};
const faRows = faTableRows;
const faLocationExclamation = {
  prefix: 'fad',
  iconName: 'location-exclamation',
  icon: [
    384,
    512,
    ['map-marker-exclamation'],
    'f608',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zM224 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM168 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M216 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM192 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMapMarkerExclamation = faLocationExclamation;
const faFaceFearful = {
  prefix: 'fad',
  iconName: 'face-fearful',
  icon: [
    512,
    512,
    [],
    'e375',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM84.3 138.9c-6-6.5-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8zM224 224A64 64 0 1 1 96 224a64 64 0 1 1 128 0zM176 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM416 224a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM320 96c0-8.8 7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c3.4 3.2 5.1 7.4 5.1 11.7c0 3.9-1.4 7.8-4.3 10.9c-6 6.5-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16z',
      'M176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM349 112.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
    ],
  ],
};
const faClipboardUser = {
  prefix: 'fad',
  iconName: 'clipboard-user',
  icon: [
    384,
    512,
    [],
    'f7f3',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM80 432c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16zM256 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faBusSchool = {
  prefix: 'fad',
  iconName: 'bus-school',
  icon: [
    512,
    512,
    [],
    'f5dd',
    [
      'M64 448l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0zm48.2-291.3c-.1 .5-.1 1.1-.1 1.6s0 1.1 0 1.6c0 21.3 0 42.7 0 64c0 .6 0 1.1 0 1.7s.1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4l96 0 0-128-96 0c-8.8 0-16.8 3.6-22.6 9.4c-2.9 2.9-5.2 6.3-6.9 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2zM272 128l0 128 96 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-96 0zm80 320l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0z',
      'M256 0C380.8 0 464 35.2 464 80l0 16 0 16 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-16 0 0 20.3c9.6 5.5 16 15.9 16 27.7l0 128c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-128c0-11.8 6.4-22.2 16-27.7L48 240l-16 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-16 0-16C48 35.2 131.2 0 256 0zM112 160l0 64c0 17.7 14.3 32 32 32l96 0 0-128-96 0c-17.7 0-32 14.3-32 32zm160 96l96 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-96 0 0 128zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 80c0-8.8-7.2-16-16-16L176 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faFilmSlash = {
  prefix: 'fad',
  iconName: 'film-slash',
  icon: [
    640,
    512,
    [],
    'e179',
    [
      'M64 146.4L64 416c0 35.3 28.7 64 64 64l359.4 0-87-68.5c-4.8 2.9-10.4 4.5-16.4 4.5l-128 0c-17.7 0-32-14.3-32-32l0-64c0-14.1 9.1-26.1 21.8-30.3l-71.1-56c.8 2 1.3 4.1 1.3 6.4l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c.9 0 1.9 .1 2.8 .2L64 146.4zM89.5 44.9C134.3 80 179.2 115.1 224 150.3l0-22.3c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-65.9 0c85.7 67.2 171.5 134.4 257.2 201.6c.5-3.1 .7-6.3 .7-9.6l0-320c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9zM112 368c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM464 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faSquareArrowDownRight = {
  prefix: 'fad',
  iconName: 'square-arrow-down-right',
  icon: [
    448,
    512,
    [],
    'e262',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 72c0-6.1 2.3-12.3 7-17s10.8-7 17-7s12.3 2.3 17 7l135 135L288 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24l-152 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L119 185c-4.7-4.7-7-10.8-7-17z',
      'M312 368l-152 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135L288 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24z',
    ],
  ],
};
const faBookSparkles = {
  prefix: 'fad',
  iconName: 'book-sparkles',
  icon: [
    448,
    512,
    ['book-spells'],
    'f6b8',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM264 200l-38.8 16.6c-6.5 2.8-6.5 11.9 0 14.7L264 248l16.6 38.8c2.8 6.5 11.9 6.5 14.7 0L312 248l38.8-16.6c6.5-2.8 6.5-11.9 0-14.7L312 200l-16.6-38.8c-2.8-6.5-11.9-6.5-14.7 0L264 200zM168.8 78.3L160 96l-17.7 8.8c-5.9 2.9-5.9 11.4 0 14.3L160 128l8.8 17.7c2.9 5.9 11.4 5.9 14.3 0L192 128l17.7-8.8c5.9-2.9 5.9-11.4 0-14.3L192 96l-8.8-17.7c-2.9-5.9-11.4-5.9-14.3 0z',
    ],
  ],
};
const faBookSpells = faBookSparkles;
const faWashingMachine = {
  prefix: 'fad',
  iconName: 'washing-machine',
  icon: [
    448,
    512,
    ['washer'],
    'f898',
    [
      'M80 304c0 79.5 64.5 144 144 144c77.6 0 140.9-61.4 143.9-138.2C350 315.4 328.1 320 304 320c-32 0-56-16-80-32s-48-32-80-32c-19.7 0-40.6 4.7-59 10.4c-3.2 12-5 24.6-5 37.6zM160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faWasher = faWashingMachine;
const faChild = {
  prefix: 'fad',
  iconName: 'child',
  icon: [
    320,
    512,
    [],
    'f1ae',
    [
      'M96 64a64 64 0 1 0 128 0A64 64 0 1 0 96 64z',
      'M144 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192.2L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8 240 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0z',
    ],
  ],
};
const faLiraSign = {
  prefix: 'fad',
  iconName: 'lira-sign',
  icon: [
    320,
    512,
    [8356],
    'f195',
    [
      'M0 224c0-17.7 14.3-32 32-32l16 0 0 64-16 0c-17.7 0-32-14.3-32-32zm0 96c0-17.7 14.3-32 32-32l16 0 0 44.5c0 6.6-.7 13.1-2 19.5l-14 0c-17.7 0-32-14.3-32-32zm110.8 32c.4-3.2 .7-6.4 .9-9.7c.1-1.6 .2-3.2 .2-4.9s.1-3.3 .1-4.9l0-44.5 112 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-113.2 0zM112 192l112 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-112 0 0-64z',
      'M176.4 96c-35.5 0-64.4 28.8-64.4 64.4l0 172.2c0 29-7.9 57.5-22.8 82.3l-.7 1.1L288 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l29.8-49.6c9-14.9 13.7-32 13.7-49.4l0-172.2C48 89.5 105.5 32 176.4 32c13.8 0 27.5 2.2 40.6 6.6l81.2 27.1c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L196.7 99.3c-6.6-2.2-13.4-3.3-20.4-3.3z',
    ],
  ],
};
const faUserVisor = {
  prefix: 'fad',
  iconName: 'user-visor',
  icon: [
    448,
    512,
    [],
    'e04c',
    [
      'M105 175.2c1.1 .3 2.3 .4 3.4 .6c.6 .1 1.2 .1 1.8 .1s1.2 0 1.8 0l224 0c2.4 0 4.8-.3 7-.8C324.2 222.5 278 256 224 256s-100.2-33.5-119-80.8zM124.1 48C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48L124.1 48zM284 459c3.9-36.5 15.9-66.5 35.7-89.5c1.5-1.8 4.9-1.9 6.1 .1c18.9 24.6 29 55 30.1 90.2c0 3.9-4.9 5.7-7.3 2.5c-12.2-17.2-17.6-23-19.9-25c-9.5 0-22.5 11.4-32.9 20.5c-2.1 1.8-3.9 3.4-5.5 4.6c-2.8 2-6.8 .1-6.5-3.5z',
      'M80 80c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-64zm48 32c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L144 96c-8.8 0-16 7.2-16 16zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zm348.7-19.9c2.4 3.2 7.3 1.4 7.3-2.5c-1.1-35.3-11.3-65.6-30.1-90.2c-1.2-2-4.6-1.9-6.1-.1c-19.9 23-31.9 53-35.7 89.5c-.3 3.5 3.7 5.5 6.5 3.5c1.8-1.4 4.1-3.4 6.6-5.6c0 0 0 0 0 0c9.2-8.1 22.3-19.5 31.7-19.5c2.3 2 7.6 7.8 19.9 25z',
    ],
  ],
};
const faFilePlusMinus = {
  prefix: 'fad',
  iconName: 'file-plus-minus',
  icon: [
    384,
    512,
    [],
    'e177',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM112 272c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM208 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48zM128 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z',
    ],
  ],
};
const faChessClockFlip = {
  prefix: 'fad',
  iconName: 'chess-clock-flip',
  icon: [
    640,
    512,
    ['chess-clock-alt'],
    'f43e',
    [
      'M96 112c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 16L96 128l0-16zm68.7 180.7l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM384 56c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 48-48 0 0-48-32 0c-13.3 0-24-10.7-24-24zm64 184c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z',
      'M0 192c0-35.3 28.7-64 64-64l512 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z',
    ],
  ],
};
const faChessClockAlt = faChessClockFlip;
const faSatellite = {
  prefix: 'fad',
  iconName: 'satellite',
  icon: [
    512,
    512,
    [128752],
    'f7bf',
    [
      'M103 103c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4L322.3 96.4 233 7c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7l-96 96zM285.7 319.6L375 409c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4C372.3 233 329 276.3 285.7 319.6z',
      'M377.4 41.4c12.5-12.5 32.8-12.5 45.3 0l48 48c12.5 12.5 12.5 32.8 0 45.3L270.2 335.1c11.4 24.6 17.8 52 17.8 80.9c0 31.7-7.7 61.5-21.2 87.8c-4.7 9-16.7 10.3-23.8 3.1L135.3 399.3l-16.4 16.4c.7 2.6 1.1 5.4 1.1 8.3c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32c2.9 0 5.6 .4 8.3 1.1l16.4-16.4L5.1 269.1c-7.2-7.2-5.9-19.2 3.1-23.8C34.5 231.7 64.3 224 96 224c28.9 0 56.3 6.4 80.9 17.8L377.4 41.4z',
    ],
  ],
};
const faTruckFire = {
  prefix: 'fad',
  iconName: 'truck-fire',
  icon: [
    640,
    512,
    [],
    'e65a',
    [
      'M0 24C0 37.3 10.7 48 24 48l8 0 0 50.7C37 97 42.4 96 48 96l32 0 0-48 56 0 0 48 48 0 0-48 48 0 0 48 48 0 0-48 56 0 0 48 48 0 0-48 232 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24zM80 432a80 80 0 1 0 160 0A80 80 0 1 0 80 432zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M496 96c0-17.7 14.3-32 32-32s32 14.3 32 32l16 0c35.3 0 64 28.7 64 64l0 96 0 112c0 26.5-21.5 48-48 48l-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-98.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L48 416c-26.5 0-48-21.5-48-48L0 256l400 0 16 0 0-16 0-144 32 0 48 0zM384 96l0 128L0 224l0-80c0-26.5 21.5-48 48-48l336 0zM576 256l0-96-96 0 0 96 96 0z',
    ],
  ],
};
const faPlaneLock = {
  prefix: 'fad',
  iconName: 'plane-lock',
  icon: [
    640,
    512,
    [],
    'e558',
    [
      'M0 297.3l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c7.8 0 14-6.3 14-14l0-18 0-24c0-5-2.4-9.8-6.4-12.8L320 400l0-70.9 64.2 18.3c1.5-21.8 13.9-40.6 31.8-50.9l0-24.6c0-12.4 2-24.4 5.8-35.6L320 178.3l0-84.6C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faSteeringWheel = {
  prefix: 'fad',
  iconName: 'steering-wheel',
  icon: [
    512,
    512,
    [],
    'f622',
    [
      'M64 256c0 10.9 .9 21.6 2.7 32l102.2 0L224 358.9l0 86.5c10.4 1.7 21.1 2.7 32 2.7s21.6-.9 32-2.7l0-86.5L343.1 288l102.2 0c1.7-10.4 2.7-21.1 2.7-32s-.9-21.6-2.7-32L352 224l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7l-120.4 0c-12.1 0-23.2 6.8-28.6 17.7L160 224l-93.3 0c-1.7 10.4-2.7 21.1-2.7 32z',
      'M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
    ],
  ],
};
const faTag = {
  prefix: 'fad',
  iconName: 'tag',
  icon: [
    448,
    512,
    [127991],
    'f02b',
    [
      'M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
      '',
    ],
  ],
};
const faStretcher = {
  prefix: 'fad',
  iconName: 'stretcher',
  icon: [
    640,
    512,
    [],
    'f825',
    [
      'M192 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 108-78.5-81.6 0L368 336.9 300.8 288l-81.6 0 108 78.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm224 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M15.2 77C34.5 58.9 64.9 59.8 83 79.2L188.8 192 592 192c26.5 0 48 21.5 48 48s-21.5 48-48 48l-410.1 0c-22.1 0-43.2-9.2-58.4-25.3L13 144.8C-5.1 125.5-4.2 95.1 15.2 77z',
    ],
  ],
};
const faBookSection = {
  prefix: 'fad',
  iconName: 'book-section',
  icon: [
    448,
    512,
    ['book-law'],
    'e0c1',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zM228.5 241.3c-22.1-5.9-68-18.1-59.5-62.7c2.1-11.2 7.9-20.4 16.7-27.5c-12.2-9.4-20.7-23.1-16.7-44.5c6.1-31.8 40.4-48 87.5-41.3c8.3 1.2 18 3.5 30.2 7.3c8.4 2.6 13.2 11.6 10.5 20c-2.6 8.4-11.7 13.1-20 10.5c-10.6-3.3-18.6-5.3-25.2-6.2c-27.8-4-49.1 2.5-51.6 15.7c-1.8 9.3-.2 16.1 36.2 25.8l7.3 1.9c0 0 0 0 0 0c30.1 7.8 75.6 19.6 67 64.7c-2.1 11.2-8 20.5-16.7 27.6c12.6 9.5 20.7 23.2 16.7 44.4c-5.2 27-30.8 42.8-67.3 42.8c-6.4 0-13.2-.5-20.2-1.5c-12.9-1.8-26.6-6.2-38.6-10.1c0 0 0 0 0 0l-5.8-1.9c-8.4-2.7-13.1-11.7-10.4-20.1c2.7-8.4 11.7-13.1 20.1-10.4l5.9 1.9c10.7 3.5 22.9 7.5 33.1 8.9c28 3.9 49.2-2.5 51.7-15.7c2.4-12.8-5.7-17.9-43.6-27.7l-7.5-2zm-2.9-72.8c-8.7 1.2-23 4.8-25.2 16.1c-1.8 9.3-.2 16.1 36.2 25.8c0 0 14.1 3.7 17.7 4.7c8.7-1.2 23-4.8 25.2-16.1c2.4-12.8-5.7-17.9-43.6-27.7c0 0-9.4-2.5-10.3-2.7z',
    ],
  ],
};
const faBookLaw = faBookSection;
const faInboxes = {
  prefix: 'fad',
  iconName: 'inboxes',
  icon: [
    512,
    512,
    [],
    'e1bb',
    [
      'M0 400l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-76.2 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L48 352c-26.5 0-48 21.5-48 48zM79.3 160l45 0c12.1 0 23.2 6.8 28.6 17.7c4.8 9.5 9.5 19.1 14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l45 0L394.3 64 117.7 64c-12.8 32-25.6 64-38.4 96z',
      'M79.3 160l38.4-96 276.7 0 38.4 96-45 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7l-45 0zm33-160c-22.9 0-43.5 13.9-52 35.2L4 175.8c-2.6 6.6-4 13.7-4 20.8L0 264c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-67.4c0-7.1-1.4-14.2-4-20.8L451.7 35.2C443.2 13.9 422.6 0 399.8 0L112.2 0z',
    ],
  ],
};
const faCoffeeBean = {
  prefix: 'fad',
  iconName: 'coffee-bean',
  icon: [
    448,
    512,
    [],
    'e13e',
    [
      'M38.8 428.8c-67-75.7-45.3-211 50.9-307.1C148.3 62.9 221.5 32 286.9 32c30.4 0 59.1 6.7 83.8 20.4c-3.7 10.2-8.5 22.7-14.1 36c-14.5 34.5-33 70.5-51.4 89c-28.7 28.9-57.5 43.4-89.7 59.4c-.3 .1-.5 .3-.8 .4c-31.9 15.9-67 33.4-101.5 68.2c-25.2 25.4-48.7 68.8-65.1 103.2c-3.4 7-6.5 13.8-9.4 20.2zm38.8 31c3.9-9.1 8.6-19.5 13.9-30.5c16.5-34.5 37.1-71.1 55.9-90.1c28.7-28.9 57.5-43.4 89.7-59.4c.3-.1 .5-.3 .8-.4c31.9-15.9 67-33.4 101.5-68.2c25.6-25.8 47.1-69.8 61.6-104.2c3.4-8 6.4-15.7 9.2-22.8c25.5 29.4 37.9 67.6 37.9 108.9c0 65.4-30.9 138.6-89.6 197.3c-85.9 85.9-202.9 112.3-280.9 69.4z',
      'M339.3 211.2c25.6-25.8 47.1-69.8 61.6-104.2c3.4-8 6.4-15.7 9.2-22.8c-2.2-2.5-4.5-5-6.9-7.4c-9.8-9.8-20.7-17.9-32.5-24.4c-3.7 10.2-8.5 22.7-14.1 36c-14.5 34.5-33 70.5-51.4 89c-28.7 28.9-57.5 43.4-89.7 59.4l-.8 .4c-31.9 15.9-67 33.4-101.5 68.2c-25.2 25.4-48.7 68.8-65.1 103.2c-3.4 7-6.5 13.8-9.4 20.2c1.9 2.2 4 4.3 6.1 6.4c9.8 9.8 20.8 18 32.7 24.6c3.9-9.1 8.6-19.5 13.9-30.5c16.5-34.5 37.1-71.1 55.9-90.1c28.7-28.9 57.5-43.4 89.7-59.4l.8-.4c31.9-15.9 67-33.4 101.5-68.2z',
    ],
  ],
};
const faCircleYen = {
  prefix: 'fad',
  iconName: 'circle-yen',
  icon: [
    512,
    512,
    [],
    'e5d0',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm152.1-90.5c.1-.8 .2-1.6 .4-2.4c.3-1.6 .8-3.2 1.5-4.7c1.3-3 3.3-5.8 5.9-8.2c4.6-4.2 10.4-6.2 16.1-6.2c6.5 0 13 2.6 17.8 7.9c20.8 22.8 41.5 45.6 62.2 68.5c20.7-22.8 41.5-45.6 62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6c5.2 4.7 7.9 11.2 7.9 17.8c0 5.8-2.1 11.5-6.2 16.1c-16.9 18.6-33.8 37.2-50.8 55.9c8.3 0 16.7 0 25 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-16 0-32 0-48 0c0 5.3 0 10.7 0 16c16 0 32 0 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c0 8.3 0 16.7 0 25c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.5c0-8.3 0-16.7 0-25l-48 0c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.7c0-.6 0-1.4 .1-2.2c.1-.8 .2-1.6 .4-2.4c.3-1.6 .8-3.1 1.4-4.5c1.2-2.9 3-5.4 5.1-7.6c4.3-4.3 10.3-7 17-7c16 0 32 0 48 0c0-5.3 0-10.7 0-16c-16 0-32 0-48 0c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.5l0-.3c0-.6 0-1.4 .1-2.2c.1-.8 .2-1.6 .4-2.4c.3-1.6 .8-3.1 1.4-4.5c1.2-2.9 3-5.4 5.1-7.6c4.3-4.3 10.3-7 17-7c8.3 0 16.7 0 25 0l-50.8-55.9c-2.1-2.3-3.6-4.9-4.7-7.6c-.5-1.4-.9-2.8-1.2-4.2c-.2-1.1-.3-2.1-.3-2.1c-.1-1.1-.1-1.1-.1-2.3c.1-1.6 .1-2 .1-2.4z',
      'M193.8 151.9c-8.9-9.8-24.1-10.5-33.9-1.6s-10.5 24.1-1.6 33.9L209 240l-25 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 16-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 25c0 13.3 10.7 24 24 24s24-10.7 24-24l0-25 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-16 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-25 0 50.8-55.9c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6L256 220.3l-62.2-68.5z',
    ],
  ],
};
const faBracketsCurly = {
  prefix: 'fad',
  iconName: 'brackets-curly',
  icon: [
    576,
    512,
    [],
    'f7ea',
    [
      'M352 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 37.5c0 25.5 10.1 49.9 28.1 67.9L498.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9l0 37.5c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c53 0 96-43 96-96l0-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6l0-37.5c0-53-43-96-96-96l-32 0c-17.7 0-32 14.3-32 32z',
      'M64 128c0-53 43-96 96-96l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32l0 37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9l0 37.5c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-53 0-96-43-96-96l0-37.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3c6-6 9.4-14.1 9.4-22.6L64 128z',
    ],
  ],
};
const faEllipsisStrokeVertical = {
  prefix: 'fad',
  iconName: 'ellipsis-stroke-vertical',
  icon: [
    192,
    512,
    ['ellipsis-v-alt'],
    'f39c',
    [
      'M24 256a72 72 0 1 0 144 0A72 72 0 1 0 24 256zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96A72 72 0 1 1 96 24a72 72 0 1 1 0 144zm0 224a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96a72 72 0 1 1 0-144 72 72 0 1 1 0 144z',
    ],
  ],
};
const faEllipsisVAlt = faEllipsisStrokeVertical;
const faComment = {
  prefix: 'fad',
  iconName: 'comment',
  icon: [
    512,
    512,
    [128489, 61669],
    'f075',
    [
      'M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z',
      '',
    ],
  ],
};
const faSquare1 = {
  prefix: 'fad',
  iconName: 'square-1',
  icon: [
    448,
    512,
    [],
    'e256',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM136 360c0 13.3 10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184c0-8.6-4.6-16.5-12-20.8c-3.7-2.2-7.9-3.2-12-3.2c-4.1 0-8.2 1.1-11.9 3.2l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4 200 336l-40 0c-13.3 0-24 10.7-24 24z',
      'M248 152c0-8.6-4.6-16.5-12-20.8s-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4 200 336l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184z',
    ],
  ],
};
const faCakeCandles = {
  prefix: 'fad',
  iconName: 'cake-candles',
  icon: [
    448,
    512,
    [127874, 'birthday-cake', 'cake'],
    'f1fd',
    [
      'M0 288c0-35.3 28.7-64 64-64l64 0 64 0 64 0 64 0 64 0c35.3 0 64 28.7 64 64l0 89.2c-8.4 4-18.1 6.8-28.8 6.8c-35.9 0-67.2-32-67.2-32s-28.1 32-64 32s-64-32-64-32s-28.1 32-64 32s-64-32-64-32s-31.3 32-67.2 32c-10.7 0-20.4-2.8-28.8-6.8L0 288zM56 69.2c0-7.6 2-15 5.8-21.6L86.4 5.5C88.4 2.1 92 0 96 0s7.6 2.1 9.6 5.5l24.5 42.1c3.8 6.5 5.8 14 5.8 21.6l0 2.8c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-2.8zm128 0c0-7.6 2-15 5.8-21.6L214.4 5.5C216.4 2.1 220 0 224 0s7.6 2.1 9.6 5.5l24.5 42.1c3.8 6.5 5.8 14 5.8 21.6l0 2.8c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-2.8zm128 0c0-7.6 2-15 5.8-21.6L342.4 5.5C344.4 2.1 348 0 352 0s7.6 2.1 9.6 5.5l24.5 42.1c3.8 6.5 5.8 14 5.8 21.6l0 2.8c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-2.8z',
      'M128 176l0 48-64 0 0-48c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 48-64 0 0-48c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 48-64 0 0-48c0-17.7 14.3-32 32-32s32 14.3 32 32zM0 464l0-86.8c8.4 4 18.1 6.8 28.8 6.8C64.7 384 96 352 96 352s28.1 32 64 32s64-32 64-32s28.1 32 64 32s64-32 64-32s31.3 32 67.2 32c10.7 0 20.4-2.8 28.8-6.8l0 86.8c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48z',
    ],
  ],
};
const faBirthdayCake = faCakeCandles;
const faCake = faCakeCandles;
const faHeadSide = {
  prefix: 'fad',
  iconName: 'head-side',
  icon: [
    512,
    512,
    [],
    'f6e9',
    [
      'M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM320 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M320 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faTruckLadder = {
  prefix: 'fad',
  iconName: 'truck-ladder',
  icon: [
    640,
    512,
    [],
    'e657',
    [
      'M0 24C0 10.7 10.7 0 24 0L328 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 96 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-96-8 0C10.7 48 0 37.3 0 24zM80 48l0 96 32 0 0-96L80 48zM240 432A80 80 0 1 1 80 432a80 80 0 1 1 160 0zM160 48l0 96 32 0 0-96-32 0zm80 0l0 96 32 0 0-96-32 0zM560 432a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
      'M416 96c-17.7 0-32 14.3-32 32l0 96L48 224c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l1.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l98.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l1.1 0c26.5 0 48-21.5 48-48l0-80 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L544 114.7c-12-12-28.3-18.7-45.3-18.7L416 96zM576 256l-128 0 0-96 50.7 0L576 237.3l0 18.7z',
    ],
  ],
};
const faEnvelope = {
  prefix: 'fad',
  iconName: 'envelope',
  icon: [
    512,
    512,
    [128386, 9993, 61443],
    'f0e0',
    [
      'M0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c5.7 4.3 12.4 6.4 19.2 6.4s13.5-2.1 19.2-6.4L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4l0 272c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 112z',
      'M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64z',
    ],
  ],
};
const faDollyEmpty = {
  prefix: 'fad',
  iconName: 'dolly-empty',
  icon: [
    576,
    512,
    [],
    'f473',
    [
      'M351.9 416A96 96 0 1 1 160 416a96 96 0 1 1 191.9 0z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l72.9 0L197 340.2c16.3-12.7 36.7-20.2 59-20.2c.6 0 1.2 0 1.7 0L165.7 43.8C156.9 17.6 132.5 0 104.9 0L32 0zM331.8 357c12.7 16.3 20.2 36.7 20.2 59c0 .6 0 1.2 0 1.7l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2L331.8 357z',
    ],
  ],
};
const faFaceTissue = {
  prefix: 'fad',
  iconName: 'face-tissue',
  icon: [
    512,
    512,
    [],
    'e39c',
    [
      'M0 256c0 11.5 .8 22.9 2.2 34c1.9-.6 3.9-1 5.9-1.4l192-32c15.3-2.5 30.9 2.4 41.8 13.4s16 26.5 13.4 41.8l-7.9 47.2 8.5 5.7 39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 371.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0l-5.4-3.6L223.3 503.9c-.3 2-.8 4-1.4 5.9c11.1 1.5 22.5 2.2 34 2.2c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm172.6 37.4l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8z',
      'M223.8 306.6c.8-5.1-.8-10.3-4.5-13.9s-8.8-5.3-13.9-4.5l-192 32c-6.7 1.1-11.9 6.3-13.1 13s1.9 13.4 7.8 16.7l45.5 26L32.5 460.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l84.2-21.1 26 45.5c3.4 5.9 10 9 16.7 7.8s11.9-6.4 13-13.1l32-192z',
    ],
  ],
};
const faAnglesUp = {
  prefix: 'fad',
  iconName: 'angles-up',
  icon: [
    448,
    512,
    ['angle-double-up'],
    'f102',
    [
      'M32 416c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-160-160c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4l-160 160C35.1 399.6 32 407.8 32 416z',
      'M201.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 109.3 86.6 246.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z',
    ],
  ],
};
const faAngleDoubleUp = faAnglesUp;
const faBinRecycle = {
  prefix: 'fad',
  iconName: 'bin-recycle',
  icon: [
    576,
    512,
    [],
    'e5f7',
    [
      'M0 64C0 46.3 14.3 32 32 32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zm32 64l512 0L517.3 421.8c-3 33-30.6 58.2-63.7 58.2l-331.1 0c-33.1 0-60.7-25.2-63.7-58.2L32 128zM136 361.6c0 30.1 24.4 54.4 54.4 54.4l49.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-49.6 0c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l21.5-30.7c7.9-11.3 4.7-26.8-6.9-34.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2zm86.4-140.6c-7.9 11.3-4.7 26.8 6.9 34.1c10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6c1.3-1.8 3.3-2.9 5.5-2.9s4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6c11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-20.7 29.6zM312 392c0 13.3 10.7 24 24 24l49.6 0c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6c-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4L336 368c-13.3 0-24 10.7-24 24z',
      'M282.5 218.9c1.3-1.8 3.3-2.9 5.5-2.9s4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6c11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-20.7 29.6c-7.9 11.3-4.7 26.8 6.9 34.1c10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6zM206.6 327.2c7.9-11.3 4.7-26.8-6.9-34.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4l49.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-49.6 0c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l21.5-30.7zM336 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l49.6 0c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6c-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4L336 368z',
    ],
  ],
};
const faPaperclip = {
  prefix: 'fad',
  iconName: 'paperclip',
  icon: [
    448,
    512,
    [128206],
    'f0c6',
    [
      'M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z',
      '',
    ],
  ],
};
const faChartLineDown = {
  prefix: 'fad',
  iconName: 'chart-line-down',
  icon: [
    512,
    512,
    [128201],
    'f64d',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M326.6 121.4c-12.5-12.5-32.8-12.5-45.3 0L208 194.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0L304 189.3l57.4 57.4L329 279c-15.1 15.1-4.4 41 17 41L456 320c13.3 0 24-10.7 24-24l0-110.1c0-21.4-25.9-32.1-41-17l-32.4 32.4-80-80z',
    ],
  ],
};
const faArrowRightToCity = {
  prefix: 'fad',
  iconName: 'arrow-right-to-city',
  icon: [
    640,
    512,
    [],
    'e4b3',
    [
      'M288 48l0 416c0 26.5 21.5 48 48 48l96 0 160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-24 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0-144c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48zm64 32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm160 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M121.4 153.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l114.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3z',
    ],
  ],
};
const faLockA = {
  prefix: 'fad',
  iconName: 'lock-a',
  icon: [
    448,
    512,
    [],
    'e422',
    [
      'M0 256L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-16 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144l0 48-16 0c-35.3 0-64 28.7-64 64zM129.7 424.8C156.3 371.6 183 318.3 209.6 265c.8-1.6 1.8-3 3.1-4.3c1.4-1.4 3.1-2.6 5-3.4c2.1-.9 4.2-1.3 6.4-1.3s4.3 .4 6.4 1.3c1.8 .8 3.5 1.9 4.9 3.4c1.3 1.3 2.3 2.7 3.1 4.3c26.6 53.3 53.3 106.6 79.9 159.9c.6 1.1 1 2.3 1.3 3.5c.2 .9 .3 1.8 .3 1.8c.1 .9 .1 .9 .1 1.8c0 .7 0 .9 0 1.1c0 .4-.1 .7-.1 1.1c-.1 .7-.2 1.4-.4 2.1c-.4 1.4-1 2.7-1.7 4c-1.5 2.5-3.7 4.6-6.5 6c-2.3 1.1-4.7 1.7-7.1 1.7c-5.9 0-11.5-3.2-14.3-8.8c-6.5-13.1-13.1-26.1-19.6-39.2l-92.2 0c-6.5 13.1-13.1 26.1-19.6 39.2c-2.8 5.6-8.5 8.8-14.3 8.8c-2.4 0-4.8-.5-7.1-1.7c-7.9-4-11.1-13.6-7.2-21.5zM144 144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48-160 0 0-48zm49.9 224l60.2 0c-10-20.1-20.1-40.1-30.1-60.2c-10 20.1-20.1 40.1-30.1 60.2z',
      'M235.3 260.7c-1.4-1.4-3.1-2.6-4.9-3.4c-2.1-.9-4.2-1.3-6.4-1.3s-4.3 .4-6.4 1.3c-1.8 .8-3.5 1.9-4.9 3.4c-1.3 1.3-2.3 2.7-3.1 4.3L129.7 424.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 400l92.2 0 19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5L238.4 265c-.8-1.6-1.8-3-3.1-4.3zM254.1 368l-60.2 0L224 307.8 254.1 368z',
    ],
  ],
};
const faRibbon = {
  prefix: 'fad',
  iconName: 'ribbon',
  icon: [
    448,
    512,
    [127895],
    'f4d6',
    [
      'M18.7 440c0 11 5.6 21.8 16.1 27.8l55.1 31.5c5 2.8 10.4 4.2 15.9 4.2c8.7 0 17.3-3.6 23.6-10.3l97.7-106.3c-27.8-31.9-55.6-63.7-83.3-95.6L27.1 418.5c-5.7 6.2-8.4 13.9-8.4 21.6zM96 64c16.7 18.2 33.4 36.4 50 54.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L352 64 328 32C312.9 11.9 289.2 0 264 0L184 0c-25.2 0-48.9 11.9-64 32L96 64z',
      'M96 64L420.9 418.5c13.9 15.1 10.1 39.2-7.7 49.4L358.8 499c-13.2 7.6-30 4.7-40-6.8L87.6 227.1C72.4 209.6 64 187.2 64 164l0-23c0-19 5.6-37.5 16.1-53.3L96 64zM328.4 270.2L245.7 180 352 64l19.4 33.9c8.3 14.5 12.6 30.9 12.6 47.6l0 25.8c0 23.6-8.7 46.4-24.5 64l-31.2 34.8z',
    ],
  ],
};
const faLungs = {
  prefix: 'fad',
  iconName: 'lungs',
  icon: [
    640,
    512,
    [129729],
    'f604',
    [
      'M.2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2C226 480.5 256 442.1 256 398l0-111.4L161.2 347c-14.9 9.5-34.7 5.1-44.2-9.8c-3.4-5.3-5-11.3-5-17.2c0-10.6 5.2-20.9 14.8-27c43.1-27.4 86.1-54.8 129.2-82.2l0-45.5C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412zM384 165.3l0 45.5c43.1 27.4 86.1 54.8 129.2 82.2c4.8 3 8.5 7.2 11 11.8c1.3 2.3 2.2 4.8 2.8 7.4c.3 1.3 .6 2.6 .7 3.9c.1 .6 .1 1.3 .2 1.9c0 .3 0 .7 .1 2c0 1.5-.1 1.9-.1 2.3c-.1 .7-.1 1.4-.2 2.2c-.2 1.5-.5 2.9-.9 4.4c-.8 2.9-2.1 5.7-3.8 8.4c-6.1 9.6-16.5 14.8-27 14.8c-5.9 0-11.8-1.6-17.1-5L384 286.7 384 398c0 44.1 30 82.5 72.7 93.1l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3z',
      'M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 132.1c0 16.4-8.4 31.7-22.2 40.5L126.8 293c-14.9 9.5-19.3 29.3-9.8 44.2s29.3 19.3 44.2 9.8l139-88.4c7.3-4.6 13.9-10.1 19.9-16.1c5.9 6 12.6 11.5 19.9 16.1l139 88.4c14.9 9.5 34.7 5.1 44.2-9.8s5.1-34.7-9.8-44.2l-139-88.4c-13.8-8.8-22.2-24.1-22.2-40.5L352 32z',
    ],
  ],
};
const faPersonPinball = {
  prefix: 'fad',
  iconName: 'person-pinball',
  icon: [
    640,
    512,
    [],
    'e21d',
    [
      'M192 288l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 320 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256 0-8 0-37.8L640 32c0-17.7-14.3-32-32-32L544 0c-17.7 0-32 14.3-32 32l0 42.8c0 6.9 1.1 13.7 3.3 20.2l32.8 98.5-295 49.2c1.9 4 2.9 8.6 2.9 13.3c0 17.7-14.3 32-32 32l-32 0zm112 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7l0 65.1 49.9 49.9c9 9 14.1 21.2 14.1 33.9l0 89.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L18.7 320C6.7 308 0 291.7 0 274.7l0-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64 62.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-71.4 0c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64L64 480s0 0 0 0c0 17.7-14.3 32-32 32s-32-14.3-32-32z',
    ],
  ],
};
const faArrowUp91 = {
  prefix: 'fad',
  iconName: 'arrow-up-9-1',
  icon: [
    576,
    512,
    ['sort-numeric-up-alt'],
    'f887',
    [
      'M344 120c0 39.2 25.6 72.4 61.1 83.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88zm8 328c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32zM464 120a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortNumericUpAlt = faArrowUp91;
const faAppleCore = {
  prefix: 'fad',
  iconName: 'apple-core',
  icon: [
    384,
    512,
    [],
    'e08f',
    [
      'M176 80l0 16c0 8.8 7.2 16 16 16l16 0c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16L256 0c-44.2 0-80 35.8-80 80z',
      'M29.9 462.4c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3c-34.9 0-69.8-18.3-98.1-49.6z',
    ],
  ],
};
const faCircleY = {
  prefix: 'fad',
  iconName: 'circle-y',
  icon: [
    512,
    512,
    [],
    'e12f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128.1-90.5c.1-.8 .2-1.7 .4-2.5c.3-1.6 .9-3.3 1.6-4.8c1.4-3.1 3.5-6 6.2-8.3c10-8.7 25.2-7.6 33.9 2.4c28.6 33 57.2 66.1 85.9 99.1c28.6-33 57.2-66.1 85.9-99.1c4.7-5.5 11.4-8.3 18.1-8.3c5.6 0 11.2 1.9 15.7 5.9c5.5 4.7 8.3 11.4 8.3 18.1c0 5.6-1.9 11.2-5.9 15.7C345.4 221.5 312.7 259.2 280 297l0 79c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-1.2-.4-2.4-.4-2.4c-.1-1.2-.1-1.2-.1-2.5c0-26.4 0-52.7 0-79L133.9 183.7c-2-2.3-3.4-4.8-4.4-7.5c-.5-1.3-.9-2.7-1.1-4.1c-.2-1-.3-2.1-.3-2.1c-.1-1-.1-1-.1-2.1c0-.8 0-1 0-1.3c0-.4 .1-.8 .1-1.2z',
      'M136.3 149.9c10-8.7 25.2-7.6 33.9 2.4L256 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297l0 79c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-79L133.9 183.7c-8.7-10-7.6-25.2 2.4-33.9z',
    ],
  ],
};
const faH6 = {
  prefix: 'fad',
  iconName: 'h6',
  icon: [
    640,
    512,
    [],
    'e413',
    [
      'M0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M537 116c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L389 198.5c-24 29.9-37 67.1-37 105.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-77.6-61.4-140.9-138.3-143.9L537 116zm39 188a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
    ],
  ],
};
const faLitecoinSign = {
  prefix: 'fad',
  iconName: 'litecoin-sign',
  icon: [
    384,
    512,
    [],
    'e1d3',
    [
      'M1.2 264.8C5.2 278.8 18.1 288 32 288c2.9 0 5.9-.4 8.8-1.2L64 280.1c0-22.2 0-44.4 0-66.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6zM128 195.3l0 66.6 136.8-39.1c14.1-4 23.2-16.8 23.2-30.8c0-2.9-.4-5.9-1.2-8.8c-4.9-17-22.6-26.8-39.6-22L128 195.3z',
      'M96 32c17.7 0 32 14.3 32 32l0 352 224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32L64 64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faBottleBaby = {
  prefix: 'fad',
  iconName: 'bottle-baby',
  icon: [
    512,
    512,
    [],
    'e673',
    [
      'M112 272l88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 16c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-176c0-31.2-10.1-61.5-28.8-86.4L352 160l-192 0-19.2 25.6C122.1 210.5 112 240.8 112 272zM192 96l128 0c0-19.6-11.1-37.5-28.6-46.3L288 48l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16-3.4 1.7C203.1 58.5 192 76.4 192 96z',
      'M192 96c-17.7 0-32 14.3-32 32l0 32 192 0 0-32c0-17.7-14.3-32-32-32L192 96zM112 272l0 48 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm0 112l0 48 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0z',
    ],
  ],
};
const faCircleSmall = {
  prefix: 'fad',
  iconName: 'circle-small',
  icon: [320, 512, [], 'e122', ['M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z', '']],
};
const faBorderNone = {
  prefix: 'fad',
  iconName: 'border-none',
  icon: [
    448,
    512,
    [],
    'f850',
    [
      'M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
      '',
    ],
  ],
};
const faArrowTurnDownLeft = {
  prefix: 'fad',
  iconName: 'arrow-turn-down-left',
  icon: [
    512,
    512,
    [],
    'e2e1',
    [
      'M77.3 288l32 32L416 320c53 0 96-43 96-96l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160c0 17.7-14.3 32-32 32l-306.7 0-32 32z',
      'M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 288 182.6 182.6c12.5-12.5 12.5-32.8 0-45.3z',
    ],
  ],
};
const faCircleWifiCircleWifi = {
  prefix: 'fad',
  iconName: 'circle-wifi-circle-wifi',
  icon: [
    640,
    512,
    ['circle-wifi-group'],
    'e67e',
    [
      'M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-17.9 2.7-35.1 7.6-51.4c-4.5-.7-8.9-2.6-12.6-5.9c-15.6-14.1-36.3-22.7-59-22.7s-43.4 8.6-59 22.7c-9.8 8.9-25 8.1-33.9-1.7s-8.1-25 1.7-33.9C188.9 253.3 220.9 240 256 240c34.8 0 66.7 13.1 90.7 34.7c8.9-14.2 19.8-27.1 32.2-38.2C345.7 208.7 302.8 192 256 192c-49.4 0-94.4 18.6-128.5 49.3c-9.8 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9C137.9 167.3 194.3 144 256 144s118.1 23.3 160.6 61.6c1.2 1.1 2.3 2.3 3.3 3.6c23-11.1 48.8-17.3 76.1-17.3c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zM288 368a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM425.4 347.1c-6.6 5.9-16.7 5.4-22.6-1.2s-5.4-16.7 1.2-22.6c24.4-21.9 56.6-35.3 92-35.3s67.7 13.4 92 35.3c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2C547.9 330.2 523.2 320 496 320s-51.9 10.2-70.6 27.1zM496 412a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-28c-12.1 0-23.2 4.6-31.5 12.1c-6.6 5.9-16.7 5.4-22.6-1.1s-5.4-16.7 1.1-22.6c14-12.7 32.6-20.4 53-20.4s39 7.7 53 20.4c6.6 5.9 7.1 16 1.1 22.6s-16 7.1-22.6 1.1c-8.3-7.5-19.4-12.1-31.5-12.1z',
    ],
  ],
};
const faCircleWifiGroup = faCircleWifiCircleWifi;
const faCircleNodes = {
  prefix: 'fad',
  iconName: 'circle-nodes',
  icon: [
    512,
    512,
    [],
    'e4e2',
    [
      'M114.1 280.4c20-9.4 35.4-26.9 42.1-48.2L301.9 359.6c-20 9.4-35.4 26.9-42.1 48.2L114.1 280.4zm22.1-129.3L320 77.5c0 .8 0 1.7 0 2.5c0 22.3 9.1 42.4 23.8 56.9L160 210.5c0-.9 0-1.6 0-2.5c0-1.5 0-2.8-.1-4.2c-.1-1.4-.2-2.7-.3-4.1c-.3-2.7-.7-5.4-1.2-8c-.5-2.6-1.2-5.2-2-7.7c-.4-1.2-.8-2.5-1.3-3.7s-.9-2.4-1.5-3.7c-4.1-9.6-10.1-18.3-17.4-25.5zM317.6 354.1l37.8-207.7c6.4 4.3 13.4 7.7 20.9 10c3.7 1.2 7.6 2.1 11.6 2.7c2 .3 4 .5 6 .7c1 .1 2 .1 3.1 .2s2 .1 3.1 .1c6.3 0 12.5-.7 18.4-2.1L380.6 365.6c-6.4-4.3-13.4-7.7-20.9-10c-3.7-1.2-7.6-2.1-11.6-2.7c-2-.3-4-.5-6-.7c-1-.1-2-.1-3.1-.2s-2-.1-3.1-.1c-6.3 0-12.5 .7-18.4 2.1z',
      'M320 80a80 80 0 1 1 160 0A80 80 0 1 1 320 80zM256 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM80 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faParachuteBox = {
  prefix: 'fad',
  iconName: 'parachute-box',
  icon: [
    512,
    512,
    [],
    'f4cd',
    [
      'M24.9 192l43.2 0L188.3 324.2c6-2.7 12.7-4.2 19.7-4.2l32 0 0-128 32 0 0 128 32 0c7 0 13.7 1.5 19.7 4.2L443.8 192l43.2 0L346.8 346.3c3.3 6.5 5.2 13.9 5.2 21.7l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-7.8 1.9-15.2 5.2-21.7L24.9 192z',
      'M128.5 192l254.9 0c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16zM358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16l77.6 0c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7zm-205.7 0C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192l77.6 0c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3z',
    ],
  ],
};
const faReflectHorizontal = {
  prefix: 'fad',
  iconName: 'reflect-horizontal',
  icon: [
    512,
    512,
    [],
    'e664',
    [
      'M0 128L0 384c0 12.9 7.8 24.6 19.8 29.6c4 1.6 8.1 2.4 12.2 2.4c8.3 0 16.5-3.3 22.6-9.4l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9S0 115.1 0 128zM329.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c6.1 6.1 14.3 9.4 22.6 9.4c4.1 0 8.3-.8 12.2-2.4c12-5 19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z',
      'M256 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faMessageMedical = {
  prefix: 'fad',
  iconName: 'message-medical',
  icon: [
    512,
    512,
    ['comment-alt-medical'],
    'f7f4',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM160 192l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z',
      'M240 112c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faCommentAltMedical = faMessageMedical;
const faRugbyBall = {
  prefix: 'fad',
  iconName: 'rugby-ball',
  icon: [
    512,
    512,
    [],
    'e3c6',
    [
      'M16 336C16 159.3 159.3 16 336 16l32 0c30.1 0 57.7 10.4 79.5 27.7c-8.5-4.2-18.8-6.3-30.4-6.3c-59.1 0-153.9 52.9-240.4 139.4C73.4 280.2 17.9 395.7 43.7 447.5C26.4 425.7 16 398.1 16 368l0-32zM64.4 468.3c51.9 25.8 167.3-29.7 270.7-133.1S494.1 116.4 468.3 64.5C485.6 86.3 496 113.9 496 144l0 32c0 176.7-143.3 320-320 320l-32 0c-30.1 0-57.7-10.4-79.6-27.7z',
      'M64.4 468.3c-7.7-6.1-14.6-13.1-20.7-20.7C17.9 395.7 73.4 280.2 176.8 176.8S395.7 17.9 447.5 43.7c7.7 6.1 14.6 13.1 20.7 20.7c25.8 51.9-29.7 167.3-133.1 270.7S116.3 494.1 64.4 468.3z',
    ],
  ],
};
const faCommentMusic = {
  prefix: 'fad',
  iconName: 'comment-music',
  icon: [
    512,
    512,
    [],
    'f8b0',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm128 80c0-17.7 21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 320c0 17.7-21.5 32-48 32s-48-14.3-48-32z',
      'M345.1 114.8c4.3 3 6.9 7.9 6.9 13.2l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 320c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8z',
    ],
  ],
};
const faIndent = {
  prefix: 'fad',
  iconName: 'indent',
  icon: [
    448,
    512,
    [],
    'f03c',
    [
      'M0 64C0 81.7 14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM192 192c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32z',
      'M127.8 243.4c8.2 6.4 8.2 18.9 0 25.3L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3z',
    ],
  ],
};
const faTreeDeciduous = {
  prefix: 'fad',
  iconName: 'tree-deciduous',
  icon: [
    512,
    512,
    [127795, 'tree-alt'],
    'f400',
    [
      'M0 288c0 53 43 96 96 96l128 0 0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224 128 0c53 0 96-43 96-96c0-39.7-24.1-73.8-58.5-88.4c6.7-11.7 10.5-25.2 10.5-39.6c0-44.2-35.8-80-80-80c-11.5 0-22.5 2.4-32.4 6.8C347 38.1 305.9 0 256 0s-91 38.1-95.6 86.8C150.5 82.4 139.5 80 128 80c-44.2 0-80 35.8-80 80c0 14.4 3.8 27.9 10.5 39.6C24.1 214.2 0 248.3 0 288z',
      'M256 128c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faTreeAlt = faTreeDeciduous;
const faPuzzlePieceSimple = {
  prefix: 'fad',
  iconName: 'puzzle-piece-simple',
  icon: [
    640,
    512,
    ['puzzle-piece-alt'],
    'e231',
    [
      'M264.8 64C277.6 64 288 74.4 288 87.2c0 9.2-5.8 17.3-13.2 22.8c-11.6 8.7-18.8 20.7-18.8 34c0 26.5 28.7 48 64 48s64-21.5 64-48c0-13.3-7.2-25.3-18.8-34c-7.4-5.5-13.2-13.6-13.2-22.8C352 74.4 362.4 64 375.2 64L464 64c26.5 0 48 21.5 48 48l0 88.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2l0 88.8c0 26.5-21.5 48-48 48l-88.8 0c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2L176 448c-26.5 0-48-21.5-48-48l0-88.8c0-12.8-10.4-23.2-23.2-23.2c-9.2 0-17.3 5.8-22.8 13.2C73.3 312.8 61.3 320 48 320c-26.5 0-48-28.7-48-64s21.5-64 48-64c13.3 0 25.3 7.2 34 18.8c5.5 7.4 13.6 13.2 22.8 13.2c12.8 0 23.2-10.4 23.2-23.2l0-88.8c0-26.5 21.5-48 48-48l88.8 0z',
      '',
    ],
  ],
};
const faPuzzlePieceAlt = faPuzzlePieceSimple;
const faTruckFieldUn = {
  prefix: 'fad',
  iconName: 'truck-field-un',
  icon: [
    640,
    512,
    [],
    'e58e',
    [
      'M96 400a80 80 0 1 0 160 0A80 80 0 1 0 96 400zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M96 32C60.7 32 32 60.7 32 96l0 32c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l33.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l66.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l33.1 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32c0-35.3-28.7-64-64-64l-4.2 0c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38l-51.8 0C364.4 44.9 343.7 32 320 32L96 32zm288 96l43.2 0 42.7 96L384 224l0-96zm-130.7 7.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faNfcTrash = {
  prefix: 'fad',
  iconName: 'nfc-trash',
  icon: [
    640,
    512,
    [],
    'e1fd',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l317.6 0-6.1-84.8C366.9 407.8 352.4 416 336 416l-224 0c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-128 0-96c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16l0 66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48l0 50.7c5-1.8 10.4-2.7 16-2.7l18.3 0 2.7-5.5c5.7-11.3 15.4-19.7 26.9-23.8L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M464 192c-6.1 0-11.6 3.4-14.3 8.8L438.1 224 400 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 128 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-38.1 0-11.6-23.2c-2.7-5.4-8.2-8.8-14.3-8.8l-96 0zm-64 96l13.9 194.3C415.1 499 429 512 445.8 512l132.4 0c16.8 0 30.7-13 31.9-29.7L624 288l-224 0z',
    ],
  ],
};
const faHourglass = {
  prefix: 'fad',
  iconName: 'hourglass',
  icon: [
    384,
    512,
    [9203, 62032, 'hourglass-empty'],
    'f254',
    [
      'M32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11 32 0 32 0 192 0 32 0 32 0 0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11-32 0L64 64 32 64z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faHourglassEmpty = faHourglass;
const faMountain = {
  prefix: 'fad',
  iconName: 'mountain',
  icon: [
    512,
    512,
    [127956],
    'f6fc',
    [
      'M135.7 191.7l59.5 79.3c.4 .5 .8 1 1.3 1.5s.9 .9 1.4 1.3c1 .8 2 1.5 3.1 2c.6 .3 1.1 .5 1.7 .7s1.2 .4 1.7 .5c1.2 .3 2.4 .4 3.6 .4c4.8 0 9.6-2.1 12.8-6.4c8.5-11.4 17.1-22.8 25.6-34.1c6-8.1 15.5-12.8 25.6-12.8l124.6 0L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L135.7 191.7z',
      'M396.6 224L272 224c-10.1 0-19.6 4.7-25.6 12.8l-25.6 34.1c-6.4 8.5-19.2 8.5-25.6 0l-59.5-79.3L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480l400.2 0c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L396.6 224z',
    ],
  ],
};
const faFileXmark = {
  prefix: 'fad',
  iconName: 'file-xmark',
  icon: [
    384,
    512,
    ['file-times'],
    'f317',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM104 384c0 6.1 2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7c15.7-15.7 31.4-31.4 47-47l47 47c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-47-47c15.7-15.7 31.3-31.3 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47c-15.7 15.7-31.4 31.4-47 47c-4.7 4.7-7 10.8-7 17z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM111 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faFileTimes = faFileXmark;
const faHouseHeart = {
  prefix: 'fad',
  iconName: 'house-heart',
  icon: [
    576,
    512,
    ['home-heart'],
    'f4c9',
    [
      'M64 270.5L64.1 448c0 35.3 28.7 64 64 64l320.4 0c35.4 0 64-28.7 64-64c-.1-59.2-.3-118.3-.4-177.4L288 74.5 64 270.5zm112 46.7c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z',
      'M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2l-256-224zM176 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
    ],
  ],
};
const faHomeHeart = faHouseHeart;
const faHouseChimneyBlank = {
  prefix: 'fad',
  iconName: 'house-chimney-blank',
  icon: [
    576,
    512,
    [],
    'e3b0',
    [
      'M64 270.5c74.7-65.3 149.3-130.7 224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1l-320.4 0c-35.3 0-64-28.6-64-64L64 270.5z',
      'M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5 512 64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 37.5L309.1 7.9z',
    ],
  ],
};
const faMeterBolt = {
  prefix: 'fad',
  iconName: 'meter-bolt',
  icon: [
    640,
    512,
    [],
    'e1e9',
    [
      'M0 256C0 397.4 114.6 512 256 512c73.7 0 140.1-31.1 186.8-81l7.5-15L432 416c-20.4 0-38.5-12.9-45.3-32.1s-.6-40.6 15.3-53.4l109.6-87.7C504.8 107.5 393 0 256 0C114.6 0 0 114.6 0 256zm128-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32z',
      'M606.3 247.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8z',
    ],
  ],
};
const faUserDoctor = {
  prefix: 'fad',
  iconName: 'user-doctor',
  icon: [
    448,
    512,
    ['user-md'],
    'f0f0',
    [
      'M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M280 304c2.7 0 5.3 .1 8 .2l0 57.8c-27.6 7.1-48 32.2-48 62l0 40c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-40c0-29.8-20.4-54.9-48-62l0-53.2C393.5 326.7 448 393 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-79 54.5-145.3 128-163.2l0 61.5c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-66.1c2.7-.1 5.3-.2 8-.2l112 0zM144 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faUserMd = faUserDoctor;
const faSlashBack = {
  prefix: 'fad',
  iconName: 'slash-back',
  icon: [
    320,
    512,
    [],
    '5c',
    [
      'M16.1 4.2C.8 13-4.6 32.5 4.2 47.9l256 448c8.8 15.3 28.3 20.7 43.7 11.9s20.7-28.3 11.9-43.7l-256-448C51 .8 31.5-4.6 16.1 4.2z',
      '',
    ],
  ],
};
const faCircleInfo = {
  prefix: 'fad',
  iconName: 'circle-info',
  icon: [
    512,
    512,
    ['info-circle'],
    'f05a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192-8c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64-24 0c-13.3 0-24-10.7-24-24zm96-88a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 248c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64-24 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faInfoCircle = faCircleInfo;
const faFishingRod = {
  prefix: 'fad',
  iconName: 'fishing-rod',
  icon: [
    448,
    512,
    [],
    'e3a8',
    [
      'M0 320L0 480c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-8 0 0-55.2c0-75 49.7-140.9 121.8-161.5L287 49.2c2.9-.8 5.8-1.2 8.8-1.2C313.6 48 328 62.4 328 80.1l0 55.9c0 13.3 10.7 24 24 24s24-10.7 24-24l0-55.9C376 35.9 340.1 0 295.9 0c-7.4 0-14.9 1-22 3.1L196.7 25.1C103.9 51.6 40 136.4 40 232.8L40 288l-8 0c-17.7 0-32 14.3-32 32z',
      'M345 195.9c-33.5 20.3-89 76.6-89 148.1c0 32 16 80 64 112l-27.3 27.3c-3 3-4.7 7.1-4.7 11.3l0 1.4c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-1.4c0-4.2-1.7-8.3-4.7-11.3L384 456c48-32 64-80 64-112c0-71.6-55.6-127.8-89-148.1c-4.3-2.6-9.6-2.6-14 0zM360 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faHammerCrash = {
  prefix: 'fad',
  iconName: 'hammer-crash',
  icon: [
    640,
    512,
    [],
    'e414',
    [
      'M283.2 383.2c0 4.8 2.2 9.4 6 12.5c5.1 4.1 12.2 4.6 17.9 1.4l91.4-52.2 59.7 86.8c3 4.4 8 6.9 13.2 6.9c1.2 0 2.4-.1 3.6-.4c6.4-1.5 11.2-6.7 12.2-13.1l16.2-104.1 105.1 7.4c6.5 .5 12.7-3.1 15.5-9s1.8-12.9-2.6-17.8L550.1 224l71.3-77.5c4.4-4.8 5.5-11.9 2.6-17.8s-9-9.5-15.5-9l-105.1 7.4L487.3 23c-1-6.5-5.9-11.7-12.2-13.1c-1.2-.3-2.4-.4-3.6-.4c-5.2 0-10.2 2.5-13.2 6.9L405.6 93c12 18.4 14.2 42.5 3.7 63.6l-64 128c-8.9 17.8-25 29.7-43.1 33.8l-18.3 60.1c-.5 1.5-.7 3.1-.7 4.6z',
      'M43.4 33.7C48.8 22.8 59.9 16 72 16l120 0c5 0 9.9 1.2 14.3 3.4l160 80c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3l-65.9-32.9s0 0 0 0L122 208.8s0 0 0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80zM5.1 442.5L107.6 237.4l85.9 42.9L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.2 5.1 442.5z',
    ],
  ],
};
const faMessageHeart = {
  prefix: 'fad',
  iconName: 'message-heart',
  icon: [
    512,
    512,
    [],
    'e5c9',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM144 173.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
      'M205.3 112c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z',
    ],
  ],
};
const faCloudMeatball = {
  prefix: 'fad',
  iconName: 'cloud-meatball',
  icon: [
    512,
    512,
    [],
    'f73b',
    [
      'M0 400a48 48 0 1 0 96 0A48 48 0 1 0 0 400zm144 0c0 17.7 14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3c-12.2-12.2-31.9-12.5-44.4-.8l-2.8 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-2.8 0c-12.5-11.7-32.2-11.4-44.4 .8c-12.5 12.5-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32zm272 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96l-44.7 0c-9.5-23.5-32.5-40-59.3-40c-2 0-3.9 .1-5.8 .3C294.4 265.5 276.3 256 256 256s-38.4 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-26.9 0-49.9 16.5-59.3 40L96 320z',
    ],
  ],
};
const faCameraPolaroid = {
  prefix: 'fad',
  iconName: 'camera-polaroid',
  icon: [
    576,
    512,
    [],
    'f8aa',
    [
      'M0 361.7c0-3.3 .2-6.5 .7-9.7l574.5 0c.5 3.2 .7 6.4 .7 9.7l0 54.3c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-54.3zM96 416c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0c-8.8 0-16 7.2-16 16zM224 192c0-1.1 0-2.2 .1-3.3c.1-1.1 .1-2.2 .2-3.2c.2-2.1 .5-4.3 1-6.3c.9-4.2 2.1-8.2 3.7-12c3.2-7.7 7.9-14.6 13.7-20.3C254.3 135.2 270.3 128 288 128c35.3 0 64 28.7 64 64s-28.7 64-64 64c-17.7 0-33.7-7.2-45.3-18.7c-5.8-5.8-10.5-12.7-13.7-20.3c-1.6-3.8-2.9-7.8-3.7-12c-.4-2.1-.8-4.2-1-6.4c-.1-1.1-.2-2.1-.2-3.2c-.1-1.1-.1-2.2-.1-3.3z',
      'M64 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 150.3 53.3 79.9c5.2 7.8 8.6 16.6 10 25.8L.7 352c1.4-9.2 4.8-18 10-25.8L64 246.3 64 96zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM448 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faCamera = {
  prefix: 'fad',
  iconName: 'camera',
  icon: [
    512,
    512,
    [62258, 'camera-alt'],
    'f030',
    [
      'M160 288a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
    ],
  ],
};
const faCameraAlt = faCamera;
const faSquareVirus = {
  prefix: 'fad',
  iconName: 'square-virus',
  icon: [
    448,
    512,
    [],
    'e578',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM62.6 254.9c0-13.3 10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c10.3 10.3 24.4 11.9 35.8 7.1c5.7-2.4 10.8-6.3 14.4-11.5c1.8-2.6 3.3-5.5 4.3-8.6c.5-1.6 .9-3.2 1.2-4.9c.1-.9 .2-1.7 .3-2.6c.1-.8 .1-1.6 .1-2.7c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.5c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.4c0 .6 0 1.4-.1 2.2s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24.3c0-.8 0-1.6-.1-2.4c-.1-.9-.2-1.8-.3-2.6c-.3-1.7-.7-3.4-1.2-4.9c-1-3.2-2.5-6-4.3-8.6c-3.6-5.2-8.7-9.1-14.4-11.5c-11.4-4.7-25.4-3.2-35.8 7.1c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24z',
      'M247.8 117.7c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2zM160 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faCartArrowUp = {
  prefix: 'fad',
  iconName: 'cart-arrow-up',
  icon: [
    576,
    512,
    [],
    'e3ee',
    [
      'M120.1 32c2 4.2 3.5 8.8 4.4 13.5c15.4 80.8 30.8 161.6 46.2 242.5L312 288l0-110.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23L360 288l99.2 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.4-39.9-40-39.9l-411 0z',
      'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM312 177.9L312 288l48 0 0-110.1 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23z',
    ],
  ],
};
const faMeteor = {
  prefix: 'fad',
  iconName: 'meteor',
  icon: [
    512,
    512,
    [9732],
    'f753',
    [
      'M0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309zm320 11A128 128 0 1 1 64 320a128 128 0 1 1 256 0z',
      'M64 320a128 128 0 1 1 256 0A128 128 0 1 1 64 320zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faCarOn = {
  prefix: 'fad',
  iconName: 'car-on',
  icon: [
    512,
    512,
    [],
    'e4dd',
    [
      'M32 56c0 6.1 2.3 12.3 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0c-4.7 4.7-7 10.8-7 17zM232 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24zM391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17c-9.4-9.4-24.6-9.4-33.9 0L391 87z',
      'M170.8 234.6L151.7 288l208.6 0-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6l-140.3 0c-6.8 0-12.8 4.3-15.1 10.6zM82.2 292.4l28.3-79.3C121.9 181.3 152 160 185.8 160l140.3 0c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6l0 40 0 64 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32 0-64 0-40c0-23.2 14.1-43.1 34.2-51.6zM152 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faSleigh = {
  prefix: 'fad',
  iconName: 'sleigh',
  icon: [
    640,
    512,
    [],
    'f7cc',
    [
      'M32 448c0 17.7 14.3 32 32 32l488 0c48.6 0 88-39.4 88-88l0-8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 8c0 13.3-10.7 24-24 24l-104 0-64 0-192 0-64 0-64 0c-17.7 0-32 14.3-32 32z',
      'M0 64C0 46.3 14.3 32 32 32l23 0 9 0c2.3 0 4.6 .2 6.7 .7c54.2 4.9 103.5 34.9 132.7 81.6l4.3 6.9c40 64 110.1 102.9 185.6 102.9c30.2 0 54.7-24.5 54.7-54.7l0-41.3c0-17.7 14.3-32 32-32l32 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 96c0 53-43 96-96 96l0 64-64 0 0-64-192 0 0 64-64 0 0-64c-53 0-96-43-96-96L32 96C14.3 96 0 81.7 0 64z',
    ],
  ],
};
const faArrowDown19 = {
  prefix: 'fad',
  iconName: 'arrow-down-1-9',
  icon: [
    576,
    512,
    ['sort-numeric-asc', 'sort-numeric-down'],
    'f162',
    [
      'M344 336c0 39.2 25.6 72.4 61.1 83.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88zm8-144c0 17.7 14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32zM464 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortNumericAsc = faArrowDown19;
const faSortNumericDown = faArrowDown19;
const faBuoyMooring = {
  prefix: 'fad',
  iconName: 'buoy-mooring',
  icon: [
    576,
    512,
    [],
    'e5b6',
    [
      'M0 480c0 2.4 .3 4.8 .8 7.3C4.3 502 17.4 512 32 512c2.4 0 4.8-.3 7.3-.8c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2C10 452.3 0 465.4 0 480zM153 288l65.3 0 139.5 0 65.3 0L395.9 152.5C387.8 111.9 358 80.3 320 68.7L320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 36.7c-38 11.5-67.8 43.2-75.9 83.7L153 288z',
      'M153 288L131.5 395.2c.4 .3 .9 .6 1.3 .9c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c.4-.3 .9-.6 1.3-.9L423 288l-65.3 0-139.5 0L153 288z',
    ],
  ],
};
const faSquare4 = {
  prefix: 'fad',
  iconName: 'square-4',
  icon: [
    448,
    512,
    [],
    'e259',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM112.3 292.2c-.1 .6-.2 1.3-.2 1.9s-.1 1.3-.1 1.9c0 .9 0 .9 .1 1.9c0 0 .1 .9 .2 1.8c.2 1.2 .5 2.4 .9 3.6c.8 2.4 1.9 4.6 3.4 6.7c4.5 6.3 11.8 10 19.5 10c34.7 0 69.3 0 104 0c0 13.3 0 26.7 0 40c0 1.2 0 1.2 .1 2.5c0 0 .1 1.2 .4 2.4c.3 1.6 .8 3.1 1.4 4.5c1.2 2.9 3 5.5 5.1 7.6c4.3 4.3 10.3 7 17 7c13.3 0 24-10.7 24-24l0-40c2.7 0 5.3 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24c-2.7 0-5.3 0-8 0c0-18.7 0-37.3 0-56c0-13.3-10.7-24-24-24c-6.6 0-12.6 2.7-17 7c-2.2 2.2-3.9 4.8-5.1 7.6c-.6 1.4-1.1 2.9-1.4 4.5c-.2 .8-.3 1.6-.4 2.4s-.1 1.6-.1 2.5l0 56c-23.6 0-47.1 0-70.7 0c12.5-37.5 25-74.9 37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2c-16 48-32 96-48 144c-.4 1.2-.7 2.5-.9 3.8z',
      'M206.8 159.6c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l104 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-70.7 0 37.5-112.4z',
    ],
  ],
};
const faHandHoldingDroplet = {
  prefix: 'fad',
  iconName: 'hand-holding-droplet',
  icon: [
    576,
    512,
    ['hand-holding-water'],
    'f4c1',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M209.2 103L275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3z',
    ],
  ],
};
const faHandHoldingWater = faHandHoldingDroplet;
const faFileEps = {
  prefix: 'fad',
  iconName: 'file-eps',
  icon: [
    512,
    512,
    [],
    'e644',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM160 368l0 64 0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm117.7-80c-25.2 0-45.7 20.4-45.7 45.7c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7L424 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l34.3 0c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7l26.3 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-26.3 0z',
    ],
  ],
};
const faTricycleAdult = {
  prefix: 'fad',
  iconName: 'tricycle-adult',
  icon: [
    640,
    512,
    [],
    'e5c4',
    [
      'M0 352c0-24.4 9.1-46.6 24-63.5C41.6 268.6 67.4 256 96 256c41.9 0 77.5 26.8 90.6 64.2c3.5 10 5.4 20.7 5.4 31.8c0 16.9-4.3 32.7-12 46.5c3.8 1 7.8 1.5 12 1.5c26.5 0 48-21.5 48-48c0-8.1-2-15.8-5.6-22.5c17.6 3.4 35.2 6.9 52.8 10.3c.5 4 .8 8.1 .8 12.2c0 53-43 96-96 96c-17.5 0-33.9-4.7-48-12.8c-14.1 8.2-30.5 12.8-48 12.8c-53 0-96-43-96-96zM33.9 138.8c-6-16.6 2.7-35 19.3-40.9C56.8 96.6 60.4 96 64 96c13.1 0 25.4 8.1 30.1 21.2l14.9 41.7c1.9 5.2 6.3 9.1 11.8 10.3l77.7 16.3c17.3 3.6 28.4 20.6 24.7 37.9s-20.6 28.4-37.9 24.7l-77.7-16.3c-27.2-5.7-49.5-25.1-58.9-51.3L33.9 138.8zM48 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm592 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zm-144 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M312 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l31.4 0c2.6 0 5 1.3 6.5 3.4l79.2 112.5-48.2 64.3c-5.6 7.5-14.4 11.9-23.7 11.9c-1.9 0-3.8-.2-5.7-.5l-322.9-63c-13-2.5-25.6 6-28.2 19s6 25.6 19 28.2l4.6 .9C41.6 268.6 67.4 256 96 256c41.9 0 77.5 26.8 90.6 64.2l155.7 30.4c4.9 1 9.9 1.4 14.9 1.4c24.4 0 47.4-11.5 62.1-31.1l38.8-51.8 13.7 19.5c10.6-12.1 24.2-21.5 39.7-27L389.2 87.8C378.7 72.9 361.6 64 343.4 64L312 64z',
    ],
  ],
};
const faWaveform = {
  prefix: 'fad',
  iconName: 'waveform',
  icon: [
    640,
    512,
    [],
    'f8f1',
    [
      'M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264l22.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.3 0 26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z',
      '',
    ],
  ],
};
const faWater = {
  prefix: 'fad',
  iconName: 'water',
  icon: [
    576,
    512,
    [],
    'f773',
    [
      'M0 272c0 2.4 .3 4.8 .8 7.3C4.3 294 17.4 304 32 304c2.4 0 4.8-.3 7.3-.8c24.5-5.7 44.9-16.5 58.2-25C126.5 293.7 159 304 192 304c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7C439.4 229.2 410.9 240 384 240c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 229.4 219.5 240 192 240c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2C10 244.3 0 257.4 0 272z',
      'M306.5 69.9c-11.1-7.9-25.9-7.9-37 0C247 85.4 219.5 96 192 96c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7C61 83.5 42.8 92.6 24.7 96.8c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 149.7 159 160 192 160c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 85.2 410.9 96 384 96c-27.5 0-55-10.6-77.5-26.1zM384 384c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 373.4 219.5 384 192 384c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 437.7 159 448 192 448c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 373.2 410.9 384 384 384z',
    ],
  ],
};
const faStarSharpHalfStroke = {
  prefix: 'fad',
  iconName: 'star-sharp-half-stroke',
  icon: [
    576,
    512,
    ['star-sharp-half-alt'],
    'e28d',
    [
      'M288 0c0 43.2 0 86.4 0 129.5c6.7 21.1 13.5 42.3 20.2 63.4l12.4 39 41 0 65.2 0-57.2 44.5-30.8 24 11.8 37.2 19.7 61.8-47.9-37.2L288 335.5c0 23.6 0 47.3 0 70.9c37.4 29.1 74.8 58.2 112.2 87.3l.3 .3 3.7 2.9 13 10.1c4.3 3.4 9.5 5.1 14.7 5.1c4.8 0 9.6-1.4 13.7-4.3c8.6-6 12.3-16.9 9.1-27l-5-15.7-1.4-4.5-.1-.4L403.9 320.7l114-88.7c.7-.6 1.4-1.1 2.1-1.6l14.7-11.5c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2l-18.7 0-2.5 0-137.3 0L317.4 37.2c-.5-1.6-.9-3-1.4-4.3l-5.2-16.2C307.7 6.8 298.5 0 288 0z',
      'M254.4 50.4L214.5 176 90.3 176 88 176l-13.3 0L56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4 103.7 80.7L132 446.7l-1.1 3.5L126.1 465l-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4l0-81.1 0-169.4L288 0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9s0 0 0 0l-4.6 14.3-1 3.2z',
    ],
  ],
};
const faStarSharpHalfAlt = faStarSharpHalfStroke;
const faNfcSignal = {
  prefix: 'fad',
  iconName: 'nfc-signal',
  icon: [
    512,
    512,
    [],
    'e1fb',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l160.1 0c.7-22.1 4-43.6 9.8-64L112 416c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l133.3 0c21.9-51.1 59.5-93.9 106.7-122.3L352 144c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16l0 66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48l0 101.3c20.2-8.7 41.6-14.9 64-18.3l0-131c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M512 280c0-13.3-10.7-24-24-24c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24zM448 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40-128c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24s-10.7-24-24-24z',
    ],
  ],
};
const faPlaneProp = {
  prefix: 'fad',
  iconName: 'plane-prop',
  icon: [
    576,
    512,
    [],
    'e22b',
    [
      'M231.7 194.4c2.8-22.1 5.5-44.3 8.3-66.4c2.7-21.3 5.3-42.7 8-64c2.1-16.7 4.2-33.3 6.2-50c1-8 7.8-14 15.9-14l35.8 0c8.1 0 14.9 6 15.9 14L328 64c2.7 21.3 5.3 42.7 8 64s5.3 42.7 8 64l-88 0-24.3 2.4zm0 123.1L256 320l88 0c-2.7 21.3-5.3 42.7-8 64s-5.3 42.7-8 64c-2.1 16.7-4.2 33.3-6.2 50c-1 8-7.8 14-15.9 14l-35.8 0c-8.1 0-14.9-6-15.9-14c-2.1-16.7-4.2-33.3-6.2-50l-8-64c-2.8-22.1-5.5-44.3-8.3-66.4z',
      'M231.7 317.6L256 320l88 0 138.3 0c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64L344 192l-88 0-24.3 2.4-110 11L113.8 142c-1-8-7.8-14-15.9-14l-35.8 0c-8.1 0-14.9 6-15.9 14L36 224.2c-1.3-.2-2.6-.2-4-.2c-17.7 0-32 14.3-32 32s14.3 32 32 32c1.3 0 2.7-.1 4-.2L46.2 370c1 8 7.8 14 15.9 14l35.8 0c8.1 0 14.9-6 15.9-14l7.9-63.4 110 11zM336 128l32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-40 0 8 64zM248 64l-24 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 8-64zm-8 320l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l24 0-8-64zm88 64l40 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0-8 64z',
    ],
  ],
};
const faCalendarCheck = {
  prefix: 'fad',
  iconName: 'calendar-check',
  icon: [
    448,
    512,
    [],
    'f274',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM119 319c-9.4 9.4-9.4 24.6 0 33.9l64 64c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7L329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z',
    ],
  ],
};
const faClockDesk = {
  prefix: 'fad',
  iconName: 'clock-desk',
  icon: [
    448,
    512,
    [],
    'e134',
    [
      'M448 224A224 224 0 1 1 0 224a224 224 0 1 1 448 0zM200 120l0 104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-94.1c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M248 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-94.1zM448 224c0 123.7-100.3 224-224 224S0 347.7 0 224L0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-240z',
    ],
  ],
};
const faCalendarClock = {
  prefix: 'fad',
  iconName: 'calendar-clock',
  icon: [
    576,
    512,
    ['calendar-time'],
    'e0d2',
    [
      'M0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112zm0 80L0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176L0 192zm432 0c5.4 0 10.7 .2 16 .7l0-.7-16 0z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faCalendarTime = faCalendarClock;
const faBraille = {
  prefix: 'fad',
  iconName: 'braille',
  icon: [
    640,
    512,
    [],
    'f2a1',
    [
      'M0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm80-160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm80-160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM352 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm80-160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM512 96a64 64 0 1 0 128 0A64 64 0 1 0 512 96zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM592 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm0 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 96A64 64 0 1 0 160 96a64 64 0 1 0 128 0zm128 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faPrescriptionBottleMedical = {
  prefix: 'fad',
  iconName: 'prescription-bottle-medical',
  icon: [
    384,
    512,
    ['prescription-bottle-alt'],
    'f486',
    [
      'M32 96l320 0 0 352c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 96zM96 272l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z',
      'M32 0C14.3 0 0 14.3 0 32L0 64C0 81.7 14.3 96 32 96l320 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0zM160 208l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faPrescriptionBottleAlt = faPrescriptionBottleMedical;
const faPlateUtensils = {
  prefix: 'fad',
  iconName: 'plate-utensils',
  icon: [
    640,
    512,
    [58713],
    'e43b',
    [
      'M152 266.8l0 116.9C192.5 441.9 259.8 480 336 480c89.4 0 166.6-52.4 202.6-128.2c-23.9-2-44-17.2-53.2-38.2C462.2 373.5 404.1 416 336 416c-88.4 0-160-71.6-160-160l0-.6c-7.4 4.8-15.5 8.6-24 11.4zM204.9 74.3l16.3 69.2c.1 .3 .1 .5 .2 .8C250.5 114.5 291.1 96 336 96c63.3 0 118.1 36.8 144 90.2l0-26.2c0-25 4.3-46.7 11.3-65.5C451 55.8 396.3 32 336 32c-48.9 0-94.2 15.7-131.1 42.3zM208 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0z',
      'M48 23.5c-.2-4-3.3-7.2-7.3-7.5s-7.6 2.3-8.5 6.1L1.9 150.9C.6 156.3 0 161.9 0 167.5c0 39.9 32.2 72.2 72 72.5l0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232c39.8-.3 72-32.6 72-72.5c0-5.6-.6-11.2-1.9-16.6L159.8 22.2c-.9-3.9-4.5-6.5-8.5-6.1s-7.1 3.5-7.3 7.5L136.5 152l-17.3 0L103.9 23.1c-.5-4-3.9-7.1-7.9-7.1s-7.5 3-7.9 7.1L72.9 152l-17.3 0L48 23.5zM512 160l0 128c0 17.7 14.3 32 32 32l48 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 0-104 0-179.1c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160z',
    ],
  ],
};
const faFamilyPants = {
  prefix: 'fad',
  iconName: 'family-pants',
  icon: [
    512,
    512,
    [],
    'e302',
    [
      'M21.8 282.7c-.2 1.8-.2 3.6-.2 5.4c0 27.5 17.6 51.3 42.4 60.2L64 464c0 26.5 21.5 48 48 48l32 0c13.5 0 25.7-5.6 34.4-14.5c-1.6-5.5-2.4-11.4-2.4-17.5l0-56.4c-19.6-17.6-32-43.1-32-71.6l0-16c0-43.1 24.3-80.5 60-99.2c-17.1-14.7-28-36.5-28-60.8c0-3.9 .3-7.8 .8-11.5c-8.3-2.9-17.2-4.5-26.4-4.5l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM308 236.8c35.7 18.7 60 56.1 60 99.2l0 16c0 28.4-12.4 54-32 71.6l0 56.4c0 6.1-.8 11.9-2.4 17.5c8.7 9 20.9 14.5 34.4 14.5l32 0c26.5 0 48-21.5 48-48l0-115.7c24.9-8.9 42.4-32.7 42.4-60.2c0-1.8-.1-3.6-.2-5.4l-4.1-49.3C482.7 191.9 448 160 406.4 160l-44.8 0c-9.2 0-18.1 1.6-26.4 4.5c.5 3.8 .8 7.6 .8 11.5c0 24.3-10.9 46.1-28 60.8zM320 64a64 64 0 1 0 128 0A64 64 0 1 0 320 64z',
      'M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 336c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16c0 23.7-12.9 44.4-32 55.4l0 72.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-72.6c-19.1-11.1-32-31.7-32-55.4l0-16z',
    ],
  ],
};
const faHoseReel = {
  prefix: 'fad',
  iconName: 'hose-reel',
  icon: [
    640,
    512,
    [],
    'e41a',
    [
      'M64 256c0 141.4 114.6 256 256 256c54.3 0 104.8-17 146.3-45.9c14.5-10.1 18-30.1 7.9-44.6s-30.1-18-44.6-7.9C398.6 435.3 360.8 448 320 448c-106 0-192-86-192-192s86-192 192-192s192 86 192 192l0 96 64 0 0-96C576 114.6 461.4 0 320 0S64 114.6 64 256zm96 0a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm256 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zm-160 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M480 376c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-2.3 0-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L506.3 400l-2.3 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faHouseWindow = {
  prefix: 'fad',
  iconName: 'house-window',
  icon: [
    576,
    512,
    [],
    'e3b3',
    [
      'M64 270.5L64.1 448c0 35.3 28.7 64 64 64l320.4 0c35.4 0 64-28.7 64-64c-.1-59.2-.3-118.3-.4-177.4L288 74.5 64 270.5zM224 264c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80z',
      'M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z',
    ],
  ],
};
const faLandmark = {
  prefix: 'fad',
  iconName: 'landmark',
  icon: [
    512,
    512,
    [127963],
    'f66f',
    [
      'M0 480c0 3.1 .4 6.2 1.4 9.3C5.5 502.8 17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7c.9-3.1 1.4-6.2 1.4-9.3c0-10.5-5.2-20.6-14.2-26.6l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 192l-64 0 0 224-40 0 0-224-64 0 0 224-48 0 0-224-64 0 0 224-40 0 0-224-64 0 0 228.3c-.6 .3-1.2 .7-1.7 1.1l-48 32C5.2 459.4 0 469.5 0 480z',
      'M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128c-12.6 7.2-18.8 22-15.1 36S17.5 192 32 192l448 0c14.5 0 27.2-9.8 30.9-23.8s-2.5-28.8-15-36l-224-128z',
    ],
  ],
};
const faTruck = {
  prefix: 'fad',
  iconName: 'truck',
  icon: [
    640,
    512,
    [128666, 9951],
    'f0d1',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l17.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l66.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l1.1 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96z',
    ],
  ],
};
const faMusicMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'music-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e662',
    [
      'M129.8 180.4l148.5-49.5c17.1-5.7 35.8-2.8 50.5 7.7S352 166 352 184l0 208c0 1.3 0 2.5-.1 3.8c.1 1.4 .1 2.8 .1 4.2c0 5.4-.6 10.6-1.8 15.5c40.4-2.7 77.7-17 108.5-39.6L585.4 502.6c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4s9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6L504 330.7c25.2-34.4 40-76.8 40-122.7C544 93.1 450.9 0 336 0C230.5 0 143.3 78.6 129.8 180.4z',
      'M320 184c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64C86.6 228.5 80 237.7 80 248l0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48z',
    ],
  ],
};
const faCrosshairs = {
  prefix: 'fad',
  iconName: 'crosshairs',
  icon: [
    512,
    512,
    [],
    'f05b',
    [
      'M42.4 224l65 0c12.5-58.3 58.4-104.1 116.6-116.6c0-21.7 0-43.3 0-65C130.3 56.3 56.3 130.3 42.4 224zm0 64c13.9 93.7 88 167.7 181.6 181.6c0-21.7 0-43.3 0-65C165.7 392.1 119.9 346.3 107.4 288c-21.7 0-43.3 0-65 0zM288 42.4l0 65c58.3 12.5 104.1 58.4 116.6 116.6l65 0C455.7 130.3 381.7 56.3 288 42.4zm0 362.3l0 65c93.7-13.9 167.7-88 181.6-181.6c-21.7 0-43.3 0-65 0C392.1 346.3 346.3 392.1 288 404.6z',
      'M256 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32zM256 352c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM128 288l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z',
    ],
  ],
};
const faCloudRainbow = {
  prefix: 'fad',
  iconName: 'cloud-rainbow',
  icon: [
    576,
    512,
    [],
    'f73e',
    [
      'M263.6 189.7c6.5 5 12.5 10.4 18 16.4c16.1-9 34.7-14.1 54.4-14.1c.2 0 .3 0 .5 0C385.4 119 466.8 69.5 560 64.4c8.8-.5 16-7.6 16-16.4l0-32c0-8.8-7.2-16-16-15.6C430.9 6.1 319.9 81.4 263.6 189.7zm108.1 8.1c20.9 7 39 20 52.3 36.9c32.1-41.5 80.7-69.5 136-74c8.8-.7 16-7.8 16-16.7l0-32c0-8.8-7.2-16.1-16-15.5c-76.9 4.7-144.6 43.4-188.4 101.3zm69.6 67.9c3 8.3 5.1 17.1 6.1 26.2c15.2 3.8 29.3 10.4 41.8 19.1c13.2-27.9 39.5-48.4 70.9-53.7c8.7-1.5 15.9-8.5 15.9-17.3l0-32c0-8.8-7.2-16.1-16-15.2c-49.9 4.9-93 32.8-118.8 72.9z',
      'M0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28c-18.7-35.7-56.1-60-99.2-60c-61.9 0-112 50.1-112 112c0 7.1 .7 14.1 1.9 20.8C27.6 337.4 0 373.5 0 416z',
    ],
  ],
};
const faPersonCane = {
  prefix: 'fad',
  iconName: 'person-cane',
  icon: [
    448,
    512,
    [],
    'e53c',
    [
      'M304 376l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-30.9-25.1-56-56-56s-56 25.1-56 56z',
      'M176 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM120 256.9L91.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l35.9 0c28.6 0 55.6 12.7 73.9 34.7l73.7 88.9c11.3 13.6 9.4 33.8-4.2 45.1s-33.8 9.4-45.1-4.2L264 235.3 264 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1z',
    ],
  ],
};
const faAlien = {
  prefix: 'fad',
  iconName: 'alien',
  icon: [
    448,
    512,
    [128125],
    'f8f5',
    [
      'M0 224C0 359.3 148.8 471.7 194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224zm64 13.7c0-7.6 6.1-13.7 13.7-13.7l32 0c45.4 0 82.3 36.8 82.3 82.3c0 7.6-6.1 13.7-13.7 13.7l-32 0C100.8 320 64 283.2 64 237.7zm192 68.6c0-45.4 36.8-82.3 82.3-82.3l32 0c7.6 0 13.7 6.1 13.7 13.7c0 45.4-36.8 82.3-82.3 82.3l-32 0c-7.6 0-13.7-6.1-13.7-13.7z',
      'M109.7 224c45.4 0 82.3 36.8 82.3 82.3c0 7.6-6.1 13.7-13.7 13.7l-32 0C100.8 320 64 283.2 64 237.7c0-7.6 6.1-13.7 13.7-13.7l32 0zm228.6 0l32 0c7.6 0 13.7 6.1 13.7 13.7c0 45.4-36.8 82.3-82.3 82.3l-32 0c-7.6 0-13.7-6.1-13.7-13.7c0-45.4 36.8-82.3 82.3-82.3z',
    ],
  ],
};
const faTent = {
  prefix: 'fad',
  iconName: 'tent',
  icon: [
    576,
    512,
    [],
    'e57d',
    [
      'M.2 476.5c-.1 1.2-.2 2.4-.2 3.5c0 7.8 2.9 15.4 8.2 21.3C14.2 508.1 22.9 512 32 512l208 0 16 0c17.7 0 32-14.3 32-32l0-182.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5L407.2 494.3c5.4 10.8 16.5 17.7 28.6 17.7l28.2 0 80 0c9.1 0 17.8-3.9 23.8-10.7c5.3-5.9 8.2-13.5 8.2-21.3c0-1.2-.1-2.4-.2-3.5l-32-288c-1-9-5.8-17.2-13.2-22.5L306.6 6C301 2 294.5 0 288 0s-13 2-18.6 6L45.4 166c-7.4 5.3-12.2 13.5-13.2 22.5l-32 288z',
      'M435.8 512c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L288 480c0 17.7-14.3 32-32 32l179.8 0z',
    ],
  ],
};
const faLaptopBinary = {
  prefix: 'fad',
  iconName: 'laptop-binary',
  icon: [
    640,
    512,
    [],
    'e5e7',
    [
      'M0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384C8.6 384 0 392.6 0 403.2zM64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96z',
      'M512 96L128 96l0 256 64 0 0-48c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 64 48 0 0-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 40 48 0 0-48c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 64 64 0 0-256zM336 352l0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 40 32 0zM160 168c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-32zm40-8c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-16 0zm88-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c-8.8 0-16-7.2-16-16zm136-16l16 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-32c0-22.1 17.9-40 40-40zm-8 40l0 32c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z',
    ],
  ],
};
const faVestPatches = {
  prefix: 'fad',
  iconName: 'vest-patches',
  icon: [
    448,
    512,
    [],
    'e086',
    [
      'M56 416a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM117.1 0c6.6 .3 12.4 4.6 14.6 10.9c6.5 19.6 13.1 39.2 19.6 58.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3l19.6-58.7c.1-.4 .3-.8 .4-1.2s.3-.8 .5-1.1c.4-.7 .8-1.4 1.3-2.1c.9-1.3 2.1-2.4 3.3-3.4c2.5-1.9 5.7-3.1 9-3.2c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0zM304 280l0 8 0 32c0 8.8 7.2 16 16 16l32 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M207.1 237.4l-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3L192 464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512L48 512c-26.5 0-48-21.5-48-48L0 270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6L64 48C64 21.5 85.5 0 112 0l4.5 0c6.9 0 13 4.4 15.2 10.9l75.5 226.5zM224 464l0-168.2c0-5.2 .8-10.3 2.5-15.2L316.4 10.9C318.5 4.4 324.6 0 331.5 0L336 0c26.5 0 48 21.5 48 48l0 97.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6L448 464c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280l0 8 0 32c0 8.8 7.2 16 16 16l32 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
    ],
  ],
};
const faPeopleDressSimple = {
  prefix: 'fad',
  iconName: 'people-dress-simple',
  icon: [
    512,
    512,
    [],
    'e218',
    [
      'M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64z',
      'M50.7 206.4c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L192 384l0 80c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-80-21.6 0c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4zm256 0c7.9-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 80c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-80-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z',
    ],
  ],
};
const faCheckDouble = {
  prefix: 'fad',
  iconName: 'check-double',
  icon: [
    448,
    512,
    [],
    'f560',
    [
      'M48 144c0 8.2 3.1 16.4 9.4 22.6l80 80c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l160-160c12.5-12.5 12.5-32.8 0-45.3C336.4 35.1 328.2 32 320 32s-16.4 3.1-22.6 9.4L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0C51.1 127.6 48 135.8 48 144z',
      'M438.6 169.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 393.4 169.4c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faArrowDownAZ = {
  prefix: 'fad',
  iconName: 'arrow-down-a-z',
  icon: [
    576,
    512,
    ['sort-alpha-asc', 'sort-alpha-down'],
    'f15d',
    [
      'M304 224c0 11.7 6.5 23 17.7 28.6c15.8 7.9 35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3C521.5 247 528 235.7 528 224c0-4.8-1.1-9.7-3.4-14.3l-16-32-64-128C439.2 38.8 428.1 32 416 32s-23.2 6.8-28.6 17.7l-64 128-16 32c-2.3 4.6-3.4 9.5-3.4 14.3zm16 96c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-128 0c-17.7 0-32 14.3-32 32zm75.8-144L416 135.6 436.2 176l-40.4 0z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortAlphaAsc = faArrowDownAZ;
const faSortAlphaDown = faArrowDownAZ;
const faBowlingBallPin = {
  prefix: 'fad',
  iconName: 'bowling-ball-pin',
  icon: [
    576,
    512,
    [],
    'e0c3',
    [
      'M96 220a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm72-48a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm0 88a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zM400.5 447.4l17.8 44.5C423.1 504 434.9 512 448 512l64 0c13.1 0 24.9-8 29.7-20.1L564.5 435c7.6-19.1 11.5-39.4 11.5-59.9c0-19-3.4-37.9-10-55.8L525.9 210.4c-2.2-6-3.8-12.1-4.8-18.4l-82.3 0c-1 6.3-2.6 12.4-4.8 18.4l-2.4 6.5c10.5 27 16.3 56.4 16.3 87.1c0 53.8-17.7 103.4-47.5 143.4zM416 64l0 1.1c0 7.4 1 14.8 2.9 22l17.7 64.8c.7 2.7 1.3 5.4 1.8 8.1l83.1 0c.5-2.7 1.1-5.4 1.8-8.1L541 87.1c2-7.2 3-14.6 3-22l0-1.1c0-35.3-28.7-64-64-64s-64 28.7-64 64z',
      'M0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zM224 172a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM196 288a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zm286.5-60l83.1 0c-1 5.7-1.5 11.4-1.5 17.2c0 5 .4 9.9 1.2 14.8l-82.3 0c.8-4.9 1.2-9.9 1.2-14.8c0-5.8-.5-11.5-1.5-17.2z',
    ],
  ],
};
const faBellSchoolSlash = {
  prefix: 'fad',
  iconName: 'bell-school-slash',
  icon: [
    640,
    512,
    [],
    'f5d6',
    [
      'M64 208c0 114.9 93.1 208 208 208c36.7 0 71.1-9.5 101-26.1L71.5 152.4C66.6 170.1 64 188.7 64 208zM118.5 67.6L220 147.2c14-11.9 32.1-19.2 52-19.2c44.2 0 80 35.8 80 80c0 12.9-3.1 25.1-8.5 35.9c33.8 26.5 67.7 53 101.5 79.6c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6zM128 400l0 64c0 26.5 21.5 48 48 48l208 0 32 0 40 0c19.3 0 37.3-5.7 52.3-15.5L465.8 463c-3.2 .7-6.4 1-9.8 1l-40 0 0-40.2-16.1-12.7C362.9 434.5 319 448 272 448c-54 0-103.9-17.9-144-48zM246.1 167.6c23.8 18.6 47.6 37.3 71.3 55.9c1.7-4.9 2.6-10.1 2.6-15.5c0-26.5-21.5-48-48-48c-9.5 0-18.4 2.8-25.9 7.6zM496.5 363.8c24.7 19.4 49.5 38.8 74.2 58.2c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faPlusLarge = {
  prefix: 'fad',
  iconName: 'plus-large',
  icon: [
    512,
    512,
    [],
    'e59e',
    [
      'M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0 0-192z',
      '',
    ],
  ],
};
const faMoneyBillWheat = {
  prefix: 'fad',
  iconName: 'money-bill-wheat',
  icon: [
    512,
    512,
    [],
    'e52a',
    [
      'M0 304L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256c-26.5 0-48 21.5-48 48zm48 0l48 0c0 26.5-21.5 48-48 48l0-48zm0 112c26.5 0 48 21.5 48 48l-48 0 0-48zm272-32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-80l48 0 0 48c-26.5 0-48-21.5-48-48zm0 160c0-26.5 21.5-48 48-48l0 48-48 0z',
      'M160 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM32 40c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 64C42.7 64 32 53.3 32 40zM0 112C0 98.7 10.7 88 24 88l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 136c-13.3 0-24-10.7-24-24zm56 48l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM288 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm96 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zm80 112c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM240 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z',
    ],
  ],
};
const faCameraViewfinder = {
  prefix: 'fad',
  iconName: 'camera-viewfinder',
  icon: [
    512,
    512,
    ['screenshot'],
    'e0da',
    [
      'M0 24L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24zM0 376L0 488c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24zM352 24c0 13.3 10.7 24 24 24l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L376 0c-13.3 0-24 10.7-24 24zm0 464c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0c-13.3 0-24 10.7-24 24z',
      'M186.2 111.6L180 128l-36 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-36 0-6.2-16.4c-3.5-9.4-12.5-15.6-22.5-15.6l-94.7 0c-10 0-19 6.2-22.5 15.6zM256 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    ],
  ],
};
const faScreenshot = faCameraViewfinder;
const faMessageMusic = {
  prefix: 'fad',
  iconName: 'message-music',
  icon: [
    512,
    512,
    ['comment-alt-music'],
    'f8af',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM128 288c0 17.7 21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32z',
      'M345.1 82.8c4.3 3 6.9 7.9 6.9 13.2l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8z',
    ],
  ],
};
const faCommentAltMusic = faMessageMusic;
const faCarBuilding = {
  prefix: 'fad',
  iconName: 'car-building',
  icon: [
    640,
    512,
    [],
    'f859',
    [
      'M0 48C0 21.5 21.5 0 48 0L272 0c26.5 0 48 21.5 48 48l0 88.4c-29.5 12.1-53.1 36.6-63.7 68.2l-.5 1.4c-1-7.9-7.7-14-15.9-14l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l31.2 0-5.6 16.9C208.5 290.2 192 319.2 192 352l0 96 0 32L48 480c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM192 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M347.4 234.9L329.7 288l204.5 0-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9l-138.8 0c-6.9 0-13 4.4-15.2 10.9zm-87.3 59.4l26.6-79.7C297.6 182 328.2 160 362.6 160l138.8 0c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352l0 96s0 0 0 0l0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32s0 0 0 0l0-96c0-25.4 14.8-47.3 36.1-57.6zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faBorderBottomRight = {
  prefix: 'fad',
  iconName: 'border-bottom-right',
  icon: [
    448,
    512,
    ['border-style-alt'],
    'f854',
    [
      'M0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 160zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 352zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M416 32c17.7 0 32 14.3 32 32l0 336c0 44.2-35.8 80-80 80L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l336 0c8.8 0 16-7.2 16-16l0-336c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faBorderStyleAlt = faBorderBottomRight;
const faOctagon = {
  prefix: 'fad',
  iconName: 'octagon',
  icon: [
    512,
    512,
    [128721],
    'f306',
    [
      'M191.5 .1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0z',
      '',
    ],
  ],
};
const faCommentArrowUpRight = {
  prefix: 'fad',
  iconName: 'comment-arrow-up-right',
  icon: [
    512,
    512,
    [],
    'e145',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160 72c0-6.1 2.3-12.3 7-17l87-87L200 208c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-87 87c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M176 184c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87L200 208c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faOctagonDivide = {
  prefix: 'fad',
  iconName: 'octagon-divide',
  icon: [
    512,
    512,
    [],
    'e203',
    [
      'M.1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5zM144 256c0-13.3 10.7-24 24-24c58.7 0 117.3 0 176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-58.7 0-117.3 0-176 0c-13.3 0-24-10.7-24-24zm80-96c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .8 .1 1.6 .1 1.6l0 1.7c0 .5 0 1.1 0 1.6s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm0 192c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1.1 0 1.8c0 .5 0 1 0 1.6s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32z',
      'M224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faCookie = {
  prefix: 'fad',
  iconName: 'cookie',
  icon: [
    512,
    512,
    [127850],
    'f563',
    [
      'M17.6 255.5l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c7.1-14.6 10.7-30.5 10.7-46.5c0-6.1-.5-12.3-1.6-18.4l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17c-4.9-.7-9.8-1-14.7-1c-17.2 0-34.3 4.2-49.6 12.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9zM208 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32-160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM400 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faArrowRotateLeft = {
  prefix: 'fad',
  iconName: 'arrow-rotate-left',
  icon: [
    512,
    512,
    [8634, 'arrow-left-rotate', 'arrow-rotate-back', 'arrow-rotate-backward', 'undo'],
    'f0e2',
    [
      'M80 115.2L80 160c15.2 0 30.5 0 45.7 0l17.1-17.1c62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3s-163.8 62.5-226.3 0c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3C141.3 458.1 198.7 480 256 480s114.7-21.9 158.4-65.6S480 313.3 480 256s-21.9-114.7-65.6-158.4S313.3 32 256 32S141.3 53.9 97.6 97.6L80 115.2z',
      'M16 192c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-96c0-17.7-14.3-32-32-32S16 46.3 16 64l0 128z',
    ],
  ],
};
const faArrowLeftRotate = faArrowRotateLeft;
const faArrowRotateBack = faArrowRotateLeft;
const faArrowRotateBackward = faArrowRotateLeft;
const faUndo = faArrowRotateLeft;
const faTvMusic = {
  prefix: 'fad',
  iconName: 'tv-music',
  icon: [
    640,
    512,
    [],
    'f8e6',
    [
      'M0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zm64 0l0 288 512 0 0-288L64 64zM96 480c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32z',
      'M576 64L64 64l0 288 512 0 0-288zM416 112l0 40 0 104c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-50.7-96 36 0 76.9c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-57.8 0-40c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z',
    ],
  ],
};
const faHardDrive = {
  prefix: 'fad',
  iconName: 'hard-drive',
  icon: [
    512,
    512,
    [128436, 'hdd'],
    'f0a0',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224c0 5.5-.7 10.8-2 16c-3.6-13.8-11.6-25.8-22.5-34.4c-5.4-4.3-11.6-7.7-18.2-10c-3.3-1.2-6.8-2.1-10.3-2.7c-1.8-.3-3.6-.5-5.4-.7c-.9-.1-1.8-.1-2.8-.2s-1.8-.1-2.8-.1L64 288c-29.8 0-54.9 20.4-62 48c-1.3-5.1-2-10.5-2-16L0 96zM352 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M0 352c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64zm352 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faHdd = faHardDrive;
const faReel = {
  prefix: 'fad',
  iconName: 'reel',
  icon: [
    448,
    512,
    [],
    'e238',
    [
      'M64 64l0 24c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-24L64 64zm0 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 144c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 208c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 272c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 336c-8.8 0-16 7.2-16 16zm0 72l0 24 320 0 0-24c0-13.3-10.7-24-24-24L88 400c-13.3 0-24 10.7-24 24z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0zm0 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faFaceGrinSquintTears = {
  prefix: 'fad',
  iconName: 'face-grin-squint-tears',
  icon: [
    512,
    512,
    [129315, 'grin-squint-tears'],
    'f586',
    [
      'M33.2 382.1c4.8-1.5 9.6-2.9 14.3-4.1c18.9-4.8 38.5-8 50.4-9.7c26.8-3.9 49.6 19 45.7 45.8c-1.7 11.8-4.8 31.3-9.7 50.3c-1.2 4.7-2.5 9.6-4 14.3C227.5 534.2 353.8 520.3 437 437c50-50 75-115.5 75-181c0-43.6-11.1-87.1-33.2-126.1c-4.8 1.5-9.6 2.8-14.3 4.1c-18.9 4.8-38.5 8-50.4 9.6c-26.8 3.9-49.6-19-45.7-45.8c1.7-11.7 4.8-31.3 9.7-50.3c1.2-4.7 2.5-9.6 4.1-14.3C343.2 11.1 299.6 0 256 0C190.5 0 125 25 75 75C-8.2 158.2-22.2 284.5 33.2 382.1zm54-97c-6.3-6.3-3.6-17.2 4.9-19.8c32.5-9.9 65-19.8 97.4-29.7c11.6-3.5 22.5 7.3 19 19c-9.9 32.5-19.8 65-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3c-1.7-18.7-3.4-37.4-5.1-56.1c-18.7-1.7-37.4-3.4-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4zM202.7 416c-11.9-4.8-10.9-20.9 .4-26.9c36.7-19.4 73.2-46.3 106.7-79.8s60.3-70 79.8-106.7c6-11.3 22.1-12.3 26.9-.4c24.1 59.4 12.2 129.9-35.8 177.9s-118.5 59.9-177.9 35.8zm32.9-226.5c9.9-32.5 19.8-65 29.7-97.4c2.6-8.6 13.4-11.3 19.8-4.9c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8c-32.5 9.9-65 19.8-97.4 29.7c-11.6 3.5-22.5-7.3-19-19z',
      'M497.1 14.9c19.6 19.6 20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2C446-5 477.5-4.6 497.1 14.9zM87.1 285.1c-6.3-6.3-3.6-17.2 4.9-19.8l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4zM265.3 92c2.6-8.6 13.4-11.3 19.8-4.9c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z',
    ],
  ],
};
const faGrinSquintTears = faFaceGrinSquintTears;
const faDumbbell = {
  prefix: 'fad',
  iconName: 'dumbbell',
  icon: [
    640,
    512,
    [],
    'f44b',
    [
      'M0 256c0 17.7 14.3 32 32 32l0-64c-17.7 0-32 14.3-32 32zm192-32l0 64 256 0 0-64-256 0zm416 0l0 64c17.7 0 32-14.3 32-32s-14.3-32-32-32z',
      'M128 32c-17.7 0-32 14.3-32 32l0 64-32 0c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32l-32 0zm384 0l-32 0c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64 32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0 0-64c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faRectangleList = {
  prefix: 'fad',
  iconName: 'rectangle-list',
  icon: [
    576,
    512,
    ['list-alt'],
    'f022',
    [
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM200 160c0 13.3 10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0c-13.3 0-24 10.7-24 24z',
      'M200 160c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm24-120l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faListAlt = faRectangleList;
const faTarpDroplet = {
  prefix: 'fad',
  iconName: 'tarp-droplet',
  icon: [
    576,
    512,
    [],
    'e57c',
    [
      'M0 192L0 448c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32l128 0 0-160c0-35.3-28.7-64-64-64l-133.5 0c-13.2 37.3-48.7 64-90.5 64s-77.4-26.7-90.5-64L64 128c-35.3 0-64 28.7-64 64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M288 160c35.3 0 64-26.9 64-60c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C257.7 29.9 224 76 224 100c0 33.1 28.7 60 64 60zM416 512L576 352l-128 0c-17.7 0-32 14.3-32 32l0 128z',
    ],
  ],
};
const faAlarmExclamation = {
  prefix: 'fad',
  iconName: 'alarm-exclamation',
  icon: [
    512,
    512,
    [],
    'f843',
    [
      'M32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4C35.1 463.6 32 471.8 32 480s3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zm256 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M160 25.4L14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4zm192 0C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-200l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faHouseMedicalCircleCheck = {
  prefix: 'fad',
  iconName: 'house-medical-circle-check',
  icon: [
    640,
    512,
    [],
    'e511',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l266.7 0C349.5 480.1 320 427.5 320 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 40.2 0c32.3-39.1 81.1-64 135.8-64c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24zM320 352l0 16c0-5.4 .2-10.7 .7-16l-.7 0z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faTrafficCone = {
  prefix: 'fad',
  iconName: 'traffic-cone',
  icon: [
    512,
    512,
    [],
    'f636',
    [
      'M85.7 352l340.6 0-25.1-64-290.3 0c-8.4 21.3-16.8 42.7-25.1 64zm62.9-160l214.9 0-25.1-64-164.6 0c-8.4 21.3-16.8 42.7-25.1 64z',
      'M173.7 128L216 20.3C220.8 8.1 232.7 0 245.8 0l20.4 0c13.2 0 25 8.1 29.8 20.3L338.3 128l-164.6 0zm-25.1 64l214.9 0 37.7 96-290.3 0 37.7-96zM48 448l37.7-96 340.6 0L464 448l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0z',
    ],
  ],
};
const faGrate = {
  prefix: 'fad',
  iconName: 'grate',
  icon: [
    448,
    512,
    [],
    'e193',
    [
      'M64 224l0 64 32 0 0 128 64 0 0-128 32 0 0 128 64 0 0-128 32 0 0 128 64 0 0-128 32 0 0-64-32 0 0-128-64 0 0 128-32 0 0-128-64 0 0 128-32 0 0-128L96 96l0 128-32 0z',
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 320 320 0 0-320L64 96z',
    ],
  ],
};
const faArrowDownRight = {
  prefix: 'fad',
  iconName: 'arrow-down-right',
  icon: [
    384,
    512,
    [],
    'e093',
    [
      'M32 128c0 8.2 3.1 16.4 9.4 22.6L242.7 352l45.3 0 0-45.3L86.6 105.4C80.4 99.1 72.2 96 64 96s-16.4 3.1-22.6 9.4S32 119.8 32 128z',
      'M352 384c0 17.7-14.3 32-32 32L96 416c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0 0-192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224z',
    ],
  ],
};
const faPersonSkiingNordic = {
  prefix: 'fad',
  iconName: 'person-skiing-nordic',
  icon: [
    576,
    512,
    ['skiing-nordic'],
    'f7ca',
    [
      'M0 488c0 13.3 10.7 24 24 24l135.3 0 1.4 0 158.6 0 1.4 0L504 512c39.8 0 72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24l-69.4 0 27.6-179.3c-4.3 2.1-9.1 3.3-14.2 3.3c-6.2 0-12.4 0-18.6 0L402.3 464l-44.4 0-66.6 0-88.5 0-70.6 0-32.4 0 54.2-257.6c-10.6 3.4-22.6 1.2-31.3-6.6L67 464l-43 0c-13.3 0-24 10.7-24 24z',
      'M336 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM227.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C166.4 108.3 196.2 96 227.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7l21.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-21.3 0c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L302 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L357.8 464l-66.6 0 23.3-81.6-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM202.8 464l-70.6 0 58.7-125.7c5.9 6.6 12.8 12.5 20.6 17.3l32.4 20.3L202.8 464zm-42.1 48c-.4 0-.9 0-1.4 0l1.4 0zm160.1 0c-.5 0-1 0-1.4 0l1.4 0z',
    ],
  ],
};
const faSkiingNordic = faPersonSkiingNordic;
const faCalendarPlus = {
  prefix: 'fad',
  iconName: 'calendar-plus',
  icon: [
    448,
    512,
    [],
    'f271',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM120 352c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-56 0c-13.3 0-24 10.7-24 24z',
      'M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 80L0 192l0-80C0 85.5 21.5 64 48 64l48 0 0-32zM224 248c13.3 0 24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faPersonFromPortal = {
  prefix: 'fad',
  iconName: 'person-from-portal',
  icon: [
    512,
    512,
    ['portal-exit'],
    'e023',
    [
      'M0 256C0 397.4 35.8 512 80 512c25.3 0 47.8-37.5 62.5-96L128 416c-.5 0-1.1 0-1.6 0c-.6 0-1.1-.1-1.6-.1c-1.1-.1-2.1-.3-3.2-.5c-2.1-.4-4.1-1.1-6-1.9c-3.8-1.6-7.3-4-10.2-6.9s-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1.1-.4-2.3-.5-3.5c0-.3 0-.6-.1-.8c0-.2 0-.4 0-.7c0-.4 0-.7 0-.7c0-.5 0-.7 0-.9c0-.3 0-.6 0-.9c0 0 0-.3 0-.7c0-.2 0-.4 0-.7c0-.2 0-.4 .1-.8c0-.3 .1-.6 .1-.9c0-.2 .1-.4 .1-.7c.1-.8 .2-1.2 .3-1.7c.5-2.2 1.1-4.2 1.9-6.1c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4l26.2 0c3.8-29.6 5.8-62.1 5.8-96c0-18.3-.6-36.1-1.7-53.4c-1.7-1.2-3.4-2.5-4.9-4c-.8-.8-1.6-1.6-2.2-2.5s-1.3-1.7-1.9-2.6c-1.2-1.8-2.1-3.6-2.9-5.5s-1.4-3.9-1.8-5.9c-.2-1-.3-2-.4-3s-.1-2-.2-3c0-8.3 3.1-16.5 9.4-22.8C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256z',
      'M416 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM221.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3C385 264.7 419.9 288 458.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM187.2 352L128 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L187.2 352z',
    ],
  ],
};
const faPortalExit = faPersonFromPortal;
const faPlaneArrival = {
  prefix: 'fad',
  iconName: 'plane-arrival',
  icon: [
    640,
    512,
    [128748],
    'f5af',
    [
      'M0 480c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM192 368a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M0 68l.2 98.9c0 8.4 3.4 16.5 9.3 22.5l82.9 83.5c8.1 8.1 18.2 14 29.3 16.9l298.4 77.7c42.6 11.1 87.6 8.6 128.8-7c28.8-10.9 34.8-49 10.7-68.2l-34.4-27.6c-13-10.4-27.8-18.1-43.7-22.8L374.2 210.2 265.2 16.3C259.5 6.2 248.8 0 237.3 0L197.2 0c-10.6 0-18.3 10.2-15.4 20.4l41.5 145.2L96 128 78.1 80.2c-3.8-10.1-12.5-17.7-23-20L19.5 52.3C9.5 50.1 0 57.7 0 68z',
    ],
  ],
};
const faCowbellCirclePlus = {
  prefix: 'fad',
  iconName: 'cowbell-circle-plus',
  icon: [
    576,
    512,
    ['cowbell-more'],
    'f8b4',
    [
      'M0 368c0 10.3 3.3 20.5 9.7 28.9C18.7 408.9 32.9 416 48 416l214.6 0c-4.3-15.3-6.6-31.4-6.6-48c0-86.4 62.3-158.3 144.4-173.2l-18.3-64C376.3 110.2 357.4 96 336 96l-16 0 0-56c0-22.1-17.9-40-40-40L168 0c-22.1 0-40 17.9-40 40l0 56-16 0c-21.4 0-40.3 14.2-46.2 34.8l-64 224C.6 359.2 0 363.6 0 368zm160 80c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6L160 448zM176 48l96 0 0 48-96 0 0-48z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faCowbellMore = faCowbellCirclePlus;
const faCircleLeft = {
  prefix: 'fad',
  iconName: 'circle-left',
  icon: [
    512,
    512,
    [61840, 'arrow-alt-circle-left'],
    'f359',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112 0c0-5.1 2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32c-32 0-64 0-96 0l0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1c-33.3-35.7-66.6-71.4-99.9-107.1c-3.5-3.8-5.5-8.7-5.5-13.8z',
      'M117.5 269.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8z',
    ],
  ],
};
const faArrowAltCircleLeft = faCircleLeft;
const faDistributeSpacingVertical = {
  prefix: 'fad',
  iconName: 'distribute-spacing-vertical',
  icon: [
    512,
    512,
    [],
    'e366',
    [
      'M96 208c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-96z',
      'M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zm0 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z',
    ],
  ],
};
const faSignalBarsFair = {
  prefix: 'fad',
  iconName: 'signal-bars-fair',
  icon: [
    640,
    512,
    ['signal-alt-2'],
    'f692',
    [
      'M352 176l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48s-48 21.5-48 48zM512 48l0 416c0 26.5 21.5 48 48 48s48-21.5 48-48l0-416c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
      'M240 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z',
    ],
  ],
};
const faSignalAlt2 = faSignalBarsFair;
const faSportsball = {
  prefix: 'fad',
  iconName: 'sportsball',
  icon: [
    512,
    512,
    [],
    'e44b',
    [
      'M24.9 257.2c55.1 5.3 105.1 28.1 144.4 62.8c21.3-21.3 42.7-42.7 64-64c-46.6-46.6-93.3-93.3-139.9-139.9C83.2 127.9 74.1 140.5 66 153.6c-19.8 32.3-33 67.7-41.1 103.6zM47.2 487.4c1.1 .3 2.2 .5 3.3 .7c65.6 11 122.9 12.5 172.8 6c-3.9-49.1-23.6-93.7-54-128.8C128.6 406 87.9 446.7 47.2 487.4zM115.8 93.2L256 233.4c21.3-21.3 42.7-42.7 64-64C285 129.7 262.1 79 257 23.3c-17 3.6-33 8.3-48.1 13.9c-37 13.7-67.8 33-93.1 56zM192 342.6c35 39.7 58 90.3 63 146.1c17-3.6 33-8.3 48.1-13.9c37-13.7 67.8-33 93.1-56c-46.7-46.7-93.5-93.5-140.2-140.2c-21.3 21.3-42.7 42.7-64 64zM278.6 256L418.5 395.9c10.3-11.8 19.4-24.4 27.4-37.5c19.8-32.3 33-67.7 41.1-103.6c-55.1-5.3-105.1-28.1-144.4-62.8l-64 64zM288.7 17.9c3.9 49.1 23.6 93.7 54 128.8C383.4 106 424.1 65.3 464.8 24.6c-1.1-.3-2.2-.5-3.3-.7C421.6 17.2 384.8 14 350.8 14c-21.9 0-42.6 1.3-62.1 3.9zm76.6 151.4c34.8 30.2 79 49.8 127.6 53.9c3.5-23.8 5-47.5 5-70.4c0-37.8-4.2-73.5-10.4-103.9c-.1-.5-.2-1-.3-1.5c-40.6 40.6-81.3 81.3-121.9 121.9z',
      'M464.8 24.6L256 233.4 115.8 93.2c-8 7.3-15.4 14.9-22.3 22.9L233.4 256 24.8 464.6c2.9 11.1 11.4 19.8 22.4 22.9L256 278.6 396.2 418.8c8-7.3 15.4-14.9 22.3-22.9L278.6 256 487.2 47.4c-2.9-11.1-11.4-19.8-22.4-22.9z',
    ],
  ],
};
const faGameConsoleHandheldCrank = {
  prefix: 'fad',
  iconName: 'game-console-handheld-crank',
  icon: [
    576,
    512,
    [],
    'e5b9',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-96 0-48 0-176c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 32c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-96zm0 240c0-8.8 7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16zm208-8a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM480 168l0 56 48 0 24 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
      'M96 96c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 96zM528 296l0-72-48 0 0 48-32 0 0 48 56 0c13.3 0 24-10.7 24-24z',
    ],
  ],
};
const faTrainSubway = {
  prefix: 'fad',
  iconName: 'train-subway',
  icon: [
    448,
    512,
    ['subway'],
    'f239',
    [
      'M35.1 492.9C28.1 499.9 33.1 512 43 512l39.7 0c8.5 0 16.6-3.4 22.6-9.4L160 448c-21.3 0-42.7 0-64 0c-2.6 0-5.1-.1-7.5-.3s-4.9-.5-7.3-.9l-46 46zm29-368.2c-.1 .5-.1 1.1-.1 1.6c0 .5 0 1 0 1.4C64 160 64 192 64 224c0 .7 0 1.2 0 1.6c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4l80 0c17.6 0 31.9-14.2 32-32c0-32 0-64 0-96c0-17.7-14.3-32-32-32L96 96c-8.8 0-16.8 3.6-22.6 9.4c-2.9 2.9-5.2 6.3-6.9 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2zm176 0c-.1 .5-.1 1.1-.1 1.6c0 .5 0 1 0 1.4c0 32.2 0 64.2 0 96.2c0 .7 0 1.2 0 1.6c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4l80 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-80 0c-8.8 0-16.8 3.6-22.6 9.4c-2.9 2.9-5.2 6.3-6.9 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2zM288 448l54.6 54.6c6 6 14.1 9.4 22.6 9.4l39.7 0c10 0 15-12.1 7.9-19.1l-46-46c-4.8 .8-9.8 1.1-14.9 1.1c-21.3 0-42.7 0-64 0z',
      'M0 96C0 43 43 0 96 0L352 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 448c-53 0-96-43-96-96L0 96zm64 32l0 96c0 17.7 14.3 32 32 32l80 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zM272 96c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l80 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-80 0zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm224 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faSubway = faTrainSubway;
const faChartGantt = {
  prefix: 'fad',
  iconName: 'chart-gantt',
  icon: [
    512,
    512,
    [],
    'e0e4',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0zm160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0z',
    ],
  ],
};
const faFaceSmileUpsideDown = {
  prefix: 'fad',
  iconName: 'face-smile-upside-down',
  icon: [
    512,
    512,
    [],
    'e395',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm139.9-90.5c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6C330 165.8 299.4 144 256 144s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6zm3.9 135.2c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6zm160 0c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6z',
      'M175.6 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm160 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
    ],
  ],
};
const faBallPile = {
  prefix: 'fad',
  iconName: 'ball-pile',
  icon: [
    576,
    512,
    [],
    'f77e',
    [
      'M0 432a80 80 0 1 0 160 0A80 80 0 1 0 0 432zM208 80a80 80 0 1 0 160 0A80 80 0 1 0 208 80zm0 352a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm208 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M176 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm224 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z',
    ],
  ],
};
const faBadgeDollar = {
  prefix: 'fad',
  iconName: 'badge-dollar',
  icon: [
    512,
    512,
    [],
    'f645',
    [
      'M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm183.8-45.8c.1-1.4 .2-2.7 .4-4c.4-2.6 .9-5.1 1.6-7.5c1.4-4.8 3.5-9.1 6-13c5-7.8 11.9-13.9 19.4-18.3c8-4.7 16.9-7.8 25.7-9.6l0-17.4c0-11 9-20 20-20s20 9 20 20l0 17.3c8.9 1.4 17.4 3.4 25.1 5.4c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-12.3-3.3-24.2-5.7-35.2-5.8c-9.1-.1-18.5 2-25 5.8c-5.8 3.4-8 7.2-7.9 12.3c0 3 .8 5.6 7 9.3c7.2 4.3 17.4 7.5 32.3 12l.3 .1c12.5 3.8 28.3 8.5 40.8 16.4c13.9 8.7 26 22.8 26.3 44.3c0 .3 0 .6 0 .8c0 21.9-11.4 37.8-26.5 47.3c-8.2 5.1-17.5 8.3-26.8 10.1l0 17.1c0 11-9 20-20 20s-20-9-20-20l0-18c-12-2.4-23.1-6.3-32.8-9.6c-2.4-.8-4.6-1.6-6.8-2.3c-8.4-2.8-13.7-10.6-13.7-19c0-2.1 .3-4.2 1-6.3c3.5-10.5 14.8-16.1 25.3-12.6c2.8 .9 5.4 1.8 8 2.7c15.1 5.1 27 9.2 39.7 9.6c9.8 .3 19.1-1.9 25.1-5.6c5.1-3.2 7.7-7.1 7.6-13.6c-.1-4.1-1.4-7.1-7.6-11c-7.3-4.6-17.8-8-31.7-12.2c-.6-.2-1.2-.4-1.9-.6c-12.1-3.7-27.2-8.2-39.1-15.4c-13.7-8.3-26.2-21.9-26.3-43.4c0-.7 0-1.4 0-2c0-.7 .1-1.4 .1-2.1z',
      'M256.9 120.4c11 0 20 9 20 20l0 17.3c8.9 1.4 17.4 3.4 25.1 5.4c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-12.3-3.3-24.2-5.7-35.2-5.8c-9.1-.1-18.5 2-25 5.8c-5.8 3.4-8 7.2-7.9 12.3c0 3 .8 5.6 7 9.3c7.3 4.4 17.8 7.7 31.9 11.9l.6 .2c12.5 3.8 28.3 8.5 40.8 16.4c13.9 8.7 26 22.8 26.3 44.3c.3 22.4-11.2 38.6-26.5 48.1c-8.2 5.1-17.5 8.3-26.8 10.1l0 17.1c0 11-9 20-20 20s-20-9-20-20l0-18c-12-2.4-23.1-6.3-32.8-9.6c-2.4-.8-4.6-1.6-6.8-2.3c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.8 .9 5.4 1.8 8 2.7c0 0 0 0 0 0s0 0 0 0c15.1 5.1 27 9.2 39.7 9.6c9.8 .3 19.1-1.9 25.1-5.6c5.1-3.2 7.7-7.1 7.6-13.6c-.1-4.1-1.4-7.1-7.6-11c-7.3-4.6-17.8-8-31.7-12.2l-1.9-.6c-12.1-3.7-27.2-8.2-39.1-15.4c-13.7-8.3-26.2-21.9-26.3-43.4c-.1-22.5 12.6-38 27.6-46.9c8-4.7 16.9-7.8 25.7-9.6l0-17.4c0-11 9-20 20-20z',
    ],
  ],
};
const faMoneyBillsSimple = {
  prefix: 'fad',
  iconName: 'money-bills-simple',
  icon: [
    640,
    512,
    ['money-bills-alt'],
    'e1f4',
    [
      'M0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240c0-13.3-10.7-24-24-24S0 106.7 0 120zm288 88a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zm208 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faMoneyBillsAlt = faMoneyBillsSimple;
const faListTimeline = {
  prefix: 'fad',
  iconName: 'list-timeline',
  icon: [
    512,
    512,
    [],
    'e1d1',
    [
      'M146.7 96c0 4.8 2.1 9.6 6.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L424 144c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L210.7 48c-6.9 0-13.7 2.2-19.2 6.4L153.1 83.2c-4.3 3.2-6.4 8-6.4 12.8zm0 160c0 4.8 2.1 9.6 6.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L488 304c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-277.3 0c-6.9 0-13.7 2.2-19.2 6.4l-38.4 28.8c-4.3 3.2-6.4 8-6.4 12.8zm0 160c0 4.8 2.1 9.6 6.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L424 464c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-213.3 0c-6.9 0-13.7 2.2-19.2 6.4l-38.4 28.8c-4.3 3.2-6.4 8-6.4 12.8z',
      'M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
    ],
  ],
};
const faIndianRupeeSign = {
  prefix: 'fad',
  iconName: 'indian-rupee-sign',
  icon: [
    320,
    512,
    ['indian-rupee', 'inr'],
    'e1bc',
    [
      'M0 176c0 17.7 14.3 32 32 32l153.3 0c4.3-9.8 6.7-20.6 6.7-32c0-1.4 0-2.8-.1-4.2s-.2-2.8-.3-4.2c-.3-2.8-.7-5.5-1.3-8.2c-1.1-5.4-2.8-10.5-4.9-15.4L32 144c-17.7 0-32 14.3-32 32zm252.4-32c2.3 10.3 3.6 21 3.6 32c0 1.4 0 2.7-.1 4.1s-.1 2.7-.2 4.1c-.2 2.7-.4 5.4-.7 8.1c-.6 5.3-1.5 10.6-2.7 15.7l35.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-35.6 0z',
      'M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l64 0 16 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-80 0c-13.9 0-26.2 9-30.5 22.2S2.1 306 13.4 314l224 160c14.4 10.3 34.4 6.9 44.6-7.4s6.9-34.4-7.4-44.6L130.3 318.9C201.2 309.9 256 249.3 256 176c0-29.6-8.9-57.1-24.2-80L288 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L112 32 96 32 32 32z',
    ],
  ],
};
const faIndianRupee = faIndianRupeeSign;
const faInr = faIndianRupeeSign;
const faCropSimple = {
  prefix: 'fad',
  iconName: 'crop-simple',
  icon: [
    512,
    512,
    ['crop-alt'],
    'f565',
    [
      'M64 32l0 32 0 64 0 256c0 35.3 28.7 64 64 64l256 0 0-64-256 0 0-256 0-64 0-32c0-17.7-14.3-32-32-32S64 14.3 64 32zM448 384l0 64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
      'M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0-64L32 64zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-35.3-28.7-64-64-64L128 64l0 64 256 0 0 352z',
    ],
  ],
};
const faCropAlt = faCropSimple;
const faMoneyBill1 = {
  prefix: 'fad',
  iconName: 'money-bill-1',
  icon: [
    576,
    512,
    ['money-bill-alt'],
    'f3d1',
    [
      'M64 192l0 128c35.3 0 64 28.7 64 64l320 0c0-35.3 28.7-64 64-64l0-128c-35.3 0-64-28.7-64-64l-320 0c0 35.3-28.7 64-64 64zm320 64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
      'M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm128 0c0 35.3-28.7 64-64 64l0 128c35.3 0 64 28.7 64 64l320 0c0-35.3 28.7-64 64-64l0-128c-35.3 0-64-28.7-64-64l-320 0zm144 60l16 0c11 0 20 9 20 20l0 68 4 0c11 0 20 9 20 20s-9 20-20 20l-24 0-24 0c-11 0-20-9-20-20s9-20 20-20l4 0 0-48.4c-9.1-1.9-16-9.9-16-19.6c0-11 9-20 20-20z',
    ],
  ],
};
const faMoneyBillAlt = faMoneyBill1;
const faLeftLong = {
  prefix: 'fad',
  iconName: 'left-long',
  icon: [
    512,
    512,
    ['long-arrow-alt-left'],
    'f30a',
    [
      'M192 192c42.7 0 85.3 0 128 0l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32c-96 0-192 0-288 0l0-128z',
      'M151.5 102.6c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 0 128 0 72c0 9.6-5.7 18.2-14.5 22s-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136z',
    ],
  ],
};
const faLongArrowAltLeft = faLeftLong;
const faKeyboardDown = {
  prefix: 'fad',
  iconName: 'keyboard-down',
  icon: [
    576,
    512,
    [],
    'e1c2',
    [
      'M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64L64 288c-35.3 0-64-28.7-64-64L0 64zM64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 64c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm96-96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M80 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm73.8 302.8c3.7-9 12.5-14.8 22.2-14.8l224 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2L305 505c-9.4 9.4-24.6 9.4-33.9 0L159 393c-6.9-6.9-8.9-17.2-5.2-26.2zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm400-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM160 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM464 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faCircleUpRight = {
  prefix: 'fad',
  iconName: 'circle-up-right',
  icon: [
    512,
    512,
    [],
    'e129',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 56c0-5.1 2-10 5.7-13.7L216 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6L336 160c8.8 0 16 7.2 16 16l0 137.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L280 296l-66.3 66.3C210 366 205.1 368 200 368s-10-2-13.7-5.7l-36.7-36.7C146 322 144 317.1 144 312z',
      'M352 176l0 137.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L280 296l-66.3 66.3C210 366 205.1 368 200 368s-10-2-13.7-5.7l-36.7-36.7C146 322 144 317.1 144 312s2-10 5.7-13.7L216 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6L336 160c8.8 0 16 7.2 16 16z',
    ],
  ],
};
const faCloudBoltMoon = {
  prefix: 'fad',
  iconName: 'cloud-bolt-moon',
  icon: [
    576,
    512,
    ['thunderstorm-moon'],
    'f76d',
    [
      'M96 368c0 1.8 .3 3.6 .9 5.3c2.2 6.4 8.3 10.7 15.1 10.7l70.1 0L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6s-14.2-4.7-20.1-.1l-160 128c-3.9 3.1-6 7.7-6 12.5zM361.4 79.9c31.2 18.7 52.5 52.2 54.3 90.8c33.3 15.8 57.6 47.5 63 85.3c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c3.2-3.1 4.9-7.3 4.9-11.5c0-2.4-.6-4.9-1.7-7.2c-3.2-6.3-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9z',
      'M447.9 271.9c0 44.2-35.8 80-80 80l-18.7 0C342.4 332.8 324.3 320 304 320l-18.3 0 29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L82 330.5c-6 4.8-10.5 10.7-13.6 17.4C28.8 336 0 299.4 0 255.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z',
    ],
  ],
};
const faThunderstormMoon = faCloudBoltMoon;
const faTurnLeftUp = {
  prefix: 'fad',
  iconName: 'turn-left-up',
  icon: [
    384,
    512,
    [],
    'e638',
    [
      'M144 192l0 192c0 70.7 57.3 128 128 128l80 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-80 0c-17.7 0-32-14.3-32-32l0-192-96 0z',
      'M38.5 151.5c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5l272 0c9.6 0 18.2-5.7 22-14.5s2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144z',
    ],
  ],
};
const faDna = {
  prefix: 'fad',
  iconName: 'dna',
  icon: [
    448,
    512,
    [129516],
    'f471',
    [
      'M0 32C0 91.8 30.3 139.5 69.4 178.6c28 28 62.5 53.5 97.3 77.4c.4-.3 .9-.6 1.3-.9c5.6-3.8 11.2-7.6 16.9-11.4c.5-.3 1-.7 1.5-1c5.3-3.5 10.5-7 15.9-10.7l2.4-1.6 1.5-1c5.6-3.7 11-7.3 16.4-10.9c.5-.3 1-.7 1.5-1c-41.8-28.1-80.1-54.9-109.4-84.1c-1.8-1.8-3.5-3.6-5.2-5.4c-10.1-10.7-18.7-21.3-25.5-32l280.2 0c6.5-10.2 11.5-20.6 14.8-31.2C382.3 54.2 384 43.3 384 32L64 32C64 14.3 49.7 0 32 0S0 14.3 0 32zM109.4 384l229.2 0c10.1 10.7 18.6 21.3 25.5 32c6.5 10.2 11.5 20.6 14.8 31.2c3.4 10.7 5.1 21.6 5.1 32.8c0 17.7 14.3 32 32 32s32-14.3 32-32c0-59.8-30.3-107.5-69.4-146.6c-28-28-62.5-53.5-97.3-77.4c-.8 .6-1.7 1.1-2.5 1.7c-5.3 3.6-10.6 7.2-15.9 10.8c-.8 .6-1.6 1.1-2.5 1.7c-5.6 3.8-11.3 7.5-17.1 11.4l-1.5 1-1.9 1.3c-.7 .5-1.4 .9-2.1 1.4c-4.6 3.1-9.2 6.2-13.8 9.2c20.9 14 40.8 27.7 59.3 41.5l-118.5 0c-19.5 14.7-36.7 29.1-51 43.5c-1.3 1.3-2.6 2.7-3.9 4c-.2 .2-.3 .3-.5 .5z',
      'M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 34.2-15.9 65-45.4 96l-229.2 0c15.2 15.9 33.8 31.8 55.4 48l118.5 0c-23.6 17.7-49.7 35.2-77 53.4l-1.6 1s0 0 0 0s0 0 0 0c-46.9 31.2-97.1 64.7-135.3 102.9C30.3 372.5 0 420.2 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l320 0c0-22.6-7-43.6-19.9-64L83.9 416c8-12.5 18.3-24.9 30.7-37.4c33.3-33.3 78.4-63.5 127.1-96l1.6-1s0 0 0 0c46.9-31.2 97.1-64.7 135.3-102.9C417.7 139.5 448 91.8 448 32z',
    ],
  ],
};
const faVirusSlash = {
  prefix: 'fad',
  iconName: 'virus-slash',
  icon: [
    640,
    512,
    [],
    'e075',
    [
      'M64 256c0 17.7 14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-31.2 23.6-52.7 50-55.7L144.7 210c-9.5 8.5-22.2 14-37.2 14L96 224c-17.7 0-32 14.3-32 32zM134.7 80.3c43.3 33.9 86.6 67.9 129.9 101.8c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7c47.4 37.1 94.8 74.3 142.2 111.4c-2-30.1 20.8-60.1 56-60.1l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBracketRoundRight = {
  prefix: 'fad',
  iconName: 'bracket-round-right',
  icon: [
    192,
    512,
    [],
    '29',
    [
      'M37.4 46.2C27.6 61 31.5 80.8 46.3 90.6C71.9 107.7 128 167 128 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C120.1 449 192 371.8 192 256S120.1 62.9 81.8 37.4C67 27.6 47.2 31.5 37.4 46.2z',
      '',
    ],
  ],
};
const faCircleSterling = {
  prefix: 'fad',
  iconName: 'circle-sterling',
  icon: [
    512,
    512,
    [],
    'e5cf',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-8c0-13.1 10.5-23.7 23.5-24c-.1-11-.2-22.1-.2-33.2c0-1.4 0-2.7 .1-4.1s.2-2.7 .3-4c.3-2.6 .6-5.3 1.1-7.8c1-5.1 2.5-10.1 4.5-14.8c3.9-9.4 9.7-17.9 16.7-25.1c14.2-14.3 33.8-23.1 55.6-23.1c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5 32.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32.3 0c-.6 16.4-3.8 32.6-9.5 48L328 320c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c6.8-13.2 10.7-27.6 11.4-42.4c-13.1-.2-23.6-10.9-23.6-24z',
      'M231.2 190.5c-.1-16.8 13.5-30.5 30.3-30.5c3.9 0 7.7 .7 11.3 2.2l30.3 12.1c12.3 4.9 26.3-1.1 31.2-13.4s-1.1-26.3-13.4-31.2l-30.3-12.1c-9.2-3.7-19.1-5.6-29.1-5.6c-43.5 0-78.6 35.4-78.3 78.9l.2 33.1c-13 .3-23.5 10.9-23.5 24c0 13.1 10.6 23.8 23.6 24c-.7 14.8-4.6 29.2-11.4 42.4L162.7 333c-3.8 7.4-3.5 16.3 .8 23.5s12.1 11.5 20.5 11.5l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-105.8 0c5.7-15.4 9-31.6 9.5-48l32.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32.5 0-.2-33.5z',
    ],
  ],
};
const faCircle5 = {
  prefix: 'fad',
  iconName: 'circle-5',
  icon: [
    512,
    512,
    [],
    'e0f2',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 72c0-7.7 3.7-15.3 10.6-19.9c11-7.4 25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c8.6 0 16.5-3.5 22.1-9.2c2.8-2.8 5.1-6.2 6.7-9.9c.8-1.9 1.4-3.8 1.8-5.9c.2-1 .4-2.1 .5-3.1c.1-.5 .1-1.1 .1-1.6s0-1 0-1.8c0-.6 0-1 0-1.4c0-.5-.1-1-.1-1.5c-.1-1-.2-1.9-.4-2.9c-.4-1.9-.9-3.7-1.6-5.5c-1.4-3.5-3.4-6.7-5.8-9.5c-5-5.6-11.9-9.3-19.8-10.2c-29-3.3-57.9-6.5-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0c-2.6 14.3-5.2 28.7-7.8 43l61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6c-1.4-2-2.7-4-4.1-6.1c-2.8-4.1-4.1-8.8-4.1-13.4z',
      'M184.4 147.7c2.1-11.4 12-19.7 23.6-19.7l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88z',
    ],
  ],
};
const faMinus = {
  prefix: 'fad',
  iconName: 'minus',
  icon: [
    448,
    512,
    [8211, 8722, 10134, 'subtract'],
    'f068',
    ['M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z', ''],
  ],
};
const faSubtract = faMinus;
const faFireFlame = {
  prefix: 'fad',
  iconName: 'fire-flame',
  icon: [
    384,
    512,
    ['flame'],
    'f6df',
    [
      'M0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6zm80-9.7c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7c6.1 0 11 4.9 11 11l0 44c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-13.2-13.2c-14-14-21.9-33.1-21.9-53c0-16.2 5.3-32 15-44.9l5.8-7.8c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7l0 11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109l-3 0c-61.9 0-112-50.1-112-112l0-8.2z',
      'M183 156l5.8-7.8c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7v11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.1-112-112v-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7c6.1 0 11 4.9 11 11v44c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-13.2-13.2c-14-14-21.9-33.1-21.9-53c0-16.2 5.3-32 15-44.9z',
    ],
  ],
};
const faFlame = faFireFlame;
const faRightToLine = {
  prefix: 'fad',
  iconName: 'right-to-line',
  icon: [
    448,
    512,
    ['arrow-alt-to-right'],
    'f34c',
    [
      'M384 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M340.7 228.7L217.9 105.9c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L340.7 283.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z',
    ],
  ],
};
const faArrowAltToRight = faRightToLine;
const faGif = {
  prefix: 'fad',
  iconName: 'gif',
  icon: [
    576,
    512,
    [],
    'e190',
    [
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM80 256c0 53 43 96 96 96c19.6 0 37.5-6.1 52.8-15.8c7-4.4 11.2-12.1 11.2-20.3l0-51.9c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 13.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48s21.5-48 48-48c8 0 15.4 1.9 22 5.3c11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7c-53 0-96 43-96 96zm192-72l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0c-13.3 0-24 10.7-24 24z',
      'M128 256c0-26.5 21.5-48 48-48c8 0 15.4 1.9 22 5.3c11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8c7-4.4 11.2-12.1 11.2-20.3l0-51.9c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 13.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48zm192-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144zm56-24c-13.3 0-24 10.7-24 24l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0z',
    ],
  ],
};
const faChess = {
  prefix: 'fad',
  iconName: 'chess',
  icon: [
    512,
    512,
    [],
    'f439',
    [
      'M288 488c0-5.2 1.7-10.2 4.8-14.4L336 416l128 0 43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4c0 13.3-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm16-280c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16 24 0 0-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16 24 0 0-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 51.5c0 8-3 15.8-8.5 21.7L459.2 312l3.3 72L337 384l2.2-72L312 281.1c-5.1-5.8-8-13.4-8-21.1l0-51.9zm80 96l0 32 32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L60.2 96C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208 72 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l4 0L60 384l136 0L180 256l4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.8 0 32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416z',
    ],
  ],
};
const faTrashSlash = {
  prefix: 'fad',
  iconName: 'trash-slash',
  icon: [
    640,
    512,
    [],
    'e2b3',
    [
      'M98.4 51.8C103.2 40.2 114.6 32 128 32l96 0 7.2-14.3C236.6 6.8 247.7 0 259.8 0L380.2 0c12.1 0 23.2 6.8 28.6 17.7L416 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L154.8 96C136 81.3 117.2 66.5 98.4 51.8zm34.1 148.6L488 480.5C481.2 499 463.5 512 442.9 512l-245.8 0c-25.3 0-46.3-19.7-47.9-45L132.5 200.4zM195.6 128L512 128 497.2 364.4C396.7 285.6 296.1 206.8 195.6 128z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faArrowLeftLong = {
  prefix: 'fad',
  iconName: 'arrow-left-long',
  icon: [
    512,
    512,
    ['long-arrow-left'],
    'f177',
    [
      'M77.3 256c10.7-10.7 21.3-21.3 32-32L480 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-370.7 0c-10.7-10.7-21.3-21.3-32-32z',
      'M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 182.6 361.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z',
    ],
  ],
};
const faLongArrowLeft = faArrowLeftLong;
const faPlugCircleCheck = {
  prefix: 'fad',
  iconName: 'plug-circle-check',
  icon: [
    576,
    512,
    [],
    'e55c',
    [
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 67.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.2C87 398 32 333.4 32 256l0-32c-17.7 0-32-14.3-32-32zM64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 96-64 0 0-96zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96-64 0 0-96z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faFontCase = {
  prefix: 'fad',
  iconName: 'font-case',
  icon: [
    640,
    512,
    [],
    'f866',
    [
      'M384 288l0 64c0 70.7 57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32l0-96 0-64 0-96c0-17.7-14.3-32-32-32c-13 0-24.1 7.7-29.2 18.8C559.4 166.9 536.5 160 512 160c-70.7 0-128 57.3-128 128zm64 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64z',
      'M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368l159.6 0L290 459.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304l-111.6 0L176 155.1 231.8 304z',
    ],
  ],
};
const faStreetView = {
  prefix: 'fad',
  iconName: 'street-view',
  icon: [
    512,
    512,
    [],
    'f21d',
    [
      'M0 424c0 22.1 15.1 37.4 29.8 47c15.2 9.9 35.5 17.5 57.8 23.3C132.7 505.9 192.9 512 256 512s123.3-6.1 168.4-17.8c22.4-5.8 42.6-13.3 57.8-23.3c14.7-9.6 29.8-24.9 29.8-47s-15.1-37.4-29.8-47c-15.2-9.9-35.5-17.5-57.8-23.3c-30.9-8-68.8-13.4-109.9-16l-5.3 47.8c39.6 2.4 75.3 7.5 103.2 14.7c56.6 14.6 56.6 32.9 0 47.5C372.5 458.1 316.6 464 256 464s-116.5-5.9-156.4-16.2c-56.6-14.6-56.6-32.9 0-47.5c27.9-7.2 63.6-12.3 103.2-14.7c-1.8-15.9-3.5-31.8-5.3-47.8c-41.1 2.6-79 8-109.9 16C65.2 359.6 45 367.1 29.8 377C15.1 386.6 0 401.9 0 424z',
      'M256 0a64 64 0 1 1 0 128A64 64 0 1 1 256 0zM160 224c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 48c0 17.7-14.3 32-32 32l-1.8 0-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5l-38.7 0c-16.3 0-30-12.3-31.8-28.5L193.8 304l-1.8 0c-17.7 0-32-14.3-32-32l0-48z',
    ],
  ],
};
const faArrowDownLeft = {
  prefix: 'fad',
  iconName: 'arrow-down-left',
  icon: [
    384,
    512,
    [],
    'e091',
    [
      'M96 306.7L297.4 105.4c6.2-6.2 14.4-9.4 22.6-9.4s16.4 3.1 22.6 9.4s9.4 14.4 9.4 22.6s-3.1 16.4-9.4 22.6L141.3 352 96 352l0-45.3z',
      'M32 384c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 352l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224z',
    ],
  ],
};
const faFrancSign = {
  prefix: 'fad',
  iconName: 'franc-sign',
  icon: [
    320,
    512,
    [],
    'e18f',
    [
      'M0 352c0 17.7 14.3 32 32 32l16 0 0-64-16 0c-17.7 0-32 14.3-32 32zm112-32l0 64 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0z',
      'M80 32C62.3 32 48 46.3 48 64l0 160 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-96 176 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z',
    ],
  ],
};
const faFlaskRoundPoison = {
  prefix: 'fad',
  iconName: 'flask-round-poison',
  icon: [
    448,
    512,
    ['flask-poison'],
    'f6e0',
    [
      'M16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L304 0 256 0 192 0 144 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 93.7c0 6-3.3 11.4-8.5 14.4c-5.3 3.1-10.4 6.4-15.4 9.9C50.8 219.7 16 281.8 16 352zm96-40c0-48.6 50.1-88 112-88s112 39.4 112 88c0 25.5-13.9 48.6-36 64.6c-7.1 5.2-12 13-12 21.8l0 9.6c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-9.6c0-8.8-4.9-16.7-12-21.8c-22.1-16.1-36-39.1-36-64.6z',
      'M288 398.4c0-8.8 4.9-16.7 12-21.8c22.1-16.1 36-39.1 36-64.6c0-48.6-50.1-88-112-88s-112 39.4-112 88c0 25.5 13.9 48.6 36 64.6c7.1 5.2 12 13 12 21.8l0 9.6c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-9.6zM160 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faFlaskPoison = faFlaskRoundPoison;
const faVolumeOff = {
  prefix: 'fad',
  iconName: 'volume-off',
  icon: [
    320,
    512,
    [],
    'f026',
    [
      '',
      'M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160 64 160c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l67.8 0L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448l0-384z',
    ],
  ],
};
const faBookCircleArrowRight = {
  prefix: 'fad',
  iconName: 'book-circle-arrow-right',
  icon: [
    640,
    512,
    [],
    'e0bc',
    [
      'M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 166.6C374.1 219.5 320 287.4 320 368c0 5.4 .2 10.7 .7 16L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l243.2 0c13.1 25.6 32.2 47.6 55.6 64L384 512 96 512c-53 0-96-43-96-96L0 96z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z',
    ],
  ],
};
const faChartUser = {
  prefix: 'fad',
  iconName: 'chart-user',
  icon: [
    640,
    512,
    ['user-chart'],
    'f6a3',
    [
      'M160 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-11.8-25.5-29.9-47.5-52.4-64L576 352l0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-32zM303 175c9.4-9.4 24.6-9.4 33.9 0l47 47 55.7-55.7-27-27c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l88 0c8.8 0 16 7.2 16 16l0 88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9z',
      'M160 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-26.7 32C59.7 352 0 411.7 0 485.3C0 500.1 11.9 512 26.7 512l266.7 0c14.7 0 26.7-11.9 26.7-26.7C320 411.7 260.3 352 186.7 352l-53.3 0z',
    ],
  ],
};
const faUserChart = faChartUser;
const faHandsAslInterpreting = {
  prefix: 'fad',
  iconName: 'hands-asl-interpreting',
  icon: [
    640,
    512,
    ['american-sign-language-interpreting', 'asl-interpreting', 'hands-american-sign-language-interpreting'],
    'f2a3',
    [
      'M305.1 392.4c4.7 17.1 22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-72 0-8 0c-35.2 3-65.4 23.1-82.1 52c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.6-27.1 22.2-22.5 39.3z',
      'M142.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9l-23 46L235.5 7.4c13.6-11.3 33.8-9.5 45.1 4.1s9.5 33.8-4.1 45.1l-81.6 68L295.6 97.1c17.1-4.7 34.6 5.4 39.3 22.5s-5.4 34.6-22.5 39.3l-80.8 22c24.9 7.9 45.6 24.9 58.4 47.1c8.8 15.3 3.6 34.9-11.7 43.7s-34.9 3.6-43.7-11.7c-7-12-19.9-20-34.7-20c-22.1 0-40 17.9-40 40s17.9 40 40 40c14.8 0 27.7-8 34.7-20c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7c-16.7 28.8-46.9 49-82.1 51.7l0 .3-8 0-72 0C57.3 384 0 326.7 0 256l0-9.3c0-19.9 4.6-39.5 13.5-57.2L99.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3z',
    ],
  ],
};
const faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faAslInterpreting = faHandsAslInterpreting;
const faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faPresentationScreen = {
  prefix: 'fad',
  iconName: 'presentation-screen',
  icon: [
    576,
    512,
    ['presentation'],
    'f685',
    [
      'M32 64l0 224c0 35.3 28.7 64 64 64l160 0 64 0 160 0c35.3 0 64-28.7 64-64l0-224-64 0 0 224L96 288 96 64 32 64z',
      'M0 32C0 14.3 14.3 0 32 0L544 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 64C14.3 64 0 49.7 0 32zM256 386.7l0-34.7 64 0 0 34.7 70.6 70.6c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 445.3l-57.4 57.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L256 386.7z',
    ],
  ],
};
const faPresentation = faPresentationScreen;
const faCircleBolt = {
  prefix: 'fad',
  iconName: 'circle-bolt',
  icon: [
    512,
    512,
    [],
    'e0fe',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.9 5.3c-2.2-6.4-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1s7.6 12.9 4.2 19.6L281.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272 160 272c-6.8 0-12.8-4.3-15.1-10.7z',
      'M334.3 135.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L177.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8z',
    ],
  ],
};
const faFaceSmileHalo = {
  prefix: 'fad',
  iconName: 'face-smile-halo',
  icon: [
    512,
    512,
    [],
    'e38f',
    [
      'M16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5C413.9 178.3 339 192 256 192s-157.9-13.7-210.4-35.5C26.7 190.7 16 230.1 16 272zM139.9 378.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 378.2 212.6 400 256 400s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 404.1 311.1 432 256 432s-93.8-27.9-116.1-53.5zM280 296c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6c-.8 .3-1.7 .4-2.5 .4c-2.5 0-4.9-1.1-6.4-3.2l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80S114.6 0 256 0S512 35.8 512 80zm-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32s192-14.3 192-32zM217.6 300.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z',
    ],
  ],
};
const faCartCircleArrowDown = {
  prefix: 'fad',
  iconName: 'cart-circle-arrow-down',
  icon: [
    640,
    512,
    [],
    'e3ef',
    [
      'M0 24C0 37.3 10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.3-39.9-40-39.9l-411 0C111 12.8 91.6 0 69.5 0L24 0C10.7 0 0 10.7 0 24zM128 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm211.3 19.3l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 393.4l0-89.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 89.4 28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faHousePersonReturn = {
  prefix: 'fad',
  iconName: 'house-person-return',
  icon: [
    640,
    512,
    ['house-person-arrive', 'house-return'],
    'e011',
    [
      'M0 232c0 3.9 .7 7.9 2.2 11.6C7 255.9 18.8 264 32 264l32 0 0 112c0 26.5 21.5 48 48 48l228 0 12.9-51.6c3.2-12.9 9.6-24.8 18.6-34.7l6.8-7.5c-31.2 14.1-68.2 1.2-83.6-29.7c-15.8-31.6-3-70.1 28.6-85.9l10.7-5.4 10.7-25.8c8.9-21.3 22.6-39.7 39.5-54L261.7 16.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192C3.6 214.7 0 223.2 0 232zm144-24c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z',
      'M384 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM513.5 199.3c1 .4 1.9 .8 2.9 1.2l8 3.5c16.4 7.3 29 21.2 34.7 38.2l2.6 7.8c5.6 16.8 23.7 25.8 40.5 20.2s25.8-23.7 20.2-40.5l-2.6-7.8c-11.4-34.1-36.6-61.9-69.4-76.5l-8-3.5c-20.8-9.2-43.3-14-66.1-14c-44.6 0-84.8 26.8-101.9 67.9L359 232.7l-21.4 10.7c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3L393 287.3c10.3-5.2 18.4-13.8 22.8-24.5l9.6-23 19.3 65.5-49.5 54c-5.4 5.9-9.2 13-11.2 20.8l-23 92.1c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.1 70.7-77.1c14.8-16.1 20.3-38.6 14.7-59.7l-16.9-63.5zM571.3 398l-25-62.4c-2.1 3-4.5 5.8-7 8.6l-40.7 44.4 14.5 36.2c2.4 6 6 11.5 10.6 16.1l61.7 61.7c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L571.3 398z',
    ],
  ],
};
const faHousePersonArrive = faHousePersonReturn;
const faHouseReturn = faHousePersonReturn;
const faMessageXmark = {
  prefix: 'fad',
  iconName: 'message-xmark',
  icon: [
    512,
    512,
    ['comment-alt-times', 'message-times'],
    'f4ab',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM168 272c0 6.1 2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7c15.7-15.7 31.4-31.4 47-47c15.7 15.7 31.4 31.4 47 47c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7s7-10.8 7-17s-2.3-12.3-7-17l-47-47 47-47c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17s-10.8-7-17-7s-12.3 2.3-17 7l-47 47-47-47c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-9.4 9.4-9.4 24.6 0 33.9l47 47c-15.7 15.7-31.4 31.4-47 47c-4.7 4.7-7 10.8-7 17z',
      'M209 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faCommentAltTimes = faMessageXmark;
const faMessageTimes = faMessageXmark;
const faFileCertificate = {
  prefix: 'fad',
  iconName: 'file-certificate',
  icon: [
    512,
    512,
    ['file-award'],
    'f5f3',
    [
      'M128 64l0 104.6c1 0 2.1-.2 3-.6l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1L248 285c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6L192 390.2 192 496c0 5.9-3.2 11.3-8.5 14.1c-.4 .2-.7 .4-1.1 .5c-.4 .2-.8 .3-1.2 .5c3.5 .6 7.1 .9 10.7 .9l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L352 0 192 0c-35.3 0-64 28.7-64 64z',
      'M512 160L352 0l0 128c0 17.7 14.3 32 32 32l128 0zm-402.8 1.6c-10-4.1-21.5-1-28.1 7.5L70.6 182.6c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.9-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2L9.1 241.1c-8.5 6.6-11.6 18.1-7.5 28.1L8 285c.8 1.9 .8 4.1 0 6.1L1.6 306.8c-4.1 10-1 21.5 7.5 28.1l13.5 10.5c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.9 19.1 20.5 20.6L64 390.2 64 496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-105.8 15.5-2.1c10.7-1.5 19.1-9.9 20.5-20.6l2.3-16.9c.3-2.1 1.4-4 3-5.2l13.5-10.5c8.5-6.6 11.6-18.1 7.5-28.1L248 291c-.8-1.9-.8-4.1 0-6.1l6.5-15.8c4.1-10 1-21.5-7.5-28.1l-13.5-10.5c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.9-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.5-13.5c-6.6-8.5-18.1-11.6-28.1-7.5L131 168c-1.9 .8-4.1 .8-6.1 0l-15.8-6.5zM64 288a64 64 0 1 1 128 0A64 64 0 1 1 64 288z',
    ],
  ],
};
const faFileAward = faFileCertificate;
const faUserDoctorHairLong = {
  prefix: 'fad',
  iconName: 'user-doctor-hair-long',
  icon: [
    448,
    512,
    [],
    'e459',
    [
      'M128 112c0 10.7 0 21.3 0 32c0 53 43 96 96 96s96-43 96-96l0-16 0-32c-2.7 0-5.3 0-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112c-16 0-32 0-48 0z',
      'M176 112l-48 0s0 0 0 0l0 32c0 53 43 96 96 96s96-43 96-96l0-16s0 0 0 0l0-32-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112zm48 160L70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11s0 0 0 0C96 57.3 153.3 0 224 0c70.6 0 127.8 57.1 128 127.6l0 .8 0 .2 0 10.3c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272zm64 32.2l0 57.8c-27.6 7.1-48 32.2-48 62l0 40c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-40c0-29.8-20.4-54.9-48-62l0-53.2C393.5 326.7 448 393 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-79 54.5-145.3 128-163.2l0 61.5c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-66.1c2.7-.1 5.3-.2 8-.2l112 0c2.7 0 5.3 .1 8 .2zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faCameraSecurity = {
  prefix: 'fad',
  iconName: 'camera-security',
  icon: [
    448,
    512,
    ['camera-home'],
    'f8fe',
    [
      'M128 208a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-74 0 59 36.9c12.1 7.6 17.7 22.2 13.8 36S366.3 512 352 512L96 512c-14.3 0-26.8-9.5-30.8-23.2s1.7-28.4 13.8-36L138 416l-74 0c-35.3 0-64-28.7-64-64L0 64zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z',
    ],
  ],
};
const faCameraHome = faCameraSecurity;
const faGear = {
  prefix: 'fad',
  iconName: 'gear',
  icon: [
    512,
    512,
    [9881, 'cog'],
    'f013',
    [
      'M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M489.6 191.2c6.9-6.2 9.6-15.9 6.4-24.6c-4.4-11.9-9.7-23.3-15.8-34.3l-4.7-8.1c-6.6-11-14-21.4-22.1-31.2c-5.9-7.2-15.7-9.6-24.5-6.8l-55.7 17.7C359.8 93.6 345 85 329.2 78.4L316.7 21.3c-2-9.1-9-16.3-18.2-17.8C284.7 1.2 270.5 0 256 0s-28.7 1.2-42.5 3.5c-9.2 1.5-16.2 8.7-18.2 17.8L182.8 78.4c-15.8 6.5-30.6 15.1-44 25.4L83.1 86.1c-8.8-2.8-18.6-.3-24.5 6.8c-8.1 9.8-15.5 20.2-22.1 31.2l-4.7 8.1c-6.1 11-11.4 22.4-15.8 34.3c-3.2 8.7-.5 18.4 6.4 24.6l43.3 39.4C64.6 238.9 64 247.4 64 256s.6 17.1 1.7 25.4L22.4 320.8c-6.9 6.2-9.6 15.9-6.4 24.6c4.4 11.9 9.7 23.3 15.8 34.3l4.7 8.1c6.6 11 14 21.4 22.1 31.2c5.9 7.2 15.7 9.6 24.5 6.8l55.7-17.7c13.4 10.3 28.2 18.9 44 25.4l12.5 57.1c2 9.1 9 16.3 18.2 17.8c13.8 2.3 28 3.5 42.5 3.5s28.7-1.2 42.5-3.5c9.2-1.5 16.2-8.7 18.2-17.8l12.5-57.1c15.8-6.5 30.6-15.1 44-25.4l55.7 17.7c8.8 2.8 18.6 .3 24.5-6.8c8.1-9.8 15.5-20.2 22.1-31.2l4.7-8.1c6.1-11 11.4-22.4 15.8-34.3c3.2-8.7 .5-18.4-6.4-24.6l-43.3-39.4c1.1-8.3 1.7-16.8 1.7-25.4s-.6-17.1-1.7-25.4l43.3-39.4zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
    ],
  ],
};
const faCog = faGear;
const faDropletSlash = {
  prefix: 'fad',
  iconName: 'droplet-slash',
  icon: [
    640,
    512,
    ['tint-slash'],
    'f5c7',
    [
      'M128 320c0-27.7 12-62.9 29.8-99.6l298.3 235C421.4 490.4 373.2 512 320 512c-106 0-192-86-192-192zm64 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80c0-8.8-7.2-16-16-16s-16 7.2-16 16zm13.8-200c34.9-54.7 72-103 88.9-124.3C300.6 4.2 309.5 0 319.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C381.8 57.7 512 228.8 512 320c0 17.5-2.4 34.5-6.8 50.7C405.4 292.5 305.6 214.2 205.8 136z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTintSlash = faDropletSlash;
const faBookHeart = {
  prefix: 'fad',
  iconName: 'book-heart',
  icon: [
    448,
    512,
    [],
    'f499',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm32 157.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4C258.9 102.5 274.5 96 290.7 96c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z',
    ],
  ],
};
const faMosque = {
  prefix: 'fad',
  iconName: 'mosque',
  icon: [
    640,
    512,
    [128332],
    'f678',
    [
      'M0 126l0 34 160 0 0-34c0-42.8-20.2-83.1-54.4-108.8l-16-12C83.9 .9 76.1 .9 70.4 5.2l-16 12C20.2 42.9 0 83.2 0 126zm192 88.6c0 28.6 11.3 54.5 29.8 73.4l356.4 0c18.4-19 29.8-44.9 29.8-73.4c0-34.4-16.7-66.9-45.7-86.1c-5.4-3.6-10.8-7.1-16-10.6C490.9 81.3 447.5 52.7 412.8 6.4C409.8 2.4 405 0 400 0s-9.8 2.4-12.8 6.4c-34.7 46.3-78.1 74.9-133.5 111.5c-5.2 3.5-10.6 7-16 10.6c-28.9 19.2-45.7 51.7-45.7 86.1z',
      'M160 160l0 104.6c-19.1 11.1-32 31.7-32 55.4l0 160c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2l-64 0c-26.5 0-48-21.5-48-48L0 176l0-16 160 0zM352 512l-64 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l416 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454l0 58z',
    ],
  ],
};
const faDuck = {
  prefix: 'fad',
  iconName: 'duck',
  icon: [
    512,
    512,
    [129414],
    'f6d8',
    [
      'M400.2 220.8c-.1 .6-.1 1.1-.2 1.6c0 .5-.1 1-.1 1.5c7 0 13.9 0 20.9 0c50.3 0 91.1-40.8 91.1-91.1c0-6.4-5.2-11.4-11.4-11.4c-.5 0-1 0-1.4 .1L463.9 126c-10.5 1.3-21.2 1.3-31.8 0l-.6-.1c.3 3.3 .5 6.7 .5 10.1c0 24.6-8.5 47.2-22.8 65c-.7 .8-1.3 1.7-1.9 2.5s-1.2 1.8-1.7 2.7c-1.1 1.8-2.1 3.7-2.9 5.6s-1.5 3.9-1.9 6c-.1 .5-.2 1-.3 1.5s-.2 1-.2 1.5z',
      'M409.2 201c-5.4 6.8-9.2 15-9.2 23.7l0 24c0 6.6 2.8 12.8 7.2 17.7C427.6 289.1 440 319.1 440 352c0 70.7-57.3 128-128 128l-116 0C87.8 480 0 392.2 0 284l0-5.4C0 266.1 10.1 256 22.6 256c6 0 11.8 2.4 16 6.6L54 278c6.2 6.2 15.2 8.5 23.6 6.1l172.8-49.4c10.4-3 15.7-14.5 7.8-21.7c-21-19-34.1-46.5-34.1-77c0-57.4 46.6-104 104-104s104 46.6 104 104c0 24.6-8.5 47.2-22.8 65zM368 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM340.6 296.9c.5-8.8-6.2-16.4-15-16.9s-16.4 6.2-16.9 15c-2.4 41.2-32.6 79-77.3 90.1c-40.3 10.1-80.5-4.6-103.7-33.5c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c31.1 38.7 84 57.6 136.4 44.5c58-14.5 98.3-63.8 101.5-119.3z',
    ],
  ],
};
const faMosquito = {
  prefix: 'fad',
  iconName: 'mosquito',
  icon: [
    640,
    512,
    [],
    'e52b',
    [
      'M0 321.1c0 84.7 97.6 127.1 154.6 67.2L287 267.3l.9-1.2c10.7-9.7 21.3-19.5 32-29.1c10.7 9.6 21.3 19.3 32 29l.9 1.1L485.4 388.3C542.4 448.2 640 405.8 640 321.1c0-48-34-88.4-79.4-94.4c-73.1-11.5-146.2-22.9-219.3-34.5c-14.2 .1-28.4 .1-42.7 0c-73.1 11.5-146.2 23-219.3 34.5C34 232.7 0 273.1 0 321.1z',
      'M463.6 505.6c9.8-8.9 10.7-24.3 2.1-34.3l-42-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266s0 0 0 0l-32-29.2L288 266s0 0 0 0l-66.6 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.4l0 63.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.2 24.4 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1zm-231.3-303l66.4-10.4 42.7 0 66.3 10.4 40.8-40.8c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.3l38.2-50.8c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.2-33.2 4.4l-48 63.8c-5.9 7.9-6.6 18.6-1.7 27.2l22.6 39.4L352 190.4l0-38.1c0-14.9-10.2-27.4-24-31l0-57.1c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.1c-13.8 3.6-24 16.1-24 31l0 38.1-50.2-50.2 22.6-39.4c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.8c-8-10.6-22.9-12.6-33.2-4.4s-12.3 23.5-4.3 34.1l38.2 50.8L187.6 132c-5.5 9.7-3.9 21.9 3.9 29.8l40.8 40.8z',
    ],
  ],
};
const faStarOfDavid = {
  prefix: 'fad',
  iconName: 'star-of-david',
  icon: [
    512,
    512,
    [10017],
    'f69a',
    [
      'M16 149.4c0 6.9 1.9 13.7 5.5 19.6c17.8 29 35.6 58 53.4 87l32.9 53.5c7 11.5 14.1 23 21.1 34.5l65.7 0c-18-29.3-36-58.7-54-88l-32.9-53.5L86.6 168l42.3 0 34.4-56L53.4 112C32.8 112 16 128.8 16 149.4zM163.3 400l56.2 91.5c7.8 12.7 21.6 20.5 36.6 20.5s28.8-7.7 36.6-20.5c18.7-30.5 37.4-61 56.2-91.5l34.4-56c7-11.5 14.1-23 21.1-34.5L371.4 256c-18 29.3-36 58.7-54 88c-11.5 18.7-22.9 37.3-34.4 56c-9 14.7-18 29.4-27 44l-27-44-65.7 0zm31.3-232l122.8 0 65.7 0 42.3 0-21.1 34.5c11 17.8 21.9 35.7 32.9 53.5l53.4-87c3.6-5.9 5.5-12.7 5.5-19.6c0-20.7-16.8-37.4-37.4-37.4l-109.8 0L283 112l-54 0-34.4 56z',
      'M283 112L256 68 140.6 256l-32.9-53.5 111.7-182C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112 283 112zm100.1 56L490.5 343c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4l-109.8 0 34.4-56 42.3 0-108-176 65.7 0zM283 400L53.4 400C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87 32.9 53.5L86.6 344l230.8 0L283 400z',
    ],
  ],
};
const faFlagSwallowtail = {
  prefix: 'fad',
  iconName: 'flag-swallowtail',
  icon: [
    448,
    512,
    ['flag-alt'],
    'f74c',
    [
      'M64 32l0 320 360 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24L64 32z',
      'M32 0C49.7 0 64 14.3 64 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0z',
    ],
  ],
};
const faFlagAlt = faFlagSwallowtail;
const faPersonMilitaryRifle = {
  prefix: 'fad',
  iconName: 'person-military-rifle',
  icon: [
    512,
    512,
    [],
    'e54b',
    [
      'M149.7 249.5c8.6-6.4 18-11.8 27.9-16c58.1 83 116.2 166 174.3 248.9c-1.4 12.1-9.6 22.2-20.7 26.2c-60.5-86.4-120.9-172.8-181.4-259.2zM176 110.6c0-11.4 2.4-22.2 6.7-32l146.7 0c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zM327.7 230.8L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7l-30.4 52.7c-1.9 3.2-4.2 6-6.9 8.3c-16.1-22.6-38.6-39.5-64.2-48.8z',
      'M178.1 19.5L334.1 .8C343.6-.4 352 7.1 352 16.6l0 46c0 8.8-7.2 16-16 16l-154.3 0c-16.4 0-29.7-13.3-29.7-29.7c0-15 11.2-27.7 26.1-29.5zM113.7 289.4c9.4-15.8 21.7-29.3 36-40L331.1 508.6c-3.5 1.3-7.2 2-11.1 2l-128 0c-17.7 0-32-14.3-32-32l0-110.3L106.4 459C95.2 478 70.7 484.3 51.7 473s-25.3-35.8-14.1-54.8l76.1-128.8zM352 478.6c0 1.3-.1 2.5-.2 3.8L177.5 233.5c16.6-7.1 34.6-10.9 53.3-10.9l50.4 0c48.1 0 92.6 25.4 117.1 66.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1L352 368.3l0 110.3zm-56-160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faCarGarage = {
  prefix: 'fad',
  iconName: 'car-garage',
  icon: [
    640,
    512,
    [],
    'f5e2',
    [
      'M12.2 205.4c5.9 10.3 16.7 16.1 27.8 16.1c5.4 0 10.8-1.4 15.8-4.2L320 66.4 584.1 217.4c5 2.9 10.5 4.2 15.8 4.2c11.1 0 21.9-5.8 27.8-16.1c8.8-15.3 3.4-34.9-11.9-43.7L343.8 6.3c-14.8-8.4-32.9-8.4-47.6 0L24.1 161.8c-15.3 8.8-20.7 28.3-11.9 43.7z',
      'M234.8 234.6L215.7 288l208.6 0-19.1-53.4c-2.3-6.4-8.3-10.6-15.1-10.6l-140.3 0c-6.8 0-12.8 4.3-15.1 10.6zm-88.6 57.8l28.3-79.3C185.9 181.3 216 160 249.8 160l140.3 0c33.8 0 64 21.3 75.3 53.1l28.3 79.3c20.1 8.5 34.2 28.4 34.2 51.6l0 40 0 64 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32 0-64 0-40c0-23.2 14.1-43.1 34.2-51.6zM216 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faCartShopping = {
  prefix: 'fad',
  iconName: 'cart-shopping',
  icon: [
    576,
    512,
    [128722, 'shopping-cart'],
    'f07a',
    [
      'M120.1 32c2 4.2 3.5 8.8 4.4 13.5c15.4 80.8 30.8 161.7 46.2 242.5l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32l-411 0z',
      'M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l51.6 271c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faShoppingCart = faCartShopping;
const faBookFont = {
  prefix: 'fad',
  iconName: 'book-font',
  icon: [
    448,
    512,
    [],
    'e0bf',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zM254.3 72.8l64 128 32 64c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 224l-108.2 0-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l32-64 64-128c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM240 115.8L201.9 192l76.2 0L240 115.8z',
    ],
  ],
};
const faShieldPlus = {
  prefix: 'fad',
  iconName: 'shield-plus',
  icon: [
    512,
    512,
    [],
    'e24a',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM144 256c0-13.3 10.7-24 24-24l64 0c0-21.3 0-42.7 0-64c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.1l0 .4c0 21.3 0 42.7 0 64l64 0c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.5 .1 2l0 .4 0 .4c0 .5 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7l-64 0c0 21.3 0 42.7 0 64l0 .3c0 .6 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3.1-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-21.3 0-42.7 0-64l-64 0c-13.3 0-24-10.7-24-24z',
      'M232 280l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faVials = {
  prefix: 'fad',
  iconName: 'vials',
  icon: [
    512,
    512,
    [],
    'f493',
    [
      'M0 64C0 46.3 14.3 32 32 32l56 0 48 0 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 96C14.3 96 0 81.7 0 64zM88 96l0 160 0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144 0-160L88 96zM288 64c0-17.7 14.3-32 32-32l56 0 48 0 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-304c-17.7 0-32-14.3-32-32zm88 32l0 160 0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144 0-160-48 0z',
      'M136 256l-48 0 0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144zm288 0l-48 0 0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144z',
    ],
  ],
};
const faEyeDropperFull = {
  prefix: 'fad',
  iconName: 'eye-dropper-full',
  icon: [
    512,
    512,
    [],
    'e172',
    [
      'M0 480c0 8.3 3.2 16.5 9.4 22.6s14.4 9.4 22.6 9.4c6.1 0 12.3-1.8 17.7-5.4L89.7 480l42.4 0c21.2 0 41.6-8.4 56.6-23.4L332 313.3 286.7 268c-8.5 8.5-16.9 16.9-25.4 25.4L143.4 411.3c-3 3-7.1 4.7-11.3 4.7L96 416c0-12 0-24.1 0-36.1c0-.5 0-1.1 .1-1.6s.1-1 .2-1.6c.2-1 .5-2 .9-3c.8-1.9 2-3.7 3.5-5.2c39.3-39.3 78.6-78.6 117.9-117.9c8.5-8.5 16.9-16.9 25.4-25.4c-15.1-15.1-30.2-30.2-45.3-45.3L55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4L5.4 462.2C1.8 467.7 0 473.8 0 480z',
      'M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM143.4 411.3L261.4 293.4l-42.7-42.7L100.7 368.6c-3 3-4.7 7.1-4.7 11.3L96 416l36.1 0c4.2 0 8.3-1.7 11.3-4.7z',
    ],
  ],
};
const faDistributeSpacingHorizontal = {
  prefix: 'fad',
  iconName: 'distribute-spacing-horizontal',
  icon: [
    512,
    512,
    [],
    'e365',
    [
      'M160 144c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-224z',
      'M56 0C42.7 0 32 10.7 32 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24L80 24C80 10.7 69.3 0 56 0zM456 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faTabletRugged = {
  prefix: 'fad',
  iconName: 'tablet-rugged',
  icon: [
    448,
    512,
    [],
    'f48f',
    [
      'M0 73.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3L32 176l0 16L8.8 203.6C3.4 206.3 0 211.8 0 217.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3L32 320l0 16L8.8 347.6C3.4 350.3 0 355.8 0 361.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3l25.5 12.7C41.8 492.2 66.6 512 96 512l256 0c29.4 0 54.2-19.8 61.7-46.8l25.5-12.7c5.4-2.7 8.8-8.2 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L416 336l0-16 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L416 192l0-16 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L413.7 46.8C406.2 19.8 381.4 0 352 0L96 0C66.6 0 41.8 19.8 34.3 46.8L8.8 59.6C3.4 62.3 0 67.8 0 73.9zM96 80c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16L96 80z',
      'M96 80c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V80z',
    ],
  ],
};
const faTemperatureSnow = {
  prefix: 'fad',
  iconName: 'temperature-snow',
  icon: [
    576,
    512,
    ['temperature-frigid'],
    'f768',
    [
      'M288 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L544 112C544 50.2 493.9 0 432 0S320 50.2 320 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L384 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C505.8 332.6 512 349.5 512 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M288 131.6l-88 50.8 0-55.8 35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4 200 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 25.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6l0 55.8-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6l0 55.8-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6l0 25.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-25.4 12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4l0-55.8 67.7 39.1c5.2-13.5 12-26.2 20.3-37.9l0-5.8-64-37 64-37 0-55.4zM432 256c-8.8 0-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faTemperatureFrigid = faTemperatureSnow;
const faMoped = {
  prefix: 'fad',
  iconName: 'moped',
  icon: [
    640,
    512,
    [],
    'e3b9',
    [
      'M64 384c0 53 43 96 96 96s96-43 96-96l-48 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-48 0zM96 128c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM416 384a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M328 56c0-13.3 10.7-24 24-24l41.3 0c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4l8.4 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-8.4 0c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8l-42.1 0c-.9 0-1.7 0-2.6-.1L32 384c-17.7 0-32-14.3-32-32l0-32c0-70.7 57.3-128 128-128l96 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l77.3 0c16.8-38.5 48.4-69.2 87.6-84.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4L352 80c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faFaceSmilePlus = {
  prefix: 'fad',
  iconName: 'face-smile-plus',
  icon: [
    640,
    512,
    ['smile-plus'],
    'f5b9',
    [
      'M0 288a224 224 0 1 0 448 0A224 224 0 1 0 0 288zm112.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM116 367.3c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7zM336.4 240a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M544 0c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faSmilePlus = faFaceSmilePlus;
const faRadioTuner = {
  prefix: 'fad',
  iconName: 'radio-tuner',
  icon: [
    512,
    512,
    ['radio-alt'],
    'f8d8',
    [
      'M0 192c0-21.4 10.5-40.3 26.7-52c10.5-7.6 23.4-12 37.3-12c51.5 0 103 0 154.5 0c76.5 0 153 0 229.5 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zm64.2 28.7c-.1 .6-.1 1.1-.1 1.6c0 .5 0 1.1 0 1.6c0 .8 0 1.3 0 1.8c0 0 0 .8 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4c106.7 0 213.3 0 320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-106.7 0-213.3 0-320 0c-8.8 0-16.8 3.6-22.6 9.4c-2.9 2.9-5.2 6.3-6.9 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2zM64 352c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 336c-8.8 0-16 7.2-16 16zm16 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm240-32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M511 17.3c3.7 12.7-3.6 26.1-16.3 29.8L218.5 128 64 128c-13.9 0-26.9 4.5-37.4 12c7.3-5.9 15.7-10.4 25.1-13.2L481.3 1C494-2.8 507.3 4.5 511 17.3zM64 224c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
    ],
  ],
};
const faRadioAlt = faRadioTuner;
const faFaceSwear = {
  prefix: 'fad',
  iconName: 'face-swear',
  icon: [
    640,
    512,
    [],
    'e399',
    [
      'M64 256C64 114.6 178.6 0 320 0S576 114.6 576 256L64 256zM176.8 138.9c-2.8 8.4 1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1zm160 42.1c2.8 8.4 11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2z',
      'M0 336c0-26.5 21.5-48 48-48l544 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 336zm416 32c0-8.8-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32 16 0c8.8 0 16-7.2 16-16zm-64 16l0 32-32 0 0-32 32 0zm220.1-29.6c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7l-96 112c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l96-112zM472 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM208 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 320c-8.8 0-16 7.2-16 16l0 1.5c-5.6 1.2-11.6 3.3-16.9 7c-7.5 5.3-12.7 13.3-14.5 23.5c-1.3 7.2-.6 14.4 2.5 20.9c3 6.4 7.8 10.9 12.4 14.1c6.8 4.7 15 6.9 23.1 9.2c8.4 2.3 16.7 4.7 23.6 9.7c2.6 1.9 2.6 6.7-.4 8.5c0 0 0 0 0 0c-1.1 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c4.9 1.6 12.1 4 20.2 5.9l0 3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-.8c5.1-.8 10.4-2.4 15.3-5.4c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.1c-2.8-6.6-7.4-11.3-12.1-14.7c-7.4-5.4-16-7.8-24.6-10.2c-8-2.3-16-4.5-22.9-9.2c-2.1-1.4-2.2-4.3 .1-5.9c1.1-.8 3.3-1.7 7.4-2.2c8.3-.9 18.9 .8 26.8 2.9c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.6l0-1.8c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faWaterArrowDown = {
  prefix: 'fad',
  iconName: 'water-arrow-down',
  icon: [
    576,
    512,
    ['water-lower'],
    'f774',
    [
      'M.8 359.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 373.7 159 384 192 384c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-5.9-5-13.3-7.6-20.7-7.6c-6.5 0-12.9 2-18.5 5.9C439.4 309.2 410.9 320 384 320c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4zm0 128c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4z',
      'M320 135.7l34.5-31.3c13.1-11.9 33.3-10.9 45.2 2.2s10.9 33.3-2.2 45.2l-88 80c-12.2 11.1-30.8 11.1-43.1 0l-88-80c-13.1-11.9-14-32.1-2.2-45.2s32.1-14 45.2-2.2L256 135.7 256 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 103.7z',
    ],
  ],
};
const faWaterLower = faWaterArrowDown;
const faScannerTouchscreen = {
  prefix: 'fad',
  iconName: 'scanner-touchscreen',
  icon: [
    512,
    512,
    [],
    'f48a',
    [
      'M0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96C28.7 96 0 124.7 0 160zm64 24c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24L88 448c-13.3 0-24-10.7-24-24l0-240z',
      'M152 0c-13.3 0-24 10.7-24 24l0 40 64 0 0-40c0-13.3-10.7-24-24-24L152 0zM312 0c-13.3 0-24 10.7-24 24l0 40 64 0 0-40c0-13.3-10.7-24-24-24L312 0zM224 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16zm48 24l0 240c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-240c0-13.3-10.7-24-24-24L472 0c-13.3 0-24 10.7-24 24zM88 160c-13.3 0-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24l0-240c0-13.3-10.7-24-24-24L88 160z',
    ],
  ],
};
const faCircle7 = {
  prefix: 'fad',
  iconName: 'circle-7',
  icon: [
    512,
    512,
    [],
    'e0f4',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7c-37.3 69.3-74.7 138.7-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L184 176c-13.3 0-24-10.7-24-24z',
      'M160 152c0-13.3 10.7-24 24-24l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L184 176c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faPlugCirclePlus = {
  prefix: 'fad',
  iconName: 'plug-circle-plus',
  icon: [
    576,
    512,
    [],
    'e55f',
    [
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 67.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.2C87 398 32 333.4 32 256l0-32c-17.7 0-32-14.3-32-32zM64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 96-64 0 0-96zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96-64 0 0-96z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faPersonSkiJumping = {
  prefix: 'fad',
  iconName: 'person-ski-jumping',
  icon: [
    512,
    512,
    ['ski-jump'],
    'f7c7',
    [
      'M0 488c0 3.7 .9 7.5 2.7 11c6.1 11.8 20.6 16.4 32.3 10.3L455.8 291.7c34.5-17.9 56.2-53.5 56.2-92.4l0-7.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 7.3c0 20.9-11.7 40.1-30.3 49.7C349 292.9 264.2 336.7 179.5 380.6l-55.3 28.6C87.1 428.3 50.1 447.5 13 466.7C4.7 470.9 0 479.3 0 488z',
      'M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32l144.5 0c46 0 65.6 58.4 29 86.2L230.1 260.8l-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6L179.5 380.6l-55.3 28.6c-10.7-8.4-15.2-23-10.2-36.4l44-117.4c3.9-10.5 9.7-20.2 17-28.8L232.1 160 160 160c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faSkiJump = faPersonSkiJumping;
const faPlaceOfWorship = {
  prefix: 'fad',
  iconName: 'place-of-worship',
  icon: [
    640,
    512,
    [],
    'f67f',
    [
      'M0 375c0-18.9 11.1-36 28.3-43.8L160 272l0 240c-37.3 0-74.7 0-112 0c-26.5 0-48-21.5-48-48l0-89zM480 272l131.7 59.3C628.9 339 640 356.2 640 375l0 89c0 26.5-21.5 48-48 48c-37.3 0-74.7 0-112 0l0-240z',
      'M224 201.6l0-92.3c0-8.5 3.4-16.6 9.4-22.6l75.3-75.3c6.2-6.2 16.4-6.2 22.6 0l75.3 75.3c6 6 9.4 14.1 9.4 22.6l0 92.3L456.7 226c14.5 8.7 23.3 24.3 23.3 41.2L480 512l-96 0 0-96c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96-96 0 0-244.8c0-16.9 8.8-32.5 23.3-41.2L224 201.6z',
    ],
  ],
};
const faWaterArrowUp = {
  prefix: 'fad',
  iconName: 'water-arrow-up',
  icon: [
    576,
    512,
    ['water-rise'],
    'f775',
    [
      'M.8 359.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 373.7 159 384 192 384c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-5.9-5-13.3-7.6-20.7-7.6c-6.5 0-12.9 2-18.5 5.9C439.4 309.2 410.9 320 384 320c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4zm0 128c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4z',
      'M320 104.3l34.5 31.3c13.1 11.9 33.3 10.9 45.2-2.2s10.9-33.3-2.2-45.2l-88-80c-12.2-11.1-30.8-11.1-43.1 0l-88 80c-13.1 11.9-14 32.1-2.2 45.2s32.1 14 45.2 2.2L256 104.3 256 208c0 17.7 14.3 32 32 32s32-14.3 32-32l0-103.7z',
    ],
  ],
};
const faWaterRise = faWaterArrowUp;
const faWaveformLines = {
  prefix: 'fad',
  iconName: 'waveform-lines',
  icon: [
    640,
    512,
    ['waveform-path'],
    'f8f2',
    [
      'M96 224l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM288 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M256 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm576 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
    ],
  ],
};
const faWaveformPath = faWaveformLines;
const faSplit = {
  prefix: 'fad',
  iconName: 'split',
  icon: [
    512,
    512,
    [],
    'e254',
    [
      'M165.5 288c25.5 0 49.9-10.1 67.9-28.1c1.3-1.3 2.6-2.6 3.9-3.9l86.6 86.6c6 6 14.1 9.4 22.6 9.4l37.5 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-6.1 6.1-14.3 9.4-22.6 9.4c-4.1 0-8.3-.8-12.2-2.4c-12-5-19.8-16.6-19.8-29.6l0-32-37.5 0c-25.5 0-49.9-10.1-67.9-28.1l-90.5-90.5c-6-6-14.1-9.4-22.6-9.4z',
      'M438.6 41.4c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-37.5 0c-25.5 0-49.9 10.1-67.9 28.1l-90.5 90.5c-6 6-14.1 9.4-22.6 9.4L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l133.5 0c25.5 0 49.9-10.1 67.9-28.1l90.5-90.5c6-6 14.1-9.4 22.6-9.4l37.5 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64z',
    ],
  ],
};
const faFilmCanister = {
  prefix: 'fad',
  iconName: 'film-canister',
  icon: [
    576,
    512,
    ['film-cannister'],
    'f8b7',
    [
      'M32 96l288 0 0 32 0 288 0 32L32 448 32 96z',
      'M96 32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l64 0zM0 480c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM320 128l224 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32l-160 0 0-288zm72 56l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM392 344l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faFilmCannister = faFilmCanister;
const faFolderXmark = {
  prefix: 'fad',
  iconName: 'folder-xmark',
  icon: [
    512,
    512,
    ['folder-times'],
    'f65f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM168 352c0-6.1 2.3-12.3 7-17c15.7-15.7 31.4-31.4 47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l47 47 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-47 47 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7c-15.7-15.7-31.4-31.3-47-47c-15.7 15.7-31.4 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M209 207c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faFolderTimes = faFolderXmark;
const faToiletPaperBlank = {
  prefix: 'fad',
  iconName: 'toilet-paper-blank',
  icon: [
    640,
    512,
    ['toilet-paper-alt'],
    'f71f',
    [
      'M16 480c0 5.4 1.4 10.9 4.2 15.8C25.8 505.8 36.5 512 48 512l269.9 0c22.3 0 45.4-12.1 55.4-36.1c7.4-17.9 17.7-47.8 26.3-91.9c9.1-47 16.4-110.1 16.4-192c0-.2 0-.4 0-.5c0-3.1 0-6.2 .1-9.3l0-.5c.1-2.9 .2-6 .3-9l0-.8c.2-2.9 .3-5.9 .6-8.9c.3-3.3 .5-6.4 .8-9.5c1.3-12.6 3.2-24.7 5.6-36.1c4.9-23 11.9-43.6 20.6-61C461.5 21.5 485.5 0 512 0L160 0C107 0 64 86 64 192c0 85.3-.4 193.7-43.5 271.6c-3 5-4.5 10.7-4.5 16.4z',
      'M399.6 384L512 384c53 0 96-86 96-192S565 0 512 0s-96 86-96 192c0 81.9-7.3 145-16.4 192zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z',
    ],
  ],
};
const faToiletPaperAlt = faToiletPaperBlank;
const faTabletScreen = {
  prefix: 'fad',
  iconName: 'tablet-screen',
  icon: [
    448,
    512,
    ['tablet-android-alt'],
    'f3fc',
    [
      'M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 0l0 320 320 0 0-320L64 64zm96 384c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
      'M64 64H384V384H64V64z',
    ],
  ],
};
const faTabletAndroidAlt = faTabletScreen;
const faHexagonVerticalNftSlanted = {
  prefix: 'fad',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [
    448,
    512,
    [],
    'e506',
    [
      'M0 168.3L0 344.9c0 25.7 13.7 49.5 36 62.4l152.9 88.3c22.3 12.9 49.7 12.9 72 0l152.9-88.3c22.3-12.9 36-36.6 36-62.4l0-176.6c0-25.7-13.7-49.5-36-62.4L260.9 17.6c-22.3-12.9-49.7-12.9-72 0L36 105.9C13.7 118.8 0 142.6 0 168.3zm64.1 5.4c.2-.9 .4-1.8 .8-2.7c.7-1.7 1.6-3.4 2.8-4.8c2.4-2.8 5.8-4.8 9.6-5.4c7.7-1.3 15.3 3.3 17.7 10.7c10.9 32.8 21.9 65.6 32.8 98.5c0-41.8 0-83.6 0-125.5c0-.5 0-1 .1-1.5s.1-1.1 .2-1.6c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c8.8 0 16 7.2 16 16c0 74.7 0 149.3 0 224c0 7.9-5.7 14.5-13.4 15.8c-7.7 1.3-15.3-3.3-17.7-10.7L95.8 275.2l0 61.4c0 8.8-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.6c0-53.3 0-106.7 0-160.1c0-.4 0-.9 .1-1.4s.1-1 .2-1.4zM192 94c.1-.8 .3-1.6 .5-2.4c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.9-2.6c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2c15.9 9.1 31.9 18.2 47.8 27.3c5 2.8 8.1 8.2 8.1 13.9c0 12.3-13.3 20-23.9 13.9c-8.1-4.6-16.1-9.2-24.2-13.8c0 39 0 78 0 117c10.7 0 21.3 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-10.7 0-21.3 0-32 0c0 42.7 0 85.3 0 128c-.1 8.9-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.6c0-48 0-96 0-144c0-53.4 0-106.8 0-160.2c0-.4 0-.8 0-1.2s.1-.8 .1-1.2zm96 56.9c0-12.3 13.3-20 23.9-13.9l72 41.1c5.2 3 8.1 8.4 8.1 13.9c0 2.7-.7 5.4-2.1 7.9c-4.4 7.7-14.2 10.3-21.8 6l-16.2-9.3 0 155.9c0 8.8-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.6c0-58.1 0-116.1 0-174.2c-7.9-4.5-15.9-9.1-23.8-13.6c-5-2.8-8.1-8.2-8.1-13.9z',
      'M263.9 109.6c5 2.8 8.1 8.2 8.1 13.9c0 12.3-13.3 20-23.9 13.9l-24.2-13.8 0 117 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144 0-160.2c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6c0 0 .1 0 .1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3zm32.1 55.2c-5-2.8-8.1-8.2-8.1-13.9c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3 0 155.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-174.2-23.8-13.6zM159.8 144.6l0 224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2l0 61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270l0-125.4c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faFolderMusic = {
  prefix: 'fad',
  iconName: 'folder-music',
  icon: [
    512,
    512,
    [],
    'e18d',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM128 384c0-17.7 21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 384c0 17.7-21.5 32-48 32s-48-14.3-48-32z',
      'M345.1 178.8c4.3 3 6.9 7.9 6.9 13.2l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 384c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8z',
    ],
  ],
};
const faDisplayMedical = {
  prefix: 'fad',
  iconName: 'display-medical',
  icon: [
    576,
    512,
    ['desktop-medical'],
    'e166',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0 96 0 176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 0l448 0 0 288L64 352 64 64z',
      'M64 64l448 0 0 288L64 352 64 64zM346.7 448l69.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416l96 0 10.7 32zM256 128l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faDesktopMedical = faDisplayMedical;
const faShareAll = {
  prefix: 'fad',
  iconName: 'share-all',
  icon: [
    576,
    512,
    [],
    'f367',
    [
      'M352 64l0 43.3 85.4 76.9c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8L352 308.7l0 43.3c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-6-5.4-13.7-8.2-21.4-8.2c-4.4 0-8.8 .9-13 2.8c-11.5 5.1-19 16.6-19 29.2z',
      'M243 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-48 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l32 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z',
    ],
  ],
};
const faPeapod = {
  prefix: 'fad',
  iconName: 'peapod',
  icon: [
    512,
    512,
    [],
    'e31c',
    [
      'M88 368a56 56 0 1 0 112 0A56 56 0 1 0 88 368zM200 256a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM312 144a56 56 0 1 0 112 0 56 56 0 1 0 -112 0z',
      'M464 0L416 0C186.2 0 0 186.2 0 416l0 48c0 26.5 21.5 48 48 48l48 0c229.8 0 416-186.2 416-416l0-48c0-26.5-21.5-48-48-48zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z',
    ],
  ],
};
const faChessClock = {
  prefix: 'fad',
  iconName: 'chess-clock',
  icon: [
    640,
    512,
    [],
    'f43d',
    [
      'M96 56c0 13.3 10.7 24 24 24l32 0 0 48 48 0 0-48 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 32c-13.3 0-24 10.7-24 24zm64 184l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM384 112l0 16 160 0 0-16c0-8.8-7.2-16-16-16L400 96c-8.8 0-16 7.2-16 16zm68.7 180.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-48 48z',
      'M0 192c0-35.3 28.7-64 64-64l512 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z',
    ],
  ],
};
const faAxe = {
  prefix: 'fad',
  iconName: 'axe',
  icon: [
    640,
    512,
    [129683],
    'f6b2',
    [
      'M0 464c0 8.2 3.1 16.4 9.4 22.6l16 16c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4L328 245.3c-20.4-20.4-40.8-40.8-61.3-61.3L9.4 441.4C3.1 447.6 0 455.8 0 464zM384 352l0 32c0 17.7 14.3 32 32 32c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32l-32 0 0 32c0 1.4 0 2.7-.1 4.1s-.1 2.7-.2 4.1c-.1 2.7-.3 5.4-.6 8.1c-.5 5.3-1.3 10.6-2.4 15.8C560.1 286.7 510.7 336.1 448 348.8c-10.3 2.1-21 3.2-32 3.2l-32 0zM408 42.7L469.3 104l33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16C480.4 3.1 472.2 0 464 0s-16.4 3.1-22.6 9.4L408 42.7z',
      'M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L525.3 160l50.7 0 0 32c0 88.4-71.6 160-160 160l-32 0 0-50.7L233.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96z',
    ],
  ],
};
const faSquareD = {
  prefix: 'fad',
  iconName: 'square-d',
  icon: [
    448,
    512,
    [],
    'e268',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208zm48 24l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z',
      'M128 152c0-13.3 10.7-24 24-24l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208zm48 24l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z',
    ],
  ],
};
const faGripVertical = {
  prefix: 'fad',
  iconName: 'grip-vertical',
  icon: [
    320,
    512,
    [],
    'f58e',
    [
      'M192 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm0 160l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm0 160l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40z',
      'M40 480l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm0-160l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32z',
    ],
  ],
};
const faMobileSignalOut = {
  prefix: 'fad',
  iconName: 'mobile-signal-out',
  icon: [
    512,
    512,
    [],
    'e1f0',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-160-64 0 0 160L64 448 64 64l160 0 0-64L64 0C28.7 0 0 28.7 0 64zM128 400c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z',
      'M256 24c0-13.3 10.7-24 24-24C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24zm0 200a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 96c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faHexagonNodes = {
  prefix: 'fad',
  iconName: 'hexagon-nodes',
  icon: [
    448,
    512,
    [],
    'e699',
    [
      'M32 210.6c15.6 7.4 33.2 7 48 0l0 90.8c-14.8-7-32.4-7.4-48 0l0-90.8zM88 206c6.5-4.6 12.2-10.6 16.5-17.9c4.3-7.5 6.7-15.6 7.4-23.7L192 210.1c-13.4 9.4-22.5 24.4-23.8 41.7L88 206zm0 100.1l80.1-45.8c1.3 17.3 10.4 32.3 23.8 41.7l-80.1 45.8c-.6-8.1-3-16.2-7.4-23.7c-4.3-7.4-9.9-13.4-16.5-18zM200 106.6c7.3 3.5 15.4 5.4 24 5.4s16.7-1.9 24-5.4l0 98.8c-7.3-3.5-15.4-5.4-24-5.4s-16.7 1.9-24 5.4l0-98.8zm0 200c7.3 3.5 15.4 5.4 24 5.4s16.7-1.9 24-5.4l0 98.8c-7.3-3.5-15.4-5.4-24-5.4s-16.7 1.9-24 5.4l0-98.8zm56-96.6l80.1-45.8c.6 8.1 3 16.2 7.4 23.7c4.2 7.4 9.9 13.4 16.5 17.9l-80.1 45.8c-1.3-17.3-10.4-32.3-23.8-41.7zm0 91.9c13.4-9.4 22.5-24.4 23.8-41.7L360 306.1c-6.5 4.6-12.2 10.6-16.5 18c-4.3 7.5-6.7 15.6-7.4 23.7L256 301.9zm112-91.3c14.8 7 32.4 7.4 48 0l0 90.8c-15.6-7.4-33.2-7-48 0l0-90.8z',
      'M168 56a56 56 0 1 1 112 0A56 56 0 1 1 168 56zm196 55.5a56 56 0 1 1 56 97 56 56 0 1 1 -56-97zM7.5 132a56 56 0 1 1 97 56 56 56 0 1 1 -97-56zM168 456a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM104.5 324a56 56 0 1 1 -97 56 56 56 0 1 1 97-56zM364 400.5a56 56 0 1 1 56-97 56 56 0 1 1 -56 97zM224 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112z',
    ],
  ],
};
const faArrowTurnUp = {
  prefix: 'fad',
  iconName: 'arrow-turn-up',
  icon: [
    384,
    512,
    ['level-up'],
    'f148',
    [
      'M0 480c0 17.7 14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7c-10.7-10.7-21.3-21.3-32-32c-10.7 10.7-21.3 21.3-32 32L160 416c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32 14.3-32 32z',
      'M41.4 182.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 77.3 86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0z',
    ],
  ],
};
const faLevelUp = faArrowTurnUp;
const faU = {
  prefix: 'fad',
  iconName: 'u',
  icon: [
    384,
    512,
    [117],
    '55',
    [
      'M32 32c17.7 0 32 14.3 32 32l0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 106-86 192-192 192S0 394 0 288L0 64C0 46.3 14.3 32 32 32z',
      '',
    ],
  ],
};
const faArrowUpFromDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-up-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e09b',
    [
      'M64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M201.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 141.3l0 66.7 0 112c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-112 0-66.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z',
    ],
  ],
};
const faSquareRootVariable = {
  prefix: 'fad',
  iconName: 'square-root-variable',
  icon: [
    576,
    512,
    ['square-root-alt'],
    'f698',
    [
      'M0 256c0 17.7 14.3 32 32 32l45.6 0L180.4 464.1C186.1 474 196.7 480 208 480c1.3 0 2.6-.1 3.9-.2c12.7-1.6 23.2-10.5 26.8-22.8L344 96l200 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L344 32c-28.4 0-53.5 18.8-61.4 46.1L198.1 367.6 132.9 255.8C121.4 236.1 100.4 224 77.6 224L32 224c-17.7 0-32 14.3-32 32z',
      'M521.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L480 274.7l41.4-41.4z',
    ],
  ],
};
const faSquareRootAlt = faSquareRootVariable;
const faLightSwitchOn = {
  prefix: 'fad',
  iconName: 'light-switch-on',
  icon: [
    384,
    512,
    [],
    'e019',
    [
      'M96 160l0 96 192 0 0-96c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64z',
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm96 96l0 192c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zM208 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faArrowDownArrowUp = {
  prefix: 'fad',
  iconName: 'arrow-down-arrow-up',
  icon: [
    576,
    512,
    ['sort-alt'],
    'f883',
    [
      'M297.4 137.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3 384 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-96-96C432.4 35.1 424.2 32 416 32s-16.4 3.1-22.6 9.4l-96 96z',
      'M137.4 470.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 370.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96z',
    ],
  ],
};
const faSortAlt = faArrowDownArrowUp;
const faRaindrops = {
  prefix: 'fad',
  iconName: 'raindrops',
  icon: [
    448,
    512,
    [],
    'f75c',
    [
      'M0 353.2C0 387.9 28.1 416 62.8 416l2.4 0c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L75.5 231.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2L6.4 325.6c-4.2 8.6-6.4 18-6.4 27.6zm96-192c0 34.7 28.1 62.8 62.8 62.8l2.4 0c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L171.5 39.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2l-46.1 94.4c-4.2 8.6-6.4 18-6.4 27.6z',
      'M210 294.2l97.8-159.4c2.6-4.2 7.2-6.8 12.2-6.8s9.6 2.6 12.2 6.8L430 294.2c11.8 19.2 18 41.3 18 63.8c0 67.4-54.6 122-122 122H314c-67.4 0-122-54.6-122-122c0-22.5 6.2-44.6 18-63.8z',
    ],
  ],
};
const faDash = {
  prefix: 'fad',
  iconName: 'dash',
  icon: [
    512,
    512,
    ['minus-large'],
    'e404',
    ['M0 256c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z', ''],
  ],
};
const faMinusLarge = faDash;
const faClock = {
  prefix: 'fad',
  iconName: 'clock',
  icon: [
    512,
    512,
    [128339, 'clock-four'],
    'f017',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c.1-13.4 10.8-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.5c0 41 0 82.1 0 123.2L365.3 300c6.9 4.6 10.7 12.2 10.7 20c0 4.6-1.3 9.2-4 13.3c-4.6 6.9-12.2 10.7-20 10.7c-4.6 0-9.2-1.3-13.3-4c-32-21.3-64-42.7-96-64C236 271.5 232 264 232 256c0-45.3 0-90.7 0-136z',
      'M256 96c-13.3 0-24 10.7-24 24l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faClockFour = faClock;
const faInputNumeric = {
  prefix: 'fad',
  iconName: 'input-numeric',
  icon: [
    640,
    512,
    [],
    'e1bd',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm64 0l512 0 0 256L64 384l0-256z',
      'M294.6 214.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-33.2 0 34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6zM128 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 96-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-120c0-13.3-10.7-24-24-24l-32 0z',
    ],
  ],
};
const faTruckTow = {
  prefix: 'fad',
  iconName: 'truck-tow',
  icon: [
    640,
    512,
    [],
    'e2b8',
    [
      'M0 160l0 16c0 26.5 21.5 48 48 48s48-21.5 48-48L96 64l96 192 192 0L169.6 10.9C163.5 4 154.7 0 145.5 0L96 0C78.3 0 64 14.3 64 32l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M416 96c-17.7 0-32 14.3-32 32l0 128L48 256c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l17.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l97.1 0 1.1 0c7.8-54.3 54.4-96 110.9-96c56.2 0 102.8 41.4 110.8 95.4c18.9-3.2 33.2-19.6 33.2-39.4l0-88 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L544 114.7c-12-12-28.3-18.7-45.3-18.7L416 96zM576 256l-128 0 0-96 50.7 0L576 237.3l0 18.7z',
    ],
  ],
};
const faBackwardStep = {
  prefix: 'fad',
  iconName: 'backward-step',
  icon: [
    320,
    512,
    ['step-backward'],
    'f048',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-145 0-30L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M301.6 445c-11.2 5.3-24.5 3.6-34.1-4.4l-192-160L64 271l0-30 11.5-9.6 192-160c9.5-7.9 22.8-9.7 34.1-4.4S320 83.6 320 96l0 320c0 12.4-7.2 23.7-18.4 29z',
    ],
  ],
};
const faStepBackward = faBackwardStep;
const faPallet = {
  prefix: 'fad',
  iconName: 'pallet',
  icon: [
    640,
    512,
    [],
    'f482',
    [
      'M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 224 0 224 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-224 0L96 320l-64 0zm96 64l160 0 0 64-160 0 0-64zm224 0l160 0 0 64-160 0 0-64z',
      '',
    ],
  ],
};
const faCarBolt = {
  prefix: 'fad',
  iconName: 'car-bolt',
  icon: [
    512,
    512,
    [],
    'e341',
    [
      'M0 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48L0 400zm416 0l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48-96 0z',
      'M74.8 96.3L39.6 196.8C16.4 206.4 0 229.3 0 256L0 400l512 0 0-144c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32L165.4 32c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM318.3 119.2L281.9 192l54.1 0c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L230.1 224 176 224c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z',
    ],
  ],
};
const faArrowsMaximize = {
  prefix: 'fad',
  iconName: 'arrows-maximize',
  icon: [
    512,
    512,
    ['expand-arrows'],
    'f31d',
    [
      'M32 64l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-50.7L210.7 256 256 210.7 141.3 96 192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64zM256 301.3L370.7 416 320 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 50.7L301.3 256 256 301.3z',
      'M288 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7L141.3 416l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 50.7L370.7 96 320 96c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faExpandArrows = faArrowsMaximize;
const faFaucet = {
  prefix: 'fad',
  iconName: 'faucet',
  icon: [
    512,
    512,
    [],
    'e005',
    [
      'M0 288l0 64c0 17.7 14.3 32 32 32l100.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160l-32 0-22.6-22.6c-6-6-14.1-9.4-22.6-9.4L256 224l0-76-32-4-32 4 0 76-18.7 0c-8.5 0-16.6 3.4-22.6 9.4L128 256l-96 0c-17.7 0-32 14.3-32 32zM192 96l0 12 32 4 32-4 0-12c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M96 160l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32L224 112 96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32z',
    ],
  ],
};
const faCloudSleet = {
  prefix: 'fad',
  iconName: 'cloud-sleet',
  icon: [
    512,
    512,
    [],
    'f741',
    [
      'M1.9 478.5c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112zM128 416c0 13.3 10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24zm145.9 62.5c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112zM384 416c0 13.3 10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faLampStreet = {
  prefix: 'fad',
  iconName: 'lamp-street',
  icon: [
    512,
    512,
    [],
    'e1c5',
    [
      'M0 176L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-304c0-61.9 50.1-112 112-112s112 50.1 112 112l0 18.7c10.4-1.7 21.1-2.7 32-2.7c1.4 0 2.7 0 4.1 0s2.7 .1 4.1 .1c2.7 .1 5.4 .3 8.1 .5c5.3 .4 10.6 1.1 15.8 2l0-18.7C352 78.8 273.2 0 176 0S0 78.8 0 176zM256 384c0 35.3 28.7 64 64 64s64-28.7 64-64l-128 0z',
      'M320 192c-95.2 0-174.2 69.3-189.4 160.1C127.7 369.6 142.3 384 160 384H480c17.7 0 32.3-14.4 29.4-31.9C494.2 261.3 415.2 192 320 192z',
    ],
  ],
};
const faListRadio = {
  prefix: 'fad',
  iconName: 'list-radio',
  icon: [
    512,
    512,
    [],
    'e1d0',
    [
      'M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32z',
      'M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faPenNibSlash = {
  prefix: 'fad',
  iconName: 'pen-nib-slash',
  icon: [
    640,
    512,
    [],
    'e4a1',
    [
      'M66.1 456c0 8.2 3.1 16.2 9 22.3L228.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-9.4 2.7-18.2 7.4-25.7l-85-67L67.8 445.8c-1.1 3.3-1.7 6.8-1.7 10.2zm31.6 44.9c6.1 5.9 14.1 9 22.3 9c3.4 0 6.8-.5 10.2-1.7l264.3-88.6c3.6-1.2 7.1-2.8 10.5-4.6l-98.5-77.6c-8.7 9-20.9 14.6-34.4 14.6c-7.4 0-14.4-1.7-20.7-4.7L97.7 500.9zM208.1 137.8c80.8 63.3 161.5 126.6 242.3 189.9l28.3-94.4 2.7-9.2L352 94.6l-9.2 2.8L208.1 137.8zM376.7 74.1L501.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L511.6 18.3C500.7 7.4 486.3 1.9 472 1.9s-28.7 5.5-39.6 16.4L376.7 74.1z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBaseballBatBall = {
  prefix: 'fad',
  iconName: 'baseball-bat-ball',
  icon: [
    512,
    512,
    [],
    'f432',
    [
      'M55.3 405.4c17.1 17.1 34.2 34.2 51.3 51.3l51.9-51.9c9.6-9.6 20.3-18.2 31.9-25.5l27.6-17.4c-22.6-22.6-45.2-45.2-67.9-67.9l-17.4 27.6c-7.3 11.5-15.8 22.2-25.5 31.9L55.3 405.4zM352 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6l-55.7 88.2 67.9 67.9 88.2-55.7c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zM49 399c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399z',
    ],
  ],
};
const faSquareUpLeft = {
  prefix: 'fad',
  iconName: 'square-up-left',
  icon: [
    448,
    512,
    [],
    'e282',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 80c0-8.8 7.2-16 16-16l137.4 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6L128 176z',
      'M128 176l0 137.4c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L200 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L264 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16c0-12.5-10.1-22.6-22.6-22.6L144 160c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faOverline = {
  prefix: 'fad',
  iconName: 'overline',
  icon: [
    448,
    512,
    [],
    'f876',
    [
      'M400 304A176 176 0 1 1 48 304a176 176 0 1 1 352 0zm-288 0a112 112 0 1 0 224 0 112 112 0 1 0 -224 0z',
      'M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64z',
    ],
  ],
};
const faS = {
  prefix: 'fad',
  iconName: 's',
  icon: [
    320,
    512,
    [115],
    '53',
    [
      'M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0s0 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z',
      '',
    ],
  ],
};
const faTimeline = {
  prefix: 'fad',
  iconName: 'timeline',
  icon: [
    640,
    512,
    [],
    'e29c',
    [
      'M0 256c0 17.7 14.3 32 32 32l256 0 0 54.7c9.8-4.3 20.6-6.7 32-6.7c1.4 0 2.8 0 4.2 .1s2.8 .2 4.2 .3c2.8 .3 5.5 .7 8.2 1.3c5.4 1.1 10.5 2.8 15.4 4.9l0-54.7 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-54.7c-9.8 4.3-20.6 6.7-32 6.7c-1.4 0-2.8 0-4.2-.1c-1.4-.1-2.8-.2-4.2-.3c-2.8-.3-5.5-.7-8.2-1.3c-5.4-1.1-10.5-2.8-15.4-4.9l0 54.7-320 0 0-54.7c-9.8 4.3-20.6 6.7-32 6.7c-1.4 0-2.8 0-4.2-.1c-1.4-.1-2.8-.2-4.2-.3c-2.8-.3-5.5-.7-8.2-1.3c-5.4-1.1-10.5-2.8-15.4-4.9L96 224l-64 0c-17.7 0-32 14.3-32 32z',
      'M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM512 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM296 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faKeyboard = {
  prefix: 'fad',
  iconName: 'keyboard',
  icon: [
    576,
    512,
    [9000],
    'f11c',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm64 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-192c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32zm96-192c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M80 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm0 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 336l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM176 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM160 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM272 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM256 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM368 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM464 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM448 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faArrowsFromDottedLine = {
  prefix: 'fad',
  iconName: 'arrows-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e0a3',
    [
      'M64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M201.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64zM192 384l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0z',
    ],
  ],
};
const faUsbDrive = {
  prefix: 'fad',
  iconName: 'usb-drive',
  icon: [
    640,
    512,
    [],
    'f8e9',
    [
      'M480 128l128 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-128 0 0-256zm56 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 96a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M0 160c0-35.3 28.7-64 64-64H448c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160z',
    ],
  ],
};
const faBallot = {
  prefix: 'fad',
  iconName: 'ballot',
  icon: [
    448,
    512,
    [],
    'f732',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM192 128c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 128c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 128c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
      'M64 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 352l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faCaretDown = {
  prefix: 'fad',
  iconName: 'caret-down',
  icon: [
    320,
    512,
    [],
    'f0d7',
    [
      'M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z',
      '',
    ],
  ],
};
const faLocationDotSlash = {
  prefix: 'fad',
  iconName: 'location-dot-slash',
  icon: [
    640,
    512,
    ['map-marker-alt-slash'],
    'f605',
    [
      'M128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9zM154 95.4c30.1 23.6 60.2 47.2 90.2 70.7C255 134.7 284.9 112 320 112c44.2 0 80 35.8 80 80c0 28.3-14.7 53.1-36.8 67.4c31.9 25 63.9 50.1 95.8 75.1c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.3 154 95.4z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faMapMarkerAltSlash = faLocationDotSlash;
const faCards = {
  prefix: 'fad',
  iconName: 'cards',
  icon: [
    640,
    512,
    [],
    'e3ed',
    [
      'M306.4 472.3c45.7-26.4 91.3-52.7 137-79.1c3.3-1.9 6.4-4.1 9.1-6.6c9.7-8.6 15.9-20.1 17.9-32.4c1-6.1 1-12.5-.1-18.8c-.5-3.1-1.4-6.2-2.5-9.3s-2.5-6-4.2-9c-46.3-80.2-92.6-160.5-139-240.7C334.4 68.7 346.7 64 360 64l224 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56l-224 0c-25.3 0-46.6-16.7-53.6-39.7zM473.9 187.6l48.4 49.9c3 3.2 8.2 3.2 11.5 0L582 187.6c14-14.5 13.2-38.5-2.2-51.9c-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2c-15.7 13.5-16.5 37.5-2.5 51.9z',
      'M27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zm143.6 55.5c3-11.1 14.4-17.7 25.6-14.8l26.9 7.2 76.1 20.4c26 7 41.4 33.7 34.4 59.7s-33.7 41.4-59.7 34.4l-8.8-2.4c-.4-.1-.8-.2-1.1-.3l17.7 30.7 12.1-7c6.7-3.8 15.2-1.6 19 5.1s1.6 15.2-5.1 19l-48.2 27.8c-6.7 3.8-15.2 1.6-19-5.1s-1.6-15.2 5.1-19l12.1-7-17.7-30.7c-.1 .4-.2 .7-.3 1.1l-2.4 8.8c-7 26-33.7 41.4-59.7 34.4s-41.4-33.7-34.4-59.7l20.4-76.1 7.2-26.9z',
    ],
  ],
};
const faHouseChimneyMedical = {
  prefix: 'fad',
  iconName: 'house-chimney-medical',
  icon: [
    576,
    512,
    ['clinic-medical'],
    'f7f2',
    [
      'M64 270.5L64.1 448c0 35.3 28.7 64 64 64l320.4 0c35.4 0 64-28.7 64-64c-.1-59.2-.3-118.3-.4-177.4L288 74.5 64 270.5zM192 304c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z',
      'M266.9 7.9C279-2.6 297-2.6 309.1 7.9L416 101.5 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121.5 53.1 46.4c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224zM256 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faClinicMedical = faHouseChimneyMedical;
const faBoxingGlove = {
  prefix: 'fad',
  iconName: 'boxing-glove',
  icon: [
    448,
    512,
    [129354, 'glove-boxing'],
    'f438',
    [
      'M32 400l0 48c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-48-131.2 0 28 18.7c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L192 419.2l-39.1 26.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l28-18.7L32 400z',
      'M96 0C43 0 0 43 0 96L0 288c0 28.4 12.4 54 32 71.6L32 400l131.2 0-28-18.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4L192 380.8l39.1-26.1c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-28 18.7 132 0c2.2-13.1 8.4-25.2 17.9-34.7l49.1-49.1c18-18 28.1-42.4 28.1-67.9l0-24.2c0-35.3-28.7-64-64-64l-32 0c-26.5 0-48 21.5-48 48c0 22.3 15.3 41.2 36 46.5c8.6 2.2 13.7 10.9 11.5 19.5s-10.9 13.7-19.5 11.5c-34.5-8.9-60-40.2-60-77.5c0-5.5 .6-10.8 1.6-16L144 192c-26.8 0-45.7-6.7-58.2-14.3c-6.2-3.7-10.7-7.6-13.8-10.7c-1.5-1.5-2.7-2.9-3.6-4c-.4-.5-.8-1-1.1-1.4l-.4-.5-.1-.2-.1-.1c0 0 0 0 0 0s0 0 0 0L80 152l-13.3 8.9c-4.9-7.4-2.9-17.3 4.4-22.2c7.3-4.8 17-3 22 4.2c0 0 0 0 0 0l.1 .1c.2 .2 .6 .8 1.3 1.5c1.4 1.4 3.9 3.6 7.7 5.8c7.4 4.5 20.6 9.7 41.8 9.7l144 0c14.6-19.4 37.8-32 64-32l32 0 0-32c0-53-43-96-96-96L96 0z',
    ],
  ],
};
const faGloveBoxing = faBoxingGlove;
const faTemperatureThreeQuarters = {
  prefix: 'fad',
  iconName: 'temperature-three-quarters',
  icon: [
    320,
    512,
    ['temperature-3', 'thermometer-3', 'thermometer-three-quarters'],
    'f2c8',
    [
      'M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L272 112C272 50.2 221.9 0 160 0S48 50.2 48 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L112 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M176 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 146.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L176 176z',
    ],
  ],
};
const faTemperature3 = faTemperatureThreeQuarters;
const faThermometer3 = faTemperatureThreeQuarters;
const faThermometerThreeQuarters = faTemperatureThreeQuarters;
const faBellSchool = {
  prefix: 'fad',
  iconName: 'bell-school',
  icon: [
    512,
    512,
    [],
    'f5d5',
    [
      'M0 208a208 208 0 1 0 416-.2A208 208 0 1 0 0 208zm288 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
      'M208 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 256c55.9 0 106.6-22 144-57.9L352 464l40 0c18.6 0 34.7-10.6 42.7-26c-11.4-8.8-18.7-22.5-18.7-38c0-26.5 21.5-48 48-48s48 21.5 48 48c0 19.4-11.5 36.1-28 43.7c-11.9 39.5-48.6 68.3-92 68.3l-40 0-240 0c-26.5 0-48-21.5-48-48l0-105.9C101.4 394 152.1 416 208 416z',
    ],
  ],
};
const faMobileScreen = {
  prefix: 'fad',
  iconName: 'mobile-screen',
  icon: [
    384,
    512,
    ['mobile-android-alt'],
    'f3cf',
    [
      'M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zm64 0l0 320 224 0 0-320L80 64zm64 384c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z',
      'M80 64H304V384H80V64z',
    ],
  ],
};
const faMobileAndroidAlt = faMobileScreen;
const faPlaneUp = {
  prefix: 'fad',
  iconName: 'plane-up',
  icon: [
    512,
    512,
    [],
    'e22d',
    [
      'M0 305.1l0 56.7c0 10.9 10.7 18.6 21.1 15.2L192 320l0-160L14.2 278.5C5.3 284.4 0 294.4 0 305.1zM320 160l0 160 170.9 57c10.4 3.5 21.1-4.3 21.1-15.2l0-56.7c0-10.7-5.3-20.7-14.2-26.6L320 160z',
      'M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7L320 400l57.6 43.2c4 3 6.4 7.8 6.4 12.8l0 42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14l0-42c0-5 2.4-9.8 6.4-12.8L192 400l0-306.3z',
    ],
  ],
};
const faFolderHeart = {
  prefix: 'fad',
  iconName: 'folder-heart',
  icon: [
    512,
    512,
    [],
    'e189',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM144 253.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z',
      'M205.3 192c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z',
    ],
  ],
};
const faCircleLocationArrow = {
  prefix: 'fad',
  iconName: 'circle-location-arrow',
  icon: [
    512,
    512,
    ['location-circle'],
    'f602',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm120.2-1.2c.2-1 .4-2.1 .7-3.1c.6-2 1.5-4 2.7-5.7c2.3-3.5 5.6-6.4 9.7-8.2c65.4-28 130.7-56 196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2c-28 65.3-56 130.7-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4c-5.1-1-9.5-3.8-12.6-7.7c-1.6-1.9-2.8-4.1-3.7-6.4c-.4-1.2-.8-2.4-1-3.6c-.1-.6-.2-1.3-.3-1.9s-.1-1.2-.1-1.9c0-30 0-60 0-90l-90 0c-10.4 0-19.4-7.4-21.6-17.6c-.2-1.1-.4-2.2-.3-2.1c-.1-1.1-.1-1.1-.1-2.3c0-1.1 0-1.3 .1-1.6c0-.5 .1-1 .2-1.6z',
      'M274.2 378.7l84-196c3.6-8.3 1.7-17.9-4.7-24.2c-6.3-6.3-15.8-8.2-24.2-4.7l-196 84c-9.6 4.1-15 14.5-12.9 24.6c2.1 10.2 11.1 17.6 21.5 17.6h90v90c0 10.4 7.4 19.5 17.6 21.6c1.5 .3 2.9 .4 4.4 .4c8.8 0 16.7-5.2 20.2-13.3z',
    ],
  ],
};
const faLocationCircle = faCircleLocationArrow;
const faFaceHeadBandage = {
  prefix: 'fad',
  iconName: 'face-head-bandage',
  icon: [
    576,
    512,
    [],
    'e37a',
    [
      'M59.8 372.2C102.2 455.2 188.5 512 288 512c141.4 0 256-114.6 256-256c0-8.2-.4-16.4-1.1-24.4l-15-4.5C451.9 204.3 371.4 192 288 192c-14.1 0-28 .3-41.9 1c-9.4 5.3-18.6 10.8-27.6 16.6c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32c-40.5 32.4-76 70.8-105.1 114c-1.2 1.8-2.8 4.4-4.7 7.5c-2 3.2-4.3 6.9-6.7 10.7zm40-289.8c36.2-7.2 73.1-12.4 110.7-15.4c49.3-24.6 102.2-43 157.7-54.3C342.9 4.5 316 0 288 0C213.6 0 146.6 31.8 99.8 82.4zM240.7 362.8c-2.7-8.4 2-17.4 10.5-20.1c13.4-4.2 28.4-6.8 44.8-6.8c44.2 0 77.2 18.3 98.8 37.9c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3c-8.4 2.7-17.4-2-20.1-10.5zM400.4 240a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M476.2 82.4c-16.4-17.8-35.3-33.2-56.1-45.7c-41.3 5.1-81.2 14.4-119.5 27.4c60 .8 118.7 7.1 175.6 18.4zM506 121.8c-32.7-7.9-66.1-14-100.1-18.3C367.3 98.5 328 96 288 96c-23.1 0-46.1 .8-68.8 2.5c-51 3.7-100.9 11.6-149.3 23.2c-14.1 22.8-24.6 47.9-31 74.7c19.1-5.7 38.5-10.8 58.1-15.3c45.4-10.2 92.2-16.9 140-19.7c16.9-1 33.8-1.5 51-1.5c86.6 0 170.2 12.7 249 36.4c-6.4-26.8-17-51.9-31-74.7zM177 199.3c-43.4 5.8-85.7 14.9-126.6 27.1c-6.2 6.7-12.3 13.5-18.2 20.5c-.1 3-.2 6.1-.2 9.1c0 28 4.5 54.9 12.8 80.1c35.7-52.9 80.5-99.3 132.2-136.7zm41.6 10.3c-14.6 9.4-28.6 19.6-42.1 30.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-14.1-9.2-26.1-21.9-30.4zM368.4 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faSushiRoll = {
  prefix: 'fad',
  iconName: 'sushi-roll',
  icon: [
    448,
    512,
    ['maki-roll', 'makizushi'],
    'e48b',
    [
      'M81.1 172.8c9.2 7.3 21.8 13.8 36.9 19.1c14.8-14.8 32.8-26.7 51.4-36.1c20.5-10.3 40.9-17 56.9-20.8c18.2 27.3 46.6 49.9 82 63.4c26.1-6.5 47.2-15.9 60.4-27c-69.5-5.5-113.5-48.4-122.8-90.8c-7.1-.4-14.4-.6-21.8-.6c-6.4 0-12.7 .1-18.9 .4c.8 6 2.1 11.9 3.8 17.7c-17.3 4.7-37.4 11.8-57.5 21.9c-24.5 12.3-49.9 29.4-70.3 52.7z',
      'M448 368l0-224C448 82.1 347.7 32 224 32S0 82.1 0 144L0 368c0 61.9 100.3 112 224 112s224-50.1 224-112zM224 208c-88.4 0-160-28.7-160-64s71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64z',
    ],
  ],
};
const faMakiRoll = faSushiRoll;
const faMakizushi = faSushiRoll;
const faCarBump = {
  prefix: 'fad',
  iconName: 'car-bump',
  icon: [
    640,
    512,
    [],
    'f5e0',
    [
      'M388 498.3c0 7.5 6.6 13.7 14.9 13.7l186.2 0c8.3 0 14.9-6.2 14.9-13.7c0-1.5-.3-3-.8-4.5C591.4 460.4 560 416 496 416s-95.4 44.4-107.2 77.8c-.5 1.5-.8 3-.8 4.5z',
      'M121.6 148.1l-7 63.6 249.6-66.9L326.4 93.2c-7.8-10.6-21.3-15.4-34.1-12L145.1 120.6c-12.7 3.4-22.1 14.3-23.5 27.4zM47.8 234.2L58 141.1c4.3-39.4 32.3-72 70.6-82.3L275.8 19.4c38.2-10.2 78.9 4 102.3 36l55.4 75.5c25.3 3 47.4 20.9 54.4 47L521 301.5l12.4 46.4c4.6 17.1-5.6 34.6-22.6 39.2l-30.9 8.3c-17.1 4.6-34.6-5.6-39.2-22.6l-12.4-46.4L150 400.9l12.4 46.4c4.6 17.1-5.6 34.6-22.6 39.2l-30.9 8.3c-17.1 4.6-34.6-5.6-39.2-22.6L57.3 425.8 24.2 302.1c-7-26.1 3.2-52.7 23.6-67.9zm108.3 65.7A32 32 0 1 0 94.3 316.5a32 32 0 1 0 61.8-16.6zm255.6-35.3a32 32 0 1 0 -16.6-61.8 32 32 0 1 0 16.6 61.8z',
    ],
  ],
};
const faPiggyBank = {
  prefix: 'fad',
  iconName: 'piggy-bank',
  icon: [
    576,
    512,
    [],
    'f4d3',
    [
      'M208 96c0 13.2 2.7 25.7 7.5 37.2c12.9-3.4 26.5-5.2 40.5-5.2l128 0c1.8 0 3.5 0 5.2 .1s3.5 .1 5.2 .2c3.6-10.1 5.6-21 5.6-32.3c0-53-43-96-96-96s-96 43-96 96z',
      'M507 115.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9l13.3 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0c-9.1 12.1-19.9 22.9-32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-128 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c-34.9-26.2-58.7-66.3-63.2-112L68 304c-37.6 0-68-30.4-68-68s30.4-68 68-68l4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-4 0c-11 0-20 9-20 20s9 20 20 20l31.2 0C114 183 178.6 128 256 128l128 0c7.8 0 15.5 .6 23 1.6C424.6 109.1 450.8 96 480 96l11.5 0c10.4 0 18 9.8 15.5 19.9zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faRacquet = {
  prefix: 'fad',
  iconName: 'racquet',
  icon: [
    512,
    512,
    [],
    'f45a',
    [
      'M0 448c0 8.2 3.1 16.4 9.4 22.6l32 32c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l56-56c6.2-6.2 9.4-14.4 9.4-22.6c0-5.2-1.2-10.3-3.7-15c-1.5-2.7-3.3-5.3-5.6-7.6c-10.7-10.7-21.3-21.3-32-32c-2.3-2.3-4.9-4.2-7.6-5.6c-12.1-6.4-27.5-4.5-37.6 5.6l-56 56C3.1 431.6 0 439.8 0 448z',
      'M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c-1.5-2.7-3.3-5.3-5.6-7.6l-32-32c-2.3-2.3-4.9-4.2-7.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154z',
    ],
  ],
};
const faCarMirrors = {
  prefix: 'fad',
  iconName: 'car-mirrors',
  icon: [
    576,
    512,
    [],
    'e343',
    [
      'M32 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48-96 0zM141.1 192l293.8 0-26.1-74.6C404.3 104.6 392.2 96 378.6 96L197.4 96c-13.6 0-25.7 8.6-30.2 21.4c-8.7 24.9-17.4 49.7-26.1 74.6zM448 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48-96 0z',
      'M167.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4l181.2 0c13.6 0 25.7 8.6 30.2 21.4L434.9 192l-293.8 0 26.1-74.6zM32 224l8.6 0c-5.4 9.4-8.6 20.3-8.6 32l0 144 512 0 0-144c0-11.7-3.1-22.6-8.6-32l8.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.5 0L469.2 96.3C455.7 57.8 419.4 32 378.6 32L197.4 32c-40.8 0-77.1 25.8-90.6 64.3L84.5 160 32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32zm64 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faIndustryWindows = {
  prefix: 'fad',
  iconName: 'industry-windows',
  icon: [
    576,
    512,
    [127981, 'industry-alt'],
    'f3b3',
    [
      'M32 64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 146.1 0 5.3 0 50c64-36.6 128-73.1 192-109.7l0 54.4 0 5.3 0 50c64-36.6 128-73.1 192-109.7L544 304l0 128c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-80 0-48L32 64zM248 328l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm128 0l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z',
      'M363.9 148.8c11.5-6.6 15.5-21.2 8.9-32.7s-21.2-15.5-32.7-8.9L160 210.1l0 55.3L363.9 148.8zm192 0c11.5-6.6 15.5-21.2 8.9-32.7s-21.2-15.5-32.7-8.9L352 210.1l0 55.3L555.9 148.8zM136 312c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm128 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm112 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faIndustryAlt = faIndustryWindows;
const faBoltAuto = {
  prefix: 'fad',
  iconName: 'bolt-auto',
  icon: [
    576,
    512,
    [],
    'e0b6',
    [
      'M0 256c0 3.8 .7 7.6 2 11.2C6.7 279.7 18.7 288 32 288l111.5 0L66.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5C82.8 510 89.4 512 96 512c7.5 0 15.1-2.7 21.1-7.9l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L317.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5C301.2 2 294.6 0 288 0c-7.5 0-15.1 2.7-21.1 7.9l-256 224C3.8 238.1 0 247 0 256z',
      'M492.6 305.7C487.2 294.8 476.1 288 464 288s-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160zM480.2 424l-32.4 0L464 391.6 480.2 424z',
    ],
  ],
};
const faBatteryHalf = {
  prefix: 'fad',
  iconName: 'battery-half',
  icon: [
    576,
    512,
    ['battery-3'],
    'f242',
    [
      'M0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176zm64 0l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160c-8.8 0-16 7.2-16 16z',
      'M96 192h192v128H96V192z',
    ],
  ],
};
const faBattery3 = faBatteryHalf;
const faFluxCapacitor = {
  prefix: 'fad',
  iconName: 'flux-capacitor',
  icon: [
    448,
    512,
    [],
    'f8ba',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm48 64c0 44.2 35.8 80 80 80c16.3 0 31.5-4.9 44.1-13.3c12 12 23.9 23.9 35.9 35.9l0 11c-36.5 7.4-64 39.7-64 78.4c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-11 35.9-35.9c12.6 8.4 27.8 13.3 44.1 13.3c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0 16.3 4.9 31.5 13.3 44.1c-9.8 9.8-19.5 19.5-29.3 29.3c-9.8-9.8-19.5-19.5-29.3-29.3c8.4-12.6 13.3-27.8 13.3-44.1c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
      'M171.3 180.7c3-6.3 4.7-13.3 4.7-20.7c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c7.4 0 14.4-1.7 20.7-4.7L208 262.6l0 44.1c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-44.1 59.3-59.3c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7L224 233.4l-52.7-52.7z',
    ],
  ],
};
const faMountainCity = {
  prefix: 'fad',
  iconName: 'mountain-city',
  icon: [
    640,
    512,
    [],
    'e52e',
    [
      'M288 48l0 92.1 71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-3.5 0 73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3L592 512c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-24 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0-144c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48zm64 32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm160 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M150.4 310.8L175 352l48-64 60.8 0L224 188.9 150.4 310.8zM224 128c12 0 23.1 6.3 29.4 16.7L442.9 458.9c6.5 10.8 6.7 24.3 .7 35.3s-17.6 17.8-30.1 17.8L34.5 512c-12.5 0-24-6.8-30.1-17.8s-5.8-24.5 .7-35.3L194.6 144.7C200.9 134.3 212 128 224 128z',
    ],
  ],
};
const faCoins = {
  prefix: 'fad',
  iconName: 'coins',
  icon: [
    512,
    512,
    [],
    'f51e',
    [
      'M128 80c0 18 14.3 34.6 38.4 48c.4 .2 .7 .4 1.1 .6c8.1-.4 16.3-.6 24.5-.6c56.2 0 108.6 9.4 148.1 25.9c3.8 1.6 7.6 3.3 11.3 5c49.8-3.4 93.2-14.8 122.3-30.9C497.7 114.6 512 98 512 80c0-44.2-86-80-192-80S128 35.8 128 80zM391.9 186.6C405.4 200.1 416 218.1 416 240l0 5.3c19.9-4.8 37.6-11.1 52.2-18.4c1.9-.9 3.7-1.9 5.5-2.9c24.1-13.4 38.4-30 38.4-48l0-35.4c-12.5 10.3-27.6 18.7-43.9 25.5c-21.9 9.1-47.8 16.1-76.2 20.5zM416 278.1l0 63.2c57.4-13.8 96-39.7 96-69.3l0-35.4c-12.5 10.3-27.6 18.7-43.9 25.5c-15.6 6.5-33.1 11.9-52.1 16z',
      'M384 240c0 18-14.3 34.6-38.4 48c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-44.2 86-80 192-80s192 35.8 192 80zM192 352c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352zm148.1 70.1c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448s108.6-9.4 148.1-25.9z',
    ],
  ],
};
const faHoneyPot = {
  prefix: 'fad',
  iconName: 'honey-pot',
  icon: [
    448,
    512,
    [127855],
    'e418',
    [
      'M0 224l448 0c0 50.4-10.5 93-25.5 128l-397 0C10.5 317 0 274.4 0 224zM128 32l48 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104z',
      'M64 32l64 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 208 0c17.7 0 32 14.3 32 32s-14.3 32-32 32c38.9 29.2 64 75.7 64 128L0 224c0-52.3 25.1-98.8 64-128C46.3 96 32 81.7 32 64s14.3-32 32-32zM25.5 352l397 0c-26.3 61.4-66.4 99.8-87.8 117.1c-9.3 7.5-21.1 10.9-33.1 10.9l-155.3 0c-12 0-23.7-3.3-33.1-10.9C91.9 451.8 51.8 413.4 25.5 352z',
    ],
  ],
};
const faOlive = {
  prefix: 'fad',
  iconName: 'olive',
  icon: [
    448,
    512,
    [],
    'e316',
    [
      'M256 129.8c0 19.2 11.1 43.1 31.1 63.1c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8c-20-20-43.9-31.1-63.1-31.1c-9.9 0-18.5 2.9-24.7 9.1s-9.1 14.8-9.1 24.7z',
      'M160 480C71.6 480 0 408.4 0 320C0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zM287.1 192.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z',
    ],
  ],
};
const faKhanda = {
  prefix: 'fad',
  iconName: 'khanda',
  icon: [
    512,
    512,
    [9772],
    'f66d',
    [
      'M193.9 63.6l.4 .7c.3 .5 .7 1.3 1.2 2.3c1 2 2.6 5 4.4 8.6c.5 .9 .9 1.9 1.4 2.9c3.4 7.1 7.7 16.3 11.9 26.5c2.4 5.9 4.8 12.1 7 18.2C227 141.8 232 161.1 232 176s-5 34.2-11.8 53.1c-2.2 6.2-4.6 12.3-7 18.2c-4.2 10.2-8.5 19.4-11.9 26.5c-.5 1-1 2-1.4 2.9c-1.8 3.7-3.3 6.6-4.4 8.6c-.5 1-.9 1.8-1.2 2.3l-.3 .6c-3.7 6.9-2.1 15.2 3.7 20.1L240 343.5l0 19.1c5.5 3.8 11 7.6 16.5 11.4c5.2-3.5 10.3-7.1 15.5-10.6l0-19.8 42.2-35.2c5.9-4.9 7.5-13.2 3.8-19.9c-.2-.3-.3-.5-.4-.7c-.3-.5-.7-1.3-1.2-2.3c-1-2-2.6-5-4.4-8.6c-.5-.9-.9-1.9-1.4-2.9c-3.4-7.1-7.7-16.3-11.9-26.5c-2.4-5.9-4.8-12.1-7-18.2C285 210.2 280 190.9 280 176s5-34.2 11.8-53.1c2.2-6.2 4.6-12.3 7-18.2c4.2-10.2 8.5-19.4 11.9-26.5c.5-1 1-2 1.4-2.9c1.8-3.7 3.3-6.6 4.4-8.6c.5-1 .9-1.8 1.2-2.3l.3-.6c3.7-6.9 2.1-15.2-3.7-20.1l-48-40C263.3 1.2 259.6 0 256 0s-7.3 1.2-10.2 3.7l-48 40c-5.9 4.9-7.5 13.2-3.8 19.9zM224 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7l0-28.9-15.5-10.6L240 424.1l0 28.1c-9.6 5.5-16 15.9-16 27.7z',
      'M389.1 69.4c4.8-5.4 12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3s0 0 0 0s0 0 0 0l.1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1c0 0 0 0 0 0s0 0 0 0L401.1 400l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21l-55.7-38.3-56.8 39.1C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3s0 0 0 0s0 0 0 0l-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0c0 0 0 0 0 0s0 0 0 0L112 80l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2 51.1 35.1 51.1-35.1 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5zM144 176c0-42 23.1-78.6 57.3-97.8c3.4 7.1 7.7 16.3 11.9 26.5c2.4 5.9 4.8 12.1 7 18.2c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1c-2.2 6.2-4.6 12.3-7 18.2c-4.2 10.2-8.5 19.4-11.9 26.5C167.1 254.6 144 218 144 176zm154.8-71.3c4.2-10.2 8.5-19.4 11.9-26.5C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c-3.4-7.1-7.7-16.3-11.9-26.5c-2.4-5.9-4.8-12.1-7-18.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1c2.2-6.2 4.6-12.3 7-18.2z',
    ],
  ],
};
const faFilterList = {
  prefix: 'fad',
  iconName: 'filter-list',
  icon: [
    512,
    512,
    [],
    'e17c',
    [
      'M3.5 87.7C9.9 73.3 24.2 64 40 64l272 0c15.8 0 30.1 9.3 36.5 23.7s3.8 31.3-6.8 43L240 243.8 240 416c0 12.1-6.8 23.2-17.7 28.6c-4.5 2.3-9.4 3.4-14.3 3.4c-6.8 0-13.6-2.2-19.2-6.4l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-124.2L10.3 130.8C-.3 119-3 102.2 3.5 87.7z',
      'M416 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM320 256c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faOutlet = {
  prefix: 'fad',
  iconName: 'outlet',
  icon: [
    448,
    512,
    [],
    'e01c',
    [
      'M64 256c0 61.1 30.8 99 49.7 116.6c8.8 8.2 20.7 11.4 32.6 11.4l155.3 0c12 0 23.9-3.3 32.6-11.4C353.2 355 384 317.1 384 256s-30.8-99.1-49.7-116.6c-8.8-8.2-20.7-11.4-32.6-11.4l-155.3 0c-12 0-23.9 3.3-32.6 11.4C94.8 156.9 64 194.9 64 256zm80-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm56 104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-16zm72-104c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm0 224c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4l155.3 0c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4l-155.3 0c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256z',
    ],
  ],
};
const faSliders = {
  prefix: 'fad',
  iconName: 'sliders',
  icon: [
    512,
    512,
    ['sliders-h'],
    'f1de',
    [
      'M0 96C0 78.3 14.3 64 32 64l86.7 0c-2.1 4.9-3.8 10.1-4.9 15.4c-.6 2.7-1 5.4-1.3 8.2c-.1 1.4-.3 2.8-.3 4.2s-.1 2.8-.1 4.2c0 11.4 2.4 22.2 6.7 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l246.7 0c-2.1 4.9-3.8 10.1-4.9 15.4c-.6 2.7-1 5.4-1.3 8.2c-.1 1.4-.3 2.8-.3 4.2s-.1 2.8-.1 4.2c0 11.4 2.4 22.2 6.7 32L32 288c-17.7 0-32-14.3-32-32zM0 416c0-17.7 14.3-32 32-32l54.7 0c-2.1 4.9-3.8 10.1-4.9 15.4c-.6 2.7-1 5.4-1.3 8.2c-.1 1.4-.3 2.8-.3 4.2s-.1 2.8-.1 4.2c0 11.4 2.4 22.2 6.7 32L32 448c-17.7 0-32-14.3-32-32zm233.3-32L480 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-246.7 0c2.1-4.9 3.8-10.1 4.9-15.4c.6-2.7 1-5.4 1.3-8.2c.1-1.4 .3-2.8 .3-4.2s.1-2.8 .1-4.2c0-11.4-2.4-22.2-6.7-32zm32-320L480 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-214.7 0c2.1-4.9 3.8-10.1 4.9-15.4c.6-2.7 1-5.4 1.3-8.2c.1-1.4 .3-2.8 .3-4.2s.1-2.8 .1-4.2c0-11.4-2.4-22.2-6.7-32zm160 160l54.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-54.7 0c2.1-4.9 3.8-10.1 4.9-15.4c.6-2.7 1-5.4 1.3-8.2c.1-1.4 .3-2.8 .3-4.2s.1-2.8 .1-4.2c0-11.4-2.4-22.2-6.7-32z',
      'M128 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 80 416a80 80 0 1 0 160 0zm80-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-112a80 80 0 1 0 0 160 80 80 0 1 0 0-160z',
    ],
  ],
};
const faSlidersH = faSliders;
const faCauldron = {
  prefix: 'fad',
  iconName: 'cauldron',
  icon: [
    448,
    512,
    [],
    'f6bf',
    [
      'M96 160l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128-64 0zM128 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5L32 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-15c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39l0 15c0 13.3 10.7 24 24 24s24-10.7 24-24l0-58.1c20.1-26.1 32-58.1 32-95.5c0-37.3-16.5-77.4-35.1-110.4l3.1 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0-144 0-64 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l3.1 0z',
    ],
  ],
};
const faPeople = {
  prefix: 'fad',
  iconName: 'people',
  icon: [
    640,
    512,
    [],
    'e216',
    [
      'M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm320 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M59.4 304.5L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.3 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1l17.8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9z',
    ],
  ],
};
const faFolderTree = {
  prefix: 'fad',
  iconName: 'folder-tree',
  icon: [
    576,
    512,
    [],
    'f802',
    [
      'M0 32l0 96L0 384c0 35.3 28.7 64 64 64l224 0 0-64L64 384l0-224 224 0 0-64L64 96l0-64C64 14.3 49.7 0 32 0S0 14.3 0 32z',
      'M288 32l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-98.7 0c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4L320 0c-17.7 0-32 14.3-32 32zm0 288l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-98.7 0c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4L320 288c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faNetworkWired = {
  prefix: 'fad',
  iconName: 'network-wired',
  icon: [
    640,
    512,
    [],
    'f6ff',
    [
      'M0 256c0 17.7 14.3 32 32 32l96 0 0 32 64 0 0-32 256 0 0 32 64 0 0-32 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0 0-32-64 0 0 32L32 224c-17.7 0-32 14.3-32 32z',
      'M256 64l128 0 0 64-128 0 0-64zM240 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L240 0zM96 384l128 0 0 64L96 448l0-64zM80 320c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L80 320zM416 448l0-64 128 0 0 64-128 0zm-64-80l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48z',
    ],
  ],
};
const faCroissant = {
  prefix: 'fad',
  iconName: 'croissant',
  icon: [
    512,
    512,
    [129360],
    'f7f6',
    [
      'M0 288c0 52.3 14 101.4 38.4 143.7c6.5 11.3 18 16.9 29.9 16.9c8.3 0 16.8-2.8 24-8.3L233 330.8c-4.1-.4-8.3-1.2-12.4-2.4L20.9 268.5c-7-2.1-13.6-5.2-19.5-9.1C.5 268.8 0 278.3 0 288zM259.4 1.4c3.9 5.9 7 12.5 9.1 19.5l59.9 199.7c1.2 4.1 2 8.2 2.4 12.4L440.3 92.2c5.6-7.2 8.3-15.7 8.3-24c0-11.9-5.7-23.4-16.9-29.9C389.4 14 340.3 0 288 0c-9.7 0-19.2 .5-28.6 1.4z',
      'M232.7 19s0 0 0 0s0 0 0 0c2 3 3.6 6.4 4.8 10c-1.2-3.6-2.8-6.9-4.8-10zm235.8 88.8c17.2 20.5 31.2 43.8 41.3 69c1.5 3.9 2.3 8 2.3 12.2l0 5.4c0 16.3-13.2 29.6-29.6 29.6c-1.6 0-3.3-.1-4.9-.4L390 209l75.6-97.1c1-1.3 2-2.6 2.9-4zM223.6 477.6c.3 1.6 .4 3.2 .4 4.9c0 16.3-13.2 29.6-29.6 29.6l-5.4 0c-4.2 0-8.3-.7-12.2-2.3c-25.2-10.1-48.5-24.1-69-41.3c1.4-.9 2.7-1.9 4-2.9L209 390l14.6 87.6zM19 232.7s0 0 0 0s0 0 0 0C7.4 225 0 211.8 0 197.4c0-4.6 .7-9.2 2.3-13.5C33 99.7 99.7 33 183.9 2.3C188.2 .7 192.8 0 197.4 0c18.7 0 35.1 12.2 40.5 30.1l59.9 199.7c3.4 11.3 .3 23.5-8 31.8l-28.1 28.1c-8.3 8.3-20.5 11.4-31.8 8L30.1 237.8c-1.3-.4-2.6-.8-3.8-1.3c-2.6-1-5-2.3-7.3-3.8z',
    ],
  ],
};
const faMapPin = {
  prefix: 'fad',
  iconName: 'map-pin',
  icon: [
    320,
    512,
    [128205],
    'f276',
    [
      'M128 284.4c5.1 1.2 10.4 2.1 15.8 2.7c2.7 .3 5.3 .5 8.1 .7c1.3 .1 2.7 .1 4.1 .2c1.2 0 2.5 .1 4 .1c11 0 21.7-1.2 32-3.6L192 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-195.6z',
      'M160 288A144 144 0 1 0 160 0a144 144 0 1 0 0 288zM96 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z',
    ],
  ],
};
const faHamsa = {
  prefix: 'fad',
  iconName: 'hamsa',
  icon: [
    512,
    512,
    [],
    'f665',
    [
      'M0 322.6c0 8.6 3.2 16.9 9 23.3L95.4 441c41.1 45.2 99.4 71 160.6 71s119.4-25.8 160.6-71L503 345.9c5.8-6.4 9-14.7 9-23.3c0-19.1-15.5-34.6-34.6-34.6L432 288c-8.8 0-16-7.2-16-16l0-200c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 132c0 11-9 20-20 20s-20-9-20-20l0-164c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 164c0 11-9 20-20 20s-20-9-20-20l0-132c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 200c0 8.8-7.2 16-16 16l-45.4 0C15.5 288 0 303.5 0 322.6zM160 352c0-5.2 1.8-10.1 5.4-13.8C179.2 323.8 217.6 288 256 288s76.8 35.8 90.6 50.2c3.6 3.7 5.4 8.7 5.4 13.8s-1.8 10.1-5.4 13.8C332.8 380.2 294.4 416 256 416s-76.8-35.8-90.6-50.2c-3.6-3.7-5.4-8.7-5.4-13.8z',
      'M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faCentSign = {
  prefix: 'fad',
  iconName: 'cent-sign',
  icon: [
    384,
    512,
    [],
    'e3f5',
    [
      'M192 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 34.7c-5.2-.9-10.5-1.5-15.8-2c-2.7-.2-5.4-.4-8-.5c-1.3-.1-2.7-.1-4.1-.1s-2.7 0-4.1 0c-10.9 0-21.6 .9-32 2.7L192 32zm0 413.3c5.2 .9 10.5 1.5 15.8 2c2.7 .2 5.4 .4 8.1 .5c1.3 .1 2.7 .1 4.1 .1s2.7 0 4.1 0c10.9 0 21.6-.9 32-2.7l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7z',
      'M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8C307.1 433.7 267.2 448 224 448C118 448 32 362 32 256S118 64 224 64c43.2 0 83.1 14.3 115.2 38.4c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128z',
    ],
  ],
};
const faSwordsLaser = {
  prefix: 'fad',
  iconName: 'swords-laser',
  icon: [
    640,
    512,
    [],
    'e03d',
    [
      'M128 24c0 5.8 2.1 11.6 6.3 16.2L384 313.1 384 208l0-4.3L168.2 6.3C158.7-2.4 144.1-2.1 135 7c-4.7 4.7-7 10.8-7 17zm94.9 210c.7 1.9 1.1 3.9 1.1 5.9l0 108.1 74.3-81.2-50.7-55.5-24.7 22.6zM343.7 123.5l46.7 42.7 115.3-126c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L343.7 123.5z',
      'M384 322.7c0 12.7 5.1 24.9 14.1 33.9l49 49 27.3-27.3 32-32L533.7 319 411.3 196.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 114.7zM545.9 504.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l3.5-3.5L480 395.3 458.3 417l87.5 87.5zM617.7 469L512 363.3 491.3 384 597 489.7 617.7 469zm14.8-14.8c4.8-4.8 7.5-11.3 7.5-18.1s-2.7-13.3-7.5-18.1L545 330.3 523.3 352 629 457.7l3.5-3.5zM224 240c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-25.4 25.4-4.9-4.9c-12.5-12.3-32.6-12.2-45 .2c-12.5 12.5-12.5 32.8 0 45.3l4.7 4.7L7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l50.3 50.3c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L209.9 388.7c9-9 14.1-21.2 14.1-33.9L224 240zM152 344a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faFlask = {
  prefix: 'fad',
  iconName: 'flask',
  icon: [
    448,
    512,
    [],
    'f0c3',
    [
      'M0 442.6C0 480.9 31.1 512 69.4 512l309.2 0c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 0 160 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6zm64 0c0-1 .3-2 .8-2.8c24.6-39.9 49.1-79.8 73.7-119.8c11.5-18.7 23-37.4 34.5-56.1c12.4-20.2 19-43.4 19-67.1L192 64l64 0 0 132.8c0 23.7 6.6 46.9 19 67.1c11.5 18.7 23 37.4 34.5 56.1l73.7 119.8c.5 .9 .8 1.8 .8 2.8c0 3-2.4 5.4-5.4 5.4L69.4 448c-3 0-5.4-2.4-5.4-5.4z',
      'M309.5 320l-171 0L64.8 439.8c-.5 .9-.8 1.8-.8 2.8c0 3 2.4 5.4 5.4 5.4l309.2 0c3 0 5.4-2.4 5.4-5.4c0-1-.3-2-.8-2.8L309.5 320z',
    ],
  ],
};
const faPersonPregnant = {
  prefix: 'fad',
  iconName: 'person-pregnant',
  icon: [
    384,
    512,
    [],
    'e31e',
    [
      'M144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M196.1 128.3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3l0 32c0 17.7-14.3 32-32 32l-16 0-40 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-8 0-8 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-97c-13.8-3.6-24-16.1-24-31l0-55.1-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1l1.1 0 12.5 0 2.4 0c1.4 0 2.8 .1 4.1 .3z',
    ],
  ],
};
const faSquareU = {
  prefix: 'fad',
  iconName: 'square-u',
  icon: [
    448,
    512,
    [],
    'e281',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120z',
      'M136 144c13.3 0 24 10.7 24 24l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faWandSparkles = {
  prefix: 'fad',
  iconName: 'wand-sparkles',
  icon: [
    512,
    512,
    [],
    'f72b',
    [
      'M0 144c0 3.6 2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8L87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8L57.5 121.5 5.8 136.3c-3.4 1-5.8 4.1-5.8 7.7zM160 48c0 3.7 2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8L215.8 6.1C214.9 2.5 211.7 0 208 0s-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6 .9-6.1 4.1-6.1 7.8zM352 368c0 3.6 2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7z',
      'M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1L144 256c-8.8 0-16 7.2-16 16l0 27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8c9.5 0 18.5-4 24.8-11.1L372.3 197.3c3-3.4 7.4-5.3 11.9-5.3l15.8 0c8.8 0 16-7.2 16-16l0-21.4c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z',
    ],
  ],
};
const faRouter = {
  prefix: 'fad',
  iconName: 'router',
  icon: [
    576,
    512,
    [],
    'f8da',
    [
      'M64 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM164.8 103.8c8.8 9.9 23.9 10.9 33.9 2.1C239.5 69.8 293.2 48 352 48s112.5 21.8 153.4 57.9c9.9 8.8 25.1 7.8 33.9-2.1s7.8-25.1-2.1-33.9C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9c-9.9 8.8-10.9 23.9-2.1 33.9zm78 79.4c8.3 10.3 23.5 11.9 33.8 3.5C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7c10.3 8.3 25.4 6.8 33.8-3.5s6.8-25.4-3.5-33.8C428.8 126 392 112 352 112s-76.8 14-105.7 37.4c-10.3 8.3-11.9 23.5-3.5 33.8z',
      'M376 248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72L64 320c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-136 0 0-72zM96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faEllipsisVertical = {
  prefix: 'fad',
  iconName: 'ellipsis-vertical',
  icon: [
    128,
    512,
    ['ellipsis-v'],
    'f142',
    [
      'M8 256a56 56 0 1 0 112 0A56 56 0 1 0 8 256z',
      'M120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0zm0 320A56 56 0 1 0 8 416a56 56 0 1 0 112 0z',
    ],
  ],
};
const faEllipsisV = faEllipsisVertical;
const faSwordLaserAlt = {
  prefix: 'fad',
  iconName: 'sword-laser-alt',
  icon: [
    512,
    512,
    [],
    'e03c',
    [
      'M198.9 256L304 256c.7 0 1.3 0 2 .1s1.3 .2 1.9 .3L505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L198.9 256z',
      'M155.3 270.1c9-9 21.2-14.1 33.9-14.1L304 256c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L193 405.7l-27.3-27.3-32-32L106.3 319l49-49zM95 330.3L116.7 352 11 457.7l-3.5-3.5C2.7 449.3 0 442.8 0 436s2.7-13.3 7.5-18.1L95 330.3zM22.3 469L128 363.3 148.7 384 43 489.7 22.3 469zm32 32L160 395.3 181.7 417 94.1 504.5C89.3 509.3 82.8 512 76 512s-13.3-2.7-18.1-7.5L54.3 501z',
    ],
  ],
};
const faTicket = {
  prefix: 'fad',
  iconName: 'ticket',
  icon: [
    576,
    512,
    [127903],
    'f145',
    [
      'M0 128l0 64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-64c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm96 32c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-320 0c-17.7 0-32-14.3-32-32l0-192zm32 0l0 192 320 0 0-192-320 0z',
      'M448 160l0 192-320 0 0-192 320 0zM128 128c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-320 0z',
    ],
  ],
};
const faPowerOff = {
  prefix: 'fad',
  iconName: 'power-off',
  icon: [
    512,
    512,
    [9211],
    'f011',
    [
      'M224 32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M147.7 75.5c11.3 13.6 9.4 33.8-4.1 45.1C104.7 152.9 80 201.6 80 256c0 97.2 78.8 176 176 176s176-78.8 176-176c0-54.4-24.7-103.1-63.5-135.4c-13.6-11.3-15.4-31.5-4.1-45.1s31.5-15.4 45.1-4.1C462.2 115.4 496 181.8 496 256c0 132.5-107.5 240-240 240S16 388.5 16 256c0-74.2 33.7-140.6 86.6-184.6c13.6-11.3 33.8-9.4 45.1 4.1z',
    ],
  ],
};
const faCoin = {
  prefix: 'fad',
  iconName: 'coin',
  icon: [
    512,
    512,
    [129689],
    'f85c',
    [
      'M0 208C0 128.5 114.6 64 256 64s256 64.5 256 144s-114.6 144-256 144S0 287.5 0 208zm64-8c0 20.5 10.5 36.7 22.6 48.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200zm32 0c0-35.3 71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64s-160-28.7-160-64z',
      'M464 394.6c30.2-21 48-46.8 48-74.6l0-29.9c-13.2 15.6-29.7 29.3-48 40.9l0 63.7zM336 377.3l0 64.3c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29zM208 445.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2l0-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4l0 64.1zM80 348.3L80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29zM48 331c-18.3-11.5-34.8-25.2-48-40.9L0 320c0 27.9 17.8 53.6 48 74.6L48 331zM64 200c0 20.5 10.5 36.7 22.6 48.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200zm192 64c-88.4 0-160-28.7-160-64s71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64z',
    ],
  ],
};
const faLaptopSlash = {
  prefix: 'fad',
  iconName: 'laptop-slash',
  icon: [
    640,
    512,
    [],
    'e1c7',
    [
      'M0 403.2C0 392.6 8.6 384 19.2 384l346.3 0 121.8 96L76.8 480C34.4 480 0 445.6 0 403.2zM64 146.4l64 50.4L128 352l-64 0 0-205.6zM89.5 44.9C100.2 36.8 113.6 32 128 32l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L154.8 96C133 79 111.3 61.9 89.5 44.9zM522.2 384l98.6 0c10.6 0 19.2 8.6 19.2 19.2c0 21.5-8.9 41-23.2 55c-31.5-24.7-63.1-49.4-94.6-74.2z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faRightLong = {
  prefix: 'fad',
  iconName: 'right-long',
  icon: [
    512,
    512,
    ['long-arrow-alt-right'],
    'f30b',
    [
      'M0 224l0 64c0 17.7 14.3 32 32 32l160 0 128 0 0-128c-96 0-192 0-288 0c-17.7 0-32 14.3-32 32z',
      'M360.5 409.4c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22l0-72 0-128 0-72c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z',
    ],
  ],
};
const faLongArrowAltRight = faRightLong;
const faCircleB = {
  prefix: 'fad',
  iconName: 'circle-b',
  icon: [
    512,
    512,
    [],
    'e0fd',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C356.3 261.6 368 283.4 368 308c0 42-34 76-76 76l-108 0c-13.3 0-24-10.7-24-24l0-104 0-104zm48 24l0 56 68 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-68 0zm0 104l0 56 84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0z',
      'M184 128c-13.3 0-24 10.7-24 24l0 104 0 104c0 13.3 10.7 24 24 24l108 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76l-92 0zm92 104l-68 0 0-56 68 0c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-68 48l68 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-84 0 0-56z',
    ],
  ],
};
const faPersonDressSimple = {
  prefix: 'fad',
  iconName: 'person-dress-simple',
  icon: [
    256,
    512,
    [],
    'e21c',
    [
      'M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64z',
      'M112.3 160c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0z',
    ],
  ],
};
const faPipeCollar = {
  prefix: 'fad',
  iconName: 'pipe-collar',
  icon: [
    512,
    512,
    [],
    'e437',
    [
      'M48 64a16 16 0 1 0 32 0A16 16 0 1 0 48 64zm0 384a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zM432 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 384a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M18.7 18.7c25-25 65.5-25 90.5 0L126 35.4C164.1 12.9 208.5 0 256 0s91.9 12.9 130 35.4l16.7-16.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L476.6 126c22.5 38.1 35.4 82.6 35.4 130s-12.9 91.9-35.4 130l16.7 16.7c25 25 25 65.5 0 90.5s-65.5 25-90.5 0L386 476.6C347.9 499.1 303.5 512 256 512s-91.9-12.9-130-35.4l-16.7 16.7c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L35.4 386C12.9 347.9 0 303.5 0 256s12.9-91.9 35.4-130L18.7 109.3c-25-25-25-65.5 0-90.5zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faLightsHoliday = {
  prefix: 'fad',
  iconName: 'lights-holiday',
  icon: [
    640,
    512,
    [],
    'f7b2',
    [
      'M37.4 275.2c11.2-30.8 39.4-50.6 70.2-52.5c10.7-.7 21.7 .8 32.3 4.7s20 9.8 27.8 17.2c22.3 21.3 31.2 54.5 20 85.3C171.3 375 91.4 431 68.8 422.8S21 320.3 37.4 275.2zM240 336c0-32.8 19.7-61 48-73.3c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7c28.3 12.3 48 40.5 48 73.3c0 48-56 128-80 128s-80-80-80-128zm212.2-6.1c-11.2-30.8-2.3-64.1 20-85.3c7.7-7.4 17.1-13.3 28.2-17.4c-.2 .1-.3 .1-.5 .2c10.7-3.9 21.7-5.4 32.3-4.7c30.8 1.9 59 21.7 70.2 52.5c3.7 10.1 5.3 22.6 5.3 36.1c0 46.9-19.1 105.2-36.7 111.5c-22.6 8.2-102.5-47.8-119-92.9z',
      'M5.4 78.2c9.8-14.7 29.6-18.7 44.3-9c0 0 0 0 0 0l.4 .3c.5 .3 1.3 .8 2.5 1.5c2.4 1.4 6.3 3.6 11.7 6.3C75 82.7 91.6 90.1 114.1 97.6C159 112.6 227.6 128 320 128s161-15.4 205.9-30.4c22.5-7.5 39.1-14.9 49.8-20.3c5.4-2.7 9.3-4.9 11.7-6.3c1.2-.7 2.1-1.2 2.5-1.5l.4-.2s0 0 0 0s0 0 0 0c14.7-9.7 34.5-5.8 44.3 8.9c9.8 14.7 5.8 34.6-8.9 44.4L608 96c17.8 26.6 17.7 26.6 17.7 26.6s0 0 0 0c0 0 0 0-.1 0l-.2 .1-.4 .3c-.3 .2-.7 .5-1.2 .8c-1 .6-2.4 1.5-4.2 2.5c-3.6 2.1-8.7 4.9-15.3 8.2c-13.3 6.6-32.7 15.2-58.2 23.7c-10.2 3.4-21.4 6.8-33.5 10l19.8 54.3c-10.7-.7-21.7 .8-32.3 4.7s-20.1 9.8-27.8 17.2l-22.8-62.7c-28.9 4.7-61.4 8.2-97.4 9.6l0 71.2c-9.8-4.3-20.6-6.7-32-6.7s-22.2 2.4-32 6.7l0-71.2c-36-1.3-68.5-4.8-97.4-9.6l-22.8 62.7c-7.7-7.4-17.1-13.3-27.8-17.2s-21.7-5.4-32.3-4.7l19.8-54.3c-12.1-3.2-23.3-6.6-33.5-10c-25.5-8.5-44.9-17.1-58.2-23.7c-6.6-3.3-11.7-6.1-15.3-8.2c-1.8-1-3.2-1.9-4.2-2.5c-.5-.3-.9-.6-1.2-.8l-.4-.3-.1-.1c0 0 0 0-.1 0c0 0 0 0 0 0L32 96 14.2 122.6C-.5 112.8-4.4 93 5.4 78.2z',
    ],
  ],
};
const faCitrus = {
  prefix: 'fad',
  iconName: 'citrus',
  icon: [
    512,
    512,
    [],
    'e2f4',
    [
      'M16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-61-22.8-116.7-60.3-159.1C420.8 122.5 403 128 384 128l-80 0c-8.8 0-16-7.2-16-16l0-16c0-1.4 0-2.7 .1-4.1s.1-2.7 .3-4.1c.2-2.7 .6-5.3 1-8c.9-5.2 2.2-10.3 3.9-15.3c3.4-9.8 8.3-18.9 14.6-27c-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272z',
      'M384 128H304c-8.8 0-16-7.2-16-16V96c0-53 43-96 96-96h80c8.8 0 16 7.2 16 16V32c0 53-43 96-96 96z',
    ],
  ],
};
const faFlagUsa = {
  prefix: 'fad',
  iconName: 'flag-usa',
  icon: [
    448,
    512,
    [],
    'f74d',
    [
      'M64 235.8l0 63.3 63.5-13.6c43-9.2 87.9-4.6 128.1 13.3l16.1 7.2c41.6 18.5 88.8 20.1 131.6 4.6L448 294.3l0-62-33.7 12.3C363.7 263 307.9 261 258.7 239.2L242.6 232c-34-15.1-72-19.1-108.4-11.3L64 235.8zm0 96L64 400l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-33.5-33.7 12.3C363.7 359 307.9 357 258.7 335.2L242.6 328c-34-15.1-72-19.1-108.4-11.3L64 331.8zM192 27l0 62.9c21.8 2.2 43.3 7.9 63.6 16.9l16.1 7.2c41.6 18.5 88.8 20.1 131.6 4.6L448 102.2l0-36.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-17.2-8.6-35.6-14-54.4-16.3zm0 95.1l0 63.8c21.8 2.2 43.3 7.9 63.6 16.9l16.1 7.2c41.6 18.5 88.8 20.1 131.6 4.6L448 198.3l0-62-33.7 12.3C363.7 167 307.9 165 258.7 143.2L242.6 136c-16.2-7.2-33.2-11.9-50.6-13.9z',
      'M192 122.1l0-32.2L192 27c-19.6-2.3-39.6-1.1-59 3.8L64 48l0-16C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64l0 56.8 0 32.7 0 63.3 0 32.7 0 63.3 0 32.7L0 416l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 0-68.2 0-32.7 0-63.3L64 224l0-20.9 63.5-13.6c21.3-4.6 43-5.7 64.5-3.6l0-63.8zM80 96a16 16 0 1 1 32 0A16 16 0 1 1 80 96zm64-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faLaptopFile = {
  prefix: 'fad',
  iconName: 'laptop-file',
  icon: [
    640,
    512,
    [],
    'e51d',
    [
      'M0 307.2C0 349.6 34.4 384 76.8 384L320 384l0-96-192 0 0-224 320 0 0 32 64 0 0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 224-44.8 0C8.6 288 0 296.6 0 307.2z',
      'M400 128l112 0 0 96c0 17.7 14.3 32 32 32l96 0 0 208c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zm240 96l-96 0 0-96 96 96z',
    ],
  ],
};
const faTty = {
  prefix: 'fad',
  iconName: 'tty',
  icon: [
    512,
    512,
    ['teletype'],
    'f1e4',
    [
      'M9 177.8c0 7.8 2.1 15.7 6.2 22.8l23.1 40.7c5.8 10.2 16.6 16.2 27.8 16.2c3.3 0 6.7-.5 10-1.6l81.1-26.6c13.1-4.3 22-16.6 22-30.4l0-54.8c49.6-18.1 104-18.1 153.6 0l0 54.8c0 13.8 8.9 26.1 22 30.4l81.1 26.6c3.3 1.1 6.7 1.6 10 1.6c11.3 0 22-6 27.8-16.2l23.1-40.7c4.1-7.1 6.2-15.1 6.2-22.8c0-9.9-3.4-19.6-10.7-27.2C450.6 106.8 367.3 48 256 48S61.4 106.8 19.6 150.6C12.4 158.1 9 167.9 9 177.8z',
      'M48 320c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm0 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80-80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM416 432l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM144 416c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-224 0z',
    ],
  ],
};
const faTeletype = faTty;
const faChartTreeMap = {
  prefix: 'fad',
  iconName: 'chart-tree-map',
  icon: [
    512,
    512,
    [],
    'e0ea',
    [
      'M0 320L0 432c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 272c-26.5 0-48 21.5-48 48zm256-80l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48z',
      'M0 80C0 53.5 21.5 32 48 32l128 0c26.5 0 48 21.5 48 48l0 112c0 26.5-21.5 48-48 48L48 240c-26.5 0-48-21.5-48-48L0 80zm256 0c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32zm48 272l160 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faDiagramNext = {
  prefix: 'fad',
  iconName: 'diagram-next',
  icon: [
    512,
    512,
    [],
    'e476',
    [
      'M0 352l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-57.4 0c5.8 16.2 3.1 35.5-11.3 49.9l-89.4 89.4c-18.7 18.7-49.1 18.7-67.9 0l-89.4-89.4c-14.4-14.4-17.1-33.7-11.3-49.9L64 288c-35.3 0-64 28.7-64 64z',
      'M448 224c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l168 0 0 64-46.1 0c-21.4 0-32.1 25.9-17 41L239 399c9.4 9.4 24.6 9.4 33.9 0L343 329c15.1-15.1 4.4-41-17-41L280 288l0-64 168 0z',
    ],
  ],
};
const faPersonRifle = {
  prefix: 'fad',
  iconName: 'person-rifle',
  icon: [
    576,
    512,
    [],
    'e54e',
    [
      'M21.6 387.7c-11.2 19-4.9 43.5 14.1 54.8s43.5 4.9 54.8-14.1L144 337.7 144 512l192 0 0-300.1c-21-12.8-45.4-19.9-70.8-19.9l-50.4 0c-48.1 0-92.6 25.4-117.1 66.8L21.6 387.7zM160 80a80 80 0 1 0 160 0A80 80 0 1 0 160 80z',
      'M432 0l16 0c8.8 0 16 7.2 16 16l0 116.3c9.6 5.5 16 15.9 16 27.7l0 109.3 16-5.3 0-56c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 84.5c0 6.9-4.4 13-10.9 15.2L480 325.3l0 26.7 48 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-44 0 23 92.1c2.5 10.1-5.1 19.9-15.5 19.9L432 512c-8.8 0-16-7.2-16-16l0-96-16 0c-17.7 0-32-14.3-32-32l0-144c0-17.7 14.3-32 32-32l0-32c0-11.8 6.4-22.2 16-27.7L416 32c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0z',
    ],
  ],
};
const faClockFiveThirty = {
  prefix: 'fad',
  iconName: 'clock-five-thirty',
  icon: [
    512,
    512,
    [],
    'e34a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232 0c0-10.6 6.9-19.9 17-23s21.1 .9 26.9 9.7l64 96c2.7 4.1 4 8.7 4 13.3c0 7.8-3.8 15.4-10.7 20c-11 7.4-25.9 4.4-33.3-6.7l-20-30 0 56.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z',
      'M256 416c13.3 0 24-10.7 24-24l0-56.7 20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23l0 136c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faPipeValve = {
  prefix: 'fad',
  iconName: 'pipe-valve',
  icon: [
    512,
    512,
    [],
    'e439',
    [
      'M64 192l0 256 384 0 0-256-160 0 0-76-32-4-32 4 0 76L64 192zM224 64l0 12 32 4 32-4 0-12c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M128 128l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32L256 80 128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32zM32 160c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zm480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256z',
    ],
  ],
};
const faLightbulbMessage = {
  prefix: 'fad',
  iconName: 'lightbulb-message',
  icon: [
    576,
    512,
    [],
    'e687',
    [
      'M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l144 0 0-96c0-35.3 28.7-64 64-64l41.4 0c4.3-15.3 6.6-31.4 6.6-48C368 78.8 289.2 0 192 0S16 78.8 16 176zm64 0c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm32 240l0 16c0 44.2 35.8 80 80 80c36.4 0 67.1-24.3 76.8-57.6c-8-10.7-12.8-24-12.8-38.4l-144 0z',
      'M576 288c0-17.7-14.3-32-32-32l-224 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l73.4 0 59.3 59.3c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-48 64 0c17.7 0 32-14.3 32-32l0-128z',
    ],
  ],
};
const faArrowUpFromArc = {
  prefix: 'fad',
  iconName: 'arrow-up-from-arc',
  icon: [
    512,
    512,
    [],
    'e4b4',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 106-86 192-192 192S64 362 64 256c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M121.4 166.6c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3 288 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-57.4 57.4c-12.5 12.5-32.8 12.5-45.3 0z',
    ],
  ],
};
const faFaceSpiralEyes = {
  prefix: 'fad',
  iconName: 'face-spiral-eyes',
  icon: [
    512,
    512,
    [],
    'e485',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm52.1-59c.1-1.6 .2-3.1 .4-4.7c.3-3.1 .9-6.3 1.5-9.4c1.3-6.2 3.3-12.3 5.8-18.1C65 153 72.3 142.1 81.5 132.7c18.3-18.8 43.6-31.6 72-32.7c6.6-.3 12.2 4.9 12.5 11.5c0 .4 0 .8 0 1.2c0 .4-.1 .8-.1 1.2c-.1 .8-.3 1.6-.6 2.3c-.5 1.5-1.4 2.8-2.4 3.9c-2.1 2.3-5 3.7-8.3 3.9c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 21.9-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.1-102.5-89.1c-.1-1.5-.3-2.9-.3-4.3c-.2-3.1-.1-6.1 0-9.1zm61.6 194.2c-4-7.9-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2zM276.5 207.7c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c.3 2.9 .4 5.8 .4 8.7c0 50.8-44.8 99.5-101.4 101.8c-.2 0-.3 0-.5 0c-3.2 0-6.1-1.3-8.3-3.3c-1.1-1-2-2.3-2.6-3.7c-.3-.7-.6-1.4-.8-2.2c-.1-.5-.2-1.1-.2-1.1c-.1-.8-.1-1.1-.1-1.4c0-.4 0-.8 0-1.2c0-.3 .1-.7 .1-1.1c.1-.8 .3-1.5 .6-2.3c.5-1.4 1.4-2.8 2.4-3.9c2.1-2.3 5-3.7 8.3-3.9c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4c0-.1 0-.2 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.4-19.9 24c0 .1 .1 .2 .1 .4l.1 .4c1 4.4 3.5 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.8-2.7-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.7-.7 13.5 2.2 17.7 8.5c5 6.8 4.4 15.5 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.4 5-79.6-25.9-82.9-69.3z',
      'M154.4 124c6.6-.3 11.8-5.8 11.5-12.5s-5.8-11.8-12.5-11.5c-59.9 2.4-106.5 56.7-101 110.5c2.9 53.9 53.7 94.3 102.5 89.1c49.1-3 85.9-47.9 80.6-91.2c-3.3-43.5-44.7-74.4-82.9-69.3c-38.4 3.4-65.7 39.2-60.3 72.1c3.8 33 35.9 54.5 63.6 49.2c27.7-4.1 45.3-30.8 39.5-53.6c-2.4-11.5-9.5-20-17.9-24.8c-8-4.7-18.3-6.6-27.5-3.3c-8.9 2.8-14.9 9-17.8 16c-2.6 6.3-3.2 15 1.8 21.8c4.2 6.3 11.1 9.2 17.6 8.5c5.3-.6 15.1-5.3 14.1-16.4c-.2-2.7-1.3-5.1-3-6.9c.8 .3 1.7 .6 2.6 1.2c3.1 1.8 5.7 4.9 6.5 9.2l.1 .4 .1 .4c2.1 7.7-4.7 21.9-19.9 24l-.3 0-.3 .1c-14 2.8-33.3-9.1-35.5-28.6l0-.4-.1-.4c-3.1-18.3 13.2-42.4 38.9-44.5l.3 0 .3 0c24.7-3.5 53.8 17.7 56 47.5l0 .3 0 .3c3.7 28.8-22.1 62.5-58.4 64.5l-.3 0-.3 0c-35.4 4-74.2-26.5-76.2-66.7l0-.3 0-.3c-4.2-39.3 31.1-82.4 78.1-84.3zM357.6 292c-6.6 .3-11.8 5.8-11.5 12.5s5.8 11.8 12.5 11.5c59.9-2.4 106.5-56.7 101-110.5c-2.9-53.9-53.7-94.3-102.5-89.1c-49.1 3-85.9 47.9-80.6 91.2c3.3 43.5 44.7 74.4 82.9 69.3c38.4-3.4 65.7-39.2 60.3-72.1c-3.8-33-35.9-54.5-63.6-49.2c-27.7 4.1-45.3 30.8-39.5 53.6c2.4 11.5 9.5 20 17.9 24.8c8 4.7 18.3 6.6 27.5 3.3c8.9-2.8 14.9-9 17.8-16c2.6-6.3 3.2-15-1.8-21.8c-4.2-6.3-11.1-9.2-17.6-8.5c-5.3 .6-15.1 5.3-14.1 16.4c.2 2.7 1.3 5.1 3 6.9c-.8-.3-1.7-.6-2.6-1.2c-3.1-1.8-5.7-4.9-6.5-9.2l-.1-.4-.1-.4c-2.1-7.7 4.7-21.9 19.9-24l.3 0 .3-.1c14-2.8 33.3 9.1 35.5 28.6l0 .4 .1 .4c3.1 18.3-13.2 42.4-38.9 44.5l-.3 0-.3 0c-24.7 3.5-53.8-17.7-56-47.5l0-.3 0-.3c-3.7-28.8 22.1-62.5 58.4-64.5l.3 0 .3 0c35.4-4 74.2 26.5 76.2 66.7l0 .3 0 .3c4.2 39.3-31.1 82.4-78.1 84.3z',
    ],
  ],
};
const faCompressWide = {
  prefix: 'fad',
  iconName: 'compress-wide',
  icon: [
    512,
    512,
    [],
    'f326',
    [
      'M0 320c0 17.7 14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM352 96l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM352 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 96z',
    ],
  ],
};
const faCirclePhoneHangup = {
  prefix: 'fad',
  iconName: 'circle-phone-hangup',
  icon: [
    512,
    512,
    ['phone-circle-down'],
    'e11d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm98.8 18.8c-4.8-7.8-3.4-17.5 3.4-23.8c42.5-39.3 98.1-59 153.7-59s111.3 19.7 153.7 59c4.1 3.8 6.3 8.9 6.3 14c0 3.4-.9 6.7-2.8 9.8L391.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L98.8 274.8z',
      'M364.7 318.5c9.9 3.8 21.4 .2 26.7-8.5l21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8c-84.9-78.6-222.6-78.6-307.5 0c-6.8 6.3-8.2 16.1-3.4 23.8L120.6 310c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3L203.7 254c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6z',
    ],
  ],
};
const faPhoneCircleDown = faCirclePhoneHangup;
const faGearComplexCode = {
  prefix: 'fad',
  iconName: 'gear-complex-code',
  icon: [
    512,
    512,
    [],
    'e5eb',
    [
      'M0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2l0-51.9c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256zm124.7-11.3c13.3-13.3 26.7-26.7 40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-9.6 9.6-19.1 19.1-28.7 28.7c9.6 9.6 19.1 19.1 28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-13.3-13.3-26.7-26.7-40-40c-6.2-6.2-6.2-16.4 0-22.6zm99.5 104.7c10.7-64 21.3-128 32-192c1.3-7.8 8.1-13.4 15.8-13.4c.9 0 1.8 .1 2.6 .2c8.7 1.5 14.6 9.7 13.2 18.4c-10.7 64-21.3 128-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4zM324.7 204.7c6.2-6.2 16.4-6.2 22.6 0c13.3 13.3 26.7 26.7 40 40c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-13.3 13.3-26.7 26.7-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c9.6-9.6 19.1-19.1 28.7-28.7c-9.6-9.6-19.1-19.1-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z',
      'M274.6 144.2c8.7 1.5 14.6 9.7 13.2 18.4l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2zm-87.3 60.5c6.2 6.2 6.2 16.4 0 22.6L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0zm137.4 0c6.2-6.2 16.4-6.2 22.6 0l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z',
    ],
  ],
};
const faHouseMedicalCircleExclamation = {
  prefix: 'fad',
  iconName: 'house-medical-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e512',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l266.7 0C349.5 480.1 320 427.5 320 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 40.2 0c32.3-39.1 81.1-64 135.8-64c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24zM320 352l0 16c0-5.4 .2-10.7 .7-16l-.7 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faBadminton = {
  prefix: 'fad',
  iconName: 'badminton',
  icon: [
    576,
    512,
    [],
    'e33a',
    [
      'M0 448c0 8.2 3.1 16.4 9.4 22.6l32 32c12.5 12.5 32.8 12.5 45.3 0l56-56c10.2-10.2 12.1-25.5 5.6-37.6c-1.5-2.7-3.3-5.3-5.6-7.6l-32-32c-2.3-2.3-4.9-4.2-7.6-5.6c-12.1-6.4-27.5-4.5-37.6 5.6l-56 56C3.1 431.6 0 439.8 0 448zm448.7 43.4c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7L495.1 448l-33.4 0-13 43.4zM464 400l0 32 96 0 0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zm32 48l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48-32 0zm32.9 0l15.8 52.6c2.5 8.5 11.5 13.3 19.9 10.7s13.3-11.5 10.7-19.9l-13-43.4-33.4 0z',
      'M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c-1.5-2.7-3.3-5.3-5.6-7.6l-32-32c-2.3-2.3-4.9-4.2-7.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154z',
    ],
  ],
};
const faClosedCaptioning = {
  prefix: 'fad',
  iconName: 'closed-captioning',
  icon: [
    576,
    512,
    [],
    'f20a',
    [
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM104 256c0 53 43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96zm192 0c0 53 43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96z',
      'M152 256c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48zm192 0c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z',
    ],
  ],
};
const faPersonHiking = {
  prefix: 'fad',
  iconName: 'person-hiking',
  icon: [
    384,
    512,
    ['hiking'],
    'f6ec',
    [
      'M7 246.4c-3.7 13.7 5.2 27.7 19.2 30l47.9 8c12.3 2.1 24.2-5.7 27.2-17.9l35.2-140.7c3.8-15.1-7.7-29.8-23.3-29.8l-4.2 0C73 96 41.4 120.1 31.9 155L7 246.4zM336 184l0 24 16 0c.5 0 1.1 0 1.6 0s1.1 .1 1.6 .1c1.1 .1 2.1 .3 3.2 .5c2.1 .4 4.1 1 6 1.8c3.8 1.6 7.3 3.9 10.1 6.8s5.2 6.3 6.9 10.1c.2 .5 .4 1 .6 1.4s.3 1 .5 1.5c.3 1 .6 2 .8 3c.2 1 .4 2.1 .5 3.2c.1 .6 .1 1.1 .1 1.6c0 .5 0 1 .1 1.5c0-18.4 0-37 0-55.6c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 88l0 216c0 13.3 10.7 24 24 24s24-10.7 24-24l0-247.7c0 .6 0 1.1-.1 1.6c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.2-6.9 10.1c-5.8 5.7-13.7 9.3-22.5 9.3l-16 0z',
      'M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9l0 89.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208l46.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-55.4 0c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1z',
    ],
  ],
};
const faHiking = faPersonHiking;
const faRightFromLine = {
  prefix: 'fad',
  iconName: 'right-from-line',
  icon: [
    448,
    512,
    ['arrow-alt-from-left'],
    'f347',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M436.7 228.7L313.9 105.9c-6.4-6.4-15-9.9-24-9.9c-18.7 0-33.9 15.2-33.9 33.9l0 62.1-128 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 62.1c0 18.7 15.2 33.9 33.9 33.9c9 0 17.6-3.6 24-9.9L436.7 283.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3z',
    ],
  ],
};
const faArrowAltFromLeft = faRightFromLine;
const faVenusDouble = {
  prefix: 'fad',
  iconName: 'venus-double',
  icon: [
    640,
    512,
    [9890],
    'f226',
    [
      'M112 176a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM344 34c14.6 15.6 26.8 33.4 36 53c18.8-14.4 42.4-23 68-23c61.9 0 112 50.1 112 112s-50.1 112-112 112c-25.6 0-49.1-8.6-68-23c-9.3 19.5-21.5 37.4-36 53c21 15.4 45.4 26.2 72 31.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9c81.9-15 144-86.8 144-173.1C624 78.8 545.2 0 448 0c-38.9 0-74.9 12.6-104 34z',
      'M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zm32 0c0-19.8-2.8-39-8-57.2C406.5 104.7 426.2 96 448 96c44.2 0 80 35.8 80 80s-35.8 80-80 80c-21.8 0-41.5-8.7-56-22.8c5.2-18.2 8-37.3 8-57.2z',
    ],
  ],
};
const faImages = {
  prefix: 'fad',
  iconName: 'images',
  icon: [
    576,
    512,
    [],
    'f302',
    [
      'M96 96c0-35.3 28.7-64 64-64l352 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64L96 96zm82.4 210.4c4 8.3 12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C391.5 132 384 128 376 128s-15.5 4-20 10.7l-56 84L282.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4zM192 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm348 18.7C391.5 132 384 128 376 128s-15.5 4-20 10.7l-56 84L282.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144z',
    ],
  ],
};
const faCalculator = {
  prefix: 'fad',
  iconName: 'calculator',
  icon: [
    384,
    512,
    [128425],
    'f1ec',
    [
      'M128 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 416c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zM224 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 64l192 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z',
    ],
  ],
};
const faShuttlecock = {
  prefix: 'fad',
  iconName: 'shuttlecock',
  icon: [
    512,
    512,
    [],
    'f45b',
    [
      'M0 410.2C0 466.4 45.6 512 101.8 512c27 0 52.9-10.7 72-29.8L192 464 48 320 29.8 338.2C10.7 357.3 0 383.2 0 410.2z',
      'M320 32c0 8.8-7.2 16-16 16c-24.4 0-46 15.8-53.4 39.1l-29.3 92.8c-1.3 4.1-4.2 7.6-8.1 9.5l-32.4 16.2c-3.1 1.5-5.6 4.1-7.2 7.2l-32.5 64.9c-3.1 6.2-1.9 13.6 3 18.5L163 315l71.9-71.9L281.1 96.8C284.3 86.8 293.5 80 304 80l104 0c13.3 0 24 10.7 24 24l0 104c0 10.5-6.8 19.7-16.8 22.9L268.8 277.1 197 349l18.9 18.9c4.9 4.9 12.3 6.1 18.5 3l64.9-32.5c3.1-1.5 5.6-4.1 7.2-7.2l16.2-32.4c1.9-3.9 5.4-6.8 9.5-8.1l92.8-29.3c23.3-7.4 39.1-29 39.1-53.4c0-8.8 7.2-16 16-16l8 0c13.3 0 24 10.7 24 24l0 51.7c0 12.4-7.2 23.7-18.4 29L250.1 411.2c-6.7 3.1-12.8 7.4-18 12.7L192 464 48 320l40.1-40.1c5.2-5.2 9.5-11.3 12.7-18L215.4 18.4C220.6 7.2 231.9 0 244.3 0L296 0c13.3 0 24 10.7 24 24l0 8z',
    ],
  ],
};
const faUserHair = {
  prefix: 'fad',
  iconName: 'user-hair',
  icon: [
    448,
    512,
    [],
    'e45a',
    [
      'M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32l-36 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112l-56 0c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128z',
      'M120 112l56 0c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96l36 0C333.8 40.8 283.6 0 224 0C160.3 0 107.5 46.5 97.7 107.4c6.8 3 14.4 4.6 22.3 4.6zm41.3 208C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320l-125.4 0z',
    ],
  ],
};
const faEyeEvil = {
  prefix: 'fad',
  iconName: 'eye-evil',
  icon: [
    640,
    512,
    [],
    'f6db',
    [
      'M288 256c0 31.5 16.5 52.7 23.8 60.6c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c7.3-7.9 23.8-29.2 23.8-60.6c0-13.2-2.9-24.6-6.8-34c-8.2 1.3-16.6 2-25.2 2s-17-.7-25.2-2c-3.9 9.4-6.8 20.8-6.8 34z',
      'M224 122.6c9.8-4.1 20.1-7.6 30.9-10.4l42.7-97.6C301.5 5.8 310.3 0 320 0s18.5 5.8 22.4 14.7l42.7 97.6c10.7 2.8 21.1 6.3 30.9 10.4L525.6 76.1c8.7-3.7 18.7-1 24.4 6.5s5.5 17.9-.4 25.2l-57.3 70.8c7 9 12.8 18.6 17.3 28.6l114.9 28.7c9.1 2.3 15.5 10.5 15.5 19.9s-6.4 17.6-15.5 19.9L509.6 304.6c-4.5 10.1-10.3 19.7-17.3 28.6l57.3 70.8c5.9 7.3 6.1 17.7 .4 25.2s-15.7 10.2-24.4 6.5L416 389.4c-9.8 4.1-20.1 7.6-30.9 10.4l-42.7 97.6c-3.9 8.9-12.7 14.7-22.4 14.7s-18.5-5.8-22.4-14.7l-42.7-97.6c-10.7-2.8-21.1-6.3-30.9-10.4L114.4 435.9c-8.7 3.7-18.7 1-24.4-6.5s-5.5-17.9 .4-25.2l57.3-70.8c-7-9-12.8-18.6-17.3-28.6L15.5 275.9C6.4 273.6 0 265.4 0 256s6.4-17.6 15.5-19.9l114.9-28.7c4.5-10.1 10.3-19.6 17.3-28.6L90.4 107.9c-5.9-7.3-6.1-17.7-.4-25.2s15.7-10.2 24.4-6.5L224 122.6zM416 256c0-19.7-6-38.1-16.2-53.3C376.3 216.2 349.1 224 320 224s-56.3-7.8-79.8-21.3C230 217.9 224 236.3 224 256c0 53 43 96 96 96s96-43 96-96z',
    ],
  ],
};
const faPeoplePulling = {
  prefix: 'fad',
  iconName: 'people-pulling',
  icon: [
    576,
    512,
    [],
    'e535',
    [
      'M0 192L0 320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352l15.7 0 30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-58-260.8 102.4 42.6c-3.9-7.4-4.9-16.4-2-25c.9-2.6 1.7-5.2 2.6-7.8c.5-1.4 .9-2.7 1.4-4c.5-1.4 1-2.7 1.5-4c1.1-2.6 2.2-5.2 3.4-7.7c2.5-5 5.2-9.9 8.3-14.5L155.2 135.4c-11.7-4.9-24.2-7.4-36.9-7.4L64 128c-35.3 0-64 28.7-64 64zM32 48a48 48 0 1 0 96 0A48 48 0 1 0 32 48z',
      'M416 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM382.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L537 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L503 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM324.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L324.7 398z',
    ],
  ],
};
const faN = {
  prefix: 'fad',
  iconName: 'n',
  icon: [
    384,
    512,
    [110],
    '4e',
    [
      'M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6 320 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4 64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 50.5 8.4 38.5 21.1 33.9z',
      '',
    ],
  ],
};
const faSwap = {
  prefix: 'fad',
  iconName: 'swap',
  icon: [
    640,
    512,
    [],
    'e609',
    [
      'M288 160l0 96 64 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 192-48 0c-12.4 0-23.7 7.2-29 18.4s-3.6 24.5 4.4 34.1l80 96c6.1 7.3 15.1 11.5 24.6 11.5s18.5-4.2 24.6-11.5l80-96c7.9-9.5 9.7-22.8 4.4-34.1s-16.6-18.4-29-18.4l-48 0 0-192c0-70.7-57.3-128-128-128s-128 57.3-128 128z',
      'M208 160c12.4 0 23.7-7.2 29-18.4s3.6-24.5-4.4-34.1l-80-96C146.5 4.2 137.5 0 128 0s-18.5 4.2-24.6 11.5l-80 96c-7.9 9.5-9.7 22.8-4.4 34.1S35.6 160 48 160l48 0 0 192c0 70.7 57.3 128 128 128s128-57.3 128-128l0-96-64 0 0 96c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-192 48 0z',
    ],
  ],
};
const faGarage = {
  prefix: 'fad',
  iconName: 'garage',
  icon: [
    640,
    512,
    [],
    'e009',
    [
      'M128 224l384 0 0 96-384 0 0-96zm0 128l384 0 0 160-384 0 0-160zm128 80c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
      'M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z',
    ],
  ],
};
const faCableCar = {
  prefix: 'fad',
  iconName: 'cable-car',
  icon: [
    512,
    512,
    [128673, 57551, 'tram'],
    'f7da',
    [
      'M0 176c0 1.6 .2 3.2 .5 4.9c2.7 13 15.4 21.3 28.4 18.6l203.1-42 0 42.5 0 24c16 0 32 0 48 0l0-24 0-52.5 212.9-44C504.2 101.2 512 91.2 512 80c0-1.6-.2-3.2-.5-4.9c-2.7-13-15.4-21.3-28.4-18.6l-232 48-232 48C7.8 154.8 0 164.8 0 176zM80 304c0 21.3 0 42.7 0 64c0 8.8 7.2 16 16 16l64 0c4.4 0 8.4-1.8 11.3-4.7c1.4-1.4 2.6-3.2 3.4-5.1c.4-1 .7-2 .9-3c.1-.5 .2-1 .2-1.6c0-.5 .1-1 .1-1.5c0-21.5 0-42.9 0-64.2c0-.6 0-1.1-.1-1.7c-.1-.5-.1-1.1-.2-1.6c-.2-1-.5-2-.9-3c-.8-1.9-2-3.6-3.4-5.1c-2.9-2.9-6.9-4.7-11.3-4.7c-21.3 0-42.7 0-64 0c-8.8 0-16 7.2-16 16zm128 0c0 21.3 0 42.7 0 64c0 8.8 7.2 16 16 16l64 0c4.4 0 8.4-1.8 11.3-4.7c1.4-1.4 2.6-3.2 3.4-5.1c.4-1 .7-2 .9-3c.1-.5 .2-1 .2-1.6c0-.5 .1-1 .1-1.5c0-21.5 0-42.8 0-64.2c0-.6 0-1.1-.1-1.7s-.1-1.1-.2-1.6c-.2-1-.5-2-.9-3c-.8-1.9-2-3.6-3.4-5.1c-2.9-2.9-6.9-4.7-11.3-4.7l-64 0c-8.8 0-16 7.2-16 16zm128 0l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16c-21.3 0-42.7 0-64 0c-8.8 0-16 7.2-16 16z',
      'M320 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 88a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 224c-35.3 0-64 28.7-64 64l0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L96 224zm0 64l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zm144-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faTram = faCableCar;
const faShovelSnow = {
  prefix: 'fad',
  iconName: 'shovel-snow',
  icon: [
    512,
    512,
    [],
    'f7c3',
    [
      'M96 336c0 4.1 1.6 8.2 4.7 11.3c6.2 6.2 16.4 6.2 22.6 0c26.7-26.7 53.3-53.3 80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-26.7 26.7-53.3 53.3-80 80c-3.1 3.1-4.7 7.2-4.7 11.3zm68.7 52.7c-6.2 6.2-6.2 16.4 0 22.6c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-26.6 26.6-53.2 53.2-80 80zm97-172.3l33.9 33.9 83.5-83.5c11.2 5.9 23.9 9.2 37.4 9.2c21.4 0 41.9-8.5 57-23.6L505 121c9.4-9.4 9.4-24.6 0-33.9L425 7c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7L359.6 38.5C344.5 53.6 336 74.1 336 95.4c0 13.5 3.3 26.2 9.2 37.4l-83.5 83.5zM384 95.4c0-8.6 3.4-16.9 9.5-23L408 57.9 454.1 104l-14.5 14.5c-6.1 6.1-14.4 9.5-23 9.5c-18 0-32.6-14.6-32.6-32.6z',
      'M172.8 166.4c12.7-9.6 30.6-8.3 41.8 3l128 128c11.3 11.3 12.5 29.1 3 41.8l-120 160c-5.6 7.4-14.1 12.1-23.3 12.7s-18.3-2.7-24.9-9.3l-168-168C2.8 328.1-.6 319 .1 309.7s5.3-17.8 12.7-23.3l160-120zm30.5 100.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z',
    ],
  ],
};
const faCloudRain = {
  prefix: 'fad',
  iconName: 'cloud-rain',
  icon: [
    512,
    512,
    [127783, 9926],
    'f73d',
    [
      'M48 461l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L102.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4L54.2 436.6C50.1 444.1 48 452.5 48 461zm160 0l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-35.1 64.6c-4.1 7.5-6.2 15.8-6.2 24.3zm160 0l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-35.1 64.6c-4.1 7.5-6.2 15.8-6.2 24.3z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faFaceLying = {
  prefix: 'fad',
  iconName: 'face-lying',
  icon: [
    512,
    512,
    [],
    'e37e',
    [
      'M0 256C0 397.4 114.6 512 256 512c108 0 200.4-66.9 238-161.5c-4.5 1-9.2 1.5-14 1.5l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0C114.6 0 0 114.6 0 256zm208.4-80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM163.2 374.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4zM368.4 176a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faSprinkler = {
  prefix: 'fad',
  iconName: 'sprinkler',
  icon: [
    512,
    512,
    [],
    'e035',
    [
      'M0 24a24 24 0 1 0 48 0A24 24 0 1 0 0 24zM0 128a24 24 0 1 0 48 0A24 24 0 1 0 0 128zM0 232a24 24 0 1 0 48 0A24 24 0 1 0 0 232zM64 72a24 24 0 1 0 48 0A24 24 0 1 0 64 72zm0 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm208 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM464 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 104a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 104a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160-100.2 0C108.4 256 96 268.4 96 283.8c0 7.8 3.3 15.2 9 20.5L192 384l0 96c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-96 87-79.7c5.7-5.3 9-12.7 9-20.5c0-15.3-12.4-27.8-27.8-27.8L288 256l0-160z',
    ],
  ],
};
const faBuildingCircleXmark = {
  prefix: 'fad',
  iconName: 'building-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e4d4',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 184.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faPersonSledding = {
  prefix: 'fad',
  iconName: 'person-sledding',
  icon: [
    512,
    512,
    ['sledding'],
    'f7cb',
    [
      'M0 248c0 8.7 4.7 17 12.9 21.3L396.4 468.4c13.9 7.2 29 10.8 44.2 10.8c14.7 0 29.4-3.4 42.9-10.1l15.2-7.6c8.4-4.2 13.3-12.7 13.3-21.5c0-3.6-.8-7.3-2.5-10.7c-5.9-11.9-20.3-16.7-32.2-10.7l-15.2 7.6c-13.7 6.9-29.9 6.7-43.6-.3c-13.9-7.2-27.8-14.4-41.7-21.6c-18.9-9.8-37.9-19.7-56.8-29.5c-35.1-18.2-70.2-36.4-105.3-54.6c-14.6-7.6-29.2-15.1-43.8-22.7c-45.3-23.5-90.6-47-135.9-70.6c-11.8-6.1-26.3-1.5-32.4 10.2C.9 240.5 0 244.3 0 248z',
      'M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM361 196.3L301.3 256l34.7 0c26.5 0 48 21.5 48 48l0 80c0 7.6-2.7 14.7-7.2 20.2L320 374.6l0-54.6-105.3 0L171 297.3c-12.2-20.2-9.8-48.8 13.8-64.9L244 192l-84 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l172.7 0c35.6 0 53.5 43.1 28.3 68.3z',
    ],
  ],
};
const faSledding = faPersonSledding;
const faGameConsoleHandheld = {
  prefix: 'fad',
  iconName: 'game-console-handheld',
  icon: [
    384,
    512,
    [],
    'f8bb',
    [
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 352c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 64zM64 336c0 8.8 7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16zM96 80l0 112c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-112c0-8.8-7.2-16-16-16L112 64c-8.8 0-16 7.2-16 16zM208 360a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64-48a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M96 80c0-8.8 7.2-16 16-16H272c8.8 0 16 7.2 16 16V192c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V80z',
    ],
  ],
};
const faShip = {
  prefix: 'fad',
  iconName: 'ship',
  icon: [
    576,
    512,
    [128674],
    'f21a',
    [
      'M0 480c0 2.4 .3 4.8 .8 7.3C4.3 502 17.4 512 32 512c2.4 0 4.8-.3 7.3-.8c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c2.4 .6 4.9 .8 7.3 .8c14.5 0 27.7-10 31.1-24.7c4-17.2-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-5.9-5-13.3-7.6-20.7-7.6c-6.5 0-12.9 2-18.5 5.9C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1C109 418 102.5 416 96 416c-7.4 0-14.8 2.6-20.7 7.6c-14.4 11.9-32.5 21-50.6 25.2C10 452.3 0 465.4 0 480z',
      'M224 0c-17.7 0-32 14.3-32 32l0 32-48 0c-26.5 0-48 21.5-48 48l0 128L51.6 254.8c-23.1 7.7-29.5 37.5-11.5 53.9l101 92.6c16.2 9.4 34.7 15.1 50.9 15.1c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c16.2 0 34.7-5.7 50.9-15.1l101-92.6c18-16.5 11.6-46.2-11.5-53.9L480 240l0-128c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32L224 0zm43.8 182.7L160 218.7l0-90.7 256 0 0 90.7L308.2 182.7c-13.1-4.4-27.3-4.4-40.5 0z',
    ],
  ],
};
const faClockSixThirty = {
  prefix: 'fad',
  iconName: 'clock-six-thirty',
  icon: [
    512,
    512,
    [],
    'e353',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z',
      'M256 416c13.3 0 24-10.7 24-24l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faBatterySlash = {
  prefix: 'fad',
  iconName: 'battery-slash',
  icon: [
    640,
    512,
    [],
    'f377',
    [
      'M32 176l0 160c0 44.2 35.8 80 80 80l294.2 0-81.2-64L112 352c-8.8 0-16-7.2-16-16l0-160c0-1.4 .2-2.7 .5-4L45.4 131.7C36.9 144.4 32 159.6 32 176zM154.8 96c27.2 21.3 54.4 42.7 81.7 64L496 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-14.6 0c20.6 16.2 41.3 32.3 61.9 48.5C563.1 386 576 362.5 576 336l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L154.8 96z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTugrikSign = {
  prefix: 'fad',
  iconName: 'tugrik-sign',
  icon: [
    384,
    512,
    [],
    'e2ba',
    [
      'M33 263.8c4.3 17.1 21.7 27.6 38.8 23.3L160 265l0-66L56.2 225c-17.1 4.3-27.6 21.7-23.3 38.8zm0 96C36.6 374.3 49.6 384 64 384c2.6 0 5.2-.3 7.8-1L160 361l0-66L56.2 321c-17.1 4.3-27.6 21.7-23.3 38.8zM224 183c0 22 0 44 0 66L327.8 223c14.5-3.6 24.2-16.7 24.2-31c0-2.6-.3-5.2-1-7.8c-4.3-17.1-21.7-27.6-38.8-23.3L224 183zm0 96c0 22 0 44 0 66L327.8 319c14.5-3.6 24.2-16.7 24.2-31c0-2.6-.3-5.2-1-7.8c-4.3-17.1-21.7-27.6-38.8-23.3L224 279z',
      'M0 64C0 46.3 14.3 32 32 32l160 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L224 96l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352L32 96C14.3 96 0 81.7 0 64z',
    ],
  ],
};
const faArrowsDownToLine = {
  prefix: 'fad',
  iconName: 'arrows-down-to-line',
  icon: [
    576,
    512,
    [],
    'e4b8',
    [
      'M0 448c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32z',
      'M521.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L416 274.7 416 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 41.4-41.4zm-320 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 274.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 41.4-41.4z',
    ],
  ],
};
const faDownload = {
  prefix: 'fad',
  iconName: 'download',
  icon: [
    512,
    512,
    [],
    'f019',
    [
      'M0 416l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-114.7 0-54.6 54.6c-6.2 6.2-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4c-18.2-18.2-36.4-36.4-54.6-54.6L64 352c-35.3 0-64 28.7-64 64zm456 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M256 0c17.7 0 32 14.3 32 32l0 274.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 306.7 224 32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faAnglesUpDown = {
  prefix: 'fad',
  iconName: 'angles-up-down',
  icon: [
    448,
    512,
    [],
    'e60d',
    [
      'M39 332c-11 13.8-8.8 33.9 5 45L204 505c5.8 4.7 12.9 7 20 7s14.1-2.3 20-7L404 377c13.8-11 16-31.2 5-45s-31.2-16-45-5L224 439 84 327c-5.9-4.7-13-7-20-7c-9.4 0-18.7 4.1-25 12z',
      'M204 7c11.7-9.3 28.3-9.3 40 0L404 135c13.8 11 16 31.2 5 45s-31.2 16-45 5L224 73 84 185c-13.8 11-33.9 8.8-45-5s-8.8-33.9 5-45L204 7z',
    ],
  ],
};
const faShelves = {
  prefix: 'fad',
  iconName: 'shelves',
  icon: [
    640,
    512,
    ['inventory'],
    'f480',
    [
      'M0 32L0 192 0 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l512 0c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-256 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 160 64 32C64 14.3 49.7 0 32 0S0 14.3 0 32zM64 224l512 0 0 192L64 416l0-192z',
      'M384 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L384 0zM96 288l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm160 0l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faInventory = faShelves;
const faCloudSnow = {
  prefix: 'fad',
  iconName: 'cloud-snow',
  icon: [
    512,
    512,
    [127784],
    'f742',
    [
      'M0 416c0 13.3 10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24zm192 32c0 13.3 10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24zm192-32c0 13.3 10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faFaceGrin = {
  prefix: 'fad',
  iconName: 'face-grin',
  icon: [
    512,
    512,
    [128512, 'grin'],
    'f580',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm105.2 75.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faGrin = faFaceGrin;
const faDeleteLeft = {
  prefix: 'fad',
  iconName: 'delete-left',
  icon: [
    576,
    512,
    [9003, 'backspace'],
    'f55a',
    [
      'M0 256c0 8.5 3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7L512 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6zm264 64c0-6.1 2.3-12.3 7-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.4-31.4-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.4 31.4 47 47c15.7-15.7 31.4-31.4 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5.1 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 .8 .1 1.6 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-15.7 15.7-31.4 31.4-47 47c15.7 15.7 31.4 31.4 47 47c2.3 2.3 4.1 5.1 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.4 31.4-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M399 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47z',
    ],
  ],
};
const faBackspace = faDeleteLeft;
const faOven = {
  prefix: 'fad',
  iconName: 'oven',
  icon: [
    448,
    512,
    [],
    'e01d',
    [
      'M0 160l448 0 0 32-64 0L64 192 0 192l0-32zm64 96l320 0 0 192L64 448l0-192zm32 48c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16z',
      'M96 0L352 0c53 0 96 43 96 96l0 64L0 160 0 96C0 43 43 0 96 0zM80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM200 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM64 256l0 192 320 0 0-192L64 256zM0 192l64 0 320 0 64 0 0 64 0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256l0-64z',
    ],
  ],
};
const faCloudBinary = {
  prefix: 'fad',
  iconName: 'cloud-binary',
  icon: [
    640,
    512,
    [],
    'e601',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zM160 200c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-32zm16 120c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c-8.8 0-16-7.2-16-16zm16-120l0 32c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zm80 144c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-32zm16-168c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c-8.8 0-16-7.2-16-16zm16 168l0 32c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zm80-144c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-32zm16 120c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c-8.8 0-16-7.2-16-16zm16-120l0 32c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z',
      'M200 160c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0zm80 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zM192 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0zm120 0c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32zm96-24c0 8.8 7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faEyeDropper = {
  prefix: 'fad',
  iconName: 'eye-dropper',
  icon: [
    512,
    512,
    ['eye-dropper-empty', 'eyedropper'],
    'f1fb',
    [
      'M0 480c0 8.3 3.2 16.5 9.4 22.6s14.4 9.4 22.6 9.4c6.1 0 12.3-1.8 17.7-5.4L89.7 480l42.4 0c21.2 0 41.6-8.4 56.6-23.4L332 313.3 286.7 268 143.4 411.3c-3 3-7.1 4.7-11.3 4.7L96 416l0-36.1c0-4.2 1.7-8.3 4.7-11.3L244 225.3c-15.1-15.1-30.2-30.2-45.3-45.3L55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4L5.4 462.2C1.8 467.7 0 473.8 0 480z',
      'M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4z',
    ],
  ],
};
const faEyeDropperEmpty = faEyeDropper;
const faEyedropper = faEyeDropper;
const faCommentCaptions = {
  prefix: 'fad',
  iconName: 'comment-captions',
  icon: [
    512,
    512,
    [],
    'e146',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm96-8c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 80c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm96-80c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24z',
      'M96 232c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm224 0c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM96 312c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faCommentsQuestion = {
  prefix: 'fad',
  iconName: 'comments-question',
  icon: [
    640,
    512,
    [],
    'e14e',
    [
      'M0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8C2.4 326.1 0 331 0 336c0 1.6 .3 3.3 .8 4.9C2.9 347.5 9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zm134.7-59.9c0-2.2 .4-4.5 1.2-6.7l.4-1c6.6-18.6 24.2-31.1 44-31.1l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2c-8.2-2.9-13.3-10.6-13.3-18.8zM234.7 264a26.7 26.7 0 1 1 -53.3 0 26.7 26.7 0 1 1 53.3 0z',
      'M136.2 108.4c6.6-18.6 24.2-31.1 44-31.1l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 264a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0zM432 512c-95.6 0-176.2-54.6-200.5-129C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2s0 0 0 0s0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.3-11.4C505.9 503.3 470.2 512 432 512z',
    ],
  ],
};
const faScribble = {
  prefix: 'fad',
  iconName: 'scribble',
  icon: [
    512,
    512,
    [],
    'e23f',
    [
      'M170 23.3C186.5 8.3 208 0 230.3 0l1.1 0C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4C96 373 107 384 120.6 384c6.5 0 12.8-2.6 17.4-7.2L360.8 153.9c16.6-16.6 39.1-25.9 62.6-25.9c48.9 0 88.6 39.7 88.6 88.6c0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.8 8.8-13.8 20.9-13.8 33.4c0 26 21.1 47.1 47 47.1c6.2 0 12.4-1.5 18-4.2l16.7-8.4c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L477.6 501c-14.5 7.2-30.4 11-46.6 11c-61.4 0-111-49.9-111-111.1c0-29.5 11.7-57.8 32.6-78.7l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4c0-13.6-11-24.6-24.6-24.6c-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9C71.7 448 32 408.3 32 359.4c0-23.5 9.3-46 25.9-62.6L248.8 105.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64l-1.1 0c-6.4 0-12.6 2.4-17.3 6.7L53.5 215.7c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2L170 23.3z',
      '',
    ],
  ],
};
const faRotateExclamation = {
  prefix: 'fad',
  iconName: 'rotate-exclamation',
  icon: [
    512,
    512,
    [],
    'e23c',
    [
      'M16 320l0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-37.4c41 52 104.6 85.4 176 85.4c97.6 0 180.5-62.4 211.2-149.3c5.9-16.7-2.8-34.9-19.5-40.8s-34.9 2.8-40.8 19.5C384.9 371.5 325.6 416 256 416c-52.3 0-98.8-25.1-128-64l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 288c-17.7 0-32 14.3-32 32zM44.8 181.3c-5.9 16.7 2.8 34.9 19.5 40.8s34.9-2.8 40.8-19.5C127.1 140.5 186.4 96 256 96c52.3 0 98.8 25.1 128 64l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l84.3 0c.5 0 1 0 1.5 0l26.2 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 37.4C391 65.4 327.4 32 256 32C158.4 32 75.5 94.4 44.8 181.3z',
      'M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faFileCircleCheck = {
  prefix: 'fad',
  iconName: 'file-circle-check',
  icon: [
    576,
    512,
    [],
    'e5a0',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faGlass = {
  prefix: 'fad',
  iconName: 'glass',
  icon: [
    384,
    512,
    [129371],
    'f804',
    [
      'M0 32c0 .8 0 1.5 .1 2.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.1-.8 .1-1.5 .1-2.3c0-8.1-3-15.9-8.6-21.8C369.4 3.7 360.9 0 352 0L32 0C23.1 0 14.6 3.7 8.6 10.2C3 16.1 0 23.9 0 32zM66.4 64l251.3 0c-1.5 21.3-3 42.7-4.6 64c-7.3 101.7-14.5 203.4-21.8 305.1c-.6 8.4-7.6 14.9-16 14.9l-166.6 0c-8.4 0-15.4-6.5-16-14.9C85.5 331.4 78.2 229.7 70.9 128c-1.5-21.3-3-42.7-4.6-64z',
      'M313.1 128L70.9 128 92.7 433.1c.6 8.4 7.6 14.9 16 14.9l166.6 0c8.4 0 15.4-6.5 16-14.9L313.1 128z',
    ],
  ],
};
const faLoader = {
  prefix: 'fad',
  iconName: 'loader',
  icon: [
    512,
    512,
    [],
    'e1d4',
    [
      'M65.6 414.4c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-6.2 6.2-9.4 14.4-9.4 22.6zM224 416l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM346.5 120.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L437 120.2c12.5-12.5 12.5-32.8 0-45.3c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4l-45.3 45.3zm0 226.3c-12.5 12.5-12.5 32.8 0 45.3L391.8 437c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3c-12.5-12.5-32.8-12.5-45.3 0zM384 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
      'M256 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32zM0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75z',
    ],
  ],
};
const faForward = {
  prefix: 'fad',
  iconName: 'forward',
  icon: [
    512,
    512,
    [9193],
    'f04e',
    [
      'M0 96L0 416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L256 271l0-30L52.5 71.4C46.6 66.5 39.3 64 32 64c-4.6 0-9.2 1-13.6 3C7.2 72.3 0 83.6 0 96z',
      'M308.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-320c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160z',
    ],
  ],
};
const faUserPilot = {
  prefix: 'fad',
  iconName: 'user-pilot',
  icon: [
    448,
    512,
    [],
    'e2c0',
    [
      'M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6l-23.8 20.4c.1 1 .1 2 .1 3.1l0 21.2c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 147.7 80 137.6 80 126.9l0-21.2c0-1 0-2.1 .1-3.1L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM161.7 72.8c-4 7.9-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7c-7.9-4-17.5-.7-21.5 7.2zM142.1 354.6l72.3 54.2c5.7 4.3 13.5 4.3 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352c2.8 0 5.5 .9 7.7 2.6zM320 432c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faMobile = {
  prefix: 'fad',
  iconName: 'mobile',
  icon: [
    384,
    512,
    [128241, 'mobile-android', 'mobile-phone'],
    'f3ce',
    [
      'M16 384l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64L16 384zm128 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z',
      'M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V384H16V64z',
    ],
  ],
};
const faMobileAndroid = faMobile;
const faMobilePhone = faMobile;
const faCodePullRequestClosed = {
  prefix: 'fad',
  iconName: 'code-pull-request-closed',
  icon: [
    512,
    512,
    [],
    'e3f9',
    [
      'M80 153.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3c1.4 .1 2.8 .1 4.2 .1c11.4 0 22.2-2.4 32-6.7l0 205.3c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7l0-205.3zM368 224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 134.7c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7L368 224z',
      'M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L400 34.7 425.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L445.3 80l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L400 125.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 80 329.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zM136 80A24 24 0 1 0 88 80a24 24 0 1 0 48 0zM32 80a80 80 0 1 1 160 0A80 80 0 1 1 32 80zm80 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-104a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM400 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-104a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faFaceMeh = {
  prefix: 'fad',
  iconName: 'face-meh',
  icon: [
    512,
    512,
    [128528, 'meh'],
    'f11a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 96c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm.4-144c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMeh = faFaceMeh;
const faAlignCenter = {
  prefix: 'fad',
  iconName: 'align-center',
  icon: [
    448,
    512,
    [],
    'f037',
    [
      'M96 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L128 32c-17.7 0-32 14.3-32 32zm0 256c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32z',
      'M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224z',
    ],
  ],
};
const faBookSkull = {
  prefix: 'fad',
  iconName: 'book-skull',
  icon: [
    448,
    512,
    ['book-dead'],
    'f6b7',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zM320 112c0 20.9-12.6 39.5-32 51.2l0 12.8c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-12.8c-19.4-11.7-32-30.3-32-51.2c0-35.3 35.8-64 80-64s80 28.7 80 64zM208 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM134.3 209.3L240 254.6l105.7-45.3c8.1-3.5 17.5 .3 21 8.4s-.3 17.5-8.4 21L280.6 272l77.7 33.3c8.1 3.5 11.9 12.9 8.4 21s-12.9 11.9-21 8.4L240 289.4 134.3 334.7c-8.1 3.5-17.5-.3-21-8.4s.3-17.5 8.4-21L199.4 272l-77.7-33.3c-8.1-3.5-11.9-12.9-8.4-21s12.9-11.9 21-8.4z',
    ],
  ],
};
const faBookDead = faBookSkull;
const faIdCard = {
  prefix: 'fad',
  iconName: 'id-card',
  icon: [
    576,
    512,
    [62147, 'drivers-license'],
    'f2c2',
    [
      'M0 128L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM240 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm112-48c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
      'M64 32C28.7 32 0 60.7 0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32zM240 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 405.3c0 5.9 4.8 10.7 10.7 10.7l202.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-117.3 0C87.9 352 64 375.9 64 405.3z',
    ],
  ],
};
const faDriversLicense = faIdCard;
const faFaceDotted = {
  prefix: 'fad',
  iconName: 'face-dotted',
  icon: [
    512,
    512,
    [129765],
    'e47f',
    [
      'M0 256c0 13.6 1.1 27 3.1 40c2.7 17.5 19.1 29.4 36.6 26.6s29.4-19.1 26.6-36.6C64.8 276.3 64 266.3 64 256s.8-20.3 2.3-30.1c2.7-17.5-9.2-33.8-26.6-36.6S5.9 198.5 3.1 216C1.1 229 0 242.4 0 256zM48.9 105.5c-10.4 14.3-7.2 34.3 7 44.7s34.3 7.2 44.7-7c11.9-16.3 26.2-30.7 42.5-42.5c14.3-10.4 17.4-30.4 7-44.7s-30.4-17.4-44.7-7C83.8 64.7 64.7 83.8 48.9 105.5zm0 301c15.8 21.7 34.9 40.8 56.6 56.6c14.3 10.4 34.3 7.2 44.7-7s7.2-34.3-7-44.7c-16.3-11.9-30.7-26.2-42.5-42.5c-10.4-14.3-30.4-17.4-44.7-7s-17.4 30.4-7 44.7zM189.3 39.7c2.7 17.5 19.1 29.4 36.6 26.6c9.8-1.5 19.8-2.3 30.1-2.3s20.3 .8 30.1 2.3c17.5 2.7 33.8-9.2 36.6-26.6s-9.2-33.8-26.6-36.6C283 1.1 269.6 0 256 0s-27 1.1-40 3.1c-17.5 2.7-29.4 19.1-26.6 36.6zm0 432.6c-2.7 17.5 9.2 33.8 26.6 36.6c13.1 2.1 26.4 3.1 40 3.1s27-1.1 40-3.1c17.5-2.7 29.4-19.1 26.6-36.6s-19.1-29.4-36.6-26.6c-9.8 1.5-19.8 2.3-30.1 2.3s-20.3-.8-30.1-2.3c-17.5-2.7-33.8 9.2-36.6 26.6zM361.8 55.9c-10.4 14.3-7.2 34.3 7 44.7c16.3 11.9 30.7 26.2 42.5 42.5c10.4 14.3 30.4 17.4 44.7 7s17.4-30.4 7-44.7c-15.8-21.7-34.9-40.8-56.6-56.6c-14.3-10.4-34.3-7.2-44.7 7zm0 400.1c10.4 14.3 30.4 17.4 44.7 7c21.7-15.8 40.8-34.9 56.6-56.6c10.4-14.3 7.2-34.3-7-44.7s-34.3-7.2-44.7 7c-11.9 16.3-26.2 30.7-42.5 42.5c-14.3 10.4-17.4 30.4-7 44.7zm83.9-230.1c1.5 9.8 2.3 19.8 2.3 30.1s-.8 20.3-2.3 30.1c-2.7 17.5 9.2 33.8 26.6 36.6s33.8-9.2 36.6-26.6c2.1-13.1 3.1-26.4 3.1-40s-1.1-27-3.1-40c-2.7-17.5-19.1-29.4-36.6-26.6s-29.4 19.1-26.6 36.6z',
      'M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
    ],
  ],
};
const faFaceWorried = {
  prefix: 'fad',
  iconName: 'face-worried',
  icon: [
    512,
    512,
    [],
    'e3a3',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm100.3-69.1c-6-6.5-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8zM208.4 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM161.3 398.1c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8c-12.4 5.2-26.5-4.1-21.1-16.4zM304 144c0-8.8 7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c3.4 3.2 5.1 7.4 5.1 11.7c0 3.9-1.4 7.8-4.3 10.9c-6 6.5-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16zm64.4 128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-15.6 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 160.9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z',
    ],
  ],
};
const faOutdent = {
  prefix: 'fad',
  iconName: 'outdent',
  icon: [
    448,
    512,
    ['dedent'],
    'f03b',
    [
      'M0 64C0 81.7 14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM192 192c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32z',
      'M.2 243.4c-8.2 6.4-8.2 18.9 0 25.3l101.9 79.3c10.5 8.2 25.8 .7 25.8-12.6V176.7c0-13.3-15.3-20.8-25.8-12.6L.2 243.4z',
    ],
  ],
};
const faDedent = faOutdent;
const faCourtSport = {
  prefix: 'fad',
  iconName: 'court-sport',
  icon: [
    640,
    512,
    [],
    'e643',
    [
      'M0 128l0 32 64 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L0 352l0 32 64 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64L0 128zM208 256c0 56.4 41.7 103.1 96 110.9L304 480l32 0 0-113.1c54.3-7.8 96-54.4 96-110.9s-41.7-103.1-96-110.9L336 32l-32 0 0 113.1c-54.3 7.8-96 54.4-96 110.9zm32 0c0-38.7 27.5-71 64-78.4l0 156.8c-36.5-7.4-64-39.7-64-78.4zm96-78.4c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4l0-156.8zM512 192l0 128c0 35.3 28.7 64 64 64l64 0 0-32-64 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l64 0 0-32-64 0c-35.3 0-64 28.7-64 64z',
      'M576 480l-240 0 0-113.1c54.3-7.8 96-54.4 96-110.9s-41.7-103.1-96-110.9L336 32l240 0c35.3 0 64 28.7 64 64l0 32-64 0c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l64 0 0 32c0 35.3-28.7 64-64 64zM304 145.1c-54.3 7.8-96 54.4-96 110.9s41.7 103.1 96 110.9L304 480 64 480c-35.3 0-64-28.7-64-64l0-32 64 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64L0 128 0 96C0 60.7 28.7 32 64 32l240 0 0 113.1zm0 189.3c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4l0 156.8zm32 0l0-156.8c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4zM576 160l64 0 0 192-64 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32zM64 352L0 352 0 160l64 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faHeartCircleExclamation = {
  prefix: 'fad',
  iconName: 'heart-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e4fe',
    [
      'M0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faHouse = {
  prefix: 'fad',
  iconName: 'house',
  icon: [
    576,
    512,
    [127968, 63498, 63500, 'home', 'home-alt', 'home-lg-alt'],
    'f015',
    [
      'M64 270.5c74.7-65.3 149.3-130.6 224-196L512.1 270.6l.4 201.3c0 22.1-17.9 40.1-40 40.1L392 512c-22.1 0-40-17.9-40-40l0-88.3c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 88.3c0 22.1-17.9 40-40 40l-79.9 0c-22.1 0-40-17.9-40-40L64 270.5z',
      'M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z',
    ],
  ],
};
const faHome = faHouse;
const faHomeAlt = faHouse;
const faHomeLgAlt = faHouse;
const faVectorCircle = {
  prefix: 'fad',
  iconName: 'vector-circle',
  icon: [
    512,
    512,
    [],
    'e2c6',
    [
      'M41.3 192c18.2 0 36.5 0 54.7 0c1.1 0 2.2 .1 3.2 .2s2.1 .3 3.1 .5c2.1 .4 4 1 5.9 1.8c16.2-38.9 47.3-70 86.2-86.2c-1.6-3.8-2.4-7.9-2.4-12.3l0-54.7C119.8 62.8 62.8 119.8 41.3 192zm0 128C62.8 392.2 119.8 449.2 192 470.7c0-18.2 0-36.5 0-54.7c0-.3 0-.6 0-.9l0-.8c0-.5 .1-1 .1-1.6c.1-1.1 .3-2.1 .5-3.1c.4-2.1 1-4 1.8-5.9c-38.8-16.2-69.8-47.2-86-85.9c-3.9 1.3-8 2.2-12.4 2.2l-54.7 0zM317.6 108.3c39 16.4 70 47.4 86.2 86.2c3.8-1.6 7.9-2.4 12.3-2.4c18.2 0 36.5 0 54.7 0C449.2 119.8 392.2 62.8 320 41.3L320 96c0 .5 0 1.1 0 1.6s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.1c-.4 2-1 4-1.8 5.9zm0 295.5c1.6 3.8 2.4 7.9 2.4 12.3l0 54.7c72.2-21.5 129.2-78.5 150.7-150.7L416 320c-.5 0-1.1 0-1.6 0s-1.1-.1-1.6-.1c-1.1-.1-2.1-.3-3.1-.5c-2.1-.4-4-1-5.9-1.8c-16.3 38.9-47.2 69.8-86.2 86.2z',
      'M240 80l32 0 0-32-32 0 0 32zM192 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM48 272l32 0 0-32-32 0 0 32zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM240 432l0 32 32 0 0-32-32 0zm-16-48l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM432 272l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64z',
    ],
  ],
};
const faCarCircleBolt = {
  prefix: 'fad',
  iconName: 'car-circle-bolt',
  icon: [
    640,
    512,
    [],
    'e342',
    [
      'M0 256L0 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 226.9 0c-1.9-10.4-2.9-21.1-2.9-32c0-88.8 65.8-162.3 151.3-174.3L437.2 96.3C423.7 57.8 387.4 32 346.6 32L165.4 32c-40.8 0-77.1 25.8-90.6 64.3L39.6 196.8C16.4 206.4 0 229.3 0 256zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-18.9-96l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4l181.2 0c13.6 0 25.7 8.6 30.2 21.4L402.9 192l-293.8 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2z',
    ],
  ],
};
const faCalendarWeek = {
  prefix: 'fad',
  iconName: 'calendar-week',
  icon: [
    448,
    512,
    [],
    'f784',
    [
      'M0 192L0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272L0 192zm64 80c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-64z',
      'M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 80L0 192l0-80C0 85.5 21.5 64 48 64l48 0 0-32z',
    ],
  ],
};
const faFlyingDisc = {
  prefix: 'fad',
  iconName: 'flying-disc',
  icon: [
    448,
    512,
    [],
    'e3a9',
    [
      'M45.9 345c7.6 7.6 18.4 11.2 31.6 11.2c40.2 0 102-33.5 157.6-89.1C308.9 193.4 343.8 108.7 313 77.9s-115.4 4.1-189.2 77.9S15.2 314.3 45.9 345z',
      'M424.3 55.7c55.3 55.3 10.5 189.8-100.2 300.5S79 511.6 23.7 456.3C-1.5 431.1-5.9 389.6 7.1 341.4c3.2 9.5 8.4 18.5 16.2 26.3c15.6 15.6 36 20.7 55 20.5c18.8-.1 38.8-5.3 58.2-13.3c39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2c.1-19-5-39.5-20.5-55c-7.8-7.8-16.8-13-26.3-16.2c48.2-13 89.8-8.6 114.9 16.6z',
    ],
  ],
};
const faLaptopMedical = {
  prefix: 'fad',
  iconName: 'laptop-medical',
  icon: [
    640,
    512,
    [],
    'f812',
    [
      'M0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384C8.6 384 0 392.6 0 403.2zM64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96z',
      'M512 96L128 96l0 256 384 0 0-256zM288 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faSquareDownRight = {
  prefix: 'fad',
  iconName: 'square-down-right',
  icon: [
    448,
    512,
    [],
    'e26c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 200c0-5.1 2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6L320 336c0 8.8-7.2 16-16 16l-137.4 0c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3C114 210 112 205.1 112 200z',
      'M320 336l0-137.4c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6L248 216l-66.3-66.3C178 146 173.1 144 168 144s-10 2-13.7 5.7l-36.7 36.7C114 190 112 194.9 112 200s2 10 5.7 13.7L184 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6L304 352c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faB = {
  prefix: 'fad',
  iconName: 'b',
  icon: [
    320,
    512,
    [98],
    '42',
    [
      'M64 32C28.7 32 0 60.7 0 96L0 256 0 416c0 35.3 28.7 64 64 64l128 0c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128L64 32zm96 192l-96 0L64 96l96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288l96 0 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 416l0-128z',
      '',
    ],
  ],
};
const faSeatAirline = {
  prefix: 'fad',
  iconName: 'seat-airline',
  icon: [
    448,
    512,
    [],
    'e244',
    [
      'M80.5 192c9.1 21.3 18.3 42.7 27.4 64l212 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80.5 192zM96 488c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48-48 0 0 48-96 0c-13.3 0-24 10.7-24 24z',
      'M32 0C49.7 0 64 14.3 64 32l0 111.6c0 6.5 1.3 12.9 3.9 18.9L121.7 288 416 288c12.1 0 23.2 6.8 28.6 17.7s4.3 23.8-3 33.5l-43.2 57.6C389.3 408.9 375.1 416 360 416l-189.8 0c-38.4 0-73.1-22.9-88.2-58.2L9.1 187.7c-6-13.9-9.1-29-9.1-44.1L0 32C0 14.3 14.3 0 32 0z',
    ],
  ],
};
const faMoonOverSun = {
  prefix: 'fad',
  iconName: 'moon-over-sun',
  icon: [
    512,
    512,
    ['eclipse-alt'],
    'f74a',
    [
      'M1.2 150.5c-2.1 5-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6zM400 256a144 144 0 1 1 -288 0 144 144 0 1 1 288 0z',
      'M257 142c-63.4 0-115 50.9-115 114s51.6 114 115 114c31.1 0 59.4-12.3 80.1-32.2c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.2 .7-8.5 1.1-13 1.1c-41.8 0-75.4-33.5-75.4-74.5c0-27.7 15.3-52 38.3-64.8c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.2-.3-6.5-.4-9.7-.4z',
    ],
  ],
};
const faEclipseAlt = faMoonOverSun;
const faPipe = {
  prefix: 'fad',
  iconName: 'pipe',
  icon: [
    64,
    512,
    [],
    '7c',
    ['M32 0C49.7 0 64 14.3 64 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0z', ''],
  ],
};
const faFileMedical = {
  prefix: 'fad',
  iconName: 'file-medical',
  icon: [
    384,
    512,
    [],
    'f477',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 304l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faPotato = {
  prefix: 'fad',
  iconName: 'potato',
  icon: [
    512,
    512,
    [129364],
    'e440',
    [
      'M0 368c0 79.5 64.5 144 144 144c30.3 0 58.4-9.3 81.5-25.3c28.1-19.3 60.2-35.3 92.5-46.2c44.1-14.9 80.1-50.9 93.1-99.2c9.2-34.2 29.4-67.9 55.2-92.1C494.4 222.9 512 185.5 512 144C512 64.5 447.5 0 368 0c-39.8 0-75.9 16.2-102 42.3C238.6 69.8 205 95 170.9 113.6c-24.1 13.2-44 33.1-57.3 57.3C95 205 69.8 238.6 42.3 266C16.2 292.1 0 328.2 0 368zm184 48a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32-192a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm192-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M360 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM168 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faDiceOne = {
  prefix: 'fad',
  iconName: 'dice-one',
  icon: [
    448,
    512,
    [9856],
    'f525',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faCircleA = {
  prefix: 'fad',
  iconName: 'circle-a',
  icon: [
    512,
    512,
    [],
    'e0f7',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm130.5 77.3c34.7-69.3 69.3-138.7 104-208c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3c34.7 69.3 69.3 138.7 104 208c.9 1.7 1.5 3.5 1.9 5.3c.2 .9 .4 1.8 .5 2.7c.1 .7 .1 1.3 .1 1.3l0 1.5c0 1.1 0 1.4-.1 1.6c0 .5-.1 1.1-.2 1.6c-.1 1.1-.4 2.1-.7 3.2c-.6 2.1-1.5 4.1-2.6 6c-2.3 3.7-5.6 6.9-9.8 9c-11.9 5.9-26.3 1.1-32.2-10.7L321.2 320l-130.3 0c-5.8 11.6-11.6 23.2-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2zM214.8 272l82.3 0c-13.7-27.4-27.4-54.9-41.2-82.3c-13.7 27.5-27.4 54.9-41.2 82.3z',
      'M277.5 125.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L190.8 320l130.3 0 17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208zM297.2 272l-82.3 0L256 189.7 297.2 272z',
    ],
  ],
};
const faHelmetBattle = {
  prefix: 'fad',
  iconName: 'helmet-battle',
  icon: [
    576,
    512,
    [],
    'f6eb',
    [
      'M0 225.6C0 242.4 13.6 256 30.4 256l2.2 0c17.1 0 31.3-13.2 32.5-30.2L80 17.1c.6-8.3-5.3-15.7-13.6-17s-16.1 4.1-18 12.2L.8 218.8c-.5 2.2-.8 4.5-.8 6.8zM496 17.1l14.9 208.6c1.2 17 15.4 30.2 32.5 30.2l2.2 0c16.8 0 30.4-13.6 30.4-30.4c0-2.3-.3-4.6-.8-6.8L527.6 12.4c-1.9-8.1-9.7-13.5-18-12.2s-14.2 8.6-13.6 17z',
      'M320 352l0 136c0 18.4 20.8 30.1 36.5 20.5l144-88c9.2-5.6 13.5-16.7 10.6-27.1C494.1 333.6 480 270.2 480 208c0-85-89.1-149.2-153.1-189c-1.9-1.2-4-2.6-6.3-4.1C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4c-3 10.4 1.4 21.4 10.6 27.1l144 88c15.7 9.6 36.5-2.1 36.5-20.5l0-192s0 0 0 0l0-28.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l218.8 0c10.3 0 18.6 8.3 18.6 18.6c0 8-5.1 15.1-12.7 17.6l-72.3 24.1c-6.5 2.2-10.9 8.3-10.9 15.2l0 84.5s0 0 0 0z',
    ],
  ],
};
const faButter = {
  prefix: 'fad',
  iconName: 'butter',
  icon: [
    640,
    512,
    [129480],
    'e3e4',
    [
      'M64 128l0 192 384 0 0-256L128 64c-35.3 0-64 28.7-64 64zM480 64l0 256 96 0 0-192c0-35.3-28.7-64-64-64l-32 0z',
      'M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-32c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 320z',
    ],
  ],
};
const faBlanketFire = {
  prefix: 'fad',
  iconName: 'blanket-fire',
  icon: [
    640,
    512,
    [],
    'e3da',
    [
      'M0 96L0 320c0 70.7 57.3 128 128 128l186.4 0c-11.3-19.5-19.4-41.2-23.4-64l-163 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l189.4 0c2.5-4.5 5.1-8.9 7.8-13.3c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7L448 96c0-53-43-96-96-96L96 0C43 0 0 43 0 96zM96 320c0 17.7 14.3 32 32 32l160 0c0-.6 0-1.3 0-1.9c0-20.2 5.3-41.3 13.8-62.1L128 288c-17.7 0-32 14.3-32 32z',
      'M518 194.5l-12.3 13.8-19-19.9c-2-2.1-4-4.4-6-6.7c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2C320 440.7 390.4 512 480 512c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9zM480 464.2c-35.3 0-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327.1 544 363.6 544 400.2c0 35.3-28.7 64-64 64z',
    ],
  ],
};
const faKiwiBird = {
  prefix: 'fad',
  iconName: 'kiwi-bird',
  icon: [
    576,
    512,
    [],
    'f535',
    [
      'M96 390.3c14.9 8.6 31 15.3 48 19.6l0 46c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-65.7zm112 25c16.7-1.4 32.8-4.9 48-10.3l0 50.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40.7zm269.6-66.8c14.1-3.3 27.3-9 39.1-16.5s22.4-17 31.2-27.9s15.8-23.3 20.6-36.8c2.4-6.7 4.3-13.7 5.6-20.9c.6-3.6 1.1-7.2 1.4-10.9c.2-1.8 .3-3.7 .4-5.6c.1-1.8 .1-3.7 .1-5.6L576 464c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7L477.6 348.6z',
      'M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4l55.7 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-55.7 0c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224S86 416 192 416c36.3 0 70.3-10.1 99.2-27.6zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faCastle = {
  prefix: 'fad',
  iconName: 'castle',
  icon: [
    640,
    512,
    [],
    'e0de',
    [
      'M128 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 0 144 0 16-16 0-32 0-288 0-32 0-16 0 0-16 0-144 0-48z',
      'M0 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 512 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 96 0 192c0 26.5-21.5 48-48 48l-208 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L48 512c-26.5 0-48-21.5-48-48L0 272l0-96z',
    ],
  ],
};
const faGolfClub = {
  prefix: 'fad',
  iconName: 'golf-club',
  icon: [
    512,
    512,
    [],
    'f451',
    [
      'M0 348.4L0 376c16 0 32 0 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-16 0-32 0-48 0l0 32c16 0 32 0 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-16 0-32 0-48 0l0 8c0 17.7 14.3 32 32 32l223.3 0c12 .3 23.6-6.3 29.3-17.7l224-448c2.3-4.6 3.4-9.5 3.4-14.3c0-11.7-6.5-23-17.7-28.6C489.7 1.1 484.8 0 480 0c-11.7 0-23 6.5-28.6 17.7L264 392.5l0-.5L42.1 318C21.4 311.1 0 326.6 0 348.4z',
      'M0 408l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 376l0 32zm0 64l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 440l0 32z',
    ],
  ],
};
const faArrowRightArrowLeft = {
  prefix: 'fad',
  iconName: 'arrow-right-arrow-left',
  icon: [
    448,
    512,
    [8644, 'exchange'],
    'f0ec',
    [
      'M0 384c0 8.2 3.1 16.4 9.4 22.6l96 96c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c12.5-12.5 12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4l-96 96C3.1 367.6 0 375.8 0 384z',
      'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160 32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l306.7 0L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96z',
    ],
  ],
};
const faExchange = faArrowRightArrowLeft;
const faRotateRight = {
  prefix: 'fad',
  iconName: 'rotate-right',
  icon: [
    512,
    512,
    ['redo-alt', 'rotate-forward'],
    'f2f9',
    [
      'M32 256c0 57.3 21.9 114.7 65.6 158.4c87.5 87.5 229.3 87.5 316.8 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-12.5-12.5-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1c15.1-15.1 30.2-30.2 45.3-45.3C369.8 53.5 312.9 32 256 32C198.7 32 141.3 53.9 97.6 97.6S32 198.7 32 256z',
      'M344 224l128 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8z',
    ],
  ],
};
const faRedoAlt = faRotateRight;
const faRotateForward = faRotateRight;
const faUtensils = {
  prefix: 'fad',
  iconName: 'utensils',
  icon: [
    448,
    512,
    [127860, 61685, 'cutlery'],
    'f2e7',
    [
      'M0 167.9c0 48.5 39.2 87.9 87.7 88.1c16.1 0 32.2 0 48.2 0l.4 0c48.5-.2 87.7-39.6 87.7-88.1c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16l0 134.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8L64 16C64 7.8 57.9 1 49.7 .1C49.2 0 48.6 0 48 0C40.6 0 34 5.1 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9zm112-.5l.3 .7c-.1 0-.2 0-.6 0l.3-.7zM288 176l0 112c0 35.3 28.7 64 64 64l32 0 64 0 0-320c0-17.7-14.3-32-32-32C400 0 288 32 288 176z',
      'M144 480l0-224-64 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32zm304 0l0-128-64 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32z',
    ],
  ],
};
const faCutlery = faUtensils;
const faArrowUpWideShort = {
  prefix: 'fad',
  iconName: 'arrow-up-wide-short',
  icon: [
    576,
    512,
    ['sort-amount-up'],
    'f161',
    [
      'M288 64c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L320 96c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32z',
      'M128 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L160 146.3 160 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L63.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C110.5 35.8 119 32 128 32z',
    ],
  ],
};
const faSortAmountUp = faArrowUpWideShort;
const faChartPieSimpleCircleDollar = {
  prefix: 'fad',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [
    640,
    512,
    [],
    'e605',
    [
      'M0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368c0-28.8 6.9-56 19.2-80L224 288l0-221.3c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272zM272 16.6L272 240l103.2 0c31.5-29.8 74-48 120.8-48c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z',
    ],
  ],
};
const faBalloons = {
  prefix: 'fad',
  iconName: 'balloons',
  icon: [
    640,
    512,
    [],
    'e2e4',
    [
      'M324.7 261.9C340.5 231.8 352 197.2 352 160c0-9.9-.7-19.6-2.2-29c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3l24.7 49.3c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-102.1 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8L442 443.9c3.5-6.9 1.6-15.3-4.4-20.3c-26.2-22.1-94.5-85.6-113-161.8zM384 208c0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80z',
      'M160 0c88.4 0 160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3l24.7 49.3c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-102.1 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8L122 379.9c3.5-6.9 1.6-15.3-4.4-20.3C87.2 334 0 252.5 0 160C0 71.6 71.6 0 160 0zM96 144c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16z',
    ],
  ],
};
const faMillSign = {
  prefix: 'fad',
  iconName: 'mill-sign',
  icon: [
    384,
    512,
    [],
    'e1ed',
    [
      'M80 480c0 13.1 8.2 25.5 21.2 30.1c3.6 1.3 7.2 1.9 10.8 1.9c13.1 0 25.5-8.2 30.1-21.2l21.4-60c-2.3-4.4-3.6-9.4-3.6-14.7l0-165.5L81.9 469.2c-1.3 3.6-1.9 7.2-1.9 10.8zM208 116.1C226.1 103.4 248.2 96 272 96c1.9 0 3.7 0 5.5 .1s3.6 .2 5.4 .4c6.4-17.9 12.8-35.8 19.2-53.8c1.3-3.6 1.9-7.2 1.9-10.8c0-13.1-8.2-25.5-21.2-30.1c-16.6-5.9-35 2.7-40.9 19.4L208 116.1zM224 208l0 53.5 35.7-100C239.1 167 224 185.7 224 208z',
      'M112 160c-26.5 0-48 21.5-48 48l0 208c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 208l0-80c0-17.7 14.3-32 32-32c10.9 0 20.5 5.4 26.3 13.7C74.2 101 92.5 96 112 96c31.3 0 59.7 12.9 80 33.6C212.3 108.9 240.7 96 272 96c61.9 0 112 50.1 112 112l0 208c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-208c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 208c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-208c0-26.5-21.5-48-48-48z',
    ],
  ],
};
const faBowlRice = {
  prefix: 'fad',
  iconName: 'bowl-rice',
  icon: [
    512,
    512,
    [],
    'e2eb',
    [
      'M32 200c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm48-72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm48 72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zM176 56c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm0 72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm48 72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zM272 56c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm0 72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm48 72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm48-72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm48 72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24z',
      'M27.4 256C12.3 256 0 268.3 0 283.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28l231.5 0c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 414.1 512 353.9 512 283.4c0-15.1-12.3-27.4-27.4-27.4L27.4 256z',
    ],
  ],
};
const faTimelineArrow = {
  prefix: 'fad',
  iconName: 'timeline-arrow',
  icon: [
    640,
    512,
    [],
    'e29d',
    [
      'M0 256c0 17.7 14.3 32 32 32l160 0 0 54.7c9.8-4.3 20.6-6.7 32-6.7c1.4 0 2.8 0 4.2 .1s2.8 .2 4.2 .3c2.8 .3 5.5 .7 8.2 1.3c5.4 1.1 10.5 2.8 15.4 4.9l0-54.7 274.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l96-96c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-96-96c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L530.7 224 384 224l0-54.7c-9.8 4.3-20.6 6.7-32 6.7c-1.4 0-2.8 0-4.2-.1s-2.8-.2-4.2-.3c-2.8-.3-5.5-.7-8.2-1.3c-5.4-1.1-10.5-2.8-15.4-4.9l0 54.7-160 0 0-54.7c-9.8 4.3-20.6 6.7-32 6.7c-1.4 0-2.8 0-4.2-.1s-2.8-.2-4.2-.3c-2.8-.3-5.5-.7-8.2-1.3c-5.4-1.1-10.5-2.8-15.4-4.9L96 224l-64 0c-17.7 0-32 14.3-32 32z',
      'M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM352 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM200 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faSkull = {
  prefix: 'fad',
  iconName: 'skull',
  icon: [
    512,
    512,
    [128128],
    'f54c',
    [
      'M0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1l0 64c0 26.5 21.5 48 48 48l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c26.5 0 48-21.5 48-48l0-64c0-.4 0-.7 0-1.1c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224zm224 32A64 64 0 1 1 96 256a64 64 0 1 1 128 0zm192 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M160 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm192 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faGameBoardSimple = {
  prefix: 'fad',
  iconName: 'game-board-simple',
  icon: [
    448,
    512,
    ['game-board-alt'],
    'f868',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 0l160 0 160 0 0 160 0 160-160 0L64 416l0-160L64 96z',
      'M64 96l0 160H224V96H64zM224 256V416H384l0-160H224z',
    ],
  ],
};
const faGameBoardAlt = faGameBoardSimple;
const faCircleVideo = {
  prefix: 'fad',
  iconName: 'circle-video',
  icon: [
    512,
    512,
    ['video-circle'],
    'e12b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128zm224 32l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L352 288l0-64z',
      'M160 160c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-128 0zM352 288l44.9 29.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3l0-103.4c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L352 224l0 64z',
    ],
  ],
};
const faVideoCircle = faCircleVideo;
const faChartScatterBubble = {
  prefix: 'fad',
  iconName: 'chart-scatter-bubble',
  icon: [
    512,
    512,
    [],
    'e0e9',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M384 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-96-16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 176a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-176 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faHouseTurret = {
  prefix: 'fad',
  iconName: 'house-turret',
  icon: [
    640,
    512,
    [],
    'e1b4',
    [
      'M0 24L0 96l0 8 0 93.5c0 17 6.7 33.3 18.7 45.3L64 288l0 176c0 26.5 21.5 48 48 48l128 0c-10-13.4-16-30-16-48l0-186.9c0-22.4 9.4-43.8 25.9-59L352 124.6l0-20.6 0-8 0-72c0-13.3-10.7-24-24-24L280 0c-13.3 0-24 10.7-24 24l0 72-32 0 0-72c0-13.3-10.7-24-24-24L152 0c-13.3 0-24 10.7-24 24l0 72L96 96l0-72C96 10.7 85.3 0 72 0L24 0C10.7 0 0 10.7 0 24zM136 200c0-22.1 17.9-40 40-40s40 17.9 40 40l0 24c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-24z',
      'M256 464l0-186.9c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4L640 464c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48zM424 272c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z',
    ],
  ],
};
const faBanana = {
  prefix: 'fad',
  iconName: 'banana',
  icon: [
    576,
    512,
    [],
    'e2e5',
    [
      'M269.1 273.1c2.7 1.8 5.3 3.7 7.8 5.7l.5 .4c16 12.8 32.1 25.7 48.1 38.5c32.2-8.6 64.4-17.2 96.7-25.8l.5-.1c2.9-.8 5.9-1.4 8.8-2c3.1-.6 6.1-1 9.2-1.3c4.8-20.8 7.3-42.4 7.3-64.6c0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55c10.3 27.7 15.9 57.7 15.9 89c0 47.1-12.7 91.2-34.9 129.1z',
      'M177.1 315.2c9.7-7.3 21.5-11.2 33.6-11.2l1.3 0c10.3 0 20.4 2.8 29.1 8.2C194.1 366 125 400 48 400c-26.5 0-48 21.5-48 48l0 16c0 26.5 21.5 48 48 48l112 0c117.3 0 218.2-70.1 263.1-170.6l12-3.2c5.4-1.4 10.9-2.2 16.5-2.2l2.6 0c22.5 0 43.3 11.8 54.9 31.1l22.4 37.3c6.8 11.4 21.6 15 32.9 8.2s15-21.6 8.2-32.9l-22.4-37.3c-20.2-33.7-56.7-54.4-96-54.4l-2.6 0c-9.7 0-19.4 1.3-28.9 3.8l-.3 .1-.2 .1-96.7 25.8-48.1-38.5-.5-.4c-18.4-14.8-41.4-22.8-65-22.8l-1.3 0c-22.5 0-44.4 7.3-62.4 20.8l-42.7 32c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l42.7-32z',
    ],
  ],
};
const faHandHoldingSkull = {
  prefix: 'fad',
  iconName: 'hand-holding-skull',
  icon: [
    576,
    512,
    [],
    'e1a4',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M363.6 250c-1.4-7 2-13.9 8-17.7C408.2 209 432 171 432 128C432 57.3 367.5 0 288 0S144 57.3 144 128c0 43 23.8 81 60.4 104.2c6 3.8 9.4 10.8 8 17.7l-4.1 20.6c-.2 .9-.3 1.9-.3 2.9c0 8 6.5 14.6 14.6 14.6l130.9 0c8 0 14.6-6.5 14.6-14.6c0-1-.1-1.9-.3-2.9L363.6 250zM208 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faPeopleDress = {
  prefix: 'fad',
  iconName: 'people-dress',
  icon: [
    640,
    512,
    [],
    'e217',
    [
      'M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm320 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M70.2 384L88 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L226.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1l17.8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-53.6-89.2c-20.3-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9C51.6 373.3 59.3 384 70.2 384z',
    ],
  ],
};
const faLoveseat = {
  prefix: 'fad',
  iconName: 'loveseat',
  icon: [
    512,
    512,
    ['couch-small'],
    'f4cc',
    [
      'M64 160l0 66.7c18.6 6.6 32 24.4 32 45.3l0 80 320 0 0-80c0-.7 0-1.3 0-1.9s.1-1.3 .1-1.9c.1-1.3 .3-2.5 .5-3.8c.4-2.5 1-4.9 1.8-7.3c1.5-4.7 3.8-9.1 6.6-13c5.7-7.9 13.7-14 23-17.3l0-66.7c0-70.7-57.3-128-128-128L192 32C121.3 32 64 89.3 64 160z',
      'M48 224c-26.5 0-48 21.5-48 48L0 448c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l320 0c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-176c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80L96 352l0-80c0-26.5-21.5-48-48-48z',
    ],
  ],
};
const faCouchSmall = faLoveseat;
const faTowerBroadcast = {
  prefix: 'fad',
  iconName: 'tower-broadcast',
  icon: [
    576,
    512,
    ['broadcast-tower'],
    'f519',
    [
      'M0 128c0 38.1 7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3S27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128zm96 0c0 27.2 5.7 53.2 16 76.8c7.1 16.2 25.9 23.6 42.1 16.5s23.6-25.9 16.5-42.1C163.8 163.6 160 146.3 160 128s3.8-35.6 10.6-51.2c7.1-16.2-.3-35.1-16.5-42.1s-35.1 .3-42.1 16.5C101.7 74.8 96 100.8 96 128zM405.4 76.8C412.2 92.4 416 109.7 416 128s-3.8 35.6-10.6 51.2c-7.1 16.2 .3 35.1 16.5 42.1s35.1-.3 42.1-16.5c10.3-23.6 16-49.6 16-76.8s-5.7-53.2-16-76.8c-7.1-16.2-25.9-23.6-42.1-16.5s-23.6 25.9-16.5 42.1zM495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3S489.1 27.6 495.7 44z',
      'M320 183.4c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.7 12.9 44.4 32 55.4L256 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-296.6z',
    ],
  ],
};
const faBroadcastTower = faTowerBroadcast;
const faTruckPickup = {
  prefix: 'fad',
  iconName: 'truck-pickup',
  icon: [
    640,
    512,
    [128763],
    'f63c',
    [
      'M80 400a80 80 0 1 0 160 0A80 80 0 1 0 80 400zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M288 96l0 96 157.4 0L368.6 96 288 96zM418.6 56L527.4 192l48.6 0c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-26.8 0c-18-37.8-56.5-64-101.2-64s-83.2 26.2-101.2 64l-117.6 0c-18-37.8-56.5-64-101.2-64s-83.2 26.2-101.2 64L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l160 0 0-112c0-26.5 21.5-48 48-48l96.6 0c19.4 0 37.8 8.8 50 24z',
    ],
  ],
};
const faBlockQuote = {
  prefix: 'fad',
  iconName: 'block-quote',
  icon: [
    448,
    512,
    [],
    'e0b5',
    [
      'M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM128 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32z',
      'M0 256c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256z',
    ],
  ],
};
const faUpLong = {
  prefix: 'fad',
  iconName: 'up-long',
  icon: [
    320,
    512,
    ['long-arrow-alt-up'],
    'f30c',
    [
      'M96 192c0 96 0 192 0 288c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-160c0-42.6 0-85.2 0-127.8c-42.7-.2-85.3-.2-128-.2z',
      'M313.4 151.5c6.6 7 8.4 17.2 4.6 26s-12.5 14.5-22 14.5l-72 0L96 192l-72 0c-9.6 0-18.2-5.7-22-14.5s-2-19 4.6-26l136-144C147.1 2.7 153.4 0 160 0s12.9 2.7 17.4 7.5l136 144z',
    ],
  ],
};
const faLongArrowAltUp = faUpLong;
const faStop = {
  prefix: 'fad',
  iconName: 'stop',
  icon: [
    384,
    512,
    [9209],
    'f04d',
    ['M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z', ''],
  ],
};
const faCodeMerge = {
  prefix: 'fad',
  iconName: 'code-merge',
  icon: [
    448,
    512,
    [],
    'f387',
    [
      'M48 153.3c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3c1.4 .1 2.8 .3 4.2 .3c1.4 .1 2.8 .1 4.2 .1c11.5 0 22.5-2.4 32.4-6.8C117 201.9 158.1 240 208 240l86.7 0c-2.1 4.9-3.8 10.1-4.9 15.4c-.6 2.7-1 5.4-1.3 8.2c-.1 1.4-.3 2.8-.3 4.2s-.1 2.8-.1 4.2c0 11.4 2.4 22.2 6.7 32L208 304c-36 0-69.3-11.9-96-32l0 86.6c-4.9-2.1-10.1-3.8-15.4-4.9c-2.7-.6-5.4-1-8.2-1.3c-1.4-.1-2.8-.3-4.2-.3s-2.8-.1-4.2-.1c-11.4 0-22.2 2.4-32 6.7l0-205.3z',
      'M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104A80 80 0 1 0 80 0a80 80 0 1 0 0 160zm0 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faMoneyCheckDollarPen = {
  prefix: 'fad',
  iconName: 'money-check-dollar-pen',
  icon: [
    640,
    512,
    ['money-check-edit-alt'],
    'f873',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l266.5 0 6-23.9c2.8-11.3 8.6-21.5 16.8-29.7L534.6 213.1c11.6-11.6 26.3-18.5 41.4-20.5l0-64.6c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm76.1 90.5c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7zM256 208c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z',
      'M557.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71z',
    ],
  ],
};
const faMoneyCheckEditAlt = faMoneyCheckDollarPen;
const faUpFromLine = {
  prefix: 'fad',
  iconName: 'up-from-line',
  icon: [
    384,
    512,
    ['arrow-alt-from-bottom'],
    'f346',
    [
      'M0 448c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
      'M164.7 43.3L41.9 166.1c-6.4 6.4-9.9 15-9.9 24C32 208.8 47.2 224 65.9 224l62.1 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L219.3 43.3C212.1 36.1 202.2 32 192 32s-20.1 4.1-27.3 11.3z',
    ],
  ],
};
const faArrowAltFromBottom = faUpFromLine;
const faUpload = {
  prefix: 'fad',
  iconName: 'upload',
  icon: [
    512,
    512,
    [],
    'f093',
    [
      'M0 416l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-160 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L64 352c-35.3 0-64 28.7-64 64zm456 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M256 416c17.7 0 32-14.3 32-32l0-274.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 224 384c0 17.7 14.3 32 32 32z',
    ],
  ],
};
const faHurricane = {
  prefix: 'fad',
  iconName: 'hurricane',
  icon: [
    384,
    512,
    [],
    'f751',
    [
      'M0 208C0 312.4 77 398.9 177.3 413.7c8.3 1.2 14.7 8.1 14.7 16.5l0 63.3c0 9.3 8 16.7 17.1 15.2C308.3 492.9 384 407 384 303.4C384 199 307 112.5 206.7 97.6c-8.3-1.2-14.7-8.1-14.7-16.5l0-63.3c0-9.3-8-16.7-17.1-15.2C75.7 18.5 0 104.4 0 208zm288 48A96 96 0 1 1 96 256a96 96 0 1 1 192 0z',
      'M192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faGridRound2Plus = {
  prefix: 'fad',
  iconName: 'grid-round-2-plus',
  icon: [
    512,
    512,
    [],
    'e5dc',
    [
      'M224 128A96 96 0 1 1 32 128a96 96 0 1 1 192 0zm0 256A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM480 128a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
      'M408 296c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64z',
    ],
  ],
};
const faPeoplePants = {
  prefix: 'fad',
  iconName: 'people-pants',
  icon: [
    640,
    512,
    [],
    'e219',
    [
      'M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm320 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M59.4 304.5L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9L408 256.9 408 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9z',
    ],
  ],
};
const faMound = {
  prefix: 'fad',
  iconName: 'mound',
  icon: [
    576,
    512,
    [],
    'e52d',
    [
      'M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z',
      '',
    ],
  ],
};
const faWindsock = {
  prefix: 'fad',
  iconName: 'windsock',
  icon: [
    512,
    512,
    [],
    'f777',
    [
      'M64 96l0 48 64 0 0 128-64 0 0 48 64 0 0 8.6c0 18 14.7 32 31.9 32c2.2 0 4.4-.2 6.6-.7l41.5-8.6 0-286.7c-13.8-2.9-27.7-5.8-41.5-8.6c-19.9-4.1-38.5 11-38.5 31.3l0 8.6L64 96zM272 78l0 260c32-6.7 64-13.3 96-20l0-220c-32-6.7-64-13.3-96-20zm160 33.3l0 193.3c18.2-3.8 36.4-7.6 54.5-11.4c14.8-3.1 25.5-16.2 25.5-31.3l0-108c0-15.2-10.6-28.2-25.5-31.3c-18.2-3.8-36.4-7.6-54.5-11.4z',
      'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32L64 32zM208 64.7l0 286.7L272 338l0-260L208 64.7zM368 318l64-13.3 0-193.3L368 98l0 220z',
    ],
  ],
};
const faCircleHalf = {
  prefix: 'fad',
  iconName: 'circle-half',
  icon: [
    512,
    512,
    [],
    'e110',
    [
      'M256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256L256 0z',
      'M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512L256 0z',
    ],
  ],
};
const faBrakeWarning = {
  prefix: 'fad',
  iconName: 'brake-warning',
  icon: [
    640,
    512,
    [],
    'e0c7',
    [
      'M96 256a224 224 0 1 0 448 0A224 224 0 1 0 96 256zm256 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM296 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M91.1 109c7.2-11.1 4-26-7.2-33.2s-26-4-33.2 7.2C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173c7.2 11.1 22 14.4 33.2 7.2s14.4-22 7.2-33.2C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147zM589.3 83c-7.2-11.1-22-14.4-33.2-7.2s-14.4 22-7.2 33.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147c-7.2 11.1-4 26 7.2 33.2s26 4 33.2-7.2C621.4 379.1 640 319.7 640 256s-18.6-123.1-50.7-173zM320 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faToiletPortable = {
  prefix: 'fad',
  iconName: 'toilet-portable',
  icon: [
    320,
    512,
    [],
    'e583',
    [
      'M0 64l24 0 272 0 24 0 0 24 0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 480l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88 0 64zM224 240l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M32 0C14.3 0 0 14.3 0 32L0 64l320 0 0-32c0-17.7-14.3-32-32-32L32 0zM256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z',
    ],
  ],
};
const faCompactDisc = {
  prefix: 'fad',
  iconName: 'compact-disc',
  icon: [
    512,
    512,
    [128191, 128192, 128440],
    'f51f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm64-16c0-45.4 22.3-89.2 54.5-121.5S194.6 64 240 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35 0-71.1 17.5-98.8 45.2S96 205 96 240c0 8.8-7.2 16-16 16s-16-7.2-16-16zm288 16a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
      'M256 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 32a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z',
    ],
  ],
};
const faFileArrowDown = {
  prefix: 'fad',
  iconName: 'file-arrow-down',
  icon: [
    384,
    512,
    ['file-download'],
    'f56d',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 320c0 6.1 2.3 12.3 7 17l72 72c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0c-4.7 4.7-7 10.8-7 17z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L216 232z',
    ],
  ],
};
const faFileDownload = faFileArrowDown;
const faSaxophoneFire = {
  prefix: 'fad',
  iconName: 'saxophone-fire',
  icon: [
    640,
    512,
    ['sax-hot'],
    'f8db',
    [
      'M0 232c0 9.5 5.5 17.7 13.5 21.6L2.7 313C.9 323 0 333.1 0 343.2l0 7C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4L534.4 140.1c6.1-7.7 15.3-12.1 25.1-12.1l64.2 0c9 0 16.3-7.3 16.3-16.3c0-4.9-2.2-9.5-5.9-12.6L609.8 78.8c-11.5-9.6-26-14.8-41-14.8l-30.3 0c-17 0-33.3 6.7-45.3 18.7C478.5 97.5 463.7 112.3 449 127L415 161c-4.7 4.7-9.4 9.4-14.1 14.1L367 209c-4.7 4.7-9.4 9.4-14.1 14.1L319 257c-34.8 34.8-69.6 69.6-104.4 104.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6l0-1.9c0-4.8 1.4-9.6 4.1-13.6L229.3 256l2.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 208c-13.3 0-24 10.7-24 24zM112 368a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32-88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M256 153.6c0 7.6-.7 15.1-2 22.4l-77.6 0c-7.7-23.3-29.5-44.6-41-54.6c-4.3-3.7-10.5-3.7-14.8 0c-11.6 10-33.4 31.3-41 54.6L2 176c-1.3-7.3-2-14.8-2-22.4C0 92.3 50 37.9 85.8 10.1c4-3.1 8.7-4.6 13.4-4.7c6.4-.1 12.8 2.5 17.6 7.4l36.8 36.8 9.1-9.1c9.4-9.4 24.4-10.1 33.8-.8C243.6 86.4 256 128.1 256 153.6zM353 223L319 257l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8zm48-48L367 209l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8zm48-48L415 161l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8zM120 256a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faSaxHot = faSaxophoneFire;
const faCameraWebSlash = {
  prefix: 'fad',
  iconName: 'camera-web-slash',
  icon: [
    640,
    512,
    ['webcam-slash'],
    'f833',
    [
      'M96 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S146 512 160 512l320 0c11.6 0 22.1-6.2 27.7-16L359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9c-88.4 0-160-71.6-160-160c0-.6 0-1.3 0-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224zM143 86.7l50.4 39.5C222.6 88.4 268.5 64 320 64c88.4 0 160 71.6 160 160c0 37.7-13 72.3-34.8 99.6l50.4 39.5C525.9 324.9 544 276.6 544 224C544 100.3 443.7 0 320 0C248 0 183.9 34 143 86.7zm51.5 162.5C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1L194.5 249.2zm24-103.3c12.6 9.9 25.2 19.7 37.8 29.6C270.9 156.4 294 144 320 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.8 0-29.7 7.6-38.5 19.3c46.2 36.2 92.3 72.4 138.5 108.6c17.5-21.9 28-49.7 28-79.9c0-70.7-57.3-128-128-128c-41.3 0-78.1 19.6-101.5 50z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faWebcamSlash = faCameraWebSlash;
const faFolderMedical = {
  prefix: 'fad',
  iconName: 'folder-medical',
  icon: [
    512,
    512,
    [],
    'e18c',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM160 272c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z',
      'M240 192c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faFolderGear = {
  prefix: 'fad',
  iconName: 'folder-gear',
  icon: [
    512,
    512,
    ['folder-cog'],
    'e187',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM135.6 329.1c0-5.2 3-10.2 7.8-13l3-1.7c9.2-5.3 13.7-15.8 13.7-26.4s-4.5-21.1-13.7-26.4l-2.9-1.7c-6.3-3.6-9.5-11.1-6.8-18c2.1-5.5 4.6-10.8 7.4-15.9l2.3-3.9c3.1-5.1 6.5-10 10.2-14.6c4.6-5.7 12.7-6.7 19-3l2.9 1.7c9.2 5.3 20.4 4 29.6-1.3s16.1-14.5 16.1-25.1l0-3.4c0-7.3 4.9-13.8 12.1-14.9c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.2 1.1 12.1 7.6 12.1 14.9l0 3.4c0 10.6 6.9 19.8 16.1 25.1s20.4 6.6 29.6 1.3l2.9-1.7c6.3-3.6 14.4-2.6 19 3c3.7 4.6 7.1 9.5 10.2 14.5l2.3 4c2.8 5.1 5.3 10.4 7.4 15.9c2.6 6.8-.5 14.3-6.8 18l-3 1.7c-9.2 5.3-13.7 15.8-13.7 26.4s4.5 21.1 13.7 26.4l3 1.7c4.8 2.8 7.8 7.8 7.8 13c0 1.7-.3 3.3-.9 5c-2.1 5.5-4.6 10.7-7.4 15.8l-2.4 4.2c-3 5.1-6.4 9.9-10.1 14.5c-4.6 5.7-12.7 6.7-19 3l-2.9-1.7c-9.2-5.3-20.4-4-29.6 1.3s-16.1 14.5-16.1 25.1l0 3.4c0 7.3-4.9 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.2-1.1-12.1-7.6-12.1-14.9l0-3.4c0-10.6-6.9-19.8-16.1-25.1s-20.4-6.6-29.6-1.3l-2.9 1.7c-6.3 3.6-14.4 2.6-19-3c-3.7-4.6-7.1-9.4-10.1-14.5l-2.4-4.1c-2.8-5.1-5.3-10.4-7.4-15.8c-.6-1.6-.9-3.3-.9-5zM216 288a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M375.5 242c2.6 6.8-.5 14.3-6.8 18l-3 1.7c-9.2 5.3-13.7 15.8-13.7 26.4s4.5 21.1 13.7 26.4l3 1.7c6.3 3.6 9.5 11.1 6.8 17.9c-2.1 5.5-4.6 10.7-7.4 15.8l-2.4 4.2c-3 5.1-6.4 9.9-10.1 14.5c-4.6 5.7-12.7 6.7-19 3l-2.9-1.7c-9.2-5.3-20.4-4-29.6 1.3s-16.1 14.5-16.1 25.1l0 3.4c0 7.3-4.9 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.2-1.1-12.1-7.6-12.1-14.9l0-3.4c0-10.6-6.9-19.8-16.1-25.1s-20.4-6.6-29.6-1.3l-2.9 1.7c-6.3 3.6-14.4 2.6-19-3c-3.7-4.6-7.1-9.4-10.1-14.5l-2.4-4.1c-2.8-5.1-5.3-10.4-7.4-15.8c-2.6-6.8 .5-14.3 6.8-17.9l3-1.7c9.2-5.3 13.7-15.8 13.7-26.4s-4.5-21.1-13.7-26.4l-2.9-1.7c-6.3-3.6-9.5-11.1-6.8-18c2.1-5.5 4.6-10.8 7.4-15.9l2.3-3.9c3.1-5.1 6.5-10 10.2-14.6c4.6-5.7 12.7-6.7 19-3l2.9 1.7c9.2 5.3 20.4 4 29.6-1.3s16.1-14.5 16.1-25.1l0-3.4c0-7.3 4.9-13.8 12.1-14.9c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.2 1.1 12.1 7.6 12.1 14.9l0 3.4c0 10.6 6.9 19.8 16.1 25.1s20.4 6.6 29.6 1.3l2.9-1.7c6.3-3.6 14.4-2.6 19 3c3.7 4.6 7.1 9.5 10.2 14.5l2.3 4c2.8 5.1 5.3 10.4 7.4 15.9zM256 328a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
    ],
  ],
};
const faFolderCog = faFolderGear;
const faHandWave = {
  prefix: 'fad',
  iconName: 'hand-wave',
  icon: [
    512,
    512,
    [],
    'e1a7',
    [
      'M41.4 265.4c-12.5 12.5-12.5 32.8 0 45.3l32 32L180.4 449.7l4.9 4.9c22.2 22.2 49.2 36.9 77.6 44.1c17.9 5.2 36.3 7.9 54.9 7.9c41.7 0 83.5-13.4 118.7-40.5c47.6-36.8 75.5-93.5 75.5-153.7L512 136c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 77.7c0 4.7-6 7-9.4 3.7l-192-192C224.4 19.1 216.2 16 208 16s-16.4 3.1-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L312 197.3c5.2 5.2 5.2 13.6 0 18.7s-13.6 5.2-18.7 0L150.6 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L248 261.3c5.2 5.2 5.2 13.6 0 18.7s-13.6 5.2-18.7 0L102.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L184 325.3c5.2 5.2 5.2 13.6 0 18.7s-13.6 5.2-18.7 0l-46.6-46.6c-10.7-10.7-21.4-21.4-32-32c-12.5-12.5-32.8-12.5-45.3 0z',
      'M352.2 82.3c1.3 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1l-1.2-8.5c-5-35.2-32.7-62.9-67.9-67.9L306.3 .2c-8.7-1.2-16.9 4.8-18.1 13.6s4.8 16.9 13.6 18.1l8.5 1.2c21.1 3 37.7 19.6 40.7 40.7l1.2 8.5zM31.8 365.7c-1.2-8.7-9.4-14.8-18.1-13.6S-1.1 361.5 .2 370.3l1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2c8.7 1.3 16.9-4.8 18.1-13.6s-4.8-16.9-13.6-18.1l-8.5-1.2c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5z',
    ],
  ],
};
const faArrowUpArrowDown = {
  prefix: 'fad',
  iconName: 'arrow-up-arrow-down',
  icon: [
    576,
    512,
    ['sort-up-down'],
    'e099',
    [
      'M288 352c0 8.2 3.1 16.4 9.4 22.6l96 96c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l96-96c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-12.5-12.5-32.8-12.5-45.3 0L448 370.7 448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0c-6.2 6.2-9.4 14.4-9.4 22.6z',
      'M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 141.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-306.7L86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z',
    ],
  ],
};
const faSortUpDown = faArrowUpArrowDown;
const faCaravan = {
  prefix: 'fad',
  iconName: 'caravan',
  icon: [
    640,
    512,
    [],
    'f8ff',
    [
      'M64 160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-64zM272 432a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zm48-272c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 96-99.2 0c-7.7-15-17.4-28.7-28.8-40.8L320 160z',
      'M0 112C0 67.8 35.8 32 80 32l336 0c88.4 0 160 71.6 160 160l0 160 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-273.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L80 416c-44.2 0-80-35.8-80-80L0 112zM348.8 352l99.2 0 0-192c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 151.2c11.4 12.1 21.2 25.8 28.8 40.8zM96 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128z',
    ],
  ],
};
const faShieldCat = {
  prefix: 'fad',
  iconName: 'shield-cat',
  icon: [
    512,
    512,
    [],
    'e572',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zm144 14.7c0-5.8 4.7-10.4 10.7-10.4c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4c13.3-17.8 26.7-35.6 40-53.3c2-2.7 5.2-4.3 8.8-4.3c2.9 0 5.5 1.2 7.4 3.1c.9 .9 1.7 2.1 2.2 3.3c.3 .6 .5 1.3 .6 2c.1 .3 .1 .7 .2 1s0 .6 .1 1.1c0 39.2 0 78.4 0 117.9c0 1.6-.1 3.3-.1 4.9c-.1 1.5-.2 3.1-.4 4.7c-.3 3.2-.8 6.4-1.5 9.5c-1.3 6.2-3.2 12.3-5.6 18c-4.9 11.5-11.9 21.8-20.6 30.5C306.5 357.3 282.5 368 256 368c-53 0-96-43-96-96c0-39.2 0-78.4 0-117.6z',
      'M160 272l0-117.6c0-5.8 4.7-10.4 10.4-10.4l.2 0c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3l.2 0c5.8 0 10.4 4.7 10.4 10.4L352 272c0 53-43 96-96 96s-96-43-96-96zm72 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faMessageSlash = {
  prefix: 'fad',
  iconName: 'message-slash',
  icon: [
    640,
    512,
    ['comment-alt-slash'],
    'f4a9',
    [
      'M64 146.4L406.2 416l-32.8 0L249.6 508.8c-2.8 2.1-6.2 3.2-9.6 3.2c-2.4 0-4.9-.6-7.2-1.7c-5.4-2.7-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64l0-205.6zM72.7 31.7C83.8 12.7 104.4 0 128 0L512 0c35.3 0 64 28.7 64 64l0 288c0 21.8-10.9 41-27.5 52.6C389.9 280.3 231.3 156 72.7 31.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faCommentAltSlash = faMessageSlash;
const faBolt = {
  prefix: 'fad',
  iconName: 'bolt',
  icon: [
    448,
    512,
    [9889, 'zap'],
    'f0e7',
    [
      'M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z',
      '',
    ],
  ],
};
const faZap = faBolt;
const faTrashCanCheck = {
  prefix: 'fad',
  iconName: 'trash-can-check',
  icon: [
    448,
    512,
    [],
    'e2a9',
    [
      'M32 96l384 0 0 352c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 96zm79 175c-9.4 9.4-9.4 24.6 0 33.9l64 64c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7L337 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
      'M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM337 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 241z',
    ],
  ],
};
const faGlassWater = {
  prefix: 'fad',
  iconName: 'glass-water',
  icon: [
    384,
    512,
    [],
    'e4f4',
    [
      'M0 32c0 .8 0 1.5 .1 2.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.1-.8 .1-1.5 .1-2.3c0-8.1-3-15.9-8.6-21.8C369.4 3.7 360.9 0 352 0L32 0C23.1 0 14.6 3.7 8.6 10.2C3 16.1 0 23.9 0 32zM66.4 64l251.3 0c-2.2 30.8-4.4 61.7-6.6 92.5c-6.6 92.2-13.2 184.4-19.8 276.7c-.6 8.4-7.6 14.9-16 14.9l-166.6 0c-8.4 0-15.4-6.5-16-14.9C86.1 340.9 79.6 248.7 73 156.5c-2.2-30.8-4.4-61.7-6.6-92.5z',
      'M311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5 92.7 433.1c.6 8.4 7.6 14.9 16 14.9l166.6 0c8.4 0 15.4-6.5 16-14.9L311 156.5z',
    ],
  ],
};
const faOilWell = {
  prefix: 'fad',
  iconName: 'oil-well',
  icon: [
    576,
    512,
    [],
    'e532',
    [
      'M137.3 448l53.1-151.7L265 277l-26.3 75 66.6 0-27.4-78.4L340 257.5 406.7 448l-67.8 0-11.2-32-111.4 0-11.2 32-67.8 0zm90.9-259.6l13.6-39c4.5-12.8 16.6-21.4 30.2-21.4s25.7 8.6 30.2 21.4l6.3 18.1c-26.8 6.9-53.6 13.9-80.4 20.8z',
      'M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L96 222.6 96 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 264-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 448l0-159.2 337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3z',
    ],
  ],
};
const faTableCellsColumnUnlock = {
  prefix: 'fad',
  iconName: 'table-cells-column-unlock',
  icon: [
    640,
    512,
    [],
    'e690',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm208 0l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM360 96l0 64 88 0 0-64-88 0z',
      'M528 240c-17.7 0-32 14.3-32 32l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faPersonSimple = {
  prefix: 'fad',
  iconName: 'person-simple',
  icon: [
    256,
    512,
    [],
    'e220',
    [
      'M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64z',
      'M105.6 160c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0z',
    ],
  ],
};
const faArrowTurnLeftUp = {
  prefix: 'fad',
  iconName: 'arrow-turn-left-up',
  icon: [
    384,
    512,
    [],
    'e634',
    [
      'M160 112l0 306.7c0 53 43 96 96 96l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L224 112 192 80l-32 32z',
      'M342.6 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 77.3 297.4 182.6c12.5 12.5 32.8 12.5 45.3 0z',
    ],
  ],
};
const faVault = {
  prefix: 'fad',
  iconName: 'vault',
  icon: [
    576,
    512,
    [],
    'e2c5',
    [
      'M0 64L0 416c0 35.3 28.7 64 64 64l16 0 16 32 64 0 16-32 224 0 16 32 64 0 16-32 16 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM384 240A160 160 0 1 1 64 240a160 160 0 1 1 320 0zm32-64c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3L480 336c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-114.7c-18.6-6.6-32-24.4-32-45.3z',
      'M304 240a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm448-64c0 20.9-13.4 38.7-32 45.3L480 336c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-114.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48z',
    ],
  ],
};
const faMars = {
  prefix: 'fad',
  iconName: 'mars',
  icon: [
    448,
    512,
    [9794],
    'f222',
    [
      'M96 304a80 80 0 1 0 160 0A80 80 0 1 0 96 304z',
      'M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8l112 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80s0 0 0 0s0 0 0 0s0 0 0 0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z',
    ],
  ],
};
const faToilet = {
  prefix: 'fad',
  iconName: 'toilet',
  icon: [
    448,
    512,
    [128701],
    'f7d8',
    [
      'M0 24C0 37.3 10.7 48 24 48l8 0 384 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24zM96 96c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M416 196.9c1.9 1.4 3.8 2.9 5.6 4.4C437.1 214.5 448 232.9 448 256c0 46.9-14.3 84.1-37 112.5c-14.2 17.7-31.1 31.3-48.5 41.8l19.8 59.5c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L96 512c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l19.8-59.5C68.1 399.8 51.2 386.2 37 368.5C14.3 340.1 0 302.9 0 256c0-23.1 10.9-41.5 26.4-54.6c1.8-1.5 3.7-3 5.6-4.4L32 48l384 0 0 148.9zM384 256c0 0 0-.1 0-.1c0-1 0-2.5-3.8-5.8c-4.8-4.1-14-9-29.3-13.4C320.5 228 276.1 224 224 224s-96.5 4-126.9 12.8c-15.3 4.4-24.5 9.3-29.3 13.4C64 253.4 64 255 64 255.9c0 0 0 .1 0 .1l0 .3c0 1 .3 2.6 3.8 5.6c4.8 4.1 14 9 29.3 13.4C127.5 284 171.9 288 224 288s96.5-4 126.9-12.8c15.3-4.4 24.5-9.3 29.3-13.4c3.5-3 3.8-4.6 3.8-5.6l0-.3zM112 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faPlaneCircleXmark = {
  prefix: 'fad',
  iconName: 'plane-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e557',
    [
      'M0 297.3l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faYenSign = {
  prefix: 'fad',
  iconName: 'yen-sign',
  icon: [
    320,
    512,
    [165, 'cny', 'jpy', 'rmb', 'yen'],
    'f157',
    [
      'M16 256c0 17.7 14.3 32 32 32l80 0c0-7.4 0-14.9 0-22.3c-9.3-13.9-18.5-27.8-27.8-41.7L48 224c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32l80 0c0-21.3 0-42.7 0-64l-80 0c-17.7 0-32 14.3-32 32zm176-86.3l0 22.3 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.2 0L192 265.7zm0 54.3l0 64 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0z',
      'M58.6 46.3C48.8 31.5 29 27.6 14.2 37.4S-4.4 67 5.4 81.8L128 265.7 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-182.3L314.6 81.8c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.3z',
    ],
  ],
};
const faCny = faYenSign;
const faJpy = faYenSign;
const faRmb = faYenSign;
const faYen = faYenSign;
const faGearCode = {
  prefix: 'fad',
  iconName: 'gear-code',
  icon: [
    512,
    512,
    [],
    'e5e8',
    [
      'M14.7 174.1c0 6.4 2.8 12.6 7.7 17.1l30.9 28.1c7.7 7.1 11.4 17.5 10.9 27.9c-.1 2.9-.2 5.8-.2 8.8s.1 5.9 .2 8.8c.5 10.5-3.1 20.9-10.9 27.9L22.4 320.8c-6.9 6.2-9.6 15.9-6.4 24.6c4.4 11.9 9.7 23.3 15.8 34.3l4.7 8.1c6.6 11 14 21.4 22.1 31.2c5.9 7.2 15.7 9.6 24.5 6.8l39.7-12.6c10-3.2 20.8-1.1 29.7 4.6c4.9 3.1 9.9 6.1 15.1 8.7c9.3 4.8 16.5 13.2 18.8 23.4l8.9 40.7c2 9.1 9 16.3 18.2 17.8c13.8 2.3 28 3.5 42.5 3.5s28.7-1.2 42.5-3.5c9.2-1.5 16.2-8.7 18.2-17.8l8.9-40.7c2.2-10.2 9.4-18.6 18.8-23.4c5.2-2.7 10.2-5.6 15.1-8.7c8.8-5.7 19.7-7.7 29.7-4.6l39.7 12.6c8.8 2.8 18.6 .3 24.5-6.8c8.1-9.8 15.5-20.2 22.1-31.2l4.7-8.1c6.1-11 11.4-22.4 15.8-34.3c3.2-8.7 .5-18.4-6.4-24.6l-30.9-28.1c-7.7-7.1-11.4-17.5-10.9-27.9c.1-2.9 .2-5.8 .2-8.8s-.1-5.9-.2-8.8c-.5-10.5 3.1-20.9 10.9-27.9l30.9-28.1c6.9-6.2 9.6-15.9 6.4-24.6c-4.4-11.9-9.7-23.3-15.8-34.3l-4.7-8.1c-6.6-11-14-21.4-22.1-31.2c-5.9-7.2-15.7-9.6-24.5-6.8L389.1 98.8c-10 3.2-20.8 1.1-29.7-4.6c-4.9-3.1-9.9-6.1-15.1-8.7c-9.3-4.8-16.5-13.2-18.8-23.4l-8.9-40.7c-2-9.1-9-16.3-18.2-17.8C284.7 1.2 270.5 0 256 0s-28.7 1.2-42.5 3.5c-9.2 1.5-16.2 8.7-18.2 17.8l-8.9 40.7c-2.2 10.2-9.5 18.6-18.8 23.4c-5.2 2.7-10.2 5.6-15.1 8.7c-8.8 5.7-19.7 7.7-29.7 4.6L83.1 86.1c-8.8-2.8-18.6-.3-24.5 6.8c-8.1 9.8-15.5 20.2-22.1 31.2l-4.7 8.1c-6.1 11-11.4 22.4-15.8 34.3c-.9 2.5-1.4 5-1.4 7.5zm110 70.6c13.3-13.3 26.7-26.7 40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-9.6 9.6-19.1 19.1-28.7 28.7c9.6 9.6 19.1 19.1 28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-13.3-13.3-26.7-26.7-40-40c-6.2-6.2-6.2-16.4 0-22.6zm99.5 104.7c10.7-64 21.3-128 32-192c1.3-7.8 8.1-13.4 15.8-13.4c.9 0 1.8 .1 2.7 .2c8.7 1.5 14.6 9.7 13.2 18.4c-10.7 64-21.3 128-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4zM324.7 204.7c6.2-6.2 16.4-6.2 22.6 0c13.3 13.3 26.7 26.7 40 40c1.6 1.6 2.7 3.4 3.5 5.3c.4 1 .7 2 .9 3c.1 .7 .2 1.5 .2 1.5c.1 .8 .1 .8 .1 1.7c0 1-.1 1.3-.1 1.5c0 .5-.1 1-.2 1.5c-.2 1-.5 2-.9 3c-.8 1.9-2 3.7-3.5 5.3c-13.3 13.3-26.7 26.7-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c9.6-9.6 19.1-19.1 28.7-28.7c-9.6-9.6-19.1-19.1-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z',
      'M274.6 144.2c8.7 1.5 14.6 9.7 13.2 18.4l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2zm-87.3 60.5c6.2 6.2 6.2 16.4 0 22.6L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0zm137.4 0c6.2-6.2 16.4-6.2 22.6 0l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z',
    ],
  ],
};
const faNotes = {
  prefix: 'fad',
  iconName: 'notes',
  icon: [
    512,
    512,
    [],
    'e202',
    [
      'M96 96l0 256c0 35.3 28.7 64 64 64l192 0 0-96c0-17.7 14.3-32 32-32l96 0 0-192c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64z',
      'M296 464c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0C60.9 512 0 451.1 0 376L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l160 0zm56-48l0-96c0-17.7 14.3-32 32-32l96 0L352 416z',
    ],
  ],
};
const faRubleSign = {
  prefix: 'fad',
  iconName: 'ruble-sign',
  icon: [
    384,
    512,
    [8381, 'rouble', 'rub', 'ruble'],
    'f158',
    [
      'M0 384c0 17.7 14.3 32 32 32l32 0 0-64-32 0c-17.7 0-32 14.3-32 32zm128-32l0 64 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0z',
      'M64 64c0-17.7 14.3-32 32-32l144 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-112 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0L64 64zm64 192l112 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L128 96l0 160z',
    ],
  ],
};
const faRouble = faRubleSign;
const faRub = faRubleSign;
const faRuble = faRubleSign;
const faTrashUndo = {
  prefix: 'fad',
  iconName: 'trash-undo',
  icon: [
    448,
    512,
    ['trash-arrow-turn-left'],
    'f895',
    [
      'M32 96l384 0L394.6 466.8c-1.5 25.4-22.5 45.2-47.9 45.2l-245.4 0c-25.4 0-46.5-19.8-47.9-45.2L32 96zM96 256c0 6.8 2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L182.5 280l57.5 0c22.1 0 40 17.9 40 40l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-48.6-39.4-88-88-88l-57.5 0 33.5-30.2c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8z',
      'M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zm54.1 167.9c8.9 9.9 8.1 25-1.8 33.9L182.5 232l57.5 0c48.6 0 88 39.4 88 88l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-22.1-17.9-40-40-40l-57.5 0 33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z',
    ],
  ],
};
const faTrashArrowTurnLeft = faTrashUndo;
const faChampagneGlass = {
  prefix: 'fad',
  iconName: 'champagne-glass',
  icon: [
    320,
    512,
    ['glass-champagne'],
    'f79e',
    [
      'M32.2 224.5c0 58.6 40.2 109.2 95.8 123.5l0 100-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-100c55.6-14.3 95.8-64.9 95.8-123.5c0-5.4-.3-10.9-1.1-16.4l-23-180.1C261.7 12 248.1 0 232 0L88 0C71.9 0 58.3 12 56.3 27.9L33.2 208c-.7 5.5-1.1 11-1.1 16.4zm64.5-8.3c3.8-29.4 7.5-58.7 11.3-88.1l8.2-64 87.7 0c2.7 21.3 5.5 42.7 8.2 64c3.8 29.4 7.5 58.8 11.3 88.1c4.9 38.1-24.8 71.9-63.3 71.9s-68.1-33.7-63.3-71.9z',
      'M212 128l-104 0L96.7 216.1C91.9 254.3 121.6 288 160 288s68.1-33.7 63.3-71.9L212 128z',
    ],
  ],
};
const faGlassChampagne = faChampagneGlass;
const faObjectsAlignCenterHorizontal = {
  prefix: 'fad',
  iconName: 'objects-align-center-horizontal',
  icon: [
    512,
    512,
    [],
    'e3bc',
    [
      'M32 112l0 64c0 26.5 21.5 48 48 48l152 0 48 0 152 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L280 64l-48 0L80 64c-26.5 0-48 21.5-48 48zM96 336l0 64c0 26.5 21.5 48 48 48l88 0 48 0 88 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-88 0-48 0-88 0c-26.5 0-48 21.5-48 48z',
      'M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40-48 0 0-40zm0 264l0-64 48 0 0 64-48 0zm0 160l48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40z',
    ],
  ],
};
const faSun = {
  prefix: 'fad',
  iconName: 'sun',
  icon: [
    512,
    512,
    [9728],
    'f185',
    [
      'M0 355.4c0 2.1 .4 4.2 1.2 6.1c2.1 5 6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9c-2-.8-4-1.2-6.1-1.2c-3.2 0-6.4 1-9.1 2.8L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3C1 349 0 352.2 0 355.4zM384 256a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z',
      'M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z',
    ],
  ],
};
const faTrashCanSlash = {
  prefix: 'fad',
  iconName: 'trash-can-slash',
  icon: [
    640,
    512,
    ['trash-alt-slash'],
    'e2ad',
    [
      'M98.4 51.8C117.2 66.5 136 81.3 154.8 96L512 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C403.4 6.8 392.3 0 380.2 0L259.8 0c-12.1 0-23.2 6.8-28.6 17.7L224 32l-96 0c-13.4 0-24.8 8.2-29.6 19.8zm29.6 145L128 448c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8L431.5 436c-1.8 6.9-8 12-15.5 12c-8.8 0-16-7.2-16-16l0-20.8-64-50.4 0 71.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96.5-64-50.4L240 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-172.1-80-63zM195.6 128c36.1 28.3 72.3 56.6 108.4 85l0-5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 30c21.3 16.7 42.7 33.4 64 50.2l0-80.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 105.3c26.7 20.9 53.3 41.8 80 62.7l0-248-316.4 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTrashAltSlash = faTrashCanSlash;
const faScreenUsers = {
  prefix: 'fad',
  iconName: 'screen-users',
  icon: [
    640,
    512,
    ['users-class'],
    'f63d',
    [
      'M32 64C32 28.7 60.7 0 96 0L544 0c35.3 0 64 28.7 64 64l0 184.4c-17-15.2-39.4-24.4-64-24.4l0-160L96 64l0 160c-24.6 0-47 9.2-64 24.4L32 64z',
      'M96 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm256-32a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm320-96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM448 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64z',
    ],
  ],
};
const faUsersClass = faScreenUsers;
const faGuitar = {
  prefix: 'fad',
  iconName: 'guitar',
  icon: [
    512,
    512,
    [],
    'f7a6',
    [
      'M28.8 283.6C-16 328.4-7.6 409.4 47.5 464.5C78.8 495.8 118.4 512 155 512c27.9 0 54-9.4 73.4-28.8c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c16-16 23.7-37.7 23.7-61c0-23-7.5-47.6-22.2-70c-24.6 24.6-49.3 49.3-73.9 73.9c0 .9 .1 1.8 .1 2.7c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.9 0 1.8 0 2.7 .1c24.6-24.6 49.3-49.3 73.9-73.9c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6z',
      'M431 7c9.4-9.4 24.6-9.4 33.9 0l40 40c9.4 9.4 9.4 24.6 0 33.9l-48 48c-2.4 2.4-5.3 4.3-8.5 5.5l-41 15.4L255.9 301.3c-1.3-24.4-20.9-43.9-45.3-45.3L362.1 104.6l15.4-41c1.2-3.2 3.1-6.1 5.5-8.5L431 7z',
    ],
  ],
};
const faSquareArrowLeft = {
  prefix: 'fad',
  iconName: 'square-arrow-left',
  icon: [
    448,
    512,
    ['arrow-square-left'],
    'f33a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM80 256c0-6.1 2.3-12.3 7-17L199 127c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L87 273c-4.7-4.7-7-10.8-7-17z',
      'M87 273c-9.4-9.4-9.4-24.6 0-33.9L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273z',
    ],
  ],
};
const faArrowSquareLeft = faSquareArrowLeft;
const faSquare8 = {
  prefix: 'fad',
  iconName: 'square-8',
  icon: [
    448,
    512,
    [],
    'e25d',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 304c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62zm48 0c0-17.7 14.3-32 32-32l8 0 16 0 8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32zm16-104c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24c0 13.2-10.7 24-24 24l-16 0c-13.2 0-24-10.8-24-24z',
      'M304 200c0-39.8-32.2-72-72-72l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42zm-72 72l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c0 0 0 0 0 0l16 0c0 0 0 0 0 0zm0-48L216 224c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
    ],
  ],
};
const faFaceSmileHearts = {
  prefix: 'fad',
  iconName: 'face-smile-hearts',
  icon: [
    640,
    512,
    [],
    'e390',
    [
      'M64 256c0 25.7 3.8 50.5 10.8 73.8c1.8 1.1 3.5 2.2 5.2 3.4c27.7-19.9 66.4-17.3 91.3 7.7c27.6 27.7 27.6 72.6 0 100.4l-13.1 13.1C202.4 490.4 258.7 512 320 512c53.3 0 102.8-16.3 143.8-44.2c-22.6-27.9-21-68.9 4.9-94.9c23-23.1 57.8-27 84.8-11.8C568 329 576 293.4 576 256c0-34-6.6-66.4-18.6-96.1c-12.1-.6-24-5.6-33.2-14.9L468.7 89.2c-15-15.1-21.8-35.2-20.5-54.9C410.5 12.5 366.7 0 320 0C178.6 0 64 114.6 64 256zm115.2-41.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4zm24.7 132.1c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C246 346.2 276.6 368 320 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C413.8 372.1 375.1 400 320 400s-93.8-27.9-116.1-53.5zM339.2 214.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M573.7 11.5L560 25.3 546.3 11.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm160 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM628.6 395.5c-15.2-15.3-39.8-15.3-54.9 0L560 409.3l-13.7-13.8c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2zm-534.9-32L80 377.3 66.3 363.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0z',
    ],
  ],
};
const faBracketsSquare = {
  prefix: 'fad',
  iconName: 'brackets-square',
  icon: [
    448,
    512,
    ['brackets'],
    'f7e9',
    [
      'M288 64c0 17.7 14.3 32 32 32l64 0 0 320-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-64 0c-17.7 0-32 14.3-32 32z',
      'M0 96C0 60.7 28.7 32 64 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 96l0 320 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-35.3 0-64-28.7-64-64L0 96z',
    ],
  ],
};
const faBrackets = faBracketsSquare;
const faLaptopArrowDown = {
  prefix: 'fad',
  iconName: 'laptop-arrow-down',
  icon: [
    640,
    512,
    [],
    'e1c6',
    [
      'M0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384C8.6 384 0 392.6 0 403.2zM64 96l0 256 64 0 0-256 168 0 0-64L128 32C92.7 32 64 60.7 64 96zM344 32l0 64 168 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L344 32z',
      'M296 96L128 96l0 256 384 0 0-256L344 96l0 110.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L296 96z',
    ],
  ],
};
const faHockeyStickPuck = {
  prefix: 'fad',
  iconName: 'hockey-stick-puck',
  icon: [
    640,
    512,
    [],
    'e3ae',
    [
      'M0 384l0 96c0 17.7 14.3 32 32 32l32 0 0-160-32 0c-17.7 0-32 14.3-32 32zm96-32l0 128 0 32 32 0 32 0 44.2 0c24.2 0 46.4-13.7 57.2-35.4L476.6 46.3c7.9-15.8 1.5-35-14.3-42.9C457.7 1.1 452.8 0 448 0c-11.7 0-23 6.5-28.6 17.7L252.2 352 96 352z',
      'M96 352l-32 0 0 160 32 0 0-160zm320 64c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-192 0z',
    ],
  ],
};
const faHouseTree = {
  prefix: 'fad',
  iconName: 'house-tree',
  icon: [
    640,
    512,
    [],
    'e1b3',
    [
      'M282.9 119.9l107.2 98.3c16.5 15.2 25.9 36.5 25.9 59L416 464c0 18-6 34.6-16 48l208 0c12.3 0 23.5-7 28.8-18.1s3.8-24.2-3.9-33.9L546.6 352l29.4 0c12.3 0 23.5-7 28.8-18.1s3.8-24.2-3.9-33.9L514.6 192l29.4 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128C432.4 3.1 424.2 0 416 0s-16.4 3.1-22.6 9.4L282.9 119.9z',
      'M0 464L0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4L384 464c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48zM168 272c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z',
    ],
  ],
};
const faSignalFair = {
  prefix: 'fad',
  iconName: 'signal-fair',
  icon: [
    640,
    512,
    ['signal-2'],
    'f68d',
    [
      'M288 224l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-17.7-14.3-32-32-32s-32 14.3-32 32zM544 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64z',
    ],
  ],
};
const faSignal2 = faSignalFair;
const faFaceLaughWink = {
  prefix: 'fad',
  iconName: 'face-laugh-wink',
  icon: [
    512,
    512,
    ['laugh-wink'],
    'f59c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 58.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm130.8 6.4c30.4-40.5 91.2-40.5 121.6 0c2.2 2.9 3.2 6.2 3.2 9.6c0 4.9-2.2 9.7-6.4 12.8c-7.1 5.3-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M176.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm124.4-6.4c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z',
    ],
  ],
};
const faLaughWink = faFaceLaughWink;
const faCircleDollar = {
  prefix: 'fad',
  iconName: 'circle-dollar',
  icon: [
    512,
    512,
    ['dollar-circle', 'usd-circle'],
    'f2e8',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm168 80c0-2.5 .4-5 1.2-7.5c4.2-12.6 17.7-19.4 30.3-15.3c2.8 .9 5.6 1.9 8.4 2.8c12.6 4.3 25.4 8.6 38.3 10.6c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-11.2-7.7-25.1-11.4-38.4-15c-2.5-.7-5-1.3-7.5-2.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.5-24.3 23.3-40.4 43.3-49c6.1-2.6 12.6-4.7 19.5-6.3l0-17.9c0-13.3 10.7-24 24-24s24 10.7 24 24l0 15.8c10.8 1.3 21.6 4.4 32.2 7.4c2.1 .6 4.1 1.2 6.2 1.7c12.8 3.5 20.3 16.8 16.8 29.5s-16.8 20.3-29.5 16.7c-1.7-.5-3.4-1-5.2-1.4c-7.8-2.2-15.6-4.4-23.5-5.9c-14.6-2.8-31.6-1.5-45.4 4.4c-12.3 5.3-22.3 18.2-8.4 27.1c10.9 7 24.2 10.6 36.8 14c2.6 .7 5.2 1.4 7.8 2.1c17.3 4.9 39.5 11.2 56.1 22.6c21.6 14.8 31.7 38.8 26.9 64.6c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9l0 16.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19.3c-16.1-3.6-31.9-8.8-47.5-13.9C174.4 355.5 168 346.1 168 336z',
      'M256 96c13.3 0 24 10.7 24 24v15.8c12.9 1.6 25.8 5.6 38.4 9.1c12.8 3.5 20.3 16.8 16.8 29.5s-16.8 20.3-29.5 16.7c-9.5-2.6-19-5.5-28.7-7.3c-14.6-2.8-31.6-1.5-45.4 4.4c-12.3 5.3-22.3 18.2-8.4 27.1c13.2 8.4 29.7 11.9 44.6 16.1c17.3 4.9 39.5 11.2 56.1 22.6c21.6 14.8 31.7 38.8 26.9 64.6c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9l0 16.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19.3c-16.1-3.6-31.9-8.8-47.5-13.9c-12.6-4.2-19.4-17.7-15.3-30.3s17.7-19.4 30.3-15.3c15.2 5 30.9 11 46.7 13.4c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-13.4-9.1-30.5-12.7-45.9-17.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.5-24.3 23.3-40.4 43.3-49c6.1-2.6 12.6-4.7 19.5-6.3V120c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faDollarCircle = faCircleDollar;
const faUsdCircle = faCircleDollar;
const faHorseHead = {
  prefix: 'fad',
  iconName: 'horse-head',
  icon: [
    640,
    512,
    [],
    'f7ab',
    [
      'M211.3 312c24 41.5 68.3 70 119.3 71.9c-7.9-11.9-15.9-23.8-23.8-35.8c-28.9-7.8-53.1-26.8-67.8-52.2c-.4-.6-.8-1.3-1.2-1.8s-.9-1.1-1.4-1.6c-1-1-2.1-1.8-3.3-2.5s-2.5-1.2-3.8-1.5s-2.7-.5-4.1-.5c-2.7 0-5.5 .7-8 2.2c-7.7 4.4-10.3 14.2-5.8 21.9z',
      'M64 464l0-147.1c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1l-3.4 0c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4c0 0 0 0-.1 0c0 0 0 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3c0 0 0 0 0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8L112 512c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faArrowsRepeat = {
  prefix: 'fad',
  iconName: 'arrows-repeat',
  icon: [
    512,
    512,
    ['repeat-alt'],
    'f364',
    [
      'M73.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l96 96c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c12.5-12.5 12.5-32.8 0-45.3L173.3 416l173.6 0c74.2 0 140.1-47.5 163.6-117.9c1.1-3.4 1.7-6.8 1.7-10.1c0-13.4-8.5-25.9-21.9-30.4c-3.4-1.1-6.8-1.7-10.1-1.7c-13.4 0-25.9 8.5-30.4 21.9C434.9 322.1 393.5 352 346.8 352l-173.6 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96z',
      'M21.9 254.4C5.1 248.8-3.9 230.6 1.6 213.9C25.1 143.5 91 96 165.2 96l173.6 0L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160l-173.6 0c-46.7 0-88.1 29.9-102.8 74.1c-5.6 16.8-23.7 25.8-40.5 20.2z',
    ],
  ],
};
const faRepeatAlt = faArrowsRepeat;
const faBoreHole = {
  prefix: 'fad',
  iconName: 'bore-hole',
  icon: [
    512,
    512,
    [],
    'e4c3',
    [
      'M0 176L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-80 0c-17.7 0-32 14.3-32 32l0 192c0 53-43 96-96 96s-96-43-96-96l0-192c0-17.7-14.3-32-32-32l-80 0c-26.5 0-48 21.5-48 48z',
      'M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 264.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L288 32z',
    ],
  ],
};
const faIndustry = {
  prefix: 'fad',
  iconName: 'industry',
  icon: [
    576,
    512,
    [],
    'f275',
    [
      'M32 64l0 240 0 48 0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-128 0-148.4c-64 36.6-128 73.1-192 109.7l0-50 0-5.3 0-54.4c-64 36.6-128 73.1-192 109.7l0-50 0-5.3L160 64c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64z',
      'M372.8 116.1c6.6 11.5 2.6 26.2-8.9 32.7L160 265.4l0-55.3L340.1 107.2c11.5-6.6 26.2-2.6 32.7 8.9zm192 0c6.6 11.5 2.6 26.2-8.9 32.7L352 265.4l0-55.3L532.1 107.2c11.5-6.6 26.2-2.6 32.7 8.9z',
    ],
  ],
};
const faImagePolaroid = {
  prefix: 'fad',
  iconName: 'image-polaroid',
  icon: [
    448,
    512,
    [],
    'f8c4',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 32c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-192z',
      'M64 128c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-192zm184 32c-5.3 0-10.2 2.6-13.2 6.9l-52.4 76.3-9.6-12.8c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-48 64c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8l48 0 48 0 40 0 88 0c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faWaveTriangle = {
  prefix: 'fad',
  iconName: 'wave-triangle',
  icon: [
    640,
    512,
    [],
    'f89a',
    [
      'M176 32c10.1 0 19.6 4.7 25.6 12.8L464 394.7 582.4 236.8c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-144 192c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L176 117.3 57.6 275.2c-10.6 14.1-30.7 17-44.8 6.4s-17-30.7-6.4-44.8l144-192c6-8.1 15.5-12.8 25.6-12.8z',
      '',
    ],
  ],
};
const faTurnLeftDown = {
  prefix: 'fad',
  iconName: 'turn-left-down',
  icon: [
    384,
    512,
    [],
    'e637',
    [
      'M152 128l0 192 96 0 0-192c0-17.7 14.3-32 32-32l80 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L280 0C209.3 0 152 57.3 152 128z',
      'M46.5 360.5c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5l272 0c9.6 0 18.2 5.7 22 14.5s2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144z',
    ],
  ],
};
const faPersonRunningFast = {
  prefix: 'fad',
  iconName: 'person-running-fast',
  icon: [
    512,
    512,
    [],
    'e5ff',
    [
      'M0 111.8c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zM96 384c0 17.7 14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5l24.6-55.4c-1.9-1.2-3.8-2.4-5.7-3.6c-25.1-15.7-36.1-46.5-26.8-74.5c2.8-8.5 5.7-17 8.5-25.6L187.2 352 128 352c-17.7 0-32 14.3-32 32z',
      'M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM259.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C198.4 108.3 228.2 96 259.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7l21.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-21.3 0c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L334 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L382.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3z',
    ],
  ],
};
const faCircleDown = {
  prefix: 'fad',
  iconName: 'circle-down',
  icon: [
    512,
    512,
    [61466, 'arrow-alt-circle-down'],
    'f358',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 22.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3c-35.7 33.3-71.4 66.6-107.1 99.9c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3z',
      'M242.2 394.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5z',
    ],
  ],
};
const faArrowAltCircleDown = faCircleDown;
const faGrill = {
  prefix: 'fad',
  iconName: 'grill',
  icon: [
    448,
    512,
    [],
    'e5a3',
    [
      'M106.1 352.8L129.2 299c14.4 6.7 29.7 12 45.6 15.6L151.8 368l144.3 0-22.9-53.4c15.9-3.6 31.1-8.8 45.6-15.6l63.2 147.5c1.3 3.1 1.9 6.3 1.9 9.4c0 9.3-5.5 18.2-14.6 22.1c-3.1 1.3-6.3 1.9-9.4 1.9c-9.3 0-18.2-5.5-22.1-14.6L316.7 416 160 416c0-1 0-2-.1-3s-.1-2-.2-3c-.2-1.9-.4-3.9-.8-5.8c-.7-3.8-1.7-7.5-3.1-11c-2.7-7-6.5-13.5-11.4-19.1s-10.6-10.4-17.1-14c-3.2-1.8-6.6-3.4-10.2-4.6c-1.8-.6-3.6-1.2-5.5-1.6c-.9-.2-1.8-.4-2.8-.7c-.9-.2-1.7-.3-2.8-.5z',
      'M40 32C17.9 32 0 49.9 0 72L0 96C0 219.7 100.3 320 224 320s224-100.3 224-224l0-24c0-22.1-17.9-40-40-40L40 32zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 32 416a64 64 0 1 0 128 0z',
    ],
  ],
};
const faArrowsTurnToDots = {
  prefix: 'fad',
  iconName: 'arrows-turn-to-dots',
  icon: [
    512,
    512,
    [],
    'e4c1',
    [
      'M0 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-17.7 14.3-32 32-32l146.7 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L242.7 352 96 352c-53 0-96 43-96 96zm384-64a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z',
    ],
  ],
};
const faChartMixed = {
  prefix: 'fad',
  iconName: 'chart-mixed',
  icon: [
    512,
    512,
    ['analytics'],
    'f643',
    [
      'M32 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 64l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-64l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M505 44c11 13.8 8.8 33.9-5 45L340 217c-11.4 9.1-27.5 9.4-39.2 .6L192.6 136.5 52 249c-13.8 11-33.9 8.8-45-5s-8.8-33.9 5-45L172 71c11.4-9.1 27.5-9.4 39.2-.6l108.2 81.1L460 39c13.8-11 33.9-8.8 45 5z',
    ],
  ],
};
const faAnalytics = faChartMixed;
const faFlorinSign = {
  prefix: 'fad',
  iconName: 'florin-sign',
  icon: [
    384,
    512,
    [],
    'e184',
    [
      'M32 256c0 17.7 14.3 32 32 32l80 0c8.9-21.3 17.8-42.7 26.7-64L64 224c-17.7 0-32 14.3-32 32zm181.3 32L320 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0-26.7 64z',
      'M226.1 91.1C241 55.3 275.9 32 314.7 32L352 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-37.3 0c-12.9 0-24.6 7.8-29.5 19.7L157.9 420.9C143 456.7 108.1 480 69.3 480L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l37.3 0c12.9 0 24.6-7.8 29.5-19.7L226.1 91.1z',
    ],
  ],
};
const faArrowDownShortWide = {
  prefix: 'fad',
  iconName: 'arrow-down-short-wide',
  icon: [
    576,
    512,
    ['sort-amount-desc', 'sort-amount-down-alt'],
    'f884',
    [
      'M288 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32z',
      'M128 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L160 365.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L63.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C110.5 476.2 119 480 128 480z',
    ],
  ],
};
const faSortAmountDesc = faArrowDownShortWide;
const faSortAmountDownAlt = faArrowDownShortWide;
const faLessThan = {
  prefix: 'fad',
  iconName: 'less-than',
  icon: [
    384,
    512,
    [62774],
    '3c',
    [
      'M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z',
      '',
    ],
  ],
};
const faDisplayCode = {
  prefix: 'fad',
  iconName: 'display-code',
  icon: [
    576,
    512,
    ['desktop-code'],
    'e165',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0 96 0 176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 0l448 0 0 288L64 352 64 64z',
      'M64 64l448 0 0 288L64 352 64 64zM346.7 448l69.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416l96 0 10.7 32zM249 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM361 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z',
    ],
  ],
};
const faDesktopCode = faDisplayCode;
const faFaceDrooling = {
  prefix: 'fad',
  iconName: 'face-drooling',
  icon: [
    512,
    512,
    [],
    'e372',
    [
      'M0 256C0 397.4 114.6 512 256 512c33.9 0 66.4-6.6 96-18.6l0-122.4c-9.7 6.4-20.3 12.2-32 16.9l0 60.2c0 8.8-7.2 16-16 16c-.6 0-1.1 0-1.6-.1s-1.1-.1-1.6-.2c-1-.2-2-.5-3-.9c-1.9-.8-3.6-2-5.1-3.4s-2.6-3.2-3.4-5.1c-.2-.5-.4-1-.5-1.5c-.2-.5-.3-1-.4-1.5c-.1-.5-.2-1.1-.2-1.6c-.1-.6-.1-1.1-.1-1.7c0-17 0-33.9 0-50.9c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-3.8 4.7-7.9 9.5-12.5 14.2l0 133.6c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256zm112.8-53.1c3.4-10.2 11.1-24.6 23.8-36.5C149.5 154.2 167.9 144 192 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-14.3 0-25.2 5.8-33.4 13.6c-8.4 8-13.5 17.7-15.4 23.5c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2zm191.5-46.2c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c24.1 0 42.5 10.2 55.4 22.4c12.6 12 20.4 26.3 23.8 36.5c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1c-1.9-5.8-7-15.4-15.4-23.5c-8.2-7.8-19-13.6-33.4-13.6c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.7c0-.5 0-1 .1-1.6s.1-1.1 .2-1.6z',
      'M158.6 189.6c8.2-7.8 19.1-13.6 33.4-13.6c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.1 0-42.5 10.2-55.4 22.4c-12.6 12-20.4 26.3-23.8 36.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1c1.9-5.8 7-15.4 15.4-23.5zm194.8 0c8.4 8 13.5 17.7 15.4 23.5c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2c-3.4-10.2-11.1-24.6-23.8-36.5C362.5 154.2 344.1 144 320 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c14.3 0 25.2 5.8 33.4 13.6zM288 448c0 8.8 7.2 16 16 16s16-7.2 16-16l0-60.2c-9.9 4-20.6 7.2-32 9.3l0 50.9zm64 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-151.8c-9.1 9.4-19.7 18.6-32 26.8L352 496z',
    ],
  ],
};
const faOilTemperature = {
  prefix: 'fad',
  iconName: 'oil-temperature',
  icon: [
    576,
    512,
    ['oil-temp'],
    'f614',
    [
      'M.8 343.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 357.7 159 368 192 368c1.3 0 2.7 0 4-.1c-12.6-18.1-20-40.2-20-63.9c0-.4 0-.8 0-1.2c-21.9-3.2-43.7-12.6-61.4-24.9c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4zm0 144c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c2.4 .6 4.9 .8 7.3 .8c14.5 0 27.7-10 31.1-24.7c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4zM380 367.9c1.3 0 2.7 .1 4 .1c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c-17.8 12.3-39.6 21.7-61.5 24.9c0 .4 0 .8 0 1.2c0 23.8-7.4 45.8-20 63.9z',
      'M288 0c-17.7 0-32 14.3-32 32l0 96 0 102.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-70.7 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 0z',
    ],
  ],
};
const faOilTemp = faOilTemperature;
const faSquareQuestion = {
  prefix: 'fad',
  iconName: 'square-question',
  icon: [
    448,
    512,
    ['question-square'],
    'f2fd',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm136 78.5c0-.3 0-.7 0 0zM192 352c0-.3 0-.6 0 0z',
      'M190.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faQuestionSquare = faSquareQuestion;
const faAirConditioner = {
  prefix: 'fad',
  iconName: 'air-conditioner',
  icon: [
    576,
    512,
    [],
    'f8f4',
    [
      'M64 144c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm0 272c0 53 43 96 96 96s96-43 96-96l0-192-64 0 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7c15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7C83.4 349.4 64 380.4 64 416zM320 224l0 160c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160-64 0z',
      'M64 0C28.7 0 0 28.7 0 64l0 96c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 0zM80 128l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faAngleDown = {
  prefix: 'fad',
  iconName: 'angle-down',
  icon: [
    448,
    512,
    [8964],
    'f107',
    [
      'M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z',
      '',
    ],
  ],
};
const faMountains = {
  prefix: 'fad',
  iconName: 'mountains',
  icon: [
    640,
    512,
    [9968],
    'f6fd',
    [
      'M412.7 249.7l48.2-79C465 164.1 472.2 160 480 160s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1l-122.8 0c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7c-30.3-48.2-60.5-96.4-90.7-144.6z',
      'M55.9 480H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z',
    ],
  ],
};
const faOmega = {
  prefix: 'fad',
  iconName: 'omega',
  icon: [
    448,
    512,
    [],
    'f67a',
    [
      'M224 96C135.6 96 64 167.6 64 256c0 56.4 29.1 106 73.3 134.5c13.3 8.6 22.7 23.7 22.7 41.2c0 26.7-21.6 48.3-48.3 48.3L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l35.2 0C25.8 375.4 0 318.7 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160l35.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-79.7 0c-26.7 0-48.3-21.6-48.3-48.3c0-17.5 9.4-32.6 22.7-41.2C354.9 362 384 312.4 384 256c0-88.4-71.6-160-160-160z',
      '',
    ],
  ],
};
const faCarTunnel = {
  prefix: 'fad',
  iconName: 'car-tunnel',
  icon: [
    512,
    512,
    [],
    'e4de',
    [
      'M0 256L0 448c0 35.3 28.7 64 64 64l42.8 0c-6.6-5.9-10.8-14.4-10.8-24l0-112c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7l115.2 0c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6l0 112c0 9.6-4.2 18.1-10.8 24l42.8 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0S0 114.6 0 256zM149.2 512l213.7 0c-6.6-5.9-10.8-14.4-10.8-24l0-40-192 0 0 40c0 9.6-4.2 18.1-10.8 24z',
      'M198.4 272l115.2 0c3.5 0 6.5 2.2 7.6 5.5L335 320l-158 0 13.8-42.5c1.1-3.3 4.1-5.5 7.6-5.5zm-53.3-9.3l-21 64.7C107.3 337.1 96 355.2 96 376l0 112c0 9.6 4.2 18.1 10.8 24l42.3 0c6.6-5.9 10.8-14.4 10.8-24l0-40 192 0 0 40c0 9.6 4.2 18.1 10.8 24l42.3 0c6.6-5.9 10.8-14.4 10.8-24l0-112c0-20.8-11.3-38.9-28.2-48.6l-21-64.7c-7.5-23.1-29-38.7-53.3-38.7l-115.2 0c-24.3 0-45.8 15.6-53.3 38.7zM144 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faPersonDollyEmpty = {
  prefix: 'fad',
  iconName: 'person-dolly-empty',
  icon: [
    512,
    512,
    [],
    'f4d1',
    [
      'M200.7 197.8c2.2 8.7 4.4 17.5 6.5 26.2c5.3 21.3 10.7 42.7 16 64c9 36.1 18 72.2 27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c10.9-2.7 18.2-12.5 18.2-23.3c0-1.9-.2-3.9-.7-5.8c-3.2-12.9-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2C244.6 175.3 234.8 168 224 168c-1.9 0-3.9 .2-5.8 .7c-12.9 3.2-20.7 16.2-17.5 29.1zM304 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7l0-65.1 16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4l70.7 0-16-64-46.1 0-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6l0 88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0 0 0 0 0 0l0-69.5-64-64z',
    ],
  ],
};
const faPanFood = {
  prefix: 'fad',
  iconName: 'pan-food',
  icon: [
    640,
    512,
    [129368],
    'e42b',
    [
      'M112 256a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zm57.9-38.1l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3zm34.8 66.8l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0c2.1 2.1 3.5 4.6 4.2 7.3c.4 1.7 .8 3.4 1.1 5.1c1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7l26.7 0c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56l0-26.7c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9c-1.7-.3-3.5-.7-5.1-1.1c-2.7-.7-5.2-2.1-7.3-4.2c-6.2-6.2-6.2-16.4 0-22.6zM344 224a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32.2 39.8l79.6-79.6c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1C462 299.2 448.4 304 434.4 304l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4zM440 384a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M528 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zM48 184l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 184c0-13.3 10.7-24 24-24s24 10.7 24 24zm568-24c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24zM230.1 214.1l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80.2 39.8l79.6-79.6c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1C462 299.2 448.4 304 434.4 304l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4z',
    ],
  ],
};
const faHeadSideCough = {
  prefix: 'fad',
  iconName: 'head-side-cough',
  icon: [
    640,
    512,
    [],
    'e061',
    [
      'M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8c-6.7 0-13.4 0-20.2 0l0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416l0 16c0 26.5-21.5 48-48 48l-80 0 0 8c0 13.3-10.7 24-24 24c-13.3 0-26.7 0-40 0L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM320 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M592 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faGripLines = {
  prefix: 'fad',
  iconName: 'grip-lines',
  icon: [
    448,
    512,
    [],
    'f7a4',
    [
      'M0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32z',
      'M416 160c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0z',
    ],
  ],
};
const faThumbsDown = {
  prefix: 'fad',
  iconName: 'thumbs-down',
  icon: [
    512,
    512,
    [128078, 61576],
    'f165',
    [
      'M160 153.7l0 38.3 0 48 0 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7s42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2l144 0c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48l-97.5 0c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7z',
      'M0 352c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352z',
    ],
  ],
};
const faUserLock = {
  prefix: 'fad',
  iconName: 'user-lock',
  icon: [
    640,
    512,
    [],
    'f502',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3l0 128c0 11.7 3.1 22.6 8.6 32L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faArrowRightLong = {
  prefix: 'fad',
  iconName: 'arrow-right-long',
  icon: [
    512,
    512,
    ['long-arrow-right'],
    'f178',
    [
      'M0 256c0 17.7 14.3 32 32 32l370.7 0c10.7-10.7 21.3-21.3 32-32c-10.7-10.7-21.3-21.3-32-32L32 224c-17.7 0-32 14.3-32 32z',
      'M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 256 329.4 150.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z',
    ],
  ],
};
const faLongArrowRight = faArrowRightLong;
const faTicketsAirline = {
  prefix: 'fad',
  iconName: 'tickets-airline',
  icon: [
    640,
    512,
    ['tickets-perforated-plane', 'tickets-plane'],
    'e29b',
    [
      'M96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-48c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm96.2 57.9c-1.3-5 2.6-9.9 7.8-9.9l13.8 0c5 0 9.8 2.4 12.8 6.4L245.8 176l42.7 0-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5L304 96c8.5 0 16.4 4.5 20.7 11.9L364.4 176l40.3 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7l-40.3 0-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9l-31.1 0c-5.5 0-9.3-5.3-7.6-10.5L288.4 240l-42.7 0-19.2 25.6c-3 4-7.8 6.4-12.8 6.4L200 272c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2zM544 112a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240zm240.4 56l-42.7 0-19.2-25.6c-3-4-7.8-6.4-12.8-6.4L200 144c-5.2 0-9 4.9-7.8 9.9l12.5 50.2c.6 2.5 .6 5.2 0 7.8l-12.5 50.2c-1.3 5 2.6 9.9 7.8 9.9l13.8 0c5 0 9.8-2.4 12.8-6.4L245.8 240l42.7 0-23.2 69.5c-1.7 5.2 2.1 10.5 7.6 10.5l31.1 0c8.5 0 16.4-4.5 20.7-11.9L364.4 240l40.3 0c16.1 0 31.5-6.4 42.8-17.7c7.9-7.9 7.9-20.7 0-28.5c-11.4-11.4-26.8-17.7-42.8-17.7l-40.3 0-39.7-68.1C320.4 100.5 312.5 96 304 96l-31.1 0c-5.5 0-9.3 5.3-7.6 10.5L288.4 176z',
    ],
  ],
};
const faTicketsPerforatedPlane = faTicketsAirline;
const faTicketsPlane = faTicketsAirline;
const faTentDoublePeak = {
  prefix: 'fad',
  iconName: 'tent-double-peak',
  icon: [
    576,
    512,
    [],
    'e627',
    [
      'M0 192l576 0 0 288c0 17.7-14.3 32-32 32l-80 0-28.2 0c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L288 480c0 17.7-14.3 32-32 32l-16 0L32 512c-17.7 0-32-14.3-32-32L0 192z',
      'M182.6 9.4C176.2 2.9 167.3-.5 158.2 0s-17.5 4.9-23.2 12L93.9 63.5c-13.5 16.9-29 31.9-46.3 44.9L12.8 134.4C4.7 140.4 0 149.9 0 160l0 32 576 0 0-32c0-10.1-4.7-19.6-12.8-25.6l-34.7-26.1c-17.3-12.9-32.8-28-46.3-44.9L441 12C435.3 4.9 426.9 .6 417.8 0s-18 2.9-24.4 9.3L374.6 28.1C351.7 51.1 320.5 64 288 64s-63.7-12.9-86.6-35.9L182.6 9.4zM407.2 494.3L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L288 480c0 17.7-14.3 32-32 32l179.8 0c-12.1 0-23.2-6.8-28.6-17.7z',
    ],
  ],
};
const faAnchorCircleXmark = {
  prefix: 'fad',
  iconName: 'anchor-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e4ac',
    [
      'M0 336c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-4.7 4.7-7 10.8-7 17zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faEllipsis = {
  prefix: 'fad',
  iconName: 'ellipsis',
  icon: [
    448,
    512,
    ['ellipsis-h'],
    'f141',
    [
      'M168 256a56 56 0 1 0 112 0 56 56 0 1 0 -112 0z',
      'M64 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm320 0a56 56 0 1 0 0-112 56 56 0 1 0 0 112z',
    ],
  ],
};
const faEllipsisH = faEllipsis;
const faNfcSlash = {
  prefix: 'fad',
  iconName: 'nfc-slash',
  icon: [
    640,
    512,
    [],
    'e1fc',
    [
      'M96 171.6L96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4L406.2 416 208 416c-26.5 0-48-21.5-48-48l0-145.9L96 171.6zM107.7 59.1c21.9 17.2 43.9 34.4 65.8 51.6c8.7-9 21-14.7 34.5-14.7l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-3.3 0-6.4 1-8.9 2.7c34.3 26.9 68.7 53.8 103 80.7c.6-.3 1.3-.5 1.9-.7l0-66.7c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48l0 206.9c21.3 16.7 42.7 33.4 64 50.2L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1zM192 247.3L192 368c0 8.8 7.2 16 16 16l157.5 0L192 247.3zM336 144l0 66.7c18.6 6.6 32 24.4 32 45.3c0 2.3-.2 4.5-.5 6.8c26.8 21 53.6 42 80.5 63.1L448 144c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faChessPawn = {
  prefix: 'fad',
  iconName: 'chess-pawn',
  icon: [
    320,
    512,
    [9823],
    'f443',
    [
      'M16 489.4C16 501.9 26.1 512 38.6 512l242.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432 64 432 22.6 473.4c-4.2 4.2-6.6 10-6.6 16z',
      'M264 136c0 37.1-19.4 69.6-48.5 88l8.5 0c17.7 0 32 14.3 32 32c0 15.7-11.3 28.8-26.3 31.5L256 432 64 432 90.3 287.5C75.3 284.8 64 271.7 64 256c0-17.7 14.3-32 32-32l8.5 0C75.4 205.6 56 173.1 56 136C56 78.6 102.6 32 160 32s104 46.6 104 104z',
    ],
  ],
};
const faKitMedical = {
  prefix: 'fad',
  iconName: 'kit-medical',
  icon: [
    576,
    512,
    ['first-aid'],
    'f479',
    [
      'M96 32l32 0 0 448-32 0L96 32zm352 0l32 0 0 448-32 0 0-448z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l32 0L96 32 64 32zm64 0l0 448 320 0 0-448L128 32zM512 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-32 0 0 448 32 0zM256 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faFirstAid = faKitMedical;
const faGrid2Plus = {
  prefix: 'fad',
  iconName: 'grid-2-plus',
  icon: [
    512,
    512,
    [],
    'e197',
    [
      'M32 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm0 256c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM288 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z',
      'M408 296c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64z',
    ],
  ],
};
const faBells = {
  prefix: 'fad',
  iconName: 'bells',
  icon: [
    640,
    512,
    [],
    'f77f',
    [
      'M.6 289.5c1.4 12 9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c9.4-32.5 8.1-67.2-3.5-99.1l-18.7-51.2C203.2 170.3 232.4 88.2 296.5 46c-4.5-2.2-9.1-4.2-13.9-6c-14.9-5.4-30.2-8-45.3-8c-54.1 0-104.9 33.3-124.5 87L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5zm260.3-54.9l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2c.2-1.3 .2-2.5 .2-3.8c0-10.6-5.3-20.6-14.2-26.6l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2C493.2 69.2 414.1 32.5 342.8 58.4s-108 104.8-81.9 176.2z',
      'M211.9 419.5L94.3 376.1c-.3 2.5-.4 5-.4 7.5c0 35.5 28.9 64.3 64.5 64.3c22.3 0 41.9-11.3 53.5-28.4zM480.8 480c35.6 0 64.5-28.8 64.5-64.3c0-1.3 0-2.6-.1-3.9L429.1 454.1c11.8 15.7 30.6 25.9 51.7 25.9z',
    ],
  ],
};
const faPersonThroughWindow = {
  prefix: 'fad',
  iconName: 'person-through-window',
  icon: [
    640,
    512,
    [],
    'e5a9',
    [
      'M96 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm32 182.2c0 24.6 0 49.2 0 73.8c0 1.1 0 1.4 0 1.7c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4c17.7 0 32-14.3 32-32c0-24.6 0-49.2 0-73.8c0-10.2 1.6-20.1 4.7-29.5c23 34.4 45.9 68.9 68.9 103.3l42.7 64c11.1 16.6 22.1 33.2 33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4c-3.2-4.8-6.3-9.5-9.5-14.2l-42.7-64c-10.7-16-21.3-32-32-48l74.6 0 40 48 83.3 0-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8c-21.3 0-42.7 0-64 0l0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2z',
      'M64 64l0 320 64 0c0 17.7 14.3 32 32 32s32-14.3 32-32l73.5 0 42.7 64L48 448c-26.5 0-48-21.5-48-48L0 48C0 21.5 21.5 0 48 0L592 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-206.9 0-42.7-64L576 384l0-320L352 64l-64 0L64 64z',
    ],
  ],
};
const faToolbox = {
  prefix: 'fad',
  iconName: 'toolbox',
  icon: [
    512,
    512,
    [129520],
    'f552',
    [
      'M0 320l128 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 128 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 128 0 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zM128 88c0-30.9 25.1-56 56-56l144 0c30.9 0 56 25.1 56 56l0 40-48 0 0-40c0-4.4-3.6-8-8-8L184 80c-4.4 0-8 3.6-8 8l0 40-48 0 0-40z',
      'M0 320l0-85.5c0-17 6.7-33.3 18.7-45.3l42.5-42.5c12-12 28.3-18.7 45.3-18.7l299 0c17 0 33.3 6.7 45.3 18.7l42.5 42.5c12 12 18.7 28.3 18.7 45.3l0 85.5-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L0 320z',
    ],
  ],
};
const faGlobeWifi = {
  prefix: 'fad',
  iconName: 'globe-wifi',
  icon: [
    640,
    512,
    [],
    'e685',
    [
      'M0 256c0 22.1 2.8 43.5 8.1 64l123.1 0c-2.1-20.6-3.2-42-3.2-64s1.1-43.4 3.2-64L8.1 192C2.8 212.5 0 233.9 0 256zm18.6-96l116.7 0c10-63.9 29.8-117.4 55.3-151.6C112.2 29.1 48.6 85.9 18.6 160zm0 192c30 74.1 93.6 130.9 171.9 151.6c-25.5-34.2-45.2-87.7-55.3-151.6L18.6 352zM160 256c0 22.2 1.2 43.6 3.3 64l163.3 0c5.4-19.2 14.1-37.1 25.3-53.1c.1-3.6 .1-7.3 .1-10.9c0-22.2-1.2-43.6-3.3-64l-185.3 0c-2.2 20.4-3.3 41.8-3.3 64zm7.7-96l176.6 0c-6.1-36.4-15.5-68.6-27-94.7c-10.5-23.6-22.2-40.7-33.5-51.5C272.6 3.2 263.3 0 256 0s-16.6 3.2-27.8 13.8c-11.3 10.8-23 27.9-33.5 51.5c-11.6 26-20.9 58.2-27 94.7zm0 192c6.1 36.4 15.5 68.6 27 94.6c10.5 23.6 22.2 40.7 33.5 51.5C239.4 508.8 248.7 512 256 512s16.6-3.2 27.8-13.8c11.3-10.8 23-27.9 33.5-51.5c3.7-8.4 7.2-17.4 10.4-27c-5-16.3-7.7-33.7-7.7-51.7c0-5.4 .2-10.7 .7-16l-153 0zM321.4 8.4c25.5 34.2 45.2 87.7 55.3 151.6l116.7 0C463.4 85.9 399.8 29.1 321.4 8.4zm0 495.1c15.6-4.1 30.6-9.7 44.9-16.5c-7.5-8.2-14.3-17.1-20.2-26.7c-7.4 16.5-15.7 31.1-24.7 43.2zM380.8 192c1.3 13.2 2.3 26.8 2.8 40.6C414.1 207.2 453.3 192 496 192l-115.2 0zM496 192c2.7 0 5.3 .1 8 .2c-2.7-.2-5.3-.2-8-.2z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM425.4 347.1c-6.6 5.9-16.7 5.4-22.6-1.2s-5.4-16.7 1.2-22.6c24.4-21.9 56.6-35.3 92-35.3s67.7 13.4 92 35.3c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2C547.9 330.2 523.2 320 496 320s-51.9 10.2-70.6 27.1zM496 412a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-28c-12.1 0-23.2 4.6-31.5 12.1c-6.6 5.9-16.7 5.4-22.6-1.1s-5.4-16.7 1.1-22.6c14-12.7 32.6-20.4 53-20.4s39 7.7 53 20.4c6.6 5.9 7.1 16 1.1 22.6s-16 7.1-22.6 1.1c-8.3-7.5-19.4-12.1-31.5-12.1z',
    ],
  ],
};
const faEnvelopeDot = {
  prefix: 'fad',
  iconName: 'envelope-dot',
  icon: [
    576,
    512,
    ['envelope-badge'],
    'e16f',
    [
      'M0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L481.7 158.7C444.3 152 416 119.3 416 80c0-1.4 0-2.7 .1-4.1s.2-2.7 .3-4c.3-2.7 .7-5.3 1.2-7.9L48 64C21.5 64 0 85.5 0 112zm0 64L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z',
      'M416 80a80 80 0 1 1 160 0A80 80 0 1 1 416 80z',
    ],
  ],
};
const faEnvelopeBadge = faEnvelopeDot;
const faMagnifyingGlassWaveform = {
  prefix: 'fad',
  iconName: 'magnifying-glass-waveform',
  icon: [
    512,
    512,
    [],
    'e661',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm96-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112zm88-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176zm88 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48z',
      'M232 120l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24zm-88 32l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm176 32l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zM457.4 502.6L330.7 376C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z',
    ],
  ],
};
const faHandsHoldingCircle = {
  prefix: 'fad',
  iconName: 'hands-holding-circle',
  icon: [
    640,
    512,
    [],
    'e4fb',
    [
      'M0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c-5.1-5.1-10.2-10.2-15.2-15.2l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40c0-22.1-17.9-40-40-40S0 81.9 0 104zM352 385.1l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c-8.5 8.5-16.9 16.9-25.4 25.4c-21 21-32.8 49.5-32.8 79.2z',
      'M320 0a128 128 0 1 0 0 256A128 128 0 1 0 320 0z',
    ],
  ],
};
const faBug = {
  prefix: 'fad',
  iconName: 'bug',
  icon: [
    512,
    512,
    [],
    'f188',
    [
      'M160 96l0 3.6c0 15.7 12.7 28.4 28.4 28.4l135.1 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96s-96 43-96 96zm80 144l0 239.2c5.3 .5 10.6 .8 16 .8s10.7-.3 16-.8L272 240c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c.7 .7 1.4 1.3 2.1 1.9c-6.2 12-10.1 25.3-11.1 39.5L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6L240 240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 239.2c34.5-3.4 65.8-17.8 90.3-39.6l63.1 63.1c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-1.9-1.9-3.9-3.4-6-4.8c9.9-20.8 15.4-44.1 15.4-68.6l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64.3 0c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C345.2 164.1 329.1 160 312 160l-112 0c-17.1 0-33.2 4.1-47.5 11.4c-.6-.7-1.2-1.4-1.9-2.1l-64-64z',
    ],
  ],
};
const faBowlChopsticks = {
  prefix: 'fad',
  iconName: 'bowl-chopsticks',
  icon: [
    512,
    512,
    [],
    'e2e9',
    [
      'M0 109.3c0 9.8 8.8 17.3 18.5 15.8l473.8-74c11.3-1.8 19.7-11.5 19.7-23c0-14.6-13.3-25.6-27.6-22.9L13.1 93.6C5.5 95 0 101.6 0 109.3zm0 50.5c0 9 7.3 16.2 16.2 16.2l472.1 0c13 0 23.6-10.6 23.6-23.6c0-13.3-11-24-24.4-23.6L15.7 143.5C7 143.8 0 151 0 159.7z',
      'M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5L33.6 224z',
    ],
  ],
};
const faCreditCard = {
  prefix: 'fad',
  iconName: 'credit-card',
  icon: [
    576,
    512,
    [128179, 62083, 'credit-card-alt'],
    'f09d',
    [
      'M0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM0 224L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-192L0 224zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
      'M576 224H0V128H576v96z',
    ],
  ],
};
const faCreditCardAlt = faCreditCard;
const faCircleS = {
  prefix: 'fad',
  iconName: 'circle-s',
  icon: [
    512,
    512,
    [],
    'e121',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160.4-68.2c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.7 5.7c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3z',
      'M223 180.4c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7l3.6-23.7-3.6 23.7c-20.3-3.1-36.8-1.4-47.8 2.9z',
    ],
  ],
};
const faBoxBallot = {
  prefix: 'fad',
  iconName: 'box-ballot',
  icon: [
    576,
    512,
    [128499],
    'f735',
    [
      'M0 208L0 320l576 0 0-112c0-26.5-21.5-48-48-48l-80 0 0 64 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-320 0-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64-80 0c-26.5 0-48 21.5-48 48z',
      'M160 0L416 0c17.7 0 32 14.3 32 32l0 224-320 0 0-224c0-17.7 14.3-32 32-32zM32 512c-17.7 0-32-14.3-32-32L0 320l576 0 0 160c0 17.7-14.3 32-32 32L32 512z',
    ],
  ],
};
const faCar = {
  prefix: 'fad',
  iconName: 'car',
  icon: [
    512,
    512,
    [128664, 'automobile'],
    'f1b9',
    [
      'M0 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48L0 400zM109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4c-8.7 24.9-17.4 49.7-26.1 74.6zM416 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48-96 0z',
      'M135.2 117.4L109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2l0 144L0 400 0 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faAutomobile = faCar;
const faHandHoldingHand = {
  prefix: 'fad',
  iconName: 'hand-holding-hand',
  icon: [
    576,
    512,
    [],
    'e4f7',
    [
      'M0 184c0 8.2 2.5 16.6 7.8 23.7c13.1 17.8 38.1 21.6 55.9 8.5L183.4 128 304 128c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 16 0 78.3 0c29.1 0 57.3-9.9 80-28l44.9-36 36.8 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L384 32 223.5 32c-29 0-57.3 9.3-80.7 26.5L16.3 151.8C5.6 159.6 0 171.8 0 184z',
      'M559.7 360.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 384 272 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 352 32 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2c.3 0 .6 0 .9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z',
    ],
  ],
};
const faUserTieHair = {
  prefix: 'fad',
  iconName: 'user-tie-hair',
  icon: [
    448,
    512,
    [],
    'e45f',
    [
      'M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32c-12 0-24 0-36 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112c-18.7 0-37.3 0-56 0c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128z',
      'M176 112c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96l36 0C333.8 40.8 283.6 0 224 0C160.3 0 107.5 46.5 97.7 107.4c6.8 3 14.4 4.6 22.3 4.6l56 0zM279.7 510.9c1.8 .7 3.8 1.1 5.8 1.1l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c2.1 0 4-.4 5.8-1.1L168 512l112 0-.3-1.1z',
    ],
  ],
};
const faPodiumStar = {
  prefix: 'fad',
  iconName: 'podium-star',
  icon: [
    448,
    512,
    [],
    'f758',
    [
      'M44.4 192l359.1 0L374.3 455.1c-3.6 32.4-31 56.9-63.6 56.9l-173.4 0c-32.6 0-60-24.5-63.6-56.9L44.4 192zm93.4 139.3l35.4 34c2 2 3 4.9 2.4 7.7l-9.4 49.1c-1.3 6.9 5.8 12.3 11.8 8.9l42.1-24.4c2.4-1.4 5.4-1.4 7.8 0L270 430.9c6 3.5 13.1-1.9 11.8-8.9L272.3 373c-.5-2.8 .4-5.8 2.4-7.7l35.4-34c5-4.8 2.3-13.5-4.5-14.3L257.8 311c-2.8-.3-5.2-2.1-6.3-4.8l-20.2-45.4c-2.9-6.4-11.7-6.4-14.5 0l-20.2 45.4c-1.2 2.6-3.6 4.4-6.3 4.8l-47.9 5.9c-6.8 .8-9.5 9.5-4.5 14.3z',
      'M182.4 72L168 72c-22.1 0-40 17.9-40 40l0 32 296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-32c0-48.6 39.4-88 88-88l14.4 0C190.7 9.7 206.2 0 224 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-17.8 0-33.3-9.7-41.6-24z',
    ],
  ],
};
const faUserHairMullet = {
  prefix: 'fad',
  iconName: 'user-hair-mullet',
  icon: [
    448,
    512,
    ['business-front', 'party-back', 'trian-balbot'],
    'e45c',
    [
      'M104 128c0 11.7 1.4 23.1 3.9 33.9c11.5 48.1 47.5 84.9 96.6 92.6c6.3 1 12.8 1.5 19.5 1.5c7.1 0 14-.6 20.6-1.7c48.5-8.1 84-44.7 95.4-92.4c2.6-10.8 3.9-22.2 3.9-33.9c0-5.4-.3-10.8-.9-16c-10.4 0-20.8 0-31.1 0c-2.7 0-5.3 0-8 0c-33.4 0-62.8-17-80-42.9C206.8 95 177.4 112 144 112c-2.7 0-5.3 0-8 0c-10.4 0-20.8 0-31.1 0c-.6 5.2-.9 10.6-.9 16z',
      'M144 112s0 0 0 0c33.4 0 62.8-17 80-42.9C241.2 95 270.6 112 304 112c0 0 0 0 0 0l8 0 32 0c8.8 0 16-7.2 16-16l0-1.2c0-9.1-5.1-17.4-13.3-21.5l-9.2-4.6C316.1 27.9 273.3 0 224 0c-48.4 0-90.5 26.8-112.2 66.4l-11.7 6.7C92.6 77.4 88 85.3 88 93.9L88 96c0 8.8 7.2 16 16 16l32 0 8 0zm196.1 49.9c-11.4 47.7-46.9 84.3-95.4 92.4L283 287.2c4.2 3.6 9.7 5.3 15.2 4.7s10.5-3.5 13.8-7.9l14-18.6 17.1 8.5c8.8 4.4 19.4 1.8 25.2-6.2s4.9-18.9-2.1-25.8c-13.9-13.9-19.7-24.7-22.7-37.4c-2.6-11-3.3-23.9-3.4-42.5zM204.5 254.5c-49.1-7.7-85-44.5-96.6-92.6c-.2 18.6-.8 31.5-3.4 42.5c-3 12.7-8.8 23.6-22.7 37.4c-6.9 6.9-7.8 17.9-2.1 25.8s16.4 10.6 25.2 6.2l17.1-8.5L136 284c3.3 4.4 8.2 7.2 13.6 7.9s10.9-1 15.1-4.5l39.8-32.9zM161.3 320C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320l-125.4 0z',
    ],
  ],
};
const faBusinessFront = faUserHairMullet;
const faPartyBack = faUserHairMullet;
const faTrianBalbot = faUserHairMullet;
const faMicrophoneStand = {
  prefix: 'fad',
  iconName: 'microphone-stand',
  icon: [
    512,
    512,
    [127908],
    'f8cb',
    [
      'M7.8 427c-11 12.7-10.3 31.7 1.6 43.6l32 32c11.9 11.9 30.9 12.6 43.6 1.6c46.4-40.2 92.7-80.3 139-120.5c21.3-18.5 42.7-37 64-55.5c27.8-24.1 55.6-48.2 83.4-72.3L256.1 140.6 7.8 427zM293.5 60.1c52.8 52.8 105.6 105.6 158.4 158.4c3.8-3.8 7.5-7.5 11.3-11.3l11.3-11.3L316.1 37.5C308.6 45 301 52.6 293.5 60.1z',
      'M479.2 32.8c43.7 43.7 43.7 114.7 0 158.4l-4.7 4.7L316.1 37.5l4.7-4.7c43.7-43.7 114.7-43.7 158.4 0zM293.5 60.1L451.9 218.5l-4.7 4.7c-21 21-48.3 31.9-75.8 32.8c0 0 0 0 0 0L256.1 140.6s0 0 0 0c.8-27.5 11.7-54.8 32.8-75.8l4.7-4.7zM224 480l0-96.3 64-55.5L288 480c0 17.7-14.3 32-32 32s-32-14.3-32-32z',
    ],
  ],
};
const faBookOpenReader = {
  prefix: 'fad',
  iconName: 'book-open-reader',
  icon: [
    512,
    512,
    ['book-reader'],
    'f5da',
    [
      'M160 96a96 96 0 1 0 192 0A96 96 0 1 0 160 96z',
      'M240 512l0-264c-52.1-36.4-114.1-56-177.7-56L32 192c-17.7 0-32 14.3-32 32L0 427c0 16.4 12.5 30.2 28.8 31.8l96 9.6c23.2 2.3 45.9 8.9 66.8 19.3L240 512zm32 0l48.4-24.2c20.9-10.4 43.5-17 66.8-19.3l96-9.6c16.4-1.6 28.8-15.4 28.8-31.8l0-203c0-17.7-14.3-32-32-32l-30.3 0c-63.6 0-125.6 19.6-177.7 56l0 264z',
    ],
  ],
};
const faBookReader = faBookOpenReader;
const faFamilyDress = {
  prefix: 'fad',
  iconName: 'family-dress',
  icon: [
    512,
    512,
    [],
    'e301',
    [
      'M11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 80c0 26.5 21.5 48 48 48l32 0c13.5 0 25.7-5.6 34.4-14.5c-1.6-5.5-2.4-11.4-2.4-17.5l0-56.4c-19.6-17.6-32-43.1-32-71.6l0-16c0-43.1 24.3-80.5 60-99.2c-17.1-14.7-28-36.5-28-60.8c0-2.4 .1-4.8 .3-7.1c-9.6-5.7-20.8-8.9-32.6-8.9l-31.4 0c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM308 236.8c35.7 18.7 60 56.1 60 99.2l0 16c0 28.4-12.4 54-32 71.6l0 56.4c0 6.1-.8 11.9-2.4 17.5c8.7 9 20.9 14.5 34.4 14.5l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c18.2 0 32-14.9 32-31.9c0-2.9-.4-5.9-1.3-8.9L461.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1c0 24.3-10.9 46.1-28 60.8zM320 64a64 64 0 1 0 128 0A64 64 0 1 0 320 64z',
      'M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 336c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16c0 23.7-12.9 44.4-32 55.4l0 72.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-72.6c-19.1-11.1-32-31.7-32-55.4l0-16z',
    ],
  ],
};
const faCircleX = {
  prefix: 'fad',
  iconName: 'circle-x',
  icon: [
    512,
    512,
    [],
    'e12e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144 360c0-5.5 1.9-11 5.7-15.5c25-29.5 49.9-59 74.9-88.5l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8c4.5-3.8 10-5.7 15.5-5.7c6.8 0 13.6 2.9 18.3 8.5c23.2 27.5 46.5 54.9 69.7 82.3c23.2-27.5 46.5-54.9 69.7-82.3c4.7-5.6 11.5-8.5 18.3-8.5c5.5 0 11 1.9 15.5 5.7c10.1 8.6 11.4 23.7 2.8 33.8c-25 29.5-49.9 59-74.9 88.5c25 29.5 49.9 59 74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8c-23.2-27.5-46.5-54.9-69.7-82.3c-23.2 27.5-46.5 54.9-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8c-5.6-4.7-8.5-11.5-8.5-18.3z',
      'M152.5 133.7c10.1-8.6 25.3-7.3 33.8 2.8L256 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L224.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8z',
    ],
  ],
};
const faCabin = {
  prefix: 'fad',
  iconName: 'cabin',
  icon: [
    512,
    512,
    [],
    'e46d',
    [
      'M32 280c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L56 320c-13.3 0-24-10.7-24-24l0-16zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L56 416c-13.3 0-24-10.7-24-24l0-16zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L56 512c-13.3 0-24-10.7-24-24l0-16zM320 280c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-16zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-16zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-16z',
      'M237.4 6C248.5-2 263.5-2 274.6 6L384 84.1 384 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 88.7L498.6 166c11.3 8.1 16.1 22.6 11.9 35.8S493.9 224 480 224l-32 0-32 0L32 224c-13.9 0-26.2-9-30.5-22.2S2.1 174 13.4 166L237.4 6zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMountainSun = {
  prefix: 'fad',
  iconName: 'mountain-sun',
  icon: [
    640,
    512,
    [],
    'e52f',
    [
      'M480 80a80 80 0 1 0 160 0A80 80 0 1 0 480 80z',
      'M381.1 512L55.9 512C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1l-122.8 0-75 0z',
    ],
  ],
};
const faChartSimpleHorizontal = {
  prefix: 'fad',
  iconName: 'chart-simple-horizontal',
  icon: [
    448,
    512,
    [],
    'e474',
    [
      'M0 240l0 32c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 192c-26.5 0-48 21.5-48 48z',
      'M384 112c0 26.5-21.5 48-48 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32zM256 432c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32z',
    ],
  ],
};
const faBluetooth = {
  prefix: 'fad',
  iconName: 'bluetooth',
  icon: [
    384,
    512,
    [],
    'f293',
    [
      'M178.8 2.9c11.4-5.2 24.8-3.2 34.3 5.1l128 112C348 126 352 134.8 352 144s-4 18-10.9 24.1L240.6 256l100.5 87.9C348 350 352 358.8 352 368s-4 18-10.9 24.1l-128 112c-9.4 8.3-22.9 10.2-34.3 5.1S160 492.6 160 480l0-153.5L85.1 392.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2L143.4 256 42.9 168.1c-13.3-11.6-14.6-31.9-3-45.2s31.9-14.6 45.2-3L160 185.5 160 32c0-12.6 7.3-24 18.8-29.1zM224 326.5l0 83L271.4 368 224 326.5zm0-141L271.4 144 224 102.5l0 83z',
      '',
    ],
  ],
};
const faArrowsLeftRightToLine = {
  prefix: 'fad',
  iconName: 'arrows-left-right-to-line',
  icon: [
    640,
    512,
    [],
    'e4ba',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96zm576 0l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M246.6 137.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faHandBackPointLeft = {
  prefix: 'fad',
  iconName: 'hand-back-point-left',
  icon: [
    512,
    512,
    [],
    'e19f',
    [
      'M0 184c0-22.1 17.9-40 40-40l200 0 7 0 73 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.7 0c1.4-2 3-3.9 4.5-5.8l16-19.2C297 72.4 315 64 334 64L372 64c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 336c0 70.7-57.3 128-128 128l-64 0-32 0c-26.5 0-48-21.5-48-48c0-12.4 4.7-23.6 12.3-32.1C227.5 382 208 361.3 208 336c0-12.4 4.7-23.6 12.3-32.1C195.5 302 176 281.3 176 256c0-12.3 4.6-23.5 12.2-32L40 224c-22.1 0-40-17.9-40-40z',
      '',
    ],
  ],
};
const faMessageDots = {
  prefix: 'fad',
  iconName: 'message-dots',
  icon: [
    512,
    512,
    ['comment-alt-dots', 'messaging'],
    'f4a3',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM96 208a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M96 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faCommentAltDots = faMessageDots;
const faMessaging = faMessageDots;
const faFileHeart = {
  prefix: 'fad',
  iconName: 'file-heart',
  icon: [
    384,
    512,
    [],
    'e176',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 301.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9C107.4 240 80 267.4 80 301.3z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM80 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 344.6C86.5 333.1 80 317.5 80 301.3z',
    ],
  ],
};
const faBeerMug = {
  prefix: 'fad',
  iconName: 'beer-mug',
  icon: [
    512,
    512,
    ['beer-foam'],
    'e0b3',
    [
      'M32 163.2C46.1 171.3 62.5 176 80 176c18.7 0 36.2-5.4 51-14.7c20 19 47.2 30.7 77 30.7s57-11.7 77-30.7c14.8 9.3 32.3 14.7 51 14.7c19.6 0 37.9-5.9 53.1-16l46.1 0c42.4 0 76.8 34.4 76.8 76.8l0 102.1c0 30.3-17.9 57.9-45.6 70.2L384 445.7l0 2.3c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-284.8zM128 240l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 0l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 0l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16zm128-16l0 151.6 56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7l0-102.1c0-7.1-5.7-12.8-12.8-12.8L384 224z',
      'M267.7 133.3c6.9-7.7 21.4-8.6 29.6-2.3c10.8 8.2 24.2 13 38.7 13c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.6 0-28 4.9-38.7 13c-8.2 6.3-22.7 5.4-29.6-2.3C253 10.3 231.7 0 208 0s-45 10.3-59.7 26.7c-6.9 7.7-21.4 8.6-29.6 2.3C108 20.9 94.6 16 80 16C44.7 16 16 44.7 16 80s28.7 64 64 64c14.6 0 28-4.9 38.7-13c8.2-6.3 22.7-5.4 29.6 2.3C163 149.7 184.3 160 208 160s45-10.3 59.7-26.7zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z',
    ],
  ],
};
const faBeerFoam = faBeerMug;
const faDiceD20 = {
  prefix: 'fad',
  iconName: 'dice-d20',
  icon: [
    512,
    512,
    [],
    'f6cf',
    [
      'M40.9 112c0 5.3 2.6 10.6 7.8 13.7l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-4.7 3.2-7 8.2-7 13.2zm119.5 40.2c-5.9 10.7 1.8 23.8 14 23.8l163.2 0c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2l-3.2 0c-5.8 0-11.2 3.2-14 8.2l-80 144zm150-140.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1z',
      'M40.2 158C29.6 151.6 16 159.3 16 171.7l0 123.5c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158zm431.5 0l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4l0-123.5c0-12.4-13.6-20.1-24.2-13.7zM464 433.1c0-9.3-8.1-16.5-17.3-15.4L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9l0 52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5zM240 505.2l0-52.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4c3.7 0 6.8-3 6.8-6.8zM30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2zm439.5 24.5c11.8-1.4 18-14.7 11.5-24.6L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20zm-222-13.6c3.7 6.5 13 6.5 16.7 0l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9l-145.7 0c-12.3 0-20 13.3-13.9 23.9l78.4 137.2z',
    ],
  ],
};
const faDrone = {
  prefix: 'fad',
  iconName: 'drone',
  icon: [
    512,
    512,
    [],
    'f85f',
    [
      'M0 112c0 61.9 50.1 112 112 112c17.2 0 33.4-3.9 47.9-10.7l-29.9-39.8c-5.7 1.7-11.8 2.6-18.1 2.6c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 6.3-.9 12.3-2.6 18.1C186.7 140 200 150 213.3 160c6.8-14.6 10.7-30.8 10.7-48C224 50.1 173.9 0 112 0S0 50.1 0 112zM0 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-17.2-3.9-33.4-10.7-47.9l-39.8 29.9c1.7 5.7 2.6 11.8 2.6 18.1c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c6.3 0 12.3 .9 18.1 2.6C140 325.3 150 312 160 298.7c-14.6-6.8-30.8-10.7-48-10.7C50.1 288 0 338.1 0 400zM288 112c0 17.2 3.9 33.4 10.7 47.9l39.8-29.9c-1.7-5.7-2.6-11.8-2.6-18.1c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.3-.9-18.1-2.6C372 186.7 362 200 352 213.3c14.6 6.8 30.8 10.7 48 10.7c61.9 0 112-50.1 112-112S461.9 0 400 0S288 50.1 288 112zm0 288c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.4 3.9-47.9 10.7c10 13.3 19.9 26.6 29.9 39.8c5.7-1.7 11.8-2.6 18.1-2.6c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-6.3 .9-12.3 2.6-18.1C325.3 372 312 362 298.7 352c-6.8 14.6-10.7 30.8-10.7 48z',
      'M80 112c0 16.2 12.1 29.7 27.8 31.7L160 213.3l0 85.3-52.2 69.6C92.1 370.3 80 383.8 80 400c0 17.7 14.3 32 32 32c16.2 0 29.7-12.1 31.7-27.8L213.3 352l85.3 0 69.6 52.2c2.1 15.7 15.5 27.8 31.7 27.8c17.7 0 32-14.3 32-32c0-16.2-12.1-29.7-27.8-31.7L352 298.7l0-85.3 52.2-69.6c15.7-2.1 27.8-15.5 27.8-31.7c0-17.7-14.3-32-32-32c-16.2 0-29.7 12.1-31.7 27.8L298.7 160l-85.3 0-69.6-52.2C141.7 92.1 128.2 80 112 80c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faTruckDroplet = {
  prefix: 'fad',
  iconName: 'truck-droplet',
  icon: [
    640,
    512,
    [],
    'e58c',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm40-242c0 36.5 32.2 66 72 66s72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-3.1-4.1-7.6-6.1-12.1-6.1s-9.1 2-12.1 6.1C175.4 107 136 163 136 190zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L48 416c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zm-208 0c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 107 136 163 136 190c0 36.5 32.2 66 72 66z',
    ],
  ],
};
const faFileCircleXmark = {
  prefix: 'fad',
  iconName: 'file-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e5a1',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faTemperatureArrowUp = {
  prefix: 'fad',
  iconName: 'temperature-arrow-up',
  icon: [
    576,
    512,
    ['temperature-up'],
    'e040',
    [
      'M32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L288 112C288 50.2 237.9 0 176 0S64 50.2 64 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L128 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M480 160l32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288zM224 368c0-20.9-13.4-38.7-32-45.3L192 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48z',
    ],
  ],
};
const faTemperatureUp = faTemperatureArrowUp;
const faMedal = {
  prefix: 'fad',
  iconName: 'medal',
  icon: [
    512,
    512,
    [127941],
    'f5a2',
    [
      'M0 24.6c0 4.8 1.4 9.6 4.1 13.6L124.6 218.9c30.5-34.2 74.2-56.4 123-58.7l.4-.2L161.3 15.5C155.5 5.9 145.1 0 133.9 0L24.6 0C11 0 0 11 0 24.6zM264 160l.4 .2c48.9 2.3 92.5 24.5 123 58.7L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0L378.1 0c-11.2 0-21.7 5.9-27.4 15.5L264 160z',
      'M256 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm30.8-225.5c1.4 2.8 4 4.7 7 5.1l50.1 7.3c7.7 1.1 10.7 10.5 5.2 16l-36.3 35.4c-2.2 2.2-3.2 5.2-2.7 8.3l8.6 49.9c1.3 7.6-6.7 13.5-13.6 9.9l-44.8-23.6c-2.7-1.4-6-1.4-8.7 0l-44.8 23.6c-6.9 3.6-14.9-2.2-13.6-9.9l8.6-49.9c.5-3-.5-6.1-2.7-8.3l-36.3-35.4c-5.6-5.4-2.5-14.8 5.2-16l50.1-7.3c3-.4 5.7-2.4 7-5.1l22.4-45.4c3.4-7 13.3-7 16.8 0l22.4 45.4z',
    ],
  ],
};
const faPersonFairy = {
  prefix: 'fad',
  iconName: 'person-fairy',
  icon: [
    640,
    512,
    [],
    'e608',
    [
      'M0 64l0 48c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448c0 17.7 14.3 32 32 32l16 0c55.9 0 106.6-22 144-57.9l0-73.8c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c.1-1 .2-2.1 .3-3.1s.3-2 .4-3.1c.3-2 .7-4 1.2-6c.9-3.9 2.2-7.8 3.7-11.4c3-7.4 7.1-14.2 12-20.2c9.9-12.1 23.2-21.2 38.3-26C222.5 84.4 133.4 32 32 32C14.3 32 0 46.3 0 64zm366.1 99.6c30.4 9.4 53.2 36.5 56 69.8l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6l0 73.8C421.4 458 472.1 480 528 480l16 0c17.7 0 32-14.3 32-32c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112l0-48c0-17.7-14.3-32-32-32C506.6 32 417.5 84.4 366.1 163.6z',
      'M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zM217.9 233.4c3.5-41.5 38.1-73.4 79.7-73.4l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L384 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z',
    ],
  ],
};
const faBed = {
  prefix: 'fad',
  iconName: 'bed',
  icon: [
    640,
    512,
    [128716],
    'f236',
    [
      'M256 208A80 80 0 1 1 96 208a80 80 0 1 1 160 0zm32-48c0-17.7 14.3-32 32-32l224 0c53 0 96 43 96 96l0 64 0 32-32 0-288 0-32 0 0-32 0-128z',
      'M32 32c17.7 0 32 14.3 32 32l0 256 544 0 32 0 0 32 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32z',
    ],
  ],
};
const faBookCopy = {
  prefix: 'fad',
  iconName: 'book-copy',
  icon: [
    576,
    512,
    [],
    'e0be',
    [
      'M0 192L0 416c0 53 43 96 96 96l224 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0-48 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l74.8 0c-6.9-14.5-10.8-30.8-10.8-48l0-240L96 96C43 96 0 139 0 192z',
      'M288 0c-53 0-96 43-96 96l0 224c0 53 43 96 96 96l224 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L512 0 288 0zm0 288l192 0 0 64-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faSquareH = {
  prefix: 'fad',
  iconName: 'square-h',
  icon: [
    448,
    512,
    ['h-square'],
    'f0fd',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z',
      'M312 128c13.3 0 24 10.7 24 24l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHSquare = faSquareH;
const faSquareC = {
  prefix: 'fad',
  iconName: 'square-c',
  icon: [
    448,
    512,
    [],
    'e266',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 256c0-32.8 12.5-65.5 37.5-90.5s57.8-37.5 90.5-37.5s65.5 12.5 90.5 37.5c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-34 0l-.4-.4c-31.3-30.8-81.6-30.7-112.7 .4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-25 25-57.8 37.5-90.5 37.5s-65.5-12.5-90.5-37.5s-37.5-57.8-37.5-90.5z',
      'M280.6 199.4c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z',
    ],
  ],
};
const faClockTwo = {
  prefix: 'fad',
  iconName: 'clock-two',
  icon: [
    512,
    512,
    [],
    'e35a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7c2.7 4.1 4 8.7 4 13.3c0 7.8-3.8 15.4-10.7 20l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256l0-136z',
      'M256 96c13.3 0 24 10.7 24 24l0 91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256l0-136c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faSquareEllipsisVertical = {
  prefix: 'fad',
  iconName: 'square-ellipsis-vertical',
  icon: [
    448,
    512,
    [],
    'e26f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M192 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faCalendarUsers = {
  prefix: 'fad',
  iconName: 'calendar-users',
  icon: [
    640,
    512,
    [],
    'e5e2',
    [
      'M96 112l0 48 32 0 384 0 32 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L256 64l0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-48 0c-26.5 0-48 21.5-48 48zm32 80l0 1.1c54.3 7.8 96 54.4 96 110.9c0 33.3-14.5 63.2-37.6 83.7C226.6 399.2 256 436.2 256 480c0 11.7-3.1 22.6-8.6 32l145.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-43.8 29.4-80.8 69.6-92.3c-23-20.5-37.6-50.4-37.6-83.7c0-56.4 41.7-103.1 96-110.9l0-1.1-384 0z',
      'M32 304a80 80 0 1 1 160 0A80 80 0 1 1 32 304zM0 480c0-35.3 28.7-64 64-64l96 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM448 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM416 480c0-35.3 28.7-64 64-64l96 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faPodcast = {
  prefix: 'fad',
  iconName: 'podcast',
  icon: [
    448,
    512,
    [],
    'f2ce',
    [
      'M0 224c0 92.5 56 171.8 136 206c-.1-.3-.1-.6-.2-1c-3.1-19.2-6-39.8-7.2-57.1C80.1 340.6 48 286.1 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176c0 62.1-32.1 116.6-80.6 148c-1.2 17.2-4 37.9-7.2 57c-.1 .4-.1 .7-.2 1.1C392 395.9 448 316.5 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224zm80 0c0 44 19.8 83.5 50.9 109.9c1.6-5.7 3.9-11.1 7-16.2c5.8-9.7 13.5-17 21.9-22.4c-19.5-17.6-31.8-43-31.8-71.3c0-53 43-96 96-96s96 43 96 96c0 28.3-12.3 53.8-31.8 71.3c8.4 5.4 16.1 12.7 21.9 22.4c3.1 5.1 5.4 10.5 7 16.2C348.2 307.5 368 268 368 224c0-79.5-64.5-144-144-144S80 144.5 80 224z',
      'M224 168a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM160 355.8c0-35.1 31.1-43.8 64-43.8s64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8z',
    ],
  ],
};
const faBee = {
  prefix: 'fad',
  iconName: 'bee',
  icon: [
    576,
    512,
    [],
    'e0b2',
    [
      'M0 208C0 146.1 57.3 96 128 96c30.5 0 58.5 9.3 80.5 24.9c1.1 9.8 3.9 19 8.2 27.4c2.1 4.2 4.7 8.2 7.5 11.9c1.4 1.9 2.9 3.7 4.5 5.4c.8 .9 1.6 1.7 2.4 2.5s1.7 1.6 2.5 2.4c-37.9 15.5-67.7 46.6-81.4 85.4c-3.6 10.2-6.1 20.9-7.3 32c-.6 5.3-.9 10.6-.9 16c0 5 .4 10 1.1 15c-5.6 .6-11.3 1-17.1 1C57.3 320 0 269.9 0 208zm342.4-37.4c13.7-12.7 22.9-30.2 25.1-49.7c22-15.6 50-24.9 80.5-24.9c70.7 0 128 50.1 128 112s-57.3 112-128 112c-5.8 0-11.5-.3-17.1-1c.3-2.5 .6-5 .8-7.6c.1-1.2 .2-2.5 .2-3.7s.1-2.5 .1-3.7c0-5.4-.3-10.7-.9-16c-1.2-11.1-3.7-21.8-7.3-32c-13.7-38.8-43.5-69.9-81.4-85.4z',
      'M196.7 4.7c6.2-6.2 16.4-6.2 22.6 0l34.8 34.8C264.4 34.7 275.9 32 288 32s23.6 2.7 33.9 7.5L356.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L347.8 58.8C360.4 73 368 91.6 368 112c0 23.2-9.8 44-25.6 58.6c37.9 15.5 67.7 46.6 81.4 85.4l-271.6 0c13.7-38.8 43.5-69.9 81.4-85.4C217.8 156 208 135.2 208 112c0-20.4 7.6-39 20.2-53.2L196.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM144 304c0-5.4 .3-10.7 .9-16l286.2 0c.6 5.3 .9 10.6 .9 16c0 10.5-1.6 21.3-4.6 32l-278.9 0c-2.9-10.7-4.6-21.5-4.6-32zm45.9 112c-11.1-15.2-21.3-31.4-29.2-48l254.6 0c-8 16.6-18.1 32.8-29.2 48l-196.2 0zm84 90.8c-10.8-9.4-34.3-30.9-58.5-58.8l145.1 0c-24.2 27.9-47.8 49.4-58.5 58.8c-3.9 3.4-8.9 5.2-14.1 5.2s-10.2-1.8-14.1-5.2z',
    ],
  ],
};
const faTemperatureFull = {
  prefix: 'fad',
  iconName: 'temperature-full',
  icon: [
    320,
    512,
    ['temperature-4', 'thermometer-4', 'thermometer-full'],
    'f2c7',
    [
      'M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L272 112C272 50.2 221.9 0 160 0S48 50.2 48 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368zm64 0c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L112 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M176 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L176 112z',
    ],
  ],
};
const faTemperature4 = faTemperatureFull;
const faThermometer4 = faTemperatureFull;
const faThermometerFull = faTemperatureFull;
const faBell = {
  prefix: 'fad',
  iconName: 'bell',
  icon: [
    448,
    512,
    [128276, 61602],
    'f0f3',
    [
      'M0 384c0 4.4 .9 8.9 2.8 13.1C8 408.6 19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9c1.9-4.2 2.8-8.7 2.8-13.1c0-7.7-2.8-15.3-8.1-21.3l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3C2.8 368.7 0 376.3 0 384z',
      'M288 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0h64z',
    ],
  ],
};
const faCandyBar = {
  prefix: 'fad',
  iconName: 'candy-bar',
  icon: [
    640,
    512,
    [127851, 'chocolate-bar'],
    'e3e8',
    [
      'M288 64l288 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-288 0 0-96 0-32 0-96 0-32 0-128z',
      'M0 224l0 96 128 0 0-96L0 224zM0 352l0 32c0 35.3 28.7 64 64 64l64 0 0-96L0 352zm160 96l128 0 0-96-128 0 0 96zM288 320l0-96-128 0 0 96 128 0zm0-128l0-128L160 64l0 128 128 0zM44.2 192L96 192s0 0 0 0l32 0 0-32s0 0 0 0l0-51.8c0-7.1-9-11.1-15-7.4C101 107.9 87 112 72 112c-4 0-7.9-.3-11.7-.9c-7-1-14.2 6.2-13.1 13.1c.6 3.8 .9 7.7 .9 11.7c0 15-4.1 29-11.3 41c-3.6 6.1 .4 15 7.4 15z',
    ],
  ],
};
const faChocolateBar = faCandyBar;
const faXmarkLarge = {
  prefix: 'fad',
  iconName: 'xmark-large',
  icon: [
    448,
    512,
    [],
    'e59b',
    [
      'M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z',
      '',
    ],
  ],
};
const faPinata = {
  prefix: 'fad',
  iconName: 'pinata',
  icon: [
    512,
    512,
    [],
    'e3c3',
    [
      'M34.4 190.6c1.4 .7 2.9 1.4 4.3 2.1L112 224c0 10.2 0 20.5 0 30.7c8.6 3.3 17.2 6.6 25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2c25.6-12.8 51.2-25.6 76.8-38.4L240 224l0-25.9-71.4 35.7c-6 3-13.1 3.4-19.3 .9C111 220 72.7 205.3 34.4 190.6zM112 318.1c0 11.9 0 23.8 0 35.8c.8 .4 1.6 .8 2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1c8.9-3.6 17.8-7.1 26.7-10.7c6.4 3.2 12.8 6.4 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6 0-34.5-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1c-8.9 3.6-17.8 7.1-26.7 10.7c-6.4-3.2-12.8-6.4-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1c-8.9 3.6-17.8 7.1-26.7 10.7l-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7c-5.6-2.8-11.2-5.6-16.7-8.4zm0 84c0 11.9 0 23.8 0 35.8c3.2 1.6 6.5 3.2 9.7 4.8c.6 .3 1.1 .5 1.7 .8s1.2 .5 1.7 .7c1.2 .4 2.4 .8 3.6 1.1c2.4 .6 4.9 .8 7.3 .8c4.9 0 9.8-1.1 14.3-3.4l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2c2.5-1.6 4.9-3.3 7.4-4.9c0-11.7 0-23.5 0-35.2c-3.2 0-6.2 .9-8.9 2.7l-16.3 10.8c-5.5-2.8-11-5.5-16.5-8.3c-9-4.5-19.6-4.5-28.6 0c-5.9 2.9-11.8 5.9-17.7 8.8c-8-4-16-8-24-12zM400 400l0 35.2 7.4 4.9c9.6 6.4 21.8 7.1 32.1 2c5.5-2.8 11-5.5 16.5-8.3l17.7 8.8c.6 .3 1.1 .5 1.7 .8s1.2 .5 1.7 .7c1.2 .4 2.4 .8 3.6 1.1c2.4 .6 4.9 .8 7.3 .8c4.9 0 9.8-1.1 14.3-3.4l9.7-4.8 0-35.8-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7z',
      'M112 318.1l0-63.4 25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2L259.8 224l28.2 0 144 0c44.2 0 80 35.8 80 80l0 13.2-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7L112 318.1zm0 35.8l2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6 0 50.5-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7l-176 0c-3.2 0-6.2 .9-8.9 2.7l-16.3 10.8-16.5-8.3c-9-4.5-19.6-4.5-28.6 0L136 414.1l-24-12 0-48.2zm37.3-119.2L34.4 190.6C13.4 179.6 0 157.8 0 133.8L0 128C0 92.7 28.7 64 64 64l112 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 166.1-71.4 35.7c-6 3-13.1 3.4-19.3 .9zM112 437.9l9.7 4.8c9 4.5 19.6 4.5 28.6 0l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2l7.4-4.9 0 44.8c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-42.1zm288-2.7l7.4 4.9c9.6 6.4 21.8 7.1 32.1 2l16.5-8.3 17.7 8.8c9 4.5 19.6 4.5 28.6 0l9.7-4.8 0 42.1c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-44.8zM200 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faFilePpt = {
  prefix: 'fad',
  iconName: 'file-ppt',
  icon: [
    512,
    512,
    [],
    'e64a',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM304 352c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zM176 352c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm208-64c0 8.8 7.2 16 16 16l16 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0-32 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faArrowsFromLine = {
  prefix: 'fad',
  iconName: 'arrows-from-line',
  icon: [
    448,
    512,
    [],
    'e0a4',
    [
      'M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z',
      'M201.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64zM192 384l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0z',
    ],
  ],
};
const faSuperscript = {
  prefix: 'fad',
  iconName: 'superscript',
  icon: [
    512,
    512,
    [],
    'f12b',
    [
      'M0 96C0 78.3 14.3 64 32 64l32 0c10.4 0 20.2 5.1 26.2 13.6L176 200.2 261.8 77.6c6-8.6 15.8-13.6 26.2-13.6l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-15.3 0L215.1 256l89.6 128 15.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-10.4 0-20.2-5.1-26.2-13.6L176 311.8 90.2 434.4C84.2 442.9 74.4 448 64 448l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l15.3 0 89.6-128L47.3 128 32 128C14.3 128 0 113.7 0 96z',
      'M464.8 4.8C474.3 10.6 480 20.9 480 32l0 128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-80c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l32-16c9.9-5 21.7-4.4 31.1 1.4z',
    ],
  ],
};
const faBowlSpoon = {
  prefix: 'fad',
  iconName: 'bowl-spoon',
  icon: [
    512,
    512,
    [129379],
    'e3e0',
    [
      'M0 96c0 53 50.1 96 112 96c48.8 0 90.3-26.7 105.6-64L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L217.6 64C202.3 26.7 160.8 0 112 0C50.1 0 0 43 0 96z',
      'M33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5L33.6 224z',
    ],
  ],
};
const faHexagonCheck = {
  prefix: 'fad',
  iconName: 'hexagon-check',
  icon: [
    512,
    512,
    [],
    'e416',
    [
      'M7.4 256c0 12.4 3.2 24.9 9.6 36l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c6.4-11.1 9.6-23.6 9.6-36s-3.2-24.9-9.6-36L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220c-6.4 11.1-9.6 23.6-9.6 36zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faPlugCircleXmark = {
  prefix: 'fad',
  iconName: 'plug-circle-xmark',
  icon: [
    576,
    512,
    [],
    'e560',
    [
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 67.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.2C87 398 32 333.4 32 256l0-32c-17.7 0-32-14.3-32-32zM64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 96-64 0 0-96zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96-64 0 0-96z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faStarOfLife = {
  prefix: 'fad',
  iconName: 'star-of-life',
  icon: [
    512,
    512,
    [],
    'f621',
    [
      'M208 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 140.9 122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.6 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1 304 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-140.9L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4L208 32z',
      '',
    ],
  ],
};
const faPhoneSlash = {
  prefix: 'fad',
  iconName: 'phone-slash',
  icon: [
    640,
    512,
    [],
    'f3dd',
    [
      'M64 64c0 107.4 37.8 206 100.8 283.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96C222.6 9.4 207.8 0 192 0c-3.5 0-7 .5-10.5 1.4l-88 24C76.1 30.2 64 46 64 64zM234.3 415.6C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3l-91.3 72z',
      'M634.9 9.2c-8.2-10.4-23.3-12.3-33.7-4.1l-592 464c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7z',
    ],
  ],
};
const faTrafficLightStop = {
  prefix: 'fad',
  iconName: 'traffic-light-stop',
  icon: [
    320,
    512,
    [],
    'f63a',
    [
      'M112 112a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z',
    ],
  ],
};
const faPaintRoller = {
  prefix: 'fad',
  iconName: 'paint-roller',
  icon: [
    512,
    512,
    [],
    'f5aa',
    [
      'M160 352l0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-16c0-8.8 7.2-16 16-16l144 0c53 0 96-43 96-96l0-32c0-53-43-96-96-96l0 64c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-144 0c-44.2 0-80 35.8-80 80l0 16c-17.7 0-32 14.3-32 32z',
      'M64 0C28.7 0 0 28.7 0 64l0 64c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 0z',
    ],
  ],
};
const faAccentGrave = {
  prefix: 'fad',
  iconName: 'accent-grave',
  icon: [
    192,
    512,
    [],
    '60',
    [
      'M108.3 204.8L41.2 95c-6-9.8-9.2-21.2-9.2-32.7C32 28.1 59.7 0 93.9 0c29.2 0 54.4 20.4 60.6 49l27.1 126.6C187 200.5 168 224 142.5 224c-14 0-26.9-7.3-34.2-19.2z',
      '',
    ],
  ],
};
const faHandshakeAngle = {
  prefix: 'fad',
  iconName: 'handshake-angle',
  icon: [
    640,
    512,
    ['hands-helping'],
    'f4c4',
    [
      'M224 128l0 9.1L224 256c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c45.3 0 90.7 0 136 0c30.9 0 56 25.1 56 56c0 1 0 2-.1 2.9s-.1 1.9-.2 2.9c-.2 1.9-.5 3.8-.9 5.6c-.8 3.7-1.9 7.2-3.3 10.6l4.5 0c8.5 0 16.6-3.4 22.6-9.4l79-79c10.9-10.9 16.4-25.3 16.4-39.6s-5.5-28.7-16.4-39.6L535.6 24.4C524.7 13.5 510.3 8 496 8s-28.7 5.5-39.6 16.4L416.8 64l-.8 0L297.1 64c-37.3 0-68.1 27.9-72.6 64l-.6 0z',
      'M218.2 128c-38.4 0-73.1 22.9-88.2 58.2L101 253.7 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1l160 0c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16l2.7 0c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.8-5 45.2-27.7 45.2-55c0-30.9-25.1-56-56-56l-136 0 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-128-5.8 0z',
    ],
  ],
};
const faHandsHelping = faHandshakeAngle;
const faCircle0 = {
  prefix: 'fad',
  iconName: 'circle-0',
  icon: [
    512,
    512,
    [],
    'e0ed',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-32c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm48 0l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
      'M160 224c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm96-48c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48z',
    ],
  ],
};
const faDialMedLow = {
  prefix: 'fad',
  iconName: 'dial-med-low',
  icon: [
    576,
    512,
    [],
    'e160',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M158.9 192.4c-46.2 62.6-41 151.3 15.7 208c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-56.7-56.7-145.4-62-208-15.7L304.7 270.4c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L158.9 192.4z',
    ],
  ],
};
const faLocationDot = {
  prefix: 'fad',
  iconName: 'location-dot',
  icon: [
    384,
    512,
    ['map-marker-alt'],
    'f3c5',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm272 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
      'M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z',
    ],
  ],
};
const faMapMarkerAlt = faLocationDot;
const faCrab = {
  prefix: 'fad',
  iconName: 'crab',
  icon: [
    512,
    512,
    [129408],
    'e3ff',
    [
      'M1.7 264.8c4-7.9 13.6-11.1 21.5-7.2L51.8 272l37.5 0c-4.1 10.1-6.9 20.8-8.3 32l-33 0c-2.5 0-4.9-.6-7.2-1.7l-32-16c-7.9-4-11.1-13.6-7.2-21.5zm19 107.8l32-32c1.8-1.8 3.9-3.1 6.3-3.9l21.1-7c0 2.1 0 4.1 0 6.2c6.9 6.9 13.8 13.8 20.7 20.7l-28 9.3L43.3 395.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm32 64l32-32c1.8-1.8 3.9-3.1 6.3-3.9l40.4-13.5c8.4 8.4 16.9 16.9 25.3 25.3l-52 17.3L75.3 459.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM128 464c0-5.6 2.9-10.8 7.8-13.7l36.6-21.9c6.6 6.6 13.1 13.1 19.7 19.7l9.8 0L160 473.1l0 22.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32zm64-320c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48-16 0c-5.4 0-10.8 .3-16 1l0-49zm96 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 49c-2.6-.3-5.3-.6-7.9-.7c-1.3-.1-2.7-.1-4-.2c-1.3 0-2.7-.1-4-.1l-16 0 0-48zm22.2 304l9.8 0 19.7-19.7 36.6 21.9c4.8 2.9 7.8 8.1 7.8 13.7l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-22.9L310.2 448zm45.1-35.4c8.4-8.4 16.9-16.9 25.3-25.3l40.4 13.5c2.4 .8 4.5 2.1 6.3 3.9l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L407.4 430l-52-17.3zm56-56c6.9-6.9 13.8-13.8 20.6-20.6l0-6.2 21.1 7c2.4 .8 4.5 2.1 6.3 3.9l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L439.4 366l-28-9.3zM422.7 272l37.5 0 28.6-14.3c7.9-4 17.5-.7 21.5 7.2c1.1 2.3 1.7 4.7 1.7 7.1c0 5.9-3.2 11.5-8.8 14.3l-32 16c-2.2 1.1-4.7 1.7-7.2 1.7l-33 0c-1.4-11.2-4.2-21.9-8.3-32z',
      'M128 0C60 0 4.4 53 .2 120c0 .2 0 .3 0 .5L0 128l7.9 0c0 0 .1 0 .1 0l-8 0 0 33.3c0 28.1 16.3 53.6 41.8 65.4L98.9 253C86.9 272.5 80 295.4 80 320l0 16L192 448l128 0L432 336l0-16c0-24.6-6.9-47.5-18.9-67l57.1-26.3c25.5-11.8 41.8-37.3 41.8-65.4l0-33.3-8 0c0 0 .1 0 .1 0l7.9 0-.2-7.5c0-.1 0-.3 0-.4c0 0 0 0 0 0s0 0 0 0C507.6 53 452 0 384 0L339.3 0c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c5 5 1.5 13.7-5.7 13.7L328 64c-4.4 0-8.1 3.6-7.5 8c3.9 31.6 30.9 56 63.5 56l80 0 0 33.3c0 9.4-5.4 17.9-13.9 21.8L378.7 216c-21-15.1-46.8-24-74.7-24l-96 0c-27.9 0-53.7 8.9-74.7 24L61.9 183.1C53.4 179.2 48 170.6 48 161.3L48 128l80 0c32.6 0 59.6-24.4 63.5-56c.5-4.4-3.1-8-7.5-8l-36.7 0c-7.1 0-10.7-8.6-5.7-13.7l36.7-36.7c5-5 1.5-13.7-5.7-13.7L128 0z',
    ],
  ],
};
const faBoxOpenFull = {
  prefix: 'fad',
  iconName: 'box-open-full',
  icon: [
    640,
    512,
    ['box-full'],
    'f49c',
    [
      'M13.8 267.8c0-4.8 1.1-9.7 3.4-14.3l41.7-83.4c3-6.1 9.6-9.6 16.3-8.7L320 192c-27.8 46.3-55.6 92.6-83.4 138.9c-7.4 12.4-22.3 18.3-36.2 14.3L64 306.3c-9-2.6-18-5.1-26.9-7.7c-14.3-4.1-23.2-17.1-23.2-30.8zM320 192l244.8-30.6c.7-.1 1.3-.1 2-.1c6 0 11.6 3.4 14.3 8.8l41.7 83.4c9 17.9-.6 39.6-19.8 45.1c-9 2.6-18 5.1-26.9 7.7c-45.5 13-90.9 26-136.4 39c-13.9 4-28.8-1.9-36.2-14.3C375.6 284.6 347.8 238.3 320 192z',
      'M480.9 3.1c24.8 9.3 37.4 37 28.1 61.8l-27.5 73.4L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1 .6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0c69.6 0 126.2 55.6 128 124.7l35.1-93.6c9.3-24.8 37-37.4 61.8-28.1zM236.6 330.9L320 192l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l136.4-39 0 104.2c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 451.7 64 432.5 64 410.5l0-104.2 136.4 39c13.9 4 28.8-1.9 36.2-14.3z',
    ],
  ],
};
const faBoxFull = faBoxOpenFull;
const faFile = {
  prefix: 'fad',
  iconName: 'file',
  icon: [
    384,
    512,
    [128196, 128459, 61462],
    'f15b',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0C28.7 0 0 28.7 0 64z',
      'M224 0L384 160H256c-17.7 0-32-14.3-32-32V0z',
    ],
  ],
};
const faGreaterThan = {
  prefix: 'fad',
  iconName: 'greater-than',
  icon: [
    384,
    512,
    [62769],
    '3e',
    [
      'M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z',
      '',
    ],
  ],
};
const faQuotes = {
  prefix: 'fad',
  iconName: 'quotes',
  icon: [
    576,
    512,
    [],
    'e234',
    [
      'M256 320c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 24 0 24 0 56c0 48.6-39.4 88-88 88l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c13.3 0 24-10.7 24-24l0-8-32 0c-26.5 0-48-21.5-48-48l0-48zm176 0c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 24 0 24 0 56c0 48.6-39.4 88-88 88l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c13.3 0 24-10.7 24-24l0-8-32 0c-26.5 0-48-21.5-48-48l0-48z',
      'M88 0C39.4 0 0 39.4 0 88l0 56 0 24 0 24c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48L64 96l0-8c0-13.3 10.7-24 24-24l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L88 0zM264 0c-48.6 0-88 39.4-88 88l0 56 0 24 0 24c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-32 0 0-8c0-13.3 10.7-24 24-24l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0z',
    ],
  ],
};
const faPretzel = {
  prefix: 'fad',
  iconName: 'pretzel',
  icon: [
    512,
    512,
    [129384],
    'e441',
    [
      'M0 170.6C0 94.1 62.1 32 138.6 32l9.4 0c42.6 0 81 18 108 46.8C283 50 321.4 32 364 32l9.4 0C449.9 32 512 94.1 512 170.6c0 82.7-40.9 155.9-103.7 200.4l32.4 46c12.7 18.1 8.4 43-9.7 55.7c-7 4.9-15 7.3-23 7.3c-12.6 0-25-5.9-32.8-17l-40-56.8c-21.8 6.4-44.9 9.8-68.7 9.8L256 416l-10.6 0c-23.9 0-46.9-3.4-68.7-9.8l-40 56.8c-7.8 11.1-20.2 17-32.7 17c-8 0-16-2.4-23-7.3C62.9 460 58.6 435 71.3 417l32.4-46C40.9 326.5 0 253.3 0 170.6zM32 208a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm48-37.4c0 55.7 27.5 105 69.7 134.9l52.5-74.7c8.9-12.7 13.7-27.9 13.7-43.4l0-7.4c0-37.6-30.4-68-68-68l-9.4 0C106.2 112 80 138.2 80 170.6zM96 80a16 16 0 1 0 32 0A16 16 0 1 0 96 80zm64 288a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm66.8-33c6.1 .7 12.3 1 18.6 1l10.6 0 10.6 0c6.3 0 12.5-.3 18.6-1L256 293.5 226.8 335zM256 144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm40 36l0 7.4c0 15.5 4.8 30.7 13.7 43.4l52.5 74.7c42.2-30 69.7-79.2 69.7-134.9c0-32.4-26.2-58.6-58.6-58.6l-9.4 0c-37.6 0-68 30.4-68 68zm88 252a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-128a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M112 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM432 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM176 352a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM48 192a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM464 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM272 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM400 416a16 16 0 1 0 0 32 16 16 0 1 0 0-32z',
    ],
  ],
};
const faTRex = {
  prefix: 'fad',
  iconName: 't-rex',
  icon: [
    640,
    512,
    [],
    'e629',
    [
      'M0 286.4C0 358 58 416 129.6 416l54.4 0 62.4 83.2c6 8.1 15.5 12.8 25.6 12.8l96 0c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48l-18.6-49.6 28.4-25.6C359.9 360.1 368 342 368 323c0-37-30-67-67-67l-13 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l13 0c35.1 0 66 18.3 83.5 45.8l.4-.3 43.5 29c2.2 1.5 3.6 4 3.6 6.7l0 14.9c0 13.3 10.7 24 24 24s24-10.7 24-24l0-14.9c0-18.7-9.4-36.2-24.9-46.6l-30.2-20.1L464 208l96 0c20.9 0 38.7-13.4 45.3-32l-40 0c-10.6 0-20.8-4.2-28.3-11.7L523.7 151c-4.5-4.5-10.6-7-17-7L488 144c-4.4 0-8-3.6-8-8s3.6-8 8-8l18.7 0c10.6 0 20.8 4.2 28.3 11.7L548.3 153c4.5 4.5 10.6 7 17 7l42.7 0 8 0c13.3 0 24-10.7 24-24l0-24c0-44.2-35.8-80-80-80l-18.7 0C534.7 13.4 516.9 0 496 0c-8.9 0-17.2 2.4-24.3 6.6C461.9 2.3 451.2 0 440.3 0c-33.6 0-63.5 21.5-74.2 53.4L352 96l-32 32-41 0c-70.7 0-132.9 46.3-153.3 114l-5.9 19.8c-4.7 15.5-18.9 26.2-35.1 26.2C64.4 288 48 271.6 48 251.3l0-48.9c0-5.8-4.7-10.4-10.4-10.4c-3.5 0-6.7 1.7-8.7 4.6l-3.2 4.8C9 226.6 0 256.1 0 286.4zM512 56a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M480 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faPersonSwimming = {
  prefix: 'fad',
  iconName: 'person-swimming',
  icon: [
    576,
    512,
    [127946, 'swimmer'],
    'f5c4',
    [
      'M0 384c0 2.4 .3 4.8 .8 7.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 405.7 159 416 192 416c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7C439.4 341.2 410.9 352 384 352c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 341.4 219.5 352 192 352c-26.9 0-55.3-10.8-77.4-26.1c-12-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2C10 356.3 0 369.4 0 384z',
      'M447.9 297.1L309.5 178.4C331.7 166.6 357.1 160 384 160l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-121.8 0-220.9 97.2-223.9 218.2c10.8 4 21.8 6.2 31.9 6.2c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.6-1.1 3.1-2.1 4.8-3zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128z',
    ],
  ],
};
const faSwimmer = faPersonSwimming;
const faArrowDown = {
  prefix: 'fad',
  iconName: 'arrow-down',
  icon: [
    384,
    512,
    [8595],
    'f063',
    [
      'M160 64l0 306.7c10.7 10.7 21.3 21.3 32 32c10.7-10.7 21.3-21.3 32-32L224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7 54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z',
    ],
  ],
};
const faUserRobotXmarks = {
  prefix: 'fad',
  iconName: 'user-robot-xmarks',
  icon: [
    448,
    512,
    [],
    'e4a7',
    [
      'M32 160l0 64c0 17.7 14.3 32 32 32l16 0 0-128-16 0c-17.7 0-32 14.3-32 32zM144 464l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm0 448l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 0l0 48 32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96-336l0 128 16 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-16 0z',
      'M80 128c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-128zm64 128a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM136.5 119.5c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L143 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L160 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L177 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L160 143l-23.5-23.5zm111 0c-4.7 4.7-4.7 12.3 0 17L271 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L288 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L305 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L288 143l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0zM0 448c0-53 43-96 96-96l256 0c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32l-64 0 0-64c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32l0 64-64 0c-17.7 0-32-14.3-32-32l0-32z',
    ],
  ],
};
const faMessageQuote = {
  prefix: 'fad',
  iconName: 'message-quote',
  icon: [
    512,
    512,
    ['comment-alt-quote'],
    'e1e4',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm128 80l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm144 0l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32z',
      'M128 144c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48zm256 87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3z',
    ],
  ],
};
const faCommentAltQuote = faMessageQuote;
const faCandyCorn = {
  prefix: 'fad',
  iconName: 'candy-corn',
  icon: [
    640,
    512,
    [],
    'f6bd',
    [
      'M0 321.7c0 10.4 4 20.7 11.6 28.3c10.1 10.1 27 22 46.3 33.9c15-25 44.8-68.5 95.1-118.8s93.8-80.1 118.8-95.1c-12-19.3-23.8-36.2-33.9-46.3c-12.2-12.2-30.8-15.2-46.2-7.5c-39.6 20.1-75.4 49.9-106.6 81C54 228.4 24.5 264 4.3 303.4c-2.9 5.8-4.3 12-4.3 18.2zM212 464.6c26.3 11.8 51.9 22.2 73.6 29.5c28.6 9.6 68.7 22.2 93.6-2.7s12.2-65 2.7-93.6c-7.3-21.8-17.7-47.3-29.5-73.6c-21.6 16.2-47.3 37.7-75 65.4s-49.2 53.3-65.4 75zM320 56c0 14.3 3.6 34.7 8.7 56.8C357 105.7 408.8 96 480 96s123 9.7 151.3 16.8C636.4 90.7 640 70.3 640 56c0-17.2-11-32.5-27.4-37.9C570.4 4.2 524.1 0 480 0c-44 0-90 4.4-132.2 17.9C331.4 23.4 320 38.8 320 56zm60.7 222.8c10.3 27 21 52.4 31.2 72.9c13.4 27 32.9 64.3 68.1 64.3s54.6-37.3 68.1-64.3c10.2-20.6 20.9-46 31.2-72.9c-26.7-3.8-60.1-6.8-99.3-6.8s-72.5 2.9-99.3 6.8z',
      'M336.4 142.9C365.9 136.1 414.8 128 480 128s114.1 8.1 143.6 14.9c-9 33.1-21 71.2-33.9 107.5c-3.4 9.5-6.9 19-10.4 28.3c-26.7-3.8-60.1-6.8-99.3-6.8s-72.5 2.9-99.3 6.8c-3.5-9.3-7-18.8-10.4-28.3c-12.9-36.3-24.9-74.4-33.9-107.5zM84.6 399.9c16.1-25.7 44.9-66 91-112.1s86.4-74.9 112.1-91c17.1 29.8 35.5 65.2 52 100c4.3 9.2 8.6 18.3 12.7 27.4c-21.6 16.2-47.2 37.7-75 65.4s-49.2 53.3-65.4 75c-9.1-4.1-18.3-8.3-27.4-12.7c-34.8-16.5-70.2-35-100-52z',
    ],
  ],
};
const faFolderMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'folder-magnifying-glass',
  icon: [
    512,
    512,
    ['folder-search'],
    'e18b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM144 272c0-53 43-96 96-96s96 43 96 96c0 17.8-4.9 34.5-13.3 48.9L361 359.2c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-38.4-38.4C274.4 363.2 257.8 368 240 368c-53 0-96-43-96-96zm48 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M322.7 320.9c8.5-14.3 13.3-31 13.3-48.9c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3zM192 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z',
    ],
  ],
};
const faFolderSearch = faFolderMagnifyingGlass;
const faNotebook = {
  prefix: 'fad',
  iconName: 'notebook',
  icon: [
    512,
    512,
    [],
    'e201',
    [
      'M192 0L432 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-240 0L192 0z',
      'M112 0C85.5 0 64 21.5 64 48l0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 80-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 80-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56c0 26.5 21.5 48 48 48l80 0L192 0 112 0z',
    ],
  ],
};
const faCircleWifi = {
  prefix: 'fad',
  iconName: 'circle-wifi',
  icon: [
    512,
    512,
    [],
    'e67d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm87.5-32.5c0-6.6 2.7-13.1 7.9-17.8C137.9 167.3 194.3 144 256 144s118.1 23.3 160.6 61.6c5.3 4.7 7.9 11.3 7.9 17.8c0 5.7-2 11.5-6.2 16.1c-8.9 9.8-24 10.6-33.9 1.8c-34-30.7-79-49.3-128.5-49.3s-94.4 18.6-128.5 49.3c-9.8 8.9-25 8.1-33.9-1.8c-4.1-4.6-6.2-10.3-6.2-16.1zM163.1 309c-8.9-9.8-8.1-25 1.7-33.9C188.9 253.3 220.9 240 256 240s67.1 13.3 91.2 35.1c9.8 8.9 10.6 24.1 1.7 33.9s-24.1 10.6-33.9 1.7c-15.6-14.1-36.3-22.7-59-22.7s-43.4 8.6-59 22.7c-9.8 8.9-25 8.1-33.9-1.7zM288 368a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M256 192c-49.4 0-94.4 18.6-128.5 49.3c-9.8 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9C137.9 167.3 194.3 144 256 144s118.1 23.3 160.6 61.6c9.8 8.9 10.6 24 1.8 33.9s-24 10.6-33.9 1.8c-34-30.7-79-49.3-128.5-49.3zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-27-57.3c-9.8 8.9-25 8.1-33.9-1.7s-8.1-25 1.7-33.9C188.9 253.3 220.9 240 256 240s67.1 13.3 91.2 35.1c9.8 8.9 10.6 24.1 1.7 33.9s-24.1 10.6-33.9 1.7c-15.6-14.1-36.3-22.7-59-22.7s-43.4 8.6-59 22.7z',
    ],
  ],
};
const faDroplet = {
  prefix: 'fad',
  iconName: 'droplet',
  icon: [
    384,
    512,
    [128167, 'tint'],
    'f043',
    [
      'M0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112z',
      'M80 320c8.8 0 16 7.2 16 16c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faTint = faDroplet;
const faBullseyePointer = {
  prefix: 'fad',
  iconName: 'bullseye-pointer',
  icon: [
    512,
    512,
    [],
    'f649',
    [
      'M0 256c0 10.2 .6 20.2 1.8 30.1l62.6-18.4c-.2-3.9-.4-7.8-.4-11.7C64 150 150 64 256 64s192 86 192 192s-86 192-192 192c-3.9 0-7.8-.1-11.7-.4l-18.4 62.6c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zm112-2.3L179.1 234c9.6-33.5 40.4-58 76.9-58c44.2 0 80 35.8 80 80c0 36.5-24.5 67.4-58 76.9l-19.7 67C336.8 398.8 400 334.8 400 256c0-79.5-64.5-144-144-144c-78.8 0-142.8 63.2-144 141.7z',
      'M243.9 248.3L39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3 .7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9z',
    ],
  ],
};
const faEraser = {
  prefix: 'fad',
  iconName: 'eraser',
  icon: [
    576,
    512,
    [],
    'f12d',
    [
      'M38.6 336c0 16.4 6.2 32.8 18.7 45.3l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0c7.4-7.4 14.7-14.7 22.1-22.1c-15.1-15.1-30.2-30.2-45.3-45.3L297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3l-45.3-45.3L57.4 290.7C44.9 303.2 38.6 319.6 38.6 336z',
      'M409.9 393.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0L182.1 166.1l45.3 45.3L364.7 348.7l45.3 45.3z',
    ],
  ],
};
const faHexagonImage = {
  prefix: 'fad',
  iconName: 'hexagon-image',
  icon: [
    512,
    512,
    [],
    'e504',
    [
      'M7.4 256c0 12.4 3.2 24.9 9.6 36l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c6.4-11.1 9.6-23.6 9.6-36s-3.2-24.9-9.6-36L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220c-6.4 11.1-9.6 23.6-9.6 36zm99.7 79.9c17.1-18.7 34.1-37.4 51.2-56.1c4.5-4.9 10.8-7.7 17.4-7.8s13 2.6 17.6 7.4c13 13.5 25.9 27.1 38.9 40.6c23.9-28.7 47.7-57.5 71.6-86.2c4.6-5.5 11.3-8.7 18.5-8.7s13.9 3.2 18.5 8.7c24.2 29.1 48.4 58.3 72.6 87.4c-18.4 31.9-36.8 63.8-55.2 95.7c-2.9 4.9-8.1 8-13.9 8c-58.9 0-117.7 0-176.6 0c-5.7 0-11-3.1-13.9-8c-15.6-27-31.2-54-46.8-81zM232 160a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z',
      'M158.3 279.8l-51.2 56.1 46.8 81c2.9 5 8.1 8 13.9 8l176.6 0c5.7 0 11-3 13.9-8l55.2-95.7-72.6-87.4c-4.6-5.5-11.3-8.7-18.5-8.7s-13.9 3.2-18.5 8.7L232.2 320l-38.9-40.6c-4.6-4.8-11-7.5-17.6-7.4s-13 2.9-17.4 7.8z',
    ],
  ],
};
const faEarthAmericas = {
  prefix: 'fad',
  iconName: 'earth-americas',
  icon: [
    512,
    512,
    [127758, 'earth', 'earth-america', 'globe-americas'],
    'f57d',
    [
      'M0 256C0 397.4 114.6 512 256 512c125.5 0 229.9-90.3 251.8-209.4c-25.5-8.5-51.1-17-76.6-25.5c-9.6-3.2-17.1-10.7-20.2-20.2c-5.9-17.6-11.8-35.2-17.6-52.9c-5.3-15.8 2.5-33 17.8-39.5c23.4-10 46.8-20.1 70.2-30.1C438 54.3 353.3 0 256 0c-4.9 0-9.7 .1-14.6 .4c9.4 17.4 18.8 34.8 28.1 52.3c6.3 11.6 4.7 26-3.9 36c-5.4 6.3-10.7 12.5-16.1 18.8c-10.2 11.9-10.3 29.3-.3 41.3c4.5 5.4 9 10.8 13.6 16.3c5.4 6.5 5.9 15.8 1.2 22.8c-4.8 7.2-13.8 10.2-21.9 7.5L219 187.7c-7-2.3-14.7-1.8-21.3 1.5c-2 1-4 2-5.9 3c-9 4.5-13.3 15-10.2 24.5c1.6 4.7 4.8 8.7 9.2 11.2c11.5 6.6 23 13.2 34.5 19.7c9.7 5.5 20.6 8.4 31.8 8.4c14.4 0 28.7 0 43.1 0c12.7 0 24.9 5.1 33.9 14.1c1.3 1.3 2.6 2.6 3.9 3.9c9 9 14.1 21.2 14.1 33.9l0 8.3c0 17.2-9.2 33.1-24.2 41.7l-8.1 4.6c-15.1 8.7-26.1 23.1-30.3 40c-.9 3.7-1.9 7.5-2.8 11.2c-4.1 16.3-16.5 29.1-32.7 33.8c-15 4.3-29.9-7-29.9-22.6c0-13 0-26 0-39c0-.9 0-1.5-.1-2c0-.7-.1-1.3-.2-2c-.2-1.3-.5-2.7-.8-3.9c-.7-2.6-1.8-5-3.2-7.2c-2.8-4.5-6.8-8.2-11.7-10.7c-9.8-4.9-16-14.9-16-25.9c0-13.3 0-26.6 0-39.9c0-.1 0-.2 0-.3c0-.3 0-.8 0-1.3c0-.6-.1-1.1-.1-1.6c-.1-1.1-.2-2.2-.4-3.3c-.4-2.2-.9-4.2-1.6-6.3c-1.4-4.1-3.4-7.8-5.9-11.2c-5.1-6.8-12.4-11.9-20.9-14.4l-60.4-17.2c-14.6-4.2-27.2-13.4-35.7-26L23.9 147.8C8.6 180.7 0 217.4 0 256z',
      'M241.4 .4C144.9 5.8 62.7 64.7 23.9 147.8l43.1 64.6c8.4 12.6 21.1 21.9 35.7 26L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l16.1-18.8c8.6-10 10.2-24.3 3.9-36L241.4 .4zM481.3 134.3l-70.2 30.1c-15.3 6.6-23 23.7-17.8 39.5l17.6 52.9c3.2 9.6 10.7 17.1 20.2 20.2l76.6 25.5c2.8-15.1 4.2-30.7 4.2-46.6c0-44-11.1-85.5-30.7-121.7z',
    ],
  ],
};
const faEarth = faEarthAmericas;
const faEarthAmerica = faEarthAmericas;
const faGlobeAmericas = faEarthAmericas;
const faFileSvg = {
  prefix: 'fad',
  iconName: 'file-svg',
  icon: [
    512,
    512,
    [],
    'e64b',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM205.7 352c-25.2 0-45.7 20.4-45.7 45.7c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7L176 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l34.3 0c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7l26.3 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-26.3 0zM456 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1-17.9-40-40-40l-16 0zm-152 0c-8.8 0-16 7.2-16 16l0 31.6c0 34.7 10.3 68.7 29.6 97.6l5.1 7.7c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l5.1-7.7c19.3-28.9 29.6-62.9 29.6-97.6l0-31.6c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 31.6c0 23-5.5 45.6-16 66c-10.5-20.3-16-42.9-16-66l0-31.6c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faCrateApple = {
  prefix: 'fad',
  iconName: 'crate-apple',
  icon: [
    512,
    512,
    ['apple-crate'],
    'f6b1',
    [
      'M0 384l0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-80L0 384zm48-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM80 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM432 288a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M160 54.9C160 24.6 184.6 0 214.9 0c5 0 9.1 4.1 9.1 9.1C224 39.4 199.4 64 169.1 64c-5 0-9.1-4.1-9.1-9.1zM32 171.4C32 127.8 52.4 80 96 80c15.6 0 34.1 5.9 47.2 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 19-3.1 36.7-8.4 52.6L40.4 224c-5.4-15.9-8.4-33.6-8.4-52.6zM313 224c4.5-16.4 7-34.1 7-52.6c0-26.1-6-55.1-20.3-78.6c-2.7-4.4-5.7-8.7-9-12.7c15 .6 32.2 6.1 44.6 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 19-3.1 36.7-8.4 52.6L313 224zM406.9 0c5 0 9.1 4.1 9.1 9.1C416 39.4 391.4 64 361.1 64c-5 0-9.1-4.1-9.1-9.1C352 24.6 376.6 0 406.9 0zM48 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faAppleCrate = faCrateApple;
const faPersonBurst = {
  prefix: 'fad',
  iconName: 'person-burst',
  icon: [
    640,
    512,
    [],
    'e53b',
    [
      'M4 219.6c0 1.2 .1 2.4 .4 3.6c1.5 6.4 6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2c.3-1.2 .4-2.4 .4-3.6c0-5.2-2.5-10.1-6.9-13.2l-65.6-45.1L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-4.4 3-6.9 8-6.9 13.2z',
      'M432 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L552 256.9 552 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0z',
    ],
  ],
};
const faGameBoard = {
  prefix: 'fad',
  iconName: 'game-board',
  icon: [
    448,
    512,
    [],
    'f867',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64 0l80 0 80 0 80 0 80 0 0 80 0 80 0 80 0 80-80 0-80 0-80 0-80 0 0-80 0-80 0-80 0-80z',
      'M64 256l0 80h80V256H64zM384 416l0-80H304v80h80zm-240 0h80V336H144v80zM64 96l0 80h80V96H64zm160 80H144v80h80V176zm0 80v80h80V256H224zm160 0V176H304v80h80zM304 96H224v80h80V96z',
    ],
  ],
};
const faHatChef = {
  prefix: 'fad',
  iconName: 'hat-chef',
  icon: [
    512,
    512,
    [],
    'f86b',
    [
      'M0 128c0 7.1 .8 14.4 2.5 21.6C16 224 64 320 64 320c24.8 0 49.6 0 74.4 0L112.2 162.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2L170.9 320l69.1 0 0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160 69.1 0 27.1-162.6c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4L373.6 320c24.8 0 49.6 0 74.4 0c0 0 48-96 61.5-170.4c1.7-7.2 2.5-14.5 2.5-21.6c0-43.7-30-83.3-74.4-93.5C430.3 32.8 423.1 32 416 32c-21.6 0-41.5 7.1-57.6 19.2C335 20.1 297.9 0 256 0s-79 20.1-102.4 51.2C137.6 39.1 117.6 32 96 32c-7.1 0-14.4 .8-21.6 2.5C30 44.7-.1 84.3 0 128z',
      'M64 320H448V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V320z',
    ],
  ],
};
const faHandBackPointRight = {
  prefix: 'fad',
  iconName: 'hand-back-point-right',
  icon: [
    512,
    512,
    [],
    'e1a1',
    [
      'M512 168c0-22.1-17.9-40-40-40l-200 0-7 0-73 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l55.7 0c-1.4-2-3-3.9-4.5-5.8L227.2 71C215 56.4 197 48 178 48L140 48c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l64 0 32 0c26.5 0 48-21.5 48-48c0-12.4-4.7-23.6-12.3-32.1C284.5 366 304 345.3 304 320c0-12.4-4.7-23.6-12.3-32.1C316.5 286 336 265.3 336 240c0-12.3-4.6-23.5-12.2-32L472 208c22.1 0 40-17.9 40-40z',
      '',
    ],
  ],
};
const faDove = {
  prefix: 'fad',
  iconName: 'dove',
  icon: [
    512,
    512,
    [128330],
    'f4ba',
    [
      'M.9 426.8c-1.7 5-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448l74.4 0c88.4 0 160-71.6 160-160l0-160 29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3L400 64c-44.2 0-80 35.8-80 80l0 30.6 0 33.4c-43.1-3.6-118.1-24.1-170.3-76.2c-21.4-21.3-39-48-48.9-81C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8zM416 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M209.2 9.3c-16.7 19.3-42.9 60.1-59.4 121.8c-.1 .2-.1 .5-.2 .7C201.9 183.9 276.9 204.4 320 208l0-33.4C282.2 139.4 250.6 90.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8z',
    ],
  ],
};
const faSnowflakeDroplets = {
  prefix: 'fad',
  iconName: 'snowflake-droplets',
  icon: [
    640,
    512,
    [],
    'e5c1',
    [
      'M96 144c0 11 5.7 21.7 15.9 27.7l25.3 14.8-21.7 5.8c-12.8 3.4-20.4 16.6-17 29.4s16.6 20.4 29.4 17l67.7-18.1L256.5 256l-60.9 35.5-67.7-18.1c-12.8-3.4-26 4.2-29.4 17s4.2 26 17 29.4l21.7 5.8-21.5 12.6 29.3 57 22.7-13.2-5.2 19.3c-3.4 12.8 4.2 26 17 29.4s26-4.2 29.4-17l17.7-66.1L288 311.7l0 70.3-49 49c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l15-15 0 30.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-30.1 15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-49-49 0-70.3 61.4 35.8 17.7 66.1c3.4 12.8 16.6 20.4 29.4 17s20.4-16.6 17-29.4l-5.2-19.3L495 395.1l29.3-57-21.5-12.6 21.7-5.8c12.8-3.4 20.4-16.6 17-29.4s-16.6-20.4-29.4-17l-67.7 18.1L383.5 256l60.9-35.5 67.7 18.1c12.8 3.4 26-4.2 29.4-17s-4.2-26-17-29.4l-21.7-5.8 25.3-14.8c15.3-8.9 20.4-28.5 11.5-43.8s-28.5-20.4-43.8-11.5l-23.6 13.8 5.2-19.3c3.4-12.8-4.2-26-17-29.4s-26 4.2-29.4 17l-17.7 66.1L352 200.3l0-70.3 49-49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-15 15L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 30.1L273 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l49 49 0 70.3-61.4-35.8L208.9 98.4c-3.4-12.8-16.6-20.4-29.4-17s-20.4 16.6-17 29.4l5.2 19.3-23.6-13.8c-15.3-8.9-34.9-3.7-43.8 11.5c-3 5.1-4.4 10.6-4.4 16.1z',
      'M54.7 325.7L7.1 418.1C2.4 427.2 0 437.4 0 447.7C0 483 28.7 512 64 512s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L73.3 325.7c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7zm512 0l-47.5 92.4c-4.7 9.1-7.1 19.3-7.1 29.5c0 35.3 28.7 64.3 64 64.3s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5l-47.5-92.4c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7z',
    ],
  ],
};
const faBatteryEmpty = {
  prefix: 'fad',
  iconName: 'battery-empty',
  icon: [
    576,
    512,
    ['battery-0'],
    'f244',
    [
      'M80 160c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160zM0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176z',
      '',
    ],
  ],
};
const faBattery0 = faBatteryEmpty;
const faGrid4 = {
  prefix: 'fad',
  iconName: 'grid-4',
  icon: [
    448,
    512,
    [],
    'e198',
    [
      'M0 167.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zM0 406.4L0 464c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zM119.5 48l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm0 238.9l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zM238.9 167.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm0 238.9l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zM358.4 48l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16L448 48c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm0 238.9l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16z',
      'M16 32C7.2 32 0 39.2 0 48l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16L16 32zm0 238.9c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zM119.5 167.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zM238.9 48l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zM358.4 167.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm16 222.9c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0z',
    ],
  ],
};
const faSocks = {
  prefix: 'fad',
  iconName: 'socks',
  icon: [
    512,
    512,
    [129510],
    'f696',
    [
      'M0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6l0-80-160 0 0 80c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416zM128 48l0 16 160 0 0-16c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0L176 0c-26.5 0-48 21.5-48 48zm0 48l0 32 160 0 0-32L128 96zM320 64l0 32 192 0 0-32L320 64zm0 64l0 32 192 0 0-32-192 0z',
      'M320 128l192 0 0-32L320 96l0 32zm0 32l0 80c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304l0-144-192 0zM512 64l0-16c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 16 192 0zM128 64l0 32 160 0 0-32L128 64zm160 64l-160 0 0 32 160 0 0-32z',
    ],
  ],
};
const faFaceSunglasses = {
  prefix: 'fad',
  iconName: 'face-sunglasses',
  icon: [
    512,
    512,
    [],
    'e398',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c-2.2 1.2-4.8 1.8-7.5 1.8l-34.7 0-6.6 39.9C450.8 255 430.8 272 407.3 272l-78.7 0c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9l-33.3 0c0 2.6-.2 5.2-.7 7.9l-8 48C226.8 255 206.8 272 183.3 272l-78.7 0c-23.5 0-43.5-17-47.3-40.1L50.7 192 16 192c-.7 0-1.3 0-2-.1s-1.3-.2-1.9-.4c-1.2-.3-2.4-.8-3.6-1.4C3 211.2 0 233.2 0 256zm18.6-96l32.8 0c6.5-18.4 24.1-32 45.3-32l94.7 0c14.4 0 27.1 6.2 35.8 16l57.8 0c8.7-9.8 21.4-16 35.8-16l94.7 0c21.2 0 38.7 13.6 45.3 32l32.8 0C455.4 66.2 363.4 0 256 0S56.6 66.2 18.6 160zM139.9 362.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 362.2 212.6 384 256 384s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 388.1 311.1 416 256 416s-93.8-27.9-116.1-53.5z',
      'M183.3 272l-78.7 0c-23.5 0-43.5-17-47.3-40.1L50.7 192 16 192c-8.8 0-16-7.2-16-16s7.2-16 16-16l35.4 0c6.5-18.4 24.1-32 45.3-32l94.7 0c14.4 0 27.1 6.2 35.8 16l57.8 0c8.7-9.8 21.4-16 35.8-16l94.7 0c21.2 0 38.7 13.6 45.3 32l35.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.7 0-6.6 39.9C450.8 255 430.8 272 407.3 272l-78.7 0c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9l-33.3 0c0 2.6-.2 5.2-.7 7.9l-8 48C226.8 255 206.8 272 183.3 272z',
    ],
  ],
};
const faInbox = {
  prefix: 'fad',
  iconName: 'inbox',
  icon: [
    512,
    512,
    [],
    'f01c',
    [
      'M73 288l51.2 0c12.1 0 23.2 6.8 28.6 17.7c4.8 9.5 9.5 19.1 14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l51.2 0L391 96 121 96c-16 64-32 128-48 192z',
      'M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-92.1c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32L121 32zm0 64l270 0 48 192-51.2 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L73 288 121 96z',
    ],
  ],
};
const faSquare0 = {
  prefix: 'fad',
  iconName: 'square-0',
  icon: [
    448,
    512,
    [],
    'e255',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM128 224c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm48 0l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z',
      'M128 224c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm96-48c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48z',
    ],
  ],
};
const faSection = {
  prefix: 'fad',
  iconName: 'section',
  icon: [
    256,
    512,
    [],
    'e447',
    [
      'M1.7 243c4.8-28 20.6-48.9 41.7-62.5c11.1 7.6 23.8 13.7 36.6 18.7c6.4 2.5 12.8 4.8 19 6.9s12.3 4 18.1 5.8c1.2 .4 2.5 .8 3.7 1.2c17.5 5.5 31.8 10.3 43.1 15.5l-16.4-2.6c-26.7-4.2-48-1.7-62.1 4.3c-12.6 5.4-18.6 13-20.5 22.7c-.8 8.1 .5 12.7 2.1 15.7c1.7 3.3 4.9 7.1 11 11.3c13.8 9.3 34.3 15.6 61.7 23.8l1.4 .4 .6 .2c24 7.2 54.3 16.3 76.9 32.9c1 .8 2.1 1.5 3.1 2.3c11.2 8.8 21.2 20.2 27.6 35.2c4.6 10.8 6.8 22.4 6.8 34.6c0 6.3-.6 12.8-1.7 19.4c-6 35-29.2 58.9-58.5 71.4c-18.6 8-39.8 11.6-62 11.6c-11.6 0-23.4-1-35.4-2.9c-18.8-3.1-48.7-13.3-67.3-19.6c-3.5-1.2-6.7-2.3-9.2-3.1C5.1 480.7-3.9 462.6 1.6 445.8s23.7-25.8 40.5-20.3c3.8 1.3 8 2.7 12.3 4.2c19 6.5 41.4 14.1 54.1 16.2c26.6 4.1 48 1.6 62-4.4c13-5.6 18.9-13.4 20.7-23.5c1.6-9.5 .4-14.9-.9-18.1c-1.4-3.3-4.1-6.9-9.5-10.9c-12.5-9.2-32.2-15.6-59.4-23.8c-1.2-.4-2.5-.7-3.7-1.1c-23.5-7-53-15.8-75.4-31c-12.5-8.5-24.4-19.9-32.3-35.5c-8-15.9-10.7-33.7-8.4-53c.1-.6 .1-1.1 .2-1.7z',
      'M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c22.5 16.1 52.1 25.4 75.6 32.8c0 0 0 0 0 0l3.7 1.2c27.2 8.6 46.8 15.4 59.2 25c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3c24 7.2 54.3 16.3 76.9 32.9c1 .8 2.1 1.5 3.1 2.3c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5z',
    ],
  ],
};
const faSquareThisWayUp = {
  prefix: 'fad',
  iconName: 'square-this-way-up',
  icon: [
    448,
    512,
    ['box-up'],
    'f49f',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm56 78.6c0-4.3 1.6-8.4 4.4-11.6c18.1-20.4 36.2-40.7 54.3-61.1c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6c18.1 20.4 36.2 40.7 54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4L160 192l0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-22.6 0c-9.6 0-17.4-7.8-17.4-17.4zM64 400c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 416c-8.8 0-16-7.2-16-16zM248 174.6c0-4.3 1.6-8.4 4.4-11.6c18.1-20.4 36.2-40.7 54.3-61.1c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6c18.1 20.4 36.2 40.7 54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4L352 192l0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-22.6 0c-9.6 0-17.4-7.8-17.4-17.4z',
      'M73.4 192c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L114.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4L160 192l0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-22.6 0zM352 192l0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-22.6 0c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L306.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4L352 192z',
    ],
  ],
};
const faBoxUp = faSquareThisWayUp;
const faGaugeHigh = {
  prefix: 'fad',
  iconName: 'gauge-high',
  icon: [
    512,
    512,
    [62461, 'tachometer-alt', 'tachometer-alt-fast'],
    'f625',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM448 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M322 142.3c5.3-12.1 19.5-17.6 31.6-12.3s17.6 19.5 12.3 31.6L301.9 307.4C313.1 318.9 320 334.6 320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c.6 0 1.3 0 1.9 0L322 142.3z',
    ],
  ],
};
const faTachometerAlt = faGaugeHigh;
const faTachometerAltFast = faGaugeHigh;
const faSquareAmpersand = {
  prefix: 'fad',
  iconName: 'square-ampersand',
  icon: [
    448,
    512,
    [],
    'e260',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 317.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6l19.2 0c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4l-32.2 0c-36.7 0-66.5-29.8-66.5-66.5zm48 0c0 10.2 8.3 18.5 18.5 18.5l32.2 0c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5c-4.7 3.5-7.5 9-7.5 14.9zm24-125.9c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2l-19.2 0c-8.6 0-15.6 7-15.6 15.6z',
      'M199.6 176l19.2 0c7.3 0 13.2 5.9 13.2 13.2c0 4.2-2 8.1-5.4 10.6L203 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11c0-8.6 7-15.6 15.6-15.6zm37.8 75.4L255 238.5c15.7-11.5 25-29.8 25-49.3c0-33.8-27.4-61.2-61.2-61.2l-19.2 0c-35.1 0-63.6 28.5-63.6 63.6c0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1c-17.1 12.5-27.2 32.4-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5l32.2 0c24.1 0 46.9-10.9 62-29.4L295 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7zm-39.2 28.7l40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8l-32.2 0c-10.2 0-18.5-8.3-18.5-18.5c0-5.9 2.8-11.4 7.5-14.9l30.7-22.5z',
    ],
  ],
};
const faEnvelopeOpenText = {
  prefix: 'fad',
  iconName: 'envelope-open-text',
  icon: [
    512,
    512,
    [],
    'f658',
    [
      'M64 64l0 64.5 0 79.6 0 41.6c57.6 42.6 115.1 85.3 172.7 127.9c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4C332.9 335 390.5 292.3 448 249.7l0-41.6 0-79.6L448 64c0-17.7-14.3-32-32-32l-98.2 0L194.2 32 96 32C78.3 32 64 46.3 64 64zm96 80c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
      'M511.8 202.5c-1.6-18.1-10.9-34.9-25.7-45.8L448 128.5l0 79.6 0 41.6 63.8-47.2zM512 448l0-205.9L294.4 403.3C283.3 411.6 269.8 416 256 416s-27.3-4.4-38.4-12.7L0 242.1 0 448s0 0 0 0c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64c0 0 0 0 0 0zM64 249.7l0-41.6 0-79.6L25.9 156.7C11.1 167.6 1.8 184.4 .2 202.5L64 249.7zM289.5 11.1C279.8 3.9 268.1 0 256 0s-23.8 3.9-33.5 11L194.2 32l123.5 0L289.5 11.1zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
    ],
  ],
};
const faLampDesk = {
  prefix: 'fad',
  iconName: 'lamp-desk',
  icon: [
    512,
    512,
    [],
    'e014',
    [
      'M96 256c0 2.6 .3 5.2 1 7.8L143 448l66 0L163.4 265.8 256 173.3l0-16c-12.4-12.4-24.8-24.8-37.3-37.3L105.4 233.4C99.3 239.4 96 247.6 96 256zm271.1-1.8c10.2 11 24.8 17.8 40.9 17.8c30.9 0 56-25.1 56-56c0-16.2-6.8-30.7-17.8-40.9l-79.1 79.1z',
      'M192 65.9C192 29.5 221.5 0 257.9 0c17.5 0 34.3 6.9 46.6 19.3L349.3 64 480 64c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-192 192c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-130.7-44.7-44.7C198.9 100.2 192 83.4 192 65.9zM32 448l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faHospital = {
  prefix: 'fad',
  iconName: 'hospital',
  icon: [
    640,
    512,
    [127973, 62589, 'hospital-alt', 'hospital-wide'],
    'f0f8',
    [
      'M0 144l0 48 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 224l0 64 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 320 0 464c0 26.5 21.5 48 48 48l112 0 0-416L48 96C21.5 96 0 117.5 0 144zM480 96l0 416 112 0c26.5 0 48-21.5 48-48l0-144-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L480 96z',
      'M208 0c-26.5 0-48 21.5-48 48l0 464 112 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 112 0 0-464c0-26.5-21.5-48-48-48L208 0zM640 224l0-32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0zm0 96l0-32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0zM80 224c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 192l0 32 80 0zm0 96c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 288l0 32 80 0zM312 64l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faHospitalAlt = faHospital;
const faHospitalWide = faHospital;
const faPollPeople = {
  prefix: 'fad',
  iconName: 'poll-people',
  icon: [
    640,
    512,
    [],
    'f759',
    [
      'M384 320l0 64 192 0 0 32-192 0 0 64 208 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-208 0zM480 32l0 64 96 0 0 32-96 0 0 64 112 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L480 32z',
      'M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0zM224 80c0-26.5 21.5-48 48-48H480V192H272c-26.5 0-48-21.5-48-48V80zm0 288c0-26.5 21.5-48 48-48H384V480H272c-26.5 0-48-21.5-48-48V368z',
    ],
  ],
};
const faWhiskeyGlassIce = {
  prefix: 'fad',
  iconName: 'whiskey-glass-ice',
  icon: [
    512,
    512,
    ['glass-whiskey-rocks'],
    'f7a1',
    [
      'M.3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6zM69 96l374 0c-4.7 32-9.3 64-14 96c-10.2 70.1-20.4 140.2-30.7 210.3c-1.1 7.9-7.9 13.7-15.8 13.7l-253 0c-7.9 0-14.7-5.8-15.8-13.7L83 192c-4.7-32-9.3-64-14-96z',
      'M83 192l346 0L398.3 402.3c-1.1 7.9-7.9 13.7-15.8 13.7l-253 0c-7.9 0-14.7-5.8-15.8-13.7L83 192zm93 32c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l48 0c3.4 0 6.6-.5 9.7-1.5c-1.1-4.4-1.7-9-1.7-13.7l0-1.7c0-14.9 5.9-29.1 16.4-39.6L256 272l0-16c0-17.7-14.3-32-32-32l-48 0zm89.4 72.5c-6 6-9.4 14.1-9.4 22.6l0 1.7c0 8.5 3.4 16.6 9.4 22.6l31.2 31.2c6 6 14.1 9.4 22.6 9.4l1.7 0c8.5 0 16.6-3.4 22.6-9.4l31.2-31.2c6-6 9.4-14.1 9.4-22.6l0-1.7c0-8.5-3.4-16.6-9.4-22.6l-31.2-31.2c-6-6-14.1-9.4-22.6-9.4l-1.7 0c-8.5 0-16.6 3.4-22.6 9.4l-31.2 31.2z',
    ],
  ],
};
const faGlassWhiskeyRocks = faWhiskeyGlassIce;
const faWineBottle = {
  prefix: 'fad',
  iconName: 'wine-bottle',
  icon: [
    512,
    512,
    [],
    'f72f',
    [
      'M54.7 278.7c41.8-41.8 83.7-83.7 125.5-125.5c.8-.8 1.7-1.7 2.5-2.5c27.5 27.5 55.1 55.1 82.6 82.6c12.5 12.5 12.5 32.8 0 45.3c-27.6 27.6-55.2 55.2-82.7 82.7c-6.2 6.2-14.4 9.4-22.6 9.4c-4.1 0-8.2-.8-12-2.3c-1.9-.8-3.8-1.8-5.6-2.9c-.9-.6-1.7-1.2-2.6-1.9s-1.6-1.4-2.4-2.2c-27.5-27.5-55.1-55.1-82.6-82.6zM350.1 94.1c10.7-10.7 21.3-21.3 32-32l9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2C399.6 3.1 407.8 0 416 0s16.4 3.1 22.6 9.4l64 64c6.2 6.2 9.4 14.4 9.4 22.6s-3.1 16.4-9.4 22.6c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5c-10.7 10.7-21.3 21.3-32 32c-22.6-22.6-45.3-45.3-67.9-67.9z',
      'M350.1 94.1l67.9 67.9-16.8 16.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l36-36 82.6 82.6c12.5 12.5 32.8 12.5 45.3 0l82.7-82.7c12.5-12.5 12.5-32.8 0-45.3l-82.6-82.6c31.7-30 75.1-40.4 115-31.3c12.6 2.9 26.4 .5 35.5-8.6l16.8-16.8z',
    ],
  ],
};
const faChessRook = {
  prefix: 'fad',
  iconName: 'chess-rook',
  icon: [
    448,
    512,
    [9820],
    'f447',
    [
      'M32 489.4C32 501.9 42.1 512 54.6 512l338.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L368 432 80 432 38.6 473.4c-4.2 4.2-6.6 10-6.6 16z',
      'M32 48l0 144c0 10.1 4.7 19.6 12.8 25.6L96 256 80 432l288 0L352 256l51.2-38.4c8.1-6 12.8-15.5 12.8-25.6l0-144c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 40c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-40c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 40c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-40c0-8.8-7.2-16-16-16L48 32c-8.8 0-16 7.2-16 16zM192 304l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faUserBountyHunter = {
  prefix: 'fad',
  iconName: 'user-bounty-hunter',
  icon: [
    448,
    512,
    [],
    'e2bf',
    [
      'M64 16C64 7.2 71.2 0 80 0L96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 38c-6.7 10.5-12.2 21.9-16.3 34c-2 6.1-3.7 12.3-4.9 18.6c-.6 3.2-1.1 6.4-1.6 9.7c-.2 1.6-.4 3.3-.6 4.9s-.3 3.3-.4 5L65 256.5c-.2 3.5 0 6.9 .6 10.2c-1-3.4-1.6-7-1.6-10.7L64 16zm49.3 236.6c1.8-27.5 3.5-54.9 5.3-82.4c29 16.3 64.2 48.1 71.9 97.8c-25.7-5.1-51.5-10.3-77.2-15.4zM160 472c0-5 2.4-9.8 6.4-12.8l48-36c5.7-4.3 13.5-4.3 19.2 0l48 36c4 3 6.4 7.8 6.4 12.8l0 40-128 0 0-40zm97.5-204c7.6-49.7 42.9-81.5 71.9-97.8l5.3 82.4L257.5 268z',
      'M224 48c46 0 85.4 30 99 72L125 120c13.6-42 52.9-72 99-72zm24 123.5l80.5-15.1 6.2 96.2L248 269.9l0-98.4zm-48 0l0 98.4-86.7-17.3 6.2-96.2L200 171.5zM224 0C143.9 0 77.5 62.2 72.3 142.2L65 256.5c-1.3 20 12.4 37.9 32.1 41.8l100.8 20.2c5.2 1 10.4 1.6 15.7 1.6l20.9 0c5.3 0 10.5-.5 15.7-1.6L351 298.3c19.7-3.9 33.4-21.8 32.1-41.8l-7.4-114.3C370.5 62.2 304.1 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512L160 512l0-40c0-5 2.4-9.8 6.4-12.8l48-36c5.7-4.3 13.5-4.3 19.2 0l48 36c4 3 6.4 7.8 6.4 12.8l0 40 134.4 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352l-179.2 0C60.2 352 0 412.2 0 486.4z',
    ],
  ],
};
const faBarsStaggered = {
  prefix: 'fad',
  iconName: 'bars-staggered',
  icon: [
    512,
    512,
    ['reorder', 'stream'],
    'f550',
    [
      'M64 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32z',
      'M448 96c0-17.7-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32L32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z',
    ],
  ],
};
const faReorder = faBarsStaggered;
const faStream = faBarsStaggered;
const faDiagramSankey = {
  prefix: 'fad',
  iconName: 'diagram-sankey',
  icon: [
    576,
    512,
    [],
    'e158',
    [
      'M0 288c0 17.7 14.3 32 32 32l109.9 0 86.7 144.5c5.8 9.6 16.2 15.5 27.4 15.5l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-269.9 0-57.6-96L544 320c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 256c-17.7 0-32 14.3-32 32z',
      'M294.4 44.8c6-8.1 15.5-12.8 25.6-12.8l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L336 96 249.6 211.2c-6 8.1-15.5 12.8-25.6 12.8L32 224c-17.7 0-32-14.3-32-32s14.3-32 32-32l176 0L294.4 44.8z',
    ],
  ],
};
const faCloudHailMixed = {
  prefix: 'fad',
  iconName: 'cloud-hail-mixed',
  icon: [
    512,
    512,
    [],
    'f73a',
    [
      'M0 480a32 32 0 1 0 64 0A32 32 0 1 0 0 480zm39.7-89.5c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-10.3 24zm82.3 88c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112zM224 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm47.7-89.5c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-10.3 24zm82.3 88c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faCircleUpLeft = {
  prefix: 'fad',
  iconName: 'circle-up-left',
  icon: [
    512,
    512,
    [],
    'e128',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-80c0-8.8 7.2-16 16-16l137.4 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L296 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C322 366 317.1 368 312 368s-10-2-13.7-5.7L232 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6L160 176z',
      'M160 176l0 137.4c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L232 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L296 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16c0-12.5-10.1-22.6-22.6-22.6L176 160c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faDharmachakra = {
  prefix: 'fad',
  iconName: 'dharmachakra',
  icon: [
    512,
    512,
    [9784],
    'f655',
    [
      'M0 256c0-17.9 15.2-32.1 33-30.9l1.1 .1c-.7 5-1.2 10.1-1.6 15.3c-.2 2.6-.3 5.2-.4 7.7c0 1.3-.1 2.6-.1 3.9s0 2.6 0 3.9c0 10.5 .7 20.8 2.1 30.8l-1.1 .1c-17.9 1.2-33-13-33-30.9zM75 75c12.7-12.7 33.4-12 45.2 1.5l.7 .8c-16.5 12.5-31.1 27.1-43.6 43.6l-.8-.7C63 108.4 62.3 87.6 75 75zm0 362c-12.7-12.7-12-33.4 1.5-45.2l.8-.7c12.5 16.5 27.1 31.1 43.6 43.6l-.7 .8C108.4 449 87.6 449.7 75 437zM96 256c0-9 .8-17.9 2.2-26.6l64.4 4.3c-.8 3.6-1.5 7.2-1.9 10.9c-.2 1.9-.4 3.7-.5 5.6c-.1 .9-.1 1.9-.1 2.8s0 1.9 0 2.9c0 7.7 .9 15.1 2.6 22.3l-64.4 4.3C96.8 273.9 96 265 96 256zm29.6-92.8c10.3-14.5 23-27.2 37.6-37.6l42.5 48.6c-12.8 7.9-23.6 18.7-31.5 31.5l-48.6-42.5zm0 185.6l48.6-42.5c7.9 12.8 18.7 23.6 31.5 31.5l-42.5 48.6c-14.5-10.3-27.2-23-37.6-37.6zM225.1 33c-1.2-17.9 13-33 30.9-33s32.1 15.2 30.9 33l-.1 1.1c-5-.7-10.1-1.2-15.3-1.6c-2.6-.2-5.2-.3-7.7-.4c-1.3 0-2.6-.1-3.9-.1s-2.6 0-3.9 0c-10.5 0-20.8 .7-30.8 2.1l-.1-1.1zm.1 444.9c5 .7 10.1 1.2 15.3 1.6c2.6 .2 5.1 .3 7.7 .4c1.3 0 2.6 .1 3.9 .1s2.6 0 3.9 0c10.5 0 20.8-.7 30.9-1.6l0 .5c1.2 17.9-13 33-30.9 33s-32.1-15.2-30.9-33c0-.4 0-.7 .1-1.1zm4.3-379.7C238.1 96.8 247 96 256 96s17.9 .8 26.6 2.2l-4.3 64.4c-3.6-.8-7.2-1.5-10.9-1.9c-1.9-.2-3.7-.4-5.6-.5c-.9-.1-1.9-.1-2.8-.1s-1.9 0-2.9 0c-7.7 0-15.1 .9-22.3 2.6l-4.3-64.4zm0 315.6l4.3-64.4c3.6 .8 7.2 1.5 10.9 1.9c1.9 .2 3.7 .4 5.6 .5c.9 .1 1.9 .1 2.8 .1s1.9 0 2.9 0c7.7 0 15.1-.9 22.3-2.6l4.3 64.4c-8.6 1.4-17.5 2.2-26.6 2.2s-17.9-.8-26.6-2.2zm76.9-239.6l42.5-48.6c14.5 10.3 27.2 23 37.6 37.6l-48.6 42.5c-7.9-12.8-18.7-23.6-31.5-31.5zm0 163.6c12.8-7.9 23.6-18.7 31.5-31.5l48.6 42.5c-10.3 14.5-23.1 27.2-37.6 37.6l-42.5-48.6zm43.1-104l64.4-4.3c1.4 8.6 2.2 17.5 2.2 26.6s-.8 17.9-2.2 26.6l-64.4-4.3c.8-3.6 1.5-7.2 1.9-10.9c.2-1.9 .4-3.7 .5-5.6c.1-.9 .1-1.9 .1-2.8s0-1.9 0-2.9c0-7.7-.9-15.1-2.6-22.3zM391.1 77.3l.7-.8C403.6 63 424.4 62.3 437 75s12 33.4-1.5 45.2l-.8 .7c-12.5-16.5-27.1-31.1-43.6-43.6zm0 357.4c16.5-12.5 31.1-27.1 43.6-43.6l.8 .7c13.5 11.8 14.2 32.5 1.5 45.2s-33.4 12-45.2-1.5l-.7-.8zm86.8-209.5l1.1-.1c17.9-1.2 33 13 33 30.9s-15.2 32.1-33 30.9c-.4 0-.7 0-1.1-.1c.7-5 1.2-10.1 1.6-15.3c.2-2.6 .3-5.1 .4-7.7c0-1.3 .1-2.6 .1-3.9s0-2.6 0-3.9c0-10.5-.7-20.8-2.1-30.8z',
      'M256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 384a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm96-224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faObjectsAlignLeft = {
  prefix: 'fad',
  iconName: 'objects-align-left',
  icon: [
    512,
    512,
    [],
    'e3be',
    [
      'M128 112c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm0 224c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z',
      'M24 0C10.7 0 0 10.7 0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24L48 24C48 10.7 37.3 0 24 0z',
    ],
  ],
};
const faOilCanDrip = {
  prefix: 'fad',
  iconName: 'oil-can-drip',
  icon: [
    640,
    512,
    [],
    'e205',
    [
      'M160 96c0 17.7 14.3 32 32 32l32 0 0 32 64 0 0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64c-17.7 0-32 14.3-32 32zM544 400c0 26.5 21.5 48 48 48s48-16 48-48c0-21-20.6-62.6-34.9-88.8c-5.8-10.6-20.5-10.6-26.3 0C564.6 337.4 544 379 544 400z',
      'M368.9 160c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7L144 416c-26.5 0-48-21.5-48-48l0-21.3-67.5-30C11.2 309 0 291.8 0 272.8L0 208c0-26.5 21.5-48 48-48l48 0 48 0 224.9 0zM96 208l-48 0 0 64.8 48 21.3L96 208z',
    ],
  ],
};
const faFaceSmilingHands = {
  prefix: 'fad',
  iconName: 'face-smiling-hands',
  icon: [
    640,
    512,
    [],
    'e396',
    [
      'M64.3 242.6C71.3 107.5 183.1 0 320 0S568.7 107.5 575.7 242.6c-16.8-5.8-36.2-2-49.6 11.4L479 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52l0 19.2c-16.8 10.6-38.1 18.4-64 18.4s-47.2-7.7-64-18.4l0-19.2c0-28.7-23.3-52-52-52c-17.9 0-33.6 9-43 22.7l-47.1-47.1c-13.4-13.4-32.8-17.2-49.6-11.4zm120-25.3c-.1 1.1-.2 2.2-.2 3.3s-.1 2.2-.1 3.2c0 .6 0 1 .1 1.4s.2 .8 .3 1.2c.3 .8 .6 1.5 1.1 2.2c1 1.3 2.3 2.4 4 2.9c3.3 1.1 6.9 0 8.9-2.8l.2-.3c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .3c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-5 6.6-9.1 14.4-12 22.7c-1.5 4.2-2.6 8.5-3.4 12.8c-.4 2.2-.7 4.4-.9 6.6zm44.6 278c17-21.6 27.1-48.9 27.1-78.5l0-30.8c18.1 8.4 39.4 14 64 14s45.9-5.6 64-14l0 30.8c0 29.6 10.1 56.9 27.1 78.5c-28.3 10.8-59 16.7-91.1 16.7s-62.8-5.9-91.1-16.7zM344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.3c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .3c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224z',
      'M281.6 228.8s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zM68.7 276.7c-6.2 6.2-6.2 16.4 0 22.6L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2l0-32.8 0-53.6c0-11-9-20-20-20s-20 9-20 20l0 19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0zm502.6 0c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6zM441.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
    ],
  ],
};
const faBroccoli = {
  prefix: 'fad',
  iconName: 'broccoli',
  icon: [
    512,
    512,
    [129382],
    'e3e2',
    [
      'M112 352l112 0 0 .9c0 9.9 2.3 19.7 6.8 28.6l18.1 36.2c2.9 5.9 11.4 5.9 14.3 0l18.1-36.2c4.4-8.9 6.8-18.7 6.8-28.6l0-.9 112 0s-47.7 54.5-80.2 138.3c-5 12.8-17.1 21.7-30.9 21.7l-65.9 0c-13.8 0-25.9-8.9-30.9-21.7C159.7 406.5 112 352 112 352z',
      'M416 352L96 352c-53 0-96-43-96-96c0-45.5 31.6-83.6 74.1-93.5C67.7 152.6 64 140.7 64 128c0-35.3 28.7-64 64-64c12.7 0 24.6 3.7 34.5 10.1C172.4 31.6 210.5 0 256 0s83.6 31.6 93.5 74.1C359.4 67.7 371.3 64 384 64c35.3 0 64 28.7 64 64c0 12.7-3.7 24.6-10.1 34.5c42.5 9.9 74.1 48 74.1 93.5c0 53-43 96-96 96z',
    ],
  ],
};
const faRouteInterstate = {
  prefix: 'fad',
  iconName: 'route-interstate',
  icon: [
    512,
    512,
    [],
    'f61b',
    [
      'M21.2 192l469 0c-.8 51.2-9 97.7-27.2 139.8c-32.5 75.1-94.6 130.9-190.3 175.7c-10.2 4.8-22.1 5-32.5 .6c-98.4-41.4-161-97.6-193-173.9C29.3 291.5 21.7 244 21.2 192z',
      'M235.1 7.3c12.8-7.8 29-7.8 41.8 0c27.5 16.8 50.2 26 73.4 30c23.3 4 49.2 3.2 83.7-3.2c22.1-4.1 43.6 11 46.9 33.6c6.5 44.2 10 85.6 9.4 124.3l-469 0c-.3-38.9 3.4-80.4 9.8-124.3C34.4 45 55.9 30 78 34.1c34.4 6.3 60.3 7.2 83.7 3.2c23.2-4 45.9-13.2 73.4-30z',
    ],
  ],
};
const faEarMuffs = {
  prefix: 'fad',
  iconName: 'ear-muffs',
  icon: [
    640,
    512,
    [],
    'f795',
    [
      'M96 224l0 34.7c.6 .2 1.1 .4 1.7 .6C103.2 239 121.9 224 144 224c.7 0 1.4 0 2.1 0s1.4 .1 2.1 .1c1.4 .1 2.7 .3 4.1 .5c2.7 .5 5.3 1.1 7.8 2l0-2.7c0-88.4 71.6-160 160-160s160 71.6 160 160l0 2.7c5-1.8 10.4-2.7 16-2.7c22.1 0 40.8 15 46.3 35.4c.5-.2 1.1-.4 1.7-.6l0-34.7C544 100.3 443.7 0 320 0S96 100.3 96 224z',
      'M192 272c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48c-22.1 0-40.8-15-46.3-35.4C92.2 478.8 86.2 480 80 480c-26.5 0-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3C33.2 316.2 32 310.2 32 304c0-26.5 21.5-48 48-48c6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48zm256 0c0-26.5 21.5-48 48-48c22.1 0 40.8 15 46.3 35.4c5.5-2.2 11.4-3.4 17.7-3.4c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7c0 26.5-21.5 48-48 48c-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32z',
    ],
  ],
};
const faHotdog = {
  prefix: 'fad',
  iconName: 'hotdog',
  icon: [
    512,
    512,
    [127789],
    'f80f',
    [
      'M23.4 375.4c5.3-5.3 10.7-10.7 16-16c106.7-106.7 213.3-213.3 320-320c5.3-5.3 10.7-10.7 16-16c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-16 16-320 320-16 16c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1zm53.3 13.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4z',
      'M495 257L257 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-22.5-22.5 320-320L495 175c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41zM359.4 39.4l-320 320L17 337C6.1 326.1 0 311.4 0 296s6.1-30.1 17-41L255 17C265.9 6.1 280.6 0 296 0s30.1 6.1 41 17l22.5 22.5zm83.9 75.9c-19.5 19.5-38.9 23.6-54.4 26.4l-.9 .2c-14.7 2.7-23.5 4.3-32.7 13.4c-9.6 9.6-12.3 20.5-15.7 36.1l-.2 1c-3.2 14.9-7.4 34.2-24.1 50.9s-36 20.9-50.9 24.1l-1 .2c-15.6 3.4-26.4 6-36.1 15.7s-12.3 20.5-15.7 36.1l-.2 1c-3.2 14.9-7.4 34.2-24.1 50.9c-16.4 16.4-34.2 19.5-48 22l-2.5 .4c-13.7 2.5-25.1 5.1-37.5 17.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c19.5-19.5 38.9-23.6 54.4-26.4l.9-.2s0 0 0 0c14.7-2.7 23.5-4.3 32.7-13.4c9.6-9.6 12.3-20.5 15.7-36.1l.2-1c3.2-14.9 7.4-34.2 24.1-50.9s36-20.9 50.9-24.1l1-.2c15.6-3.4 26.4-6 36.1-15.7s12.3-20.5 15.7-36.1l.2-1s0 0 0 0c3.2-14.9 7.4-34.2 24.1-50.9c16.4-16.4 34.2-19.5 48-22l2.5-.4c13.7-2.5 25.1-5.1 37.5-17.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faTransporterEmpty = {
  prefix: 'fad',
  iconName: 'transporter-empty',
  icon: [
    512,
    512,
    [],
    'e046',
    ['', 'M96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z'],
  ],
};
const faPersonWalkingWithCane = {
  prefix: 'fad',
  iconName: 'person-walking-with-cane',
  icon: [
    512,
    512,
    ['blind'],
    'f29d',
    [
      'M332.6 334.3c5.7-1.5 11.2-4.2 16.2-7.9c4-3 7.4-6.5 10.1-10.3L477.2 486.9c1.9 2.8 2.8 6 2.8 9.1c0 5.1-2.4 10.1-6.9 13.2c-7.3 5-17.2 3.2-22.3-4L332.6 334.3z',
      'M128 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM81.7 181.1C98 148.5 131.2 128 167.6 128l24.4 0c30.2 0 58.7 14.2 76.8 38.4l76.8 102.4c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L224 213.3l0 93.4 49.9 49.9c9 9 14.1 21.2 14.1 33.9l0 89.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L146.7 320c-12-12-18.7-28.3-18.7-45.3l0-43.2L92.6 302.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l46.3-92.6zM97 472.2l31.4-125.4 52.8 52.8-22 88.2c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8z',
    ],
  ],
};
const faBlind = faPersonWalkingWithCane;
const faAngle90 = {
  prefix: 'fad',
  iconName: 'angle-90',
  icon: [
    448,
    512,
    [],
    'e08d',
    [
      'M96 97.6l0 48.3c36.9 4.3 71.6 16 102.4 33.6l27.4-39.6C187 117.1 143 102.2 96 97.6zm129.3 99.4c29.4 21.6 54.2 49.1 72.9 80.5l41.7-23.8c-22.2-37.7-52-70.5-87.2-96.2l-27.3 39.5zm87.6 109c10.8 24.3 18.1 50.6 21.3 78l48.3 0c-3.6-36.1-13.2-70.4-27.7-102L312.8 306z',
      'M32 32c17.7 0 32 14.3 32 32l0 352 352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32z',
    ],
  ],
};
const faRectangleTerminal = {
  prefix: 'fad',
  iconName: 'rectangle-terminal',
  icon: [
    512,
    512,
    [],
    'e236',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96.4 67.7c-.1 .7-.2 1.4-.3 2.2s-.1 1.4-.1 2.1c0 1.7 .2 3.3 .5 4.9s.8 3.2 1.5 4.7c1.3 3 3.2 5.8 5.8 8.2L180.5 256l-76.7 70.3c-2.6 2.4-4.5 5.2-5.8 8.2c-.7 1.5-1.1 3.1-1.5 4.7s-.5 3.2-.5 4.8c0 .8 0 1.5 .1 2.2s.2 1.4 .3 2.2c.3 1.4 .7 2.8 1.2 4.2c1 2.8 2.6 5.4 4.7 7.7c9 9.8 24.1 10.4 33.9 1.5c32-29.3 64-58.7 96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7c-32-29.3-64-58.7-96-88c-4.6-4.2-10.4-6.3-16.2-6.3c-6.5 0-13 2.6-17.7 7.8c-2.1 2.3-3.7 4.9-4.7 7.7c-.5 1.4-.9 2.8-1.2 4.2zM224 360c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z',
      'M103.8 185.7c-9.8-9-10.4-24.1-1.5-33.9s24.1-10.4 33.9-1.5l96 88c5 4.5 7.8 11 7.8 17.7s-2.8 13.1-7.8 17.7l-96 88c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L180.5 256l-76.7-70.3zM248 336l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faKite = {
  prefix: 'fad',
  iconName: 'kite',
  icon: [
    640,
    512,
    [129665],
    'f6f4',
    [
      'M0 152c0 13.3 10.7 24 24 24l8 0c22.1 0 40 17.9 40 40l0 68c3.2 1.6 6.5 3.2 9.7 4.8c9 4.5 19.6 4.5 28.6 0L120 284l0-68c0-48.6-39.4-88-88-88l-8 0c-13.3 0-24 10.7-24 24zM72 324l0 124.4c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L266 407.9c1.8-.1 3.5-.4 5.2-.8l344-80c7.9-1.8 14.6-6.6 19-12.9C582.8 262.8 531.4 211.4 480 160c-53 53-106 106-159 159c-26.5 26.5-53.1 53.1-79.6 79.6c-.4-.4-.8-.8-1.2-1.3s-.8-.9-1.1-1.3c-.7-.9-1.4-1.8-2-2.8c-1.2-1.9-2.2-3.9-3-6c-1.6-4.2-2.3-8.7-2-13.3l-85.4 85.4c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6L120 324l-9.7-4.8c-9-4.5-19.6-4.5-28.6 0L72 324zM325.7 5.7C377.2 57.2 428.6 108.6 480 160C530.2 109.8 580.4 59.6 630.6 9.4C624.8 3.6 616.8 0 608 0L344 0c-6.7 0-13 2.1-18.3 5.7z',
      'M312.8 24.8c1.8-7.9 6.6-14.6 12.9-19L480 160 241.4 398.6c-7.8-7.8-11-19.1-8.5-29.9l80-344zM480 160L630.6 9.4c5.8 5.8 9.4 13.8 9.4 22.6l0 264c0 6.7-2.1 13-5.7 18.3L480 160zM0 268.9C0 261.8 5.8 256 12.9 256c2 0 4 .5 5.8 1.4l63 31.5c9 4.5 19.6 4.5 28.6 0l63-31.5c1.8-.9 3.8-1.4 5.8-1.4c7.1 0 12.9 5.8 12.9 12.9l0 70.1c0 7.1-5.8 12.9-12.9 12.9c-2 0-4-.5-5.8-1.4l-63-31.5c-9-4.5-19.6-4.5-28.6 0l-63 31.5c-1.8 .9-3.8 1.4-5.8 1.4C5.8 352 0 346.2 0 339.1l0-70.1z',
    ],
  ],
};
const faDrum = {
  prefix: 'fad',
  iconName: 'drum',
  icon: [
    512,
    512,
    [129345],
    'f569',
    [
      'M72 344l0 102.7c14.3 6.4 30.5 12 48 16.7L120 344c0-13.3-10.7-24-24-24s-24 10.7-24 24zm160 32l0 103.5c7.9 .3 15.9 .5 24 .5s16.1-.2 24-.5L280 376c0-13.3-10.7-24-24-24s-24 10.7-24 24zm3.9-154.8c7.3 11.1 22.1 14.2 33.2 6.9c37-24.3 74.1-48.5 111.1-72.8l53-34.7c22.6-14.8 45.3-29.7 67.9-44.5c7-4.6 10.8-12.3 10.8-20.1c0-4.5-1.3-9.1-3.9-13.1c-7.3-11.1-22.1-14.2-33.2-6.9C440 58.8 405.1 81.6 370.2 104.5c-20.9 13.7-41.9 27.4-62.8 41.1c-21.5 14.1-43 28.2-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2zM392 344l0 119.4c17.5-4.7 33.7-10.3 48-16.7L440 344c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208L0 368c0 31.3 27.4 58.8 72 78.7L72 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 119.4c33 8.9 71.1 14.5 112 16.1L232 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 103.5c40.9-1.6 79-7.2 112-16.1L392 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.7c44.6-19.9 72-47.4 72-78.7l0-160c0-41.1-30.2-69.5-78.8-87.4l-53 34.7c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6l62.8-41.1z',
    ],
  ],
};
const faScrubber = {
  prefix: 'fad',
  iconName: 'scrubber',
  icon: [
    512,
    512,
    [],
    'f2f8',
    [
      'M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    ],
  ],
};
const faIceCream = {
  prefix: 'fad',
  iconName: 'ice-cream',
  icon: [
    448,
    512,
    [127848],
    'f810',
    [
      'M32 208c0 26.5 21.5 48 48 48l53.5 0 181 0 53.5 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-.9 0c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16l-.9 0c-26.5 0-48 21.5-48 48z',
      'M199.8 495.6L80 256H372.6L252.7 495.6c-5 10-15.3 16.4-26.5 16.4s-21.5-6.3-26.5-16.4z',
    ],
  ],
};
const faHeartCircleBolt = {
  prefix: 'fad',
  iconName: 'heart-circle-bolt',
  icon: [
    576,
    512,
    [],
    'e4fc',
    [
      'M0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2z',
    ],
  ],
};
const faFishBones = {
  prefix: 'fad',
  iconName: 'fish-bones',
  icon: [
    576,
    512,
    [],
    'e304',
    [
      'M2.5 138.6L54.9 245.4c3.3 6.7 3.3 14.5 0 21.2L2.5 373.4c-5 10.1-2.2 22.3 6.6 29.3c4.4 3.5 9.7 5.2 15 5.2c5.4 0 10.7-1.8 15.1-5.3l48-38.9c5.6-4.6 8.9-11.4 8.9-18.7L96 320c0-13.3 0-26.7 0-40l0-48 0-40c0-8.4 0-16.8 0-25.1c0-7.2-3.3-14.1-8.9-18.7l-48-38.9c-4.4-3.6-9.8-5.3-15.1-5.3c-5.3 0-10.6 1.7-15 5.2c-8.8 7-11.5 19.2-6.6 29.3zM416 130.9L416 232l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 101.1c0 16.9 17.1 28.4 31.8 20c16-9.1 30.6-19.7 43.7-30.7c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8c-13.1-11-27.7-21.6-43.7-30.7c-14.7-8.4-31.8 3.1-31.8 20z',
      'M184 160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0 48 40 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0 0-72z',
    ],
  ],
};
const faDeerRudolph = {
  prefix: 'fad',
  iconName: 'deer-rudolph',
  icon: [
    576,
    512,
    [],
    'f78f',
    [
      'M224 16l0 24c0 30.9 25.1 56 56 56l8 0 8 0 24 0 32 0c8.8 0 16-7.2 16-16c0-5.6-2.9-10.6-7.3-13.5c-2.5-1.6-5.5-2.5-8.7-2.5l-5.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16zM393.4 65.4c18 3.2 34.9 11.6 48.3 24.4C459.7 80.4 472 61.7 472 40l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-16 0c-2.3 0-4.6 .5-6.6 1.4zM480 136a40 40 0 1 0 80-.1 40 40 0 1 0 -80 .1z',
      'M320 96l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18l38 0-9.6 32-106.1 0c-.8 0-1.7 0-2.5 0c-.6 0-1.2 0-1.7 0l-64 0-14.1 0-7.9 0C51.7 176 6.6 217.8 2.4 272L.1 302.2c-1 13.2 8.9 24.8 22.1 25.8c13 1 24.4-8.6 25.7-21.5c2.4 3.3 5.2 6.5 8.1 9.5c9 9 9 23.5 2.4 34.4c-17.4 28.6-21.5 63.9-10 96.3l15.5 44C68.4 503.4 80.5 512 94.1 512l33.9 0c22.1 0 37.5-21.8 30.2-42.6l-19.3-54.7c-2.2-6.2-.6-13 4-17.7l10.6-10.6c12.1-12.1 19.8-27.9 21.9-44.8c21 16.5 47.5 26.4 76.3 26.4l36.3 0 0 112c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-112 0-64 26.7-80 5.3 0 50.7 0c25 0 45.3-20.3 45.3-45.3c0-1.2 0-2.4-.1-3.6C493.7 171.4 480 155.3 480 136c0-2.5 .2-5 .7-7.3L443.4 91.4C425.9 73.9 402.1 64 377.3 64c-5.7 0-11.3 .9-16.6 2.5c4.4 2.8 7.3 7.8 7.3 13.5c0 8.8-7.2 16-16 16l-32 0zm80 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faFax = {
  prefix: 'fad',
  iconName: 'fax',
  icon: [
    512,
    512,
    [128224, 128439],
    'f1ac',
    [
      'M128 64l0 128 352 0 0-101.5c0-17-6.7-33.3-18.7-45.3L434.7 18.7C422.7 6.7 406.5 0 389.5 0L192 0c-35.3 0-64 28.7-64 64zm96 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M32 128c-17.7 0-32 14.3-32 32L0 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32l-32 0zm448 64l-352 0 0 288c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faParagraph = {
  prefix: 'fad',
  iconName: 'paragraph',
  icon: [
    448,
    512,
    [182],
    'f1dd',
    [
      'M320 96l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352-64 0z',
      'M192 32l64 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L288 96l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0c-88.4 0-160-71.6-160-160s71.6-160 160-160z',
    ],
  ],
};
const faHeadSideHeart = {
  prefix: 'fad',
  iconName: 'head-side-heart',
  icon: [
    512,
    512,
    [],
    'e1aa',
    [
      'M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm128-35c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
      'M189.3 128c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z',
    ],
  ],
};
const faSquareE = {
  prefix: 'fad',
  iconName: 'square-e',
  icon: [
    448,
    512,
    [],
    'e26d',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 56c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104z',
      'M128 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104z',
    ],
  ],
};
const faMeterFire = {
  prefix: 'fad',
  iconName: 'meter-fire',
  icon: [
    640,
    512,
    [],
    'e1eb',
    [
      'M0 256C0 397.4 114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-39-35.9-63.1-87.5-63.1-143.7c0-35.2 16.3-73.6 37.2-107.4c4.4-7.1 9.1-14.2 14.1-21.3C327.9 216.5 320 205.2 320 192l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.4c9-9.4 18.5-18.6 28.5-27.5C430.2 124 457.3 124 475 140c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256zm128-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32z',
      'M518 194.3l-12.3 13.8-19-19.9c-2-2.1-4-4.4-6-6.7c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9zM480 464c-35.3 0-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400c0 35.3-28.7 64-64 64z',
    ],
  ],
};
const faCloudHail = {
  prefix: 'fad',
  iconName: 'cloud-hail',
  icon: [
    512,
    512,
    [],
    'f739',
    [
      'M32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faCheckToSlot = {
  prefix: 'fad',
  iconName: 'check-to-slot',
  icon: [
    576,
    512,
    ['vote-yea'],
    'f772',
    [
      'M96 80l0 208 0 80 0 32 384 0 0-32 0-80 0-208c0-26.5-21.5-48-48-48L144 32c-26.5 0-48 21.5-48 48zm87 111c9.4-9.4 24.6-9.4 33.9 0l47 47L375 127c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9L281 289c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9z',
      'M409 161L281 289c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L375 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 288l48 0 0 80-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-80 48 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faVoteYea = faCheckToSlot;
const faMoneyFromBracket = {
  prefix: 'fad',
  iconName: 'money-from-bracket',
  icon: [
    640,
    512,
    [],
    'e312',
    [
      'M128 96l0 352c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352L128 96zm64 288c35.3 0 64 28.7 64 64l-64 0 0-64zm32-112c0-44.2 43-80 96-80s96 35.8 96 80s-43 80-96 80s-96-35.8-96-80zM384 448c0-35.3 28.7-64 64-64l0 64-64 0z',
      'M96 64C78.3 64 64 78.3 64 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 43 43 0 96 0L544 0c53 0 96 43 96 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32L96 64z',
    ],
  ],
};
const faStarHalf = {
  prefix: 'fad',
  iconName: 'star-half',
  icon: [
    576,
    512,
    [61731],
    'f089',
    [
      'M288.1 0c12.3 0 23.5 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3c-5.1 3.7-11.1 5.7-17.1 6l-3.2 0c-4.6-.2-9.2-1.5-13.5-3.7c-42.8-22.8-85.6-45.7-128.5-68.4c0-146.7 0-293.3 .1-439.9z',
      'M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8 288 0zM429.9 512c1.1 .1 2.1 .1 3.2 0l-3.2 0z',
    ],
  ],
};
const faCarBus = {
  prefix: 'fad',
  iconName: 'car-bus',
  icon: [
    640,
    512,
    [],
    'f85a',
    [
      'M0 74.5L0 384c0 17.7 14.3 32 32 32l16 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 64 0 0-64c0-32.8 16.5-61.8 41.6-79.1L249.9 224 208 224l0-128 88 0c13.3 0 24 10.7 24 24l0 16.4c13.2-5.4 27.7-8.4 42.6-8.4l21.4 0 0-53.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0L176.9 0C123.7 0 71.2 12.4 23.7 36.2C9.2 43.4 0 58.2 0 74.5zM64 120c0-13.3 10.7-24 24-24l88 0 0 128-88 0c-13.3 0-24-10.7-24-24l0-80zm56 200a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M347.4 234.9L329.7 288l204.5 0-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9l-138.8 0c-6.9 0-13 4.4-15.2 10.9zm-87.3 59.4l26.6-79.7C297.6 182 328.2 160 362.6 160l138.8 0c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352l0 96s0 0 0 0l0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32s0 0 0 0l0-96c0-25.4 14.8-47.3 36.1-57.6zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faSpeaker = {
  prefix: 'fad',
  iconName: 'speaker',
  icon: [
    384,
    512,
    [],
    'f8df',
    [
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 336a112 112 0 1 0 224 0A112 112 0 1 0 80 336zm64-224a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M192 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM128 336a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
    ],
  ],
};
const faTimer = {
  prefix: 'fad',
  iconName: 'timer',
  icon: [
    512,
    512,
    [],
    'e29e',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-29.3C378.8 81.9 448 160.9 448 256c0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1c12.6-12.4 12.8-32.6 .5-45.3S89.5 60.8 76.8 73.1C29.5 119.6 0 184.4 0 256z',
      'M159 159c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faBoxesStacked = {
  prefix: 'fad',
  iconName: 'boxes-stacked',
  icon: [
    576,
    512,
    [62625, 'boxes', 'boxes-alt'],
    'f468',
    [
      'M104 256l80 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80zM248 16c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64zM392 256l80 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80z',
      'M248 0L208 0c-26.5 0-48 21.5-48 48l0 112c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-112c0-26.5-21.5-48-48-48L328 0l0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80zM64 256c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0zM352 512l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2l0 160c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z',
    ],
  ],
};
const faBoxes = faBoxesStacked;
const faBoxesAlt = faBoxesStacked;
const faLandmarkMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'landmark-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e622',
    [
      'M0 160c0 2.7 .3 5.5 1.1 8.2C4.8 182.2 17.5 192 32 192l269.3 0c-8.6-19.6-13.3-41.2-13.3-64c0-36.1 12-69.4 32.1-96.2L271.9 4.2C267 1.4 261.5 0 256 0s-11 1.4-15.9 4.2L68.4 102.4 64 104l0 .9L16.1 132.2C6 138 0 148.7 0 160zM1.4 489.3C5.5 502.8 17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 288c-22.8 0-44.4-4.8-64-13.3L384 416l-40 0 0-166.4c-8.9-7.6-17-16.2-24-25.6l-40 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192-64 0 0 196.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9z',
      'M528 128.2a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 234c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 279.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 234z',
    ],
  ],
};
const faGrillHot = {
  prefix: 'fad',
  iconName: 'grill-hot',
  icon: [
    448,
    512,
    [],
    'e5a5',
    [
      'M96 24l0 2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6c0-13.3-10.7-24-24-24S96 10.7 96 24zm112 0l0 2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472l-171.7 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424l151.1 0-18.3-42.7C277.7 383.1 267 384 256 384l-64 0c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faBallotCheck = {
  prefix: 'fad',
  iconName: 'ballot-check',
  icon: [
    448,
    512,
    [],
    'f733',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM56.3 244.9c.2-1 .5-2 .9-3c.8-1.9 2-3.7 3.5-5.3c6.2-6.2 16.4-6.2 22.6 0c4.2 4.2 8.5 8.5 12.7 12.7c12.2-12.2 24.5-24.5 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-16 16-32 32-48 48c-6.2 6.2-16.4 6.2-22.6 0c-8-8-16-16-24-24c-1.6-1.6-2.7-3.4-3.5-5.3c-.4-1-.7-2-.9-3c-.1-.8-.2-1.5-.2-1.5c-.1-.8-.1-.8-.1-1.6c0-1 .1-1.3 .1-1.5c0-.5 .1-1 .2-1.5zm8-136.2c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1C71.6 97.8 75.6 96 80 96l32 0c8.8 0 16 7.2 16 16c0 10.7 0 21.3 0 32c0 8.8-7.2 16-16 16l-32 0c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.6c0-10.7 0-21.3 0-32.2c0-.4 0-.9 .1-1.5s.1-1.1 .2-1.6zm0 256c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7l32 0c8.8 0 16 7.2 16 16c0 10.7 0 21.3 0 32c0 8.8-7.2 16-16 16l-32 0c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1.1-.1-1.6c0-10.7 0-21.3 0-32.2c0-.4 0-.9 .1-1.5s.1-1.1 .2-1.6zM192 128c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 128c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 128c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
      'M64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 256l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm91.3-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L96 249.4 83.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z',
    ],
  ],
};
const faLink = {
  prefix: 'fad',
  iconName: 'link',
  icon: [
    640,
    512,
    [128279, 'chain'],
    'f0c1',
    [
      'M247.6 193.7C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6z',
      'M60.2 448.8c-56.5-56.5-56.5-148 0-204.5L172.5 132c56.5-56.5 148-56.5 204.5 0c50 50 56.5 128.8 15.4 186.3l-1.1 1.6c-10.3 14.4-30.3 17.7-44.6 7.4s-17.7-30.3-7.4-44.6l1.1-1.6c22.9-32.1 19.3-76-8.6-103.9c-31.5-31.5-82.5-31.5-114 0L105.5 289.5C74 321 74 372 105.5 403.5c27.9 27.9 71.8 31.5 103.8 8.6l1.6-1.1c14.4-10.3 34.4-6.9 44.6 7.4s6.9 34.4-7.4 44.6l-1.6 1.1C189 505.3 110.2 498.7 60.2 448.8z',
    ],
  ],
};
const faChain = faLink;
const faEarListen = {
  prefix: 'fad',
  iconName: 'ear-listen',
  icon: [
    512,
    512,
    ['assistive-listening-systems'],
    'f2a2',
    [
      'M64 480A32 32 0 1 1 0 480a32 32 0 1 1 64 0zM41.4 361.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3zM192 352a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM355.4 17.7c7.9-15.8 27.1-22.2 43.1-14.2c.3 .1 .4 .2 .6 .3c.3 .2 .7 .4 1.2 .7c1 .5 2.3 1.3 4 2.2c3.3 1.9 7.7 4.7 13 8.3c10.5 7.3 24.4 18.3 38.3 33.3C483.5 78.6 512 126 512 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-46-19.5-78.6-39.5-100.3c-10.1-10.9-20.2-19-27.7-24.2c-3.7-2.6-6.8-4.5-8.7-5.6c-1-.6-1.7-1-2.1-1.2l-.4-.2c-15.7-7.9-22-27.1-14.2-42.9zM384 32c4.8-9.5 9.5-19.1 14.5-28.6c-.1-.1-.1-.1-14.5 28.6z',
      'M128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78l0 6.1c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112l0-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z',
    ],
  ],
};
const faAssistiveListeningSystems = faEarListen;
const faFileMinus = {
  prefix: 'fad',
  iconName: 'file-minus',
  icon: [
    384,
    512,
    [],
    'f318',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 328c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM120 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z',
    ],
  ],
};
const faTreeCity = {
  prefix: 'fad',
  iconName: 'tree-city',
  icon: [
    640,
    512,
    [],
    'e587',
    [
      'M288 48l0 416c0 26.5 21.5 48 48 48l96 0 160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-24 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0-144c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48zm64 32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm160 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M222 176c1-5 2-10 2-16c0-53-43-96-96-96c-54 0-96 43-96 96c0 6 0 11 1 16C13 190 0 214 0 240c0 45 35 80 80 80H96V480c0 18 14 32 32 32c17 0 32-14 32-32V320h16c44 0 80-35 80-80c0-26-14-50-34-64z',
    ],
  ],
};
const faPlay = {
  prefix: 'fad',
  iconName: 'play',
  icon: [
    384,
    512,
    [9654],
    'f04b',
    [
      '',
      'M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z',
    ],
  ],
};
const faFont = {
  prefix: 'fad',
  iconName: 'font',
  icon: [
    448,
    512,
    [],
    'f031',
    [
      'M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416 32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1.8 0 18-48 159.6 0 18 48-1.8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-25.8 0L254 52.8zM279.8 304l-111.6 0L224 155.1 279.8 304z',
      '',
    ],
  ],
};
const faCupTogo = {
  prefix: 'fad',
  iconName: 'cup-togo',
  icon: [
    448,
    512,
    ['coffee-togo'],
    'f6c5',
    [
      'M48 128l352 0-8.7 104L56.7 232 48 128zM70 392l308 0-5.1 61.3c-2.8 33.2-30.5 58.7-63.8 58.7l-170.2 0c-33.3 0-61-25.5-63.8-58.7c-1.7-20.4-3.4-40.9-5.1-61.3z',
      'M55.2 17.7L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L392.8 17.7C387.4 6.8 376.3 0 364.2 0L83.8 0C71.7 0 60.6 6.8 55.2 17.7zM378 392l13.3-160L56.7 232 70 392l308 0z',
    ],
  ],
};
const faCoffeeTogo = faCupTogo;
const faSquareDownLeft = {
  prefix: 'fad',
  iconName: 'square-down-left',
  icon: [
    448,
    512,
    [],
    'e26b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM128 198.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L200 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L264 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L144 352c-8.8 0-16-7.2-16-16l0-137.4z',
      'M128 336l0-137.4c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L200 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L264 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L144 352c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faBurgerLettuce = {
  prefix: 'fad',
  iconName: 'burger-lettuce',
  icon: [
    512,
    512,
    [],
    'e3e3',
    [
      'M32 194.9C32 211 45 224 61.1 224l389.8 0c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM32 400l0 16c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-16c0-8.8-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16zM144 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM272 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M136.2 333c-12 7.2-31.6 19-56.2 19c-21.5 0-38.4-5.4-50.3-11.4c-5.9-3-10.5-6-13.9-8.5c-1.7-1.3-3.1-2.4-4.1-3.3c-.5-.5-1-.9-1.4-1.2l-.5-.5-.2-.2-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0l22.4-22.4L9.4 326.6c-12.5-12.5-12.5-32.8 0-45.3c12.3-12.3 32-12.5 44.5-.7c.1 .1 .2 .1 .3 .2c.6 .5 2 1.4 4.1 2.5c4.1 2 11.2 4.6 21.7 4.6c5.6 0 10.7-2.4 25.9-11.5l.5-.3c13.2-7.9 33.9-20.2 61.6-20.2c27.5 0 46.3 12.2 58.3 20c.6 .4 1.2 .8 1.8 1.1c11.9 7.7 18 10.9 28 10.9c9.7 0 14.6-2.9 26.2-10.6c.3-.2 .5-.3 .8-.5c12.4-8.3 31.3-20.9 61-20.9c29.5 0 50.1 12.3 63.8 20.7c15.1 9.3 19 11.3 24.2 11.3c10.5 0 17.6-2.6 21.7-4.6c2.1-1 3.5-2 4.1-2.5c.1-.1 .2-.2 .3-.2c12.5-11.8 32.3-11.6 44.5 .7c12.5 12.5 12.5 32.8 0 45.3L480 304c22.6 22.6 22.6 22.6 22.6 22.6s0 0 0 0c0 0 0 0 0 0l-.1 .1-.2 .2-.5 .5c-.4 .4-.8 .8-1.4 1.2c-1.1 .9-2.4 2.1-4.1 3.3c-3.4 2.5-8 5.6-13.9 8.5c-11.9 6-28.8 11.4-50.3 11.4c-24.7 0-43.6-11.9-55-19c-1-.6-1.9-1.2-2.8-1.7C361.9 323.7 354.5 320 344 320c-9.7 0-14.6 2.9-26.2 10.6c-.3 .2-.5 .3-.8 .5c-12.4 8.3-31.3 20.9-61 20.9c-29.8 0-49.5-12.6-62.4-21l-.2-.1c-13-8.4-17.7-10.9-25.4-10.9c-8.5 0-15.7 3.3-29.3 11.5c-.8 .5-1.6 1-2.5 1.5z',
    ],
  ],
};
const faTableCellsRowLock = {
  prefix: 'fad',
  iconName: 'table-cells-row-lock',
  icon: [
    640,
    512,
    [],
    'e67a',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faRupiahSign = {
  prefix: 'fad',
  iconName: 'rupiah-sign',
  icon: [
    512,
    512,
    [],
    'e23d',
    [
      'M288 192c0-17.7 14.3-32 32-32l80 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-48 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128 0-160zm64 32l0 96 48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48 0z',
      'M32 32C14.3 32 0 46.3 0 64L0 288 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 42.3 0 56 139.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L170.3 307.7C220.8 285.3 256 234.8 256 176c0-79.5-64.5-144-144-144L32 32zm80 224l-48 0L64 96l48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z',
    ],
  ],
};
const faMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'magnifying-glass',
  icon: [
    512,
    512,
    [128269, 'search'],
    'f002',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm352 0A144 144 0 1 1 64 208a144 144 0 1 1 288 0z',
      'M330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z',
    ],
  ],
};
const faSearch = faMagnifyingGlass;
const faTableTennisPaddleBall = {
  prefix: 'fad',
  iconName: 'table-tennis-paddle-ball',
  icon: [
    512,
    512,
    [127955, 'ping-pong-paddle-ball', 'table-tennis'],
    'f45d',
    [
      'M320 416a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M301.4 358.8c21-42 64.4-70.8 114.6-70.8c29 0 55.8 9.6 77.2 25.9c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7l-.6 .6L301.4 358.8zm-11.3 33.9L49.3 151.9C38.1 171.3 32 193.5 32 216.2l0 2.7c0 33.9 13.5 66.5 37.5 90.5l9.8 9.8c13.1 13.1 12.4 34.6-1.7 46.8L11 423.8C4.3 429.6 .3 438 0 446.9s3.1 17.5 9.4 23.8l32 32c6.3 6.3 14.9 9.7 23.8 9.4s17.2-4.3 23-11l57.7-66.6c12.2-14 33.7-14.8 46.8-1.7l9.8 9.8c24 24 56.6 37.5 90.5 37.5l2.7 0c3.1 0 6.1-.1 9.2-.3C294.2 460.9 288 439.2 288 416c0-7.9 .7-15.7 2.1-23.3z',
    ],
  ],
};
const faPingPongPaddleBall = faTableTennisPaddleBall;
const faTableTennis = faTableTennisPaddleBall;
const faPersonDotsFromLine = {
  prefix: 'fad',
  iconName: 'person-dots-from-line',
  icon: [
    576,
    512,
    ['diagnoses'],
    'f470',
    [
      'M0 336c0 10.8 3.6 21.7 11.1 30.7c17 20.4 47.2 23.1 67.6 6.1c15-12.5 50-34.4 97.3-50.1L176 432l224 0 0-109.3c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5C5.9 308.6 0 322.3 0 336zM200 88a88 88 0 1 0 176 0A88 88 0 1 0 200 88zm72 192a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M64 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM0 488c0-13.3 10.7-24 24-24l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24zM464 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faDiagnoses = faPersonDotsFromLine;
const faChevronsDown = {
  prefix: 'fad',
  iconName: 'chevrons-down',
  icon: [
    512,
    512,
    ['chevron-double-down'],
    'f322',
    [
      'M32 64c0 8.2 3.1 16.4 9.4 22.6l192 192c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7 86.6 41.4C80.4 35.1 72.2 32 64 32s-16.4 3.1-22.6 9.4S32 55.8 32 64z',
      'M278.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 402.7 425.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z',
    ],
  ],
};
const faChevronDoubleDown = faChevronsDown;
const faTrashCanArrowUp = {
  prefix: 'fad',
  iconName: 'trash-can-arrow-up',
  icon: [
    448,
    512,
    ['trash-restore-alt'],
    'f82a',
    [
      'M32 96l384 0 0 352c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 96zm95 151c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1c13 13 26 26 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80z',
      'M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0zM248 241.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1z',
    ],
  ],
};
const faTrashRestoreAlt = faTrashCanArrowUp;
const faSignalGood = {
  prefix: 'fad',
  iconName: 'signal-good',
  icon: [
    640,
    512,
    ['signal-3'],
    'f68e',
    [
      'M416 128l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-17.7-14.3-32-32-32s-32 14.3-32 32zM544 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M320 192c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32zM192 288c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z',
    ],
  ],
};
const faSignal3 = faSignalGood;
const faLocationQuestion = {
  prefix: 'fad',
  iconName: 'location-question',
  icon: [
    384,
    512,
    ['map-marker-question'],
    'f60b',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm104-49.5c0-2.7 .4-5.4 1.4-8c.1-.4 .3-.8 .4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c17.4 0 33.2 7.1 44.7 18.5c5.7 5.7 10.3 12.5 13.5 20.1c1.6 3.8 2.8 7.7 3.7 11.8c.4 2.1 .7 4.2 1 6.3c.1 1.1 .2 2.1 .2 3.2c.1 1.1 .1 2.1 .1 2.8l0 .4 0 .4c0 .6 0 1.1 0 1.7c0 .7-.1 1.4-.1 2.1c-.1 1.4-.2 2.8-.4 4.2c-.4 2.8-.9 5.5-1.6 8.1c-1.4 5.3-3.6 10.4-6.3 15.1c-5.5 9.5-13.4 17.5-23.2 23.1c-10.8 6.2-21.5 12.3-32.3 18.6c0 .7-.1 1.5-.2 2.3s-.2 1.6-.4 2.3c-.3 1.5-.8 3-1.4 4.4c-1.2 2.8-3 5.4-5.2 7.5c-4.3 4.3-10.3 6.9-16.8 6.9c-13.3 0-24-10.7-24-24c0-4.5 0-9 0-13.5c.1-8.7 4.7-16.6 12.1-20.8c14.8-8.5 29.6-17 44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-2c0-.3 .1-.7 .1-1c0-.3 0-.5 0-1.1c0-.6 0-1-.1-1.5c-.1-.5-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4l-58.3 0c-3.3 0-6.3 2.1-7.8 5.9c-.1 .2-.1 .4-.2 .6c-4.4 12.5-18.2 19-30.6 14.6c-9.8-3.5-16-12.7-16-22.6zM160 320c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32z',
      'M158.6 96c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM192 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMapMarkerQuestion = faLocationQuestion;
const faFloppyDiskCircleXmark = {
  prefix: 'fad',
  iconName: 'floppy-disk-circle-xmark',
  icon: [
    576,
    512,
    ['floppy-disk-times', 'save-circle-xmark', 'save-times'],
    'e181',
    [
      'M0 96C0 60.7 28.7 32 64 32l242.7 0c17 0 33.3 6.7 45.3 18.7L429.3 128c12 12 18.7 28.3 18.7 45.3l0 19.5c-5.3-.5-10.6-.7-16-.7c-75 0-139.1 47-164.4 113.1C256.1 294.5 240.8 288 224 288c-35.3 0-64 28.7-64 64s28.7 64 64 64c13.3 0 25.7-4.1 35.9-11c6 28.1 18.7 53.7 36.3 75L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faFloppyDiskTimes = faFloppyDiskCircleXmark;
const faSaveCircleXmark = faFloppyDiskCircleXmark;
const faSaveTimes = faFloppyDiskCircleXmark;
const faNairaSign = {
  prefix: 'fad',
  iconName: 'naira-sign',
  icon: [
    448,
    512,
    [],
    'e1f6',
    [
      'M0 288c0 17.7 14.3 32 32 32l32 0 0-64-32 0c-17.7 0-32 14.3-32 32zm128-32l0 64 100.2 0c-14.2-21.3-28.4-42.7-42.7-64L128 256zm134.5 0l42.7 64 14.9 0 0-64-57.5 0zM384 256l0 64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
      'M86.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L320 342.3 320 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 14.1-9.2 26.5-22.7 30.6s-28.1-1.1-35.9-12.9L128 169.7 128 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L64 64c0-14.1 9.2-26.5 22.7-30.6z',
    ],
  ],
};
const faPeach = {
  prefix: 'fad',
  iconName: 'peach',
  icon: [
    512,
    512,
    [],
    'e20b',
    [
      'M0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-92.8-75.2-168-168-168c-18.3 0-35.9 2.9-52.3 8.3c-.8 .3-1.5 .5-2.3 .7c43.8 33.5 73.4 84.7 78 143c.7 8.8-6.5 16-15.4 16s-15.9-7.2-16.8-16c-6.4-68-53.3-124.1-116.3-144.2c-16.1-5.1-33.2-7.9-50.9-7.9C75.2 112 0 187.2 0 280z',
      'M377.5 82.8C366.6 81 355.4 80 344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-11.4 0-22.6 1-33.5 2.8C120.5 67.2 112 46.6 112 24c0-13.3 10.7-24 24-24l24 0c53 0 96 43 96 96c0-53 43-96 96-96l24 0c13.3 0 24 10.7 24 24c0 22.6-8.5 43.2-22.5 58.8z',
    ],
  ],
};
const faCirclesOverlap3 = {
  prefix: 'fad',
  iconName: 'circles-overlap-3',
  icon: [
    512,
    512,
    ['pronoun'],
    'e6a1',
    [
      'M64 344c0 48.6 39.4 88 88 88c26.9 0 50.9-12 67-31c-7.1-17.6-11-36.8-11-57c0-13.2 1.7-26 4.8-38.2c-29.3-8.7-54.9-25.9-73.9-48.8C96.5 263.3 64 299.8 64 344zM168 160c0 11.9 2.4 23.3 6.7 33.7c31.2 4.7 59.3 18.8 81.3 39.5c22-20.6 50.1-34.8 81.3-39.5c4.3-10.4 6.7-21.8 6.7-33.7c0-48.6-39.4-88-88-88s-88 39.4-88 88zM293 401c16.1 19 40.2 31 67 31c48.6 0 88-39.4 88-88c0-44.2-32.5-80.7-74.9-87c-19 22.9-44.6 40.2-73.9 48.8c3.2 12.2 4.8 25 4.8 38.2c0 20.2-3.9 39.4-11 57z',
      'M174.7 193.7c31.2 4.7 59.3 18.8 81.3 39.5c22-20.6 50.1-34.8 81.3-39.5c4.3-10.4 6.7-21.8 6.7-33.7c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 11.9 2.4 23.3 6.7 33.7zm-65.8 4.5c-3.2-12.2-4.8-25-4.8-38.2C104 76.1 172.1 8 256 8s152 68.1 152 152c0 13.2-1.7 26-4.8 38.2C466.1 216.8 512 275 512 344c0 83.9-68.1 152-152 152c-40.2 0-76.8-15.6-104-41.1C228.8 480.4 192.2 496 152 496C68.1 496 0 427.9 0 344c0-69 45.9-127.2 108.8-145.8zM138.9 257C96.5 263.3 64 299.8 64 344c0 48.6 39.4 88 88 88c26.9 0 50.9-12 67-31c-7.1-17.6-11-36.8-11-57c0-13.2 1.7-26 4.8-38.2c-29.3-8.7-54.9-25.9-73.9-48.8zm160.2 48.8c3.2 12.2 4.8 25 4.8 38.2c0 20.2-3.9 39.4-11 57c16.1 19 40.2 31 67 31c48.6 0 88-39.4 88-88c0-44.2-32.5-80.7-74.9-87c-19 22.9-44.6 40.2-73.9 48.8z',
    ],
  ],
};
const faPronoun = faCirclesOverlap3;
const faTaxiBus = {
  prefix: 'fad',
  iconName: 'taxi-bus',
  icon: [
    640,
    512,
    [],
    'e298',
    [
      'M0 74.5L0 384c0 17.7 14.3 32 32 32l16 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 64 0 0-64c0-32.8 16.5-61.8 41.6-79.1L249.9 224 208 224l0-128 88 0c13.3 0 24 10.7 24 24l0 16.4c5.7-2.4 11.7-4.3 17.8-5.6C343.6 110.7 362.1 96 384 96l0-21.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0L176.9 0C123.7 0 71.2 12.4 23.7 36.2C9.2 43.4 0 58.2 0 74.5zM64 120c0-13.3 10.7-24 24-24l88 0 0 128-88 0c-13.3 0-24-10.7-24-24l0-80zm56 200a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M392 128c-13.3 0-24 10.7-24 24l0 8-5.4 0c-34.4 0-65 22-75.9 54.7l-26.6 79.7C238.8 304.7 224 326.6 224 352l0 96s0 0 0 0l0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32s0 0 0 0l0-96c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160l-5.4 0 0-8c0-13.3-10.7-24-24-24l-80 0zm-29.4 96l138.8 0c6.9 0 13 4.4 15.2 10.9L534.3 288l-204.5 0 17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faBracketCurly = {
  prefix: 'fad',
  iconName: 'bracket-curly',
  icon: [
    256,
    512,
    ['bracket-curly-left'],
    '7b',
    [
      'M64 128c0-53 43-96 96-96l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32l0 37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9l0 37.5c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-53 0-96-43-96-96l0-37.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3c6-6 9.4-14.1 9.4-22.6L64 128z',
      '',
    ],
  ],
};
const faBracketCurlyLeft = faBracketCurly;
const faLobster = {
  prefix: 'fad',
  iconName: 'lobster',
  icon: [
    512,
    512,
    [129438],
    'e421',
    [
      'M48 304c0 6.7 4.2 12.9 10.9 15.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1l69.6 0 0-32-69.6 0c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1c-.6 1.7-.8 3.4-.8 5.1zm17.7-63.2c-4 7.9-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4l48.9 0 0-32-48.9 0c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2zm48 150.3c4 7.9 13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1l16.9 0 0-32-16.9 0c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5zM160.2 29.4c-1.5 8.7 4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7l0 91.1c9.3-14.4 21.2-25.8 32-33.7l0-57.3c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2zM272 80.7l0 57.3c10.8 8 22.7 19.4 32 33.7l0-91.1c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7zM320 256l0 32 48.9 0c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1L320 256zm0 48l0 32 69.6 0c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5L320 304zm0 48c0 10.7 0 21.3 0 32l16.9 0c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c2.3 1.1 4.7 1.7 7.1 1.7c5.9 0 11.5-3.2 14.3-8.8c4-7.9 .7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4L320 352z',
      'M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64l0 64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240l18.9 0 0 144 21.4 64.1c-29.8 1.8-53.4 26.5-53.4 56.8c0 3.9 3.2 7.1 7.1 7.1l177.8 0c3.9 0 7.1-3.2 7.1-7.1c0-30.2-23.6-55-53.4-56.8L320 384l0-144 18.9 0c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5L432 72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9l0 64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192l-24.7 0c-10.8-29.1-34.4-49.8-51.2-60.1c-4.3-2.6-9.7-2.6-13.9 0c-16.8 10.3-40.4 31-51.2 60.1l-24.7 0c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4l0-64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72L80 8.2z',
    ],
  ],
};
const faCartFlatbedEmpty = {
  prefix: 'fad',
  iconName: 'cart-flatbed-empty',
  icon: [
    640,
    512,
    ['dolly-flatbed-empty'],
    'f476',
    [
      'M160 464c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16zm288 0c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16z',
      'M0 32C0 14.3 14.3 0 32 0L48 0c44.2 0 80 35.8 80 80l0 288c0 8.8 7.2 16 16 16l464 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-464 0c-44.2 0-80-35.8-80-80L64 80c0-8.8-7.2-16-16-16L32 64C14.3 64 0 49.7 0 32z',
    ],
  ],
};
const faDollyFlatbedEmpty = faCartFlatbedEmpty;
const faColon = {
  prefix: 'fad',
  iconName: 'colon',
  icon: [
    192,
    512,
    [],
    '3a',
    ['M32 384a64 64 0 1 0 128 0A64 64 0 1 0 32 384z', 'M32 128a64 64 0 1 1 128 0A64 64 0 1 1 32 128z'],
  ],
};
const faCartArrowDown = {
  prefix: 'fad',
  iconName: 'cart-arrow-down',
  icon: [
    576,
    512,
    [],
    'f218',
    [
      'M120.1 32c2 4.2 3.5 8.8 4.4 13.5c15.4 80.8 30.8 161.7 46.2 242.5l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32L360 32l0 110.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-1.1 1.1-2.4 2.1-3.7 3c-1.3 .9-2.7 1.6-4.1 2.2c-1.4 .6-2.9 1-4.5 1.4s-3.1 .5-4.7 .5c-1.6 0-3.2-.2-4.7-.5c-1.5-.3-3-.8-4.5-1.4c-1.4-.6-2.8-1.3-4.1-2.2s-2.5-1.9-3.7-3l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L312 32 120.1 32z',
      'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5l-51.6-271C119.5 19.1 96.4 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM360 142.1L360 32l-48 0 0 110.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23z',
    ],
  ],
};
const faWand = {
  prefix: 'fad',
  iconName: 'wand',
  icon: [
    512,
    512,
    [],
    'f72a',
    [
      '',
      'M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1L144 256c-8.8 0-16 7.2-16 16l0 27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8c9.5 0 18.5-4 24.8-11.1L372.3 197.3c3-3.4 7.4-5.3 11.9-5.3l15.8 0c8.8 0 16-7.2 16-16l0-21.4c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z',
    ],
  ],
};
const faWalkieTalkie = {
  prefix: 'fad',
  iconName: 'walkie-talkie',
  icon: [
    384,
    512,
    [],
    'f8ef',
    [
      'M0 144L0 300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9L32 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-92.1c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9L384 144c0-26.5-21.5-48-48-48l-16 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-48 0L64 96 48 96C21.5 96 0 117.5 0 144zm96 32c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
      'M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72 48 0 0-72zm0 136c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z',
    ],
  ],
};
const faFilePen = {
  prefix: 'fad',
  iconName: 'file-pen',
  icon: [
    576,
    512,
    [128221, 'file-edit'],
    'f31c',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 139.5-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19.1 1.4 27.9L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zm165.9 75.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.5-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417.1L441.2 287.8l71 71L382.9 488.1c-4.1 4.1-9.2 7-14.9 8.4l-60.2 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.2c1.4-5.6 4.3-10.8 8.4-14.9z',
    ],
  ],
};
const faFileEdit = faFilePen;
const faReceipt = {
  prefix: 'fad',
  iconName: 'receipt',
  icon: [
    384,
    512,
    [129534],
    'f543',
    [
      'M0 24L0 488c0 9.4 5.5 17.9 14 21.8c3.2 1.5 6.6 2.2 10 2.2c5.6 0 11.2-2 15.6-5.8L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c4.4 3.8 10 5.8 15.6 5.8c3.4 0 6.8-.7 10-2.2c8.5-3.9 14-12.4 14-21.8l0-464c0-9.4-5.5-17.9-14-21.8C366.8 .7 363.4 0 360 0c-5.6 0-11.2 2-15.6 5.8L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8C35.2 2 29.6 0 24 0c-3.4 0-6.8 .7-10 2.2C5.5 6.1 0 14.6 0 24zM80 160c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 176c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 272c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 368c-8.8 0-16-7.2-16-16z',
      'M80 160c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 176c-8.8 0-16-7.2-16-16zm0 192c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 368c-8.8 0-16-7.2-16-16zM96 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 272c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faTablePicnic = {
  prefix: 'fad',
  iconName: 'table-picnic',
  icon: [
    512,
    512,
    [],
    'e32d',
    [
      'M32 288c149.3 0 298.6 0 448 0c-16.2 0-32.5 0-48.7 0l46.4 116.1c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L362.3 288l-212.7 0-56 139.9c-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.2-17.8-41.6L80.7 288c-16.2 0-32.5 0-48.7 0zM65.3 105.1C69.3 118.4 81.5 128 96 128c-.9 0-1.8 0-2.7-.1c-.9-.1-1.8-.2-2.6-.3c-1.7-.3-3.4-.7-5-1.3c-3.2-1.1-6.3-2.7-8.9-4.8c-5.4-4.1-9.4-9.8-11.4-16.4zM96 128c106.7 0 213.3 0 320 0c-16.2 0-32.5 0-48.7 0l38.4 96c-23 0-45.9 0-68.9 0l-38.4-96-84.7 0-38.4 96c-23 0-45.9 0-68.9 0l38.4-96L96 128zM319.3 64l1.5 0c-.5 0-1 0-1.5 0z',
      'M96 64C78.3 64 64 78.3 64 96s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z',
    ],
  ],
};
const faSquarePen = {
  prefix: 'fad',
  iconName: 'square-pen',
  icon: [
    448,
    512,
    ['pen-square', 'pencil-square'],
    'f14b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96.5 364l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2zM247.8 161.1l21.4-21.4c7.8-7.8 18-11.7 28.3-11.7s20.5 3.9 28.3 11.7l14.4 14.4c7.8 7.8 11.7 18 11.7 28.3s-3.9 20.5-11.7 28.3l-21.4 21.4-71-71z',
      'M269.2 139.7l-21.4 21.4 71 71 21.4-21.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-44 44L119.9 289c-4.1 4.1-7 9.2-8.4 14.9L96.5 364c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L296.1 254.7l-71-71z',
    ],
  ],
};
const faPenSquare = faSquarePen;
const faPencilSquare = faSquarePen;
const faCircleMicrophoneLines = {
  prefix: 'fad',
  iconName: 'circle-microphone-lines',
  icon: [
    512,
    512,
    ['microphone-circle-alt'],
    'e117',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 65.3-48.9 119.1-112 127l0 17c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17c-63.1-7.9-112-61.7-112-127l0-16zm80-96c0-26.5 21.5-48 48-48s48 21.5 48 48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 16c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112z',
      'M208 144c0-26.5 21.5-48 48-48s48 21.5 48 48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 16c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112zm-64 80c8.8 0 16 7.2 16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 65.3-48.9 119.1-112 127l0 17c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17c-63.1-7.9-112-61.7-112-127l0-16c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faMicrophoneCircleAlt = faCircleMicrophoneLines;
const faDisplaySlash = {
  prefix: 'fad',
  iconName: 'display-slash',
  icon: [
    640,
    512,
    ['desktop-slash'],
    'e2fa',
    [
      'M32 121.2L32 352c0 35.3 28.7 64 64 64l176 0-10.7 32L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32c0-2.2-.2-4.3-.6-6.3L446.8 448l-68.1 0L368 416l38.2 0-81.2-64L96 352l0-180.4L32 121.2zM53.2 16.4L113.9 64 544 64l0 288-62.6 0c26.3 20.6 52.6 41.3 79 61.9c27.4-7.2 47.6-32.2 47.6-61.9l0-288c0-35.3-28.7-64-64-64L96 0C79.6 0 64.6 6.2 53.2 16.4z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faDesktopSlash = faDisplaySlash;
const faSuitcaseRolling = {
  prefix: 'fad',
  iconName: 'suitcase-rolling',
  icon: [
    384,
    512,
    [],
    'f5c1',
    [
      'M64 480c0 17.7 14.3 32 32 32s32-14.3 32-32l-64 0zM96 56l0 72 48 0 0-72c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8l0 72 48 0 0-72c0-30.9-25.1-56-56-56L152 0C121.1 0 96 25.1 96 56zM256 480c0 17.7 14.3 32 32 32s32-14.3 32-32l-64 0z',
      'M64 128c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 128zm48 96l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faPersonCircleExclamation = {
  prefix: 'fad',
  iconName: 'person-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e53f',
    [
      'M0 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C1.5 276.7 0 282.4 0 288zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faTransporter2 = {
  prefix: 'fad',
  iconName: 'transporter-2',
  icon: [
    512,
    512,
    [],
    'e044',
    [
      'M0 48c0 4.1 2.7 7.6 6.6 8.7L32 64l7.3 25.4C40.4 93.3 43.9 96 48 96s7.6-2.7 8.7-6.6L64 64l25.4-7.3C93.3 55.6 96 52.1 96 48s-2.7-7.6-6.6-8.7L64 32 56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm256-32c0 4.1 2.7 7.6 6.6 8.7L448 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7z',
      'M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm8 464l-88 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-88 0-80 0zM351.3 164l48.1 60-286.7 0 48.1-60c18.2-22.7 45.8-36 74.9-36l40.7 0c29.1 0 56.7 13.2 74.9 36zM96 256.5l0-1c0 .3 0 .7 0 1z',
    ],
  ],
};
const faUserHoodie = {
  prefix: 'fad',
  iconName: 'user-hoodie',
  icon: [
    448,
    512,
    [],
    'e68a',
    [
      'M128 157.3c0 55.6 53.3 100.9 80.5 120.4c4.7 3.4 10.1 5 15.5 5s10.8-1.7 15.5-5C266.7 258.2 320 213 320 157.3c0-51.5-43-93.3-96-93.3s-96 41.8-96 93.3z',
      'M118.8 297.6c-1.3 10.6-8.6 19.5-18.2 24.2C41 350.7 0 411.7 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-70.6-41-131.6-100.6-160.5c-9.6-4.7-16.9-13.5-18.2-24.2c-1.2-9.6 2.7-19.1 9.4-26C366.7 242.8 384 203.4 384 160C384 71.6 312.4 0 224 0S64 71.6 64 160c0 43.4 17.3 82.8 45.4 111.6c6.8 6.9 10.6 16.4 9.4 26zM224 64c53 0 96 41.8 96 93.3c0 55.6-53.3 100.9-80.5 120.4c-9.4 6.7-21.7 6.7-31.1 0C181.3 258.2 128 213 128 157.3c0-51.5 43-93.3 96-93.3zM160 400l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faHandsHoldingDiamond = {
  prefix: 'fad',
  iconName: 'hands-holding-diamond',
  icon: [
    640,
    512,
    ['hand-receiving'],
    'f47c',
    [
      'M0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c-5.1-5.1-10.2-10.2-15.2-15.2l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40c0-22.1-17.9-40-40-40S0 81.9 0 104zM352 385.1l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c-8.5 8.5-16.9 16.9-25.4 25.4c-21 21-32.8 49.5-32.8 79.2z',
      'M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96z',
    ],
  ],
};
const faHandReceiving = faHandsHoldingDiamond;
const faMoneyBillSimpleWave = {
  prefix: 'fad',
  iconName: 'money-bill-simple-wave',
  icon: [
    576,
    512,
    [],
    'e1f2',
    [
      'M208 256c0 53 35.8 96 80 96s80-43 80-96s-35.8-96-80-96s-80 43-80 96z',
      'M0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z',
    ],
  ],
};
const faChevronDown = {
  prefix: 'fad',
  iconName: 'chevron-down',
  icon: [
    512,
    512,
    [],
    'f078',
    [
      'M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z',
      '',
    ],
  ],
};
const faBatteryFull = {
  prefix: 'fad',
  iconName: 'battery-full',
  icon: [
    576,
    512,
    [128267, 'battery', 'battery-5'],
    'f240',
    [
      'M0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176zm64 0l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160c-8.8 0-16 7.2-16 16z',
      'M96 192h352v128H96V192z',
    ],
  ],
};
const faBattery = faBatteryFull;
const faBattery5 = faBatteryFull;
const faBellPlus = {
  prefix: 'fad',
  iconName: 'bell-plus',
  icon: [
    448,
    512,
    [],
    'f849',
    [
      'M2.8 397.1C8 408.6 19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9c1.9-4.2 2.8-8.7 2.8-13.1c0-7.7-2.8-15.3-8.1-21.3l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4zM136 240c0-13.3 10.7-24 24-24l40 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24z',
      'M224 152c13.3 0 24 10.7 24 24l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-40c0-13.3 10.7-24 24-24zm45.3 341.3c-12 12-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0 64 0c0 17-6.7 33.3-18.7 45.3z',
    ],
  ],
};
const faBookArrowRight = {
  prefix: 'fad',
  iconName: 'book-arrow-right',
  icon: [
    640,
    512,
    [],
    'e0b9',
    [
      'M64 416c0 17.7 14.3 32 32 32l160 0 96 0 64 0 0-64-64 0-96 0L96 384c-17.7 0-32 14.3-32 32zM224 208c0 13.3 10.7 24 24 24l200 0 110.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17l-80-80c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-9.4 9.4-9.4 24.6 0 33.9l39 39L448 184l-200 0c-13.3 0-24 10.7-24 24z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-120-200 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l200 0 0-152c0-17.7-14.3-32-32-32L384 0 96 0z',
    ],
  ],
};
const faHospitals = {
  prefix: 'fad',
  iconName: 'hospitals',
  icon: [
    576,
    512,
    [],
    'f80e',
    [
      'M256 48c0-26.5 21.5-48 48-48L528 0c26.5 0 48 21.5 48 48l0 208-144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0 0 64-144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0 0 80c0 26.5-21.5 48-48 48l-216.6 0c5.4-9.4 8.6-20.3 8.6-32l0-352c0-35.3-28.7-64-64-64l0-16zm112 88l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16z',
      'M408 96l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM48 96C21.5 96 0 117.5 0 144L0 384l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 416l0 48c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L48 96zm88 80l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faClub = {
  prefix: 'fad',
  iconName: 'club',
  icon: [
    512,
    512,
    [9827],
    'f327',
    [
      'M0 288c0 70.7 57.3 128 128 128c38.2 0 72.5-16.8 96-43.3L224 256c0-17.7 14.3-32 32-32s32 14.3 32 32l0 116.7c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1c-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288z',
      'M256 224c17.7 0 32 14.3 32 32l0 192 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faSkullCrossbones = {
  prefix: 'fad',
  iconName: 'skull-crossbones',
  icon: [
    448,
    512,
    [128369, 9760],
    'f714',
    [
      'M3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9L152.4 384 17.7 451.4C1.9 459.3-4.5 478.5 3.4 494.3C9 505.5 20.3 512 32 512c4.8 0 9.7-1.1 14.3-3.4L224 419.8l177.7 88.8c4.6 2.3 9.5 3.4 14.3 3.4c11.7 0 23-6.5 28.6-17.7c7.9-15.8 1.5-35-14.3-42.9L295.6 384l134.8-67.4c15.8-7.9 22.2-27.1 14.3-42.9C439 262.5 427.7 256 416 256c-4.8 0-9.7 1.1-14.3 3.4L224 348.2 46.3 259.4c-4.6-2.3-9.5-3.4-14.3-3.4c-11.7 0-23 6.5-28.6 17.7z',
      'M304 234.4c38.6-23 64-62.1 64-106.4C368 57.3 303.5 0 224 0S80 57.3 80 128c0 44.4 25.4 83.5 64 106.4l0 21.6c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-21.6zM136 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm144-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faDropletDegree = {
  prefix: 'fad',
  iconName: 'droplet-degree',
  icon: [
    512,
    512,
    ['dewpoint'],
    'f748',
    [
      'M352 112a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm112 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320z',
    ],
  ],
};
const faDewpoint = faDropletDegree;
const faCodeCompare = {
  prefix: 'fad',
  iconName: 'code-compare',
  icon: [
    512,
    512,
    [],
    'e13a',
    [
      'M48 192l0 166.7c9.8-4.3 20.6-6.7 32-6.7c1.4 0 2.8 0 4.2 .1s2.8 .2 4.2 .3c2.8 .3 5.5 .7 8.2 1.3c5.4 1.1 10.5 2.8 15.4 4.9L112 192c0-35.3 28.7-64 64-64l16 0 0 40c0 9.5 5.6 18.1 14.2 21.9s18.8 2.3 25.8-4.1l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72C227.6 2.1 221.8 0 216 0c-3.3 0-6.6 .7-9.8 2.1C197.6 5.9 192 14.5 192 24l0 40-16 0C105.3 64 48 121.3 48 192zM192 416c0 6.8 2.9 13.3 7.9 17.8l80 72c7 6.3 17.2 7.9 25.8 4.1s14.2-12.4 14.2-21.9l0-40 16 0c70.7 0 128-57.3 128-128l0-166.7c-9.8 4.3-20.6 6.7-32 6.7c-1.4 0-2.8 0-4.2-.1s-2.8-.2-4.2-.3c-2.8-.3-5.5-.7-8.2-1.3c-5.4-1.1-10.5-2.8-15.4-4.9L400 320c0 35.3-28.7 64-64 64l-16 0 0-40c0-9.5-5.6-18.1-14.2-21.9s-18.8-2.3-25.8 4.1l-80 72c-5.1 4.6-7.9 11-7.9 17.8z',
      'M408 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 0A80 80 0 1 0 352 80a80 80 0 1 0 160 0zM104 432a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM0 432a80 80 0 1 0 160 0A80 80 0 1 0 0 432z',
    ],
  ],
};
const faListUl = {
  prefix: 'fad',
  iconName: 'list-ul',
  icon: [
    512,
    512,
    ['list-dots'],
    'f0ca',
    [
      'M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32z',
      'M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
    ],
  ],
};
const faListDots = faListUl;
const faHandHoldingMagic = {
  prefix: 'fad',
  iconName: 'hand-holding-magic',
  icon: [
    576,
    512,
    [],
    'f6e5',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0c-44.2 0-80-35.8-80-80s35.8-80 80-80L320 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l64 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L208 64z',
    ],
  ],
};
const faWatermelonSlice = {
  prefix: 'fad',
  iconName: 'watermelon-slice',
  icon: [
    512,
    512,
    [],
    'e337',
    [
      'M16.2 385.3L385.3 16.2c-1.4 4.2-1.7 8.7-.7 13c.5 2.1 1.2 4.2 2.3 6.2c.5 1 1.1 1.9 1.8 2.9s1.4 1.8 2.3 2.7c96.9 96.9 97.1 253.6 .3 350.4c-48.3 48.3-111.6 72.5-174.9 72.5c-15.9 0-31.7-1.5-47.4-4.6s-31-7.6-46-13.7s-29.4-13.7-43.2-22.8c-6.9-4.5-13.6-9.5-20.1-14.8c-3.2-2.7-6.4-5.4-9.6-8.2S44 394.1 41 391c-6.7-6.7-16.4-8.6-24.8-5.7zm140.5-68.6c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-5.3-5.3-10.7-10.7-16-16c-6.2-6.2-16.4-6.2-22.6 0zm80-80c-6.2 6.2-6.2 16.4 0 22.6c5.3 5.3 10.7 10.7 16 16c6.2 6.2 16.4 6.2 22.6 0c6.2-6.4 6.2-16.4 0-22.6c-5.3-5.3-10.7-10.7-16-16c-6.2-6.2-16.4-6.2-22.6 0zm8 88c-6.2 6.3-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-5.3-5.3-10.7-10.7-16-16c-6.2-6.2-16.4-6.2-22.6 0zm72-168c-6.2 6.2-6.2 16.4 0 22.6c5.3 5.3 10.7 10.7 16 16c6.2 6.2 16.4 6.2 22.6 0c6.2-6.4 6.2-16.4 0-22.6c-5.3-5.3-10.7-10.7-16-16c-6.2-6.2-16.4-6.2-22.6 0zm8 88c-6.2 6.2-6.2 16.4 0 22.6c5.3 5.3 10.7 10.7 16 16c6.2 6.2 16.4 6.2 22.6 0c6.2-6.4 6.2-16.4 0-22.6c-5.3-5.3-10.7-10.7-16-16c-6.2-6.2-16.4-6.2-22.6 0z',
      'M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zM339.3 156.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm-80 80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm88 8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm-168 72c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm88 8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16z',
    ],
  ],
};
const faCircleEllipsis = {
  prefix: 'fad',
  iconName: 'circle-ellipsis',
  icon: [
    512,
    512,
    [],
    'e10a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M128 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faSchoolLock = {
  prefix: 'fad',
  iconName: 'school-lock',
  icon: [
    640,
    512,
    [],
    'e56f',
    [
      'M0 144L0 464c0 26.5 21.5 48 48 48l272 0-64 0 0-96c0-35.3 28.7-64 64-64l64 0c0-23.7 12.9-44.4 32-55.4l0-24.6c0-61.9 50.1-112 112-112s112 50.1 112 112l0-128c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4C332.4 1.8 326.2 0 320 0s-12.4 1.8-17.8 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144zm80 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM408 176a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM304 144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faTowerCell = {
  prefix: 'fad',
  iconName: 'tower-cell',
  icon: [
    576,
    512,
    [],
    'e585',
    [
      'M0 128c0 38.1 7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3S27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128zm104 0c0 26.1 5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128zM412.7 73.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6zm83-29.6C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3S489.1 27.6 495.7 44z',
      'M340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448l220.6 0 20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384l-162.4 0 14.5-32 133.3 0 14.5 32zM288 205.3L325.6 288l-75.2 0L288 205.3z',
    ],
  ],
};
const faSdCards = {
  prefix: 'fad',
  iconName: 'sd-cards',
  icon: [
    448,
    512,
    [],
    'e240',
    [
      'M0 120L0 376c0 75.1 60.9 136 136 136l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0c-48.6 0-88-39.4-88-88l0-256c0-13.3-10.7-24-24-24S0 106.7 0 120zM256 88l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M448 64c0-35.3-28.7-64-64-64L237.3 0C220.3 0 204 6.7 192 18.7L114.7 96c-12 12-18.7 28.3-18.7 45.3L96 352c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288zM304 88l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faJugBottle = {
  prefix: 'fad',
  iconName: 'jug-bottle',
  icon: [
    640,
    512,
    [],
    'e5fb',
    [
      'M400.4 187c10 20.9 15.6 44.3 15.6 69l0 135.4c.3 .2 .7 .4 1 .6c-.3 .2-.7 .4-1 .6l0 55.4c0 16.9-4.3 32.7-12 46.5c11.5 10.9 27 17.5 44 17.5l128 0c35.3 0 64-28.7 64-64c0-24.1-13.3-45.1-33-56c19.7-10.9 33-31.9 33-56c0-23.5-12.6-44-31.5-55.1c18.7-10.1 31.5-29.9 31.5-52.7c0-23.2-13.4-44.3-34.4-54.2l-13.2-6.2c-11-5.1-23-7.8-35.1-7.8l-90.6 0c-12.1 0-24.1 2.7-35.1 7.8L418.4 174c-6.9 3.2-13 7.7-18 13zM448 88l0 40 128 0 0-40c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24z',
      'M96 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 96C74.7 96 64 85.3 64 72s10.7-24 24-24l8 0 0-24zM0 256c0-70.7 57.3-128 128-128l128 0c70.7 0 128 57.3 128 128l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256zm256 0l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
    ],
  ],
};
const faDownLong = {
  prefix: 'fad',
  iconName: 'down-long',
  icon: [
    320,
    512,
    ['long-arrow-alt-down'],
    'f309',
    [
      'M96 32l0 288c42.7 0 85.3 0 128 0c0-42.7 0-85.3 0-128c0-53.3 0-106.7 0-160c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32z',
      'M313.4 360.5c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0L96 320l-72 0c-9.6 0-18.2 5.7-22 14.5s-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144z',
    ],
  ],
};
const faLongArrowAltDown = faDownLong;
const faEnvelopes = {
  prefix: 'fad',
  iconName: 'envelopes',
  icon: [
    576,
    512,
    [],
    'e170',
    [
      'M96 126c67.2 49.8 134.4 99.6 201.6 149.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7C441.6 225.6 508.8 175.8 576 126l0 194c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64l0-194zm.7-39.3C101.2 55.7 127.8 32 160 32l352 0c32.2 0 58.8 23.7 63.3 54.7c-73.3 54.3-146.6 108.6-220 163c-5.6 4.1-12.4 6.4-19.3 6.4s-13.7-2.2-19.3-6.4C243.3 195.3 170 141 96.7 86.7z',
      'M96 96l0 30L297.6 275.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L576 126l0-30c0-3.2-.2-6.3-.7-9.3l-220 163c-5.6 4.1-12.4 6.4-19.3 6.4s-13.7-2.2-19.3-6.4l-220-163c-.4 3-.7 6.2-.7 9.3zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z',
    ],
  ],
};
const faPhoneOffice = {
  prefix: 'fad',
  iconName: 'phone-office',
  icon: [
    576,
    512,
    [],
    'f67d',
    [
      'M96 32l0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-352c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32zM320 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M64 32l32 0 0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-352 288 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM352 96c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L352 96zM320 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm160-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM448 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-96-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
    ],
  ],
};
const faRankingStar = {
  prefix: 'fad',
  iconName: 'ranking-star',
  icon: [
    640,
    512,
    [],
    'e561',
    [
      'M0 352c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32L0 352zm224-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-192zM448 416c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-64z',
      'M330.2 6.3l23.6 47.8 52.3 7.5c9.3 1.4 13.2 12.9 6.4 19.8l-38 36.6 9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.6-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l9-52.1-38-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5L309.8 6.3c4.3-8.6 16.5-8.3 20.4 0z',
    ],
  ],
};
const faChessKing = {
  prefix: 'fad',
  iconName: 'chess-king',
  icon: [
    448,
    512,
    [9818],
    'f43f',
    [
      'M32 489.4C32 501.9 42.1 512 54.6 512l338.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L368 432 80 432 38.6 473.4c-4.2 4.2-6.6 10-6.6 16z',
      'M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 48L40.9 160C18.3 160 0 178.3 0 200.9c0 4.7 .8 9.3 2.4 13.8L80 432l288 0 77.6-217.3c1.6-4.4 2.4-9.1 2.4-13.8c0-22.6-18.3-40.9-40.9-40.9L256 160l0-48 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-16z',
    ],
  ],
};
const faNfcPen = {
  prefix: 'fad',
  iconName: 'nfc-pen',
  icon: [
    576,
    512,
    [],
    'e1fa',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l194.5 0 14-55.9c.7-2.8 1.6-5.5 2.6-8.1L112 416c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l187.6 0L352 331.6 352 144c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16l0 66.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48l0 155.6 64-64L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M493.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L311.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.7l-71-71z',
    ],
  ],
};
const faPersonHarassing = {
  prefix: 'fad',
  iconName: 'person-harassing',
  icon: [
    576,
    512,
    [],
    'e549',
    [
      'M320 480c0 11.7 6.5 23 17.7 28.6c4.6 2.3 9.5 3.4 14.3 3.4c11.7 0 23-6.5 28.6-17.7L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L576 344c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 58.7-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-2.3 4.6-3.4 9.5-3.4 14.3zm64-240a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM88 256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l35.9 0c28.6 0 55.6 12.7 73.9 34.7l73.7 88.9c11.3 13.6 9.4 33.8-4.2 45.1s-33.8 9.4-45.1-4.2L232 235.3 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1zM288 48c0-8.8 7.2-16 16-16l56 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56 0c-8.8 0-16-7.2-16-16zm-.8 49.7l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z',
    ],
  ],
};
const faMagnifyingGlassPlay = {
  prefix: 'fad',
  iconName: 'magnifying-glass-play',
  icon: [
    512,
    512,
    [],
    'e660',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm153.8-64c0-5.7 3.1-11 8-13.9s11.1-2.8 16 0l110.2 64c4.9 2.9 8 8.1 8 13.8s-3 11-8 13.8l-110.2 64c-4.9 2.9-11.1 2.9-16 0s-8-8.1-8-13.9l0-128z',
      'M161.8 130.1c-5 2.9-8 8.1-8 13.9l0 128c0 5.7 3.1 11 8 13.9s11.1 2.8 16 0l110.2-64c4.9-2.9 8-8.1 8-13.8s-3-11-8-13.8l-110.2-64c-4.9-2.9-11.1-2.9-16 0zM330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z',
    ],
  ],
};
const faHatWinter = {
  prefix: 'fad',
  iconName: 'hat-winter',
  icon: [
    512,
    512,
    [],
    'f7a8',
    [
      'M0 464c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7l416 0c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48zM176 80c0-12.7 9.8-23 22.2-23.9c-8.1-9.4-7.7-23.7 1.2-32.6s23.2-9.4 32.6-1.2C233 9.8 243.3 0 256 0s23 9.8 23.9 22.2c9.4-8.1 23.7-7.7 32.6 1.2s9.4 23.2 1.2 32.6C326.2 57 336 67.3 336 80s-9.8 23-22.2 23.9c8 9.3 7.7 23.2-.8 32.2c-.1 .2-.3 .3-.4 .4c-8.9 8.9-23.2 9.4-32.6 1.2C279 150.2 268.7 160 256 160s-23-9.8-23.9-22.2c-9.4 8.1-23.7 7.7-32.6-1.2c-.1-.1-.3-.3-.4-.4c-8.5-9-8.8-22.9-.8-32.2C185.8 103 176 92.7 176 80z',
      'M199 136.1c.1 .2 .3 .3 .4 .4c8.9 8.9 23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2c.1-.1 .3-.3 .4-.4c78.9 24 120.7 96.7 142.8 162.1l-.7 .3c-4.5 2.3-9.8 2.3-14.3 0l-35.4-17.7c-13.5-6.8-29.4-6.8-42.9 0l-35.4 17.7c-4.5 2.3-9.8 2.3-14.3 0l-35.4-17.7c-13.5-6.8-29.4-6.8-42.9 0l-35.4 17.7c-4.5 2.3-9.8 2.3-14.3 0l-35.4-17.7c-13.5-6.8-29.4-6.8-42.9 0L71.2 298.5c-4.5 2.3-9.8 2.3-14.3 0l-.7-.3c22.1-65.3 64-138.1 142.8-162.1zM46.9 329.1c12.5 4.8 26.5 4.1 38.6-1.9l35.4-17.7c4.5-2.3 9.8-2.3 14.3 0l35.4 17.7c13.5 6.8 29.4 6.8 42.9 0l35.4-17.7c4.5-2.3 9.8-2.3 14.3 0l35.4 17.7c13.5 6.8 29.4 6.8 42.9 0l35.4-17.7c4.5-2.3 9.8-2.3 14.3 0l35.4 17.7c12.1 6 26.1 6.7 38.6 1.9C477.9 377.7 480 416 480 416l0 2.7c-5-1.8-10.4-2.7-16-2.7L48 416c-5.6 0-11 1-16 2.7l0-2.7s2.1-38.3 14.9-86.9z',
    ],
  ],
};
const faBrazilianRealSign = {
  prefix: 'fad',
  iconName: 'brazilian-real-sign',
  icon: [
    512,
    512,
    [],
    'e46c',
    [
      'M288 165.9c0 48.2 29.3 91.5 74.1 109.4l52 20.8c20.5 8.2 33.9 28 33.9 50l0 3.4c0 27.9-22.6 50.5-50.5 50.5c-12.9 0-25.6-3.8-36.3-11l-23.4-15.6c-14.7-9.8-34.6-5.8-44.4 8.9c-3.6 5.5-5.4 11.6-5.4 17.7c0 10.3 5 20.5 14.3 26.7l23.4 15.6c13 8.6 27.3 14.8 42.3 18.3l0 19.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-21.3c46.4-14.6 80-58 80-109.2l0-3.4c0-48.2-29.3-91.5-74.1-109.4l-52-20.8c-20.5-8.2-33.9-28-33.9-50c0-29.7 24.1-53.9 53.9-53.9l1.7 0c11.1 0 22 2.6 32 7.5l10.2 5.1c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-10.1-5.1c-11.5-5.7-23.6-9.8-36.2-12.1L432 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 22.2C321.5 70 288 114 288 165.9z',
      'M32 32C14.3 32 0 46.3 0 64L0 288 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 42.3 0 56 139.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L170.3 307.7C220.8 285.3 256 234.8 256 176c0-79.5-64.5-144-144-144L32 32zm80 224l-48 0L64 96l48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z',
    ],
  ],
};
const faLandmarkDome = {
  prefix: 'fad',
  iconName: 'landmark-dome',
  icon: [
    512,
    512,
    ['landmark-alt'],
    'f752',
    [
      'M1.4 489.3C5.5 502.8 17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7c.9-3.1 1.4-6.2 1.4-9.3c0-10.5-5.2-20.6-14.2-26.6l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 256l-64 0 0 160-40 0 0-160-64 0 0 160-48 0 0-160-64 0 0 160-40 0 0-160-64 0 0 164.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9z',
      'M248 0c-13.3 0-24 10.7-24 24l0 10.7C143.6 48.1 80.1 111.6 66.7 192L64 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-2.7 0C431.9 111.6 368.4 48.1 288 34.7L288 24c0-13.3-10.7-24-24-24L248 0z',
    ],
  ],
};
const faLandmarkAlt = faLandmarkDome;
const faBoneBreak = {
  prefix: 'fad',
  iconName: 'bone-break',
  icon: [
    640,
    512,
    [],
    'f5d8',
    [
      'M0 272c0 35.8 23.5 66.1 55.9 76.3c4.6 1.5 8.3 5.1 9.3 9.8s-1.1 9.5-4.8 12.6C43.1 385.5 32 407.5 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-11.9 7-23.8 18.6-26.1L320 384 294.3 255.4c-3.5-17.3-20.3-28.6-37.7-25.1L186 244.4c-16.4 3.3-32.1-7.2-42.1-20.5C129.3 204.5 106.1 192 80 192c-44.2 0-80 35.8-80 80zM320 384l109.4 21.9C441 408.2 448 420.1 448 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-24.5-11.1-46.5-28.5-61.2c-3.7-3.1-5.7-7.9-4.8-12.6s4.7-8.4 9.3-9.8C616.5 338.1 640 307.8 640 272c0-44.2-35.8-80-80-80c-26.1 0-49.3 12.5-63.9 31.8c-10.1 13.3-25.7 23.8-42.1 20.5l-70.6-14.1c-17.3-3.5-34.2 7.8-37.7 25.1L320 384z',
      'M320 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zM167 71c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zM473 71c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faArrowUp = {
  prefix: 'fad',
  iconName: 'arrow-up',
  icon: [
    384,
    512,
    [8593],
    'f062',
    [
      'M160 141.3c10.7-10.7 21.3-21.3 32-32c10.7 10.7 21.3 21.3 32 32L224 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-306.7z',
      'M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 109.3 54.6 246.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z',
    ],
  ],
};
const faDownFromDottedLine = {
  prefix: 'fad',
  iconName: 'down-from-dotted-line',
  icon: [
    448,
    512,
    [],
    'e407',
    [
      'M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm96 0A32 32 0 1 1 96 64a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M196.7 468.7L73.9 345.9c-6.4-6.4-9.9-15-9.9-24C64 303.2 79.2 288 97.9 288l62.1 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 62.1 0c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24L251.3 468.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3z',
    ],
  ],
};
const faTv = {
  prefix: 'fad',
  iconName: 'tv',
  icon: [
    640,
    512,
    [63717, 'television', 'tv-alt'],
    'f26c',
    [
      'M0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zm64 0l0 288 512 0 0-288L64 64zM96 480c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32z',
      'M64 64H576V352H64V64z',
    ],
  ],
};
const faTelevision = faTv;
const faTvAlt = faTv;
const faBorderLeft = {
  prefix: 'fad',
  iconName: 'border-left',
  icon: [
    448,
    512,
    [],
    'f84f',
    [
      'M96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M32 480c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32z',
    ],
  ],
};
const faCircleDivide = {
  prefix: 'fad',
  iconName: 'circle-divide',
  icon: [
    512,
    512,
    [],
    'e106',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 0c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm144-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faShrimp = {
  prefix: 'fad',
  iconName: 'shrimp',
  icon: [
    512,
    512,
    [129424],
    'e448',
    [
      'M0 96C0 60.7 28.7 32 64 32l400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 64C46.3 64 32 78.3 32 96s14.3 32 32 32l0 24 0 8C28.7 160 0 131.3 0 96zm288 32l32 0 0 192-32 0c0-64 0-128 0-192zm32 279.8l3.2 1.1c9.9 3.4 19.9 3.3 28.8 .5l0 69.9c-5.3 .5-10.6 .7-16 .7l-16 0 0-72.2zm41.6-2.7c9.7-5.7 17.2-15 20.5-26.2L472.6 415c-7.3 9-15.5 17.3-24.5 24.7l-86.5-34.6zm3.3-76.5l133.5-92.4c4.3 10.2 7.6 20.9 9.9 32.1L382.8 355.1c-2.6-10.9-9.1-20.2-17.9-26.6z',
      'M64 128l24.8 0L256 128l32 0 0 192-32 0-24 0s0 0 0 0c-92.8 0-168-75.2-168-168l0-24zM320 320l0-192 16 0c73.1 0 135.8 44.6 162.4 108.1L364.9 328.5c-7.5-5.4-16.7-8.5-26.6-8.5L320 320zm62.8 35.1l125.6-86.9c2.4 11.6 3.7 23.6 3.7 35.9c0 42.1-14.8 80.7-39.4 111l-90.5-36.2c1.2-4.1 1.9-8.5 1.9-13.1c0-3.7-.4-7.2-1.2-10.6zm-21.2 50l86.5 34.6c-26.6 22-59.8 36.3-96.1 39.6l0-69.9c3.4-1.1 6.6-2.5 9.6-4.3zM320 407.8l0 72.2-72 0c-13.3 0-24-10.7-24-24c0-12.1 9-22.1 20.6-23.8l-4.5-1.6c-12.5-4.4-19.1-18.1-14.7-30.6s18.1-19.1 30.6-14.7L320 407.8zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faListCheck = {
  prefix: 'fad',
  iconName: 'list-check',
  icon: [
    512,
    512,
    ['tasks'],
    'f0ae',
    [
      'M160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32z',
      'M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faTasks = faListCheck;
const faDiagramSubtask = {
  prefix: 'fad',
  iconName: 'diagram-subtask',
  icon: [
    512,
    512,
    [],
    'e479',
    [
      'M96 224l0 96c0 53 43 96 96 96l32 0 0-64-32 0c-17.7 0-32-14.3-32-32l0-96-64 0z',
      'M64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32zM288 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-160 0z',
    ],
  ],
};
const faJugDetergent = {
  prefix: 'fad',
  iconName: 'jug-detergent',
  icon: [
    384,
    512,
    [],
    'e519',
    [
      'M64 72c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24c0-13.3-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24l0 24-8 0C74.7 48 64 58.7 64 72z',
      'M128 128C57.3 128 0 185.3 0 256L0 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-224c0-70.7-57.3-128-128-128l-128 0zm160 96c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faCircleUser = {
  prefix: 'fad',
  iconName: 'circle-user',
  icon: [
    512,
    512,
    [62142, 'user-circle'],
    'f2bd',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM113 384.2c22.1-38.3 63.5-64.2 111-64.2l64 0c47.4 0 88.9 25.8 111 64.2C363.8 423.3 312.8 448 256 448s-107.8-24.7-143-63.8zM328 200a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z',
      'M256 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 176c56.8 0 107.8-24.7 143-63.8C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8z',
    ],
  ],
};
const faUserCircle = faCircleUser;
const faSquareY = {
  prefix: 'fad',
  iconName: 'square-y',
  icon: [
    448,
    512,
    [],
    'e287',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96.1 69.5c.1-.8 .2-1.7 .4-2.5c.3-1.6 .9-3.3 1.6-4.8c1.4-3.1 3.5-6 6.2-8.3c10-8.7 25.2-7.6 33.9 2.4c28.6 33 57.2 66.1 85.9 99.1c28.6-33 57.2-66.1 85.9-99.1c4.7-5.5 11.4-8.3 18.1-8.3c5.6 0 11.2 1.9 15.7 5.9c10 8.7 11.1 23.8 2.4 33.9C313.4 221.5 280.7 259.2 248 297l0 79c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-1.2-.4-2.4-.4-2.4c-.1-1.2-.1-1.2-.1-2.5c0-26.4 0-52.7 0-79L101.9 183.7c-2-2.3-3.4-4.8-4.4-7.5c-.5-1.3-.9-2.7-1.1-4.1c-.2-1-.3-2.1-.3-2.1c-.1-1-.1-1-.1-2.1c0-.8 0-1 0-1.3c0-.4 .1-.8 .1-1.2z',
      'M104.3 149.9c10-8.7 25.2-7.6 33.9 2.4L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297l0 79c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-79L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9z',
    ],
  ],
};
const faUserDoctorHair = {
  prefix: 'fad',
  iconName: 'user-doctor-hair',
  icon: [
    448,
    512,
    [],
    'e458',
    [
      'M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32c-12 0-24 0-36 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112c-18.7 0-37.3 0-56 0c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128z',
      'M120 112l56 0c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96l36 0C333.8 40.8 283.6 0 224 0C160.3 0 107.5 46.5 97.7 107.4c6.8 3 14.4 4.6 22.3 4.6zM288 304.2c-2.7-.1-5.3-.2-8-.2l-112 0c-2.7 0-5.3 .1-8 .2l0 66.1c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-61.5C54.5 326.7 0 393 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-79-54.5-145.3-128-163.2l0 53.2c27.6 7.1 48 32.2 48 62l0 40c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-40c0-29.8 20.4-54.9 48-62l0-57.8zM168 424a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faPlanetRinged = {
  prefix: 'fad',
  iconName: 'planet-ringed',
  icon: [
    512,
    512,
    [129680],
    'e020',
    [
      'M0 480.2c0-30.8 24.1-81.1 65.5-139.8c2.5 5 5 10 7.7 14.9c2.7 5 5.6 9.8 8.8 14.6c.2 .3 .4 .6 .6 .9c1.5 2.2 3 4.4 4.6 6.6c1.6 2.2 3.2 4.4 4.9 6.6l.3 .4c1.8 2.3 3.6 4.5 5.6 6.9c.9 1.1 1.9 2.1 3 3.4c.9 1 1.8 2 2.7 3c-5.7 8.8-11.1 17.8-16.3 26.9c9.1-5.2 18-10.6 26.9-16.3c58.5-37.6 111.3-85 160.1-133.8s96.3-101.7 133.8-160.1c5.7-8.8 11.1-17.8 16.3-26.9c-9.1 5.2-18 10.6-26.9 16.3c-2.2-2.1-4.4-4-6.6-5.9c-6.7-5.7-13.7-11-20.9-15.7l-.6-.4c-2.3-1.5-4.6-2.9-6.9-4.3c-2.5-1.5-5-2.9-7.5-4.3c-2.4-1.3-4.9-2.6-7.4-3.8l-.4-.2c-1.1-.5-2.3-1.1-3.4-1.6c-.3-.1-.5-.2-.8-.4c-.7-.3-1.5-.7-2.2-1c-.3-.1-.5-.2-.8-.4C418.3 10.4 481.7-14 503.9 8.1c5.5 5.5 8.1 13.5 8.1 23.7c0 30.8-24.1 81.3-65.7 140c-32.6 46-75.8 97.1-126.6 147.9s-101.8 94-147.9 126.6C93.7 501.6 30.3 526 8.1 503.9C2.6 498.4 0 490.4 0 480.2z',
      'M408.3 114.3C370.3 73.5 316.1 48 256 48C141.1 48 48 141.1 48 256c0 60.1 25.5 114.3 66.3 152.3c58.5-37.6 111.3-85 160.1-133.8s96.3-101.7 133.8-160.1zm38 57.5c-32.6 46-75.8 97.1-126.6 147.9s-101.8 94-147.9 126.6C197.6 457.7 226 464 256 464c114.9 0 208-93.1 208-208c0-30-6.3-58.4-17.7-84.2z',
    ],
  ],
};
const faMushroom = {
  prefix: 'fad',
  iconName: 'mushroom',
  icon: [
    512,
    512,
    [127812],
    'e425',
    [
      'M96 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM144 96c0 44.2 35.8 80 80 80s80-35.8 80-80c0-26-12.4-49.2-31.7-63.8c-3.5-.2-6.9-.2-10.4-.2l-11.8 0c-33.1 0-64.5 7.1-92.9 19.9C148.9 64.5 144 79.7 144 96zm25 344.2c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3l112 0c9.9 0 19.2-4.5 25.2-12.3s8.2-17.9 5.8-27.5L313 320l-114 0L169 440.2zM368 176c0 35.3 28.7 64 64 64c21.2 0 40-10.3 51.7-26.2c-7.6-38.3-24.9-73.1-49.2-101.7c-.4 0-.8 0-1.2 0c-36.6 0-65.3 28.7-65.3 64z',
      'M224 176c44.2 0 80-35.8 80-80c0-26-12.4-49.2-31.7-63.8c65 2.9 122.8 33.3 162.2 79.8c-.8 0-1.7 0-2.5 0c-35.3 0-64 28.7-64 64s28.7 64 64 64c21.2 0 40-10.3 51.7-26.2c2.8 14.3 4.3 29.1 4.3 44.3c0 34.2-27.7 61.9-61.9 61.9L85.9 320C51.7 320 24 292.3 24 258.1C24 166.3 78.7 87.3 157.3 51.9C148.9 64.5 144 79.7 144 96c0 44.2 35.8 80 80 80zm-96 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faUserShield = {
  prefix: 'fad',
  iconName: 'user-shield',
  icon: [
    640,
    512,
    [],
    'f505',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c17.6 0 34.6 2.6 50.7 7.3c3.3 59.2 26.8 145.1 103.1 200.2c-1.7 .3-3.5 .5-5.3 .5L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M504.9 225.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48zm-8.9 236l0-187.8L591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7z',
    ],
  ],
};
const faMegaphone = {
  prefix: 'fad',
  iconName: 'megaphone',
  icon: [
    576,
    512,
    [128227],
    'f675',
    [
      'M0 192L0 320c0 17.7 14.3 32 32 32c17.3 0 31.4-13.8 32-30.9c34.1 9.7 68.1 19.3 102.2 29l46.5 13.2c30.3 8.6 60.7 17.2 91 25.8c15.5 4.4 31 8.8 46.5 13.2L512 448l0-384L64 190.9C63.4 173.8 49.3 160 32 160c-17.7 0-32 14.3-32 32z',
      'M544 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32zM160 384c0 53 43 96 96 96c46.8 0 85.8-33.5 94.3-77.8L303.7 389c-2.5 24.2-22.9 43-47.7 43c-26.5 0-48-21.5-48-48c0-7.4 1.7-14.5 4.7-20.8L166.2 350c-4 10.6-6.2 22-6.2 34z',
    ],
  ],
};
const faWreathLaurel = {
  prefix: 'fad',
  iconName: 'wreath-laurel',
  icon: [
    640,
    512,
    [],
    'e5d2',
    [
      'M160 488c0 3.6 .8 7.3 2.5 10.7c4.2 8.4 12.7 13.3 21.5 13.3c3.6 0 7.3-.8 10.7-2.5l9.9-5c32.2-16.1 67.7-24.5 103.8-24.5l11.6 0c-2.5 0-5.1 0-7.6-.1s-5-.2-7.5-.4c-5-.3-9.9-.8-14.8-1.5c-9.8-1.3-19.4-3.2-28.7-5.8c-2.3-.6-4.7-1.3-7-2c-2.3-.7-4.6-1.4-6.8-2.2c-4.5-1.6-9-3.2-13.4-5.1c-8.8-3.7-17.3-7.9-25.5-12.6c-8.6 3.3-17.1 7-25.4 11.2l-9.9 5c-8.4 4.2-13.3 12.7-13.3 21.5zm160-56l11.6 0c2.1 0 4.3 0 6.4 .1s4.3 .1 6.4 .2c4.3 .2 8.5 .5 12.8 .9c8.5 .8 16.9 1.9 25.3 3.5c16.7 3.1 33.1 7.7 49 13.7c5.6-3.2 11-6.7 16.3-10.3c59.6 28.2 131.9 6.3 165.4-51.8l8-13.9c4.4-7.7 1.8-17.4-5.9-21.9c-13.8-8-28.4-13.1-43.3-15.5c40.4-21.5 68-64.1 68-113.1l0-16c0-8.8-7.2-16-16-16c-15.9 0-31.1 2.9-45.2 8.2c24.3-38.8 26.8-89.5 2.3-131.9l-8-13.9c-4.4-7.7-14.2-10.3-21.9-5.9C525 63.7 506.2 86.8 496 113l0-1C496 50.1 445.9 0 384 0L368 0c-8.8 0-16 7.2-16 16l0 16c0 60.2 47.5 109.3 107 111.9c23.9 32.2 37 71.5 37 112.1c0 97.2-78.8 176-176 176z',
      'M144 112C144 50.1 194.1 0 256 0l16 0c8.8 0 16 7.2 16 16l0 16c0 60.2-47.5 109.3-107 111.9c-23.9 32.2-37 71.5-37 112.1c0 97.2 78.8 176 176 176l11.6 0c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480L320 480c-47.5 0-91.5-14.8-127.7-39.9c-59.6 28.2-131.9 6.3-165.4-51.8l-8-13.9c-4.4-7.7-1.8-17.4 5.9-21.9c13.8-8 28.4-13.1 43.3-15.5C27.5 315.6 0 273 0 224l0-16c0-8.8 7.2-16 16-16c15.9 0 31.1 2.9 45.2 8.2c-24.3-38.8-26.8-89.5-2.3-131.9l8-13.9c4.4-7.7 14.2-10.3 21.9-5.9C115 63.7 133.8 86.8 144 113l0-1z',
    ],
  ],
};
const faCircleExclamationCheck = {
  prefix: 'fad',
  iconName: 'circle-exclamation-check',
  icon: [
    640,
    512,
    [],
    'e10d',
    [
      'M0 256C0 397.4 114.6 512 256 512c94.8 0 177.5-51.5 221.8-128c-15.6-.5-31.1-6.8-43-18.7l-64-64c-25-25-25-65.5 0-90.5s65.5-25 90.5 0L480 229.5 506.5 203C482.1 87 379.2 0 256 0C114.6 0 0 114.6 0 256zm288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM625 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 209z',
    ],
  ],
};
const faWind = {
  prefix: 'fad',
  iconName: 'wind',
  icon: [
    512,
    512,
    [],
    'f72e',
    [
      'M0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c53 0 96-43 96-96s-43-96-96-96L32 224c-17.7 0-32 14.3-32 32z',
      'M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c53 0 96-43 96-96s-43-96-96-96L320 0zM128 512l32 0c53 0 96-43 96-96s-43-96-96-96L32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z',
    ],
  ],
};
const faBoxDollar = {
  prefix: 'fad',
  iconName: 'box-dollar',
  icon: [
    448,
    512,
    ['box-usd'],
    'f4a0',
    [
      'M0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160zM240 32l0 128 208 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32z',
      'M448 160l-208 0 0-128-32 0 0 128L0 160 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256zM244 216l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2s0 0 0 0c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c0 0 0 0 0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z',
    ],
  ],
};
const faBoxUsd = faBoxDollar;
const faCarBurst = {
  prefix: 'fad',
  iconName: 'car-burst',
  icon: [
    640,
    512,
    ['car-crash'],
    'f5e1',
    [
      'M20.9 193.9c-6 4.1-3.9 13.4 3.3 14.5L95 219.3c4.1 .6 7.1 4.3 6.8 8.5l-5.2 71.4c-.5 7.2 8.1 11.4 13.4 6.5L162.6 257c1.2-1.1 2.7-1.8 4.2-2l5.8-21.5c8-29.9 30.5-52.1 57.9-60.9L266.7 120l22.5-39.2c3.6-6.3-2.3-13.8-9.3-11.6l-68.5 21c-4 1.2-8.3-.8-9.8-4.7L175.4 18.8c-1.3-3.4-4.4-5.1-7.4-5.1s-6.1 1.7-7.4 5.1L134.3 85.4c-1.5 3.9-5.8 5.9-9.8 4.7L56 69.2c-6.9-2.1-12.9 5.3-9.3 11.6l35.7 62.1c2.1 3.6 1 8.2-2.4 10.6L20.9 193.9zm182.5 47.8c1.5-5.6 3.8-10.8 6.7-15.4c-1.5 2.3-2.8 4.8-3.9 7.4c-.6 1.3-1.1 2.6-1.6 4c-.2 .7-.5 1.3-.7 2.1c-.2 .7-.4 1.3-.6 2.1z',
      'M350.4 167.8l-32.2 46.6 201.5 54L515 212c-.5-6.7-5.3-12.4-11.8-14.2L367.7 161.5c-6.5-1.8-13.5 .8-17.3 6.4zM249.8 200.7l47.9-69.3c19.2-27.8 53.9-40.5 86.5-31.8L519.8 136c32.7 8.8 56.3 37.1 59 70.8l6.8 84c17.2 13.4 25.6 36.3 19.6 58.7L595 388l-16.6 61.8-8.3 30.9c-4.6 17.1-22.1 27.2-39.2 22.6l-15.5-4.1c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9L253.8 362.9l-8.3 30.9c-4.6 17.1-22.1 27.2-39.2 22.6l-15.5-4.1c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9 16.6-61.8 10.4-38.6c6-22.4 24.7-38 46.3-41zm47.9 91.1a24 24 0 1 0 -46.4-12.4 24 24 0 1 0 46.4 12.4zm217.9 83.2A24 24 0 1 0 528 328.7a24 24 0 1 0 -12.4 46.4z',
    ],
  ],
};
const faCarCrash = faCarBurst;
const faY = {
  prefix: 'fad',
  iconName: 'y',
  icon: [
    384,
    512,
    [121],
    '59',
    [
      'M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-149.7L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z',
      '',
    ],
  ],
};
const faUserHeadset = {
  prefix: 'fad',
  iconName: 'user-headset',
  icon: [
    448,
    512,
    [],
    'f82d',
    [
      'M96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256l-8.6 0c-11.1-19.1-31.7-32-55.4-32l-32 0c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192z',
      'M224 32C135.6 32 64 103.6 64 192l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16C32 86 118 0 224 0S416 86 416 192l0 16c0 61.9-50.1 112-112 112l-64 0-16 0-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l32 0c44.2 0 80-35.8 80-80l0-16c0-88.4-71.6-160-160-160zM134.4 352l179.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352z',
    ],
  ],
};
const faArrowsRetweet = {
  prefix: 'fad',
  iconName: 'arrows-retweet',
  icon: [
    640,
    512,
    ['retweet-alt'],
    'f361',
    [
      'M304 128c0-17.7 14.3-32 32-32l112 0c53 0 96 43 96 96l0 146.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0c6.2 6.2 9.4 14.4 9.4 22.6s-3.1 16.4-9.4 22.6l-96 96c-6.2 6.2-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L480 338.7 480 192c0-17.7-14.3-32-32-32l-112 0c-17.7 0-32-14.3-32-32z',
      'M105.4 73.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 173.3 160 320c0 17.7 14.3 32 32 32l112 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-112 0c-53 0-96-43-96-96l0-146.7L54.6 214.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z',
    ],
  ],
};
const faRetweetAlt = faArrowsRetweet;
const faPersonSnowboarding = {
  prefix: 'fad',
  iconName: 'person-snowboarding',
  icon: [
    512,
    512,
    [127938, 'snowboarding'],
    'f7ce',
    [
      'M0 312c0 6.1 2.3 12.3 7 17l22.4 22.4c8.7 8.7 19.2 15.5 30.8 20L412.4 506.2c10 3.8 20.7 5.8 31.5 5.8l28.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-28.2 0c-4.9 0-9.7-.9-14.3-2.6c-28.8-11-57.6-22.1-86.5-33.1L297.9 411c-53-20.3-106-40.6-159-60.9c-13.1-5-26.1-10-39.2-15c-7.5-2.9-15-5.7-22.4-8.6c-5.2-2-10-5.1-14-9.1L41 295c-9.4-9.4-24.6-9.4-33.9 0c-4.7 4.7-7 10.8-7 17z',
      'M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21L297.9 411c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1l-39.2-15c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faSnowboarding = faPersonSnowboarding;
const faSquareChevronRight = {
  prefix: 'fad',
  iconName: 'square-chevron-right',
  icon: [
    448,
    512,
    ['chevron-square-right'],
    'f32b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm168 56c0-6.1 2.3-12.3 7-17s10.8-7 17-7s12.3 2.3 17 7L313 239c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17L209 377c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17s2.3-12.3 7-17l87-87-87-87c-4.7-4.7-7-10.8-7-17z',
      'M313 239c9.4 9.4 9.4 24.6 0 33.9L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239z',
    ],
  ],
};
const faChevronSquareRight = faSquareChevronRight;
const faLacrosseStickBall = {
  prefix: 'fad',
  iconName: 'lacrosse-stick-ball',
  icon: [
    576,
    512,
    [],
    'e3b6',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l136-136c-18.7-11-34.3-26.6-45.3-45.3l-136 136C3.1 463.6 0 471.8 0 480zm416-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M264.8 117.7l-3.3 11.5c-5.6 19.6-15.1 37.9-27.8 53.9L205.8 218c-8.9 11.1-13.8 25-13.8 39.2c0 34.7 28.1 62.8 62.8 62.8c14.3 0 28.1-4.9 39.2-13.8l34.9-27.9c15.9-12.8 34.3-22.2 53.9-27.8l11.5-3.3c31.8-9.1 53.7-38.1 53.7-71.2c0 0 0 0 0 0c0-.1 0-.2 0-.3c0-19.9-13.6-48.1-38.6-73.1s-53.2-38.6-73.1-38.6l-.3 0s0 0 0 0c-33.1 0-62.1 21.9-71.2 53.7zM512 176s0 0 0 0c0 61.6-40.9 115.8-100.1 132.7L400.3 312c-11.5 3.3-22.2 8.8-31.5 16.2l-34.9 27.9c-22.5 18-50.4 27.8-79.2 27.8c-70 0-126.8-56.8-126.8-126.8c0-28.8 9.8-56.7 27.8-79.2l27.9-34.9c7.4-9.3 13-20 16.2-31.5l3.3-11.5C220.2 40.9 274.4 0 336 0c0 0 0 0 0 0l.3 0c43.8 0 87.4 26.4 118.4 57.3s57.3 74.5 57.3 118.4l0 .3z',
    ],
  ],
};
const faTruckFast = {
  prefix: 'fad',
  iconName: 'truck-fast',
  icon: [
    640,
    512,
    ['shipping-fast'],
    'f48b',
    [
      'M0 112c0 8.8 7.2 16 16 16l48 0 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 96 16 96c-8.8 0-16 7.2-16 16zM0 240c0 8.8 7.2 16 16 16l48 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 224l-48 0c-8.8 0-16 7.2-16 16zm32-64c0 8.8 7.2 16 16 16l16 0 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 160l-16 0c-8.8 0-16 7.2-16 16zM96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M64 48C64 21.5 85.5 0 112 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96c-48.1 0-89.2 30.4-105 73c-4.4-7.3-7-15.8-7-25l0-112 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 224l0-32 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 160l0-32 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 96l0-48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96z',
    ],
  ],
};
const faShippingFast = faTruckFast;
const faUserMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'user-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e5c5',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c6.4 0 12.7 .3 19 1c-.5 4.9-.7 9.9-.7 15c0 88.4 71.6 160 160 160c0 .8 0 1.5 0 2.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M528 320.1a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 426c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426z',
    ],
  ],
};
const faStarSharp = {
  prefix: 'fad',
  iconName: 'star-sharp',
  icon: [
    576,
    512,
    [],
    'e28b',
    [
      'M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176 56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2l-158.4 0L310.9 16.7z',
      '',
    ],
  ],
};
const faCommentHeart = {
  prefix: 'fad',
  iconName: 'comment-heart',
  icon: [
    512,
    512,
    [],
    'e5c8',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm144-34.7c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4c2.5-2.5 5-5 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3c-27.6 27.6-55.2 55.2-82.7 82.7c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-27.6-27.6-55.2-55.2-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z',
      'M205.3 144c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z',
    ],
  ],
};
const faCircle1 = {
  prefix: 'fad',
  iconName: 'circle-1',
  icon: [
    512,
    512,
    [],
    'e0ee',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM168 360c0-13.3 10.7-24 24-24l40 0 0-142.6-20.1 11.5c-11.5 6.6-26.2 2.6-32.7-8.9s-2.6-26.2 8.9-32.7l56-32c3.7-2.1 7.8-3.2 11.9-3.2c4.2 0 8.3 1.1 12 3.2c7.4 4.3 12 12.2 12 20.8l0 184 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-64 0c-13.3 0-24-10.7-24-24z',
      'M280 152c0-8.6-4.6-16.5-12-20.8s-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L232 193.4 232 336l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184z',
    ],
  ],
};
const faCircleStar = {
  prefix: 'fad',
  iconName: 'circle-star',
  icon: [
    512,
    512,
    ['star-circle'],
    'e123',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm111.4-47c1.9-5.8 6.9-10 12.9-10.9c27-3.9 54-7.9 81.1-11.8c12.1-24.5 24.2-49 36.2-73.4c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9c12.1 24.5 24.2 49 36.2 73.4c27 3.9 54 7.9 81 11.8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-58.6 57.2 13.8 80.7c1 6-1.4 12.1-6.4 15.6c-2.8 2-6.1 3.1-9.4 3.1c-2.5 0-5.1-.6-7.4-1.8c-24.2-12.7-48.3-25.4-72.5-38.1c-24.2 12.7-48.3 25.4-72.5 38.1c-2.3 1.2-4.9 1.8-7.4 1.8c-3.3 0-6.6-1-9.4-3.1c-4.9-3.6-7.4-9.6-6.4-15.6c4.6-26.9 9.2-53.8 13.8-80.7l-58.6-57.2c-4.4-4.3-5.9-10.6-4-16.4z',
      'M270.3 112.9c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4-81.1 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81-11.8-36.2-73.4z',
    ],
  ],
};
const faStarCircle = faCircleStar;
const faFish = {
  prefix: 'fad',
  iconName: 'fish',
  icon: [
    576,
    512,
    [128031],
    'f578',
    [
      'M0 160c0 5.4 1.4 10.9 4.2 15.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l89.7-52.3c12.2 14.6 26.5 29.4 42.7 43.1c39.2 33.1 92 61.5 155.5 61.5s116.3-28.5 155.5-61.5c39.1-33 66.9-72.4 81-99.8c2.4-4.6 3.6-9.6 3.6-14.7s-1.2-10.1-3.6-14.7c-14.1-27.4-41.9-66.8-81-99.8C452.3 108.5 399.4 80 336 80s-116.3 28.5-155.5 61.5c-16.2 13.7-30.5 28.5-42.7 43.1L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9C3.2 143.4 0 151.7 0 160zm448 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M416 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
    ],
  ],
};
const faCloudFog = {
  prefix: 'fad',
  iconName: 'cloud-fog',
  icon: [
    640,
    512,
    [127787, 'fog'],
    'f74e',
    [
      'M0 392c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 368c-13.3 0-24 10.7-24 24zm64 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 464c-13.3 0-24 10.7-24 24zm208 0c0 13.3 10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-13.3 0-24 10.7-24 24z',
      'M64 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C320.5 24.3 283.1 0 240 0C178.1 0 128 50.1 128 112c0 7.1 .7 14.1 1.9 20.8C91.6 145.4 64 181.5 64 224z',
    ],
  ],
};
const faFog = faCloudFog;
const faWaffle = {
  prefix: 'fad',
  iconName: 'waffle',
  icon: [
    512,
    512,
    [129479],
    'e466',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm48 0c0-8.8 7.2-16 16-16l80 0 0-64-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 64 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 64 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64-80 0c-8.8 0-16-7.2-16-16zm128-80l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm96-96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z',
      'M272 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-80zm64 272l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zm0-96l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64z',
    ],
  ],
};
const faMusicNote = {
  prefix: 'fad',
  iconName: 'music-note',
  icon: [
    384,
    512,
    ['music-alt'],
    'f8cf',
    [
      'M192 64l0 64 0 231.7c37.8 12.8 64 40.4 64 72.3l0-279L359.8 127C374 123.5 384 110.7 384 96l0-64c0-9.9-4.5-19.2-12.3-25.2S353.8-1.4 344.2 1l-128 32C202 36.5 192 49.3 192 64z',
      'M144 352a112 80 0 1 0 0 160 112 80 0 1 0 0-160z',
    ],
  ],
};
const faMusicAlt = faMusicNote;
const faHexagonExclamation = {
  prefix: 'fad',
  iconName: 'hexagon-exclamation',
  icon: [
    512,
    512,
    [],
    'e417',
    [
      'M7.4 256c0 12.4 3.2 24.9 9.6 36l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c6.4-11.1 9.6-23.6 9.6-36s-3.2-24.9-9.6-36L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220c-6.4 11.1-9.6 23.6-9.6 36zM288 352a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faCartShoppingFast = {
  prefix: 'fad',
  iconName: 'cart-shopping-fast',
  icon: [
    640,
    512,
    [],
    'e0dc',
    [
      'M0 120c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 96C10.7 96 0 106.7 0 120zm0 80c0 13.3 10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24zm0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 256c-13.3 0-24 10.7-24 24zM184.1 32c2 4.2 3.5 8.8 4.4 13.5c15.4 80.8 30.8 161.7 46.2 242.5l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.3-39.9-40-39.9l-411 0z',
      'M64 24C64 10.7 74.7 0 88 0l45.5 0c26.9 0 50 19.1 55 45.5l51.6 271c2.2 11.3 12.1 19.5 23.6 19.5L552 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5L88 48C74.7 48 64 37.3 64 24zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faObjectUnion = {
  prefix: 'fad',
  iconName: 'object-union',
  icon: [
    512,
    512,
    [],
    'e49f',
    [
      '',
      'M64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l96 0 0 96c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0-96c0-35.3-28.7-64-64-64L64 0z',
    ],
  ],
};
const faUserGraduate = {
  prefix: 'fad',
  iconName: 'user-graduate',
  icon: [
    448,
    512,
    [],
    'f501',
    [
      'M96 144l256 0 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16z',
      'M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9l0 41.1L96 144l0-41.1L48 93.3l0 65.1 15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9l-32 0c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4l0-71.8C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z',
    ],
  ],
};
const faStarfighter = {
  prefix: 'fad',
  iconName: 'starfighter',
  icon: [
    640,
    512,
    [],
    'e037',
    [
      'M0 144c0 13.3 10.7 24 24 24l0 280c0 13.3 10.7 24 24 24s24-10.7 24-24l0-4 0-92 0-184c13.3 0 24-10.7 24-24s-10.7-24-24-24l0-24c0-13.3-10.7-24-24-24S24 82.7 24 96l0 24c-13.3 0-24 10.7-24 24zM128 320l0 32 0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm160-64l0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 64l0 32 0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zM544 144c0 13.3 10.7 24 24 24l0 184 0 92 0 4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-280c13.3 0 24-10.7 24-24s-10.7-24-24-24l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24c-13.3 0-24 10.7-24 24z',
      'M353.8 14c-1-8-7.8-14-15.9-14L302.1 0c-8.1 0-14.9 6-15.9 14L256 256l0 96-32 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-56 0 0 92 88 26.4 0 9.6c0 17.7 14.3 32 32 32s32-14.3 32-32l48 0 96 0 48 0c0 17.7 14.3 32 32 32s32-14.3 32-32l0-9.6L568 444l0-92-56 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-32 0 0-96L353.8 14zM288 256c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48z',
    ],
  ],
};
const faCircleHalfStroke = {
  prefix: 'fad',
  iconName: 'circle-half-stroke',
  icon: [
    512,
    512,
    [9680, 'adjust'],
    'f042',
    [
      'M256 0l0 64c106 0 192 86 192 192s-86 192-192 192l0 64c141.4 0 256-114.6 256-256S397.4 0 256 0z',
      'M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512L256 0z',
    ],
  ],
};
const faAdjust = faCircleHalfStroke;
const faArrowRightLongToLine = {
  prefix: 'fad',
  iconName: 'arrow-right-long-to-line',
  icon: [
    640,
    512,
    [],
    'e3d5',
    [
      'M576 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z',
    ],
  ],
};
const faSquareArrowDown = {
  prefix: 'fad',
  iconName: 'square-arrow-down',
  icon: [
    448,
    512,
    ['arrow-square-down'],
    'f339',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM88 264c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l71 71L200 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17L241 393c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L95 281c-4.7-4.7-7-10.8-7-17z',
      'M207 393c9.4 9.4 24.6 9.4 33.9 0L353 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71L248 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 182.1-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 393z',
    ],
  ],
};
const faArrowSquareDown = faSquareArrowDown;
const faDiamondHalfStroke = {
  prefix: 'fad',
  iconName: 'diamond-half-stroke',
  icon: [
    512,
    512,
    [],
    'e5b8',
    [
      'M256 0l0 78.5L433.5 256 256 433.5l0 78.5c10.2 0 20.5-3.9 28.3-11.7l216-216c7.8-7.8 11.7-18 11.7-28.3s-3.9-20.5-11.7-28.3l-216-216C276.5 3.9 266.2 0 256 0z',
      'M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7L256 0z',
    ],
  ],
};
const faClapperboard = {
  prefix: 'fad',
  iconName: 'clapperboard',
  icon: [
    512,
    512,
    [],
    'e131',
    [
      'M0 160l6.1 0 67.9 0 92.1 0 67.9 0 92.1 0 67.9 0L512 160l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160z',
      'M453.8 32.3L327 159l-1 1-92.1 0L361 33l1-1L448 32c2 0 3.9 .1 5.8 .3zM393.9 160L498 56c8.8 11 14 24.9 14 40l0 64-118.1 0zM201.9 32l92.1 0L167 159l-1 1-92.1 0L201 33l1-1zm-67.9 0L7 159l-1 1L0 160 0 96C0 60.7 28.7 32 64 32l70.1 0z',
    ],
  ],
};
const faSquareChevronLeft = {
  prefix: 'fad',
  iconName: 'square-chevron-left',
  icon: [
    448,
    512,
    ['chevron-square-left'],
    'f32a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM128 256c0-6.1 2.3-12.3 7-17L239 135c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-87 87 87 87c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7L135 273c-4.7-4.7-7-10.8-7-17z',
      'M135 273c-9.4-9.4-9.4-24.6 0-33.9L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273z',
    ],
  ],
};
const faChevronSquareLeft = faSquareChevronLeft;
const faPhoneIntercom = {
  prefix: 'fad',
  iconName: 'phone-intercom',
  icon: [
    512,
    512,
    [],
    'e434',
    [
      'M160 96l0 320c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L224 32c-35.3 0-64 28.7-64 64zm64 32c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-96zm96 240a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm32-32c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z',
      'M48 32C21.5 32 0 53.5 0 80L0 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 32zM368 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z',
    ],
  ],
};
const faLinkHorizontal = {
  prefix: 'fad',
  iconName: 'link-horizontal',
  icon: [
    640,
    512,
    ['chain-horizontal'],
    'e1cb',
    [
      'M192 303.4C192 383.3 256.7 448 336.6 448l158.8 0C575.3 448 640 383.3 640 303.4c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-1.8-.3-3.6-.4-5.3-.4c-15.4 0-28.9 11.1-31.5 26.7c-2.9 17.4 8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 44.5-36.1 80.6-80.6 80.6l-158.8 0c-44.5 0-80.6-36.1-80.6-80.6c0-39.4 28.5-73 67.4-79.5l1.9-.3c17.4-2.9 29.2-19.4 26.3-36.8C349 171.1 335.4 160 320 160c-1.7 0-3.5 .1-5.3 .4l-1.9 .3C243.1 172.4 192 232.7 192 303.4z',
      'M0 208.6C0 128.7 64.7 64 144.6 64l158.8 0C383.3 64 448 128.7 448 208.6c0 70.7-51.1 131-120.8 142.6l-1.9 .3c-17.4 2.9-33.9-8.9-36.8-26.3s8.9-33.9 26.3-36.8l1.9-.3c38.9-6.5 67.4-40.1 67.4-79.5c0-44.5-36.1-80.6-80.6-80.6l-158.8 0C100.1 128 64 164.1 64 208.6c0 39.4 28.5 73 67.4 79.5l1.9 .3c17.4 2.9 29.2 19.4 26.3 36.8s-19.4 29.2-36.8 26.3l-1.9-.3C51.1 339.6 0 279.3 0 208.6z',
    ],
  ],
};
const faChainHorizontal = faLinkHorizontal;
const faMango = {
  prefix: 'fad',
  iconName: 'mango',
  icon: [
    512,
    512,
    [],
    'e30f',
    [
      'M0 408c0 26.8 17 51.8 43.9 60.7c0 0 100.1 43.3 244.1 43.3c166.5 0 224-147.4 224-224c0-49.1-18.7-98.3-56.2-135.8c-25.2-25.2-55.6-41.9-87.8-50.2l0 25.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c-49.1 0-98.3 18.7-135.8 56.2c-45.8 37.2-67.8 76.7-88.4 113.5c-19.1 34.1-36.9 66-71.2 91.8C15 365 7.4 375.4 3.3 387.9C1 394.5 0 401.3 0 408zm288 8c0-8.8 7.2-16 16-16c53 0 96-43 96-96c0-8.8 7.2-16 16-16s16 7.2 16 16c0 70.7-57.3 128-128 128c-8.8 0-16-7.2-16-16z',
      'M352 0l-8 0c-13.3 0-24 10.7-24 24l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-74.9C385.2 79 414.6 96 448 96l40 0c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72L384 0l-8 0L352 0z',
    ],
  ],
};
const faMusicNoteSlash = {
  prefix: 'fad',
  iconName: 'music-note-slash',
  icon: [
    640,
    512,
    ['music-alt-slash'],
    'f8d0',
    [
      'M160 432c0 44.2 50.1 80 112 80s112-35.8 112-80l0-33.5-64-50.4 0 11.6c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80zM320 64l0 64 0 97.5c21.3 16.7 42.7 33.4 64 50.2L384 153 487.8 127C502 123.5 512 110.7 512 96l0-64c0-9.9-4.5-19.2-12.3-25.2S481.8-1.4 472.2 1l-128 32C330 36.5 320 49.3 320 64z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faMusicAltSlash = faMusicNoteSlash;
const faCircleRadiation = {
  prefix: 'fad',
  iconName: 'circle-radiation',
  icon: [
    512,
    512,
    [9762, 'radiation-alt'],
    'f7ba',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm448 0A192 192 0 1 1 64 256a192 192 0 1 1 384 0zm-224 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5z',
    ],
  ],
};
const faRadiationAlt = faCircleRadiation;
const faFaceTongueSweat = {
  prefix: 'fad',
  iconName: 'face-tongue-sweat',
  icon: [
    576,
    512,
    [],
    'e39e',
    [
      'M32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3c28.9 31.4 65.5 55.5 106.9 69.4C197.3 484 192 466.6 192 448l0-31.3c-10.2-7.2-16-15.7-16-24.7c0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7l0 31.3c0 18.6-5.3 36-14.5 50.8C470.9 464.7 544 368.9 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256zm80.2-45.4c-1.5-8.7 4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2zM239.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM348.7 148.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c7.8 1.3 13.4 8.1 13.4 15.8c0 .9-.1 1.8-.2 2.6c-1.5 8.7-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z',
      'M227.3 148.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM207.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-18.9-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM352 402.6l0 45.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-45.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6zM48 416c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369c0 26-21.5 47-48 47z',
    ],
  ],
};
const faGlobeStand = {
  prefix: 'fad',
  iconName: 'globe-stand',
  icon: [
    448,
    512,
    [],
    'f5f6',
    [
      'M64 208a144 144 0 1 0 288 0A144 144 0 1 0 64 208z',
      'M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3l0 33.3-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-33.3c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L332.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367z',
    ],
  ],
};
const faBaseball = {
  prefix: 'fad',
  iconName: 'baseball',
  icon: [
    512,
    512,
    [129358, 9918, 'baseball-ball'],
    'f433',
    [
      'M.1 250.4c0 1.8-.1 3.7-.1 5.6C0 397.4 114.6 512 256 512c1.9 0 3.7 0 5.6-.1c-1.8-7.8-3.2-15.7-4.2-23.7c-.2-2-.4-3.9-.6-5.8c-.5-6.1-.8-12.2-.8-18.4c0-.2 0-.4 0-.7c0-1.1 0-2.2 0-3.5c0-.3 0-.5 0-.8c0-1 .1-2.1 .1-3.3c0-.4 0-.8 0-1.1c0-1.1 .1-2.2 .2-3.3c0-.3 0-.5 0-.8c.1-1 .1-2.1 .2-3.3c0-.2 0-.4 .1-.6c.7-8.8 8.5-15.4 17.3-14.6c4.4 .4 8.2 2.5 10.9 5.6s4.1 7.3 3.7 11.7c-.2 2.7-.4 5.3-.5 7.8c0 .9-.1 1.7-.1 2.6c0 .4 0 .7 0 .8c0 .9 0 1.9 0 2.9c0 .2 0 .4 0 .7c0 .1 0 .3 0 .4c0 1.8 0 3.5 .1 5.4l0 .5c.1 1.7 .1 3.4 .3 5.2l0 .7c.1 1.7 .3 3.4 .4 5.1c.2 2 .4 3.9 .7 5.7c1 7.7 2.5 15.1 4.4 22.3c111.1-16.5 198.9-104.3 215.4-215.4C494.8 290 479.6 288 464 288c-4.9 0-9.8 .2-14.7 .6c-8.8 .7-16.5-5.8-17.3-14.6c-.7-8.8 5.8-16.5 14.6-17.3c5.7-.5 11.5-.7 17.3-.7c16.5 0 32.6 1.9 47.9 5.6c0-1.8 .1-3.7 .1-5.6C512 114.6 397.4 0 256 0c-1.9 0-3.7 0-5.5 .1C254.1 15.5 256 31.5 256 48c0 5.8-.2 11.6-.7 17.3c-.7 8.8-8.5 15.4-17.1 14.6c-8.9-.7-15.5-8.5-14.8-17.3c.4-4.8 .6-9.7 .6-14.7c0-15.6-2-30.8-5.9-45.2C107.1 19.2 19.2 107.1 2.8 218.1C17.2 222 32.4 224 48 224c5 0 9.8-.2 14.7-.6c8.8-.7 16.5 5.8 17.3 14.6c.4 4.4-1.1 8.5-3.7 11.7s-6.5 5.2-10.9 5.6c-5.7 .5-11.5 .7-17.3 .7c-16.5 0-32.6-1.9-47.9-5.6zm113.4-21.2c-3.7-8-.2-17.5 7.9-21.2c38.3-17.6 69.2-48.5 86.7-86.7c3.7-8 13.2-11.6 21.2-7.9s11.5 13.2 7.9 21.2c-20.8 45.2-57.2 81.7-102.5 102.5c-8 3.7-17.5 .2-21.2-7.9zM274.9 377.3c20.8-45.2 57.2-81.7 102.5-102.5c8-3.7 17.5-.2 21.2 7.9s.2 17.5-7.9 21.2c-38.3 17.6-69.2 48.5-86.7 86.7c-3.7 8-13.2 11.6-21.2 7.9s-11.5-13.2-7.9-21.2z',
      'M48 224c4.9 0 9.8-.2 14.7-.6c8.8-.7 16.5 5.8 17.3 14.6s-5.8 16.5-14.6 17.3c-5.7 .5-11.5 .7-17.3 .7c-16.5 0-32.6-1.9-47.9-5.6c.2-11 1.2-21.7 2.7-32.3C17.2 222 32.4 224 48 224zM250.5 .1C254.1 15.4 256 31.5 256 48c0 5.8-.2 11.6-.7 17.3c-.7 8.8-8.5 15.4-17.3 14.6s-15.4-8.5-14.6-17.3c.4-4.8 .6-9.7 .6-14.7c0-15.6-2-30.8-5.9-45.2c10.6-1.6 21.4-2.5 32.3-2.7zM511.9 261.6c-.2 11-1.2 21.7-2.7 32.3C494.8 290 479.6 288 464 288c-4.9 0-9.8 .2-14.7 .6c-8.8 .7-16.5-5.8-17.3-14.6s5.8-16.5 14.6-17.3c5.7-.5 11.5-.7 17.3-.7c16.5 0 32.6 1.9 47.9 5.6zM293.9 509.2c-10.6 1.6-21.4 2.5-32.3 2.7c-3.6-15.4-5.6-31.4-5.6-47.9c0-5.8 .2-11.6 .7-17.3c.7-8.8 8.5-15.4 17.3-14.6s15.4 8.5 14.6 17.3c-.4 4.8-.6 9.7-.6 14.7c0 15.6 2 30.8 5.9 45.2zm-180.4-280c-3.7-8-.2-17.5 7.9-21.2c38.3-17.6 69.2-48.5 86.7-86.7c3.7-8 13.2-11.6 21.2-7.9s11.6 13.2 7.9 21.2c-20.8 45.2-57.2 81.7-102.5 102.5c-8 3.7-17.5 .2-21.2-7.9zm285.1 53.5c3.7 8 .2 17.5-7.9 21.2c-38.3 17.6-69.2 48.5-86.7 86.7c-3.7 8-13.2 11.6-21.2 7.9s-11.6-13.2-7.9-21.2c20.8-45.2 57.2-81.7 102.5-102.5c8-3.7 17.5-.2 21.2 7.9z',
    ],
  ],
};
const faBaseballBall = faBaseball;
const faCircleP = {
  prefix: 'fad',
  iconName: 'circle-p',
  icon: [
    512,
    512,
    [],
    'e11a',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136zm48 24l0 88 68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0z',
      'M160 152c0-13.3 10.7-24 24-24l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136zm48 112l68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88z',
    ],
  ],
};
const faAwardSimple = {
  prefix: 'fad',
  iconName: 'award-simple',
  icon: [
    384,
    512,
    [],
    'e0ab',
    [
      'M64.4 492.4c-1.3 5.5 .5 11.3 4.6 15.2s10 5.3 15.4 3.8L192 480.6l107.6 30.7c5.4 1.6 11.3 .1 15.4-3.8c3.2-3.1 5-7.3 5-11.6c0-1.2-.1-2.4-.4-3.6l-31-134.5c-5.8 3.5-12.5 5.3-19.4 5.1l-20.9-.5c-6.9-.2-13.7 1.7-19.6 5.2c-6 3.6-11.9 7.3-17.9 10.9c-5.8 3.5-12.3 5.3-18.7 5.3s-13-1.8-18.7-5.3c-6-3.6-11.9-7.3-17.9-10.9c-5.9-3.6-12.7-5.4-19.6-5.2l-20.9 .5c-.9 0-1.7 0-2.6 0s-1.7-.1-2.6-.2c-1.7-.2-3.4-.5-5-1c-3.3-.9-6.4-2.2-9.3-3.9l-31 134.5z',
      'M210.7 5.3c-11.5-7-26-7-37.5 0L155.4 16.1c-5.9 3.6-12.7 5.4-19.6 5.2l-20.9-.5c-13.5-.3-26 6.9-32.5 18.7L72.4 58c-3.3 6.1-8.3 11-14.3 14.3l-18.4 10c-11.8 6.5-19.1 19-18.7 32.5l.5 20.9c.2 6.9-1.7 13.7-5.2 19.6L5.3 173.3c-7 11.5-7 26 0 37.5l10.9 17.9c3.6 5.9 5.4 12.7 5.2 19.6l-.5 20.9c-.3 13.5 6.9 26 18.7 32.5l18.4 10c6.1 3.3 11 8.3 14.3 14.3l10 18.4c6.5 11.8 19 19.1 32.5 18.7l20.9-.5c6.9-.2 13.7 1.7 19.6 5.2l17.9 10.9c11.5 7 26 7 37.5 0l17.9-10.9c5.9-3.6 12.7-5.4 19.6-5.2l20.9 .5c13.5 .3 26-6.9 32.5-18.7l10-18.4c3.3-6.1 8.3-11 14.3-14.3l18.4-10c11.8-6.5 19.1-19 18.7-32.5l-.5-20.9c-.2-6.9 1.7-13.7 5.2-19.6l10.9-17.9c7-11.5 7-26 0-37.5l-10.9-17.9c-3.6-5.9-5.4-12.7-5.2-19.6l.5-20.9c.3-13.5-6.9-26-18.7-32.5L326 72.4c-6.1-3.3-11-8.3-14.3-14.3l-10-18.4c-6.5-11.8-19-19.1-32.5-18.7l-20.9 .5c-6.9 .2-13.7-1.7-19.6-5.2L210.7 5.3zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faJetFighterUp = {
  prefix: 'fad',
  iconName: 'jet-fighter-up',
  icon: [
    512,
    512,
    [],
    'e518',
    [
      'M48 296l144-80 0 168L48 384l0-88zm272-80l144 80 0 88-144 0 0-168z',
      'M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2l0 278.9L133.5 468c-3.5 3-5.5 7.4-5.5 12l0 16c0 8.8 7.2 16 16 16l96 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 96 0c8.8 0 16-7.2 16-16l0-16c0-4.6-2-9-5.5-12L320 416.7l0-278.9c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7zM24 256c-13.3 0-24 10.7-24 24L0 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112z',
    ],
  ],
};
const faDiagramProject = {
  prefix: 'fad',
  iconName: 'diagram-project',
  icon: [
    576,
    512,
    ['project-diagram'],
    'f542',
    [
      'M144 224c24.8 0 45.2-18.8 47.7-43L272 288c-24.8 0-45.2 18.8-47.7 43L144 224zM192 96l192 0 0 64-192 0 0-64z',
      'M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM224 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM432 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faProjectDiagram = faDiagramProject;
const faPedestal = {
  prefix: 'fad',
  iconName: 'pedestal',
  icon: [
    448,
    512,
    [],
    'e20d',
    [
      'M32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 384L32 448 32 64zM96 88a24 24 0 1 0 48 0A24 24 0 1 0 96 88zm208 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M144 88A24 24 0 1 0 96 88a24 24 0 1 0 48 0zm208 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faChartPyramid = {
  prefix: 'fad',
  iconName: 'chart-pyramid',
  icon: [
    512,
    512,
    [],
    'e0e6',
    [
      'M51 352L461 352 367.7 192l-223.4 0C113.2 245.3 82.1 298.7 51 352z',
      'M221.4 59.7L144.3 192l223.4 0L290.6 59.7c-15.4-26.5-53.7-26.5-69.1 0zM51 352L11.4 419.8C-4.2 446.5 15.1 480 45.9 480l420.1 0c30.9 0 50.1-33.5 34.6-60.2L461 352 51 352z',
    ],
  ],
};
const faSidebar = {
  prefix: 'fad',
  iconName: 'sidebar',
  icon: [
    512,
    512,
    [],
    'e24e',
    [
      'M224 32l0 448 224 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L224 32z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l160 0 0-448L64 32zM88 96l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 216c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm24 72l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faSnowmanHead = {
  prefix: 'fad',
  iconName: 'snowman-head',
  icon: [
    448,
    512,
    ['frosty-head'],
    'f79b',
    [
      'M32 352c0 59.8 27.4 113.3 70.3 148.5c9.7 8 22.3 11.5 34.9 11.5l173.7 0c12.6 0 25.1-3.5 34.9-11.5C388.6 465.3 416 411.8 416 352c0-35-9.4-67.8-25.7-96L57.7 256C41.3 284.2 32 317 32 352zm144-40a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm16 72.2c0-17.7 14.3-32.2 32-32.2s32 14.5 32 32.2c0 5.1-1.2 10.2-3.5 14.7l-23.8 46.3c-.9 1.7-2.7 2.8-4.7 2.8s-3.8-1.1-4.7-2.8l-23.8-46.3c-2.3-4.5-3.5-9.6-3.5-14.7zM320 312a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M64 64C64 28.7 92.7 0 128 0L320 0c35.3 0 64 28.7 64 64l0 96L64 160l0-96zm88 224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm144 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 192l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32z',
    ],
  ],
};
const faFrostyHead = faSnowmanHead;
const faCopy = {
  prefix: 'fad',
  iconName: 'copy',
  icon: [
    448,
    512,
    [],
    'f0c5',
    [
      'M0 176L0 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-48-64 0 0 32L64 448l0-256 64 0 0-64-80 0c-26.5 0-48 21.5-48 48z',
      'M160 48c0-26.5 21.5-48 48-48H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48z',
    ],
  ],
};
const faBurgerGlass = {
  prefix: 'fad',
  iconName: 'burger-glass',
  icon: [
    640,
    512,
    [],
    'e0ce',
    [
      'M0 32c0 .8 0 1.5 .1 2.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3L272 512c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c5.5-12.5 20.5-40.4 52.7-65.3c16.2-12.5 36.3-23.8 60.9-32l10-139.4c.1-.8 .1-1.5 .1-2.3c0-8.1-3-15.9-8.6-21.8C369.4 3.7 360.9 0 352 0L32 0C23.1 0 14.6 3.7 8.6 10.2C3 16.1 0 23.9 0 32zM66.4 64l251.3 0-6.9 96L73.2 160 66.4 64z',
      'M612.5 319.8c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5l296.9 0zM368 255.8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 128c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0c-17.7 0-32 14.3-32 32zm0 80c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faVolumeXmark = {
  prefix: 'fad',
  iconName: 'volume-xmark',
  icon: [
    576,
    512,
    ['volume-mute', 'volume-times'],
    'f6a9',
    [
      'M384 184c0 6.1 2.3 12.3 7 17l55 55-55 55c-4.7 4.7-7 10.8-7 17s2.3 12.3 7 17s10.8 7 17 7s12.3-2.3 17-7l55-55 55 55c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7s7-10.8 7-17s-2.3-12.3-7-17l-55-55 55-55c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17s-10.8-7-17-7s-12.3 2.3-17 7l-55 55-55-55c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7s-7 10.8-7 17z',
      'M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160 64 160c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l67.8 0L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448l0-384z',
    ],
  ],
};
const faVolumeMute = faVolumeXmark;
const faVolumeTimes = faVolumeXmark;
const faHandSparkles = {
  prefix: 'fad',
  iconName: 'hand-sparkles',
  icon: [
    640,
    512,
    [],
    'e05d',
    [
      'M75 284.4c-15.2 16-14.6 41.3 1.4 56.6L188.8 448c43.1 41.1 100.4 64 160 64l19.2 0c41.9 0 80.4-14.6 110.6-39.1c-18.1-5.3-30.6-22-30.6-40.9c0-19 12.6-35.7 30.9-41l31.2-8.9 8.9-31.2c3.7-12.9 13.1-23 25-27.8L544 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L131.6 283c-16-15.2-41.3-14.6-56.6 1.4zM256 368c0-4.1 2.7-7.6 6.6-8.7L288 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L320 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L320 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L288 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7z',
      'M90.2 71.7L104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7zm480 288L584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7z',
    ],
  ],
};
const faBarsFilter = {
  prefix: 'fad',
  iconName: 'bars-filter',
  icon: [
    448,
    512,
    [],
    'e0ad',
    [
      'M64 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32z',
      'M448 96c0-17.7-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM288 416c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32z',
    ],
  ],
};
const faPaintbrushPencil = {
  prefix: 'fad',
  iconName: 'paintbrush-pencil',
  icon: [
    576,
    512,
    [],
    'e206',
    [
      'M50.7 42.7c-25 25-25 65.5 0 90.5L173.5 256c.8 0 1.7 0 2.5 0c6.2 0 12.4 .4 18.4 1.2L298.5 153.1 164.7 19.3c-25-25-65.5-25-90.5 0L50.7 42.7zM318.8 381.6c.8 6 1.2 12.2 1.2 18.4c0 .8 0 1.7 0 2.5l64.6 64.6c6.7 6.7 15.1 11.6 24.2 14.2l104 29.7c2.2 .6 4.4 .9 6.6 .9c6.3 0 12.4-2.5 17-7s7-10.7 7-17c0-2.2-.3-4.4-.9-6.6l-29.7-104c-2.6-9.2-7.5-17.5-14.2-24.2l-75.6-75.6L318.8 381.6z',
      'M559.6 16.4c21.9 21.9 21.9 57.3 0 79.2L306.9 348.3l-79.2-79.2L480.4 16.4c21.9-21.9 57.3-21.9 79.2 0zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l4.8 0c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z',
    ],
  ],
};
const faPartyBell = {
  prefix: 'fad',
  iconName: 'party-bell',
  icon: [
    512,
    512,
    [],
    'e31a',
    [
      'M32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM167 359c-9.4 9.4-9.4 24.6 0 33.9l8.3 8.3c16.7 16.7 27.2 38.6 29.8 62.1l3 27.4c1.5 13.2 13.3 22.7 26.5 21.2s22.7-13.3 21.2-26.5l-3-27.4c-3.8-34.3-19.2-66.3-43.6-90.7L201 359c-9.4-9.4-24.6-9.4-33.9 0zm126.6-63.5l8.5 10c4.9 5.8 7.5 13.2 7.3 20.7c-1.1 42.5 31.7 78.3 74.2 80.8l30 1.8c16.6 1 29.4 15 29 31.6c-.5 19.4 6.1 38.2 18.6 53l8.5 10c8.6 10.1 23.7 11.4 33.8 2.8s11.4-23.7 2.8-33.8l-8.5-10c-4.9-5.8-7.5-13.2-7.3-20.7c1.1-42.5-31.7-78.3-74.2-80.8l-30-1.8c-16.6-1-29.4-15-29-31.6c.5-19.4-6.1-38.2-18.6-53l-8.5-10c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8zM320 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm39-313c-9.4 9.4-9.4 24.6 0 33.9l8.2 8.3c24.4 24.4 56.4 39.8 90.7 43.6l27.4 3c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5l-27.4-3c-23.5-2.6-45.4-13.1-62.1-29.8L393 167c-9.4-9.4-24.6-9.4-33.9 0zM448 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0z',
    ],
  ],
};
const faUserVneckHair = {
  prefix: 'fad',
  iconName: 'user-vneck-hair',
  icon: [
    448,
    512,
    [],
    'e462',
    [
      'M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32c-12 0-24 0-36 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112c-18.7 0-37.3 0-56 0c-7.9 0-15.5-1.7-22.3-4.6C96.6 114.1 96 121 96 128z',
      'M120 112l56 0c34.6 0 65-18.3 81.9-45.8C269.2 84.1 289.2 96 312 96l36 0C333.8 40.8 283.6 0 224 0C160.3 0 107.5 46.5 97.7 107.4c6.8 3 14.4 4.6 22.3 4.6zm25.9 202.9c-3.5-5.2-9.8-8-15.9-6.6C55.5 325.5 0 392.3 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-79.7-55.5-146.5-130-163.7c-6.1-1.4-12.4 1.4-15.9 6.6L237.3 412c-6.3 9.5-20.3 9.5-26.6 0l-64.8-97.1z',
    ],
  ],
};
const faJackOLantern = {
  prefix: 'fad',
  iconName: 'jack-o-lantern',
  icon: [
    576,
    512,
    [127875],
    'f30e',
    [
      'M0 320C0 426 68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320zm105.4 20.4c0-.2 0-.5 0 0zm56.5-60.9c-2.8-5.2-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5l-64 0c-5.9 0-11.3-3.2-14.1-8.5zm160 0c-2.8-5.2-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5l-64 0c-5.9 0-11.3-3.2-14.1-8.5z',
      'M275.5 10.4l-40.9 93.5C251.5 98.8 269.4 96 288 96c22.5 0 44.1 4 64 11.4l0-72c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4zM221.3 215.1c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l64 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zm160 0c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l64 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zM416 415.4c36.9-24.7 49.9-56.7 54.1-71.4c1.4-5-.3-10.2-4-13.8c-5.8-5.8-15.1-6.6-22.2-2.4C420.8 341.4 365.6 368 288 368l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-19.5c-52.4-7.7-89.9-26.2-107.9-36.8c-7.1-4.2-16.4-3.4-22.2 2.4c-3.7 3.7-5.4 8.8-4 13.8c4.2 14.7 17.2 46.8 54.1 71.4c.3-8.6 7.3-15.4 16-15.4l16 0c8.8 0 16 7.2 16 16l0 21.5c21.8 6.5 48.2 10.5 80 10.5s58.2-4 80-10.5l0-21.5c0-8.8 7.2-16 16-16l16 0c8.6 0 15.7 6.9 16 15.4z',
    ],
  ],
};
const faGrip = {
  prefix: 'fad',
  iconName: 'grip',
  icon: [
    448,
    512,
    ['grip-horizontal'],
    'f58d',
    [
      'M0 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm160 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm160 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48z',
      'M0 136c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm160 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zm288 0l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40z',
    ],
  ],
};
const faGripHorizontal = faGrip;
const faShareFromSquare = {
  prefix: 'fad',
  iconName: 'share-from-square',
  icon: [
    576,
    512,
    [61509, 'share-square'],
    'f14d',
    [
      'M0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112z',
      'M352 224l0 64c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 96l-80 0c-79.5 0-144 64.5-144 144c0 93.4 82.8 134.8 100.6 142.6c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-8.3-5.9-15.5-12.8-20.3c-8.9-6.2-19.2-18.2-19.2-40.5c0-45 36.5-81.5 81.5-81.5l46.5 0z',
    ],
  ],
};
const faShareSquare = faShareFromSquare;
const faKeynote = {
  prefix: 'fad',
  iconName: 'keynote',
  icon: [
    512,
    512,
    [],
    'f66c',
    [
      'M96 112l0 48 48 0 0-48c0-22.1 17.9-40 40-40l14.4 0c8.3 14.3 23.8 24 41.6 24l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L240 0c-17.8 0-33.3 9.7-41.6 24L184 24c-48.6 0-88 39.4-88 88zm32 368c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-96-64 0 0 96-64 0c-17.7 0-32 14.3-32 32z',
      'M80 160c-12.1 0-23.2 6.8-28.6 17.7l-48 96C1.2 278.1 0 283 0 288l0 32c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-32c0-5-1.2-9.9-3.4-14.3l-48-96C455.2 166.8 444.1 160 432 160L80 160z',
    ],
  ],
};
const faChildCombatant = {
  prefix: 'fad',
  iconName: 'child-combatant',
  icon: [
    576,
    512,
    ['child-rifle'],
    'e4e0',
    [
      'M32 304c0 10.6 5.3 21 15 27.1c15 9.4 34.7 4.9 44.1-10L104 300.5 104 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-179.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9l-12.3 0c-33 0-63.7 16.9-81.2 44.9L36.9 287c-3.3 5.3-4.9 11.2-4.9 17zM112 64a64 64 0 1 0 128 0A64 64 0 1 0 112 64z',
      'M432 0l16 0c8.8 0 16 7.2 16 16l0 116.3c9.6 5.5 16 15.9 16 27.7l0 109.3 16-5.3 0-56c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 84.5c0 6.9-4.4 13-10.9 15.2L480 325.3l0 26.7 48 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-44 0 23 92.1c2.5 10.1-5.1 19.9-15.5 19.9L432 512c-8.8 0-16-7.2-16-16l0-96-16 0c-17.7 0-32-14.3-32-32l0-144c0-17.7 14.3-32 32-32l0-32c0-11.8 6.4-22.2 16-27.7L416 32c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0z',
    ],
  ],
};
const faChildRifle = faChildCombatant;
const faGun = {
  prefix: 'fad',
  iconName: 'gun',
  icon: [
    576,
    512,
    [],
    'e19b',
    [
      'M64 144c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zM217 352l104.5 0c23.7 0 44.8-14.9 52.7-37.2L400.9 240l-51 0-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3L229 304l-12 48z',
      'M504 32c13.3 0 24 10.7 24 24l0 8 16 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32l-66.7 0-22.6 22.6c-6 6-14.1 9.4-22.6 9.4l-187 0L191 455.8C187.5 470 174.7 480 160 480l-96 0c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L73.1 279.8c5-20.2-10.2-39.8-31-39.8l-10 0c-17.7 0-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64l448 0 0-8c0-13.3 10.7-24 24-24zM80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128z',
    ],
  ],
};
const faSquarePhone = {
  prefix: 'fad',
  iconName: 'square-phone',
  icon: [
    448,
    512,
    ['phone-square'],
    'f098',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 64c0-9 6-16.9 14.7-19.3l44-12c1.8-.5 3.5-.7 5.3-.7c7.9 0 15.3 4.7 18.5 12.3l20 48c3.4 8.2 1 17.6-5.8 23.2c-8.2 6.7-16.4 13.5-24.7 20.2c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8c16 6.7 32 13.3 48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160z',
      'M178.5 140.3c-3.9-9.3-14-14.2-23.7-11.6l-44 12C102 143.1 96 151 96 160c0 123.7 100.3 224 224 224c9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L248.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48z',
    ],
  ],
};
const faPhoneSquare = faSquarePhone;
const faHatBeach = {
  prefix: 'fad',
  iconName: 'hat-beach',
  icon: [
    640,
    512,
    [],
    'e606',
    [
      'M160 224c0 35.3 71.6 64 160 64c23 0 44.9-1.9 64.7-5.4c3.7 21.3 22.3 37.4 44.6 37.4c12 0 23.5-4.8 32-13.3L464 304l2.7 2.7c8.5 8.5 20 13.3 32 13.3c25 0 45.3-20.3 45.3-45.3c0-10.9-3.9-21.3-11-29.5c-.7-.9-1.5-1.7-2.3-2.5L528 240l2.7-2.7c8.5-8.5 13.3-20 13.3-32c0-25-20.3-45.3-45.3-45.3c-10.3 0-20.2 3.5-28.2 9.8c-1.3 1.1-2.6 2.2-3.8 3.4L464 176l-2.7-2.7c-8.5-8.5-20-13.3-32-13.3c-25 0-45.3 20.3-45.3 45.3c0 4.5 .7 9 2 13.2c-20 3.5-42.3 5.5-66 5.5c-79.9 0-145.3-22.7-151.5-51.5C163 188.6 160 206 160 224zm328 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M320 448c176.7 0 320-57.3 320-128c0-19.3-11.8-36.7-29.7-43.9L533 245.2c7 8.2 11 18.7 11 29.5c0 25-20.3 45.3-45.3 45.3c-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3c-22.3 0-40.9-16.2-44.6-37.4C364.9 286.1 343 288 320 288c-88.4 0-160-28.7-160-64L29.7 276.1C11.8 283.3 0 300.7 0 320c0 70.7 143.3 128 320 128zM470.6 169.8C448.4 108.1 389.3 64 320 64c-70.3 0-130.1 45.4-151.5 108.5C174.7 201.3 240.1 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-25 20.3-45.3 45.3-45.3c12 0 23.5 4.8 32 13.3L464 176l2.7-2.7c1.2-1.2 2.5-2.4 3.8-3.4z',
    ],
  ],
};
const faPlus = {
  prefix: 'fad',
  iconName: 'plus',
  icon: [
    448,
    512,
    [10133, 61543, 'add'],
    '2b',
    [
      'M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z',
      '',
    ],
  ],
};
const faAdd = faPlus;
const faExpand = {
  prefix: 'fad',
  iconName: 'expand',
  icon: [
    448,
    512,
    [],
    'f065',
    [
      'M0 352l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM288 64c0 17.7 14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32z',
      'M0 64C0 46.3 14.3 32 32 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64zM416 320c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 0-64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faComputer = {
  prefix: 'fad',
  iconName: 'computer',
  icon: [
    640,
    512,
    [],
    'e4e5',
    [
      'M480 80l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm48 32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M64 96l320 0 0 224L64 320 64 96zM48 32C21.5 32 0 53.5 0 80L0 336c0 26.5 21.5 48 48 48l133.3 0-10.7 32L96 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-74.7 0-10.7-32L400 384c26.5 0 48-21.5 48-48l0-256c0-26.5-21.5-48-48-48L48 32z',
    ],
  ],
};
const faFort = {
  prefix: 'fad',
  iconName: 'fort',
  icon: [
    640,
    512,
    [],
    'e486',
    [
      'M0 16L0 96l0 16 0 64c0 20.9 13.4 38.7 32 45.3c5 1.8 10.4 2.7 16 2.7l160 0c26.5 0 48-21.5 48-48l0-16 0-48 0-16 0-80c0-8.8-7.2-16-16-16L208 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16L112 0c-8.8 0-16 7.2-16 16l0 48L64 64l0-48C64 7.2 56.8 0 48 0L16 0C7.2 0 0 7.2 0 16zm384 0l0 80 0 16 0 48 0 16c0 26.5 21.5 48 48 48l160 0c5.6 0 11-1 16-2.7c18.6-6.6 32-24.4 32-45.3l0-64 0-16 0-80c0-8.8-7.2-16-16-16L592 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16L496 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16L400 0c-8.8 0-16 7.2-16 16z',
      'M384 160l-128 0 0 16c0 26.5-21.5 48-48 48L48 224c-5.6 0-11-1-16-2.7L32 464c0 26.5 21.5 48 48 48l176 0 0-128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 128 176 0c26.5 0 48-21.5 48-48l0-242.7c-5 1.8-10.4 2.7-16 2.7l-160 0c-26.5 0-48-21.5-48-48l0-16z',
    ],
  ],
};
const faCloudCheck = {
  prefix: 'fad',
  iconName: 'cloud-check',
  icon: [
    640,
    512,
    [],
    'e35c',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm200-48c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z',
      'M433 207c9.4 9.4 9.4 24.6 0 33.9L305 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L399 207c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faXmark = {
  prefix: 'fad',
  iconName: 'xmark',
  icon: [
    384,
    512,
    [128473, 10005, 10006, 10060, 215, 'close', 'multiply', 'remove', 'times'],
    'f00d',
    [
      'M297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6z',
      '',
    ],
  ],
};
const faClose = faXmark;
const faMultiply = faXmark;
const faRemove = faXmark;
const faTimes = faXmark;
const faFaceSmirking = {
  prefix: 'fad',
  iconName: 'face-smirking',
  icon: [
    512,
    512,
    [],
    'e397',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-48c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16zm80 176c0-8.8 7.2-16 16-16l112.6 0c19.6 0 36.2-14.1 39.5-33.4l.2-1.2c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4l-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2L192 400c-8.8 0-16-7.2-16-16zM288 208c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z',
      'M96 208c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faArrowsUpDownLeftRight = {
  prefix: 'fad',
  iconName: 'arrows-up-down-left-right',
  icon: [
    512,
    512,
    ['arrows'],
    'f047',
    [
      'M169.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4L224 224l32 0 32 0 0-114.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-64-64C272.4 3.1 264.2 0 256 0s-16.4 3.1-22.6 9.4l-64 64zm0 320c-12.5 12.5-12.5 32.8 0 45.3l64 64c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l64-64c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-12.5-12.5-32.8-12.5-45.3 0l-9.4 9.4L288 288l-32 0-32 0 0 114.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0z',
      'M118.6 169.4c12.5 12.5 12.5 32.8 0 45.3l-9.4 9.4L256 224l146.7 0-9.4-9.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l9.4-9.4L256 288l-146.7 0 9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faArrows = faArrowsUpDownLeftRight;
const faChalkboardUser = {
  prefix: 'fad',
  iconName: 'chalkboard-user',
  icon: [
    640,
    512,
    ['chalkboard-teacher'],
    'f51c',
    [
      'M160 64l0 32c23.3 0 45.2 6.2 64 17.1L224 64l352 0 0 288-64 0-128 0-99.6 0c22.4 16.5 40.6 38.5 52.4 64L576 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64z',
      'M64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM0 485.3C0 411.7 59.7 352 133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3zM416 288l64 0c17.7 0 32 14.3 32 32l0 32-128 0 0-32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faChalkboardTeacher = faChalkboardUser;
const faRhombus = {
  prefix: 'fad',
  iconName: 'rhombus',
  icon: [
    448,
    512,
    [],
    'e23b',
    [
      'M254.4 14.1C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9l-184-216z',
      '',
    ],
  ],
};
const faClawMarks = {
  prefix: 'fad',
  iconName: 'claw-marks',
  icon: [
    576,
    512,
    [],
    'f6c2',
    [
      'M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3L96 333.3 96 416c0 17.7 14.3 32 32 32l82.7 0 54.6 54.6c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c12.5-12.5 12.5-32.8 0-45.3l-64-64-96-96-64-64c-12.5-12.5-32.8-12.5-45.3 0zm224-224c-12.5 12.5-12.5 32.8 0 45.3L288 77.3l0 50.7c0 17.7 14.3 32 32 32l50.7 0L416 205.3l0 50.7c0 17.7 14.3 32 32 32l50.7 0 22.6 22.6c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-32-32-64-64-64-64-64-64-32-32C304.4 3.1 296.2 0 288 0s-16.4 3.1-22.6 9.4z',
      'M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4l96 96 64 64 160 160 64 64 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L434.7 448 384 448c-17.7 0-32-14.3-32-32l0-50.7L210.7 224 160 224c-17.7 0-32-14.3-32-32l0-50.7L41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3z',
    ],
  ],
};
const faPesoSign = {
  prefix: 'fad',
  iconName: 'peso-sign',
  icon: [
    384,
    512,
    [],
    'e222',
    [
      'M0 160c0-17.7 14.3-32 32-32l0 64c-17.7 0-32-14.3-32-32zm0 96c0-17.7 14.3-32 32-32l0 64c-17.7 0-32-14.3-32-32zM96 128l158.4 0c17.1 16.8 28.9 39.1 32.5 64L96 192l0-64zm0 96l190.9 0c-3.6 24.9-15.3 47.2-32.5 64L96 288l0-64zm236.8-96l19.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-.7 0c-2.1-22.9-8.5-44.5-18.5-64zm0 160c10-19.5 16.4-41.1 18.5-64l.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-19.2 0z',
      'M32 64c0-17.7 14.3-32 32-32l112 0c97.2 0 176 78.8 176 176s-78.8 176-176 176l-80 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96L32 64zM96 320l80 0c61.9 0 112-50.1 112-112s-50.1-112-112-112L96 96l0 224z',
    ],
  ],
};
const faFaceSmileTongue = {
  prefix: 'fad',
  iconName: 'face-smile-tongue',
  icon: [
    512,
    512,
    [],
    'e394',
    [
      'M0 256C0 397.4 114.6 512 256 512c61.5 0 118-21.7 162.1-57.9c-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1c2.3-8.5 11.1-13.6 19.6-11.3c1.5 .4 2.9 1 4.2 1.8l65.4 37.8c5 2.9 9.6 6.2 13.7 10c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256zm120-32c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6zm160 0c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M217.6 228.8s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm207.5 82.9c-11.7 30.4-30.5 57.1-54.5 77.6l55.7 33.1c22.6 13.4 51.8 5.8 65-17c13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1zm-47.5-82.9s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z',
    ],
  ],
};
const faCartCircleXmark = {
  prefix: 'fad',
  iconName: 'cart-circle-xmark',
  icon: [
    640,
    512,
    [],
    'e3f4',
    [
      'M0 24C0 37.3 10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c29.1-57 88.4-96 156.8-96c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4c.9-3.5 1.4-7 1.4-10.5c0-21.4-17.3-39.9-40-39.9l-411 0C111 12.8 91.6 0 69.5 0L24 0C10.7 0 0 10.7 0 24zM128 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-59.3c-6.2-6.2-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z',
    ],
  ],
};
const faBuildingShield = {
  prefix: 'fad',
  iconName: 'building-shield',
  icon: [
    576,
    512,
    [],
    'e4d8',
    [
      'M0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c6.7 0 13.1-1.4 18.9-3.9c-74.6-56.7-96.4-143.4-98.7-201.5c-.1-.8-.2-1.7-.2-2.6l0-7.8 0-24.2 0-32c0-8.8 7.2-16 16-16l32 0 37.6 0L384 207l0-159c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48zm64 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm96-128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M440.9 225.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48zm-8.9 236l0-187.8L527.4 312c-3.9 50.7-27.2 116.7-95.4 149.7z',
    ],
  ],
};
const faCirclePhoneFlip = {
  prefix: 'fad',
  iconName: 'circle-phone-flip',
  icon: [
    512,
    512,
    ['phone-circle-alt'],
    'e11c',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 64c0-7.9 4.7-15.3 12.3-18.5c16-6.7 32-13.3 48-20c8.2-3.4 17.6-1 23.2 5.8c6.7 8.2 13.4 16.4 20.2 24.7c35.2-16.6 63.7-45.1 80.3-80.3c-8.2-6.7-16.4-13.4-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2c6.7-16 13.3-32 20-48c3.2-7.6 10.6-12.3 18.5-12.3c1.7 0 3.5 .2 5.3 .7c14.7 4 29.3 8 44 12C378 143.1 384 151 384 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-.5-1.8-.7-3.5-.7-5.3z',
      'M301.5 140.3c3.9-9.3 14-14.2 23.7-11.6l44 12C378 143.1 384 151 384 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8L231.7 312c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48z',
    ],
  ],
};
const faPhoneCircleAlt = faCirclePhoneFlip;
const faBaby = {
  prefix: 'fad',
  iconName: 'baby',
  icon: [
    448,
    512,
    [],
    'f77c',
    [
      'M32 168c0 12.4 5.7 24.6 16.5 32.4l36.2 26.4c13.6 9.9 28.1 18.2 43.3 25l0 36.3 192 0 0-36.3c15.2-6.7 29.7-15.1 43.3-25l36.2-26.4c17.9-13 21.8-38 8.8-55.9s-38-21.8-55.9-8.8L316.2 162c-26.8 19.5-59.1 30-92.2 30s-65.4-10.5-92.2-30L95.5 135.7c-17.9-13-42.9-9-55.9 8.8C34.5 151.6 32 159.8 32 168zM79.2 401.1C68.1 417 70 438.6 83.7 452.3l48 48c7.8 7.8 18 11.7 28.3 11.7s20.5-3.9 28.3-11.7c15.6-15.6 15.6-40.9 0-56.6L164 419.4l26-37.2c-20.2-17.7-40.4-35.3-60.6-53L79.2 401.1zM152 88a72 72 0 1 0 144 0A72 72 0 1 0 152 88zM258 382.3l26 37.2-24.3 24.3c-15.6 15.6-15.6 40.9 0 56.6c7.8 7.8 18 11.7 28.3 11.7s20.5-3.9 28.3-11.7l48-48c13.7-13.7 15.6-35.3 4.5-51.2l-50.2-71.8c-20.2 17.7-40.4 35.3-60.6 53z',
      'M192 384l-64-56V288H320v40l-64 56H192z',
    ],
  ],
};
const faUsersLine = {
  prefix: 'fad',
  iconName: 'users-line',
  icon: [
    640,
    512,
    [],
    'e592',
    [
      'M32 256c0 17.7 14.3 32 32 32l85.6 0c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4l-96 0c-35.3 0-64 28.7-64 64zM83.2 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm94.4 224c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6c-6.9-1.6-14.2-2.4-21.6-2.4l-96 0c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32zm64-208a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm174.3 88.6c38.1 14.8 67.4 47.3 77.7 87.4l82.4 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-11.7 0-22.7 3.1-32.1 8.6zM435.2 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M0 448c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faQuoteLeft = {
  prefix: 'fad',
  iconName: 'quote-left',
  icon: [
    448,
    512,
    [8220, 'quote-left-alt'],
    'f10d',
    [
      'M256 216l0 72 0 32 0 32c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-64 0 0-8c0-30.9 25.1-56 56-56l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0c-66.3 0-120 53.7-120 120z',
      'M120 96C53.7 96 0 149.7 0 216l0 72 0 32 0 32c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-64 0 0-8c0-30.9 25.1-56 56-56l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0z',
    ],
  ],
};
const faQuoteLeftAlt = faQuoteLeft;
const faTractor = {
  prefix: 'fad',
  iconName: 'tractor',
  icon: [
    640,
    512,
    [128668],
    'f722',
    [
      'M0 320l0 32c0 17.7 14.3 32 32 32l8.2 0c1.7 4.8 3.7 9.5 5.8 14.1l-5.8 5.8c-12.5 12.5-12.5 32.8 0 45.3l22.6 22.6c12.5 12.5 32.8 12.5 45.3 0l5.8-5.8c4.6 2.2 9.3 4.1 14.1 5.8l0 8.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-8.2c4.8-1.7 9.5-3.7 14.1-5.8l5.8 5.8c12.5 12.5 32.8 12.5 45.3 0l22.6-22.6c12.5-12.5 12.5-32.8 0-45.3l-5.8-5.8c2.2-4.6 4.1-9.3 5.8-14.1l8.2 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-8.2 0c-1.7-4.8-3.7-9.5-5.8-14.1l5.8-5.8c12.5-12.5 12.5-32.8 0-45.3l-22.6-22.6c-12.5-12.5-32.8-12.5-45.3 0l-5.8 5.8c-4.6-2.2-9.3-4.1-14.1-5.8l0-8.2c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 8.2c-4.8 1.7-9.5 3.7-14.1 5.8l-5.8-5.8c-3.5-3.5-7.7-6.1-12.1-7.6c-11.2-3.9-24.2-1.4-33.1 7.6L40.2 222.9c-12.5 12.5-12.5 32.8 0 45.3l5.8 5.8c-2.2 4.6-4.1 9.3-5.8 14.1L32 288c-17.7 0-32 14.3-32 32zm256 16A80 80 0 1 1 96 336a80 80 0 1 1 160 0zm184 88a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zm112 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M160 0C124.7 0 96 28.7 96 64l0 96 0 32 0 .6c4.4 1.5 8.6 4.1 12.1 7.6l5.8 5.8c4.6-2.2 9.3-4.1 14.1-5.8l0-8.2c0-17.7 14.3-32 32-32l0-96 106.3 0 38.4 96L192 160c17.7 0 32 14.3 32 32l0 8.2c4.8 1.7 9.5 3.7 14.1 5.8l5.8-5.8c12.5-12.5 32.8-12.5 45.3 0l22.6 22.6c12.5 12.5 12.5 32.8 0 45.3l-5.8 5.8c2.2 4.6 4.1 9.3 5.8 14.1l8.2 0c17.7 0 32 14.3 32 32l0 32 80 0c21.9-29.1 56.7-48 96-48c16.3 0 31.9 3.3 46.1 9.2l43.3-27.1c14-8.8 22.6-24.2 22.6-40.7l0-45.4c0-22.1-17.9-40-40-40l-56 0 0-33.8c0-14.9 3.5-29.6 10.1-42.9l2.5-5c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.5 5C485.8 76.9 480 101.4 480 126.2l0 33.8-106.3 0L325.8 40.2C316 15.9 292.5 0 266.3 0L160 0z',
    ],
  ],
};
const faDownFromBracket = {
  prefix: 'fad',
  iconName: 'down-from-bracket',
  icon: [
    448,
    512,
    [],
    'e66b',
    [
      'M0 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96z',
      'M251.3 500.7L374.1 377.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 320l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 320 64 335.2 64 353.9c0 9 3.6 17.6 9.9 24L196.7 500.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3z',
    ],
  ],
};
const faKeySkeleton = {
  prefix: 'fad',
  iconName: 'key-skeleton',
  icon: [
    448,
    512,
    [128477],
    'f6f3',
    [
      'M0 416c0 8.2 3.1 16.4 9.4 22.6l64 64c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c12.5-12.5 12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c-18.3-11.5-33.8-27-45.3-45.3L9.4 393.4C3.1 399.6 0 407.8 0 416z',
      'M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224A144 144 0 1 0 304 0a144 144 0 1 0 0 288z',
    ],
  ],
};
const faTrashArrowUp = {
  prefix: 'fad',
  iconName: 'trash-arrow-up',
  icon: [
    448,
    512,
    ['trash-restore'],
    'f829',
    [
      'M32 96l384 0L394.6 466.8c-1.5 25.4-22.5 45.2-47.9 45.2l-245.4 0c-25.4 0-46.5-19.8-47.9-45.2L32 96zm95 151c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1c13 13 26 26 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80z',
      'M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0zM248 241.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1z',
    ],
  ],
};
const faTrashRestore = faTrashArrowUp;
const faArrowDownUpLock = {
  prefix: 'fad',
  iconName: 'arrow-down-up-lock',
  icon: [
    640,
    512,
    [],
    'e4b0',
    [
      'M0 256c0 17.7 14.3 32 32 32l64 0 0 114.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 160 288l256 0 0-16c0-17.2 3.9-33.5 10.8-48L352 224l0-114.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3 288 224l-128 0-64 0-64 0c-17.7 0-32 14.3-32 32zM96 64l0 128 64 0 0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32zM288 320l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128-64 0z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faArrowDownToBracket = {
  prefix: 'fad',
  iconName: 'arrow-down-to-bracket',
  icon: [
    448,
    512,
    [],
    'e094',
    [
      'M0 352l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z',
    ],
  ],
};
const faLinesLeaning = {
  prefix: 'fad',
  iconName: 'lines-leaning',
  icon: [
    384,
    512,
    [],
    'e51e',
    [
      'M0 448c0 13.4 8.5 25.9 21.9 30.4c3.4 1.1 6.8 1.7 10.1 1.7c13.4 0 25.9-8.5 30.4-21.9l128-384c5.6-16.8-3.5-34.9-20.2-40.5c-3.4-1.1-6.8-1.7-10.1-1.7c-13.4 0-25.9 8.5-30.4 21.9l-128 384C.5 441.2 0 444.7 0 448zM320 64l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M261.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8l-64 384c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l64-384c2.9-17.4 19.4-29.2 36.8-26.3z',
    ],
  ],
};
const faSquareQ = {
  prefix: 'fad',
  iconName: 'square-q',
  icon: [
    448,
    512,
    [],
    'e27b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM96 256c0-70.7 57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128zm48 0c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80z',
      'M224 176c44.2 0 80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1c-44.2 0-80-35.8-80-80s35.8-80 80-80zM329.9 327.9c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L311 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-15.1-15.1z',
    ],
  ],
};
const faRulerCombined = {
  prefix: 'fad',
  iconName: 'ruler-combined',
  icon: [
    512,
    512,
    [],
    'f546',
    [
      'M0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48z',
      'M112 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0-32-80 0zm80 96l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0-32zm0 96l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80-32 0 0-32zm128 32l-32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zm96 80l0-80-32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16z',
    ],
  ],
};
const faSymbols = {
  prefix: 'fad',
  iconName: 'symbols',
  icon: [
    512,
    512,
    [128291, 'icons-alt'],
    'f86e',
    [
      'M0 32C0 49.7 14.3 64 32 64l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zm0 96c0 17.7 14.3 32 32 32l48 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0L32 96C14.3 96 0 110.3 0 128zM288 328a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm9.4 129.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zM432 472a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M500.3 7.3C507.7 13.3 512 22.4 512 32l0 144c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-57L352 90.2 352 208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-96c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zm-374 356.9l19.6 20.7 23.5-23.5c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-24.7 24.7L215.2 458c12.2 12.8 11.6 33.1-1.2 45.2s-33.1 11.6-45.2-1.2l-24.1-25.4-12.8 12.8C117.4 503.9 97.7 512 77.3 512C34.6 512 0 477.4 0 434.7l0-.9c0-19.4 7.2-38.2 20.3-52.6l14.5-15.9C23.2 353.7 16 337.7 16 320c0-35.3 28.7-64 64-64s64 28.7 64 64c0 17.1-6.7 32.7-17.7 44.2zM67.7 424.3c-2.4 2.6-3.7 6-3.7 9.5l0 .9c0 7.3 5.9 13.3 13.3 13.3c3.5 0 6.9-1.4 9.4-3.9l14-14L81.1 409.5 67.7 424.3zM96 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faIconsAlt = faSymbols;
const faCopyright = {
  prefix: 'fad',
  iconName: 'copyright',
  icon: [
    512,
    512,
    [169],
    'f1f9',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-32.8 12.5-65.5 37.5-90.5s57.8-37.5 90.5-37.5s65.5 12.5 90.5 37.5c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-34 0l-.4-.4c-31.3-30.8-81.6-30.7-112.7 .4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-25 25-57.8 37.5-90.5 37.5s-65.5-12.5-90.5-37.5s-37.5-57.8-37.5-90.5z',
      'M312.6 199.4c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z',
    ],
  ],
};
const faFlaskGear = {
  prefix: 'fad',
  iconName: 'flask-gear',
  icon: [
    640,
    512,
    [],
    'e5f1',
    [
      'M0 442.6C0 480.9 31.1 512 69.4 512l309.2 0c10.6 0 20.7-2.4 29.7-6.6c-2.8-6.2-4.2-12.9-4.2-19.7l0-.9c-17.6 9.7-41.5 8.1-57.2-8.7c-9.2-9.9-17.4-20.9-24.4-33s-12.5-24.7-16.4-37.6c-6.7-21.6 3.4-42.7 20-53.3c-69.2-.2-138.2-.2-207.3-.2L173 263.9c12.4-20.2 19-43.4 19-67.1L192 64l64 0 0 132.8c0 23.7 6.6 46.9 19 67.1L304 311c.1-4 .8-8.1 2-12.2c4-12.9 9.4-25.5 16.4-37.6c4.1-7.1 8.7-13.9 13.6-20.3l-6.5-10.6c-6.2-10.1-9.5-21.7-9.5-33.5L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 0 160 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6z',
      'M447.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8l0 17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7l0-17.7c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faHighlighterLine = {
  prefix: 'fad',
  iconName: 'highlighter-line',
  icon: [
    576,
    512,
    [],
    'e1af',
    [
      'M61.3 400c0 3.5 .6 7 1.7 10.4c1.5 4.5 4.1 8.7 7.6 12.2c16.9 16.9 33.8 33.8 50.7 50.7c3.6 3.6 7.8 6.1 12.2 7.6c11.2 3.8 24.1 1.3 33-7.6L224 416l71.7 0c15.3 0 29.6-7.2 38.6-19.5l26.3-35.8c-59.2-59.2-118.3-118.3-177.5-177.5l-35.7 26.3c-12.3 9-19.5 23.4-19.5 38.6l0 71.7c-19.1 19.1-38.2 38.2-57.4 57.4c-6.2 6.2-9.4 14.4-9.4 22.6zM200 488c0 13.3 10.7 24 24 24l328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-328 0c-13.3 0-24 10.7-24 24z',
      'M360.7 360.7L183.3 183.3 420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L360.7 360.7zM7 466.3l56-56c1.5 4.5 4.1 8.7 7.6 12.2l50.7 50.7c3.6 3.6 7.8 6.1 12.2 7.6l-24 24c-4.5 4.5-10.6 7-17 7L24 512c-13.3 0-24-10.7-24-24l0-4.7c0-6.4 2.5-12.5 7-17z',
    ],
  ],
};
const faBracketSquare = {
  prefix: 'fad',
  iconName: 'bracket-square',
  icon: [
    192,
    512,
    ['bracket', 'bracket-left'],
    '5b',
    [
      'M0 96C0 60.7 28.7 32 64 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 96l0 320 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-35.3 0-64-28.7-64-64L0 96z',
      '',
    ],
  ],
};
const faBracket = faBracketSquare;
const faBracketLeft = faBracketSquare;
const faIslandTropical = {
  prefix: 'fad',
  iconName: 'island-tropical',
  icon: [
    512,
    512,
    [127965, 'island-tree-palm'],
    'f811',
    [
      'M224 352l64 0c1 0 2 0 3 0s2 .1 3 .1c2 .1 3.9 .2 5.9 .4c3.9 .4 7.7 .9 11.5 1.6c11.3-55.9 18.2-146.2-9.9-226.1l-24.7 0c-10 10-20 20-30 30c6.6 43.1 6.9 114.7-22.8 194z',
      'M108.7 96c2.1 0 4.2-.8 5.7-2.3l24-24c3.1-3.1 8.2-3.1 11.3 0l24 24c.3 .3 .6 .6 1 .8c-1.4 1.3-2.8 2.6-4.1 4c-54.7 54.7-50.8 114.1-32.3 145.7c4.5 7.6 14.7 7.6 21 1.4L276.8 128l103.9 0c2.1 0 4.2-.8 5.7-2.3l24-24c3.1-3.1 8.2-3.1 11.3 0l24 24c1.5 1.5 3.5 2.3 5.7 2.3l44.7 0c8.8 0 16.1-7.2 13.8-15.8C500.6 76.8 461.4 32 384 32c-33.8 0-60.4 8.6-80.3 21.2C285.2 25.5 248.6 0 190.2 0C112.8 0 73.6 44.8 64.4 80.2C62.2 88.8 69.4 96 78.2 96l30.4 0zM160 352C89.3 352 32 409.3 32 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32c0-70.7-57.3-128-128-128l-128 0z',
    ],
  ],
};
const faIslandTreePalm = faIslandTropical;
const faArrowRightFromLine = {
  prefix: 'fad',
  iconName: 'arrow-right-from-line',
  icon: [
    448,
    512,
    [8614, 'arrow-from-left'],
    'f343',
    [
      'M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 288 272 288l-112 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l112 0 66.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z',
    ],
  ],
};
const faArrowFromLeft = faArrowRightFromLine;
const faH2 = {
  prefix: 'fad',
  iconName: 'h2',
  icon: [
    640,
    512,
    [],
    'f314',
    [
      'M0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M491.5 128c-15.3 0-30.1 5.5-41.7 15.4l-29 24.9c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l29-24.9C431.4 74.9 461 64 491.5 64l4.5 0c70.7 0 128 57.3 128 128l0 5.8c0 35.9-15.1 70.1-41.5 94.4L482.3 384 608 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L539.2 244.9c13.2-12.1 20.8-29.2 20.8-47.2l0-5.8c0-35.3-28.7-64-64-64l-4.5 0z',
    ],
  ],
};
const faEquals = {
  prefix: 'fad',
  iconName: 'equals',
  icon: [
    448,
    512,
    [62764],
    '3d',
    [
      'M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 128zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 320z',
      '',
    ],
  ],
};
const faCakeSlice = {
  prefix: 'fad',
  iconName: 'cake-slice',
  icon: [
    512,
    512,
    [127856, 'shortcake'],
    'e3e5',
    [
      'M0 288l64 0 384 0 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 32.1L0 368l0-80zM0 400c149.3 0 298.6 0 448 .2l0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 64L32 480c-17.7 0-32-14.3-32-32l0-48z',
      'M296 32c-7.2 0-14.2 2.4-19.8 6.9l-264 208C4.5 252.9 0 262.2 0 272l0 16 64 0 384 0 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3c0 0 0 0 0 .1l0 32 0 .1 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 64c35.3 0 64-28.6 64-64l0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.3 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32z',
    ],
  ],
};
const faShortcake = faCakeSlice;
const faBuildingMagnifyingGlass = {
  prefix: 'fad',
  iconName: 'building-magnifying-glass',
  icon: [
    640,
    512,
    [],
    'e61c',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 125.3c-27.6 12-51.1 31.6-67.9 56.2c-2.9-3.4-7.2-5.5-12.1-5.5l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l19.2 0c-2.1 10.3-3.2 21-3.2 32c0 65.6 39.5 121.9 95.9 146.7C382.6 491.9 361.6 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M528 320.2a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM519.9 426c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426z',
    ],
  ],
};
const faPeanut = {
  prefix: 'fad',
  iconName: 'peanut',
  icon: [
    512,
    512,
    [],
    'e430',
    [
      'M0 364l0 68c0 44.2 35.8 80 80 80l68 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148l0-68c0-44.2-35.8-80-80-80L364 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364zm147.2 52.1a19.2 19.2 0 1 1 -38.4-.3 19.2 19.2 0 1 1 38.4 .3zm64-64a19.2 19.2 0 1 1 -38.4-.3 19.2 19.2 0 1 1 38.4 .3zm0 64a19.2 19.2 0 1 1 -38.4-.3 19.2 19.2 0 1 1 38.4 .3zM371.2 192a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm64-64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm0 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0z',
      'M416 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM211.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z',
    ],
  ],
};
const faWrenchSimple = {
  prefix: 'fad',
  iconName: 'wrench-simple',
  icon: [
    384,
    512,
    [],
    'e2d1',
    [
      'M96 342.3c14.1 8.2 29.4 14.6 45.5 19c8 2.2 16.3 3.9 24.7 5c4.2 .6 8.5 1 12.8 1.3c2.1 .1 4.3 .3 6.5 .3s4.3 .1 6.5 .1c35 0 67.8-9.4 96-25.7L288 464c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-121.7z',
      'M203.3 212.7c-6.2 6.2-16.4 6.2-22.6 0l-48-48c-3-3-4.7-7.1-4.7-11.3l0-135.8c0-11-10.9-18.7-20.8-13.8C43.7 35 0 100.4 0 176C0 282 86 368 192 368s192-86 192-192c0-75.6-43.7-141-107.2-172.3C266.9-1.2 256 6.5 256 17.6l0 135.8c0 4.2-1.7 8.3-4.7 11.3l-48 48z',
    ],
  ],
};
const faBlender = {
  prefix: 'fad',
  iconName: 'blender',
  icon: [
    512,
    512,
    [],
    'f517',
    [
      'M0 64L0 192c0 35.3 28.7 64 64 64l85.3 0L160 384l256 0 24-96-104 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 16-64-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l136 0 16-64L336 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0 6.1-24.2c.7-2.6 1-5.3 1-7.8C503 14.8 489.1 0 471 0L160 0 128 0 64 0C28.7 0 0 28.7 0 64zm64 0l69.3 0L144 192l-80 0L64 64z',
      'M336 64l160 0-8 32L336 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l136 0-8 32-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l112 0-8 32-104 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 432c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-32zm224 16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faTeeth = {
  prefix: 'fad',
  iconName: 'teeth',
  icon: [
    576,
    512,
    [],
    'f62e',
    [
      'M48 208l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 104l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM176 176l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 136l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM304 176l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 136l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM432 208l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 104l0 24c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z',
      'M0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 128zm176 48l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48zM48 208l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24zm176 48c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48zm80-176l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48z',
    ],
  ],
};
const faTally2 = {
  prefix: 'fad',
  iconName: 'tally-2',
  icon: [
    640,
    512,
    [],
    'e295',
    [
      'M96 64l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M256 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faShekelSign = {
  prefix: 'fad',
  iconName: 'shekel-sign',
  icon: [
    448,
    512,
    [8362, 'ils', 'shekel', 'sheqel', 'sheqel-sign'],
    'f20b',
    [
      'M128 192l0 256c0 17.7 14.3 32 32 32l160 0c70.7 0 128-57.3 128-128l0-288c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 288c0 35.3-28.7 64-64 64l-128 0 0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M0 64C0 46.3 14.3 32 32 32l160 0c70.7 0 128 57.3 128 128l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-35.3-28.7-64-64-64L64 96l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64z',
    ],
  ],
};
const faIls = faShekelSign;
const faShekel = faShekelSign;
const faSheqel = faShekelSign;
const faSheqelSign = faShekelSign;
const faCars = {
  prefix: 'fad',
  iconName: 'cars',
  icon: [
    640,
    512,
    [],
    'f85b',
    [
      'M0 192l0 96c0 10.7 0 21.3 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 136.5 0c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6l15.1 0L353.3 54.7C342.4 22 311.8 0 277.4 0L138.6 0c-34.4 0-65 22-75.9 54.7L36.1 134.4C14.8 144.7 0 166.6 0 192zm104 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm1.7-80l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9l138.8 0c6.9 0 13 4.4 15.2 10.9L310.3 128l-204.5 0z',
      'M347.4 234.9L329.7 288l204.5 0-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9l-138.8 0c-6.9 0-13 4.4-15.2 10.9zm-87.3 59.4l26.6-79.7C297.6 182 328.2 160 362.6 160l138.8 0c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352l0 96s0 0 0 0l0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32s0 0 0 0l0-96c0-25.4 14.8-47.3 36.1-57.6zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faAxeBattle = {
  prefix: 'fad',
  iconName: 'axe-battle',
  icon: [
    512,
    512,
    [],
    'f6b3',
    [
      'M0 192c0 53.3 17 99.9 33.7 132.7c8.4 16.5 16.8 29.7 23.1 38.9c3.2 4.6 5.8 8.2 7.7 10.6c1 1.2 1.7 2.2 2.3 2.9l.6 .8 .3 .3c3.9 4.6 10 6.7 15.9 5.3s10.4-5.9 11.9-11.7c.1-.4 .2-.6 .3-.9c.2-.7 .6-1.9 1.1-3.5c1-3.1 2.7-7.6 5.1-13.1c4.8-11 12.6-25.7 24.5-40.3c19.4-23.9 50-48 97.6-55.6L224 126c-54.6-7.1-85.4-31.9-103.2-55.6c-10.7-14.3-17-28.7-20.6-39.5c-1.8-5.4-2.9-9.8-3.5-12.8c-.3-1.5-.5-2.6-.6-3.3c-.1-.4-.1-.6-.1-.7C95.1 7.7 90.6 2.5 84.5 .7C83 .2 81.5 0 80 0c-4.6 0-9.2 2-12.2 5.7L67.5 6l-.6 .8c-.5 .7-1.3 1.6-2.3 2.9c-1.9 2.5-4.6 6.1-7.7 10.6c-6.3 9.2-14.7 22.4-23.1 38.9C17 92.1 0 138.7 0 192zm288-66l0 132.4c47.6 7.6 78.2 31.7 97.6 55.6c13.6 16.8 25 36.7 30.9 57.7c1.5 5.8 6.1 10.5 11.9 11.8s12.3-1 16.1-5.6c33.1-41.1 56.5-93.6 64.5-146.6c.1-.4 .1-.8 .1-1.2c0-3.1-1.9-6-4.8-7.2l-55.1-23.6c-6.5-2.8-6.5-11.9 0-14.7L504.3 161c3.3-1.4 5.3-4.8 4.7-8.4c-5.6-36.8-18.3-68.9-30.7-93.4c-9.5-18.7-20.7-37.2-33.9-53.4c-4.1-4.9-10.8-7-16.9-5.2c-6.1 1.8-10.5 7-11.3 13.3c-3.3 20-12.9 40.3-24.9 56.4C373.4 94.1 342.6 119 288 126z',
      'M256 32c17.7 0 32 14.3 32 32l0 416c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-416c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faUserHairLong = {
  prefix: 'fad',
  iconName: 'user-hair-long',
  icon: [
    448,
    512,
    [],
    'e45b',
    [
      'M128 112l0 48c0 53 43 96 96 96s96-43 96-96l0-32 0-32-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112l-48 0z',
      'M176 112l-48 0s0 0 0 0l0 48c0 53 43 96 96 96s96-43 96-96l0-32s0 0 0 0l0-32-8 0c-22.8 0-42.8-11.9-54.1-29.8C241 93.7 210.6 112 176 112zm48 160L70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11s0 0 0 0C96 57.3 153.3 0 224 0c70.6 0 127.8 57.1 128 127.6l0 .8 0 .2 0 10.3c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272zm-62.7 48l125.4 0C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3C0 392.2 72.2 320 161.3 320z',
    ],
  ],
};
const faMap = {
  prefix: 'fad',
  iconName: 'map',
  icon: [
    576,
    512,
    [128506, 62072],
    'f279',
    [
      'M192 32c.1 128 .1 256 .1 384c64 21.3 128 42.7 192 64l0-384C320 74.7 256 53.3 192 32z',
      'M0 114.5V464c0 11.3 11.5 19 22 14.8L192 416l-.1-384L10.1 99.6C4 102 0 107.9 0 114.5zM554 33.2L384 96V480l181.9-67.6c6.1-2.4 10.1-8.3 10.1-14.9V48c0-11.3-11.4-19.1-22-14.9z',
    ],
  ],
};
const faArrowLeftFromArc = {
  prefix: 'fad',
  iconName: 'arrow-left-from-arc',
  icon: [
    512,
    512,
    [],
    'e615',
    [
      'M224 32c0 17.7 14.3 32 32 32c106 0 192 86 192 192s-86 192-192 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c141.4 0 256-114.6 256-256S397.4 0 256 0c-17.7 0-32 14.3-32 32z',
      'M166.6 121.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 320 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-210.7 0 57.4-57.4c12.5-12.5 12.5-32.8 0-45.3z',
    ],
  ],
};
const faFileCircleInfo = {
  prefix: 'fad',
  iconName: 'file-circle-info',
  icon: [
    576,
    512,
    [58604],
    'e493',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-32 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 64c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16c0 0 0 0 0 0l0-48s0 0 0 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faFaceDisappointed = {
  prefix: 'fad',
  iconName: 'face-disappointed',
  icon: [
    512,
    512,
    [],
    'e36f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 48c0-7.7 5.5-14.5 13.4-15.8c.8-.1 1.7-.3 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7c-.8 .1-1.7 .3-2.5 .4c-.9 .1-1.8 .2-2.7 .2c-7.7 0-14.5-5.5-15.8-13.4c-.1-.9-.2-1.8-.2-2.6zm76.1 85.3C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6zM300.7 244.7c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c3.9 .7 7.3 2.7 9.6 5.5c1.2 1.4 2.1 3 2.8 4.8c.3 .9 .6 1.8 .7 2.7c.1 .5 .1 .9 .2 1.4s.1 .9 .1 1.4c0 .4 0 .9-.1 1.3s-.1 .9-.2 1.3c-1.3 7.8-8.1 13.4-15.8 13.4c-.9 0-1.8-.1-2.6-.2c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z',
      'M211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z',
    ],
  ],
};
const faLassoSparkles = {
  prefix: 'fad',
  iconName: 'lasso-sparkles',
  icon: [
    576,
    512,
    [],
    'e1c9',
    [
      'M0 176c0 57.2 44.7 108.1 113.9 140.2l-.2 .4L160.5 340c19.3 9.7 31.5 29.4 31.5 51c0 31.5-25.5 57-57 57l-71 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l71 0c66.8 0 121-54.2 121-121c0-14.1-2.4-27.8-7-40.6c12.8 1.1 25.8 1.6 39 1.6c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80c0 5.6-1 11.1-2.8 16.2C486.4 116.5 512 144.8 512 176c0 61.9-100.3 112-224 112S64 237.9 64 176c0-51 68.2-94 161.4-107.6c3.8-15.2 14.8-27.9 29.9-33.4l26-9.6L290.7 0c-.9 0-1.8 0-2.7 0C128.9 0 0 78.8 0 176z',
      'M336 0c6.7 0 12.7 4.2 15 10.4l14.7 39.8L405.6 65c6.3 2.3 10.4 8.3 10.4 15s-4.2 12.7-10.4 15l-39.8 14.7L351 149.6c-2.3 6.3-8.3 10.4-15 10.4s-12.7-4.2-15-10.4l-14.7-39.8L266.4 95c-6.3-2.3-10.4-8.3-10.4-15s4.2-12.7 10.4-15l39.8-14.7L321 10.4C323.3 4.2 329.3 0 336 0zM496 352c6.7 0 12.7 4.2 15 10.4l14.7 39.8L565.6 417c6.3 2.3 10.4 8.3 10.4 15s-4.2 12.7-10.4 15l-39.8 14.7L511 501.6c-2.3 6.3-8.3 10.4-15 10.4s-12.7-4.2-15-10.4l-14.7-39.8L426.4 447c-6.3-2.3-10.4-8.3-10.4-15s4.2-12.7 10.4-15l39.8-14.7L481 362.4c2.3-6.3 8.3-10.4 15-10.4z',
    ],
  ],
};
const faClockEleven = {
  prefix: 'fad',
  iconName: 'clock-eleven',
  icon: [
    512,
    512,
    [],
    'e347',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm168-96c0-7.8 3.8-15.4 10.7-20c11-7.4 25.9-4.4 33.3 6.7l20 30 0-56.7c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 10.6-6.9 19.9-17 23s-21.1-.9-26.9-9.7l-64-96c-2.7-4.1-4-8.7-4-13.3z',
      'M256 96c-13.3 0-24 10.7-24 24l0 56.7-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-136c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faRocket = {
  prefix: 'fad',
  iconName: 'rocket',
  icon: [
    512,
    512,
    [],
    'f135',
    [
      'M3.1 275.8C7.3 283.3 15.3 288 24 288l94.5 0c19.5-43.5 51.6-112.1 80.1-158l-80.8 0c-25.2 0-48.5 13.1-61.5 34.6L3.5 251.5c-4.5 7.4-4.7 16.7-.4 24.2zM224 391.8l0 96.2c0 8.7 4.7 16.7 12.2 20.9c3.7 2.1 7.7 3.1 11.8 3.1c4.3 0 8.6-1.2 12.5-3.5l86.9-52.8c21.5-13.1 34.6-36.4 34.6-61.5l0-80.8c-45.6 28.2-114 59.4-158 78.4z',
      'M166.5 394.8l-50.7-50.7c-9.2-9.2-11.9-23-6.7-34.9c18.3-41.9 62.7-140.2 98.1-192.5C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7C342.6 340.5 243 383.9 201 401.7c-11.8 5-25.4 2.2-34.5-6.9zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
    ],
  ],
};
const faSirenOn = {
  prefix: 'fad',
  iconName: 'siren-on',
  icon: [
    640,
    512,
    [],
    'e02e',
    [
      'M144 352l25-199.9c4-32 31.2-56.1 63.5-56.1l175 0c32.3 0 59.5 24 63.5 56.1L496 352l-261.9 0 21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L201.9 352 144 352z',
      'M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM128 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-384 0z',
    ],
  ],
};
const faClockTen = {
  prefix: 'fad',
  iconName: 'clock-ten',
  icon: [
    512,
    512,
    [],
    'e354',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm140-77.3c7.4-11 22.3-14 33.3-6.7L232 211.2l0-91.2c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-96-64c-11-7.4-14-22.3-6.7-33.3z',
      'M256 96c-13.3 0-24 10.7-24 24l0 91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256l0-136c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faCandleHolder = {
  prefix: 'fad',
  iconName: 'candle-holder',
  icon: [
    448,
    512,
    [128367],
    'f6bc',
    [
      'M0 488c0 13.3 10.7 24 24 24l352 0c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72c0 8.4 1.4 16.5 4.1 24L256 464 64 464l-40 0c-13.3 0-24 10.7-24 24zM80 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-39.6-49.1-90.1-66.2-106.6C170.1 1.9 165.2 0 160 0s-10.1 1.9-13.8 5.4C129.1 21.9 80 72.4 80 112zM400 440a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M128 224l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c17.7 0 32 14.3 32 32l0 208L64 464l0-208c0-17.7 14.3-32 32-32l32 0z',
    ],
  ],
};
const faVideoArrowDownLeft = {
  prefix: 'fad',
  iconName: 'video-arrow-down-left',
  icon: [
    576,
    512,
    [],
    'e2c8',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-68.2 0-119.6 0-68.2c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm96 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103 54.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-112z',
      'M559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 315.8l0-119.6 142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM232 352l-112 0c-13.3 0-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103 54.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z',
    ],
  ],
};
const faPhotoFilm = {
  prefix: 'fad',
  iconName: 'photo-film',
  icon: [
    640,
    512,
    ['photo-video'],
    'f87c',
    [
      'M192 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-64 0-160 0-96 0c-35.3 0-64-28.7-64-64l0-96 0-64 0-64zm66.4 210.4c4 8.3 12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7c1.9-3.5 2.8-7.4 2.8-11.3c0-4.7-1.4-9.3-4-13.3l-96-144C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4zM272 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M476 106.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S560.9 288 552 288l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C440.5 100 448 96 456 96s15.5 4 20 10.7zM64 128l128 0 0 64c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64 160 0 0 96c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm336 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faPhotoVideo = faPhotoFilm;
const faFloppyDiskCircleArrowRight = {
  prefix: 'fad',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [
    576,
    512,
    ['save-circle-arrow-right'],
    'e180',
    [
      'M0 96C0 60.7 28.7 32 64 32l242.7 0c17 0 33.3 6.7 45.3 18.7L429.3 128c12 12 18.7 28.3 18.7 45.3l0 19.5c-5.3-.5-10.6-.7-16-.7c-75 0-139.1 47-164.4 113.1C256.1 294.5 240.8 288 224 288c-35.3 0-64 28.7-64 64s28.7 64 64 64c13.3 0 25.7-4.1 35.9-11c6 28.1 18.7 53.7 36.3 75L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z',
    ],
  ],
};
const faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
const faFolderMinus = {
  prefix: 'fad',
  iconName: 'folder-minus',
  icon: [
    512,
    512,
    [],
    'f65d',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM160 296c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M160 296c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faHexagonNodesBolt = {
  prefix: 'fad',
  iconName: 'hexagon-nodes-bolt',
  icon: [
    576,
    512,
    [],
    'e69a',
    [
      'M0 160c0 19.4 10 38.2 28 48.5c1.3 .8 2.6 1.5 4 2.1l0 90.8c-1.3 .6-2.7 1.3-4 2.1C10 313.9 0 332.7 0 352.1c0 9.5 2.4 19.1 7.5 27.9C23 406.8 57.2 416 84 400.5c19.3-11.1 29.4-32 27.8-52.8l50.5-28.9c-11.5-11.2-19.9-25.6-23.8-41.7L88 306.1c-2.6-1.8-5.2-3.3-8-4.7l0-90.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-.1 1.4-.2 2.8-.2 4.3c0 22.3 13.1 41.6 32 50.6l0 98.8c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56c30.7 0 55.6-24.7 56-55.2c-7.5-12.9-13.5-26.8-17.6-41.5c-4.2-4-9.1-7.3-14.4-9.9l0-98.8c2.8-1.3 5.5-2.9 8-4.7l10.5 6c5.5-15.3 13.1-29.5 22.4-42.5l-9.1-5.2c.1-1.4 .2-2.8 .2-4.3c0-22.3-13.1-41.6-32-50.6l0-98.8c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 98.8c-2.8 1.3-5.5 2.9-8 4.7l-80.1-45.8c1.6-20.8-8.6-41.6-27.9-52.8C57.2 96 23 105.2 7.5 132C2.4 140.8 0 150.5 0 160zm285.6 33.2c11.5 11.2 19.9 25.6 23.8 41.7L360 205.9c.4 .3 .8 .6 1.3 .9c21.7-9.5 45.6-14.8 70.8-14.8c2 0 4 0 5.9 .1c6.6-9.4 10.1-20.7 10.1-32.1c0-9.5-2.4-19.1-7.5-27.9C425 105.2 390.8 96 364 111.5c-19.3 11.1-29.4 32-27.8 52.8l-50.6 28.9z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm194.5-66.2c2.8-5 1.7-11.1-2.6-14.9s-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2z',
    ],
  ],
};
const faPlanetMoon = {
  prefix: 'fad',
  iconName: 'planet-moon',
  icon: [
    576,
    512,
    [],
    'e01f',
    [
      'M0 288C0 411.7 100.3 512 224 512s224-100.3 224-224c0-112.8-83.4-206.2-192-221.7c0 27.4 0 54.8 0 82.1c0 7.5-2.6 14.7-7.4 20.5C231 190 213.5 211 195.9 232.1c-11.3 13.5-10.4 33.5 2.1 45.9c6.4 6.4 15.1 10 24.1 10l65.9 0c17.7 0 32 14.3 32 32l0 15.9c0 10.6-2.6 21-7.6 30.3l-41.3 76.6c-4.4 8.1-12.8 13.2-22 13.2c-.4 0-.9 0-1.3 0s-.9-.1-1.3-.1c-.8-.1-1.7-.2-2.5-.4c-1.6-.3-3.2-.8-4.7-1.5c-3-1.3-5.7-3.1-8-5.4s-4.1-5-5.4-8c-.3-.8-.6-1.5-.8-2.3c-.2-.8-.5-1.6-.6-2.4c-.2-.8-.3-1.6-.4-2.5s-.1-1.7-.1-2.6c0-15.7 0-31.3 0-47c-.6 0-1.1 0-1.6 0s-1.1-.1-1.6-.1c-1.1-.1-2.1-.3-3.2-.5c-2.1-.4-4.1-1.1-6-1.9c-3.8-1.6-7.3-4-10.2-6.9s-5.2-6.3-6.9-10.2c-.2-.5-.4-1-.6-1.4c-.2-.5-.4-1-.5-1.5c-.3-1-.6-2-.8-3.1c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1.1 0-1.6c0-10.7 0-21.3 0-32c-16.7-16.7-33.3-33.3-49.9-49.9c-9-9-21.2-14.1-33.9-14.1l-33.6 0c-17 0-33.3-6.7-45.3-18.7C23.1 231.1 17 225 10.9 218.9C3.8 240.6 0 263.9 0 288z',
      'M512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 64C124.4 64 40 129 10.9 218.9l18.4 18.4c12 12 28.3 18.7 45.3 18.7l33.6 0c12.7 0 24.9 5.1 33.9 14.1L192 320l0 32c0 17.7 14.3 32 32 32l0 47c0 13.8 11.2 25 25 25c9.2 0 17.7-5.1 22-13.2l41.3-76.6c5-9.3 7.6-19.8 7.6-30.3l0-15.9c0-17.7-14.3-32-32-32l-65.9 0c-9 0-17.7-3.6-24.1-10c-12.5-12.5-13.4-32.4-2.1-45.9l52.7-63.2c4.8-5.8 7.4-13 7.4-20.5l0-82.1c-10.5-1.5-21.1-2.3-32-2.3z',
    ],
  ],
};
const faFaceEyesXmarks = {
  prefix: 'fad',
  iconName: 'face-eyes-xmarks',
  icon: [
    512,
    512,
    [],
    'e374',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM96 144c0-4.1 1.6-8.2 4.7-11.3s7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7L160 169.4l36.7-36.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L160 214.6l-36.7 36.7c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7s-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3L137.4 192l-36.7-36.7c-3.1-3.1-4.7-7.2-4.7-11.3zm80 240c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM292.7 132.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7L352 169.4l36.7-36.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3L374.6 192l36.7 36.7c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3s-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L352 214.6l-36.7 36.7c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z',
      'M196.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 169.4l36.7-36.7zm96 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z',
    ],
  ],
};
const faChartScatter = {
  prefix: 'fad',
  iconName: 'chart-scatter',
  icon: [
    512,
    512,
    [],
    'f7ee',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M384 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faCircleGf = {
  prefix: 'fad',
  iconName: 'circle-gf',
  icon: [
    512,
    512,
    [],
    'e67f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112-56c0-39.8 32.2-72 72-72s72 32.2 72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24s-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0c13.3 0 24 10.7 24 24l0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112zm176-48c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 64 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z',
      'M112 200c0-39.8 32.2-72 72-72s72 32.2 72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24s-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0c13.3 0 24 10.7 24 24l0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112zm176-48c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 64 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z',
    ],
  ],
};
const faDisplayArrowDown = {
  prefix: 'fad',
  iconName: 'display-arrow-down',
  icon: [
    576,
    512,
    [],
    'e164',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0 96 0 176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L312 0l0 64 200 0 0 288L64 352 64 64l200 0 0-64L64 0C28.7 0 0 28.7 0 64z',
      'M264 64L64 64l0 288 448 0 0-288L312 64l0 142.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 64zm82.7 384L336 416l-96 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0z',
    ],
  ],
};
const faStore = {
  prefix: 'fad',
  iconName: 'store',
  icon: [
    576,
    512,
    [],
    'f54e',
    [
      'M64 219.1c2.5 1 5.2 1.8 7.9 2.5s5.5 1.2 8.4 1.6c4 .5 8.1 .8 12.1 .8c12.8 0 24.8-2.7 35.6-7.5L128 384l320 0 0-167.5c5.4 2.4 11.1 4.3 17 5.5c3 .6 6 1.1 9 1.4s6.2 .5 9.4 .5c4.1 0 8.1-.3 12.1-.8c5.8-.8 11.3-2.2 16.5-4.1L512 384l0 64c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-64 0-164.9z',
      'M490.3 13.1l57.3 90.7c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8c-26.1 0-49.2-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39.1 29-65.2 29c-4.1 0-8.2-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L85.7 13.1C90.8 5 99.9 0 109.6 0H466.4c9.7 0 18.8 5 23.9 13.1z',
    ],
  ],
};
const faArrowTrendUp = {
  prefix: 'fad',
  iconName: 'arrow-trend-up',
  icon: [
    576,
    512,
    [],
    'e098',
    [
      'M0 384c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4L192 269.3 297.4 374.6c12.5 12.5 32.8 12.5 45.3 0L512 205.3l0-45.3-45.3 0L320 306.7 214.6 201.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160C3.1 367.6 0 375.8 0 384z',
      'M352 128c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-128 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faPlugCircleMinus = {
  prefix: 'fad',
  iconName: 'plug-circle-minus',
  icon: [
    576,
    512,
    [],
    'e55e',
    [
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 67.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.2C87 398 32 333.4 32 256l0-32c-17.7 0-32-14.3-32-32zM64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 96-64 0 0-96zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96-64 0 0-96z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z',
    ],
  ],
};
const faOliveBranch = {
  prefix: 'fad',
  iconName: 'olive-branch',
  icon: [
    640,
    512,
    [],
    'e317',
    [
      'M192 320c0 106 64.5 192 144 192s144-86 144-192s-64.5-192-144-192s-144 86-144 192zM427.2 128.1c13.6 10.4 25.7 22.9 36.2 36.9C494 205.8 512 260.7 512 320c0 57.8-17.1 111.4-46.3 151.8c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3z',
      'M128 0C59 0 13.8 41.6 2.7 53.1C.9 55 0 57.4 0 60s.9 5 2.7 6.9c8.6 8.9 37.7 35.9 82.5 47.6C34.5 141.4 0 194.6 0 256l0 16c0 8.8 7.2 16 16 16l16 0c86.6 0 157.1-68.7 159.9-154.6L326.4 70.1C357.3 55.5 391.1 48 425.2 48L616 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L425.2 0C384 0 343.3 9.1 306 26.7L252.2 52C239.4 39.1 194.9 0 128 0z',
    ],
  ],
};
const faAngle = {
  prefix: 'fad',
  iconName: 'angle',
  icon: [
    448,
    512,
    [],
    'e08c',
    [
      'M218.5 218.1c21.4 17.4 40.4 37.7 56.2 60.4l40.8-25.3c-20.7-30.1-46.1-56.7-75.1-78.9l-21.9 43.8zm73.1 87.6c13.3 24.2 23.3 50.5 29.5 78.3l49 0c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3z',
      'M238.3 35.4c15.8 7.9 22.2 27.1 14.3 42.9L83.8 416 416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l192-384c7.9-15.8 27.1-22.2 42.9-14.3z',
    ],
  ],
};
const faVacuumRobot = {
  prefix: 'fad',
  iconName: 'vacuum-robot',
  icon: [
    512,
    512,
    [],
    'e04e',
    [
      'M112 320c0-4.1 1.6-8.2 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7l-64-64c-3.1-3.1-4.7-7.2-4.7-11.3zm20.7-91.3c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm80-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l64 64c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z',
      'M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM155.3 155.3c55.6-55.6 145.8-55.6 201.4 0s55.6 145.8 0 201.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c68.1-68.1 68.1-178.5 0-246.6s-178.5-68.1-246.6 0c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm80 57.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zm-80 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zm-38.6 80c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z',
    ],
  ],
};
const faSignHanging = {
  prefix: 'fad',
  iconName: 'sign-hanging',
  icon: [
    512,
    512,
    ['sign'],
    'f4d9',
    [
      'M0 96c0 17.7 14.3 32 32 32l32 0 0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L128 64l0-32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 32L32 64C14.3 64 0 78.3 0 96z',
      'M192 160c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-256 0z',
    ],
  ],
};
const faSign = faSignHanging;
const faSquareDivide = {
  prefix: 'fad',
  iconName: 'square-divide',
  icon: [
    448,
    512,
    [],
    'e26a',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM112 256c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm144-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M192 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 96c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm112 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faFolderCheck = {
  prefix: 'fad',
  iconName: 'folder-check',
  icon: [
    512,
    512,
    [],
    'e64e',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM136 288c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47L335 207c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17L241 369c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7l-64-64c-4.7-4.7-7-10.8-7-17z',
      'M369 207c9.4 9.4 9.4 24.6 0 33.9L241 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 207c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faSignalStreamSlash = {
  prefix: 'fad',
  iconName: 'signal-stream-slash',
  icon: [
    640,
    512,
    [],
    'e250',
    [
      'M0 256c0 68.1 23.7 130.7 63.2 180c6.3 7.9 15.6 12 25 12c7 0 14.1-2.3 20-7c13.8-11.1 16-31.2 5-45C82.4 357.6 64 309 64 256c0-33.4 7.3-65.1 20.4-93.5L33 122C11.9 162 0 207.6 0 256zm112 0c0 45.1 17 86.2 44.8 117.3c11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7c0-6.8 .6-13.5 1.8-19.9l-54.3-42.8C116.1 212.8 112 233.9 112 256zm175.5-56c18.4 14.4 36.7 28.8 55.1 43.2c-5.8-24.7-28-43.2-54.5-43.2l-.5 0zm84-18.7c17.8 19.8 28.5 46 28.5 74.7c0 10.1-1.3 19.9-3.8 29.2c17.7 13.9 35.3 27.7 53 41.6c9.5-21.7 14.8-45.6 14.8-70.8c0-45.1-17-86.2-44.8-117.3c-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2zM462.9 116c30.7 38.4 49.1 87 49.1 140c0 36.4-8.7 70.8-24.1 101.1c17 13.4 34.1 26.7 51.1 40.1C562.6 355.5 576 307.3 576 256c0-68.1-23.7-130.7-63.2-180c-11.1-13.8-31.2-16-45-5s-16 31.2-5 45z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBezierCurve = {
  prefix: 'fad',
  iconName: 'bezier-curve',
  icon: [
    640,
    512,
    [],
    'f55b',
    [
      'M0 112C0 76.7 28.7 48 64 48c25.3 0 47.2 14.7 57.6 36L240 84l0 60c0 10 3 19.2 8.2 26.9C189.2 196.6 146.6 253 140.7 320l-56.2 0c5-75 45.1-140.4 104-180l-66.9 0c-10.4 21.3-32.3 36-57.6 36c-35.3 0-64-28.7-64-64zm391.8 58.9c2.6-3.8 4.7-8.1 6.1-12.6c.7-2.3 1.2-4.6 1.6-7c.2-1.2 .3-2.4 .4-3.6c0-.6 .1-1.2 .1-1.8s0-1.2 0-1.9l0-60 118.4 0c10.4-21.3 32.3-36 57.6-36c35.3 0 64 28.7 64 64s-28.7 64-64 64c-25.3 0-47.2-14.7-57.6-36l-66.9 0c58.9 39.6 98.9 105 104 180l-56.2 0c-5.9-67-48.5-123.4-107.5-149.1z',
      'M296 136l48 0 0-48-48 0 0 48zM240 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64zM88 376l0 48 48 0 0-48-48 0zm-8-56l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm424 56l0 48 48 0 0-48-48 0zm-8-56l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z',
    ],
  ],
};
const faEyeDropperHalf = {
  prefix: 'fad',
  iconName: 'eye-dropper-half',
  icon: [
    512,
    512,
    [],
    'e173',
    [
      'M5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4c6.2 6.2 14.4 9.4 22.6 9.4c6.1 0 12.3-1.8 17.7-5.4L89.7 480l42.4 0c21.2 0 41.6-8.4 56.6-23.4L332 313.3 286.7 268c-17.3 17.3-34.7 34.7-52 52l-91.3 91.3c-3 3-7.1 4.7-11.3 4.7L96 416c0-12 0-24.1 0-36.1c0-.5 0-1.1 .1-1.6s.1-1 .2-1.6c.2-1 .5-2 .9-3c.8-1.9 2-3.7 3.5-5.2c16.2-16.2 32.4-32.4 48.6-48.6c31.6-31.6 63.2-63.2 94.7-94.7c-15.1-15.1-30.2-30.2-45.3-45.3L55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4L5.4 462.2z',
      'M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM143.4 411.3L234.7 320l-85.5 0-48.6 48.6c-3 3-4.7 7.1-4.7 11.3L96 416l36.1 0c4.2 0 8.3-1.7 11.3-4.7z',
    ],
  ],
};
const faStoreLock = {
  prefix: 'fad',
  iconName: 'store-lock',
  icon: [
    640,
    512,
    [],
    'e4a6',
    [
      'M28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c5 5.5 10.6 10.3 16.8 14.4C455.2 179.6 489.3 160 528 160c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8zM64 252.6L64 384l0 64c0 35.3 28.7 64 64 64l264.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-96-256 0 0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1c-4.2-.6-8.2-1.3-12.1-2.3z',
      'M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faBellSlash = {
  prefix: 'fad',
  iconName: 'bell-slash',
  icon: [
    640,
    512,
    [128277, 61943],
    'f1f6',
    [
      'M98.8 397.1c-5.2-11.5-3.1-25 5.3-34.4l7.4-8.3c31.2-35.1 48.5-80.5 48.5-127.6l0-4.8L406.2 416 128 416c-12.6 0-24-7.4-29.2-18.9zM186 120.5c23-35.1 59.4-60.7 102-69.3L288 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 19.2C425 66 480 130.6 480 208l0 18.8c0 47 17.3 92.4 48.5 127.6l7.4 8.3c5.3 6 8.1 13.6 8.1 21.3c0 4.4-.9 8.9-2.8 13.1c-.2 .4-.4 .9-.6 1.3C422.4 305.8 304.2 213.1 186 120.5zM256 448l64 0 64 0c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faCloudBoltSun = {
  prefix: 'fad',
  iconName: 'cloud-bolt-sun',
  icon: [
    640,
    512,
    ['thunderstorm-sun'],
    'f76e',
    [
      'M0 128c0 3.2 1 6.4 2.9 9.2L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-19.9-22-32.3-50.9-33.1-82.7c-28.7-16.6-48-47.6-48-83.2c0-53 43-96 96-96c18.4 0 35.6 5.2 50.2 14.1c13.2-21.9 32.7-39.5 56-50.3L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1c-2-.8-4.1-1.2-6.2-1.2c-3.2 0-6.4 1-9.2 2.9L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6c-.8 2-1.2 4.1-1.2 6.2zm144 80c0 18.5 7.8 35.1 20.3 46.8c10.6-39.7 39.9-71.8 77.8-86.4c.8-4.3 1.8-8.4 3-12.6C234.7 148.4 221.8 144 208 144c-35.3 0-64 28.7-64 64zM288.9 373.3c2.2 6.4 8.3 10.7 15.1 10.7l70.1 0L321.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c3.9-3.1 6-7.7 6-12.5c0-1.8-.3-3.6-.9-5.3c-2.2-6.4-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8z',
      'M639.9 303.9c0 44.2-35.8 80-80 80l-18.6 0c3.5-10.1 3.7-21.3 0-31.8C534.5 332.9 516.4 320 496 320l-18.3 0 29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-14.5 11.6-20.9 30.5-16.8 48.4c-37.9-12.8-65.2-48.7-65.2-90.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z',
    ],
  ],
};
const faThunderstormSun = faCloudBoltSun;
const faCameraSlash = {
  prefix: 'fad',
  iconName: 'camera-slash',
  icon: [
    640,
    512,
    [],
    'e0d9',
    [
      'M64 160l0 256c0 35.3 28.7 64 64 64l359.4 0L356.4 376.8c-11.2 4.6-23.5 7.2-36.4 7.2c-53 0-96-43-96-96c0-5 .4-9.9 1.1-14.6L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6zm90.8-64c43.6 34.1 87.1 68.3 130.7 102.4c10.7-4.1 22.4-6.4 34.6-6.4c53 0 96 43 96 96c0 4.1-.3 8.2-.8 12.2c53.4 41.8 106.7 83.6 160 125.4c.5-3.1 .7-6.3 .7-9.6l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8L202.7 96l-47.9 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faCommentQuote = {
  prefix: 'fad',
  iconName: 'comment-quote',
  icon: [
    512,
    512,
    [],
    'e14c',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm128-64c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-1.3 .2-2.7 .3-4 .3c-11.5 0-21.7-8.3-23.6-20.1c-2.2-13.1 6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48zm144 0c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-1.3 .2-2.7 .3-4 .3c-11.5 0-21.7-8.3-23.6-20.1c-2.2-13.1 6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48z',
      'M128 176c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48zm256 87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3z',
    ],
  ],
};
const faTablet = {
  prefix: 'fad',
  iconName: 'tablet',
  icon: [
    448,
    512,
    ['tablet-android'],
    'f3fb',
    [
      'M0 384l0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64L0 384zm160 64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
      'M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V384H0V64z',
    ],
  ],
};
const faTabletAndroid = faTablet;
const faSchoolFlag = {
  prefix: 'fad',
  iconName: 'school-flag',
  icon: [
    576,
    512,
    [],
    'e56e',
    [
      'M0 224L0 448c0 35.3 28.7 64 64 64l176 0 0-112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112 176 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-101.7 0L320.7 96l-.7 0-16 0-48 0-.7 0-89.6 64L64 160c-35.3 0-64 28.7-64 64zm64 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM336 240a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm112 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64z',
      'M297.4 1.4c2-.9 4.2-1.4 6.6-1.4l96 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-80 0-16 0-48 0 0-64c0-17.7 14.3-32 32-32c3.3 0 6.4 .5 9.4 1.4zM80 224l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm384 0l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM64 368c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm400-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faMessageCode = {
  prefix: 'fad',
  iconName: 'message-code',
  icon: [
    512,
    512,
    [],
    'e1df',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM112 208c0 6.1 2.3 12.3 7 17l64 64c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7l-64 64c-4.7 4.7-7 10.8-7 17zm183-81c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7l64-64c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17l-64-64c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7z',
      'M217 127c9.4 9.4 9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0zm78.1 0c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z',
    ],
  ],
};
const faGlassHalf = {
  prefix: 'fad',
  iconName: 'glass-half',
  icon: [
    384,
    512,
    ['glass-half-empty', 'glass-half-full'],
    'e192',
    [
      'M0 32c0 .8 0 1.5 .1 2.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.1-.8 .1-1.5 .1-2.3c0-8.1-3-15.9-8.6-21.8C369.4 3.7 360.9 0 352 0L32 0C23.1 0 14.6 3.7 8.6 10.2C3 16.1 0 23.9 0 32zM66.4 64l251.3 0c-3.8 53.3-7.6 106.7-11.4 160L291.3 433.1c-.6 8.4-7.6 14.9-16 14.9l-166.6 0c-8.4 0-15.4-6.5-16-14.9L77.8 224C74 170.7 70.2 117.3 66.4 64z',
      'M306.2 224L77.8 224 92.7 433.1c.6 8.4 7.6 14.9 16 14.9l166.6 0c8.4 0 15.4-6.5 16-14.9L306.2 224z',
    ],
  ],
};
const faGlassHalfEmpty = faGlassHalf;
const faGlassHalfFull = faGlassHalf;
const faFill = {
  prefix: 'fad',
  iconName: 'fill',
  icon: [
    512,
    512,
    [],
    'f575',
    [
      'M66.5 296c0 8.2 3.1 16.4 9.4 22.6L193.4 436.1c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4C288 386.7 337.4 337.4 386.7 288L67.5 288c-.7 2.6-1 5.3-1 8z',
      'M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L238.6 436.1c-12.5 12.5-32.8 12.5-45.3 0L75.9 318.6c-12.5-12.5-12.5-32.8 0-45.3L168 181.3z',
    ],
  ],
};
const faMessageMinus = {
  prefix: 'fad',
  iconName: 'message-minus',
  icon: [
    512,
    512,
    ['comment-alt-minus'],
    'f4a7',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM160 208c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z',
      'M160 208c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faCommentAltMinus = faMessageMinus;
const faAngleUp = {
  prefix: 'fad',
  iconName: 'angle-up',
  icon: [
    448,
    512,
    [8963],
    'f106',
    [
      'M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z',
      '',
    ],
  ],
};
const faDinosaur = {
  prefix: 'fad',
  iconName: 'dinosaur',
  icon: [
    640,
    512,
    [],
    'e5fe',
    [
      'M0 391.3C0 457.9 54.1 512 120.7 512l71.3 0 32 0 32 0 4.7 0c15.1 0 27.3-12.2 27.3-27.3c0-13.4-9.7-24.7-22.8-26.9L156.7 439.7C121.7 433.8 96 403.5 96 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 19.9 14.4 36.8 34 40.1l108.5 18.1c21.1 3.5 38 17.9 45.4 36.8c6.6 .7 13.3 1 20.1 1c16.6 0 32.7-2.1 48-6l0 22c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-55.9c76.5-35.9 128-113.5 128-201.5l0-30.6C640 86 554 0 448 0l-1.8 0c-13.6 0-26 7.7-32.1 19.8c-3.9 7.9-10.6 14-18.7 17.2l-1.7 .7C378.1 43.9 368 58.9 368 75.6l0 4.7c0 26.3 21.4 47.7 47.7 47.7l32.3 0 32 0c35.3 0 64 28.7 64 64l0 24c0 22.1-17.9 40-40 40c-8.7 0-17.1-2.8-24-8l-55.5-41.6c-40.2-30.1-89-46.4-139.2-46.4c-57.7 0-113.4 21.5-156.1 60.3L39.5 301.9C14.4 324.8 0 357.2 0 391.3zM480 48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M448 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faDrumstickBite = {
  prefix: 'fad',
  iconName: 'drumstick-bite',
  icon: [
    512,
    512,
    [],
    'f6d7',
    [
      'M0 380c0 33.1 26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l36.4-36.4c-39.2-3-70.5-34.3-73.5-73.5l-36.4 36.4c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60z',
      'M160 272l0-96C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1l-96 0c-44.2 0-80-35.8-80-80z',
    ],
  ],
};
const faLinkHorizontalSlash = {
  prefix: 'fad',
  iconName: 'link-horizontal-slash',
  icon: [
    640,
    512,
    ['chain-horizontal-slash'],
    'e1cc',
    [
      'M0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-18.5 6.2-35.5 16.6-49.1L30.4 119.9C11.3 144.4 0 175.2 0 208.6zm117.2-142L195.6 128l107.8 0c44.5 0 80.6 36.1 80.6 80.6c0 19.7-7.1 38-19.1 52.1c16.8 13.2 33.6 26.3 50.4 39.5c20.5-25.1 32.7-57.1 32.7-91.6C448 128.7 383.3 64 303.4 64L144.6 64c-9.4 0-18.5 .9-27.4 2.6zM192 303.4C192 383.3 256.7 448 336.6 448l110.2 0-81.2-64-28.9 0c-44.5 0-80.6-36.1-80.6-80.6c0-1.9 .1-3.7 .2-5.5l-55.5-43.8c-5.6 15.4-8.6 32.1-8.6 49.3zM480.4 186.7c-2.9 17.4 8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 36.6-24.4 67.6-57.9 77.4c18.7 14.6 37.4 29.3 56.1 43.9c39.6-25.8 65.9-70.5 65.9-121.3c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faChainHorizontalSlash = faLinkHorizontalSlash;
const faHollyBerry = {
  prefix: 'fad',
  iconName: 'holly-berry',
  icon: [
    512,
    512,
    [],
    'f7aa',
    [
      'M9.3 376c0 2.5 .4 5.1 1.3 7.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.7c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8l0-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16.1 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3c-15.5-5.2-31.6 6.4-31.6 22.8l0 32C96 323.9 67.9 352 33.3 352c-13.7 0-24 11.2-24 24zM275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72l0 22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7l0-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.1-.6-4.3-.9-6.4-.9c-.8 0-1.6 0-2.3 .1c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7z',
      'M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z',
    ],
  ],
};
const faNose = {
  prefix: 'fad',
  iconName: 'nose',
  icon: [
    448,
    512,
    [],
    'e5bd',
    [
      'M0 401.9c1 61 50.8 110.1 112 110.1l12 0c-.5-.7-.9-1.3-1.4-1.9c-.5-.7-.9-1.3-1.3-2c-.9-1.3-1.6-2.7-2.4-4.1c-1.5-2.8-2.7-5.7-3.8-8.7s-1.8-6.2-2.4-9.4c-.1-.8-.3-1.6-.4-2.4s-.2-1.6-.3-2.4c-.1-.9-.1-1.7-.2-2.5c0-.8 0-1.6-.1-2.2l0-.4c0-2.1 .1-2.6 .1-3.1c.1-1 .1-2 .2-3c.2-2 .5-4 .9-5.9c.8-3.9 2-7.7 3.5-11.3c3-7.2 7.4-13.6 12.9-19.1C140.4 422.7 155.4 416 172 416l4.8 0c19.7 0 38.3 9 50.6 24.3l15.4 19.2c25.8 32.3 64.6 51.4 105.8 52.4c55.2-1.6 99.4-46.8 99.4-102.3c0-28.1-11.4-54.4-30.4-74.1C369.9 286 259.3 163 181.3 12.9C177.2 5 169 0 160 0L88 0C74.7 0 64 10.7 64 24l0 230.5c0 6.6 6.6 11.3 13 9.7c6.7-1.7 13.6-2.9 20.7-3.6l44.7-4.5c8.8-.9 16.6 5.5 17.5 14.3s-5.5 16.6-14.3 17.5l-44.7 4.5C44.3 298 1 345.3 0 401.9z',
      'M124 512c-7.5-10-12-22.5-12-36c0-33.1 26.9-60 60-60h4.8c19.7 0 38.3 9 50.6 24.3l15.4 19.2c25.8 32.3 64.6 51.4 105.8 52.4L124 512z',
    ],
  ],
};
const faArrowLeftToArc = {
  prefix: 'fad',
  iconName: 'arrow-left-to-arc',
  icon: [
    512,
    512,
    [],
    'e616',
    [
      'M0 256C0 397.4 114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256S150 64 256 64c17.7 0 32-14.3 32-32s-14.3-32-32-32C114.6 0 0 114.6 0 256z',
      'M326.6 121.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-210.7 0 57.4-57.4c12.5-12.5 12.5-32.8 0-45.3z',
    ],
  ],
};
const faChevronLeft = {
  prefix: 'fad',
  iconName: 'chevron-left',
  icon: [
    320,
    512,
    [9001],
    'f053',
    [
      'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z',
      '',
    ],
  ],
};
const faBacteria = {
  prefix: 'fad',
  iconName: 'bacteria',
  icon: [
    640,
    512,
    [],
    'e059',
    [
      'M0 300c0 1.6 .2 3.3 .7 5c2.7 9.6 12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3c-1.7-.5-3.3-.7-5-.7c-7.8 0-15 5.2-17.3 13.1l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .4c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C5.2 284.9 0 292.2 0 300zm160-76a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM384 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1c0 0 0 0 .1 0l29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.2 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5c0 0 0 0 0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faClouds = {
  prefix: 'fad',
  iconName: 'clouds',
  icon: [
    640,
    512,
    [],
    'f744',
    [
      'M0 192c0 53 43 96 96 96l64.9 0c8-72 69-128 143.1-128c41.7 0 79.3 17.7 105.6 46.1c9.9-5.5 20.7-9.6 32.1-11.9c4.1-10.6 6.3-22.2 6.3-34.2c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192z',
      'M128 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28c-18.7-35.7-56.1-60-99.2-60c-61.9 0-112 50.1-112 112c0 7.1 .7 14.1 1.9 20.8C155.6 337.4 128 373.5 128 416z',
    ],
  ],
};
const faMoneyBillSimple = {
  prefix: 'fad',
  iconName: 'money-bill-simple',
  icon: [
    576,
    512,
    [],
    'e1f1',
    [
      'M192 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z',
      'M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z',
    ],
  ],
};
const faHandLizard = {
  prefix: 'fad',
  iconName: 'hand-lizard',
  icon: [
    512,
    512,
    [],
    'f258',
    [
      'M0 112C0 85.5 21.5 64 48 64l112 0 80 0 46.5 0c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8l0 12 0 16 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-13.8L273.9 352 240 352l-80 0-48 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l48 0 80 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-80 0L48 160c-26.5 0-48-21.5-48-48z',
      '',
    ],
  ],
};
const faTablePivot = {
  prefix: 'fad',
  iconName: 'table-pivot',
  icon: [
    512,
    512,
    [],
    'e291',
    [
      'M0 192l128 0 0 224 320 0 0-256-288 0 0-128 288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192z',
      'M64 32l64 0 0 128L0 160 0 96C0 60.7 28.7 32 64 32zM414.8 246.1c-2.5 6-8.3 9.9-14.8 9.9l-16 0 0 48c0 26.5-21.5 48-48 48l-48 0 0 16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 16 48 0c8.8 0 16-7.2 16-16l0-48-16 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z',
    ],
  ],
};
const faFilterSlash = {
  prefix: 'fad',
  iconName: 'filter-slash',
  icon: [
    640,
    512,
    [],
    'e17d',
    [
      'M81.7 38.8L406.6 293.4 567 97.3c9.8-12 11.8-28.5 5.2-42.5S551.5 32 536 32L104 32c-8.1 0-15.8 2.4-22.3 6.8zM202.5 255.5L256 320.9l0 79.1c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6l0-49.5-181.5-143z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTrashCanUndo = {
  prefix: 'fad',
  iconName: 'trash-can-undo',
  icon: [
    448,
    512,
    ['trash-can-arrow-turn-left', 'trash-undo-alt'],
    'f896',
    [
      'M32 96l384 0 0 352c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 96zM96 256c0 6.8 2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L182.5 280l57.5 0c22.1 0 40 17.9 40 40l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-48.6-39.4-88-88-88l-57.5 0 33.5-30.2c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8z',
      'M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zm54.1 167.9c8.9 9.9 8.1 25-1.8 33.9L182.5 232l57.5 0c48.6 0 88 39.4 88 88l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-22.1-17.9-40-40-40l-57.5 0 33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z',
    ],
  ],
};
const faTrashCanArrowTurnLeft = faTrashCanUndo;
const faTrashUndoAlt = faTrashCanUndo;
const faNotdef = {
  prefix: 'fad',
  iconName: 'notdef',
  icon: [
    384,
    512,
    [],
    'e1fe',
    [
      'M64 64l38.5 0L192 198.3 281.5 64 320 64l0 57.7L230.5 256 320 390.3l0 57.7-38.5 0L192 313.7 102.5 448 64 448l0-57.7L153.5 256 64 121.7c0-19.2 0-38.5 0-57.7z',
      'M64 64l0 384 256 0 0-384L64 64zM0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z',
    ],
  ],
};
const faDisease = {
  prefix: 'fad',
  iconName: 'disease',
  icon: [
    512,
    512,
    [],
    'f7fa',
    [
      'M.1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6l10 0c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1zM192 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64.2 92.7c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.3l0-.4 0-.4c0-.3 0-.8 0-1.3c0-.5 .1-1.1 .1-1.6zm32.2-111.9c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.4-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1-.1-1.8c0-.4 0-.9 .1-1.5c.1-.5 .1-1.1 .2-1.6z',
      'M304 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faPersonToDoor = {
  prefix: 'fad',
  iconName: 'person-to-door',
  icon: [
    576,
    512,
    [58704],
    'e433',
    [
      'M384 48l0 176c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 176c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L432 0c-26.5 0-48 21.5-48 48z',
      'M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352L32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z',
    ],
  ],
};
const faTurntable = {
  prefix: 'fad',
  iconName: 'turntable',
  icon: [
    576,
    512,
    [],
    'f8e4',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM384 256A160 160 0 1 1 64 256a160 160 0 1 1 320 0zm35.4 105.7c5.3-10.7 10.7-21.3 16-32c5.3-10.6 15.7-17 26.7-17.6c5.4-10.8 10.8-21.6 16.2-32.5c1.1-2.2 1.7-4.7 1.7-7.2L480 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160.4c0 7.5-1.7 14.8-5.1 21.5l-16.2 32.4c6.1 9.2 7.2 21.4 1.9 31.9l-16 32c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9z',
      'M64 256a160 160 0 1 1 320 0A160 160 0 1 1 64 256zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM496 96c8.8 0 16 7.2 16 16l0 160.4c0 7.5-1.7 14.8-5.1 21.5l-16.2 32.4c6.1 9.2 7.2 21.4 1.9 31.9l-16 32c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32c5.3-10.6 15.7-17 26.7-17.6l16.2-32.5c1.1-2.2 1.7-4.7 1.7-7.2L480 112c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faBriefcaseMedical = {
  prefix: 'fad',
  iconName: 'briefcase-medical',
  icon: [
    512,
    512,
    [],
    'f469',
    [
      'M128 56l0 40 48 0 0-40c0-4.4 3.6-8 8-8l144 0c4.4 0 8 3.6 8 8l0 40 48 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56z',
      'M64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 96zM224 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z',
    ],
  ],
};
const faGenderless = {
  prefix: 'fad',
  iconName: 'genderless',
  icon: [
    384,
    512,
    [],
    'f22d',
    [
      'M112 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z',
    ],
  ],
};
const faChevronRight = {
  prefix: 'fad',
  iconName: 'chevron-right',
  icon: [
    320,
    512,
    [9002],
    'f054',
    [
      'M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z',
      '',
    ],
  ],
};
const faSignalWeak = {
  prefix: 'fad',
  iconName: 'signal-weak',
  icon: [
    640,
    512,
    ['signal-1'],
    'f68c',
    [
      'M160 320l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-17.7-14.3-32-32-32s-32 14.3-32 32zM544 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M64 384c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faSignal1 = faSignalWeak;
const faClockFive = {
  prefix: 'fad',
  iconName: 'clock-five',
  icon: [
    512,
    512,
    [],
    'e349',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128.7 60 90c2.7 4.1 4 8.7 4 13.3c0 7.8-3.8 15.4-10.7 20c-4.1 2.7-8.7 4-13.3 4c-7.8 0-15.4-3.8-20-10.7l-64-96c-2.6-3.9-4-8.6-4-13.3l0-136z',
      'M256 96c13.3 0 24 10.7 24 24l0 128.7 60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3l0-136c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faRetweet = {
  prefix: 'fad',
  iconName: 'retweet',
  icon: [
    576,
    512,
    [],
    'f079',
    [
      'M272 128c0-17.7 14.3-32 32-32l112 0c53 0 96 43 96 96l0 128 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-128c0-17.7-14.3-32-32-32l-112 0c-17.7 0-32-14.3-32-32z',
      'M304 384c0 17.7-14.3 32-32 32l-112 0c-53 0-96-43-96-96l0-128-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 128c0 17.7 14.3 32 32 32l112 0c17.7 0 32 14.3 32 32z',
    ],
  ],
};
const faCarRear = {
  prefix: 'fad',
  iconName: 'car-rear',
  icon: [
    512,
    512,
    ['car-alt'],
    'f5de',
    [
      'M32 391.4L32 448c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48-64 0c-.7 0-1.5 0-2.2 0s-1.4-.1-2.2-.1c-1.4-.1-2.9-.2-4.3-.4c-2.8-.4-5.6-.9-8.2-1.7c-5.4-1.5-10.5-3.6-15.2-6.3zM109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4c-8.7 24.9-17.4 49.7-26.1 74.6zM384 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-56.6c-9.4 5.4-20.3 8.6-32 8.6l-64 0z',
      'M165.4 96l181.2 0c13.6 0 25.7 8.6 30.2 21.4L402.9 192l-293.8 0 26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32L165.4 32c-40.8 0-77.1 25.8-90.6 64.3zM208 272l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm360-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faCarAlt = faCarRear;
const faPumpSoap = {
  prefix: 'fad',
  iconName: 'pump-soap',
  icon: [
    448,
    512,
    [],
    'e06b',
    [
      'M35 442.7C31.9 480 61.3 512 98.8 512l186.4 0c35.6 0 64-29 64-63.9c0-1.8-.1-3.6-.2-5.4l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7L256 160l-128 0-10.6 0c-33.3 0-61 25.5-63.8 58.7L35 442.7zM128 360c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56z',
      'M128 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l60.1 0c21.2 0 41.6 8.4 56.6 23.4l33.9 33.9c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-33.9-33.9c-3-3-7.1-4.7-11.3-4.7L256 96l0 64-128 0 0-128zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z',
    ],
  ],
};
const faComputerClassic = {
  prefix: 'fad',
  iconName: 'computer-classic',
  icon: [
    448,
    512,
    [],
    'f8b1',
    [
      'M0 48C0 21.5 21.5 0 48 0L400 0c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48L48 416c-26.5 0-48-21.5-48-48L0 48zM32 448l384 0 0 32c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-32zM56 336a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM64 96l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zM224 336c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z',
      'M64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96z',
    ],
  ],
};
const faFrame = {
  prefix: 'fad',
  iconName: 'frame',
  icon: [
    448,
    512,
    [],
    'e495',
    [
      'M64 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 0 64 0 192-64 0 0-192 0-64 0-32zm0 352l64 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zM320 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32-64 0 0-32zm0 96l64 0 0 192 0 64 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32 0-64 0-192z',
      'M416 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0 0-64 288 0zM32 96l32 0 0 64-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0 0 64L32 416zm384 0l-32 0 0-64 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z',
    ],
  ],
};
const faVideoSlash = {
  prefix: 'fad',
  iconName: 'video-slash',
  icon: [
    640,
    512,
    [],
    'f4e2',
    [
      'M32 128l0 256c0 35.3 28.7 64 64 64l256 0c23.4 0 43.9-12.6 55-31.3L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5zm81.9-64L416 300.8 416 128c0-35.3-28.7-64-64-64L113.9 64zM448 174.9l0 17.1 0 128 0 5.8 96.4 75.6 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBatteryQuarter = {
  prefix: 'fad',
  iconName: 'battery-quarter',
  icon: [
    576,
    512,
    ['battery-2'],
    'f243',
    [
      'M0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176zm64 0l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160c-8.8 0-16 7.2-16 16z',
      'M96 192h96v128H96V192z',
    ],
  ],
};
const faBattery2 = faBatteryQuarter;
const faEllipsisStroke = {
  prefix: 'fad',
  iconName: 'ellipsis-stroke',
  icon: [
    512,
    512,
    ['ellipsis-h-alt'],
    'f39b',
    [
      'M184 256a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M392 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96 0a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zM72 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96 0A72 72 0 1 1 24 256a72 72 0 1 1 144 0z',
    ],
  ],
};
const faEllipsisHAlt = faEllipsisStroke;
const faRadio = {
  prefix: 'fad',
  iconName: 'radio',
  icon: [
    512,
    512,
    [128251],
    'f8d7',
    [
      'M0 192c0-21.4 10.5-40.3 26.7-52c10.5-7.6 23.4-12 37.3-12c51.5 0 103 0 154.5 0c76.5 0 153 0 229.5 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zM64 320c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 304c-8.8 0-16 7.2-16 16zm16-64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
      'M511 17.3c3.7 12.7-3.6 26.1-16.3 29.8L218.5 128 64 128c-13.9 0-26.9 4.5-37.4 12c7.3-5.9 15.7-10.4 25.1-13.2L481.3 1C494-2.8 507.3 4.5 511 17.3zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faBabyCarriage = {
  prefix: 'fad',
  iconName: 'baby-carriage',
  icon: [
    512,
    512,
    ['carriage-baby'],
    'f77d',
    [
      'M.1 192L256 192 138.9 22.9C133 14.4 123.6 9.5 114.1 9.5c-5.2 0-10.4 1.5-15.1 4.6C41.3 52.9 2.7 117.9 .1 192zM32 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm288 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M448 96c-35.3 0-64 28.7-64 64l0 64-160 0L0 224c0 25.2 5.8 50.2 17.1 73.5s27.8 44.5 48.6 62.3s45.5 32 72.7 41.6S194.6 416 224 416s58.5-5 85.7-14.6s51.9-23.8 72.7-41.6s37.3-39 48.6-62.3s17-48.3 17-73.5l0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z',
    ],
  ],
};
const faCarriageBaby = faBabyCarriage;
const faFaceExpressionless = {
  prefix: 'fad',
  iconName: 'face-expressionless',
  icon: [
    512,
    512,
    [],
    'e373',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm16 144c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zM288 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z',
      'M144 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z',
    ],
  ],
};
const faDownToDottedLine = {
  prefix: 'fad',
  iconName: 'down-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e408',
    [
      'M0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M251.3 372.7L374.1 249.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 192l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 192 64 207.2 64 225.9c0 9 3.6 17.6 9.9 24L196.7 372.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3z',
    ],
  ],
};
const faCloudMusic = {
  prefix: 'fad',
  iconName: 'cloud-music',
  icon: [
    640,
    512,
    [],
    'f8ae',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm192 32c0-22.1 21.5-40 48-40c5.6 0 11 .8 16 2.3l0-87.2c0-13.3 8.3-25.3 20.8-30l96-36c20.9-7.8 43.2 7.6 43.2 30L416 336c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c5.6 0 11 .8 16 2.3l0-59.2-96 36 0 92.9c0 22.1-21.5 40-48 40s-48-17.9-48-40z',
      'M372.8 177.1c20.9-7.8 43.2 7.6 43.2 30L416 336s0 0 0 0c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c5.6 0 11 .8 16 2.3l0-59.2-96 36 0 92.9s0 0 0 0c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c5.6 0 11 .8 16 2.3l0-87.2c0-13.3 8.3-25.3 20.8-30l96-36z',
    ],
  ],
};
const faTrafficLight = {
  prefix: 'fad',
  iconName: 'traffic-light',
  icon: [
    320,
    512,
    [128678],
    'f637',
    [
      'M112 112a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z',
    ],
  ],
};
const faCloudMinus = {
  prefix: 'fad',
  iconName: 'cloud-minus',
  icon: [
    640,
    512,
    [],
    'e35d',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm224-48c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M224 288c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faThermometer = {
  prefix: 'fad',
  iconName: 'thermometer',
  icon: [
    512,
    512,
    [],
    'f491',
    [
      'M0 488c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l89-89 88.8 0c14.9 0 29.1-5.9 39.6-16.4L481.8 176.2c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2c-15.2 15.2-30.3 30.3-45.5 45.5c19 19 38 38 57 57c1.6 1.6 2.7 3.4 3.5 5.3c.4 1 .7 2 .9 3c.1 .5 .2 1 .2 1.5c0 .3 0 .5 .1 1.5c0 1-.1 1.3-.1 1.6c0 .5-.1 1-.2 1.5c-.2 1-.5 2-.9 3c-.8 1.9-1.9 3.7-3.5 5.3c-6.3 6.2-16.4 6.2-22.6 0c-19-19-38-38-57-57c-13.8 13.8-27.6 27.6-41.4 41.4c19 19 38 38 57 57c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-19-19-38-38-57-57c-13.8 13.8-27.6 27.6-41.4 41.4c19 19 38 38 57 57c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-19-19-38-38-57-57l-27.3 27.3C101.9 264.2 96 278.4 96 293.3l0 88.8L7 471c-4.7 4.7-7 10.8-7 17z',
      'M139.7 226.3l57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57-22.6 22.6zm64-64l57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57-22.6 22.6zm64-64l57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57L267.7 98.3z',
    ],
  ],
};
const faShieldMinus = {
  prefix: 'fad',
  iconName: 'shield-minus',
  icon: [
    512,
    512,
    [],
    'e249',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM160 256c0-13.3 10.7-24 24-24l144 0c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.5 .1 2l0 .4 0 .4c0 .5 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7l-144 0c-13.3 0-24-10.7-24-24z',
      'M160 256c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faVrCardboard = {
  prefix: 'fad',
  iconName: 'vr-cardboard',
  icon: [
    640,
    512,
    [],
    'f729',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l120.4 0c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4L576 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zM224 240A64 64 0 1 1 96 240a64 64 0 1 1 128 0zm320 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M160 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm320 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faCarTilt = {
  prefix: 'fad',
  iconName: 'car-tilt',
  icon: [
    640,
    512,
    [],
    'f5e5',
    [
      'M0 496c0-26.5 21.5-48 48-48l15.3 0 99.4 0L592 448c26.5 0 48 21.5 48 48l0 16L0 512l0-16z',
      'M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l6 22.2 99.4 0c-.1-.2-.1-.5-.2-.7L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6z',
    ],
  ],
};
const faGaugeCircleMinus = {
  prefix: 'fad',
  iconName: 'gauge-circle-minus',
  icon: [
    640,
    512,
    [],
    'e497',
    [
      'M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z',
    ],
  ],
};
const faBrightnessLow = {
  prefix: 'fad',
  iconName: 'brightness-low',
  icon: [
    512,
    512,
    [],
    'e0ca',
    [
      'M112 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 352a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z',
    ],
  ],
};
const faHandMiddleFinger = {
  prefix: 'fad',
  iconName: 'hand-middle-finger',
  icon: [
    448,
    512,
    [128405],
    'f806',
    [
      'M232 0c-22.1 0-40 17.9-40 40l0 164.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48l0 7 0 73c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.7c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334L32 372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L304 512c70.7 0 128-57.3 128-128l0-64 0-32c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2L272 40c0-22.1-17.9-40-40-40z',
      '',
    ],
  ],
};
const faPercent = {
  prefix: 'fad',
  iconName: 'percent',
  icon: [
    384,
    512,
    [62101, 62785, 'percentage'],
    '25',
    [
      'M0 416c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l320-320c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-12.5-12.5-32.8-12.5-45.3 0l-320 320C3.1 399.6 0 407.8 0 416z',
      'M64 192A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faPercentage = faPercent;
const faTruckMoving = {
  prefix: 'fad',
  iconName: 'truck-moving',
  icon: [
    640,
    512,
    [],
    'f4df',
    [
      'M32 416a64 64 0 1 0 128 0A64 64 0 1 0 32 416zm160 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm288 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M64 32C28.7 32 0 60.7 0 96L0 384l5.5 0c13.2-37.3 48.7-64 90.5-64c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64l69.5 0 37.5 0c13.2-37.3 48.7-64 90.5-64c38.2 0 71.2 22.3 86.6 54.6c5.8-5.8 9.4-13.8 9.4-22.6l0-64 0-16 0-10.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5L480 144l0-48c0-35.3-28.7-64-64-64L64 32zM585 256l-105 0 0-64 48.8 0c2.4 0 4.7 1.1 6.2 2.9L585 256z',
    ],
  ],
};
const faGlassWaterDroplet = {
  prefix: 'fad',
  iconName: 'glass-water-droplet',
  icon: [
    384,
    512,
    [],
    'e4f5',
    [
      'M0 32c0 .8 0 1.5 .1 2.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.1-.8 .1-1.5 .1-2.3c0-8.1-3-15.9-8.6-21.8C369.4 3.7 360.9 0 352 0L32 0C23.1 0 14.6 3.7 8.6 10.2C3 16.1 0 23.9 0 32zM66.4 64l251.3 0c-5.6 77.8-11.1 155.7-16.7 233.5c-3.2 45.2-6.5 90.4-9.7 135.6c-.6 8.4-7.6 14.9-16 14.9l-166.6 0c-8.4 0-15.4-6.5-16-14.9c-3.2-45.2-6.5-90.4-9.7-135.6C77.5 219.7 71.9 141.9 66.4 64z',
      'M301 297.5L288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5 9.7 135.6c.6 8.4 7.6 14.9 16 14.9l166.6 0c8.4 0 15.4-6.5 16-14.9L301 297.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z',
    ],
  ],
};
const faConveyorBelt = {
  prefix: 'fad',
  iconName: 'conveyor-belt',
  icon: [
    640,
    512,
    [],
    'f46e',
    [
      'M0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 0l16 0 96 0 16 0 0 16 0 96c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 99.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-96 0-16zm32 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm192 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M256 0L176 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L384 0l0 112c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 99.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1L256 0z',
    ],
  ],
};
const faLocationCheck = {
  prefix: 'fad',
  iconName: 'location-check',
  icon: [
    384,
    512,
    ['map-marker-check'],
    'f606',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm88 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0c12.1 12.1 24.2 24.2 36.4 36.4c29.9-29.9 59.8-59.8 89.7-89.7c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17c-35.6 35.6-71.1 71.1-106.7 106.7c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7L95 209c-4.7-4.7-7-10.8-7-17z',
      'M289 121.7c9.4 9.4 9.4 24.6 0 33.9L182.3 262.3c-9.4 9.4-24.6 9.4-33.9 0L95 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4L255 121.7c9.4-9.4 24.6-9.4 33.9 0z',
    ],
  ],
};
const faMapMarkerCheck = faLocationCheck;
const faCoinVertical = {
  prefix: 'fad',
  iconName: 'coin-vertical',
  icon: [
    384,
    512,
    [],
    'e3fd',
    [
      'M0 256C0 397.4 64.5 512 144 512s144-114.6 144-256S223.5 0 144 0S0 114.6 0 256zm40 0c0-47.2 7.6-91.4 21-125c6.7-16.7 15.4-32.4 26.8-44.4C99.3 74.5 115.5 64 136 64s36.7 10.5 48.2 22.6c11.4 12 20.1 27.7 26.8 44.4c13.4 33.6 21 77.8 21 125s-7.6 91.4-21 125c-6.7 16.7-15.4 32.4-26.8 44.4C172.7 437.5 156.5 448 136 448s-36.7-10.5-48.2-22.6C76.5 413.4 67.7 397.7 61 381c-13.4-33.6-21-77.8-21-125zm32 0c0 88.4 28.7 160 64 160s64-71.6 64-160s-28.7-160-64-160s-64 71.6-64 160z',
      'M330.6 48C309.6 17.8 283.8 0 256 0L226.1 0c15.6 13.2 29.3 29.7 40.9 48l63.7 0zM313.3 176l64.3 0c-6-36.2-15.9-68.9-28.7-96l-64.7 0c13.2 28.4 23 60.9 29 96zm68.4 128c1.5-15.5 2.2-31.6 2.2-48s-.8-32.5-2.2-48l-64.1 0c1.6 15.7 2.4 31.7 2.4 48s-.8 32.3-2.4 48l64.1 0zM284.3 432l64.7 0c12.8-27.1 22.7-59.8 28.7-96l-64.3 0c-6 35.1-15.9 67.6-29 96zM267 464c-11.5 18.3-25.2 34.8-40.9 48l29.9 0c27.9 0 53.6-17.8 74.6-48L267 464zM136 448c20.5 0 36.7-10.5 48.2-22.6c11.4-12 20.1-27.7 26.8-44.4c13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64s-36.7 10.5-48.2 22.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448zm64-192c0 88.4-28.7 160-64 160s-64-71.6-64-160s28.7-160 64-160s64 71.6 64 160z',
    ],
  ],
};
const faDisplay = {
  prefix: 'fad',
  iconName: 'display',
  icon: [
    576,
    512,
    [],
    'e163',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0 96 0 176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 0l448 0 0 288L64 352 64 64z',
      'M512 64L64 64l0 288 448 0 0-288zM416 448l-69.3 0L336 416l-96 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32z',
    ],
  ],
};
const faPersonSign = {
  prefix: 'fad',
  iconName: 'person-sign',
  icon: [
    512,
    512,
    [],
    'f757',
    [
      'M258.1 134.5c0 9.8 6.1 19 15.8 22.6l59.7 21.7c-5.1 14.1-10.3 28.2-15.4 42.3c-7.3 20.1-14.6 40.1-21.9 60.1c-2.4 6.7-4.9 13.4-7.3 20.2c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7c4.5-12.5-1.9-26.2-14.3-30.8c-2.7-1-5.5-1.5-8.2-1.5c-9.8 0-19 6.1-22.6 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-1 2.7-1.5 5.5-1.5 8.2z',
      'M318.3 221.2l-28.8-10.8c-9.7-3.7-18.4-9.6-25.4-17.4L235 160.2c-18.2-20.5-44.3-32.2-71.8-32.2l-27.7 0c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L80 263.5 80 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 20.2 0L192 407.5l0 72.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-72.4c0-9.9-2.3-19.7-6.8-28.6L216 312.4l0-77.3 .3 .3C230.1 251 247.5 263 267 270.3l29.3 11 21.9-60.1zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faFaceSmile = {
  prefix: 'fad',
  iconName: 'face-smile',
  icon: [
    512,
    512,
    [128578, 'smile'],
    'f118',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm139.9 90.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faSmile = faFaceSmile;
const faPhoneHangup = {
  prefix: 'fad',
  iconName: 'phone-hangup',
  icon: [
    640,
    512,
    [],
    'e225',
    [
      'M20.2 285.5c75.5-34 139.6-51.8 203.8-59.8l0 32.3c-59.6 7.9-119.7 24.8-190.8 56.8c-4.3-9.7-8.7-19.5-13-29.2zM416 225.6c32.1 4 64.1 10.5 97.6 20.2c16.7 4.8 33.8 10.5 51.5 17.1c8.8 3.3 17.7 6.8 26.7 10.5s18.3 7.7 27.6 11.9c.1 0 .2 .1 .3 .1c-4.3 9.7-8.7 19.5-13 29.2c-71.2-32.1-131.2-49-190.8-56.8l0-17.9 0-14.4z',
      'M20.2 285.5l-8.5-19.2c-7.2-16.2-5.1-35.1 7.4-47.7C69.2 168.1 175.8 96 320 96s250.8 72.1 300.9 122.6c12.5 12.6 14.6 31.5 7.4 47.7l-8.5 19.2C507.2 234.7 420 220.1 320 220.1s-187.2 14.7-299.8 65.4zm13 29.2c71.2-32.1 131.2-49 190.8-56.8l0 67.9c0 15.3-10.8 28.4-25.7 31.4L89.1 379c-14.7 2.9-29.4-4.7-35.5-18.4L33.2 314.7zM416 257.9c59.6 7.9 119.7 24.8 190.8 56.8l-20.4 45.9c-6.1 13.7-20.8 21.3-35.5 18.4L441.7 357.1c-15-3-25.7-16.1-25.7-31.4l0-67.9z',
    ],
  ],
};
const faSignatureSlash = {
  prefix: 'fad',
  iconName: 'signature-slash',
  icon: [
    640,
    512,
    [],
    'e3cb',
    [
      'M0 392c0 13.3 10.7 24 24 24l40.3 0c-.2-2.8-.3-5.6-.3-8.5L64 368l-40 0c-13.3 0-24 10.7-24 24zm96-56.4l0 71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c17.5-30.5 31.9-62.7 43.1-95.9L181.1 238.7l-16.7 5c-40.6 12.2-68.4 49.6-68.4 92zM138.9 83.6c17.7 13.9 35.5 27.8 53.2 41.7C193.5 108.9 207.2 96 224 96c17.7 0 32 14.3 32 32l0 7.8c0 12.8-.5 25.6-1.5 38.3c33.6 26.4 67.3 52.7 100.9 79.1l42.8-12.8-12.3 36.8L440.6 320 544 320c17.7 0 32-14.3 32-32s-14.3-32-32-32l-83.6 0 18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6zM160 335.6c0-14.1 9.3-26.6 22.8-30.7l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5l0-71.9zM283.5 416l122.6 0-60.9-48-39.4 0c-6.7 16.3-14.2 32.3-22.3 48zm218.3-48c20.4 16 40.8 32 61.2 48l53 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-114.2 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faThumbtack = {
  prefix: 'fad',
  iconName: 'thumbtack',
  icon: [
    384,
    512,
    [128204, 128392, 'thumb-tack'],
    'f08d',
    [
      'M0 320c0 6.6 2.1 13.2 6 18.7c6 8.3 15.7 13.3 26 13.3l128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 128 0c10.3 0 19.9-4.9 26-13.3c4-5.5 6-12.1 6-18.7c0-3.4-.5-6.8-1.6-10.1l-1-3c-13.8-41.5-42.8-74.8-79.5-94.7L290.5 64 320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 0C46.3 0 32 14.3 32 32s14.3 32 32 32l29.5 0L82.1 212.2c-36.7 19.9-65.7 53.2-79.5 94.7l-1 3C.5 313.2 0 316.6 0 320z',
      'M192 224c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faThumbTack = faThumbtack;
const faWheatSlash = {
  prefix: 'fad',
  iconName: 'wheat-slash',
  icon: [
    640,
    512,
    [],
    'e339',
    [
      'M64 480c0-8.2 3.1-16.4 9.4-22.6l68.9-68.9L131.9 378c-37.5-37.5-37.5-98.3 0-135.8L143.2 231c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c21 21 33.2 47.5 36.5 74.8l29.5-29.5 50.6 39.9-36.3 36.3c28.5 2.8 56.2 15.1 78.1 36.9L346.8 412c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-68.9 68.9c-6.2 6.2-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4S64 488.2 64 480zM224.7 150.8c2.7-3.6 5.7-7.1 9-10.4L245 129.1c6.2-6.2 16.4-6.2 22.6 0L279 140.5c21 21 33.2 47.5 36.5 74.8l30.5-30.5-10.4-10.4c-37.5-37.5-37.5-98.3 0-135.8l11.3-11.3c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-28.7 28.7c-45.9-36-91.8-72-137.8-108zM448 88c0-48.6 39.4-88 88-88l24 0c8.8 0 16 7.2 16 16l0 24c0 48.6-39.4 88-88 88l-24 0c-8.8 0-16-7.2-16-16l0-24z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTrophy = {
  prefix: 'fad',
  iconName: 'trophy',
  icon: [
    576,
    512,
    [127942],
    'f091',
    [
      'M0 88C0 222.5 70.4 295.7 140.5 334.1c34.5 18.9 68.8 29.3 94.3 35c5.5 1.2 10.6 2.3 15.3 3.1c-3.7-7-8.8-13.4-15-18.9c-1.5-1.3-3-2.7-4.5-4.1c-1.7-1.6-3.3-3.1-4.9-4.8c-3.2-3.3-6.5-6.8-9.8-10.7c-6.6-7.7-13.2-16.4-20.1-26.7c-10.5-4.2-21.4-9.2-32.3-15.1C109.8 262.6 56.4 209.9 48.9 112l85.3 0c-1.8-15.1-3.3-31.1-4.3-48L24 64C10.7 64 0 74.7 0 88zM325.9 372.1c4.7-.8 9.8-1.9 15.3-3.1c25.5-5.7 59.8-16.1 94.3-35C505.6 295.7 576 222.5 576 88c0-13.3-10.7-24-24-24L446.1 64c-1 16.9-2.5 32.9-4.3 48l85.3 0c-7.5 97.9-60.9 150.6-114.6 179.9c-11 6-22 11-32.6 15.2c-13.1 20.2-26.6 35.2-39.1 46.3c-6 5.4-11.2 11.7-14.8 18.7z',
      'M256 395.5c0-16.3-8.6-31.2-20.8-42C192.2 315.3 137.3 231 129.1 48c-1.2-26.5 20.4-48 47-48L400 0c26.5 0 48.1 21.6 47 48c-8.2 183-63.2 267.2-106.2 305.4c-12.2 10.8-20.8 25.7-20.8 42l0 4.5c0 26.5 21.5 48 48 48l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0c26.5 0 48-21.5 48-48l0-4.5z',
    ],
  ],
};
const faCloudsSun = {
  prefix: 'fad',
  iconName: 'clouds-sun',
  icon: [
    640,
    512,
    [],
    'f746',
    [
      'M1.2 121.8c-2.1 5.1-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c6.5-41.8 33.2-76.8 69.8-94.9c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96c36.8 0 68.8 20.7 84.9 51.1c8.7-27.3 29.3-49.3 55.7-59.9l-30.7-5.1L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6zM144 208a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M495.9 224c-12.9 0-25.3 2.2-36.8 6.2C435.9 206.6 403.7 192 368 192c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9c-18.9-35.1-56-59-98.7-59zm144 207.9c0 44.2-35.8 80-80 80l-271.9 0c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z',
    ],
  ],
};
const faPersonPraying = {
  prefix: 'fad',
  iconName: 'person-praying',
  icon: [
    448,
    512,
    [128720, 'pray'],
    'f683',
    [
      'M224 64a64 64 0 1 0 128 0A64 64 0 1 0 224 64z',
      'M187.7 354l116.1 85.8c13.9 10.3 19.6 28.3 14.2 44.7s-20.7 27.5-38 27.5L72 512c-22.1 0-40-17.9-40-40s17.9-40 40-40l86.6 0-53.2-39.3c-34.9-25.8-45.8-73.3-25.6-111.8l48.7-92.5C142.9 161.1 171.2 144 202 144c26.6 0 51.6 12.7 67.2 34.2l26.2 36L350.7 169c17.1-14 42.3-11.5 56.3 5.6s11.5 42.3-5.6 56.3l-88 72c-8.5 7-19.5 10.1-30.4 8.7s-20.8-7.2-27.2-16.1L232.7 264l-45 90z',
    ],
  ],
};
const faPray = faPersonPraying;
const faHammer = {
  prefix: 'fad',
  iconName: 'hammer',
  icon: [
    576,
    512,
    [128296],
    'f6e3',
    [
      'M0 435.7C0 477.8 34.1 512 76.3 512c22.6 0 44.1-10.1 58.6-27.4L350.7 225.6c-6.1-3.7-11.9-8.2-17.2-13.5c-12.7-12.7-25.4-25.4-38.1-38.1c-.9-.9-1.8-1.9-2.7-2.8s-1.7-1.9-2.5-2.9c-1.6-2-3.2-4-4.6-6.2L27.4 377.1C10.1 391.6 0 413.1 0 435.7z',
      'M333.5 212.1c21.8 21.8 51.9 30.2 80 25.4L431 255l-8 8c-9.4 9.4-9.4 24.6 0 33.9l24 24c9.4 9.4 24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9l-24-24c-9.4-9.4-24.6-9.4-33.9 0l-8 8-15.9-15.9c6.6-30.3-2.4-63.2-26.6-86l-44.6-42C389.2 14 353.9 0 317.2 0L299.2 0C279 0 259.1 4.2 240.7 12.4l-47.2 21c-5.6 2.5-9.2 7.9-9.5 14s3 11.8 8.3 14.7L272 105.5l0 12.1c0 21.1 8.4 41.4 23.3 56.3l38.1 38.1z',
    ],
  ],
};
const faFaceVomit = {
  prefix: 'fad',
  iconName: 'face-vomit',
  icon: [
    576,
    512,
    [],
    'e3a0',
    [
      'M32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.9-4 21.5-12.3 27.2-22.9c-16.7-12.6-26.4-27.7-26.4-44c0-44.2 71.6-80 160-80s160 35.8 160 80c0 16.3-9.7 31.4-26.4 44c5.7 10.6 15.2 19 27.2 22.9l16.7 5.6C513.9 393.9 544 328.5 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256zM148 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm172.6 37.4l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8z',
      'M192 396.1l0-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7l0 57.4c0 31 19.8 58.5 49.2 68.3l34.1 11.4c7.6 2.5 12.7 9.6 12.7 17.6c0 10.3-8.3 18.6-18.6 18.6l-346.8 0c-10.3 0-18.6-8.3-18.6-18.6c0-8 5.1-15.1 12.7-17.6l34.1-11.4c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm256 16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480z',
    ],
  ],
};
const faSpeakers = {
  prefix: 'fad',
  iconName: 'speakers',
  icon: [
    640,
    512,
    [],
    'f8e0',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l216.4 0c-15.2-17-24.4-39.4-24.4-64l0-33.6c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6L256 64c0-24.6 9.2-47 24.4-64L64 0C28.7 0 0 28.7 0 64zm224 48a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm64-48l0 384c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L352 0c-35.3 0-64 28.7-64 64zM576 336a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zM512 112a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M176 224c31.3 0 59.7 12.9 80 33.6l0 156.8c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112zm0-160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm64 272a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM352 336a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faTtyAnswer = {
  prefix: 'fad',
  iconName: 'tty-answer',
  icon: [
    640,
    512,
    ['teletype-answer'],
    'e2b9',
    [
      'M0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c1-3.5 1.4-7 1.4-10.5c0-15.8-9.4-30.6-24.6-36.9l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96C158.6 9.4 143.8 0 128 0c-3.5 0-7 .5-10.5 1.4l-88 24C12.1 30.2 0 46 0 64z',
      'M304 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L304 0zm0 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm32-80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L400 0zm32 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L496 0zm32 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM592 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L592 0zM576 208l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM400 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-128 0z',
    ],
  ],
};
const faTeletypeAnswer = faTtyAnswer;
const faMugTeaSaucer = {
  prefix: 'fad',
  iconName: 'mug-tea-saucer',
  icon: [
    640,
    512,
    [],
    'e1f5',
    [
      'M0 448c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM160 157.3l0 66.7c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-66.7c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6L240 32l-32 0 0 50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6z',
      'M208 32l0 50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6l0 66.7c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-66.7c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6L240 32l208 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L96 64c0-17.7 14.3-32 32-32l80 0zM480 224l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128z',
    ],
  ],
};
const faDiagramLeanCanvas = {
  prefix: 'fad',
  iconName: 'diagram-lean-canvas',
  icon: [
    640,
    512,
    [],
    'e156',
    [
      'M64 96l0 208 64 0 0-208L64 96zm448 0l0 208 64 0 0-208-64 0z',
      'M512 96l0 208 64 0 0-208-64 0zm-48 0l-64 0 0 80 64 0 0-80zM352 96l-64 0 0 208 64 0 0-208zM240 96l-64 0 0 80 64 0 0-80zM128 96L64 96l0 208 64 0 0-208zM64 352l0 64 232 0 0-64L64 352zm280 64l232 0 0-64-232 0 0 64zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM240 304l0-80-64 0 0 80 64 0zm224-80l-64 0 0 80 64 0 0-80z',
    ],
  ],
};
const faAlt = {
  prefix: 'fad',
  iconName: 'alt',
  icon: [
    640,
    512,
    [],
    'e08a',
    [
      'M416 416c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32z',
      'M423 76c6.1-7.6 15.3-12 25-12l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144.6 0L217 436c-6.1 7.6-15.3 12-25 12L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l144.6 0L423 76z',
    ],
  ],
};
const faDial = {
  prefix: 'fad',
  iconName: 'dial',
  icon: [
    576,
    512,
    ['dial-med-high'],
    'e15b',
    [
      'M0 288a32 32 0 1 0 64 0A32 32 0 1 0 0 288zM64 96a32 32 0 1 0 64 0A32 32 0 1 0 64 96zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M383.2 158.5c-62.6-46.2-151.3-41-208 15.7c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c56.7-56.7 61.9-145.4 15.7-208L305.2 304.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L383.2 158.5z',
    ],
  ],
};
const faDialMedHigh = faDial;
const faHandPeace = {
  prefix: 'fad',
  iconName: 'hand-peace',
  icon: [
    512,
    512,
    [9996],
    'f25b',
    [
      'M34.7 76.8L106.1 240l69.9 0L93.3 51.2C86.2 35 67.4 27.6 51.2 34.7S27.6 60.6 34.7 76.8zM64 336l0 27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l0-8.6c-9.4 5.4-20.3 8.6-32 8.6c-27.9 0-51.7-17.9-60.4-42.8C345.4 316 333.2 320 320 320c-11.7 0-22.6-3.1-32-8.6l0 .6c0 39.8-32.2 72-72 72l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-26.1 0-69.9 0 .2 .5C88.6 276.3 64 303.3 64 336zM192 32l0 208 64 0 0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M320 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32zm96 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faCircleTrash = {
  prefix: 'fad',
  iconName: 'circle-trash',
  icon: [
    512,
    512,
    ['trash-circle'],
    'e126',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144 144c0-8.8 7.2-16 16-16l41.4 0 11.3-11.3c3-3 7.1-4.7 11.3-4.7l64 0c4.2 0 8.3 1.7 11.3 4.7L310.6 128l41.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3l-101.1 0c-16.6 0-30.5-12.8-31.9-29.3L160 192z',
      'M212.7 116.7L201.4 128 160 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-41.4 0-11.3-11.3c-3-3-7.1-4.7-11.3-4.7l-64 0c-4.2 0-8.3 1.7-11.3 4.7zM160 192l13.6 162.7c1.4 16.6 15.2 29.3 31.9 29.3l101.1 0c16.6 0 30.5-12.8 31.9-29.3L352 192l-192 0z',
    ],
  ],
};
const faTrashCircle = faCircleTrash;
const faRotate = {
  prefix: 'fad',
  iconName: 'rotate',
  icon: [
    512,
    512,
    [128260, 'sync-alt'],
    'f2f1',
    [
      'M16 312l0 7.6c0 .2 0 .5 0 .7L16 440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8L48.4 288c-.2 0-.5 0-.7 0L40 288c-13.3 0-24 10.7-24 24z',
      'M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0c0 0 0 0 0 0l8.4 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5z',
    ],
  ],
};
const faSyncAlt = faRotate;
const faCircleQuarters = {
  prefix: 'fad',
  iconName: 'circle-quarters',
  icon: [
    512,
    512,
    [],
    'e3f8',
    [
      'M120.2 120.2L256 256 391.8 120.2C357 85.5 309 64 256 64s-101 21.5-135.8 56.2zm0 271.5C155 426.5 203 448 256 448s101-21.5 135.8-56.2L256 256 120.2 391.8z',
      'M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
    ],
  ],
};
const faSpinner = {
  prefix: 'fad',
  iconName: 'spinner',
  icon: [
    512,
    512,
    [],
    'f110',
    [
      'M60.9 403.1a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM369.1 75A48 48 0 1 0 437 142.9 48 48 0 1 0 369.1 75zm0 294.2A48 48 0 1 0 437 437a48 48 0 1 0 -67.9-67.9zM416 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256A48 48 0 1 0 0 256a48 48 0 1 0 96 0zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9z',
    ],
  ],
};
const faTowerControl = {
  prefix: 'fad',
  iconName: 'tower-control',
  icon: [
    448,
    512,
    [],
    'e2a2',
    [
      'M2.6 167.9c0 3.6 .5 7.3 1.6 11.1L44.5 320.2C28.5 321.9 16 335.5 16 352c0 17.7 14.3 32 32 32l32 0 288 0 32 0c17.7 0 32-14.3 32-32c0-16.5-12.5-30.1-28.5-31.8L443.9 179c1.1-3.7 1.6-7.4 1.6-11.1c0-21.3-17.3-39.9-40-39.9L320 128l-32 0-40 0-48 0-40 0-32 0-85.4 0c-22.7 0-40 18.6-40 39.9zM74.4 192l53.6 0 0 128-17 0c-.1-.3-.1-.5-.2-.8L74.4 192zM176 192l96 0 0 128-96 0 0-128zm144 0l53.6 0L337.2 319.2c-.1 .3-.1 .5-.2 .8l-17 0 0-128z',
      'M160 24c0-13.3 10.7-24 24-24l40 0 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 48 40 0c17.7 0 32 14.3 32 32l-32 0-40 0-48 0-40 0-32 0c0-17.7 14.3-32 32-32l40 0 0-48-16 0c-13.3 0-24-10.7-24-24zM368 384l0 96c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-96 288 0z',
    ],
  ],
};
const faArrowUpTriangleSquare = {
  prefix: 'fad',
  iconName: 'arrow-up-triangle-square',
  icon: [
    576,
    512,
    ['sort-shapes-up'],
    'f88a',
    [
      'M304 192c0 5.3 1.3 10.7 4 15.5c5.6 10.2 16.4 16.5 28 16.5l160 0c11.6 0 22.3-6.3 28-16.5c2.7-4.8 4-10.2 4-15.5c0-5.9-1.6-11.8-4.9-17l-80-128C437.3 37.7 427 32 416 32s-21.3 5.7-27.1 15l-80 128c-3.2 5.2-4.9 11.1-4.9 17zm16 144l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortShapesUp = faArrowUpTriangleSquare;
const faWhale = {
  prefix: 'fad',
  iconName: 'whale',
  icon: [
    640,
    512,
    [128011],
    'f72c',
    [
      'M0 317.6C0 407.3 72.7 480 162.4 480L544 480c53 0 96-43 96-96l0-111.9C640 192.5 575.5 128 495.9 128c-82.5 0-162.4 29.5-225 83.2L156.4 309.4c-8 6.8-18.1 10.6-28.6 10.6l-1.1 0c-18.3 0-34.5-11.7-40.3-29c-4-12-2.4-25.2 4.3-35.9l37.6-60.1 44.7 7.5c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L43.6 212.4C15.7 240.3 0 278.2 0 317.6zM424 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M376 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faRobot = {
  prefix: 'fad',
  iconName: 'robot',
  icon: [
    640,
    512,
    [129302],
    'f544',
    [
      'M32 272l0 96c0 26.5 21.5 48 48 48l16 0 0-192-16 0c-26.5 0-48 21.5-48 48zM192 400c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM288 32l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 368c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM544 224l0 192 16 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-16 0z',
      'M168 96c-39.8 0-72 32.2-72 72l0 272c0 39.8 32.2 72 72 72l304 0c39.8 0 72-32.2 72-72l0-272c0-39.8-32.2-72-72-72L168 96zm40 288l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM184 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm232-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z',
    ],
  ],
};
const faPeace = {
  prefix: 'fad',
  iconName: 'peace',
  icon: [
    512,
    512,
    [9774],
    'f67c',
    [
      'M89.2 351.1c10.7 18.7 24.4 35.4 40.6 49.5L224 323.5l0 121.8c10.4 1.7 21.1 2.7 32 2.7s21.6-.9 32-2.7l0-121.8 94.3 77.1c16.1-14.1 29.9-30.8 40.6-49.5L288 240.8l0-174.2c-10.4-1.7-21.1-2.7-32-2.7s-21.6 .9-32 2.7l0 174.2L89.2 351.1z',
      'M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z',
    ],
  ],
};
const faPartyHorn = {
  prefix: 'fad',
  iconName: 'party-horn',
  icon: [
    512,
    512,
    [],
    'e31b',
    [
      'M32 32a32 32 0 1 0 64 0A32 32 0 1 0 32 32zm3.9 346.5c32.5 32.5 65.1 65.1 97.6 97.6c11-4.1 21.9-8.2 32.9-12.3C127 424.4 87.6 385 48.2 345.6c-4.1 11-8.2 21.9-12.3 32.9zm34.9-93.1c51.9 51.9 103.9 103.9 155.8 155.8l32.9-12.3L83.1 252.5c-4.1 11-8.2 21.9-12.3 32.9zM167 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l8.3-8.3C233.6 120.3 249 88.3 252.8 54l3-27.4c1.5-13.2-8-25-21.2-26.5c-.9-.1-1.8-.1-2.7-.1c-12.1 0-22.5 9.1-23.8 21.4l-3 27.4c-2.6 23.5-13.1 45.4-29.8 62.1L167 119zm94.6 96.5c8.6 10.1 23.7 11.4 33.8 2.8l10-8.5c5.8-4.9 13.2-7.5 20.7-7.3c42.5 1.1 78.3-31.7 80.8-74.2l1.8-30c1-16.6 15-29.4 31.6-29c19.4 .5 38.2-6.1 53-18.6l10-8.5c10.1-8.6 11.4-23.7 2.8-33.8s-23.7-11.4-33.8-2.8l-10 8.5c-5.8 4.9-13.2 7.5-20.7 7.3c-42.5-1.1-78.3 31.7-80.8 74.2l-1.8 30c-1 16.6-15 29.4-31.6 29c-19.4-.5-38.2 6.1-53 18.6l-10 8.5c-10.1 8.6-11.4 23.7-2.8 33.8zM359 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l8.3-8.3c16.7-16.7 38.6-27.2 62.1-29.8l27.4-3c12.3-1.4 21.4-11.8 21.4-23.8c0-.9 0-1.8-.1-2.7c-1.5-13.2-13.3-22.7-26.5-21.2l-27.4 3c-34.3 3.8-66.3 19.2-90.7 43.6L359 311zm89-151a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M121.2 192.7c10.6-2.3 21.7 1 29.4 8.6l160 160c7.7 7.7 10.9 18.8 8.6 29.4s-9.9 19.4-20 23.2l-39.7 14.9L83.1 252.5 98 212.8c3.8-10.2 12.6-17.7 23.2-20zM70.8 285.4L226.6 441.2l-60.2 22.6L48.2 345.6l22.6-60.2zm62.7 190.7L43.2 510c-11.7 4.4-25 1.5-33.9-7.3S-2.4 480.5 2 468.8l33.8-90.3 97.6 97.6z',
    ],
  ],
};
const faGears = {
  prefix: 'fad',
  iconName: 'gears',
  icon: [
    640,
    512,
    ['cogs'],
    'f085',
    [
      'M296 352c0 6.9 .4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c2.6 1.1 5.3 1.6 8 1.6c6.3 0 12.5-2.9 16.9-7.8l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2c4.4 5 10.6 7.8 16.9 7.8c2.7 0 5.4-.5 8-1.6c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-2.6-1.1-5.3-1.6-8-1.6c-6.3 0-12.5 2.9-16.9 7.8l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-4.4-4.9-10.6-7.8-16.9-7.8c-2.7 0-5.4 .5-8 1.6c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4zm216 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M314.7 110.3c3.7 8.7 .9 18.6-6.2 25l-22.2 19.8c1.1 6.8 1.7 13.8 1.7 20.9s-.6 14.1-1.7 20.9l22.2 19.8c7.1 6.3 9.9 16.2 6.2 25c-2.3 5.3-4.8 10.5-7.6 15.5l-3.1 5.4c-3 5-6.3 9.9-9.8 14.6c-5.7 7.6-15.7 10.1-24.7 7.1l-28.2-9.3c-10.7 8.8-23 16-36.2 20.9L199 324.9c-1.9 9.3-9.1 16.7-18.5 17.8c-6.7 .8-13.5 1.2-20.4 1.2s-13.7-.4-20.4-1.2c-9.4-1.1-16.6-8.6-18.5-17.8L115 295.9c-13.3-5-25.5-12.1-36.2-20.9l-28.2 9.3c-9 3-19 .5-24.7-7.1c-3.5-4.7-6.8-9.6-9.9-14.6l-3-5.2c-2.8-5-5.3-10.2-7.6-15.6c-3.7-8.7-.9-18.6 6.2-25l22.2-19.8C32.6 190.1 32 183.1 32 176s.6-14.1 1.7-20.9L11.5 135.3c-7.1-6.3-9.9-16.2-6.2-25c2.3-5.3 4.8-10.5 7.6-15.6l3-5.3c3-5.1 6.3-9.9 9.9-14.6c5.7-7.6 15.7-10.1 24.7-7.1l28.2 9.3c10.7-8.8 23-16 36.2-20.9L121 27.1c1.9-9.3 9.1-16.7 18.5-17.8C146.3 8.4 153.1 8 160 8s13.7 .4 20.4 1.2c9.4 1.1 16.6 8.6 18.5 17.8L205 56.1c13.3 5 25.5 12.1 36.2 20.9l28.2-9.3c9-3 19-.5 24.7 7.1c3.5 4.7 6.8 9.5 9.8 14.6l3.1 5.4c2.8 5 5.3 10.2 7.6 15.5zM160 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
    ],
  ],
};
const faCogs = faGears;
const faSunBright = {
  prefix: 'fad',
  iconName: 'sun-bright',
  icon: [
    512,
    512,
    ['sun-alt'],
    'e28f',
    [
      'M0 256c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24zM75 75c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zm0 328.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1zM232 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 400l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zM357.8 120.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3zm0 237.6c-9.4 9.4-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0zM400 256c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24z',
      'M256 144a112 112 0 1 0 0 224 112 112 0 1 0 0-224z',
    ],
  ],
};
const faSunAlt = faSunBright;
const faWarehouse = {
  prefix: 'fad',
  iconName: 'warehouse',
  icon: [
    640,
    512,
    [],
    'f494',
    [
      'M128 224l0 80 384 0 0-80-384 0zm0 112l0 64 384 0 0-64-384 0zm0 96l0 56c0 13.3 10.7 24 24 24l336 0c13.3 0 24-10.7 24-24l0-56-384 0z',
      'M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z',
    ],
  ],
};
const faConveyorBeltArm = {
  prefix: 'fad',
  iconName: 'conveyor-belt-arm',
  icon: [
    640,
    512,
    [],
    'e5f8',
    [
      'M0 416c0 53 43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96l-32 0-96 0-64 0-96 0-64 0-96 0c-53 0-96 43-96 96zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M240.9 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-52.9 0-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3c17.5 2.3 29.8 18.4 27.5 35.9c-1.4 10.2-7.4 18.7-15.7 23.5l0 20.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.9L255.2 164.4c-8.4 7.2-19.3 11.6-31.2 11.6c-26.5 0-48-21.5-48-48c0-17.1 8.9-32 22.3-40.6L202.2 64 160 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l79 0c.6 0 1.2 0 1.9 0zM240 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 280c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 40-96 0 0-40zm184-24l48 0c13.3 0 24 10.7 24 24l0 40-96 0 0-40c0-13.3 10.7-24 24-24zm160 0l48 0c13.3 0 24 10.7 24 24l0 40-96 0 0-40c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faLockKeyholeOpen = {
  prefix: 'fad',
  iconName: 'lock-keyhole-open',
  icon: [
    576,
    512,
    ['lock-open-alt'],
    'f3c2',
    [
      'M288 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48C576 64.5 511.5 0 432 0S288 64.5 288 144z',
      'M64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 192zM256 384l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z',
    ],
  ],
};
const faLockOpenAlt = faLockKeyholeOpen;
const faSquareFragile = {
  prefix: 'fad',
  iconName: 'square-fragile',
  icon: [
    448,
    512,
    ['box-fragile', 'square-wine-glass-crack'],
    'f49b',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm128 22.3C128 106 138 96 150.3 96L176 96l64 0 57.7 0C310 96 320 106 320 118.3l0 89.7c0 47.6-34.6 87.1-80 94.7l0 81.3 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-81.3c-45.4-7.6-80-47.1-80-94.7l0-89.7z',
      'M150.3 96C138 96 128 106 128 118.3l0 89.7c0 47.6 34.6 87.1 80 94.7l0 81.3-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-81.3c45.4-7.6 80-47.1 80-94.7l0-89.7C320 106 310 96 297.7 96L240 96l32 64-48 32 32 64-80-64 32-32L176 96l-25.7 0z',
    ],
  ],
};
const faBoxFragile = faSquareFragile;
const faSquareWineGlassCrack = faSquareFragile;
const faArrowUpRightDots = {
  prefix: 'fad',
  iconName: 'arrow-up-right-dots',
  icon: [
    576,
    512,
    [],
    'e4b7',
    [
      'M96 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM352 208a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM480 80a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M128 32c0-17.7 14.3-32 32-32L288 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7L54.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 64 160 64c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faSquareN = {
  prefix: 'fad',
  iconName: 'square-n',
  icon: [
    448,
    512,
    [],
    'e277',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 56c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7c44.6 52.7 89.1 105.3 133.7 158L288 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.1-6.3 19.1-15.7 22.5c-2.7 1-5.5 1.5-8.3 1.5c-6.9 0-13.7-3-18.3-8.5c-44.6-52.7-89.1-105.3-133.7-158L160 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z',
      'M127.7 129.5c9.5-3.5 20.1-.7 26.6 7L288 294.5 288 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5 160 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.1 6.3-19.1 15.7-22.5z',
    ],
  ],
};
const faSplotch = {
  prefix: 'fad',
  iconName: 'splotch',
  icon: [
    512,
    512,
    [],
    'f5bc',
    [
      'M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z',
      '',
    ],
  ],
};
const faFaceGrinHearts = {
  prefix: 'fad',
  iconName: 'face-grin-hearts',
  icon: [
    512,
    512,
    [128525, 'grin-hearts'],
    'f584',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm97.1-67.9c4.8-17.8 23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6s28.4 23.1 23.6 40.8l-17.4 65c-1.9 7.1-8.4 11.9-15.4 11.9c-1.4 0-2.8-.2-4.2-.5l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8zm8 143.4c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM289.1 170c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-1.4 .4-2.8 .5-4.2 .5c-7.1 0-13.5-4.7-15.4-11.9l-17.4-65z',
      'M158.4 152.7c4.8-17.8 23.1-28.4 40.8-23.6s28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1zm195.2 0l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z',
    ],
  ],
};
const faGrinHearts = faFaceGrinHearts;
const faMeter = {
  prefix: 'fad',
  iconName: 'meter',
  icon: [
    512,
    512,
    [],
    'e1e8',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm96 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32z',
      'M160 128c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faMandolin = {
  prefix: 'fad',
  iconName: 'mandolin',
  icon: [
    512,
    512,
    [],
    'f6f9',
    [
      'M0 336c0 97.2 78.8 176 176 176c135.5 0 147.7-189.6 146.2-276.9l-66.2 66.2c0 .9 .1 1.8 .1 2.7c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.9 0 1.8 0 2.7 .1c22.1-22.1 44.2-44.2 66.2-66.2C189.6 188.3 0 200.5 0 336z',
      'M465 7c-7.9-7.9-20.2-9.3-29.7-3.4l-64 40c-5.1 3.2-8.8 8.2-10.4 14L342.8 124 210.7 256.1c24.4 1.3 43.9 20.9 45.3 45.3L388 169.2l66.3-18.1c5.8-1.6 10.8-5.3 14-10.4l40-64c5.9-9.5 4.5-21.8-3.4-29.7L465 7z',
    ],
  ],
};
const faDiceFour = {
  prefix: 'fad',
  iconName: 'dice-four',
  icon: [
    448,
    512,
    [9859],
    'f524',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faSimCard = {
  prefix: 'fad',
  iconName: 'sim-card',
  icon: [
    384,
    512,
    [],
    'f7c4',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-306.7c0-17-6.7-33.3-18.7-45.3L288 18.7C276 6.7 259.7 0 242.7 0L64 0C28.7 0 0 28.7 0 64zM64 224c0-17.7 14.3-32 32-32l32 0 32 0 64 0 32 0 32 0c17.7 0 32 14.3 32 32l0 32 0 32 0 64 0 32 0 32c0 17.7-14.3 32-32 32l-32 0-32 0-64 0-32 0-32 0c-17.7 0-32-14.3-32-32l0-32 0-32 0-64 0-32 0-32z',
      'M128 192l-32 0c-17.7 0-32 14.3-32 32l0 32 64 0 0-64zM64 288l0 64 80 0 96 0 80 0 0-64-80 0-96 0-80 0zm256-32l0-32c0-17.7-14.3-32-32-32l-32 0 0 64 64 0zm-96-64l-64 0 0 64 64 0 0-64zm96 192l-64 0 0 64 32 0c17.7 0 32-14.3 32-32l0-32zm-96 64l0-64-64 0 0 64 64 0zm-96 0l0-64-64 0 0 32c0 17.7 14.3 32 32 32l32 0z',
    ],
  ],
};
const faTransgender = {
  prefix: 'fad',
  iconName: 'transgender',
  icon: [
    512,
    512,
    [9895, 'transgender-alt'],
    'f225',
    [
      'M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l96 0c8.8 0 16 7.2 16 16l0 96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2l0 17.8 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-17.8C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112L0 16C0 7.2 7.2 0 16 0l96 0zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z',
    ],
  ],
};
const faTransgenderAlt = faTransgender;
const faMercury = {
  prefix: 'fad',
  iconName: 'mercury',
  icon: [
    384,
    512,
    [9791],
    'f223',
    [
      'M112 224a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4l0 25.6 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-25.6C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z',
    ],
  ],
};
const faUpFromBracket = {
  prefix: 'fad',
  iconName: 'up-from-bracket',
  icon: [
    448,
    512,
    [],
    'e590',
    [
      'M0 352l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M196.7 11.3L73.9 134.1c-6.4 6.4-9.9 15-9.9 24C64 176.8 79.2 192 97.9 192l62.1 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24L251.3 11.3C244.1 4.1 234.2 0 224 0s-20.1 4.1-27.3 11.3z',
    ],
  ],
};
const faKnifeKitchen = {
  prefix: 'fad',
  iconName: 'knife-kitchen',
  icon: [
    576,
    512,
    [128298],
    'f6f5',
    [
      'M0 480c0 1.2 .1 2.5 .4 3.7c1.3 5.4 5.3 9.8 10.5 11.5c.4 .1 .5 .2 .7 .2c.4 .1 1 .3 1.8 .6c1.5 .5 3.7 1.1 6.5 1.9c5.5 1.6 13.3 3.7 22.7 5.7c18.6 4.1 43.9 8.4 69.5 8.4c123.3 0 209.4-62.8 287.3-140.7c3.1-3.1 4.7-7.2 4.7-11.3s-1.6-8.2-4.7-11.3c-9.4-9.4-18.8-18.8-28.1-28.1c-32.6-32.6-65.2-65.2-97.9-97.9c-3.8-3.8-7.5-7.5-11.3-11.3c-3.8 3.8-7.5 7.5-11.3 11.3l-246 246c-3 3-4.7 7.1-4.7 11.3z',
      'M463 10.3C469.7 3.7 478.6 0 488 0s18.3 3.7 25 10.3L557.7 55c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-97 97c-3 3-4.7 7.1-4.7 11.3l0 31.9c0 17.4-9.4 33.5-24.7 42L375.8 318l-4.6 2.6-97.9-97.9L262 211.4l6.7-6.7L463 10.3zM448 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faBorderRight = {
  prefix: 'fad',
  iconName: 'border-right',
  icon: [
    448,
    512,
    [],
    'f852',
    [
      'M0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 160zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M416 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faArrowTurnDown = {
  prefix: 'fad',
  iconName: 'arrow-turn-down',
  icon: [
    384,
    512,
    ['level-down'],
    'f149',
    [
      'M0 32C0 49.7 14.3 64 32 64l96 0c17.7 0 32 14.3 32 32l0 306.7c10.7 10.7 21.3 21.3 32 32c10.7-10.7 21.3-21.3 32-32L224 96c0-53-43-96-96-96L32 0C14.3 0 0 14.3 0 32z',
      'M41.4 329.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 434.7 86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0z',
    ],
  ],
};
const faLevelDown = faArrowTurnDown;
const faSpade = {
  prefix: 'fad',
  iconName: 'spade',
  icon: [
    512,
    512,
    [9824],
    'f2f4',
    [
      'M0 289.3c0 31.6 11.6 63.3 35.1 88c48.6 51.3 129.6 53.5 181 4.9l8-7.6L224 256c0-17.7 14.3-32 32-32s32 14.3 32 32l0 118.6 8 7.6c24.8 23.4 56.4 35.1 88 35.1c33.9 0 67.8-13.4 92.9-40c23.4-24.8 35.1-56.4 35.1-88c0-33.9-13.4-67.8-40-92.9L344 75.1 278 12.5c-6.2-5.8-14.1-8.8-22-8.8s-15.8 2.9-22 8.8L168 75.1 40 196.3c-26.6 25.2-40 59-40 92.9z',
      'M256 224c17.7 0 32 14.3 32 32l0 192 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faCardSpade = {
  prefix: 'fad',
  iconName: 'card-spade',
  icon: [
    384,
    512,
    [],
    'e3ec',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM72 264c0-14.3 5.5-28.7 16.4-39.6l64-64L175 137.8c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l22.6 22.6 64 64C306.5 235.3 312 249.7 312 264s-5.5 28.7-16.4 39.6c-21.9 21.9-57.3 21.9-79.2 0l-7.4-7.4c-.3-.3-.6-.6-1-.9l0 40.8 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-40.8c-.3 .3-.7 .6-1 .9l-7.4 7.4c-21.9 21.9-57.3 21.9-79.2 0C77.5 292.7 72 278.3 72 264z',
      'M209 137.8c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6-64 64c-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0l7.4-7.4c.3-.3 .6-.6 1-.9l0 40.8-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-40.8c.3 .3 .7 .6 1 .9l7.4 7.4c21.9 21.9 57.3 21.9 79.2 0s21.9-57.3 0-79.2l-64-64L209 137.8z',
    ],
  ],
};
const faLineColumns = {
  prefix: 'fad',
  iconName: 'line-columns',
  icon: [
    512,
    512,
    [],
    'f870',
    [
      'M288 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 32c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32zm0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32z',
      'M224 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l160 0c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32zM0 320c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32zM224 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32z',
    ],
  ],
};
const faAnt = {
  prefix: 'fad',
  iconName: 'ant',
  icon: [
    640,
    512,
    [],
    'e680',
    [
      'M64 488c0-4 1-8.1 3.2-11.9L128.9 368l47.1 0c2.8 0 5.6-.1 8.4-.3L108.8 499.9c-6.6 11.5-21.2 15.5-32.7 8.9C68.3 504.4 64 496.3 64 488zm83.2-11.9L212.4 362c10.2-3.5 19.7-8.4 28.4-14.6c4.3-3.1 8.4-6.4 12.2-10.1c1.9-1.8 3.8-3.7 5.6-5.6c.9-1 1.8-2 2.6-3s1.7-2 2.5-3.1c3.3 7.7 7.5 14.8 12.6 21.3L188.8 499.9c-6.6 11.5-21.2 15.5-32.7 8.9s-15.5-21.2-8.9-32.7zm80 0l64-112 .3-.4 .5-.8c12.5 10.1 27.6 17 44.1 19.8l-3.3 5.5L268.8 499.9c-6.6 11.5-21.2 15.5-32.7 8.9s-15.5-21.2-8.9-32.7zm163-100c15.1-6.6 28.2-16.9 38.1-29.8l35.4 35.4c8.4 8.4 15.1 18.5 19.5 29.5l27.1 67.8c4.9 12.3-1.1 26.3-13.4 31.2s-26.3-1.1-31.2-13.4l-27.1-67.8c-2-5-5-9.6-8.9-13.4l-39.6-39.6zm44.1-38.7c4.3-7.2 7.7-15 10.1-23.2c1.2-4.1 2.1-8.4 2.7-12.7c.3-2.2 .5-4.4 .7-6.6c.1-1.1 .1-2.2 .2-3.3s.1-2.2 .1-3.4l5.9 4.2L549 360.4c15.1 10.8 26.5 26.1 32.3 43.8l25.4 76.3c.8 2.5 1.2 5.1 1.2 7.6c0 10-6.4 19.4-16.4 22.8c-12.6 4.2-26.2-2.6-30.4-15.2l-25.4-76.3c-2.7-8-7.8-15-14.7-19.9l-86.8-62z',
      'M523.3 51.9c1.4-2.4 4.1-3.9 6.9-3.9L584 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L530.1 0c-19.7 0-37.9 10.3-48 27.2L458.6 66.4C415.9 76.1 384 114.3 384 160c0 14.8 3.3 28.8 9.3 41.3c-12.5-6-26.5-9.3-41.3-9.3c-27 0-51.4 11.2-68.9 29.1C267.9 167.6 218.6 128 160.4 128C72 128 0 199.6 0 288c0 44.2 35.8 80 80 80l96 0c35.5 0 67.2-16.5 87.7-42.3C278.3 360 312.4 384 352 384c53 0 96-43 96-96c0-14.8-3.3-28.8-9.3-41.3c12.5 6 26.5 9.3 41.3 9.3l64 0c35.3 0 64-28.7 64-64c0-59.2-40.1-108.9-94.6-123.6l9.9-16.5zM512 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faArrowRightToLine = {
  prefix: 'fad',
  iconName: 'arrow-right-to-line',
  icon: [
    448,
    512,
    [8677, 'arrow-to-right'],
    'f340',
    [
      'M384 96l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l178.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z',
    ],
  ],
};
const faArrowToRight = faArrowRightToLine;
const faPersonFallingBurst = {
  prefix: 'fad',
  iconName: 'person-falling-burst',
  icon: [
    640,
    512,
    [],
    'e547',
    [
      'M292 219.6c0 1.2 .1 2.4 .4 3.6c1.5 6.4 6.7 11.2 13.1 12.2l78.7 12.2L379.5 314c4.7 6.3 9.4 12.5 14.1 18.8c.3 .4 .6 .8 .9 1.3s.6 .9 .8 1.3c.5 .9 1 1.8 1.5 2.7c.9 1.8 1.6 3.7 2.1 5.6c2.4-.7 4.6-1.9 6.5-3.6L464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2c.3-1.2 .4-2.4 .4-3.6c0-5.2-2.5-10.1-6.9-13.2l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-4.4 3-6.9 8-6.9 13.2z',
      'M224 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L240.5 256l71.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L304 320l-80 0-1.4 0 92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L100.5 249.2c-2.9 9.2-4.5 19-4.5 29L96 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-73.8C32 213 71.6 154.5 132.1 130.3C168.3 115.8 192 80.8 192 41.8l0-9.8c0-17.7 14.3-32 32-32zM48 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faFlagPennant = {
  prefix: 'fad',
  iconName: 'flag-pennant',
  icon: [
    448,
    512,
    [128681, 'pennant'],
    'f456',
    [
      'M64 32L433 170.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L64 352 64 32z',
      'M32 0C49.7 0 64 14.3 64 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0z',
    ],
  ],
};
const faPennant = faFlagPennant;
const faConveyorBeltEmpty = {
  prefix: 'fad',
  iconName: 'conveyor-belt-empty',
  icon: [
    640,
    512,
    [],
    'e150',
    [
      'M96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
      '',
    ],
  ],
};
const faUserGroupSimple = {
  prefix: 'fad',
  iconName: 'user-group-simple',
  icon: [
    640,
    512,
    [],
    'e603',
    [
      'M321.9 322.6C340.8 348.9 352 381.1 352 416l0 16c0 1.5 0 3-.1 4.5C375.3 463.2 409.7 480 448 480l64 0c70.7 0 128-57.3 128-128l0-16c0-26.5-21.5-48-48-48l-224 0c-21.8 0-40.3 14.6-46.1 34.6zM376 136a104 104 0 1 0 208 0 104 104 0 1 0 -208 0z',
      'M160 240a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm-32 48C57.3 288 0 345.3 0 416l0 16c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-16c0-70.7-57.3-128-128-128l-64 0z',
    ],
  ],
};
const faAward = {
  prefix: 'fad',
  iconName: 'award',
  icon: [
    384,
    512,
    [],
    'f559',
    [
      'M0 448c0-2.1 .4-4.2 1.3-6.2L56.9 309.7l1.8 .9c6.4 3.2 11.5 8.4 14.7 14.7L83 344.5c5.9 11.8 18.3 19 31.5 18.2l21.3-1.3c7.1-.4 14.2 1.5 20.1 5.4l17.8 11.8c3.4 2.3 7.2 3.8 11 4.7l-50.1 119c-2.3 5.5-7.4 9.2-13.3 9.7c-.5 0-1 .1-1.4 .1c-5.4 0-10.4-2.7-13.4-7.3L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6C1.1 455 0 451.5 0 448zm199.2-64.8c1.9-.4 3.8-1 5.7-1.8c.9-.4 1.8-.8 2.7-1.3c.4-.2 .9-.5 1.3-.7s.9-.5 1.3-.8L228 366.8c6-3.9 13-5.8 20.1-5.4l21.3 1.3c13.2 .8 25.6-6.4 31.5-18.2l9.6-19.1c3.2-6.4 8.4-11.5 14.7-14.7l1.8-.9 55.6 132.1c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7l-50.1-119z',
      'M210.2 5.5c-11-7.3-25.4-7.3-36.4 0L156 17.2c-6 3.9-13 5.8-20.1 5.4l-21.3-1.3c-13.2-.8-25.6 6.4-31.5 18.2L73.4 58.6C70.2 65 65 70.2 58.6 73.4L39.5 83c-11.8 5.9-19 18.3-18.2 31.5l1.3 21.3c.4 7.1-1.5 14.2-5.4 20.1L5.5 173.8c-7.3 11-7.3 25.4 0 36.4L17.2 228c3.9 6 5.8 13 5.4 20.1l-1.3 21.3c-.8 13.2 6.4 25.6 18.2 31.5l19.1 9.6c6.4 3.2 11.5 8.4 14.7 14.7L83 344.5c5.9 11.8 18.3 19 31.5 18.2l21.3-1.3c7.1-.4 14.2 1.5 20.1 5.4l17.8 11.8c11 7.3 25.4 7.3 36.4 0L228 366.8c6-3.9 13-5.8 20.1-5.4l21.3 1.3c13.2 .8 25.6-6.4 31.5-18.2l9.6-19.1c3.2-6.4 8.4-11.5 14.7-14.7l19.1-9.6c11.8-5.9 19-18.3 18.2-31.5l-1.3-21.3c-.4-7.1 1.5-14.2 5.4-20.1l11.8-17.8c7.3-11 7.3-25.4 0-36.4L366.8 156c-3.9-6-5.8-13-5.4-20.1l1.3-21.3c.8-13.2-6.4-25.6-18.2-31.5l-19.1-9.6c-6.4-3.2-11.5-8.4-14.7-14.7L301 39.5c-5.9-11.8-18.3-19-31.5-18.2l-21.3 1.3c-7.1 .4-14.2-1.5-20.1-5.4L210.2 5.5zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faTicketSimple = {
  prefix: 'fad',
  iconName: 'ticket-simple',
  icon: [
    576,
    512,
    ['ticket-alt'],
    'f3ff',
    [
      'M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6l0 64c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64l0-64c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192l0-64z',
      '',
    ],
  ],
};
const faTicketAlt = faTicketSimple;
const faBuilding = {
  prefix: 'fad',
  iconName: 'building',
  icon: [
    384,
    512,
    [127970, 61687],
    'f1ad',
    [
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
      'M80 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96zm0 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM160 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM272 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0z',
    ],
  ],
};
const faAnglesLeft = {
  prefix: 'fad',
  iconName: 'angles-left',
  icon: [
    512,
    512,
    [171, 'angle-double-left'],
    'f100',
    [
      'M224 256c0 8.2 3.1 16.4 9.4 22.6l160 160c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4s9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6L301.3 256 438.6 118.6c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6S424.2 64 416 64s-16.4 3.1-22.6 9.4l-160 160c-6.2 6.2-9.4 14.4-9.4 22.6z',
      'M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z',
    ],
  ],
};
const faAngleDoubleLeft = faAnglesLeft;
const faCamcorder = {
  prefix: 'fad',
  iconName: 'camcorder',
  icon: [
    576,
    512,
    [128249, 'video-handheld'],
    'f8a8',
    [
      'M0 224L0 416c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-36.2 0-119.6 0-36.2c0-35.3-28.7-64-64-64L96 160l0-32c0-17.7 14.3-32 32-32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L128 32c-53 0-96 43-96 96l0 40.6C12.9 179.6 0 200.3 0 224zm64 16c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16z',
      'M559.1 163.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6L384 379.8l0-119.6 142.2-94.8c9.8-6.5 22.4-7.2 32.9-1.6zM80 224l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
    ],
  ],
};
const faVideoHandheld = faCamcorder;
const faPancakes = {
  prefix: 'fad',
  iconName: 'pancakes',
  icon: [
    512,
    512,
    [129374],
    'e42d',
    [
      'M0 160c0 20.3 24.2 38.8 64 52.9l0-48.1c0-.1-.1-.2-.2-.4c-.4-.5-1.2-1.3-2.4-1.8c-14.7-5.9-28.7-13.4-39.6-22.9c-2.3-2-4.6-4.3-6.8-6.8C5.3 141.4 0 150.5 0 160zm0 80c0 21 25.8 40 68 54.3c-2.6-6.9-4-14.5-4-22.3l0-25.3c-21.5-6.8-41.1-15.2-56.8-25.6C2.5 227.2 0 233.5 0 240zm0 80c0 44.2 114.6 80 256 80s256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320zm0 80c0 44.2 114.6 80 256 80s256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400zm174.6-84.1c25.6 2.7 52.9 4.1 81.4 4.1c141.4 0 256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26c-47.8 14.9-111.2 24-180.2 24.8c-11.3 10-26.1 16.1-42.4 16.1c-11.8 0-22.9-3.2-32.4-8.8c-1.6 14.1-7.8 26.9-17 36.7zm111.5-76.4C413.3 234.8 512 201 512 160c0-9.5-5.3-18.6-14.9-27c-4 4.5-8.5 8.4-12.7 11.5c-13.4 10-30.9 17.8-49.8 24C396.6 181 345.5 189 289.3 191.3c-.5 0-.9 .2-1.2 .5c-.1 10.8-.1 21.5-.1 32.2c0 5.3-.7 10.5-1.9 15.5z',
      'M288 159.4c-17.7 .7-32 15-32 32.6l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-52.3c0-8.1-6.5-14.9-14.5-15.7c-9.4-1-17.5 6.3-17.5 15.7L160 272c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-107.2c0-14.2-9.5-26.5-22.7-31.8C47.3 122.6 32 109.8 32 96c0-35.3 100.3-64 224-64s224 28.7 224 64c0 32.2-83.4 58.9-192 63.4zM208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z',
    ],
  ],
};
const faAlbumCircleUser = {
  prefix: 'fad',
  iconName: 'album-circle-user',
  icon: [
    576,
    512,
    [],
    'e48d',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-16.2-19.7-28.3-42.9-34.8-68.4c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160c69.3 0 128.3 44 150.5 105.6c18-6.2 37.4-9.6 57.5-9.6c5.4 0 10.7 .2 16 .7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM192 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7C489.5 468.1 462.2 480 432 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faSubtitlesSlash = {
  prefix: 'fad',
  iconName: 'subtitles-slash',
  icon: [
    640,
    512,
    [],
    'e610',
    [
      'M32 121.2L32 416c0 35.3 28.7 64 64 64l391.4 0L365.5 384 312 384c-13.3 0-24-10.7-24-24c0-11.1 7.5-20.4 17.7-23.2l-62-48.8L152 288c-13.3 0-24-10.7-24-24s10.7-24 24-24l30.8 0L32 121.2zM76.8 34.9c105.3 82.5 210.5 165 315.8 247.5c-5.3-4.4-8.6-11-8.6-18.4c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-5.3 0-10.2-1.7-14.2-4.6c22.4 17.5 44.7 35.1 67.1 52.6l27 0c13.3 0 24 10.7 24 24c0 4.8-1.4 9.3-3.8 13c30.9 24.2 61.7 48.4 92.6 72.6c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9zM128 360c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faQrcode = {
  prefix: 'fad',
  iconName: 'qrcode',
  icon: [
    448,
    512,
    [],
    'f029',
    [
      'M0 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80zM0 336l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM64 96l64 0 0 64-64 0 0-64zm0 256l64 0 0 64-64 0 0-64zM256 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zm64 16l64 0 0 64-64 0 0-64z',
      'M256 464l0-160c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
    ],
  ],
};
const faDiceD10 = {
  prefix: 'fad',
  iconName: 'dice-d10',
  icon: [
    512,
    512,
    [],
    'f6cd',
    [
      'M0 243.8c0 7 6.4 12.1 13.2 10.6l117.6-26.1c5.5-1.2 9.9-5.2 11.7-10.6L209.7 16.3C212.4 8.3 206.4 0 198 0c-3.8 0-7.3 1.7-9.7 4.6L2.4 237C.8 238.9 0 241.3 0 243.8zm174.8-21.5c-2.2 6.7 .2 14.2 6.1 18.2l66.1 45.7c2.7 1.9 5.9 2.8 9.1 2.8s6.4-.9 9.1-2.8l66.1-45.7c5.8-4 8.3-11.5 6.1-18.2L265.4 6.8C264 2.7 260.3 0 256 0s-8 2.7-9.4 6.8L174.8 222.3zm127.5-206l67.2 201.5c1.8 5.3 6.2 9.3 11.7 10.6l117.6 26.1c6.8 1.5 13.2-3.7 13.2-10.6c0-2.5-.8-4.9-2.4-6.8L323.7 4.6C321.4 1.7 317.8 0 314 0c-8.5 0-14.4 8.3-11.7 16.3z',
      'M0 299.1c0-5.2 3.6-9.8 8.7-10.9l133.1-29.6c4.4-1 8.9-.1 12.6 2.5l78.7 54.5c4.3 3 6.9 7.9 6.9 13.2l0 171.7c0 6.3-5.1 11.5-11.5 11.5c-2.9 0-5.7-1.1-7.8-3.1L3.6 307.3c-2.3-2.1-3.6-5.1-3.6-8.2zM283.5 512c-6.3 0-11.5-5.1-11.5-11.5l0-171.7c0-5.3 2.6-10.2 6.9-13.2l78.7-54.5c3.7-2.5 8.2-3.4 12.6-2.5l133.1 29.6c5.1 1.1 8.7 5.7 8.7 10.9c0 3.1-1.3 6.1-3.6 8.2L291.3 508.9c-2.1 2-4.9 3.1-7.8 3.1z',
    ],
  ],
};
const faFireplace = {
  prefix: 'fad',
  iconName: 'fireplace',
  icon: [
    640,
    512,
    [],
    'f79a',
    [
      'M0 32L0 64C0 81.7 14.3 96 32 96l576 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zM208 400.1c0 62 49.3 111.9 112 111.9c62.1 0 112-49.8 112-111.9c0-21-7.7-42.6-18.3-61.7C403 319.3 389 301.8 375.2 289c-3.9-3.6-8.9-5.5-13.9-5.5c-5.3 0-10.9 2-14.6 6.2l-8.6 9.7-13.3-14c-1.4-1.5-2.8-3.1-4.2-4.7c-6.3-7.2-13.1-14.9-22.9-15.1c-5.1-.1-10.2 1.6-14.2 5.3c-16.4 14.8-35 34.2-49.6 56.1c-14.5 21.8-25.8 47-25.8 73.1zm67.2 33.6c0-25.6 25.9-51.1 38.3-61.9c3.8-3.3 9.2-3.3 12.9 0c12.4 10.8 38.3 36.3 38.3 61.9c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8z',
      'M608 96L32 96l0 384c0 17.7 14.3 32 32 32l96 0 0-160c0-88.4 71.6-160 160-160s160 71.6 160 160l0 160 96 0c17.7 0 32-14.3 32-32l0-384z',
    ],
  ],
};
const faBrowser = {
  prefix: 'fad',
  iconName: 'browser',
  icon: [
    512,
    512,
    [128468],
    'f37e',
    [
      'M0 224L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192L0 224zm64-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 128L0 224 0 96zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm120-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-240 0z',
    ],
  ],
};
const faPenPaintbrush = {
  prefix: 'fad',
  iconName: 'pen-paintbrush',
  icon: [
    576,
    512,
    ['pencil-paintbrush'],
    'f618',
    [
      'M0 56C0 41.7 5.5 27.3 16.4 16.4S41.7 0 56 0S84.7 5.5 95.6 16.4L226.3 147.1l-79.2 79.2L16.4 95.6C5.5 84.7 0 70.3 0 56zM290.6 423.9L423.9 290.6c50.3 11 88.1 55.8 88.1 109.4c0 3.9-.2 7.8-.6 11.6c-1.8 17.5 10.2 36.4 27.8 36.4l4.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0c-53.6 0-98.5-37.7-109.4-88.1z',
      'M410.7 19.3L354.3 75.7 468.3 189.7l56.4-56.4c25-25 25-65.5 0-90.5L501.3 19.3c-25-25-65.5-25-90.5 0zm-79 79L76.9 353.2c-6.7 6.7-11.6 15.1-14.2 24.2l-29.7 104c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l104-29.7c9.2-2.6 17.5-7.5 24.2-14.2L445.7 212.3 331.7 98.3z',
    ],
  ],
};
const faPencilPaintbrush = faPenPaintbrush;
const faFishCooked = {
  prefix: 'fad',
  iconName: 'fish-cooked',
  icon: [
    576,
    512,
    [],
    'f7fe',
    [
      'M.5 131.9L30.5 252.1c.6 2.5 .6 5.2 0 7.8L.5 380.1c-1.7 6.7 1.1 13.7 6.9 17.4s13.3 3.3 18.7-1.1l65.1-52.9c6.7-5.5 16.5-4.6 22.5 1.7C164.1 398.2 245.2 448 320 448c120 0 256-128 256-192s-136-192-256-192c-72.6 0-151.1 46.9-201.8 98.1c-5.6 5.7-14.5 6.8-21.1 2.2l-72-49.5c-5.5-3.8-12.7-3.8-18.2 0s-8 10.6-6.4 17zM224 224c0-4.1 1.6-8.2 4.7-11.3c21.3-21.3 42.7-42.7 64-64c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6c-21.3 21.3-42.7 42.7-64 64c-6.2 6.2-16.4 6.2-22.6 0c-3.1-3.1-4.7-7.2-4.7-11.3zm20.7 100.7c53.3-53.3 106.7-106.7 160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-53.3 53.3-106.7 106.7-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm112 16c21.3-21.3 42.7-42.7 64-64c6.2-6.2 16.4-6.2 22.6 0c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l-64 64c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6z',
      'M315.3 148.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0zm112 16c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0zm16 112c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0z',
    ],
  ],
};
const faChairOffice = {
  prefix: 'fad',
  iconName: 'chair-office',
  icon: [
    448,
    512,
    [],
    'f6c1',
    [
      'M96 64l0 224 256 0 0-224c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64zm32 416c0 17.7 14.3 32 32 32l64 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64-64 0 0 64-32 0c-17.7 0-32 14.3-32 32z',
      'M64 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zm384 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zM80 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S52.9 384 64 384l320 0c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C391.2 294.8 380.1 288 368 288L80 288z',
    ],
  ],
};
const faMagnifyingGlassMusic = {
  prefix: 'fad',
  iconName: 'magnifying-glass-music',
  icon: [
    512,
    512,
    [],
    'e65f',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm112 64c0-26.5 28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-57.5 0-32c0-10.3 6.6-19.5 16.4-22.8l48-16c2.5-.8 5-1.2 7.6-1.2c5 0 9.9 1.5 14 4.5c6.3 4.5 10 11.8 10 19.5l0 32c0 10.3-6.6 19.5-16.4 22.8L240 185.3l0 86.8c-.1 26.5-28.7 47.9-64 47.9c-35.3 0-64-21.5-64-48z',
      'M278 100.5c6.3 4.5 10 11.8 10 19.5l0 32c0 10.3-6.6 19.5-16.4 22.8L240 185.3l0 86.7c0 0 0 .1 0 .1c-.1 26.5-28.7 47.9-64 47.9c-35.3 0-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-57.5 0-32c0-10.3 6.6-19.5 16.4-22.8l48-16c7.3-2.4 15.4-1.2 21.6 3.3zM457.4 502.6L330.7 376C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z',
    ],
  ],
};
const faNestingDolls = {
  prefix: 'fad',
  iconName: 'nesting-dolls',
  icon: [
    640,
    512,
    [],
    'e3ba',
    [
      'M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112l0 144L80 256l0-144zm48.4-9.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7c-4.1-5.3-13.2-5.3-17.3 0c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2zm256 255.3c.1-.5 .2-1 .4-1.4c.4-.9 .9-1.7 1.6-2.4c1.4-1.4 3.4-2.2 5.6-2.2c25.8 0 48.7-12.2 63.3-31.1c4.1-5.3 13.2-5.3 17.3 0C487.3 339.8 510.2 352 536 352c4.3 0 8 3.3 7.6 7.6c-1.7 17.9-9.4 35.3-23.1 49c-31.2 31.2-81.9 31.2-113.1 0c-13.7-13.7-21.4-31.1-23.1-49c0-.3 0-.5 0-.8s0-.5 .1-.8z',
      'M637.3 499c4.1-8 3.4-17.6-1.8-24.9c0 0 0 0 0 0s0 0 0 0l-.2-.3c-.2-.3-.6-.8-1-1.5c-.9-1.4-2.3-3.5-4-6.3c-3.4-5.6-7.9-13.8-12.5-23.8C608.6 421.7 600 395.3 600 368l0-8c0-75.1-60.9-136-136-136s-136 60.9-136 136l0 8c0 27.3-8.6 53.7-17.8 74.1c-4.6 10-9.1 18.2-12.5 23.8c-1.7 2.8-3.1 5-4 6.3c-.5 .7-.8 1.2-1 1.5l-.2 .3c0 0 0 0 0 0c-5.2 7.3-5.9 16.9-1.8 24.9c4.1 8 12.3 13 21.3 13l304 0c9 0 17.2-5 21.3-13zM472.7 320.9C487.3 339.8 510.2 352 536 352c4.3 0 8 3.3 7.6 7.6c-1.7 17.9-9.4 35.3-23.1 49c-31.2 31.2-81.9 31.2-113.1 0c-13.7-13.7-21.4-31.1-23.1-49c-.4-4.3 3.3-7.6 7.6-7.6c25.8 0 48.7-12.2 63.3-31.1c4.1-5.3 13.2-5.3 17.3 0zM296 360c0-39.3 13.5-75.4 36.1-104L51.9 256c-5.9 0-11.3 3.3-14 8.6C20.2 299.6 0 339.6 0 384c0 48.8 17.9 85.7 31.8 107.1C41.1 505.3 57.5 512 74.5 512l186.9 0c-8.7-18.2-6.8-39.8 4.9-56.3c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0-.1c0 0 0 0 0 0c.1-.1 .3-.5 .7-1c.7-1 1.8-2.8 3.2-5.2c2.9-4.8 6.8-11.9 10.8-20.6c8.2-18.1 15-39.8 15-60.8l0-8z',
    ],
  ],
};
const faClockRotateLeft = {
  prefix: 'fad',
  iconName: 'clock-rotate-left',
  icon: [
    512,
    512,
    ['history'],
    'f1da',
    [
      'M0 57.9L0 168c0 13.3 10.7 24 24 24l110.1 0c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9z',
      'M256 128c13.3 0 24 10.7 24 24l0 94.1 65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17l0-104c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faHistory = faClockRotateLeft;
const faTrumpet = {
  prefix: 'fad',
  iconName: 'trumpet',
  icon: [
    640,
    512,
    [127930],
    'f8e3',
    [
      'M64 320c0 70.7 57.3 128 128 128l96 0 96 0c70.7 0 128-57.3 128-128l0-36.5c-19.7-12-41.3-21.4-64-25.4l0 61.8c0 29.8-20.4 54.9-48 62l0-126c-16 0-32 0-48 0l0 128-40 0 0-128c-16 0-32 0-48 0l0 128-40 0 0-128c-47.6 0-95.2 0-142.9 0C70.2 274.8 64 296.7 64 320zm64 0c0-29.8 20.4-54.9 48-62l0 124c-27.6-7.1-48-32.2-48-62zm48-160l0 32 48.1 0c-.1-10.7-.1-21.3-.1-32c0-13.3-10.7-24-24-24s-24 10.7-24 24zm88 0l0 32 48 0 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24zm88 0l0 32 48 0 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M640 80c0-7-4.6-13.2-11.3-15.3s-14 .4-17.9 6.2c0 0 0 0 0 0c0 0 0 0 0 0l-.1 .2-.7 .9c-.6 .8-1.5 2.1-2.8 3.8c-2.5 3.3-6.2 8.1-11 13.9c-9.6 11.6-23.6 26.9-40.8 42.3c-35 31.1-81.3 60-131.4 60L46.6 192c-3.3-9.3-12.2-16-22.6-16c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24c10.4 0 19.3-6.7 22.6-16L424 256c50.1 0 96.4 28.8 131.4 60c17.3 15.3 31.2 30.7 40.8 42.3c4.8 5.8 8.5 10.6 11 13.9c1.2 1.7 2.2 2.9 2.8 3.8l.7 .9 .1 .2c0 0 0 0 0 0c0 0 0 0 0 0c4 5.8 11.2 8.3 17.9 6.2s11.3-8.3 11.3-15.3l0-288z',
    ],
  ],
};
const faFaceGrinBeamSweat = {
  prefix: 'fad',
  iconName: 'face-grin-beam-sweat',
  icon: [
    512,
    512,
    [128517, 'grin-beam-sweat'],
    'f583',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-43.4 0-80-34.6-80-79c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256zm105.2 75.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5zM120 224c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6zm160 0c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l-.2-.3c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .3c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6z',
      'M512 81c0 26-21.5 47-48 47s-48-21-48-47c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z',
    ],
  ],
};
const faGrinBeamSweat = faFaceGrinBeamSweat;
const faFireSmoke = {
  prefix: 'fad',
  iconName: 'fire-smoke',
  icon: [
    640,
    512,
    [],
    'f74b',
    [
      'M160 192c0 36 11.9 69.3 32 96c16.5-22 38.6-39.6 64.1-50.7c1.9-35.5 37.4-70.6 54.7-85.5c5.4-4.7 13.1-4.7 18.5 0c17.3 15 52.8 50 54.7 85.5C409.4 248.4 431.5 266 448 288c20.1-26.7 32-60 32-96c0-31.8-15.5-84-74.4-142.4c-11.8-11.7-30.6-10.7-42.3 1L352 61.9l-46-46c-6.1-6.1-14.1-9.3-22-9.2c-5.9 .1-11.8 1.9-16.8 5.8C222.5 47.3 160 115.3 160 192z',
      'M112 512C50.1 512 0 461.9 0 400s50.1-112 112-112c37 0 69.9 18 90.3 45.7C221.8 288 267.2 256 320 256s98.2 32 117.7 77.7C458.1 306 491 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112l-208 0-208 0z',
    ],
  ],
};
const faPhoneMissed = {
  prefix: 'fad',
  iconName: 'phone-missed',
  icon: [
    640,
    512,
    [],
    'e226',
    [
      'M0 401.9c0 6.7 1.8 13.5 5.6 19.6L49.1 492c10.7 17.3 33.5 24.5 53.4 17l92.4-35.2c17.5-6.7 28.1-23.1 26.3-40.6l-5.8-53.3c67.6-21.7 141.5-21.7 209.1 0l-5.8 53.3c-1.9 17.4 8.8 33.9 26.3 40.6L537.5 509c5.3 2 10.8 3 16.3 3c14.9 0 29.3-7.3 37.1-20l43.5-70.5c9.6-15.5 6.7-35-6.9-47.6C542.6 295.3 431.3 256 320 256S97.4 295.3 12.5 373.9C4.3 381.6 0 391.7 0 401.9z',
      'M120 0L232 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 58.7 58.7C282.3 152.4 300.8 160 320 160s37.7-7.6 51.3-21.3L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L405.3 172.7C382.6 195.3 352 208 320 208s-62.6-12.7-85.3-35.3L176 113.9l-39 39c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2L96 24c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faFileExport = {
  prefix: 'fad',
  iconName: 'file-export',
  icon: [
    576,
    512,
    ['arrow-right-from-file'],
    'f56e',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 128-168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0 0 112c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm105 55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L216 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z',
    ],
  ],
};
const faArrowRightFromFile = faFileExport;
const faShield = {
  prefix: 'fad',
  iconName: 'shield',
  icon: [
    512,
    512,
    [128737, 'shield-blank'],
    'f132',
    [
      'M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z',
      '',
    ],
  ],
};
const faShieldBlank = faShield;
const faArrowUpShortWide = {
  prefix: 'fad',
  iconName: 'arrow-up-short-wide',
  icon: [
    576,
    512,
    ['sort-amount-up-alt'],
    'f885',
    [
      'M288 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 128c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32z',
      'M128 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L160 146.3 160 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L63.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C110.5 35.8 119 32 128 32z',
    ],
  ],
};
const faSortAmountUpAlt = faArrowUpShortWide;
const faArrowsRepeat1 = {
  prefix: 'fad',
  iconName: 'arrows-repeat-1',
  icon: [
    512,
    512,
    ['repeat-1-alt'],
    'f366',
    [
      'M1.6 213.9C25.1 143.5 91 96 165.2 96l173.6 0L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-250.8 0c-46.7 0-88.1 29.9-102.8 74.1c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 230.6 1.6 213.9zM66.4 371.8c5-12 16.6-19.8 29.6-19.8l250.8 0c46.7 0 88.1-29.9 102.8-74.1c5.6-16.8 23.7-25.8 40.5-20.2s25.8 23.7 20.2 40.5C486.9 368.5 421 416 346.8 416l-173.6 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3c-6.2 6.2-14.4 9.4-22.6 9.4s-16.4-3.1-22.6-9.4l-96-96c-9.2-9.2-11.9-22.9-6.9-34.9z',
      'M278 196.5c6.3 4.5 10 11.8 10 19.5l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3z',
    ],
  ],
};
const faRepeat1Alt = faArrowsRepeat1;
const faGunSlash = {
  prefix: 'fad',
  iconName: 'gun-slash',
  icon: [
    640,
    512,
    [],
    'e19c',
    [
      'M32 121.2L32 208c0 17.7 14.3 32 32 32l10 0c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480l96 0c14.7 0 27.5-10 31-24.2L249 352l75.9 0L32 121.2zM113.9 64l81.7 64L496 128c8.8 0 16 7.2 16 16s-7.2 16-16 16l-259.6 0c34 26.7 68 53.3 102.1 80l43.4 0-9.5 26.6c13.3 10.4 26.5 20.8 39.8 31.2L432.9 240l31.1 0c8.5 0 16.6-3.4 22.6-9.4L509.3 208l66.7 0c17.7 0 32-14.3 32-32l0-80c0-17.7-14.3-32-32-32l-16 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L113.9 64z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faAvocado = {
  prefix: 'fad',
  iconName: 'avocado',
  icon: [
    512,
    512,
    [],
    'e0aa',
    [
      'M0 304c0 53.2 20.3 106.5 60.9 147.1c81.2 81.2 212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3C20.3 197.5 0 250.8 0 304zm148.4 59.6c-32.7-32.7-25.3-93 16.4-134.8C189 204.6 219.4 192 247.1 192c20.1 0 38.7 6.7 52.5 20.4s20.4 32.4 20.4 52.5c0 27.7-12.6 58.1-36.8 82.3c-41.7 41.7-102.1 49.1-134.8 16.4z',
      'M299.6 212.4c32.7 32.7 25.3 93-16.4 134.8s-102.1 49.1-134.8 16.4s-25.3-93 16.4-134.8s102.1-49.1 134.8-16.4z',
    ],
  ],
};
const faBinary = {
  prefix: 'fad',
  iconName: 'binary',
  icon: [
    384,
    512,
    [],
    'e33b',
    [
      'M0 64l0 96c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 0l64 0 0 96-64 0 0-96zM192 352l0 96c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zm64 0l64 0 0 96-64 0 0-96z',
      'M336 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 83.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128zM112 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16C5.1 311.2-3.9 329.4 1.6 346.1s23.7 25.8 40.5 20.2l5.9-2L48 448l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128z',
    ],
  ],
};
const faCommentNodes = {
  prefix: 'fad',
  iconName: 'comment-nodes',
  icon: [
    640,
    512,
    [],
    'e696',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c10.8 0 21.5-.5 32-1.6c.3-15.8 4.4-31.7 12.9-46.4c16-27.7 43.7-44.4 73.2-47.5l16.7-29.2c-4.3-11-6.7-22.9-6.7-35.4c0-53 43-96 96-96c9.1 0 17.8 1.3 26.2 3.6C481.1 102.1 378.6 32 256 32C114.6 32 0 125.1 0 240z',
      'M392.6 384.6c-25-3.4-50.6 8.3-64 31.4c-17.7 30.6-7.2 69.7 23.4 87.4s69.7 7.2 87.4-23.4c1.5-2.6 2.8-5.3 3.9-8l73.3 0c1.1 2.7 2.4 5.4 3.9 8c17.7 30.6 56.8 41.1 87.4 23.4s41.1-56.8 23.4-87.4c-13.4-23.2-39.1-34.8-64-31.4l-17.6-30.7c-11 11.7-25 20.6-40.6 25.6l16.5 28.9c-3.8 4.8-6.8 10-9 15.6l-73.4 0c-2.2-5.6-5.3-10.8-9-15.6l33-57.7c4.1 .8 8.4 1.3 12.8 1.3c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 13.4 4.1 25.8 11.2 36.1l-34.6 60.5z',
    ],
  ],
};
const faGlassesRound = {
  prefix: 'fad',
  iconName: 'glasses-round',
  icon: [
    576,
    512,
    [128083, 'glasses-alt'],
    'f5f5',
    [
      'M48 344a88 88 0 1 0 176 0A88 88 0 1 0 48 344zm304 0a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z',
      'M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6l0 10.5c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128l-32.5 0c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4l0-10.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 432a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm392-88a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z',
    ],
  ],
};
const faGlassesAlt = faGlassesRound;
const faPhonePlus = {
  prefix: 'fad',
  iconName: 'phone-plus',
  icon: [
    576,
    512,
    [],
    'f4d2',
    [
      'M32 64c0 247.4 200.6 448 448 448c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L336.7 368C266.3 334.7 209.3 277.7 176 207.3L225.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C44.1 30.2 32 46 32 64z',
      'M424 136l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faDitto = {
  prefix: 'fad',
  iconName: 'ditto',
  icon: [
    320,
    512,
    [],
    '22',
    [
      'M0 96l0 2.3c0 3.8 .3 7.6 1 11.4L26.5 256.5C29.7 274.7 45.5 288 64 288s34.3-13.3 37.5-31.5L127 109.6c.7-3.8 1-7.5 1-11.4l0-2.3c0-35.3-28.7-64-64-64S0 60.7 0 96z',
      'M192 98.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L293.5 256.5c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L193 109.6c-.7-3.8-1-7.5-1-11.4z',
    ],
  ],
};
const faPersonSeat = {
  prefix: 'fad',
  iconName: 'person-seat',
  icon: [
    384,
    512,
    [],
    'e21e',
    [
      'M0 160L0 320c0 70.7 57.3 128 128 128l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-35.3 0-64-28.7-64-64l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm96 176l0 32 53.6 0c40.3 0 74.4 30 79.4 70.1l7.2 57.9 19.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0c-16.1 0-29.8-12-31.8-28l-10.7-86c-1-8-7.8-14-15.9-14L160 352c-35.3 0-64-28.7-64-64l0-80c0-26.5 21.5-48 48-48c20.9 0 38.7 13.4 45.3 32l66.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0z',
    ],
  ],
};
const faHouseMedical = {
  prefix: 'fad',
  iconName: 'house-medical',
  icon: [
    576,
    512,
    [],
    'e3b2',
    [
      'M64 270.5c74.7-65.3 149.3-130.7 224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1l-320.4 0c-35.3 0-64-28.6-64-64L64 270.5zM192 304l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z',
      'M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2l-256-224zM256 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faGolfBallTee = {
  prefix: 'fad',
  iconName: 'golf-ball-tee',
  icon: [
    384,
    512,
    ['golf-ball'],
    'f450',
    [
      'M0 192c0 66.8 34.1 125.6 85.8 160l212.3 0c51.7-34.4 85.8-93.2 85.8-160C384 86 298 0 192 0S0 86 0 192zm184.4 23.6c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4zm18.8 82.8c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4zm61.2-66.8c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4z',
      'M128 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0c8.8 0 16 7.2 16 16l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16c0-8.8 7.2-16 16-16l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-64 0z',
    ],
  ],
};
const faGolfBall = faGolfBallTee;
const faCircleChevronLeft = {
  prefix: 'fad',
  iconName: 'circle-chevron-left',
  icon: [
    512,
    512,
    ['chevron-circle-left'],
    'f137',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 0c0-6.1 2.3-12.3 7-17L271 135c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-87 87 87 87c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7L167 273c-4.7-4.7-7-10.8-7-17z',
      'M167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273z',
    ],
  ],
};
const faChevronCircleLeft = faCircleChevronLeft;
const faHouseChimneyWindow = {
  prefix: 'fad',
  iconName: 'house-chimney-window',
  icon: [
    576,
    512,
    [],
    'e00d',
    [
      'M64 270.5L64.1 448c0 35.3 28.7 64 64 64l320.4 0c35.4 0 64-28.7 64-64c-.1-59.2-.3-118.3-.4-177.4L288 74.5 64 270.5zM224 264c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80z',
      'M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5 512 64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 37.5L309.1 7.9z',
    ],
  ],
};
const faScythe = {
  prefix: 'fad',
  iconName: 'scythe',
  icon: [
    640,
    512,
    [],
    'f710',
    [
      'M0 179.3c0 7 5.7 12.7 12.7 12.7L541 192c9.3-43.6 18.7-87.1 28-130.7c2.6-12 5.1-24 7.7-36c1.8-8.4 3.6-16.9 5.4-25.3C505.4 0 428.7 0 352 0C114.8 0 15 151.1 1.6 173.3c-1.1 1.8-1.6 3.8-1.6 6z',
      'M639 24.1C636.1 12.7 627 3.3 614.7 .7c-2.2-.5-4.5-.7-6.7-.7L582.1 0l-5.4 25.3s0 0 0 0l-7.7 36L520.4 288 416 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l90.7 0-26 121.3c-3.7 17.3 7.3 34.3 24.6 38s34.3-7.3 38-24.6l34.3-160L634.4 61.3l4.8-22.6s0 0 0 0c1.1-5 .9-10-.3-14.6z',
    ],
  ],
};
const faPenNib = {
  prefix: 'fad',
  iconName: 'pen-nib',
  icon: [
    512,
    512,
    [10001],
    'f5ad',
    [
      'M2.1 456c0 8.2 3.1 16.2 9 22.3L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.4l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1c1.5-5 3-10.1 4.5-15.1c-41.8-41.8-83.5-83.5-125.3-125.3c-5 1.5-10.1 3-15.1 4.5L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-1.1 3.3-1.7 6.8-1.7 10.2z',
      'M368.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71-3.4 3.4s0 0 0 0L293.9 92.8s0 0 0 0s0 0 0 0l3.4-3.4 71-71z',
    ],
  ],
};
const faBanParking = {
  prefix: 'fad',
  iconName: 'ban-parking',
  icon: [
    512,
    512,
    ['parking-circle-slash'],
    'f616',
    [
      'M168 261.3l0 26.7 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-26.7-64-64zm14.5-124L237.3 192l42.7 0c17.7 0 32 14.3 32 32c0 11.6-6.2 21.7-15.4 27.4L342.3 297c20.6-17.6 33.7-43.8 33.7-73c0-53-43-96-96-96l-72 0c-9.7 0-18.6 3.5-25.5 9.2z',
      'M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z',
    ],
  ],
};
const faParkingCircleSlash = faBanParking;
const faTentArrowTurnLeft = {
  prefix: 'fad',
  iconName: 'tent-arrow-turn-left',
  icon: [
    576,
    512,
    [],
    'e580',
    [
      'M64.4 475.3c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-5.7-4.4-12.6-6.5-19.4-6.5s-13.7 2.2-19.4 6.5l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160z',
      'M121.8 7.9c8.9 9.9 8.1 25-1.8 33.9L86.5 72 456 72c66.3 0 120 53.7 120 120l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-39.8-32.2-72-72-72L86.5 120l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72C2.9 109.3 0 102.8 0 96s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z',
    ],
  ],
};
const faFaceDiagonalMouth = {
  prefix: 'fad',
  iconName: 'face-diagonal-mouth',
  icon: [
    512,
    512,
    [129764],
    'e47e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128.6 372.4c-2.4-8.5 2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8l-224 64c-8.5 2.4-17.4-2.5-19.8-11zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faDiagramCells = {
  prefix: 'fad',
  iconName: 'diagram-cells',
  icon: [
    512,
    512,
    [],
    'e475',
    [
      'M0 352l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64z',
      'M448 224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0z',
    ],
  ],
};
const faCricketBatBall = {
  prefix: 'fad',
  iconName: 'cricket-bat-ball',
  icon: [
    512,
    512,
    [127951, 'cricket'],
    'f449',
    [
      'M.5 374.4c.8 11.3 2.8 28.6 8.2 46.4C13.8 438.1 22.9 457.9 39 473c15 16.2 34.9 25.2 52.2 30.4c17.8 5.4 35.1 7.4 46.4 8.2c16 1.1 30.4-5.6 40.4-15.6C236.7 437.3 295.3 378.6 353.9 320c-38 0-76 0-113.9 0c-26.5 0-48-21.5-48-48l0-113.9C133.3 216.7 74.7 275.3 16.1 334C6.1 344-.6 358.4 .5 374.4zM224 126.1L224 272c0 8.8 7.2 16 16 16c48.6 0 97.3 0 145.9 0c7.7-7.7 15.4-15.4 23-23c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17c-13.8-13.8-27.6-27.6-41.4-41.4c-15.1-15.1-30.2-30.2-45.3-45.3L281 103c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-7.7 7.7-15.4 15.4-23 23z',
      'M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-135 135 45.3 45.3 135-135c12.5-12.5 12.5-32.8 0-45.3zM385.9 288L240 288c-8.8 0-16-7.2-16-16l0-145.9-32 32L192 272c0 26.5 21.5 48 48 48l113.9 0 32-32zM512 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z',
    ],
  ],
};
const faCricket = faCricketBatBall;
const faTents = {
  prefix: 'fad',
  iconName: 'tents',
  icon: [
    640,
    512,
    [],
    'e582',
    [
      'M235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5L608 352c9.3 0 18.2-4.1 24.2-11.1c5-5.8 7.8-13.3 7.8-20.9c0-1.6-.1-3.2-.4-4.7l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128C429.7 2.2 422.8 0 416 0s-13.7 2.2-19.4 6.5L235.8 129.1z',
      'M204.6 166.5c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160c1.4 9.2-1.3 18.6-7.4 25.6s-14.9 11.1-24.2 11.1l-16 0-60.2 0c-12.1 0-23.2-6.8-28.6-17.7L242.7 357.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L224 480c0 17.7-14.3 32-32 32l-16 0L32 512c-9.3 0-18.2-4.1-24.2-11.1S-1 484.5 .4 475.3l24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128z',
    ],
  ],
};
const faWandMagic = {
  prefix: 'fad',
  iconName: 'wand-magic',
  icon: [
    512,
    512,
    ['magic'],
    'f0d0',
    [
      'M284.7 124.7l39.6 39.6 105-105 23.3 23.3-105 105c13.2 13.2 26.4 26.4 39.6 39.6c36.9-36.9 73.8-73.8 110.7-110.7c18.7-18.7 18.7-49.1 0-67.9L463.3 14.1C453.9 4.7 441.7 0 429.4 0s-24.6 4.7-33.9 14.1L284.7 124.7z',
      'M387.2 227.2L284.7 124.7 14.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L387.2 227.2z',
    ],
  ],
};
const faMagic = faWandMagic;
const faDog = {
  prefix: 'fad',
  iconName: 'dog',
  icon: [
    576,
    512,
    [128021],
    'f6d3',
    [
      'M303.9 192c37.3 21.4 74.7 42.8 112.1 64.1c1.9-11.3 3.7-22.5 5.6-33.7c-37.3-21.3-74.7-42.7-112-64c-1.9 11.2-3.7 22.3-5.7 33.5z',
      'M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32l52.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l56 0c13.3 0 24 10.7 24 24l0 24c0 44.2-35.8 80-80 80l-32 0-16 0-21.3 0-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-115.2c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2L160 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-230.2c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192l30 0 16 0 159.8 0L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faPenLine = {
  prefix: 'fad',
  iconName: 'pen-line',
  icon: [
    576,
    512,
    [],
    'e212',
    [
      'M224 488c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zM303 79C346.4 122.4 389.7 165.7 433 209c19.9-19.9 39.8-39.8 59.7-59.7c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0L303 79z',
      'M433 209L303 79 52.8 329.3c-6.6 6.6-11.5 14.8-14.1 23.8L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1L433 209z',
    ],
  ],
};
const faAtomSimple = {
  prefix: 'fad',
  iconName: 'atom-simple',
  icon: [
    512,
    512,
    ['atom-alt'],
    'f5d3',
    [
      'M55.7 55.7C16.5 94.9 27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zm45.3 45.3c1.3-1.3 16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64zm0 310.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zM314.2 117.9c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm0 276.2c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6z',
      'M224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faAtomAlt = faAtomSimple;
const faAmpersand = {
  prefix: 'fad',
  iconName: 'ampersand',
  icon: [
    448,
    512,
    [],
    '26',
    [
      'M180.7 96l38 0c20.6 0 37.3 16.7 37.3 37.3c0 11.8-5.5 22.8-14.9 29.9l-48 36-39-41.3c-6.4-6.8-10-15.8-10-25.2c0-20.3 16.4-36.7 36.7-36.7zm56.6 150l42.2-31.6C305 195.3 320 165.2 320 133.3C320 77.4 274.6 32 218.7 32l-38 0C125.1 32 80 77.1 80 132.7c0 25.7 9.8 50.4 27.5 69.1l34 36L74.7 288C47.8 308.1 32 339.8 32 373.3C32 432.2 79.8 480 138.7 480l74.5 0c37.4 0 72.4-18.7 93.2-49.9l6.9-10.4L360.7 470c12.1 12.8 32.4 13.4 45.2 1.3s13.4-32.4 1.3-45.2l-57.5-60.9 60.9-91.4c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9l-52.7 79.1L237.3 246zm-51.5 38.6L268.2 372l-15.1 22.6C244.2 408 229.2 416 213.2 416l-74.5 0C115.1 416 96 396.9 96 373.3c0-13.4 6.3-26.1 17.1-34.1l72.7-54.5z',
      '',
    ],
  ],
};
const faCarrot = {
  prefix: 'fad',
  iconName: 'carrot',
  icon: [
    512,
    512,
    [129365],
    'f787',
    [
      'M0 488c0 6.2 2.4 12.4 7 17c7.1 7.1 17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3C84.3 300.7 43.3 389.3 2.2 477.9C.7 481.1 0 484.6 0 488z',
      'M320 72c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 32-8 40-8 40s8-8 40-8c35.7 0 62.6 17.7 74 26.8c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80z',
    ],
  ],
};
const faArrowUpFromLine = {
  prefix: 'fad',
  iconName: 'arrow-up-from-line',
  icon: [
    384,
    512,
    [8613, 'arrow-from-bottom'],
    'f342',
    [
      'M0 448c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
      'M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 141.3l0 66.7 0 112c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-112 0-66.7L86.6 214.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128z',
    ],
  ],
};
const faArrowFromBottom = faArrowUpFromLine;
const faMoon = {
  prefix: 'fad',
  iconName: 'moon',
  icon: [
    384,
    512,
    [127769, 9214],
    'f186',
    [
      'M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z',
      '',
    ],
  ],
};
const faPenSlash = {
  prefix: 'fad',
  iconName: 'pen-slash',
  icon: [
    640,
    512,
    [],
    'e213',
    [
      'M64 488c0 6.3 2.5 12.4 7 17s10.7 7 17 7c2.3 0 4.5-.3 6.8-1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.6-88.6L195.8 250.3l-73.2 73.2c-10.4 10.4-18 23.3-22.2 37.4L65 481.2c-.7 2.2-1 4.5-1 6.8zM264.3 181.8c48.6 38.1 97.1 76.1 145.7 114.2l75.7-75.7L355.7 90.3l-91.5 91.5zM378.3 67.7L508.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L517.3 19.3C504.8 6.8 488.4 .6 472 .6s-32.8 6.2-45.3 18.7L378.3 67.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faWineGlassEmpty = {
  prefix: 'fad',
  iconName: 'wine-glass-empty',
  icon: [
    320,
    512,
    ['wine-glass-alt'],
    'f5ce',
    [
      'M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6l0 99.6-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0L64 0zM81.9 203.1L93.4 64l133.1 0 11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z',
      '',
    ],
  ],
};
const faWineGlassAlt = faWineGlassEmpty;
const faSquareStar = {
  prefix: 'fad',
  iconName: 'square-star',
  icon: [
    448,
    512,
    [],
    'e27f',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM79.4 209c-1.9 5.8-.3 12.1 4 16.4l58.6 57.2c-4.6 26.9-9.2 53.8-13.8 80.7c-1 6 1.4 12.1 6.4 15.6c2.8 2 6.1 3.1 9.4 3.1c2.5 0 5.1-.6 7.4-1.8c24.2-12.7 48.3-25.4 72.5-38.1c24.2 12.7 48.3 25.4 72.5 38.1c2.3 1.2 4.9 1.8 7.4 1.8c3.3 0 6.6-1 9.4-3.1c4.9-3.6 7.4-9.6 6.4-15.6c-4.6-26.9-9.2-53.8-13.8-80.7l58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9c-27-3.9-54-7.9-81-11.8c-12.1-24.5-24.2-49-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9c-12.1 24.5-24.2 49-36.2 73.4c-27 3.9-54 7.9-81.1 11.8c-6 .9-11 5.1-12.9 10.9z',
      'M238.3 112.9c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4L92.4 198.1c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2L224 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81-11.8-36.2-73.4z',
    ],
  ],
};
const faCheese = {
  prefix: 'fad',
  iconName: 'cheese',
  icon: [
    512,
    512,
    [],
    'f7ef',
    [
      'M0 256c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2l0 15.8L0 256z',
      'M0 256H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z',
    ],
  ],
};
const faSendBackward = {
  prefix: 'fad',
  iconName: 'send-backward',
  icon: [
    512,
    512,
    [],
    'f87f',
    [
      'M160 224l0 128 0 96c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0-128 0c-35.3 0-64 28.7-64 64zm64 0l224 0 0 224-224 0 0-224z',
      'M0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 96-128 0c-35.3 0-64 28.7-64 64l0 128-96 0c-35.3 0-64-28.7-64-64L0 64z',
    ],
  ],
};
const faYinYang = {
  prefix: 'fad',
  iconName: 'yin-yang',
  icon: [
    512,
    512,
    [9775],
    'f6ad',
    [
      'M128 384c0 70.7 57.3 128 128 128c141.4 0 256-114.6 256-256C512 115.9 399.4 2 259.8 0C328.7 2.1 384 58.6 384 128c0 70.7-57.3 128-128 128s-128 57.3-128 128zm96-256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M0 256C0 114.6 114.6 0 256 0c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128 57.3-128 128s57.3 128 128 128C114.6 512 0 397.4 0 256zM288 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
    ],
  ],
};
const faMusic = {
  prefix: 'fad',
  iconName: 'music',
  icon: [
    512,
    512,
    [127925],
    'f001',
    [
      'M128 128l0 72 0 156.6c37.3 11 64 40.6 64 75.4l0-208.2L448 147l0 145.5c37.3 11 64 40.6 64 75.4l0-264 0-72c0-10.1-4.8-19.6-12.9-25.7C493.5 2.2 486.8 0 480 0c-3.1 0-6.2 .4-9.2 1.3l-320 96C137.3 101.4 128 113.9 128 128z',
      'M416 448c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80zM96 512c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z',
    ],
  ],
};
const faCompassSlash = {
  prefix: 'fad',
  iconName: 'compass-slash',
  icon: [
    640,
    512,
    [],
    'f5e9',
    [
      'M64 256c0 141.4 114.6 256 256 256c55.2 0 106.3-17.5 148.1-47.2L317 345.8l-90.6 34.8c-19.4 7.5-38.5-11.6-31-31l29.4-76.5L82.3 160.8C70.5 190.2 64 222.4 64 256zM134.2 79.9l136 106.6 143.3-55.1c19.4-7.5 38.5 11.6 31 31L397.1 285.9c46.1 36.1 92.2 72.3 138.3 108.4C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faClockOne = {
  prefix: 'fad',
  iconName: 'clock-one',
  icon: [
    512,
    512,
    [],
    'e34e',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56.7 20-30c7.4-11 22.3-14 33.3-6.7c6.9 4.6 10.7 12.2 10.7 20c0 4.6-1.3 9.2-4 13.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23l0-136z',
      'M256 96c13.3 0 24 10.7 24 24l0 56.7 20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23l0-136c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faFileMusic = {
  prefix: 'fad',
  iconName: 'file-music',
  icon: [
    384,
    512,
    [],
    'f8b6',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 416c0 17.7 21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm-96 64c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z',
    ],
  ],
};
const faCodeCommit = {
  prefix: 'fad',
  iconName: 'code-commit',
  icon: [
    640,
    512,
    [],
    'f386',
    [
      'M0 256c0 17.7 14.3 32 32 32l131.2 0c-2.1-10.3-3.2-21-3.2-32c0-1.4 0-2.7 .1-4.1s.1-2.7 .2-4.1c.1-2.7 .3-5.4 .6-8.1c.5-5.3 1.3-10.6 2.4-15.8L32 224c-17.7 0-32 14.3-32 32zm476.8-32c2.1 10.3 3.2 21 3.2 32c0 1.4 0 2.7-.1 4.1s-.1 2.7-.2 4.1c-.1 2.7-.3 5.4-.6 8.1c-.5 5.3-1.3 10.6-2.4 15.8L608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-131.2 0z',
      'M320 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 240a160 160 0 1 0 0-320 160 160 0 1 0 0 320z',
    ],
  ],
};
const faTemperatureLow = {
  prefix: 'fad',
  iconName: 'temperature-low',
  icon: [
    512,
    512,
    [],
    'f76b',
    [
      'M0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L256 112C256 50.2 205.9 0 144 0S32 50.2 32 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368zm64 0c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5L96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM144 256c-8.8 0-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16z',
    ],
  ],
};
const faPersonBiking = {
  prefix: 'fad',
  iconName: 'person-biking',
  icon: [
    640,
    512,
    [128692, 'biking'],
    'f84a',
    [
      'M0 384a128 128 0 1 0 256 0A128 128 0 1 0 0 384zm200 0A72 72 0 1 1 56 384a72 72 0 1 1 144 0zm184 0a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm200 0a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z',
      'M400 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM365.4 111.2L427.2 160l52.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-7.3 0-14.3-2.5-20-7l-40.7-32.6L295 232.9l42.7 28.5c8.9 5.9 14.2 15.9 14.2 26.6l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-110.9-60.5-38.4c-32.8-20.8-35-67.9-4.3-91.6l83.1-64.2c17.4-13.5 41.8-13.3 59.1 .3z',
    ],
  ],
};
const faBiking = faPersonBiking;
const faDisplayChartUpCircleCurrency = {
  prefix: 'fad',
  iconName: 'display-chart-up-circle-currency',
  icon: [
    640,
    512,
    [],
    'e5e5',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l234.8 0C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16L64 352 64 64l448 0 0 128.7c22.9 2.1 44.5 8.5 64 18.5L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2l0-72.7c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM460.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426c-21.6 13.2-49.1 13.2-70.7 0z',
    ],
  ],
};
const faSkeleton = {
  prefix: 'fad',
  iconName: 'skeleton',
  icon: [
    512,
    512,
    [],
    'f620',
    [
      'M0 192c0 17.7 14.3 32 32 32l192 0 0-64L32 160c-17.7 0-32 14.3-32 32zM64 96c0 17.7 14.3 32 32 32l128 0 0-64L96 64C78.3 64 64 78.3 64 96zM96 288c0 17.7 14.3 32 32 32l96 0 0-64-96 0c-17.7 0-32 14.3-32 32zM288 64l0 64 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 64zm0 96l0 64 192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0zm0 96l0 64 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z',
      'M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 354.3-67.5-28.9c-8.3-3.5-17.2-5.4-26.1-5.4C93.7 352 64 381.7 64 418.4l0 1.5c0 18 7.2 35.3 19.9 48l25.8 25.8c11.7 11.7 27.6 18.3 44.1 18.3l204.3 0c16.6 0 32.4-6.6 44.1-18.3l25.8-25.8c12.7-12.7 19.9-30 19.9-48l0-1.5c0-36.7-29.7-66.4-66.4-66.4c-9 0-17.9 1.8-26.1 5.4L288 386.3 288 32zM136 440a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faCircleG = {
  prefix: 'fad',
  iconName: 'circle-g',
  icon: [
    512,
    512,
    [],
    'e10f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L280 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M256 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L280 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176z',
    ],
  ],
};
const faCircleArrowUpLeft = {
  prefix: 'fad',
  iconName: 'circle-arrow-up-left',
  icon: [
    512,
    512,
    [],
    'e0fb',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-88c0-13.3 10.7-24 24-24l152 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L361 327c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-135-135L192 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160z',
      'M168 144l152 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L361 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135L192 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faCoinBlank = {
  prefix: 'fad',
  iconName: 'coin-blank',
  icon: [
    512,
    512,
    [],
    'e3fb',
    [
      'M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144s-114.6-144-256-144S0 128.5 0 208z',
      'M48 331c-18.3-11.5-34.8-25.2-48-40.9L0 320c0 27.9 17.8 53.6 48 74.6L48 331zm32 17.3L80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29zM256 448c-16.4 0-32.5-.8-48-2.2l0-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4l0 64.1c-15.5 1.5-31.6 2.2-48 2.2zm80-70.7l0 64.3c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29zM512 320c0 27.9-17.8 53.6-48 74.6l0-63.7c18.3-11.5 34.8-25.2 48-40.9l0 29.9z',
    ],
  ],
};
const faBroom = {
  prefix: 'fad',
  iconName: 'broom',
  icon: [
    576,
    512,
    [129529],
    'f51a',
    [
      'M329.4 201.4c15.1 15.1 30.2 30.2 45.3 45.3l192-192c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6S552.2 0 544 0s-16.4 3.1-22.6 9.4l-192 192z',
      'M409.4 281.4L294.6 166.6c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6l0 29.1L364.3 320l29.1 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16zm-68.3 72L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l29.9-15c8.3-4.2 15.9 6.9 8.9 13.1L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z',
    ],
  ],
};
const faVacuum = {
  prefix: 'fad',
  iconName: 'vacuum',
  icon: [
    640,
    512,
    [],
    'e04d',
    [
      'M352 192l0 133.5c10-3.5 20.8-5.5 32-5.5c53 0 96 43 96 96s-43 96-96 96l160 0c35.3 0 64-28.7 64-64l0-128c0-31.7-7.7-61.7-21.3-88c-9.9-19.2-23-36.5-38.5-51.2C513.8 148.1 467.2 128 416 128c-35.3 0-64 28.7-64 64z',
      'M301.6 64L512 64c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.8 52.8c15.5 14.7 28.6 32 38.5 51.2C619 208.7 640 170.8 640 128C640 57.3 582.7 0 512 0L301.6 0C241.3 0 189.1 42.2 176.4 101.2L150.1 224l65.5 0L239 114.6C245.4 85.1 271.4 64 301.6 64zM208.7 256l-65.5 0L109 416l-25.2 0c-33.8 0-64.7 18.9-80 49C1.4 469.5 0 474.6 0 480c0 17.7 14.3 32 32 32l95.4 0c.4 0 .9 0 1.3 0l47.3 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-1.6 0 34.3-160zM384 512a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faShieldHeart = {
  prefix: 'fad',
  iconName: 'shield-heart',
  icon: [
    512,
    512,
    [],
    'e574',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zm352 81.8c0-.4 0-.3 0 0z',
      'M205.3 160c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z',
    ],
  ],
};
const faCardHeart = {
  prefix: 'fad',
  iconName: 'card-heart',
  icon: [
    384,
    512,
    [],
    'e3eb',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM97.4 264.3C72.9 239 74.2 197 101.7 173.4c23.6-20.5 59.9-16.6 81.7 5.7l8.7 9.2 8.3-9.2c21.8-22.3 57.7-26.2 82.2-5.7c27.1 23.6 28.4 65.6 3.9 90.9l-84.3 87.4c-2.8 2.8-6.6 4.3-10.2 4.3s-7.3-1.4-9.9-4.3L97.4 264.3z',
      'M286.6 264.3l-84.3 87.4c-5.7 5.7-14.9 5.7-20.1 0L97.4 264.3C72.9 239 74.2 197 101.7 173.4c23.6-20.5 59.9-16.6 81.7 5.7l8.7 9.2 8.3-9.2c21.8-22.3 57.7-26.2 82.2-5.7c27.1 23.6 28.4 65.6 3.9 90.9z',
    ],
  ],
};
const faLightbulbCflOn = {
  prefix: 'fad',
  iconName: 'lightbulb-cfl-on',
  icon: [
    640,
    512,
    [],
    'e5a7',
    [
      'M160 64c0 2.6 .3 5.2 1 7.8c4.3 17.1 21.7 27.6 38.8 23.3l128-32c17.1-4.3 27.6-21.7 23.3-38.8S329.4-3.3 312.2 1l-128 32C169.7 36.6 160 49.6 160 64zm0 96c0 2.6 .3 5.2 1 7.8c4.3 17.1 21.7 27.6 38.8 23.3l256-64c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64c-14.5 3.6-24.2 16.7-24.2 31zm0 96c0 2.6 .3 5.2 1 7.8c4.3 17.1 21.7 27.6 38.8 23.3L256 273l3.9-1 195.8-49c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64c-14.5 3.6-24.2 16.7-24.2 31zm96 50l0 78 48 0 0-90-48 12zm80.2-2c-.2 1.1-.2 2.2-.2 3.3c0 .5 0 .9 0 1.4l0 75.3 48 0 0-47 7.8-1.9 64-16c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-64 16-16 4c-13.2 3.3-22.4 14.3-24 27z',
      'M53.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S42.3-3.3 53.3 4zM613.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM101.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm464-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM224 416c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l-32 0c-17.7 0-32-14.3-32-32l0-32z',
    ],
  ],
};
const faMelon = {
  prefix: 'fad',
  iconName: 'melon',
  icon: [
    512,
    512,
    [],
    'e310',
    [
      'M0 256c0 38.5 8.5 75 23.7 107.7c5.8-67.1 48.2-149.8 119.2-220.8s153.8-113.4 220.8-119.2C331 8.5 294.5 0 256 0C114.6 0 0 114.6 0 256zm62.8 72.8c-14.8 51.9-7.2 88.3 11.8 107.9c.3 .3 .5 .5 .6 .6c19.4 19.1 55.8 26.8 108 11.9c51.2-14.6 110.2-49.6 163.3-102.7s88.1-112.1 102.7-163.3c15-52.4 7.1-88.9-12.2-108.2s-55.9-27.2-108.2-12.2c-51.2 14.6-110.2 49.6-163.3 102.7S77.4 277.6 62.8 328.8zm85.5 159.5C181 503.5 217.5 512 256 512c141.4 0 256-114.6 256-256c0-38.5-8.5-75-23.7-107.7c-5.8 67.1-48.2 149.8-119.2 220.8s-153.8 113.4-220.8 119.2z',
      'M363.7 23.7c54.8 25.5 99.2 69.8 124.6 124.6c-5.8 67.1-48.2 149.8-119.2 220.8s-153.8 113.4-220.8 119.2c-27.3-12.7-52-30-73.1-51c19.4 19.1 55.8 26.8 108 11.9c51.2-14.6 110.2-49.6 163.3-102.7s88.1-112.1 102.7-163.3c15-52.4 7.1-88.9-12.2-108.2s-55.9-27.2-108.2-12.2c-51.2 14.6-110.2 49.6-163.3 102.7S77.4 277.6 62.8 328.8c-14.9 52.1-7.2 88.6 11.9 108c-21-21.1-38.4-45.8-51-73.1c5.8-67.1 48.2-149.8 119.2-220.8s153.8-113.4 220.8-119.2z',
    ],
  ],
};
const faGopuram = {
  prefix: 'fad',
  iconName: 'gopuram',
  icon: [
    512,
    512,
    [],
    'f664',
    [
      'M96 352l0 160 32 0 0-160-32 0zm32-128l0 128 32 0 0-128-32 0zm32-96l0 96 32 0 0-96-32 0zm160 0l0 96 32 0 0-96-32 0zm32 96l0 128 32 0 0-128-32 0zm32 128l0 160 32 0 0-160-32 0z',
      'M120 0c13.3 0 24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 32 0 64c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0 0-160-32 0 0-128-32 0 0-96-32 0 0 96 32 0 0 128 32 0 0 160-80 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48-80 0 0-160 32 0 0-128 32 0 0-96-32 0 0 96-32 0 0 128-32 0 0 160-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-96c0-17.7 14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l0-64 0-32 0-8c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-32-80l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
    ],
  ],
};
const faEarthOceania = {
  prefix: 'fad',
  iconName: 'earth-oceania',
  icon: [
    512,
    512,
    ['globe-oceania'],
    'e47b',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm83.4 66.7c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9c3.5-4.7 6.9-9.5 10.4-14.2c2-2.8 5.2-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8c3.4 8.6 6.7 17.3 10.1 25.9c2.8 7.2 6.7 14 11.5 20.2l18 22.9c2.9 3.7 5.1 7.9 6.7 12.2c.8 2.2 1.3 4.5 1.7 6.8c.2 1.2 .3 2.4 .4 3.6c0 .6 .1 1.1 .1 1.6c0 .5 0 1 0 1.2l0 .5 0 .5c0 .3 0 .8 0 1.5c0 .5-.1 1-.1 1.5c-.1 1.1-.2 2.3-.4 3.5c-.4 2.3-1 4.5-1.7 6.7c-1.5 4.4-3.8 8.5-6.7 12.3c-4 5.1-8 10.3-12.1 15.4c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7c-8.5-5.5-16.9-10.9-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4c-13-4.5-26-9-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3c-5.1 1.6-10.2 3.2-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5c-1.1-2.1-2.2-4.2-3.3-6.2zM195.7 169.5c-14.3-6.3-11.9-27.2 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3c-10 0-19.9 0-29.9 0c-5.6 0-11.1-1.2-16.2-3.4c-14.3-6.3-28.5-12.7-42.8-19zM248 432c0-8.8 7.2-16 16-16l16 0c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.8c0 .5 0 1-.1 1.5c-.1 .5-.1 1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7l-16 0c-8.8 0-16-7.2-16-16zm108.7-43.3l32-32c6.2-6.2 16.4-6.2 22.6 0c6.2 6.3 6.2 16.4 0 22.6c-10.7 10.7-21.3 21.3-32 32c-6.2 6.2-16.4 6.2-22.6 0c-6.2-6.4-6.2-16.4 0-22.6zm44.1-79.6c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1c2.7 8 5.3 16 8 24c.3 .8 .5 1.7 .6 2.5c.1 .6 .2 1.2 .1 1.2l.1 1.3c0 .8 0 1-.1 1.3c0 .4-.1 .8-.1 1.2c-.1 .8-.3 1.6-.6 2.4c-.5 1.6-1.2 3-2.2 4.4c-1.9 2.7-4.6 4.8-8 5.9c-8.4 2.8-17.4-1.7-20.2-10.1c-2.7-8-5.3-16-8-24z',
      'M273.8 142.5c-9.5-9.5-23-13.6-36.1-10.9l-38.5 7.7c-15.3 3.1-17.6 24-3.4 30.3l42.8 19c5.1 2.3 10.6 3.4 16.2 3.4l29.9 0c14.3 0 21.4-17.2 11.3-27.3l-22.2-22.2zM169.6 343.8l39 13.5c2.4 .8 4.7 2 6.9 3.4L240.9 377c7.1 4.6 15.3 7 23.7 7c13.4 0 26.1-6.2 34.4-16.8L311 351.8c5.8-7.4 9-16.6 9-26s-3.2-18.6-9-26l-17.9-22.9c-4.8-6.1-8.7-12.9-11.5-20.2l-10.1-25.9c-1.6-4.1-5.6-6.8-10-6.8c-3.4 0-6.7 1.6-8.7 4.4l-10.4 14.2c-4.7 6.4-12.7 9.5-20.4 7.9c-3.2-.7-6.1-2.5-8.1-5.1l-4.6-6.1c-7.2-9.6-18.6-15.3-30.6-15.3s-23.4 5.7-30.6 15.3l-5.3 7c-1.6 2.1-3.6 3.7-5.9 4.8l-35.3 16.8c-20.5 9.8-28.8 34.6-18.2 54.7l3.3 6.2c9 17.1 29 25.4 47.5 19.5l15.3-4.9c6.6-2.1 13.6-2 20.1 .3zM248 432c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM431.2 298.9c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l8 24c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-8-24zm-19.9 80.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z',
    ],
  ],
};
const faGlobeOceania = faEarthOceania;
const faContainerStorage = {
  prefix: 'fad',
  iconName: 'container-storage',
  icon: [
    640,
    512,
    [],
    'f4b7',
    [
      'M32 96l0 320 576 0 0-320L32 96zm96 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm112 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm112 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm112 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z',
      'M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z',
    ],
  ],
};
const faFacePouting = {
  prefix: 'fad',
  iconName: 'face-pouting',
  icon: [
    512,
    512,
    [],
    'e387',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112.8-69.1c2.8-8.4 11.9-12.9 20.2-10.1c32 10.7 64 21.3 96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1c-3.6-1.2-7.2-2.4-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6c-10.2-3.4-20.5-6.8-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2zm48.5 195.2c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8c-12.4 5.2-26.5-4.1-21.1-16.4zM272.8 229.1c-2.8-8.4 1.7-17.4 10.1-20.2c32-10.7 64-21.3 96-32c8.4-2.8 17.4 1.7 20.2 10.1c.6 1.7 .8 3.4 .8 5.1c0 6.7-4.2 12.9-10.9 15.2c-10.1 3.4-20.1 6.7-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7c-3.9 1.3-7.8 2.6-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1z',
      'M133.1 176.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32zm256 30.4c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1z',
    ],
  ],
};
const faSquareXmark = {
  prefix: 'fad',
  iconName: 'square-xmark',
  icon: [
    448,
    512,
    [10062, 'times-square', 'xmark-square'],
    'f2d3',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM136.1 317.7c.1-.7 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.4 31.4 47 47c15.7-15.7 31.4-31.4 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.3 31.4-47 47c15.7 15.7 31.4 31.4 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.3 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.2-1.1-.4-2.3-.3-2.2c-.1-1.2-.1-1.2-.1-2.4c0-1.5 .1-1.9 .1-2.3z',
      'M177 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faTimesSquare = faSquareXmark;
const faXmarkSquare = faSquareXmark;
const faFaceExplode = {
  prefix: 'fad',
  iconName: 'face-explode',
  icon: [
    512,
    512,
    ['exploding-head'],
    'e2fe',
    [
      'M0 253.5c0 .8 0 1.7 0 2.5C0 397.4 114.6 512 256 512s256-114.6 256-256c0-.8 0-1.7 0-2.5l-30.5 11.7c-14.1 5.4-29.9 3.9-42.7-4.1l-20.7-12.9c-2.6-1.6-5.5-2.4-8.5-2.4s-5.9 .8-8.5 2.4L383.8 259c-15.6 9.7-35.3 9.7-50.9 0l-17.3-10.8c-2.6-1.6-5.5-2.4-8.5-2.4s-5.9 .8-8.5 2.4L281.4 259c-15.6 9.7-35.3 9.7-50.9 0l-17.3-10.8c-2.6-1.6-5.5-2.4-8.5-2.4s-5.9 .8-8.5 2.4L179 259c-15.6 9.7-35.3 9.7-50.9 0l-17.3-10.8c-2.6-1.6-5.5-2.4-8.5-2.4s-5.9 .8-8.5 2.4L73.2 261.1c-12.8 8-28.6 9.5-42.7 4.1L0 253.5zM208.4 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM192 437.3c0-29.5 23.9-53.3 53.3-53.3l21.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7l-106.7 0c-5.9 0-10.7-4.8-10.7-10.7zM368.4 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M320 197.3c0 7.3 2.1 14.3 5.9 20.2c-14.3-6.1-30.8-4.9-44.2 3.5l-17.3 10.8c-5.2 3.2-11.8 3.2-17 0L230.2 221c-13.4-8.4-29.9-9.5-44.2-3.5c3.8-6 5.9-13 5.9-20.2l0-5.3c0-17.7-14.3-32-32-32l-40 0c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56l-40 0c-17.7 0-32 14.3-32 32l0 5.3zM144.4 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faExplodingHead = faFaceExplode;
const faHashtag = {
  prefix: 'fad',
  iconName: 'hashtag',
  icon: [
    448,
    512,
    [62098],
    '23',
    [
      'M80.4 442.7c3.3-19.6 6.5-39.2 9.8-58.7c3.6-21.3 7.1-42.7 10.7-64c7.1-42.7 14.2-85.3 21.3-128c21.6 0 43.3 0 64.9 0c-7.1 42.7-14.2 85.3-21.3 128l-10.7 64c-3.8 23.1-7.7 46.2-11.5 69.3C141 468.9 127.4 480 112 480c-1.7 0-3.5-.1-5.3-.4c-17.4-2.9-29.2-19.4-26.3-36.8zM132.9 128l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L197.8 128l-64.9 0zM240.4 442.7l9.8-58.7 64.9 0-11.5 69.3C301 468.9 287.4 480 272 480c-1.7 0-3.5-.1-5.3-.4c-17.4-2.9-29.2-19.4-26.3-36.8zM260.9 320c7.1-42.7 14.2-85.3 21.3-128l10.7-64c3.8-23.1 7.7-46.2 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3C356.9 35.1 368 48.6 368 64c0 1.7-.1 3.5-.4 5.3c-3.3 19.6-6.5 39.2-9.8 58.7c-3.6 21.3-7.1 42.7-10.7 64c-7.1 42.7-14.2 85.3-21.3 128l-64.9 0z',
      'M292.9 128L64 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l218.2 0 10.7-64zm54.2 64l68.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-58.2 0-10.7 64zm-192 192L384 384c17.7 0 32-14.3 32-32s-14.3-32-32-32l-218.2 0-10.7 64zm-54.2-64L32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l58.2 0 10.7-64z',
    ],
  ],
};
const faUpRightAndDownLeftFromCenter = {
  prefix: 'fad',
  iconName: 'up-right-and-down-left-from-center',
  icon: [
    512,
    512,
    ['expand-alt'],
    'f424',
    [
      'M0 344L0 488c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-39-39 87-87c4.7-4.7 7-10.8 7-17s-2.3-12.3-7-17l-32-32c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7l-87 87L41 327c-6.9-6.9-17.2-8.9-26.2-5.2S0 334.3 0 344z',
      'M488 0L344 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-87 87c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l87-87 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-144c0-13.3-10.7-24-24-24z',
    ],
  ],
};
const faExpandAlt = faUpRightAndDownLeftFromCenter;
const faOilCan = {
  prefix: 'fad',
  iconName: 'oil-can',
  icon: [
    640,
    512,
    [],
    'f613',
    [
      'M160 96c0 17.7 14.3 32 32 32l32 0 0 32 64 0 0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64c-17.7 0-32 14.3-32 32z',
      'M368.9 160c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7L144 416c-26.5 0-48-21.5-48-48l0-21.3-67.5-30C11.2 309 0 291.8 0 272.8L0 208c0-26.5 21.5-48 48-48l48 0 48 0 224.9 0zM96 208l-48 0 0 64.8 48 21.3L96 208z',
    ],
  ],
};
const faT = {
  prefix: 'fad',
  iconName: 't',
  icon: [
    384,
    512,
    [116],
    '54',
    [
      'M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l128 0 0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 32 32 32z',
      '',
    ],
  ],
};
const faTransformerBolt = {
  prefix: 'fad',
  iconName: 'transformer-bolt',
  icon: [
    384,
    512,
    [],
    'e2a4',
    [
      'M48 48c0 8.8 7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-8c0-13.3-10.7-24-24-24S88 10.7 88 24l0 8L64 32c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zM97 341.6c2.3 6.3 8.3 10.4 15 10.4l57.8 0-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4l-57.8 0 25-74.9c2.3-6.8-.3-14.3-6.3-18.3s-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7zM208 48c0 8.8 7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-24 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z',
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 224c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-224c-17.7 0-32-14.3-32-32zm232.9 34.7c-6-4-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4l57.8 0-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4l-57.8 0 25-74.9c2.3-6.8-.3-14.3-6.3-18.3z',
    ],
  ],
};
const faHippo = {
  prefix: 'fad',
  iconName: 'hippo',
  icon: [
    640,
    512,
    [129435],
    'f6ed',
    [
      'M0 360c0 9.2 5.3 18 14.3 21.9c12.1 5.4 26.3-.1 31.7-12.2L64 329.1 64 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-76c19.8 7.7 41.4 12 64 12s44.2-4.3 64-12l0 76c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64-32 0c-17.7 0-32-14.3-32-32l0-10.8c-37.8-18-64-56.5-64-101.2c0-8.8 7.2-16 16-16s16 7.2 16 16c0 24.9 11.3 47.1 29.1 61.7c.9 .8 1.9 1.5 2.9 2.3c9.3 7 20.2 12 32 14.4c5.2 1 10.5 1.6 16 1.6l48 0 64 0 16 0c18 0 34.6-6 48-16c19.4-14.6 32-37.8 32-64c0-32.5-19.4-60.5-47.3-73c-9.3-4.2-16.7-12.7-16.7-23c0-15.4-4.4-29.9-12-42.1L577 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L527.6 70.5C517.9 66.3 507.2 64 496 64l-32 0c-2 0-3.9 .1-5.8 .2L441 47c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-9.4 9.4-9.4 24.6 0 33.9l3.5 3.5c-1.9 1.7-3.6 3.4-5.3 5.2C371.4 76.1 329.7 64 288 64l-32 0-24.8 0L224 64C117.2 68 32 155.7 32 263.2c0 13-2.7 25.8-8 37.7L2.1 350.3C.7 353.4 0 356.7 0 360zM480 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-31.7-91.2c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.5-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1-.1-1.3l0-.4 0-.4c0-.3 0-.8 .1-1.3c.1-.5 .1-1 .2-1.6zm64 0c.2-1 .5-2 .9-3c.8-1.9 2-3.6 3.4-5.1c2.9-2.9 6.9-4.7 11.3-4.7c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.4-1.8-11.3-4.7c-1.4-1.5-2.6-3.2-3.4-5.1c-.4-1-.7-2-.9-3c-.1-.5-.2-1.1-.2-1.6s-.1-1-.1-1.3l0-.4 0-.4c0-.3 0-.8 .1-1.3c.1-.5 .1-1 .2-1.6zM592 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 176l-16 0 0 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c-13.4 10-30 16-48 16zm-128 0c-5.5 0-10.8-.6-16-1.6l0 17.6c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-16-48 0z',
    ],
  ],
};
const faChartColumn = {
  prefix: 'fad',
  iconName: 'chart-column',
  icon: [
    512,
    512,
    [],
    'e0e3',
    [
      'M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64z',
      'M480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224zM288 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zm160-64c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faCassetteVhs = {
  prefix: 'fad',
  iconName: 'cassette-vhs',
  icon: [
    576,
    512,
    [128252, 'vhs'],
    'f8ec',
    [
      'M0 128L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM80 304c0-30.3 10.5-58.1 28.1-80l51.9 0 0 34.7 0 90.5 0 34.7-51.9 0C90.5 362.1 80 334.3 80 304zm144-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96zm192-32l51.9 0c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80L416 384l0-34.7 0-90.5 0-34.7z',
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 32L0 128 0 96zM160 384l-51.9 0C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80l51.9 0 0 34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3l0 34.7zm307.9 0L416 384l0-34.7c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3l0-34.7 51.9 0c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80z',
    ],
  ],
};
const faVhs = faCassetteVhs;
const faInfinity = {
  prefix: 'fad',
  iconName: 'infinity',
  icon: [
    640,
    512,
    [8734, 9854],
    'f534',
    [
      'M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1l0 29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9l0-29.7zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1l0 29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1l0-29.7c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z',
      '',
    ],
  ],
};
const faVialCircleCheck = {
  prefix: 'fad',
  iconName: 'vial-circle-check',
  icon: [
    512,
    512,
    [],
    'e596',
    [
      'M0 64C0 81.7 14.3 96 32 96l0 288c0 53 43 96 96 96c32.6 0 61.5-16.3 78.8-41.2C197.3 417.1 192 393.2 192 368c0-37.7 11.8-72.6 32-101.2L224 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0L96 32 32 32C14.3 32 0 46.3 0 64zM96 96l64 0 0 96-64 0 0-96z',
      'M368 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faChimney = {
  prefix: 'fad',
  iconName: 'chimney',
  icon: [
    448,
    512,
    [],
    'f78b',
    [
      'M32 192l0 128 96 0 0-128-96 0zm0 160l0 128 256 0 0-128L32 352zM160 192l0 128 256 0 0-128-256 0zM320 352l0 128 96 0 0-128-96 0z',
      'M32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 32z',
    ],
  ],
};
const faObjectIntersect = {
  prefix: 'fad',
  iconName: 'object-intersect',
  icon: [
    512,
    512,
    [],
    'e49d',
    [
      'M64 64l224 0 0 96 64 0 0 64 96 0 0 224-224 0 0-96-64 0 0-64-96 0L64 64zm96 288l0 96c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0-96c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l96 0z',
      'M160 224c0-35.3 28.7-64 64-64H352V288c0 35.3-28.7 64-64 64H160V224z',
    ],
  ],
};
const faPersonArrowDownToLine = {
  prefix: 'fad',
  iconName: 'person-arrow-down-to-line',
  icon: [
    640,
    512,
    [],
    'e538',
    [
      'M32 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L120 256.9 120 448l64 0 0-96 16 0 0 96 64 0 0-191.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c10-6 15.5-16.6 15.5-27.5c0-5.6-1.5-11.3-4.6-16.5l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C33.5 276.7 32 282.4 32 288zM144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M496 32c-17.7 0-32 14.3-32 32l0 242.7-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7 528 64c0-17.7-14.3-32-32-32zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z',
    ],
  ],
};
const faVoicemail = {
  prefix: 'fad',
  iconName: 'voicemail',
  icon: [
    640,
    512,
    [],
    'f897',
    [
      'M96 240a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144l352 0c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80l-112.5 0zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faBlockBrick = {
  prefix: 'fad',
  iconName: 'block-brick',
  icon: [
    448,
    512,
    ['wall-brick'],
    'e3db',
    [
      'M0 96l0 16 64 0 0-80C28.7 32 0 60.7 0 96zm0 48l0 96 208 0 0-96L0 144zM0 272l0 96 64 0 0-96L0 272zM0 400l0 16c0 35.3 28.7 64 64 64l144 0 0-80L0 400zM96 32l0 80 256 0 0-80L96 32zm0 240l0 96 256 0 0-96L96 272zM240 144l0 96 208 0 0-96-208 0zm0 256l0 80 144 0c35.3 0 64-28.7 64-64l0-16-208 0zM384 32l0 80 64 0 0-16c0-35.3-28.7-64-64-64zm0 240l0 96 64 0 0-96-64 0z',
      'M64 112L0 112l0 32 208 0 0 96L0 240l0 32 64 0 0 96L0 368l0 32 208 0 0 80 32 0 0-80 208 0 0-32-64 0 0-96 64 0 0-32-208 0 0-96 208 0 0-32-64 0 0-80-32 0 0 80L96 112l0-80L64 32l0 80zM352 368L96 368l0-96 256 0 0 96z',
    ],
  ],
};
const faWallBrick = faBlockBrick;
const faFan = {
  prefix: 'fad',
  iconName: 'fan',
  icon: [
    512,
    512,
    [],
    'f863',
    [
      'M0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480l0 2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288l2.6 0c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32l0-2.6C288 13.2 274.8 0 258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224l-2.6 0C13.2 224 0 237.2 0 253.4zM288 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M256 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z',
    ],
  ],
};
const faBagsShopping = {
  prefix: 'fad',
  iconName: 'bags-shopping',
  icon: [
    576,
    512,
    [128717],
    'f847',
    [
      'M0 224L0 416c0 35.3 28.7 64 64 64l97.6 0c-1-5.2-1.6-10.5-1.6-16l0-160c0-44.2 35.8-80 80-80l208 0c0-35.3-28.7-64-64-64l-64 0 0-64c0-53-43-96-96-96s-96 43-96 96l0 64-64 0c-35.3 0-64 28.7-64 64zM176 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64-96 0 0-64zM288 336l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M256 256c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-256 0zm64 80l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 53-43 96-96 96s-96-43-96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faParagraphLeft = {
  prefix: 'fad',
  iconName: 'paragraph-left',
  icon: [
    384,
    512,
    ['paragraph-rtl'],
    'f878',
    [
      'M32 112c0 61.9 50.1 112 112 112l16 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 32 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 0 144 0C82.1 0 32 50.1 32 112z',
      'M128 384l0-46.4c0-9.7-7.9-17.6-17.6-17.6c-4.2 0-8.2 1.5-11.3 4.2l-93 78.7C2.2 406.1 0 410.9 0 416s2.2 9.9 6.1 13.2l93 78.7c3.2 2.7 7.2 4.2 11.3 4.2c9.7 0 17.6-7.9 17.6-17.6l0-46.4 224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0z',
    ],
  ],
};
const faParagraphRtl = faParagraphLeft;
const faPersonWalkingLuggage = {
  prefix: 'fad',
  iconName: 'person-walking-luggage',
  icon: [
    576,
    512,
    [],
    'e554',
    [
      'M35.7 442.5c0 11.1 5.7 21.8 16 27.7l55.4 32c5 2.9 10.5 4.3 16 4.3c11.1 0 21.8-5.7 27.7-16l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9c-2.5-1.5-5.3-2.1-8-2.1c-5.5 0-10.9 2.9-13.9 8l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-2.9 5-4.3 10.5-4.3 16z',
      'M384 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM350.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L505 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L471 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM292.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L292.7 398z',
    ],
  ],
};
const faCaravanSimple = {
  prefix: 'fad',
  iconName: 'caravan-simple',
  icon: [
    640,
    512,
    ['caravan-alt'],
    'e000',
    [
      'M64 160l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zm48 272a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM320 160l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
      'M80 32C35.8 32 0 67.8 0 112L0 336c0 44.2 35.8 80 80 80l1.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L576 416l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-160c0-88.4-71.6-160-160-160L80 32zM64 160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-64zm288-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faCaravanAlt = faCaravanSimple;
const faTurtle = {
  prefix: 'fad',
  iconName: 'turtle',
  icon: [
    576,
    512,
    [128034],
    'f726',
    [
      'M0 352c0 17.7 14.3 32 32 32l32 0 0 56c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-56 32 0 0 56c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-56.2c57.8-3.4 105.9-42.8 122.1-96c1.9 .2 3.9 .3 5.9 .3l32 0c35.3 0 64-28.7 64-64l0-16c0-53-43-96-96-96c-35.3 0-64 28.7-64 64l0 16 0 32 0 24c0 39.8-32.2 72-72 72l-32 0-48 0-112 0-48 0-72 0c-17.7 0-32 14.3-32 32zM512 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M384 249.2V208c0-97.2-78.8-176-176-176S32 110.8 32 208v41.2C32 270.6 49.4 288 70.8 288H345.2c21.4 0 38.8-17.4 38.8-38.8z',
    ],
  ],
};
const faPencilMechanical = {
  prefix: 'fad',
  iconName: 'pencil-mechanical',
  icon: [
    512,
    512,
    [],
    'e5ca',
    [
      'M365.5 66.5c5.1 1.9 9.8 4.9 13.8 8.9c19.1 19.1 38.2 38.3 57.4 57.4c.5 .5 1 1 1.4 1.5c.5 .5 .9 1.1 1.4 1.6c.9 1.1 1.7 2.2 2.4 3.3c1.5 2.3 2.7 4.8 3.7 7.3l55.1-55.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3L475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L365.5 66.5z',
      'M253.7 87.6c-3.1-3.1-8.2-3.1-11.3 0L137 193c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L208.4 53.7c21.9-21.9 57.3-21.9 79.2 0L317 83l7.7-7.7C331.9 68.1 341.8 64 352 64s20.1 4.1 27.3 11.3l57.4 57.4c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L184.8 439.2c-5.8 5.8-12.9 10-20.8 12.2L66.7 479.2 41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l25.7-25.7L60.6 348c2.2-7.8 6.4-15 12.2-20.8L283 117 253.7 87.6zM106.4 362.4L89.1 422.9l60.5-17.3-43.2-43.2z',
    ],
  ],
};
const faUpDown = {
  prefix: 'fad',
  iconName: 'up-down',
  icon: [
    256,
    512,
    [8597, 11021, 'arrows-alt-v'],
    'f338',
    [
      'M2 366.4c-3.8 8.7-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-96-96 0 0 96-56 0c-9.5 0-18.2 5.7-22 14.4z',
      'M128 0c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-56 0 0 96-96 0 0-96-56 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112C115 2.8 121.3 0 128 0z',
    ],
  ],
};
const faArrowsAltV = faUpDown;
const faCloudMoonRain = {
  prefix: 'fad',
  iconName: 'cloud-moon-rain',
  icon: [
    576,
    512,
    [],
    'f73c',
    [
      'M20.1 474.7l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3zm96 0l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3zm96 0l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3zm96 0l32-48c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3zm45.6-367.1C363.5 46.5 417 0 481.2 0c3.7 0 7.3 .2 10.9 .5c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1c0 48.1 39.4 87.4 88.4 87.4c5.2 0 10.3-.4 15.2-1.3c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1c-4.1 0-8.2-.2-12.3-.6c-11.1-23.1-29.9-41.8-53.1-52.7c-1.9-41.7-26.7-77.5-62.1-95.1z',
      'M367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96l271.9 0z',
    ],
  ],
};
const faBoothCurtain = {
  prefix: 'fad',
  iconName: 'booth-curtain',
  icon: [
    512,
    512,
    [],
    'f734',
    [
      'M0 64C0 28.7 28.7 0 64 0l96 0 0 64L64 64l0 416c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64zM448 0c35.3 0 64 28.7 64 64l0 416c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80 0-336 0-64z',
      'M160 0l96 0 96 0 96 0 0 400c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48L160 0z',
    ],
  ],
};
const faCalendar = {
  prefix: 'fad',
  iconName: 'calendar',
  icon: [
    448,
    512,
    [128197, 128198],
    'f133',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192z',
      'M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32z',
    ],
  ],
};
const faBoxHeart = {
  prefix: 'fad',
  iconName: 'box-heart',
  icon: [
    448,
    512,
    [],
    'f49d',
    [
      'M0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5L0 160zM240 32l0 128 208 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32z',
      'M448 160l-208 0 0-128-32 0 0 128L0 160 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256zM212.7 404.7l-77.3-77.3c-20.5-20.5-20.5-53.8 0-74.3s53.8-20.5 74.3 0L224 267.4l14.3-14.3c20.5-20.5 53.8-20.5 74.3 0s20.5 53.8 0 74.3l-77.3 77.3c-6.2 6.2-16.4 6.2-22.6 0z',
    ],
  ],
};
const faTrailer = {
  prefix: 'fad',
  iconName: 'trailer',
  icon: [
    640,
    512,
    [],
    'e041',
    [
      'M64 112l0 152.2c9.8-8.1 20.6-15.2 32-21L96 112c0-8.8-7.2-16-16-16s-16 7.2-16 16zM96 400a80 80 0 1 0 160 0A80 80 0 1 0 96 400zm64-288l0 112.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7L192 112c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 0l0 131.2c11.4 5.9 22.2 12.9 32 21L288 112c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 0l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 0l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M48 32C21.5 32 0 53.5 0 80L0 336c0 26.5 21.5 48 48 48l17.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L488 384l8 0 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-240c0-26.5-21.5-48-48-48L48 32zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21L64 112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faUserDoctorMessage = {
  prefix: 'fad',
  iconName: 'user-doctor-message',
  icon: [
    640,
    512,
    ['user-md-chat'],
    'f82e',
    [
      'M0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1l0 50.8c27.6 7.1 48 32.2 48 62l0 40c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-40c0-29.8 20.4-54.9 48-62l0-57.1c-6-.6-12.1-.9-18.3-.9l-91.4 0c-6.2 0-12.3 .3-18.3 .9l0 65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-59.1C54 332.9 0 401.3 0 482.3zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm24 296a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z',
      'M384 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-56-16 0c-26.5 0-48-21.5-48-48l0-128z',
    ],
  ],
};
const faUserMdChat = faUserDoctorMessage;
const faBahai = {
  prefix: 'fad',
  iconName: 'bahai',
  icon: [
    576,
    512,
    ['haykal'],
    'f666',
    [
      'M181.8 245.3l16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2c-4.4 4.4-8.8 8.7-13.2 13.1c6-1.6 12-3.2 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7c3.5 5.1 7.1 10.2 10.6 15.2l-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4c6 1.6 12 3.2 17.9 4.8c-4.4-4.4-8.8-8.7-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8c-5.1 3.6-10.1 7.1-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8c-1.6-6-3.2-12-4.8-18c-1.6 6-3.2 12-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9c-5.1-3.6-10.1-7.1-15.2-10.7c2.6 5.6 5.2 11.2 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9c-6.2 .5-12.3 1.1-18.5 1.6z',
      'M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z',
    ],
  ],
};
const faHaykal = faBahai;
const faLighthouse = {
  prefix: 'fad',
  iconName: 'lighthouse',
  icon: [
    640,
    512,
    [],
    'e612',
    [
      'M0 24c0 9.3 5.5 18.2 14.6 22.1l112 48c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-112-48C30.4 .6 27.2 0 24 0C14.7 0 5.8 5.4 1.9 14.5C.6 17.6 0 20.8 0 24zM0 232c0 3.2 .6 6.4 1.9 9.4c5.2 12.2 19.3 17.8 31.5 12.6l112-48c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6l-112 48C5.5 213.8 0 222.7 0 232zM196.4 104.1C202.3 114.3 213 120 224 120l0 40 64 0 0-72.3L320 69l32 18.7 0 72.3 64 0 0-40c11 0 21.7-5.7 27.6-15.9c8.9-15.3 3.7-34.9-11.5-43.8l-96-56c-10-5.8-22.3-5.8-32.2 0l-96 56c-15.3 8.9-20.4 28.5-11.5 43.8zM481.9 81.5c5.2 12.2 19.3 17.8 31.5 12.6l112-48c12.2-5.2 17.8-19.3 12.6-31.5S618.7-3.3 606.6 1.9l-112 48c-12.2 5.2-17.8 19.3-12.6 31.5zm0 93.1c-5.2 12.2 .4 26.3 12.6 31.5l112 48c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-112-48c-12.2-5.2-26.3 .4-31.5 12.6z',
      'M224 160s0 0 0 0l192 0s0 0 0 0c17.7 0 32 14.3 32 32c0 13.3-8.1 24.7-19.7 29.5L473.6 448l6.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.1 0L352 512l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-98.9 0L160 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l6.4 0 45.3-226.5C200.1 216.7 192 205.3 192 192c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faAmpGuitar = {
  prefix: 'fad',
  iconName: 'amp-guitar',
  icon: [
    512,
    512,
    [],
    'f8a1',
    [
      'M92.5 96l66.5 0c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8l66.5 0c-1.7-2.1-3.7-4.4-6-6.9c-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0s-92.5 28.8-121.6 53.8c-15 12.9-27.3 25.7-35.8 35.3c-2.3 2.6-4.3 4.9-6 6.9zM112 304a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96zm32 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 80l0 192L64 448l0-192 384 0z',
    ],
  ],
};
const faSdCard = {
  prefix: 'fad',
  iconName: 'sd-card',
  icon: [
    384,
    512,
    [],
    'f7c2',
    [
      'M112 88l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 0l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M320 0L141.3 0C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64zM160 88l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z',
    ],
  ],
};
const faVolumeSlash = {
  prefix: 'fad',
  iconName: 'volume-slash',
  icon: [
    640,
    512,
    [128263],
    'f2e2',
    [
      'M32 224l0 64c0 35.3 28.7 64 64 64l67.8 0L298.7 471.9c6 5.3 13.6 8.1 21.3 8.1c4.4 0 8.9-.9 13.1-2.8C344.6 472 352 460.6 352 448l0-74.7L82.9 161.3C53.8 167.4 32 193.1 32 224zm165.8-94.2C249.2 170 300.6 210.3 352 250.6L352 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L197.8 129.8zM410.8 185c-8.4 10.3-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4c12.7 10 25.5 20 38.2 29.9c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5zm60.5-74.5c-8.4 10.3-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5c12.6 9.9 25.3 19.8 37.9 29.7C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBorderBottom = {
  prefix: 'fad',
  iconName: 'border-bottom',
  icon: [
    448,
    512,
    [],
    'f84d',
    [
      'M0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 160zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 352zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z',
    ],
  ],
};
const faWifiWeak = {
  prefix: 'fad',
  iconName: 'wifi-weak',
  icon: [
    640,
    512,
    ['wifi-1'],
    'f6aa',
    [
      'M0 179.8c0 8 3 15.9 8.9 22.2c12.2 12.8 32.5 13.2 45.2 .9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9c6-6.2 8.9-14.2 8.9-22.2c0-8.4-3.3-16.8-9.8-23.1C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C3.3 163 0 171.4 0 179.8zM126.7 309.2c11.7 13.3 31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2z',
      'M256 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z',
    ],
  ],
};
const faWifi1 = faWifiWeak;
const faDragon = {
  prefix: 'fad',
  iconName: 'dragon',
  icon: [
    640,
    512,
    [128009],
    'f6d5',
    [
      'M1.5 246.8c3 6.4 9.9 10.1 16.9 9L171 232.3l-69.4 59.5c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4l269.8 0c-9.6-13.5-17.1-28.3-22.1-44c-2.5-7.8-4.4-15.9-5.7-24.1c-.7-4.1-1.1-8.3-1.5-12.4c-.2-2.1-.3-4.2-.4-6.2c-.1-2-.1-4-.1-5.9c0-.1 0-.2 0-.3c0-2.1 0-4.1 0-6.2L189.4 112.4c-18.2-12.1-42.2-10.4-58.5 4.1L5.4 228c-5.3 4.7-6.9 12.4-3.8 18.8z',
      'M300.1 111.5l51.9 13 0 57 0 45.5c0 42.4 16.9 83.1 46.9 113.1l44.4 44.4c3 3 4.7 7.1 4.7 11.4c0 8.4-6.4 15.4-14.7 16.1L29.5 448.1c-3.3 .3-6.6 1-9.5 2.2C11 454 4.2 461.5 1.4 470.7c-1 3.4-1.5 7-1.3 10.7c.2 3.8 1 7.3 2.3 10.7c3.6 9 11.2 15.8 20.4 18.6c3 .9 6.3 1.4 9.6 1.4L432 512l64 0 34.2 0C590.9 512 640 462.9 640 402.2c0-37.8-19.5-73-51.6-93.1L481.8 242.5c-21.1-13.2-33.8-36.2-33.8-61.1l0-21.5 32 0 13.3 13.3c12 12 28.3 18.7 45.3 18.7l21.5 0c26.5 0 48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L540.8 38.4C522.7 14.2 494.2 0 464 0L448 0 416 0 304 0c-6.9 0-13 4.4-15.2 10.9s.1 13.7 5.6 17.9l43.3 32.5L296.8 81.7c-6 3-9.5 9.4-8.7 16.1s5.5 12.2 12 13.8zM510.7 79.7C507.5 89.2 498.6 96 488 96c-13.3 0-24-10.7-24-24c0-1.3 .1-2.6 .3-3.9l46.4 11.6zm1.3-7.4l0-.6c0 .1 0 .2 0 .3s0 .2 0 .3z',
    ],
  ],
};
const faShoePrints = {
  prefix: 'fad',
  iconName: 'shoe-prints',
  icon: [
    640,
    512,
    [],
    'f54b',
    [
      'M0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zm128-64l0 128s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32z',
      'M256 32s96.3-32 160-32c96 0 224 48 224 128s-119.6 96-176 96c-48 0-76-16-104-32s-56-32-104-32l0-128zm-64 0l32 0 0 128-32 0c-35.3 0-64-28.7-64-64s28.7-64 64-64z',
    ],
  ],
};
const faCirclePlus = {
  prefix: 'fad',
  iconName: 'circle-plus',
  icon: [
    512,
    512,
    ['plus-circle'],
    'f055',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 0c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M232 280l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faPlusCircle = faCirclePlus;
const faFaceGrinTongueWink = {
  prefix: 'fad',
  iconName: 'face-grin-tongue-wink',
  icon: [
    512,
    512,
    [128540, 'grin-tongue-wink'],
    'f58b',
    [
      'M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm99.2-41.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4zM400 208a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM195.2 233.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM320 402.6l0 45.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-45.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6z',
    ],
  ],
};
const faGrinTongueWink = faFaceGrinTongueWink;
const faHandHolding = {
  prefix: 'fad',
  iconName: 'hand-holding',
  icon: [
    576,
    512,
    [],
    'f4bd',
    [
      'M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2c.3 0 .6 0 .9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z',
      '',
    ],
  ],
};
const faPlugCircleExclamation = {
  prefix: 'fad',
  iconName: 'plug-circle-exclamation',
  icon: [
    576,
    512,
    [],
    'e55d',
    [
      'M0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32c0 2.3-.3 4.6-.7 6.8C309.8 220 256 287.7 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 67.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.2C87 398 32 333.4 32 256l0-32c-17.7 0-32-14.3-32-32zM64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 96-64 0 0-96zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96-64 0 0-96z',
      'M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faLinkSlash = {
  prefix: 'fad',
  iconName: 'link-slash',
  icon: [
    640,
    512,
    ['chain-broken', 'chain-slash', 'unlink'],
    'f127',
    [
      'M17.9 346.5c0 37 14.1 74 42.4 102.3c28 28 65 42.4 102.3 42.4c29.3 0 58.7-8.9 84-26.9l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9L60.2 244.3C32 272.5 17.9 309.5 17.9 346.5zM185.7 120.3c17.7 13.9 35.5 27.8 53.2 41.7c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5c17.7 13.9 35.5 27.8 53.2 41.7C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7zM220.8 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3L220.8 270zM384.5 93.6c10.3 14.4 30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.9 8.6c31.5 31.5 31.5 82.5 0 114l-96 96c16.9 13.3 33.8 26.5 50.7 39.8l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faChainBroken = faLinkSlash;
const faChainSlash = faLinkSlash;
const faUnlink = faLinkSlash;
const faClone = {
  prefix: 'fad',
  iconName: 'clone',
  icon: [
    512,
    512,
    [],
    'f24d',
    [
      'M0 224L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-96-64 0 0 96L64 448l0-224 96 0 0-64-96 0c-35.3 0-64 28.7-64 64z',
      'M160 288c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288z',
    ],
  ],
};
const faPersonWalkingArrowLoopLeft = {
  prefix: 'fad',
  iconName: 'person-walking-arrow-loop-left',
  icon: [
    640,
    512,
    [],
    'e551',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6L68.7 398 9.4 457.4C3.1 463.6 0 471.8 0 480zM17.6 229.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c3.6 14.5 16.7 24.2 31 24.2c2.6 0 5.2-.3 7.8-1c17.1-4.3 27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8zM160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M486.6 454.6c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L461.3 320l18.7 0c53 0 96-43 96-96s-43-96-96-96l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-18.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3z',
    ],
  ],
};
const faArrowUpZA = {
  prefix: 'fad',
  iconName: 'arrow-up-z-a',
  icon: [
    576,
    512,
    ['sort-alpha-up-alt'],
    'f882',
    [
      'M304 448c0 11.7 6.5 23 17.7 28.6c15.8 7.9 35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3C521.5 471 528 459.7 528 448c0-4.8-1.1-9.7-3.4-14.3l-16-32-64-128C439.2 262.8 428.1 256 416 256s-23.2 6.8-28.6 17.7l-64 128-16 32c-2.3 4.6-3.4 9.5-3.4 14.3zM320 64c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L352 32c-17.7 0-32 14.3-32 32zm75.8 336L416 359.6 436.2 400l-40.4 0z',
      'M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32z',
    ],
  ],
};
const faSortAlphaUpAlt = faArrowUpZA;
const faFireFlameCurved = {
  prefix: 'fad',
  iconName: 'fire-flame-curved',
  icon: [
    384,
    512,
    ['fire-alt'],
    'f7e4',
    [
      'M0 316.2L0 320C0 426 86 512 192 512l17.7 0C306 512 384 434 384 337.7c0-67.5-27.6-132-76.4-178.6L222.9 78.2C213.4 69.1 208 56.6 208 43.5l0-22.1C208 9.6 198.4 0 186.7 0c-6.7 0-13 3.2-17.1 8.5l-16 21.3C137 52 128 79.1 128 106.8c0 33.9 13.5 66.7 37.5 90.7l38.6 38.6c12.7 12.7 19.9 30 19.9 48l0 3.9c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-89.4C96 186.1 85.9 176 73.4 176c-6 0-11.8 2.4-16 6.6l-3.5 3.5C19.4 220.6 0 267.4 0 316.2zM115.4 419.6c0-4.5 5.6-8.8 11.7-7.1c97.6 27.5 182.5-86.7 148.5-179.8c-1.5-4 2.3-8.2 5.7-8.2c1.1 0 2.3 .5 3.1 1.6c25.9 32 35.6 69.8 35.6 111.6C320 398.6 270.6 448 209.7 448L192 448c-27.4 0-52.8-8.6-73.7-23.3c-2.1-1.5-3-3.3-3-5.1z',
      'M127.1 412.6c-8.6-2.4-16.1 7-8.8 12.1C139.2 439.4 164.6 448 192 448l17.7 0C270.6 448 320 398.6 320 337.7c0-41.8-9.7-79.6-35.6-111.6c-3.6-4.4-10.8 1.4-8.8 6.6c34 93.1-50.9 207.4-148.5 179.8z',
    ],
  ],
};
const faFireAlt = faFireFlameCurved;
const faTornado = {
  prefix: 'fad',
  iconName: 'tornado',
  icon: [
    448,
    512,
    [127786],
    'f76f',
    [
      'M0 32C0 14.3 14.3 0 32 0L393.4 0C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16L370.8 77.2c-5.5 5.5-9.9 11.9-13 18.8L5 96C1.7 79.6 0 62.7 0 45.6L0 32zm13.6 96l338.6 0c1 12 5.4 23.5 12.6 33.1L412 224 72.4 224c-26.5-27.3-46.6-60.1-58.8-96zm96.6 128l322.5 0c10 20.4 15.3 43 15.3 65.9c0 10.2-1 20.2-3 30.1l-179.8 0c-6.7-6.6-14.3-12.4-22.5-17.3L126.2 266.2c-5.5-3.2-10.8-6.6-16-10.2zM288 384l146.6 0c-7.4 16.2-17.6 31.1-30.4 43.9l-78.2 78.2c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l5.9-35.7c3.9-23.5 .5-47.5-9.9-69z',
      'M13.6 128C10.1 117.6 7.2 106.9 5 96l352.8 0c-3.8 8.3-5.8 17.3-5.8 26.6c0 1.8 .1 3.6 .2 5.4L13.6 128zm96.6 128c-13.7-9.5-26.3-20.2-37.8-32L412 224l6 8c5.7 7.5 10.6 15.6 14.7 24l-322.5 0zM288 384c-.2-.5-.5-1-.7-1.5c-5.7-11.4-13.2-21.7-22.1-30.5L445 352c-2.3 11-5.8 21.8-10.4 32L288 384z',
    ],
  ],
};
const faFileCirclePlus = {
  prefix: 'fad',
  iconName: 'file-circle-plus',
  icon: [
    576,
    512,
    [58606],
    'e494',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faDeleteRight = {
  prefix: 'fad',
  iconName: 'delete-right',
  icon: [
    576,
    512,
    [],
    'e154',
    [
      'M0 128C0 92.7 28.7 64 64 64l306.7 0c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7L64 448c-35.3 0-64-28.7-64-64L0 128zM136.1 317.7c0 .4-.1 .8-.1 2.3c0 1.2 0 1.2 .1 2.4c0 0 .1 1.1 .3 2.2c.3 1.5 .7 3 1.3 4.4c1.2 2.9 2.9 5.6 5.3 7.9c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7c15.7-15.7 31.4-31.4 47-47l47 47c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7s7-10.8 7-17s-2.3-12.3-7-17c-15.7-15.7-31.4-31.4-47-47c15.7-15.7 31.4-31.4 47-47c9.4-9.4 9.4-24.6 0-33.9c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-15.7 15.7-31.4 31.4-47 47c-15.7-15.7-31.4-31.4-47-47c-4.7-4.7-10.8-7-17-7s-12.3 2.3-17 7c-9.4 9.4-9.4 24.6 0 33.9c15.7 15.7 31.4 31.4 47 47c-15.7 15.7-31.4 31.4-47 47c-2.3 2.3-4.1 5.1-5.3 7.9c-.6 1.4-1 2.9-1.3 4.4c-.1 .8-.3 1.5-.3 2.3z',
      'M177 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faBookQuran = {
  prefix: 'fad',
  iconName: 'book-quran',
  icon: [
    448,
    512,
    ['quran'],
    'f687',
    [
      'M32 384l64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0 0-64z',
      'M448 96c0-53-43-96-96-96L64 0 32 0C14.3 0 0 14.3 0 32L0 352c0 17.7 14.3 32 32 32l64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 288 0c53 0 96-43 96-96l0-320zM274.1 150.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L304 199.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L280 217.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zM96 192c0-70.7 57.3-128 128-128c25.6 0 49.5 7.5 69.5 20.5c3.2 2.1 4.5 6.2 3.1 9.7s-5.2 5.6-9 4.8c-6.1-1.2-12.5-1.9-19-1.9c-52.4 0-94.9 42.5-94.9 94.9s42.5 94.9 94.9 94.9c6.5 0 12.8-.7 19-1.9c3.8-.8 7.5 1.3 9 4.8s.2 7.6-3.1 9.7c-20 13-43.9 20.5-69.5 20.5c-70.7 0-128-57.3-128-128z',
    ],
  ],
};
const faQuran = faBookQuran;
const faCircleQuarter = {
  prefix: 'fad',
  iconName: 'circle-quarter',
  icon: [
    512,
    512,
    [],
    'e11f',
    [
      'M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0l0 256L0 256z',
      'M0 256C0 114.6 114.6 0 256 0V256H0z',
    ],
  ],
};
const faAnchor = {
  prefix: 'fad',
  iconName: 'anchor',
  icon: [
    576,
    512,
    [9875],
    'f13d',
    [
      'M192 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 64 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M256 448l0-208 64 0 0 208 48 0c53 0 96-43 96-96l0-6.1-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7 0 6.1c0 88.4-71.6 160-160 160l-80 0-80 0c-88.4 0-160-71.6-160-160l0-6.1-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56-56c9.4-9.4 24.6-9.4 33.9 0l56 56c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7 0 6.1c0 53 43 96 96 96l48 0z',
    ],
  ],
};
const faBorderAll = {
  prefix: 'fad',
  iconName: 'border-all',
  icon: [
    448,
    512,
    [],
    'f84c',
    [
      'M64 224l0 64 128 0 0 128 64 0 0-128 128 0 0-64-128 0 0-128-64 0 0 128L64 224z',
      'M384 96l0 320L64 416 64 96l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z',
    ],
  ],
};
const faFunction = {
  prefix: 'fad',
  iconName: 'function',
  icon: [
    640,
    512,
    [],
    'f661',
    [
      'M224 320c0-65.6 19.6-126.7 53.3-177.7c9.8-14.7 29.6-18.8 44.3-9s18.8 29.6 9 44.3C303.7 218.4 288 267.3 288 320s15.7 101.6 42.7 142.3c9.8 14.7 5.7 34.6-9 44.3c-5.4 3.6-11.6 5.3-17.6 5.3c-10.4 0-20.6-5-26.7-14.3C243.6 446.7 224 385.6 224 320zM533.3 177.7c-9.8-14.7-5.7-34.6 9-44.3s34.6-5.7 44.3 9C620.4 193.3 640 254.4 640 320s-19.6 126.7-53.3 177.7C580.5 507 570.3 512 560 512c-6.1 0-12.2-1.7-17.6-5.3c-14.7-9.8-18.8-29.6-9-44.3c27-40.7 42.7-89.6 42.7-142.3s-15.7-101.6-42.7-142.3z',
      'M160 0C107 0 64 43 64 96l0 96-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 127.5c0 16.1-12 29.8-28 31.8l-7.9 1C10.5 418.4-1.9 434.4 .3 452s18.2 30 35.7 27.8l7.9-1c48-6 84.1-46.8 84.1-95.3L128 256l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 0zM398.6 241.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L386.7 320l-33.4 33.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L432 365.3l33.4 33.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L477.3 320l33.4-33.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L432 274.7l-33.4-33.4z',
    ],
  ],
};
const faFaceAngry = {
  prefix: 'fad',
  iconName: 'face-angry',
  icon: [
    512,
    512,
    [128544, 'angry'],
    'f556',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112.8-69.1c2.8-8.4 11.9-12.9 20.2-10.1c32 10.7 64 21.3 96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1c-3.6-1.2-7.2-2.4-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.8-.1-1.6-.1-1.6l0-1.7c0-.5 0-1.1 0-1.6s.1-1.1 .1-1.6c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1-4.1 1.9-6c1.6-3.8 3.9-7.3 6.8-10.2c-10.2-3.4-20.5-6.8-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2zm59.3 186.4C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6zM304.4 240c0-.4 0-.8 0 0z',
      'M133.1 176.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32zm256 30.4c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1z',
    ],
  ],
};
const faAngry = faFaceAngry;
const faPeopleSimple = {
  prefix: 'fad',
  iconName: 'people-simple',
  icon: [
    512,
    512,
    [],
    'e21b',
    [
      'M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64z',
      'M25.9 233.4C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L192 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zm280.9-26.9c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 80c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-80-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z',
    ],
  ],
};
const faCookieBite = {
  prefix: 'fad',
  iconName: 'cookie-bite',
  icon: [
    512,
    512,
    [],
    'f564',
    [
      'M16 237.1c0 6.1 .5 12.3 1.6 18.4l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c4.9 .7 9.8 1 14.7 1c17.2 0 34.3-4.2 49.7-12.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6C19.6 205.1 16 221 16 237.1zM208 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32-160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM400 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M176 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faArrowTrendDown = {
  prefix: 'fad',
  iconName: 'arrow-trend-down',
  icon: [
    576,
    512,
    [],
    'e097',
    [
      'M0 128c0 8.2 3.1 16.4 9.4 22.6l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352l45.3 0 0-45.3L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4C48.4 99.1 40.2 96 32 96s-16.4 3.1-22.6 9.4S0 119.8 0 128z',
      'M352 384c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128-128 0c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faRss = {
  prefix: 'fad',
  iconName: 'rss',
  icon: [
    448,
    512,
    ['feed'],
    'f09e',
    [
      'M0 64C0 81.7 14.3 96 32 96c194.4 0 352 157.6 352 352c0 17.7 14.3 32 32 32s32-14.3 32-32C448 218.2 261.8 32 32 32C14.3 32 0 46.3 0 64zM0 192c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-159.1-128.9-288-288-288c-17.7 0-32 14.3-32 32z',
      'M0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416z',
    ],
  ],
};
const faFeed = faRss;
const faFaceMonocle = {
  prefix: 'fad',
  iconName: 'face-monocle',
  icon: [
    512,
    512,
    [],
    'e380',
    [
      'M0 256C0 397.4 114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c-7.3-16.2-11.2-34-11.2-52.4l0-91.5c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112l0 169.9c0 1.2 0 2.3 .1 3.5s.1 2.3 .2 3.4c.2 2.3 .4 4.6 .7 6.8c.6 4.5 1.6 8.9 2.9 13.2C489.4 376.2 512 318.7 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm112.4-64c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM144 352c0-8.8 7.2-16 16-16c17.7 0 45.3 3.5 72.2 13.9c26.8 10.4 54.9 28.5 70.1 59c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2c-10.3-20.7-30.3-34.6-53.1-43.4C197.9 370.9 174.3 368 160 368c-8.8 0-16-7.2-16-16zM259.5 106c-5.5-6.9-4.4-17 2.5-22.5c7.7-6.2 15.5-12.4 23.2-18.6C298.9 54 315.9 48 333.5 48c15.2 0 30.1 4.5 42.8 13c2.9 1.9 5.7 3.8 8.6 5.7c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-8.6-5.7c-7.4-5-16.2-7.6-25.1-7.6c-10.3 0-20.2 3.5-28.2 9.9c-7.7 6.2-15.5 12.4-23.2 18.6c-6.9 5.5-17 4.4-22.5-2.5z',
      'M305.2 89.9L282 108.5c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l23.2-18.6C298.9 54 315.9 48 333.5 48c15.2 0 30.1 4.5 42.8 13l8.6 5.7c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-8.6-5.7c-7.4-5-16.2-7.6-25.1-7.6c-10.3 0-20.2 3.5-28.2 9.9zM416 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm0 169.9l0-91.5c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112l0 169.9c0 33.1 17 63.9 45.1 81.4l11.4 7.1c7.5 4.7 9.8 14.6 5.1 22s-14.6 9.8-22 5.1l-11.4-7.1C438.7 479.1 416 438.1 416 393.9zM112.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
    ],
  ],
};
const faDrawPolygon = {
  prefix: 'fad',
  iconName: 'draw-polygon',
  icon: [
    448,
    512,
    [],
    'f5ee',
    [
      'M32 151.4l0 209.1c9.4-5.4 20.3-8.6 32-8.6c.7 0 1.5 0 2.2 0s1.4 .1 2.2 .1c1.4 .1 2.9 .2 4.3 .4c2.8 .4 5.6 .9 8.2 1.7c5.4 1.5 10.5 3.6 15.2 6.3l0-209.1c-9.4 5.4-20.3 8.6-32 8.6c-.7 0-1.5 0-2.2 0s-1.4-.1-2.2-.1c-1.4-.1-2.9-.2-4.3-.4c-2.8-.4-5.6-.9-8.2-1.7c-5.4-1.5-10.5-3.6-15.2-6.3zM119.4 64c5.4 9.4 8.6 20.3 8.6 32c0 .7 0 1.5 0 2.2s-.1 1.4-.1 2.2c-.1 1.4-.2 2.9-.4 4.3c-.4 2.8-.9 5.6-1.7 8.2c-1.5 5.4-3.6 10.5-6.3 15.2l209.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-.7 0-1.5 0-2.2s.1-1.4 .1-2.2c.1-1.4 .2-2.9 .4-4.3c.4-2.8 .9-5.6 1.7-8.2c1.5-5.4 3.6-10.5 6.3-15.2L119.4 64zm0 320c5.4 9.4 8.6 20.3 8.6 32c0 .7 0 1.5 0 2.2s-.1 1.4-.1 2.2c-.1 1.4-.2 2.9-.4 4.3c-.4 2.8-.9 5.6-1.7 8.2c-1.5 5.4-3.6 10.5-6.3 15.2l209.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-.7 0-1.5 0-2.2s.1-1.4 .1-2.2c.1-1.4 .2-2.9 .4-4.3c.4-2.8 .9-5.6 1.7-8.2c1.5-5.4 3.6-10.5 6.4-15.4c-69.8 .2-139.5 .2-209.2 .2zM292.2 192.1c23.5 1.5 43.5 15.7 53.3 35.7l2.3-4 32-56 4.5-7.9c-3.2 0-6.1-.2-9-.6c-5.7-.7-11.2-2.3-16.3-4.5c-2.5-1.1-4.9-2.3-7.2-3.6c-9.6-5.5-17.5-13.5-23.3-23.3c-1.4 2.9-2.8 5.5-4.3 8.1c-10.7 18.7-21.3 37.3-32 56zm0 127.7c10.7 18.7 21.3 37.3 32 56c1.5 2.6 3 5.2 4.5 7.9C339.8 364.8 360.4 352 384 352c-1.2-2.6-2.7-5.3-4.2-7.9l-32-56-2.3-4c-9.8 20.1-29.8 34.2-53.3 35.7z',
      'M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zm320 0a64 64 0 1 1 128 0A64 64 0 1 1 320 96zM64 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM288 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    ],
  ],
};
const faScaleBalanced = {
  prefix: 'fad',
  iconName: 'scale-balanced',
  icon: [
    640,
    512,
    [9878, 'balance-scale'],
    'f24e',
    [
      'M96 64c0 17.7 14.3 32 32 32l113.6 0c5.2 25.8 22.9 47.1 46.4 57.3L288 448l-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0 192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-294.7c23.5-10.3 41.2-31.6 46.4-57.3L512 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L384 32C369.4 12.6 346.2 0 320 0s-49.4 12.6-64 32L128 32c-17.7 0-32 14.3-32 32z',
      'M126.8 195.8L199.3 320 54.4 320l72.4-124.2zM.9 337.1C11.7 382 64 416 126.8 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L150.9 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L7.6 305.1c-5.7 9.8-9.3 21.1-6.7 32.1zM512 195.8L584.4 320l-144.9 0L512 195.8zM386 337.1C396.8 382 449.1 416 512 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 305.1c-5.7 9.8-9.3 21.1-6.7 32.1z',
    ],
  ],
};
const faBalanceScale = faScaleBalanced;
const faCalendarLines = {
  prefix: 'fad',
  iconName: 'calendar-lines',
  icon: [
    448,
    512,
    ['calendar-note'],
    'e0d5',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM96 296c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z',
      'M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 80L0 192l0-80C0 85.5 21.5 64 48 64l48 0 0-32zm0 264c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faCalendarNote = faCalendarLines;
const faArrowDownBigSmall = {
  prefix: 'fad',
  iconName: 'arrow-down-big-small',
  icon: [
    576,
    512,
    ['sort-size-down'],
    'f88c',
    [
      'M320 80l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L368 32c-26.5 0-48 21.5-48 48zm0 288l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z',
      'M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480z',
    ],
  ],
};
const faSortSizeDown = faArrowDownBigSmall;
const faGaugeSimpleHigh = {
  prefix: 'fad',
  iconName: 'gauge-simple-high',
  icon: [
    512,
    512,
    [61668, 'tachometer', 'tachometer-fast'],
    'f62a',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM192 352c0 35.3 28.7 64 64 64c17.7 0 33.7-7.2 45.3-18.7c5.8-5.8 10.5-12.7 13.7-20.3c1.6-3.8 2.9-7.8 3.7-12c.4-2.1 .8-4.2 1-6.3c.1-1.1 .2-2.2 .2-3.2c.1-1.1 .1-2.2 .1-3.3l0-.4c0-.7 0-1.6-.1-2.6s-.1-1.9-.2-2.9c-.2-1.9-.4-3.9-.8-5.7c-.7-3.8-1.7-7.4-3-10.9c-2.6-7-6.5-13.4-11.3-19c25.5-49.1 51.1-98.2 76.6-147.4c1.8-3.5 2.7-7.3 2.7-11.1c0-8.7-4.7-17-12.9-21.3c-11.8-6.1-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64z',
      'M338.7 140.9c6.1-11.8 20.6-16.3 32.4-10.2s16.3 20.6 10.2 32.4L304.7 310.4c9.6 11.2 15.3 25.7 15.3 41.6c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c2.1 0 4.1 .1 6.1 .3l76.6-147.4z',
    ],
  ],
};
const faTachometer = faGaugeSimpleHigh;
const faTachometerFast = faGaugeSimpleHigh;
const faDoNotEnter = {
  prefix: 'fad',
  iconName: 'do-not-enter',
  icon: [
    512,
    512,
    [],
    'f5ec',
    [
      'M80 224c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L96 304c-8.8 0-16-7.2-16-16l0-64z',
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96 208l320 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L96 304c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faShower = {
  prefix: 'fad',
  iconName: 'shower',
  icon: [
    512,
    512,
    [128703],
    'f2cc',
    [
      'M224 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M99.9 96C80.1 96 64 112.1 64 131.9L64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 131.9C0 76.7 44.7 32 99.9 32c26.5 0 51.9 10.5 70.6 29.3l16.2 16.2c38.9-21 87.5-17.4 123 10.9L311 87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L185 281c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l1.3-1.3c-28.3-35.5-31.9-84.2-10.9-123l-16.2-16.2C118.5 99.8 109.4 96 99.9 96z',
    ],
  ],
};
const faDiceD8 = {
  prefix: 'fad',
  iconName: 'dice-d8',
  icon: [
    512,
    512,
    [],
    'f6d2',
    [
      'M0 232c0 1.2 .1 2.3 .4 3.5c1.2 5.2 4.9 9.5 9.9 11.5l208 80c1.9 .7 3.8 1.1 5.7 1.1c3.2 0 6.4-1 9.1-2.8c4.3-3 6.9-7.9 6.9-13.2l0-296c0-6.5-4-12.4-10-14.8s-13-1-17.5 3.7l-208 216c-2.9 3-4.5 7-4.5 11.1zM272 16l0 296c0 5.3 2.6 10.2 6.9 13.2c2.7 1.9 5.9 2.8 9.1 2.8c1.9 0 3.9-.4 5.7-1.1l208-80c5-1.9 8.7-6.2 9.9-11.5s-.4-10.7-4.1-14.6l-208-216C295 .2 288.1-1.3 282 1.2S272 9.5 272 16z',
      'M34.6 307.5c-4.1 6.3-3.3 14.6 1.9 20l176 179.7c4.5 4.6 11.5 6.1 17.5 3.6s10-8.3 10-14.8l0-112c0-6.6-4.1-12.6-10.3-14.9l-176-67.7c-7-2.7-15-.1-19.1 6.1zm442.7 0c-4.1-6.3-12.1-8.8-19.1-6.1l-176 67.7c-6.2 2.4-10.3 8.3-10.3 14.9l0 112c0 6.5 3.9 12.4 10 14.8s12.9 1 17.5-3.6l176-179.7c5.3-5.4 6.1-13.7 1.9-20z',
    ],
  ],
};
const faDesktop = {
  prefix: 'fad',
  iconName: 'desktop',
  icon: [
    576,
    512,
    [128421, 61704, 'desktop-alt'],
    'f390',
    [
      'M0 64L0 352c0 35.3 28.7 64 64 64l176 0 96 0 176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm64 0l448 0 0 224L64 288 64 64z',
      'M512 64L64 64l0 224 448 0 0-224zM416 448l-69.3 0L336 416l-96 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32z',
    ],
  ],
};
const faDesktopAlt = faDesktop;
const faM = {
  prefix: 'fad',
  iconName: 'm',
  icon: [
    448,
    512,
    [109],
    '4d',
    [
      'M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.3c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-278.3L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7 64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 49.9 9.2 37.5 22.7 33.4z',
      '',
    ],
  ],
};
const faSpinnerScale = {
  prefix: 'fad',
  iconName: 'spinner-scale',
  icon: [
    512,
    512,
    [],
    'e62a',
    [
      'M72.2 120.2a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM97.6 369.1a32 32 0 1 0 45.3 45.2A32 32 0 1 0 97.6 369.1zM352.2 80.6a56 56 0 1 0 79.2 79.2A56 56 0 1 0 352.2 80.6zm17 288.5a32 32 0 1 0 45.3 45.3 32 32 0 1 0 -45.3-45.3z',
      'M256 12a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm0 404a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM448 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faGripDotsVertical = {
  prefix: 'fad',
  iconName: 'grip-dots-vertical',
  icon: [
    256,
    512,
    [],
    'e411',
    [
      'M160 96a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z',
    ],
  ],
};
const faFaceViewfinder = {
  prefix: 'fad',
  iconName: 'face-viewfinder',
  icon: [
    512,
    512,
    [],
    'e2ff',
    [
      'M0 56C0 25.1 25.1 0 56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56zM0 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 4.4 3.6 8 8 8l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80zM352 24c0-13.3 10.7-24 24-24l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24zm0 464c0-13.3 10.7-24 24-24l80 0c4.4 0 8-3.6 8-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24z',
      'M256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM200 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-95.5 76.9C208.5 309.6 231 320 256 320s47.5-10.4 63.5-27.1c6.1-6.4 16.2-6.6 22.6-.5s6.6 16.2 .5 22.6C320.8 337.8 290 352 256 352s-64.8-14.2-86.6-36.9c-6.1-6.4-5.9-16.5 .5-22.6s16.5-5.9 22.6 .5z',
    ],
  ],
};
const faSoftServe = {
  prefix: 'fad',
  iconName: 'soft-serve',
  icon: [
    384,
    512,
    [127846, 'creemee'],
    'e400',
    [
      'M16 232c0 39.8 32.2 72 72 72l208 0c39.8 0 72-32.2 72-72c0-34.8-24.7-63.8-57.4-70.5c6-9.7 9.4-21.2 9.4-33.5C320 57.3 262.7 0 192 0l6.1 6.1c6.4 6.4 9.9 15 9.9 24C208 48.8 192.8 64 174.1 64L128 64c-35.3 0-64 28.7-64 64c0 12.3 3.5 23.7 9.4 33.5C40.7 168.2 16 197.2 16 232z',
      'M80 304c-17.7 0-32 14.3-32 32l0 16c0 17.7 14.3 32 32 32l1.8 0 11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5l134.7 0c16.3 0 30-12.3 31.8-28.5L302.2 384l1.8 0c17.7 0 32-14.3 32-32l0-16c0-17.7-14.3-32-32-32L80 304z',
    ],
  ],
};
const faCreemee = faSoftServe;
const faH5 = {
  prefix: 'fad',
  iconName: 'h5',
  icon: [
    640,
    512,
    [],
    'e412',
    [
      'M0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96z',
      'M400.7 89.4C403.8 74.6 416.9 64 432 64l144 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-118 0-18.5 88 84.6 0c64.1 0 116 51.9 116 116s-51.9 116-116 116l-67.6 0c-37.9 0-71.5-24.2-83.5-60.2l-3.2-9.7c-5.6-16.8 3.5-34.9 20.2-40.5s34.9 3.5 40.5 20.2l3.2 9.7c3.3 9.8 12.4 16.4 22.8 16.4l67.6 0c28.7 0 52-23.3 52-52s-23.3-52-52-52l-124 0c-9.6 0-18.8-4.3-24.8-11.8s-8.5-17.3-6.5-26.8l32-152z',
    ],
  ],
};
const faHandBackPointDown = {
  prefix: 'fad',
  iconName: 'hand-back-point-down',
  icon: [
    448,
    512,
    [],
    'e19e',
    [
      'M136 512c-22.1 0-40-17.9-40-40l0-200 0-7 0-73c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 55.7c-2-1.4-3.9-3-5.8-4.5L39 227.2C24.4 215 16 197 16 178L16 140c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0L288 0c70.7 0 128 57.3 128 128l0 64 0 32c0 26.5-21.5 48-48 48c-12.4 0-23.6-4.7-32.1-12.3C334 284.5 313.3 304 288 304c-12.4 0-23.6-4.7-32.1-12.3C254 316.5 233.3 336 208 336c-12.3 0-23.5-4.6-32-12.2L176 472c0 22.1-17.9 40-40 40z',
      '',
    ],
  ],
};
const faTableList = {
  prefix: 'fad',
  iconName: 'table-list',
  icon: [
    512,
    512,
    ['th-list'],
    'f00b',
    [
      'M64 160l0 64 64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 256 0 0-64-256 0 0-64 256 0 0-64-256 0 0-64-64 0 0 64-64 0z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 96l0 320L64 416 64 96l384 0z',
    ],
  ],
};
const faThList = faTableList;
const faBasketShoppingMinus = {
  prefix: 'fad',
  iconName: 'basket-shopping-minus',
  icon: [
    576,
    512,
    [],
    'e652',
    [
      'M0 224c0-17.7 14.3-32 32-32l98.4 0 52.6 0 210 0 52.6 0 98.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L492.1 463.5C485 492 459.4 512 430 512L146 512c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32zM184 352c0 13.3 10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0c-13.3 0-24 10.7-24 24z',
      'M253.9 33.8L183 192l-52.6 0L210.1 14.2c5.4-12.1 19.6-17.5 31.7-12.1s17.5 19.6 12.1 31.7zm112-19.6L445.6 192 393 192 322.1 33.8c-5.4-12.1 0-26.3 12.1-31.7s26.3 0 31.7 12.1zM208 328l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
    ],
  ],
};
const faCommentSms = {
  prefix: 'fad',
  iconName: 'comment-sms',
  icon: [
    512,
    512,
    ['sms'],
    'f7cd',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm96-27.2c0-20.3 16.5-36.8 36.8-36.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L112 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM192 192c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm144 20.8c0-20.3 16.5-36.8 36.8-36.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L352 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7z',
      'M132.8 176l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L112 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8c0-20.3 16.5-36.8 36.8-36.8zM336 212.8c0-20.3 16.5-36.8 36.8-36.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L352 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7zm-133.1-36c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-6.9 4.4-13 10.9-15.2z',
    ],
  ],
};
const faSms = faCommentSms;
const faRectangle = {
  prefix: 'fad',
  iconName: 'rectangle',
  icon: [
    512,
    512,
    [9644, 'rectangle-landscape'],
    'f2fa',
    ['M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z', ''],
  ],
};
const faRectangleLandscape = faRectangle;
const faClipboardListCheck = {
  prefix: 'fad',
  iconName: 'clipboard-list-check',
  icon: [
    384,
    512,
    [],
    'f737',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM64 272c0-4.1 1.6-8.2 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0L112 281.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-3.1-3.1-4.7-7.2-4.7-11.3zm56 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm40 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm32-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z',
      'M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM187.3 228.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 281.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM72 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z',
    ],
  ],
};
const faTurkey = {
  prefix: 'fad',
  iconName: 'turkey',
  icon: [
    640,
    512,
    [],
    'f725',
    [
      'M0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.2 .1-.4 .2-.5 .3c-9.9 7-19.4 13.7-28.8 20.3c-8.3 5.9-15.1 15-21.2 28.3c-6.1 13.4-10.4 28.5-15.4 45.8l-.3 1.2c-7.9 27.5-24 53-47.9 72.3c-26.7 21.6-58.7 32.1-90.5 32.1c-42 0-83.6-18.3-112-53.4c-13.9-17.2-23.2-36.6-28.1-56.7c-2.3-9.4 5.3-17.9 15-17.9c8.1 0 14.8 6 17 13.8c4 14.4 10.9 28.3 20.9 40.7c.6 .7 1.2 1.5 1.8 2.2c.6 .7 1.3 1.5 1.9 2.2c1.3 1.4 2.6 2.8 3.9 4.2c2.7 2.7 5.4 5.2 8.3 7.6c5.7 4.7 11.9 8.8 18.3 12.2c12.8 6.9 26.8 11.1 41.1 12.6c24.1 2.5 49-2.7 70.6-16.1c4-2.5 7.9-5.2 11.6-8.2c18.6-15.1 31.1-34.8 37.2-56.2l.7-2.5-.1 .5c9.6-33.7 20.1-70.5 48.7-90.6c8.6-6.1 17.2-12.1 25.8-18.2l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384z',
      'M486.7 192l-25.8 18.2c-28.6 20.2-39 56.9-48.7 90.6l-.6 2c-6.1 21.4-18.6 41.2-37.2 56.2c-48.1 38.9-118.6 31.5-157.5-16.6c-10-12.4-17-26.2-20.9-40.7c-2.1-7.8-8.9-13.8-17-13.8c-9.7 0-17.3 8.5-15 17.9c4.9 20.1 14.2 39.5 28.1 56.7c50 61.8 140.7 71.4 202.5 21.4c23.9-19.3 40-44.8 47.9-72.3l.3-1c5-17.4 9.3-32.6 15.4-46c6.1-13.3 12.9-22.5 21.2-28.3l28.3-20c.3-.2 .6-.4 1-.6c-7-8.2-14.3-16.2-22-23.7z',
    ],
  ],
};
const faBook = {
  prefix: 'fad',
  iconName: 'book',
  icon: [
    448,
    512,
    [128212],
    'f02d',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zm144 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0zm-16 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16z',
    ],
  ],
};
const faUserPlus = {
  prefix: 'fad',
  iconName: 'user-plus',
  icon: [
    640,
    512,
    [],
    'f234',
    [
      'M0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0C79.8 304 0 383.8 0 482.3zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z',
      'M504 248l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z',
    ],
  ],
};
const faIceSkate = {
  prefix: 'fad',
  iconName: 'ice-skate',
  icon: [
    576,
    512,
    [9976],
    'f7ac',
    [
      'M0 488c0 13.3 10.7 24 24 24l96 0 288 0 96 0c39.8 0 72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24l-72 0 0-80-48 0 0 80-240 0 0-80-48 0 0 80-72 0c-13.3 0-24 10.7-24 24z',
      'M32 336c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-21c0-44.1-30-82.4-72.7-93.1L320 192l-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32L66.8 86.1C46.2 91.9 32 110.8 32 132.2L32 336z',
    ],
  ],
};
const faCheck = {
  prefix: 'fad',
  iconName: 'check',
  icon: [
    448,
    512,
    [10003, 10004],
    'f00c',
    [
      '',
      'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z',
    ],
  ],
};
const faBatteryThreeQuarters = {
  prefix: 'fad',
  iconName: 'battery-three-quarters',
  icon: [
    576,
    512,
    ['battery-4'],
    'f241',
    [
      'M0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176zm64 0l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160c-8.8 0-16 7.2-16 16z',
      'M96 192h256v128H96V192z',
    ],
  ],
};
const faBattery4 = faBatteryThreeQuarters;
const faTomato = {
  prefix: 'fad',
  iconName: 'tomato',
  icon: [
    512,
    512,
    [],
    'e330',
    [
      'M0 304C0 434.9 114.6 512 256 512s256-77.1 256-208c0-75.5-38.1-133-97.5-168.3c-2.8 5-8.1 8.3-14 8.3c-11.5 0-23.1 0-34.6 0c5.1 7.7 10.3 15.4 15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4c-35.2 15.1-70.5 30.2-105.7 45.3c-6.5 2.8-14.1 1-18.5-4.4c-4.6-5.5-5-13.3-1.1-19.2c5.1-7.7 10.3-15.4 15.4-23.1c-11.4 0-22.7 0-34.1 0c-.8 0-1.5-.1-2.2-.2s-1.4-.3-2.1-.5c-1.4-.4-2.7-1-3.9-1.7c-2.4-1.5-4.5-3.6-5.8-6.2C38.2 170.7 0 228.4 0 304z',
      'M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c5 8.4 8.3 17.6 9.6 27.2c-46.3 3-89.6 14.3-126.5 32.9c-6.6 3.3-10.1 10.8-8.4 18s8.2 12.3 15.6 12.3l34.1 0-15.4 23.1c-3.9 5.9-3.5 13.7 1 19.1s12.1 7.3 18.6 4.5L256 145.4l105.7 45.3c6.5 2.8 14.1 1 18.6-4.5s4.9-13.2 1-19.1L365.9 144l34.6 0c7.4 0 13.8-5.1 15.6-12.3s-1.7-14.6-8.3-18c-37.5-19-81.3-30.2-128.2-33c-1.5-18.3-7.2-36-16.7-51.8L252.6 11.7z',
    ],
  ],
};
const faSwordLaser = {
  prefix: 'fad',
  iconName: 'sword-laser',
  icon: [
    512,
    512,
    [],
    'e03b',
    [
      'M207.1 248.5c18.8 18.8 37.6 37.6 56.4 56.4L505.7 40.2c4.2-4.6 6.3-10.4 6.3-16.2c0-6.2-2.4-12.3-7-17c-9.1-9.1-23.7-9.4-33.2-.7L207.1 248.5z',
      'M172.7 236.7c-6.1 6.1-6.2 15.8-.5 22.1l81 81c6.3 5.8 16 5.6 22.1-.5c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0zm-11.3 33.9l-23.7 23.7 80 80 23.7-23.7-80-80zm45 115l-80-80-20.7 20.7 80 80 20.7-20.7zM181.7 425L87 330.3l-2.3 2.3L10.3 407C3.7 413.7 0 422.6 0 432s3.7 18.3 10.3 25L55 501.7c6.6 6.6 15.6 10.3 25 10.3s18.3-3.7 25-10.3l74.3-74.3 2.3-2.3z',
    ],
  ],
};
const faHouseCircleCheck = {
  prefix: 'fad',
  iconName: 'house-circle-check',
  icon: [
    640,
    512,
    [],
    'e509',
    [
      'M0 255.5c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faBuildings = {
  prefix: 'fad',
  iconName: 'buildings',
  icon: [
    512,
    512,
    [],
    'e0cc',
    [
      'M0 192L0 448c0 35.3 28.7 64 64 64l192 0 192 0c35.3 0 64-28.7 64-64l0-256 0-128c0-35.3-28.7-64-64-64L256 0c-35.3 0-64 28.7-64 64l0 64L64 128c-35.3 0-64 28.7-64 64zm64 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM384 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 192l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM272 320c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0zM80 288l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm304 16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 208l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0z',
    ],
  ],
};
const faAngleLeft = {
  prefix: 'fad',
  iconName: 'angle-left',
  icon: [
    320,
    512,
    [8249],
    'f104',
    [
      'M41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 246.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z',
      '',
    ],
  ],
};
const faCartFlatbedBoxes = {
  prefix: 'fad',
  iconName: 'cart-flatbed-boxes',
  icon: [
    640,
    512,
    ['dolly-flatbed-alt'],
    'f475',
    [
      'M160 464c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16zM192 64l0 224c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L224 32c-17.7 0-32 14.3-32 32zm224 0l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm0 160l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zm32 240c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16z',
      'M0 32C0 14.3 14.3 0 32 0L48 0c44.2 0 80 35.8 80 80l0 288c0 8.8 7.2 16 16 16l464 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-464 0c-44.2 0-80-35.8-80-80L64 80c0-8.8-7.2-16-16-16L32 64C14.3 64 0 49.7 0 32z',
    ],
  ],
};
const faDollyFlatbedAlt = faCartFlatbedBoxes;
const faDiagramSuccessor = {
  prefix: 'fad',
  iconName: 'diagram-successor',
  icon: [
    512,
    512,
    [],
    'e47a',
    [
      'M0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7L503 169c4.9-4.9 7.1-10.9 7.1-16.8c0-12.3-9.6-24.2-24-24.2L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96z',
      'M448 480c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0z',
    ],
  ],
};
const faTruckArrowRight = {
  prefix: 'fad',
  iconName: 'truck-arrow-right',
  icon: [
    640,
    512,
    [],
    'e58b',
    [
      'M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L48 416c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM257 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L96 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l166.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 79z',
    ],
  ],
};
const faSquareW = {
  prefix: 'fad',
  iconName: 'square-w',
  icon: [
    448,
    512,
    [],
    'e285',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm72.3 76.2c.2-1.2 .5-2.5 .9-3.6c.8-2.4 1.9-4.6 3.3-6.6c2.9-4 7.1-7.2 12.2-8.8c2.4-.8 4.9-1.1 7.3-1.1c10.2 0 19.6 6.5 22.9 16.7c13.7 42.9 27.4 85.7 41.1 128.6c13.7-42.9 27.4-85.7 41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7c13.7 42.9 27.4 85.7 41.1 128.6c13.7-42.9 27.4-85.7 41.1-128.6c3.3-10.2 12.7-16.7 22.9-16.7c2.4 0 4.9 .4 7.3 1.1c10.2 3.3 16.7 12.7 16.7 22.9c0 2.4-.4 4.9-1.1 7.3c-21.3 66.7-42.7 133.3-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 254.7c-13.7 42.9-27.4 85.7-41.1 128.6c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7c-21.3-66.7-42.7-133.3-64-200c-.4-1.2-.7-2.4-.9-3.7c-.1-.9-.2-1.8-.2-1.8c-.1-.9-.1-.9-.1-1.8c0-.6 0-1.3 .1-1.9s.1-1.2 .2-1.9z',
      'M88.7 153.1c12.6-4 26.1 2.9 30.2 15.5L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 254.7 182.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2z',
    ],
  ],
};
const faArrowsSplitUpAndLeft = {
  prefix: 'fad',
  iconName: 'arrows-split-up-and-left',
  icon: [
    512,
    512,
    [],
    'e4bc',
    [
      'M201.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3l0 163.9c38.3 22.1 64 63.5 64 110.9l0-274.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6l-96-96C336.4 3.1 328.2 0 320 0s-16.4 3.1-22.6 9.4l-96 96z',
      'M9.4 310.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 224 256c70.7 0 128 57.3 128 128c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64l-114.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96z',
    ],
  ],
};
const faLamp = {
  prefix: 'fad',
  iconName: 'lamp',
  icon: [
    448,
    512,
    [],
    'f4ca',
    [
      'M96 432c0 24.4 8.3 44.6 16.4 58.7c8.5 14.7 25.2 21.3 42.1 21.3l139 0c17 0 33.6-6.6 42.1-21.3c8.1-14 16.4-34.3 16.4-58.7c0-61.5-64-128-64-128l0-48-128 0 0 48s-64 66.5-64 128z',
      'M112 0C99.1 0 87.4 7.8 82.5 19.7l-80 192c-4.1 9.9-3 21.2 2.9 30.1S21.3 256 32 256l384 0c10.7 0 20.7-5.3 26.6-14.2s7-20.2 2.9-30.1l-80-192C360.6 7.8 348.9 0 336 0L112 0z',
    ],
  ],
};
const faAirplay = {
  prefix: 'fad',
  iconName: 'airplay',
  icon: [
    576,
    512,
    [],
    'e089',
    [
      'M0 128L0 320c0 53 43 96 96 96l8.6 0c2.8-4.8 6.2-9.2 10.2-13.3L165.5 352 96 352c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-69.5 0 50.7 50.7c4 4 7.4 8.5 10.2 13.3l8.6 0c53 0 96-43 96-96l0-192c0-53-43-96-96-96L96 32C43 32 0 75 0 128z',
      'M310.6 297.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z',
    ],
  ],
};
const faHandFist = {
  prefix: 'fad',
  iconName: 'hand-fist',
  icon: [
    448,
    512,
    [9994, 'fist-raised'],
    'f6de',
    [
      'M32 240l0 27c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c13.7 13.7 29.6 24.6 46.9 32.5l0 78.4c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-96c38.9-29.2 64-75.7 64-128l0-8.6c-9.4 5.4-20.3 8.6-32 8.6c-27.9 0-51.7-17.9-60.4-42.8C313.4 220 301.2 224 288 224c-11.7 0-22.6-3.1-32-8.6c0 .2 0 .4 0 .6c0 39.8-32.2 72-72 72l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-88 0c-35.3 0-64 28.7-64 64z',
      'M160 32l0 112 64 0 0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32zM96 32C78.3 32 64 46.3 64 64l0 80 64 0 0-80c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32zm96 64c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faFistRaised = faHandFist;
const faShieldQuartered = {
  prefix: 'fad',
  iconName: 'shield-quartered',
  icon: [
    512,
    512,
    [],
    'e575',
    [
      'M16 140c.1 24 2.6 52.9 8.7 84L256 224c0-74.7 0-149.3 0-224c-.2 0-.5 0-.7 0c-4.4 .1-8.7 1.1-12.6 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2zm240.7 84c0 95.1 0 190.1 0 285.1c9 0 18.1-2 26.4-6C413.7 440.7 468.8 321.3 488 224l-231.3 0z',
      'M256.4 0l.3 0c4.6 0 9.2 1 13.4 2.9L458.4 82.8c22 9.3 38.4 31 38.3 57.2c-.1 24-2.6 52.9-8.7 84l-231.3 0 0-224L256 0s0 0 0 0l-.7 0 .7 0 .3 0zM229.6 503.2C99 440.7 44 321.3 24.7 224L256 224l0 285.1c-9 0-18.1-2-26.4-6z',
    ],
  ],
};
const faSlashForward = {
  prefix: 'fad',
  iconName: 'slash-forward',
  icon: [
    320,
    512,
    [],
    '2f',
    [
      'M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9S-4.6 479.5 4.2 464.1l256-448C269 .8 288.5-4.6 303.9 4.2z',
      '',
    ],
  ],
};
const faLocationPen = {
  prefix: 'fad',
  iconName: 'location-pen',
  icon: [
    384,
    512,
    ['map-marker-edit'],
    'f607',
    [
      'M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm96.5 76l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9c24-24 47.9-48 71.9-71.9c17.8 17.8 35.6 35.6 53.3 53.3l-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2zM208.6 122c5-5 9.9-9.9 14.9-14.9c7.4-7.4 17-11.1 26.7-11.1s19.3 3.7 26.7 11.1s11 17 11 26.7s-3.7 19.3-11 26.7l-14.9 14.9c-17.8-17.8-35.6-35.6-53.3-53.3z',
      'M223.5 107L208.6 122l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3c-14.7-14.7-38.6-14.7-53.3 0zM186 144.6l-71.9 71.9c-4.1 4.1-7 9.2-8.4 14.9L96.5 268c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L186 144.6z',
    ],
  ],
};
const faMapMarkerEdit = faLocationPen;
const faCloudMoon = {
  prefix: 'fad',
  iconName: 'cloud-moon',
  icon: [
    640,
    512,
    [],
    'f6c3',
    [
      'M304 192.2C304 86.1 389.8 0 495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5c1.2 2.3 1.8 4.8 1.8 7.3c0 4.2-1.7 8.4-4.8 11.5c-34.5 33.6-81.7 54.4-133.6 54.4c-3.5 0-7-.1-10.5-.3c-13.6-28.6-39-50.6-69.9-59.6c-5.7-55.6-52-99.1-108.8-100.4c-1.7-10.4-2.6-21-2.6-31.8z',
      'M383.9 511.9L96 511.9c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16l1.6 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z',
    ],
  ],
};
const faPotFood = {
  prefix: 'fad',
  iconName: 'pot-food',
  icon: [
    640,
    512,
    [127858],
    'e43f',
    [
      'M16 288c0 17.7 14.3 32 32 32l29.7 0c20.6 64 66.1 116.7 124.7 147.2l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7C496.2 436.7 541.7 384 562.3 320l29.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-17.9 0c.2-17.5-14-32-31.7-32L97.6 224c-17.7 0-31.9 14.5-31.7 32L48 256c-17.7 0-32 14.3-32 32zM64 24c0 45.1 21.2 69 37.7 87.5l.4 .4C117.5 129.3 128 141.5 128 168c0 13.3 10.7 24 24 24s24-10.7 24-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C122.5 62.7 112 50.5 112 24c0-13.3-10.7-24-24-24S64 10.7 64 24zm112 0c0 45.1 21.2 69 37.7 87.5l.4 .4C229.5 129.3 240 141.5 240 168c0 13.3 10.7 24 24 24s24-10.7 24-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C234.5 62.7 224 50.5 224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24zM320 224l222.4 0 1.6 0c0-61.9-50.1-112-112-112s-112 50.1-112 112z',
      'M65.9 256c-.2-17.5 14-32 31.7-32l444.8 0c17.7 0 31.9 14.5 31.7 32l17.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.7 0c-20.6 64-66.1 116.7-124.7 147.2l-1.2 9.7c-2.5 20-19.5 35-39.7 35l-153.4 0c-20.2 0-37.2-15-39.7-35l-1.2-9.7C143.8 436.7 98.3 384 77.7 320L48 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l17.9 0z',
    ],
  ],
};
const faBriefcase = {
  prefix: 'fad',
  iconName: 'briefcase',
  icon: [
    512,
    512,
    [128188],
    'f0b1',
    [
      'M0 288L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128-192 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32L0 288z',
      'M384 96l80 0c25.6 0 48 22.4 48 48l0 144L0 288 0 144c0-25.6 22.4-48 48-48l80 0 0-40 0-8c0-25.6 22.4-48 48-48l8 0L328 0l8 0c25.6 0 48 22.4 48 48l0 8 0 40zm-48 0l0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8l0 40 160 0z',
    ],
  ],
};
const faPersonFalling = {
  prefix: 'fad',
  iconName: 'person-falling',
  icon: [
    512,
    512,
    [],
    'e546',
    [
      'M64 80a48 48 0 1 0 96 0A48 48 0 1 0 64 80z',
      'M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C135.6 154.5 96 213 96 278.2L96 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L325.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L286.6 320l1.4 0 80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C405.3 263.1 391.1 256 376 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8z',
    ],
  ],
};
const faImagePortrait = {
  prefix: 'fad',
  iconName: 'image-portrait',
  icon: [
    384,
    512,
    ['portrait'],
    'f3e0',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zM80 356.6l0-.4c0-.9 0-2 .1-3.2c.1-1.1 .1-2.3 .3-3.5c.2-2.3 .6-4.6 1-6.8c.9-4.5 2.3-8.8 4-12.9c3.5-8.2 8.5-15.6 14.7-21.8c12.4-12.4 29.6-20.1 48.5-20.1c29 0 57.9 0 86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0c-7.6 0-14.4-3.1-19.4-8c-2.5-2.5-4.5-5.4-5.9-8.7c-.7-1.6-1.2-3.4-1.6-5.1c-.2-.9-.3-1.8-.4-2.7c-.1-.7-.1-1.4-.1-1.3l0-1.5zm48.3-171.1c.2-2.1 .5-4.3 1-6.3c.9-4.2 2.1-8.2 3.7-12c3.2-7.7 7.9-14.5 13.7-20.3C158.3 135.2 174.3 128 192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64c-17.7 0-33.7-7.2-45.3-18.7c-5.8-5.8-10.5-12.7-13.7-20.3c-1.6-3.8-2.9-7.8-3.7-12c-.4-2.1-.8-4.2-1-6.4c-.1-1.1-.2-2.1-.2-3.2c-.1-1.1-.1-2.2-.1-3.3l0-.4c0-.8 0-1.9 .1-2.9c.1-1.1 .1-2.2 .2-3.2z',
      'M192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-43.4 32C110.7 288 80 318.7 80 356.6c0 15.1 12.3 27.4 27.4 27.4l169.1 0c15.1 0 27.4-12.3 27.4-27.4c0-37.9-30.7-68.6-68.6-68.6l-86.9 0z',
    ],
  ],
};
const faPortrait = faImagePortrait;
const faUserTag = {
  prefix: 'fad',
  iconName: 'user-tag',
  icon: [
    640,
    512,
    [],
    'f507',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c17.5 0 34.3 2.5 50.3 7.2l0 33c0 21.1 8.4 41.2 23.3 56.1l99.2 99.2c-5.4 7.5-14.2 12.5-24.2 12.5L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M352 256c0-17.7 14.3-32 32-32l82.7 0c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3l0-82.7zm80 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faRug = {
  prefix: 'fad',
  iconName: 'rug',
  icon: [
    640,
    512,
    [],
    'e569',
    [
      'M80 64l0 24 0 88 0 80 0 80 0 88 0 24 80 0 0-384L80 64zm112 0l0 384 256 0 0-384L192 64zm288 0l0 384 80 0 0-24 0-88 0-80 0-80 0-88 0-24-80 0z',
      'M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l8 0 0 40-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 40-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 24 0 0-24 0-88 0-80 0-80 0-88 0-24L56 64 24 64zm592 0l-32 0-24 0 0 24 0 88 0 80 0 80 0 88 0 24 24 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM160 64l0 384 32 0 0-384-32 0zm320 0l-32 0 0 384 32 0 0-384z',
    ],
  ],
};
const faPrintSlash = {
  prefix: 'fad',
  iconName: 'print-slash',
  icon: [
    640,
    512,
    [],
    'f686',
    [
      'M64 256l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8l-51-40.2L192 448l0-64 0-16 0-16 132.9 0L122.2 192.3C89.6 195.2 64 222.6 64 256zM128 64l0 11 64 50.2L192 64l226.7 0L448 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0L192 0c-35.3 0-64 28.7-64 64zM277.3 192c81.7 64 163.3 128 245 192l21.8 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64l-234.7 0zM520 272a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faEarthEurope = {
  prefix: 'fad',
  iconName: 'earth-europe',
  icon: [
    512,
    512,
    ['globe-europe'],
    'f7a2',
    [
      'M0 256C0 397.4 114.6 512 256 512c5.4 0 10.7-.2 16-.5l0-34.3c0-25-20.3-45.3-45.3-45.3c-12 0-23.5-4.8-32-13.3l-16-16c-12-12-18.7-28.3-18.7-45.3l0-3.2c0-21.4 10.7-41.4 28.5-53.3c9.1-6.1 18.3-12.2 27.4-18.3c10.5-7 22.9-10.7 35.5-10.7c7 0 14 0 20.9 0c15.3 0 30.1 5.5 41.7 15.4c8.9 7.6 17.7 15.2 26.6 22.8c7.4 6.3 16.8 9.8 26.6 9.8c10.8 0 21.2 4.3 28.9 12l4 4c10.2 10.2 24.1 16 38.6 16l54.8 0c4.2-10.3 7.7-21 10.5-32c-19.1 0-38.2 0-57.3 0c-14.5 0-28.4-5.8-38.6-16c-6.1-6.1-12.2-12.2-18.3-18.3C386 282 384 277.1 384 272s2-10 5.7-13.7c2.5-2.5 5-5 7.5-7.5c1.8-1.8 2.8-4.3 2.8-6.8s-1-5-2.8-6.8c-2.2-2.2-4.4-4.4-6.5-6.5c-4.2-4.2-10-6.6-16-6.6c-3.8 0-7.5 0-11.3 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8c1.6-1.6 3.1-3.1 4.7-4.7c5.1-5.1 12.1-8 19.3-8c6.9 0 13.8 0 20.7 0c8.8 0 16-7.2 16-16c0-8.8-7.1-15.9-16-16c-9.8 0-19.6 0-29.4 0c-10.3 0-18.6 8.3-18.6 18.6c0 8-5.1 15.1-12.7 17.6c-7.1 2.4-14.1 4.7-21.2 7.1c-7.5 2.5-11 11-7.5 18c.4 .8 .8 1.5 1.1 2.3c3.8 7.5-1.7 16.4-10.1 16.4c-3.6 0-6.9-1.7-9.1-4.5c-5.4-7.2-10.9-14.5-16.3-21.7c-2.7-3.6-6.9-5.7-11.4-5.7c-5.4 0-10.4 3.1-12.8 7.9c-1.3 2.7-2.7 5.4-4 8.1c-4.9 9.8-15.1 16-26.1 16c-16.4 0-29.9-13.3-29.9-29.7l0-4.3c0-9 3.6-17.6 9.9-24c6-6 12-12 17.9-17.9c2.6-2.6 4.1-6.2 4.1-10c0-6.1 3.9-11.5 9.6-13.4c8.8-2.9 17.7-5.9 26.5-8.8c7.8-2.6 14.9-7 20.7-12.8c6.6-6.6 13.2-13.2 19.9-19.9c2.1-2.1 3.3-5 3.3-8c0-6.2-5.1-11.3-11.3-11.3l-.5 0c-3 0-5.3 .7-7.3 2.1c-13.9 9.3-27.9 18.6-41.8 27.9c-2 1.3-4.4 2.1-6.8 2.1c-6.8 0-12.3-5.5-12.3-12.3l0-8.6c0-7 3.5-13.5 9.3-17.3c31.7-21.1 63.4-42.3 95.1-63.4C305.5 3.6 281.2 0 256 0C114.6 0 0 114.6 0 256zM132.7 132.7c10.7-10.7 21.3-21.3 32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-10.7 10.7-21.3 21.3-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z',
      'M192 210.3l0-4.3c0-9 3.6-17.6 9.9-24l17.9-17.9c2.6-2.6 4.1-6.2 4.1-10c0-6.1 3.9-11.5 9.6-13.4l26.5-8.8c7.8-2.6 14.9-7 20.7-12.8l19.9-19.9c2.1-2.1 3.3-5 3.3-8c0-6.2-5.1-11.3-11.3-11.3l-1 0c-2.4 0-4.8 .7-6.8 2.1l-41.8 27.9c-2 1.3-4.4 2.1-6.8 2.1c-6.8 0-12.3-5.5-12.3-12.3l0-8.6c0-7 3.5-13.5 9.3-17.3l95.1-63.4C434.5 41.6 512 139.8 512 256c0 22.1-2.8 43.5-8.1 64l-57.3 0c-14.5 0-28.4-5.8-38.6-16l-18.3-18.3C386 282 384 277.1 384 272s2-10 5.7-13.7l7.5-7.5c1.8-1.8 2.8-4.3 2.8-6.8s-1-5-2.8-6.8l-6.5-6.5c-4.2-4.2-10-6.6-16-6.6l-11.3 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L360 200c5.1-5.1 12.1-8 19.3-8l20.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-29.4 0c-10.3 0-18.6 8.3-18.6 18.6c0 8-5.1 15.1-12.7 17.6l-21.2 7.1c-7.5 2.5-11 11-7.5 18l1.1 2.3c3.8 7.5-1.7 16.4-10.1 16.4c-3.6 0-6.9-1.7-9.1-4.5l-16.3-21.7c-2.7-3.6-6.9-5.7-11.4-5.7c-5.4 0-10.4 3.1-12.8 7.9l-4 8.1c-4.9 9.8-15.1 16-26.1 16c-16.4 0-29.9-13.3-29.9-29.7zM493.4 352C457.3 441.1 372.5 505.3 272 511.5l0-34.3c0-25-20.3-45.3-45.3-45.3c-12 0-23.5-4.8-32-13.3l-16-16c-12-12-18.7-28.3-18.7-45.3l0-3.2c0-21.4 10.7-41.4 28.5-53.2l27.4-18.3c10.5-7 22.9-10.7 35.5-10.7l20.9 0c15.3 0 30.1 5.5 41.7 15.4l26.6 22.8c7.4 6.3 16.8 9.8 26.6 9.8c10.8 0 21.2 4.3 28.9 12l4 4c10.2 10.2 24.1 16 38.6 16l54.8 0zM187.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0z',
    ],
  ],
};
const faGlobeEurope = faEarthEurope;
const faCartFlatbedSuitcase = {
  prefix: 'fad',
  iconName: 'cart-flatbed-suitcase',
  icon: [
    640,
    512,
    ['luggage-cart'],
    'f59d',
    [
      'M160 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48zm32-320c0-26.5 21.5-48 48-48l16 0 0 224-16 0c-26.5 0-48-21.5-48-48l0-128zm96-88c0-30.9 25.1-56 56-56l80 0c30.9 0 56 25.1 56 56l0 40 0 224-192 0 0-224 0-40zm48 0l0 40 96 0 0-40c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8zM448 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48zM512 96l16 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-16 0 0-224z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l16 0c8.8 0 16 7.2 16 16l0 288c0 44.2 35.8 80 80 80l464 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-464 0c-8.8 0-16-7.2-16-16l0-288C128 35.8 92.2 0 48 0L32 0zM256 96l0 224 32 0 0-224-32 0zm224 0l0 224 32 0 0-224-32 0z',
    ],
  ],
};
const faLuggageCart = faCartFlatbedSuitcase;
const faHandBackPointRibbon = {
  prefix: 'fad',
  iconName: 'hand-back-point-ribbon',
  icon: [
    448,
    512,
    [],
    'e1a0',
    [
      'M32 334L32 372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L304 512c70.7 0 128-57.3 128-128l0-64 0-32c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.4 0-23.6 4.7-32.1 12.3C270 195.5 249.3 176 224 176c-12.3 0-23.5 4.6-32 12.2l0-28.2-80 0 0 80 0 7 0 73c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.7c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334zM112.8 32l78.4 0C187.5 13.7 171.4 0 152 0s-35.5 13.7-39.2 32z',
      'M224 112V48c0-8.8-7.2-16-16-16H43.8C37.3 32 32 37.3 32 43.8c0 3.9 1.9 7.5 5.1 9.7L75.6 80 37.1 106.5c-3.2 2.2-5.1 5.8-5.1 9.7c0 6.5 5.3 11.8 11.8 11.8H208c8.8 0 16-7.2 16-16z',
    ],
  ],
};
const faRectangleXmark = {
  prefix: 'fad',
  iconName: 'rectangle-xmark',
  icon: [
    512,
    512,
    [62164, 'rectangle-times', 'times-rectangle', 'window-close'],
    'f410',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM168.1 317.7c.1-.7 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.4-31.4 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.3 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.2-1.1-.4-2.3-.3-2.2c-.1-1.2-.1-1.2-.1-2.4c0-1.5 .1-1.9 .1-2.3z',
      'M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faRectangleTimes = faRectangleXmark;
const faTimesRectangle = faRectangleXmark;
const faWindowClose = faRectangleXmark;
const faTireRugged = {
  prefix: 'fad',
  iconName: 'tire-rugged',
  icon: [
    512,
    512,
    [],
    'f634',
    [
      'M128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm82.3-14.8a24 24 0 1 1 -45.7-14.8 24 24 0 1 1 45.7 14.8zm22.7 87.2a24 24 0 1 1 -38.8-28.2 24 24 0 1 1 38.8 28.2zM280 184a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm37.7 116.1a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zm29.6-73.8a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8z',
      'M296 0c13.3 0 24 10.7 24 24l0 16c0 .4 0 .8 0 1.3c14.9 4.4 29.2 10.4 42.6 17.7c.3-.3 .6-.6 .9-.9l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9L454 148.5c-.3 .3-.6 .6-.9 .9c7.3 13.4 13.2 27.7 17.7 42.6c.4 0 .8 0 1.3 0l16 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-16 0c-.4 0-.8 0-1.3 0c-4.4 14.9-10.4 29.2-17.7 42.6c.3 .3 .6 .6 .9 .9l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0L363.5 454c-.3-.3-.6-.6-.9-.9c-13.4 7.3-27.7 13.2-42.6 17.7c0 .4 0 .8 0 1.3l0 16c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-16c0-.4 0-.8 0-1.3c-14.9-4.4-29.2-10.4-42.6-17.7c-.3 .3-.6 .6-.9 .9l-11.3 11.3c-9.4 9.4-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9L58 363.5c.3-.3 .6-.6 .9-.9c-7.3-13.4-13.2-27.7-17.7-42.6c-.4 0-.8 0-1.3 0l-16 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l16 0c.4 0 .8 0 1.3 0c4.4-14.9 10.4-29.2 17.7-42.6c-.3-.3-.6-.6-.9-.9L46.7 137.2c-9.4-9.4-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0L148.5 58c.3 .3 .6 .6 .9 .9c13.4-7.3 27.7-13.2 42.6-17.7c0-.4 0-.8 0-1.3l0-16c0-13.3 10.7-24 24-24l80 0zm88 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z',
    ],
  ],
};
const faLightbulbDollar = {
  prefix: 'fad',
  iconName: 'lightbulb-dollar',
  icon: [
    384,
    512,
    [],
    'f670',
    [
      'M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176zm108.1-21.5c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.3-8.4c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7z',
      'M192 512c44.2 0 80-35.8 80-80V384H112v48c0 44.2 35.8 80 80 80z',
    ],
  ],
};
const faCowbell = {
  prefix: 'fad',
  iconName: 'cowbell',
  icon: [
    448,
    512,
    [],
    'f8b3',
    [
      'M0 400c0 10.6 3.5 21 10.2 29.5C19.3 441.2 33.2 448 48 448l112 0 128 0 112 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-64-256C377.2 111 358 96 336 96l0-56c0-22.1-17.9-40-40-40L152 0c-22.1 0-40 17.9-40 40l0 56c-22 0-41.2 15-46.6 36.4l-64 256C.5 392.2 0 396.1 0 400zM160 48l128 0 0 48L160 96l0-48z',
      'M224 512c35.3 0 64-28.7 64-64H160c0 35.3 28.7 64 64 64z',
    ],
  ],
};
const faBahtSign = {
  prefix: 'fad',
  iconName: 'baht-sign',
  icon: [
    320,
    512,
    [],
    'e0ac',
    [
      'M112 32l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 96l0 96 64 0 0-96-64 0zm0 160l0 96 64 0 0-96-64 0zm0 160l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0z',
      'M64 224l112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 128l0 96zM0 265.7L0 224 0 101.6C0 80.8 16.8 64 37.6 64L176 64c61.9 0 112 50.1 112 112c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112L41.7 448C18.7 448 0 429.3 0 406.3L0 288l0-22.3zM176 288L64 288l0 96 144 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z',
    ],
  ],
};
const faCorner = {
  prefix: 'fad',
  iconName: 'corner',
  icon: [
    448,
    512,
    [],
    'e3fe',
    [
      'M0 192c0-17.7 14.3-32 32-32l352 0c35.3 0 64 28.7 64 64l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128L32 224c-17.7 0-32-14.3-32-32z',
      '',
    ],
  ],
};
const faChevronsRight = {
  prefix: 'fad',
  iconName: 'chevrons-right',
  icon: [
    512,
    512,
    ['chevron-double-right'],
    'f324',
    [
      'M32 448c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192C80.4 35.1 72.2 32 64 32s-16.4 3.1-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L210.7 256 41.4 425.4C35.1 431.6 32 439.8 32 448z',
      'M470.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 256 233.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z',
    ],
  ],
};
const faChevronDoubleRight = faChevronsRight;
const faBookOpen = {
  prefix: 'fad',
  iconName: 'book-open',
  icon: [
    576,
    512,
    [128214, 128366],
    'f518',
    [
      'M288 72c16-16 80-40 144-40c50.5 0 97.7 13.3 125.9 24.1C569.2 60.5 576 71.7 576 83.8l0 370.3c0 11.9-12.8 20.2-24.1 16.5C520.4 460.1 470.5 448 432 448c-51.2 0-144 32-144 32l0-408z',
      'M288 72V480s-92.8-32-144-32c-38.5 0-88.4 12.1-119.9 22.6C12.8 474.3 0 466 0 454.1V83.8C0 71.7 6.8 60.5 18.1 56.1C46.3 45.3 93.5 32 144 32c64 0 128 24 144 40z',
    ],
  ],
};
const faBookJournalWhills = {
  prefix: 'fad',
  iconName: 'book-journal-whills',
  icon: [
    448,
    512,
    ['journal-whills'],
    'f66a',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm58.4 181.6c3.1 3.1 8.1 3.1 11.2 0s3.1-8.1 0-11.2l-26.4-26.5c8.2-17 20.6-31.6 35.8-42.6c2.7-1.9 6.2 1.4 5 4.5c-8.5 22.4-3.5 48 13.1 65.5c3.2 3.4 3.6 8.8 .9 12.7c-9.8 14-12.7 31.9-7.6 48.5c5.9 19.4 22 34.1 41.9 38.3l1.4-32.8-10.4 7.1c-.6 .4-1.5 .6-2.2 .6c-1 0-2-.4-2.8-1c-.8-.9-1.2-1.9-1.2-3c0-.6 .2-1.4 .5-2l8.6-14.2-18-3.8c-1.8-.4-3.1-2.1-3.1-4s1.4-3.5 3.1-3.9l18-3.7-8.6-14.3c-.9-1.6-.6-3.7 .8-5s3.5-1.5 5-.4l12 8.1L236 87.9c.1-2.2 1.9-3.9 4-3.9s3.9 1.6 4 3.9l4.8 112.3 14.1-9.6c.6-.5 1.4-.6 2.1-.7l.1 0c1.5 0 2.7 .7 3.5 2s.6 2.9-.1 4.1L260 210.1l18 3.7c1.8 .4 3.1 2 3.1 3.9s-1.4 3.6-3.1 4l-18 3.6 8.5 14.4c.8 1.2 .9 2.7 .1 4s-2 2-3.5 2c-.8 0-1.6-.2-2.3-.6l-12.6-8.6 1.4 34.3c19.9-4.1 36-18.9 41.9-38.3c5.1-16.5 2.2-34.5-7.5-48.5c-2.7-3.9-2.4-9.3 .9-12.7c16.6-17.5 21.6-43.1 13-65.6c-1.2-3.1 2.3-6.4 5-4.5c15.3 10.9 27.7 25.6 35.9 42.6l-26.4 26.5c-3.1 3.1-3.1 8.1 0 11.2s8.1 3.1 11.3 0l21.2-21.2c3 10.1 5.1 20.6 5.1 31.6c0 .2 0 .5-.1 .8s-.1 .5-.1 .8L314.8 226c-1.6 1.6-2.6 3.8-2.8 6c.1 1.9 .7 3.8 2 5.2c1.6 1.6 3.8 2.6 6 2.8c2 0 3.9-.8 5.3-2l23.6-20.6C337.3 267 293.1 304 240 304s-97.2-37-108.9-86.6L154.8 238c1.5 1.2 3.4 1.9 5.2 2c3.4 0 6.2-2.1 7.5-5.1c1.1-3.1 .2-6.7-2.3-8.9l-37.1-32.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-11 2.1-21.5 5.1-31.6l21.2 21.2z',
    ],
  ],
};
const faJournalWhills = faBookJournalWhills;
const faInhaler = {
  prefix: 'fad',
  iconName: 'inhaler',
  icon: [
    576,
    512,
    [],
    'f5f9',
    [
      'M0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM96 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM376.6 139.6c2.6 .7 5 2.1 7.1 4.2L523.5 283.5 575.2 94.3c1.7-6.2 .8-12.9-2.4-18.4s-8.6-9.6-14.9-11.2l-128-32c-12.7-3.2-25.6 4.4-29 17l-24.2 89.9z',
      'M534.1 305.5c1.5-5.5-.1-11.5-4.1-15.5L383.8 143.8c-8.7-8.7-23.6-4.7-26.8 7.2l-16.5 61.2c-1.9 7-8.2 11.8-15.4 11.8L232 224c-22.1 0-40 17.9-40 40l0 176c0 22.1 17.9 40 40 40l224 0c18 0 33.8-12.1 38.6-29.5l39.5-145z',
    ],
  ],
};
const faHandcuffs = {
  prefix: 'fad',
  iconName: 'handcuffs',
  icon: [
    640,
    512,
    [],
    'e4f8',
    [
      'M128 160l64 0c0-17.7-14.3-32-32-32s-32 14.3-32 32zm32-80a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80-48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 80l64 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z',
      'M96 184c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1l0-16zm64 264a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z',
    ],
  ],
};
const faSnake = {
  prefix: 'fad',
  iconName: 'snake',
  icon: [
    512,
    512,
    [128013],
    'f716',
    [
      'M32 208c0-5.4 .3-10.7 .9-16c15.7 0 31.4 0 47.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.7 0-31.4 0-47.1 0c-.6-5.3-.9-10.6-.9-16zm31.5-89.9c6.7-8.4 14.3-15.9 22.6-22.6c7.1 7.1 14.1 14.1 21.2 21.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-7.1-7.1-14.1-14.1-21.2-21.2zM64 426.7l17.2-5.7c4.8-1.6 9.8-2.8 14.8-3.7L96 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-37.3zM160 64.9c5.3-.6 10.6-.9 16-.9c5.3 0 10.7 0 16 0l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-47.1zM160 304c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48-16 0c-5.4 0-10.7-.3-16-.9l0-47.1zm0 112l32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zM256 64c10.7 0 21.3 0 32 0l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm0 240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48-32 0 0-48zm0 112l32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm72.3-62.9c9.5-9.5 18.9-18.9 28.4-28.4c6.2-6.2 16.4-6.2 22.6 0c3.1 3.1 4.7 7.2 4.7 11.3c0 2-.4 4.1-1.2 6c-.4 1-.9 1.9-1.5 2.8c-.3 .4-.6 .9-1 1.3s-.7 .8-1.1 1.2l-28.4 28.4c-2.9-11-11.6-19.7-22.6-22.6zm0 61.8c11-2.9 19.7-11.6 22.6-22.6c9.5 9.5 18.9 18.9 28.4 28.4c3.1 3.1 4.7 7.2 4.7 11.3c0 2-.4 4.1-1.2 6c-.4 1-.9 1.9-1.5 2.8c-.3 .4-.6 .9-1 1.3s-.7 .8-1.1 1.2c-6.2 6.2-16.4 6.2-22.6 0l-28.4-28.4z',
      'M403.6 25.8l79.8 39.9C500.9 74.5 512 92.4 512 112s-11.1 37.5-28.6 46.3l-79.8 39.9c-30.8 15.4-68 9.4-92.3-15L288 160l-112 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l144 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-144 0-.1 0-64.3 0c-10.3 0-20.6-1.7-30.4-4.9l-66-22C6.1 482 0 473.6 0 464s6.1-18 15.2-21.1L64 426.7 64 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-46.7c5.1-.8 10.4-1.3 15.6-1.3l48.4 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0c2.9 0 5.6-.4 8.3-1.1l28.4 28.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-28.4-28.4c.7-2.6 1.1-5.4 1.1-8.3s-.4-5.6-1.1-8.3l28.4-28.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-28.4 28.4c-2.6-.7-5.4-1.1-8.3-1.1l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 47.1c-27.8-3.1-53.2-14-73.9-30.6l21.2-21.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L63.5 297.9C46.9 277.2 35.9 251.8 32.9 224L80 224c8.8 0 16-7.2 16-16s-7.2-16-16-16l-47.1 0c3.1-27.8 14-53.2 30.6-73.9l21.2 21.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.1 95.5c20.7-16.6 46.1-27.5 73.9-30.6l0 47.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 23.2-23.2c24.3-24.3 61.5-30.4 92.3-15zM368 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z',
    ],
  ],
};
const faTriangleExclamation = {
  prefix: 'fad',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    [9888, 'exclamation-triangle', 'warning'],
    'f071',
    [
      'M0 440c0 6.9 1.8 13.7 5.3 19.9C12.4 472.3 25.7 480 40 480l432 0c14.3 0 27.6-7.7 34.7-20.1c3.5-6.2 5.3-13 5.3-19.9c0-7-1.8-14-5.5-20.2l-216-368C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368C1.8 426 0 433 0 440zm288-56a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM232 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faExclamationTriangle = faTriangleExclamation;
const faWarning = faTriangleExclamation;
const faNoteMedical = {
  prefix: 'fad',
  iconName: 'note-medical',
  icon: [
    448,
    512,
    [],
    'e200',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224-128 0c-17.7 0-32 14.3-32 32l0 128L64 480c-35.3 0-64-28.7-64-64L0 96zM128 208l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z',
      'M192 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48zm96 336l0-128c0-17.7 14.3-32 32-32l128 0 0 5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7l-5.5 0z',
    ],
  ],
};
const faDatabase = {
  prefix: 'fad',
  iconName: 'database',
  icon: [
    448,
    512,
    [],
    'f1c0',
    [
      'M0 80l0 48c0 44.2 100.3 80 224 80s224-35.8 224-80l0-48C448 35.8 347.7 0 224 0S0 35.8 0 80zM0 186.1L0 288c0 44.2 100.3 80 224 80s224-35.8 224-80l0-101.9c-14.9 11.8-34 21.2-54.8 28.6C348.3 230.7 288.5 240 224 240s-124.3-9.3-169.2-25.3C34 207.3 14.9 197.8 0 186.1zm0 160L0 432c0 44.2 100.3 80 224 80s224-35.8 224-80l0-85.9c-14.9 11.8-34 21.2-54.8 28.6C348.3 390.7 288.5 400 224 400s-124.3-9.3-169.2-25.3C34 367.3 14.9 357.8 0 346.1z',
      'M0 186.1L0 128c0 44.2 100.3 80 224 80s224-35.8 224-80l0 58.1c-14.9 11.8-34 21.2-54.8 28.6C348.3 230.7 288.5 240 224 240s-124.3-9.3-169.2-25.3C34 207.3 14.9 197.8 0 186.1zm0 160L0 288c0 44.2 100.3 80 224 80s224-35.8 224-80l0 58.1c-14.9 11.8-34 21.2-54.8 28.6C348.3 390.7 288.5 400 224 400s-124.3-9.3-169.2-25.3C34 367.3 14.9 357.8 0 346.1z',
    ],
  ],
};
const faDownLeft = {
  prefix: 'fad',
  iconName: 'down-left',
  icon: [
    384,
    512,
    [],
    'e16a',
    [
      'M142.6 209.4L276.7 75.3C283.9 68.1 293.8 64 304 64s20.1 4.1 27.3 11.3l41.4 41.4c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L238.6 305.4c-32-32-64-64-96-96z',
      'M48 432H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-240-240c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V400c0 17.7 14.3 32 32 32z',
    ],
  ],
};
const faShare = {
  prefix: 'fad',
  iconName: 'share',
  icon: [
    512,
    512,
    ['mail-forward'],
    'f064',
    [
      'M0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l96 0 0-160-112 0C78.8 128 0 206.8 0 304z',
      'M288 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2l0-288z',
    ],
  ],
};
const faMailForward = faShare;
const faFaceThinking = {
  prefix: 'fad',
  iconName: 'face-thinking',
  icon: [
    512,
    512,
    [],
    'e39b',
    [
      'M0 256c0 45 11.6 87.3 32 124l0-28c0-30.9 25.1-56 56-56s56 25.1 56 56l0 3 92.2-33.5-82.4-34.7c-8.1-3.4-12-12.8-8.5-21s12.8-12 21-8.5l122.5 51.6c22.7 9.6 37.9 31.2 39.2 55.6c1.5 24.2-12.9 47.4-36.8 56.1l-35.8 13-21 57.7c-2.5 6.8-5.8 13.1-9.8 18.8c10.3 1.3 20.8 1.9 31.4 1.9c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM114.1 119.9c-4.4-7.7-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5c4.4 3.8 8.8 7.5 13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6zM208.4 176a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 352c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 26.5 21.5 48 48 48l47.2 0c20.2 0 38.2-12.6 45.1-31.6l26.1-71.7 49.8-18.1c12.5-4.5 18.9-18.3 14.4-30.8s-18.3-18.9-30.8-14.4L112 400.6l0-48.6zM368.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faTurnDownRight = {
  prefix: 'fad',
  iconName: 'turn-down-right',
  icon: [
    512,
    512,
    [],
    'e455',
    [
      'M0 64L0 224c0 61.9 50.1 112 112 112l208 0 0-96-208 0c-8.8 0-16-7.2-16-16L96 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64z',
      'M360.5 441.4c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22l0-272c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z',
    ],
  ],
};
const faBottleDroplet = {
  prefix: 'fad',
  iconName: 'bottle-droplet',
  icon: [
    320,
    512,
    [],
    'e4c4',
    [
      'M32 256l0 192c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-192c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1L216 48c-37.3 0-74.7 0-112 0l0 72.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256zm80 80c0-22.2 23-52 37.2-68.2c5.8-6.7 15.9-6.7 21.7 0C185 284 208 313.8 208 336c0 32-21.5 48-48 48s-48-21.5-48-48z',
      'M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 0zm64 384c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C135 284 112 313.8 112 336c0 26.5 21.5 48 48 48z',
    ],
  ],
};
const faMaskFace = {
  prefix: 'fad',
  iconName: 'mask-face',
  icon: [
    640,
    512,
    [],
    'e1d7',
    [
      'M0 184c0-30.9 25.1-56 56-56l72 0c-17.7 0-32 14.3-32 32l0 16-40 0c-4.4 0-8 3.6-8 8l0 85c0 33 22.5 61.8 54.5 69.9l29.8 7.4c17.3 26.4 40 49 66.5 66.1l-108-27C37.5 372.1 0 324.1 0 269l0-85zM441.1 412.5c26.6-17.1 49.3-39.7 66.5-66.1l29.8-7.4c32.1-8 54.5-36.8 54.5-69.9l0-85c0-4.4-3.6-8-8-8l-40 0 0-16c0-17.7-14.3-32-32-32l72 0c30.9 0 56 25.1 56 56l0 85c0 55.1-37.5 103.1-90.9 116.4l-108 27z',
      'M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1L128 128c-17.7 0-32 14.3-32 32l0 64c0 123.7 100.3 224 224 224s224-100.3 224-224l0-64c0-17.7-14.3-32-32-32l-25.2 0c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM192 208c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 48l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faHillRockslide = {
  prefix: 'fad',
  iconName: 'hill-rockslide',
  icon: [
    576,
    512,
    [],
    'e508',
    [
      'M192 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm60.4 24.2l27-48c2.8-5 8.2-8.2 13.9-8.2l53.3 0c5.8 0 11.1 3.1 13.9 8.2l27 48c2.7 4.9 2.7 10.8 0 15.7l-27 48c-2.8 5-8.2 8.2-13.9 8.2l-53.3 0c-5.8 0-11.1-3.1-13.9-8.2l-27-48c-2.7-4.9-2.7-10.8 0-15.7zM416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 53.4c0-5.8 3.1-11.1 8.2-13.9l48-27c4.9-2.7 10.8-2.7 15.7 0l48 27c5 2.8 8.2 8.2 8.2 13.9l0 53.3c0 5.8-3.1 11.1-8.2 13.9l-48 27c-2.4 1.4-5.1 2.1-7.8 2.1s-5.4-.7-7.8-2.1l-48-27c-5-2.8-8.2-8.2-8.2-13.9l0-53.3z',
      'M54.6 73.4c-9.2-9.2-22.9-11.9-34.9-6.9S0 83.1 0 96L0 480c0 17.7 14.3 32 32 32l384 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-384-384z',
    ],
  ],
};
const faScannerKeyboard = {
  prefix: 'fad',
  iconName: 'scanner-keyboard',
  icon: [
    512,
    512,
    [],
    'f489',
    [
      'M0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96C28.7 96 0 124.7 0 160zm64 24c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L88 224c-13.3 0-24-10.7-24-24l0-16zm0 120c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-32zm128-96c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-32z',
      'M152 0l16 0c13.3 0 24 10.7 24 24l0 40-64 0 0-40c0-13.3 10.7-24 24-24zM312 0l16 0c13.3 0 24 10.7 24 24l0 40-64 0 0-40c0-13.3 10.7-24 24-24zM224 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48-32 0 0-48zM400 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-240zM88 160l176 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L88 224c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faCircleO = {
  prefix: 'fad',
  iconName: 'circle-o',
  icon: [
    512,
    512,
    [],
    'e119',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm384 0a128 128 0 1 1 -256 0 128 128 0 1 1 256 0zm-208 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      'M256 176a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm128 80a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z',
    ],
  ],
};
const faGridHorizontal = {
  prefix: 'fad',
  iconName: 'grid-horizontal',
  icon: [
    448,
    512,
    [],
    'e307',
    [
      'M0 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM160 168c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM320 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48z',
      'M0 168c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM160 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM448 168l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40z',
    ],
  ],
};
const faMessageDollar = {
  prefix: 'fad',
  iconName: 'message-dollar',
  icon: [
    512,
    512,
    ['comment-alt-dollar'],
    'f650',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM188.2 166.6c0 .6-.1 1.3-.1 1.9s0 1.3 0 1.9c0 .8 0 1.3 0 1.9c0 .6 .1 1.2 .1 1.8c.1 1.2 .2 2.4 .4 3.5c.4 2.3 .9 4.5 1.5 6.6c1.3 4.2 3.2 7.9 5.5 11.2c4.6 6.7 10.7 11.8 17.1 15.6c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c0 .6 0 1.2-.1 1.8c-.1 .6-.1 1.1-.3 1.6c-.2 1-.6 1.9-1.1 2.8c-1 1.7-2.5 3-4.5 4.3c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c8.3 2.9 17.9 6.2 28.3 8.4c0 4.9 0 9.7 0 14.6c0 .7 0 1.4 .1 2s.2 1.3 .3 2c.3 1.3 .7 2.6 1.2 3.7c1 2.4 2.5 4.5 4.3 6.4c3.6 3.6 8.6 5.9 14.1 5.9c11 0 20-9 20-20c0-4.6 0-9.2 0-13.8c8-1.7 16-4.5 23.2-9c7.2-4.4 13.4-10.5 17.9-18c2.2-3.8 4-7.9 5.2-12.4c.6-2.3 1.1-4.6 1.3-7c.1-1.2 .3-2.4 .3-3.7c0-.6 .1-1.3 .1-1.9c0-.6 0-1.3 0-1.9c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-2.6-1.6-3.9-2.8-4.6-3.8c-.3-.5-.5-1-.6-1.5c0-.2-.1-.5-.1-.7c0-.2 0-.4 0-.6c0-.7 0-1.1 .1-1.4c0-.4 .1-.9 .2-1.3c.2-.8 .5-1.6 1-2.4c.9-1.5 2.5-2.9 4.9-4.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7c0-4.6 0-9.2 0-13.9c0-11-9-20-20-20c-5.5 0-10.5 2.2-14.1 5.9c-1.8 1.8-3.3 4-4.3 6.4c-.5 1.2-.9 2.5-1.2 3.8c-.1 .7-.2 1.3-.3 2s-.1 1.3-.1 1.9c0 4.8 0 9.5 0 14.2c-7.6 1.7-15.2 4.4-22.2 8.5c-7 4.1-13.4 9.8-18.2 17.1c-2.4 3.7-4.3 7.7-5.6 12.2c-.7 2.2-1.2 4.6-1.5 7c-.2 1.2-.3 2.5-.4 3.7z',
      'M256 84c11 0 20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20z',
    ],
  ],
};
const faCommentAltDollar = faMessageDollar;
const faRightLeft = {
  prefix: 'fad',
  iconName: 'right-left',
  icon: [
    512,
    512,
    ['exchange-alt'],
    'f362',
    [
      'M0 384c0 8.5 3.4 16.6 9.4 22.6l96 96c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-64 320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-320 0 0-64c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-96 96c-6 6-9.4 14.1-9.4 22.6z',
      'M0 128c0-17.7 14.3-32 32-32l320 0 0-64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-64L32 160c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faExchangeAlt = faRightLeft;
const faColumns3 = {
  prefix: 'fad',
  iconName: 'columns-3',
  icon: [
    640,
    512,
    [],
    'e361',
    [
      'M192 96l64 0 0 320-64 0 0-320zm192 0l64 0 0 320-64 0 0-320z',
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM576 96l0 320L64 416 64 96l512 0z',
    ],
  ],
};
const faPaperPlane = {
  prefix: 'fad',
  iconName: 'paper-plane',
  icon: [
    512,
    512,
    [61913],
    'f1d8',
    [
      'M0 288c0 .7 0 1.3 .1 2c.8 12.2 8.4 22.9 19.6 27.6l112 46.7L160 376l0-8c0-4.2 1.7-8.3 4.7-11.3l13-13c59.6-59.6 119.2-119.2 178.8-178.7c.1-.1 .2-.2 .2-.3c3-3 6.8-4.5 10.7-4.7s7.9 1.1 11 3.9c3.7 3.3 5.6 7.7 5.6 12.1c0 3.4-1.1 6.8-3.3 9.7L224 389.4l0 13.2c20 8.3 40 16.7 60 25c39.9 16.6 79.8 33.2 119.7 49.9c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416c1.9-12.1-3.4-24.3-13.5-31.2C492.7 1.9 486.4 0 480 0c-5.5 0-10.9 1.4-15.9 4.2l-448 256C6.1 265.9 0 276.6 0 288z',
      'M380.7 185.8c5.1-6.7 4.2-16.2-2.1-21.8s-15.9-5.3-21.9 .7l-179 179-13 13c-3 3-4.7 7.1-4.7 11.3l0 8 0 56 0 48c0 13.2 8.1 25 20.3 29.8s26.2 1.6 35.2-8.1L284 427.7l-60-25 0-13.2L380.7 185.8z',
    ],
  ],
};
const faRoadCircleExclamation = {
  prefix: 'fad',
  iconName: 'road-circle-exclamation',
  icon: [
    640,
    512,
    [],
    'e565',
    [
      'M32 425.4C32 455.5 56.5 480 86.6 480L288 480l0-64c0-17.7 14.3-32 32-32l.7 0c-.5-5.3-.7-10.6-.7-16c0-16.9 2.4-33.3 6.8-48.7c-2.2 .5-4.5 .7-6.8 .7c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 42.8c31.9-45.2 84.5-74.8 144-74.8c11.6 0 22.9 1.1 33.8 3.2L487.1 74.6C478 49.1 453.9 32 426.8 32L352 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2z',
      'M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z',
    ],
  ],
};
const faDungeon = {
  prefix: 'fad',
  iconName: 'dungeon',
  icon: [
    512,
    512,
    [],
    'f6d9',
    [
      'M176 224l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64-32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16l0-272c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 32l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
      'M327.1 125.3l30.5-76.2c5.2-12.9 20.3-18.8 32.1-11.6c21.2 13 40.3 29 56.9 47.4c9.1 10.2 6.3 25.8-5.1 33.4l-67.6 45.1c-10.3 6.9-24.1 4.6-33.4-3.6c-1.3-1.1-2.6-2.3-3.9-3.3c-9.3-7.5-13.9-20.1-9.5-31.2zM313 6.4c13.4 3.1 20.1 17.6 15 30.5l-30.3 75.8c-4.5 11.3-16.8 17.2-29 16c-4.2-.4-8.4-.6-12.7-.6s-8.6 .2-12.7 .6c-12.1 1.2-24.4-4.7-29-16L184 36.8C178.8 24 185.5 9.4 199 6.4C217.3 2.2 236.4 0 256 0s38.7 2.2 57 6.4zM70.5 118.5C59.1 110.9 56.3 95.2 65.5 85C82 66.6 101.1 50.6 122.3 37.6c11.9-7.3 26.9-1.4 32.1 11.6l30.5 76.2c4.4 11.1-.2 23.6-9.5 31.2c-1.3 1.1-2.7 2.2-4 3.3c-9.3 8.2-23 10.5-33.4 3.6L70.5 118.5zm319 73.1l68.6-45.7c11.7-7.8 27.6-4 33.1 8.9c10.4 24.1 17.2 50.1 19.7 77.3c1.2 13.2-9.6 24-22.9 24l-80 0c-13.3 0-23.8-10.8-26.2-23.9c-.6-3.4-1.4-6.7-2.3-10c-3.1-11.4 .2-24 10-30.5zM20.8 154.7c5.5-12.9 21.4-16.6 33.1-8.9l68.6 45.7c9.8 6.5 13.2 19.2 10 30.5c-.9 3.3-1.7 6.6-2.3 10c-2.5 13-13 23.9-26.2 23.9l-80 0C10.7 256-.1 245.2 1.1 232c2.5-27.2 9.3-53.2 19.7-77.3zM128 312l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24zm256 0c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48zM0 440c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48zm384 0c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48z',
    ],
  ],
};
const faHandHoldingBox = {
  prefix: 'fad',
  iconName: 'hand-holding-box',
  icon: [
    576,
    512,
    [],
    'f47b',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M224 0l0 121.7c0 3.5 2.8 6.3 6.3 6.3c1.1 0 2.2-.3 3.1-.8l46.6-26.6c4.9-2.8 11-2.8 15.9 0l46.6 26.6c1 .5 2 .8 3.1 .8c3.5 0 6.3-2.8 6.3-6.3L352 0l80 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48L96 48c0-26.5 21.5-48 48-48l80 0z',
    ],
  ],
};
const faInputText = {
  prefix: 'fad',
  iconName: 'input-text',
  icon: [
    640,
    512,
    [],
    'e1bf',
    [
      'M0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm64 0l512 0 0 256L64 384l0-256z',
      'M205.9 174.3c-3.9-8.7-12.4-14.3-21.9-14.3s-18.1 5.6-21.9 14.3l-64 144c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l4.3-9.7 75.5 0 4.3 9.7c5.4 12.1 19.6 17.6 31.7 12.2s17.6-19.6 12.2-31.7l-64-144zM200.4 280l-32.8 0L184 243.1 200.4 280zM304 184l0 8 0 64 0 64 0 8c0 13.3 10.7 24 24 24l68 0c33.1 0 60-26.9 60-60c0-18.6-8.5-35.3-21.8-46.3c3.7-7.8 5.8-16.5 5.8-25.7c0-33.1-26.9-60-60-60l-52 0c-13.3 0-24 10.7-24 24zm48 24l28 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-28 0 0-24zm0 96l0-24 28 0 16 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-44 0z',
    ],
  ],
};
const faWindowFlip = {
  prefix: 'fad',
  iconName: 'window-flip',
  icon: [
    512,
    512,
    ['window-alt'],
    'f40f',
    [
      'M0 224l512 0 0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 224zm352-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M448 32c35.3 0 64 28.7 64 64l0 128L0 224 0 96C0 60.7 28.7 32 64 32l384 0zM416 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faWindowAlt = faWindowFlip;
const faAlignRight = {
  prefix: 'fad',
  iconName: 'align-right',
  icon: [
    448,
    512,
    [],
    'f038',
    [
      'M160 64c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 32c-17.7 0-32 14.3-32 32zm0 256c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0c-17.7 0-32 14.3-32 32z',
      'M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224z',
    ],
  ],
};
const faScannerGun = {
  prefix: 'fad',
  iconName: 'scanner-gun',
  icon: [
    576,
    512,
    ['scanner'],
    'f488',
    [
      'M0 144c0 50.7 33.8 93.6 80 107.4L8.1 374.7c-13.3 22.8-5.7 52.2 17.1 65.6l53.4 31.4c7.6 4.5 16 6.6 24.3 6.6c16.5 0 32.5-8.5 41.4-23.7L261.2 256l42.8 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L112 32C50.1 32 0 82.1 0 144z',
      'M440 32c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24L440 32zm0 160c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24l-112 0zM416 440l0 16c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zm16-312c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zM416 304c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z',
    ],
  ],
};
const faScanner = faScannerGun;
const faTire = {
  prefix: 'fad',
  iconName: 'tire',
  icon: [
    512,
    512,
    [],
    'f631',
    [
      'M96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm32 0c0-36.8 15.5-69.9 40.3-93.3l28.1 38.7 10.1 13.9c-9.1 11-14.5 25.2-14.5 40.6c0 1.4 0 2.7 .1 4l-61.8 20.1c-1.5-7.8-2.3-15.9-2.3-24.2zm12.2 54.6l61.9-20.1c8.6 13.4 22.1 23.4 37.9 27.5l0 65c-44.2-5.5-81.5-33.6-99.8-72.4zm54-166.7C212.5 133.8 233.6 128 256 128s43.5 5.8 61.8 15.9l-38.2 52.6c-7.3-2.9-15.3-4.5-23.6-4.5s-16.3 1.6-23.6 4.5l-10-13.8-28.1-38.8zM288 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-16.1 62c15.9-4.1 29.4-14.1 38-27.6l61.9 20.1c-18.3 38.8-55.6 66.9-99.8 72.4l0-65zm33.5-102.6l38.2-52.6C368.5 186.1 384 219.2 384 256c0 8.3-.8 16.3-2.3 24.2L319.9 260c.1-1.3 .1-2.7 .1-4c0-15.4-5.5-29.6-14.5-40.6z',
      'M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm416 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faEngine = {
  prefix: 'fad',
  iconName: 'engine',
  icon: [
    640,
    512,
    [],
    'e16e',
    [
      'M0 160L0 352c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0-48-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24zM184 88c0 13.3 10.7 24 24 24l72 0 0 32 48 0 0-32 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L208 64c-13.3 0-24 10.7-24 24zM544 224l0 192c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z',
      'M96 176c0-17.7 14.3-32 32-32l32 0 48 0 201.5 0c14.5 0 28.6 4.9 40 14L488 188.8c15.2 12.1 24 30.5 24 50L512 384c0 35.3-28.7 64-64 64l-193.2 0c-19.4 0-37.8-8.8-50-24l-32-40L128 384c-17.7 0-32-14.3-32-32l0-176zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faMoneyBill1Wave = {
  prefix: 'fad',
  iconName: 'money-bill-1-wave',
  icon: [
    576,
    512,
    ['money-bill-wave-alt'],
    'f53b',
    [
      'M64 208l0 144c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.1c4.7-1.2 9.4-2.3 14.2-3.6c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4l0-144c-33.9 0-61.6-26.4-63.9-59.7c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208zm144 48c0-53 35.8-96 80-96s80 43 80 96s-35.8 96-80 96s-80-43-80-96z',
      'M0 418.3L0 115.8C0 92 25.4 76.2 48.4 82.4C128.2 103.9 208.1 84 288 64c86.9-21.7 173.8-43.5 260.7-11.8C565.8 58.5 576 75.5 576 93.7l0 302.6c0 23.8-25.4 39.5-48.3 33.4C447.8 408.1 367.9 428 288 448c-86.9 21.7-173.8 43.4-260.7 11.8C10.2 453.5 0 436.5 0 418.3zm448.1-318c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6c0 0 0 0 0 0c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208l0 144c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.1c4.7-1.2 9.4-2.3 14.2-3.6c0 0 0 0 0 0c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4l0-144c-33.9 0-61.6-26.3-63.9-59.7zM272 188l16 0c11 0 20 9 20 20l0 68 4 0c11 0 20 9 20 20s-9 20-20 20l-24 0-24 0c-11 0-20-9-20-20s9-20 20-20l4 0 0-48.4c-9.1-1.9-16-9.9-16-19.6c0-11 9-20 20-20z',
    ],
  ],
};
const faMoneyBillWaveAlt = faMoneyBill1Wave;
const faLifeRing = {
  prefix: 'fad',
  iconName: 'life-ring',
  icon: [
    512,
    512,
    [],
    'f1cd',
    [
      'M0 256c0 59.2 20.3 113.5 53.9 156.8l3.1-3.1c.1-.1 .2-.2 .3-.3l112-112c-5.8-12.6-9.4-26.6-9.4-41.4s3.5-28.8 9.4-41.4c-37.4-37.3-74.7-74.7-112-112c-.1-.1-.3-.3-.4-.4l-3.1-3.1C20.3 142.5 0 196.8 0 256zM99.2 53.9l3.1 3.1c.1 .1 .3 .2 .4 .4c37.3 37.3 74.6 74.6 111.9 112c12.7-5.9 26.6-9.4 41.4-9.4s28.8 3.5 41.4 9.4c37.4-37.4 74.7-74.7 112-112c.1-.1 .2-.2 .3-.3l3.1-3.1C369.5 20.3 315.2 0 256 0S142.5 20.3 99.2 53.9zm0 404.1C142.5 491.7 196.8 512 256 512s113.5-20.3 156.8-53.9l-3.1-3.1c-.1-.1-.2-.2-.3-.3c-37.3-37.3-74.6-74.6-112-112c-12.7 5.9-26.6 9.4-41.4 9.4s-28.8-3.5-41.4-9.4c-37.3 37.4-74.7 74.7-112 112c-.1 .1-.3 .3-.4 .4l-3 3zM342.6 214.6c5.8 12.6 9.4 26.6 9.4 41.4s-3.5 28.8-9.4 41.4c37.4 37.3 74.7 74.7 112 112c.1 .1 .2 .2 .3 .3l3.1 3.1C491.7 369.5 512 315.2 512 256s-20.3-113.5-53.9-156.8l-3 3c-.1 .1-.3 .3-.4 .4l-112 112z',
      'M57.4 57.4c-12.5 12.5-12.5 32.8 0 45.3l112 112c9.5-19.8 25.5-35.8 45.3-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm112 240l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c-19.8-9.5-35.8-25.5-45.3-45.3zm128 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-112-112c-9.5 19.8-25.5 35.8-45.3 45.3zm45.3-128l112-112c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-112 112c19.8 9.5 35.8 25.5 45.3 45.3z',
    ],
  ],
};
const faHands = {
  prefix: 'fad',
  iconName: 'hands',
  icon: [
    576,
    512,
    ['sign-language', 'signing'],
    'f2a7',
    [
      'M152.8 164.2c0 4.1 1 8.2 3.2 12L179 216l31.8 0c4.4 0 8.8 0 13.3 0l4.7 0c-2.2-5.6-3.7-11.4-4.3-17.4l-26.8-46.4c-6.6-11.5-21.3-15.4-32.8-8.8c-7.7 4.4-12 12.5-12 20.8zm49.6-51.7l28.9 50c.8-1.5 1.6-3 2.5-4.4c8.4-13.4 20.8-22.6 34.7-27L243.9 88.5c-6.6-11.5-21.3-15.4-32.8-8.8s-15.4 21.3-8.8 32.8zm46.4-63.7l45.9 79.5c9.4 1 18.7 4.1 27.3 9.4l60.2 37.6C443 213.4 480 280.2 480 352l0 8c0 1.9 0 3.8-.1 5.7c40.1-32.1 64-80.9 64-133.1L544 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l-.1 49.3L426.1 116c-19.2-33.2-38.3-66.4-57.5-99.5c-4.4-7.7-12.5-12-20.8-12c-4.1 0-8.2 1-12 3.2c-11.5 6.6-15.4 21.3-8.8 32.8l51.5 89.1c3.3 5.7 1.3 13.1-4.4 16.4s-13.1 1.3-16.4-4.4L290.3 24.8C283.6 13.3 269 9.4 257.5 16s-15.4 21.3-8.8 32.8z',
      'M305 164.9c-15-9.4-34.7-4.8-44.1 10.2s-4.8 34.7 10.2 44.1L317.2 248 224 248s0 0 0 0s0 0 0 0L88 248c-13.3 0-24 10.7-24 24s10.7 24 24 24l124 0c6.6 0 12 5.4 12 12s-5.4 12-12 12L56 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l156 0c6.6 0 12 5.4 12 12s-5.4 12-12 12L88 392c-13.3 0-24 10.7-24 24s10.7 24 24 24l124 0c6.6 0 12 5.4 12 12s-5.4 12-12 12l-92 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c83.9 0 152-68.1 152-152l0-8c0-60.8-31.3-117.3-82.9-149.5L305 164.9z',
    ],
  ],
};
const faSignLanguage = faHands;
const faSigning = faHands;
const faCircleCaretRight = {
  prefix: 'fad',
  iconName: 'circle-caret-right',
  icon: [
    512,
    512,
    ['caret-circle-right'],
    'f330',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM208 152l0 208c0 9.5 5.7 18.2 14.4 22c3.1 1.3 6.3 2 9.6 2c5.9 0 11.8-2.2 16.3-6.4l112-104c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-4.5-4.2-10.4-6.4-16.3-6.4c-3.2 0-6.5 .7-9.6 2c-8.7 3.8-14.4 12.5-14.4 22z',
      'M360.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z',
    ],
  ],
};
const faCaretCircleRight = faCircleCaretRight;
const faTurnLeft = {
  prefix: 'fad',
  iconName: 'turn-left',
  icon: [
    512,
    512,
    [],
    'e636',
    [
      'M192 176l0 96 192 0c17.7 0 32 14.3 32 32l0 144c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-144c0-70.7-57.3-128-128-128l-192 0z',
      'M151.5 70.6c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 272c0 9.6-5.7 18.2-14.5 22s-19 2-26-4.6l-144-136C2.7 236.9 0 230.6 0 224s2.7-12.9 7.5-17.4l144-136z',
    ],
  ],
};
const faWheat = {
  prefix: 'fad',
  iconName: 'wheat',
  icon: [
    512,
    512,
    [],
    'f72d',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6s14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l68.9-68.9c-3.5-3.5-6.9-6.9-10.4-10.4c-4.9-4.9-9.9-9.9-14.8-14.8c-6.7-6.7-13.4-13.4-20.1-20.1L9.4 457.4C3.1 463.6 0 471.8 0 480zM145.7 368.1c1-.3 2-.5 2.9-.8c1-.3 2-.5 3-.7c2-.5 4-.9 5.9-1.3c4-.7 8-1.3 12-1.7c8-.7 16.1-.7 24.1 .1l31.9-31.9c-3.5-3.5-6.9-6.9-10.4-10.4c-10-10-20-20-30-30c-1.6-1.6-3.3-3.3-4.9-4.9l-30.5 30.5c2.1 17 .8 34.4-4 51zM247.5 266.3c1-.3 2-.6 3-.8s1.9-.5 2.9-.7c2-.5 3.9-.9 5.9-1.2c4-.7 8-1.3 12-1.7c8-.7 16.1-.7 24.1 .1l31.9-31.9-10.4-10.4L294.2 197c-4.1-4.1-8.1-8.1-12.2-12.2l-30.5 30.5c2.1 17 .8 34.4-4 51z',
      'M384 88c0-48.6 39.4-88 88-88l24 0c8.8 0 16 7.2 16 16l0 24c0 48.6-39.4 88-88 88l-24 0c-8.8 0-16-7.2-16-16l0-24zM181 129.1c6.2-6.2 16.4-6.2 22.6 0L215 140.5c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0L215 321.5s0 0 0 0l-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8L181 129.1zM282.8 27.3c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6s0 0 0 0l-45.3-45.3c-37.5-37.5-37.5-98.3 0-135.8l11.3-11.3zM79.2 231c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5L282.8 412c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-22.6-22.6s0 0 0 0L67.9 378c-37.5-37.5-37.5-98.3 0-135.8L79.2 231z',
    ],
  ],
};
const faFileSpreadsheet = {
  prefix: 'fad',
  iconName: 'file-spreadsheet',
  icon: [
    384,
    512,
    [],
    'f65b',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM56 256l0 16 0 80 0 64c0 17.7 14.3 32 32 32l64 0 80 0 64 0c17.7 0 32-14.3 32-32l0-64 0-80 0-16c0-17.7-14.3-32-32-32L88 224c-17.7 0-32 14.3-32 32z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM88 224c-17.7 0-32 14.3-32 32l0 16 0 80 0 64c0 17.7 14.3 32 32 32l64 0 80 0 64 0c17.7 0 32-14.3 32-32l0-64 0-80 0-16c0-17.7-14.3-32-32-32L88 224zm0 112l0-48 48 0 0 48-48 0zm80 0l0-48 48 0 0 48-48 0zm80 0l0-48 48 0 0 48-48 0zm0 32l48 0 0 48-48 0 0-48zm-32 0l0 48-48 0 0-48 48 0zm-80 0l0 48-48 0 0-48 48 0z',
    ],
  ],
};
const faAudioDescriptionSlash = {
  prefix: 'fad',
  iconName: 'audio-description-slash',
  icon: [
    640,
    512,
    [],
    'e0a8',
    [
      'M32 121.2L32 416c0 35.3 28.7 64 64 64l391.4 0L314.3 343.6c-2 2.4-4.6 4.4-7.5 5.9c-11.9 5.9-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l42.5-85L32 121.2zM76.8 34.9C163.2 102.6 249.6 170.3 336 238l0-54c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96c0 35.3-19 66.1-47.4 82.8C510 374.4 555.4 410 600.8 445.6c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9zM202.9 279.8l30.4 0-21.8-17.2-8.6 17.2zM384 208l0 67.7c12 9.4 24 18.8 35.9 28.2c24.7-2 44.1-22.7 44.1-47.8c0-26.5-21.5-48-48-48l-32 0z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faBellRing = {
  prefix: 'fad',
  iconName: 'bell-ring',
  icon: [
    512,
    512,
    [],
    'e62c',
    [
      'M32 384c0 4.4 .9 8.9 2.8 13.1C40 408.6 51.4 416 64 416l384 0c12.6 0 24-7.4 29.2-18.9c1.9-4.2 2.8-8.7 2.8-13.1c0-7.7-2.8-15.3-8.1-21.3l-7.4-8.3C433.3 319.2 416 273.9 416 226.8l0-18.8c0-77.4-55-142-128-156.8L288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2C151 66 96 130.6 96 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-5.3 6-8.1 13.6-8.1 21.3z',
      'M113.4 15.4c9.1 9.6 8.8 24.8-.8 33.9C72.8 87.3 48 140.7 48 200c0 13.3-10.7 24-24 24s-24-10.7-24-24C0 127.1 30.5 61.2 79.4 14.6c9.6-9.1 24.8-8.8 33.9 .8zM320 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0 64 0zM399.4 49.4c-9.6-9.1-10-24.3-.8-33.9s24.3-10 33.9-.8C481.5 61.2 512 127.1 512 200c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-59.3-24.8-112.7-64.6-150.6z',
    ],
  ],
};
const faCalendarDay = {
  prefix: 'fad',
  iconName: 'calendar-day',
  icon: [
    448,
    512,
    [],
    'f783',
    [
      'M0 192L0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272L0 192zm64 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96z',
      'M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 80L0 192l0-80C0 85.5 21.5 64 48 64l48 0 0-32z',
    ],
  ],
};
const faWaterLadder = {
  prefix: 'fad',
  iconName: 'water-ladder',
  icon: [
    576,
    512,
    ['ladder-water', 'swimming-pool'],
    'f5c5',
    [
      'M.8 455.3c4 17.2 21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9c.6-2.4 .8-4.9 .8-7.3c0-14.5-10-27.7-24.7-31.1c-18.1-4.2-36.2-13.3-50.6-25.2c-5.9-5-13.3-7.6-20.7-7.6c-6.5 0-12.9 2-18.5 5.9C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1C109 386 102.5 384 96 384c-7.4 0-14.8 2.6-20.7 7.6c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4z',
      'M223.7 32C170.9 32 128 74.9 128 127.7L128 361c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.1 20.3l0-96.5 192 0 0 96.5s0 0 0 0c19 0 41.2-7.9 59.2-20.3c1.6-1.1 3.2-2.1 4.8-3.1l0-233.3c0-17.5 14.2-31.7 31.7-31.7c16 0 29.5 11.9 31.5 27.8l1 8.2c2.2 17.5 18.2 30 35.7 27.8s30-18.2 27.8-35.7l-1-8.2C568.7 68 528 32 479.7 32C426.9 32 384 74.9 384 127.7l0 96.3-192 0 0-96.3c0-17.5 14.2-31.7 31.7-31.7c16 0 29.5 11.9 31.5 27.8l1 8.2c2.2 17.5 18.2 30 35.7 27.8s30-18.2 27.8-35.7l-1-8.2C312.7 68 272 32 223.7 32z',
    ],
  ],
};
const faLadderWater = faWaterLadder;
const faSwimmingPool = faWaterLadder;
const faArrowsUpDown = {
  prefix: 'fad',
  iconName: 'arrows-up-down',
  icon: [
    320,
    512,
    ['arrows-v'],
    'f07d',
    [
      'M32 384c0 8.2 3.1 16.4 9.4 22.6l96 96c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l96-96c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-12.5-12.5-32.8-12.5-45.3 0L192 402.7 192 256l-64 0 0 146.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0C35.1 367.6 32 375.8 32 384z',
      'M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3 128 256l64 0 0-146.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z',
    ],
  ],
};
const faArrowsV = faArrowsUpDown;
const faChessPawnPiece = {
  prefix: 'fad',
  iconName: 'chess-pawn-piece',
  icon: [
    256,
    512,
    ['chess-pawn-alt'],
    'f444',
    [
      'M0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416 4.8 473.6C1.7 477.8 0 482.8 0 488z',
      'M176 240c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l4.4 0L48 416l160 0L179.6 288l4.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0z',
    ],
  ],
};
const faChessPawnAlt = faChessPawnPiece;
const faFaceGrimace = {
  prefix: 'fad',
  iconName: 'face-grimace',
  icon: [
    512,
    512,
    [128556, 'grimace'],
    'f57f',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112.7 88c3.8-22.7 23.6-40 47.3-40l8 0 0 40-55.3 0zm0 16l55.3 0 0 40-8 0c-23.8 0-43.5-17.3-47.3-40zm31.7-152c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM184 304l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-64 0 0-40zm80-56l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-64 0 0-40zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM344 304l8 0c23.8 0 43.5 17.3 47.3 40L344 344l0-40zm0 56l55.3 0c-3.8 22.7-23.6 40-47.3 40l-8 0 0-40z',
      'M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faGrimace = faFaceGrimace;
const faWheelchairMove = {
  prefix: 'fad',
  iconName: 'wheelchair-move',
  icon: [
    448,
    512,
    ['wheelchair-alt'],
    'e2ce',
    [
      'M0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-22.8-4.8-44.4-13.3-64c-20.5-46.9-62.9-82.1-114.3-92.7C182 193.1 171.1 192 160 192C71.6 192 0 263.6 0 352zm256 0A96 96 0 1 1 64 352a96 96 0 1 1 192 0z',
      'M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM172.8 54.4c9.5-7.1 22.1-8.4 32.8-3.4l116.5 54.8c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224l97.4 0c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288l-70.3 0c-20.5-46.9-62.9-82.1-114.3-92.7l54.2-54.2-50.8-23.9-48.6 36.4c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l64-48z',
    ],
  ],
};
const faWheelchairAlt = faWheelchairMove;
const faTurnDown = {
  prefix: 'fad',
  iconName: 'turn-down',
  icon: [
    384,
    512,
    [10549, 'level-down-alt'],
    'f3be',
    [
      'M0 32L0 64C0 81.7 14.3 96 32 96l96 0c8.8 0 16 7.2 16 16l0 208 96 0 0-208C240 50.1 189.9 0 128 0L32 0C14.3 0 0 14.3 0 32z',
      'M40.3 368.3L178.3 506.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L343.7 368.3c5.3-5.3 8.3-12.5 8.3-20c0-15.6-12.7-28.3-28.3-28.3L60.3 320C44.7 320 32 332.7 32 348.3c0 7.5 3 14.7 8.3 20z',
    ],
  ],
};
const faLevelDownAlt = faTurnDown;
const faSquareS = {
  prefix: 'fad',
  iconName: 'square-s',
  icon: [
    448,
    512,
    [],
    'e27d',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm127.4 98.8c.2-2.3 .5-4.7 1-7c4.7-26.3 23.1-43.3 45-52c13.7-5.4 29.3-7.8 45.5-7.8c8.9 0 18 .7 27.1 2.1c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c3.8 8.3 5.7 17.1 5.7 26.4c0 4.5-.4 9.2-1.3 13.9c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.7 5.7c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-1.9-4.1-3.3-8.4-4.3-12.8c-.5-2.2-.8-4.4-1-6.7c-.1-1.1-.2-2.3-.3-3.4c-.1-2.3-.1-4.6 0-6.9c.1-1.1 .1-2.3 .2-3.5z',
      'M191 180.4c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7l3.6-23.7-3.6 23.7c-20.3-3.1-36.8-1.4-47.8 2.9z',
    ],
  ],
};
const faRectangleBarcode = {
  prefix: 'fad',
  iconName: 'rectangle-barcode',
  icon: [
    576,
    512,
    ['barcode-alt'],
    'f463',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm96 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm80-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm64 8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm112 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm96-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z',
      'M96 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm80-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm88-16c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm88 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm112-24c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faBarcodeAlt = faRectangleBarcode;
const faPersonWalkingArrowRight = {
  prefix: 'fad',
  iconName: 'person-walking-arrow-right',
  icon: [
    640,
    512,
    [],
    'e552',
    [
      'M0 480c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6L68.7 398 9.4 457.4C3.1 463.6 0 471.8 0 480zM17.6 229.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c3.6 14.5 16.7 24.2 31 24.2c2.6 0 5.2-.3 7.8-1c17.1-4.3 27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8zM160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M505.4 153.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L530.7 288 384 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3z',
    ],
  ],
};
const faSquareEnvelope = {
  prefix: 'fad',
  iconName: 'square-envelope',
  icon: [
    448,
    512,
    ['envelope-square'],
    'f199',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm64.2 76.4C66 156.4 79.5 144 96 144l256 0c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8L64.2 172.4zm-.2 38c45.5 29.4 91.1 58.8 136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9c45.5-29.4 91.1-58.8 136.6-88.2L384 336c0 17.7-14.3 32-32 32L96 368c-17.7 0-32-14.3-32-32l0-125.6z',
      'M64.2 172.4L218 271.7c1.8 1.2 3.9 1.8 6 1.8s4.2-.6 6-1.8l153.8-99.3C382 156.4 368.5 144 352 144L96 144c-16.5 0-30 12.4-31.8 28.4zm319.8 38L247.4 298.6c-7 4.5-15.1 6.9-23.4 6.9s-16.4-2.4-23.4-6.9L64 210.4 64 336c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-125.6z',
    ],
  ],
};
const faEnvelopeSquare = faSquareEnvelope;
const faDice = {
  prefix: 'fad',
  iconName: 'dice',
  icon: [
    640,
    512,
    [127922],
    'f522',
    [
      'M13.3 224c0 18.4 7 36.9 21.1 50.9L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3C260.9 20.3 242.4 13.3 224 13.3s-36.9 7-50.9 21.1L34.3 173.1C20.3 187.1 13.3 205.6 13.3 224zM120 224a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM248 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM376 224a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 176a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 448l0-34.2L436.3 297.5c28.6-28.6 37-69.6 25.4-105.5L576 192c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64zm160-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faUnicorn = {
  prefix: 'fad',
  iconName: 'unicorn',
  icon: [
    640,
    512,
    [129412],
    'f727',
    [
      'M0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256zM551.4 48c5.4 9.4 8.6 20.3 8.6 32l0 10.7 73.6-24.5c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3l-79.3 0z',
      'M448 238.1l0-78.1 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L560 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 464 0 448 0C377.3 0 320 57.3 320 128l-96 0-20.8 0-54.4 0C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faBowlingBall = {
  prefix: 'fad',
  iconName: 'bowling-ball',
  icon: [
    512,
    512,
    [],
    'f436',
    [
      'M112 176a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faPompebled = {
  prefix: 'fad',
  iconName: 'pompebled',
  icon: [
    512,
    512,
    [],
    'e43d',
    [
      'M460.3 172c-46.2-33.2-117-14.1-165.1 44.3c-5.9 8.6-17.2 10.6-25.6 4.5s-10.3-17.6-4.4-26.2c36.9-66.9 29-141.3-17.7-173.5C188.6-20.6 103.1 1.5 56.9 70.4c-85.5 126.3-77.6 313.4 44.2 400.4c121.4 87 296.3 27.7 381.8-98.6c46.2-68.4 36.4-158.5-22.6-200.2z',
      '',
    ],
  ],
};
const faBrain = {
  prefix: 'fad',
  iconName: 'brain',
  icon: [
    512,
    512,
    [129504],
    'f5dc',
    [
      'M0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56l0-400c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304zM272 56l0 400c0 30.9 25.1 56 56 56c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56z',
      'M240 456l0-400 32 0 0 400-32 0z',
    ],
  ],
};
const faWatchSmart = {
  prefix: 'fad',
  iconName: 'watch-smart',
  icon: [
    384,
    512,
    [],
    'e2cc',
    [
      'M0 144c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6l224 0c5.5 0 10.8 .6 16 1.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6C27.5 439 0 406.7 0 368L0 144zm168 16l0 96c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-86.1c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3c5.2-1 10.5-1.6 16-1.6l224 0c5.5 0 10.8 .6 16 1.6l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6L64 464zM216 160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-86.1z',
    ],
  ],
};
const faBookUser = {
  prefix: 'fad',
  iconName: 'book-user',
  icon: [
    448,
    512,
    [],
    'f7e7',
    [
      'M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z',
      'M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm80 128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM128 304c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faSensorCloud = {
  prefix: 'fad',
  iconName: 'sensor-cloud',
  icon: [
    640,
    512,
    ['sensor-smoke'],
    'e02c',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 138.8c-14.5-6.9-30.8-10.8-48-10.8c-60.1 0-109.1 47.3-111.9 106.7C250.2 348.7 224 387.3 224 432c0 17.2 3.9 33.5 10.8 48L64 480c-35.3 0-64-28.7-64-64L0 96zm64 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 0l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M256 432c0 44.2 35.8 80 80 80l224 0c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432z',
    ],
  ],
};
const faSensorSmoke = faSensorCloud;
const faClapperboardPlay = {
  prefix: 'fad',
  iconName: 'clapperboard-play',
  icon: [
    512,
    512,
    [],
    'e132',
    [
      'M0 160l6.1 0 67.9 0 92.1 0 67.9 0 92.1 0 67.9 0L512 160l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160zm208 96l0 128c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1z',
      'M448 32l-86.1 0-1 1-127 127 92.1 0 1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128l0-64c0-15.1-5.3-29.1-14-40l-104 104L512 160zM294.1 32l-92.1 0-1 1L73.9 160l92.1 0 1-1 127-127zM64 32C28.7 32 0 60.7 0 96l0 64 6.1 0 1-1 127-127L64 32zM216.5 241.9c-5.2 2.8-8.5 8.2-8.5 14.1l0 128c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8z',
    ],
  ],
};
const faBandage = {
  prefix: 'fad',
  iconName: 'bandage',
  icon: [
    640,
    512,
    [129657, 'band-aid'],
    'f462',
    [
      'M0 160L0 352c0 35.3 28.7 64 64 64l96 0 0-320L64 96C28.7 96 0 124.7 0 160zM192 96l0 320 256 0 0-320L192 96zM296 208a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96-96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM480 96l0 320 96 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-96 0z',
      'M192 96l-32 0 0 320 32 0 0-320zm288 0l-32 0 0 320 32 0 0-320z',
    ],
  ],
};
const faBandAid = faBandage;
const faCalendarMinus = {
  prefix: 'fad',
  iconName: 'calendar-minus',
  icon: [
    448,
    512,
    [],
    'f272',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM112 352c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0z',
    ],
  ],
};
const faCircleXmark = {
  prefix: 'fad',
  iconName: 'circle-xmark',
  icon: [
    512,
    512,
    [61532, 'times-circle', 'xmark-circle'],
    'f057',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm168.1 61.7c.1-.7 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.4 31.4 47 47c15.7-15.7 31.4-31.4 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.3 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.2-1.1-.4-2.3-.3-2.2c-.1-1.2-.1-1.2-.1-2.4c0-1.5 .1-1.9 .1-2.3z',
      'M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faTimesCircle = faCircleXmark;
const faXmarkCircle = faCircleXmark;
const faCircle4 = {
  prefix: 'fad',
  iconName: 'circle-4',
  icon: [
    512,
    512,
    [],
    'e0f1',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.3 36.2c.2-1.3 .5-2.5 .9-3.8c16-48 32-96 48-144c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4c-12.5 37.5-25 74.9-37.5 112.4c23.6 0 47.1 0 70.7 0l0-56c0-.8 0-1.6 .1-2.5s.2-1.6 .4-2.4c.3-1.6 .8-3.1 1.4-4.5c1.2-2.9 3-5.5 5.1-7.6c4.3-4.3 10.3-7 17-7c13.3 0 24 10.7 24 24l0 56c2.7 0 5.3 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.7 0-5.3 0-8 0l0 40c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-1.2-.4-2.4-.4-2.4c-.1-1.2-.1-1.2-.1-2.5c0-13.3 0-26.7 0-40c-34.7 0-69.3 0-104 0c-7.7 0-15-3.7-19.5-10c-1.5-2.1-2.6-4.3-3.4-6.7c-.4-1.2-.7-2.4-.9-3.6c-.1-.9-.2-1.8-.2-1.8c-.1-.9-.1-.9-.1-1.9c0-.6 0-1.3 .1-1.9s.1-1.3 .2-1.9z',
      'M238.8 159.6c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l104 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-70.7 0 37.5-112.4z',
    ],
  ],
};
const faGifts = {
  prefix: 'fad',
  iconName: 'gifts',
  icon: [
    640,
    512,
    [],
    'f79c',
    [
      'M37.4 40.8C29 51.1 30.5 66.2 40.8 74.6L67 96l154 0 26.2-21.4c10.3-8.4 11.8-23.5 3.4-33.8s-23.5-11.8-33.8-3.4L191.3 58.3 200.6 32C205 19.5 198.5 5.8 186 1.4c-2.6-.9-5.4-1.4-8-1.4c-9.9 0-19.1 6.1-22.6 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l9.4 28.3L71.2 37.4C60.9 29 45.8 30.5 37.4 40.8zM224 272c0 26.7 0 53.3 0 80c64 0 128 0 192 0c0-26.7 0-53.3 0-80c-5.3 0-10.7 0-16 0c-18.7 0-37.3 0-56 0c-2 0-3.9-.1-5.8-.2s-3.8-.4-5.7-.7c-3.7-.6-7.4-1.5-10.9-2.7c-7.1-2.3-13.6-5.7-19.6-9.9C290.2 250 281 238 276.1 224l-4.1 0c-26.5 0-48 21.5-48 48zm0 112l0 80c0 26.5 21.5 48 48 48l144 0c0-42.7 0-85.3 0-128c-64 0-128 0-192 0zM448 272c0 26.7 0 53.3 0 80c64 0 128 0 192 0c0-26.7 0-53.3 0-80c0-26.5-21.5-48-48-48l-4.1 0c-9.9 28-36.6 48-67.9 48c-24 0-48 0-72 0zm0 112c0 42.7 0 85.3 0 128c48 0 96 0 144 0c26.5 0 48-21.5 48-48l0-80c-64 0-128 0-192 0z',
      'M48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l152.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-224c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96L48 96zm315.5 89.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM344 272l56 0 16 0 0 80-192 0 0 32 192 0 0 128 32 0 0-128 192 0 0-32-192 0 0-80 72 0c39.8 0 72-32.2 72-72c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72c0 39.8 32.2 72 72 72zm175.8-96c13.4 0 24.2 10.9 24.2 24c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5z',
    ],
  ],
};
const faAlbumCollection = {
  prefix: 'fad',
  iconName: 'album-collection',
  icon: [
    512,
    512,
    [],
    'f8a0',
    [
      'M.4 214l32 256c3 24 23.4 42 47.6 42l352 0c24.2 0 44.6-18 47.6-42l32-256c.2-2 .4-4 .4-6c0-11.6-4.2-22.9-12-31.8c-9.1-10.3-22.2-16.2-36-16.2L48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214zM72 344c0-75.1 82.4-136 184-136s184 60.9 184 136s-82.4 136-184 136S72 419.1 72 344z',
      'M32 24c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM256 480c101.6 0 184-60.9 184-136s-82.4-136-184-136S72 268.9 72 344s82.4 136 184 136zm0-104c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l432 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 80z',
    ],
  ],
};
const faHotel = {
  prefix: 'fad',
  iconName: 'hotel',
  icon: [
    512,
    512,
    [127976],
    'f594',
    [
      'M0 480c0 17.7 14.3 32 32 32l176 0 0-48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 48 176 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-384L32 64l0 384c-17.7 0-32 14.3-32 32zM96 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm67 152.2c10.6-41.5 48.2-72.2 93-72.2s82.5 30.7 93 72.2c3.3 12.8-7.8 23.8-21 23.8l-144 0c-13.3 0-24.3-10.9-21-23.8zM224 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm128-96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z',
      'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 0zm80 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm128 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8l144 0z',
    ],
  ],
};
const faEarthAsia = {
  prefix: 'fad',
  iconName: 'earth-asia',
  icon: [
    512,
    512,
    [127759, 'globe-asia'],
    'f57e',
    [
      'M1.1 280.3C13.4 410.3 122.8 512 256 512c66.3 0 126.7-25.2 172.1-66.5l-45.1-28.9c-8.5-5.4-19-6.6-28.4-3.1l-3.7 1.4c-19.8 7.4-41.8-1.9-50.4-21.1L295 381.4c-8.5-18.9-1.1-41.2 17-51.3L348.2 310c2.3-1.3 4.3-3.1 5.7-5.3l6.1-9.5c6-9.4 16.4-15.1 27.6-15.1s21.6 5.7 27.6 15.1l2 3.1c3.7 5.8 10.8 8.6 17.5 6.7l13.5-3.8c7-2 14.6-.6 20.5 3.6l31.9 23c.4 .3 .7 .6 1.1 .8c6.8-23 10.4-47.4 10.4-72.6c0-109.5-68.8-203-165.5-239.6l-37.7 84.9c-3 6.8-8.9 11.7-16.1 13.5l-17.6 4.4c-16.7 4.2-23.7 24-13.4 37.7l16.1 21.5c6.1 8.1 6.4 19.2 .8 27.7l-10.7 16.1C260.5 233.3 248 240 234.6 240l-2.3 0c-16.1 0-27.6 15.5-23 30.9l6 19.9c4.4 14.6-6.5 29.2-21.7 29.2c-10.7 0-20.6-6.1-25.4-15.7l-9.3-18.5c-7.3-14.7-26.9-17.8-38.4-6.2l-14.8 14.8c-6 6-14.6 8.4-22.8 6.3L1.1 280.3zm143.3 67.8c2.1-8.6 10.8-13.8 19.4-11.6l32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4zm92-20l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4zm69.2-175.3l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5z',
      'M1.1 280.3l81.7 20.4c8.2 2 16.8-.4 22.8-6.3l14.8-14.8c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9l2.3 0c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17.6-4.4c7.2-1.8 13.1-6.8 16.1-13.5l37.7-84.9C318.3 5.8 287.8 0 256 0C114.6 0 0 114.6 0 256c0 8.2 .4 16.3 1.1 24.3zm500.4 48.3c-.3-.3-.7-.6-1.1-.8l-31.9-23c-5.9-4.3-13.4-5.6-20.5-3.6l-13.5 3.8c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.4 21.1l3.7-1.4c9.4-3.5 20-2.4 28.4 3.1l45.1 28.9c34.2-31.1 60-71.4 73.5-116.9zM144.5 348.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z',
    ],
  ],
};
const faGlobeAsia = faEarthAsia;
const faIdCardClip = {
  prefix: 'fad',
  iconName: 'id-card-clip',
  icon: [
    576,
    512,
    ['id-card-alt'],
    'f47f',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L352 64l0 64 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-64L64 64C28.7 64 0 92.7 0 128zM176 437.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7l-202.7 0c-5.9 0-10.7-4.8-10.7-10.7zM352 288a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M256 0c-17.7 0-32 14.3-32 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32L256 0zm96 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM176 437.3c0 5.9 4.8 10.7 10.7 10.7l202.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-117.3 0c-29.5 0-53.3 23.9-53.3 53.3z',
    ],
  ],
};
const faIdCardAlt = faIdCardClip;
const faMagnifyingGlassPlus = {
  prefix: 'fad',
  iconName: 'magnifying-glass-plus',
  icon: [
    512,
    512,
    ['search-plus'],
    'f00e',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm96 0c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z',
      'M184 296l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24zM457.4 502.6L330.7 376C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z',
    ],
  ],
};
const faSearchPlus = faMagnifyingGlassPlus;
const faThumbsUp = {
  prefix: 'fad',
  iconName: 'thumbs-up',
  icon: [
    512,
    512,
    [128077, 61575],
    'f164',
    [
      'M160 247.1l0 24.9 0 48 0 38.3c0 32.1 16 62.1 42.7 79.9l38.5 25.7c15.8 10.5 34.3 16.1 53.3 16.1l97.5 0c26.5 0 48-21.5 48-48c0-3.6-.4-7-1.1-10.4c19.2-6.3 33.1-24.3 33.1-45.6c0-9.1-2.5-17.6-6.9-24.9c22.2-4.2 38.9-23.7 38.9-47.1c0-15.1-7-28.6-17.9-37.4c15.4-8 25.9-24.1 25.9-42.6c0-26.5-21.5-48-48-48l-144 0c13.7-23.1 23.5-48.5 28.8-75.2l2.3-11.4c5.2-26-11.7-51.3-37.7-56.5c-3.2-.6-6.3-.9-9.5-.9c-22.4 0-42.5 15.8-47 38.6L254.6 82c-6.6 33.2-24.8 63-51.2 84.2l-7.4 5.9c-22.8 18.2-36 45.8-36 75z',
      'M0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224z',
    ],
  ],
};
const faCloudShowers = {
  prefix: 'fad',
  iconName: 'cloud-showers',
  icon: [
    512,
    512,
    [],
    'f73f',
    [
      'M88 376l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 32l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96-32l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 32l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24z',
      'M0 224c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224z',
    ],
  ],
};
const faUserClock = {
  prefix: 'fad',
  iconName: 'user-clock',
  icon: [
    640,
    512,
    [],
    'f4fd',
    [
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144L29.7 512C13.3 512 0 498.7 0 482.3zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z',
      'M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z',
    ],
  ],
};
const faOnion = {
  prefix: 'fad',
  iconName: 'onion',
  icon: [
    448,
    512,
    [129477],
    'e427',
    [
      'M0 288c0 80.4 58 135.2 131.9 160.3c15 5.1 30.7 9 46.7 11.6c7.1 1.2 14.2 2.1 21.4 2.7c8 .7 16 1.2 24 1.3c8-.1 16-.5 24-1.3c7.2-.7 14.3-1.6 21.4-2.7c16-2.6 31.7-6.5 46.7-11.6C390 423.2 448 368.4 448 288c0-84.5-49-124.3-95.3-162C316 96.2 281 67.8 273.5 19.8C271.8 9 263.1 0 252.2 0c-7.5 0-14.3 4.2-17.7 10.9l-3.4 6.8c-2.9 5.9-11.4 5.9-14.3 0l-3.4-6.8C210.1 4.2 203.3 0 195.8 0c-10.9 0-19.6 9-21.3 19.8C167 67.8 132 96.2 95.3 126C49 163.7 0 203.5 0 288zm73 69.6c-13.9-37-6.6-81.3 2.6-114c4.7-16.7 10.2-31.4 14.5-41.8c2.2-5.2 4-9.4 5.4-12.3c.7-1.5 1.2-2.6 1.6-3.4l.4-.9c.4-.8 .8-1.5 1.2-2.2c2.5-3.8 6.6-6.4 11.3-6.9c1.9-.2 3.8-.1 5.6 .3s3.6 1.2 5.2 2.2c3.9 2.6 6.4 6.8 7 11.2c.3 1.9 .2 3.9-.3 5.9c-.3 1.3-.8 2.5-1.3 3.6l-.3 .7c-.3 .6-.8 1.6-1.4 2.9c-1.2 2.6-2.9 6.4-4.9 11.2c-4 9.6-9 23-13.3 38.2c-8.8 31.3-13.5 67.1-3.4 94c3.1 8.3-1.1 17.5-9.4 20.6s-17.5-1.1-20.6-9.4zm103.5 30.3c-16.9-67.5-8.3-134.4 4-183.8c6.2-24.8 13.4-45.5 19.1-60c2.9-7.3 5.3-13 7.1-17c.9-2 1.6-3.5 2.1-4.6l.6-1.2c.4-.8 .8-1.5 1.2-2.2c2.6-4 6.8-6.5 11.4-7c1.9-.2 3.8-.1 5.6 .3s3.6 1.2 5.2 2.2c3.8 2.5 6.4 6.6 7 11.4c.2 1.9 .1 3.8-.3 5.6c-.3 1.3-.8 2.5-1.4 3.7l-.5 1c-.4 .9-1 2.2-1.8 4c-1.6 3.5-3.9 8.8-6.5 15.5c-5.3 13.5-12.1 32.8-17.9 56c-11.7 46.6-19.1 107.7-4 168.2c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6zM288 160c0-8.8 7.2-16 16-16c.2 0 .4 0 .6 0c5.8-.2 11.6 2.7 14.7 8.2l.2 .4 .6 1.1c.5 .9 1.2 2.2 2.1 3.9c1.8 3.4 4.2 8.3 7.1 14.3c5.7 12.1 13.1 29.2 19.8 48.9c13.1 38.7 24.5 90.6 11.7 135.5c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c10-35.1 1.4-79.2-11.2-116.5c-6.2-18.3-13.1-34.2-18.4-45.6c-2.7-5.7-4.9-10.2-6.6-13.3c-3.5-2.9-5.7-7.3-5.7-12.2z',
      'M131.9 448.3l-10.7 32.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2L178.6 460c-16-2.6-31.7-6.5-46.7-11.6zM200 462.7l0 25.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-25.3c-8 .7-16 1.2-24 1.3c-8-.1-16-.5-24-1.3zm69.4-2.7l11.9 35.6c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-10.7-32.1c-15 5.1-30.7 9-46.7 11.6z',
    ],
  ],
};
const faClockTwelveThirty = {
  prefix: 'fad',
  iconName: 'clock-twelve-thirty',
  icon: [
    512,
    512,
    [],
    'e359',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240z',
      'M256 128c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faArrowDownToDottedLine = {
  prefix: 'fad',
  iconName: 'arrow-down-to-dotted-line',
  icon: [
    448,
    512,
    [],
    'e095',
    [
      'M64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7l0-66.7 0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112 0 66.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z',
    ],
  ],
};
const faHandDots = {
  prefix: 'fad',
  iconName: 'hand-dots',
  icon: [
    512,
    512,
    ['allergies'],
    'f461',
    [
      'M0 312c0 10.6 4.2 21.1 12.4 29L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4C3.7 292.2 0 302.1 0 312zm208 88a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
      'M304 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z',
    ],
  ],
};
const faAllergies = faHandDots;
const faFileInvoice = {
  prefix: 'fad',
  iconName: 'file-invoice',
  icon: [
    384,
    512,
    [],
    'f570',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0C28.7 0 0 28.7 0 64zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm0 112c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64zM224 432c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM96 224c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 224zm0 32l192 0 0 64L96 320l0-64zM240 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z',
    ],
  ],
};
const faWindowMinimize = {
  prefix: 'fad',
  iconName: 'window-minimize',
  icon: [
    512,
    512,
    [128469],
    'f2d1',
    ['M0 448c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z', ''],
  ],
};
const faRectangleWide = {
  prefix: 'fad',
  iconName: 'rectangle-wide',
  icon: [
    640,
    512,
    [],
    'f2fc',
    ['M0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z', ''],
  ],
};
const faCommentArrowUp = {
  prefix: 'fad',
  iconName: 'comment-arrow-up',
  icon: [
    512,
    512,
    [],
    'e144',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c-4.6 4.6-6 11.5-3.5 17.5c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160-16c0-6.1 2.3-12.3 7-17c24-24 48-48 72-72c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l72 72c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17c-9.4 9.4-24.6 9.4-33.9 0c-10.3-10.3-20.7-20.7-31-31c0 39.4 0 78.7 0 118.2c0 .7 0 1.5-.1 2.3s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-39.4 0-78.7 0-118.1c-10.3 10.3-20.7 20.7-31 31c-9.4 9.4-24.6 9.4-33.9 0c-4.7-4.7-7-10.8-7-17z',
      'M256 352c13.3 0 24-10.7 24-24l0-118.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 328c0 13.3 10.7 24 24 24z',
    ],
  ],
};
const faGarlic = {
  prefix: 'fad',
  iconName: 'garlic',
  icon: [
    512,
    512,
    [129476],
    'e40e',
    [
      'M0 288C0 392.6 85.5 411.7 116.7 415.2C85 390.5 64 352.6 64 304c0-27.8 4.3-48.7 11-66.5c5.9-15.6 13.6-28.6 20.7-40.5c.8-1.4 1.7-2.8 2.5-4.2c7.8-13.2 15.1-26.2 20.5-43.3c1.2-3.7 2.3-7.7 3.3-11.9c-11.7 10.9-25.1 21.1-38.7 31.5C42.3 200.5 0 232.7 0 288zm96 16c0 69.3 54.9 112 120 112s120-42.7 120-112c0-42.1-15-62.5-33.5-87.7c-1.1-1.6-2.3-3.1-3.5-4.7c-10.2-13.9-21.2-29.8-29.5-50.9C261.3 139.5 256 113.8 256 80l0-80L208 0c-26.5 0-48 21.5-48 48l0 16 0 16c0 33.4-4.2 58.5-10.8 79.2c-6.6 20.7-15.3 36.2-23.5 49.9l-2.5 4.2c-7.2 12.1-13.5 22.6-18.3 35.5c-5.3 13.9-9 31-9 55.2zM288 0l0 80c0 30.2 4.7 51.9 11.4 69c6.7 17.1 15.7 30.3 25.5 43.8c1.2 1.6 2.4 3.3 3.6 5c19 25.8 39.4 53.6 39.4 106.3c0 49.2-21.5 87.3-53.7 112l69.7 0s128 0 128-128c0-55.3-42.3-87.5-83.4-118.9C389.8 139.5 352 110.6 352 64l0-16c0-26.5-21.5-48-48-48L288 0z',
      'M136 488l0-40 48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24zm64 0l0-40 48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24zm64 0l0-40 48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24zm64 0l0-40 48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24z',
    ],
  ],
};
const faMugSaucer = {
  prefix: 'fad',
  iconName: 'mug-saucer',
  icon: [
    640,
    512,
    ['coffee'],
    'f0f4',
    [
      'M0 448c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z',
      'M128 32c-17.7 0-32 14.3-32 32l0 224c0 53 43 96 96 96l192 0c53 0 96-43 96-96l32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0L128 32zM480 96l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128z',
    ],
  ],
};
const faCoffee = faMugSaucer;
const faBrush = {
  prefix: 'fad',
  iconName: 'brush',
  icon: [
    384,
    512,
    [],
    'f55d',
    [
      'M0 48L0 256l0 22.4L0 288l9.6 0 364.8 0 9.6 0 0-9.6 0-22.4 0-208c0-26.5-21.5-48-48-48L230.5 0c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6c-1.5-3.6-5-6-8.9-6l-19 0c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6L48 0C21.5 0 0 21.5 0 48z',
      'M0 288l384 0 0 32c0 35.3-28.7 64-64 64l-64 0 0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64-64 0c-35.3 0-64-28.7-64-64l0-32zM192 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faFileHalfDashed = {
  prefix: 'fad',
  iconName: 'file-half-dashed',
  icon: [
    384,
    512,
    [],
    'e698',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 160L0 320 0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM0 352l0 64 64 0 0-64L0 352zM64 512l0-64L0 448c0 35.3 28.7 64 64 64zm32 0l80 0 0-64-80 0 0 64zm112 0l80 0 0-64-80 0 0 64zm112 0c35.3 0 64-28.7 64-64l-64 0 0 64zm64-160l-64 0 0 64 64 0 0-64z',
    ],
  ],
};
const faTreeDecorated = {
  prefix: 'fad',
  iconName: 'tree-decorated',
  icon: [
    448,
    512,
    [],
    'f7dc',
    [
      'M0 487.1C0 500.9 11.1 512 24.9 512l398.3 0c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352l31.8 0c13.4 0 24.2-10.9 24.2-24.2c0-5-1.6-10-4.5-14.1L344 208l24.9 0c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208l24.9 0L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1C24 341.1 34.8 352 48.2 352L80 352 3.8 474c-2.5 4-3.8 8.5-3.8 13.2zM184 288a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96-128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z',
      'M256 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm32 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z',
    ],
  ],
};
const faMask = {
  prefix: 'fad',
  iconName: 'mask',
  icon: [
    576,
    512,
    [],
    'f6fa',
    [
      'M0 272C0 384 80 448 176 448l8.4 0c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4l8.4 0c96 0 176-64 176-176s-64-208-288-208S0 160 0 272zm224-16A64 64 0 1 1 96 256a64 64 0 1 1 128 0zm256 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z',
      'M160 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z',
    ],
  ],
};
const faCalendarHeart = {
  prefix: 'fad',
  iconName: 'calendar-heart',
  icon: [
    448,
    512,
    [],
    'e0d3',
    [
      'M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM112 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
      'M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM112 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z',
    ],
  ],
};
const faMagnifyingGlassMinus = {
  prefix: 'fad',
  iconName: 'magnifying-glass-minus',
  icon: [
    512,
    512,
    ['search-minus'],
    'f010',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm112 0c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z',
      'M136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z',
    ],
  ],
};
const faSearchMinus = faMagnifyingGlassMinus;
const faFlower = {
  prefix: 'fad',
  iconName: 'flower',
  icon: [
    448,
    512,
    [127804, 10047],
    'f7ff',
    [
      'M0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160zm144 96c0-5.6 .6-11 1.7-16.3c.3-1.2 .6-2.5 .9-3.7c.3-1.2 .7-2.4 1-3.7c.8-2.4 1.7-4.9 2.6-7.2c.6-1.4 1.2-2.8 1.9-4.2c.5-1 1.1-2.1 1.6-3.2c1.2-2.2 2.5-4.3 3.9-6.4c2.9-4.3 6.2-8.3 9.8-11.9C181.9 184.9 201.9 176 224 176s42.1 8.9 56.5 23.4c3.6 3.6 6.9 7.6 9.8 11.9c1.4 2.1 2.7 4.2 3.9 6.5c.6 1 1.1 2.1 1.6 3.1c.7 1.4 1.3 2.8 1.9 4.2c1 2.4 1.9 4.8 2.6 7.3c.4 1.2 .7 2.4 1 3.6c.3 1.3 .6 2.6 .9 3.9c1.1 5.2 1.6 10.6 1.6 16.1c0 5.6-.6 11-1.7 16.3c-.3 1.3-.6 2.5-.9 3.7s-.7 2.5-1 3.7c-.8 2.5-1.6 4.9-2.6 7.2c-.6 1.4-1.2 2.8-1.9 4.2c-.5 1.1-1.1 2.1-1.6 3.2c-1.2 2.2-2.5 4.3-3.9 6.4c-2.9 4.3-6.2 8.3-9.8 11.9C266.1 327 246.1 336 224 336s-42.1-9-56.5-23.4c-3.6-3.7-6.9-7.7-9.8-11.9c-1.4-2.1-2.7-4.2-3.9-6.5c-.5-1-1.1-2.1-1.6-3.1c-.7-1.4-1.3-2.8-1.9-4.2c-1-2.4-1.9-4.8-2.6-7.3c-.4-1.2-.7-2.4-1-3.6c-.3-1.3-.6-2.6-.9-3.9c-1.1-5.2-1.6-10.6-1.6-16.1z',
      'M224 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z',
    ],
  ],
};
const faArrowDownFromArc = {
  prefix: 'fad',
  iconName: 'arrow-down-from-arc',
  icon: [
    512,
    512,
    [],
    'e614',
    [
      'M0 256c0 17.7 14.3 32 32 32s32-14.3 32-32C64 150 150 64 256 64s192 86 192 192c0 17.7 14.3 32 32 32s32-14.3 32-32C512 114.6 397.4 0 256 0S0 114.6 0 256z',
      'M121.4 345.4c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 402.7 288 192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0z',
    ],
  ],
};
const faRightLeftLarge = {
  prefix: 'fad',
  iconName: 'right-left-large',
  icon: [
    640,
    512,
    [],
    'e5e1',
    [
      'M0 336c0 13.6 5.4 26.7 15 36.3L133.8 491c13.4 13.4 31.6 21 50.6 21c37 0 67.4-28 71.2-64l64.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0c-8.8 0-16 7.2-16 16l0 40.4c0 4.2-3.4 7.6-7.6 7.6c-2 0-3.9-.8-5.4-2.2L69.3 336 179 226.2c1.4-1.4 3.4-2.2 5.4-2.2c4.2 0 7.6 3.4 7.6 7.6l0 40.4c0 8.8 7.2 16 16 16l112 0 0-64-64.4 0c-3.8-36-34.2-64-71.2-64c-19 0-37.2 7.5-50.6 21L15 299.7C5.4 309.3 0 322.4 0 336z',
      'M506.2 21C492.8 7.5 474.6 0 455.6 0c-37 0-67.4 28-71.2 64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H432c8.8 0 16-7.2 16-16V71.6c0-4.2 3.4-7.6 7.6-7.6c2 0 3.9 .8 5.4 2.2L570.7 176 461 285.8c-1.4 1.4-3.4 2.2-5.4 2.2c-4.2 0-7.6-3.4-7.6-7.6V240c0-8.8-7.2-16-16-16H320v64h64.4c3.8 36 34.2 64 71.2 64c19 0 37.2-7.5 50.6-21L625 212.3c9.6-9.6 15-22.7 15-36.3s-5.4-26.7-15-36.3L506.2 21z',
    ],
  ],
};
const faRulerVertical = {
  prefix: 'fad',
  iconName: 'ruler-vertical',
  icon: [
    256,
    512,
    [],
    'f548',
    [
      'M0 48C0 21.5 21.5 0 48 0L208 0c26.5 0 48 21.5 48 48l0 48-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z',
      'M176 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0-32-80 0zM160 208c0 8.8 7.2 16 16 16l80 0 0-32-80 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0-32-80 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0-32-80 0z',
    ],
  ],
};
const faCirclesOverlap = {
  prefix: 'fad',
  iconName: 'circles-overlap',
  icon: [
    640,
    512,
    [],
    'e600',
    [
      'M0 224C0 347.7 100.3 448 224 448c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224zm64 0c0-88.4 71.6-160 160-160c32.2 0 62.2 9.5 87.3 25.9c22-11.7 46.2-19.8 71.8-23.5c2.2 2.3 4.4 4.6 6.5 6.9s4.2 4.7 6.2 7.1c4.1 4.8 7.9 9.9 11.5 15c7.3 10.4 13.7 21.4 19.2 32.9C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160c-32.2 0-62.2-9.5-87.3-25.9c-22.1 11.6-46.3 19.7-71.9 23.5c-1.1-1.1-2.2-2.2-3.3-3.4c-1.1-1.2-2.2-2.3-3.2-3.5c-2.1-2.3-4.2-4.7-6.2-7.1c-4.1-4.8-7.9-9.9-11.5-15c-7.3-10.4-13.7-21.4-19.2-32.9C130 378.2 64 308.8 64 224z',
      'M256.8 445.6C365 429.7 448 336.6 448 224c0-61.5-24.8-117.1-64.8-157.6C275 82.3 192 175.4 192 288c0 61.5 24.8 117.1 64.8 157.6z',
    ],
  ],
};
const faUserLarge = {
  prefix: 'fad',
  iconName: 'user-large',
  icon: [
    512,
    512,
    ['user-alt'],
    'f406',
    [
      'M112 144a144 144 0 1 0 288 0 144 144 0 1 0 -288 0z',
      'M0 481.3C0 392.2 72.2 320 161.3 320H350.7C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z',
    ],
  ],
};
const faUserAlt = faUserLarge;
const faStarshipFreighter = {
  prefix: 'fad',
  iconName: 'starship-freighter',
  icon: [
    576,
    512,
    [],
    'e03a',
    [
      'M0 256C0 132.3 100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8l0 42.1c0 8.8-7.2 16-16 16l-114.3 0L432 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l13.7 0L560 288c8.8 0 16 7.2 16 16l0 42.1c0 13.2-8.1 25-20.4 29.8l-82.1 31.9c-4.2-7.1-10.1-13.1-17.2-17.3c-3.6-2.1-7.4-3.7-11.5-4.9c-2-.6-4.1-1-6.3-1.3c-1.1-.1-2.1-.3-3.2-.3s-2.2-.1-3.3-.1l-48.4 0L301.1 277.3c1.9-6.8 2.9-13.9 2.9-21.3c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80l1.2 0L322 461.4c.9 1.2 1.9 2.3 2.9 3.4C292.3 474.8 258.2 480 224 480C100.3 480 0 379.7 0 256zm64 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z',
      'M128 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM301.1 277.3c1.9-6.8 2.9-13.9 2.9-21.3c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80l1.2 0L322 461.4c9.1 11.8 23.1 18.6 38 18.6l72 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48.4 0L301.1 277.3zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z',
    ],
  ],
};
const faTrainTram = {
  prefix: 'fad',
  iconName: 'train-tram',
  icon: [
    448,
    512,
    [128650],
    'e5b4',
    [
      'M0 64c0 7 3.1 14 9 18.8C19.4 91 34.5 89.3 42.7 79L55.5 63c7.6-9.5 19.1-15 31.2-15L200 48l0 48 48 0 0-48 113.2 0c12.2 0 23.6 5.5 31.2 15l12.8 16c8.3 10.4 23.4 12 33.7 3.7s12-23.4 3.8-33.7L430 33C413.3 12.2 388 0 361.2 0L86.8 0C60 0 34.7 12.2 18 33L5.3 49C1.7 53.4 0 58.7 0 64zM35.1 492.9C28.1 499.9 33.1 512 43 512l39.7 0c8.5 0 16.6-3.4 22.6-9.4L160 448c-1.4 0-2.8 0-4.2-.1s-2.8-.1-4.1-.3c-2.7-.2-5.5-.6-8.1-1c-5.3-.9-10.5-2.3-15.5-4.1c-10-3.5-19.3-8.7-27.4-15.1L35.1 492.9zM128 192c0 10.7 0 21.3 0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zM288 448c18.2 18.2 36.4 36.4 54.6 54.6c6 6 14.1 9.4 22.6 9.4l39.7 0c10 0 15-12.1 7.9-19.1l-65.5-65.5c-16.3 12.9-37 20.6-59.4 20.6z',
      'M160 96c-53 0-96 43-96 96l0 160c0 53 43 96 96 96l128 0c53 0 96-43 96-96l0-160c0-53-43-96-96-96L160 96zm0 64l128 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zM128 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faBridgeSuspension = {
  prefix: 'fad',
  iconName: 'bridge-suspension',
  icon: [
    640,
    512,
    [],
    'e4cd',
    [
      'M1.4 147.2c4.5 12.5 18.2 18.9 30.7 14.4c25.5-9.2 46.4-25.8 63.9-44.5L96 256l64 0 0-147.9c12.4 10.7 25.8 20.1 40 28.2L200 256l48 0 0-99c15.5 4.8 31.6 8.1 48 9.8l0 89.2c16 0 32 0 48 0l0-89.2c16.4-1.6 32.5-4.9 48-9.8l0 99c16 0 32 0 48 0l0-119.7c14.2-8 27.6-17.5 40-28.2L480 256l64 0 0-138.9c17.4 18.7 38.4 35.3 63.9 44.5c12.5 4.5 26.2-2 30.7-14.4c1-2.7 1.4-5.4 1.4-8.1c0-9.8-6.1-19-15.9-22.6c-17.7-6.4-33.9-19.3-49.4-36.9c-15.4-17.6-29-38.6-42.1-59.8C528.5 12.7 520.8 8 512 8c-9.1 0-17 5.1-21.1 12.5C455.8 81.6 390.3 120 320 120c-70.3 0-135.8-38.4-171-99.5C145 13 137.1 8 128 8c-8.8 0-16.5 4.7-20.7 11.8C94.3 41 80.7 62 65.3 79.5c-15.5 17.7-31.7 30.6-49.4 36.9C3.4 121-3.1 134.7 1.4 147.2z',
      'M32 256c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32c35.3 0 64 28.7 64 64l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-53 43-96 96-96l64 0c53 0 96 43 96 96l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-35.3 28.7-64 64-64c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 256z',
    ],
  ],
};
const faTrashCheck = {
  prefix: 'fad',
  iconName: 'trash-check',
  icon: [
    448,
    512,
    [],
    'e2af',
    [
      'M32 96l384 0L394.6 466.8c-1.5 25.4-22.5 45.2-47.9 45.2l-245.4 0c-25.4 0-46.5-19.8-47.9-45.2L32 96zm79 175c-9.4 9.4-9.4 24.6 0 33.9l64 64c4.7 4.7 10.8 7 17 7s12.3-2.3 17-7L337 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0z',
      'M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM337 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 241z',
    ],
  ],
};
const faUserNurse = {
  prefix: 'fad',
  iconName: 'user-nurse',
  icon: [
    448,
    512,
    [],
    'f82f',
    [
      'M96 160c85.3 0 170.6 0 256 0c0 70.7-57.3 128-128 128s-128-57.3-128-128z',
      'M96 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 89.8L96 160l0-89.8zm15.9 257.5c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.5 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z',
    ],
  ],
};
const faBoombox = {
  prefix: 'fad',
  iconName: 'boombox',
  icon: [
    640,
    512,
    [128254],
    'f8a5',
    [
      'M0 224c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6l16 0 112 0 64 0 32 0 64 0 32 0 64 0 112 0 16 0c11.7 0 22.6 3.1 32 8.6c19.1 11.1 32 31.7 32 55.4l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224zM64 336a112 112 0 1 0 224 0A112 112 0 1 0 64 336zm288 0a112 112 0 1 0 224 0 112 112 0 1 0 -224 0z',
      'M120 48C97.9 48 80 65.9 80 88l0 72-16 0c-11.7 0-22.6 3.1-32 8.6L32 88C32 39.4 71.4 0 120 0L520 0c48.6 0 88 39.4 88 88l0 80.6c-9.4-5.4-20.3-8.6-32-8.6l-16 0 0-72c0-22.1-17.9-40-40-40L120 48zM448 160l-64 0c0-17.7 14.3-32 32-32s32 14.3 32 32zm-96 0l-64 0c0-17.7 14.3-32 32-32s32 14.3 32 32zm-96 0l-64 0c0-17.7 14.3-32 32-32s32 14.3 32 32zM176 416a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM544 336a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z',
    ],
  ],
};
const faSyringe = {
  prefix: 'fad',
  iconName: 'syringe',
  icon: [
    512,
    512,
    [128137],
    'f48e',
    [
      'M0 488c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l57-57 88.8 0c14.9 0 29.1-5.9 39.6-16.4L440 217.9c-.3-.3-.7-.6-1-.9l-16-16-56-56L311 89 295 73c-.3-.3-.6-.7-.9-1c-27.9 27.9-55.8 55.8-83.7 83.7c19 19 38 38 57 57c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-19-19-38-38-57-57c-13.8 13.8-27.6 27.6-41.4 41.4c19 19 38 38 57 57c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-19-19-38-38-57-57L80.4 285.7C69.9 296.2 64 310.4 64 325.3l0 88.8L7 471c-4.7 4.7-7 10.8-7 17z',
      'M441 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15L384 94.1 329 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72 72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L456 89.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L473 39 441 7zM210.3 155.7l-22.6 22.6 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57zm-64 64l-22.6 22.6 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z',
    ],
  ],
};
const faCloudSun = {
  prefix: 'fad',
  iconName: 'cloud-sun',
  icon: [
    640,
    512,
    [9925],
    'f6c4',
    [
      'M1.2 121.8c-2.1 5.1-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c6.5-41.8 33.2-76.8 69.8-94.9c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 .4 0 .7 0 1.1c18.8-10.9 40.7-17.1 64-17.1c2.2 0 4.5 .1 6.7 .2l38.5-55c1.9-2.7 2.9-5.9 2.9-9.2c0-2.1-.4-4.2-1.2-6.2c-2.1-5.1-6.7-8.7-12.1-9.6L317.9 98.1 303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6zM144 208a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M559.9 511.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 242.6 402.8 224 368 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96l271.9 0z',
    ],
  ],
};
const faShieldExclamation = {
  prefix: 'fad',
  iconName: 'shield-exclamation',
  icon: [
    512,
    512,
    [],
    'e247',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM224 352c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1.1 .4 2.2 .5 3.3c.1 .5 .1 1.1 .1 1.5c0 .5 0 1 0 1.2l0 .5 0 .5c0 .3 0 .8 0 1.4c0 .4-.1 .9-.1 1.5c-.1 1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm8-200c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.1l0 .4c0 37.3 0 74.7 0 112l0 .4c0 .5 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3.1-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-37.3 0-74.7 0-112z',
      'M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faStopwatch20 = {
  prefix: 'fad',
  iconName: 'stopwatch-20',
  icon: [
    448,
    512,
    [],
    'e06f',
    [
      'M16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 34.4C92.3 113.8 16 200 16 304zm92 64.3c0-20.6 7.5-40.4 21.2-55.8c13-14.6 26-29.3 39-43.9c2.4-2.7 3.7-6.2 3.7-9.8l0-2.2c0-6.9-5.6-12.5-12.5-12.5c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5l0 2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9l43.8 0c11 0 20 9 20 20s-9 20-20 20l-64 0c-11 0-20-9-20-20l0-15.7zM236 256c0-28.7 23.3-52 52-52s52 23.3 52 52l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96zm40 0l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12z',
      'M147.6 252.6c1.7-5.1 6.5-8.6 11.9-8.6c6.9 0 12.5 5.6 12.5 12.5l0 2.2c0 3.6-1.3 7.1-3.7 9.8l-39 43.9c-13.7 15.4-21.2 35.2-21.2 55.8l0 15.7c0 11 9 20 20 20l64 0c11 0 20-9 20-20s-9-20-20-20l-43.8 0c.9-9.2 4.7-17.9 10.9-24.9l39-43.9c8.9-10 13.8-23 13.8-36.4l0-2.2c0-29-23.5-52.5-52.5-52.5c-22.6 0-42.7 14.5-49.8 35.9l-.6 1.7c-3.5 10.5 2.2 21.8 12.6 25.3s21.8-2.2 25.3-12.6l.6-1.7zM288 204c-28.7 0-52 23.3-52 52l0 96c0 28.7 23.3 52 52 52s52-23.3 52-52l0-96c0-28.7-23.3-52-52-52zm-12 52c0-6.6 5.4-12 12-12s12 5.4 12 12l0 96c0 6.6-5.4 12-12 12s-12-5.4-12-12l0-96z',
    ],
  ],
};
const faSquareFull = {
  prefix: 'fad',
  iconName: 'square-full',
  icon: [
    512,
    512,
    [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036],
    'f45c',
    ['M0 0H512V512H0V0z', ''],
  ],
};
const faGripDots = {
  prefix: 'fad',
  iconName: 'grip-dots',
  icon: [
    448,
    512,
    [],
    'e410',
    [
      'M112 336a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
      'M384 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM112 176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z',
    ],
  ],
};
const faCommentExclamation = {
  prefix: 'fad',
  iconName: 'comment-exclamation',
  icon: [
    512,
    512,
    [],
    'f4af',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm224 96c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1.1 0 1.8c0 .5 0 1 0 1.6s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm8-200c.1-13.4 10.8-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.5c0 37.3 0 74.7 0 112.2c0 .7 0 1.5-.1 2.3s-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-37.3 0-74.7 0-112z',
      'M280 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faPenSwirl = {
  prefix: 'fad',
  iconName: 'pen-swirl',
  icon: [
    512,
    512,
    [],
    'e214',
    [
      'M8 256C8 393 119 504 256 504c13.3 0 24-10.7 24-24s-10.7-24-24-24C145.5 456 56 366.5 56 256S145.5 56 256 56c16.4 0 32.3 2 47.6 5.7l38.1-38.5C315 13.4 286.1 8 256 8C119 8 8 119 8 256zM296.8 374c-3.3 12.8 4.4 25.9 17.3 29.2c12.2 3.1 24.9 4.8 38 4.8c83.9 0 152-68.1 152-152c0-29.9-5.3-58.6-15-85.1l-38.5 38.5c3.6 15 5.5 30.6 5.5 46.6c0 57.4-46.6 104-104 104c-9 0-17.7-1.1-26-3.3c-12.8-3.3-25.9 4.4-29.2 17.3z',
      'M406.1 16L366.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L473.9 16c-18.8-18.8-49.2-18.7-67.9 0zM343.7 78.4L200.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L432.8 167.5 343.7 78.4z',
    ],
  ],
};
const faFalafel = {
  prefix: 'fad',
  iconName: 'falafel',
  icon: [
    576,
    512,
    [129478],
    'e40a',
    [
      'M416 263.3c0-5.8 .8-11.2 2.6-16c.9-2.4 2-4.7 3.3-6.8c.7-1.1 1.4-2.1 2.2-3.1c.4-.5 .8-1 1.2-1.4s.8-.9 1.3-1.4c1.6-1.6 3.3-2.9 5.1-4.2c6.5-4.3 14.6-6.4 23.7-6.4c.5 0 1 0 1.5 0c1.9 0 3.8 .2 5.8 .4c22.7 2.5 49.8 16.6 73.1 39.9c31 31 45.6 68.8 38.6 93.7c-1.7 6-4.6 11.2-8.8 15.4c-21.9 21.9-70.8 8.6-109.1-29.8c-25.8-25.8-40.3-56.4-40.3-80.4z',
      'M166.6 125.5c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-.3 1.3-.6 2.6-.7 3.9c17.2 .6 33.9 8.6 45.1 22.8c28.3 .2 52.1 20.3 58.1 47.4c4.8 2.4 9.2 5.4 13.1 8.8c3.9-3.4 8.3-6.4 13.1-8.8c6-27.1 29.8-47.1 58.1-47.4c17.3-21.9 47.4-29.2 72.8-17c1.5-.7 3-1.4 4.5-1.9c.1-2.6-.2-5.2-.9-7.8c-2.3-9-.1-18.6 5.7-25.7c8.8-10.7 8.8-26.3 0-37c-5.9-7.1-8-16.7-5.7-25.7c3.4-13.5-3.2-27.6-15.7-33.3c-8.3-3.8-14.3-11.5-16.1-20.6c-2.7-13.7-14.6-23.5-28.3-23.1c-9.1 .3-17.8-4-23.2-11.4C344 .3 329.1-3.2 316.9 3.2c-8.1 4.3-17.7 4.3-25.8 0C278.9-3.2 264 .3 255.8 11.4c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7zm76.4 141.4c-3.7-12.1-14.9-20.4-27.6-20.1c-3.6 .1-7.2-.5-10.5-1.8c-5-1.9-9.4-5.2-12.7-9.6c-8.2-11.2-23.2-14.6-35.3-8.2c-8.1 4.3-17.7 4.3-25.8 0c-12.2-6.4-27.1-2.9-35.3 8.2c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c4.1-1.9 7.6-4.7 10.3-8.1c-3.1-10.1-3.7-21-1.2-31.7c-17.3-22.1-17.3-53.3 0-75.4c-2.4-10.7-1.9-21.7 1.2-31.7c-2.7-3.4-6.2-6.2-10.3-8.1c-8.3-3.8-14.3-11.5-16.1-20.6c-.2-1-.5-2-.8-3zM240 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM64 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm469.4-58.6c-21.9 21.9-70.8 8.6-109.1-29.8s-51.7-87.2-29.8-109.1c1.6-1.6 3.3-2.9 5.1-4.2c-4.3-.1-8.6-1.1-12.5-3.2c-12.2-6.4-27.1-2.9-35.3 8.2c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c12.5-5.7 19.2-19.8 15.7-33.3c-2.3-9-.1-18.6 5.7-25.7c6.7-8.1 8.3-19 4.9-28.4c-1.7 5.9-4.6 11.2-8.8 15.4zM456.8 224c1.9 0 3.8 .2 5.8 .4c-1.9-.3-3.8-.5-5.8-.4zM368 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faCircle2 = {
  prefix: 'fad',
  iconName: 'circle-2',
  icon: [
    512,
    512,
    [],
    'e0ef',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm161.7 96.8c-3.6-9.2-1.3-19.6 5.9-26.3c36.2-34 72.5-67.9 108.7-101.9c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3c-8.1 6.1-16.1 12.3-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6c8.1-6.1 16.1-12.3 24.2-18.4c15.8-12 35.2-18.4 55.1-18.1c1.1 0 2.3 0 3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1c-21.5 20.1-42.9 40.3-64.4 60.4c27.8 0 55.5 0 83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-48 0-96 0-144 0c-9.8 0-18.7-6-22.3-15.2z',
      'M248 160.3c-9.1-.1-18 2.8-25.3 8.3l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 320l83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L276.3 224.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1z',
    ],
  ],
};
const faMagnet = {
  prefix: 'fad',
  iconName: 'magnet',
  icon: [
    448,
    512,
    [129522],
    'f076',
    [
      'M0 64l0 96 128 0 0-96c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64zm320 0l0 96 128 0 0-96c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
      'M0 160l0 96C0 379.7 100.3 480 224 480s224-100.3 224-224l0-96-128 0 0 96c0 53-43 96-96 96s-96-43-96-96l0-96L0 160z',
    ],
  ],
};
const faJar = {
  prefix: 'fad',
  iconName: 'jar',
  icon: [
    320,
    512,
    [],
    'e516',
    [
      'M0 128L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm64 96c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L96 384c-17.7 0-32-14.3-32-32l0-128z',
      'M64 0C46.3 0 32 14.3 32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 0zM96 192c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 192z',
    ],
  ],
};
const faGramophone = {
  prefix: 'fad',
  iconName: 'gramophone',
  icon: [
    384,
    512,
    [],
    'f8bd',
    [
      'M32 296c0 1.5 .1 2.9 .4 4.3c.6 3.1 1.7 6.1 3.5 8.8c2.4 3.7 5.9 6.8 10.2 8.7c1.4 .6 2.8 1.1 4.3 1.5c3.4 .8 6.8 .9 10 .2c3-.6 5.9-1.7 8.7-3.5c.3-.2 .7-.5 1-.7c108.2-77.3 197.2-76.6 241.4-69.4c4.7 .8 9.3 3.7 12.4 8.6c2.6 4.9 4 10.3 4.1 15.6c-.2 18.7-15.3 33.7-34 33.7l-110 0c-11.6 0-21.3 8.2-23.5 19.2c-.3 1.6-.5 3.2-.5 4.8l0 56 48 0 0-32 86.6 0c45 0 81.4-36.5 81.4-81.4l0-.6c0-12-2.8-24.1-8.2-35c-8.5-17.5-22.9-31.7-40.1-40.4C257.8 159.3 213.4 114 186.4 77.8c-13.5-18.1-22.6-34-28.2-45.1c-2.8-5.6-4.8-9.9-6-12.8c-.6-1.4-1-2.5-1.3-3.2c-.1-.2-.2-.4-.3-.7C147.1 6.1 137.5-.4 127 0c-10.5 .4-19.5 7.7-22.2 17.8L32.8 289.7c-.1 .3-.2 .7-.3 1c-.4 1.8-.6 3.6-.6 5.3z',
      'M64 384c-17.7 0-32 14.3-32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32c0-17.7-14.3-32-32-32L64 384z',
    ],
  ],
};
const faDiceD12 = {
  prefix: 'fad',
  iconName: 'dice-d12',
  icon: [
    512,
    512,
    [],
    'f6ce',
    [
      'M12.7 165.3L57.4 88c3.9-6.7 12-9.7 19.2-7.1l152.8 54.6c6.4 2.3 10.6 8.3 10.6 15.1l0 85.7c0 6.1-3.4 11.6-8.8 14.3l-89.7 44.8c-6.2 3.1-13.6 1.9-18.5-3L15.3 184.7c-5.1-5.1-6.2-13-2.5-19.3zM109.8 44.8l72-41.6c3.6-2.1 7.8-3.2 12-3.2L318.2 0c4.2 0 8.4 1.1 12 3.2l72 41.6c5.9 3.4 5.1 12.2-1.3 14.5L264.1 108.1c-5.2 1.9-10.9 1.9-16.1 0L111.1 59.3c-6.4-2.3-7.2-11.1-1.3-14.5zM272 150.6c0-6.8 4.3-12.8 10.6-15.1L435.4 80.9c7.3-2.6 15.4 .4 19.2 7.1l44.7 77.3c3.6 6.3 2.6 14.2-2.5 19.3L389 292.4c-4.9 4.9-12.3 6.1-18.5 3l-89.7-44.8c-5.4-2.7-8.8-8.3-8.8-14.3l0-85.7z',
      'M161.6 481c2.2 7-5.3 13-11.6 9.3L74.2 446.6c-3.6-2.1-6.7-5.1-8.8-8.8L3.2 330.2c-2.1-3.6-3.2-7.8-3.2-12l0-84.2c0-7.1 8.6-10.7 13.7-5.7l96.1 96.1c2.7 2.7 4.8 6.1 5.9 9.8L161.6 481zM498.3 228.3c5-5 13.7-1.5 13.7 5.7l0 84.2c0 4.2-1.1 8.4-3.2 12L446.6 437.8c-2.1 3.6-5.1 6.7-8.8 8.8l-75.8 43.7c-6.3 3.6-13.8-2.4-11.6-9.3l45.9-146.9c1.2-3.7 3.2-7.1 5.9-9.8l96.1-96.1zM310.7 500.8c-2.1 6.7-8.3 11.2-15.3 11.2l-78.9 0c-7 0-13.2-4.5-15.3-11.2L151.4 341.2c-2.3-7.5 1.1-15.6 8.1-19.1l89.3-44.7c4.5-2.3 9.8-2.3 14.3 0l89.3 44.7c7 3.5 10.5 11.6 8.1 19.1L310.7 500.8z',
    ],
  ],
};
const faNoteSticky = {
  prefix: 'fad',
  iconName: 'note-sticky',
  icon: [
    448,
    512,
    [62026, 'sticky-note'],
    'f249',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l224 0 0-128c0-17.7 14.3-32 32-32l128 0 0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96z',
      'M288 352V480h5.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V320H320c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faStickyNote = faNoteSticky;
const faDown = {
  prefix: 'fad',
  iconName: 'down',
  icon: [
    384,
    512,
    ['arrow-alt-down'],
    'f354',
    [
      'M128 72l0 184c42.7 0 85.3 0 128 0c0-61.3 0-122.7 0-184c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40z',
      'M128 256s0 0 0 0l-96 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l160 160c12.5 12.5 32.8 12.5 45.3 0l160-160c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-96 0s0 0 0 0l-128 0z',
    ],
  ],
};
const faArrowAltDown = faDown;
const faHundredPoints = {
  prefix: 'fad',
  iconName: 'hundred-points',
  icon: [
    512,
    512,
    [128175, '100'],
    'e41c',
    [
      'M0 384c0 1.5 .1 3 .3 4.6C2.8 406 19 418.2 36.5 415.7l448-64c17.5-2.5 29.7-18.7 27.2-36.2c-2.3-16-16-27.5-31.6-27.5c-1.5 0-3 .1-4.6 .3l-448 64C11.5 354.6 0 368.3 0 384zm224.3 68.6c2.5 17.5 18.7 29.7 36.2 27.2l224-32c17.5-2.5 29.7-18.7 27.2-36.2s-18.7-29.7-36.2-27.2l-224 32c-17.5 2.5-29.7 18.7-27.2 36.2z',
      'M163 101.8C168 61.9 201.9 32 242 32c47.9 0 85 42 79 89.5L309 218.2c-5 39.8-38.9 69.8-79 69.8c-47.9 0-85-42-79-89.5L163 101.8zM242 96c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6c7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6zM123.5 38.3c9.2 6.9 13.8 18.2 12.2 29.7l-32 224c-2.5 17.5-18.7 30-36.2 27.7S37.8 301.5 40.3 284L64.3 116.5l-19.7 8.7c-16.2 7.2-35.1 0-42-16.1s.6-35.1 16.8-42.3l72-32c10.6-4.7 22.9-3.4 32.1 3.5zM427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6c-46.9 0-83.7-40.3-79.5-87l7.3-80.4C351.9 63.5 386.4 32 427.7 32zm-15.7 78.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2c8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2c-8.2 0-15 6.2-15.7 14.4z',
    ],
  ],
};
const fa100 = faHundredPoints;
const faPaperclipVertical = {
  prefix: 'fad',
  iconName: 'paperclip-vertical',
  icon: [
    384,
    512,
    [],
    'e3c2',
    [
      'M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128l0 192c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 208c0 61.9 50.1 112 112 112s112-50.1 112-112l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 97.2-78.8 176-176 176s-176-78.8-176-176l0-208z',
      '',
    ],
  ],
};
const faWindWarning = {
  prefix: 'fad',
  iconName: 'wind-warning',
  icon: [
    640,
    512,
    ['wind-circle-exclamation'],
    'f776',
    [
      'M0 256C0 379.7 100.3 480 224 480c95.5 0 177.1-59.8 209.3-144L384 336c-17.7 0-32-14.3-32-32s14.3-32 32-32l63.4 0c.4-5.3 .6-10.6 .6-16s-.2-10.7-.6-16c-1.6-22.4-6.5-43.9-14.1-64C401.1 91.8 319.5 32 224 32C100.3 32 0 132.3 0 256zm256 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM200 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112z',
      'M433.3 176c7.7 20.1 12.6 41.6 14.1 64l96.6 0c53 0 96-43 96-96s-43-96-96-96l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-110.7 0zM472 432c0 17.7 14.3 32 32 32l32 0c53 0 96-43 96-96s-43-96-96-96l-152 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l152 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32zM224 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
    ],
  ],
};
const faWindCircleExclamation = faWindWarning;
const faLocationPinSlash = {
  prefix: 'fad',
  iconName: 'location-pin-slash',
  icon: [
    640,
    512,
    ['map-marker-slash'],
    'f60c',
    [
      'M128.1 196.9L406.2 416.1c-23.6 33.5-46.3 62.9-62.5 83.1c-6.1 7.7-14.9 11.5-23.7 11.5s-17.6-3.8-23.7-11.5c-50.4-62.9-164-214-168.2-302.2zM154 95.4C187.3 38.3 249.2 0 320 0C426 0 512 86 512 192c0 38.7-23 90.8-53 142.5c-101.7-79.7-203.3-159.4-305-239z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faMapMarkerSlash = faLocationPinSlash;
const faFaceSadSweat = {
  prefix: 'fad',
  iconName: 'face-sad-sweat',
  icon: [
    576,
    512,
    [],
    'e38a',
    [
      'M32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256zm80.2-45.4c-1.5-8.7 4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2zM239.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM204.1 389.3C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6zM399.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM348.7 148.7c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c7.8 1.3 13.4 8.1 13.4 15.8c0 .9-.1 1.8-.2 2.6c-1.5 8.7-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z',
      'M227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM239.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM348.7 148.7c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM48 416c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369c0 26-21.5 47-48 47z',
    ],
  ],
};
const faBugSlash = {
  prefix: 'fad',
  iconName: 'bug-slash',
  icon: [
    640,
    512,
    [],
    'e490',
    [
      'M64 288c0 17.7 14.3 32 32 32l64 0c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6l0-143.7L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7L96 256c-17.7 0-32 14.3-32 32zM224 96l0 3.6c0 15.7 12.7 28.4 28.4 28.4l135.1 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96s-96 43-96 96zm16 66.8c79.1 62 158.3 124 237.4 186.1c1.7-9.4 2.6-19 2.6-28.9l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64.3 0c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160l-112 0c-8.3 0-16.3 1-24 2.8zm96 197.9l0 118.5c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faCupcake = {
  prefix: 'fad',
  iconName: 'cupcake',
  icon: [
    448,
    512,
    [129473],
    'e402',
    [
      'M0 227c0 41.4 27.1 76.6 64.6 88.6c9 2.9 18.5 4.4 28.4 4.4l30.9 0 32.2 0 135.8 0 32.2 0 30.9 0c9.9 0 19.5-1.5 28.4-4.4c37.5-12 64.6-47.1 64.6-88.6c0-40-25.6-75.6-63.6-88.2l-22.6-7.5c-4.1-1.4-8.2-2.3-12.5-2.8c1.7-6.7 2.6-13.8 2.6-21C352 48.1 303.9 0 244.6 0L240 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C240 56 232 64 222.1 64L160 64c-35.3 0-64 28.7-64 64c0 .3 0 .6 0 .8c-3.3 .5-6.6 1.4-9.9 2.4l-22.6 7.5C25.6 151.5 0 187 0 227z',
      'M64.6 315.6l25 156c3.7 23.3 23.8 40.4 47.4 40.4l10.9 0-24-192L93 320c-9.9 0-19.5-1.5-28.4-4.4zm91.6 4.4l24 192 87.8 0 24-192-135.8 0zm168 0l-24 192 10.9 0c23.6 0 43.7-17.1 47.4-40.4l25-156c-9 2.9-18.5 4.4-28.4 4.4l-30.9 0z',
    ],
  ],
};
const faLightSwitchOff = {
  prefix: 'fad',
  iconName: 'light-switch-off',
  icon: [
    384,
    512,
    [],
    'e018',
    [
      'M96 256l0 96c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-96L96 256z',
      'M0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zm96-96l0-192c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64zm80 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0-416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z',
    ],
  ],
};
const faToggleLargeOff = {
  prefix: 'fad',
  iconName: 'toggle-large-off',
  icon: [
    576,
    512,
    [],
    'e5b0',
    [
      'M0 256C0 362 86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256zm64 0c0-70.7 57.3-128 128-128l192 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-192 0c-70.7 0-128-57.3-128-128z',
      'M192 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z',
    ],
  ],
};
const faPenFancySlash = {
  prefix: 'fad',
  iconName: 'pen-fancy-slash',
  icon: [
    640,
    512,
    [],
    'e210',
    [
      'M65.7 487.6l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1L88.4 510.3 266 460.5c16.9-4.7 29.9-18.3 33.8-35.4L318 346.5 211 262.3l-60.1 13.9c-17.1 3.9-30.7 16.9-35.4 33.8L65.7 487.6zM287.1 199.7l100.8 79 161-140.2c17.2-15 27.1-36.7 27.1-59.6c0-43.6-35.4-79-79-79c-22.8 0-44.6 9.9-59.6 27.1L287.1 199.7z',
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z',
    ],
  ],
};
const faTruckContainer = {
  prefix: 'fad',
  iconName: 'truck-container',
  icon: [
    640,
    512,
    [],
    'f4dc',
    [
      'M0 80L0 224c0 26.5 21.5 48 48 48l304 0c26.5 0 48-21.5 48-48l0-144c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80zM32 416a64 64 0 1 0 128 0A64 64 0 1 0 32 416zM64 88c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16L64 88zm80 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128zm48 328a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM224 88c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128zm80 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128zM480 416a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z',
      'M456 144c-13.3 0-24 10.7-24 24l0 88 0 32 0 16L32 304c-17.7 0-32 14.3-32 32l0 16c0 8.8 3.6 16.8 9.4 22.6C24.8 342.3 57.8 320 96 320c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64l85.5 0 21.5 0c13.2-37.3 48.7-64 90.5-64c38.2 0 71.2 22.3 86.6 54.6c5.8-5.8 9.4-13.8 9.4-22.6l0-64 0-16 0-10.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5L456 144zM585 256l-105 0 0-64 48.8 0c2.4 0 4.7 1.1 6.2 2.9L585 256z',
    ],
  ],
};
const faBoot = {
  prefix: 'fad',
  iconName: 'boot',
  icon: [
    512,
    512,
    [129406],
    'f782',
    [
      'M0 96l320 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 119.3 29.8C482 296.5 512 334.9 512 379l0 69L0 448 0 96z',
      'M32 0C14.3 0 0 14.3 0 32L0 96l320 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0zM0 448l0 9.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16l14.9 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l14.9 0c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6l0-9.4L0 448z',
    ],
  ],
};
const faArrowUpFromWaterPump = {
  prefix: 'fad',
  iconName: 'arrow-up-from-water-pump',
  icon: [
    576,
    512,
    [],
    'e4b6',
    [
      'M0 304l0 96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400l0-96c0-26.5-21.5-48-48-48l-48 0-64 0-128 0 0-208c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48l0 208-16 0c-26.5 0-48 21.5-48 48z',
      'M550.6 134.6c12.5-12.5 12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256l64 0 0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z',
    ],
  ],
};
const faFileCheck = {
  prefix: 'fad',
  iconName: 'file-check',
  icon: [
    384,
    512,
    [],
    'f316',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0c0 42.7 0 85.3 0 128c0 .6 0 1.1 0 1.6s.1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.2 1 .5 2.1 .8 3.1c.2 .5 .3 1 .5 1.5c.2 .5 .4 .9 .6 1.4c1.6 3.8 4 7.3 6.9 10.2s6.3 5.2 10.2 6.9c1.9 .8 3.9 1.4 6 1.9c1 .2 2.1 .4 3.2 .5c.5 .1 1.1 .1 1.6 .1s1.1 0 1.6 0l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM72 328c0-.8 0-.4 0 0z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM305 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L305 281z',
    ],
  ],
};
const faBone = {
  prefix: 'fad',
  iconName: 'bone',
  icon: [
    576,
    512,
    [129460],
    'f5d7',
    [
      'M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2l192 0c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336l-192 0c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z',
      '',
    ],
  ],
};
const faCardsBlank = {
  prefix: 'fad',
  iconName: 'cards-blank',
  icon: [
    640,
    512,
    [],
    'e4df',
    [
      'M306.4 472.3c45.7-26.4 91.3-52.7 137-79.1c3.3-1.9 6.4-4.1 9.1-6.6c6-5.4 10.7-11.9 13.9-19s4.8-14.9 4.8-22.7c0-9.4-2.4-19-7.5-27.8c-46.3-80.2-92.7-160.5-139-240.7C334.4 68.7 346.7 64 360 64l224 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56l-224 0c-25.3 0-46.6-16.7-53.6-39.7z',
      'M7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9z',
    ],
  ],
};
const faCircle3 = {
  prefix: 'fad',
  iconName: 'circle-3',
  icon: [
    512,
    512,
    [],
    'e0f0',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L240 384c-30.1 0-58.1-15.6-73.9-41.2c-.9-1.4-1.7-2.8-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c10 0 19-4 25.6-10.6c3.3-3.3 5.9-7.2 7.7-11.5c.9-2.2 1.6-4.4 2.1-6.8c.2-1.2 .4-2.4 .5-3.6c.1-.6 .1-1.2 .1-1.8s0-1.2 0-2c0-.6 0-1.2 0-1.8s-.1-1.2-.1-1.8c-.1-1.2-.3-2.4-.6-3.6c-.5-2.4-1.2-4.6-2.1-6.8c-1.8-4.3-4.5-8.2-7.8-11.5c-6.6-6.5-15.7-10.6-25.7-10.5l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176 184 176c-13.3 0-24-10.7-24-24z',
      'M160 152c0-13.3 10.7-24 24-24l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L240 384c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176 184 176c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faBenchTree = {
  prefix: 'fad',
  iconName: 'bench-tree',
  icon: [
    640,
    512,
    [],
    'e2e7',
    [
      'M384 176c0 44.2 35.8 80 80 80l16 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 16 0c44.2 0 80-35.8 80-80c0-26.7-13.1-50.3-33.2-64.9c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1C397.1 125.7 384 149.3 384 176z',
      'M64 192l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L64 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM0 384c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64L96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faKeyboardBrightnessLow = {
  prefix: 'fad',
  iconName: 'keyboard-brightness-low',
  icon: [
    640,
    512,
    [],
    'e1c1',
    [
      'M64 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm160-64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm160 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M192 384c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32z',
    ],
  ],
};
const faSkiBootSki = {
  prefix: 'fad',
  iconName: 'ski-boot-ski',
  icon: [
    640,
    512,
    [],
    'e3cd',
    [
      'M0 480c0 17.7 14.3 32 32 32l512 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32s-32 14.3-32 32s-14.3 32-32 32L32 448c-17.7 0-32 14.3-32 32zM116.8 237c39.8-9.3 125.1-47.4 152.7-205c-28.5 0-57 0-85.5 0c-15.3 0-28.4 10.8-31.4 25.7c-12 59.8-23.9 119.6-35.9 179.3z',
      'M415.4 38.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1L351.4 32l-81.9 0c-27.6 157.6-113 195.8-152.7 205L88.6 377.7c-1.9 9.4 .6 19.1 6.6 26.6s15.2 11.7 24.7 11.7l328 0c17.7 0 32-14.3 32-32l0-80c0-12.7-7.5-24.2-19.1-29.3L382.2 240 320 240c-8.8 0-16-7.2-16-16s7.2-16 16-16l61.4 0 9.6-48-55 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l61.4 0L409 70.3l6.4-32z',
    ],
  ],
};
const faBrainCircuit = {
  prefix: 'fad',
  iconName: 'brain-circuit',
  icon: [
    512,
    512,
    [],
    'e0c6',
    [
      'M0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56l0-184-48 0c-8.8 0-16 7.2-16 16l0 34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-34.7c0-26.5 21.5-48 48-48l48 0 0-80-34.7 0c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32l34.7 0 0-72c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304zM272 56l0 72 48 0c26.5 0 48 21.5 48 48l0 2.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-2.7c0-8.8-7.2-16-16-16l-48 0 0 192 34.7 0c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32L272 384l0 72c0 30.9 25.1 56 56 56c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56z',
      'M240 272l0 184 32 0 0-72 34.7 0c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48s-21.5-48-48-48c-20.9 0-38.7 13.4-45.3 32L272 352l0-192 48 0c8.8 0 16 7.2 16 16l0 2.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-2.7c0-26.5-21.5-48-48-48l-48 0 0-72-32 0 0 72-34.7 0c-6.6-18.6-24.4-32-45.3-32c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32l34.7 0 0 80-48 0c-26.5 0-48 21.5-48 48l0 34.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-34.7c0-8.8 7.2-16 16-16l48 0zM176 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm176 96a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM176 368a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm192 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z',
    ],
  ],
};
const faTableCellsRowUnlock = {
  prefix: 'fad',
  iconName: 'table-cells-row-unlock',
  icon: [
    640,
    512,
    [],
    'e691',
    [
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0z',
      'M528 240c-17.7 0-32 14.3-32 32l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z',
    ],
  ],
};
const faUserInjured = {
  prefix: 'fad',
  iconName: 'user-injured',
  icon: [
    448,
    512,
    [],
    'f728',
    [
      'M0 482.3C0 498.7 13.3 512 29.7 512L64 512l0-166.6C24.9 378.1 0 427.3 0 482.3zM96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32L222.6 96l-52.1 0L100 96c-2.6 10.2-4 21-4 32zm44.1 180.1c15.2 25.3 30.4 50.6 45.5 75.9l86.4 0c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48l82.3 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0c-13.1 0-25.9 1.4-38.2 4.1zM204.8 416l57.6 96 9.6 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-67.2 0z',
      'M348 96c-6.7-25.9-21.3-48.7-41.1-65.5L222.6 96 348 96zM224 0C164.4 0 114.2 40.8 100 96l70.5 0L278.4 12.1C261.9 4.3 243.4 0 224 0zm38.4 512L140.1 308.1c-28.5 6.2-54.5 19.3-76.1 37.3L64 512l198.4 0z',
    ],
  ],
};
const faBlockBrickFire = {
  prefix: 'fad',
  iconName: 'block-brick-fire',
  icon: [
    640,
    512,
    ['firewall'],
    'e3dc',
    [
      'M32 96l0 16 64 0 0-80C60.7 32 32 60.7 32 96zm0 48l0 96 208 0 0-96L32 144zm0 128l0 96 64 0 0-96-64 0zm0 128l0 16c0 35.3 28.7 64 64 64l144 0 0-80L32 400zM128 32l0 80 256 0 0-80L128 32zm0 240l0 96 160.8 0c-.5-5.9-.8-11.9-.8-17.9c0-25.4 8.5-52.4 21-78.1l-181 0zM272 144l0 96 54.9 0c20.6-32.8 48.5-66.2 81-96L272 144zm0 256l0 80 65.6 0c-20.2-22.6-35.1-50-43.1-80L272 400zM416 32l0 80 64 0 0-16c0-35.3-28.7-64-64-64zm63.4 112c.2 .2 .4 .4 .6 .6l0-.6-.6 0z',
      'M518 194.5l-12.3 13.8-19-19.9c-2-2.1-4-4.4-6-6.7c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2C320 440.7 390.4 512 480 512c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9zM480 464.2c-35.3 0-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327.1 544 363.6 544 400.2c0 35.3-28.7 64-64 64z',
    ],
  ],
};
const faFirewall = faBlockBrickFire;
const faFaceSadTear = {
  prefix: 'fad',
  iconName: 'face-sad-tear',
  icon: [
    512,
    512,
    [128546, 'sad-tear'],
    'f5b4',
    [
      'M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM112 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C140.6 308.6 112 349 112 369zm31.6-161a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM240 336c0 8.8 7.2 16 16 16c34.9 0 67.2 15.8 92.3 42.9c6 6.5 16.1 6.9 22.6 .9s6.9-16.1 .9-22.6C341.6 340.5 301 320 256 320c-8.8 0-16 7.2-16 16zm63.6-128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z',
      'M303.6 208a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM112 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C140.6 308.6 112 349 112 369zm63.6-129a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faSadTear = faFaceSadTear;
const faPlane = {
  prefix: 'fad',
  iconName: 'plane',
  icon: [
    576,
    512,
    [],
    'f072',
    [
      'M165.2 16c0 1.5 .2 2.9 .6 4.4l49 171.6 150.9 0L265.2 16.1C259.5 6.2 248.9 0 237.4 0L181.2 0c-9.1 0-16 7.4-16 16zm0 480.1c0 8.5 6.9 16 16 16l56.2 0c11.5 0 22.1-6.2 27.8-16.1L365.7 320l-150.9 0-49 171.6c-.4 1.5-.6 3-.6 4.4z',
      'M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l370.3 0z',
    ],
  ],
};
const faTentArrowsDown = {
  prefix: 'fad',
  iconName: 'tent-arrows-down',
  icon: [
    576,
    512,
    [],
    'e581',
    [
      'M64.4 475.3c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-5.7-4.4-12.6-6.5-19.4-6.5s-13.7 2.2-19.4 6.5l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160z',
      'M208.1 145.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72zm352 0c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-39.9 36L488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72z',
    ],
  ],
};
const faExclamation = {
  prefix: 'fad',
  iconName: 'exclamation',
  icon: [
    128,
    512,
    [10069, 10071, 61738],
    '21',
    [
      'M24 440a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z',
      'M64 32c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faArrowsSpin = {
  prefix: 'fad',
  iconName: 'arrows-spin',
  icon: [
    512,
    512,
    [],
    'e4bb',
    [
      'M33.1 255.5c0 11 .8 21.9 2.3 32.5c21.7 0 43.3 0 65 0c-2.2-10.5-3.3-21.3-3.3-32.5c0-39.7 14.5-76 38.4-104l30.5 30.5c10.1 10.1 27.3 2.9 27.3-11.3l0-105.4c0-8.8-7.2-16-16-16L72 49.4c-14.3 0-21.4 17.2-11.3 27.3l29.5 29.5c-35.5 39.6-57 92-57 149.3zm287.8 88l0 105.4c0 8.8 7.2 16 16 16l105.4 0c14.3 0 21.4-17.2 11.3-27.3l-31-31c36.4-39.8 58.6-92.8 58.6-151c0-10.7-.7-21.2-2.2-31.5L414 224c2 10.2 3.1 20.7 3.1 31.5c0 40.5-15.1 77.5-39.9 105.7l-29-29c-10.1-10.1-27.3-2.9-27.3 11.3z',
      'M35.5 288s0 0 0 0l65 0s0 0 0 0l-65 0zM257.1 95.5c-11.4 0-22.4 1.2-33.1 3.4l0-65c10.8-1.6 21.9-2.4 33.1-2.4c58.2 0 111.2 22.2 151 58.6l29.4-29.4c10.1-10.1 27.3-2.9 27.3 11.3l0 105.4c0 8.8-7.2 16-16 16l-105.4 0c-14.3 0-21.4-17.2-11.3-27.3l30.6-30.6c-28.2-24.8-65.2-39.9-105.7-39.9zM182.1 348.2l-28.9 28.9c28 23.9 64.3 38.4 104 38.4c10.6 0 20.9-1 30.9-3l0 64.9c-10.1 1.4-20.4 2.1-30.9 2.1c-57.4 0-109.7-21.6-149.3-57L76.7 453.6c-10.1 10.1-27.3 2.9-27.3-11.3l0-105.4c0-8.8 7.2-16 16-16l105.4 0c14.3 0 21.4 17.2 11.3 27.3z',
    ],
  ],
};
const faFaceSmileRelaxed = {
  prefix: 'fad',
  iconName: 'face-smile-relaxed',
  icon: [
    512,
    512,
    [],
    'e392',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm115.2-41.6c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4zm24.7 132.1c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5zM275.2 214.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4z',
      'M140.8 233.6c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm160 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2z',
    ],
  ],
};
const faCommentXmark = {
  prefix: 'fad',
  iconName: 'comment-xmark',
  icon: [
    512,
    512,
    ['comment-times'],
    'f4b5',
    [
      'M0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3C1.6 455.8 0 459.9 0 464c0 2.1 .4 4.1 1.2 6.1c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm168 64c0-6.1 2.3-12.3 7-17c15.7-15.7 31.3-31.4 47-47c-15.7-15.7-31.4-31.4-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7l47 47c15.7-15.7 31.3-31.4 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7s7 10.8 7 17s-2.3 12.3-7 17l-47 47 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7c-15.7-15.7-31.4-31.4-47-47c-15.7 15.7-31.4 31.4-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7s-7-10.8-7-17z',
      'M209 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z',
    ],
  ],
};
const faCommentTimes = faCommentXmark;
const faPrint = {
  prefix: 'fad',
  iconName: 'print',
  icon: [
    512,
    512,
    [128424, 128438, 9113],
    'f02f',
    [
      'M64 64l0 128 384 0 0-101.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64zM96 352l0 32 0 64c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-64 0-32L96 352z',
      'M0 256c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 96c0 17.7-14.3 32-32 32l-64 0 0-32L96 352l0 32-64 0c-17.7 0-32-14.3-32-32l0-96zm456 16a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  ],
};
const faTurkishLiraSign = {
  prefix: 'fad',
  iconName: 'turkish-lira-sign',
  icon: [
    384,
    512,
    ['try', 'turkish-lira'],
    'e2bb',
    [
      'M1.2 168.8c4.9 17 22.6 26.8 39.6 22L64 184.1l0-66.6L23.2 129.2c-17 4.9-26.8 22.6-22 39.6zm0 96C5.2 278.8 18.1 288 32 288c2.9 0 5.9-.4 8.8-1.2L64 280.1l0-66.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6zM128 99.3l0 66.6 136.8-39.1c14.1-4 23.2-16.8 23.2-30.8c0-2.9-.4-5.9-1.2-8.8C282.8 73.2 269.9 64 256 64c-2.9 0-5.9 .4-8.8 1.2L128 99.3zm0 96l0 66.6 136.8-39.1c14.1-4 23.2-16.8 23.2-30.8c0-2.9-.4-5.9-1.2-8.8c-4.9-17-22.6-26.8-39.6-22L128 195.3z',
      'M96 32c17.7 0 32 14.3 32 32l0 352 63.8 0c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480L96 480c-17.7 0-32-14.3-32-32L64 64c0-17.7 14.3-32 32-32z',
    ],
  ],
};
const faTry = faTurkishLiraSign;
const faTurkishLira = faTurkishLiraSign;
const faFaceNoseSteam = {
  prefix: 'fad',
  iconName: 'face-nose-steam',
  icon: [
    576,
    512,
    [],
    'e382',
    [
      'M32 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4c23.3-23.3 60.1-24.9 85.3-4.7l56.5-33.9c12.6-7.6 28.7-5.6 39.1 4.8s12.4 26.5 4.8 39.1L215.8 393c20.2 25.1 18.6 62-4.7 85.3c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C230.4 507 258.6 512 288 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-23.3-23.3-24.9-60.1-4.7-85.3l-33.9-56.5c-7.6-12.6-5.6-28.7 4.8-39.1s26.5-12.4 39.1-4.8L425 327.3c25.1-20.2 62-18.6 85.3 4.7c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1c8.9-26.1 13.8-54 13.8-83.1C544 114.6 429.4 0 288 0S32 114.6 32 256zm96-16c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm16.8-117.1c2.8-8.4 11.9-12.9 20.2-10.1c41.3 13.8 74.2 39.9 86.3 51.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-9.3-9.3-38.2-32.3-73.7-44.1c-8.4-2.8-12.9-11.9-10.1-20.2zM320 240c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm4.7-75.3c12-12 45-38.1 86.3-51.9c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2c-35.5 11.8-64.4 34.8-73.7 44.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z',
      'M41.4 421.7c2.1 2.1 4.3 3.8 6.7 5.2c-14.4 18.8-13.1 45.9 4.2 63.1s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c9.9-9.9 11.9-24.6 6.2-36.5c6-1.2 11.7-4.1 16.4-8.8c12.5-12.5 12.5-32.8 0-45.3c-3.6-3.6-7.9-6.2-12.5-7.7l44.9-69.8c1.8-2.8 1.4-6.5-.9-8.8c-2.3-2.3-5.9-2.7-8.7-1L140 367.5c-1.5-5-4.2-9.7-8.1-13.7c-12.5-12.5-32.8-12.5-45.3 0c-4.7 4.7-7.6 10.4-8.8 16.4c-11.9-5.7-26.6-3.6-36.5 6.2c-12.5 12.5-12.5 32.8 0 45.3zm491.5 .9c12.5-12.5 12.5-32.8 0-45.3c-9.9-9.9-24.6-11.9-36.5-6.2c-1.2-6-4.1-11.7-8.8-16.4c-12.5-12.5-32.8-12.5-45.3 0c-3.7 3.7-6.3 8.1-7.8 12.8L364.8 323c-2.8-1.8-6.5-1.4-8.8 1c-2.3 2.3-2.7 6-1 8.8l44.2 70.4c-4.9 1.5-9.6 4.1-13.4 8c-12.5 12.5-12.5 32.8 0 45.3c4.7 4.7 10.4 7.6 16.4 8.8c-5.7 11.9-3.6 26.6 6.2 36.5c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2z',
    ],
  ],
};
const faCircleWaveformLines = {
  prefix: 'fad',
  iconName: 'circle-waveform-lines',
  icon: [
    512,
    512,
    ['waveform-circle'],
    'e12d',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160zm64 40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80zm64-72c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm64 56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112zm64 40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32z',
      'M272 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM144 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16zm192 24c8.8 0 16 7.2 16 16l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16zM208 200c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16zm192 24c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faWaveformCircle = faCircleWaveformLines;
const faDollarSign = {
  prefix: 'fad',
  iconName: 'dollar-sign',
  icon: [
    320,
    512,
    [128178, 61781, 'dollar', 'usd'],
    '24',
    [
      'M128 32l0 35.3c20.4-2.7 42.1-2.5 64 .3L192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm0 413.1l0 34.9c0 17.7 14.3 32 32 32s32-14.3 32-32l0-33.4c-10.2 1.2-20.7 1.6-31.4 1.3c-10.7-.3-21.6-1.2-32.6-2.8z',
      'M108.5 137.8c-19.4 7.7-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3c.9 .3 1.9 .5 2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-31.6 12.9-70.3 15.2-109.7 9.3l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.2-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.4 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3c-.9-.2-1.8-.5-2.8-.7C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c32.4-12.9 72.1-15.9 111.9-10c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2z',
    ],
  ],
};
const faDollar = faDollarSign;
const faUsd = faDollarSign;
const faFerrisWheel = {
  prefix: 'fad',
  iconName: 'ferris-wheel',
  icon: [
    512,
    512,
    [],
    'e174',
    [
      'M128 488c0 4.5 1.3 9 3.8 12.9c4.4 6.9 12 11.1 20.2 11.1l208 0c8.2 0 15.8-4.2 20.2-11.1c2.5-3.9 3.8-8.4 3.8-12.9c0-3.4-.7-6.9-2.2-10.1c-4.4-9.4-8.7-18.8-13.1-28.2c-9-19.5-18.1-38.9-27.1-58.4L293 286.6c1.7-2.1 3.3-4.3 4.6-6.6c4.1-7.1 6.4-15.3 6.4-24c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 8.7 2.3 16.9 6.4 24c1.4 2.3 2.9 4.6 4.6 6.6c-16.2 34.9-32.4 69.7-48.6 104.6l-27.1 58.4c-4.4 9.4-8.7 18.8-13.1 28.2c-1.5 3.2-2.2 6.7-2.2 10.1z',
      'M302.7 36.9c27.7 5.9 53.5 16.9 76.4 31.9c6.3-3.1 13.4-4.8 20.9-4.8c26.5 0 48 21.5 48 48c0 7.5-1.7 14.6-4.8 20.9c15.1 22.9 26 48.7 31.9 76.4c21.1 5 36.9 24 36.9 46.7s-15.7 41.7-36.9 46.7c-5.9 27.7-16.9 53.5-31.9 76.4c3.1 6.3 4.8 13.4 4.8 20.9c0 26.5-21.5 48-48 48c-7.5 0-14.6-1.7-20.9-4.8c-3.4 2.2-6.9 4.4-10.4 6.4l-27.1-58.4c5-3.2 9.8-6.6 14.4-10.3c4.8-11.2 13.8-20.2 25.1-25.1c17.2-21.5 29-47.5 33.2-75.9l-116.6 0c4.1-7.1 6.4-15.3 6.4-24c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 8.7 2.3 16.9 6.4 24L97.8 280c4.3 28.5 16.1 54.4 33.2 75.9c11.2 4.8 20.2 13.8 25.1 25.1c4.6 3.7 9.4 7.1 14.4 10.3l-27.1 58.4c-3.5-2.1-7-4.2-10.4-6.4c-6.3 3.1-13.4 4.8-20.9 4.8c-26.5 0-48-21.5-48-48c0-7.5 1.7-14.6 4.8-20.9c-15.1-22.9-26.1-48.7-31.9-76.4C15.7 297.7 0 278.7 0 256s15.7-41.7 36.9-46.7c5.9-27.7 16.9-53.5 31.9-76.4C65.7 126.6 64 119.5 64 112c0-26.5 21.5-48 48-48c7.5 0 14.6 1.7 20.9 4.8c22.9-15.1 48.7-26.1 76.4-31.9C214.3 15.7 233.3 0 256 0s41.7 15.7 46.7 36.9zM127.2 161.1c-15.1 20.5-25.4 44.6-29.4 70.9l100.3 0-70.9-70.9zm33.9-33.9L232 198.1l0-100.3c-26.3 4-50.4 14.3-70.9 29.4zM280 97.8l0 100.3 70.9-70.9c-20.5-15.1-44.6-25.4-70.9-29.4zm104.8 63.3L313.9 232l100.3 0c-3.9-26.3-14.3-50.4-29.4-70.9z',
    ],
  ],
};
const faComputerSpeaker = {
  prefix: 'fad',
  iconName: 'computer-speaker',
  icon: [
    640,
    512,
    [],
    'f8b2',
    [
      'M0 96L0 320c0 35.3 28.7 64 64 64l224 0 0-64L64 320 64 96l224 0 0-16c0-18 6-34.6 16-48L64 32C28.7 32 0 60.7 0 96zM96 448c0 17.7 14.3 32 32 32l176 0c-10-13.4-16-30-16-48l0-16-160 0c-17.7 0-32 14.3-32 32zM320 80l0 352c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L368 32c-26.5 0-48 21.5-48 48zM576 320a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM512 128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z',
      'M64 96l224 0 0 224L64 320 64 96zm384 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z',
    ],
  ],
};
const faSkullCow = {
  prefix: 'fad',
  iconName: 'skull-cow',
  icon: [
    640,
    512,
    [],
    'f8de',
    [
      'M0 95.5C0 166.1 57.2 224 128 224l32 0 0-48c0-1.1 0-2.2 .1-3.4s.1-2.2 .2-3.3c.2-2.2 .5-4.4 .8-6.5c.7-4.3 1.8-8.5 3.1-12.5c2.7-8.1 6.7-15.6 11.8-22.3l-48 0-23 0c-28.7 0-52.7-21.7-55.6-50.3c-.8-7.8 .1-15.8 2.6-23.2L63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5zM464 128c10 13.4 16 30 16 48l0 48 32 0c70.8 0 128-57.9 128-128.5c0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1s-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2C587.7 106.3 563.7 128 535 128l-23 0-48 0z',
      'M240 96c-44.2 0-80 35.8-80 80l0 112c0 37 25.2 68.2 59.3 77.3l27.6 110.3c5.3 21.4 24.5 36.4 46.6 36.4l53 0c22 0 41.2-15 46.6-36.4l27.6-110.3C454.8 356.2 480 325 480 288l0-112c0-44.2-35.8-80-80-80L240 96zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faX = {
  prefix: 'fad',
  iconName: 'x',
  icon: [
    384,
    512,
    [120],
    '58',
    [
      'M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z',
      '',
    ],
  ],
};
const faMagnifyingGlassDollar = {
  prefix: 'fad',
  iconName: 'magnifying-glass-dollar',
  icon: [
    512,
    512,
    ['search-dollar'],
    'f688',
    [
      'M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zM228 312c0 .3 0 .7 0 0z',
      'M228 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9zM330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z',
    ],
  ],
};
const faSearchDollar = faMagnifyingGlassDollar;
const faUsersGear = {
  prefix: 'fad',
  iconName: 'users-gear',
  icon: [
    640,
    512,
    ['users-cog'],
    'f509',
    [
      'M0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM64 80a80 80 0 1 0 160 0A80 80 0 1 0 64 80zm64 405.3c0 14.7 11.9 26.7 26.7 26.7l300.6 0c-2.1-5.2-3.2-10.9-3.2-16.4l0-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6c-.2-.3-.2-.4-.3-.4l-2.4-4.1c-.2-.3-.2-.4-.3-.5c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5c-10.3-5.9-18.1-16.2-20.8-28.2l-103.2 0C187.7 352 128 411.7 128 485.3zM224 224c0 53 43 96 96 96c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80zm6.3 193c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3l0-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6l0 3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49z',
      'M631.5 338c2.6 6.8-.5 14.3-6.8 18l-3 1.7c-9.2 5.3-13.7 15.8-13.7 26.4s4.5 21.1 13.7 26.4l3 1.7c6.3 3.6 9.5 11.1 6.8 17.9c-2.1 5.5-4.6 10.7-7.4 15.8l-2.4 4.2c-3 5.1-6.4 9.9-10.1 14.5c-4.6 5.7-12.7 6.7-19 3l-2.9-1.7c-9.2-5.3-20.4-4-29.6 1.3s-16.1 14.5-16.1 25.1l0 3.4c0 7.3-4.9 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.2-1.1-12.1-7.6-12.1-14.9l0-3.4c0-10.6-6.9-19.8-16.1-25.1s-20.4-6.6-29.6-1.3l-2.9 1.7c-6.3 3.6-14.4 2.6-19-3c-3.7-4.6-7.1-9.4-10.1-14.5l-2.4-4.1c-2.8-5.1-5.3-10.4-7.4-15.8c-2.6-6.8 .5-14.3 6.8-17.9l3-1.7c9.2-5.3 13.7-15.8 13.7-26.4s-4.5-21.1-13.7-26.4l-2.9-1.7c-6.3-3.6-9.5-11.1-6.8-17.9c2.1-5.5 4.6-10.8 7.4-15.9l2.3-3.9c3.1-5.1 6.5-10 10.2-14.6c4.6-5.7 12.7-6.7 19-3l2.9 1.7c9.2 5.3 20.4 4 29.6-1.3s16.1-14.5 16.1-25.1l0-3.4c0-7.3 4.9-13.8 12.1-14.9c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.2 1.1 12.1 7.6 12.1 14.9l0 3.4c0 10.6 6.9 19.8 16.1 25.1s20.4 6.6 29.6 1.3l2.9-1.7c6.3-3.6 14.4-2.6 19 3c3.7 4.6 7.1 9.5 10.2 14.5l2.3 4c2.8 5.1 5.3 10.4 7.4 15.9zM512 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80z',
    ],
  ],
};
const faUsersCog = faUsersGear;
const faPersonMilitaryPointing = {
  prefix: 'fad',
  iconName: 'person-military-pointing',
  icon: [
    576,
    512,
    [],
    'e54a',
    [
      'M224 393.4L386.8 230.5c10.9 3.5 21.2 8.3 30.9 14.4L246.6 416 416 416l0 32-192 0 0-54.6zM240 112c0-11.4 2.4-22.2 6.7-32l146.7 0c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80s-80-35.8-80-80z',
      'M237.8 28.5c-12.6 2-21.8 12.9-21.8 25.6C216 68.4 227.6 80 241.9 80L400 80c8.8 0 16-7.2 16-16l0-45.2c0-9.8-8.8-17.4-18.5-15.8L237.8 28.5zM345.2 224L240 224 72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40l152 0 0 89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5zM224 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32-192 0 0 32zm22.6-64L416 416l0-46.3 53.6 90.7c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9L246.6 416z',
    ],
  ],
};
const faBuildingColumns = {
  prefix: 'fad',
  iconName: 'building-columns',
  icon: [
    512,
    512,
    ['bank', 'institution', 'museum', 'university'],
    'f19c',
    [
      'M0 480c0 3.1 .4 6.2 1.4 9.3C5.5 502.8 17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7c.9-3.1 1.4-6.2 1.4-9.3c0-10.5-5.2-20.6-14.2-26.6l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 192l-64 0 0 224-40 0 0-224-64 0 0 224-48 0 0-224-64 0 0 224-40 0 0-224-64 0 0 228.3c-.6 .3-1.2 .7-1.7 1.1l-48 32C5.2 459.4 0 469.5 0 480z',
      'M268.6 2.6c-8-3.4-17.2-3.4-25.2 0l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160l0 8c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24l0-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
    ],
  ],
};
const faBank = faBuildingColumns;
const faInstitution = faBuildingColumns;
const faMuseum = faBuildingColumns;
const faUniversity = faBuildingColumns;
const faCircleT = {
  prefix: 'fad',
  iconName: 'circle-t',
  icon: [
    512,
    512,
    [],
    'e124',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-88c0-13.3 10.7-24 24-24l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24z',
      'M128 168c0-13.3 10.7-24 24-24l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faSack = {
  prefix: 'fad',
  iconName: 'sack',
  icon: [
    512,
    512,
    [],
    'f81c',
    [
      'M0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4l-128 0c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416zM144.6 24.9L192 96l128 0 47.4-71.1C374.5 14.2 366.9 0 354.1 0L157.9 0c-12.8 0-20.4 14.2-13.3 24.9z',
      'M176 112c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
    ],
  ],
};
const faGrid2 = {
  prefix: 'fad',
  iconName: 'grid-2',
  icon: [
    512,
    512,
    [],
    'e196',
    [
      'M32 328l0 112c0 22.1 17.9 40 40 40l112 0c22.1 0 40-17.9 40-40l0-112c0-22.1-17.9-40-40-40L72 288c-22.1 0-40 17.9-40 40zM288 72l0 112c0 22.1 17.9 40 40 40l112 0c22.1 0 40-17.9 40-40l0-112c0-22.1-17.9-40-40-40L328 32c-22.1 0-40 17.9-40 40z',
      'M224 80c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM480 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z',
    ],
  ],
};
const faCameraCctv = {
  prefix: 'fad',
  iconName: 'camera-cctv',
  icon: [
    576,
    512,
    ['cctv'],
    'f8ac',
    [
      'M0 384l0 48 0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 96 0c13.3 0 25.2-8.2 29.9-20.6l47-123.4c-19.7-8.2-39.4-16.4-59.1-24.6L137.9 400 64 400l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32zm362.6-54l150.8 68.5c3.9 1.8 8.4 1.9 12.5 .3s7.2-4.7 8.9-8.7l40-96c.8-2 1.2-4.1 1.2-6.1c0-6.1-3.6-12-9.5-14.6l-71.3-31.7C451 271.1 406.8 300.6 362.6 330z',
      'M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l288 120c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160z',
    ],
  ],
};
const faCctv = faCameraCctv;
const faUmbrella = {
  prefix: 'fad',
  iconName: 'umbrella',
  icon: [
    576,
    512,
    [],
    'f0e9',
    [
      'M163.4 462.3l2.3 4.7c13.8 27.6 42 45 72.8 45c45 0 81.4-36.5 81.4-81.4l0-151.9c-9.8-4.3-20.6-6.7-32-6.7c-1.4 0-2.8 0-4.2 .1s-2.8 .2-4.2 .3c-2.8 .3-5.5 .7-8.2 1.3c-5.4 1.1-10.5 2.8-15.4 4.9l0 151.9c0 9.6-7.8 17.4-17.4 17.4c-6.6 0-12.6-3.7-15.6-9.6l-2.3-4.7c-7.9-15.8-27.1-22.2-42.9-14.3s-22.2 27.1-14.3 42.9z',
      'M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.7C124.2 63.4 18.3 161 2.1 285.9c-2 15.6 17.3 24.4 27.8 12.7C43.9 283 71.2 272 96 272c38.7 0 71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C217 299.5 249.3 272 288 272s71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C409 299.5 441.3 272 480 272c24.8 0 52.1 11 66.1 26.7c10.5 11.7 29.8 2.9 27.8-12.7C557.7 161 451.8 63.4 320 49.7L320 32z',
    ],
  ],
};
const faTrowel = {
  prefix: 'fad',
  iconName: 'trowel',
  icon: [
    512,
    512,
    [],
    'e589',
    [
      'M0 480c0 8.4 3.3 16.5 9.4 22.6s14.3 9.4 22.6 9.4c3.2 0 6.4-.5 9.5-1.5l256-80c10.7-3.3 18.9-12 21.5-22.9s-.5-22.4-8.4-30.3L245.3 312l98.6-98.6-.3-.3c-14.9-14.9-29.8-29.8-44.7-44.7l-.3-.3L200 266.7l-65.4-65.4c-7.9-7.9-19.4-11.1-30.3-8.4s-19.6 10.8-22.9 21.5l-80 256C.5 473.6 0 476.8 0 480z',
      'M298.9 115.6c-14.6 14.6-14.6 38.2 0 52.8l44.7 44.7c14.6 14.6 38.2 14.6 52.8 0l95.4-95.4c26.9-26.9 26.9-70.5 0-97.5s-70.5-26.9-97.5 0l-95.4 95.4z',
    ],
  ],
};
const faHorizontalRule = {
  prefix: 'fad',
  iconName: 'horizontal-rule',
  icon: [
    640,
    512,
    [8213],
    'f86c',
    ['M0 256c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z', ''],
  ],
};
const faBedFront = {
  prefix: 'fad',
  iconName: 'bed-front',
  icon: [
    512,
    512,
    ['bed-alt'],
    'f8f7',
    [
      'M0 288c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6l16 0 160 0 32 0 160 0 16 0c11.7 0 22.6 3.1 32 8.6c19.1 11.1 32 31.7 32 55.4l0 32 0 32-32 0L32 352 0 352l0-32 0-32z',
      'M32 80c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 152.6c-9.4-5.4-20.3-8.6-32-8.6l-16 0 0-64c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 64-32 0 0-64c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 64-16 0c-11.7 0-22.6 3.1-32 8.6L32 80zm0 272l448 0 32 0 0 32 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-32 32 0z',
    ],
  ],
};
const faBedAlt = faBedFront;
const faD = {
  prefix: 'fad',
  iconName: 'd',
  icon: [
    384,
    512,
    [100],
    '44',
    [
      'M0 96C0 60.7 28.7 32 64 32l96 0c123.7 0 224 100.3 224 224s-100.3 224-224 224l-96 0c-35.3 0-64-28.7-64-64L0 96zm160 0L64 96l0 320 96 0c88.4 0 160-71.6 160-160s-71.6-160-160-160z',
      '',
    ],
  ],
};
const faStapler = {
  prefix: 'fad',
  iconName: 'stapler',
  icon: [
    640,
    512,
    [],
    'e5af',
    [
      'M64 219.4L64 320c0 17.7 14.3 32 32 32l352 0 0-64c-128-22.9-256-45.7-384-68.6z',
      'M640 304l0-4.7c0-36.4-20.5-69.6-53.1-85.9L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L8.2 149.1C2.9 156.2 0 164.8 0 173.7c0 19.9 14.2 36.9 33.8 40.4L448 288l0 128L64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0 64 0 80 0c26.5 0 48-21.5 48-48l0-128z',
    ],
  ],
};
const faMasksTheater = {
  prefix: 'fad',
  iconName: 'masks-theater',
  icon: [
    640,
    512,
    [127917, 'theater-masks'],
    'f630',
    [
      'M0 103.7c0 2.7 .2 5.4 .6 8.1L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2c41.7 36.1 108 82.5 166.1 73.7c16.5-2.5 32.2-9.4 47.1-19.1c-9.9-12.9-18.7-26-26.2-37.9c-15-24-21.6-51.7-21.6-79.9c0-3.2 .1-6.3 .2-9.5s.4-6.3 .7-9.5c-8.7-.5-17.7-.1-26.7 1.2c-22.9 3.5-43.4 12.8-60.4 26.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c13.8-2.1 27.3-.6 39.5 3.9L266.3 118c1.4-9.8 5.1-19.2 12.9-25.2c.9-.7 1.8-1.4 2.8-2.1s2-1.4 3.1-2.1c2.2-1.5 4.7-2.9 7.4-4.5c5.5-3 12-6.1 19.8-8.9c15.6-5.6 36-10.3 62.6-11.9l-1.2-8.1c-1.4-9.8-5.1-19.2-12.9-25.2C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C1.6 89.7 0 96.6 0 103.7zm96.5 65.1c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6z',
      'M399.3 509.7c-58.2-8.8-108.2-72.8-137.6-119.7c-20-31.9-25.1-70.3-19.6-107.7L266.3 118c1.4-9.8 5.1-19.2 12.9-25.2c20.2-15.6 72.4-41.5 185.1-24.5s155.2 57.4 170 78.3c5.7 8 6.5 18.1 5.1 27.9L615.2 338.8c-5.5 37.3-21.5 72.6-49.8 97.2c-41.7 36.1-108 82.5-166.1 73.7zm17.1-277.7c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8c4.4 3.1 10.8 2 11.8-3.3zm112.6 22.2c4.4 3.1 10.8 2 11.8-3.3c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8zm-11.5 85.2c-28.8 12.8-61.4 17.8-94.9 12.8s-63.2-19.5-87-40.3c-6.3-5.5-16.2-1.7-15.2 6.7c5.9 48.5 43 89.1 93 96.7s97.2-20.2 116.8-64.9c3.4-7.7-5-14.3-12.6-10.9z',
    ],
  ],
};
const faTheaterMasks = faMasksTheater;
const faFileGif = {
  prefix: 'fad',
  iconName: 'file-gif',
  icon: [
    512,
    512,
    [],
    'e645',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-144 0c-35.3 0-64 28.7-64 64l0 144L64 512c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM224 392l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm160-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm48-16c-8.8 0-16 7.2-16 16l0 64 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0z',
    ],
  ],
};
const faKipSign = {
  prefix: 'fad',
  iconName: 'kip-sign',
  icon: [
    384,
    512,
    [],
    'e1c4',
    [
      'M0 256c0-17.7 14.3-32 32-32l32 0 0 32 0 32-32 0c-17.7 0-32-14.3-32-32zm145.2 0l37.3-32L352 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-169.5 0c-12.4-10.7-24.9-21.3-37.3-32z',
      'M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4 128 64c0-17.7-14.3-32-32-32S64 46.3 64 64l0 192 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-122.4L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L145.2 256 340.8 88.3z',
    ],
  ],
};
const faFaceWoozy = {
  prefix: 'fad',
  iconName: 'face-woozy',
  icon: [
    512,
    512,
    [],
    'e3a2',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-80c0-6.7 4.2-12.9 10.9-15.2c13.4-4.5 48.5-22.9 71.7-57.7c3.1-4.6 8.2-7.1 13.3-7.1c3 0 6.1 .9 8.9 2.7c7.4 4.9 9.3 14.8 4.4 22.2c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1c-.6-1.7-.8-3.4-.8-5.1zm2.7 167.1c4.9-7.4 14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2zm29.8-99.2c-2.1-8.6 3.1-17.3 11.6-19.4c21.3-5.3 42.7-10.7 64-16c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4c-21.3 5.3-42.7 10.7-64 16c-8.6 2.1-17.3-3.1-19.4-11.6zM304 208c0-35.3 14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64s-32-28.7-32-64z',
      'M205.3 120.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4c-23.2 34.8-58.4 53.2-71.7 57.7c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1c18.6-6.2 60.3-28.3 88.3-70.3zm6.6 118.6c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-64 16c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l64-16zM336 272c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z',
    ],
  ],
};
const faCloudQuestion = {
  prefix: 'fad',
  iconName: 'cloud-question',
  icon: [
    640,
    512,
    [],
    'e492',
    [
      'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zM233.4 198.5c.1-.4 .3-.8 .4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L344 296.4c-.2 13-10.9 23.6-24 23.6c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.5c0-4.5 0-9 0-13.6c0-.4 0-.9 .1-1.4s.1-1.1 .2-1.6c.1-1 .3-2.1 .6-3.1c.5-2 1.4-3.9 2.4-5.7c2.1-3.6 5.1-6.6 8.8-8.8c14.8-8.5 29.6-17 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3c-.1 .4-.3 .8-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6zm54.8 182.2c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1.1 0-1.8c0-.4 0-1 0-1.5s.1-1.1 .1-1.6z',
      'M286.6 160c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  ],
};
const faPineapple = {
  prefix: 'fad',
  iconName: 'pineapple',
  icon: [
    512,
    512,
    [],
    'e31f',
    [
      'M0 320c0 41 16.3 80.3 45.3 109.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3L402.7 365.3c29-29 45.3-68.3 45.3-109.3c0-20.9-4.2-41.3-12.2-60.2c-7.7-18.2-18.8-34.8-33-49.1l-37.5-37.5C351 95 334.4 83.9 316.2 76.2C297.3 68.2 276.9 64 256 64c-41 0-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320zm80-16c0-4.1 1.6-8.2 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-3.1-3.1-4.7-7.2-4.7-11.3zm84.7-91.3c6.2-6.2 16.4-6.2 22.6 0L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm0 160c6.2-6.2 16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm80-80c6.2-6.2 16.4-6.2 22.6 0L288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z',
      'M423.1 1.7c4.2 2.1 7.3 5.9 8.4 10.5l3.6 14.3C447 19.6 460.6 16 474.5 16l5.5 0c8.8 0 16 7.2 16 16l0 5.5c0 13.9-3.6 27.5-10.4 39.4l14.3 3.6c4.5 1.1 8.4 4.2 10.5 8.4s2.2 9.1 .4 13.4c-6.8 15.9-19.5 26.7-34.1 31.6l14.7 14.7c6.2 6.2 6.2 16.4 0 22.6c-15.4 15.4-35.3 23.6-55.5 24.5c-7.7-18.2-18.8-34.8-33-49.1l-37.5-37.5C351 95 334.4 83.9 316.2 76.2c.9-20.2 9.1-40.1 24.5-55.5c6.2-6.2 16.4-6.2 22.6 0l14.7 14.7C383 20.8 393.8 8.1 409.7 1.3c4.3-1.8 9.2-1.7 13.4 .4zm-235.8 211L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm160 0L288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-102.6 80c6.2-6.2 16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z',
    ],
  ],
};
const faHandPointLeft = {
  prefix: 'fad',
  iconName: 'hand-point-left',
  icon: [
    512,
    512,
    [],
    'f0a5',
    [
      'M0 128c0 17.7 14.3 32 32 32l208 0 0-64L32 96C14.3 96 0 110.3 0 128zm272 0l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64z',
      'M160 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0zm32 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z',
    ],
  ],
};
const faGalleryThumbnails = {
  prefix: 'fad',
  iconName: 'gallery-thumbnails',
  icon: [
    576,
    512,
    [],
    'e3aa',
    [
      'M0 448l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm160 0l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm160 0l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm160 0l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z',
      'M512 64l0 224L64 288 64 64l448 0zM64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 0z',
    ],
  ],
};
const faCircleJ = {
  prefix: 'fad',
  iconName: 'circle-j',
  icon: [
    512,
    512,
    [],
    'e112',
    [
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c0 53-43 96-96 96s-96-43-96-96l0-8z',
      'M312 128c13.3 0 24 10.7 24 24l0 136c0 53-43 96-96 96s-96-43-96-96l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24z',
    ],
  ],
};
const faEyes = {
  prefix: 'fad',
  iconName: 'eyes',
  icon: [
    640,
    512,
    [],
    'e367',
    [
      'M64 256c0 36.2 8.5 69 22.4 95.3c3.2 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c-.8 7.9-1.3 15.9-1.3 24.2zm288 0c0 36.2 8.5 69 22.4 95.3c3.2 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c-.8 7.9-1.3 15.9-1.3 24.2z',
      'M64 256c0-46.8 14.3-87.9 35.8-116.6C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4S64 302.8 64 256zM320 126.7c-5-9.1-10.5-17.6-16.6-25.7C272.8 60.2 228.1 32 176 32s-96.8 28.2-127.4 69C18 141.8 0 196.7 0 256s18 114.2 48.6 155c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7c5 9.1 10.5 17.6 16.6 25.7c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155C560.8 60.2 516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zM352 256c0-46.8 14.3-87.9 35.8-116.6C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4S352 302.8 352 256z',
    ],
  ],
};
const faHandshakeSimple = {
  prefix: 'fad',
  iconName: 'handshake-simple',
  icon: [
    640,
    512,
    [129309, 'handshake-alt'],
    'f4c6',
    [
      'M208.3 186.4c-.1 .9-.2 1.9-.2 2.8c-.1 .9-.1 1.9-.1 2.8c0 9.7 2.9 19.4 8.9 27.9c15.4 21.6 45.4 26.6 67 11.2l57.2-40.8c4.4 4 8.8 8 13.1 12L496.4 332.6c5.5 5 9.5 11.1 12.1 17.5c.3 .6 .5 1.2 .7 1.8l82.7 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-16 0-65.5 0-71-47.3C423.2 69.8 404.1 64 384.5 64c-20.7 0-40.9 6.5-57.7 18.5c-3.1 2.2-6.2 4.4-9.3 6.7l-89.3 63.8c-.8 .6-1.6 1.2-2.4 1.8s-1.5 1.3-2.2 1.9c-1.4 1.3-2.8 2.7-4 4.2c-2.5 2.9-4.6 6.1-6.3 9.5s-3 6.9-3.8 10.5c-.4 1.8-.8 3.7-1 5.5z',
      'M48 352l108.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c7.4-8.1 11.5-18 12.4-28.2l7.8 7.1c19.5 17.9 49.9 16.6 67.8-2.9c12.9-14 15.8-33.7 9.2-50.3c-2.6-6.5-6.6-12.5-12.1-17.5L354.2 202.3l-13.1-12-57.2 40.8c-21.6 15.4-51.6 10.4-67-11.2s-10.4-51.6 11.2-67l89.3-63.8-2.7-2.3C297.5 72.1 275.5 64 252.8 64C234 64 215.7 69.6 200 80l-72 48-80 0c-26.5 0-48 21.5-48 48L0 304c0 26.5 21.5 48 48 48z',
    ],
  ],
};
const faHandshakeAlt = faHandshakeSimple;
const faPageCaretUp = {
  prefix: 'fad',
  iconName: 'page-caret-up',
  icon: [
    384,
    512,
    ['file-caret-up'],
    'e42a',
    [
      'M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-309.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L64 0C28.7 0 0 28.7 0 64zM98.1 295.8c0-5.6 2-11.3 6.4-16.1c25.2-27.5 50.5-55.1 75.7-82.6c3-3.3 7.3-5.2 11.8-5.2s8.8 1.9 11.8 5.2c25.2 27.5 50.5 55.1 75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2l-139.6 0c-14.4 0-24-11.8-24-24.2z',
      'M203.8 197.2c-3-3.3-7.3-5.2-11.8-5.2s-8.8 1.9-11.8 5.2l-75.7 82.6c-14.1 15.4-3.2 40.2 17.7 40.2l139.6 0c20.9 0 31.8-24.8 17.7-40.2l-75.7-82.6z',
    ],
  ],
};
const faFileCaretUp = faPageCaretUp;
const faJetFighter = {
  prefix: 'fad',
  iconName: 'jet-fighter',
  icon: [
    640,
    512,
    ['fighter-jet'],
    'f0fb',
    [
      'M192 48l0 144 192 0L280 48l-88 0zm0 272l0 144 88 0L384 320l-192 0z',
      'M160 24c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 0c-13.3 0-24 10.7-24 24zm32 168l-32 0-54.6-54.6c-6-6-14.1-9.4-22.6-9.4L48 128c-8.8 0-16 7.2-16 16l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 80c0 8.8 7.2 16 16 16l34.7 0c8.5 0 16.6-3.4 22.6-9.4L160 320l32 0 308.4 0c7.7 0 15.3-1.4 22.5-4.1L625 277.6c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L522.9 196.1c-7.2-2.7-14.8-4.1-22.5-4.1L192 192zM80 240l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM184 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z',
    ],
  ],
};
const faFighterJet = faJetFighter;
const faComet = {
  prefix: 'fad',
  iconName: 'comet',
  icon: [
    512,
    512,
    [],
    'e003',
    [
      'M0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309zm69.7-18.1c.1-.8 .3-1.6 .6-2.5c1.9-5.8 6.9-10 12.9-10.9c21.8-3.2 43.5-6.3 65.3-9.5c9.7-19.7 19.5-39.4 29.2-59.2c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9c9.7 19.7 19.5 39.4 29.2 59.2l65.3 9.5c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4c-15.7 15.3-31.5 30.7-47.2 46c3.7 21.7 7.4 43.3 11.2 65c1 6-1.4 12.1-6.4 15.7s-11.5 4.1-16.8 1.2c-19.5-10.2-38.9-20.5-58.4-30.7c-19.5 10.2-38.9 20.5-58.4 30.7c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.7l11.2-65-47.2-46c-1.6-1.5-2.8-3.3-3.6-5.3c-.4-1-.7-2-.9-3c-.2-.8-.3-1.6-.2-1.6c-.1-.8-.1-.8-.1-1.6c0-.8 0-1 0-1.2c0-.4 .1-.8 .1-1.2z',
      'M206.3 208.9c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L192 402.1l58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z',
    ],
  ],
};
const faSquareShareNodes = {
  prefix: 'fad',
  iconName: 'square-share-nodes',
  icon: [
    448,
    512,
    ['share-alt-square'],
    'f1e1',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM64 256c0-35.3 28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64z',
      'M320 224c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3L174.5 212c-11.7-12.3-28.2-20-46.5-20c-35.3 0-64 28.7-64 64s28.7 64 64 64c18.3 0 34.8-7.7 46.5-20l81.9 44.7c-.3 2.4-.4 4.9-.4 7.3c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-15.4 0-29.5 5.4-40.6 14.5L194.1 256l85.3-46.5c11 9.1 25.2 14.5 40.6 14.5z',
    ],
  ],
};
const faShareAltSquare = faSquareShareNodes;
const faReflectVertical = {
  prefix: 'fad',
  iconName: 'reflect-vertical',
  icon: [
    512,
    512,
    [],
    'e665',
    [
      'M98.4 19.8c-5 12-2.2 25.7 6.9 34.9l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c6.1-6.1 9.4-14.3 9.4-22.6c0-4.1-.8-8.3-2.4-12.2C408.6 7.8 396.9 0 384 0L128 0c-12.9 0-24.6 7.8-29.6 19.8zm0 472.5c5 12 16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8c1.6-4 2.4-8.1 2.4-12.2c0-8.3-3.3-16.5-9.4-22.6l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9z',
      'M0 256c0-13.3 10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faShieldKeyhole = {
  prefix: 'fad',
  iconName: 'shield-keyhole',
  icon: [
    512,
    512,
    [],
    'e248',
    [
      'M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM200 208c0-30.9 25.1-56 56-56c15.5 0 29.5 6.3 39.6 16.4c5.1 5.1 9.2 11.1 12 17.8c1.4 3.3 2.5 6.9 3.3 10.5c.4 1.9 .7 3.8 .9 5.7c.1 .9 .2 1.9 .2 2.8c0 .9 .1 1.8 .1 2.9l0 .6c0 .4 0 1 0 1.7c0 .6-.1 1.2-.1 1.8c-.1 1.3-.3 2.7-.4 4.1c-.4 2.7-1 5.3-1.7 7.8c-1.5 5.1-3.7 9.9-6.6 14.2c-5.6 8.7-13.6 15.8-23.1 20.3c0 23.1 0 46.3 0 69.4l0 .4c0 .5 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3.1-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-23.1 0-46.3 0-69.4c-18.9-9-32-28.3-32-50.6z',
      'M280 258.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 69.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-69.4z',
    ],
  ],
};
const faFileMp4 = {
  prefix: 'fad',
  iconName: 'file-mp4',
  icon: [
    512,
    512,
    [],
    'e649',
    [
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-240 0c-35.3 0-64 28.7-64 64l0 144-16 0c-35.3 0-64-28.7-64-64L0 64z',
      'M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM157.7 359.8c-3.7-6.2-11.1-9.1-18-7.2s-11.7 8.2-11.7 15.4l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-70.2 18.3 30.5c2.9 4.8 8.1 7.8 13.7 7.8s10.8-3 13.7-7.8L224 425.8l0 70.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-7.2-4.8-13.5-11.7-15.4s-14.3 1-18 7.2L192 416.9l-34.3-57.1zM304 352c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm84.7 11.3c3 3 7.1 4.7 11.3 4.7l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 4.2 1.7 8.3 4.7 11.3z',
    ],
  ],
};
const faBarcode = {
  prefix: 'fad',
  iconName: 'barcode',
  icon: [
    512,
    512,
    [],
    'f02a',
    [
      'M0 56L0 456c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24L64 56c0-13.3-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56zm160 0l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm288 0l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24z',
      'M96 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16L96 48zm160 8c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 400c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-400zM400 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16z',
    ],
  ],
};
const faBulldozer = {
  prefix: 'fad',
  iconName: 'bulldozer',
  icon: [
    640,
    512,
    [],
    'e655',
    [
      'M0 400c0-30.5 12.2-58.2 32-78.4C52.4 300.9 80.7 288 112 288l256 0c44.7 0 83.2 26.2 101.2 64c6.9 14.5 10.8 30.8 10.8 48c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400zm64 0c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-256 0c-26.5 0-48 21.5-48 48z',
      'M96 96l0 96 124.2 0-48-96L96 96zM229.5 67.4L291.8 192l28.2 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 32 0c17.7 0 32 14.3 32 32l0 64 64 0 0-41.6c0-21.8 7.4-42.9 21-60L583 124c11-13.8 31.2-16 45-5s16 31.2 5 45l-50 62.5c-4.5 5.7-7 12.7-7 20l0 73.6 0 69.5c0 8.5 3.4 16.6 9.4 22.6l45.3 45.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-45.3-45.3c-18-18-28.1-42.4-28.1-67.9l0-37.5-42.8 0c-18-37.8-56.5-64-101.2-64l-256 0c-31.3 0-59.6 12.9-80 33.6c0-.5 0-1 0-1.6l0-64 0-32L32 80c0-26.5 21.5-48 48-48l92.2 0c24.2 0 46.4 13.7 57.2 35.4zM96 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z',
    ],
  ],
};
const faPlusMinus = {
  prefix: 'fad',
  iconName: 'plus-minus',
  icon: [
    384,
    512,
    [],
    'e43c',
    [
      'M0 480c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z',
      'M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112L48 144c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0 0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-112z',
    ],
  ],
};
const faSquareSlidersVertical = {
  prefix: 'fad',
  iconName: 'square-sliders-vertical',
  icon: [
    448,
    512,
    ['sliders-v-square'],
    'f3f2',
    [
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 96c0 17.7 14.3 32 32 32l16 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-16 0c-17.7 0-32 14.3-32 32zM224 320c0 17.7 14.3 32 32 32l16 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160-16 0c-17.7 0-32 14.3-32 32z',
      'M96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zM256 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z',
    ],
  ],
};
const faSlidersVSquare = faSquareSlidersVertical;
const faVideo = {
  prefix: 'fad',
  iconName: 'video',
  icon: [
    576,
    512,
    ['video-camera'],
    'f03d',
    [
      'M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 68.2 0 119.6 0 68.2c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z',
      'M576 128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6L384 196.2V315.8l142.2 94.8c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128z',
    ],
  ],
};
const faVideoCamera = faVideo;
const faMessageMiddle = {
  prefix: 'fad',
  iconName: 'message-middle',
  icon: [
    512,
    512,
    ['comment-middle-alt'],
    'e1e1',
    [
      'M343.5 416L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l104.5 0 75.2 90.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L343.5 416z',
      '',
    ],
  ],
};
const faCommentMiddleAlt = faMessageMiddle;
const faGraduationCap = {
  prefix: 'fad',
  iconName: 'graduation-cap',
  icon: [
    640,
    512,
    [127891, 'mortar-board'],
    'f19d',
    [
      'M.9 453.4c1.8 5 6 8.9 11.2 10.2l64 16c1.3 .3 2.6 .5 3.9 .5c3 0 6-.8 8.6-2.5c3.7-2.3 6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2c11.5-9.7 24.7-17.6 39.3-23.1c53.1-19.9 106.3-39.9 159.4-59.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4c-53.2 19.9-106.3 39.9-159.4 59.8c-23.9 9-44.9 23.1-61.7 40.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4z',
      'M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l77.4 27.9c16.8-17.8 37.8-31.9 61.7-40.9l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6L166.2 199.6c-14.6 5.5-27.8 13.4-39.3 23.1l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z',
    ],
  ],
};
const faMortarBoard = faGraduationCap;
const faHandHoldingMedical = {
  prefix: 'fad',
  iconName: 'hand-holding-medical',
  icon: [
    576,
    512,
    [],
    'e05c',
    [
      'M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z',
      'M248 0c-13.3 0-24 10.7-24 24l0 56-56 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24L248 0z',
    ],
  ],
};
const faPersonCircleCheck = {
  prefix: 'fad',
  iconName: 'person-circle-check',
  icon: [
    576,
    512,
    [],
    'e53e',
    [
      'M0 288c0 10.9 5.5 21.5 15.5 27.5c15.1 9.1 34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c1.4 2.3 3.1 4.5 4.9 6.3c7.9-23 20.5-43.9 36.6-61.5l-44.9-74.7c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97C1.5 276.7 0 282.4 0 288zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z',
      'M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z',
    ],
  ],
};
const faSquareZ = {
  prefix: 'fad',
  iconName: 'square-z',
  icon: [
    448,
    512,
    [],
    'e288',
    [
      'M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 56c0-.4 0-.8 0 0z',
      'M112 152c0-13.3 10.7-24 24-24l176 0c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336 312 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176 136 176c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faMessageText = {
  prefix: 'fad',
  iconName: 'message-text',
  icon: [
    512,
    512,
    ['comment-alt-text'],
    'e1e6',
    [
      'M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm144 72c0 13.3 10.7 24 24 24l64 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0-88 0c-13.3 0-24 10.7-24 24z',
      'M144 136c0-13.3 10.7-24 24-24l88 0 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-64 0c-13.3 0-24-10.7-24-24z',
    ],
  ],
};
const faCommentAltText = faMessageText;
const faTurnUp = {
  prefix: 'fad',
  iconName: 'turn-up',
  icon: [
    384,
    512,
    [10548, 'level-up-alt'],
    'f3bf',
    [
      'M0 448l0 32c0 17.7 14.3 32 32 32l96 0c61.9 0 112-50.1 112-112l0-208c-32 0-64 0-96 0l0 208c0 8.8-7.2 16-16 16l-96 0c-17.7 0-32 14.3-32 32z',
      'M345.4 151.5c6.6 7 8.4 17.2 4.6 26s-12.5 14.5-22 14.5L56 192c-9.6 0-18.2-5.7-22-14.5s-2-19 4.6-26l136-144C179.1 2.7 185.4 0 192 0s12.9 2.7 17.4 7.5l136 144z',
    ],
  ],
};
const faLevelUpAlt = faTurnUp;
var icons = {
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faFillDrip,
  faArrowsToCircle,
  faCircleChevronRight,
  faChevronCircleRight,
  faWagonCovered,
  faLineHeight,
  faBagel,
  faTransporter7,
  faAt,
  faRectanglesMixed,
  faPhoneArrowUpRight,
  faPhoneArrowUp,
  faPhoneOutgoing,
  faTrashCan,
  faTrashAlt,
  faCircleL,
  faHeadSideGoggles,
  faHeadVr,
  faTextHeight,
  faUserXmark,
  faUserTimes,
  faFaceHandYawn,
  faGaugeSimpleMin,
  faTachometerSlowest,
  faStethoscope,
  faCoffin,
  faMessage,
  faCommentAlt,
  faSalad,
  faBowlSalad,
  faInfo,
  faRobotAstromech,
  faRingDiamond,
  faFonduePot,
  faTheta,
  faFaceHandPeeking,
  faSquareUser,
  faDownLeftAndUpRightToCenter,
  faCompressAlt,
  faExplosion,
  faFileLines,
  faFileAlt,
  faFileText,
  faWaveSquare,
  faRing,
  faBuildingUn,
  faDiceThree,
  faTirePressureWarning,
  faWifiFair,
  faWifi2,
  faCalendarDays,
  faCalendarAlt,
  faMp3Player,
  faAnchorCircleCheck,
  faTally4,
  faRectangleHistory,
  faBuildingCircleArrowRight,
  faVolleyball,
  faVolleyballBall,
  faSunHaze,
  faTextSize,
  faUfo,
  faFork,
  faUtensilFork,
  faArrowsUpToLine,
  faMobileSignal,
  faBarcodeScan,
  faSortDown,
  faSortDesc,
  faFolderArrowDown,
  faFolderDownload,
  faCircleMinus,
  faMinusCircle,
  faFaceIcicles,
  faShovel,
  faDoorOpen,
  faFilms,
  faRightFromBracket,
  faSignOutAlt,
  faFaceGlasses,
  faNfc,
  faAtom,
  faSoap,
  faIcons,
  faHeartMusicCameraBolt,
  faMicrophoneLinesSlash,
  faMicrophoneAltSlash,
  faClosedCaptioningSlash,
  faCalculatorSimple,
  faCalculatorAlt,
  faBridgeCircleCheck,
  faSlidersUp,
  faSlidersV,
  faLocationMinus,
  faMapMarkerMinus,
  faPumpMedical,
  faFingerprint,
  faSkiBoot,
  faStandardDefinition,
  faRectangleSd,
  faH1,
  faHandPointRight,
  faMagnifyingGlassLocation,
  faSearchLocation,
  faMessageBot,
  faForwardStep,
  faStepForward,
  faFaceSmileBeam,
  faSmileBeam,
  faLightCeiling,
  faMessageExclamation,
  faCommentAltExclamation,
  faBowlScoop,
  faBowlShavedIce,
  faSquareX,
  faBuildingMemo,
  faUtilityPoleDouble,
  faFlagCheckered,
  faChevronsUp,
  faChevronDoubleUp,
  faFootball,
  faFootballBall,
  faUserVneck,
  faSchoolCircleExclamation,
  faCrop,
  faAnglesDown,
  faAngleDoubleDown,
  faUsersRectangle,
  faPeopleRoof,
  faSquareArrowRight,
  faArrowSquareRight,
  faLocationPlus,
  faMapMarkerPlus,
  faLightbulbExclamationOn,
  faPeopleLine,
  faBeerMugEmpty,
  faBeer,
  faCarpool,
  faCarPeople,
  faCrateEmpty,
  faDiagramPredecessor,
  faTransporter,
  faCalendarCircleUser,
  faArrowUpLong,
  faLongArrowUp,
  faPersonCarryBox,
  faPersonCarry,
  faFireFlameSimple,
  faBurn,
  faPerson,
  faMale,
  faLaptop,
  faFileCsv,
  faMenorah,
  faUnion,
  faChevronsLeft,
  faChevronDoubleLeft,
  faCircleHeart,
  faHeartCircle,
  faTruckPlane,
  faRecordVinyl,
  faBringForward,
  faSquareP,
  faFaceGrinStars,
  faGrinStars,
  faSigma,
  faCameraMovie,
  faBong,
  faClarinet,
  faTruckFlatbed,
  faSpaghettiMonsterFlying,
  faPastafarianism,
  faArrowDownUpAcrossLine,
  faArrowsRotateReverse,
  faLeafHeart,
  faHouseBuilding,
  faCheeseSwiss,
  faSpoon,
  faUtensilSpoon,
  faJarWheat,
  faEnvelopesBulk,
  faMailBulk,
  faFileCircleExclamation,
  faBowArrow,
  faCartXmark,
  faHexagonXmark,
  faTimesHexagon,
  faXmarkHexagon,
  faCircleH,
  faHospitalSymbol,
  faMerge,
  faPager,
  faCartMinus,
  faAddressBook,
  faContactBook,
  faPanFrying,
  faGrid,
  faGrid3,
  faFootballHelmet,
  faHandLove,
  faTrees,
  faStrikethrough,
  faPage,
  faK,
  faDiagramPrevious,
  faGaugeMin,
  faTachometerAltSlowest,
  faFolderGrid,
  faEggplant,
  faExcavator,
  faRam,
  faLandmarkFlag,
  faLips,
  faPencil,
  faPencilAlt,
  faBackward,
  faCaretRight,
  faComments,
  faPaste,
  faFileClipboard,
  faDesktopArrowDown,
  faCodePullRequest,
  faPumpkin,
  faClipboardList,
  faPenField,
  faChartSine,
  faBlueberries,
  faTruckRampBox,
  faTruckLoading,
  faNote,
  faArrowDownToSquare,
  faUserCheck,
  faCloudXmark,
  faVialVirus,
  faBookBlank,
  faBookAlt,
  faGolfFlagHole,
  faMessageArrowDown,
  faCommentAltArrowDown,
  faFaceUnamused,
  faSheetPlastic,
  faCircle9,
  faBlog,
  faUserNinja,
  faPencilSlash,
  faBowlingPins,
  faPersonArrowUpFromLine,
  faDownRight,
  faScrollTorah,
  faTorah,
  faWebhook,
  faBlindsOpen,
  faFence,
  faUp,
  faArrowAltUp,
  faBroomBall,
  faQuidditch,
  faQuidditchBroomBall,
  faDrumstick,
  faSquareV,
  faFaceAwesome,
  faGaveDandy,
  faDialOff,
  faToggleOff,
  faFaceSmileHorns,
  faBoxArchive,
  faArchive,
  faGrapes,
  faPersonDrowning,
  faDialMax,
  faCircleM,
  faCalendarImage,
  faCircleCaretDown,
  faCaretCircleDown,
  faArrowDown91,
  faSortNumericDesc,
  faSortNumericDownAlt,
  faFaceGrinTongueSquint,
  faGrinTongueSquint,
  faShishKebab,
  faSprayCan,
  faAlarmSnooze,
  faScarecrow,
  faTruckMonster,
  faGiftCard,
  faW,
  faCodePullRequestDraft,
  faSquareB,
  faElephant,
  faEarthAfrica,
  faGlobeAfrica,
  faRainbow,
  faCircleNotch,
  faTabletScreenButton,
  faTabletAlt,
  faPaw,
  faMessageQuestion,
  faCloud,
  faTrowelBricks,
  faSquare3,
  faFaceFlushed,
  faFlushed,
  faHospitalUser,
  faMicrowave,
  faChfSign,
  faTentArrowLeftRight,
  faCartCircleArrowUp,
  faTrashClock,
  faReflectBoth,
  faGavel,
  faLegal,
  faSprinklerCeiling,
  faBrowsers,
  faTrillium,
  faTableCellsUnlock,
  faMusicSlash,
  faTruckRamp,
  faBinoculars,
  faMicrophoneSlash,
  faBoxTissue,
  faCircleC,
  faStarChristmas,
  faChartBullet,
  faMotorcycle,
  faTreeChristmas,
  faTireFlat,
  faSunglasses,
  faBadge,
  faMessagePen,
  faCommentAltEdit,
  faMessageEdit,
  faBellConcierge,
  faConciergeBell,
  faPenRuler,
  faPencilRuler,
  faFileMp3,
  faArrowProgress,
  faChessRookPiece,
  faChessRookAlt,
  faSquareRoot,
  faAlbumCollectionCirclePlus,
  faPeopleArrows,
  faPeopleArrowsLeftRight,
  faSignPost,
  faFaceAngryHorns,
  faMarsAndVenusBurst,
  faTombstone,
  faSquareCaretRight,
  faCaretSquareRight,
  faScissors,
  faCut,
  faListMusic,
  faSunPlantWilt,
  faToiletsPortable,
  faHockeyPuck,
  faMustache,
  faHyphen,
  faTable,
  faUserChef,
  faMessageImage,
  faCommentAltImage,
  faUsersMedical,
  faSensorTriangleExclamation,
  faSensorAlert,
  faMagnifyingGlassArrowRight,
  faTachographDigital,
  faDigitalTachograph,
  faFaceMask,
  faPickleball,
  faStarSharpHalf,
  faUsersSlash,
  faClover,
  faMeat,
  faReply,
  faMailReply,
  faStarAndCrescent,
  faEmptySet,
  faHouseFire,
  faSquareMinus,
  faMinusSquare,
  faHelicopter,
  faBird,
  faCompass,
  faSquareCaretDown,
  faCaretSquareDown,
  faHeartHalfStroke,
  faHeartHalfAlt,
  faFileCircleQuestion,
  faTruckUtensils,
  faLaptopCode,
  faJoystick,
  faGrillFire,
  faRectangleVerticalHistory,
  faSwatchbook,
  faPrescriptionBottle,
  faBars,
  faNavicon,
  faKeyboardLeft,
  faPeopleGroup,
  faHourglassEnd,
  faHourglass3,
  faHeartCrack,
  faHeartBroken,
  faFaceBeamHandOverMouth,
  faDropletPercent,
  faHumidity,
  faSquareUpRight,
  faExternalLinkSquareAlt,
  faFaceKissBeam,
  faKissBeam,
  faCorn,
  faRollerCoaster,
  faPhotoFilmMusic,
  faRadar,
  faSickle,
  faFilm,
  faCoconut,
  faRulerHorizontal,
  faShieldCross,
  faCassetteTape,
  faSquareTerminal,
  faPeopleRobbery,
  faLightbulb,
  faCaretLeft,
  faCommentMiddle,
  faTrashCanList,
  faBlock,
  faCircleExclamation,
  faExclamationCircle,
  faSchoolCircleXmark,
  faArrowRightFromBracket,
  faSignOut,
  faFaceFrownSlight,
  faCircleChevronDown,
  faChevronCircleDown,
  faSidebarFlip,
  faUnlockKeyhole,
  faUnlockAlt,
  faTemperatureList,
  faCloudShowersHeavy,
  faHeadphonesSimple,
  faHeadphonesAlt,
  faSitemap,
  faPipeSection,
  faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt,
  faCircleDollarToSlot,
  faDonate,
  faMemory,
  faFaceSleeping,
  faRoadSpikes,
  faFireBurner,
  faSquirrel,
  faArrowUpToLine,
  faArrowToTop,
  faFlag,
  faFaceCowboyHat,
  faHanukiah,
  faChartScatter3d,
  faDisplayChartUp,
  faSquareCode,
  faFeather,
  faVolumeLow,
  faVolumeDown,
  faXmarkToSlot,
  faTimesToSlot,
  faVoteNay,
  faBoxTaped,
  faBoxAlt,
  faCommentSlash,
  faSwords,
  faCloudSunRain,
  faAlbum,
  faCircleN,
  faCompress,
  faWheatAwn,
  faWheatAlt,
  faAnkh,
  faHandsHoldingChild,
  faAsterisk,
  faKeySkeletonLeftRight,
  faCommentLines,
  faLuchadorMask,
  faLuchador,
  faMaskLuchador,
  faSquareCheck,
  faCheckSquare,
  faShredder,
  faBookOpenCover,
  faBookOpenAlt,
  faSandwich,
  faPesetaSign,
  faSquareParkingSlash,
  faParkingSlash,
  faTrainTunnel,
  faHeading,
  faHeader,
  faGhost,
  faFaceAnguished,
  faHockeySticks,
  faAbacus,
  faFilmSimple,
  faFilmAlt,
  faList,
  faListSquares,
  faTreePalm,
  faSquarePhoneFlip,
  faPhoneSquareAlt,
  faUserBeardBolt,
  faCartPlus,
  faGamepad,
  faBorderCenterV,
  faCircleDot,
  faDotCircle,
  faClipboardMedical,
  faFaceDizzy,
  faDizzy,
  faEgg,
  faUpToLine,
  faArrowAltToTop,
  faHouseMedicalCircleXmark,
  faWatchFitness,
  faClockNineThirty,
  faCampground,
  faFolderPlus,
  faJug,
  faFutbol,
  faFutbolBall,
  faSoccerBall,
  faSnowBlowing,
  faPaintbrush,
  faPaintBrush,
  faLock,
  faArrowDownFromLine,
  faArrowFromTop,
  faGasPump,
  faSignalBarsSlash,
  faSignalAltSlash,
  faMonkey,
  faRectanglePro,
  faPro,
  faHouseNight,
  faHotTubPerson,
  faHotTub,
  faGlobePointer,
  faBlanket,
  faMapLocation,
  faMapMarked,
  faHouseFloodWater,
  faCommentsQuestionCheck,
  faTree,
  faArrowsCross,
  faBackpack,
  faSquareSmall,
  faFolderArrowUp,
  faFolderUpload,
  faBridgeLock,
  faCrosshairsSimple,
  faSackDollar,
  faPenToSquare,
  faEdit,
  faSquareSliders,
  faSlidersHSquare,
  faCarSide,
  faMessageMiddleTop,
  faCommentMiddleTopAlt,
  faLightbulbOn,
  faKnife,
  faUtensilKnife,
  faShareNodes,
  faShareAlt,
  faDisplayChartUpCircleDollar,
  faWaveSine,
  faHeartCircleMinus,
  faCircleW,
  faCircleCalendar,
  faCalendarCircle,
  faHourglassHalf,
  faHourglass2,
  faMicroscope,
  faSunset,
  faSink,
  faCalendarExclamation,
  faTruckContainerEmpty,
  faHandHeart,
  faBagShopping,
  faShoppingBag,
  faArrowDownZA,
  faSortAlphaDesc,
  faSortAlphaDownAlt,
  faMitten,
  faReplyClock,
  faReplyTime,
  faPersonRays,
  faRight,
  faArrowAltRight,
  faCircleF,
  faUsers,
  faFacePleading,
  faEyeSlash,
  faFlaskVial,
  faPoliceBox,
  faCucumber,
  faHeadSideBrain,
  faHand,
  faHandPaper,
  faPersonBikingMountain,
  faBikingMountain,
  faUtensilsSlash,
  faPrintMagnifyingGlass,
  faPrintSearch,
  faTurnRight,
  faFolderBookmark,
  faArrowTurnLeftDown,
  faOm,
  faPi,
  faFlaskRoundPotion,
  faFlaskPotion,
  faFaceShush,
  faWorm,
  faHouseCircleXmark,
  faPlug,
  faCalendarCircleExclamation,
  faSquareI,
  faChevronUp,
  faFaceSaluting,
  faGaugeSimpleLow,
  faTachometerSlow,
  faFacePersevering,
  faCircleCamera,
  faCameraCircle,
  faHandSpock,
  faSpiderWeb,
  faCircleMicrophone,
  faMicrophoneCircle,
  faBookArrowUp,
  faPopsicle,
  faCommand,
  faBlinds,
  faStopwatch,
  faSaxophone,
  faSquare2,
  faFieldHockeyStickBall,
  faFieldHockey,
  faArrowUpSquareTriangle,
  faSortShapesUpAlt,
  faFaceScream,
  faSquareM,
  faCameraWeb,
  faWebcam,
  faCommentArrowDown,
  faLightbulbCfl,
  faWindowFrameOpen,
  faFaceKiss,
  faKiss,
  faBridgeCircleXmark,
  faPeriod,
  faFaceGrinTongue,
  faGrinTongue,
  faUpToDottedLine,
  faThoughtBubble,
  faSkeletonRibs,
  faRaygun,
  faFlute,
  faAcorn,
  faVideoArrowUpRight,
  faGrateDroplet,
  faSealExclamation,
  faChessBishop,
  faMessageSms,
  faCoffeeBeans,
  faHatWitch,
  faFaceGrinWink,
  faGrinWink,
  faClockThreeThirty,
  faEarDeaf,
  faDeaf,
  faDeafness,
  faHardOfHearing,
  faAlarmClock,
  faEclipse,
  faFaceRelieved,
  faRoadCircleCheck,
  faDiceFive,
  faOctagonMinus,
  faMinusOctagon,
  faSquareRss,
  faRssSquare,
  faFaceZany,
  faTricycle,
  faLandMineOn,
  faSquareArrowUpLeft,
  faICursor,
  faChartMixedUpCircleDollar,
  faSaltShaker,
  faStamp,
  faFilePlus,
  faDrawSquare,
  faToiletPaperUnderSlash,
  faToiletPaperReverseSlash,
  faStairs,
  faDroneFront,
  faDroneAlt,
  faGlassEmpty,
  faDialHigh,
  faUserHelmetSafety,
  faUserConstruction,
  faUserHardHat,
  faI,
  faHryvniaSign,
  faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter,
  faPills,
  faFaceGrinWide,
  faGrinAlt,
  faTooth,
  faBasketballHoop,
  faObjectsAlignBottom,
  faV,
  faSparkles,
  faSquid,
  faLeafyGreen,
  faCircleArrowUpRight,
  faCalendars,
  faBangladeshiTakaSign,
  faBicycle,
  faHammerWar,
  faCircleD,
  faSpiderBlackWidow,
  faStaffSnake,
  faRodAsclepius,
  faRodSnake,
  faStaffAesculapius,
  faPear,
  faHeadSideCoughSlash,
  faFileMov,
  faTriangle,
  faApartment,
  faTruckMedical,
  faAmbulance,
  faPepper,
  faPiano,
  faGunSquirt,
  faWheatAwnCircleExclamation,
  faSnowman,
  faUserAlien,
  faShieldCheck,
  faMortarPestle,
  faRoadBarrier,
  faChartCandlestick,
  faBriefcaseBlank,
  faSchool,
  faIgloo,
  faBracketRound,
  faParenthesis,
  faJoint,
  faHorseSaddle,
  faMugMarshmallows,
  faFilters,
  faBellOn,
  faAngleRight,
  faDialMed,
  faHorse,
  faQ,
  faMonitorWaveform,
  faMonitorHeartRate,
  faLinkSimple,
  faWhistle,
  faG,
  faWineGlassCrack,
  faFragile,
  faSlotMachine,
  faNotesMedical,
  faCarWash,
  faEscalator,
  faCommentImage,
  faTemperatureHalf,
  faTemperature2,
  faThermometer2,
  faThermometerHalf,
  faDongSign,
  faDonut,
  faDoughnut,
  faCapsules,
  faPooStorm,
  faPooBolt,
  faTally1,
  faFileVector,
  faFaceFrownOpen,
  faFrownOpen,
  faSquareDashed,
  faBagShoppingPlus,
  faSquareJ,
  faHandPointUp,
  faMoneyBill,
  faArrowUpBigSmall,
  faSortSizeUp,
  faBarcodeRead,
  faBaguette,
  faBowlSoftServe,
  faFaceHoldingBackTears,
  faSquareUp,
  faArrowAltSquareUp,
  faTrainSubwayTunnel,
  faSubwayTunnel,
  faSquareExclamation,
  faExclamationSquare,
  faSemicolon,
  faBookmark,
  faFanTable,
  faAlignJustify,
  faBatteryLow,
  faBattery1,
  faCreditCardFront,
  faBrainArrowCurvedRight,
  faMindShare,
  faUmbrellaBeach,
  faHelmetUn,
  faLocationSmile,
  faMapMarkerSmile,
  faArrowLeftToLine,
  faArrowToLeft,
  faBullseye,
  faSushi,
  faNigiri,
  faMessageCaptions,
  faCommentAltCaptions,
  faTrashList,
  faBacon,
  faOption,
  faRaccoon,
  faHandPointDown,
  faArrowUpFromBracket,
  faHeadSideGear,
  faTrashPlus,
  faFileCad,
  faObjectsAlignTop,
  faFolder,
  faFolderBlank,
  faFaceAnxiousSweat,
  faCreditCardBlank,
  faFileWaveform,
  faFileMedicalAlt,
  faMicrochipAi,
  faMug,
  faPlaneUpSlash,
  faRadiation,
  faPenCircle,
  faBagSeedling,
  faChartSimple,
  faCrutches,
  faCircleParking,
  faParkingCircle,
  faMarsStroke,
  faLeafOak,
  faSquareBolt,
  faVial,
  faGauge,
  faDashboard,
  faGaugeMed,
  faTachometerAltAverage,
  faWandMagicSparkles,
  faMagicWandSparkles,
  faLambda,
  faE,
  faPizza,
  faBowlChopsticksNoodles,
  faH3,
  faPenClip,
  faPenAlt,
  faBridgeCircleExclamation,
  faBadgePercent,
  faRotateReverse,
  faUser,
  faSensor,
  faComma,
  faSchoolCircleCheck,
  faToiletPaperUnder,
  faToiletPaperReverse,
  faLightEmergency,
  faArrowDownToArc,
  faDumpster,
  faVanShuttle,
  faShuttleVan,
  faBuildingUser,
  faLightSwitch,
  faSquareCaretLeft,
  faCaretSquareLeft,
  faHighlighter,
  faWavePulse,
  faHeartRate,
  faKey,
  faArrowLeftToBracket,
  faHatSanta,
  faTamale,
  faBoxCheck,
  faBullhorn,
  faSteak,
  faLocationCrosshairsSlash,
  faLocationSlash,
  faPersonDolly,
  faGlobe,
  faSynagogue,
  faFileChartColumn,
  faFileChartLine,
  faPersonHalfDress,
  faFolderImage,
  faCalendarPen,
  faCalendarEdit,
  faRoadBridge,
  faFaceSmileTear,
  faMessagePlus,
  faCommentAltPlus,
  faLocationArrow,
  faC,
  faTabletButton,
  faPersonDressFairy,
  faRectangleHistoryCircleUser,
  faBuildingLock,
  faChartLineUp,
  faMailbox,
  faSignPosts,
  faTruckBolt,
  faPizzaSlice,
  faMoneyBillWave,
  faChartArea,
  faAreaChart,
  faHouseFlag,
  faCircleThreeQuartersStroke,
  faPersonCircleMinus,
  faScalpel,
  faBan,
  faCancel,
  faBellExclamation,
  faCircleBookmark,
  faBookmarkCircle,
  faEggFried,
  faFaceWeary,
  faUniformMartialArts,
  faCameraRotate,
  faSunDust,
  faCommentText,
  faSprayCanSparkles,
  faAirFreshener,
  faSignalBars,
  faSignalAlt,
  faSignalAlt4,
  faSignalBarsStrong,
  faDiamondExclamation,
  faStar,
  faDialMin,
  faRepeat,
  faCross,
  faPageCaretDown,
  faFileCaretDown,
  faBox,
  faVenusMars,
  faClockSevenThirty,
  faArrowPointer,
  faMousePointer,
  faClockFourThirty,
  faSignalBarsGood,
  faSignalAlt3,
  faCactus,
  faLightbulbGear,
  faMaximize,
  faExpandArrowsAlt,
  faChargingStation,
  faShapes,
  faTriangleCircleSquare,
  faPlaneTail,
  faGaugeSimpleMax,
  faTachometerFastest,
  faCircleU,
  faShieldSlash,
  faSquarePhoneHangup,
  faPhoneSquareDown,
  faArrowUpLeft,
  faTransporter1,
  faPeanuts,
  faShuffle,
  faRandom,
  faPersonRunning,
  faRunning,
  faMobileRetro,
  faGripLinesVertical,
  faBinBottlesRecycle,
  faArrowUpFromSquare,
  faFileDashedLine,
  faPageBreak,
  faBracketCurlyRight,
  faSpider,
  faClockThree,
  faHandsBound,
  faScalpelLineDashed,
  faScalpelPath,
  faFileInvoiceDollar,
  faPipeSmoking,
  faFaceAstonished,
  faWindow,
  faPlaneCircleExclamation,
  faEar,
  faFileLock,
  faDiagramVenn,
  faArrowDownFromBracket,
  faXRay,
  faGoalNet,
  faCoffinCross,
  faOctopus,
  faSpellCheck,
  faLocationXmark,
  faMapMarkerTimes,
  faMapMarkerXmark,
  faCircleQuarterStroke,
  faLasso,
  faSlash,
  faPersonToPortal,
  faPortalEnter,
  faCalendarStar,
  faComputerMouse,
  faMouse,
  faArrowRightToBracket,
  faSignIn,
  faPegasus,
  faFilesMedical,
  faCannon,
  faNfcLock,
  faPersonSkiLift,
  faSkiLift,
  faSquare6,
  faShopSlash,
  faStoreAltSlash,
  faWindTurbine,
  faSlidersSimple,
  faGridRound,
  faBadgeSheriff,
  faServer,
  faVirusCovidSlash,
  faIntersection,
  faShopLock,
  faFamily,
  faHourglassStart,
  faHourglass1,
  faUserHairBuns,
  faBlenderPhone,
  faHourglassClock,
  faPersonSeatReclined,
  faPaperPlaneTop,
  faPaperPlaneAlt,
  faSend,
  faMessageArrowUp,
  faCommentAltArrowUp,
  faLightbulbExclamation,
  faLayerMinus,
  faLayerGroupMinus,
  faChartPieSimpleCircleCurrency,
  faCircleE,
  faBuildingWheat,
  faGaugeMax,
  faTachometerAltFastest,
  faPersonBreastfeeding,
  faApostrophe,
  faFilePng,
  faFireHydrant,
  faRightToBracket,
  faSignInAlt,
  faVideoPlus,
  faSquareRight,
  faArrowAltSquareRight,
  faCommentSmile,
  faVenus,
  faPassport,
  faThumbtackSlash,
  faThumbTackSlash,
  faInboxIn,
  faInboxArrowDown,
  faHeartPulse,
  faHeartbeat,
  faCircle8,
  faCloudsMoon,
  faClockTenThirty,
  faPeopleCarryBox,
  faPeopleCarry,
  faFolderUser,
  faTrashCanXmark,
  faTemperatureHigh,
  faMicrochip,
  faLeftLongToLine,
  faCrown,
  faWeightHanging,
  faXmarksLines,
  faFilePrescription,
  faTableCellsLock,
  faCalendarRange,
  faFlowerDaffodil,
  faHandBackPointUp,
  faWeightScale,
  faWeight,
  faArrowUpToArc,
  faStarExclamation,
  faBooks,
  faUserGroup,
  faUserFriends,
  faArrowUpAZ,
  faSortAlphaUp,
  faLayerPlus,
  faLayerGroupPlus,
  faPlayPause,
  faBlockQuestion,
  faSnooze,
  faZzz,
  faScannerImage,
  faTvRetro,
  faSquareT,
  faFarm,
  faBarnSilo,
  faChessKnight,
  faBarsSort,
  faPalletBoxes,
  faPaletteBoxes,
  faPalletAlt,
  faFaceLaughSquint,
  faLaughSquint,
  faCodeSimple,
  faBoltSlash,
  faPanelFire,
  faBinaryCircleCheck,
  faCommentMinus,
  faBurrito,
  faViolin,
  faObjectsColumn,
  faSquareChevronDown,
  faChevronSquareDown,
  faCommentPlus,
  faTriangleInstrument,
  faTriangleMusic,
  faWheelchair,
  faUserPilotTie,
  faPianoKeyboard,
  faBedEmpty,
  faCircleArrowUp,
  faArrowCircleUp,
  faToggleOn,
  faRectangleVertical,
  faRectanglePortrait,
  faPersonWalking,
  faWalking,
  faL,
  faSignalStream,
  faDownToBracket,
  faCircleZ,
  faStars,
  faFire,
  faBedPulse,
  faProcedures,
  faHouseDay,
  faShuttleSpace,
  faSpaceShuttle,
  faShirtLongSleeve,
  faChartPieSimple,
  faChartPieAlt,
  faFaceLaugh,
  faLaugh,
  faFolderOpen,
  faAlbumCollectionCircleUser,
  faCandy,
  faBowlHot,
  faSoup,
  faFlatbread,
  faHeartCirclePlus,
  faCodeFork,
  faCity,
  faSignalBarsWeak,
  faSignalAlt1,
  faMicrophoneLines,
  faMicrophoneAlt,
  faClockTwelve,
  faPepperHot,
  faCitrusSlice,
  faSheep,
  faUnlock,
  faColonSign,
  faHeadset,
  faBadgerHoney,
  faH4,
  faStoreSlash,
  faRoadCircleXmark,
  faSignalSlash,
  faUserMinus,
  faMarsStrokeUp,
  faMarsStrokeV,
  faChampagneGlasses,
  faGlassCheers,
  faTaco,
  faHexagonPlus,
  faPlusHexagon,
  faClipboard,
  faHouseCircleExclamation,
  faFileArrowUp,
  faFileUpload,
  faWifi,
  faWifi3,
  faWifiStrong,
  faMessages,
  faCommentsAlt,
  faBath,
  faBathtub,
  faUmbrellaSimple,
  faUmbrellaAlt,
  faRectangleHistoryCirclePlus,
  faUnderline,
  faPrescriptionBottlePill,
  faUserPen,
  faUserEdit,
  faBinarySlash,
  faSquareO,
  faCaduceus,
  faSignature,
  faStroopwafel,
  faBold,
  faAnchorLock,
  faBuildingNgo,
  faTransporter3,
  faEngineWarning,
  faEngineExclamation,
  faCircleDownRight,
  faSquareK,
  faManatSign,
  faMoneyCheckPen,
  faMoneyCheckEdit,
  faNotEqual,
  faBorderTopLeft,
  faBorderStyle,
  faMapLocationDot,
  faMapMarkedAlt,
  faTilde,
  faJedi,
  faSquarePollVertical,
  faPoll,
  faArrowDownSquareTriangle,
  faSortShapesDownAlt,
  faMugHot,
  faDogLeashed,
  faCarBattery,
  faBatteryCar,
  faFaceDowncastSweat,
  faMailboxFlagUp,
  faMemoCircleInfo,
  faGift,
  faDiceTwo,
  faVolume,
  faVolumeMedium,
  faTransporter5,
  faGaugeCircleBolt,
  faCoinFront,
  faFileSlash,
  faMessageArrowUpRight,
  faTreasureChest,
  faChessQueen,
  faPaintbrushFine,
  faPaintBrushAlt,
  faPaintBrushFine,
  faPaintbrushAlt,
  faGlasses,
  faHoodCloak,
  faSquareQuote,
  faUpLeft,
  faBringFront,
  faChessBoard,
  faBurgerCheese,
  faCheeseburger,
  faBuildingCircleCheck,
  faRepeat1,
  faArrowDownToLine,
  faArrowToBottom,
  faGrid5,
  faSwapArrows,
  faRightLongToLine,
  faPersonChalkboard,
  faMarsStrokeRight,
  faMarsStrokeH,
  faHandBackFist,
  faHandRock,
  faGridRound5,
  faTally,
  faTally5,
  faSquareCaretUp,
  faCaretSquareUp,
  faCloudShowersWater,
  faChartBar,
  faBarChart,
  faHandsBubbles,
  faHandsWash,
  faLessThanEqual,
  faTrain,
  faUpFromDottedLine,
  faEyeLowVision,
  faLowVision,
  faTrafficLightGo,
  faFaceExhaling,
  faSensorFire,
  faUserUnlock,
  faHexagonDivide,
  fa00,
  faCrow,
  faCassetteBetamax,
  faBetamax,
  faSailboat,
  faWindowRestore,
  faNfcMagnifyingGlass,
  faFileBinary,
  faCircleV,
  faSquarePlus,
  faPlusSquare,
  faBowlScoops,
  faMistletoe,
  faCustard,
  faLacrosseStick,
  faHockeyMask,
  faSunrise,
  faSubtitles,
  faPanelEws,
  faToriiGate,
  faCloudExclamation,
  faMessageLines,
  faCommentAltLines,
  faFrog,
  faBucket,
  faFloppyDiskPen,
  faImage,
  faWindowFrame,
  faMicrophone,
  faCow,
  faFileZip,
  faSquareRing,
  faDownFromLine,
  faArrowAltFromTop,
  faCaretUp,
  faShieldXmark,
  faShieldTimes,
  faScrewdriver,
  faCircleSortDown,
  faSortCircleDown,
  faFolderClosed,
  faHouseTsunami,
  faSquareNfi,
  faForklift,
  faArrowUpFromGroundWater,
  faBracketSquareRight,
  faMartiniGlass,
  faGlassMartiniAlt,
  faSquareBinary,
  faRotateLeft,
  faRotateBack,
  faRotateBackward,
  faUndoAlt,
  faTableColumns,
  faColumns,
  faSquareA,
  faTick,
  faLemon,
  faHeadSideMask,
  faHandshake,
  faGem,
  faDolly,
  faDollyBox,
  faSmoking,
  faMinimize,
  faCompressArrowsAlt,
  faRefrigerator,
  faMonument,
  faOctagonXmark,
  faTimesOctagon,
  faXmarkOctagon,
  faAlignSlash,
  faSnowplow,
  faAnglesRight,
  faAngleDoubleRight,
  faTruckRampCouch,
  faTruckCouch,
  faCannabis,
  faCirclePlay,
  faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faLocationArrowUp,
  faTablets,
  fa360Degrees,
  faEthernet,
  faEuroSign,
  faEur,
  faEuro,
  faChair,
  faCircleCheck,
  faCheckCircle,
  faSquareDashedCirclePlus,
  faHandHoldingCircleDollar,
  faMoneySimpleFromBracket,
  faBat,
  faCircleStop,
  faStopCircle,
  faHeadSideHeadphones,
  faPhoneRotary,
  faArrowUpToBracket,
  faCompassDrafting,
  faDraftingCompass,
  faPlateWheat,
  faCalendarCircleMinus,
  faChopsticks,
  faCarWrench,
  faCarMechanic,
  faIcicles,
  faPersonShelter,
  faNeuter,
  faIdBadge,
  faKazoo,
  faMarker,
  faBinBottles,
  faFaceLaughBeam,
  faLaughBeam,
  faSquareArrowDownLeft,
  faBatteryBolt,
  faTreeLarge,
  faHelicopterSymbol,
  faAperture,
  faUniversalAccess,
  faGearComplex,
  faFileMagnifyingGlass,
  faFileSearch,
  faUpRight,
  faCircleChevronUp,
  faChevronCircleUp,
  faUserPolice,
  faLariSign,
  faVolcano,
  faTeddyBear,
  faStocking,
  faPersonWalkingDashedLineArrowRight,
  faImageSlash,
  faMaskSnorkel,
  faSmoke,
  faSterlingSign,
  faGbp,
  faPoundSign,
  faBatteryExclamation,
  faViruses,
  faSquarePersonConfined,
  faUserTie,
  faUpToBracket,
  faArrowDownLong,
  faLongArrowDown,
  faTentArrowDownToLine,
  faCertificate,
  faCrystalBall,
  faReplyAll,
  faMailReplyAll,
  faSuitcase,
  faPersonSkating,
  faSkating,
  faStarShooting,
  faBinaryLock,
  faFilterCircleDollar,
  faFunnelDollar,
  faCameraRetro,
  faCircleArrowDown,
  faArrowCircleDown,
  faCommentPen,
  faCommentEdit,
  faFileImport,
  faArrowRightToFile,
  faBanjo,
  faSquareArrowUpRight,
  faExternalLinkSquare,
  faLightEmergencyOn,
  faKerning,
  faBoxOpen,
  faSquareF,
  faScroll,
  faSpa,
  faArrowLeftFromLine,
  faArrowFromRight,
  faStrawberry,
  faLocationPinLock,
  faPause,
  faClockEightThirty,
  faPlaneEngines,
  faPlaneAlt,
  faHillAvalanche,
  faTemperatureEmpty,
  faTemperature0,
  faThermometer0,
  faThermometerEmpty,
  faBomb,
  faGaugeLow,
  faTachometerAltSlow,
  faRegistered,
  faTrashCanPlus,
  faAddressCard,
  faContactCard,
  faVcard,
  faChartFft,
  faScaleUnbalancedFlip,
  faBalanceScaleRight,
  faGlobeSnow,
  faSubscript,
  faDiamondTurnRight,
  faDirections,
  faIntegral,
  faBurst,
  faHouseLaptop,
  faLaptopHouse,
  faFaceTired,
  faTired,
  faMoneyBills,
  faBlindsRaised,
  faSmog,
  faUfoBeam,
  faHydra,
  faCircleCaretUp,
  faCaretCircleUp,
  faUserVneckHairLong,
  faSquareALock,
  faCrutch,
  faGasPumpSlash,
  faFontAwesome,
  faFontAwesomeFlag,
  faFontAwesomeLogoFull,
  faCloudArrowUp,
  faCloudUpload,
  faCloudUploadAlt,
  faPalette,
  faTransporter4,
  faChartMixedUpCircleCurrency,
  faObjectsAlignRight,
  faArrowsTurnRight,
  faVest,
  faPig,
  faInboxFull,
  faCircleEnvelope,
  faEnvelopeCircle,
  faTrianglePersonDigging,
  faConstruction,
  faFerry,
  faBullseyeArrow,
  faArrowsDownToPeople,
  faSeedling,
  faSprout,
  faClockSeven,
  faLeftRight,
  faArrowsAltH,
  faBoxesPacking,
  faCircleArrowLeft,
  faArrowCircleLeft,
  faFlashlight,
  faFileJpg,
  faGroupArrowsRotate,
  faBowlFood,
  faSquare9,
  faCandyCane,
  faArrowDownWideShort,
  faSortAmountAsc,
  faSortAmountDown,
  faSquareDollar,
  faDollarSquare,
  faUsdSquare,
  faPhoneArrowRight,
  faHandHoldingSeedling,
  faMessageCheck,
  faCommentAltCheck,
  faCloudBolt,
  faThunderstorm,
  faChartLineUpDown,
  faTextSlash,
  faRemoveFormat,
  faWatch,
  faCircleDownLeft,
  faText,
  faProjector,
  faFaceSmileWink,
  faSmileWink,
  faTombstoneBlank,
  faTombstoneAlt,
  faChessKingPiece,
  faChessKingAlt,
  faCircle6,
  faWavesSine,
  faLeft,
  faArrowAltLeft,
  faFileWord,
  faFilePowerpoint,
  faSquareDown,
  faArrowAltSquareDown,
  faObjectsAlignCenterVertical,
  faArrowsLeftRight,
  faArrowsH,
  faHouseLock,
  faCloudArrowDown,
  faCloudDownload,
  faCloudDownloadAlt,
  faWreath,
  faChildren,
  faMeterDroplet,
  faChalkboard,
  faBlackboard,
  faUserLargeSlash,
  faUserAltSlash,
  faSignalStrong,
  faSignal4,
  faLollipop,
  faLollypop,
  faListTree,
  faEnvelopeOpen,
  faDrawCircle,
  faCatSpace,
  faHandshakeSimpleSlash,
  faHandshakeAltSlash,
  faRabbitRunning,
  faRabbitFast,
  faMemoPad,
  faMattressPillow,
  faAlarmPlus,
  faAlicorn,
  faCommentQuestion,
  faGingerbreadMan,
  faGuaraniSign,
  faBurgerFries,
  faMugTea,
  faBorderTop,
  faArrowsRotate,
  faRefresh,
  faSync,
  faCircleBookOpen,
  faBookCircle,
  faArrowsToDottedLine,
  faFireExtinguisher,
  faMagnifyingGlassArrowsRotate,
  faGarageOpen,
  faShelvesEmpty,
  faCruzeiroSign,
  faWatchApple,
  faWatchCalculator,
  faListDropdown,
  faCabinetFiling,
  faBurgerSoda,
  faSquareArrowUp,
  faArrowSquareUp,
  faGreaterThanEqual,
  faPalletBox,
  faFaceConfounded,
  faShieldHalved,
  faShieldAlt,
  faTruckPlow,
  faBookAtlas,
  faAtlas,
  faVirus,
  faGridRound2,
  faCommentMiddleTop,
  faWave,
  faEnvelopeCircleCheck,
  faLayerGroup,
  faRestroomSimple,
  faArrowsToDot,
  faBorderOuter,
  faHashtagLock,
  faClockTwoThirty,
  faArchway,
  faHeartCircleCheck,
  faHouseChimneyCrack,
  faHouseDamage,
  faFileZipper,
  faFileArchive,
  faTicketPerforated,
  faHeartHalf,
  faCommentCheck,
  faSquare,
  faMemo,
  faMartiniGlassEmpty,
  faGlassMartini,
  faCouch,
  faCediSign,
  faItalic,
  faGlassCitrus,
  faCalendarLinesPen,
  faTableCellsColumnLock,
  faChurch,
  faPersonSnowmobiling,
  faSnowmobile,
  faFaceHushed,
  faCommentsDollar,
  faTicketsSimple,
  faPickaxe,
  faLinkSimpleSlash,
  faDemocrat,
  faFaceConfused,
  faPinball,
  faZ,
  faPersonSkiing,
  faSkiing,
  faDeer,
  faInputPipe,
  faRoadLock,
  faA,
  faBookmarkSlash,
  faTemperatureArrowDown,
  faTemperatureDown,
  faMace,
  faFeatherPointed,
  faFeatherAlt,
  faSausage,
  faTrashCanClock,
  faP,
  faBroomWide,
  faSnowflake,
  faStomach,
  faNewspaper,
  faRectangleAd,
  faAd,
  faGuitarElectric,
  faArrowTurnDownRight,
  faMoonCloud,
  faBreadSliceButter,
  faCircleArrowRight,
  faArrowCircleRight,
  faUserGroupCrown,
  faUsersCrown,
  faCircleI,
  faToiletPaperCheck,
  faFilterCircleXmark,
  faLocust,
  faSort,
  faUnsorted,
  faListOl,
  faList12,
  faListNumeric,
  faChartWaterfall,
  faSparkle,
  faFaceParty,
  faKidneys,
  faWifiExclamation,
  faChartNetwork,
  faPersonDressBurst,
  faDiceD4,
  faMoneyCheckDollar,
  faMoneyCheckAlt,
  faVectorSquare,
  faBreadSlice,
  faLanguage,
  faWheatAwnSlash,
  faFaceKissWinkHeart,
  faKissWinkHeart,
  faDagger,
  faPodium,
  faDiamonds4,
  faMemoCircleCheck,
  faRouteHighway,
  faDownToLine,
  faArrowAltToBottom,
  faFilter,
  faSquareG,
  faCirclePhone,
  faPhoneCircle,
  faClipboardPrescription,
  faUserNurseHair,
  faQuestion,
  faFileSignature,
  faToggleLargeOn,
  faUpDownLeftRight,
  faArrowsAlt,
  faDryerHeat,
  faDryerAlt,
  faHouseChimneyUser,
  faHandHoldingHeart,
  faArrowUpSmallBig,
  faSortSizeUpAlt,
  faTrainTrack,
  faPuzzlePiece,
  faMoneyCheck,
  faStarHalfStroke,
  faStarHalfAlt,
  faFileExclamation,
  faCode,
  faWhiskeyGlass,
  faGlassWhiskey,
  faMoonStars,
  faBuildingCircleExclamation,
  faClothesHanger,
  faMobileNotch,
  faMobileIphone,
  faMagnifyingGlassChart,
  faArrowUpRightFromSquare,
  faExternalLink,
  faCubesStacked,
  faImagesUser,
  faWonSign,
  faKrw,
  faWon,
  faImagePolaroidUser,
  faVirusCovid,
  faSquareEllipsis,
  faPie,
  faChessKnightPiece,
  faChessKnightAlt,
  faAustralSign,
  faCloudPlus,
  faF,
  faLeaf,
  faBedBunk,
  faRoad,
  faTaxi,
  faCab,
  faPersonCirclePlus,
  faChartPie,
  faPieChart,
  faBoltLightning,
  faClockEight,
  faSackXmark,
  faFileXls,
  faFileExcel,
  faFileContract,
  faFishFins,
  faCircleQ,
  faBuildingFlag,
  faFaceGrinBeam,
  faGrinBeam,
  faObjectUngroup,
  faFaceDisguise,
  faCircleArrowDownRight,
  faAlien8bit,
  faAlienMonster,
  faHandPointRibbon,
  faPoop,
  faObjectExclude,
  faTelescope,
  faLocationPin,
  faMapMarker,
  faSquareList,
  faKaaba,
  faToiletPaper,
  faHelmetSafety,
  faHardHat,
  faHatHard,
  faCommentCode,
  faSimCards,
  faStarship,
  faEject,
  faCircleRight,
  faArrowAltCircleRight,
  faPlaneCircleCheck,
  faSeal,
  faUserCowboy,
  faHexagonVerticalNft,
  faFaceRollingEyes,
  faMehRollingEyes,
  faBreadLoaf,
  faRingsWedding,
  faObjectGroup,
  faFrenchFries,
  faChartLine,
  faLineChart,
  faCalendarArrowDown,
  faCalendarDownload,
  faSendBack,
  faMaskVentilator,
  faTickets,
  faSignatureLock,
  faArrowRight,
  faSignsPost,
  faMapSigns,
  faOctagonPlus,
  faPlusOctagon,
  faCashRegister,
  faPersonCircleQuestion,
  faMelonSlice,
  faSpaceStationMoon,
  faMessageSmile,
  faCommentAltSmile,
  faCupStraw,
  faLeftFromLine,
  faArrowAltFromRight,
  faH,
  faBasketShoppingSimple,
  faShoppingBasketAlt,
  faHandsHoldingHeart,
  faHandsHeart,
  faClockNine,
  faHammerBrush,
  faTarp,
  faFaceSleepy,
  faHandHorns,
  faScrewdriverWrench,
  faTools,
  faArrowsToEye,
  faCircleThreeQuarters,
  faTrophyStar,
  faTrophyAlt,
  faPlugCircleBolt,
  faFaceThermometer,
  faGridRound4,
  faSignPostsWrench,
  faShirtRunning,
  faBookCircleArrowUp,
  faFaceNauseated,
  faHeart,
  faFileChartPie,
  faMarsAndVenus,
  faHouseUser,
  faHomeUser,
  faCircleArrowDownLeft,
  faDumpsterFire,
  faHexagonMinus,
  faMinusHexagon,
  faLeftToLine,
  faArrowAltToLeft,
  faHouseCrack,
  faPawSimple,
  faPawAlt,
  faArrowLeftLongToLine,
  faBracketsRound,
  faParentheses,
  faMartiniGlassCitrus,
  faCocktail,
  faUserShakespeare,
  faArrowRightToArc,
  faFaceSurprise,
  faSurprise,
  faBottleWater,
  faCirclePause,
  faPauseCircle,
  faGaugeCirclePlus,
  faFolders,
  faAngel,
  faValueAbsolute,
  faRabbit,
  faToiletPaperSlash,
  faCircleEuro,
  faAppleWhole,
  faAppleAlt,
  faKitchenSet,
  faDiamondHalf,
  faLockKeyhole,
  faLockAlt,
  faR,
  faTemperatureQuarter,
  faTemperature1,
  faThermometer1,
  faThermometerQuarter,
  faSquareInfo,
  faInfoSquare,
  faWifiSlash,
  faToiletPaperXmark,
  faHandsHoldingDollar,
  faHandsUsd,
  faCube,
  faArrowDownTriangleSquare,
  faSortShapesDown,
  faBitcoinSign,
  faShutters,
  faShieldDog,
  faSolarPanel,
  faLockOpen,
  faTableTree,
  faHouseChimneyHeart,
  faTally3,
  faElevator,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal,
  faPollH,
  faCircle,
  faLeftToBracket,
  faCartCircleExclamation,
  faSword,
  faBackwardFast,
  faFastBackward,
  faRecycle,
  faUserAstronaut,
  faInterrobang,
  faPlaneSlash,
  faCircleDashed,
  faTrademark,
  faBasketball,
  faBasketballBall,
  faForkKnife,
  faUtensilsAlt,
  faSatelliteDish,
  faBadgeCheck,
  faCircleUp,
  faArrowAltCircleUp,
  faSlider,
  faMobileScreenButton,
  faMobileAlt,
  faClockOneThirty,
  faInboxOut,
  faInboxArrowUp,
  faCloudSlash,
  faVolumeHigh,
  faVolumeUp,
  faUsersRays,
  faWallet,
  faOctagonCheck,
  faFlatbreadStuffed,
  faClipboardCheck,
  faCartCirclePlus,
  faTruckClock,
  faShippingTimed,
  faPool8Ball,
  faFileAudio,
  faTurnDownLeft,
  faLockHashtag,
  faChartRadar,
  faStaff,
  faBurger,
  faHamburger,
  faUtilityPole,
  faTransporter6,
  faArrowTurnLeft,
  faWrench,
  faBugs,
  faVectorPolygon,
  faDiagramNested,
  faRupeeSign,
  faRupee,
  faFileImage,
  faCircleQuestion,
  faQuestionCircle,
  faTicketsPerforated,
  faImageUser,
  faBuoy,
  faPlaneDeparture,
  faHandshakeSlash,
  faBookBookmark,
  faBorderCenterH,
  faCanFood,
  faTypewriter,
  faArrowRightFromArc,
  faCircleK,
  faFaceHandOverMouth,
  faPopcorn,
  faHouseWater,
  faHouseFlood,
  faObjectSubtract,
  faCodeBranch,
  faWarehouseFull,
  faWarehouseAlt,
  faHatCowboy,
  faBridge,
  faPhoneFlip,
  faPhoneAlt,
  faArrowDownFromDottedLine,
  faFileDoc,
  faSquareQuarters,
  faTruckFront,
  faCat,
  faTrashXmark,
  faCircleCaretLeft,
  faCaretCircleLeft,
  faFiles,
  faAnchorCircleExclamation,
  faFaceClouds,
  faUserCrown,
  faBasketShoppingPlus,
  faTruckField,
  faRoute,
  faCartCircleCheck,
  faClipboardQuestion,
  faPanorama,
  faCommentMedical,
  faTeethOpen,
  faUserTieHairLong,
  faFileCircleMinus,
  faHeadSideMedical,
  faArrowTurnRight,
  faTags,
  faWineGlass,
  faForwardFast,
  faFastForward,
  faFaceMehBlank,
  faMehBlank,
  faUserRobot,
  faSquareParking,
  faParking,
  faCardDiamond,
  faFaceZipper,
  faFaceRaisedEyebrow,
  faHouseSignal,
  faSquareChevronUp,
  faChevronSquareUp,
  faNfcSymbol,
  faBarsProgress,
  faTasksAlt,
  faFaucetDrip,
  faArrowsToLine,
  faDolphin,
  faArrowUpRight,
  faCircleR,
  faCartFlatbed,
  faDollyFlatbed,
  faBanSmoking,
  faSmokingBan,
  faCircleSortUp,
  faSortCircleUp,
  faTerminal,
  faMobileButton,
  faHouseMedicalFlag,
  faBasketShopping,
  faShoppingBasket,
  faTape,
  faChestnut,
  faBusSimple,
  faBusAlt,
  faEye,
  faFaceSadCry,
  faSadCry,
  faHeat,
  faTicketAirline,
  faTicketPerforatedPlane,
  faTicketPlane,
  faBootHeeled,
  faArrowsMinimize,
  faCompressArrows,
  faAudioDescription,
  faPersonMilitaryToPerson,
  faFileShield,
  faHexagon,
  faManhole,
  faUserSlash,
  faPen,
  faTowerObservation,
  faFloppyDisks,
  faToiletPaperBlankUnder,
  faToiletPaperReverseAlt,
  faFileCode,
  faSignal,
  faSignal5,
  faSignalPerfect,
  faPump,
  faBus,
  faHeartCircleXmark,
  faArrowUpLeftFromCircle,
  faHouseChimney,
  faHomeLg,
  faWindowMaximize,
  faDryer,
  faFaceFrown,
  faFrown,
  faChessBishopPiece,
  faChessBishopAlt,
  faShirtTankTop,
  faDiploma,
  faScrollRibbon,
  faScreencast,
  faWalker,
  faPrescription,
  faShop,
  faStoreAlt,
  faFloppyDisk,
  faSave,
  faVihara,
  faFaceKissClosedEyes,
  faScaleUnbalanced,
  faBalanceScaleLeft,
  faFileUser,
  faUserPoliceTie,
  faFaceTongueMoney,
  faTennisBall,
  faSquareL,
  faSortUp,
  faSortAsc,
  faCalendarArrowUp,
  faCalendarUpload,
  faCommentDots,
  faCommenting,
  faPlantWilt,
  faScarf,
  faAlbumCirclePlus,
  faUserNurseHairLong,
  faDiamond,
  faSquareLeft,
  faArrowAltSquareLeft,
  faFaceGrinSquint,
  faGrinSquint,
  faCircleEllipsisVertical,
  faHandHoldingDollar,
  faHandHoldingUsd,
  faGridDividers,
  faChartDiagram,
  faBacterium,
  faHandPointer,
  faDrumSteelpan,
  faHandScissors,
  faHandsPraying,
  faPrayingHands,
  faFacePensive,
  faUserMusic,
  faArrowRotateRight,
  faArrowRightRotate,
  faArrowRotateForward,
  faRedo,
  faMessagesDollar,
  faCommentsAltDollar,
  faSensorOn,
  faBalloon,
  faWebAwesome,
  faBiohazard,
  faChessQueenPiece,
  faChessQueenAlt,
  faLocationCrosshairs,
  faLocation,
  faMarsDouble,
  faLeftFromBracket,
  faHousePersonLeave,
  faHouseLeave,
  faHousePersonDepart,
  faRulerTriangle,
  faCardClub,
  faChildDress,
  faUsersBetweenLines,
  faLungsVirus,
  faSpinnerThird,
  faFaceGrinTears,
  faGrinTears,
  faPhone,
  faComputerMouseScrollwheel,
  faMouseAlt,
  faCalendarXmark,
  faCalendarTimes,
  faChildReaching,
  faTableLayout,
  faNarwhal,
  faRampLoading,
  faCalendarCirclePlus,
  faToothbrush,
  faBorderInner,
  faPawClaws,
  faKiwiFruit,
  faTrafficLightSlow,
  faRectangleCode,
  faHeadSideVirus,
  faKeyboardBrightness,
  faBooksMedical,
  faLightbulbSlash,
  faHouseBlank,
  faHomeBlank,
  faSquare5,
  faSquareHeart,
  faHeartSquare,
  faPuzzle,
  faUserGear,
  faUserCog,
  faPipeCircleCheck,
  faArrowUp19,
  faSortNumericUp,
  faOctagonExclamation,
  faDialLow,
  faDoorClosed,
  faLaptopMobile,
  faPhoneLaptop,
  faConveyorBeltBoxes,
  faConveyorBeltAlt,
  faShieldVirus,
  faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced,
  faDiceSix,
  faStarfighterTwinIonEngine,
  faStarfighterAlt,
  faRocketLaunch,
  faMosquitoNet,
  faFileFragment,
  faVentDamper,
  faBridgeWater,
  faBanBug,
  faDebug,
  faPersonBooth,
  faTextWidth,
  faGarageCar,
  faSquareKanban,
  faHatWizard,
  faChartKanban,
  faPenFancy,
  faCoffeePot,
  faMouseField,
  faPersonDigging,
  faDigging,
  faShowerDown,
  faShowerAlt,
  faBoxCircleCheck,
  faBrightness,
  faCarSideBolt,
  faFileXml,
  faOrnament,
  faPhoneArrowDownLeft,
  faPhoneArrowDown,
  faPhoneIncoming,
  faCloudWord,
  faHandFingersCrossed,
  faTrash,
  faGaugeSimple,
  faGaugeSimpleMed,
  faTachometerAverage,
  faArrowDownSmallBig,
  faSortSizeDownAlt,
  faBookMedical,
  faFaceMelting,
  faPoo,
  faPenClipSlash,
  faPenAltSlash,
  faQuoteRight,
  faQuoteRightAlt,
  faScrollOld,
  faGuitars,
  faPhoneXmark,
  faHose,
  faClockSix,
  faShirt,
  faTShirt,
  faTshirt,
  faBillboard,
  faSquareR,
  faCubes,
  faEnvelopeOpenDollar,
  faDivide,
  faSunCloud,
  faLampFloor,
  faSquare7,
  faTengeSign,
  faTenge,
  faHeadphones,
  faHandsHolding,
  faCampfire,
  faCircleAmpersand,
  faSnowflakes,
  faHandsClapping,
  faRepublican,
  faLeafMaple,
  faArrowLeft,
  faPersonCircleXmark,
  faRuler,
  faArrowLeftFromBracket,
  faCupStrawSwoosh,
  faTemperatureSun,
  faTemperatureHot,
  faAlignLeft,
  faDiceD6,
  faRestroom,
  faHighDefinition,
  faRectangleHd,
  faJ,
  faGalaxy,
  faUsersViewfinder,
  faFileVideo,
  faCherries,
  faUpRightFromSquare,
  faExternalLinkAlt,
  faCircleSort,
  faSortCircle,
  faTableCells,
  faTh,
  faBagShoppingMinus,
  faFilePdf,
  faSiren,
  faArrowUpToDottedLine,
  faImageLandscape,
  faLandscape,
  faTankWater,
  faCurlingStone,
  faCurling,
  faGamepadModern,
  faGamepadAlt,
  faMessagesQuestion,
  faBookBible,
  faBible,
  faO,
  faSuitcaseMedical,
  faMedkit,
  faBriefcaseArrowRight,
  faExpandWide,
  faClockElevenThirty,
  faRv,
  faUserSecret,
  faOtter,
  faDreidel,
  faPersonDress,
  faFemale,
  faCommentDollar,
  faBusinessTime,
  faBriefcaseClock,
  faFlowerTulip,
  faPeoplePantsSimple,
  faCloudDrizzle,
  faTableCellsLarge,
  faThLarge,
  faBookTanakh,
  faTanakh,
  faSolarSystem,
  faSealQuestion,
  faPhoneVolume,
  faVolumeControlPhone,
  faDiscDrive,
  faHatCowboySide,
  faTableRows,
  faRows,
  faLocationExclamation,
  faMapMarkerExclamation,
  faFaceFearful,
  faClipboardUser,
  faBusSchool,
  faFilmSlash,
  faSquareArrowDownRight,
  faBookSparkles,
  faBookSpells,
  faWashingMachine,
  faWasher,
  faChild,
  faLiraSign,
  faUserVisor,
  faFilePlusMinus,
  faChessClockFlip,
  faChessClockAlt,
  faSatellite,
  faTruckFire,
  faPlaneLock,
  faSteeringWheel,
  faTag,
  faStretcher,
  faBookSection,
  faBookLaw,
  faInboxes,
  faCoffeeBean,
  faCircleYen,
  faBracketsCurly,
  faEllipsisStrokeVertical,
  faEllipsisVAlt,
  faComment,
  faSquare1,
  faCakeCandles,
  faBirthdayCake,
  faCake,
  faHeadSide,
  faTruckLadder,
  faEnvelope,
  faDollyEmpty,
  faFaceTissue,
  faAnglesUp,
  faAngleDoubleUp,
  faBinRecycle,
  faPaperclip,
  faChartLineDown,
  faArrowRightToCity,
  faLockA,
  faRibbon,
  faLungs,
  faPersonPinball,
  faArrowUp91,
  faSortNumericUpAlt,
  faAppleCore,
  faCircleY,
  faH6,
  faLitecoinSign,
  faBottleBaby,
  faCircleSmall,
  faBorderNone,
  faArrowTurnDownLeft,
  faCircleWifiCircleWifi,
  faCircleWifiGroup,
  faCircleNodes,
  faParachuteBox,
  faReflectHorizontal,
  faMessageMedical,
  faCommentAltMedical,
  faRugbyBall,
  faCommentMusic,
  faIndent,
  faTreeDeciduous,
  faTreeAlt,
  faPuzzlePieceSimple,
  faPuzzlePieceAlt,
  faTruckFieldUn,
  faNfcTrash,
  faHourglass,
  faHourglassEmpty,
  faMountain,
  faFileXmark,
  faFileTimes,
  faHouseHeart,
  faHomeHeart,
  faHouseChimneyBlank,
  faMeterBolt,
  faUserDoctor,
  faUserMd,
  faSlashBack,
  faCircleInfo,
  faInfoCircle,
  faFishingRod,
  faHammerCrash,
  faMessageHeart,
  faCloudMeatball,
  faCameraPolaroid,
  faCamera,
  faCameraAlt,
  faSquareVirus,
  faCartArrowUp,
  faMeteor,
  faCarOn,
  faSleigh,
  faArrowDown19,
  faSortNumericAsc,
  faSortNumericDown,
  faBuoyMooring,
  faSquare4,
  faHandHoldingDroplet,
  faHandHoldingWater,
  faFileEps,
  faTricycleAdult,
  faWaveform,
  faWater,
  faStarSharpHalfStroke,
  faStarSharpHalfAlt,
  faNfcSignal,
  faPlaneProp,
  faCalendarCheck,
  faClockDesk,
  faCalendarClock,
  faCalendarTime,
  faBraille,
  faPrescriptionBottleMedical,
  faPrescriptionBottleAlt,
  faPlateUtensils,
  faFamilyPants,
  faHoseReel,
  faHouseWindow,
  faLandmark,
  faTruck,
  faMusicMagnifyingGlass,
  faCrosshairs,
  faCloudRainbow,
  faPersonCane,
  faAlien,
  faTent,
  faLaptopBinary,
  faVestPatches,
  faPeopleDressSimple,
  faCheckDouble,
  faArrowDownAZ,
  faSortAlphaAsc,
  faSortAlphaDown,
  faBowlingBallPin,
  faBellSchoolSlash,
  faPlusLarge,
  faMoneyBillWheat,
  faCameraViewfinder,
  faScreenshot,
  faMessageMusic,
  faCommentAltMusic,
  faCarBuilding,
  faBorderBottomRight,
  faBorderStyleAlt,
  faOctagon,
  faCommentArrowUpRight,
  faOctagonDivide,
  faCookie,
  faArrowRotateLeft,
  faArrowLeftRotate,
  faArrowRotateBack,
  faArrowRotateBackward,
  faUndo,
  faTvMusic,
  faHardDrive,
  faHdd,
  faReel,
  faFaceGrinSquintTears,
  faGrinSquintTears,
  faDumbbell,
  faRectangleList,
  faListAlt,
  faTarpDroplet,
  faAlarmExclamation,
  faHouseMedicalCircleCheck,
  faTrafficCone,
  faGrate,
  faArrowDownRight,
  faPersonSkiingNordic,
  faSkiingNordic,
  faCalendarPlus,
  faPersonFromPortal,
  faPortalExit,
  faPlaneArrival,
  faCowbellCirclePlus,
  faCowbellMore,
  faCircleLeft,
  faArrowAltCircleLeft,
  faDistributeSpacingVertical,
  faSignalBarsFair,
  faSignalAlt2,
  faSportsball,
  faGameConsoleHandheldCrank,
  faTrainSubway,
  faSubway,
  faChartGantt,
  faFaceSmileUpsideDown,
  faBallPile,
  faBadgeDollar,
  faMoneyBillsSimple,
  faMoneyBillsAlt,
  faListTimeline,
  faIndianRupeeSign,
  faIndianRupee,
  faInr,
  faCropSimple,
  faCropAlt,
  faMoneyBill1,
  faMoneyBillAlt,
  faLeftLong,
  faLongArrowAltLeft,
  faKeyboardDown,
  faCircleUpRight,
  faCloudBoltMoon,
  faThunderstormMoon,
  faTurnLeftUp,
  faDna,
  faVirusSlash,
  faBracketRoundRight,
  faCircleSterling,
  faCircle5,
  faMinus,
  faSubtract,
  faFireFlame,
  faFlame,
  faRightToLine,
  faArrowAltToRight,
  faGif,
  faChess,
  faTrashSlash,
  faArrowLeftLong,
  faLongArrowLeft,
  faPlugCircleCheck,
  faFontCase,
  faStreetView,
  faArrowDownLeft,
  faFrancSign,
  faFlaskRoundPoison,
  faFlaskPoison,
  faVolumeOff,
  faBookCircleArrowRight,
  faChartUser,
  faUserChart,
  faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting,
  faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen,
  faPresentation,
  faCircleBolt,
  faFaceSmileHalo,
  faCartCircleArrowDown,
  faHousePersonReturn,
  faHousePersonArrive,
  faHouseReturn,
  faMessageXmark,
  faCommentAltTimes,
  faMessageTimes,
  faFileCertificate,
  faFileAward,
  faUserDoctorHairLong,
  faCameraSecurity,
  faCameraHome,
  faGear,
  faCog,
  faDropletSlash,
  faTintSlash,
  faBookHeart,
  faMosque,
  faDuck,
  faMosquito,
  faStarOfDavid,
  faFlagSwallowtail,
  faFlagAlt,
  faPersonMilitaryRifle,
  faCarGarage,
  faCartShopping,
  faShoppingCart,
  faBookFont,
  faShieldPlus,
  faVials,
  faEyeDropperFull,
  faDistributeSpacingHorizontal,
  faTabletRugged,
  faTemperatureSnow,
  faTemperatureFrigid,
  faMoped,
  faFaceSmilePlus,
  faSmilePlus,
  faRadioTuner,
  faRadioAlt,
  faFaceSwear,
  faWaterArrowDown,
  faWaterLower,
  faScannerTouchscreen,
  faCircle7,
  faPlugCirclePlus,
  faPersonSkiJumping,
  faSkiJump,
  faPlaceOfWorship,
  faWaterArrowUp,
  faWaterRise,
  faWaveformLines,
  faWaveformPath,
  faSplit,
  faFilmCanister,
  faFilmCannister,
  faFolderXmark,
  faFolderTimes,
  faToiletPaperBlank,
  faToiletPaperAlt,
  faTabletScreen,
  faTabletAndroidAlt,
  faHexagonVerticalNftSlanted,
  faFolderMusic,
  faDisplayMedical,
  faDesktopMedical,
  faShareAll,
  faPeapod,
  faChessClock,
  faAxe,
  faSquareD,
  faGripVertical,
  faMobileSignalOut,
  faHexagonNodes,
  faArrowTurnUp,
  faLevelUp,
  faU,
  faArrowUpFromDottedLine,
  faSquareRootVariable,
  faSquareRootAlt,
  faLightSwitchOn,
  faArrowDownArrowUp,
  faSortAlt,
  faRaindrops,
  faDash,
  faMinusLarge,
  faClock,
  faClockFour,
  faInputNumeric,
  faTruckTow,
  faBackwardStep,
  faStepBackward,
  faPallet,
  faCarBolt,
  faArrowsMaximize,
  faExpandArrows,
  faFaucet,
  faCloudSleet,
  faLampStreet,
  faListRadio,
  faPenNibSlash,
  faBaseballBatBall,
  faSquareUpLeft,
  faOverline,
  faS,
  faTimeline,
  faKeyboard,
  faArrowsFromDottedLine,
  faUsbDrive,
  faBallot,
  faCaretDown,
  faLocationDotSlash,
  faMapMarkerAltSlash,
  faCards,
  faHouseChimneyMedical,
  faClinicMedical,
  faBoxingGlove,
  faGloveBoxing,
  faTemperatureThreeQuarters,
  faTemperature3,
  faThermometer3,
  faThermometerThreeQuarters,
  faBellSchool,
  faMobileScreen,
  faMobileAndroidAlt,
  faPlaneUp,
  faFolderHeart,
  faCircleLocationArrow,
  faLocationCircle,
  faFaceHeadBandage,
  faSushiRoll,
  faMakiRoll,
  faMakizushi,
  faCarBump,
  faPiggyBank,
  faRacquet,
  faCarMirrors,
  faIndustryWindows,
  faIndustryAlt,
  faBoltAuto,
  faBatteryHalf,
  faBattery3,
  faFluxCapacitor,
  faMountainCity,
  faCoins,
  faHoneyPot,
  faOlive,
  faKhanda,
  faFilterList,
  faOutlet,
  faSliders,
  faSlidersH,
  faCauldron,
  faPeople,
  faFolderTree,
  faNetworkWired,
  faCroissant,
  faMapPin,
  faHamsa,
  faCentSign,
  faSwordsLaser,
  faFlask,
  faPersonPregnant,
  faSquareU,
  faWandSparkles,
  faRouter,
  faEllipsisVertical,
  faEllipsisV,
  faSwordLaserAlt,
  faTicket,
  faPowerOff,
  faCoin,
  faLaptopSlash,
  faRightLong,
  faLongArrowAltRight,
  faCircleB,
  faPersonDressSimple,
  faPipeCollar,
  faLightsHoliday,
  faCitrus,
  faFlagUsa,
  faLaptopFile,
  faTty,
  faTeletype,
  faChartTreeMap,
  faDiagramNext,
  faPersonRifle,
  faClockFiveThirty,
  faPipeValve,
  faLightbulbMessage,
  faArrowUpFromArc,
  faFaceSpiralEyes,
  faCompressWide,
  faCirclePhoneHangup,
  faPhoneCircleDown,
  faGearComplexCode,
  faHouseMedicalCircleExclamation,
  faBadminton,
  faClosedCaptioning,
  faPersonHiking,
  faHiking,
  faRightFromLine,
  faArrowAltFromLeft,
  faVenusDouble,
  faImages,
  faCalculator,
  faShuttlecock,
  faUserHair,
  faEyeEvil,
  faPeoplePulling,
  faN,
  faSwap,
  faGarage,
  faCableCar,
  faTram,
  faShovelSnow,
  faCloudRain,
  faFaceLying,
  faSprinkler,
  faBuildingCircleXmark,
  faPersonSledding,
  faSledding,
  faGameConsoleHandheld,
  faShip,
  faClockSixThirty,
  faBatterySlash,
  faTugrikSign,
  faArrowsDownToLine,
  faDownload,
  faAnglesUpDown,
  faShelves,
  faInventory,
  faCloudSnow,
  faFaceGrin,
  faGrin,
  faDeleteLeft,
  faBackspace,
  faOven,
  faCloudBinary,
  faEyeDropper,
  faEyeDropperEmpty,
  faEyedropper,
  faCommentCaptions,
  faCommentsQuestion,
  faScribble,
  faRotateExclamation,
  faFileCircleCheck,
  faGlass,
  faLoader,
  faForward,
  faUserPilot,
  faMobile,
  faMobileAndroid,
  faMobilePhone,
  faCodePullRequestClosed,
  faFaceMeh,
  faMeh,
  faAlignCenter,
  faBookSkull,
  faBookDead,
  faIdCard,
  faDriversLicense,
  faFaceDotted,
  faFaceWorried,
  faOutdent,
  faDedent,
  faCourtSport,
  faHeartCircleExclamation,
  faHouse,
  faHome,
  faHomeAlt,
  faHomeLgAlt,
  faVectorCircle,
  faCarCircleBolt,
  faCalendarWeek,
  faFlyingDisc,
  faLaptopMedical,
  faSquareDownRight,
  faB,
  faSeatAirline,
  faMoonOverSun,
  faEclipseAlt,
  faPipe,
  faFileMedical,
  faPotato,
  faDiceOne,
  faCircleA,
  faHelmetBattle,
  faButter,
  faBlanketFire,
  faKiwiBird,
  faCastle,
  faGolfClub,
  faArrowRightArrowLeft,
  faExchange,
  faRotateRight,
  faRedoAlt,
  faRotateForward,
  faUtensils,
  faCutlery,
  faArrowUpWideShort,
  faSortAmountUp,
  faChartPieSimpleCircleDollar,
  faBalloons,
  faMillSign,
  faBowlRice,
  faTimelineArrow,
  faSkull,
  faGameBoardSimple,
  faGameBoardAlt,
  faCircleVideo,
  faVideoCircle,
  faChartScatterBubble,
  faHouseTurret,
  faBanana,
  faHandHoldingSkull,
  faPeopleDress,
  faLoveseat,
  faCouchSmall,
  faTowerBroadcast,
  faBroadcastTower,
  faTruckPickup,
  faBlockQuote,
  faUpLong,
  faLongArrowAltUp,
  faStop,
  faCodeMerge,
  faMoneyCheckDollarPen,
  faMoneyCheckEditAlt,
  faUpFromLine,
  faArrowAltFromBottom,
  faUpload,
  faHurricane,
  faGridRound2Plus,
  faPeoplePants,
  faMound,
  faWindsock,
  faCircleHalf,
  faBrakeWarning,
  faToiletPortable,
  faCompactDisc,
  faFileArrowDown,
  faFileDownload,
  faSaxophoneFire,
  faSaxHot,
  faCameraWebSlash,
  faWebcamSlash,
  faFolderMedical,
  faFolderGear,
  faFolderCog,
  faHandWave,
  faArrowUpArrowDown,
  faSortUpDown,
  faCaravan,
  faShieldCat,
  faMessageSlash,
  faCommentAltSlash,
  faBolt,
  faZap,
  faTrashCanCheck,
  faGlassWater,
  faOilWell,
  faTableCellsColumnUnlock,
  faPersonSimple,
  faArrowTurnLeftUp,
  faVault,
  faMars,
  faToilet,
  faPlaneCircleXmark,
  faYenSign,
  faCny,
  faJpy,
  faRmb,
  faYen,
  faGearCode,
  faNotes,
  faRubleSign,
  faRouble,
  faRub,
  faRuble,
  faTrashUndo,
  faTrashArrowTurnLeft,
  faChampagneGlass,
  faGlassChampagne,
  faObjectsAlignCenterHorizontal,
  faSun,
  faTrashCanSlash,
  faTrashAltSlash,
  faScreenUsers,
  faUsersClass,
  faGuitar,
  faSquareArrowLeft,
  faArrowSquareLeft,
  faSquare8,
  faFaceSmileHearts,
  faBracketsSquare,
  faBrackets,
  faLaptopArrowDown,
  faHockeyStickPuck,
  faHouseTree,
  faSignalFair,
  faSignal2,
  faFaceLaughWink,
  faLaughWink,
  faCircleDollar,
  faDollarCircle,
  faUsdCircle,
  faHorseHead,
  faArrowsRepeat,
  faRepeatAlt,
  faBoreHole,
  faIndustry,
  faImagePolaroid,
  faWaveTriangle,
  faTurnLeftDown,
  faPersonRunningFast,
  faCircleDown,
  faArrowAltCircleDown,
  faGrill,
  faArrowsTurnToDots,
  faChartMixed,
  faAnalytics,
  faFlorinSign,
  faArrowDownShortWide,
  faSortAmountDesc,
  faSortAmountDownAlt,
  faLessThan,
  faDisplayCode,
  faDesktopCode,
  faFaceDrooling,
  faOilTemperature,
  faOilTemp,
  faSquareQuestion,
  faQuestionSquare,
  faAirConditioner,
  faAngleDown,
  faMountains,
  faOmega,
  faCarTunnel,
  faPersonDollyEmpty,
  faPanFood,
  faHeadSideCough,
  faGripLines,
  faThumbsDown,
  faUserLock,
  faArrowRightLong,
  faLongArrowRight,
  faTicketsAirline,
  faTicketsPerforatedPlane,
  faTicketsPlane,
  faTentDoublePeak,
  faAnchorCircleXmark,
  faEllipsis,
  faEllipsisH,
  faNfcSlash,
  faChessPawn,
  faKitMedical,
  faFirstAid,
  faGrid2Plus,
  faBells,
  faPersonThroughWindow,
  faToolbox,
  faGlobeWifi,
  faEnvelopeDot,
  faEnvelopeBadge,
  faMagnifyingGlassWaveform,
  faHandsHoldingCircle,
  faBug,
  faBowlChopsticks,
  faCreditCard,
  faCreditCardAlt,
  faCircleS,
  faBoxBallot,
  faCar,
  faAutomobile,
  faHandHoldingHand,
  faUserTieHair,
  faPodiumStar,
  faUserHairMullet,
  faBusinessFront,
  faPartyBack,
  faTrianBalbot,
  faMicrophoneStand,
  faBookOpenReader,
  faBookReader,
  faFamilyDress,
  faCircleX,
  faCabin,
  faMountainSun,
  faChartSimpleHorizontal,
  faBluetooth,
  faArrowsLeftRightToLine,
  faHandBackPointLeft,
  faMessageDots,
  faCommentAltDots,
  faMessaging,
  faFileHeart,
  faBeerMug,
  faBeerFoam,
  faDiceD20,
  faDrone,
  faTruckDroplet,
  faFileCircleXmark,
  faTemperatureArrowUp,
  faTemperatureUp,
  faMedal,
  faPersonFairy,
  faBed,
  faBookCopy,
  faSquareH,
  faHSquare,
  faSquareC,
  faClockTwo,
  faSquareEllipsisVertical,
  faCalendarUsers,
  faPodcast,
  faBee,
  faTemperatureFull,
  faTemperature4,
  faThermometer4,
  faThermometerFull,
  faBell,
  faCandyBar,
  faChocolateBar,
  faXmarkLarge,
  faPinata,
  faFilePpt,
  faArrowsFromLine,
  faSuperscript,
  faBowlSpoon,
  faHexagonCheck,
  faPlugCircleXmark,
  faStarOfLife,
  faPhoneSlash,
  faTrafficLightStop,
  faPaintRoller,
  faAccentGrave,
  faHandshakeAngle,
  faHandsHelping,
  faCircle0,
  faDialMedLow,
  faLocationDot,
  faMapMarkerAlt,
  faCrab,
  faBoxOpenFull,
  faBoxFull,
  faFile,
  faGreaterThan,
  faQuotes,
  faPretzel,
  faTRex,
  faPersonSwimming,
  faSwimmer,
  faArrowDown,
  faUserRobotXmarks,
  faMessageQuote,
  faCommentAltQuote,
  faCandyCorn,
  faFolderMagnifyingGlass,
  faFolderSearch,
  faNotebook,
  faCircleWifi,
  faDroplet,
  faTint,
  faBullseyePointer,
  faEraser,
  faHexagonImage,
  faEarthAmericas,
  faEarth,
  faEarthAmerica,
  faGlobeAmericas,
  faFileSvg,
  faCrateApple,
  faAppleCrate,
  faPersonBurst,
  faGameBoard,
  faHatChef,
  faHandBackPointRight,
  faDove,
  faSnowflakeDroplets,
  faBatteryEmpty,
  faBattery0,
  faGrid4,
  faSocks,
  faFaceSunglasses,
  faInbox,
  faSquare0,
  faSection,
  faSquareThisWayUp,
  faBoxUp,
  faGaugeHigh,
  faTachometerAlt,
  faTachometerAltFast,
  faSquareAmpersand,
  faEnvelopeOpenText,
  faLampDesk,
  faHospital,
  faHospitalAlt,
  faHospitalWide,
  faPollPeople,
  faWhiskeyGlassIce,
  faGlassWhiskeyRocks,
  faWineBottle,
  faChessRook,
  faUserBountyHunter,
  faBarsStaggered,
  faReorder,
  faStream,
  faDiagramSankey,
  faCloudHailMixed,
  faCircleUpLeft,
  faDharmachakra,
  faObjectsAlignLeft,
  faOilCanDrip,
  faFaceSmilingHands,
  faBroccoli,
  faRouteInterstate,
  faEarMuffs,
  faHotdog,
  faTransporterEmpty,
  faPersonWalkingWithCane,
  faBlind,
  faAngle90,
  faRectangleTerminal,
  faKite,
  faDrum,
  faScrubber,
  faIceCream,
  faHeartCircleBolt,
  faFishBones,
  faDeerRudolph,
  faFax,
  faParagraph,
  faHeadSideHeart,
  faSquareE,
  faMeterFire,
  faCloudHail,
  faCheckToSlot,
  faVoteYea,
  faMoneyFromBracket,
  faStarHalf,
  faCarBus,
  faSpeaker,
  faTimer,
  faBoxesStacked,
  faBoxes,
  faBoxesAlt,
  faLandmarkMagnifyingGlass,
  faGrillHot,
  faBallotCheck,
  faLink,
  faChain,
  faEarListen,
  faAssistiveListeningSystems,
  faFileMinus,
  faTreeCity,
  faPlay,
  faFont,
  faCupTogo,
  faCoffeeTogo,
  faSquareDownLeft,
  faBurgerLettuce,
  faTableCellsRowLock,
  faRupiahSign,
  faMagnifyingGlass,
  faSearch,
  faTableTennisPaddleBall,
  faPingPongPaddleBall,
  faTableTennis,
  faPersonDotsFromLine,
  faDiagnoses,
  faChevronsDown,
  faChevronDoubleDown,
  faTrashCanArrowUp,
  faTrashRestoreAlt,
  faSignalGood,
  faSignal3,
  faLocationQuestion,
  faMapMarkerQuestion,
  faFloppyDiskCircleXmark,
  faFloppyDiskTimes,
  faSaveCircleXmark,
  faSaveTimes,
  faNairaSign,
  faPeach,
  faCirclesOverlap3,
  faPronoun,
  faTaxiBus,
  faBracketCurly,
  faBracketCurlyLeft,
  faLobster,
  faCartFlatbedEmpty,
  faDollyFlatbedEmpty,
  faColon,
  faCartArrowDown,
  faWand,
  faWalkieTalkie,
  faFilePen,
  faFileEdit,
  faReceipt,
  faTablePicnic,
  faSquarePen,
  faPenSquare,
  faPencilSquare,
  faCircleMicrophoneLines,
  faMicrophoneCircleAlt,
  faDisplaySlash,
  faDesktopSlash,
  faSuitcaseRolling,
  faPersonCircleExclamation,
  faTransporter2,
  faUserHoodie,
  faHandsHoldingDiamond,
  faHandReceiving,
  faMoneyBillSimpleWave,
  faChevronDown,
  faBatteryFull,
  faBattery,
  faBattery5,
  faBellPlus,
  faBookArrowRight,
  faHospitals,
  faClub,
  faSkullCrossbones,
  faDropletDegree,
  faDewpoint,
  faCodeCompare,
  faListUl,
  faListDots,
  faHandHoldingMagic,
  faWatermelonSlice,
  faCircleEllipsis,
  faSchoolLock,
  faTowerCell,
  faSdCards,
  faJugBottle,
  faDownLong,
  faLongArrowAltDown,
  faEnvelopes,
  faPhoneOffice,
  faRankingStar,
  faChessKing,
  faNfcPen,
  faPersonHarassing,
  faMagnifyingGlassPlay,
  faHatWinter,
  faBrazilianRealSign,
  faLandmarkDome,
  faLandmarkAlt,
  faBoneBreak,
  faArrowUp,
  faDownFromDottedLine,
  faTv,
  faTelevision,
  faTvAlt,
  faBorderLeft,
  faCircleDivide,
  faShrimp,
  faListCheck,
  faTasks,
  faDiagramSubtask,
  faJugDetergent,
  faCircleUser,
  faUserCircle,
  faSquareY,
  faUserDoctorHair,
  faPlanetRinged,
  faMushroom,
  faUserShield,
  faMegaphone,
  faWreathLaurel,
  faCircleExclamationCheck,
  faWind,
  faBoxDollar,
  faBoxUsd,
  faCarBurst,
  faCarCrash,
  faY,
  faUserHeadset,
  faArrowsRetweet,
  faRetweetAlt,
  faPersonSnowboarding,
  faSnowboarding,
  faSquareChevronRight,
  faChevronSquareRight,
  faLacrosseStickBall,
  faTruckFast,
  faShippingFast,
  faUserMagnifyingGlass,
  faStarSharp,
  faCommentHeart,
  faCircle1,
  faCircleStar,
  faStarCircle,
  faFish,
  faCloudFog,
  faFog,
  faWaffle,
  faMusicNote,
  faMusicAlt,
  faHexagonExclamation,
  faCartShoppingFast,
  faObjectUnion,
  faUserGraduate,
  faStarfighter,
  faCircleHalfStroke,
  faAdjust,
  faArrowRightLongToLine,
  faSquareArrowDown,
  faArrowSquareDown,
  faDiamondHalfStroke,
  faClapperboard,
  faSquareChevronLeft,
  faChevronSquareLeft,
  faPhoneIntercom,
  faLinkHorizontal,
  faChainHorizontal,
  faMango,
  faMusicNoteSlash,
  faMusicAltSlash,
  faCircleRadiation,
  faRadiationAlt,
  faFaceTongueSweat,
  faGlobeStand,
  faBaseball,
  faBaseballBall,
  faCircleP,
  faAwardSimple,
  faJetFighterUp,
  faDiagramProject,
  faProjectDiagram,
  faPedestal,
  faChartPyramid,
  faSidebar,
  faSnowmanHead,
  faFrostyHead,
  faCopy,
  faBurgerGlass,
  faVolumeXmark,
  faVolumeMute,
  faVolumeTimes,
  faHandSparkles,
  faBarsFilter,
  faPaintbrushPencil,
  faPartyBell,
  faUserVneckHair,
  faJackOLantern,
  faGrip,
  faGripHorizontal,
  faShareFromSquare,
  faShareSquare,
  faKeynote,
  faChildCombatant,
  faChildRifle,
  faGun,
  faSquarePhone,
  faPhoneSquare,
  faHatBeach,
  faPlus,
  faAdd,
  faExpand,
  faComputer,
  faFort,
  faCloudCheck,
  faXmark,
  faClose,
  faMultiply,
  faRemove,
  faTimes,
  faFaceSmirking,
  faArrowsUpDownLeftRight,
  faArrows,
  faChalkboardUser,
  faChalkboardTeacher,
  faRhombus,
  faClawMarks,
  faPesoSign,
  faFaceSmileTongue,
  faCartCircleXmark,
  faBuildingShield,
  faCirclePhoneFlip,
  faPhoneCircleAlt,
  faBaby,
  faUsersLine,
  faQuoteLeft,
  faQuoteLeftAlt,
  faTractor,
  faDownFromBracket,
  faKeySkeleton,
  faTrashArrowUp,
  faTrashRestore,
  faArrowDownUpLock,
  faArrowDownToBracket,
  faLinesLeaning,
  faSquareQ,
  faRulerCombined,
  faSymbols,
  faIconsAlt,
  faCopyright,
  faFlaskGear,
  faHighlighterLine,
  faBracketSquare,
  faBracket,
  faBracketLeft,
  faIslandTropical,
  faIslandTreePalm,
  faArrowRightFromLine,
  faArrowFromLeft,
  faH2,
  faEquals,
  faCakeSlice,
  faShortcake,
  faBuildingMagnifyingGlass,
  faPeanut,
  faWrenchSimple,
  faBlender,
  faTeeth,
  faTally2,
  faShekelSign,
  faIls,
  faShekel,
  faSheqel,
  faSheqelSign,
  faCars,
  faAxeBattle,
  faUserHairLong,
  faMap,
  faArrowLeftFromArc,
  faFileCircleInfo,
  faFaceDisappointed,
  faLassoSparkles,
  faClockEleven,
  faRocket,
  faSirenOn,
  faClockTen,
  faCandleHolder,
  faVideoArrowDownLeft,
  faPhotoFilm,
  faPhotoVideo,
  faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight,
  faFolderMinus,
  faHexagonNodesBolt,
  faPlanetMoon,
  faFaceEyesXmarks,
  faChartScatter,
  faCircleGf,
  faDisplayArrowDown,
  faStore,
  faArrowTrendUp,
  faPlugCircleMinus,
  faOliveBranch,
  faAngle,
  faVacuumRobot,
  faSignHanging,
  faSign,
  faSquareDivide,
  faFolderCheck,
  faSignalStreamSlash,
  faBezierCurve,
  faEyeDropperHalf,
  faStoreLock,
  faBellSlash,
  faCloudBoltSun,
  faThunderstormSun,
  faCameraSlash,
  faCommentQuote,
  faTablet,
  faTabletAndroid,
  faSchoolFlag,
  faMessageCode,
  faGlassHalf,
  faGlassHalfEmpty,
  faGlassHalfFull,
  faFill,
  faMessageMinus,
  faCommentAltMinus,
  faAngleUp,
  faDinosaur,
  faDrumstickBite,
  faLinkHorizontalSlash,
  faChainHorizontalSlash,
  faHollyBerry,
  faNose,
  faArrowLeftToArc,
  faChevronLeft,
  faBacteria,
  faClouds,
  faMoneyBillSimple,
  faHandLizard,
  faTablePivot,
  faFilterSlash,
  faTrashCanUndo,
  faTrashCanArrowTurnLeft,
  faTrashUndoAlt,
  faNotdef,
  faDisease,
  faPersonToDoor,
  faTurntable,
  faBriefcaseMedical,
  faGenderless,
  faChevronRight,
  faSignalWeak,
  faSignal1,
  faClockFive,
  faRetweet,
  faCarRear,
  faCarAlt,
  faPumpSoap,
  faComputerClassic,
  faFrame,
  faVideoSlash,
  faBatteryQuarter,
  faBattery2,
  faEllipsisStroke,
  faEllipsisHAlt,
  faRadio,
  faBabyCarriage,
  faCarriageBaby,
  faFaceExpressionless,
  faDownToDottedLine,
  faCloudMusic,
  faTrafficLight,
  faCloudMinus,
  faThermometer,
  faShieldMinus,
  faVrCardboard,
  faCarTilt,
  faGaugeCircleMinus,
  faBrightnessLow,
  faHandMiddleFinger,
  faPercent,
  faPercentage,
  faTruckMoving,
  faGlassWaterDroplet,
  faConveyorBelt,
  faLocationCheck,
  faMapMarkerCheck,
  faCoinVertical,
  faDisplay,
  faPersonSign,
  faFaceSmile,
  faSmile,
  faPhoneHangup,
  faSignatureSlash,
  faThumbtack,
  faThumbTack,
  faWheatSlash,
  faTrophy,
  faCloudsSun,
  faPersonPraying,
  faPray,
  faHammer,
  faFaceVomit,
  faSpeakers,
  faTtyAnswer,
  faTeletypeAnswer,
  faMugTeaSaucer,
  faDiagramLeanCanvas,
  faAlt,
  faDial,
  faDialMedHigh,
  faHandPeace,
  faCircleTrash,
  faTrashCircle,
  faRotate,
  faSyncAlt,
  faCircleQuarters,
  faSpinner,
  faTowerControl,
  faArrowUpTriangleSquare,
  faSortShapesUp,
  faWhale,
  faRobot,
  faPeace,
  faPartyHorn,
  faGears,
  faCogs,
  faSunBright,
  faSunAlt,
  faWarehouse,
  faConveyorBeltArm,
  faLockKeyholeOpen,
  faLockOpenAlt,
  faSquareFragile,
  faBoxFragile,
  faSquareWineGlassCrack,
  faArrowUpRightDots,
  faSquareN,
  faSplotch,
  faFaceGrinHearts,
  faGrinHearts,
  faMeter,
  faMandolin,
  faDiceFour,
  faSimCard,
  faTransgender,
  faTransgenderAlt,
  faMercury,
  faUpFromBracket,
  faKnifeKitchen,
  faBorderRight,
  faArrowTurnDown,
  faLevelDown,
  faSpade,
  faCardSpade,
  faLineColumns,
  faAnt,
  faArrowRightToLine,
  faArrowToRight,
  faPersonFallingBurst,
  faFlagPennant,
  faPennant,
  faConveyorBeltEmpty,
  faUserGroupSimple,
  faAward,
  faTicketSimple,
  faTicketAlt,
  faBuilding,
  faAnglesLeft,
  faAngleDoubleLeft,
  faCamcorder,
  faVideoHandheld,
  faPancakes,
  faAlbumCircleUser,
  faSubtitlesSlash,
  faQrcode,
  faDiceD10,
  faFireplace,
  faBrowser,
  faPenPaintbrush,
  faPencilPaintbrush,
  faFishCooked,
  faChairOffice,
  faMagnifyingGlassMusic,
  faNestingDolls,
  faClockRotateLeft,
  faHistory,
  faTrumpet,
  faFaceGrinBeamSweat,
  faGrinBeamSweat,
  faFireSmoke,
  faPhoneMissed,
  faFileExport,
  faArrowRightFromFile,
  faShield,
  faShieldBlank,
  faArrowUpShortWide,
  faSortAmountUpAlt,
  faArrowsRepeat1,
  faRepeat1Alt,
  faGunSlash,
  faAvocado,
  faBinary,
  faCommentNodes,
  faGlassesRound,
  faGlassesAlt,
  faPhonePlus,
  faDitto,
  faPersonSeat,
  faHouseMedical,
  faGolfBallTee,
  faGolfBall,
  faCircleChevronLeft,
  faChevronCircleLeft,
  faHouseChimneyWindow,
  faScythe,
  faPenNib,
  faBanParking,
  faParkingCircleSlash,
  faTentArrowTurnLeft,
  faFaceDiagonalMouth,
  faDiagramCells,
  faCricketBatBall,
  faCricket,
  faTents,
  faWandMagic,
  faMagic,
  faDog,
  faPenLine,
  faAtomSimple,
  faAtomAlt,
  faAmpersand,
  faCarrot,
  faArrowUpFromLine,
  faArrowFromBottom,
  faMoon,
  faPenSlash,
  faWineGlassEmpty,
  faWineGlassAlt,
  faSquareStar,
  faCheese,
  faSendBackward,
  faYinYang,
  faMusic,
  faCompassSlash,
  faClockOne,
  faFileMusic,
  faCodeCommit,
  faTemperatureLow,
  faPersonBiking,
  faBiking,
  faDisplayChartUpCircleCurrency,
  faSkeleton,
  faCircleG,
  faCircleArrowUpLeft,
  faCoinBlank,
  faBroom,
  faVacuum,
  faShieldHeart,
  faCardHeart,
  faLightbulbCflOn,
  faMelon,
  faGopuram,
  faEarthOceania,
  faGlobeOceania,
  faContainerStorage,
  faFacePouting,
  faSquareXmark,
  faTimesSquare,
  faXmarkSquare,
  faFaceExplode,
  faExplodingHead,
  faHashtag,
  faUpRightAndDownLeftFromCenter,
  faExpandAlt,
  faOilCan,
  faT,
  faTransformerBolt,
  faHippo,
  faChartColumn,
  faCassetteVhs,
  faVhs,
  faInfinity,
  faVialCircleCheck,
  faChimney,
  faObjectIntersect,
  faPersonArrowDownToLine,
  faVoicemail,
  faBlockBrick,
  faWallBrick,
  faFan,
  faBagsShopping,
  faParagraphLeft,
  faParagraphRtl,
  faPersonWalkingLuggage,
  faCaravanSimple,
  faCaravanAlt,
  faTurtle,
  faPencilMechanical,
  faUpDown,
  faArrowsAltV,
  faCloudMoonRain,
  faBoothCurtain,
  faCalendar,
  faBoxHeart,
  faTrailer,
  faUserDoctorMessage,
  faUserMdChat,
  faBahai,
  faHaykal,
  faLighthouse,
  faAmpGuitar,
  faSdCard,
  faVolumeSlash,
  faBorderBottom,
  faWifiWeak,
  faWifi1,
  faDragon,
  faShoePrints,
  faCirclePlus,
  faPlusCircle,
  faFaceGrinTongueWink,
  faGrinTongueWink,
  faHandHolding,
  faPlugCircleExclamation,
  faLinkSlash,
  faChainBroken,
  faChainSlash,
  faUnlink,
  faClone,
  faPersonWalkingArrowLoopLeft,
  faArrowUpZA,
  faSortAlphaUpAlt,
  faFireFlameCurved,
  faFireAlt,
  faTornado,
  faFileCirclePlus,
  faDeleteRight,
  faBookQuran,
  faQuran,
  faCircleQuarter,
  faAnchor,
  faBorderAll,
  faFunction,
  faFaceAngry,
  faAngry,
  faPeopleSimple,
  faCookieBite,
  faArrowTrendDown,
  faRss,
  faFeed,
  faFaceMonocle,
  faDrawPolygon,
  faScaleBalanced,
  faBalanceScale,
  faCalendarLines,
  faCalendarNote,
  faArrowDownBigSmall,
  faSortSizeDown,
  faGaugeSimpleHigh,
  faTachometer,
  faTachometerFast,
  faDoNotEnter,
  faShower,
  faDiceD8,
  faDesktop,
  faDesktopAlt,
  faM,
  faSpinnerScale,
  faGripDotsVertical,
  faFaceViewfinder,
  faSoftServe,
  faCreemee,
  faH5,
  faHandBackPointDown,
  faTableList,
  faThList,
  faBasketShoppingMinus,
  faCommentSms,
  faSms,
  faRectangle,
  faRectangleLandscape,
  faClipboardListCheck,
  faTurkey,
  faBook,
  faUserPlus,
  faIceSkate,
  faCheck,
  faBatteryThreeQuarters,
  faBattery4,
  faTomato,
  faSwordLaser,
  faHouseCircleCheck,
  faBuildings,
  faAngleLeft,
  faCartFlatbedBoxes,
  faDollyFlatbedAlt,
  faDiagramSuccessor,
  faTruckArrowRight,
  faSquareW,
  faArrowsSplitUpAndLeft,
  faLamp,
  faAirplay,
  faHandFist,
  faFistRaised,
  faShieldQuartered,
  faSlashForward,
  faLocationPen,
  faMapMarkerEdit,
  faCloudMoon,
  faPotFood,
  faBriefcase,
  faPersonFalling,
  faImagePortrait,
  faPortrait,
  faUserTag,
  faRug,
  faPrintSlash,
  faEarthEurope,
  faGlobeEurope,
  faCartFlatbedSuitcase,
  faLuggageCart,
  faHandBackPointRibbon,
  faRectangleXmark,
  faRectangleTimes,
  faTimesRectangle,
  faWindowClose,
  faTireRugged,
  faLightbulbDollar,
  faCowbell,
  faBahtSign,
  faCorner,
  faChevronsRight,
  faChevronDoubleRight,
  faBookOpen,
  faBookJournalWhills,
  faJournalWhills,
  faInhaler,
  faHandcuffs,
  faSnake,
  faTriangleExclamation,
  faExclamationTriangle,
  faWarning,
  faNoteMedical,
  faDatabase,
  faDownLeft,
  faShare,
  faMailForward,
  faFaceThinking,
  faTurnDownRight,
  faBottleDroplet,
  faMaskFace,
  faHillRockslide,
  faScannerKeyboard,
  faCircleO,
  faGridHorizontal,
  faMessageDollar,
  faCommentAltDollar,
  faRightLeft,
  faExchangeAlt,
  faColumns3,
  faPaperPlane,
  faRoadCircleExclamation,
  faDungeon,
  faHandHoldingBox,
  faInputText,
  faWindowFlip,
  faWindowAlt,
  faAlignRight,
  faScannerGun,
  faScanner,
  faTire,
  faEngine,
  faMoneyBill1Wave,
  faMoneyBillWaveAlt,
  faLifeRing,
  faHands,
  faSignLanguage,
  faSigning,
  faCircleCaretRight,
  faCaretCircleRight,
  faTurnLeft,
  faWheat,
  faFileSpreadsheet,
  faAudioDescriptionSlash,
  faBellRing,
  faCalendarDay,
  faWaterLadder,
  faLadderWater,
  faSwimmingPool,
  faArrowsUpDown,
  faArrowsV,
  faChessPawnPiece,
  faChessPawnAlt,
  faFaceGrimace,
  faGrimace,
  faWheelchairMove,
  faWheelchairAlt,
  faTurnDown,
  faLevelDownAlt,
  faSquareS,
  faRectangleBarcode,
  faBarcodeAlt,
  faPersonWalkingArrowRight,
  faSquareEnvelope,
  faEnvelopeSquare,
  faDice,
  faUnicorn,
  faBowlingBall,
  faPompebled,
  faBrain,
  faWatchSmart,
  faBookUser,
  faSensorCloud,
  faSensorSmoke,
  faClapperboardPlay,
  faBandage,
  faBandAid,
  faCalendarMinus,
  faCircleXmark,
  faTimesCircle,
  faXmarkCircle,
  faCircle4,
  faGifts,
  faAlbumCollection,
  faHotel,
  faEarthAsia,
  faGlobeAsia,
  faIdCardClip,
  faIdCardAlt,
  faMagnifyingGlassPlus,
  faSearchPlus,
  faThumbsUp,
  faCloudShowers,
  faUserClock,
  faOnion,
  faClockTwelveThirty,
  faArrowDownToDottedLine,
  faHandDots,
  faAllergies,
  faFileInvoice,
  faWindowMinimize,
  faRectangleWide,
  faCommentArrowUp,
  faGarlic,
  faMugSaucer,
  faCoffee,
  faBrush,
  faFileHalfDashed,
  faTreeDecorated,
  faMask,
  faCalendarHeart,
  faMagnifyingGlassMinus,
  faSearchMinus,
  faFlower,
  faArrowDownFromArc,
  faRightLeftLarge,
  faRulerVertical,
  faCirclesOverlap,
  faUserLarge,
  faUserAlt,
  faStarshipFreighter,
  faTrainTram,
  faBridgeSuspension,
  faTrashCheck,
  faUserNurse,
  faBoombox,
  faSyringe,
  faCloudSun,
  faShieldExclamation,
  faStopwatch20,
  faSquareFull,
  faGripDots,
  faCommentExclamation,
  faPenSwirl,
  faFalafel,
  faCircle2,
  faMagnet,
  faJar,
  faGramophone,
  faDiceD12,
  faNoteSticky,
  faStickyNote,
  faDown,
  faArrowAltDown,
  faHundredPoints,
  fa100,
  faPaperclipVertical,
  faWindWarning,
  faWindCircleExclamation,
  faLocationPinSlash,
  faMapMarkerSlash,
  faFaceSadSweat,
  faBugSlash,
  faCupcake,
  faLightSwitchOff,
  faToggleLargeOff,
  faPenFancySlash,
  faTruckContainer,
  faBoot,
  faArrowUpFromWaterPump,
  faFileCheck,
  faBone,
  faCardsBlank,
  faCircle3,
  faBenchTree,
  faKeyboardBrightnessLow,
  faSkiBootSki,
  faBrainCircuit,
  faTableCellsRowUnlock,
  faUserInjured,
  faBlockBrickFire,
  faFirewall,
  faFaceSadTear,
  faSadTear,
  faPlane,
  faTentArrowsDown,
  faExclamation,
  faArrowsSpin,
  faFaceSmileRelaxed,
  faCommentXmark,
  faCommentTimes,
  faPrint,
  faTurkishLiraSign,
  faTry,
  faTurkishLira,
  faFaceNoseSteam,
  faCircleWaveformLines,
  faWaveformCircle,
  faDollarSign,
  faDollar,
  faUsd,
  faFerrisWheel,
  faComputerSpeaker,
  faSkullCow,
  faX,
  faMagnifyingGlassDollar,
  faSearchDollar,
  faUsersGear,
  faUsersCog,
  faPersonMilitaryPointing,
  faBuildingColumns,
  faBank,
  faInstitution,
  faMuseum,
  faUniversity,
  faCircleT,
  faSack,
  faGrid2,
  faCameraCctv,
  faCctv,
  faUmbrella,
  faTrowel,
  faHorizontalRule,
  faBedFront,
  faBedAlt,
  faD,
  faStapler,
  faMasksTheater,
  faTheaterMasks,
  faFileGif,
  faKipSign,
  faFaceWoozy,
  faCloudQuestion,
  faPineapple,
  faHandPointLeft,
  faGalleryThumbnails,
  faCircleJ,
  faEyes,
  faHandshakeSimple,
  faHandshakeAlt,
  faPageCaretUp,
  faFileCaretUp,
  faJetFighter,
  faFighterJet,
  faComet,
  faSquareShareNodes,
  faShareAltSquare,
  faReflectVertical,
  faShieldKeyhole,
  faFileMp4,
  faBarcode,
  faBulldozer,
  faPlusMinus,
  faSquareSlidersVertical,
  faSlidersVSquare,
  faVideo,
  faVideoCamera,
  faMessageMiddle,
  faCommentMiddleAlt,
  faGraduationCap,
  faMortarBoard,
  faHandHoldingMedical,
  faPersonCircleCheck,
  faSquareZ,
  faMessageText,
  faCommentAltText,
  faTurnUp,
  faLevelUpAlt,
};

export {
  icons as fad,
  prefix,
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faFillDrip,
  faArrowsToCircle,
  faCircleChevronRight,
  faChevronCircleRight,
  faWagonCovered,
  faLineHeight,
  faBagel,
  faTransporter7,
  faAt,
  faRectanglesMixed,
  faPhoneArrowUpRight,
  faPhoneArrowUp,
  faPhoneOutgoing,
  faTrashCan,
  faTrashAlt,
  faCircleL,
  faHeadSideGoggles,
  faHeadVr,
  faTextHeight,
  faUserXmark,
  faUserTimes,
  faFaceHandYawn,
  faGaugeSimpleMin,
  faTachometerSlowest,
  faStethoscope,
  faCoffin,
  faMessage,
  faCommentAlt,
  faSalad,
  faBowlSalad,
  faInfo,
  faRobotAstromech,
  faRingDiamond,
  faFonduePot,
  faTheta,
  faFaceHandPeeking,
  faSquareUser,
  faDownLeftAndUpRightToCenter,
  faCompressAlt,
  faExplosion,
  faFileLines,
  faFileAlt,
  faFileText,
  faWaveSquare,
  faRing,
  faBuildingUn,
  faDiceThree,
  faTirePressureWarning,
  faWifiFair,
  faWifi2,
  faCalendarDays,
  faCalendarAlt,
  faMp3Player,
  faAnchorCircleCheck,
  faTally4,
  faRectangleHistory,
  faBuildingCircleArrowRight,
  faVolleyball,
  faVolleyballBall,
  faSunHaze,
  faTextSize,
  faUfo,
  faFork,
  faUtensilFork,
  faArrowsUpToLine,
  faMobileSignal,
  faBarcodeScan,
  faSortDown,
  faSortDesc,
  faFolderArrowDown,
  faFolderDownload,
  faCircleMinus,
  faMinusCircle,
  faFaceIcicles,
  faShovel,
  faDoorOpen,
  faFilms,
  faRightFromBracket,
  faSignOutAlt,
  faFaceGlasses,
  faNfc,
  faAtom,
  faSoap,
  faIcons,
  faHeartMusicCameraBolt,
  faMicrophoneLinesSlash,
  faMicrophoneAltSlash,
  faClosedCaptioningSlash,
  faCalculatorSimple,
  faCalculatorAlt,
  faBridgeCircleCheck,
  faSlidersUp,
  faSlidersV,
  faLocationMinus,
  faMapMarkerMinus,
  faPumpMedical,
  faFingerprint,
  faSkiBoot,
  faStandardDefinition,
  faRectangleSd,
  faH1,
  faHandPointRight,
  faMagnifyingGlassLocation,
  faSearchLocation,
  faMessageBot,
  faForwardStep,
  faStepForward,
  faFaceSmileBeam,
  faSmileBeam,
  faLightCeiling,
  faMessageExclamation,
  faCommentAltExclamation,
  faBowlScoop,
  faBowlShavedIce,
  faSquareX,
  faBuildingMemo,
  faUtilityPoleDouble,
  faFlagCheckered,
  faChevronsUp,
  faChevronDoubleUp,
  faFootball,
  faFootballBall,
  faUserVneck,
  faSchoolCircleExclamation,
  faCrop,
  faAnglesDown,
  faAngleDoubleDown,
  faUsersRectangle,
  faPeopleRoof,
  faSquareArrowRight,
  faArrowSquareRight,
  faLocationPlus,
  faMapMarkerPlus,
  faLightbulbExclamationOn,
  faPeopleLine,
  faBeerMugEmpty,
  faBeer,
  faCarpool,
  faCarPeople,
  faCrateEmpty,
  faDiagramPredecessor,
  faTransporter,
  faCalendarCircleUser,
  faArrowUpLong,
  faLongArrowUp,
  faPersonCarryBox,
  faPersonCarry,
  faFireFlameSimple,
  faBurn,
  faPerson,
  faMale,
  faLaptop,
  faFileCsv,
  faMenorah,
  faUnion,
  faChevronsLeft,
  faChevronDoubleLeft,
  faCircleHeart,
  faHeartCircle,
  faTruckPlane,
  faRecordVinyl,
  faBringForward,
  faSquareP,
  faFaceGrinStars,
  faGrinStars,
  faSigma,
  faCameraMovie,
  faBong,
  faClarinet,
  faTruckFlatbed,
  faSpaghettiMonsterFlying,
  faPastafarianism,
  faArrowDownUpAcrossLine,
  faArrowsRotateReverse,
  faLeafHeart,
  faHouseBuilding,
  faCheeseSwiss,
  faSpoon,
  faUtensilSpoon,
  faJarWheat,
  faEnvelopesBulk,
  faMailBulk,
  faFileCircleExclamation,
  faBowArrow,
  faCartXmark,
  faHexagonXmark,
  faTimesHexagon,
  faXmarkHexagon,
  faCircleH,
  faHospitalSymbol,
  faMerge,
  faPager,
  faCartMinus,
  faAddressBook,
  faContactBook,
  faPanFrying,
  faGrid,
  faGrid3,
  faFootballHelmet,
  faHandLove,
  faTrees,
  faStrikethrough,
  faPage,
  faK,
  faDiagramPrevious,
  faGaugeMin,
  faTachometerAltSlowest,
  faFolderGrid,
  faEggplant,
  faExcavator,
  faRam,
  faLandmarkFlag,
  faLips,
  faPencil,
  faPencilAlt,
  faBackward,
  faCaretRight,
  faComments,
  faPaste,
  faFileClipboard,
  faDesktopArrowDown,
  faCodePullRequest,
  faPumpkin,
  faClipboardList,
  faPenField,
  faChartSine,
  faBlueberries,
  faTruckRampBox,
  faTruckLoading,
  faNote,
  faArrowDownToSquare,
  faUserCheck,
  faCloudXmark,
  faVialVirus,
  faBookBlank,
  faBookAlt,
  faGolfFlagHole,
  faMessageArrowDown,
  faCommentAltArrowDown,
  faFaceUnamused,
  faSheetPlastic,
  faCircle9,
  faBlog,
  faUserNinja,
  faPencilSlash,
  faBowlingPins,
  faPersonArrowUpFromLine,
  faDownRight,
  faScrollTorah,
  faTorah,
  faWebhook,
  faBlindsOpen,
  faFence,
  faUp,
  faArrowAltUp,
  faBroomBall,
  faQuidditch,
  faQuidditchBroomBall,
  faDrumstick,
  faSquareV,
  faFaceAwesome,
  faGaveDandy,
  faDialOff,
  faToggleOff,
  faFaceSmileHorns,
  faBoxArchive,
  faArchive,
  faGrapes,
  faPersonDrowning,
  faDialMax,
  faCircleM,
  faCalendarImage,
  faCircleCaretDown,
  faCaretCircleDown,
  faArrowDown91,
  faSortNumericDesc,
  faSortNumericDownAlt,
  faFaceGrinTongueSquint,
  faGrinTongueSquint,
  faShishKebab,
  faSprayCan,
  faAlarmSnooze,
  faScarecrow,
  faTruckMonster,
  faGiftCard,
  faW,
  faCodePullRequestDraft,
  faSquareB,
  faElephant,
  faEarthAfrica,
  faGlobeAfrica,
  faRainbow,
  faCircleNotch,
  faTabletScreenButton,
  faTabletAlt,
  faPaw,
  faMessageQuestion,
  faCloud,
  faTrowelBricks,
  faSquare3,
  faFaceFlushed,
  faFlushed,
  faHospitalUser,
  faMicrowave,
  faChfSign,
  faTentArrowLeftRight,
  faCartCircleArrowUp,
  faTrashClock,
  faReflectBoth,
  faGavel,
  faLegal,
  faSprinklerCeiling,
  faBrowsers,
  faTrillium,
  faTableCellsUnlock,
  faMusicSlash,
  faTruckRamp,
  faBinoculars,
  faMicrophoneSlash,
  faBoxTissue,
  faCircleC,
  faStarChristmas,
  faChartBullet,
  faMotorcycle,
  faTreeChristmas,
  faTireFlat,
  faSunglasses,
  faBadge,
  faMessagePen,
  faCommentAltEdit,
  faMessageEdit,
  faBellConcierge,
  faConciergeBell,
  faPenRuler,
  faPencilRuler,
  faFileMp3,
  faArrowProgress,
  faChessRookPiece,
  faChessRookAlt,
  faSquareRoot,
  faAlbumCollectionCirclePlus,
  faPeopleArrows,
  faPeopleArrowsLeftRight,
  faSignPost,
  faFaceAngryHorns,
  faMarsAndVenusBurst,
  faTombstone,
  faSquareCaretRight,
  faCaretSquareRight,
  faScissors,
  faCut,
  faListMusic,
  faSunPlantWilt,
  faToiletsPortable,
  faHockeyPuck,
  faMustache,
  faHyphen,
  faTable,
  faUserChef,
  faMessageImage,
  faCommentAltImage,
  faUsersMedical,
  faSensorTriangleExclamation,
  faSensorAlert,
  faMagnifyingGlassArrowRight,
  faTachographDigital,
  faDigitalTachograph,
  faFaceMask,
  faPickleball,
  faStarSharpHalf,
  faUsersSlash,
  faClover,
  faMeat,
  faReply,
  faMailReply,
  faStarAndCrescent,
  faEmptySet,
  faHouseFire,
  faSquareMinus,
  faMinusSquare,
  faHelicopter,
  faBird,
  faCompass,
  faSquareCaretDown,
  faCaretSquareDown,
  faHeartHalfStroke,
  faHeartHalfAlt,
  faFileCircleQuestion,
  faTruckUtensils,
  faLaptopCode,
  faJoystick,
  faGrillFire,
  faRectangleVerticalHistory,
  faSwatchbook,
  faPrescriptionBottle,
  faBars,
  faNavicon,
  faKeyboardLeft,
  faPeopleGroup,
  faHourglassEnd,
  faHourglass3,
  faHeartCrack,
  faHeartBroken,
  faFaceBeamHandOverMouth,
  faDropletPercent,
  faHumidity,
  faSquareUpRight,
  faExternalLinkSquareAlt,
  faFaceKissBeam,
  faKissBeam,
  faCorn,
  faRollerCoaster,
  faPhotoFilmMusic,
  faRadar,
  faSickle,
  faFilm,
  faCoconut,
  faRulerHorizontal,
  faShieldCross,
  faCassetteTape,
  faSquareTerminal,
  faPeopleRobbery,
  faLightbulb,
  faCaretLeft,
  faCommentMiddle,
  faTrashCanList,
  faBlock,
  faCircleExclamation,
  faExclamationCircle,
  faSchoolCircleXmark,
  faArrowRightFromBracket,
  faSignOut,
  faFaceFrownSlight,
  faCircleChevronDown,
  faChevronCircleDown,
  faSidebarFlip,
  faUnlockKeyhole,
  faUnlockAlt,
  faTemperatureList,
  faCloudShowersHeavy,
  faHeadphonesSimple,
  faHeadphonesAlt,
  faSitemap,
  faPipeSection,
  faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt,
  faCircleDollarToSlot,
  faDonate,
  faMemory,
  faFaceSleeping,
  faRoadSpikes,
  faFireBurner,
  faSquirrel,
  faArrowUpToLine,
  faArrowToTop,
  faFlag,
  faFaceCowboyHat,
  faHanukiah,
  faChartScatter3d,
  faDisplayChartUp,
  faSquareCode,
  faFeather,
  faVolumeLow,
  faVolumeDown,
  faXmarkToSlot,
  faTimesToSlot,
  faVoteNay,
  faBoxTaped,
  faBoxAlt,
  faCommentSlash,
  faSwords,
  faCloudSunRain,
  faAlbum,
  faCircleN,
  faCompress,
  faWheatAwn,
  faWheatAlt,
  faAnkh,
  faHandsHoldingChild,
  faAsterisk,
  faKeySkeletonLeftRight,
  faCommentLines,
  faLuchadorMask,
  faLuchador,
  faMaskLuchador,
  faSquareCheck,
  faCheckSquare,
  faShredder,
  faBookOpenCover,
  faBookOpenAlt,
  faSandwich,
  faPesetaSign,
  faSquareParkingSlash,
  faParkingSlash,
  faTrainTunnel,
  faHeading,
  faHeader,
  faGhost,
  faFaceAnguished,
  faHockeySticks,
  faAbacus,
  faFilmSimple,
  faFilmAlt,
  faList,
  faListSquares,
  faTreePalm,
  faSquarePhoneFlip,
  faPhoneSquareAlt,
  faUserBeardBolt,
  faCartPlus,
  faGamepad,
  faBorderCenterV,
  faCircleDot,
  faDotCircle,
  faClipboardMedical,
  faFaceDizzy,
  faDizzy,
  faEgg,
  faUpToLine,
  faArrowAltToTop,
  faHouseMedicalCircleXmark,
  faWatchFitness,
  faClockNineThirty,
  faCampground,
  faFolderPlus,
  faJug,
  faFutbol,
  faFutbolBall,
  faSoccerBall,
  faSnowBlowing,
  faPaintbrush,
  faPaintBrush,
  faLock,
  faArrowDownFromLine,
  faArrowFromTop,
  faGasPump,
  faSignalBarsSlash,
  faSignalAltSlash,
  faMonkey,
  faRectanglePro,
  faPro,
  faHouseNight,
  faHotTubPerson,
  faHotTub,
  faGlobePointer,
  faBlanket,
  faMapLocation,
  faMapMarked,
  faHouseFloodWater,
  faCommentsQuestionCheck,
  faTree,
  faArrowsCross,
  faBackpack,
  faSquareSmall,
  faFolderArrowUp,
  faFolderUpload,
  faBridgeLock,
  faCrosshairsSimple,
  faSackDollar,
  faPenToSquare,
  faEdit,
  faSquareSliders,
  faSlidersHSquare,
  faCarSide,
  faMessageMiddleTop,
  faCommentMiddleTopAlt,
  faLightbulbOn,
  faKnife,
  faUtensilKnife,
  faShareNodes,
  faShareAlt,
  faDisplayChartUpCircleDollar,
  faWaveSine,
  faHeartCircleMinus,
  faCircleW,
  faCircleCalendar,
  faCalendarCircle,
  faHourglassHalf,
  faHourglass2,
  faMicroscope,
  faSunset,
  faSink,
  faCalendarExclamation,
  faTruckContainerEmpty,
  faHandHeart,
  faBagShopping,
  faShoppingBag,
  faArrowDownZA,
  faSortAlphaDesc,
  faSortAlphaDownAlt,
  faMitten,
  faReplyClock,
  faReplyTime,
  faPersonRays,
  faRight,
  faArrowAltRight,
  faCircleF,
  faUsers,
  faFacePleading,
  faEyeSlash,
  faFlaskVial,
  faPoliceBox,
  faCucumber,
  faHeadSideBrain,
  faHand,
  faHandPaper,
  faPersonBikingMountain,
  faBikingMountain,
  faUtensilsSlash,
  faPrintMagnifyingGlass,
  faPrintSearch,
  faTurnRight,
  faFolderBookmark,
  faArrowTurnLeftDown,
  faOm,
  faPi,
  faFlaskRoundPotion,
  faFlaskPotion,
  faFaceShush,
  faWorm,
  faHouseCircleXmark,
  faPlug,
  faCalendarCircleExclamation,
  faSquareI,
  faChevronUp,
  faFaceSaluting,
  faGaugeSimpleLow,
  faTachometerSlow,
  faFacePersevering,
  faCircleCamera,
  faCameraCircle,
  faHandSpock,
  faSpiderWeb,
  faCircleMicrophone,
  faMicrophoneCircle,
  faBookArrowUp,
  faPopsicle,
  faCommand,
  faBlinds,
  faStopwatch,
  faSaxophone,
  faSquare2,
  faFieldHockeyStickBall,
  faFieldHockey,
  faArrowUpSquareTriangle,
  faSortShapesUpAlt,
  faFaceScream,
  faSquareM,
  faCameraWeb,
  faWebcam,
  faCommentArrowDown,
  faLightbulbCfl,
  faWindowFrameOpen,
  faFaceKiss,
  faKiss,
  faBridgeCircleXmark,
  faPeriod,
  faFaceGrinTongue,
  faGrinTongue,
  faUpToDottedLine,
  faThoughtBubble,
  faSkeletonRibs,
  faRaygun,
  faFlute,
  faAcorn,
  faVideoArrowUpRight,
  faGrateDroplet,
  faSealExclamation,
  faChessBishop,
  faMessageSms,
  faCoffeeBeans,
  faHatWitch,
  faFaceGrinWink,
  faGrinWink,
  faClockThreeThirty,
  faEarDeaf,
  faDeaf,
  faDeafness,
  faHardOfHearing,
  faAlarmClock,
  faEclipse,
  faFaceRelieved,
  faRoadCircleCheck,
  faDiceFive,
  faOctagonMinus,
  faMinusOctagon,
  faSquareRss,
  faRssSquare,
  faFaceZany,
  faTricycle,
  faLandMineOn,
  faSquareArrowUpLeft,
  faICursor,
  faChartMixedUpCircleDollar,
  faSaltShaker,
  faStamp,
  faFilePlus,
  faDrawSquare,
  faToiletPaperUnderSlash,
  faToiletPaperReverseSlash,
  faStairs,
  faDroneFront,
  faDroneAlt,
  faGlassEmpty,
  faDialHigh,
  faUserHelmetSafety,
  faUserConstruction,
  faUserHardHat,
  faI,
  faHryvniaSign,
  faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter,
  faPills,
  faFaceGrinWide,
  faGrinAlt,
  faTooth,
  faBasketballHoop,
  faObjectsAlignBottom,
  faV,
  faSparkles,
  faSquid,
  faLeafyGreen,
  faCircleArrowUpRight,
  faCalendars,
  faBangladeshiTakaSign,
  faBicycle,
  faHammerWar,
  faCircleD,
  faSpiderBlackWidow,
  faStaffSnake,
  faRodAsclepius,
  faRodSnake,
  faStaffAesculapius,
  faPear,
  faHeadSideCoughSlash,
  faFileMov,
  faTriangle,
  faApartment,
  faTruckMedical,
  faAmbulance,
  faPepper,
  faPiano,
  faGunSquirt,
  faWheatAwnCircleExclamation,
  faSnowman,
  faUserAlien,
  faShieldCheck,
  faMortarPestle,
  faRoadBarrier,
  faChartCandlestick,
  faBriefcaseBlank,
  faSchool,
  faIgloo,
  faBracketRound,
  faParenthesis,
  faJoint,
  faHorseSaddle,
  faMugMarshmallows,
  faFilters,
  faBellOn,
  faAngleRight,
  faDialMed,
  faHorse,
  faQ,
  faMonitorWaveform,
  faMonitorHeartRate,
  faLinkSimple,
  faWhistle,
  faG,
  faWineGlassCrack,
  faFragile,
  faSlotMachine,
  faNotesMedical,
  faCarWash,
  faEscalator,
  faCommentImage,
  faTemperatureHalf,
  faTemperature2,
  faThermometer2,
  faThermometerHalf,
  faDongSign,
  faDonut,
  faDoughnut,
  faCapsules,
  faPooStorm,
  faPooBolt,
  faTally1,
  faFileVector,
  faFaceFrownOpen,
  faFrownOpen,
  faSquareDashed,
  faBagShoppingPlus,
  faSquareJ,
  faHandPointUp,
  faMoneyBill,
  faArrowUpBigSmall,
  faSortSizeUp,
  faBarcodeRead,
  faBaguette,
  faBowlSoftServe,
  faFaceHoldingBackTears,
  faSquareUp,
  faArrowAltSquareUp,
  faTrainSubwayTunnel,
  faSubwayTunnel,
  faSquareExclamation,
  faExclamationSquare,
  faSemicolon,
  faBookmark,
  faFanTable,
  faAlignJustify,
  faBatteryLow,
  faBattery1,
  faCreditCardFront,
  faBrainArrowCurvedRight,
  faMindShare,
  faUmbrellaBeach,
  faHelmetUn,
  faLocationSmile,
  faMapMarkerSmile,
  faArrowLeftToLine,
  faArrowToLeft,
  faBullseye,
  faSushi,
  faNigiri,
  faMessageCaptions,
  faCommentAltCaptions,
  faTrashList,
  faBacon,
  faOption,
  faRaccoon,
  faHandPointDown,
  faArrowUpFromBracket,
  faHeadSideGear,
  faTrashPlus,
  faFileCad,
  faObjectsAlignTop,
  faFolder,
  faFolderBlank,
  faFaceAnxiousSweat,
  faCreditCardBlank,
  faFileWaveform,
  faFileMedicalAlt,
  faMicrochipAi,
  faMug,
  faPlaneUpSlash,
  faRadiation,
  faPenCircle,
  faBagSeedling,
  faChartSimple,
  faCrutches,
  faCircleParking,
  faParkingCircle,
  faMarsStroke,
  faLeafOak,
  faSquareBolt,
  faVial,
  faGauge,
  faDashboard,
  faGaugeMed,
  faTachometerAltAverage,
  faWandMagicSparkles,
  faMagicWandSparkles,
  faLambda,
  faE,
  faPizza,
  faBowlChopsticksNoodles,
  faH3,
  faPenClip,
  faPenAlt,
  faBridgeCircleExclamation,
  faBadgePercent,
  faRotateReverse,
  faUser,
  faSensor,
  faComma,
  faSchoolCircleCheck,
  faToiletPaperUnder,
  faToiletPaperReverse,
  faLightEmergency,
  faArrowDownToArc,
  faDumpster,
  faVanShuttle,
  faShuttleVan,
  faBuildingUser,
  faLightSwitch,
  faSquareCaretLeft,
  faCaretSquareLeft,
  faHighlighter,
  faWavePulse,
  faHeartRate,
  faKey,
  faArrowLeftToBracket,
  faHatSanta,
  faTamale,
  faBoxCheck,
  faBullhorn,
  faSteak,
  faLocationCrosshairsSlash,
  faLocationSlash,
  faPersonDolly,
  faGlobe,
  faSynagogue,
  faFileChartColumn,
  faFileChartLine,
  faPersonHalfDress,
  faFolderImage,
  faCalendarPen,
  faCalendarEdit,
  faRoadBridge,
  faFaceSmileTear,
  faMessagePlus,
  faCommentAltPlus,
  faLocationArrow,
  faC,
  faTabletButton,
  faPersonDressFairy,
  faRectangleHistoryCircleUser,
  faBuildingLock,
  faChartLineUp,
  faMailbox,
  faSignPosts,
  faTruckBolt,
  faPizzaSlice,
  faMoneyBillWave,
  faChartArea,
  faAreaChart,
  faHouseFlag,
  faCircleThreeQuartersStroke,
  faPersonCircleMinus,
  faScalpel,
  faBan,
  faCancel,
  faBellExclamation,
  faCircleBookmark,
  faBookmarkCircle,
  faEggFried,
  faFaceWeary,
  faUniformMartialArts,
  faCameraRotate,
  faSunDust,
  faCommentText,
  faSprayCanSparkles,
  faAirFreshener,
  faSignalBars,
  faSignalAlt,
  faSignalAlt4,
  faSignalBarsStrong,
  faDiamondExclamation,
  faStar,
  faDialMin,
  faRepeat,
  faCross,
  faPageCaretDown,
  faFileCaretDown,
  faBox,
  faVenusMars,
  faClockSevenThirty,
  faArrowPointer,
  faMousePointer,
  faClockFourThirty,
  faSignalBarsGood,
  faSignalAlt3,
  faCactus,
  faLightbulbGear,
  faMaximize,
  faExpandArrowsAlt,
  faChargingStation,
  faShapes,
  faTriangleCircleSquare,
  faPlaneTail,
  faGaugeSimpleMax,
  faTachometerFastest,
  faCircleU,
  faShieldSlash,
  faSquarePhoneHangup,
  faPhoneSquareDown,
  faArrowUpLeft,
  faTransporter1,
  faPeanuts,
  faShuffle,
  faRandom,
  faPersonRunning,
  faRunning,
  faMobileRetro,
  faGripLinesVertical,
  faBinBottlesRecycle,
  faArrowUpFromSquare,
  faFileDashedLine,
  faPageBreak,
  faBracketCurlyRight,
  faSpider,
  faClockThree,
  faHandsBound,
  faScalpelLineDashed,
  faScalpelPath,
  faFileInvoiceDollar,
  faPipeSmoking,
  faFaceAstonished,
  faWindow,
  faPlaneCircleExclamation,
  faEar,
  faFileLock,
  faDiagramVenn,
  faArrowDownFromBracket,
  faXRay,
  faGoalNet,
  faCoffinCross,
  faOctopus,
  faSpellCheck,
  faLocationXmark,
  faMapMarkerTimes,
  faMapMarkerXmark,
  faCircleQuarterStroke,
  faLasso,
  faSlash,
  faPersonToPortal,
  faPortalEnter,
  faCalendarStar,
  faComputerMouse,
  faMouse,
  faArrowRightToBracket,
  faSignIn,
  faPegasus,
  faFilesMedical,
  faCannon,
  faNfcLock,
  faPersonSkiLift,
  faSkiLift,
  faSquare6,
  faShopSlash,
  faStoreAltSlash,
  faWindTurbine,
  faSlidersSimple,
  faGridRound,
  faBadgeSheriff,
  faServer,
  faVirusCovidSlash,
  faIntersection,
  faShopLock,
  faFamily,
  faHourglassStart,
  faHourglass1,
  faUserHairBuns,
  faBlenderPhone,
  faHourglassClock,
  faPersonSeatReclined,
  faPaperPlaneTop,
  faPaperPlaneAlt,
  faSend,
  faMessageArrowUp,
  faCommentAltArrowUp,
  faLightbulbExclamation,
  faLayerMinus,
  faLayerGroupMinus,
  faChartPieSimpleCircleCurrency,
  faCircleE,
  faBuildingWheat,
  faGaugeMax,
  faTachometerAltFastest,
  faPersonBreastfeeding,
  faApostrophe,
  faFilePng,
  faFireHydrant,
  faRightToBracket,
  faSignInAlt,
  faVideoPlus,
  faSquareRight,
  faArrowAltSquareRight,
  faCommentSmile,
  faVenus,
  faPassport,
  faThumbtackSlash,
  faThumbTackSlash,
  faInboxIn,
  faInboxArrowDown,
  faHeartPulse,
  faHeartbeat,
  faCircle8,
  faCloudsMoon,
  faClockTenThirty,
  faPeopleCarryBox,
  faPeopleCarry,
  faFolderUser,
  faTrashCanXmark,
  faTemperatureHigh,
  faMicrochip,
  faLeftLongToLine,
  faCrown,
  faWeightHanging,
  faXmarksLines,
  faFilePrescription,
  faTableCellsLock,
  faCalendarRange,
  faFlowerDaffodil,
  faHandBackPointUp,
  faWeightScale,
  faWeight,
  faArrowUpToArc,
  faStarExclamation,
  faBooks,
  faUserGroup,
  faUserFriends,
  faArrowUpAZ,
  faSortAlphaUp,
  faLayerPlus,
  faLayerGroupPlus,
  faPlayPause,
  faBlockQuestion,
  faSnooze,
  faZzz,
  faScannerImage,
  faTvRetro,
  faSquareT,
  faFarm,
  faBarnSilo,
  faChessKnight,
  faBarsSort,
  faPalletBoxes,
  faPaletteBoxes,
  faPalletAlt,
  faFaceLaughSquint,
  faLaughSquint,
  faCodeSimple,
  faBoltSlash,
  faPanelFire,
  faBinaryCircleCheck,
  faCommentMinus,
  faBurrito,
  faViolin,
  faObjectsColumn,
  faSquareChevronDown,
  faChevronSquareDown,
  faCommentPlus,
  faTriangleInstrument,
  faTriangleMusic,
  faWheelchair,
  faUserPilotTie,
  faPianoKeyboard,
  faBedEmpty,
  faCircleArrowUp,
  faArrowCircleUp,
  faToggleOn,
  faRectangleVertical,
  faRectanglePortrait,
  faPersonWalking,
  faWalking,
  faL,
  faSignalStream,
  faDownToBracket,
  faCircleZ,
  faStars,
  faFire,
  faBedPulse,
  faProcedures,
  faHouseDay,
  faShuttleSpace,
  faSpaceShuttle,
  faShirtLongSleeve,
  faChartPieSimple,
  faChartPieAlt,
  faFaceLaugh,
  faLaugh,
  faFolderOpen,
  faAlbumCollectionCircleUser,
  faCandy,
  faBowlHot,
  faSoup,
  faFlatbread,
  faHeartCirclePlus,
  faCodeFork,
  faCity,
  faSignalBarsWeak,
  faSignalAlt1,
  faMicrophoneLines,
  faMicrophoneAlt,
  faClockTwelve,
  faPepperHot,
  faCitrusSlice,
  faSheep,
  faUnlock,
  faColonSign,
  faHeadset,
  faBadgerHoney,
  faH4,
  faStoreSlash,
  faRoadCircleXmark,
  faSignalSlash,
  faUserMinus,
  faMarsStrokeUp,
  faMarsStrokeV,
  faChampagneGlasses,
  faGlassCheers,
  faTaco,
  faHexagonPlus,
  faPlusHexagon,
  faClipboard,
  faHouseCircleExclamation,
  faFileArrowUp,
  faFileUpload,
  faWifi,
  faWifi3,
  faWifiStrong,
  faMessages,
  faCommentsAlt,
  faBath,
  faBathtub,
  faUmbrellaSimple,
  faUmbrellaAlt,
  faRectangleHistoryCirclePlus,
  faUnderline,
  faPrescriptionBottlePill,
  faUserPen,
  faUserEdit,
  faBinarySlash,
  faSquareO,
  faCaduceus,
  faSignature,
  faStroopwafel,
  faBold,
  faAnchorLock,
  faBuildingNgo,
  faTransporter3,
  faEngineWarning,
  faEngineExclamation,
  faCircleDownRight,
  faSquareK,
  faManatSign,
  faMoneyCheckPen,
  faMoneyCheckEdit,
  faNotEqual,
  faBorderTopLeft,
  faBorderStyle,
  faMapLocationDot,
  faMapMarkedAlt,
  faTilde,
  faJedi,
  faSquarePollVertical,
  faPoll,
  faArrowDownSquareTriangle,
  faSortShapesDownAlt,
  faMugHot,
  faDogLeashed,
  faCarBattery,
  faBatteryCar,
  faFaceDowncastSweat,
  faMailboxFlagUp,
  faMemoCircleInfo,
  faGift,
  faDiceTwo,
  faVolume,
  faVolumeMedium,
  faTransporter5,
  faGaugeCircleBolt,
  faCoinFront,
  faFileSlash,
  faMessageArrowUpRight,
  faTreasureChest,
  faChessQueen,
  faPaintbrushFine,
  faPaintBrushAlt,
  faPaintBrushFine,
  faPaintbrushAlt,
  faGlasses,
  faHoodCloak,
  faSquareQuote,
  faUpLeft,
  faBringFront,
  faChessBoard,
  faBurgerCheese,
  faCheeseburger,
  faBuildingCircleCheck,
  faRepeat1,
  faArrowDownToLine,
  faArrowToBottom,
  faGrid5,
  faSwapArrows,
  faRightLongToLine,
  faPersonChalkboard,
  faMarsStrokeRight,
  faMarsStrokeH,
  faHandBackFist,
  faHandRock,
  faGridRound5,
  faTally,
  faTally5,
  faSquareCaretUp,
  faCaretSquareUp,
  faCloudShowersWater,
  faChartBar,
  faBarChart,
  faHandsBubbles,
  faHandsWash,
  faLessThanEqual,
  faTrain,
  faUpFromDottedLine,
  faEyeLowVision,
  faLowVision,
  faTrafficLightGo,
  faFaceExhaling,
  faSensorFire,
  faUserUnlock,
  faHexagonDivide,
  fa00,
  faCrow,
  faCassetteBetamax,
  faBetamax,
  faSailboat,
  faWindowRestore,
  faNfcMagnifyingGlass,
  faFileBinary,
  faCircleV,
  faSquarePlus,
  faPlusSquare,
  faBowlScoops,
  faMistletoe,
  faCustard,
  faLacrosseStick,
  faHockeyMask,
  faSunrise,
  faSubtitles,
  faPanelEws,
  faToriiGate,
  faCloudExclamation,
  faMessageLines,
  faCommentAltLines,
  faFrog,
  faBucket,
  faFloppyDiskPen,
  faImage,
  faWindowFrame,
  faMicrophone,
  faCow,
  faFileZip,
  faSquareRing,
  faDownFromLine,
  faArrowAltFromTop,
  faCaretUp,
  faShieldXmark,
  faShieldTimes,
  faScrewdriver,
  faCircleSortDown,
  faSortCircleDown,
  faFolderClosed,
  faHouseTsunami,
  faSquareNfi,
  faForklift,
  faArrowUpFromGroundWater,
  faBracketSquareRight,
  faMartiniGlass,
  faGlassMartiniAlt,
  faSquareBinary,
  faRotateLeft,
  faRotateBack,
  faRotateBackward,
  faUndoAlt,
  faTableColumns,
  faColumns,
  faSquareA,
  faTick,
  faLemon,
  faHeadSideMask,
  faHandshake,
  faGem,
  faDolly,
  faDollyBox,
  faSmoking,
  faMinimize,
  faCompressArrowsAlt,
  faRefrigerator,
  faMonument,
  faOctagonXmark,
  faTimesOctagon,
  faXmarkOctagon,
  faAlignSlash,
  faSnowplow,
  faAnglesRight,
  faAngleDoubleRight,
  faTruckRampCouch,
  faTruckCouch,
  faCannabis,
  faCirclePlay,
  faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faLocationArrowUp,
  faTablets,
  fa360Degrees,
  faEthernet,
  faEuroSign,
  faEur,
  faEuro,
  faChair,
  faCircleCheck,
  faCheckCircle,
  faSquareDashedCirclePlus,
  faHandHoldingCircleDollar,
  faMoneySimpleFromBracket,
  faBat,
  faCircleStop,
  faStopCircle,
  faHeadSideHeadphones,
  faPhoneRotary,
  faArrowUpToBracket,
  faCompassDrafting,
  faDraftingCompass,
  faPlateWheat,
  faCalendarCircleMinus,
  faChopsticks,
  faCarWrench,
  faCarMechanic,
  faIcicles,
  faPersonShelter,
  faNeuter,
  faIdBadge,
  faKazoo,
  faMarker,
  faBinBottles,
  faFaceLaughBeam,
  faLaughBeam,
  faSquareArrowDownLeft,
  faBatteryBolt,
  faTreeLarge,
  faHelicopterSymbol,
  faAperture,
  faUniversalAccess,
  faGearComplex,
  faFileMagnifyingGlass,
  faFileSearch,
  faUpRight,
  faCircleChevronUp,
  faChevronCircleUp,
  faUserPolice,
  faLariSign,
  faVolcano,
  faTeddyBear,
  faStocking,
  faPersonWalkingDashedLineArrowRight,
  faImageSlash,
  faMaskSnorkel,
  faSmoke,
  faSterlingSign,
  faGbp,
  faPoundSign,
  faBatteryExclamation,
  faViruses,
  faSquarePersonConfined,
  faUserTie,
  faUpToBracket,
  faArrowDownLong,
  faLongArrowDown,
  faTentArrowDownToLine,
  faCertificate,
  faCrystalBall,
  faReplyAll,
  faMailReplyAll,
  faSuitcase,
  faPersonSkating,
  faSkating,
  faStarShooting,
  faBinaryLock,
  faFilterCircleDollar,
  faFunnelDollar,
  faCameraRetro,
  faCircleArrowDown,
  faArrowCircleDown,
  faCommentPen,
  faCommentEdit,
  faFileImport,
  faArrowRightToFile,
  faBanjo,
  faSquareArrowUpRight,
  faExternalLinkSquare,
  faLightEmergencyOn,
  faKerning,
  faBoxOpen,
  faSquareF,
  faScroll,
  faSpa,
  faArrowLeftFromLine,
  faArrowFromRight,
  faStrawberry,
  faLocationPinLock,
  faPause,
  faClockEightThirty,
  faPlaneEngines,
  faPlaneAlt,
  faHillAvalanche,
  faTemperatureEmpty,
  faTemperature0,
  faThermometer0,
  faThermometerEmpty,
  faBomb,
  faGaugeLow,
  faTachometerAltSlow,
  faRegistered,
  faTrashCanPlus,
  faAddressCard,
  faContactCard,
  faVcard,
  faChartFft,
  faScaleUnbalancedFlip,
  faBalanceScaleRight,
  faGlobeSnow,
  faSubscript,
  faDiamondTurnRight,
  faDirections,
  faIntegral,
  faBurst,
  faHouseLaptop,
  faLaptopHouse,
  faFaceTired,
  faTired,
  faMoneyBills,
  faBlindsRaised,
  faSmog,
  faUfoBeam,
  faHydra,
  faCircleCaretUp,
  faCaretCircleUp,
  faUserVneckHairLong,
  faSquareALock,
  faCrutch,
  faGasPumpSlash,
  faFontAwesome,
  faFontAwesomeFlag,
  faFontAwesomeLogoFull,
  faCloudArrowUp,
  faCloudUpload,
  faCloudUploadAlt,
  faPalette,
  faTransporter4,
  faChartMixedUpCircleCurrency,
  faObjectsAlignRight,
  faArrowsTurnRight,
  faVest,
  faPig,
  faInboxFull,
  faCircleEnvelope,
  faEnvelopeCircle,
  faTrianglePersonDigging,
  faConstruction,
  faFerry,
  faBullseyeArrow,
  faArrowsDownToPeople,
  faSeedling,
  faSprout,
  faClockSeven,
  faLeftRight,
  faArrowsAltH,
  faBoxesPacking,
  faCircleArrowLeft,
  faArrowCircleLeft,
  faFlashlight,
  faFileJpg,
  faGroupArrowsRotate,
  faBowlFood,
  faSquare9,
  faCandyCane,
  faArrowDownWideShort,
  faSortAmountAsc,
  faSortAmountDown,
  faSquareDollar,
  faDollarSquare,
  faUsdSquare,
  faPhoneArrowRight,
  faHandHoldingSeedling,
  faMessageCheck,
  faCommentAltCheck,
  faCloudBolt,
  faThunderstorm,
  faChartLineUpDown,
  faTextSlash,
  faRemoveFormat,
  faWatch,
  faCircleDownLeft,
  faText,
  faProjector,
  faFaceSmileWink,
  faSmileWink,
  faTombstoneBlank,
  faTombstoneAlt,
  faChessKingPiece,
  faChessKingAlt,
  faCircle6,
  faWavesSine,
  faLeft,
  faArrowAltLeft,
  faFileWord,
  faFilePowerpoint,
  faSquareDown,
  faArrowAltSquareDown,
  faObjectsAlignCenterVertical,
  faArrowsLeftRight,
  faArrowsH,
  faHouseLock,
  faCloudArrowDown,
  faCloudDownload,
  faCloudDownloadAlt,
  faWreath,
  faChildren,
  faMeterDroplet,
  faChalkboard,
  faBlackboard,
  faUserLargeSlash,
  faUserAltSlash,
  faSignalStrong,
  faSignal4,
  faLollipop,
  faLollypop,
  faListTree,
  faEnvelopeOpen,
  faDrawCircle,
  faCatSpace,
  faHandshakeSimpleSlash,
  faHandshakeAltSlash,
  faRabbitRunning,
  faRabbitFast,
  faMemoPad,
  faMattressPillow,
  faAlarmPlus,
  faAlicorn,
  faCommentQuestion,
  faGingerbreadMan,
  faGuaraniSign,
  faBurgerFries,
  faMugTea,
  faBorderTop,
  faArrowsRotate,
  faRefresh,
  faSync,
  faCircleBookOpen,
  faBookCircle,
  faArrowsToDottedLine,
  faFireExtinguisher,
  faMagnifyingGlassArrowsRotate,
  faGarageOpen,
  faShelvesEmpty,
  faCruzeiroSign,
  faWatchApple,
  faWatchCalculator,
  faListDropdown,
  faCabinetFiling,
  faBurgerSoda,
  faSquareArrowUp,
  faArrowSquareUp,
  faGreaterThanEqual,
  faPalletBox,
  faFaceConfounded,
  faShieldHalved,
  faShieldAlt,
  faTruckPlow,
  faBookAtlas,
  faAtlas,
  faVirus,
  faGridRound2,
  faCommentMiddleTop,
  faWave,
  faEnvelopeCircleCheck,
  faLayerGroup,
  faRestroomSimple,
  faArrowsToDot,
  faBorderOuter,
  faHashtagLock,
  faClockTwoThirty,
  faArchway,
  faHeartCircleCheck,
  faHouseChimneyCrack,
  faHouseDamage,
  faFileZipper,
  faFileArchive,
  faTicketPerforated,
  faHeartHalf,
  faCommentCheck,
  faSquare,
  faMemo,
  faMartiniGlassEmpty,
  faGlassMartini,
  faCouch,
  faCediSign,
  faItalic,
  faGlassCitrus,
  faCalendarLinesPen,
  faTableCellsColumnLock,
  faChurch,
  faPersonSnowmobiling,
  faSnowmobile,
  faFaceHushed,
  faCommentsDollar,
  faTicketsSimple,
  faPickaxe,
  faLinkSimpleSlash,
  faDemocrat,
  faFaceConfused,
  faPinball,
  faZ,
  faPersonSkiing,
  faSkiing,
  faDeer,
  faInputPipe,
  faRoadLock,
  faA,
  faBookmarkSlash,
  faTemperatureArrowDown,
  faTemperatureDown,
  faMace,
  faFeatherPointed,
  faFeatherAlt,
  faSausage,
  faTrashCanClock,
  faP,
  faBroomWide,
  faSnowflake,
  faStomach,
  faNewspaper,
  faRectangleAd,
  faAd,
  faGuitarElectric,
  faArrowTurnDownRight,
  faMoonCloud,
  faBreadSliceButter,
  faCircleArrowRight,
  faArrowCircleRight,
  faUserGroupCrown,
  faUsersCrown,
  faCircleI,
  faToiletPaperCheck,
  faFilterCircleXmark,
  faLocust,
  faSort,
  faUnsorted,
  faListOl,
  faList12,
  faListNumeric,
  faChartWaterfall,
  faSparkle,
  faFaceParty,
  faKidneys,
  faWifiExclamation,
  faChartNetwork,
  faPersonDressBurst,
  faDiceD4,
  faMoneyCheckDollar,
  faMoneyCheckAlt,
  faVectorSquare,
  faBreadSlice,
  faLanguage,
  faWheatAwnSlash,
  faFaceKissWinkHeart,
  faKissWinkHeart,
  faDagger,
  faPodium,
  faDiamonds4,
  faMemoCircleCheck,
  faRouteHighway,
  faDownToLine,
  faArrowAltToBottom,
  faFilter,
  faSquareG,
  faCirclePhone,
  faPhoneCircle,
  faClipboardPrescription,
  faUserNurseHair,
  faQuestion,
  faFileSignature,
  faToggleLargeOn,
  faUpDownLeftRight,
  faArrowsAlt,
  faDryerHeat,
  faDryerAlt,
  faHouseChimneyUser,
  faHandHoldingHeart,
  faArrowUpSmallBig,
  faSortSizeUpAlt,
  faTrainTrack,
  faPuzzlePiece,
  faMoneyCheck,
  faStarHalfStroke,
  faStarHalfAlt,
  faFileExclamation,
  faCode,
  faWhiskeyGlass,
  faGlassWhiskey,
  faMoonStars,
  faBuildingCircleExclamation,
  faClothesHanger,
  faMobileNotch,
  faMobileIphone,
  faMagnifyingGlassChart,
  faArrowUpRightFromSquare,
  faExternalLink,
  faCubesStacked,
  faImagesUser,
  faWonSign,
  faKrw,
  faWon,
  faImagePolaroidUser,
  faVirusCovid,
  faSquareEllipsis,
  faPie,
  faChessKnightPiece,
  faChessKnightAlt,
  faAustralSign,
  faCloudPlus,
  faF,
  faLeaf,
  faBedBunk,
  faRoad,
  faTaxi,
  faCab,
  faPersonCirclePlus,
  faChartPie,
  faPieChart,
  faBoltLightning,
  faClockEight,
  faSackXmark,
  faFileXls,
  faFileExcel,
  faFileContract,
  faFishFins,
  faCircleQ,
  faBuildingFlag,
  faFaceGrinBeam,
  faGrinBeam,
  faObjectUngroup,
  faFaceDisguise,
  faCircleArrowDownRight,
  faAlien8bit,
  faAlienMonster,
  faHandPointRibbon,
  faPoop,
  faObjectExclude,
  faTelescope,
  faLocationPin,
  faMapMarker,
  faSquareList,
  faKaaba,
  faToiletPaper,
  faHelmetSafety,
  faHardHat,
  faHatHard,
  faCommentCode,
  faSimCards,
  faStarship,
  faEject,
  faCircleRight,
  faArrowAltCircleRight,
  faPlaneCircleCheck,
  faSeal,
  faUserCowboy,
  faHexagonVerticalNft,
  faFaceRollingEyes,
  faMehRollingEyes,
  faBreadLoaf,
  faRingsWedding,
  faObjectGroup,
  faFrenchFries,
  faChartLine,
  faLineChart,
  faCalendarArrowDown,
  faCalendarDownload,
  faSendBack,
  faMaskVentilator,
  faTickets,
  faSignatureLock,
  faArrowRight,
  faSignsPost,
  faMapSigns,
  faOctagonPlus,
  faPlusOctagon,
  faCashRegister,
  faPersonCircleQuestion,
  faMelonSlice,
  faSpaceStationMoon,
  faMessageSmile,
  faCommentAltSmile,
  faCupStraw,
  faLeftFromLine,
  faArrowAltFromRight,
  faH,
  faBasketShoppingSimple,
  faShoppingBasketAlt,
  faHandsHoldingHeart,
  faHandsHeart,
  faClockNine,
  faHammerBrush,
  faTarp,
  faFaceSleepy,
  faHandHorns,
  faScrewdriverWrench,
  faTools,
  faArrowsToEye,
  faCircleThreeQuarters,
  faTrophyStar,
  faTrophyAlt,
  faPlugCircleBolt,
  faFaceThermometer,
  faGridRound4,
  faSignPostsWrench,
  faShirtRunning,
  faBookCircleArrowUp,
  faFaceNauseated,
  faHeart,
  faFileChartPie,
  faMarsAndVenus,
  faHouseUser,
  faHomeUser,
  faCircleArrowDownLeft,
  faDumpsterFire,
  faHexagonMinus,
  faMinusHexagon,
  faLeftToLine,
  faArrowAltToLeft,
  faHouseCrack,
  faPawSimple,
  faPawAlt,
  faArrowLeftLongToLine,
  faBracketsRound,
  faParentheses,
  faMartiniGlassCitrus,
  faCocktail,
  faUserShakespeare,
  faArrowRightToArc,
  faFaceSurprise,
  faSurprise,
  faBottleWater,
  faCirclePause,
  faPauseCircle,
  faGaugeCirclePlus,
  faFolders,
  faAngel,
  faValueAbsolute,
  faRabbit,
  faToiletPaperSlash,
  faCircleEuro,
  faAppleWhole,
  faAppleAlt,
  faKitchenSet,
  faDiamondHalf,
  faLockKeyhole,
  faLockAlt,
  faR,
  faTemperatureQuarter,
  faTemperature1,
  faThermometer1,
  faThermometerQuarter,
  faSquareInfo,
  faInfoSquare,
  faWifiSlash,
  faToiletPaperXmark,
  faHandsHoldingDollar,
  faHandsUsd,
  faCube,
  faArrowDownTriangleSquare,
  faSortShapesDown,
  faBitcoinSign,
  faShutters,
  faShieldDog,
  faSolarPanel,
  faLockOpen,
  faTableTree,
  faHouseChimneyHeart,
  faTally3,
  faElevator,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal,
  faPollH,
  faCircle,
  faLeftToBracket,
  faCartCircleExclamation,
  faSword,
  faBackwardFast,
  faFastBackward,
  faRecycle,
  faUserAstronaut,
  faInterrobang,
  faPlaneSlash,
  faCircleDashed,
  faTrademark,
  faBasketball,
  faBasketballBall,
  faForkKnife,
  faUtensilsAlt,
  faSatelliteDish,
  faBadgeCheck,
  faCircleUp,
  faArrowAltCircleUp,
  faSlider,
  faMobileScreenButton,
  faMobileAlt,
  faClockOneThirty,
  faInboxOut,
  faInboxArrowUp,
  faCloudSlash,
  faVolumeHigh,
  faVolumeUp,
  faUsersRays,
  faWallet,
  faOctagonCheck,
  faFlatbreadStuffed,
  faClipboardCheck,
  faCartCirclePlus,
  faTruckClock,
  faShippingTimed,
  faPool8Ball,
  faFileAudio,
  faTurnDownLeft,
  faLockHashtag,
  faChartRadar,
  faStaff,
  faBurger,
  faHamburger,
  faUtilityPole,
  faTransporter6,
  faArrowTurnLeft,
  faWrench,
  faBugs,
  faVectorPolygon,
  faDiagramNested,
  faRupeeSign,
  faRupee,
  faFileImage,
  faCircleQuestion,
  faQuestionCircle,
  faTicketsPerforated,
  faImageUser,
  faBuoy,
  faPlaneDeparture,
  faHandshakeSlash,
  faBookBookmark,
  faBorderCenterH,
  faCanFood,
  faTypewriter,
  faArrowRightFromArc,
  faCircleK,
  faFaceHandOverMouth,
  faPopcorn,
  faHouseWater,
  faHouseFlood,
  faObjectSubtract,
  faCodeBranch,
  faWarehouseFull,
  faWarehouseAlt,
  faHatCowboy,
  faBridge,
  faPhoneFlip,
  faPhoneAlt,
  faArrowDownFromDottedLine,
  faFileDoc,
  faSquareQuarters,
  faTruckFront,
  faCat,
  faTrashXmark,
  faCircleCaretLeft,
  faCaretCircleLeft,
  faFiles,
  faAnchorCircleExclamation,
  faFaceClouds,
  faUserCrown,
  faBasketShoppingPlus,
  faTruckField,
  faRoute,
  faCartCircleCheck,
  faClipboardQuestion,
  faPanorama,
  faCommentMedical,
  faTeethOpen,
  faUserTieHairLong,
  faFileCircleMinus,
  faHeadSideMedical,
  faArrowTurnRight,
  faTags,
  faWineGlass,
  faForwardFast,
  faFastForward,
  faFaceMehBlank,
  faMehBlank,
  faUserRobot,
  faSquareParking,
  faParking,
  faCardDiamond,
  faFaceZipper,
  faFaceRaisedEyebrow,
  faHouseSignal,
  faSquareChevronUp,
  faChevronSquareUp,
  faNfcSymbol,
  faBarsProgress,
  faTasksAlt,
  faFaucetDrip,
  faArrowsToLine,
  faDolphin,
  faArrowUpRight,
  faCircleR,
  faCartFlatbed,
  faDollyFlatbed,
  faBanSmoking,
  faSmokingBan,
  faCircleSortUp,
  faSortCircleUp,
  faTerminal,
  faMobileButton,
  faHouseMedicalFlag,
  faBasketShopping,
  faShoppingBasket,
  faTape,
  faChestnut,
  faBusSimple,
  faBusAlt,
  faEye,
  faFaceSadCry,
  faSadCry,
  faHeat,
  faTicketAirline,
  faTicketPerforatedPlane,
  faTicketPlane,
  faBootHeeled,
  faArrowsMinimize,
  faCompressArrows,
  faAudioDescription,
  faPersonMilitaryToPerson,
  faFileShield,
  faHexagon,
  faManhole,
  faUserSlash,
  faPen,
  faTowerObservation,
  faFloppyDisks,
  faToiletPaperBlankUnder,
  faToiletPaperReverseAlt,
  faFileCode,
  faSignal,
  faSignal5,
  faSignalPerfect,
  faPump,
  faBus,
  faHeartCircleXmark,
  faArrowUpLeftFromCircle,
  faHouseChimney,
  faHomeLg,
  faWindowMaximize,
  faDryer,
  faFaceFrown,
  faFrown,
  faChessBishopPiece,
  faChessBishopAlt,
  faShirtTankTop,
  faDiploma,
  faScrollRibbon,
  faScreencast,
  faWalker,
  faPrescription,
  faShop,
  faStoreAlt,
  faFloppyDisk,
  faSave,
  faVihara,
  faFaceKissClosedEyes,
  faScaleUnbalanced,
  faBalanceScaleLeft,
  faFileUser,
  faUserPoliceTie,
  faFaceTongueMoney,
  faTennisBall,
  faSquareL,
  faSortUp,
  faSortAsc,
  faCalendarArrowUp,
  faCalendarUpload,
  faCommentDots,
  faCommenting,
  faPlantWilt,
  faScarf,
  faAlbumCirclePlus,
  faUserNurseHairLong,
  faDiamond,
  faSquareLeft,
  faArrowAltSquareLeft,
  faFaceGrinSquint,
  faGrinSquint,
  faCircleEllipsisVertical,
  faHandHoldingDollar,
  faHandHoldingUsd,
  faGridDividers,
  faChartDiagram,
  faBacterium,
  faHandPointer,
  faDrumSteelpan,
  faHandScissors,
  faHandsPraying,
  faPrayingHands,
  faFacePensive,
  faUserMusic,
  faArrowRotateRight,
  faArrowRightRotate,
  faArrowRotateForward,
  faRedo,
  faMessagesDollar,
  faCommentsAltDollar,
  faSensorOn,
  faBalloon,
  faWebAwesome,
  faBiohazard,
  faChessQueenPiece,
  faChessQueenAlt,
  faLocationCrosshairs,
  faLocation,
  faMarsDouble,
  faLeftFromBracket,
  faHousePersonLeave,
  faHouseLeave,
  faHousePersonDepart,
  faRulerTriangle,
  faCardClub,
  faChildDress,
  faUsersBetweenLines,
  faLungsVirus,
  faSpinnerThird,
  faFaceGrinTears,
  faGrinTears,
  faPhone,
  faComputerMouseScrollwheel,
  faMouseAlt,
  faCalendarXmark,
  faCalendarTimes,
  faChildReaching,
  faTableLayout,
  faNarwhal,
  faRampLoading,
  faCalendarCirclePlus,
  faToothbrush,
  faBorderInner,
  faPawClaws,
  faKiwiFruit,
  faTrafficLightSlow,
  faRectangleCode,
  faHeadSideVirus,
  faKeyboardBrightness,
  faBooksMedical,
  faLightbulbSlash,
  faHouseBlank,
  faHomeBlank,
  faSquare5,
  faSquareHeart,
  faHeartSquare,
  faPuzzle,
  faUserGear,
  faUserCog,
  faPipeCircleCheck,
  faArrowUp19,
  faSortNumericUp,
  faOctagonExclamation,
  faDialLow,
  faDoorClosed,
  faLaptopMobile,
  faPhoneLaptop,
  faConveyorBeltBoxes,
  faConveyorBeltAlt,
  faShieldVirus,
  faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced,
  faDiceSix,
  faStarfighterTwinIonEngine,
  faStarfighterAlt,
  faRocketLaunch,
  faMosquitoNet,
  faFileFragment,
  faVentDamper,
  faBridgeWater,
  faBanBug,
  faDebug,
  faPersonBooth,
  faTextWidth,
  faGarageCar,
  faSquareKanban,
  faHatWizard,
  faChartKanban,
  faPenFancy,
  faCoffeePot,
  faMouseField,
  faPersonDigging,
  faDigging,
  faShowerDown,
  faShowerAlt,
  faBoxCircleCheck,
  faBrightness,
  faCarSideBolt,
  faFileXml,
  faOrnament,
  faPhoneArrowDownLeft,
  faPhoneArrowDown,
  faPhoneIncoming,
  faCloudWord,
  faHandFingersCrossed,
  faTrash,
  faGaugeSimple,
  faGaugeSimpleMed,
  faTachometerAverage,
  faArrowDownSmallBig,
  faSortSizeDownAlt,
  faBookMedical,
  faFaceMelting,
  faPoo,
  faPenClipSlash,
  faPenAltSlash,
  faQuoteRight,
  faQuoteRightAlt,
  faScrollOld,
  faGuitars,
  faPhoneXmark,
  faHose,
  faClockSix,
  faShirt,
  faTShirt,
  faTshirt,
  faBillboard,
  faSquareR,
  faCubes,
  faEnvelopeOpenDollar,
  faDivide,
  faSunCloud,
  faLampFloor,
  faSquare7,
  faTengeSign,
  faTenge,
  faHeadphones,
  faHandsHolding,
  faCampfire,
  faCircleAmpersand,
  faSnowflakes,
  faHandsClapping,
  faRepublican,
  faLeafMaple,
  faArrowLeft,
  faPersonCircleXmark,
  faRuler,
  faArrowLeftFromBracket,
  faCupStrawSwoosh,
  faTemperatureSun,
  faTemperatureHot,
  faAlignLeft,
  faDiceD6,
  faRestroom,
  faHighDefinition,
  faRectangleHd,
  faJ,
  faGalaxy,
  faUsersViewfinder,
  faFileVideo,
  faCherries,
  faUpRightFromSquare,
  faExternalLinkAlt,
  faCircleSort,
  faSortCircle,
  faTableCells,
  faTh,
  faBagShoppingMinus,
  faFilePdf,
  faSiren,
  faArrowUpToDottedLine,
  faImageLandscape,
  faLandscape,
  faTankWater,
  faCurlingStone,
  faCurling,
  faGamepadModern,
  faGamepadAlt,
  faMessagesQuestion,
  faBookBible,
  faBible,
  faO,
  faSuitcaseMedical,
  faMedkit,
  faBriefcaseArrowRight,
  faExpandWide,
  faClockElevenThirty,
  faRv,
  faUserSecret,
  faOtter,
  faDreidel,
  faPersonDress,
  faFemale,
  faCommentDollar,
  faBusinessTime,
  faBriefcaseClock,
  faFlowerTulip,
  faPeoplePantsSimple,
  faCloudDrizzle,
  faTableCellsLarge,
  faThLarge,
  faBookTanakh,
  faTanakh,
  faSolarSystem,
  faSealQuestion,
  faPhoneVolume,
  faVolumeControlPhone,
  faDiscDrive,
  faHatCowboySide,
  faTableRows,
  faRows,
  faLocationExclamation,
  faMapMarkerExclamation,
  faFaceFearful,
  faClipboardUser,
  faBusSchool,
  faFilmSlash,
  faSquareArrowDownRight,
  faBookSparkles,
  faBookSpells,
  faWashingMachine,
  faWasher,
  faChild,
  faLiraSign,
  faUserVisor,
  faFilePlusMinus,
  faChessClockFlip,
  faChessClockAlt,
  faSatellite,
  faTruckFire,
  faPlaneLock,
  faSteeringWheel,
  faTag,
  faStretcher,
  faBookSection,
  faBookLaw,
  faInboxes,
  faCoffeeBean,
  faCircleYen,
  faBracketsCurly,
  faEllipsisStrokeVertical,
  faEllipsisVAlt,
  faComment,
  faSquare1,
  faCakeCandles,
  faBirthdayCake,
  faCake,
  faHeadSide,
  faTruckLadder,
  faEnvelope,
  faDollyEmpty,
  faFaceTissue,
  faAnglesUp,
  faAngleDoubleUp,
  faBinRecycle,
  faPaperclip,
  faChartLineDown,
  faArrowRightToCity,
  faLockA,
  faRibbon,
  faLungs,
  faPersonPinball,
  faArrowUp91,
  faSortNumericUpAlt,
  faAppleCore,
  faCircleY,
  faH6,
  faLitecoinSign,
  faBottleBaby,
  faCircleSmall,
  faBorderNone,
  faArrowTurnDownLeft,
  faCircleWifiCircleWifi,
  faCircleWifiGroup,
  faCircleNodes,
  faParachuteBox,
  faReflectHorizontal,
  faMessageMedical,
  faCommentAltMedical,
  faRugbyBall,
  faCommentMusic,
  faIndent,
  faTreeDeciduous,
  faTreeAlt,
  faPuzzlePieceSimple,
  faPuzzlePieceAlt,
  faTruckFieldUn,
  faNfcTrash,
  faHourglass,
  faHourglassEmpty,
  faMountain,
  faFileXmark,
  faFileTimes,
  faHouseHeart,
  faHomeHeart,
  faHouseChimneyBlank,
  faMeterBolt,
  faUserDoctor,
  faUserMd,
  faSlashBack,
  faCircleInfo,
  faInfoCircle,
  faFishingRod,
  faHammerCrash,
  faMessageHeart,
  faCloudMeatball,
  faCameraPolaroid,
  faCamera,
  faCameraAlt,
  faSquareVirus,
  faCartArrowUp,
  faMeteor,
  faCarOn,
  faSleigh,
  faArrowDown19,
  faSortNumericAsc,
  faSortNumericDown,
  faBuoyMooring,
  faSquare4,
  faHandHoldingDroplet,
  faHandHoldingWater,
  faFileEps,
  faTricycleAdult,
  faWaveform,
  faWater,
  faStarSharpHalfStroke,
  faStarSharpHalfAlt,
  faNfcSignal,
  faPlaneProp,
  faCalendarCheck,
  faClockDesk,
  faCalendarClock,
  faCalendarTime,
  faBraille,
  faPrescriptionBottleMedical,
  faPrescriptionBottleAlt,
  faPlateUtensils,
  faFamilyPants,
  faHoseReel,
  faHouseWindow,
  faLandmark,
  faTruck,
  faMusicMagnifyingGlass,
  faCrosshairs,
  faCloudRainbow,
  faPersonCane,
  faAlien,
  faTent,
  faLaptopBinary,
  faVestPatches,
  faPeopleDressSimple,
  faCheckDouble,
  faArrowDownAZ,
  faSortAlphaAsc,
  faSortAlphaDown,
  faBowlingBallPin,
  faBellSchoolSlash,
  faPlusLarge,
  faMoneyBillWheat,
  faCameraViewfinder,
  faScreenshot,
  faMessageMusic,
  faCommentAltMusic,
  faCarBuilding,
  faBorderBottomRight,
  faBorderStyleAlt,
  faOctagon,
  faCommentArrowUpRight,
  faOctagonDivide,
  faCookie,
  faArrowRotateLeft,
  faArrowLeftRotate,
  faArrowRotateBack,
  faArrowRotateBackward,
  faUndo,
  faTvMusic,
  faHardDrive,
  faHdd,
  faReel,
  faFaceGrinSquintTears,
  faGrinSquintTears,
  faDumbbell,
  faRectangleList,
  faListAlt,
  faTarpDroplet,
  faAlarmExclamation,
  faHouseMedicalCircleCheck,
  faTrafficCone,
  faGrate,
  faArrowDownRight,
  faPersonSkiingNordic,
  faSkiingNordic,
  faCalendarPlus,
  faPersonFromPortal,
  faPortalExit,
  faPlaneArrival,
  faCowbellCirclePlus,
  faCowbellMore,
  faCircleLeft,
  faArrowAltCircleLeft,
  faDistributeSpacingVertical,
  faSignalBarsFair,
  faSignalAlt2,
  faSportsball,
  faGameConsoleHandheldCrank,
  faTrainSubway,
  faSubway,
  faChartGantt,
  faFaceSmileUpsideDown,
  faBallPile,
  faBadgeDollar,
  faMoneyBillsSimple,
  faMoneyBillsAlt,
  faListTimeline,
  faIndianRupeeSign,
  faIndianRupee,
  faInr,
  faCropSimple,
  faCropAlt,
  faMoneyBill1,
  faMoneyBillAlt,
  faLeftLong,
  faLongArrowAltLeft,
  faKeyboardDown,
  faCircleUpRight,
  faCloudBoltMoon,
  faThunderstormMoon,
  faTurnLeftUp,
  faDna,
  faVirusSlash,
  faBracketRoundRight,
  faCircleSterling,
  faCircle5,
  faMinus,
  faSubtract,
  faFireFlame,
  faFlame,
  faRightToLine,
  faArrowAltToRight,
  faGif,
  faChess,
  faTrashSlash,
  faArrowLeftLong,
  faLongArrowLeft,
  faPlugCircleCheck,
  faFontCase,
  faStreetView,
  faArrowDownLeft,
  faFrancSign,
  faFlaskRoundPoison,
  faFlaskPoison,
  faVolumeOff,
  faBookCircleArrowRight,
  faChartUser,
  faUserChart,
  faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting,
  faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen,
  faPresentation,
  faCircleBolt,
  faFaceSmileHalo,
  faCartCircleArrowDown,
  faHousePersonReturn,
  faHousePersonArrive,
  faHouseReturn,
  faMessageXmark,
  faCommentAltTimes,
  faMessageTimes,
  faFileCertificate,
  faFileAward,
  faUserDoctorHairLong,
  faCameraSecurity,
  faCameraHome,
  faGear,
  faCog,
  faDropletSlash,
  faTintSlash,
  faBookHeart,
  faMosque,
  faDuck,
  faMosquito,
  faStarOfDavid,
  faFlagSwallowtail,
  faFlagAlt,
  faPersonMilitaryRifle,
  faCarGarage,
  faCartShopping,
  faShoppingCart,
  faBookFont,
  faShieldPlus,
  faVials,
  faEyeDropperFull,
  faDistributeSpacingHorizontal,
  faTabletRugged,
  faTemperatureSnow,
  faTemperatureFrigid,
  faMoped,
  faFaceSmilePlus,
  faSmilePlus,
  faRadioTuner,
  faRadioAlt,
  faFaceSwear,
  faWaterArrowDown,
  faWaterLower,
  faScannerTouchscreen,
  faCircle7,
  faPlugCirclePlus,
  faPersonSkiJumping,
  faSkiJump,
  faPlaceOfWorship,
  faWaterArrowUp,
  faWaterRise,
  faWaveformLines,
  faWaveformPath,
  faSplit,
  faFilmCanister,
  faFilmCannister,
  faFolderXmark,
  faFolderTimes,
  faToiletPaperBlank,
  faToiletPaperAlt,
  faTabletScreen,
  faTabletAndroidAlt,
  faHexagonVerticalNftSlanted,
  faFolderMusic,
  faDisplayMedical,
  faDesktopMedical,
  faShareAll,
  faPeapod,
  faChessClock,
  faAxe,
  faSquareD,
  faGripVertical,
  faMobileSignalOut,
  faHexagonNodes,
  faArrowTurnUp,
  faLevelUp,
  faU,
  faArrowUpFromDottedLine,
  faSquareRootVariable,
  faSquareRootAlt,
  faLightSwitchOn,
  faArrowDownArrowUp,
  faSortAlt,
  faRaindrops,
  faDash,
  faMinusLarge,
  faClock,
  faClockFour,
  faInputNumeric,
  faTruckTow,
  faBackwardStep,
  faStepBackward,
  faPallet,
  faCarBolt,
  faArrowsMaximize,
  faExpandArrows,
  faFaucet,
  faCloudSleet,
  faLampStreet,
  faListRadio,
  faPenNibSlash,
  faBaseballBatBall,
  faSquareUpLeft,
  faOverline,
  faS,
  faTimeline,
  faKeyboard,
  faArrowsFromDottedLine,
  faUsbDrive,
  faBallot,
  faCaretDown,
  faLocationDotSlash,
  faMapMarkerAltSlash,
  faCards,
  faHouseChimneyMedical,
  faClinicMedical,
  faBoxingGlove,
  faGloveBoxing,
  faTemperatureThreeQuarters,
  faTemperature3,
  faThermometer3,
  faThermometerThreeQuarters,
  faBellSchool,
  faMobileScreen,
  faMobileAndroidAlt,
  faPlaneUp,
  faFolderHeart,
  faCircleLocationArrow,
  faLocationCircle,
  faFaceHeadBandage,
  faSushiRoll,
  faMakiRoll,
  faMakizushi,
  faCarBump,
  faPiggyBank,
  faRacquet,
  faCarMirrors,
  faIndustryWindows,
  faIndustryAlt,
  faBoltAuto,
  faBatteryHalf,
  faBattery3,
  faFluxCapacitor,
  faMountainCity,
  faCoins,
  faHoneyPot,
  faOlive,
  faKhanda,
  faFilterList,
  faOutlet,
  faSliders,
  faSlidersH,
  faCauldron,
  faPeople,
  faFolderTree,
  faNetworkWired,
  faCroissant,
  faMapPin,
  faHamsa,
  faCentSign,
  faSwordsLaser,
  faFlask,
  faPersonPregnant,
  faSquareU,
  faWandSparkles,
  faRouter,
  faEllipsisVertical,
  faEllipsisV,
  faSwordLaserAlt,
  faTicket,
  faPowerOff,
  faCoin,
  faLaptopSlash,
  faRightLong,
  faLongArrowAltRight,
  faCircleB,
  faPersonDressSimple,
  faPipeCollar,
  faLightsHoliday,
  faCitrus,
  faFlagUsa,
  faLaptopFile,
  faTty,
  faTeletype,
  faChartTreeMap,
  faDiagramNext,
  faPersonRifle,
  faClockFiveThirty,
  faPipeValve,
  faLightbulbMessage,
  faArrowUpFromArc,
  faFaceSpiralEyes,
  faCompressWide,
  faCirclePhoneHangup,
  faPhoneCircleDown,
  faGearComplexCode,
  faHouseMedicalCircleExclamation,
  faBadminton,
  faClosedCaptioning,
  faPersonHiking,
  faHiking,
  faRightFromLine,
  faArrowAltFromLeft,
  faVenusDouble,
  faImages,
  faCalculator,
  faShuttlecock,
  faUserHair,
  faEyeEvil,
  faPeoplePulling,
  faN,
  faSwap,
  faGarage,
  faCableCar,
  faTram,
  faShovelSnow,
  faCloudRain,
  faFaceLying,
  faSprinkler,
  faBuildingCircleXmark,
  faPersonSledding,
  faSledding,
  faGameConsoleHandheld,
  faShip,
  faClockSixThirty,
  faBatterySlash,
  faTugrikSign,
  faArrowsDownToLine,
  faDownload,
  faAnglesUpDown,
  faShelves,
  faInventory,
  faCloudSnow,
  faFaceGrin,
  faGrin,
  faDeleteLeft,
  faBackspace,
  faOven,
  faCloudBinary,
  faEyeDropper,
  faEyeDropperEmpty,
  faEyedropper,
  faCommentCaptions,
  faCommentsQuestion,
  faScribble,
  faRotateExclamation,
  faFileCircleCheck,
  faGlass,
  faLoader,
  faForward,
  faUserPilot,
  faMobile,
  faMobileAndroid,
  faMobilePhone,
  faCodePullRequestClosed,
  faFaceMeh,
  faMeh,
  faAlignCenter,
  faBookSkull,
  faBookDead,
  faIdCard,
  faDriversLicense,
  faFaceDotted,
  faFaceWorried,
  faOutdent,
  faDedent,
  faCourtSport,
  faHeartCircleExclamation,
  faHouse,
  faHome,
  faHomeAlt,
  faHomeLgAlt,
  faVectorCircle,
  faCarCircleBolt,
  faCalendarWeek,
  faFlyingDisc,
  faLaptopMedical,
  faSquareDownRight,
  faB,
  faSeatAirline,
  faMoonOverSun,
  faEclipseAlt,
  faPipe,
  faFileMedical,
  faPotato,
  faDiceOne,
  faCircleA,
  faHelmetBattle,
  faButter,
  faBlanketFire,
  faKiwiBird,
  faCastle,
  faGolfClub,
  faArrowRightArrowLeft,
  faExchange,
  faRotateRight,
  faRedoAlt,
  faRotateForward,
  faUtensils,
  faCutlery,
  faArrowUpWideShort,
  faSortAmountUp,
  faChartPieSimpleCircleDollar,
  faBalloons,
  faMillSign,
  faBowlRice,
  faTimelineArrow,
  faSkull,
  faGameBoardSimple,
  faGameBoardAlt,
  faCircleVideo,
  faVideoCircle,
  faChartScatterBubble,
  faHouseTurret,
  faBanana,
  faHandHoldingSkull,
  faPeopleDress,
  faLoveseat,
  faCouchSmall,
  faTowerBroadcast,
  faBroadcastTower,
  faTruckPickup,
  faBlockQuote,
  faUpLong,
  faLongArrowAltUp,
  faStop,
  faCodeMerge,
  faMoneyCheckDollarPen,
  faMoneyCheckEditAlt,
  faUpFromLine,
  faArrowAltFromBottom,
  faUpload,
  faHurricane,
  faGridRound2Plus,
  faPeoplePants,
  faMound,
  faWindsock,
  faCircleHalf,
  faBrakeWarning,
  faToiletPortable,
  faCompactDisc,
  faFileArrowDown,
  faFileDownload,
  faSaxophoneFire,
  faSaxHot,
  faCameraWebSlash,
  faWebcamSlash,
  faFolderMedical,
  faFolderGear,
  faFolderCog,
  faHandWave,
  faArrowUpArrowDown,
  faSortUpDown,
  faCaravan,
  faShieldCat,
  faMessageSlash,
  faCommentAltSlash,
  faBolt,
  faZap,
  faTrashCanCheck,
  faGlassWater,
  faOilWell,
  faTableCellsColumnUnlock,
  faPersonSimple,
  faArrowTurnLeftUp,
  faVault,
  faMars,
  faToilet,
  faPlaneCircleXmark,
  faYenSign,
  faCny,
  faJpy,
  faRmb,
  faYen,
  faGearCode,
  faNotes,
  faRubleSign,
  faRouble,
  faRub,
  faRuble,
  faTrashUndo,
  faTrashArrowTurnLeft,
  faChampagneGlass,
  faGlassChampagne,
  faObjectsAlignCenterHorizontal,
  faSun,
  faTrashCanSlash,
  faTrashAltSlash,
  faScreenUsers,
  faUsersClass,
  faGuitar,
  faSquareArrowLeft,
  faArrowSquareLeft,
  faSquare8,
  faFaceSmileHearts,
  faBracketsSquare,
  faBrackets,
  faLaptopArrowDown,
  faHockeyStickPuck,
  faHouseTree,
  faSignalFair,
  faSignal2,
  faFaceLaughWink,
  faLaughWink,
  faCircleDollar,
  faDollarCircle,
  faUsdCircle,
  faHorseHead,
  faArrowsRepeat,
  faRepeatAlt,
  faBoreHole,
  faIndustry,
  faImagePolaroid,
  faWaveTriangle,
  faTurnLeftDown,
  faPersonRunningFast,
  faCircleDown,
  faArrowAltCircleDown,
  faGrill,
  faArrowsTurnToDots,
  faChartMixed,
  faAnalytics,
  faFlorinSign,
  faArrowDownShortWide,
  faSortAmountDesc,
  faSortAmountDownAlt,
  faLessThan,
  faDisplayCode,
  faDesktopCode,
  faFaceDrooling,
  faOilTemperature,
  faOilTemp,
  faSquareQuestion,
  faQuestionSquare,
  faAirConditioner,
  faAngleDown,
  faMountains,
  faOmega,
  faCarTunnel,
  faPersonDollyEmpty,
  faPanFood,
  faHeadSideCough,
  faGripLines,
  faThumbsDown,
  faUserLock,
  faArrowRightLong,
  faLongArrowRight,
  faTicketsAirline,
  faTicketsPerforatedPlane,
  faTicketsPlane,
  faTentDoublePeak,
  faAnchorCircleXmark,
  faEllipsis,
  faEllipsisH,
  faNfcSlash,
  faChessPawn,
  faKitMedical,
  faFirstAid,
  faGrid2Plus,
  faBells,
  faPersonThroughWindow,
  faToolbox,
  faGlobeWifi,
  faEnvelopeDot,
  faEnvelopeBadge,
  faMagnifyingGlassWaveform,
  faHandsHoldingCircle,
  faBug,
  faBowlChopsticks,
  faCreditCard,
  faCreditCardAlt,
  faCircleS,
  faBoxBallot,
  faCar,
  faAutomobile,
  faHandHoldingHand,
  faUserTieHair,
  faPodiumStar,
  faUserHairMullet,
  faBusinessFront,
  faPartyBack,
  faTrianBalbot,
  faMicrophoneStand,
  faBookOpenReader,
  faBookReader,
  faFamilyDress,
  faCircleX,
  faCabin,
  faMountainSun,
  faChartSimpleHorizontal,
  faBluetooth,
  faArrowsLeftRightToLine,
  faHandBackPointLeft,
  faMessageDots,
  faCommentAltDots,
  faMessaging,
  faFileHeart,
  faBeerMug,
  faBeerFoam,
  faDiceD20,
  faDrone,
  faTruckDroplet,
  faFileCircleXmark,
  faTemperatureArrowUp,
  faTemperatureUp,
  faMedal,
  faPersonFairy,
  faBed,
  faBookCopy,
  faSquareH,
  faHSquare,
  faSquareC,
  faClockTwo,
  faSquareEllipsisVertical,
  faCalendarUsers,
  faPodcast,
  faBee,
  faTemperatureFull,
  faTemperature4,
  faThermometer4,
  faThermometerFull,
  faBell,
  faCandyBar,
  faChocolateBar,
  faXmarkLarge,
  faPinata,
  faFilePpt,
  faArrowsFromLine,
  faSuperscript,
  faBowlSpoon,
  faHexagonCheck,
  faPlugCircleXmark,
  faStarOfLife,
  faPhoneSlash,
  faTrafficLightStop,
  faPaintRoller,
  faAccentGrave,
  faHandshakeAngle,
  faHandsHelping,
  faCircle0,
  faDialMedLow,
  faLocationDot,
  faMapMarkerAlt,
  faCrab,
  faBoxOpenFull,
  faBoxFull,
  faFile,
  faGreaterThan,
  faQuotes,
  faPretzel,
  faTRex,
  faPersonSwimming,
  faSwimmer,
  faArrowDown,
  faUserRobotXmarks,
  faMessageQuote,
  faCommentAltQuote,
  faCandyCorn,
  faFolderMagnifyingGlass,
  faFolderSearch,
  faNotebook,
  faCircleWifi,
  faDroplet,
  faTint,
  faBullseyePointer,
  faEraser,
  faHexagonImage,
  faEarthAmericas,
  faEarth,
  faEarthAmerica,
  faGlobeAmericas,
  faFileSvg,
  faCrateApple,
  faAppleCrate,
  faPersonBurst,
  faGameBoard,
  faHatChef,
  faHandBackPointRight,
  faDove,
  faSnowflakeDroplets,
  faBatteryEmpty,
  faBattery0,
  faGrid4,
  faSocks,
  faFaceSunglasses,
  faInbox,
  faSquare0,
  faSection,
  faSquareThisWayUp,
  faBoxUp,
  faGaugeHigh,
  faTachometerAlt,
  faTachometerAltFast,
  faSquareAmpersand,
  faEnvelopeOpenText,
  faLampDesk,
  faHospital,
  faHospitalAlt,
  faHospitalWide,
  faPollPeople,
  faWhiskeyGlassIce,
  faGlassWhiskeyRocks,
  faWineBottle,
  faChessRook,
  faUserBountyHunter,
  faBarsStaggered,
  faReorder,
  faStream,
  faDiagramSankey,
  faCloudHailMixed,
  faCircleUpLeft,
  faDharmachakra,
  faObjectsAlignLeft,
  faOilCanDrip,
  faFaceSmilingHands,
  faBroccoli,
  faRouteInterstate,
  faEarMuffs,
  faHotdog,
  faTransporterEmpty,
  faPersonWalkingWithCane,
  faBlind,
  faAngle90,
  faRectangleTerminal,
  faKite,
  faDrum,
  faScrubber,
  faIceCream,
  faHeartCircleBolt,
  faFishBones,
  faDeerRudolph,
  faFax,
  faParagraph,
  faHeadSideHeart,
  faSquareE,
  faMeterFire,
  faCloudHail,
  faCheckToSlot,
  faVoteYea,
  faMoneyFromBracket,
  faStarHalf,
  faCarBus,
  faSpeaker,
  faTimer,
  faBoxesStacked,
  faBoxes,
  faBoxesAlt,
  faLandmarkMagnifyingGlass,
  faGrillHot,
  faBallotCheck,
  faLink,
  faChain,
  faEarListen,
  faAssistiveListeningSystems,
  faFileMinus,
  faTreeCity,
  faPlay,
  faFont,
  faCupTogo,
  faCoffeeTogo,
  faSquareDownLeft,
  faBurgerLettuce,
  faTableCellsRowLock,
  faRupiahSign,
  faMagnifyingGlass,
  faSearch,
  faTableTennisPaddleBall,
  faPingPongPaddleBall,
  faTableTennis,
  faPersonDotsFromLine,
  faDiagnoses,
  faChevronsDown,
  faChevronDoubleDown,
  faTrashCanArrowUp,
  faTrashRestoreAlt,
  faSignalGood,
  faSignal3,
  faLocationQuestion,
  faMapMarkerQuestion,
  faFloppyDiskCircleXmark,
  faFloppyDiskTimes,
  faSaveCircleXmark,
  faSaveTimes,
  faNairaSign,
  faPeach,
  faCirclesOverlap3,
  faPronoun,
  faTaxiBus,
  faBracketCurly,
  faBracketCurlyLeft,
  faLobster,
  faCartFlatbedEmpty,
  faDollyFlatbedEmpty,
  faColon,
  faCartArrowDown,
  faWand,
  faWalkieTalkie,
  faFilePen,
  faFileEdit,
  faReceipt,
  faTablePicnic,
  faSquarePen,
  faPenSquare,
  faPencilSquare,
  faCircleMicrophoneLines,
  faMicrophoneCircleAlt,
  faDisplaySlash,
  faDesktopSlash,
  faSuitcaseRolling,
  faPersonCircleExclamation,
  faTransporter2,
  faUserHoodie,
  faHandsHoldingDiamond,
  faHandReceiving,
  faMoneyBillSimpleWave,
  faChevronDown,
  faBatteryFull,
  faBattery,
  faBattery5,
  faBellPlus,
  faBookArrowRight,
  faHospitals,
  faClub,
  faSkullCrossbones,
  faDropletDegree,
  faDewpoint,
  faCodeCompare,
  faListUl,
  faListDots,
  faHandHoldingMagic,
  faWatermelonSlice,
  faCircleEllipsis,
  faSchoolLock,
  faTowerCell,
  faSdCards,
  faJugBottle,
  faDownLong,
  faLongArrowAltDown,
  faEnvelopes,
  faPhoneOffice,
  faRankingStar,
  faChessKing,
  faNfcPen,
  faPersonHarassing,
  faMagnifyingGlassPlay,
  faHatWinter,
  faBrazilianRealSign,
  faLandmarkDome,
  faLandmarkAlt,
  faBoneBreak,
  faArrowUp,
  faDownFromDottedLine,
  faTv,
  faTelevision,
  faTvAlt,
  faBorderLeft,
  faCircleDivide,
  faShrimp,
  faListCheck,
  faTasks,
  faDiagramSubtask,
  faJugDetergent,
  faCircleUser,
  faUserCircle,
  faSquareY,
  faUserDoctorHair,
  faPlanetRinged,
  faMushroom,
  faUserShield,
  faMegaphone,
  faWreathLaurel,
  faCircleExclamationCheck,
  faWind,
  faBoxDollar,
  faBoxUsd,
  faCarBurst,
  faCarCrash,
  faY,
  faUserHeadset,
  faArrowsRetweet,
  faRetweetAlt,
  faPersonSnowboarding,
  faSnowboarding,
  faSquareChevronRight,
  faChevronSquareRight,
  faLacrosseStickBall,
  faTruckFast,
  faShippingFast,
  faUserMagnifyingGlass,
  faStarSharp,
  faCommentHeart,
  faCircle1,
  faCircleStar,
  faStarCircle,
  faFish,
  faCloudFog,
  faFog,
  faWaffle,
  faMusicNote,
  faMusicAlt,
  faHexagonExclamation,
  faCartShoppingFast,
  faObjectUnion,
  faUserGraduate,
  faStarfighter,
  faCircleHalfStroke,
  faAdjust,
  faArrowRightLongToLine,
  faSquareArrowDown,
  faArrowSquareDown,
  faDiamondHalfStroke,
  faClapperboard,
  faSquareChevronLeft,
  faChevronSquareLeft,
  faPhoneIntercom,
  faLinkHorizontal,
  faChainHorizontal,
  faMango,
  faMusicNoteSlash,
  faMusicAltSlash,
  faCircleRadiation,
  faRadiationAlt,
  faFaceTongueSweat,
  faGlobeStand,
  faBaseball,
  faBaseballBall,
  faCircleP,
  faAwardSimple,
  faJetFighterUp,
  faDiagramProject,
  faProjectDiagram,
  faPedestal,
  faChartPyramid,
  faSidebar,
  faSnowmanHead,
  faFrostyHead,
  faCopy,
  faBurgerGlass,
  faVolumeXmark,
  faVolumeMute,
  faVolumeTimes,
  faHandSparkles,
  faBarsFilter,
  faPaintbrushPencil,
  faPartyBell,
  faUserVneckHair,
  faJackOLantern,
  faGrip,
  faGripHorizontal,
  faShareFromSquare,
  faShareSquare,
  faKeynote,
  faChildCombatant,
  faChildRifle,
  faGun,
  faSquarePhone,
  faPhoneSquare,
  faHatBeach,
  faPlus,
  faAdd,
  faExpand,
  faComputer,
  faFort,
  faCloudCheck,
  faXmark,
  faClose,
  faMultiply,
  faRemove,
  faTimes,
  faFaceSmirking,
  faArrowsUpDownLeftRight,
  faArrows,
  faChalkboardUser,
  faChalkboardTeacher,
  faRhombus,
  faClawMarks,
  faPesoSign,
  faFaceSmileTongue,
  faCartCircleXmark,
  faBuildingShield,
  faCirclePhoneFlip,
  faPhoneCircleAlt,
  faBaby,
  faUsersLine,
  faQuoteLeft,
  faQuoteLeftAlt,
  faTractor,
  faDownFromBracket,
  faKeySkeleton,
  faTrashArrowUp,
  faTrashRestore,
  faArrowDownUpLock,
  faArrowDownToBracket,
  faLinesLeaning,
  faSquareQ,
  faRulerCombined,
  faSymbols,
  faIconsAlt,
  faCopyright,
  faFlaskGear,
  faHighlighterLine,
  faBracketSquare,
  faBracket,
  faBracketLeft,
  faIslandTropical,
  faIslandTreePalm,
  faArrowRightFromLine,
  faArrowFromLeft,
  faH2,
  faEquals,
  faCakeSlice,
  faShortcake,
  faBuildingMagnifyingGlass,
  faPeanut,
  faWrenchSimple,
  faBlender,
  faTeeth,
  faTally2,
  faShekelSign,
  faIls,
  faShekel,
  faSheqel,
  faSheqelSign,
  faCars,
  faAxeBattle,
  faUserHairLong,
  faMap,
  faArrowLeftFromArc,
  faFileCircleInfo,
  faFaceDisappointed,
  faLassoSparkles,
  faClockEleven,
  faRocket,
  faSirenOn,
  faClockTen,
  faCandleHolder,
  faVideoArrowDownLeft,
  faPhotoFilm,
  faPhotoVideo,
  faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight,
  faFolderMinus,
  faHexagonNodesBolt,
  faPlanetMoon,
  faFaceEyesXmarks,
  faChartScatter,
  faCircleGf,
  faDisplayArrowDown,
  faStore,
  faArrowTrendUp,
  faPlugCircleMinus,
  faOliveBranch,
  faAngle,
  faVacuumRobot,
  faSignHanging,
  faSign,
  faSquareDivide,
  faFolderCheck,
  faSignalStreamSlash,
  faBezierCurve,
  faEyeDropperHalf,
  faStoreLock,
  faBellSlash,
  faCloudBoltSun,
  faThunderstormSun,
  faCameraSlash,
  faCommentQuote,
  faTablet,
  faTabletAndroid,
  faSchoolFlag,
  faMessageCode,
  faGlassHalf,
  faGlassHalfEmpty,
  faGlassHalfFull,
  faFill,
  faMessageMinus,
  faCommentAltMinus,
  faAngleUp,
  faDinosaur,
  faDrumstickBite,
  faLinkHorizontalSlash,
  faChainHorizontalSlash,
  faHollyBerry,
  faNose,
  faArrowLeftToArc,
  faChevronLeft,
  faBacteria,
  faClouds,
  faMoneyBillSimple,
  faHandLizard,
  faTablePivot,
  faFilterSlash,
  faTrashCanUndo,
  faTrashCanArrowTurnLeft,
  faTrashUndoAlt,
  faNotdef,
  faDisease,
  faPersonToDoor,
  faTurntable,
  faBriefcaseMedical,
  faGenderless,
  faChevronRight,
  faSignalWeak,
  faSignal1,
  faClockFive,
  faRetweet,
  faCarRear,
  faCarAlt,
  faPumpSoap,
  faComputerClassic,
  faFrame,
  faVideoSlash,
  faBatteryQuarter,
  faBattery2,
  faEllipsisStroke,
  faEllipsisHAlt,
  faRadio,
  faBabyCarriage,
  faCarriageBaby,
  faFaceExpressionless,
  faDownToDottedLine,
  faCloudMusic,
  faTrafficLight,
  faCloudMinus,
  faThermometer,
  faShieldMinus,
  faVrCardboard,
  faCarTilt,
  faGaugeCircleMinus,
  faBrightnessLow,
  faHandMiddleFinger,
  faPercent,
  faPercentage,
  faTruckMoving,
  faGlassWaterDroplet,
  faConveyorBelt,
  faLocationCheck,
  faMapMarkerCheck,
  faCoinVertical,
  faDisplay,
  faPersonSign,
  faFaceSmile,
  faSmile,
  faPhoneHangup,
  faSignatureSlash,
  faThumbtack,
  faThumbTack,
  faWheatSlash,
  faTrophy,
  faCloudsSun,
  faPersonPraying,
  faPray,
  faHammer,
  faFaceVomit,
  faSpeakers,
  faTtyAnswer,
  faTeletypeAnswer,
  faMugTeaSaucer,
  faDiagramLeanCanvas,
  faAlt,
  faDial,
  faDialMedHigh,
  faHandPeace,
  faCircleTrash,
  faTrashCircle,
  faRotate,
  faSyncAlt,
  faCircleQuarters,
  faSpinner,
  faTowerControl,
  faArrowUpTriangleSquare,
  faSortShapesUp,
  faWhale,
  faRobot,
  faPeace,
  faPartyHorn,
  faGears,
  faCogs,
  faSunBright,
  faSunAlt,
  faWarehouse,
  faConveyorBeltArm,
  faLockKeyholeOpen,
  faLockOpenAlt,
  faSquareFragile,
  faBoxFragile,
  faSquareWineGlassCrack,
  faArrowUpRightDots,
  faSquareN,
  faSplotch,
  faFaceGrinHearts,
  faGrinHearts,
  faMeter,
  faMandolin,
  faDiceFour,
  faSimCard,
  faTransgender,
  faTransgenderAlt,
  faMercury,
  faUpFromBracket,
  faKnifeKitchen,
  faBorderRight,
  faArrowTurnDown,
  faLevelDown,
  faSpade,
  faCardSpade,
  faLineColumns,
  faAnt,
  faArrowRightToLine,
  faArrowToRight,
  faPersonFallingBurst,
  faFlagPennant,
  faPennant,
  faConveyorBeltEmpty,
  faUserGroupSimple,
  faAward,
  faTicketSimple,
  faTicketAlt,
  faBuilding,
  faAnglesLeft,
  faAngleDoubleLeft,
  faCamcorder,
  faVideoHandheld,
  faPancakes,
  faAlbumCircleUser,
  faSubtitlesSlash,
  faQrcode,
  faDiceD10,
  faFireplace,
  faBrowser,
  faPenPaintbrush,
  faPencilPaintbrush,
  faFishCooked,
  faChairOffice,
  faMagnifyingGlassMusic,
  faNestingDolls,
  faClockRotateLeft,
  faHistory,
  faTrumpet,
  faFaceGrinBeamSweat,
  faGrinBeamSweat,
  faFireSmoke,
  faPhoneMissed,
  faFileExport,
  faArrowRightFromFile,
  faShield,
  faShieldBlank,
  faArrowUpShortWide,
  faSortAmountUpAlt,
  faArrowsRepeat1,
  faRepeat1Alt,
  faGunSlash,
  faAvocado,
  faBinary,
  faCommentNodes,
  faGlassesRound,
  faGlassesAlt,
  faPhonePlus,
  faDitto,
  faPersonSeat,
  faHouseMedical,
  faGolfBallTee,
  faGolfBall,
  faCircleChevronLeft,
  faChevronCircleLeft,
  faHouseChimneyWindow,
  faScythe,
  faPenNib,
  faBanParking,
  faParkingCircleSlash,
  faTentArrowTurnLeft,
  faFaceDiagonalMouth,
  faDiagramCells,
  faCricketBatBall,
  faCricket,
  faTents,
  faWandMagic,
  faMagic,
  faDog,
  faPenLine,
  faAtomSimple,
  faAtomAlt,
  faAmpersand,
  faCarrot,
  faArrowUpFromLine,
  faArrowFromBottom,
  faMoon,
  faPenSlash,
  faWineGlassEmpty,
  faWineGlassAlt,
  faSquareStar,
  faCheese,
  faSendBackward,
  faYinYang,
  faMusic,
  faCompassSlash,
  faClockOne,
  faFileMusic,
  faCodeCommit,
  faTemperatureLow,
  faPersonBiking,
  faBiking,
  faDisplayChartUpCircleCurrency,
  faSkeleton,
  faCircleG,
  faCircleArrowUpLeft,
  faCoinBlank,
  faBroom,
  faVacuum,
  faShieldHeart,
  faCardHeart,
  faLightbulbCflOn,
  faMelon,
  faGopuram,
  faEarthOceania,
  faGlobeOceania,
  faContainerStorage,
  faFacePouting,
  faSquareXmark,
  faTimesSquare,
  faXmarkSquare,
  faFaceExplode,
  faExplodingHead,
  faHashtag,
  faUpRightAndDownLeftFromCenter,
  faExpandAlt,
  faOilCan,
  faT,
  faTransformerBolt,
  faHippo,
  faChartColumn,
  faCassetteVhs,
  faVhs,
  faInfinity,
  faVialCircleCheck,
  faChimney,
  faObjectIntersect,
  faPersonArrowDownToLine,
  faVoicemail,
  faBlockBrick,
  faWallBrick,
  faFan,
  faBagsShopping,
  faParagraphLeft,
  faParagraphRtl,
  faPersonWalkingLuggage,
  faCaravanSimple,
  faCaravanAlt,
  faTurtle,
  faPencilMechanical,
  faUpDown,
  faArrowsAltV,
  faCloudMoonRain,
  faBoothCurtain,
  faCalendar,
  faBoxHeart,
  faTrailer,
  faUserDoctorMessage,
  faUserMdChat,
  faBahai,
  faHaykal,
  faLighthouse,
  faAmpGuitar,
  faSdCard,
  faVolumeSlash,
  faBorderBottom,
  faWifiWeak,
  faWifi1,
  faDragon,
  faShoePrints,
  faCirclePlus,
  faPlusCircle,
  faFaceGrinTongueWink,
  faGrinTongueWink,
  faHandHolding,
  faPlugCircleExclamation,
  faLinkSlash,
  faChainBroken,
  faChainSlash,
  faUnlink,
  faClone,
  faPersonWalkingArrowLoopLeft,
  faArrowUpZA,
  faSortAlphaUpAlt,
  faFireFlameCurved,
  faFireAlt,
  faTornado,
  faFileCirclePlus,
  faDeleteRight,
  faBookQuran,
  faQuran,
  faCircleQuarter,
  faAnchor,
  faBorderAll,
  faFunction,
  faFaceAngry,
  faAngry,
  faPeopleSimple,
  faCookieBite,
  faArrowTrendDown,
  faRss,
  faFeed,
  faFaceMonocle,
  faDrawPolygon,
  faScaleBalanced,
  faBalanceScale,
  faCalendarLines,
  faCalendarNote,
  faArrowDownBigSmall,
  faSortSizeDown,
  faGaugeSimpleHigh,
  faTachometer,
  faTachometerFast,
  faDoNotEnter,
  faShower,
  faDiceD8,
  faDesktop,
  faDesktopAlt,
  faM,
  faSpinnerScale,
  faGripDotsVertical,
  faFaceViewfinder,
  faSoftServe,
  faCreemee,
  faH5,
  faHandBackPointDown,
  faTableList,
  faThList,
  faBasketShoppingMinus,
  faCommentSms,
  faSms,
  faRectangle,
  faRectangleLandscape,
  faClipboardListCheck,
  faTurkey,
  faBook,
  faUserPlus,
  faIceSkate,
  faCheck,
  faBatteryThreeQuarters,
  faBattery4,
  faTomato,
  faSwordLaser,
  faHouseCircleCheck,
  faBuildings,
  faAngleLeft,
  faCartFlatbedBoxes,
  faDollyFlatbedAlt,
  faDiagramSuccessor,
  faTruckArrowRight,
  faSquareW,
  faArrowsSplitUpAndLeft,
  faLamp,
  faAirplay,
  faHandFist,
  faFistRaised,
  faShieldQuartered,
  faSlashForward,
  faLocationPen,
  faMapMarkerEdit,
  faCloudMoon,
  faPotFood,
  faBriefcase,
  faPersonFalling,
  faImagePortrait,
  faPortrait,
  faUserTag,
  faRug,
  faPrintSlash,
  faEarthEurope,
  faGlobeEurope,
  faCartFlatbedSuitcase,
  faLuggageCart,
  faHandBackPointRibbon,
  faRectangleXmark,
  faRectangleTimes,
  faTimesRectangle,
  faWindowClose,
  faTireRugged,
  faLightbulbDollar,
  faCowbell,
  faBahtSign,
  faCorner,
  faChevronsRight,
  faChevronDoubleRight,
  faBookOpen,
  faBookJournalWhills,
  faJournalWhills,
  faInhaler,
  faHandcuffs,
  faSnake,
  faTriangleExclamation,
  faExclamationTriangle,
  faWarning,
  faNoteMedical,
  faDatabase,
  faDownLeft,
  faShare,
  faMailForward,
  faFaceThinking,
  faTurnDownRight,
  faBottleDroplet,
  faMaskFace,
  faHillRockslide,
  faScannerKeyboard,
  faCircleO,
  faGridHorizontal,
  faMessageDollar,
  faCommentAltDollar,
  faRightLeft,
  faExchangeAlt,
  faColumns3,
  faPaperPlane,
  faRoadCircleExclamation,
  faDungeon,
  faHandHoldingBox,
  faInputText,
  faWindowFlip,
  faWindowAlt,
  faAlignRight,
  faScannerGun,
  faScanner,
  faTire,
  faEngine,
  faMoneyBill1Wave,
  faMoneyBillWaveAlt,
  faLifeRing,
  faHands,
  faSignLanguage,
  faSigning,
  faCircleCaretRight,
  faCaretCircleRight,
  faTurnLeft,
  faWheat,
  faFileSpreadsheet,
  faAudioDescriptionSlash,
  faBellRing,
  faCalendarDay,
  faWaterLadder,
  faLadderWater,
  faSwimmingPool,
  faArrowsUpDown,
  faArrowsV,
  faChessPawnPiece,
  faChessPawnAlt,
  faFaceGrimace,
  faGrimace,
  faWheelchairMove,
  faWheelchairAlt,
  faTurnDown,
  faLevelDownAlt,
  faSquareS,
  faRectangleBarcode,
  faBarcodeAlt,
  faPersonWalkingArrowRight,
  faSquareEnvelope,
  faEnvelopeSquare,
  faDice,
  faUnicorn,
  faBowlingBall,
  faPompebled,
  faBrain,
  faWatchSmart,
  faBookUser,
  faSensorCloud,
  faSensorSmoke,
  faClapperboardPlay,
  faBandage,
  faBandAid,
  faCalendarMinus,
  faCircleXmark,
  faTimesCircle,
  faXmarkCircle,
  faCircle4,
  faGifts,
  faAlbumCollection,
  faHotel,
  faEarthAsia,
  faGlobeAsia,
  faIdCardClip,
  faIdCardAlt,
  faMagnifyingGlassPlus,
  faSearchPlus,
  faThumbsUp,
  faCloudShowers,
  faUserClock,
  faOnion,
  faClockTwelveThirty,
  faArrowDownToDottedLine,
  faHandDots,
  faAllergies,
  faFileInvoice,
  faWindowMinimize,
  faRectangleWide,
  faCommentArrowUp,
  faGarlic,
  faMugSaucer,
  faCoffee,
  faBrush,
  faFileHalfDashed,
  faTreeDecorated,
  faMask,
  faCalendarHeart,
  faMagnifyingGlassMinus,
  faSearchMinus,
  faFlower,
  faArrowDownFromArc,
  faRightLeftLarge,
  faRulerVertical,
  faCirclesOverlap,
  faUserLarge,
  faUserAlt,
  faStarshipFreighter,
  faTrainTram,
  faBridgeSuspension,
  faTrashCheck,
  faUserNurse,
  faBoombox,
  faSyringe,
  faCloudSun,
  faShieldExclamation,
  faStopwatch20,
  faSquareFull,
  faGripDots,
  faCommentExclamation,
  faPenSwirl,
  faFalafel,
  faCircle2,
  faMagnet,
  faJar,
  faGramophone,
  faDiceD12,
  faNoteSticky,
  faStickyNote,
  faDown,
  faArrowAltDown,
  faHundredPoints,
  fa100,
  faPaperclipVertical,
  faWindWarning,
  faWindCircleExclamation,
  faLocationPinSlash,
  faMapMarkerSlash,
  faFaceSadSweat,
  faBugSlash,
  faCupcake,
  faLightSwitchOff,
  faToggleLargeOff,
  faPenFancySlash,
  faTruckContainer,
  faBoot,
  faArrowUpFromWaterPump,
  faFileCheck,
  faBone,
  faCardsBlank,
  faCircle3,
  faBenchTree,
  faKeyboardBrightnessLow,
  faSkiBootSki,
  faBrainCircuit,
  faTableCellsRowUnlock,
  faUserInjured,
  faBlockBrickFire,
  faFirewall,
  faFaceSadTear,
  faSadTear,
  faPlane,
  faTentArrowsDown,
  faExclamation,
  faArrowsSpin,
  faFaceSmileRelaxed,
  faCommentXmark,
  faCommentTimes,
  faPrint,
  faTurkishLiraSign,
  faTry,
  faTurkishLira,
  faFaceNoseSteam,
  faCircleWaveformLines,
  faWaveformCircle,
  faDollarSign,
  faDollar,
  faUsd,
  faFerrisWheel,
  faComputerSpeaker,
  faSkullCow,
  faX,
  faMagnifyingGlassDollar,
  faSearchDollar,
  faUsersGear,
  faUsersCog,
  faPersonMilitaryPointing,
  faBuildingColumns,
  faBank,
  faInstitution,
  faMuseum,
  faUniversity,
  faCircleT,
  faSack,
  faGrid2,
  faCameraCctv,
  faCctv,
  faUmbrella,
  faTrowel,
  faHorizontalRule,
  faBedFront,
  faBedAlt,
  faD,
  faStapler,
  faMasksTheater,
  faTheaterMasks,
  faFileGif,
  faKipSign,
  faFaceWoozy,
  faCloudQuestion,
  faPineapple,
  faHandPointLeft,
  faGalleryThumbnails,
  faCircleJ,
  faEyes,
  faHandshakeSimple,
  faHandshakeAlt,
  faPageCaretUp,
  faFileCaretUp,
  faJetFighter,
  faFighterJet,
  faComet,
  faSquareShareNodes,
  faShareAltSquare,
  faReflectVertical,
  faShieldKeyhole,
  faFileMp4,
  faBarcode,
  faBulldozer,
  faPlusMinus,
  faSquareSlidersVertical,
  faSlidersVSquare,
  faVideo,
  faVideoCamera,
  faMessageMiddle,
  faCommentMiddleAlt,
  faGraduationCap,
  faMortarBoard,
  faHandHoldingMedical,
  faPersonCircleCheck,
  faSquareZ,
  faMessageText,
  faCommentAltText,
  faTurnUp,
  faLevelUpAlt,
};
